/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  Decimal: any;
  Json: any;
  NEVER: any;
  Upload: any;
};

export type Address = {
  __typename?: 'Address';
  Person: Person;
  city?: Maybe<Scalars['String']>;
  complement?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  neighborhood?: Maybe<Scalars['String']>;
  personId: Scalars['String'];
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
};

export type AddressAvgOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
};

export type AddressCountOrderByAggregateInput = {
  city?: Maybe<SortOrder>;
  complement?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  neighborhood?: Maybe<SortOrder>;
  personId?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  state?: Maybe<SortOrder>;
  street?: Maybe<SortOrder>;
};

export type AddressCreateInput = {
  Person: PersonCreateNestedOneWithoutAddressInput;
  city?: Maybe<Scalars['String']>;
  complement?: Maybe<Scalars['String']>;
  neighborhood?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
};

export type AddressCreateManyInput = {
  city?: Maybe<Scalars['String']>;
  complement?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  neighborhood?: Maybe<Scalars['String']>;
  personId: Scalars['String'];
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
};

export type AddressCreateNestedOneWithoutPersonInput = {
  connect?: Maybe<AddressWhereUniqueInput>;
  connectOrCreate?: Maybe<AddressCreateOrConnectWithoutPersonInput>;
  create?: Maybe<AddressCreateWithoutPersonInput>;
};

export type AddressCreateOrConnectWithoutPersonInput = {
  create: AddressCreateWithoutPersonInput;
  where: AddressWhereUniqueInput;
};

export type AddressCreateWithoutPersonInput = {
  city?: Maybe<Scalars['String']>;
  complement?: Maybe<Scalars['String']>;
  neighborhood?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  city?: Maybe<Scalars['String']>;
  complement?: Maybe<Scalars['String']>;
  neighborhood?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
};

export type AddressMaxOrderByAggregateInput = {
  city?: Maybe<SortOrder>;
  complement?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  neighborhood?: Maybe<SortOrder>;
  personId?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  state?: Maybe<SortOrder>;
  street?: Maybe<SortOrder>;
};

export type AddressMinOrderByAggregateInput = {
  city?: Maybe<SortOrder>;
  complement?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  neighborhood?: Maybe<SortOrder>;
  personId?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  state?: Maybe<SortOrder>;
  street?: Maybe<SortOrder>;
};

export type AddressNullableRelationFilter = {
  is?: Maybe<AddressWhereInput>;
  isNot?: Maybe<AddressWhereInput>;
};

export type AddressOrderByWithAggregationInput = {
  _avg?: Maybe<AddressAvgOrderByAggregateInput>;
  _count?: Maybe<AddressCountOrderByAggregateInput>;
  _max?: Maybe<AddressMaxOrderByAggregateInput>;
  _min?: Maybe<AddressMinOrderByAggregateInput>;
  _sum?: Maybe<AddressSumOrderByAggregateInput>;
  city?: Maybe<SortOrder>;
  complement?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  neighborhood?: Maybe<SortOrder>;
  personId?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  state?: Maybe<SortOrder>;
  street?: Maybe<SortOrder>;
};

export type AddressOrderByWithRelationInput = {
  Person?: Maybe<PersonOrderByWithRelationInput>;
  city?: Maybe<SortOrder>;
  complement?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  neighborhood?: Maybe<SortOrder>;
  personId?: Maybe<SortOrder>;
  postalCode?: Maybe<SortOrder>;
  state?: Maybe<SortOrder>;
  street?: Maybe<SortOrder>;
};

export enum AddressScalarFieldEnum {
  City = 'city',
  Complement = 'complement',
  Id = 'id',
  Neighborhood = 'neighborhood',
  PersonId = 'personId',
  PostalCode = 'postalCode',
  State = 'state',
  Street = 'street'
}

export type AddressScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<AddressScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<AddressScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<AddressScalarWhereWithAggregatesInput>>;
  city?: Maybe<StringNullableWithAggregatesFilter>;
  complement?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  neighborhood?: Maybe<StringNullableWithAggregatesFilter>;
  personId?: Maybe<StringWithAggregatesFilter>;
  postalCode?: Maybe<StringNullableWithAggregatesFilter>;
  state?: Maybe<StringNullableWithAggregatesFilter>;
  street?: Maybe<StringNullableWithAggregatesFilter>;
};

export type AddressSumOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
};

export type AddressUpdateInput = {
  Person?: Maybe<PersonUpdateOneRequiredWithoutAddressNestedInput>;
  city?: Maybe<NullableStringFieldUpdateOperationsInput>;
  complement?: Maybe<NullableStringFieldUpdateOperationsInput>;
  neighborhood?: Maybe<NullableStringFieldUpdateOperationsInput>;
  postalCode?: Maybe<NullableStringFieldUpdateOperationsInput>;
  state?: Maybe<NullableStringFieldUpdateOperationsInput>;
  street?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type AddressUpdateManyMutationInput = {
  city?: Maybe<NullableStringFieldUpdateOperationsInput>;
  complement?: Maybe<NullableStringFieldUpdateOperationsInput>;
  neighborhood?: Maybe<NullableStringFieldUpdateOperationsInput>;
  postalCode?: Maybe<NullableStringFieldUpdateOperationsInput>;
  state?: Maybe<NullableStringFieldUpdateOperationsInput>;
  street?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type AddressUpdateOneWithoutPersonNestedInput = {
  connect?: Maybe<AddressWhereUniqueInput>;
  connectOrCreate?: Maybe<AddressCreateOrConnectWithoutPersonInput>;
  create?: Maybe<AddressCreateWithoutPersonInput>;
  delete?: Maybe<AddressWhereInput>;
  disconnect?: Maybe<AddressWhereInput>;
  update?: Maybe<AddressUpdateToOneWithWhereWithoutPersonInput>;
  upsert?: Maybe<AddressUpsertWithoutPersonInput>;
};

export type AddressUpdateToOneWithWhereWithoutPersonInput = {
  data: AddressUpdateWithoutPersonInput;
  where?: Maybe<AddressWhereInput>;
};

export type AddressUpdateWithoutPersonInput = {
  city?: Maybe<NullableStringFieldUpdateOperationsInput>;
  complement?: Maybe<NullableStringFieldUpdateOperationsInput>;
  neighborhood?: Maybe<NullableStringFieldUpdateOperationsInput>;
  postalCode?: Maybe<NullableStringFieldUpdateOperationsInput>;
  state?: Maybe<NullableStringFieldUpdateOperationsInput>;
  street?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type AddressUpsertWithoutPersonInput = {
  create: AddressCreateWithoutPersonInput;
  update: AddressUpdateWithoutPersonInput;
  where?: Maybe<AddressWhereInput>;
};

export type AddressWhereInput = {
  AND?: Maybe<Array<AddressWhereInput>>;
  NOT?: Maybe<Array<AddressWhereInput>>;
  OR?: Maybe<Array<AddressWhereInput>>;
  Person?: Maybe<PersonWhereInput>;
  city?: Maybe<StringNullableFilter>;
  complement?: Maybe<StringNullableFilter>;
  id?: Maybe<IntFilter>;
  neighborhood?: Maybe<StringNullableFilter>;
  personId?: Maybe<StringFilter>;
  postalCode?: Maybe<StringNullableFilter>;
  state?: Maybe<StringNullableFilter>;
  street?: Maybe<StringNullableFilter>;
};

export type AddressWhereUniqueInput = {
  AND?: Maybe<Array<AddressWhereInput>>;
  NOT?: Maybe<Array<AddressWhereInput>>;
  OR?: Maybe<Array<AddressWhereInput>>;
  Person?: Maybe<PersonWhereInput>;
  city?: Maybe<StringNullableFilter>;
  complement?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['Int']>;
  neighborhood?: Maybe<StringNullableFilter>;
  personId?: Maybe<Scalars['String']>;
  postalCode?: Maybe<StringNullableFilter>;
  state?: Maybe<StringNullableFilter>;
  street?: Maybe<StringNullableFilter>;
};

export type ApiKey = {
  __typename?: 'ApiKey';
  Team: Team;
  User: CommonUser;
  commonUserId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  hashedKey: Scalars['String'];
  id: Scalars['Int'];
  teamId: Scalars['Int'];
};

export type ApiKeyAvgOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type ApiKeyCountOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  hashedKey?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type ApiKeyCreateInput = {
  Team: TeamCreateNestedOneWithoutApiKeyInput;
  User: CommonUserCreateNestedOneWithoutApiKeyInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  hashedKey: Scalars['String'];
};

export type ApiKeyCreateManyInput = {
  commonUserId: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  hashedKey: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  teamId: Scalars['Int'];
};

export type ApiKeyCreateManyTeamInput = {
  commonUserId: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  hashedKey: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
};

export type ApiKeyCreateManyTeamInputEnvelope = {
  data: Array<ApiKeyCreateManyTeamInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ApiKeyCreateManyUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  hashedKey: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  teamId: Scalars['Int'];
};

export type ApiKeyCreateManyUserInputEnvelope = {
  data: Array<ApiKeyCreateManyUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ApiKeyCreateNestedManyWithoutTeamInput = {
  connect?: Maybe<Array<ApiKeyWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ApiKeyCreateOrConnectWithoutTeamInput>>;
  create?: Maybe<Array<ApiKeyCreateWithoutTeamInput>>;
  createMany?: Maybe<ApiKeyCreateManyTeamInputEnvelope>;
};

export type ApiKeyCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<ApiKeyWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ApiKeyCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<ApiKeyCreateWithoutUserInput>>;
  createMany?: Maybe<ApiKeyCreateManyUserInputEnvelope>;
};

export type ApiKeyCreateOrConnectWithoutTeamInput = {
  create: ApiKeyCreateWithoutTeamInput;
  where: ApiKeyWhereUniqueInput;
};

export type ApiKeyCreateOrConnectWithoutUserInput = {
  create: ApiKeyCreateWithoutUserInput;
  where: ApiKeyWhereUniqueInput;
};

export type ApiKeyCreateWithoutTeamInput = {
  User: CommonUserCreateNestedOneWithoutApiKeyInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  hashedKey: Scalars['String'];
};

export type ApiKeyCreateWithoutUserInput = {
  Team: TeamCreateNestedOneWithoutApiKeyInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  hashedKey: Scalars['String'];
};

export type ApiKeyListRelationFilter = {
  every?: Maybe<ApiKeyWhereInput>;
  none?: Maybe<ApiKeyWhereInput>;
  some?: Maybe<ApiKeyWhereInput>;
};

export type ApiKeyMaxOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  hashedKey?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type ApiKeyMinOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  hashedKey?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type ApiKeyOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ApiKeyOrderByWithAggregationInput = {
  _avg?: Maybe<ApiKeyAvgOrderByAggregateInput>;
  _count?: Maybe<ApiKeyCountOrderByAggregateInput>;
  _max?: Maybe<ApiKeyMaxOrderByAggregateInput>;
  _min?: Maybe<ApiKeyMinOrderByAggregateInput>;
  _sum?: Maybe<ApiKeySumOrderByAggregateInput>;
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  hashedKey?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type ApiKeyOrderByWithRelationInput = {
  Team?: Maybe<TeamOrderByWithRelationInput>;
  User?: Maybe<CommonUserOrderByWithRelationInput>;
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  hashedKey?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export enum ApiKeyScalarFieldEnum {
  CommonUserId = 'commonUserId',
  CreatedAt = 'createdAt',
  Description = 'description',
  HashedKey = 'hashedKey',
  Id = 'id',
  TeamId = 'teamId'
}

export type ApiKeyScalarWhereInput = {
  AND?: Maybe<Array<ApiKeyScalarWhereInput>>;
  NOT?: Maybe<Array<ApiKeyScalarWhereInput>>;
  OR?: Maybe<Array<ApiKeyScalarWhereInput>>;
  commonUserId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  hashedKey?: Maybe<StringFilter>;
  id?: Maybe<IntFilter>;
  teamId?: Maybe<IntFilter>;
};

export type ApiKeyScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ApiKeyScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ApiKeyScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ApiKeyScalarWhereWithAggregatesInput>>;
  commonUserId?: Maybe<IntWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  description?: Maybe<StringWithAggregatesFilter>;
  hashedKey?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  teamId?: Maybe<IntWithAggregatesFilter>;
};

export type ApiKeySumOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type ApiKeyUpdateInput = {
  Team?: Maybe<TeamUpdateOneRequiredWithoutApiKeyNestedInput>;
  User?: Maybe<CommonUserUpdateOneRequiredWithoutApiKeyNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  description?: Maybe<StringFieldUpdateOperationsInput>;
  hashedKey?: Maybe<StringFieldUpdateOperationsInput>;
};

export type ApiKeyUpdateManyMutationInput = {
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  description?: Maybe<StringFieldUpdateOperationsInput>;
  hashedKey?: Maybe<StringFieldUpdateOperationsInput>;
};

export type ApiKeyUpdateManyWithWhereWithoutTeamInput = {
  data: ApiKeyUpdateManyMutationInput;
  where: ApiKeyScalarWhereInput;
};

export type ApiKeyUpdateManyWithWhereWithoutUserInput = {
  data: ApiKeyUpdateManyMutationInput;
  where: ApiKeyScalarWhereInput;
};

export type ApiKeyUpdateManyWithoutTeamNestedInput = {
  connect?: Maybe<Array<ApiKeyWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ApiKeyCreateOrConnectWithoutTeamInput>>;
  create?: Maybe<Array<ApiKeyCreateWithoutTeamInput>>;
  createMany?: Maybe<ApiKeyCreateManyTeamInputEnvelope>;
  delete?: Maybe<Array<ApiKeyWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ApiKeyScalarWhereInput>>;
  disconnect?: Maybe<Array<ApiKeyWhereUniqueInput>>;
  set?: Maybe<Array<ApiKeyWhereUniqueInput>>;
  update?: Maybe<Array<ApiKeyUpdateWithWhereUniqueWithoutTeamInput>>;
  updateMany?: Maybe<Array<ApiKeyUpdateManyWithWhereWithoutTeamInput>>;
  upsert?: Maybe<Array<ApiKeyUpsertWithWhereUniqueWithoutTeamInput>>;
};

export type ApiKeyUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<ApiKeyWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ApiKeyCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<ApiKeyCreateWithoutUserInput>>;
  createMany?: Maybe<ApiKeyCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<ApiKeyWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ApiKeyScalarWhereInput>>;
  disconnect?: Maybe<Array<ApiKeyWhereUniqueInput>>;
  set?: Maybe<Array<ApiKeyWhereUniqueInput>>;
  update?: Maybe<Array<ApiKeyUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<ApiKeyUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<ApiKeyUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ApiKeyUpdateWithWhereUniqueWithoutTeamInput = {
  data: ApiKeyUpdateWithoutTeamInput;
  where: ApiKeyWhereUniqueInput;
};

export type ApiKeyUpdateWithWhereUniqueWithoutUserInput = {
  data: ApiKeyUpdateWithoutUserInput;
  where: ApiKeyWhereUniqueInput;
};

export type ApiKeyUpdateWithoutTeamInput = {
  User?: Maybe<CommonUserUpdateOneRequiredWithoutApiKeyNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  description?: Maybe<StringFieldUpdateOperationsInput>;
  hashedKey?: Maybe<StringFieldUpdateOperationsInput>;
};

export type ApiKeyUpdateWithoutUserInput = {
  Team?: Maybe<TeamUpdateOneRequiredWithoutApiKeyNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  description?: Maybe<StringFieldUpdateOperationsInput>;
  hashedKey?: Maybe<StringFieldUpdateOperationsInput>;
};

export type ApiKeyUpsertWithWhereUniqueWithoutTeamInput = {
  create: ApiKeyCreateWithoutTeamInput;
  update: ApiKeyUpdateWithoutTeamInput;
  where: ApiKeyWhereUniqueInput;
};

export type ApiKeyUpsertWithWhereUniqueWithoutUserInput = {
  create: ApiKeyCreateWithoutUserInput;
  update: ApiKeyUpdateWithoutUserInput;
  where: ApiKeyWhereUniqueInput;
};

export type ApiKeyWhereInput = {
  AND?: Maybe<Array<ApiKeyWhereInput>>;
  NOT?: Maybe<Array<ApiKeyWhereInput>>;
  OR?: Maybe<Array<ApiKeyWhereInput>>;
  Team?: Maybe<TeamWhereInput>;
  User?: Maybe<CommonUserWhereInput>;
  commonUserId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  hashedKey?: Maybe<StringFilter>;
  id?: Maybe<IntFilter>;
  teamId?: Maybe<IntFilter>;
};

export type ApiKeyWhereUniqueInput = {
  AND?: Maybe<Array<ApiKeyWhereInput>>;
  NOT?: Maybe<Array<ApiKeyWhereInput>>;
  OR?: Maybe<Array<ApiKeyWhereInput>>;
  Team?: Maybe<TeamWhereInput>;
  User?: Maybe<CommonUserWhereInput>;
  commonUserId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  hashedKey?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  teamId?: Maybe<IntFilter>;
};

/** Batch payloads from prisma. */
export type BatchPayload = {
  __typename?: 'BatchPayload';
  /** Prisma Batch Payload */
  count: Scalars['Int'];
};

export type BoolFieldUpdateOperationsInput = {
  set?: Maybe<Scalars['Boolean']>;
};

export type BoolFilter = {
  equals?: Maybe<Scalars['Boolean']>;
  not?: Maybe<NestedBoolFilter>;
};

export type BoolWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedBoolFilter>;
  _min?: Maybe<NestedBoolFilter>;
  equals?: Maybe<Scalars['Boolean']>;
  not?: Maybe<NestedBoolWithAggregatesFilter>;
};

export type BulkCertificateRecord = {
  __typename?: 'BulkCertificateRecord';
  DocumentCertificates: Array<DocumentCertificate>;
  Team: Team;
  bulkCertificateRecordName: Scalars['String'];
  countDocumentCertificates: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  educationLevel: EducationLevelType;
  id: Scalars['String'];
  status: DocumentCertificateStatus;
  teamId: Scalars['Int'];
  totalCertificates: Scalars['Int'];
};


export type BulkCertificateRecordDocumentCertificatesArgs = {
  cursor?: Maybe<DocumentCertificateWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentCertificateScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentCertificateOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentCertificateWhereInput>;
};


export type BulkCertificateRecordCountDocumentCertificatesArgs = {
  where?: Maybe<DocumentCertificateWhereInput>;
};

export type BulkCertificateRecordAvgOrderByAggregateInput = {
  teamId?: Maybe<SortOrder>;
  totalCertificates?: Maybe<SortOrder>;
};

export type BulkCertificateRecordCountOrderByAggregateInput = {
  bulkCertificateRecordName?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  educationLevel?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  totalCertificates?: Maybe<SortOrder>;
};

export type BulkCertificateRecordCreateInput = {
  DocumentCertificates?: Maybe<DocumentCertificateCreateNestedManyWithoutBulkCertificateRecordInput>;
  Team: TeamCreateNestedOneWithoutBulkCertificateRecordInput;
  bulkCertificateRecordName: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  educationLevel?: Maybe<EducationLevelType>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<DocumentCertificateStatus>;
  totalCertificates: Scalars['Int'];
};

export type BulkCertificateRecordCreateManyInput = {
  bulkCertificateRecordName: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  educationLevel?: Maybe<EducationLevelType>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<DocumentCertificateStatus>;
  teamId: Scalars['Int'];
  totalCertificates: Scalars['Int'];
};

export type BulkCertificateRecordCreateManyTeamInput = {
  bulkCertificateRecordName: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  educationLevel?: Maybe<EducationLevelType>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<DocumentCertificateStatus>;
  totalCertificates: Scalars['Int'];
};

export type BulkCertificateRecordCreateManyTeamInputEnvelope = {
  data: Array<BulkCertificateRecordCreateManyTeamInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type BulkCertificateRecordCreateNestedManyWithoutTeamInput = {
  connect?: Maybe<Array<BulkCertificateRecordWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BulkCertificateRecordCreateOrConnectWithoutTeamInput>>;
  create?: Maybe<Array<BulkCertificateRecordCreateWithoutTeamInput>>;
  createMany?: Maybe<BulkCertificateRecordCreateManyTeamInputEnvelope>;
};

export type BulkCertificateRecordCreateNestedOneWithoutDocumentCertificatesInput = {
  connect?: Maybe<BulkCertificateRecordWhereUniqueInput>;
  connectOrCreate?: Maybe<BulkCertificateRecordCreateOrConnectWithoutDocumentCertificatesInput>;
  create?: Maybe<BulkCertificateRecordCreateWithoutDocumentCertificatesInput>;
};

export type BulkCertificateRecordCreateOrConnectWithoutDocumentCertificatesInput = {
  create: BulkCertificateRecordCreateWithoutDocumentCertificatesInput;
  where: BulkCertificateRecordWhereUniqueInput;
};

export type BulkCertificateRecordCreateOrConnectWithoutTeamInput = {
  create: BulkCertificateRecordCreateWithoutTeamInput;
  where: BulkCertificateRecordWhereUniqueInput;
};

export type BulkCertificateRecordCreateWithoutDocumentCertificatesInput = {
  Team: TeamCreateNestedOneWithoutBulkCertificateRecordInput;
  bulkCertificateRecordName: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  educationLevel?: Maybe<EducationLevelType>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<DocumentCertificateStatus>;
  totalCertificates: Scalars['Int'];
};

export type BulkCertificateRecordCreateWithoutTeamInput = {
  DocumentCertificates?: Maybe<DocumentCertificateCreateNestedManyWithoutBulkCertificateRecordInput>;
  bulkCertificateRecordName: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  educationLevel?: Maybe<EducationLevelType>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<DocumentCertificateStatus>;
  totalCertificates: Scalars['Int'];
};

export type BulkCertificateRecordListRelationFilter = {
  every?: Maybe<BulkCertificateRecordWhereInput>;
  none?: Maybe<BulkCertificateRecordWhereInput>;
  some?: Maybe<BulkCertificateRecordWhereInput>;
};

export type BulkCertificateRecordMaxOrderByAggregateInput = {
  bulkCertificateRecordName?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  educationLevel?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  totalCertificates?: Maybe<SortOrder>;
};

export type BulkCertificateRecordMinOrderByAggregateInput = {
  bulkCertificateRecordName?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  educationLevel?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  totalCertificates?: Maybe<SortOrder>;
};

export type BulkCertificateRecordNullableRelationFilter = {
  is?: Maybe<BulkCertificateRecordWhereInput>;
  isNot?: Maybe<BulkCertificateRecordWhereInput>;
};

export type BulkCertificateRecordOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type BulkCertificateRecordOrderByWithAggregationInput = {
  _avg?: Maybe<BulkCertificateRecordAvgOrderByAggregateInput>;
  _count?: Maybe<BulkCertificateRecordCountOrderByAggregateInput>;
  _max?: Maybe<BulkCertificateRecordMaxOrderByAggregateInput>;
  _min?: Maybe<BulkCertificateRecordMinOrderByAggregateInput>;
  _sum?: Maybe<BulkCertificateRecordSumOrderByAggregateInput>;
  bulkCertificateRecordName?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  educationLevel?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  totalCertificates?: Maybe<SortOrder>;
};

export type BulkCertificateRecordOrderByWithRelationInput = {
  DocumentCertificates?: Maybe<DocumentCertificateOrderByRelationAggregateInput>;
  Team?: Maybe<TeamOrderByWithRelationInput>;
  bulkCertificateRecordName?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  educationLevel?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  totalCertificates?: Maybe<SortOrder>;
};

export enum BulkCertificateRecordScalarFieldEnum {
  BulkCertificateRecordName = 'bulkCertificateRecordName',
  CreatedAt = 'createdAt',
  EducationLevel = 'educationLevel',
  Id = 'id',
  Status = 'status',
  TeamId = 'teamId',
  TotalCertificates = 'totalCertificates'
}

export type BulkCertificateRecordScalarWhereInput = {
  AND?: Maybe<Array<BulkCertificateRecordScalarWhereInput>>;
  NOT?: Maybe<Array<BulkCertificateRecordScalarWhereInput>>;
  OR?: Maybe<Array<BulkCertificateRecordScalarWhereInput>>;
  bulkCertificateRecordName?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  educationLevel?: Maybe<EnumEducationLevelTypeFilter>;
  id?: Maybe<StringFilter>;
  status?: Maybe<EnumDocumentCertificateStatusFilter>;
  teamId?: Maybe<IntFilter>;
  totalCertificates?: Maybe<IntFilter>;
};

export type BulkCertificateRecordScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<BulkCertificateRecordScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<BulkCertificateRecordScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<BulkCertificateRecordScalarWhereWithAggregatesInput>>;
  bulkCertificateRecordName?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  educationLevel?: Maybe<EnumEducationLevelTypeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  status?: Maybe<EnumDocumentCertificateStatusWithAggregatesFilter>;
  teamId?: Maybe<IntWithAggregatesFilter>;
  totalCertificates?: Maybe<IntWithAggregatesFilter>;
};

export type BulkCertificateRecordSumOrderByAggregateInput = {
  teamId?: Maybe<SortOrder>;
  totalCertificates?: Maybe<SortOrder>;
};

export type BulkCertificateRecordUpdateInput = {
  DocumentCertificates?: Maybe<DocumentCertificateUpdateManyWithoutBulkCertificateRecordNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutBulkCertificateRecordNestedInput>;
  bulkCertificateRecordName?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  educationLevel?: Maybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentCertificateStatusFieldUpdateOperationsInput>;
  totalCertificates?: Maybe<IntFieldUpdateOperationsInput>;
};

export type BulkCertificateRecordUpdateManyMutationInput = {
  bulkCertificateRecordName?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  educationLevel?: Maybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentCertificateStatusFieldUpdateOperationsInput>;
  totalCertificates?: Maybe<IntFieldUpdateOperationsInput>;
};

export type BulkCertificateRecordUpdateManyWithWhereWithoutTeamInput = {
  data: BulkCertificateRecordUpdateManyMutationInput;
  where: BulkCertificateRecordScalarWhereInput;
};

export type BulkCertificateRecordUpdateManyWithoutTeamNestedInput = {
  connect?: Maybe<Array<BulkCertificateRecordWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BulkCertificateRecordCreateOrConnectWithoutTeamInput>>;
  create?: Maybe<Array<BulkCertificateRecordCreateWithoutTeamInput>>;
  createMany?: Maybe<BulkCertificateRecordCreateManyTeamInputEnvelope>;
  delete?: Maybe<Array<BulkCertificateRecordWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BulkCertificateRecordScalarWhereInput>>;
  disconnect?: Maybe<Array<BulkCertificateRecordWhereUniqueInput>>;
  set?: Maybe<Array<BulkCertificateRecordWhereUniqueInput>>;
  update?: Maybe<Array<BulkCertificateRecordUpdateWithWhereUniqueWithoutTeamInput>>;
  updateMany?: Maybe<Array<BulkCertificateRecordUpdateManyWithWhereWithoutTeamInput>>;
  upsert?: Maybe<Array<BulkCertificateRecordUpsertWithWhereUniqueWithoutTeamInput>>;
};

export type BulkCertificateRecordUpdateOneWithoutDocumentCertificatesNestedInput = {
  connect?: Maybe<BulkCertificateRecordWhereUniqueInput>;
  connectOrCreate?: Maybe<BulkCertificateRecordCreateOrConnectWithoutDocumentCertificatesInput>;
  create?: Maybe<BulkCertificateRecordCreateWithoutDocumentCertificatesInput>;
  delete?: Maybe<BulkCertificateRecordWhereInput>;
  disconnect?: Maybe<BulkCertificateRecordWhereInput>;
  update?: Maybe<BulkCertificateRecordUpdateToOneWithWhereWithoutDocumentCertificatesInput>;
  upsert?: Maybe<BulkCertificateRecordUpsertWithoutDocumentCertificatesInput>;
};

export type BulkCertificateRecordUpdateToOneWithWhereWithoutDocumentCertificatesInput = {
  data: BulkCertificateRecordUpdateWithoutDocumentCertificatesInput;
  where?: Maybe<BulkCertificateRecordWhereInput>;
};

export type BulkCertificateRecordUpdateWithWhereUniqueWithoutTeamInput = {
  data: BulkCertificateRecordUpdateWithoutTeamInput;
  where: BulkCertificateRecordWhereUniqueInput;
};

export type BulkCertificateRecordUpdateWithoutDocumentCertificatesInput = {
  Team?: Maybe<TeamUpdateOneRequiredWithoutBulkCertificateRecordNestedInput>;
  bulkCertificateRecordName?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  educationLevel?: Maybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentCertificateStatusFieldUpdateOperationsInput>;
  totalCertificates?: Maybe<IntFieldUpdateOperationsInput>;
};

export type BulkCertificateRecordUpdateWithoutTeamInput = {
  DocumentCertificates?: Maybe<DocumentCertificateUpdateManyWithoutBulkCertificateRecordNestedInput>;
  bulkCertificateRecordName?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  educationLevel?: Maybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentCertificateStatusFieldUpdateOperationsInput>;
  totalCertificates?: Maybe<IntFieldUpdateOperationsInput>;
};

export type BulkCertificateRecordUpsertWithWhereUniqueWithoutTeamInput = {
  create: BulkCertificateRecordCreateWithoutTeamInput;
  update: BulkCertificateRecordUpdateWithoutTeamInput;
  where: BulkCertificateRecordWhereUniqueInput;
};

export type BulkCertificateRecordUpsertWithoutDocumentCertificatesInput = {
  create: BulkCertificateRecordCreateWithoutDocumentCertificatesInput;
  update: BulkCertificateRecordUpdateWithoutDocumentCertificatesInput;
  where?: Maybe<BulkCertificateRecordWhereInput>;
};

export type BulkCertificateRecordWhereInput = {
  AND?: Maybe<Array<BulkCertificateRecordWhereInput>>;
  DocumentCertificates?: Maybe<DocumentCertificateListRelationFilter>;
  NOT?: Maybe<Array<BulkCertificateRecordWhereInput>>;
  OR?: Maybe<Array<BulkCertificateRecordWhereInput>>;
  Team?: Maybe<TeamWhereInput>;
  bulkCertificateRecordName?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  educationLevel?: Maybe<EnumEducationLevelTypeFilter>;
  id?: Maybe<StringFilter>;
  status?: Maybe<EnumDocumentCertificateStatusFilter>;
  teamId?: Maybe<IntFilter>;
  totalCertificates?: Maybe<IntFilter>;
};

export type BulkCertificateRecordWhereUniqueInput = {
  AND?: Maybe<Array<BulkCertificateRecordWhereInput>>;
  DocumentCertificates?: Maybe<DocumentCertificateListRelationFilter>;
  NOT?: Maybe<Array<BulkCertificateRecordWhereInput>>;
  OR?: Maybe<Array<BulkCertificateRecordWhereInput>>;
  Team?: Maybe<TeamWhereInput>;
  bulkCertificateRecordName?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  educationLevel?: Maybe<EnumEducationLevelTypeFilter>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<EnumDocumentCertificateStatusFilter>;
  teamId?: Maybe<IntFilter>;
  totalCertificates?: Maybe<IntFilter>;
};

export type CertificateBase = {
  __typename?: 'CertificateBase';
  CertificateCourse?: Maybe<CertificateCourse>;
  CertificateCurriculum?: Maybe<CertificateCurriculum>;
  CertificateDiscipline?: Maybe<CertificateDiscipline>;
  CertificateEvent?: Maybe<CertificateEvent>;
  CertificateTeacher?: Maybe<CertificateTeacher>;
  CourseLevel?: Maybe<CertificateCourseLevel>;
  Team: Team;
  UserOwner: CommonUser;
  commonUserId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  educationLevel: EducationLevelType;
  id: Scalars['String'];
  teamId: Scalars['Int'];
  /** course, discipline, teacher */
  type: CertificateTypes;
};

export type CertificateBaseAvgOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type CertificateBaseCountOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  educationLevel?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
};

export type CertificateBaseCreateInput = {
  CertificateCourse?: Maybe<CertificateCourseCreateNestedOneWithoutCertificateBaseInput>;
  CertificateCurriculum?: Maybe<CertificateCurriculumCreateNestedOneWithoutCertificateBaseInput>;
  CertificateDiscipline?: Maybe<CertificateDisciplineCreateNestedOneWithoutCertificateBaseInput>;
  CertificateEvent?: Maybe<CertificateEventCreateNestedOneWithoutCertificateBaseInput>;
  CertificateTeacher?: Maybe<CertificateTeacherCreateNestedOneWithoutCertificateBaseInput>;
  CourseLevel?: Maybe<CertificateCourseLevelCreateNestedOneWithoutCertificateBaseInput>;
  Team: TeamCreateNestedOneWithoutCertificateBaseInput;
  UserOwner: CommonUserCreateNestedOneWithoutCertificateBaseInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  educationLevel?: Maybe<EducationLevelType>;
  id?: Maybe<Scalars['String']>;
  type: CertificateTypes;
};

export type CertificateBaseCreateManyInput = {
  commonUserId: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  educationLevel?: Maybe<EducationLevelType>;
  id?: Maybe<Scalars['String']>;
  teamId: Scalars['Int'];
  type: CertificateTypes;
};

export type CertificateBaseCreateManyTeamInput = {
  commonUserId: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  educationLevel?: Maybe<EducationLevelType>;
  id?: Maybe<Scalars['String']>;
  type: CertificateTypes;
};

export type CertificateBaseCreateManyTeamInputEnvelope = {
  data: Array<CertificateBaseCreateManyTeamInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CertificateBaseCreateManyUserOwnerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  educationLevel?: Maybe<EducationLevelType>;
  id?: Maybe<Scalars['String']>;
  teamId: Scalars['Int'];
  type: CertificateTypes;
};

export type CertificateBaseCreateManyUserOwnerInputEnvelope = {
  data: Array<CertificateBaseCreateManyUserOwnerInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CertificateBaseCreateNestedManyWithoutTeamInput = {
  connect?: Maybe<Array<CertificateBaseWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CertificateBaseCreateOrConnectWithoutTeamInput>>;
  create?: Maybe<Array<CertificateBaseCreateWithoutTeamInput>>;
  createMany?: Maybe<CertificateBaseCreateManyTeamInputEnvelope>;
};

export type CertificateBaseCreateNestedManyWithoutUserOwnerInput = {
  connect?: Maybe<Array<CertificateBaseWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CertificateBaseCreateOrConnectWithoutUserOwnerInput>>;
  create?: Maybe<Array<CertificateBaseCreateWithoutUserOwnerInput>>;
  createMany?: Maybe<CertificateBaseCreateManyUserOwnerInputEnvelope>;
};

export type CertificateBaseCreateNestedOneWithoutCertificateCourseInput = {
  connect?: Maybe<CertificateBaseWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateBaseCreateOrConnectWithoutCertificateCourseInput>;
  create?: Maybe<CertificateBaseCreateWithoutCertificateCourseInput>;
};

export type CertificateBaseCreateNestedOneWithoutCertificateCurriculumInput = {
  connect?: Maybe<CertificateBaseWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateBaseCreateOrConnectWithoutCertificateCurriculumInput>;
  create?: Maybe<CertificateBaseCreateWithoutCertificateCurriculumInput>;
};

export type CertificateBaseCreateNestedOneWithoutCertificateDisciplineInput = {
  connect?: Maybe<CertificateBaseWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateBaseCreateOrConnectWithoutCertificateDisciplineInput>;
  create?: Maybe<CertificateBaseCreateWithoutCertificateDisciplineInput>;
};

export type CertificateBaseCreateNestedOneWithoutCertificateEventInput = {
  connect?: Maybe<CertificateBaseWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateBaseCreateOrConnectWithoutCertificateEventInput>;
  create?: Maybe<CertificateBaseCreateWithoutCertificateEventInput>;
};

export type CertificateBaseCreateNestedOneWithoutCertificateTeacherInput = {
  connect?: Maybe<CertificateBaseWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateBaseCreateOrConnectWithoutCertificateTeacherInput>;
  create?: Maybe<CertificateBaseCreateWithoutCertificateTeacherInput>;
};

export type CertificateBaseCreateNestedOneWithoutCourseLevelInput = {
  connect?: Maybe<CertificateBaseWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateBaseCreateOrConnectWithoutCourseLevelInput>;
  create?: Maybe<CertificateBaseCreateWithoutCourseLevelInput>;
};

export type CertificateBaseCreateOrConnectWithoutCertificateCourseInput = {
  create: CertificateBaseCreateWithoutCertificateCourseInput;
  where: CertificateBaseWhereUniqueInput;
};

export type CertificateBaseCreateOrConnectWithoutCertificateCurriculumInput = {
  create: CertificateBaseCreateWithoutCertificateCurriculumInput;
  where: CertificateBaseWhereUniqueInput;
};

export type CertificateBaseCreateOrConnectWithoutCertificateDisciplineInput = {
  create: CertificateBaseCreateWithoutCertificateDisciplineInput;
  where: CertificateBaseWhereUniqueInput;
};

export type CertificateBaseCreateOrConnectWithoutCertificateEventInput = {
  create: CertificateBaseCreateWithoutCertificateEventInput;
  where: CertificateBaseWhereUniqueInput;
};

export type CertificateBaseCreateOrConnectWithoutCertificateTeacherInput = {
  create: CertificateBaseCreateWithoutCertificateTeacherInput;
  where: CertificateBaseWhereUniqueInput;
};

export type CertificateBaseCreateOrConnectWithoutCourseLevelInput = {
  create: CertificateBaseCreateWithoutCourseLevelInput;
  where: CertificateBaseWhereUniqueInput;
};

export type CertificateBaseCreateOrConnectWithoutTeamInput = {
  create: CertificateBaseCreateWithoutTeamInput;
  where: CertificateBaseWhereUniqueInput;
};

export type CertificateBaseCreateOrConnectWithoutUserOwnerInput = {
  create: CertificateBaseCreateWithoutUserOwnerInput;
  where: CertificateBaseWhereUniqueInput;
};

export type CertificateBaseCreateWithoutCertificateCourseInput = {
  CertificateCurriculum?: Maybe<CertificateCurriculumCreateNestedOneWithoutCertificateBaseInput>;
  CertificateDiscipline?: Maybe<CertificateDisciplineCreateNestedOneWithoutCertificateBaseInput>;
  CertificateEvent?: Maybe<CertificateEventCreateNestedOneWithoutCertificateBaseInput>;
  CertificateTeacher?: Maybe<CertificateTeacherCreateNestedOneWithoutCertificateBaseInput>;
  CourseLevel?: Maybe<CertificateCourseLevelCreateNestedOneWithoutCertificateBaseInput>;
  Team: TeamCreateNestedOneWithoutCertificateBaseInput;
  UserOwner: CommonUserCreateNestedOneWithoutCertificateBaseInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  educationLevel?: Maybe<EducationLevelType>;
  id?: Maybe<Scalars['String']>;
  type: CertificateTypes;
};

export type CertificateBaseCreateWithoutCertificateCurriculumInput = {
  CertificateCourse?: Maybe<CertificateCourseCreateNestedOneWithoutCertificateBaseInput>;
  CertificateDiscipline?: Maybe<CertificateDisciplineCreateNestedOneWithoutCertificateBaseInput>;
  CertificateEvent?: Maybe<CertificateEventCreateNestedOneWithoutCertificateBaseInput>;
  CertificateTeacher?: Maybe<CertificateTeacherCreateNestedOneWithoutCertificateBaseInput>;
  CourseLevel?: Maybe<CertificateCourseLevelCreateNestedOneWithoutCertificateBaseInput>;
  Team: TeamCreateNestedOneWithoutCertificateBaseInput;
  UserOwner: CommonUserCreateNestedOneWithoutCertificateBaseInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  educationLevel?: Maybe<EducationLevelType>;
  id?: Maybe<Scalars['String']>;
  type: CertificateTypes;
};

export type CertificateBaseCreateWithoutCertificateDisciplineInput = {
  CertificateCourse?: Maybe<CertificateCourseCreateNestedOneWithoutCertificateBaseInput>;
  CertificateCurriculum?: Maybe<CertificateCurriculumCreateNestedOneWithoutCertificateBaseInput>;
  CertificateEvent?: Maybe<CertificateEventCreateNestedOneWithoutCertificateBaseInput>;
  CertificateTeacher?: Maybe<CertificateTeacherCreateNestedOneWithoutCertificateBaseInput>;
  CourseLevel?: Maybe<CertificateCourseLevelCreateNestedOneWithoutCertificateBaseInput>;
  Team: TeamCreateNestedOneWithoutCertificateBaseInput;
  UserOwner: CommonUserCreateNestedOneWithoutCertificateBaseInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  educationLevel?: Maybe<EducationLevelType>;
  id?: Maybe<Scalars['String']>;
  type: CertificateTypes;
};

export type CertificateBaseCreateWithoutCertificateEventInput = {
  CertificateCourse?: Maybe<CertificateCourseCreateNestedOneWithoutCertificateBaseInput>;
  CertificateCurriculum?: Maybe<CertificateCurriculumCreateNestedOneWithoutCertificateBaseInput>;
  CertificateDiscipline?: Maybe<CertificateDisciplineCreateNestedOneWithoutCertificateBaseInput>;
  CertificateTeacher?: Maybe<CertificateTeacherCreateNestedOneWithoutCertificateBaseInput>;
  CourseLevel?: Maybe<CertificateCourseLevelCreateNestedOneWithoutCertificateBaseInput>;
  Team: TeamCreateNestedOneWithoutCertificateBaseInput;
  UserOwner: CommonUserCreateNestedOneWithoutCertificateBaseInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  educationLevel?: Maybe<EducationLevelType>;
  id?: Maybe<Scalars['String']>;
  type: CertificateTypes;
};

export type CertificateBaseCreateWithoutCertificateTeacherInput = {
  CertificateCourse?: Maybe<CertificateCourseCreateNestedOneWithoutCertificateBaseInput>;
  CertificateCurriculum?: Maybe<CertificateCurriculumCreateNestedOneWithoutCertificateBaseInput>;
  CertificateDiscipline?: Maybe<CertificateDisciplineCreateNestedOneWithoutCertificateBaseInput>;
  CertificateEvent?: Maybe<CertificateEventCreateNestedOneWithoutCertificateBaseInput>;
  CourseLevel?: Maybe<CertificateCourseLevelCreateNestedOneWithoutCertificateBaseInput>;
  Team: TeamCreateNestedOneWithoutCertificateBaseInput;
  UserOwner: CommonUserCreateNestedOneWithoutCertificateBaseInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  educationLevel?: Maybe<EducationLevelType>;
  id?: Maybe<Scalars['String']>;
  type: CertificateTypes;
};

export type CertificateBaseCreateWithoutCourseLevelInput = {
  CertificateCourse?: Maybe<CertificateCourseCreateNestedOneWithoutCertificateBaseInput>;
  CertificateCurriculum?: Maybe<CertificateCurriculumCreateNestedOneWithoutCertificateBaseInput>;
  CertificateDiscipline?: Maybe<CertificateDisciplineCreateNestedOneWithoutCertificateBaseInput>;
  CertificateEvent?: Maybe<CertificateEventCreateNestedOneWithoutCertificateBaseInput>;
  CertificateTeacher?: Maybe<CertificateTeacherCreateNestedOneWithoutCertificateBaseInput>;
  Team: TeamCreateNestedOneWithoutCertificateBaseInput;
  UserOwner: CommonUserCreateNestedOneWithoutCertificateBaseInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  educationLevel?: Maybe<EducationLevelType>;
  id?: Maybe<Scalars['String']>;
  type: CertificateTypes;
};

export type CertificateBaseCreateWithoutTeamInput = {
  CertificateCourse?: Maybe<CertificateCourseCreateNestedOneWithoutCertificateBaseInput>;
  CertificateCurriculum?: Maybe<CertificateCurriculumCreateNestedOneWithoutCertificateBaseInput>;
  CertificateDiscipline?: Maybe<CertificateDisciplineCreateNestedOneWithoutCertificateBaseInput>;
  CertificateEvent?: Maybe<CertificateEventCreateNestedOneWithoutCertificateBaseInput>;
  CertificateTeacher?: Maybe<CertificateTeacherCreateNestedOneWithoutCertificateBaseInput>;
  CourseLevel?: Maybe<CertificateCourseLevelCreateNestedOneWithoutCertificateBaseInput>;
  UserOwner: CommonUserCreateNestedOneWithoutCertificateBaseInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  educationLevel?: Maybe<EducationLevelType>;
  id?: Maybe<Scalars['String']>;
  type: CertificateTypes;
};

export type CertificateBaseCreateWithoutUserOwnerInput = {
  CertificateCourse?: Maybe<CertificateCourseCreateNestedOneWithoutCertificateBaseInput>;
  CertificateCurriculum?: Maybe<CertificateCurriculumCreateNestedOneWithoutCertificateBaseInput>;
  CertificateDiscipline?: Maybe<CertificateDisciplineCreateNestedOneWithoutCertificateBaseInput>;
  CertificateEvent?: Maybe<CertificateEventCreateNestedOneWithoutCertificateBaseInput>;
  CertificateTeacher?: Maybe<CertificateTeacherCreateNestedOneWithoutCertificateBaseInput>;
  CourseLevel?: Maybe<CertificateCourseLevelCreateNestedOneWithoutCertificateBaseInput>;
  Team: TeamCreateNestedOneWithoutCertificateBaseInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  educationLevel?: Maybe<EducationLevelType>;
  id?: Maybe<Scalars['String']>;
  type: CertificateTypes;
};

export type CertificateBaseListRelationFilter = {
  every?: Maybe<CertificateBaseWhereInput>;
  none?: Maybe<CertificateBaseWhereInput>;
  some?: Maybe<CertificateBaseWhereInput>;
};

export type CertificateBaseMaxOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  educationLevel?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
};

export type CertificateBaseMinOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  educationLevel?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
};

export type CertificateBaseOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CertificateBaseOrderByWithAggregationInput = {
  _avg?: Maybe<CertificateBaseAvgOrderByAggregateInput>;
  _count?: Maybe<CertificateBaseCountOrderByAggregateInput>;
  _max?: Maybe<CertificateBaseMaxOrderByAggregateInput>;
  _min?: Maybe<CertificateBaseMinOrderByAggregateInput>;
  _sum?: Maybe<CertificateBaseSumOrderByAggregateInput>;
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  educationLevel?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
};

export type CertificateBaseOrderByWithRelationInput = {
  CertificateCourse?: Maybe<CertificateCourseOrderByWithRelationInput>;
  CertificateCurriculum?: Maybe<CertificateCurriculumOrderByWithRelationInput>;
  CertificateDiscipline?: Maybe<CertificateDisciplineOrderByWithRelationInput>;
  CertificateEvent?: Maybe<CertificateEventOrderByWithRelationInput>;
  CertificateTeacher?: Maybe<CertificateTeacherOrderByWithRelationInput>;
  CourseLevel?: Maybe<CertificateCourseLevelOrderByWithRelationInput>;
  Team?: Maybe<TeamOrderByWithRelationInput>;
  UserOwner?: Maybe<CommonUserOrderByWithRelationInput>;
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  educationLevel?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
};

export type CertificateBaseRelationFilter = {
  is?: Maybe<CertificateBaseWhereInput>;
  isNot?: Maybe<CertificateBaseWhereInput>;
};

export enum CertificateBaseScalarFieldEnum {
  CommonUserId = 'commonUserId',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  EducationLevel = 'educationLevel',
  Id = 'id',
  TeamId = 'teamId',
  Type = 'type'
}

export type CertificateBaseScalarWhereInput = {
  AND?: Maybe<Array<CertificateBaseScalarWhereInput>>;
  NOT?: Maybe<Array<CertificateBaseScalarWhereInput>>;
  OR?: Maybe<Array<CertificateBaseScalarWhereInput>>;
  commonUserId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  educationLevel?: Maybe<EnumEducationLevelTypeFilter>;
  id?: Maybe<StringFilter>;
  teamId?: Maybe<IntFilter>;
  type?: Maybe<EnumCertificateTypesFilter>;
};

export type CertificateBaseScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CertificateBaseScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CertificateBaseScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CertificateBaseScalarWhereWithAggregatesInput>>;
  commonUserId?: Maybe<IntWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  deletedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  educationLevel?: Maybe<EnumEducationLevelTypeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  teamId?: Maybe<IntWithAggregatesFilter>;
  type?: Maybe<EnumCertificateTypesWithAggregatesFilter>;
};

export type CertificateBaseSumOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type CertificateBaseUpdateInput = {
  CertificateCourse?: Maybe<CertificateCourseUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateCurriculum?: Maybe<CertificateCurriculumUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateDiscipline?: Maybe<CertificateDisciplineUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateEvent?: Maybe<CertificateEventUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateTeacher?: Maybe<CertificateTeacherUpdateOneWithoutCertificateBaseNestedInput>;
  CourseLevel?: Maybe<CertificateCourseLevelUpdateOneWithoutCertificateBaseNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutCertificateBaseNestedInput>;
  UserOwner?: Maybe<CommonUserUpdateOneRequiredWithoutCertificateBaseNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  educationLevel?: Maybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  type?: Maybe<EnumCertificateTypesFieldUpdateOperationsInput>;
};

export type CertificateBaseUpdateManyMutationInput = {
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  educationLevel?: Maybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  type?: Maybe<EnumCertificateTypesFieldUpdateOperationsInput>;
};

export type CertificateBaseUpdateManyWithWhereWithoutTeamInput = {
  data: CertificateBaseUpdateManyMutationInput;
  where: CertificateBaseScalarWhereInput;
};

export type CertificateBaseUpdateManyWithWhereWithoutUserOwnerInput = {
  data: CertificateBaseUpdateManyMutationInput;
  where: CertificateBaseScalarWhereInput;
};

export type CertificateBaseUpdateManyWithoutTeamNestedInput = {
  connect?: Maybe<Array<CertificateBaseWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CertificateBaseCreateOrConnectWithoutTeamInput>>;
  create?: Maybe<Array<CertificateBaseCreateWithoutTeamInput>>;
  createMany?: Maybe<CertificateBaseCreateManyTeamInputEnvelope>;
  delete?: Maybe<Array<CertificateBaseWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CertificateBaseScalarWhereInput>>;
  disconnect?: Maybe<Array<CertificateBaseWhereUniqueInput>>;
  set?: Maybe<Array<CertificateBaseWhereUniqueInput>>;
  update?: Maybe<Array<CertificateBaseUpdateWithWhereUniqueWithoutTeamInput>>;
  updateMany?: Maybe<Array<CertificateBaseUpdateManyWithWhereWithoutTeamInput>>;
  upsert?: Maybe<Array<CertificateBaseUpsertWithWhereUniqueWithoutTeamInput>>;
};

export type CertificateBaseUpdateManyWithoutUserOwnerNestedInput = {
  connect?: Maybe<Array<CertificateBaseWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CertificateBaseCreateOrConnectWithoutUserOwnerInput>>;
  create?: Maybe<Array<CertificateBaseCreateWithoutUserOwnerInput>>;
  createMany?: Maybe<CertificateBaseCreateManyUserOwnerInputEnvelope>;
  delete?: Maybe<Array<CertificateBaseWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CertificateBaseScalarWhereInput>>;
  disconnect?: Maybe<Array<CertificateBaseWhereUniqueInput>>;
  set?: Maybe<Array<CertificateBaseWhereUniqueInput>>;
  update?: Maybe<Array<CertificateBaseUpdateWithWhereUniqueWithoutUserOwnerInput>>;
  updateMany?: Maybe<Array<CertificateBaseUpdateManyWithWhereWithoutUserOwnerInput>>;
  upsert?: Maybe<Array<CertificateBaseUpsertWithWhereUniqueWithoutUserOwnerInput>>;
};

export type CertificateBaseUpdateOneRequiredWithoutCertificateCourseNestedInput = {
  connect?: Maybe<CertificateBaseWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateBaseCreateOrConnectWithoutCertificateCourseInput>;
  create?: Maybe<CertificateBaseCreateWithoutCertificateCourseInput>;
  update?: Maybe<CertificateBaseUpdateToOneWithWhereWithoutCertificateCourseInput>;
  upsert?: Maybe<CertificateBaseUpsertWithoutCertificateCourseInput>;
};

export type CertificateBaseUpdateOneRequiredWithoutCertificateCurriculumNestedInput = {
  connect?: Maybe<CertificateBaseWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateBaseCreateOrConnectWithoutCertificateCurriculumInput>;
  create?: Maybe<CertificateBaseCreateWithoutCertificateCurriculumInput>;
  update?: Maybe<CertificateBaseUpdateToOneWithWhereWithoutCertificateCurriculumInput>;
  upsert?: Maybe<CertificateBaseUpsertWithoutCertificateCurriculumInput>;
};

export type CertificateBaseUpdateOneRequiredWithoutCertificateDisciplineNestedInput = {
  connect?: Maybe<CertificateBaseWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateBaseCreateOrConnectWithoutCertificateDisciplineInput>;
  create?: Maybe<CertificateBaseCreateWithoutCertificateDisciplineInput>;
  update?: Maybe<CertificateBaseUpdateToOneWithWhereWithoutCertificateDisciplineInput>;
  upsert?: Maybe<CertificateBaseUpsertWithoutCertificateDisciplineInput>;
};

export type CertificateBaseUpdateOneRequiredWithoutCertificateEventNestedInput = {
  connect?: Maybe<CertificateBaseWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateBaseCreateOrConnectWithoutCertificateEventInput>;
  create?: Maybe<CertificateBaseCreateWithoutCertificateEventInput>;
  update?: Maybe<CertificateBaseUpdateToOneWithWhereWithoutCertificateEventInput>;
  upsert?: Maybe<CertificateBaseUpsertWithoutCertificateEventInput>;
};

export type CertificateBaseUpdateOneRequiredWithoutCertificateTeacherNestedInput = {
  connect?: Maybe<CertificateBaseWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateBaseCreateOrConnectWithoutCertificateTeacherInput>;
  create?: Maybe<CertificateBaseCreateWithoutCertificateTeacherInput>;
  update?: Maybe<CertificateBaseUpdateToOneWithWhereWithoutCertificateTeacherInput>;
  upsert?: Maybe<CertificateBaseUpsertWithoutCertificateTeacherInput>;
};

export type CertificateBaseUpdateOneRequiredWithoutCourseLevelNestedInput = {
  connect?: Maybe<CertificateBaseWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateBaseCreateOrConnectWithoutCourseLevelInput>;
  create?: Maybe<CertificateBaseCreateWithoutCourseLevelInput>;
  update?: Maybe<CertificateBaseUpdateToOneWithWhereWithoutCourseLevelInput>;
  upsert?: Maybe<CertificateBaseUpsertWithoutCourseLevelInput>;
};

export type CertificateBaseUpdateToOneWithWhereWithoutCertificateCourseInput = {
  data: CertificateBaseUpdateWithoutCertificateCourseInput;
  where?: Maybe<CertificateBaseWhereInput>;
};

export type CertificateBaseUpdateToOneWithWhereWithoutCertificateCurriculumInput = {
  data: CertificateBaseUpdateWithoutCertificateCurriculumInput;
  where?: Maybe<CertificateBaseWhereInput>;
};

export type CertificateBaseUpdateToOneWithWhereWithoutCertificateDisciplineInput = {
  data: CertificateBaseUpdateWithoutCertificateDisciplineInput;
  where?: Maybe<CertificateBaseWhereInput>;
};

export type CertificateBaseUpdateToOneWithWhereWithoutCertificateEventInput = {
  data: CertificateBaseUpdateWithoutCertificateEventInput;
  where?: Maybe<CertificateBaseWhereInput>;
};

export type CertificateBaseUpdateToOneWithWhereWithoutCertificateTeacherInput = {
  data: CertificateBaseUpdateWithoutCertificateTeacherInput;
  where?: Maybe<CertificateBaseWhereInput>;
};

export type CertificateBaseUpdateToOneWithWhereWithoutCourseLevelInput = {
  data: CertificateBaseUpdateWithoutCourseLevelInput;
  where?: Maybe<CertificateBaseWhereInput>;
};

export type CertificateBaseUpdateWithWhereUniqueWithoutTeamInput = {
  data: CertificateBaseUpdateWithoutTeamInput;
  where: CertificateBaseWhereUniqueInput;
};

export type CertificateBaseUpdateWithWhereUniqueWithoutUserOwnerInput = {
  data: CertificateBaseUpdateWithoutUserOwnerInput;
  where: CertificateBaseWhereUniqueInput;
};

export type CertificateBaseUpdateWithoutCertificateCourseInput = {
  CertificateCurriculum?: Maybe<CertificateCurriculumUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateDiscipline?: Maybe<CertificateDisciplineUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateEvent?: Maybe<CertificateEventUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateTeacher?: Maybe<CertificateTeacherUpdateOneWithoutCertificateBaseNestedInput>;
  CourseLevel?: Maybe<CertificateCourseLevelUpdateOneWithoutCertificateBaseNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutCertificateBaseNestedInput>;
  UserOwner?: Maybe<CommonUserUpdateOneRequiredWithoutCertificateBaseNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  educationLevel?: Maybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  type?: Maybe<EnumCertificateTypesFieldUpdateOperationsInput>;
};

export type CertificateBaseUpdateWithoutCertificateCurriculumInput = {
  CertificateCourse?: Maybe<CertificateCourseUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateDiscipline?: Maybe<CertificateDisciplineUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateEvent?: Maybe<CertificateEventUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateTeacher?: Maybe<CertificateTeacherUpdateOneWithoutCertificateBaseNestedInput>;
  CourseLevel?: Maybe<CertificateCourseLevelUpdateOneWithoutCertificateBaseNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutCertificateBaseNestedInput>;
  UserOwner?: Maybe<CommonUserUpdateOneRequiredWithoutCertificateBaseNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  educationLevel?: Maybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  type?: Maybe<EnumCertificateTypesFieldUpdateOperationsInput>;
};

export type CertificateBaseUpdateWithoutCertificateDisciplineInput = {
  CertificateCourse?: Maybe<CertificateCourseUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateCurriculum?: Maybe<CertificateCurriculumUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateEvent?: Maybe<CertificateEventUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateTeacher?: Maybe<CertificateTeacherUpdateOneWithoutCertificateBaseNestedInput>;
  CourseLevel?: Maybe<CertificateCourseLevelUpdateOneWithoutCertificateBaseNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutCertificateBaseNestedInput>;
  UserOwner?: Maybe<CommonUserUpdateOneRequiredWithoutCertificateBaseNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  educationLevel?: Maybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  type?: Maybe<EnumCertificateTypesFieldUpdateOperationsInput>;
};

export type CertificateBaseUpdateWithoutCertificateEventInput = {
  CertificateCourse?: Maybe<CertificateCourseUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateCurriculum?: Maybe<CertificateCurriculumUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateDiscipline?: Maybe<CertificateDisciplineUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateTeacher?: Maybe<CertificateTeacherUpdateOneWithoutCertificateBaseNestedInput>;
  CourseLevel?: Maybe<CertificateCourseLevelUpdateOneWithoutCertificateBaseNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutCertificateBaseNestedInput>;
  UserOwner?: Maybe<CommonUserUpdateOneRequiredWithoutCertificateBaseNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  educationLevel?: Maybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  type?: Maybe<EnumCertificateTypesFieldUpdateOperationsInput>;
};

export type CertificateBaseUpdateWithoutCertificateTeacherInput = {
  CertificateCourse?: Maybe<CertificateCourseUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateCurriculum?: Maybe<CertificateCurriculumUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateDiscipline?: Maybe<CertificateDisciplineUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateEvent?: Maybe<CertificateEventUpdateOneWithoutCertificateBaseNestedInput>;
  CourseLevel?: Maybe<CertificateCourseLevelUpdateOneWithoutCertificateBaseNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutCertificateBaseNestedInput>;
  UserOwner?: Maybe<CommonUserUpdateOneRequiredWithoutCertificateBaseNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  educationLevel?: Maybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  type?: Maybe<EnumCertificateTypesFieldUpdateOperationsInput>;
};

export type CertificateBaseUpdateWithoutCourseLevelInput = {
  CertificateCourse?: Maybe<CertificateCourseUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateCurriculum?: Maybe<CertificateCurriculumUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateDiscipline?: Maybe<CertificateDisciplineUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateEvent?: Maybe<CertificateEventUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateTeacher?: Maybe<CertificateTeacherUpdateOneWithoutCertificateBaseNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutCertificateBaseNestedInput>;
  UserOwner?: Maybe<CommonUserUpdateOneRequiredWithoutCertificateBaseNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  educationLevel?: Maybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  type?: Maybe<EnumCertificateTypesFieldUpdateOperationsInput>;
};

export type CertificateBaseUpdateWithoutTeamInput = {
  CertificateCourse?: Maybe<CertificateCourseUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateCurriculum?: Maybe<CertificateCurriculumUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateDiscipline?: Maybe<CertificateDisciplineUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateEvent?: Maybe<CertificateEventUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateTeacher?: Maybe<CertificateTeacherUpdateOneWithoutCertificateBaseNestedInput>;
  CourseLevel?: Maybe<CertificateCourseLevelUpdateOneWithoutCertificateBaseNestedInput>;
  UserOwner?: Maybe<CommonUserUpdateOneRequiredWithoutCertificateBaseNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  educationLevel?: Maybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  type?: Maybe<EnumCertificateTypesFieldUpdateOperationsInput>;
};

export type CertificateBaseUpdateWithoutUserOwnerInput = {
  CertificateCourse?: Maybe<CertificateCourseUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateCurriculum?: Maybe<CertificateCurriculumUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateDiscipline?: Maybe<CertificateDisciplineUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateEvent?: Maybe<CertificateEventUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateTeacher?: Maybe<CertificateTeacherUpdateOneWithoutCertificateBaseNestedInput>;
  CourseLevel?: Maybe<CertificateCourseLevelUpdateOneWithoutCertificateBaseNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutCertificateBaseNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  educationLevel?: Maybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  type?: Maybe<EnumCertificateTypesFieldUpdateOperationsInput>;
};

export type CertificateBaseUpsertWithWhereUniqueWithoutTeamInput = {
  create: CertificateBaseCreateWithoutTeamInput;
  update: CertificateBaseUpdateWithoutTeamInput;
  where: CertificateBaseWhereUniqueInput;
};

export type CertificateBaseUpsertWithWhereUniqueWithoutUserOwnerInput = {
  create: CertificateBaseCreateWithoutUserOwnerInput;
  update: CertificateBaseUpdateWithoutUserOwnerInput;
  where: CertificateBaseWhereUniqueInput;
};

export type CertificateBaseUpsertWithoutCertificateCourseInput = {
  create: CertificateBaseCreateWithoutCertificateCourseInput;
  update: CertificateBaseUpdateWithoutCertificateCourseInput;
  where?: Maybe<CertificateBaseWhereInput>;
};

export type CertificateBaseUpsertWithoutCertificateCurriculumInput = {
  create: CertificateBaseCreateWithoutCertificateCurriculumInput;
  update: CertificateBaseUpdateWithoutCertificateCurriculumInput;
  where?: Maybe<CertificateBaseWhereInput>;
};

export type CertificateBaseUpsertWithoutCertificateDisciplineInput = {
  create: CertificateBaseCreateWithoutCertificateDisciplineInput;
  update: CertificateBaseUpdateWithoutCertificateDisciplineInput;
  where?: Maybe<CertificateBaseWhereInput>;
};

export type CertificateBaseUpsertWithoutCertificateEventInput = {
  create: CertificateBaseCreateWithoutCertificateEventInput;
  update: CertificateBaseUpdateWithoutCertificateEventInput;
  where?: Maybe<CertificateBaseWhereInput>;
};

export type CertificateBaseUpsertWithoutCertificateTeacherInput = {
  create: CertificateBaseCreateWithoutCertificateTeacherInput;
  update: CertificateBaseUpdateWithoutCertificateTeacherInput;
  where?: Maybe<CertificateBaseWhereInput>;
};

export type CertificateBaseUpsertWithoutCourseLevelInput = {
  create: CertificateBaseCreateWithoutCourseLevelInput;
  update: CertificateBaseUpdateWithoutCourseLevelInput;
  where?: Maybe<CertificateBaseWhereInput>;
};

export type CertificateBaseWhereInput = {
  AND?: Maybe<Array<CertificateBaseWhereInput>>;
  CertificateCourse?: Maybe<CertificateCourseWhereInput>;
  CertificateCurriculum?: Maybe<CertificateCurriculumWhereInput>;
  CertificateDiscipline?: Maybe<CertificateDisciplineWhereInput>;
  CertificateEvent?: Maybe<CertificateEventWhereInput>;
  CertificateTeacher?: Maybe<CertificateTeacherWhereInput>;
  CourseLevel?: Maybe<CertificateCourseLevelWhereInput>;
  NOT?: Maybe<Array<CertificateBaseWhereInput>>;
  OR?: Maybe<Array<CertificateBaseWhereInput>>;
  Team?: Maybe<TeamWhereInput>;
  UserOwner?: Maybe<CommonUserWhereInput>;
  commonUserId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  educationLevel?: Maybe<EnumEducationLevelTypeFilter>;
  id?: Maybe<StringFilter>;
  teamId?: Maybe<IntFilter>;
  type?: Maybe<EnumCertificateTypesFilter>;
};

export type CertificateBaseWhereUniqueInput = {
  AND?: Maybe<Array<CertificateBaseWhereInput>>;
  CertificateCourse?: Maybe<CertificateCourseWhereInput>;
  CertificateCurriculum?: Maybe<CertificateCurriculumWhereInput>;
  CertificateDiscipline?: Maybe<CertificateDisciplineWhereInput>;
  CertificateEvent?: Maybe<CertificateEventWhereInput>;
  CertificateTeacher?: Maybe<CertificateTeacherWhereInput>;
  CourseLevel?: Maybe<CertificateCourseLevelWhereInput>;
  NOT?: Maybe<Array<CertificateBaseWhereInput>>;
  OR?: Maybe<Array<CertificateBaseWhereInput>>;
  Team?: Maybe<TeamWhereInput>;
  UserOwner?: Maybe<CommonUserWhereInput>;
  commonUserId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  educationLevel?: Maybe<EnumEducationLevelTypeFilter>;
  id?: Maybe<Scalars['String']>;
  teamId?: Maybe<IntFilter>;
  type?: Maybe<EnumCertificateTypesFilter>;
};

export type CertificateCourse = {
  __typename?: 'CertificateCourse';
  CertificateBase: CertificateBase;
  CertificateCurriculum: Array<CertificateCurriculum>;
  CourseLevel?: Maybe<CertificateCourseLevel>;
  areaKnowledge: Scalars['String'];
  certificateBaseId: Scalars['String'];
  courseLevelCertificateBaseId?: Maybe<Scalars['String']>;
  metaData: Array<Scalars['String']>;
  name: Scalars['String'];
};


export type CertificateCourseCertificateCurriculumArgs = {
  cursor?: Maybe<CertificateCurriculumWhereUniqueInput>;
  distinct?: Maybe<Array<CertificateCurriculumScalarFieldEnum>>;
  orderBy?: Maybe<Array<CertificateCurriculumOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CertificateCurriculumWhereInput>;
};

export type CertificateCourseCountOrderByAggregateInput = {
  areaKnowledge?: Maybe<SortOrder>;
  certificateBaseId?: Maybe<SortOrder>;
  courseLevelCertificateBaseId?: Maybe<SortOrder>;
  metaData?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
};

export type CertificateCourseCreateInput = {
  CertificateBase: CertificateBaseCreateNestedOneWithoutCertificateCourseInput;
  CertificateCurriculum?: Maybe<CertificateCurriculumCreateNestedManyWithoutCertificateCourseInput>;
  CourseLevel?: Maybe<CertificateCourseLevelCreateNestedOneWithoutCertificateCourseInput>;
  areaKnowledge: Scalars['String'];
  metaData?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
};

export type CertificateCourseCreateManyCourseLevelInput = {
  areaKnowledge: Scalars['String'];
  certificateBaseId: Scalars['String'];
  metaData?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
};

export type CertificateCourseCreateManyCourseLevelInputEnvelope = {
  data: Array<CertificateCourseCreateManyCourseLevelInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CertificateCourseCreateManyInput = {
  areaKnowledge: Scalars['String'];
  certificateBaseId: Scalars['String'];
  courseLevelCertificateBaseId?: Maybe<Scalars['String']>;
  metaData?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
};

export type CertificateCourseCreateNestedManyWithoutCourseLevelInput = {
  connect?: Maybe<Array<CertificateCourseWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CertificateCourseCreateOrConnectWithoutCourseLevelInput>>;
  create?: Maybe<Array<CertificateCourseCreateWithoutCourseLevelInput>>;
  createMany?: Maybe<CertificateCourseCreateManyCourseLevelInputEnvelope>;
};

export type CertificateCourseCreateNestedOneWithoutCertificateBaseInput = {
  connect?: Maybe<CertificateCourseWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateCourseCreateOrConnectWithoutCertificateBaseInput>;
  create?: Maybe<CertificateCourseCreateWithoutCertificateBaseInput>;
};

export type CertificateCourseCreateNestedOneWithoutCertificateCurriculumInput = {
  connect?: Maybe<CertificateCourseWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateCourseCreateOrConnectWithoutCertificateCurriculumInput>;
  create?: Maybe<CertificateCourseCreateWithoutCertificateCurriculumInput>;
};

export type CertificateCourseCreateOrConnectWithoutCertificateBaseInput = {
  create: CertificateCourseCreateWithoutCertificateBaseInput;
  where: CertificateCourseWhereUniqueInput;
};

export type CertificateCourseCreateOrConnectWithoutCertificateCurriculumInput = {
  create: CertificateCourseCreateWithoutCertificateCurriculumInput;
  where: CertificateCourseWhereUniqueInput;
};

export type CertificateCourseCreateOrConnectWithoutCourseLevelInput = {
  create: CertificateCourseCreateWithoutCourseLevelInput;
  where: CertificateCourseWhereUniqueInput;
};

export type CertificateCourseCreateWithoutCertificateBaseInput = {
  CertificateCurriculum?: Maybe<CertificateCurriculumCreateNestedManyWithoutCertificateCourseInput>;
  CourseLevel?: Maybe<CertificateCourseLevelCreateNestedOneWithoutCertificateCourseInput>;
  areaKnowledge: Scalars['String'];
  metaData?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
};

export type CertificateCourseCreateWithoutCertificateCurriculumInput = {
  CertificateBase: CertificateBaseCreateNestedOneWithoutCertificateCourseInput;
  CourseLevel?: Maybe<CertificateCourseLevelCreateNestedOneWithoutCertificateCourseInput>;
  areaKnowledge: Scalars['String'];
  metaData?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
};

export type CertificateCourseCreateWithoutCourseLevelInput = {
  CertificateBase: CertificateBaseCreateNestedOneWithoutCertificateCourseInput;
  CertificateCurriculum?: Maybe<CertificateCurriculumCreateNestedManyWithoutCertificateCourseInput>;
  areaKnowledge: Scalars['String'];
  metaData?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
};

export type CertificateCourseCreatemetaDataInput = {
  set: Array<Scalars['String']>;
};

export type CertificateCourseLevel = {
  __typename?: 'CertificateCourseLevel';
  CertificateBase: CertificateBase;
  CertificateCourse: Array<CertificateCourse>;
  certificateBaseId: Scalars['String'];
  name: Scalars['String'];
};


export type CertificateCourseLevelCertificateCourseArgs = {
  cursor?: Maybe<CertificateCourseWhereUniqueInput>;
  distinct?: Maybe<Array<CertificateCourseScalarFieldEnum>>;
  orderBy?: Maybe<Array<CertificateCourseOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CertificateCourseWhereInput>;
};

export type CertificateCourseLevelCountOrderByAggregateInput = {
  certificateBaseId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
};

export type CertificateCourseLevelCreateInput = {
  CertificateBase: CertificateBaseCreateNestedOneWithoutCourseLevelInput;
  CertificateCourse?: Maybe<CertificateCourseCreateNestedManyWithoutCourseLevelInput>;
  name: Scalars['String'];
};

export type CertificateCourseLevelCreateManyInput = {
  certificateBaseId: Scalars['String'];
  name: Scalars['String'];
};

export type CertificateCourseLevelCreateNestedOneWithoutCertificateBaseInput = {
  connect?: Maybe<CertificateCourseLevelWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateCourseLevelCreateOrConnectWithoutCertificateBaseInput>;
  create?: Maybe<CertificateCourseLevelCreateWithoutCertificateBaseInput>;
};

export type CertificateCourseLevelCreateNestedOneWithoutCertificateCourseInput = {
  connect?: Maybe<CertificateCourseLevelWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateCourseLevelCreateOrConnectWithoutCertificateCourseInput>;
  create?: Maybe<CertificateCourseLevelCreateWithoutCertificateCourseInput>;
};

export type CertificateCourseLevelCreateOrConnectWithoutCertificateBaseInput = {
  create: CertificateCourseLevelCreateWithoutCertificateBaseInput;
  where: CertificateCourseLevelWhereUniqueInput;
};

export type CertificateCourseLevelCreateOrConnectWithoutCertificateCourseInput = {
  create: CertificateCourseLevelCreateWithoutCertificateCourseInput;
  where: CertificateCourseLevelWhereUniqueInput;
};

export type CertificateCourseLevelCreateWithoutCertificateBaseInput = {
  CertificateCourse?: Maybe<CertificateCourseCreateNestedManyWithoutCourseLevelInput>;
  name: Scalars['String'];
};

export type CertificateCourseLevelCreateWithoutCertificateCourseInput = {
  CertificateBase: CertificateBaseCreateNestedOneWithoutCourseLevelInput;
  name: Scalars['String'];
};

export type CertificateCourseLevelMaxOrderByAggregateInput = {
  certificateBaseId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
};

export type CertificateCourseLevelMinOrderByAggregateInput = {
  certificateBaseId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
};

export type CertificateCourseLevelNullableRelationFilter = {
  is?: Maybe<CertificateCourseLevelWhereInput>;
  isNot?: Maybe<CertificateCourseLevelWhereInput>;
};

export type CertificateCourseLevelOrderByWithAggregationInput = {
  _count?: Maybe<CertificateCourseLevelCountOrderByAggregateInput>;
  _max?: Maybe<CertificateCourseLevelMaxOrderByAggregateInput>;
  _min?: Maybe<CertificateCourseLevelMinOrderByAggregateInput>;
  certificateBaseId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
};

export type CertificateCourseLevelOrderByWithRelationInput = {
  CertificateBase?: Maybe<CertificateBaseOrderByWithRelationInput>;
  CertificateCourse?: Maybe<CertificateCourseOrderByRelationAggregateInput>;
  certificateBaseId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
};

export enum CertificateCourseLevelScalarFieldEnum {
  CertificateBaseId = 'certificateBaseId',
  Name = 'name'
}

export type CertificateCourseLevelScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CertificateCourseLevelScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CertificateCourseLevelScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CertificateCourseLevelScalarWhereWithAggregatesInput>>;
  certificateBaseId?: Maybe<StringWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
};

export type CertificateCourseLevelUpdateInput = {
  CertificateBase?: Maybe<CertificateBaseUpdateOneRequiredWithoutCourseLevelNestedInput>;
  CertificateCourse?: Maybe<CertificateCourseUpdateManyWithoutCourseLevelNestedInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
};

export type CertificateCourseLevelUpdateManyMutationInput = {
  name?: Maybe<StringFieldUpdateOperationsInput>;
};

export type CertificateCourseLevelUpdateOneWithoutCertificateBaseNestedInput = {
  connect?: Maybe<CertificateCourseLevelWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateCourseLevelCreateOrConnectWithoutCertificateBaseInput>;
  create?: Maybe<CertificateCourseLevelCreateWithoutCertificateBaseInput>;
  delete?: Maybe<CertificateCourseLevelWhereInput>;
  disconnect?: Maybe<CertificateCourseLevelWhereInput>;
  update?: Maybe<CertificateCourseLevelUpdateToOneWithWhereWithoutCertificateBaseInput>;
  upsert?: Maybe<CertificateCourseLevelUpsertWithoutCertificateBaseInput>;
};

export type CertificateCourseLevelUpdateOneWithoutCertificateCourseNestedInput = {
  connect?: Maybe<CertificateCourseLevelWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateCourseLevelCreateOrConnectWithoutCertificateCourseInput>;
  create?: Maybe<CertificateCourseLevelCreateWithoutCertificateCourseInput>;
  delete?: Maybe<CertificateCourseLevelWhereInput>;
  disconnect?: Maybe<CertificateCourseLevelWhereInput>;
  update?: Maybe<CertificateCourseLevelUpdateToOneWithWhereWithoutCertificateCourseInput>;
  upsert?: Maybe<CertificateCourseLevelUpsertWithoutCertificateCourseInput>;
};

export type CertificateCourseLevelUpdateToOneWithWhereWithoutCertificateBaseInput = {
  data: CertificateCourseLevelUpdateWithoutCertificateBaseInput;
  where?: Maybe<CertificateCourseLevelWhereInput>;
};

export type CertificateCourseLevelUpdateToOneWithWhereWithoutCertificateCourseInput = {
  data: CertificateCourseLevelUpdateWithoutCertificateCourseInput;
  where?: Maybe<CertificateCourseLevelWhereInput>;
};

export type CertificateCourseLevelUpdateWithoutCertificateBaseInput = {
  CertificateCourse?: Maybe<CertificateCourseUpdateManyWithoutCourseLevelNestedInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
};

export type CertificateCourseLevelUpdateWithoutCertificateCourseInput = {
  CertificateBase?: Maybe<CertificateBaseUpdateOneRequiredWithoutCourseLevelNestedInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
};

export type CertificateCourseLevelUpsertWithoutCertificateBaseInput = {
  create: CertificateCourseLevelCreateWithoutCertificateBaseInput;
  update: CertificateCourseLevelUpdateWithoutCertificateBaseInput;
  where?: Maybe<CertificateCourseLevelWhereInput>;
};

export type CertificateCourseLevelUpsertWithoutCertificateCourseInput = {
  create: CertificateCourseLevelCreateWithoutCertificateCourseInput;
  update: CertificateCourseLevelUpdateWithoutCertificateCourseInput;
  where?: Maybe<CertificateCourseLevelWhereInput>;
};

export type CertificateCourseLevelWhereInput = {
  AND?: Maybe<Array<CertificateCourseLevelWhereInput>>;
  CertificateBase?: Maybe<CertificateBaseWhereInput>;
  CertificateCourse?: Maybe<CertificateCourseListRelationFilter>;
  NOT?: Maybe<Array<CertificateCourseLevelWhereInput>>;
  OR?: Maybe<Array<CertificateCourseLevelWhereInput>>;
  certificateBaseId?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
};

export type CertificateCourseLevelWhereUniqueInput = {
  AND?: Maybe<Array<CertificateCourseLevelWhereInput>>;
  CertificateBase?: Maybe<CertificateBaseWhereInput>;
  CertificateCourse?: Maybe<CertificateCourseListRelationFilter>;
  NOT?: Maybe<Array<CertificateCourseLevelWhereInput>>;
  OR?: Maybe<Array<CertificateCourseLevelWhereInput>>;
  certificateBaseId?: Maybe<Scalars['String']>;
  name?: Maybe<StringFilter>;
};

export type CertificateCourseListRelationFilter = {
  every?: Maybe<CertificateCourseWhereInput>;
  none?: Maybe<CertificateCourseWhereInput>;
  some?: Maybe<CertificateCourseWhereInput>;
};

export type CertificateCourseMaxOrderByAggregateInput = {
  areaKnowledge?: Maybe<SortOrder>;
  certificateBaseId?: Maybe<SortOrder>;
  courseLevelCertificateBaseId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
};

export type CertificateCourseMinOrderByAggregateInput = {
  areaKnowledge?: Maybe<SortOrder>;
  certificateBaseId?: Maybe<SortOrder>;
  courseLevelCertificateBaseId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
};

export type CertificateCourseNullableRelationFilter = {
  is?: Maybe<CertificateCourseWhereInput>;
  isNot?: Maybe<CertificateCourseWhereInput>;
};

export type CertificateCourseOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CertificateCourseOrderByWithAggregationInput = {
  _count?: Maybe<CertificateCourseCountOrderByAggregateInput>;
  _max?: Maybe<CertificateCourseMaxOrderByAggregateInput>;
  _min?: Maybe<CertificateCourseMinOrderByAggregateInput>;
  areaKnowledge?: Maybe<SortOrder>;
  certificateBaseId?: Maybe<SortOrder>;
  courseLevelCertificateBaseId?: Maybe<SortOrder>;
  metaData?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
};

export type CertificateCourseOrderByWithRelationInput = {
  CertificateBase?: Maybe<CertificateBaseOrderByWithRelationInput>;
  CertificateCurriculum?: Maybe<CertificateCurriculumOrderByRelationAggregateInput>;
  CourseLevel?: Maybe<CertificateCourseLevelOrderByWithRelationInput>;
  areaKnowledge?: Maybe<SortOrder>;
  certificateBaseId?: Maybe<SortOrder>;
  courseLevelCertificateBaseId?: Maybe<SortOrder>;
  metaData?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
};

export type CertificateCourseRelationFilter = {
  is?: Maybe<CertificateCourseWhereInput>;
  isNot?: Maybe<CertificateCourseWhereInput>;
};

export enum CertificateCourseScalarFieldEnum {
  AreaKnowledge = 'areaKnowledge',
  CertificateBaseId = 'certificateBaseId',
  CourseLevelCertificateBaseId = 'courseLevelCertificateBaseId',
  MetaData = 'metaData',
  Name = 'name'
}

export type CertificateCourseScalarWhereInput = {
  AND?: Maybe<Array<CertificateCourseScalarWhereInput>>;
  NOT?: Maybe<Array<CertificateCourseScalarWhereInput>>;
  OR?: Maybe<Array<CertificateCourseScalarWhereInput>>;
  areaKnowledge?: Maybe<StringFilter>;
  certificateBaseId?: Maybe<StringFilter>;
  courseLevelCertificateBaseId?: Maybe<StringNullableFilter>;
  metaData?: Maybe<StringNullableListFilter>;
  name?: Maybe<StringFilter>;
};

export type CertificateCourseScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CertificateCourseScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CertificateCourseScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CertificateCourseScalarWhereWithAggregatesInput>>;
  areaKnowledge?: Maybe<StringWithAggregatesFilter>;
  certificateBaseId?: Maybe<StringWithAggregatesFilter>;
  courseLevelCertificateBaseId?: Maybe<StringNullableWithAggregatesFilter>;
  metaData?: Maybe<StringNullableListFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
};

export type CertificateCourseUpdateInput = {
  CertificateBase?: Maybe<CertificateBaseUpdateOneRequiredWithoutCertificateCourseNestedInput>;
  CertificateCurriculum?: Maybe<CertificateCurriculumUpdateManyWithoutCertificateCourseNestedInput>;
  CourseLevel?: Maybe<CertificateCourseLevelUpdateOneWithoutCertificateCourseNestedInput>;
  areaKnowledge?: Maybe<StringFieldUpdateOperationsInput>;
  metaData?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
};

export type CertificateCourseUpdateManyMutationInput = {
  areaKnowledge?: Maybe<StringFieldUpdateOperationsInput>;
  metaData?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
};

export type CertificateCourseUpdateManyWithWhereWithoutCourseLevelInput = {
  data: CertificateCourseUpdateManyMutationInput;
  where: CertificateCourseScalarWhereInput;
};

export type CertificateCourseUpdateManyWithoutCourseLevelNestedInput = {
  connect?: Maybe<Array<CertificateCourseWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CertificateCourseCreateOrConnectWithoutCourseLevelInput>>;
  create?: Maybe<Array<CertificateCourseCreateWithoutCourseLevelInput>>;
  createMany?: Maybe<CertificateCourseCreateManyCourseLevelInputEnvelope>;
  delete?: Maybe<Array<CertificateCourseWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CertificateCourseScalarWhereInput>>;
  disconnect?: Maybe<Array<CertificateCourseWhereUniqueInput>>;
  set?: Maybe<Array<CertificateCourseWhereUniqueInput>>;
  update?: Maybe<Array<CertificateCourseUpdateWithWhereUniqueWithoutCourseLevelInput>>;
  updateMany?: Maybe<Array<CertificateCourseUpdateManyWithWhereWithoutCourseLevelInput>>;
  upsert?: Maybe<Array<CertificateCourseUpsertWithWhereUniqueWithoutCourseLevelInput>>;
};

export type CertificateCourseUpdateOneRequiredWithoutCertificateCurriculumNestedInput = {
  connect?: Maybe<CertificateCourseWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateCourseCreateOrConnectWithoutCertificateCurriculumInput>;
  create?: Maybe<CertificateCourseCreateWithoutCertificateCurriculumInput>;
  update?: Maybe<CertificateCourseUpdateToOneWithWhereWithoutCertificateCurriculumInput>;
  upsert?: Maybe<CertificateCourseUpsertWithoutCertificateCurriculumInput>;
};

export type CertificateCourseUpdateOneWithoutCertificateBaseNestedInput = {
  connect?: Maybe<CertificateCourseWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateCourseCreateOrConnectWithoutCertificateBaseInput>;
  create?: Maybe<CertificateCourseCreateWithoutCertificateBaseInput>;
  delete?: Maybe<CertificateCourseWhereInput>;
  disconnect?: Maybe<CertificateCourseWhereInput>;
  update?: Maybe<CertificateCourseUpdateToOneWithWhereWithoutCertificateBaseInput>;
  upsert?: Maybe<CertificateCourseUpsertWithoutCertificateBaseInput>;
};

export type CertificateCourseUpdateToOneWithWhereWithoutCertificateBaseInput = {
  data: CertificateCourseUpdateWithoutCertificateBaseInput;
  where?: Maybe<CertificateCourseWhereInput>;
};

export type CertificateCourseUpdateToOneWithWhereWithoutCertificateCurriculumInput = {
  data: CertificateCourseUpdateWithoutCertificateCurriculumInput;
  where?: Maybe<CertificateCourseWhereInput>;
};

export type CertificateCourseUpdateWithWhereUniqueWithoutCourseLevelInput = {
  data: CertificateCourseUpdateWithoutCourseLevelInput;
  where: CertificateCourseWhereUniqueInput;
};

export type CertificateCourseUpdateWithoutCertificateBaseInput = {
  CertificateCurriculum?: Maybe<CertificateCurriculumUpdateManyWithoutCertificateCourseNestedInput>;
  CourseLevel?: Maybe<CertificateCourseLevelUpdateOneWithoutCertificateCourseNestedInput>;
  areaKnowledge?: Maybe<StringFieldUpdateOperationsInput>;
  metaData?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
};

export type CertificateCourseUpdateWithoutCertificateCurriculumInput = {
  CertificateBase?: Maybe<CertificateBaseUpdateOneRequiredWithoutCertificateCourseNestedInput>;
  CourseLevel?: Maybe<CertificateCourseLevelUpdateOneWithoutCertificateCourseNestedInput>;
  areaKnowledge?: Maybe<StringFieldUpdateOperationsInput>;
  metaData?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
};

export type CertificateCourseUpdateWithoutCourseLevelInput = {
  CertificateBase?: Maybe<CertificateBaseUpdateOneRequiredWithoutCertificateCourseNestedInput>;
  CertificateCurriculum?: Maybe<CertificateCurriculumUpdateManyWithoutCertificateCourseNestedInput>;
  areaKnowledge?: Maybe<StringFieldUpdateOperationsInput>;
  metaData?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
};

export type CertificateCourseUpdatemetaDataInput = {
  push?: Maybe<Array<Scalars['String']>>;
  set?: Maybe<Array<Scalars['String']>>;
};

export type CertificateCourseUpsertWithWhereUniqueWithoutCourseLevelInput = {
  create: CertificateCourseCreateWithoutCourseLevelInput;
  update: CertificateCourseUpdateWithoutCourseLevelInput;
  where: CertificateCourseWhereUniqueInput;
};

export type CertificateCourseUpsertWithoutCertificateBaseInput = {
  create: CertificateCourseCreateWithoutCertificateBaseInput;
  update: CertificateCourseUpdateWithoutCertificateBaseInput;
  where?: Maybe<CertificateCourseWhereInput>;
};

export type CertificateCourseUpsertWithoutCertificateCurriculumInput = {
  create: CertificateCourseCreateWithoutCertificateCurriculumInput;
  update: CertificateCourseUpdateWithoutCertificateCurriculumInput;
  where?: Maybe<CertificateCourseWhereInput>;
};

export type CertificateCourseWhereInput = {
  AND?: Maybe<Array<CertificateCourseWhereInput>>;
  CertificateBase?: Maybe<CertificateBaseWhereInput>;
  CertificateCurriculum?: Maybe<CertificateCurriculumListRelationFilter>;
  CourseLevel?: Maybe<CertificateCourseLevelWhereInput>;
  NOT?: Maybe<Array<CertificateCourseWhereInput>>;
  OR?: Maybe<Array<CertificateCourseWhereInput>>;
  areaKnowledge?: Maybe<StringFilter>;
  certificateBaseId?: Maybe<StringFilter>;
  courseLevelCertificateBaseId?: Maybe<StringNullableFilter>;
  metaData?: Maybe<StringNullableListFilter>;
  name?: Maybe<StringFilter>;
};

export type CertificateCourseWhereUniqueInput = {
  AND?: Maybe<Array<CertificateCourseWhereInput>>;
  CertificateBase?: Maybe<CertificateBaseWhereInput>;
  CertificateCurriculum?: Maybe<CertificateCurriculumListRelationFilter>;
  CourseLevel?: Maybe<CertificateCourseLevelWhereInput>;
  NOT?: Maybe<Array<CertificateCourseWhereInput>>;
  OR?: Maybe<Array<CertificateCourseWhereInput>>;
  areaKnowledge?: Maybe<StringFilter>;
  certificateBaseId?: Maybe<Scalars['String']>;
  courseLevelCertificateBaseId?: Maybe<StringNullableFilter>;
  metaData?: Maybe<StringNullableListFilter>;
  name?: Maybe<StringFilter>;
};

export type CertificateCurriculum = {
  __typename?: 'CertificateCurriculum';
  CertificateBase: CertificateBase;
  CertificateCourse: CertificateCourse;
  CertificateCurriculumSelectedDisciplines: Array<CertificateCurriculumSelectedDiscipline>;
  DocumentCertificate: Array<DocumentCertificate>;
  amountOfHours?: Maybe<Scalars['Int']>;
  certificateBaseId: Scalars['String'];
  certificateCourseCertificateBaseId: Scalars['String'];
  name: Scalars['String'];
};


export type CertificateCurriculumCertificateCurriculumSelectedDisciplinesArgs = {
  cursor?: Maybe<CertificateCurriculumSelectedDisciplineWhereUniqueInput>;
  distinct?: Maybe<Array<CertificateCurriculumSelectedDisciplineScalarFieldEnum>>;
  orderBy?: Maybe<Array<CertificateCurriculumSelectedDisciplineOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CertificateCurriculumSelectedDisciplineWhereInput>;
};


export type CertificateCurriculumDocumentCertificateArgs = {
  cursor?: Maybe<DocumentCertificateWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentCertificateScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentCertificateOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentCertificateWhereInput>;
};

export type CertificateCurriculumAvgOrderByAggregateInput = {
  amountOfHours?: Maybe<SortOrder>;
};

export type CertificateCurriculumCountOrderByAggregateInput = {
  amountOfHours?: Maybe<SortOrder>;
  certificateBaseId?: Maybe<SortOrder>;
  certificateCourseCertificateBaseId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
};

export type CertificateCurriculumCreateInput = {
  CertificateBase: CertificateBaseCreateNestedOneWithoutCertificateCurriculumInput;
  CertificateCourse: CertificateCourseCreateNestedOneWithoutCertificateCurriculumInput;
  CertificateCurriculumSelectedDisciplines?: Maybe<CertificateCurriculumSelectedDisciplineCreateNestedManyWithoutCertificateCurriculumInput>;
  DocumentCertificate?: Maybe<DocumentCertificateCreateNestedManyWithoutCurriculumInput>;
  amountOfHours?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type CertificateCurriculumCreateManyCertificateCourseInput = {
  amountOfHours?: Maybe<Scalars['Int']>;
  certificateBaseId: Scalars['String'];
  name: Scalars['String'];
};

export type CertificateCurriculumCreateManyCertificateCourseInputEnvelope = {
  data: Array<CertificateCurriculumCreateManyCertificateCourseInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CertificateCurriculumCreateManyInput = {
  amountOfHours?: Maybe<Scalars['Int']>;
  certificateBaseId: Scalars['String'];
  certificateCourseCertificateBaseId: Scalars['String'];
  name: Scalars['String'];
};

export type CertificateCurriculumCreateNestedManyWithoutCertificateCourseInput = {
  connect?: Maybe<Array<CertificateCurriculumWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CertificateCurriculumCreateOrConnectWithoutCertificateCourseInput>>;
  create?: Maybe<Array<CertificateCurriculumCreateWithoutCertificateCourseInput>>;
  createMany?: Maybe<CertificateCurriculumCreateManyCertificateCourseInputEnvelope>;
};

export type CertificateCurriculumCreateNestedOneWithoutCertificateBaseInput = {
  connect?: Maybe<CertificateCurriculumWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateCurriculumCreateOrConnectWithoutCertificateBaseInput>;
  create?: Maybe<CertificateCurriculumCreateWithoutCertificateBaseInput>;
};

export type CertificateCurriculumCreateNestedOneWithoutCertificateCurriculumSelectedDisciplinesInput = {
  connect?: Maybe<CertificateCurriculumWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateCurriculumCreateOrConnectWithoutCertificateCurriculumSelectedDisciplinesInput>;
  create?: Maybe<CertificateCurriculumCreateWithoutCertificateCurriculumSelectedDisciplinesInput>;
};

export type CertificateCurriculumCreateNestedOneWithoutDocumentCertificateInput = {
  connect?: Maybe<CertificateCurriculumWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateCurriculumCreateOrConnectWithoutDocumentCertificateInput>;
  create?: Maybe<CertificateCurriculumCreateWithoutDocumentCertificateInput>;
};

export type CertificateCurriculumCreateOrConnectWithoutCertificateBaseInput = {
  create: CertificateCurriculumCreateWithoutCertificateBaseInput;
  where: CertificateCurriculumWhereUniqueInput;
};

export type CertificateCurriculumCreateOrConnectWithoutCertificateCourseInput = {
  create: CertificateCurriculumCreateWithoutCertificateCourseInput;
  where: CertificateCurriculumWhereUniqueInput;
};

export type CertificateCurriculumCreateOrConnectWithoutCertificateCurriculumSelectedDisciplinesInput = {
  create: CertificateCurriculumCreateWithoutCertificateCurriculumSelectedDisciplinesInput;
  where: CertificateCurriculumWhereUniqueInput;
};

export type CertificateCurriculumCreateOrConnectWithoutDocumentCertificateInput = {
  create: CertificateCurriculumCreateWithoutDocumentCertificateInput;
  where: CertificateCurriculumWhereUniqueInput;
};

export type CertificateCurriculumCreateWithoutCertificateBaseInput = {
  CertificateCourse: CertificateCourseCreateNestedOneWithoutCertificateCurriculumInput;
  CertificateCurriculumSelectedDisciplines?: Maybe<CertificateCurriculumSelectedDisciplineCreateNestedManyWithoutCertificateCurriculumInput>;
  DocumentCertificate?: Maybe<DocumentCertificateCreateNestedManyWithoutCurriculumInput>;
  amountOfHours?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type CertificateCurriculumCreateWithoutCertificateCourseInput = {
  CertificateBase: CertificateBaseCreateNestedOneWithoutCertificateCurriculumInput;
  CertificateCurriculumSelectedDisciplines?: Maybe<CertificateCurriculumSelectedDisciplineCreateNestedManyWithoutCertificateCurriculumInput>;
  DocumentCertificate?: Maybe<DocumentCertificateCreateNestedManyWithoutCurriculumInput>;
  amountOfHours?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type CertificateCurriculumCreateWithoutCertificateCurriculumSelectedDisciplinesInput = {
  CertificateBase: CertificateBaseCreateNestedOneWithoutCertificateCurriculumInput;
  CertificateCourse: CertificateCourseCreateNestedOneWithoutCertificateCurriculumInput;
  DocumentCertificate?: Maybe<DocumentCertificateCreateNestedManyWithoutCurriculumInput>;
  amountOfHours?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type CertificateCurriculumCreateWithoutDocumentCertificateInput = {
  CertificateBase: CertificateBaseCreateNestedOneWithoutCertificateCurriculumInput;
  CertificateCourse: CertificateCourseCreateNestedOneWithoutCertificateCurriculumInput;
  CertificateCurriculumSelectedDisciplines?: Maybe<CertificateCurriculumSelectedDisciplineCreateNestedManyWithoutCertificateCurriculumInput>;
  amountOfHours?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type CertificateCurriculumListRelationFilter = {
  every?: Maybe<CertificateCurriculumWhereInput>;
  none?: Maybe<CertificateCurriculumWhereInput>;
  some?: Maybe<CertificateCurriculumWhereInput>;
};

export type CertificateCurriculumMaxOrderByAggregateInput = {
  amountOfHours?: Maybe<SortOrder>;
  certificateBaseId?: Maybe<SortOrder>;
  certificateCourseCertificateBaseId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
};

export type CertificateCurriculumMinOrderByAggregateInput = {
  amountOfHours?: Maybe<SortOrder>;
  certificateBaseId?: Maybe<SortOrder>;
  certificateCourseCertificateBaseId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
};

export type CertificateCurriculumNullableRelationFilter = {
  is?: Maybe<CertificateCurriculumWhereInput>;
  isNot?: Maybe<CertificateCurriculumWhereInput>;
};

export type CertificateCurriculumOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CertificateCurriculumOrderByWithAggregationInput = {
  _avg?: Maybe<CertificateCurriculumAvgOrderByAggregateInput>;
  _count?: Maybe<CertificateCurriculumCountOrderByAggregateInput>;
  _max?: Maybe<CertificateCurriculumMaxOrderByAggregateInput>;
  _min?: Maybe<CertificateCurriculumMinOrderByAggregateInput>;
  _sum?: Maybe<CertificateCurriculumSumOrderByAggregateInput>;
  amountOfHours?: Maybe<SortOrder>;
  certificateBaseId?: Maybe<SortOrder>;
  certificateCourseCertificateBaseId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
};

export type CertificateCurriculumOrderByWithRelationInput = {
  CertificateBase?: Maybe<CertificateBaseOrderByWithRelationInput>;
  CertificateCourse?: Maybe<CertificateCourseOrderByWithRelationInput>;
  CertificateCurriculumSelectedDisciplines?: Maybe<CertificateCurriculumSelectedDisciplineOrderByRelationAggregateInput>;
  DocumentCertificate?: Maybe<DocumentCertificateOrderByRelationAggregateInput>;
  amountOfHours?: Maybe<SortOrder>;
  certificateBaseId?: Maybe<SortOrder>;
  certificateCourseCertificateBaseId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
};

export type CertificateCurriculumRelationFilter = {
  is?: Maybe<CertificateCurriculumWhereInput>;
  isNot?: Maybe<CertificateCurriculumWhereInput>;
};

export enum CertificateCurriculumScalarFieldEnum {
  AmountOfHours = 'amountOfHours',
  CertificateBaseId = 'certificateBaseId',
  CertificateCourseCertificateBaseId = 'certificateCourseCertificateBaseId',
  Name = 'name'
}

export type CertificateCurriculumScalarWhereInput = {
  AND?: Maybe<Array<CertificateCurriculumScalarWhereInput>>;
  NOT?: Maybe<Array<CertificateCurriculumScalarWhereInput>>;
  OR?: Maybe<Array<CertificateCurriculumScalarWhereInput>>;
  amountOfHours?: Maybe<IntNullableFilter>;
  certificateBaseId?: Maybe<StringFilter>;
  certificateCourseCertificateBaseId?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
};

export type CertificateCurriculumScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CertificateCurriculumScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CertificateCurriculumScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CertificateCurriculumScalarWhereWithAggregatesInput>>;
  amountOfHours?: Maybe<IntNullableWithAggregatesFilter>;
  certificateBaseId?: Maybe<StringWithAggregatesFilter>;
  certificateCourseCertificateBaseId?: Maybe<StringWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
};

export type CertificateCurriculumSelectedDiscipline = {
  __typename?: 'CertificateCurriculumSelectedDiscipline';
  CertificateCurriculum: CertificateCurriculum;
  SelectedDiscipline: CertificateDiscipline;
  SelectedTeacher?: Maybe<CertificateTeacher>;
  amountOfHours?: Maybe<Scalars['Int']>;
  certificateCurriculumId: Scalars['String'];
  certificateDisciplineCertificateBaseId: Scalars['String'];
  certificateTeacherCertificateBaseId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type CertificateCurriculumSelectedDisciplineAvgOrderByAggregateInput = {
  amountOfHours?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type CertificateCurriculumSelectedDisciplineCountOrderByAggregateInput = {
  amountOfHours?: Maybe<SortOrder>;
  certificateCurriculumId?: Maybe<SortOrder>;
  certificateDisciplineCertificateBaseId?: Maybe<SortOrder>;
  certificateTeacherCertificateBaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type CertificateCurriculumSelectedDisciplineCreateInput = {
  CertificateCurriculum: CertificateCurriculumCreateNestedOneWithoutCertificateCurriculumSelectedDisciplinesInput;
  SelectedDiscipline: CertificateDisciplineCreateNestedOneWithoutCertificateCurriculumSelectedDisciplinesInput;
  SelectedTeacher?: Maybe<CertificateTeacherCreateNestedOneWithoutCertificateCurriculumSelectedDisciplinesInput>;
  amountOfHours?: Maybe<Scalars['Int']>;
};

export type CertificateCurriculumSelectedDisciplineCreateManyCertificateCurriculumInput = {
  amountOfHours?: Maybe<Scalars['Int']>;
  certificateDisciplineCertificateBaseId: Scalars['String'];
  certificateTeacherCertificateBaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type CertificateCurriculumSelectedDisciplineCreateManyCertificateCurriculumInputEnvelope = {
  data: Array<CertificateCurriculumSelectedDisciplineCreateManyCertificateCurriculumInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CertificateCurriculumSelectedDisciplineCreateManyInput = {
  amountOfHours?: Maybe<Scalars['Int']>;
  certificateCurriculumId: Scalars['String'];
  certificateDisciplineCertificateBaseId: Scalars['String'];
  certificateTeacherCertificateBaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type CertificateCurriculumSelectedDisciplineCreateManySelectedDisciplineInput = {
  amountOfHours?: Maybe<Scalars['Int']>;
  certificateCurriculumId: Scalars['String'];
  certificateTeacherCertificateBaseId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type CertificateCurriculumSelectedDisciplineCreateManySelectedDisciplineInputEnvelope = {
  data: Array<CertificateCurriculumSelectedDisciplineCreateManySelectedDisciplineInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CertificateCurriculumSelectedDisciplineCreateManySelectedTeacherInput = {
  amountOfHours?: Maybe<Scalars['Int']>;
  certificateCurriculumId: Scalars['String'];
  certificateDisciplineCertificateBaseId: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
};

export type CertificateCurriculumSelectedDisciplineCreateManySelectedTeacherInputEnvelope = {
  data: Array<CertificateCurriculumSelectedDisciplineCreateManySelectedTeacherInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CertificateCurriculumSelectedDisciplineCreateNestedManyWithoutCertificateCurriculumInput = {
  connect?: Maybe<Array<CertificateCurriculumSelectedDisciplineWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CertificateCurriculumSelectedDisciplineCreateOrConnectWithoutCertificateCurriculumInput>>;
  create?: Maybe<Array<CertificateCurriculumSelectedDisciplineCreateWithoutCertificateCurriculumInput>>;
  createMany?: Maybe<CertificateCurriculumSelectedDisciplineCreateManyCertificateCurriculumInputEnvelope>;
};

export type CertificateCurriculumSelectedDisciplineCreateNestedManyWithoutSelectedDisciplineInput = {
  connect?: Maybe<Array<CertificateCurriculumSelectedDisciplineWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CertificateCurriculumSelectedDisciplineCreateOrConnectWithoutSelectedDisciplineInput>>;
  create?: Maybe<Array<CertificateCurriculumSelectedDisciplineCreateWithoutSelectedDisciplineInput>>;
  createMany?: Maybe<CertificateCurriculumSelectedDisciplineCreateManySelectedDisciplineInputEnvelope>;
};

export type CertificateCurriculumSelectedDisciplineCreateNestedManyWithoutSelectedTeacherInput = {
  connect?: Maybe<Array<CertificateCurriculumSelectedDisciplineWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CertificateCurriculumSelectedDisciplineCreateOrConnectWithoutSelectedTeacherInput>>;
  create?: Maybe<Array<CertificateCurriculumSelectedDisciplineCreateWithoutSelectedTeacherInput>>;
  createMany?: Maybe<CertificateCurriculumSelectedDisciplineCreateManySelectedTeacherInputEnvelope>;
};

export type CertificateCurriculumSelectedDisciplineCreateOrConnectWithoutCertificateCurriculumInput = {
  create: CertificateCurriculumSelectedDisciplineCreateWithoutCertificateCurriculumInput;
  where: CertificateCurriculumSelectedDisciplineWhereUniqueInput;
};

export type CertificateCurriculumSelectedDisciplineCreateOrConnectWithoutSelectedDisciplineInput = {
  create: CertificateCurriculumSelectedDisciplineCreateWithoutSelectedDisciplineInput;
  where: CertificateCurriculumSelectedDisciplineWhereUniqueInput;
};

export type CertificateCurriculumSelectedDisciplineCreateOrConnectWithoutSelectedTeacherInput = {
  create: CertificateCurriculumSelectedDisciplineCreateWithoutSelectedTeacherInput;
  where: CertificateCurriculumSelectedDisciplineWhereUniqueInput;
};

export type CertificateCurriculumSelectedDisciplineCreateWithoutCertificateCurriculumInput = {
  SelectedDiscipline: CertificateDisciplineCreateNestedOneWithoutCertificateCurriculumSelectedDisciplinesInput;
  SelectedTeacher?: Maybe<CertificateTeacherCreateNestedOneWithoutCertificateCurriculumSelectedDisciplinesInput>;
  amountOfHours?: Maybe<Scalars['Int']>;
};

export type CertificateCurriculumSelectedDisciplineCreateWithoutSelectedDisciplineInput = {
  CertificateCurriculum: CertificateCurriculumCreateNestedOneWithoutCertificateCurriculumSelectedDisciplinesInput;
  SelectedTeacher?: Maybe<CertificateTeacherCreateNestedOneWithoutCertificateCurriculumSelectedDisciplinesInput>;
  amountOfHours?: Maybe<Scalars['Int']>;
};

export type CertificateCurriculumSelectedDisciplineCreateWithoutSelectedTeacherInput = {
  CertificateCurriculum: CertificateCurriculumCreateNestedOneWithoutCertificateCurriculumSelectedDisciplinesInput;
  SelectedDiscipline: CertificateDisciplineCreateNestedOneWithoutCertificateCurriculumSelectedDisciplinesInput;
  amountOfHours?: Maybe<Scalars['Int']>;
};

export type CertificateCurriculumSelectedDisciplineListRelationFilter = {
  every?: Maybe<CertificateCurriculumSelectedDisciplineWhereInput>;
  none?: Maybe<CertificateCurriculumSelectedDisciplineWhereInput>;
  some?: Maybe<CertificateCurriculumSelectedDisciplineWhereInput>;
};

export type CertificateCurriculumSelectedDisciplineMaxOrderByAggregateInput = {
  amountOfHours?: Maybe<SortOrder>;
  certificateCurriculumId?: Maybe<SortOrder>;
  certificateDisciplineCertificateBaseId?: Maybe<SortOrder>;
  certificateTeacherCertificateBaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type CertificateCurriculumSelectedDisciplineMinOrderByAggregateInput = {
  amountOfHours?: Maybe<SortOrder>;
  certificateCurriculumId?: Maybe<SortOrder>;
  certificateDisciplineCertificateBaseId?: Maybe<SortOrder>;
  certificateTeacherCertificateBaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type CertificateCurriculumSelectedDisciplineOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CertificateCurriculumSelectedDisciplineOrderByWithAggregationInput = {
  _avg?: Maybe<CertificateCurriculumSelectedDisciplineAvgOrderByAggregateInput>;
  _count?: Maybe<CertificateCurriculumSelectedDisciplineCountOrderByAggregateInput>;
  _max?: Maybe<CertificateCurriculumSelectedDisciplineMaxOrderByAggregateInput>;
  _min?: Maybe<CertificateCurriculumSelectedDisciplineMinOrderByAggregateInput>;
  _sum?: Maybe<CertificateCurriculumSelectedDisciplineSumOrderByAggregateInput>;
  amountOfHours?: Maybe<SortOrder>;
  certificateCurriculumId?: Maybe<SortOrder>;
  certificateDisciplineCertificateBaseId?: Maybe<SortOrder>;
  certificateTeacherCertificateBaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type CertificateCurriculumSelectedDisciplineOrderByWithRelationInput = {
  CertificateCurriculum?: Maybe<CertificateCurriculumOrderByWithRelationInput>;
  SelectedDiscipline?: Maybe<CertificateDisciplineOrderByWithRelationInput>;
  SelectedTeacher?: Maybe<CertificateTeacherOrderByWithRelationInput>;
  amountOfHours?: Maybe<SortOrder>;
  certificateCurriculumId?: Maybe<SortOrder>;
  certificateDisciplineCertificateBaseId?: Maybe<SortOrder>;
  certificateTeacherCertificateBaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export enum CertificateCurriculumSelectedDisciplineScalarFieldEnum {
  AmountOfHours = 'amountOfHours',
  CertificateCurriculumId = 'certificateCurriculumId',
  CertificateDisciplineCertificateBaseId = 'certificateDisciplineCertificateBaseId',
  CertificateTeacherCertificateBaseId = 'certificateTeacherCertificateBaseId',
  Id = 'id'
}

export type CertificateCurriculumSelectedDisciplineScalarWhereInput = {
  AND?: Maybe<Array<CertificateCurriculumSelectedDisciplineScalarWhereInput>>;
  NOT?: Maybe<Array<CertificateCurriculumSelectedDisciplineScalarWhereInput>>;
  OR?: Maybe<Array<CertificateCurriculumSelectedDisciplineScalarWhereInput>>;
  amountOfHours?: Maybe<IntNullableFilter>;
  certificateCurriculumId?: Maybe<StringFilter>;
  certificateDisciplineCertificateBaseId?: Maybe<StringFilter>;
  certificateTeacherCertificateBaseId?: Maybe<StringNullableFilter>;
  id?: Maybe<IntFilter>;
};

export type CertificateCurriculumSelectedDisciplineScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CertificateCurriculumSelectedDisciplineScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CertificateCurriculumSelectedDisciplineScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CertificateCurriculumSelectedDisciplineScalarWhereWithAggregatesInput>>;
  amountOfHours?: Maybe<IntNullableWithAggregatesFilter>;
  certificateCurriculumId?: Maybe<StringWithAggregatesFilter>;
  certificateDisciplineCertificateBaseId?: Maybe<StringWithAggregatesFilter>;
  certificateTeacherCertificateBaseId?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
};

export type CertificateCurriculumSelectedDisciplineSumOrderByAggregateInput = {
  amountOfHours?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type CertificateCurriculumSelectedDisciplineUpdateInput = {
  CertificateCurriculum?: Maybe<CertificateCurriculumUpdateOneRequiredWithoutCertificateCurriculumSelectedDisciplinesNestedInput>;
  SelectedDiscipline?: Maybe<CertificateDisciplineUpdateOneRequiredWithoutCertificateCurriculumSelectedDisciplinesNestedInput>;
  SelectedTeacher?: Maybe<CertificateTeacherUpdateOneWithoutCertificateCurriculumSelectedDisciplinesNestedInput>;
  amountOfHours?: Maybe<NullableIntFieldUpdateOperationsInput>;
};

export type CertificateCurriculumSelectedDisciplineUpdateManyMutationInput = {
  amountOfHours?: Maybe<NullableIntFieldUpdateOperationsInput>;
};

export type CertificateCurriculumSelectedDisciplineUpdateManyWithWhereWithoutCertificateCurriculumInput = {
  data: CertificateCurriculumSelectedDisciplineUpdateManyMutationInput;
  where: CertificateCurriculumSelectedDisciplineScalarWhereInput;
};

export type CertificateCurriculumSelectedDisciplineUpdateManyWithWhereWithoutSelectedDisciplineInput = {
  data: CertificateCurriculumSelectedDisciplineUpdateManyMutationInput;
  where: CertificateCurriculumSelectedDisciplineScalarWhereInput;
};

export type CertificateCurriculumSelectedDisciplineUpdateManyWithWhereWithoutSelectedTeacherInput = {
  data: CertificateCurriculumSelectedDisciplineUpdateManyMutationInput;
  where: CertificateCurriculumSelectedDisciplineScalarWhereInput;
};

export type CertificateCurriculumSelectedDisciplineUpdateManyWithoutCertificateCurriculumNestedInput = {
  connect?: Maybe<Array<CertificateCurriculumSelectedDisciplineWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CertificateCurriculumSelectedDisciplineCreateOrConnectWithoutCertificateCurriculumInput>>;
  create?: Maybe<Array<CertificateCurriculumSelectedDisciplineCreateWithoutCertificateCurriculumInput>>;
  createMany?: Maybe<CertificateCurriculumSelectedDisciplineCreateManyCertificateCurriculumInputEnvelope>;
  delete?: Maybe<Array<CertificateCurriculumSelectedDisciplineWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CertificateCurriculumSelectedDisciplineScalarWhereInput>>;
  disconnect?: Maybe<Array<CertificateCurriculumSelectedDisciplineWhereUniqueInput>>;
  set?: Maybe<Array<CertificateCurriculumSelectedDisciplineWhereUniqueInput>>;
  update?: Maybe<Array<CertificateCurriculumSelectedDisciplineUpdateWithWhereUniqueWithoutCertificateCurriculumInput>>;
  updateMany?: Maybe<Array<CertificateCurriculumSelectedDisciplineUpdateManyWithWhereWithoutCertificateCurriculumInput>>;
  upsert?: Maybe<Array<CertificateCurriculumSelectedDisciplineUpsertWithWhereUniqueWithoutCertificateCurriculumInput>>;
};

export type CertificateCurriculumSelectedDisciplineUpdateManyWithoutSelectedDisciplineNestedInput = {
  connect?: Maybe<Array<CertificateCurriculumSelectedDisciplineWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CertificateCurriculumSelectedDisciplineCreateOrConnectWithoutSelectedDisciplineInput>>;
  create?: Maybe<Array<CertificateCurriculumSelectedDisciplineCreateWithoutSelectedDisciplineInput>>;
  createMany?: Maybe<CertificateCurriculumSelectedDisciplineCreateManySelectedDisciplineInputEnvelope>;
  delete?: Maybe<Array<CertificateCurriculumSelectedDisciplineWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CertificateCurriculumSelectedDisciplineScalarWhereInput>>;
  disconnect?: Maybe<Array<CertificateCurriculumSelectedDisciplineWhereUniqueInput>>;
  set?: Maybe<Array<CertificateCurriculumSelectedDisciplineWhereUniqueInput>>;
  update?: Maybe<Array<CertificateCurriculumSelectedDisciplineUpdateWithWhereUniqueWithoutSelectedDisciplineInput>>;
  updateMany?: Maybe<Array<CertificateCurriculumSelectedDisciplineUpdateManyWithWhereWithoutSelectedDisciplineInput>>;
  upsert?: Maybe<Array<CertificateCurriculumSelectedDisciplineUpsertWithWhereUniqueWithoutSelectedDisciplineInput>>;
};

export type CertificateCurriculumSelectedDisciplineUpdateManyWithoutSelectedTeacherNestedInput = {
  connect?: Maybe<Array<CertificateCurriculumSelectedDisciplineWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CertificateCurriculumSelectedDisciplineCreateOrConnectWithoutSelectedTeacherInput>>;
  create?: Maybe<Array<CertificateCurriculumSelectedDisciplineCreateWithoutSelectedTeacherInput>>;
  createMany?: Maybe<CertificateCurriculumSelectedDisciplineCreateManySelectedTeacherInputEnvelope>;
  delete?: Maybe<Array<CertificateCurriculumSelectedDisciplineWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CertificateCurriculumSelectedDisciplineScalarWhereInput>>;
  disconnect?: Maybe<Array<CertificateCurriculumSelectedDisciplineWhereUniqueInput>>;
  set?: Maybe<Array<CertificateCurriculumSelectedDisciplineWhereUniqueInput>>;
  update?: Maybe<Array<CertificateCurriculumSelectedDisciplineUpdateWithWhereUniqueWithoutSelectedTeacherInput>>;
  updateMany?: Maybe<Array<CertificateCurriculumSelectedDisciplineUpdateManyWithWhereWithoutSelectedTeacherInput>>;
  upsert?: Maybe<Array<CertificateCurriculumSelectedDisciplineUpsertWithWhereUniqueWithoutSelectedTeacherInput>>;
};

export type CertificateCurriculumSelectedDisciplineUpdateWithWhereUniqueWithoutCertificateCurriculumInput = {
  data: CertificateCurriculumSelectedDisciplineUpdateWithoutCertificateCurriculumInput;
  where: CertificateCurriculumSelectedDisciplineWhereUniqueInput;
};

export type CertificateCurriculumSelectedDisciplineUpdateWithWhereUniqueWithoutSelectedDisciplineInput = {
  data: CertificateCurriculumSelectedDisciplineUpdateWithoutSelectedDisciplineInput;
  where: CertificateCurriculumSelectedDisciplineWhereUniqueInput;
};

export type CertificateCurriculumSelectedDisciplineUpdateWithWhereUniqueWithoutSelectedTeacherInput = {
  data: CertificateCurriculumSelectedDisciplineUpdateWithoutSelectedTeacherInput;
  where: CertificateCurriculumSelectedDisciplineWhereUniqueInput;
};

export type CertificateCurriculumSelectedDisciplineUpdateWithoutCertificateCurriculumInput = {
  SelectedDiscipline?: Maybe<CertificateDisciplineUpdateOneRequiredWithoutCertificateCurriculumSelectedDisciplinesNestedInput>;
  SelectedTeacher?: Maybe<CertificateTeacherUpdateOneWithoutCertificateCurriculumSelectedDisciplinesNestedInput>;
  amountOfHours?: Maybe<NullableIntFieldUpdateOperationsInput>;
};

export type CertificateCurriculumSelectedDisciplineUpdateWithoutSelectedDisciplineInput = {
  CertificateCurriculum?: Maybe<CertificateCurriculumUpdateOneRequiredWithoutCertificateCurriculumSelectedDisciplinesNestedInput>;
  SelectedTeacher?: Maybe<CertificateTeacherUpdateOneWithoutCertificateCurriculumSelectedDisciplinesNestedInput>;
  amountOfHours?: Maybe<NullableIntFieldUpdateOperationsInput>;
};

export type CertificateCurriculumSelectedDisciplineUpdateWithoutSelectedTeacherInput = {
  CertificateCurriculum?: Maybe<CertificateCurriculumUpdateOneRequiredWithoutCertificateCurriculumSelectedDisciplinesNestedInput>;
  SelectedDiscipline?: Maybe<CertificateDisciplineUpdateOneRequiredWithoutCertificateCurriculumSelectedDisciplinesNestedInput>;
  amountOfHours?: Maybe<NullableIntFieldUpdateOperationsInput>;
};

export type CertificateCurriculumSelectedDisciplineUpsertWithWhereUniqueWithoutCertificateCurriculumInput = {
  create: CertificateCurriculumSelectedDisciplineCreateWithoutCertificateCurriculumInput;
  update: CertificateCurriculumSelectedDisciplineUpdateWithoutCertificateCurriculumInput;
  where: CertificateCurriculumSelectedDisciplineWhereUniqueInput;
};

export type CertificateCurriculumSelectedDisciplineUpsertWithWhereUniqueWithoutSelectedDisciplineInput = {
  create: CertificateCurriculumSelectedDisciplineCreateWithoutSelectedDisciplineInput;
  update: CertificateCurriculumSelectedDisciplineUpdateWithoutSelectedDisciplineInput;
  where: CertificateCurriculumSelectedDisciplineWhereUniqueInput;
};

export type CertificateCurriculumSelectedDisciplineUpsertWithWhereUniqueWithoutSelectedTeacherInput = {
  create: CertificateCurriculumSelectedDisciplineCreateWithoutSelectedTeacherInput;
  update: CertificateCurriculumSelectedDisciplineUpdateWithoutSelectedTeacherInput;
  where: CertificateCurriculumSelectedDisciplineWhereUniqueInput;
};

export type CertificateCurriculumSelectedDisciplineWhereInput = {
  AND?: Maybe<Array<CertificateCurriculumSelectedDisciplineWhereInput>>;
  CertificateCurriculum?: Maybe<CertificateCurriculumWhereInput>;
  NOT?: Maybe<Array<CertificateCurriculumSelectedDisciplineWhereInput>>;
  OR?: Maybe<Array<CertificateCurriculumSelectedDisciplineWhereInput>>;
  SelectedDiscipline?: Maybe<CertificateDisciplineWhereInput>;
  SelectedTeacher?: Maybe<CertificateTeacherWhereInput>;
  amountOfHours?: Maybe<IntNullableFilter>;
  certificateCurriculumId?: Maybe<StringFilter>;
  certificateDisciplineCertificateBaseId?: Maybe<StringFilter>;
  certificateTeacherCertificateBaseId?: Maybe<StringNullableFilter>;
  id?: Maybe<IntFilter>;
};

export type CertificateCurriculumSelectedDisciplineWhereUniqueInput = {
  AND?: Maybe<Array<CertificateCurriculumSelectedDisciplineWhereInput>>;
  CertificateCurriculum?: Maybe<CertificateCurriculumWhereInput>;
  NOT?: Maybe<Array<CertificateCurriculumSelectedDisciplineWhereInput>>;
  OR?: Maybe<Array<CertificateCurriculumSelectedDisciplineWhereInput>>;
  SelectedDiscipline?: Maybe<CertificateDisciplineWhereInput>;
  SelectedTeacher?: Maybe<CertificateTeacherWhereInput>;
  amountOfHours?: Maybe<IntNullableFilter>;
  certificateCurriculumId?: Maybe<StringFilter>;
  certificateDisciplineCertificateBaseId?: Maybe<StringFilter>;
  certificateTeacherCertificateBaseId?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['Int']>;
};

export type CertificateCurriculumSumOrderByAggregateInput = {
  amountOfHours?: Maybe<SortOrder>;
};

export type CertificateCurriculumUpdateInput = {
  CertificateBase?: Maybe<CertificateBaseUpdateOneRequiredWithoutCertificateCurriculumNestedInput>;
  CertificateCourse?: Maybe<CertificateCourseUpdateOneRequiredWithoutCertificateCurriculumNestedInput>;
  CertificateCurriculumSelectedDisciplines?: Maybe<CertificateCurriculumSelectedDisciplineUpdateManyWithoutCertificateCurriculumNestedInput>;
  DocumentCertificate?: Maybe<DocumentCertificateUpdateManyWithoutCurriculumNestedInput>;
  amountOfHours?: Maybe<NullableIntFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
};

export type CertificateCurriculumUpdateManyMutationInput = {
  amountOfHours?: Maybe<NullableIntFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
};

export type CertificateCurriculumUpdateManyWithWhereWithoutCertificateCourseInput = {
  data: CertificateCurriculumUpdateManyMutationInput;
  where: CertificateCurriculumScalarWhereInput;
};

export type CertificateCurriculumUpdateManyWithoutCertificateCourseNestedInput = {
  connect?: Maybe<Array<CertificateCurriculumWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CertificateCurriculumCreateOrConnectWithoutCertificateCourseInput>>;
  create?: Maybe<Array<CertificateCurriculumCreateWithoutCertificateCourseInput>>;
  createMany?: Maybe<CertificateCurriculumCreateManyCertificateCourseInputEnvelope>;
  delete?: Maybe<Array<CertificateCurriculumWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CertificateCurriculumScalarWhereInput>>;
  disconnect?: Maybe<Array<CertificateCurriculumWhereUniqueInput>>;
  set?: Maybe<Array<CertificateCurriculumWhereUniqueInput>>;
  update?: Maybe<Array<CertificateCurriculumUpdateWithWhereUniqueWithoutCertificateCourseInput>>;
  updateMany?: Maybe<Array<CertificateCurriculumUpdateManyWithWhereWithoutCertificateCourseInput>>;
  upsert?: Maybe<Array<CertificateCurriculumUpsertWithWhereUniqueWithoutCertificateCourseInput>>;
};

export type CertificateCurriculumUpdateOneRequiredWithoutCertificateCurriculumSelectedDisciplinesNestedInput = {
  connect?: Maybe<CertificateCurriculumWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateCurriculumCreateOrConnectWithoutCertificateCurriculumSelectedDisciplinesInput>;
  create?: Maybe<CertificateCurriculumCreateWithoutCertificateCurriculumSelectedDisciplinesInput>;
  update?: Maybe<CertificateCurriculumUpdateToOneWithWhereWithoutCertificateCurriculumSelectedDisciplinesInput>;
  upsert?: Maybe<CertificateCurriculumUpsertWithoutCertificateCurriculumSelectedDisciplinesInput>;
};

export type CertificateCurriculumUpdateOneWithoutCertificateBaseNestedInput = {
  connect?: Maybe<CertificateCurriculumWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateCurriculumCreateOrConnectWithoutCertificateBaseInput>;
  create?: Maybe<CertificateCurriculumCreateWithoutCertificateBaseInput>;
  delete?: Maybe<CertificateCurriculumWhereInput>;
  disconnect?: Maybe<CertificateCurriculumWhereInput>;
  update?: Maybe<CertificateCurriculumUpdateToOneWithWhereWithoutCertificateBaseInput>;
  upsert?: Maybe<CertificateCurriculumUpsertWithoutCertificateBaseInput>;
};

export type CertificateCurriculumUpdateOneWithoutDocumentCertificateNestedInput = {
  connect?: Maybe<CertificateCurriculumWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateCurriculumCreateOrConnectWithoutDocumentCertificateInput>;
  create?: Maybe<CertificateCurriculumCreateWithoutDocumentCertificateInput>;
  delete?: Maybe<CertificateCurriculumWhereInput>;
  disconnect?: Maybe<CertificateCurriculumWhereInput>;
  update?: Maybe<CertificateCurriculumUpdateToOneWithWhereWithoutDocumentCertificateInput>;
  upsert?: Maybe<CertificateCurriculumUpsertWithoutDocumentCertificateInput>;
};

export type CertificateCurriculumUpdateToOneWithWhereWithoutCertificateBaseInput = {
  data: CertificateCurriculumUpdateWithoutCertificateBaseInput;
  where?: Maybe<CertificateCurriculumWhereInput>;
};

export type CertificateCurriculumUpdateToOneWithWhereWithoutCertificateCurriculumSelectedDisciplinesInput = {
  data: CertificateCurriculumUpdateWithoutCertificateCurriculumSelectedDisciplinesInput;
  where?: Maybe<CertificateCurriculumWhereInput>;
};

export type CertificateCurriculumUpdateToOneWithWhereWithoutDocumentCertificateInput = {
  data: CertificateCurriculumUpdateWithoutDocumentCertificateInput;
  where?: Maybe<CertificateCurriculumWhereInput>;
};

export type CertificateCurriculumUpdateWithWhereUniqueWithoutCertificateCourseInput = {
  data: CertificateCurriculumUpdateWithoutCertificateCourseInput;
  where: CertificateCurriculumWhereUniqueInput;
};

export type CertificateCurriculumUpdateWithoutCertificateBaseInput = {
  CertificateCourse?: Maybe<CertificateCourseUpdateOneRequiredWithoutCertificateCurriculumNestedInput>;
  CertificateCurriculumSelectedDisciplines?: Maybe<CertificateCurriculumSelectedDisciplineUpdateManyWithoutCertificateCurriculumNestedInput>;
  DocumentCertificate?: Maybe<DocumentCertificateUpdateManyWithoutCurriculumNestedInput>;
  amountOfHours?: Maybe<NullableIntFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
};

export type CertificateCurriculumUpdateWithoutCertificateCourseInput = {
  CertificateBase?: Maybe<CertificateBaseUpdateOneRequiredWithoutCertificateCurriculumNestedInput>;
  CertificateCurriculumSelectedDisciplines?: Maybe<CertificateCurriculumSelectedDisciplineUpdateManyWithoutCertificateCurriculumNestedInput>;
  DocumentCertificate?: Maybe<DocumentCertificateUpdateManyWithoutCurriculumNestedInput>;
  amountOfHours?: Maybe<NullableIntFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
};

export type CertificateCurriculumUpdateWithoutCertificateCurriculumSelectedDisciplinesInput = {
  CertificateBase?: Maybe<CertificateBaseUpdateOneRequiredWithoutCertificateCurriculumNestedInput>;
  CertificateCourse?: Maybe<CertificateCourseUpdateOneRequiredWithoutCertificateCurriculumNestedInput>;
  DocumentCertificate?: Maybe<DocumentCertificateUpdateManyWithoutCurriculumNestedInput>;
  amountOfHours?: Maybe<NullableIntFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
};

export type CertificateCurriculumUpdateWithoutDocumentCertificateInput = {
  CertificateBase?: Maybe<CertificateBaseUpdateOneRequiredWithoutCertificateCurriculumNestedInput>;
  CertificateCourse?: Maybe<CertificateCourseUpdateOneRequiredWithoutCertificateCurriculumNestedInput>;
  CertificateCurriculumSelectedDisciplines?: Maybe<CertificateCurriculumSelectedDisciplineUpdateManyWithoutCertificateCurriculumNestedInput>;
  amountOfHours?: Maybe<NullableIntFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
};

export type CertificateCurriculumUpsertWithWhereUniqueWithoutCertificateCourseInput = {
  create: CertificateCurriculumCreateWithoutCertificateCourseInput;
  update: CertificateCurriculumUpdateWithoutCertificateCourseInput;
  where: CertificateCurriculumWhereUniqueInput;
};

export type CertificateCurriculumUpsertWithoutCertificateBaseInput = {
  create: CertificateCurriculumCreateWithoutCertificateBaseInput;
  update: CertificateCurriculumUpdateWithoutCertificateBaseInput;
  where?: Maybe<CertificateCurriculumWhereInput>;
};

export type CertificateCurriculumUpsertWithoutCertificateCurriculumSelectedDisciplinesInput = {
  create: CertificateCurriculumCreateWithoutCertificateCurriculumSelectedDisciplinesInput;
  update: CertificateCurriculumUpdateWithoutCertificateCurriculumSelectedDisciplinesInput;
  where?: Maybe<CertificateCurriculumWhereInput>;
};

export type CertificateCurriculumUpsertWithoutDocumentCertificateInput = {
  create: CertificateCurriculumCreateWithoutDocumentCertificateInput;
  update: CertificateCurriculumUpdateWithoutDocumentCertificateInput;
  where?: Maybe<CertificateCurriculumWhereInput>;
};

export type CertificateCurriculumWhereInput = {
  AND?: Maybe<Array<CertificateCurriculumWhereInput>>;
  CertificateBase?: Maybe<CertificateBaseWhereInput>;
  CertificateCourse?: Maybe<CertificateCourseWhereInput>;
  CertificateCurriculumSelectedDisciplines?: Maybe<CertificateCurriculumSelectedDisciplineListRelationFilter>;
  DocumentCertificate?: Maybe<DocumentCertificateListRelationFilter>;
  NOT?: Maybe<Array<CertificateCurriculumWhereInput>>;
  OR?: Maybe<Array<CertificateCurriculumWhereInput>>;
  amountOfHours?: Maybe<IntNullableFilter>;
  certificateBaseId?: Maybe<StringFilter>;
  certificateCourseCertificateBaseId?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
};

export type CertificateCurriculumWhereUniqueInput = {
  AND?: Maybe<Array<CertificateCurriculumWhereInput>>;
  CertificateBase?: Maybe<CertificateBaseWhereInput>;
  CertificateCourse?: Maybe<CertificateCourseWhereInput>;
  CertificateCurriculumSelectedDisciplines?: Maybe<CertificateCurriculumSelectedDisciplineListRelationFilter>;
  DocumentCertificate?: Maybe<DocumentCertificateListRelationFilter>;
  NOT?: Maybe<Array<CertificateCurriculumWhereInput>>;
  OR?: Maybe<Array<CertificateCurriculumWhereInput>>;
  amountOfHours?: Maybe<IntNullableFilter>;
  certificateBaseId?: Maybe<Scalars['String']>;
  certificateCourseCertificateBaseId?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
};

export type CertificateDiscipline = {
  __typename?: 'CertificateDiscipline';
  CertificateBase: CertificateBase;
  CertificateCurriculumSelectedDisciplines: Array<CertificateCurriculumSelectedDiscipline>;
  certificateBaseId: Scalars['String'];
  name: Scalars['String'];
  viewOnDegree: Scalars['Boolean'];
};


export type CertificateDisciplineCertificateCurriculumSelectedDisciplinesArgs = {
  cursor?: Maybe<CertificateCurriculumSelectedDisciplineWhereUniqueInput>;
  distinct?: Maybe<Array<CertificateCurriculumSelectedDisciplineScalarFieldEnum>>;
  orderBy?: Maybe<Array<CertificateCurriculumSelectedDisciplineOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CertificateCurriculumSelectedDisciplineWhereInput>;
};

export type CertificateDisciplineCountOrderByAggregateInput = {
  certificateBaseId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  viewOnDegree?: Maybe<SortOrder>;
};

export type CertificateDisciplineCreateInput = {
  CertificateBase: CertificateBaseCreateNestedOneWithoutCertificateDisciplineInput;
  CertificateCurriculumSelectedDisciplines?: Maybe<CertificateCurriculumSelectedDisciplineCreateNestedManyWithoutSelectedDisciplineInput>;
  name: Scalars['String'];
  viewOnDegree: Scalars['Boolean'];
};

export type CertificateDisciplineCreateManyInput = {
  certificateBaseId: Scalars['String'];
  name: Scalars['String'];
  viewOnDegree: Scalars['Boolean'];
};

export type CertificateDisciplineCreateNestedOneWithoutCertificateBaseInput = {
  connect?: Maybe<CertificateDisciplineWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateDisciplineCreateOrConnectWithoutCertificateBaseInput>;
  create?: Maybe<CertificateDisciplineCreateWithoutCertificateBaseInput>;
};

export type CertificateDisciplineCreateNestedOneWithoutCertificateCurriculumSelectedDisciplinesInput = {
  connect?: Maybe<CertificateDisciplineWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateDisciplineCreateOrConnectWithoutCertificateCurriculumSelectedDisciplinesInput>;
  create?: Maybe<CertificateDisciplineCreateWithoutCertificateCurriculumSelectedDisciplinesInput>;
};

export type CertificateDisciplineCreateOrConnectWithoutCertificateBaseInput = {
  create: CertificateDisciplineCreateWithoutCertificateBaseInput;
  where: CertificateDisciplineWhereUniqueInput;
};

export type CertificateDisciplineCreateOrConnectWithoutCertificateCurriculumSelectedDisciplinesInput = {
  create: CertificateDisciplineCreateWithoutCertificateCurriculumSelectedDisciplinesInput;
  where: CertificateDisciplineWhereUniqueInput;
};

export type CertificateDisciplineCreateWithoutCertificateBaseInput = {
  CertificateCurriculumSelectedDisciplines?: Maybe<CertificateCurriculumSelectedDisciplineCreateNestedManyWithoutSelectedDisciplineInput>;
  name: Scalars['String'];
  viewOnDegree: Scalars['Boolean'];
};

export type CertificateDisciplineCreateWithoutCertificateCurriculumSelectedDisciplinesInput = {
  CertificateBase: CertificateBaseCreateNestedOneWithoutCertificateDisciplineInput;
  name: Scalars['String'];
  viewOnDegree: Scalars['Boolean'];
};

export type CertificateDisciplineMaxOrderByAggregateInput = {
  certificateBaseId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  viewOnDegree?: Maybe<SortOrder>;
};

export type CertificateDisciplineMinOrderByAggregateInput = {
  certificateBaseId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  viewOnDegree?: Maybe<SortOrder>;
};

export type CertificateDisciplineNullableRelationFilter = {
  is?: Maybe<CertificateDisciplineWhereInput>;
  isNot?: Maybe<CertificateDisciplineWhereInput>;
};

export type CertificateDisciplineOrderByWithAggregationInput = {
  _count?: Maybe<CertificateDisciplineCountOrderByAggregateInput>;
  _max?: Maybe<CertificateDisciplineMaxOrderByAggregateInput>;
  _min?: Maybe<CertificateDisciplineMinOrderByAggregateInput>;
  certificateBaseId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  viewOnDegree?: Maybe<SortOrder>;
};

export type CertificateDisciplineOrderByWithRelationInput = {
  CertificateBase?: Maybe<CertificateBaseOrderByWithRelationInput>;
  CertificateCurriculumSelectedDisciplines?: Maybe<CertificateCurriculumSelectedDisciplineOrderByRelationAggregateInput>;
  certificateBaseId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  viewOnDegree?: Maybe<SortOrder>;
};

export type CertificateDisciplineRelationFilter = {
  is?: Maybe<CertificateDisciplineWhereInput>;
  isNot?: Maybe<CertificateDisciplineWhereInput>;
};

export enum CertificateDisciplineScalarFieldEnum {
  CertificateBaseId = 'certificateBaseId',
  Name = 'name',
  ViewOnDegree = 'viewOnDegree'
}

export type CertificateDisciplineScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CertificateDisciplineScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CertificateDisciplineScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CertificateDisciplineScalarWhereWithAggregatesInput>>;
  certificateBaseId?: Maybe<StringWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  viewOnDegree?: Maybe<BoolWithAggregatesFilter>;
};

export type CertificateDisciplineUpdateInput = {
  CertificateBase?: Maybe<CertificateBaseUpdateOneRequiredWithoutCertificateDisciplineNestedInput>;
  CertificateCurriculumSelectedDisciplines?: Maybe<CertificateCurriculumSelectedDisciplineUpdateManyWithoutSelectedDisciplineNestedInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
  viewOnDegree?: Maybe<BoolFieldUpdateOperationsInput>;
};

export type CertificateDisciplineUpdateManyMutationInput = {
  name?: Maybe<StringFieldUpdateOperationsInput>;
  viewOnDegree?: Maybe<BoolFieldUpdateOperationsInput>;
};

export type CertificateDisciplineUpdateOneRequiredWithoutCertificateCurriculumSelectedDisciplinesNestedInput = {
  connect?: Maybe<CertificateDisciplineWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateDisciplineCreateOrConnectWithoutCertificateCurriculumSelectedDisciplinesInput>;
  create?: Maybe<CertificateDisciplineCreateWithoutCertificateCurriculumSelectedDisciplinesInput>;
  update?: Maybe<CertificateDisciplineUpdateToOneWithWhereWithoutCertificateCurriculumSelectedDisciplinesInput>;
  upsert?: Maybe<CertificateDisciplineUpsertWithoutCertificateCurriculumSelectedDisciplinesInput>;
};

export type CertificateDisciplineUpdateOneWithoutCertificateBaseNestedInput = {
  connect?: Maybe<CertificateDisciplineWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateDisciplineCreateOrConnectWithoutCertificateBaseInput>;
  create?: Maybe<CertificateDisciplineCreateWithoutCertificateBaseInput>;
  delete?: Maybe<CertificateDisciplineWhereInput>;
  disconnect?: Maybe<CertificateDisciplineWhereInput>;
  update?: Maybe<CertificateDisciplineUpdateToOneWithWhereWithoutCertificateBaseInput>;
  upsert?: Maybe<CertificateDisciplineUpsertWithoutCertificateBaseInput>;
};

export type CertificateDisciplineUpdateToOneWithWhereWithoutCertificateBaseInput = {
  data: CertificateDisciplineUpdateWithoutCertificateBaseInput;
  where?: Maybe<CertificateDisciplineWhereInput>;
};

export type CertificateDisciplineUpdateToOneWithWhereWithoutCertificateCurriculumSelectedDisciplinesInput = {
  data: CertificateDisciplineUpdateWithoutCertificateCurriculumSelectedDisciplinesInput;
  where?: Maybe<CertificateDisciplineWhereInput>;
};

export type CertificateDisciplineUpdateWithoutCertificateBaseInput = {
  CertificateCurriculumSelectedDisciplines?: Maybe<CertificateCurriculumSelectedDisciplineUpdateManyWithoutSelectedDisciplineNestedInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
  viewOnDegree?: Maybe<BoolFieldUpdateOperationsInput>;
};

export type CertificateDisciplineUpdateWithoutCertificateCurriculumSelectedDisciplinesInput = {
  CertificateBase?: Maybe<CertificateBaseUpdateOneRequiredWithoutCertificateDisciplineNestedInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
  viewOnDegree?: Maybe<BoolFieldUpdateOperationsInput>;
};

export type CertificateDisciplineUpsertWithoutCertificateBaseInput = {
  create: CertificateDisciplineCreateWithoutCertificateBaseInput;
  update: CertificateDisciplineUpdateWithoutCertificateBaseInput;
  where?: Maybe<CertificateDisciplineWhereInput>;
};

export type CertificateDisciplineUpsertWithoutCertificateCurriculumSelectedDisciplinesInput = {
  create: CertificateDisciplineCreateWithoutCertificateCurriculumSelectedDisciplinesInput;
  update: CertificateDisciplineUpdateWithoutCertificateCurriculumSelectedDisciplinesInput;
  where?: Maybe<CertificateDisciplineWhereInput>;
};

export type CertificateDisciplineWhereInput = {
  AND?: Maybe<Array<CertificateDisciplineWhereInput>>;
  CertificateBase?: Maybe<CertificateBaseWhereInput>;
  CertificateCurriculumSelectedDisciplines?: Maybe<CertificateCurriculumSelectedDisciplineListRelationFilter>;
  NOT?: Maybe<Array<CertificateDisciplineWhereInput>>;
  OR?: Maybe<Array<CertificateDisciplineWhereInput>>;
  certificateBaseId?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  viewOnDegree?: Maybe<BoolFilter>;
};

export type CertificateDisciplineWhereUniqueInput = {
  AND?: Maybe<Array<CertificateDisciplineWhereInput>>;
  CertificateBase?: Maybe<CertificateBaseWhereInput>;
  CertificateCurriculumSelectedDisciplines?: Maybe<CertificateCurriculumSelectedDisciplineListRelationFilter>;
  NOT?: Maybe<Array<CertificateDisciplineWhereInput>>;
  OR?: Maybe<Array<CertificateDisciplineWhereInput>>;
  certificateBaseId?: Maybe<Scalars['String']>;
  name?: Maybe<StringFilter>;
  viewOnDegree?: Maybe<BoolFilter>;
};

export type CertificateEvent = {
  __typename?: 'CertificateEvent';
  CertificateBase: CertificateBase;
  DocumentCertificate: Array<DocumentCertificate>;
  certificateBaseId: Scalars['String'];
  name: Scalars['String'];
};


export type CertificateEventDocumentCertificateArgs = {
  cursor?: Maybe<DocumentCertificateWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentCertificateScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentCertificateOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentCertificateWhereInput>;
};

export type CertificateEventCountOrderByAggregateInput = {
  certificateBaseId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
};

export type CertificateEventCreateInput = {
  CertificateBase: CertificateBaseCreateNestedOneWithoutCertificateEventInput;
  DocumentCertificate?: Maybe<DocumentCertificateCreateNestedManyWithoutEventInput>;
  name: Scalars['String'];
};

export type CertificateEventCreateManyInput = {
  certificateBaseId: Scalars['String'];
  name: Scalars['String'];
};

export type CertificateEventCreateNestedOneWithoutCertificateBaseInput = {
  connect?: Maybe<CertificateEventWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateEventCreateOrConnectWithoutCertificateBaseInput>;
  create?: Maybe<CertificateEventCreateWithoutCertificateBaseInput>;
};

export type CertificateEventCreateNestedOneWithoutDocumentCertificateInput = {
  connect?: Maybe<CertificateEventWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateEventCreateOrConnectWithoutDocumentCertificateInput>;
  create?: Maybe<CertificateEventCreateWithoutDocumentCertificateInput>;
};

export type CertificateEventCreateOrConnectWithoutCertificateBaseInput = {
  create: CertificateEventCreateWithoutCertificateBaseInput;
  where: CertificateEventWhereUniqueInput;
};

export type CertificateEventCreateOrConnectWithoutDocumentCertificateInput = {
  create: CertificateEventCreateWithoutDocumentCertificateInput;
  where: CertificateEventWhereUniqueInput;
};

export type CertificateEventCreateWithoutCertificateBaseInput = {
  DocumentCertificate?: Maybe<DocumentCertificateCreateNestedManyWithoutEventInput>;
  name: Scalars['String'];
};

export type CertificateEventCreateWithoutDocumentCertificateInput = {
  CertificateBase: CertificateBaseCreateNestedOneWithoutCertificateEventInput;
  name: Scalars['String'];
};

export type CertificateEventMaxOrderByAggregateInput = {
  certificateBaseId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
};

export type CertificateEventMinOrderByAggregateInput = {
  certificateBaseId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
};

export type CertificateEventNullableRelationFilter = {
  is?: Maybe<CertificateEventWhereInput>;
  isNot?: Maybe<CertificateEventWhereInput>;
};

export type CertificateEventOrderByWithAggregationInput = {
  _count?: Maybe<CertificateEventCountOrderByAggregateInput>;
  _max?: Maybe<CertificateEventMaxOrderByAggregateInput>;
  _min?: Maybe<CertificateEventMinOrderByAggregateInput>;
  certificateBaseId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
};

export type CertificateEventOrderByWithRelationInput = {
  CertificateBase?: Maybe<CertificateBaseOrderByWithRelationInput>;
  DocumentCertificate?: Maybe<DocumentCertificateOrderByRelationAggregateInput>;
  certificateBaseId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
};

export enum CertificateEventScalarFieldEnum {
  CertificateBaseId = 'certificateBaseId',
  Name = 'name'
}

export type CertificateEventScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CertificateEventScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CertificateEventScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CertificateEventScalarWhereWithAggregatesInput>>;
  certificateBaseId?: Maybe<StringWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
};

export type CertificateEventUpdateInput = {
  CertificateBase?: Maybe<CertificateBaseUpdateOneRequiredWithoutCertificateEventNestedInput>;
  DocumentCertificate?: Maybe<DocumentCertificateUpdateManyWithoutEventNestedInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
};

export type CertificateEventUpdateManyMutationInput = {
  name?: Maybe<StringFieldUpdateOperationsInput>;
};

export type CertificateEventUpdateOneWithoutCertificateBaseNestedInput = {
  connect?: Maybe<CertificateEventWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateEventCreateOrConnectWithoutCertificateBaseInput>;
  create?: Maybe<CertificateEventCreateWithoutCertificateBaseInput>;
  delete?: Maybe<CertificateEventWhereInput>;
  disconnect?: Maybe<CertificateEventWhereInput>;
  update?: Maybe<CertificateEventUpdateToOneWithWhereWithoutCertificateBaseInput>;
  upsert?: Maybe<CertificateEventUpsertWithoutCertificateBaseInput>;
};

export type CertificateEventUpdateOneWithoutDocumentCertificateNestedInput = {
  connect?: Maybe<CertificateEventWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateEventCreateOrConnectWithoutDocumentCertificateInput>;
  create?: Maybe<CertificateEventCreateWithoutDocumentCertificateInput>;
  delete?: Maybe<CertificateEventWhereInput>;
  disconnect?: Maybe<CertificateEventWhereInput>;
  update?: Maybe<CertificateEventUpdateToOneWithWhereWithoutDocumentCertificateInput>;
  upsert?: Maybe<CertificateEventUpsertWithoutDocumentCertificateInput>;
};

export type CertificateEventUpdateToOneWithWhereWithoutCertificateBaseInput = {
  data: CertificateEventUpdateWithoutCertificateBaseInput;
  where?: Maybe<CertificateEventWhereInput>;
};

export type CertificateEventUpdateToOneWithWhereWithoutDocumentCertificateInput = {
  data: CertificateEventUpdateWithoutDocumentCertificateInput;
  where?: Maybe<CertificateEventWhereInput>;
};

export type CertificateEventUpdateWithoutCertificateBaseInput = {
  DocumentCertificate?: Maybe<DocumentCertificateUpdateManyWithoutEventNestedInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
};

export type CertificateEventUpdateWithoutDocumentCertificateInput = {
  CertificateBase?: Maybe<CertificateBaseUpdateOneRequiredWithoutCertificateEventNestedInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
};

export type CertificateEventUpsertWithoutCertificateBaseInput = {
  create: CertificateEventCreateWithoutCertificateBaseInput;
  update: CertificateEventUpdateWithoutCertificateBaseInput;
  where?: Maybe<CertificateEventWhereInput>;
};

export type CertificateEventUpsertWithoutDocumentCertificateInput = {
  create: CertificateEventCreateWithoutDocumentCertificateInput;
  update: CertificateEventUpdateWithoutDocumentCertificateInput;
  where?: Maybe<CertificateEventWhereInput>;
};

export type CertificateEventWhereInput = {
  AND?: Maybe<Array<CertificateEventWhereInput>>;
  CertificateBase?: Maybe<CertificateBaseWhereInput>;
  DocumentCertificate?: Maybe<DocumentCertificateListRelationFilter>;
  NOT?: Maybe<Array<CertificateEventWhereInput>>;
  OR?: Maybe<Array<CertificateEventWhereInput>>;
  certificateBaseId?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
};

export type CertificateEventWhereUniqueInput = {
  AND?: Maybe<Array<CertificateEventWhereInput>>;
  CertificateBase?: Maybe<CertificateBaseWhereInput>;
  DocumentCertificate?: Maybe<DocumentCertificateListRelationFilter>;
  NOT?: Maybe<Array<CertificateEventWhereInput>>;
  OR?: Maybe<Array<CertificateEventWhereInput>>;
  certificateBaseId?: Maybe<Scalars['String']>;
  name?: Maybe<StringFilter>;
};

export type CertificateTeacher = {
  __typename?: 'CertificateTeacher';
  CertificateBase: CertificateBase;
  CertificateCurriculumSelectedDisciplines: Array<CertificateCurriculumSelectedDiscipline>;
  certificateBaseId: Scalars['String'];
  name: Scalars['String'];
  titration: Scalars['String'];
};


export type CertificateTeacherCertificateCurriculumSelectedDisciplinesArgs = {
  cursor?: Maybe<CertificateCurriculumSelectedDisciplineWhereUniqueInput>;
  distinct?: Maybe<Array<CertificateCurriculumSelectedDisciplineScalarFieldEnum>>;
  orderBy?: Maybe<Array<CertificateCurriculumSelectedDisciplineOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CertificateCurriculumSelectedDisciplineWhereInput>;
};

export type CertificateTeacherCountOrderByAggregateInput = {
  certificateBaseId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  titration?: Maybe<SortOrder>;
};

export type CertificateTeacherCreateInput = {
  CertificateBase: CertificateBaseCreateNestedOneWithoutCertificateTeacherInput;
  CertificateCurriculumSelectedDisciplines?: Maybe<CertificateCurriculumSelectedDisciplineCreateNestedManyWithoutSelectedTeacherInput>;
  name: Scalars['String'];
  titration: Scalars['String'];
};

export type CertificateTeacherCreateManyInput = {
  certificateBaseId: Scalars['String'];
  name: Scalars['String'];
  titration: Scalars['String'];
};

export type CertificateTeacherCreateNestedOneWithoutCertificateBaseInput = {
  connect?: Maybe<CertificateTeacherWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateTeacherCreateOrConnectWithoutCertificateBaseInput>;
  create?: Maybe<CertificateTeacherCreateWithoutCertificateBaseInput>;
};

export type CertificateTeacherCreateNestedOneWithoutCertificateCurriculumSelectedDisciplinesInput = {
  connect?: Maybe<CertificateTeacherWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateTeacherCreateOrConnectWithoutCertificateCurriculumSelectedDisciplinesInput>;
  create?: Maybe<CertificateTeacherCreateWithoutCertificateCurriculumSelectedDisciplinesInput>;
};

export type CertificateTeacherCreateOrConnectWithoutCertificateBaseInput = {
  create: CertificateTeacherCreateWithoutCertificateBaseInput;
  where: CertificateTeacherWhereUniqueInput;
};

export type CertificateTeacherCreateOrConnectWithoutCertificateCurriculumSelectedDisciplinesInput = {
  create: CertificateTeacherCreateWithoutCertificateCurriculumSelectedDisciplinesInput;
  where: CertificateTeacherWhereUniqueInput;
};

export type CertificateTeacherCreateWithoutCertificateBaseInput = {
  CertificateCurriculumSelectedDisciplines?: Maybe<CertificateCurriculumSelectedDisciplineCreateNestedManyWithoutSelectedTeacherInput>;
  name: Scalars['String'];
  titration: Scalars['String'];
};

export type CertificateTeacherCreateWithoutCertificateCurriculumSelectedDisciplinesInput = {
  CertificateBase: CertificateBaseCreateNestedOneWithoutCertificateTeacherInput;
  name: Scalars['String'];
  titration: Scalars['String'];
};

export type CertificateTeacherMaxOrderByAggregateInput = {
  certificateBaseId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  titration?: Maybe<SortOrder>;
};

export type CertificateTeacherMinOrderByAggregateInput = {
  certificateBaseId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  titration?: Maybe<SortOrder>;
};

export type CertificateTeacherNullableRelationFilter = {
  is?: Maybe<CertificateTeacherWhereInput>;
  isNot?: Maybe<CertificateTeacherWhereInput>;
};

export type CertificateTeacherOrderByWithAggregationInput = {
  _count?: Maybe<CertificateTeacherCountOrderByAggregateInput>;
  _max?: Maybe<CertificateTeacherMaxOrderByAggregateInput>;
  _min?: Maybe<CertificateTeacherMinOrderByAggregateInput>;
  certificateBaseId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  titration?: Maybe<SortOrder>;
};

export type CertificateTeacherOrderByWithRelationInput = {
  CertificateBase?: Maybe<CertificateBaseOrderByWithRelationInput>;
  CertificateCurriculumSelectedDisciplines?: Maybe<CertificateCurriculumSelectedDisciplineOrderByRelationAggregateInput>;
  certificateBaseId?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  titration?: Maybe<SortOrder>;
};

export enum CertificateTeacherScalarFieldEnum {
  CertificateBaseId = 'certificateBaseId',
  Name = 'name',
  Titration = 'titration'
}

export type CertificateTeacherScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CertificateTeacherScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CertificateTeacherScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CertificateTeacherScalarWhereWithAggregatesInput>>;
  certificateBaseId?: Maybe<StringWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  titration?: Maybe<StringWithAggregatesFilter>;
};

export type CertificateTeacherUpdateInput = {
  CertificateBase?: Maybe<CertificateBaseUpdateOneRequiredWithoutCertificateTeacherNestedInput>;
  CertificateCurriculumSelectedDisciplines?: Maybe<CertificateCurriculumSelectedDisciplineUpdateManyWithoutSelectedTeacherNestedInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
  titration?: Maybe<StringFieldUpdateOperationsInput>;
};

export type CertificateTeacherUpdateManyMutationInput = {
  name?: Maybe<StringFieldUpdateOperationsInput>;
  titration?: Maybe<StringFieldUpdateOperationsInput>;
};

export type CertificateTeacherUpdateOneWithoutCertificateBaseNestedInput = {
  connect?: Maybe<CertificateTeacherWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateTeacherCreateOrConnectWithoutCertificateBaseInput>;
  create?: Maybe<CertificateTeacherCreateWithoutCertificateBaseInput>;
  delete?: Maybe<CertificateTeacherWhereInput>;
  disconnect?: Maybe<CertificateTeacherWhereInput>;
  update?: Maybe<CertificateTeacherUpdateToOneWithWhereWithoutCertificateBaseInput>;
  upsert?: Maybe<CertificateTeacherUpsertWithoutCertificateBaseInput>;
};

export type CertificateTeacherUpdateOneWithoutCertificateCurriculumSelectedDisciplinesNestedInput = {
  connect?: Maybe<CertificateTeacherWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateTeacherCreateOrConnectWithoutCertificateCurriculumSelectedDisciplinesInput>;
  create?: Maybe<CertificateTeacherCreateWithoutCertificateCurriculumSelectedDisciplinesInput>;
  delete?: Maybe<CertificateTeacherWhereInput>;
  disconnect?: Maybe<CertificateTeacherWhereInput>;
  update?: Maybe<CertificateTeacherUpdateToOneWithWhereWithoutCertificateCurriculumSelectedDisciplinesInput>;
  upsert?: Maybe<CertificateTeacherUpsertWithoutCertificateCurriculumSelectedDisciplinesInput>;
};

export type CertificateTeacherUpdateToOneWithWhereWithoutCertificateBaseInput = {
  data: CertificateTeacherUpdateWithoutCertificateBaseInput;
  where?: Maybe<CertificateTeacherWhereInput>;
};

export type CertificateTeacherUpdateToOneWithWhereWithoutCertificateCurriculumSelectedDisciplinesInput = {
  data: CertificateTeacherUpdateWithoutCertificateCurriculumSelectedDisciplinesInput;
  where?: Maybe<CertificateTeacherWhereInput>;
};

export type CertificateTeacherUpdateWithoutCertificateBaseInput = {
  CertificateCurriculumSelectedDisciplines?: Maybe<CertificateCurriculumSelectedDisciplineUpdateManyWithoutSelectedTeacherNestedInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
  titration?: Maybe<StringFieldUpdateOperationsInput>;
};

export type CertificateTeacherUpdateWithoutCertificateCurriculumSelectedDisciplinesInput = {
  CertificateBase?: Maybe<CertificateBaseUpdateOneRequiredWithoutCertificateTeacherNestedInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
  titration?: Maybe<StringFieldUpdateOperationsInput>;
};

export type CertificateTeacherUpsertWithoutCertificateBaseInput = {
  create: CertificateTeacherCreateWithoutCertificateBaseInput;
  update: CertificateTeacherUpdateWithoutCertificateBaseInput;
  where?: Maybe<CertificateTeacherWhereInput>;
};

export type CertificateTeacherUpsertWithoutCertificateCurriculumSelectedDisciplinesInput = {
  create: CertificateTeacherCreateWithoutCertificateCurriculumSelectedDisciplinesInput;
  update: CertificateTeacherUpdateWithoutCertificateCurriculumSelectedDisciplinesInput;
  where?: Maybe<CertificateTeacherWhereInput>;
};

export type CertificateTeacherWhereInput = {
  AND?: Maybe<Array<CertificateTeacherWhereInput>>;
  CertificateBase?: Maybe<CertificateBaseWhereInput>;
  CertificateCurriculumSelectedDisciplines?: Maybe<CertificateCurriculumSelectedDisciplineListRelationFilter>;
  NOT?: Maybe<Array<CertificateTeacherWhereInput>>;
  OR?: Maybe<Array<CertificateTeacherWhereInput>>;
  certificateBaseId?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  titration?: Maybe<StringFilter>;
};

export type CertificateTeacherWhereUniqueInput = {
  AND?: Maybe<Array<CertificateTeacherWhereInput>>;
  CertificateBase?: Maybe<CertificateBaseWhereInput>;
  CertificateCurriculumSelectedDisciplines?: Maybe<CertificateCurriculumSelectedDisciplineListRelationFilter>;
  NOT?: Maybe<Array<CertificateTeacherWhereInput>>;
  OR?: Maybe<Array<CertificateTeacherWhereInput>>;
  certificateBaseId?: Maybe<Scalars['String']>;
  name?: Maybe<StringFilter>;
  titration?: Maybe<StringFilter>;
};

/** Guarda o modelo para criação dos certificados / representações visuais de diploma */
export type CertificateTemplate = {
  __typename?: 'CertificateTemplate';
  DocumentCertificate: Array<DocumentCertificate>;
  Team: Team;
  UserCreated: CommonUser;
  commonUserId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  /** ![PrismaJson.AnyJson] */
  data: Scalars['Json'];
  description?: Maybe<Scalars['String']>;
  /**
   * Undergraduate -> Degree RVDD
   * Postgraduate -> Certificate of Post Graduation
   * Generic Certificates -> Any Certificate
   */
  educationLevel: EducationLevelType;
  id: Scalars['String'];
  name: Scalars['String'];
  teamId: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


/** Guarda o modelo para criação dos certificados / representações visuais de diploma */
export type CertificateTemplateDocumentCertificateArgs = {
  cursor?: Maybe<DocumentCertificateWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentCertificateScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentCertificateOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentCertificateWhereInput>;
};

export type CertificateTemplateAvgOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type CertificateTemplateCountOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  data?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  educationLevel?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CertificateTemplateCreateInput = {
  DocumentCertificate?: Maybe<DocumentCertificateCreateNestedManyWithoutTemplateInput>;
  Team: TeamCreateNestedOneWithoutCertificateTemplatesInput;
  UserCreated: CommonUserCreateNestedOneWithoutCreatedCertificateTemplatesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  data: Scalars['Json'];
  description?: Maybe<Scalars['String']>;
  educationLevel?: Maybe<EducationLevelType>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CertificateTemplateCreateManyInput = {
  commonUserId: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  data: Scalars['Json'];
  description?: Maybe<Scalars['String']>;
  educationLevel?: Maybe<EducationLevelType>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  teamId: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CertificateTemplateCreateManyTeamInput = {
  commonUserId: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  data: Scalars['Json'];
  description?: Maybe<Scalars['String']>;
  educationLevel?: Maybe<EducationLevelType>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CertificateTemplateCreateManyTeamInputEnvelope = {
  data: Array<CertificateTemplateCreateManyTeamInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CertificateTemplateCreateManyUserCreatedInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  data: Scalars['Json'];
  description?: Maybe<Scalars['String']>;
  educationLevel?: Maybe<EducationLevelType>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  teamId: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CertificateTemplateCreateManyUserCreatedInputEnvelope = {
  data: Array<CertificateTemplateCreateManyUserCreatedInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CertificateTemplateCreateNestedManyWithoutTeamInput = {
  connect?: Maybe<Array<CertificateTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CertificateTemplateCreateOrConnectWithoutTeamInput>>;
  create?: Maybe<Array<CertificateTemplateCreateWithoutTeamInput>>;
  createMany?: Maybe<CertificateTemplateCreateManyTeamInputEnvelope>;
};

export type CertificateTemplateCreateNestedManyWithoutUserCreatedInput = {
  connect?: Maybe<Array<CertificateTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CertificateTemplateCreateOrConnectWithoutUserCreatedInput>>;
  create?: Maybe<Array<CertificateTemplateCreateWithoutUserCreatedInput>>;
  createMany?: Maybe<CertificateTemplateCreateManyUserCreatedInputEnvelope>;
};

export type CertificateTemplateCreateNestedOneWithoutDocumentCertificateInput = {
  connect?: Maybe<CertificateTemplateWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateTemplateCreateOrConnectWithoutDocumentCertificateInput>;
  create?: Maybe<CertificateTemplateCreateWithoutDocumentCertificateInput>;
};

export type CertificateTemplateCreateOrConnectWithoutDocumentCertificateInput = {
  create: CertificateTemplateCreateWithoutDocumentCertificateInput;
  where: CertificateTemplateWhereUniqueInput;
};

export type CertificateTemplateCreateOrConnectWithoutTeamInput = {
  create: CertificateTemplateCreateWithoutTeamInput;
  where: CertificateTemplateWhereUniqueInput;
};

export type CertificateTemplateCreateOrConnectWithoutUserCreatedInput = {
  create: CertificateTemplateCreateWithoutUserCreatedInput;
  where: CertificateTemplateWhereUniqueInput;
};

export type CertificateTemplateCreateWithoutDocumentCertificateInput = {
  Team: TeamCreateNestedOneWithoutCertificateTemplatesInput;
  UserCreated: CommonUserCreateNestedOneWithoutCreatedCertificateTemplatesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  data: Scalars['Json'];
  description?: Maybe<Scalars['String']>;
  educationLevel?: Maybe<EducationLevelType>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CertificateTemplateCreateWithoutTeamInput = {
  DocumentCertificate?: Maybe<DocumentCertificateCreateNestedManyWithoutTemplateInput>;
  UserCreated: CommonUserCreateNestedOneWithoutCreatedCertificateTemplatesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  data: Scalars['Json'];
  description?: Maybe<Scalars['String']>;
  educationLevel?: Maybe<EducationLevelType>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CertificateTemplateCreateWithoutUserCreatedInput = {
  DocumentCertificate?: Maybe<DocumentCertificateCreateNestedManyWithoutTemplateInput>;
  Team: TeamCreateNestedOneWithoutCertificateTemplatesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  data: Scalars['Json'];
  description?: Maybe<Scalars['String']>;
  educationLevel?: Maybe<EducationLevelType>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CertificateTemplateListRelationFilter = {
  every?: Maybe<CertificateTemplateWhereInput>;
  none?: Maybe<CertificateTemplateWhereInput>;
  some?: Maybe<CertificateTemplateWhereInput>;
};

export type CertificateTemplateMaxOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  educationLevel?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CertificateTemplateMinOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  educationLevel?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CertificateTemplateNullableRelationFilter = {
  is?: Maybe<CertificateTemplateWhereInput>;
  isNot?: Maybe<CertificateTemplateWhereInput>;
};

export type CertificateTemplateOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CertificateTemplateOrderByWithAggregationInput = {
  _avg?: Maybe<CertificateTemplateAvgOrderByAggregateInput>;
  _count?: Maybe<CertificateTemplateCountOrderByAggregateInput>;
  _max?: Maybe<CertificateTemplateMaxOrderByAggregateInput>;
  _min?: Maybe<CertificateTemplateMinOrderByAggregateInput>;
  _sum?: Maybe<CertificateTemplateSumOrderByAggregateInput>;
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  data?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  educationLevel?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CertificateTemplateOrderByWithRelationInput = {
  DocumentCertificate?: Maybe<DocumentCertificateOrderByRelationAggregateInput>;
  Team?: Maybe<TeamOrderByWithRelationInput>;
  UserCreated?: Maybe<CommonUserOrderByWithRelationInput>;
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  data?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  educationLevel?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum CertificateTemplateScalarFieldEnum {
  CommonUserId = 'commonUserId',
  CreatedAt = 'createdAt',
  Data = 'data',
  Description = 'description',
  EducationLevel = 'educationLevel',
  Id = 'id',
  Name = 'name',
  TeamId = 'teamId',
  UpdatedAt = 'updatedAt'
}

export type CertificateTemplateScalarWhereInput = {
  AND?: Maybe<Array<CertificateTemplateScalarWhereInput>>;
  NOT?: Maybe<Array<CertificateTemplateScalarWhereInput>>;
  OR?: Maybe<Array<CertificateTemplateScalarWhereInput>>;
  commonUserId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  data?: Maybe<JsonFilter>;
  description?: Maybe<StringNullableFilter>;
  educationLevel?: Maybe<EnumEducationLevelTypeFilter>;
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  teamId?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
};

export type CertificateTemplateScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CertificateTemplateScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CertificateTemplateScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CertificateTemplateScalarWhereWithAggregatesInput>>;
  commonUserId?: Maybe<IntWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  data?: Maybe<JsonWithAggregatesFilter>;
  description?: Maybe<StringNullableWithAggregatesFilter>;
  educationLevel?: Maybe<EnumEducationLevelTypeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  teamId?: Maybe<IntWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
};

export type CertificateTemplateSumOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type CertificateTemplateUpdateInput = {
  DocumentCertificate?: Maybe<DocumentCertificateUpdateManyWithoutTemplateNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutCertificateTemplatesNestedInput>;
  UserCreated?: Maybe<CommonUserUpdateOneRequiredWithoutCreatedCertificateTemplatesNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  data?: Maybe<Scalars['Json']>;
  description?: Maybe<NullableStringFieldUpdateOperationsInput>;
  educationLevel?: Maybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CertificateTemplateUpdateManyMutationInput = {
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  data?: Maybe<Scalars['Json']>;
  description?: Maybe<NullableStringFieldUpdateOperationsInput>;
  educationLevel?: Maybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CertificateTemplateUpdateManyWithWhereWithoutTeamInput = {
  data: CertificateTemplateUpdateManyMutationInput;
  where: CertificateTemplateScalarWhereInput;
};

export type CertificateTemplateUpdateManyWithWhereWithoutUserCreatedInput = {
  data: CertificateTemplateUpdateManyMutationInput;
  where: CertificateTemplateScalarWhereInput;
};

export type CertificateTemplateUpdateManyWithoutTeamNestedInput = {
  connect?: Maybe<Array<CertificateTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CertificateTemplateCreateOrConnectWithoutTeamInput>>;
  create?: Maybe<Array<CertificateTemplateCreateWithoutTeamInput>>;
  createMany?: Maybe<CertificateTemplateCreateManyTeamInputEnvelope>;
  delete?: Maybe<Array<CertificateTemplateWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CertificateTemplateScalarWhereInput>>;
  disconnect?: Maybe<Array<CertificateTemplateWhereUniqueInput>>;
  set?: Maybe<Array<CertificateTemplateWhereUniqueInput>>;
  update?: Maybe<Array<CertificateTemplateUpdateWithWhereUniqueWithoutTeamInput>>;
  updateMany?: Maybe<Array<CertificateTemplateUpdateManyWithWhereWithoutTeamInput>>;
  upsert?: Maybe<Array<CertificateTemplateUpsertWithWhereUniqueWithoutTeamInput>>;
};

export type CertificateTemplateUpdateManyWithoutUserCreatedNestedInput = {
  connect?: Maybe<Array<CertificateTemplateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CertificateTemplateCreateOrConnectWithoutUserCreatedInput>>;
  create?: Maybe<Array<CertificateTemplateCreateWithoutUserCreatedInput>>;
  createMany?: Maybe<CertificateTemplateCreateManyUserCreatedInputEnvelope>;
  delete?: Maybe<Array<CertificateTemplateWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CertificateTemplateScalarWhereInput>>;
  disconnect?: Maybe<Array<CertificateTemplateWhereUniqueInput>>;
  set?: Maybe<Array<CertificateTemplateWhereUniqueInput>>;
  update?: Maybe<Array<CertificateTemplateUpdateWithWhereUniqueWithoutUserCreatedInput>>;
  updateMany?: Maybe<Array<CertificateTemplateUpdateManyWithWhereWithoutUserCreatedInput>>;
  upsert?: Maybe<Array<CertificateTemplateUpsertWithWhereUniqueWithoutUserCreatedInput>>;
};

export type CertificateTemplateUpdateOneWithoutDocumentCertificateNestedInput = {
  connect?: Maybe<CertificateTemplateWhereUniqueInput>;
  connectOrCreate?: Maybe<CertificateTemplateCreateOrConnectWithoutDocumentCertificateInput>;
  create?: Maybe<CertificateTemplateCreateWithoutDocumentCertificateInput>;
  delete?: Maybe<CertificateTemplateWhereInput>;
  disconnect?: Maybe<CertificateTemplateWhereInput>;
  update?: Maybe<CertificateTemplateUpdateToOneWithWhereWithoutDocumentCertificateInput>;
  upsert?: Maybe<CertificateTemplateUpsertWithoutDocumentCertificateInput>;
};

export type CertificateTemplateUpdateToOneWithWhereWithoutDocumentCertificateInput = {
  data: CertificateTemplateUpdateWithoutDocumentCertificateInput;
  where?: Maybe<CertificateTemplateWhereInput>;
};

export type CertificateTemplateUpdateWithWhereUniqueWithoutTeamInput = {
  data: CertificateTemplateUpdateWithoutTeamInput;
  where: CertificateTemplateWhereUniqueInput;
};

export type CertificateTemplateUpdateWithWhereUniqueWithoutUserCreatedInput = {
  data: CertificateTemplateUpdateWithoutUserCreatedInput;
  where: CertificateTemplateWhereUniqueInput;
};

export type CertificateTemplateUpdateWithoutDocumentCertificateInput = {
  Team?: Maybe<TeamUpdateOneRequiredWithoutCertificateTemplatesNestedInput>;
  UserCreated?: Maybe<CommonUserUpdateOneRequiredWithoutCreatedCertificateTemplatesNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  data?: Maybe<Scalars['Json']>;
  description?: Maybe<NullableStringFieldUpdateOperationsInput>;
  educationLevel?: Maybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CertificateTemplateUpdateWithoutTeamInput = {
  DocumentCertificate?: Maybe<DocumentCertificateUpdateManyWithoutTemplateNestedInput>;
  UserCreated?: Maybe<CommonUserUpdateOneRequiredWithoutCreatedCertificateTemplatesNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  data?: Maybe<Scalars['Json']>;
  description?: Maybe<NullableStringFieldUpdateOperationsInput>;
  educationLevel?: Maybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CertificateTemplateUpdateWithoutUserCreatedInput = {
  DocumentCertificate?: Maybe<DocumentCertificateUpdateManyWithoutTemplateNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutCertificateTemplatesNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  data?: Maybe<Scalars['Json']>;
  description?: Maybe<NullableStringFieldUpdateOperationsInput>;
  educationLevel?: Maybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CertificateTemplateUpsertWithWhereUniqueWithoutTeamInput = {
  create: CertificateTemplateCreateWithoutTeamInput;
  update: CertificateTemplateUpdateWithoutTeamInput;
  where: CertificateTemplateWhereUniqueInput;
};

export type CertificateTemplateUpsertWithWhereUniqueWithoutUserCreatedInput = {
  create: CertificateTemplateCreateWithoutUserCreatedInput;
  update: CertificateTemplateUpdateWithoutUserCreatedInput;
  where: CertificateTemplateWhereUniqueInput;
};

export type CertificateTemplateUpsertWithoutDocumentCertificateInput = {
  create: CertificateTemplateCreateWithoutDocumentCertificateInput;
  update: CertificateTemplateUpdateWithoutDocumentCertificateInput;
  where?: Maybe<CertificateTemplateWhereInput>;
};

export type CertificateTemplateWhereInput = {
  AND?: Maybe<Array<CertificateTemplateWhereInput>>;
  DocumentCertificate?: Maybe<DocumentCertificateListRelationFilter>;
  NOT?: Maybe<Array<CertificateTemplateWhereInput>>;
  OR?: Maybe<Array<CertificateTemplateWhereInput>>;
  Team?: Maybe<TeamWhereInput>;
  UserCreated?: Maybe<CommonUserWhereInput>;
  commonUserId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  data?: Maybe<JsonFilter>;
  description?: Maybe<StringNullableFilter>;
  educationLevel?: Maybe<EnumEducationLevelTypeFilter>;
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  teamId?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
};

export type CertificateTemplateWhereUniqueInput = {
  AND?: Maybe<Array<CertificateTemplateWhereInput>>;
  DocumentCertificate?: Maybe<DocumentCertificateListRelationFilter>;
  NOT?: Maybe<Array<CertificateTemplateWhereInput>>;
  OR?: Maybe<Array<CertificateTemplateWhereInput>>;
  Team?: Maybe<TeamWhereInput>;
  UserCreated?: Maybe<CommonUserWhereInput>;
  commonUserId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  data?: Maybe<JsonFilter>;
  description?: Maybe<StringNullableFilter>;
  educationLevel?: Maybe<EnumEducationLevelTypeFilter>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<StringFilter>;
  teamId?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
};

export enum CertificateTypes {
  Course = 'COURSE',
  CourseLevel = 'COURSE_LEVEL',
  Curriculum = 'CURRICULUM',
  Discipline = 'DISCIPLINE',
  Event = 'EVENT',
  Teacher = 'TEACHER'
}

export type CirriculumSelectedDiscipline = {
  amountOfHours?: Maybe<Scalars['Int']>;
  disciplineId: Scalars['String'];
  teacherId?: Maybe<Scalars['String']>;
};

export type CommonUser = {
  __typename?: 'CommonUser';
  ApiKey: Array<ApiKey>;
  CertificateBase: Array<CertificateBase>;
  Charges: Array<FinancialCharge>;
  CreatedCertificateTemplates: Array<CertificateTemplate>;
  CreatedSignatureImages: Array<SignSignatureImage>;
  CreatedSubscriptions: Array<FinancialTeamWalletSubscription>;
  CreditCardSaveds: Array<FinancialCreditCardSaved>;
  DefaultImage?: Maybe<SignSignatureImage>;
  DocumentBase: Array<DocumentBase>;
  DocumentBaseHistory: Array<DocumentBaseHistory>;
  DocumentBaseSignatureInviteSignature: Array<DocumentBaseSignatureInviteSignature>;
  MaintainerAdmin?: Maybe<MaintainerAdmin>;
  Recharges: Array<FinancialRecharge>;
  ReusableFormDataCurriculumList: Array<ReusableFormDataCurriculum>;
  ReusableFormDatas: Array<ReusableFormData>;
  SystemAuditLogs: Array<SystemAuditLog>;
  SystemGlobalAlertUserDismisses: Array<SystemGlobalAlertUserDismiss>;
  SystemLog: Array<SystemLog>;
  Team: Team;
  TeamMember: Array<TeamMember>;
  TeamsCreated: Array<Team>;
  /** Notificações não fechadas e notificações 'fixadas' */
  UserAlerts: Array<SystemGlobalAlert>;
  UserConfigs: Array<CommonUserConfig>;
  computedResolvedAt: Scalars['String'];
  /** From LedgerSign, if empty -> user was invited without logged yet */
  cpf?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  defaultSignatureImageId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  hasInvite: Scalars['Boolean'];
  id: Scalars['Int'];
  /** Id of the user created/authed at LedgerSign */
  idLedgerSign?: Maybe<Scalars['Int']>;
  institutionCnpj?: Maybe<Scalars['String']>;
  lastActivityAt: Scalars['DateTime'];
  loggedAs?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  permissions: Array<Scalars['String']>;
  /** Photo without signUrl, from DOC, updated every login */
  photo?: Maybe<Scalars['String']>;
  teamId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type CommonUserApiKeyArgs = {
  cursor?: Maybe<ApiKeyWhereUniqueInput>;
  distinct?: Maybe<Array<ApiKeyScalarFieldEnum>>;
  orderBy?: Maybe<Array<ApiKeyOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ApiKeyWhereInput>;
};


export type CommonUserCertificateBaseArgs = {
  cursor?: Maybe<CertificateBaseWhereUniqueInput>;
  distinct?: Maybe<Array<CertificateBaseScalarFieldEnum>>;
  orderBy?: Maybe<Array<CertificateBaseOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CertificateBaseWhereInput>;
};


export type CommonUserChargesArgs = {
  cursor?: Maybe<FinancialChargeWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialChargeScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialChargeOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialChargeWhereInput>;
};


export type CommonUserCreatedCertificateTemplatesArgs = {
  cursor?: Maybe<CertificateTemplateWhereUniqueInput>;
  distinct?: Maybe<Array<CertificateTemplateScalarFieldEnum>>;
  orderBy?: Maybe<Array<CertificateTemplateOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CertificateTemplateWhereInput>;
};


export type CommonUserCreatedSignatureImagesArgs = {
  cursor?: Maybe<SignSignatureImageWhereUniqueInput>;
  distinct?: Maybe<Array<SignSignatureImageScalarFieldEnum>>;
  orderBy?: Maybe<Array<SignSignatureImageOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SignSignatureImageWhereInput>;
};


export type CommonUserCreatedSubscriptionsArgs = {
  cursor?: Maybe<FinancialTeamWalletSubscriptionWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialTeamWalletSubscriptionScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialTeamWalletSubscriptionOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialTeamWalletSubscriptionWhereInput>;
};


export type CommonUserCreditCardSavedsArgs = {
  cursor?: Maybe<FinancialCreditCardSavedWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialCreditCardSavedScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialCreditCardSavedOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialCreditCardSavedWhereInput>;
};


export type CommonUserDocumentBaseArgs = {
  cursor?: Maybe<DocumentBaseWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseWhereInput>;
};


export type CommonUserDocumentBaseHistoryArgs = {
  cursor?: Maybe<DocumentBaseHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseHistoryScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseHistoryOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseHistoryWhereInput>;
};


export type CommonUserDocumentBaseSignatureInviteSignatureArgs = {
  cursor?: Maybe<DocumentBaseSignatureInviteSignatureWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseSignatureInviteSignatureScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseSignatureInviteSignatureOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseSignatureInviteSignatureWhereInput>;
};


export type CommonUserRechargesArgs = {
  cursor?: Maybe<FinancialRechargeWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialRechargeScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialRechargeOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialRechargeWhereInput>;
};


export type CommonUserReusableFormDataCurriculumListArgs = {
  cursor?: Maybe<ReusableFormDataCurriculumWhereUniqueInput>;
  distinct?: Maybe<Array<ReusableFormDataCurriculumScalarFieldEnum>>;
  orderBy?: Maybe<Array<ReusableFormDataCurriculumOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ReusableFormDataCurriculumWhereInput>;
};


export type CommonUserReusableFormDatasArgs = {
  cursor?: Maybe<ReusableFormDataWhereUniqueInput>;
  distinct?: Maybe<Array<ReusableFormDataScalarFieldEnum>>;
  orderBy?: Maybe<Array<ReusableFormDataOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ReusableFormDataWhereInput>;
};


export type CommonUserSystemAuditLogsArgs = {
  cursor?: Maybe<SystemAuditLogWhereUniqueInput>;
  distinct?: Maybe<Array<SystemAuditLogScalarFieldEnum>>;
  orderBy?: Maybe<Array<SystemAuditLogOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SystemAuditLogWhereInput>;
};


export type CommonUserSystemGlobalAlertUserDismissesArgs = {
  cursor?: Maybe<SystemGlobalAlertUserDismissWhereUniqueInput>;
  distinct?: Maybe<Array<SystemGlobalAlertUserDismissScalarFieldEnum>>;
  orderBy?: Maybe<Array<SystemGlobalAlertUserDismissOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SystemGlobalAlertUserDismissWhereInput>;
};


export type CommonUserSystemLogArgs = {
  cursor?: Maybe<SystemLogWhereUniqueInput>;
  distinct?: Maybe<Array<SystemLogScalarFieldEnum>>;
  orderBy?: Maybe<Array<SystemLogOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SystemLogWhereInput>;
};


export type CommonUserTeamMemberArgs = {
  cursor?: Maybe<TeamMemberWhereUniqueInput>;
  distinct?: Maybe<Array<TeamMemberScalarFieldEnum>>;
  orderBy?: Maybe<Array<TeamMemberOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TeamMemberWhereInput>;
};


export type CommonUserTeamsCreatedArgs = {
  cursor?: Maybe<TeamWhereUniqueInput>;
  distinct?: Maybe<Array<TeamScalarFieldEnum>>;
  orderBy?: Maybe<Array<TeamOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TeamWhereInput>;
};


export type CommonUserUserConfigsArgs = {
  cursor?: Maybe<CommonUserConfigWhereUniqueInput>;
  distinct?: Maybe<Array<CommonUserConfigScalarFieldEnum>>;
  orderBy?: Maybe<Array<CommonUserConfigOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CommonUserConfigWhereInput>;
};

export type CommonUserAvgOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  idLedgerSign?: Maybe<SortOrder>;
};

/**
 * Created to store Onboarding Watched Videos
 * Ids are frontend generated, so there's no links to other tables
 */
export type CommonUserConfig = {
  __typename?: 'CommonUserConfig';
  CommonUser: CommonUser;
  commonUserId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  key: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** ![PrismaJson.AnyJson] */
  value: Scalars['Json'];
};

export type CommonUserConfigAvgOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
};

export type CommonUserConfigCommonUserIdKeyCompoundUniqueInput = {
  commonUserId: Scalars['Int'];
  key: Scalars['String'];
};

export type CommonUserConfigCountOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  key?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export type CommonUserConfigCreateInput = {
  CommonUser: CommonUserCreateNestedOneWithoutUserConfigsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  key: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  value: Scalars['Json'];
};

export type CommonUserConfigCreateManyCommonUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  key: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  value: Scalars['Json'];
};

export type CommonUserConfigCreateManyCommonUserInputEnvelope = {
  data: Array<CommonUserConfigCreateManyCommonUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CommonUserConfigCreateManyInput = {
  commonUserId: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  key: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  value: Scalars['Json'];
};

export type CommonUserConfigCreateNestedManyWithoutCommonUserInput = {
  connect?: Maybe<Array<CommonUserConfigWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CommonUserConfigCreateOrConnectWithoutCommonUserInput>>;
  create?: Maybe<Array<CommonUserConfigCreateWithoutCommonUserInput>>;
  createMany?: Maybe<CommonUserConfigCreateManyCommonUserInputEnvelope>;
};

export type CommonUserConfigCreateOrConnectWithoutCommonUserInput = {
  create: CommonUserConfigCreateWithoutCommonUserInput;
  where: CommonUserConfigWhereUniqueInput;
};

export type CommonUserConfigCreateWithoutCommonUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  key: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  value: Scalars['Json'];
};

export enum CommonUserConfigKeys {
  OnboardingProgress = 'onboardingProgress'
}

export type CommonUserConfigListRelationFilter = {
  every?: Maybe<CommonUserConfigWhereInput>;
  none?: Maybe<CommonUserConfigWhereInput>;
  some?: Maybe<CommonUserConfigWhereInput>;
};

export type CommonUserConfigMaxOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  key?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CommonUserConfigMinOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  key?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CommonUserConfigOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CommonUserConfigOrderByWithAggregationInput = {
  _avg?: Maybe<CommonUserConfigAvgOrderByAggregateInput>;
  _count?: Maybe<CommonUserConfigCountOrderByAggregateInput>;
  _max?: Maybe<CommonUserConfigMaxOrderByAggregateInput>;
  _min?: Maybe<CommonUserConfigMinOrderByAggregateInput>;
  _sum?: Maybe<CommonUserConfigSumOrderByAggregateInput>;
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  key?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export type CommonUserConfigOrderByWithRelationInput = {
  CommonUser?: Maybe<CommonUserOrderByWithRelationInput>;
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  key?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export enum CommonUserConfigScalarFieldEnum {
  CommonUserId = 'commonUserId',
  CreatedAt = 'createdAt',
  Key = 'key',
  UpdatedAt = 'updatedAt',
  Value = 'value'
}

export type CommonUserConfigScalarWhereInput = {
  AND?: Maybe<Array<CommonUserConfigScalarWhereInput>>;
  NOT?: Maybe<Array<CommonUserConfigScalarWhereInput>>;
  OR?: Maybe<Array<CommonUserConfigScalarWhereInput>>;
  commonUserId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  key?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
  value?: Maybe<JsonFilter>;
};

export type CommonUserConfigScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CommonUserConfigScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CommonUserConfigScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CommonUserConfigScalarWhereWithAggregatesInput>>;
  commonUserId?: Maybe<IntWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  key?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  value?: Maybe<JsonWithAggregatesFilter>;
};

export type CommonUserConfigSumOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
};

export type CommonUserConfigUpdateInput = {
  CommonUser?: Maybe<CommonUserUpdateOneRequiredWithoutUserConfigsNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  key?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  value?: Maybe<Scalars['Json']>;
};

export type CommonUserConfigUpdateManyMutationInput = {
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  key?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  value?: Maybe<Scalars['Json']>;
};

export type CommonUserConfigUpdateManyWithWhereWithoutCommonUserInput = {
  data: CommonUserConfigUpdateManyMutationInput;
  where: CommonUserConfigScalarWhereInput;
};

export type CommonUserConfigUpdateManyWithoutCommonUserNestedInput = {
  connect?: Maybe<Array<CommonUserConfigWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CommonUserConfigCreateOrConnectWithoutCommonUserInput>>;
  create?: Maybe<Array<CommonUserConfigCreateWithoutCommonUserInput>>;
  createMany?: Maybe<CommonUserConfigCreateManyCommonUserInputEnvelope>;
  delete?: Maybe<Array<CommonUserConfigWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CommonUserConfigScalarWhereInput>>;
  disconnect?: Maybe<Array<CommonUserConfigWhereUniqueInput>>;
  set?: Maybe<Array<CommonUserConfigWhereUniqueInput>>;
  update?: Maybe<Array<CommonUserConfigUpdateWithWhereUniqueWithoutCommonUserInput>>;
  updateMany?: Maybe<Array<CommonUserConfigUpdateManyWithWhereWithoutCommonUserInput>>;
  upsert?: Maybe<Array<CommonUserConfigUpsertWithWhereUniqueWithoutCommonUserInput>>;
};

export type CommonUserConfigUpdateWithWhereUniqueWithoutCommonUserInput = {
  data: CommonUserConfigUpdateWithoutCommonUserInput;
  where: CommonUserConfigWhereUniqueInput;
};

export type CommonUserConfigUpdateWithoutCommonUserInput = {
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  key?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  value?: Maybe<Scalars['Json']>;
};

export type CommonUserConfigUpsertWithWhereUniqueWithoutCommonUserInput = {
  create: CommonUserConfigCreateWithoutCommonUserInput;
  update: CommonUserConfigUpdateWithoutCommonUserInput;
  where: CommonUserConfigWhereUniqueInput;
};

export type CommonUserConfigWhereInput = {
  AND?: Maybe<Array<CommonUserConfigWhereInput>>;
  CommonUser?: Maybe<CommonUserWhereInput>;
  NOT?: Maybe<Array<CommonUserConfigWhereInput>>;
  OR?: Maybe<Array<CommonUserConfigWhereInput>>;
  commonUserId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  key?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
  value?: Maybe<JsonFilter>;
};

export type CommonUserConfigWhereUniqueInput = {
  AND?: Maybe<Array<CommonUserConfigWhereInput>>;
  CommonUser?: Maybe<CommonUserWhereInput>;
  NOT?: Maybe<Array<CommonUserConfigWhereInput>>;
  OR?: Maybe<Array<CommonUserConfigWhereInput>>;
  commonUserId?: Maybe<IntFilter>;
  commonUserId_key?: Maybe<CommonUserConfigCommonUserIdKeyCompoundUniqueInput>;
  createdAt?: Maybe<DateTimeFilter>;
  key?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
  value?: Maybe<JsonFilter>;
};

export type CommonUserCountOrderByAggregateInput = {
  cpf?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultSignatureImageId?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  idLedgerSign?: Maybe<SortOrder>;
  lastActivityAt?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  photo?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CommonUserCreateInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: Maybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: Maybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: Maybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: Maybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: Maybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: Maybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: Maybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  idLedgerSign?: Maybe<Scalars['Int']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CommonUserCreateManyInput = {
  cpf?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultSignatureImageId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  idLedgerSign?: Maybe<Scalars['Int']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CommonUserCreateNestedOneWithoutApiKeyInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutApiKeyInput>;
  create?: Maybe<CommonUserCreateWithoutApiKeyInput>;
};

export type CommonUserCreateNestedOneWithoutCertificateBaseInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutCertificateBaseInput>;
  create?: Maybe<CommonUserCreateWithoutCertificateBaseInput>;
};

export type CommonUserCreateNestedOneWithoutChargesInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutChargesInput>;
  create?: Maybe<CommonUserCreateWithoutChargesInput>;
};

export type CommonUserCreateNestedOneWithoutCreatedCertificateTemplatesInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutCreatedCertificateTemplatesInput>;
  create?: Maybe<CommonUserCreateWithoutCreatedCertificateTemplatesInput>;
};

export type CommonUserCreateNestedOneWithoutCreatedSignatureImagesInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutCreatedSignatureImagesInput>;
  create?: Maybe<CommonUserCreateWithoutCreatedSignatureImagesInput>;
};

export type CommonUserCreateNestedOneWithoutCreatedSubscriptionsInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutCreatedSubscriptionsInput>;
  create?: Maybe<CommonUserCreateWithoutCreatedSubscriptionsInput>;
};

export type CommonUserCreateNestedOneWithoutCreditCardSavedsInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutCreditCardSavedsInput>;
  create?: Maybe<CommonUserCreateWithoutCreditCardSavedsInput>;
};

export type CommonUserCreateNestedOneWithoutDefaultImageInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutDefaultImageInput>;
  create?: Maybe<CommonUserCreateWithoutDefaultImageInput>;
};

export type CommonUserCreateNestedOneWithoutDocumentBaseHistoryInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutDocumentBaseHistoryInput>;
  create?: Maybe<CommonUserCreateWithoutDocumentBaseHistoryInput>;
};

export type CommonUserCreateNestedOneWithoutDocumentBaseInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutDocumentBaseInput>;
  create?: Maybe<CommonUserCreateWithoutDocumentBaseInput>;
};

export type CommonUserCreateNestedOneWithoutDocumentBaseSignatureInviteSignatureInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutDocumentBaseSignatureInviteSignatureInput>;
  create?: Maybe<CommonUserCreateWithoutDocumentBaseSignatureInviteSignatureInput>;
};

export type CommonUserCreateNestedOneWithoutMaintainerAdminInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutMaintainerAdminInput>;
  create?: Maybe<CommonUserCreateWithoutMaintainerAdminInput>;
};

export type CommonUserCreateNestedOneWithoutRechargesInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutRechargesInput>;
  create?: Maybe<CommonUserCreateWithoutRechargesInput>;
};

export type CommonUserCreateNestedOneWithoutReusableFormDataCurriculumListInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutReusableFormDataCurriculumListInput>;
  create?: Maybe<CommonUserCreateWithoutReusableFormDataCurriculumListInput>;
};

export type CommonUserCreateNestedOneWithoutReusableFormDatasInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutReusableFormDatasInput>;
  create?: Maybe<CommonUserCreateWithoutReusableFormDatasInput>;
};

export type CommonUserCreateNestedOneWithoutSystemAuditLogsInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutSystemAuditLogsInput>;
  create?: Maybe<CommonUserCreateWithoutSystemAuditLogsInput>;
};

export type CommonUserCreateNestedOneWithoutSystemGlobalAlertUserDismissesInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutSystemGlobalAlertUserDismissesInput>;
  create?: Maybe<CommonUserCreateWithoutSystemGlobalAlertUserDismissesInput>;
};

export type CommonUserCreateNestedOneWithoutSystemLogInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutSystemLogInput>;
  create?: Maybe<CommonUserCreateWithoutSystemLogInput>;
};

export type CommonUserCreateNestedOneWithoutTeamMemberInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutTeamMemberInput>;
  create?: Maybe<CommonUserCreateWithoutTeamMemberInput>;
};

export type CommonUserCreateNestedOneWithoutTeamsCreatedInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutTeamsCreatedInput>;
  create?: Maybe<CommonUserCreateWithoutTeamsCreatedInput>;
};

export type CommonUserCreateNestedOneWithoutUserConfigsInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutUserConfigsInput>;
  create?: Maybe<CommonUserCreateWithoutUserConfigsInput>;
};

export type CommonUserCreateOrConnectWithoutApiKeyInput = {
  create: CommonUserCreateWithoutApiKeyInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutCertificateBaseInput = {
  create: CommonUserCreateWithoutCertificateBaseInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutChargesInput = {
  create: CommonUserCreateWithoutChargesInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutCreatedCertificateTemplatesInput = {
  create: CommonUserCreateWithoutCreatedCertificateTemplatesInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutCreatedSignatureImagesInput = {
  create: CommonUserCreateWithoutCreatedSignatureImagesInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutCreatedSubscriptionsInput = {
  create: CommonUserCreateWithoutCreatedSubscriptionsInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutCreditCardSavedsInput = {
  create: CommonUserCreateWithoutCreditCardSavedsInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutDefaultImageInput = {
  create: CommonUserCreateWithoutDefaultImageInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutDocumentBaseHistoryInput = {
  create: CommonUserCreateWithoutDocumentBaseHistoryInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutDocumentBaseInput = {
  create: CommonUserCreateWithoutDocumentBaseInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutDocumentBaseSignatureInviteSignatureInput = {
  create: CommonUserCreateWithoutDocumentBaseSignatureInviteSignatureInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutMaintainerAdminInput = {
  create: CommonUserCreateWithoutMaintainerAdminInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutRechargesInput = {
  create: CommonUserCreateWithoutRechargesInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutReusableFormDataCurriculumListInput = {
  create: CommonUserCreateWithoutReusableFormDataCurriculumListInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutReusableFormDatasInput = {
  create: CommonUserCreateWithoutReusableFormDatasInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutSystemAuditLogsInput = {
  create: CommonUserCreateWithoutSystemAuditLogsInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutSystemGlobalAlertUserDismissesInput = {
  create: CommonUserCreateWithoutSystemGlobalAlertUserDismissesInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutSystemLogInput = {
  create: CommonUserCreateWithoutSystemLogInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutTeamMemberInput = {
  create: CommonUserCreateWithoutTeamMemberInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutTeamsCreatedInput = {
  create: CommonUserCreateWithoutTeamsCreatedInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutUserConfigsInput = {
  create: CommonUserCreateWithoutUserConfigsInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateWithoutApiKeyInput = {
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: Maybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: Maybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: Maybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: Maybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: Maybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: Maybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: Maybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  idLedgerSign?: Maybe<Scalars['Int']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CommonUserCreateWithoutCertificateBaseInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutUserInput>;
  Charges?: Maybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: Maybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: Maybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: Maybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: Maybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: Maybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: Maybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  idLedgerSign?: Maybe<Scalars['Int']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CommonUserCreateWithoutChargesInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: Maybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: Maybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: Maybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: Maybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: Maybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: Maybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  idLedgerSign?: Maybe<Scalars['Int']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CommonUserCreateWithoutCreatedCertificateTemplatesInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: Maybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: Maybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: Maybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: Maybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: Maybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: Maybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: Maybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  idLedgerSign?: Maybe<Scalars['Int']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CommonUserCreateWithoutCreatedSignatureImagesInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: Maybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: Maybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: Maybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: Maybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: Maybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: Maybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: Maybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  idLedgerSign?: Maybe<Scalars['Int']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CommonUserCreateWithoutCreatedSubscriptionsInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: Maybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: Maybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: Maybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: Maybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: Maybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: Maybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: Maybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  idLedgerSign?: Maybe<Scalars['Int']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CommonUserCreateWithoutCreditCardSavedsInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: Maybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: Maybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: Maybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: Maybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: Maybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: Maybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: Maybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  idLedgerSign?: Maybe<Scalars['Int']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CommonUserCreateWithoutDefaultImageInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: Maybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DocumentBase?: Maybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: Maybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: Maybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: Maybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: Maybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  idLedgerSign?: Maybe<Scalars['Int']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CommonUserCreateWithoutDocumentBaseHistoryInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: Maybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: Maybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: Maybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: Maybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: Maybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: Maybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: Maybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  idLedgerSign?: Maybe<Scalars['Int']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CommonUserCreateWithoutDocumentBaseInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: Maybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: Maybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: Maybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: Maybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: Maybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: Maybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  idLedgerSign?: Maybe<Scalars['Int']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CommonUserCreateWithoutDocumentBaseSignatureInviteSignatureInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: Maybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: Maybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: Maybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: Maybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: Maybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: Maybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: Maybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  idLedgerSign?: Maybe<Scalars['Int']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CommonUserCreateWithoutMaintainerAdminInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: Maybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: Maybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: Maybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  Recharges?: Maybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: Maybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: Maybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: Maybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  idLedgerSign?: Maybe<Scalars['Int']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CommonUserCreateWithoutRechargesInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: Maybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: Maybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: Maybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: Maybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: Maybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: Maybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  idLedgerSign?: Maybe<Scalars['Int']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CommonUserCreateWithoutReusableFormDataCurriculumListInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: Maybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: Maybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: Maybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: Maybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: Maybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: Maybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: Maybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  idLedgerSign?: Maybe<Scalars['Int']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CommonUserCreateWithoutReusableFormDatasInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: Maybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: Maybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: Maybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: Maybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: Maybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: Maybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: Maybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  idLedgerSign?: Maybe<Scalars['Int']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CommonUserCreateWithoutSystemAuditLogsInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: Maybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: Maybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: Maybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: Maybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: Maybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: Maybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: Maybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  idLedgerSign?: Maybe<Scalars['Int']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CommonUserCreateWithoutSystemGlobalAlertUserDismissesInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: Maybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: Maybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: Maybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: Maybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemLog?: Maybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: Maybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: Maybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  idLedgerSign?: Maybe<Scalars['Int']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CommonUserCreateWithoutSystemLogInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: Maybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: Maybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: Maybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: Maybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: Maybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: Maybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  idLedgerSign?: Maybe<Scalars['Int']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CommonUserCreateWithoutTeamMemberInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: Maybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: Maybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: Maybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: Maybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: Maybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamsCreated?: Maybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: Maybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  idLedgerSign?: Maybe<Scalars['Int']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CommonUserCreateWithoutTeamsCreatedInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: Maybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: Maybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: Maybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: Maybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: Maybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutUserInput>;
  UserConfigs?: Maybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  idLedgerSign?: Maybe<Scalars['Int']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CommonUserCreateWithoutUserConfigsInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: Maybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: Maybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: Maybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: Maybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: Maybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: Maybe<TeamCreateNestedManyWithoutOwnerInput>;
  cpf?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  idLedgerSign?: Maybe<Scalars['Int']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CommonUserMaxOrderByAggregateInput = {
  cpf?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultSignatureImageId?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  idLedgerSign?: Maybe<SortOrder>;
  lastActivityAt?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  photo?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CommonUserMinOrderByAggregateInput = {
  cpf?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultSignatureImageId?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  idLedgerSign?: Maybe<SortOrder>;
  lastActivityAt?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  photo?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CommonUserNullableRelationFilter = {
  is?: Maybe<CommonUserWhereInput>;
  isNot?: Maybe<CommonUserWhereInput>;
};

export type CommonUserOrderByWithAggregationInput = {
  _avg?: Maybe<CommonUserAvgOrderByAggregateInput>;
  _count?: Maybe<CommonUserCountOrderByAggregateInput>;
  _max?: Maybe<CommonUserMaxOrderByAggregateInput>;
  _min?: Maybe<CommonUserMinOrderByAggregateInput>;
  _sum?: Maybe<CommonUserSumOrderByAggregateInput>;
  cpf?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultSignatureImageId?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  idLedgerSign?: Maybe<SortOrder>;
  lastActivityAt?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  photo?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CommonUserOrderByWithRelationInput = {
  ApiKey?: Maybe<ApiKeyOrderByRelationAggregateInput>;
  CertificateBase?: Maybe<CertificateBaseOrderByRelationAggregateInput>;
  Charges?: Maybe<FinancialChargeOrderByRelationAggregateInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateOrderByRelationAggregateInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageOrderByRelationAggregateInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionOrderByRelationAggregateInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedOrderByRelationAggregateInput>;
  DefaultImage?: Maybe<SignSignatureImageOrderByWithRelationInput>;
  DocumentBase?: Maybe<DocumentBaseOrderByRelationAggregateInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryOrderByRelationAggregateInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureOrderByRelationAggregateInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminOrderByWithRelationInput>;
  Recharges?: Maybe<FinancialRechargeOrderByRelationAggregateInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumOrderByRelationAggregateInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataOrderByRelationAggregateInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogOrderByRelationAggregateInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissOrderByRelationAggregateInput>;
  SystemLog?: Maybe<SystemLogOrderByRelationAggregateInput>;
  TeamMember?: Maybe<TeamMemberOrderByRelationAggregateInput>;
  TeamsCreated?: Maybe<TeamOrderByRelationAggregateInput>;
  UserConfigs?: Maybe<CommonUserConfigOrderByRelationAggregateInput>;
  cpf?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  defaultSignatureImageId?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  idLedgerSign?: Maybe<SortOrder>;
  lastActivityAt?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  photo?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CommonUserRelationFilter = {
  is?: Maybe<CommonUserWhereInput>;
  isNot?: Maybe<CommonUserWhereInput>;
};

export enum CommonUserScalarFieldEnum {
  Cpf = 'cpf',
  CreatedAt = 'createdAt',
  DefaultSignatureImageId = 'defaultSignatureImageId',
  Email = 'email',
  Id = 'id',
  IdLedgerSign = 'idLedgerSign',
  LastActivityAt = 'lastActivityAt',
  Name = 'name',
  Photo = 'photo',
  UpdatedAt = 'updatedAt'
}

export type CommonUserScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CommonUserScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<CommonUserScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CommonUserScalarWhereWithAggregatesInput>>;
  cpf?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  defaultSignatureImageId?: Maybe<StringNullableWithAggregatesFilter>;
  email?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  idLedgerSign?: Maybe<IntNullableWithAggregatesFilter>;
  lastActivityAt?: Maybe<DateTimeWithAggregatesFilter>;
  name?: Maybe<StringNullableWithAggregatesFilter>;
  photo?: Maybe<StringNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
};

export type CommonUserSumOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  idLedgerSign?: Maybe<SortOrder>;
};

export type CommonUserUpdateInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: Maybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: Maybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: Maybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: Maybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: Maybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: Maybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  email?: Maybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: Maybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  name?: Maybe<NullableStringFieldUpdateOperationsInput>;
  photo?: Maybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateManyMutationInput = {
  cpf?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  email?: Maybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: Maybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  name?: Maybe<NullableStringFieldUpdateOperationsInput>;
  photo?: Maybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateOneRequiredWithoutApiKeyNestedInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutApiKeyInput>;
  create?: Maybe<CommonUserCreateWithoutApiKeyInput>;
  update?: Maybe<CommonUserUpdateToOneWithWhereWithoutApiKeyInput>;
  upsert?: Maybe<CommonUserUpsertWithoutApiKeyInput>;
};

export type CommonUserUpdateOneRequiredWithoutCertificateBaseNestedInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutCertificateBaseInput>;
  create?: Maybe<CommonUserCreateWithoutCertificateBaseInput>;
  update?: Maybe<CommonUserUpdateToOneWithWhereWithoutCertificateBaseInput>;
  upsert?: Maybe<CommonUserUpsertWithoutCertificateBaseInput>;
};

export type CommonUserUpdateOneRequiredWithoutChargesNestedInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutChargesInput>;
  create?: Maybe<CommonUserCreateWithoutChargesInput>;
  update?: Maybe<CommonUserUpdateToOneWithWhereWithoutChargesInput>;
  upsert?: Maybe<CommonUserUpsertWithoutChargesInput>;
};

export type CommonUserUpdateOneRequiredWithoutCreatedCertificateTemplatesNestedInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutCreatedCertificateTemplatesInput>;
  create?: Maybe<CommonUserCreateWithoutCreatedCertificateTemplatesInput>;
  update?: Maybe<CommonUserUpdateToOneWithWhereWithoutCreatedCertificateTemplatesInput>;
  upsert?: Maybe<CommonUserUpsertWithoutCreatedCertificateTemplatesInput>;
};

export type CommonUserUpdateOneRequiredWithoutCreatedSignatureImagesNestedInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutCreatedSignatureImagesInput>;
  create?: Maybe<CommonUserCreateWithoutCreatedSignatureImagesInput>;
  update?: Maybe<CommonUserUpdateToOneWithWhereWithoutCreatedSignatureImagesInput>;
  upsert?: Maybe<CommonUserUpsertWithoutCreatedSignatureImagesInput>;
};

export type CommonUserUpdateOneRequiredWithoutCreatedSubscriptionsNestedInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutCreatedSubscriptionsInput>;
  create?: Maybe<CommonUserCreateWithoutCreatedSubscriptionsInput>;
  update?: Maybe<CommonUserUpdateToOneWithWhereWithoutCreatedSubscriptionsInput>;
  upsert?: Maybe<CommonUserUpsertWithoutCreatedSubscriptionsInput>;
};

export type CommonUserUpdateOneRequiredWithoutCreditCardSavedsNestedInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutCreditCardSavedsInput>;
  create?: Maybe<CommonUserCreateWithoutCreditCardSavedsInput>;
  update?: Maybe<CommonUserUpdateToOneWithWhereWithoutCreditCardSavedsInput>;
  upsert?: Maybe<CommonUserUpsertWithoutCreditCardSavedsInput>;
};

export type CommonUserUpdateOneRequiredWithoutDocumentBaseNestedInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutDocumentBaseInput>;
  create?: Maybe<CommonUserCreateWithoutDocumentBaseInput>;
  update?: Maybe<CommonUserUpdateToOneWithWhereWithoutDocumentBaseInput>;
  upsert?: Maybe<CommonUserUpsertWithoutDocumentBaseInput>;
};

export type CommonUserUpdateOneRequiredWithoutDocumentBaseSignatureInviteSignatureNestedInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutDocumentBaseSignatureInviteSignatureInput>;
  create?: Maybe<CommonUserCreateWithoutDocumentBaseSignatureInviteSignatureInput>;
  update?: Maybe<CommonUserUpdateToOneWithWhereWithoutDocumentBaseSignatureInviteSignatureInput>;
  upsert?: Maybe<CommonUserUpsertWithoutDocumentBaseSignatureInviteSignatureInput>;
};

export type CommonUserUpdateOneRequiredWithoutMaintainerAdminNestedInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutMaintainerAdminInput>;
  create?: Maybe<CommonUserCreateWithoutMaintainerAdminInput>;
  update?: Maybe<CommonUserUpdateToOneWithWhereWithoutMaintainerAdminInput>;
  upsert?: Maybe<CommonUserUpsertWithoutMaintainerAdminInput>;
};

export type CommonUserUpdateOneRequiredWithoutRechargesNestedInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutRechargesInput>;
  create?: Maybe<CommonUserCreateWithoutRechargesInput>;
  update?: Maybe<CommonUserUpdateToOneWithWhereWithoutRechargesInput>;
  upsert?: Maybe<CommonUserUpsertWithoutRechargesInput>;
};

export type CommonUserUpdateOneRequiredWithoutReusableFormDataCurriculumListNestedInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutReusableFormDataCurriculumListInput>;
  create?: Maybe<CommonUserCreateWithoutReusableFormDataCurriculumListInput>;
  update?: Maybe<CommonUserUpdateToOneWithWhereWithoutReusableFormDataCurriculumListInput>;
  upsert?: Maybe<CommonUserUpsertWithoutReusableFormDataCurriculumListInput>;
};

export type CommonUserUpdateOneRequiredWithoutReusableFormDatasNestedInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutReusableFormDatasInput>;
  create?: Maybe<CommonUserCreateWithoutReusableFormDatasInput>;
  update?: Maybe<CommonUserUpdateToOneWithWhereWithoutReusableFormDatasInput>;
  upsert?: Maybe<CommonUserUpsertWithoutReusableFormDatasInput>;
};

export type CommonUserUpdateOneRequiredWithoutSystemGlobalAlertUserDismissesNestedInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutSystemGlobalAlertUserDismissesInput>;
  create?: Maybe<CommonUserCreateWithoutSystemGlobalAlertUserDismissesInput>;
  update?: Maybe<CommonUserUpdateToOneWithWhereWithoutSystemGlobalAlertUserDismissesInput>;
  upsert?: Maybe<CommonUserUpsertWithoutSystemGlobalAlertUserDismissesInput>;
};

export type CommonUserUpdateOneRequiredWithoutTeamMemberNestedInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutTeamMemberInput>;
  create?: Maybe<CommonUserCreateWithoutTeamMemberInput>;
  update?: Maybe<CommonUserUpdateToOneWithWhereWithoutTeamMemberInput>;
  upsert?: Maybe<CommonUserUpsertWithoutTeamMemberInput>;
};

export type CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutTeamsCreatedInput>;
  create?: Maybe<CommonUserCreateWithoutTeamsCreatedInput>;
  update?: Maybe<CommonUserUpdateToOneWithWhereWithoutTeamsCreatedInput>;
  upsert?: Maybe<CommonUserUpsertWithoutTeamsCreatedInput>;
};

export type CommonUserUpdateOneRequiredWithoutUserConfigsNestedInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutUserConfigsInput>;
  create?: Maybe<CommonUserCreateWithoutUserConfigsInput>;
  update?: Maybe<CommonUserUpdateToOneWithWhereWithoutUserConfigsInput>;
  upsert?: Maybe<CommonUserUpsertWithoutUserConfigsInput>;
};

export type CommonUserUpdateOneWithoutDefaultImageNestedInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutDefaultImageInput>;
  create?: Maybe<CommonUserCreateWithoutDefaultImageInput>;
  delete?: Maybe<CommonUserWhereInput>;
  disconnect?: Maybe<CommonUserWhereInput>;
  update?: Maybe<CommonUserUpdateToOneWithWhereWithoutDefaultImageInput>;
  upsert?: Maybe<CommonUserUpsertWithoutDefaultImageInput>;
};

export type CommonUserUpdateOneWithoutDocumentBaseHistoryNestedInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutDocumentBaseHistoryInput>;
  create?: Maybe<CommonUserCreateWithoutDocumentBaseHistoryInput>;
  delete?: Maybe<CommonUserWhereInput>;
  disconnect?: Maybe<CommonUserWhereInput>;
  update?: Maybe<CommonUserUpdateToOneWithWhereWithoutDocumentBaseHistoryInput>;
  upsert?: Maybe<CommonUserUpsertWithoutDocumentBaseHistoryInput>;
};

export type CommonUserUpdateOneWithoutSystemAuditLogsNestedInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutSystemAuditLogsInput>;
  create?: Maybe<CommonUserCreateWithoutSystemAuditLogsInput>;
  delete?: Maybe<CommonUserWhereInput>;
  disconnect?: Maybe<CommonUserWhereInput>;
  update?: Maybe<CommonUserUpdateToOneWithWhereWithoutSystemAuditLogsInput>;
  upsert?: Maybe<CommonUserUpsertWithoutSystemAuditLogsInput>;
};

export type CommonUserUpdateOneWithoutSystemLogNestedInput = {
  connect?: Maybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: Maybe<CommonUserCreateOrConnectWithoutSystemLogInput>;
  create?: Maybe<CommonUserCreateWithoutSystemLogInput>;
  delete?: Maybe<CommonUserWhereInput>;
  disconnect?: Maybe<CommonUserWhereInput>;
  update?: Maybe<CommonUserUpdateToOneWithWhereWithoutSystemLogInput>;
  upsert?: Maybe<CommonUserUpsertWithoutSystemLogInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutApiKeyInput = {
  data: CommonUserUpdateWithoutApiKeyInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutCertificateBaseInput = {
  data: CommonUserUpdateWithoutCertificateBaseInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutChargesInput = {
  data: CommonUserUpdateWithoutChargesInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutCreatedCertificateTemplatesInput = {
  data: CommonUserUpdateWithoutCreatedCertificateTemplatesInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutCreatedSignatureImagesInput = {
  data: CommonUserUpdateWithoutCreatedSignatureImagesInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutCreatedSubscriptionsInput = {
  data: CommonUserUpdateWithoutCreatedSubscriptionsInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutCreditCardSavedsInput = {
  data: CommonUserUpdateWithoutCreditCardSavedsInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutDefaultImageInput = {
  data: CommonUserUpdateWithoutDefaultImageInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutDocumentBaseHistoryInput = {
  data: CommonUserUpdateWithoutDocumentBaseHistoryInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutDocumentBaseInput = {
  data: CommonUserUpdateWithoutDocumentBaseInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutDocumentBaseSignatureInviteSignatureInput = {
  data: CommonUserUpdateWithoutDocumentBaseSignatureInviteSignatureInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutMaintainerAdminInput = {
  data: CommonUserUpdateWithoutMaintainerAdminInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutRechargesInput = {
  data: CommonUserUpdateWithoutRechargesInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutReusableFormDataCurriculumListInput = {
  data: CommonUserUpdateWithoutReusableFormDataCurriculumListInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutReusableFormDatasInput = {
  data: CommonUserUpdateWithoutReusableFormDatasInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutSystemAuditLogsInput = {
  data: CommonUserUpdateWithoutSystemAuditLogsInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutSystemGlobalAlertUserDismissesInput = {
  data: CommonUserUpdateWithoutSystemGlobalAlertUserDismissesInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutSystemLogInput = {
  data: CommonUserUpdateWithoutSystemLogInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutTeamMemberInput = {
  data: CommonUserUpdateWithoutTeamMemberInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutTeamsCreatedInput = {
  data: CommonUserUpdateWithoutTeamsCreatedInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutUserConfigsInput = {
  data: CommonUserUpdateWithoutUserConfigsInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpdateWithoutApiKeyInput = {
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: Maybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: Maybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: Maybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: Maybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: Maybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: Maybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  email?: Maybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: Maybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  name?: Maybe<NullableStringFieldUpdateOperationsInput>;
  photo?: Maybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutCertificateBaseInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  Charges?: Maybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: Maybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: Maybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: Maybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: Maybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: Maybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  email?: Maybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: Maybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  name?: Maybe<NullableStringFieldUpdateOperationsInput>;
  photo?: Maybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutChargesInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: Maybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: Maybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: Maybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: Maybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: Maybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  email?: Maybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: Maybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  name?: Maybe<NullableStringFieldUpdateOperationsInput>;
  photo?: Maybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutCreatedCertificateTemplatesInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: Maybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: Maybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: Maybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: Maybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: Maybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: Maybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  email?: Maybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: Maybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  name?: Maybe<NullableStringFieldUpdateOperationsInput>;
  photo?: Maybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutCreatedSignatureImagesInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: Maybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: Maybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: Maybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: Maybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: Maybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: Maybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  email?: Maybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: Maybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  name?: Maybe<NullableStringFieldUpdateOperationsInput>;
  photo?: Maybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutCreatedSubscriptionsInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: Maybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: Maybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: Maybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: Maybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: Maybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: Maybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  email?: Maybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: Maybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  name?: Maybe<NullableStringFieldUpdateOperationsInput>;
  photo?: Maybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutCreditCardSavedsInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: Maybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: Maybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: Maybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: Maybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: Maybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: Maybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  email?: Maybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: Maybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  name?: Maybe<NullableStringFieldUpdateOperationsInput>;
  photo?: Maybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutDefaultImageInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: Maybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: Maybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: Maybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: Maybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: Maybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  email?: Maybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: Maybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  name?: Maybe<NullableStringFieldUpdateOperationsInput>;
  photo?: Maybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutDocumentBaseHistoryInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: Maybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: Maybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: Maybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: Maybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: Maybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: Maybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  email?: Maybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: Maybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  name?: Maybe<NullableStringFieldUpdateOperationsInput>;
  photo?: Maybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutDocumentBaseInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: Maybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: Maybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: Maybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: Maybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: Maybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: Maybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  email?: Maybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: Maybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  name?: Maybe<NullableStringFieldUpdateOperationsInput>;
  photo?: Maybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutDocumentBaseSignatureInviteSignatureInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: Maybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: Maybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: Maybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: Maybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: Maybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: Maybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  email?: Maybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: Maybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  name?: Maybe<NullableStringFieldUpdateOperationsInput>;
  photo?: Maybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutMaintainerAdminInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: Maybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: Maybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  Recharges?: Maybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: Maybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: Maybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: Maybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  email?: Maybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: Maybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  name?: Maybe<NullableStringFieldUpdateOperationsInput>;
  photo?: Maybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutRechargesInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: Maybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: Maybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: Maybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: Maybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: Maybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  email?: Maybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: Maybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  name?: Maybe<NullableStringFieldUpdateOperationsInput>;
  photo?: Maybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutReusableFormDataCurriculumListInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: Maybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: Maybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: Maybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: Maybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: Maybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: Maybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  email?: Maybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: Maybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  name?: Maybe<NullableStringFieldUpdateOperationsInput>;
  photo?: Maybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutReusableFormDatasInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: Maybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: Maybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: Maybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: Maybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: Maybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: Maybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  email?: Maybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: Maybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  name?: Maybe<NullableStringFieldUpdateOperationsInput>;
  photo?: Maybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutSystemAuditLogsInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: Maybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: Maybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: Maybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: Maybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: Maybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: Maybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  email?: Maybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: Maybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  name?: Maybe<NullableStringFieldUpdateOperationsInput>;
  photo?: Maybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutSystemGlobalAlertUserDismissesInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: Maybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: Maybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: Maybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemLog?: Maybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: Maybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: Maybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  email?: Maybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: Maybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  name?: Maybe<NullableStringFieldUpdateOperationsInput>;
  photo?: Maybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutSystemLogInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: Maybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: Maybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: Maybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: Maybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: Maybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  email?: Maybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: Maybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  name?: Maybe<NullableStringFieldUpdateOperationsInput>;
  photo?: Maybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutTeamMemberInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: Maybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: Maybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: Maybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: Maybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: Maybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: Maybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  email?: Maybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: Maybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  name?: Maybe<NullableStringFieldUpdateOperationsInput>;
  photo?: Maybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutTeamsCreatedInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: Maybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: Maybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: Maybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: Maybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  UserConfigs?: Maybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  email?: Maybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: Maybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  name?: Maybe<NullableStringFieldUpdateOperationsInput>;
  photo?: Maybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutUserConfigsInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: Maybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: Maybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: Maybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: Maybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: Maybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: Maybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: Maybe<TeamUpdateManyWithoutOwnerNestedInput>;
  cpf?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  email?: Maybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: Maybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  name?: Maybe<NullableStringFieldUpdateOperationsInput>;
  photo?: Maybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpsertWithoutApiKeyInput = {
  create: CommonUserCreateWithoutApiKeyInput;
  update: CommonUserUpdateWithoutApiKeyInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutCertificateBaseInput = {
  create: CommonUserCreateWithoutCertificateBaseInput;
  update: CommonUserUpdateWithoutCertificateBaseInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutChargesInput = {
  create: CommonUserCreateWithoutChargesInput;
  update: CommonUserUpdateWithoutChargesInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutCreatedCertificateTemplatesInput = {
  create: CommonUserCreateWithoutCreatedCertificateTemplatesInput;
  update: CommonUserUpdateWithoutCreatedCertificateTemplatesInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutCreatedSignatureImagesInput = {
  create: CommonUserCreateWithoutCreatedSignatureImagesInput;
  update: CommonUserUpdateWithoutCreatedSignatureImagesInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutCreatedSubscriptionsInput = {
  create: CommonUserCreateWithoutCreatedSubscriptionsInput;
  update: CommonUserUpdateWithoutCreatedSubscriptionsInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutCreditCardSavedsInput = {
  create: CommonUserCreateWithoutCreditCardSavedsInput;
  update: CommonUserUpdateWithoutCreditCardSavedsInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutDefaultImageInput = {
  create: CommonUserCreateWithoutDefaultImageInput;
  update: CommonUserUpdateWithoutDefaultImageInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutDocumentBaseHistoryInput = {
  create: CommonUserCreateWithoutDocumentBaseHistoryInput;
  update: CommonUserUpdateWithoutDocumentBaseHistoryInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutDocumentBaseInput = {
  create: CommonUserCreateWithoutDocumentBaseInput;
  update: CommonUserUpdateWithoutDocumentBaseInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutDocumentBaseSignatureInviteSignatureInput = {
  create: CommonUserCreateWithoutDocumentBaseSignatureInviteSignatureInput;
  update: CommonUserUpdateWithoutDocumentBaseSignatureInviteSignatureInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutMaintainerAdminInput = {
  create: CommonUserCreateWithoutMaintainerAdminInput;
  update: CommonUserUpdateWithoutMaintainerAdminInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutRechargesInput = {
  create: CommonUserCreateWithoutRechargesInput;
  update: CommonUserUpdateWithoutRechargesInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutReusableFormDataCurriculumListInput = {
  create: CommonUserCreateWithoutReusableFormDataCurriculumListInput;
  update: CommonUserUpdateWithoutReusableFormDataCurriculumListInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutReusableFormDatasInput = {
  create: CommonUserCreateWithoutReusableFormDatasInput;
  update: CommonUserUpdateWithoutReusableFormDatasInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutSystemAuditLogsInput = {
  create: CommonUserCreateWithoutSystemAuditLogsInput;
  update: CommonUserUpdateWithoutSystemAuditLogsInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutSystemGlobalAlertUserDismissesInput = {
  create: CommonUserCreateWithoutSystemGlobalAlertUserDismissesInput;
  update: CommonUserUpdateWithoutSystemGlobalAlertUserDismissesInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutSystemLogInput = {
  create: CommonUserCreateWithoutSystemLogInput;
  update: CommonUserUpdateWithoutSystemLogInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutTeamMemberInput = {
  create: CommonUserCreateWithoutTeamMemberInput;
  update: CommonUserUpdateWithoutTeamMemberInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutTeamsCreatedInput = {
  create: CommonUserCreateWithoutTeamsCreatedInput;
  update: CommonUserUpdateWithoutTeamsCreatedInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutUserConfigsInput = {
  create: CommonUserCreateWithoutUserConfigsInput;
  update: CommonUserUpdateWithoutUserConfigsInput;
  where?: Maybe<CommonUserWhereInput>;
};

export type CommonUserWhereInput = {
  AND?: Maybe<Array<CommonUserWhereInput>>;
  ApiKey?: Maybe<ApiKeyListRelationFilter>;
  CertificateBase?: Maybe<CertificateBaseListRelationFilter>;
  Charges?: Maybe<FinancialChargeListRelationFilter>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateListRelationFilter>;
  CreatedSignatureImages?: Maybe<SignSignatureImageListRelationFilter>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionListRelationFilter>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedListRelationFilter>;
  DefaultImage?: Maybe<SignSignatureImageWhereInput>;
  DocumentBase?: Maybe<DocumentBaseListRelationFilter>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryListRelationFilter>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureListRelationFilter>;
  MaintainerAdmin?: Maybe<MaintainerAdminWhereInput>;
  NOT?: Maybe<Array<CommonUserWhereInput>>;
  OR?: Maybe<Array<CommonUserWhereInput>>;
  Recharges?: Maybe<FinancialRechargeListRelationFilter>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumListRelationFilter>;
  ReusableFormDatas?: Maybe<ReusableFormDataListRelationFilter>;
  SystemAuditLogs?: Maybe<SystemAuditLogListRelationFilter>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissListRelationFilter>;
  SystemLog?: Maybe<SystemLogListRelationFilter>;
  TeamMember?: Maybe<TeamMemberListRelationFilter>;
  TeamsCreated?: Maybe<TeamListRelationFilter>;
  UserConfigs?: Maybe<CommonUserConfigListRelationFilter>;
  cpf?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  defaultSignatureImageId?: Maybe<StringNullableFilter>;
  email?: Maybe<StringFilter>;
  id?: Maybe<IntFilter>;
  idLedgerSign?: Maybe<IntNullableFilter>;
  lastActivityAt?: Maybe<DateTimeFilter>;
  name?: Maybe<StringNullableFilter>;
  photo?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
};

export type CommonUserWhereUniqueInput = {
  AND?: Maybe<Array<CommonUserWhereInput>>;
  ApiKey?: Maybe<ApiKeyListRelationFilter>;
  CertificateBase?: Maybe<CertificateBaseListRelationFilter>;
  Charges?: Maybe<FinancialChargeListRelationFilter>;
  CreatedCertificateTemplates?: Maybe<CertificateTemplateListRelationFilter>;
  CreatedSignatureImages?: Maybe<SignSignatureImageListRelationFilter>;
  CreatedSubscriptions?: Maybe<FinancialTeamWalletSubscriptionListRelationFilter>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedListRelationFilter>;
  DefaultImage?: Maybe<SignSignatureImageWhereInput>;
  DocumentBase?: Maybe<DocumentBaseListRelationFilter>;
  DocumentBaseHistory?: Maybe<DocumentBaseHistoryListRelationFilter>;
  DocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignatureListRelationFilter>;
  MaintainerAdmin?: Maybe<MaintainerAdminWhereInput>;
  NOT?: Maybe<Array<CommonUserWhereInput>>;
  OR?: Maybe<Array<CommonUserWhereInput>>;
  Recharges?: Maybe<FinancialRechargeListRelationFilter>;
  ReusableFormDataCurriculumList?: Maybe<ReusableFormDataCurriculumListRelationFilter>;
  ReusableFormDatas?: Maybe<ReusableFormDataListRelationFilter>;
  SystemAuditLogs?: Maybe<SystemAuditLogListRelationFilter>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissListRelationFilter>;
  SystemLog?: Maybe<SystemLogListRelationFilter>;
  TeamMember?: Maybe<TeamMemberListRelationFilter>;
  TeamsCreated?: Maybe<TeamListRelationFilter>;
  UserConfigs?: Maybe<CommonUserConfigListRelationFilter>;
  cpf?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  defaultSignatureImageId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  idLedgerSign?: Maybe<IntNullableFilter>;
  lastActivityAt?: Maybe<DateTimeFilter>;
  name?: Maybe<StringNullableFilter>;
  photo?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
};

export type CompleteSignatureImage = {
  base64Image: Scalars['String'];
  createdAt: Scalars['String'];
  id: Scalars['String'];
  percentageBelowTheLine: Scalars['Float'];
};

export type CreateOneEnabledInstitutionInput = {
  cnpj: Scalars['String'];
  educationLevelType: Array<EducationLevelType>;
  email: Scalars['String'];
  isMaintainer: Scalars['Boolean'];
  isNSF: Scalars['Boolean'];
  placeholderName: Scalars['String'];
  syncWithLedgerDoc: Scalars['Boolean'];
};

export type CreateOneFinancialRechargeInput = {
  creditCard?: Maybe<InputFinancialPurchaseCreditCard>;
  creditsCount: Scalars['Int'];
  /** To avoid charge different value than expected (shown in frontend) */
  expectedCost: Scalars['Float'];
  savedCreditCard?: Maybe<InputFinancialPurchaseSavedCreditCard>;
  service: FinancialChargeableService;
};

export type CreateOneSignSignatureImageData = {
  base64Image: Scalars['String'];
  description: Scalars['String'];
  percentageBelowTheLine: Scalars['Float'];
};

export type CurriculumDisciplineVariable = {
  certificateBaseId: Scalars['String'];
  data: CurriculumDisciplineVariableData;
};

export type CurriculumDisciplineVariableData = {
  frequency?: Maybe<Scalars['String']>;
  testGrade?: Maybe<Scalars['String']>;
};

export type CustomReturnType = {
  __typename?: 'CustomReturnType';
  success: Scalars['Boolean'];
  total: Scalars['Int'];
};



export type DateTimeFieldUpdateOperationsInput = {
  set?: Maybe<Scalars['DateTime']>;
};

export type DateTimeFilter = {
  equals?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  not?: Maybe<NestedDateTimeFilter>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type DateTimeNullableFilter = {
  equals?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  not?: Maybe<NestedDateTimeNullableFilter>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type DateTimeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedDateTimeNullableFilter>;
  _min?: Maybe<NestedDateTimeNullableFilter>;
  equals?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  not?: Maybe<NestedDateTimeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type DateTimeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedDateTimeFilter>;
  _min?: Maybe<NestedDateTimeFilter>;
  equals?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  not?: Maybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};


export type DecimalFieldUpdateOperationsInput = {
  decrement?: Maybe<Scalars['Decimal']>;
  divide?: Maybe<Scalars['Decimal']>;
  increment?: Maybe<Scalars['Decimal']>;
  multiply?: Maybe<Scalars['Decimal']>;
  set?: Maybe<Scalars['Decimal']>;
};

export type DecimalFilter = {
  equals?: Maybe<Scalars['Decimal']>;
  gt?: Maybe<Scalars['Decimal']>;
  gte?: Maybe<Scalars['Decimal']>;
  in?: Maybe<Array<Scalars['Decimal']>>;
  lt?: Maybe<Scalars['Decimal']>;
  lte?: Maybe<Scalars['Decimal']>;
  not?: Maybe<NestedDecimalFilter>;
  notIn?: Maybe<Array<Scalars['Decimal']>>;
};

export type DecimalWithAggregatesFilter = {
  _avg?: Maybe<NestedDecimalFilter>;
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedDecimalFilter>;
  _min?: Maybe<NestedDecimalFilter>;
  _sum?: Maybe<NestedDecimalFilter>;
  equals?: Maybe<Scalars['Decimal']>;
  gt?: Maybe<Scalars['Decimal']>;
  gte?: Maybe<Scalars['Decimal']>;
  in?: Maybe<Array<Scalars['Decimal']>>;
  lt?: Maybe<Scalars['Decimal']>;
  lte?: Maybe<Scalars['Decimal']>;
  not?: Maybe<NestedDecimalWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['Decimal']>>;
};

/** Descontos em porcentagem que começam a partir de uma quantidade */
export type Discount = {
  __typename?: 'Discount';
  count: Scalars['Int'];
  valueInPercent: Scalars['Float'];
};

export type DocumentAcademicDocumentation = {
  __typename?: 'DocumentAcademicDocumentation';
  /** Lista os históricos finais */
  ChildDocuments: Array<DocumentFinalAcademicTranscript>;
  ChildRevokedDocumentList: Array<DocumentAcademicDocumentation>;
  /** View for search */
  DocumentAcademicDocumentationSearchView?: Maybe<DocumentAcademicDocumentationSearchView>;
  DocumentBase: DocumentBase;
  LinkedDegreeList: Array<DocumentDegree>;
  ParentRevokedDocument?: Maybe<DocumentAcademicDocumentation>;
  documentBaseId: Scalars['String'];
  parentRevokedDocumentId?: Maybe<Scalars['String']>;
  searchCPF: Scalars['String'];
  searchCourse: Scalars['String'];
  searchEmecCode: Scalars['String'];
  searchStudentName: Scalars['String'];
  /** Esse status é transformado */
  status: DocumentAcademicDocumentationStatus;
  type: DocumentAcademicDocumentationType;
  validationAttempts: Scalars['Int'];
};


export type DocumentAcademicDocumentationChildRevokedDocumentListArgs = {
  cursor?: Maybe<DocumentAcademicDocumentationWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentAcademicDocumentationScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentAcademicDocumentationOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentAcademicDocumentationWhereInput>;
};


export type DocumentAcademicDocumentationLinkedDegreeListArgs = {
  cursor?: Maybe<DocumentDegreeWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentDegreeScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentDegreeOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentDegreeWhereInput>;
};

export type DocumentAcademicDocumentationAvgOrderByAggregateInput = {
  validationAttempts?: Maybe<SortOrder>;
};

export type DocumentAcademicDocumentationCountOrderByAggregateInput = {
  documentBaseId?: Maybe<SortOrder>;
  parentRevokedDocumentId?: Maybe<SortOrder>;
  searchCPF?: Maybe<SortOrder>;
  searchCourse?: Maybe<SortOrder>;
  searchEmecCode?: Maybe<SortOrder>;
  searchStudentName?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  validationAttempts?: Maybe<SortOrder>;
};

export type DocumentAcademicDocumentationCreateInput = {
  ChildDocuments?: Maybe<DocumentFinalAcademicTranscriptCreateNestedManyWithoutParentDocumentInput>;
  ChildRevokedDocumentList?: Maybe<DocumentAcademicDocumentationCreateNestedManyWithoutParentRevokedDocumentInput>;
  DocumentAcademicDocumentationSearchView?: Maybe<DocumentAcademicDocumentationSearchViewCreateNestedOneWithoutDocumentAcademicDocumentationInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentAcademicDocumentationInput;
  LinkedDegreeList?: Maybe<DocumentDegreeCreateNestedManyWithoutParentAcademicDocumentationInput>;
  ParentRevokedDocument?: Maybe<DocumentAcademicDocumentationCreateNestedOneWithoutChildRevokedDocumentListInput>;
  searchCPF?: Maybe<Scalars['String']>;
  searchCourse?: Maybe<Scalars['String']>;
  searchEmecCode?: Maybe<Scalars['String']>;
  searchStudentName?: Maybe<Scalars['String']>;
  status?: Maybe<DocumentAcademicDocumentationStatus>;
  type?: Maybe<DocumentAcademicDocumentationType>;
  validationAttempts?: Maybe<Scalars['Int']>;
};

export type DocumentAcademicDocumentationCreateManyInput = {
  documentBaseId: Scalars['String'];
  parentRevokedDocumentId?: Maybe<Scalars['String']>;
  searchCPF?: Maybe<Scalars['String']>;
  searchCourse?: Maybe<Scalars['String']>;
  searchEmecCode?: Maybe<Scalars['String']>;
  searchStudentName?: Maybe<Scalars['String']>;
  status?: Maybe<DocumentAcademicDocumentationStatus>;
  type?: Maybe<DocumentAcademicDocumentationType>;
  validationAttempts?: Maybe<Scalars['Int']>;
};

export type DocumentAcademicDocumentationCreateManyParentRevokedDocumentInput = {
  documentBaseId: Scalars['String'];
  searchCPF?: Maybe<Scalars['String']>;
  searchCourse?: Maybe<Scalars['String']>;
  searchEmecCode?: Maybe<Scalars['String']>;
  searchStudentName?: Maybe<Scalars['String']>;
  status?: Maybe<DocumentAcademicDocumentationStatus>;
  type?: Maybe<DocumentAcademicDocumentationType>;
  validationAttempts?: Maybe<Scalars['Int']>;
};

export type DocumentAcademicDocumentationCreateManyParentRevokedDocumentInputEnvelope = {
  data: Array<DocumentAcademicDocumentationCreateManyParentRevokedDocumentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentAcademicDocumentationCreateNestedManyWithoutParentRevokedDocumentInput = {
  connect?: Maybe<Array<DocumentAcademicDocumentationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentAcademicDocumentationCreateOrConnectWithoutParentRevokedDocumentInput>>;
  create?: Maybe<Array<DocumentAcademicDocumentationCreateWithoutParentRevokedDocumentInput>>;
  createMany?: Maybe<DocumentAcademicDocumentationCreateManyParentRevokedDocumentInputEnvelope>;
};

export type DocumentAcademicDocumentationCreateNestedOneWithoutChildDocumentsInput = {
  connect?: Maybe<DocumentAcademicDocumentationWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentAcademicDocumentationCreateOrConnectWithoutChildDocumentsInput>;
  create?: Maybe<DocumentAcademicDocumentationCreateWithoutChildDocumentsInput>;
};

export type DocumentAcademicDocumentationCreateNestedOneWithoutChildRevokedDocumentListInput = {
  connect?: Maybe<DocumentAcademicDocumentationWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentAcademicDocumentationCreateOrConnectWithoutChildRevokedDocumentListInput>;
  create?: Maybe<DocumentAcademicDocumentationCreateWithoutChildRevokedDocumentListInput>;
};

export type DocumentAcademicDocumentationCreateNestedOneWithoutDocumentAcademicDocumentationSearchViewInput = {
  connect?: Maybe<DocumentAcademicDocumentationWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentAcademicDocumentationCreateOrConnectWithoutDocumentAcademicDocumentationSearchViewInput>;
  create?: Maybe<DocumentAcademicDocumentationCreateWithoutDocumentAcademicDocumentationSearchViewInput>;
};

export type DocumentAcademicDocumentationCreateNestedOneWithoutDocumentBaseInput = {
  connect?: Maybe<DocumentAcademicDocumentationWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentAcademicDocumentationCreateOrConnectWithoutDocumentBaseInput>;
  create?: Maybe<DocumentAcademicDocumentationCreateWithoutDocumentBaseInput>;
};

export type DocumentAcademicDocumentationCreateNestedOneWithoutLinkedDegreeListInput = {
  connect?: Maybe<DocumentAcademicDocumentationWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentAcademicDocumentationCreateOrConnectWithoutLinkedDegreeListInput>;
  create?: Maybe<DocumentAcademicDocumentationCreateWithoutLinkedDegreeListInput>;
};

export type DocumentAcademicDocumentationCreateOrConnectWithoutChildDocumentsInput = {
  create: DocumentAcademicDocumentationCreateWithoutChildDocumentsInput;
  where: DocumentAcademicDocumentationWhereUniqueInput;
};

export type DocumentAcademicDocumentationCreateOrConnectWithoutChildRevokedDocumentListInput = {
  create: DocumentAcademicDocumentationCreateWithoutChildRevokedDocumentListInput;
  where: DocumentAcademicDocumentationWhereUniqueInput;
};

export type DocumentAcademicDocumentationCreateOrConnectWithoutDocumentAcademicDocumentationSearchViewInput = {
  create: DocumentAcademicDocumentationCreateWithoutDocumentAcademicDocumentationSearchViewInput;
  where: DocumentAcademicDocumentationWhereUniqueInput;
};

export type DocumentAcademicDocumentationCreateOrConnectWithoutDocumentBaseInput = {
  create: DocumentAcademicDocumentationCreateWithoutDocumentBaseInput;
  where: DocumentAcademicDocumentationWhereUniqueInput;
};

export type DocumentAcademicDocumentationCreateOrConnectWithoutLinkedDegreeListInput = {
  create: DocumentAcademicDocumentationCreateWithoutLinkedDegreeListInput;
  where: DocumentAcademicDocumentationWhereUniqueInput;
};

export type DocumentAcademicDocumentationCreateOrConnectWithoutParentRevokedDocumentInput = {
  create: DocumentAcademicDocumentationCreateWithoutParentRevokedDocumentInput;
  where: DocumentAcademicDocumentationWhereUniqueInput;
};

export type DocumentAcademicDocumentationCreateWithoutChildDocumentsInput = {
  ChildRevokedDocumentList?: Maybe<DocumentAcademicDocumentationCreateNestedManyWithoutParentRevokedDocumentInput>;
  DocumentAcademicDocumentationSearchView?: Maybe<DocumentAcademicDocumentationSearchViewCreateNestedOneWithoutDocumentAcademicDocumentationInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentAcademicDocumentationInput;
  LinkedDegreeList?: Maybe<DocumentDegreeCreateNestedManyWithoutParentAcademicDocumentationInput>;
  ParentRevokedDocument?: Maybe<DocumentAcademicDocumentationCreateNestedOneWithoutChildRevokedDocumentListInput>;
  searchCPF?: Maybe<Scalars['String']>;
  searchCourse?: Maybe<Scalars['String']>;
  searchEmecCode?: Maybe<Scalars['String']>;
  searchStudentName?: Maybe<Scalars['String']>;
  status?: Maybe<DocumentAcademicDocumentationStatus>;
  type?: Maybe<DocumentAcademicDocumentationType>;
  validationAttempts?: Maybe<Scalars['Int']>;
};

export type DocumentAcademicDocumentationCreateWithoutChildRevokedDocumentListInput = {
  ChildDocuments?: Maybe<DocumentFinalAcademicTranscriptCreateNestedManyWithoutParentDocumentInput>;
  DocumentAcademicDocumentationSearchView?: Maybe<DocumentAcademicDocumentationSearchViewCreateNestedOneWithoutDocumentAcademicDocumentationInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentAcademicDocumentationInput;
  LinkedDegreeList?: Maybe<DocumentDegreeCreateNestedManyWithoutParentAcademicDocumentationInput>;
  ParentRevokedDocument?: Maybe<DocumentAcademicDocumentationCreateNestedOneWithoutChildRevokedDocumentListInput>;
  searchCPF?: Maybe<Scalars['String']>;
  searchCourse?: Maybe<Scalars['String']>;
  searchEmecCode?: Maybe<Scalars['String']>;
  searchStudentName?: Maybe<Scalars['String']>;
  status?: Maybe<DocumentAcademicDocumentationStatus>;
  type?: Maybe<DocumentAcademicDocumentationType>;
  validationAttempts?: Maybe<Scalars['Int']>;
};

export type DocumentAcademicDocumentationCreateWithoutDocumentAcademicDocumentationSearchViewInput = {
  ChildDocuments?: Maybe<DocumentFinalAcademicTranscriptCreateNestedManyWithoutParentDocumentInput>;
  ChildRevokedDocumentList?: Maybe<DocumentAcademicDocumentationCreateNestedManyWithoutParentRevokedDocumentInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentAcademicDocumentationInput;
  LinkedDegreeList?: Maybe<DocumentDegreeCreateNestedManyWithoutParentAcademicDocumentationInput>;
  ParentRevokedDocument?: Maybe<DocumentAcademicDocumentationCreateNestedOneWithoutChildRevokedDocumentListInput>;
  searchCPF?: Maybe<Scalars['String']>;
  searchCourse?: Maybe<Scalars['String']>;
  searchEmecCode?: Maybe<Scalars['String']>;
  searchStudentName?: Maybe<Scalars['String']>;
  status?: Maybe<DocumentAcademicDocumentationStatus>;
  type?: Maybe<DocumentAcademicDocumentationType>;
  validationAttempts?: Maybe<Scalars['Int']>;
};

export type DocumentAcademicDocumentationCreateWithoutDocumentBaseInput = {
  ChildDocuments?: Maybe<DocumentFinalAcademicTranscriptCreateNestedManyWithoutParentDocumentInput>;
  ChildRevokedDocumentList?: Maybe<DocumentAcademicDocumentationCreateNestedManyWithoutParentRevokedDocumentInput>;
  DocumentAcademicDocumentationSearchView?: Maybe<DocumentAcademicDocumentationSearchViewCreateNestedOneWithoutDocumentAcademicDocumentationInput>;
  LinkedDegreeList?: Maybe<DocumentDegreeCreateNestedManyWithoutParentAcademicDocumentationInput>;
  ParentRevokedDocument?: Maybe<DocumentAcademicDocumentationCreateNestedOneWithoutChildRevokedDocumentListInput>;
  searchCPF?: Maybe<Scalars['String']>;
  searchCourse?: Maybe<Scalars['String']>;
  searchEmecCode?: Maybe<Scalars['String']>;
  searchStudentName?: Maybe<Scalars['String']>;
  status?: Maybe<DocumentAcademicDocumentationStatus>;
  type?: Maybe<DocumentAcademicDocumentationType>;
  validationAttempts?: Maybe<Scalars['Int']>;
};

export type DocumentAcademicDocumentationCreateWithoutLinkedDegreeListInput = {
  ChildDocuments?: Maybe<DocumentFinalAcademicTranscriptCreateNestedManyWithoutParentDocumentInput>;
  ChildRevokedDocumentList?: Maybe<DocumentAcademicDocumentationCreateNestedManyWithoutParentRevokedDocumentInput>;
  DocumentAcademicDocumentationSearchView?: Maybe<DocumentAcademicDocumentationSearchViewCreateNestedOneWithoutDocumentAcademicDocumentationInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentAcademicDocumentationInput;
  ParentRevokedDocument?: Maybe<DocumentAcademicDocumentationCreateNestedOneWithoutChildRevokedDocumentListInput>;
  searchCPF?: Maybe<Scalars['String']>;
  searchCourse?: Maybe<Scalars['String']>;
  searchEmecCode?: Maybe<Scalars['String']>;
  searchStudentName?: Maybe<Scalars['String']>;
  status?: Maybe<DocumentAcademicDocumentationStatus>;
  type?: Maybe<DocumentAcademicDocumentationType>;
  validationAttempts?: Maybe<Scalars['Int']>;
};

export type DocumentAcademicDocumentationCreateWithoutParentRevokedDocumentInput = {
  ChildDocuments?: Maybe<DocumentFinalAcademicTranscriptCreateNestedManyWithoutParentDocumentInput>;
  ChildRevokedDocumentList?: Maybe<DocumentAcademicDocumentationCreateNestedManyWithoutParentRevokedDocumentInput>;
  DocumentAcademicDocumentationSearchView?: Maybe<DocumentAcademicDocumentationSearchViewCreateNestedOneWithoutDocumentAcademicDocumentationInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentAcademicDocumentationInput;
  LinkedDegreeList?: Maybe<DocumentDegreeCreateNestedManyWithoutParentAcademicDocumentationInput>;
  searchCPF?: Maybe<Scalars['String']>;
  searchCourse?: Maybe<Scalars['String']>;
  searchEmecCode?: Maybe<Scalars['String']>;
  searchStudentName?: Maybe<Scalars['String']>;
  status?: Maybe<DocumentAcademicDocumentationStatus>;
  type?: Maybe<DocumentAcademicDocumentationType>;
  validationAttempts?: Maybe<Scalars['Int']>;
};

export enum DocumentAcademicDocumentationCreationType {
  ApiExternalSign = 'API_EXTERNAL_SIGN',
  ApiJson = 'API_JSON',
  ApiXml = 'API_XML',
  Form = 'FORM',
  GenerateXml = 'GENERATE_XML'
}

export type DocumentAcademicDocumentationListRelationFilter = {
  every?: Maybe<DocumentAcademicDocumentationWhereInput>;
  none?: Maybe<DocumentAcademicDocumentationWhereInput>;
  some?: Maybe<DocumentAcademicDocumentationWhereInput>;
};

export type DocumentAcademicDocumentationMaxOrderByAggregateInput = {
  documentBaseId?: Maybe<SortOrder>;
  parentRevokedDocumentId?: Maybe<SortOrder>;
  searchCPF?: Maybe<SortOrder>;
  searchCourse?: Maybe<SortOrder>;
  searchEmecCode?: Maybe<SortOrder>;
  searchStudentName?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  validationAttempts?: Maybe<SortOrder>;
};

export type DocumentAcademicDocumentationMinOrderByAggregateInput = {
  documentBaseId?: Maybe<SortOrder>;
  parentRevokedDocumentId?: Maybe<SortOrder>;
  searchCPF?: Maybe<SortOrder>;
  searchCourse?: Maybe<SortOrder>;
  searchEmecCode?: Maybe<SortOrder>;
  searchStudentName?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  validationAttempts?: Maybe<SortOrder>;
};

export type DocumentAcademicDocumentationNullableRelationFilter = {
  is?: Maybe<DocumentAcademicDocumentationWhereInput>;
  isNot?: Maybe<DocumentAcademicDocumentationWhereInput>;
};

export type DocumentAcademicDocumentationOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type DocumentAcademicDocumentationOrderByWithAggregationInput = {
  _avg?: Maybe<DocumentAcademicDocumentationAvgOrderByAggregateInput>;
  _count?: Maybe<DocumentAcademicDocumentationCountOrderByAggregateInput>;
  _max?: Maybe<DocumentAcademicDocumentationMaxOrderByAggregateInput>;
  _min?: Maybe<DocumentAcademicDocumentationMinOrderByAggregateInput>;
  _sum?: Maybe<DocumentAcademicDocumentationSumOrderByAggregateInput>;
  documentBaseId?: Maybe<SortOrder>;
  parentRevokedDocumentId?: Maybe<SortOrder>;
  searchCPF?: Maybe<SortOrder>;
  searchCourse?: Maybe<SortOrder>;
  searchEmecCode?: Maybe<SortOrder>;
  searchStudentName?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  validationAttempts?: Maybe<SortOrder>;
};

export type DocumentAcademicDocumentationOrderByWithRelationInput = {
  ChildDocuments?: Maybe<DocumentFinalAcademicTranscriptOrderByRelationAggregateInput>;
  ChildRevokedDocumentList?: Maybe<DocumentAcademicDocumentationOrderByRelationAggregateInput>;
  DocumentAcademicDocumentationSearchView?: Maybe<DocumentAcademicDocumentationSearchViewOrderByWithRelationInput>;
  DocumentBase?: Maybe<DocumentBaseOrderByWithRelationInput>;
  LinkedDegreeList?: Maybe<DocumentDegreeOrderByRelationAggregateInput>;
  ParentRevokedDocument?: Maybe<DocumentAcademicDocumentationOrderByWithRelationInput>;
  documentBaseId?: Maybe<SortOrder>;
  parentRevokedDocumentId?: Maybe<SortOrder>;
  searchCPF?: Maybe<SortOrder>;
  searchCourse?: Maybe<SortOrder>;
  searchEmecCode?: Maybe<SortOrder>;
  searchStudentName?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  validationAttempts?: Maybe<SortOrder>;
};

export type DocumentAcademicDocumentationRelationFilter = {
  is?: Maybe<DocumentAcademicDocumentationWhereInput>;
  isNot?: Maybe<DocumentAcademicDocumentationWhereInput>;
};

export enum DocumentAcademicDocumentationScalarFieldEnum {
  DocumentBaseId = 'documentBaseId',
  ParentRevokedDocumentId = 'parentRevokedDocumentId',
  SearchCpf = 'searchCPF',
  SearchCourse = 'searchCourse',
  SearchEmecCode = 'searchEmecCode',
  SearchStudentName = 'searchStudentName',
  Status = 'status',
  Type = 'type',
  ValidationAttempts = 'validationAttempts'
}

export type DocumentAcademicDocumentationScalarWhereInput = {
  AND?: Maybe<Array<DocumentAcademicDocumentationScalarWhereInput>>;
  NOT?: Maybe<Array<DocumentAcademicDocumentationScalarWhereInput>>;
  OR?: Maybe<Array<DocumentAcademicDocumentationScalarWhereInput>>;
  documentBaseId?: Maybe<StringFilter>;
  parentRevokedDocumentId?: Maybe<StringNullableFilter>;
  searchCPF?: Maybe<StringFilter>;
  searchCourse?: Maybe<StringFilter>;
  searchEmecCode?: Maybe<StringFilter>;
  searchStudentName?: Maybe<StringFilter>;
  status?: Maybe<EnumDocumentAcademicDocumentationStatusFilter>;
  type?: Maybe<EnumDocumentAcademicDocumentationTypeFilter>;
  validationAttempts?: Maybe<IntFilter>;
};

export type DocumentAcademicDocumentationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<DocumentAcademicDocumentationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<DocumentAcademicDocumentationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<DocumentAcademicDocumentationScalarWhereWithAggregatesInput>>;
  documentBaseId?: Maybe<StringWithAggregatesFilter>;
  parentRevokedDocumentId?: Maybe<StringNullableWithAggregatesFilter>;
  searchCPF?: Maybe<StringWithAggregatesFilter>;
  searchCourse?: Maybe<StringWithAggregatesFilter>;
  searchEmecCode?: Maybe<StringWithAggregatesFilter>;
  searchStudentName?: Maybe<StringWithAggregatesFilter>;
  status?: Maybe<EnumDocumentAcademicDocumentationStatusWithAggregatesFilter>;
  type?: Maybe<EnumDocumentAcademicDocumentationTypeWithAggregatesFilter>;
  validationAttempts?: Maybe<IntWithAggregatesFilter>;
};

export type DocumentAcademicDocumentationSearchView = {
  __typename?: 'DocumentAcademicDocumentationSearchView';
  DocumentAcademicDocumentation: DocumentAcademicDocumentation;
  documentBaseId: Scalars['String'];
  normalizedSearchCPF: Scalars['String'];
  normalizedSearchCourse: Scalars['String'];
  normalizedSearchEmecCode: Scalars['String'];
  normalizedSearchStudentName: Scalars['String'];
};

export type DocumentAcademicDocumentationSearchViewCountOrderByAggregateInput = {
  documentBaseId?: Maybe<SortOrder>;
  normalizedSearchCPF?: Maybe<SortOrder>;
  normalizedSearchCourse?: Maybe<SortOrder>;
  normalizedSearchEmecCode?: Maybe<SortOrder>;
  normalizedSearchStudentName?: Maybe<SortOrder>;
};

export type DocumentAcademicDocumentationSearchViewCreateInput = {
  DocumentAcademicDocumentation: DocumentAcademicDocumentationCreateNestedOneWithoutDocumentAcademicDocumentationSearchViewInput;
  normalizedSearchCPF: Scalars['String'];
  normalizedSearchCourse: Scalars['String'];
  normalizedSearchEmecCode: Scalars['String'];
  normalizedSearchStudentName: Scalars['String'];
};

export type DocumentAcademicDocumentationSearchViewCreateManyInput = {
  documentBaseId: Scalars['String'];
  normalizedSearchCPF: Scalars['String'];
  normalizedSearchCourse: Scalars['String'];
  normalizedSearchEmecCode: Scalars['String'];
  normalizedSearchStudentName: Scalars['String'];
};

export type DocumentAcademicDocumentationSearchViewCreateNestedOneWithoutDocumentAcademicDocumentationInput = {
  connect?: Maybe<DocumentAcademicDocumentationSearchViewWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentAcademicDocumentationSearchViewCreateOrConnectWithoutDocumentAcademicDocumentationInput>;
  create?: Maybe<DocumentAcademicDocumentationSearchViewCreateWithoutDocumentAcademicDocumentationInput>;
};

export type DocumentAcademicDocumentationSearchViewCreateOrConnectWithoutDocumentAcademicDocumentationInput = {
  create: DocumentAcademicDocumentationSearchViewCreateWithoutDocumentAcademicDocumentationInput;
  where: DocumentAcademicDocumentationSearchViewWhereUniqueInput;
};

export type DocumentAcademicDocumentationSearchViewCreateWithoutDocumentAcademicDocumentationInput = {
  normalizedSearchCPF: Scalars['String'];
  normalizedSearchCourse: Scalars['String'];
  normalizedSearchEmecCode: Scalars['String'];
  normalizedSearchStudentName: Scalars['String'];
};

export type DocumentAcademicDocumentationSearchViewMaxOrderByAggregateInput = {
  documentBaseId?: Maybe<SortOrder>;
  normalizedSearchCPF?: Maybe<SortOrder>;
  normalizedSearchCourse?: Maybe<SortOrder>;
  normalizedSearchEmecCode?: Maybe<SortOrder>;
  normalizedSearchStudentName?: Maybe<SortOrder>;
};

export type DocumentAcademicDocumentationSearchViewMinOrderByAggregateInput = {
  documentBaseId?: Maybe<SortOrder>;
  normalizedSearchCPF?: Maybe<SortOrder>;
  normalizedSearchCourse?: Maybe<SortOrder>;
  normalizedSearchEmecCode?: Maybe<SortOrder>;
  normalizedSearchStudentName?: Maybe<SortOrder>;
};

export type DocumentAcademicDocumentationSearchViewNullableRelationFilter = {
  is?: Maybe<DocumentAcademicDocumentationSearchViewWhereInput>;
  isNot?: Maybe<DocumentAcademicDocumentationSearchViewWhereInput>;
};

export type DocumentAcademicDocumentationSearchViewOrderByWithAggregationInput = {
  _count?: Maybe<DocumentAcademicDocumentationSearchViewCountOrderByAggregateInput>;
  _max?: Maybe<DocumentAcademicDocumentationSearchViewMaxOrderByAggregateInput>;
  _min?: Maybe<DocumentAcademicDocumentationSearchViewMinOrderByAggregateInput>;
  documentBaseId?: Maybe<SortOrder>;
  normalizedSearchCPF?: Maybe<SortOrder>;
  normalizedSearchCourse?: Maybe<SortOrder>;
  normalizedSearchEmecCode?: Maybe<SortOrder>;
  normalizedSearchStudentName?: Maybe<SortOrder>;
};

export type DocumentAcademicDocumentationSearchViewOrderByWithRelationInput = {
  DocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationOrderByWithRelationInput>;
  documentBaseId?: Maybe<SortOrder>;
  normalizedSearchCPF?: Maybe<SortOrder>;
  normalizedSearchCourse?: Maybe<SortOrder>;
  normalizedSearchEmecCode?: Maybe<SortOrder>;
  normalizedSearchStudentName?: Maybe<SortOrder>;
};

export enum DocumentAcademicDocumentationSearchViewScalarFieldEnum {
  DocumentBaseId = 'documentBaseId',
  NormalizedSearchCpf = 'normalizedSearchCPF',
  NormalizedSearchCourse = 'normalizedSearchCourse',
  NormalizedSearchEmecCode = 'normalizedSearchEmecCode',
  NormalizedSearchStudentName = 'normalizedSearchStudentName'
}

export type DocumentAcademicDocumentationSearchViewScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<DocumentAcademicDocumentationSearchViewScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<DocumentAcademicDocumentationSearchViewScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<DocumentAcademicDocumentationSearchViewScalarWhereWithAggregatesInput>>;
  documentBaseId?: Maybe<StringWithAggregatesFilter>;
  normalizedSearchCPF?: Maybe<StringWithAggregatesFilter>;
  normalizedSearchCourse?: Maybe<StringWithAggregatesFilter>;
  normalizedSearchEmecCode?: Maybe<StringWithAggregatesFilter>;
  normalizedSearchStudentName?: Maybe<StringWithAggregatesFilter>;
};

export type DocumentAcademicDocumentationSearchViewUpdateInput = {
  DocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationUpdateOneRequiredWithoutDocumentAcademicDocumentationSearchViewNestedInput>;
  normalizedSearchCPF?: Maybe<StringFieldUpdateOperationsInput>;
  normalizedSearchCourse?: Maybe<StringFieldUpdateOperationsInput>;
  normalizedSearchEmecCode?: Maybe<StringFieldUpdateOperationsInput>;
  normalizedSearchStudentName?: Maybe<StringFieldUpdateOperationsInput>;
};

export type DocumentAcademicDocumentationSearchViewUpdateManyMutationInput = {
  normalizedSearchCPF?: Maybe<StringFieldUpdateOperationsInput>;
  normalizedSearchCourse?: Maybe<StringFieldUpdateOperationsInput>;
  normalizedSearchEmecCode?: Maybe<StringFieldUpdateOperationsInput>;
  normalizedSearchStudentName?: Maybe<StringFieldUpdateOperationsInput>;
};

export type DocumentAcademicDocumentationSearchViewUpdateOneWithoutDocumentAcademicDocumentationNestedInput = {
  connect?: Maybe<DocumentAcademicDocumentationSearchViewWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentAcademicDocumentationSearchViewCreateOrConnectWithoutDocumentAcademicDocumentationInput>;
  create?: Maybe<DocumentAcademicDocumentationSearchViewCreateWithoutDocumentAcademicDocumentationInput>;
  delete?: Maybe<DocumentAcademicDocumentationSearchViewWhereInput>;
  disconnect?: Maybe<DocumentAcademicDocumentationSearchViewWhereInput>;
  update?: Maybe<DocumentAcademicDocumentationSearchViewUpdateToOneWithWhereWithoutDocumentAcademicDocumentationInput>;
  upsert?: Maybe<DocumentAcademicDocumentationSearchViewUpsertWithoutDocumentAcademicDocumentationInput>;
};

export type DocumentAcademicDocumentationSearchViewUpdateToOneWithWhereWithoutDocumentAcademicDocumentationInput = {
  data: DocumentAcademicDocumentationSearchViewUpdateWithoutDocumentAcademicDocumentationInput;
  where?: Maybe<DocumentAcademicDocumentationSearchViewWhereInput>;
};

export type DocumentAcademicDocumentationSearchViewUpdateWithoutDocumentAcademicDocumentationInput = {
  normalizedSearchCPF?: Maybe<StringFieldUpdateOperationsInput>;
  normalizedSearchCourse?: Maybe<StringFieldUpdateOperationsInput>;
  normalizedSearchEmecCode?: Maybe<StringFieldUpdateOperationsInput>;
  normalizedSearchStudentName?: Maybe<StringFieldUpdateOperationsInput>;
};

export type DocumentAcademicDocumentationSearchViewUpsertWithoutDocumentAcademicDocumentationInput = {
  create: DocumentAcademicDocumentationSearchViewCreateWithoutDocumentAcademicDocumentationInput;
  update: DocumentAcademicDocumentationSearchViewUpdateWithoutDocumentAcademicDocumentationInput;
  where?: Maybe<DocumentAcademicDocumentationSearchViewWhereInput>;
};

export type DocumentAcademicDocumentationSearchViewWhereInput = {
  AND?: Maybe<Array<DocumentAcademicDocumentationSearchViewWhereInput>>;
  DocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationWhereInput>;
  NOT?: Maybe<Array<DocumentAcademicDocumentationSearchViewWhereInput>>;
  OR?: Maybe<Array<DocumentAcademicDocumentationSearchViewWhereInput>>;
  documentBaseId?: Maybe<StringFilter>;
  normalizedSearchCPF?: Maybe<StringFilter>;
  normalizedSearchCourse?: Maybe<StringFilter>;
  normalizedSearchEmecCode?: Maybe<StringFilter>;
  normalizedSearchStudentName?: Maybe<StringFilter>;
};

export type DocumentAcademicDocumentationSearchViewWhereUniqueInput = {
  AND?: Maybe<Array<DocumentAcademicDocumentationSearchViewWhereInput>>;
  DocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationWhereInput>;
  NOT?: Maybe<Array<DocumentAcademicDocumentationSearchViewWhereInput>>;
  OR?: Maybe<Array<DocumentAcademicDocumentationSearchViewWhereInput>>;
  documentBaseId?: Maybe<Scalars['String']>;
  normalizedSearchCPF?: Maybe<StringFilter>;
  normalizedSearchCourse?: Maybe<StringFilter>;
  normalizedSearchEmecCode?: Maybe<StringFilter>;
  normalizedSearchStudentName?: Maybe<StringFilter>;
};

export enum DocumentAcademicDocumentationStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  FastValidation = 'FAST_VALIDATION',
  InCorrection = 'IN_CORRECTION',
  InSignature = 'IN_SIGNATURE',
  Issued = 'ISSUED',
  PendingReview = 'PENDING_REVIEW',
  Revoked = 'REVOKED',
  ValidationImpossibleToValidate = 'VALIDATION_IMPOSSIBLE_TO_VALIDATE',
  ValidationIndeterminated = 'VALIDATION_INDETERMINATED',
  ValidationInvalid = 'VALIDATION_INVALID',
  ValidationInValidation = 'VALIDATION_IN_VALIDATION'
}

export type DocumentAcademicDocumentationSumOrderByAggregateInput = {
  validationAttempts?: Maybe<SortOrder>;
};

export enum DocumentAcademicDocumentationType {
  CourtDecision = 'COURT_DECISION',
  FirstCopy = 'FIRST_COPY',
  SecondCopy = 'SECOND_COPY'
}

export type DocumentAcademicDocumentationUpdateInput = {
  ChildDocuments?: Maybe<DocumentFinalAcademicTranscriptUpdateManyWithoutParentDocumentNestedInput>;
  ChildRevokedDocumentList?: Maybe<DocumentAcademicDocumentationUpdateManyWithoutParentRevokedDocumentNestedInput>;
  DocumentAcademicDocumentationSearchView?: Maybe<DocumentAcademicDocumentationSearchViewUpdateOneWithoutDocumentAcademicDocumentationNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateOneRequiredWithoutDocumentAcademicDocumentationNestedInput>;
  LinkedDegreeList?: Maybe<DocumentDegreeUpdateManyWithoutParentAcademicDocumentationNestedInput>;
  ParentRevokedDocument?: Maybe<DocumentAcademicDocumentationUpdateOneWithoutChildRevokedDocumentListNestedInput>;
  searchCPF?: Maybe<StringFieldUpdateOperationsInput>;
  searchCourse?: Maybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: Maybe<StringFieldUpdateOperationsInput>;
  searchStudentName?: Maybe<StringFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentAcademicDocumentationStatusFieldUpdateOperationsInput>;
  type?: Maybe<EnumDocumentAcademicDocumentationTypeFieldUpdateOperationsInput>;
  validationAttempts?: Maybe<IntFieldUpdateOperationsInput>;
};

export type DocumentAcademicDocumentationUpdateManyMutationInput = {
  searchCPF?: Maybe<StringFieldUpdateOperationsInput>;
  searchCourse?: Maybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: Maybe<StringFieldUpdateOperationsInput>;
  searchStudentName?: Maybe<StringFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentAcademicDocumentationStatusFieldUpdateOperationsInput>;
  type?: Maybe<EnumDocumentAcademicDocumentationTypeFieldUpdateOperationsInput>;
  validationAttempts?: Maybe<IntFieldUpdateOperationsInput>;
};

export type DocumentAcademicDocumentationUpdateManyWithWhereWithoutParentRevokedDocumentInput = {
  data: DocumentAcademicDocumentationUpdateManyMutationInput;
  where: DocumentAcademicDocumentationScalarWhereInput;
};

export type DocumentAcademicDocumentationUpdateManyWithoutParentRevokedDocumentNestedInput = {
  connect?: Maybe<Array<DocumentAcademicDocumentationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentAcademicDocumentationCreateOrConnectWithoutParentRevokedDocumentInput>>;
  create?: Maybe<Array<DocumentAcademicDocumentationCreateWithoutParentRevokedDocumentInput>>;
  createMany?: Maybe<DocumentAcademicDocumentationCreateManyParentRevokedDocumentInputEnvelope>;
  delete?: Maybe<Array<DocumentAcademicDocumentationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentAcademicDocumentationScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentAcademicDocumentationWhereUniqueInput>>;
  set?: Maybe<Array<DocumentAcademicDocumentationWhereUniqueInput>>;
  update?: Maybe<Array<DocumentAcademicDocumentationUpdateWithWhereUniqueWithoutParentRevokedDocumentInput>>;
  updateMany?: Maybe<Array<DocumentAcademicDocumentationUpdateManyWithWhereWithoutParentRevokedDocumentInput>>;
  upsert?: Maybe<Array<DocumentAcademicDocumentationUpsertWithWhereUniqueWithoutParentRevokedDocumentInput>>;
};

export type DocumentAcademicDocumentationUpdateOneRequiredWithoutDocumentAcademicDocumentationSearchViewNestedInput = {
  connect?: Maybe<DocumentAcademicDocumentationWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentAcademicDocumentationCreateOrConnectWithoutDocumentAcademicDocumentationSearchViewInput>;
  create?: Maybe<DocumentAcademicDocumentationCreateWithoutDocumentAcademicDocumentationSearchViewInput>;
  update?: Maybe<DocumentAcademicDocumentationUpdateToOneWithWhereWithoutDocumentAcademicDocumentationSearchViewInput>;
  upsert?: Maybe<DocumentAcademicDocumentationUpsertWithoutDocumentAcademicDocumentationSearchViewInput>;
};

export type DocumentAcademicDocumentationUpdateOneWithoutChildDocumentsNestedInput = {
  connect?: Maybe<DocumentAcademicDocumentationWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentAcademicDocumentationCreateOrConnectWithoutChildDocumentsInput>;
  create?: Maybe<DocumentAcademicDocumentationCreateWithoutChildDocumentsInput>;
  delete?: Maybe<DocumentAcademicDocumentationWhereInput>;
  disconnect?: Maybe<DocumentAcademicDocumentationWhereInput>;
  update?: Maybe<DocumentAcademicDocumentationUpdateToOneWithWhereWithoutChildDocumentsInput>;
  upsert?: Maybe<DocumentAcademicDocumentationUpsertWithoutChildDocumentsInput>;
};

export type DocumentAcademicDocumentationUpdateOneWithoutChildRevokedDocumentListNestedInput = {
  connect?: Maybe<DocumentAcademicDocumentationWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentAcademicDocumentationCreateOrConnectWithoutChildRevokedDocumentListInput>;
  create?: Maybe<DocumentAcademicDocumentationCreateWithoutChildRevokedDocumentListInput>;
  delete?: Maybe<DocumentAcademicDocumentationWhereInput>;
  disconnect?: Maybe<DocumentAcademicDocumentationWhereInput>;
  update?: Maybe<DocumentAcademicDocumentationUpdateToOneWithWhereWithoutChildRevokedDocumentListInput>;
  upsert?: Maybe<DocumentAcademicDocumentationUpsertWithoutChildRevokedDocumentListInput>;
};

export type DocumentAcademicDocumentationUpdateOneWithoutDocumentBaseNestedInput = {
  connect?: Maybe<DocumentAcademicDocumentationWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentAcademicDocumentationCreateOrConnectWithoutDocumentBaseInput>;
  create?: Maybe<DocumentAcademicDocumentationCreateWithoutDocumentBaseInput>;
  delete?: Maybe<DocumentAcademicDocumentationWhereInput>;
  disconnect?: Maybe<DocumentAcademicDocumentationWhereInput>;
  update?: Maybe<DocumentAcademicDocumentationUpdateToOneWithWhereWithoutDocumentBaseInput>;
  upsert?: Maybe<DocumentAcademicDocumentationUpsertWithoutDocumentBaseInput>;
};

export type DocumentAcademicDocumentationUpdateOneWithoutLinkedDegreeListNestedInput = {
  connect?: Maybe<DocumentAcademicDocumentationWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentAcademicDocumentationCreateOrConnectWithoutLinkedDegreeListInput>;
  create?: Maybe<DocumentAcademicDocumentationCreateWithoutLinkedDegreeListInput>;
  delete?: Maybe<DocumentAcademicDocumentationWhereInput>;
  disconnect?: Maybe<DocumentAcademicDocumentationWhereInput>;
  update?: Maybe<DocumentAcademicDocumentationUpdateToOneWithWhereWithoutLinkedDegreeListInput>;
  upsert?: Maybe<DocumentAcademicDocumentationUpsertWithoutLinkedDegreeListInput>;
};

export type DocumentAcademicDocumentationUpdateToOneWithWhereWithoutChildDocumentsInput = {
  data: DocumentAcademicDocumentationUpdateWithoutChildDocumentsInput;
  where?: Maybe<DocumentAcademicDocumentationWhereInput>;
};

export type DocumentAcademicDocumentationUpdateToOneWithWhereWithoutChildRevokedDocumentListInput = {
  data: DocumentAcademicDocumentationUpdateWithoutChildRevokedDocumentListInput;
  where?: Maybe<DocumentAcademicDocumentationWhereInput>;
};

export type DocumentAcademicDocumentationUpdateToOneWithWhereWithoutDocumentAcademicDocumentationSearchViewInput = {
  data: DocumentAcademicDocumentationUpdateWithoutDocumentAcademicDocumentationSearchViewInput;
  where?: Maybe<DocumentAcademicDocumentationWhereInput>;
};

export type DocumentAcademicDocumentationUpdateToOneWithWhereWithoutDocumentBaseInput = {
  data: DocumentAcademicDocumentationUpdateWithoutDocumentBaseInput;
  where?: Maybe<DocumentAcademicDocumentationWhereInput>;
};

export type DocumentAcademicDocumentationUpdateToOneWithWhereWithoutLinkedDegreeListInput = {
  data: DocumentAcademicDocumentationUpdateWithoutLinkedDegreeListInput;
  where?: Maybe<DocumentAcademicDocumentationWhereInput>;
};

export type DocumentAcademicDocumentationUpdateWithWhereUniqueWithoutParentRevokedDocumentInput = {
  data: DocumentAcademicDocumentationUpdateWithoutParentRevokedDocumentInput;
  where: DocumentAcademicDocumentationWhereUniqueInput;
};

export type DocumentAcademicDocumentationUpdateWithoutChildDocumentsInput = {
  ChildRevokedDocumentList?: Maybe<DocumentAcademicDocumentationUpdateManyWithoutParentRevokedDocumentNestedInput>;
  DocumentAcademicDocumentationSearchView?: Maybe<DocumentAcademicDocumentationSearchViewUpdateOneWithoutDocumentAcademicDocumentationNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateOneRequiredWithoutDocumentAcademicDocumentationNestedInput>;
  LinkedDegreeList?: Maybe<DocumentDegreeUpdateManyWithoutParentAcademicDocumentationNestedInput>;
  ParentRevokedDocument?: Maybe<DocumentAcademicDocumentationUpdateOneWithoutChildRevokedDocumentListNestedInput>;
  searchCPF?: Maybe<StringFieldUpdateOperationsInput>;
  searchCourse?: Maybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: Maybe<StringFieldUpdateOperationsInput>;
  searchStudentName?: Maybe<StringFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentAcademicDocumentationStatusFieldUpdateOperationsInput>;
  type?: Maybe<EnumDocumentAcademicDocumentationTypeFieldUpdateOperationsInput>;
  validationAttempts?: Maybe<IntFieldUpdateOperationsInput>;
};

export type DocumentAcademicDocumentationUpdateWithoutChildRevokedDocumentListInput = {
  ChildDocuments?: Maybe<DocumentFinalAcademicTranscriptUpdateManyWithoutParentDocumentNestedInput>;
  DocumentAcademicDocumentationSearchView?: Maybe<DocumentAcademicDocumentationSearchViewUpdateOneWithoutDocumentAcademicDocumentationNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateOneRequiredWithoutDocumentAcademicDocumentationNestedInput>;
  LinkedDegreeList?: Maybe<DocumentDegreeUpdateManyWithoutParentAcademicDocumentationNestedInput>;
  ParentRevokedDocument?: Maybe<DocumentAcademicDocumentationUpdateOneWithoutChildRevokedDocumentListNestedInput>;
  searchCPF?: Maybe<StringFieldUpdateOperationsInput>;
  searchCourse?: Maybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: Maybe<StringFieldUpdateOperationsInput>;
  searchStudentName?: Maybe<StringFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentAcademicDocumentationStatusFieldUpdateOperationsInput>;
  type?: Maybe<EnumDocumentAcademicDocumentationTypeFieldUpdateOperationsInput>;
  validationAttempts?: Maybe<IntFieldUpdateOperationsInput>;
};

export type DocumentAcademicDocumentationUpdateWithoutDocumentAcademicDocumentationSearchViewInput = {
  ChildDocuments?: Maybe<DocumentFinalAcademicTranscriptUpdateManyWithoutParentDocumentNestedInput>;
  ChildRevokedDocumentList?: Maybe<DocumentAcademicDocumentationUpdateManyWithoutParentRevokedDocumentNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateOneRequiredWithoutDocumentAcademicDocumentationNestedInput>;
  LinkedDegreeList?: Maybe<DocumentDegreeUpdateManyWithoutParentAcademicDocumentationNestedInput>;
  ParentRevokedDocument?: Maybe<DocumentAcademicDocumentationUpdateOneWithoutChildRevokedDocumentListNestedInput>;
  searchCPF?: Maybe<StringFieldUpdateOperationsInput>;
  searchCourse?: Maybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: Maybe<StringFieldUpdateOperationsInput>;
  searchStudentName?: Maybe<StringFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentAcademicDocumentationStatusFieldUpdateOperationsInput>;
  type?: Maybe<EnumDocumentAcademicDocumentationTypeFieldUpdateOperationsInput>;
  validationAttempts?: Maybe<IntFieldUpdateOperationsInput>;
};

export type DocumentAcademicDocumentationUpdateWithoutDocumentBaseInput = {
  ChildDocuments?: Maybe<DocumentFinalAcademicTranscriptUpdateManyWithoutParentDocumentNestedInput>;
  ChildRevokedDocumentList?: Maybe<DocumentAcademicDocumentationUpdateManyWithoutParentRevokedDocumentNestedInput>;
  DocumentAcademicDocumentationSearchView?: Maybe<DocumentAcademicDocumentationSearchViewUpdateOneWithoutDocumentAcademicDocumentationNestedInput>;
  LinkedDegreeList?: Maybe<DocumentDegreeUpdateManyWithoutParentAcademicDocumentationNestedInput>;
  ParentRevokedDocument?: Maybe<DocumentAcademicDocumentationUpdateOneWithoutChildRevokedDocumentListNestedInput>;
  searchCPF?: Maybe<StringFieldUpdateOperationsInput>;
  searchCourse?: Maybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: Maybe<StringFieldUpdateOperationsInput>;
  searchStudentName?: Maybe<StringFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentAcademicDocumentationStatusFieldUpdateOperationsInput>;
  type?: Maybe<EnumDocumentAcademicDocumentationTypeFieldUpdateOperationsInput>;
  validationAttempts?: Maybe<IntFieldUpdateOperationsInput>;
};

export type DocumentAcademicDocumentationUpdateWithoutLinkedDegreeListInput = {
  ChildDocuments?: Maybe<DocumentFinalAcademicTranscriptUpdateManyWithoutParentDocumentNestedInput>;
  ChildRevokedDocumentList?: Maybe<DocumentAcademicDocumentationUpdateManyWithoutParentRevokedDocumentNestedInput>;
  DocumentAcademicDocumentationSearchView?: Maybe<DocumentAcademicDocumentationSearchViewUpdateOneWithoutDocumentAcademicDocumentationNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateOneRequiredWithoutDocumentAcademicDocumentationNestedInput>;
  ParentRevokedDocument?: Maybe<DocumentAcademicDocumentationUpdateOneWithoutChildRevokedDocumentListNestedInput>;
  searchCPF?: Maybe<StringFieldUpdateOperationsInput>;
  searchCourse?: Maybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: Maybe<StringFieldUpdateOperationsInput>;
  searchStudentName?: Maybe<StringFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentAcademicDocumentationStatusFieldUpdateOperationsInput>;
  type?: Maybe<EnumDocumentAcademicDocumentationTypeFieldUpdateOperationsInput>;
  validationAttempts?: Maybe<IntFieldUpdateOperationsInput>;
};

export type DocumentAcademicDocumentationUpdateWithoutParentRevokedDocumentInput = {
  ChildDocuments?: Maybe<DocumentFinalAcademicTranscriptUpdateManyWithoutParentDocumentNestedInput>;
  ChildRevokedDocumentList?: Maybe<DocumentAcademicDocumentationUpdateManyWithoutParentRevokedDocumentNestedInput>;
  DocumentAcademicDocumentationSearchView?: Maybe<DocumentAcademicDocumentationSearchViewUpdateOneWithoutDocumentAcademicDocumentationNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateOneRequiredWithoutDocumentAcademicDocumentationNestedInput>;
  LinkedDegreeList?: Maybe<DocumentDegreeUpdateManyWithoutParentAcademicDocumentationNestedInput>;
  searchCPF?: Maybe<StringFieldUpdateOperationsInput>;
  searchCourse?: Maybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: Maybe<StringFieldUpdateOperationsInput>;
  searchStudentName?: Maybe<StringFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentAcademicDocumentationStatusFieldUpdateOperationsInput>;
  type?: Maybe<EnumDocumentAcademicDocumentationTypeFieldUpdateOperationsInput>;
  validationAttempts?: Maybe<IntFieldUpdateOperationsInput>;
};

export type DocumentAcademicDocumentationUpsertWithWhereUniqueWithoutParentRevokedDocumentInput = {
  create: DocumentAcademicDocumentationCreateWithoutParentRevokedDocumentInput;
  update: DocumentAcademicDocumentationUpdateWithoutParentRevokedDocumentInput;
  where: DocumentAcademicDocumentationWhereUniqueInput;
};

export type DocumentAcademicDocumentationUpsertWithoutChildDocumentsInput = {
  create: DocumentAcademicDocumentationCreateWithoutChildDocumentsInput;
  update: DocumentAcademicDocumentationUpdateWithoutChildDocumentsInput;
  where?: Maybe<DocumentAcademicDocumentationWhereInput>;
};

export type DocumentAcademicDocumentationUpsertWithoutChildRevokedDocumentListInput = {
  create: DocumentAcademicDocumentationCreateWithoutChildRevokedDocumentListInput;
  update: DocumentAcademicDocumentationUpdateWithoutChildRevokedDocumentListInput;
  where?: Maybe<DocumentAcademicDocumentationWhereInput>;
};

export type DocumentAcademicDocumentationUpsertWithoutDocumentAcademicDocumentationSearchViewInput = {
  create: DocumentAcademicDocumentationCreateWithoutDocumentAcademicDocumentationSearchViewInput;
  update: DocumentAcademicDocumentationUpdateWithoutDocumentAcademicDocumentationSearchViewInput;
  where?: Maybe<DocumentAcademicDocumentationWhereInput>;
};

export type DocumentAcademicDocumentationUpsertWithoutDocumentBaseInput = {
  create: DocumentAcademicDocumentationCreateWithoutDocumentBaseInput;
  update: DocumentAcademicDocumentationUpdateWithoutDocumentBaseInput;
  where?: Maybe<DocumentAcademicDocumentationWhereInput>;
};

export type DocumentAcademicDocumentationUpsertWithoutLinkedDegreeListInput = {
  create: DocumentAcademicDocumentationCreateWithoutLinkedDegreeListInput;
  update: DocumentAcademicDocumentationUpdateWithoutLinkedDegreeListInput;
  where?: Maybe<DocumentAcademicDocumentationWhereInput>;
};

export type DocumentAcademicDocumentationWhereInput = {
  AND?: Maybe<Array<DocumentAcademicDocumentationWhereInput>>;
  ChildDocuments?: Maybe<DocumentFinalAcademicTranscriptListRelationFilter>;
  ChildRevokedDocumentList?: Maybe<DocumentAcademicDocumentationListRelationFilter>;
  DocumentAcademicDocumentationSearchView?: Maybe<DocumentAcademicDocumentationSearchViewWhereInput>;
  DocumentBase?: Maybe<DocumentBaseWhereInput>;
  LinkedDegreeList?: Maybe<DocumentDegreeListRelationFilter>;
  NOT?: Maybe<Array<DocumentAcademicDocumentationWhereInput>>;
  OR?: Maybe<Array<DocumentAcademicDocumentationWhereInput>>;
  ParentRevokedDocument?: Maybe<DocumentAcademicDocumentationWhereInput>;
  documentBaseId?: Maybe<StringFilter>;
  parentRevokedDocumentId?: Maybe<StringNullableFilter>;
  searchCPF?: Maybe<StringFilter>;
  searchCourse?: Maybe<StringFilter>;
  searchEmecCode?: Maybe<StringFilter>;
  searchStudentName?: Maybe<StringFilter>;
  status?: Maybe<EnumDocumentAcademicDocumentationStatusFilter>;
  type?: Maybe<EnumDocumentAcademicDocumentationTypeFilter>;
  validationAttempts?: Maybe<IntFilter>;
};

export type DocumentAcademicDocumentationWhereUniqueInput = {
  AND?: Maybe<Array<DocumentAcademicDocumentationWhereInput>>;
  ChildDocuments?: Maybe<DocumentFinalAcademicTranscriptListRelationFilter>;
  ChildRevokedDocumentList?: Maybe<DocumentAcademicDocumentationListRelationFilter>;
  DocumentAcademicDocumentationSearchView?: Maybe<DocumentAcademicDocumentationSearchViewWhereInput>;
  DocumentBase?: Maybe<DocumentBaseWhereInput>;
  LinkedDegreeList?: Maybe<DocumentDegreeListRelationFilter>;
  NOT?: Maybe<Array<DocumentAcademicDocumentationWhereInput>>;
  OR?: Maybe<Array<DocumentAcademicDocumentationWhereInput>>;
  ParentRevokedDocument?: Maybe<DocumentAcademicDocumentationWhereInput>;
  documentBaseId?: Maybe<Scalars['String']>;
  parentRevokedDocumentId?: Maybe<StringNullableFilter>;
  searchCPF?: Maybe<StringFilter>;
  searchCourse?: Maybe<StringFilter>;
  searchEmecCode?: Maybe<StringFilter>;
  searchStudentName?: Maybe<StringFilter>;
  status?: Maybe<EnumDocumentAcademicDocumentationStatusFilter>;
  type?: Maybe<EnumDocumentAcademicDocumentationTypeFilter>;
  validationAttempts?: Maybe<IntFilter>;
};

export type DocumentAuditFileIssuer = {
  __typename?: 'DocumentAuditFileIssuer';
  Degrees: Array<DocumentAuditFileIssuerDegreeItem>;
  DocumentBase: DocumentBase;
  documentBaseId: Scalars['String'];
  searchAuditEndDate: Scalars['DateTime'];
  searchAuditStartDate: Scalars['DateTime'];
  status: DocumentAuditFileIssuerStatus;
};


export type DocumentAuditFileIssuerDegreesArgs = {
  cursor?: Maybe<DocumentAuditFileIssuerDegreeItemWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentAuditFileIssuerDegreeItemScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentAuditFileIssuerDegreeItemOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentAuditFileIssuerDegreeItemWhereInput>;
};

export type DocumentAuditFileIssuerCountOrderByAggregateInput = {
  documentBaseId?: Maybe<SortOrder>;
  searchAuditEndDate?: Maybe<SortOrder>;
  searchAuditStartDate?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type DocumentAuditFileIssuerCreateInput = {
  Degrees?: Maybe<DocumentAuditFileIssuerDegreeItemCreateNestedManyWithoutDocumentAuditFileIssuerInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentAuditFileIssuerInput;
  searchAuditEndDate: Scalars['DateTime'];
  searchAuditStartDate: Scalars['DateTime'];
  status?: Maybe<DocumentAuditFileIssuerStatus>;
};

export type DocumentAuditFileIssuerCreateManyInput = {
  documentBaseId: Scalars['String'];
  searchAuditEndDate: Scalars['DateTime'];
  searchAuditStartDate: Scalars['DateTime'];
  status?: Maybe<DocumentAuditFileIssuerStatus>;
};

export type DocumentAuditFileIssuerCreateNestedOneWithoutDegreesInput = {
  connect?: Maybe<DocumentAuditFileIssuerWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentAuditFileIssuerCreateOrConnectWithoutDegreesInput>;
  create?: Maybe<DocumentAuditFileIssuerCreateWithoutDegreesInput>;
};

export type DocumentAuditFileIssuerCreateNestedOneWithoutDocumentBaseInput = {
  connect?: Maybe<DocumentAuditFileIssuerWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentAuditFileIssuerCreateOrConnectWithoutDocumentBaseInput>;
  create?: Maybe<DocumentAuditFileIssuerCreateWithoutDocumentBaseInput>;
};

export type DocumentAuditFileIssuerCreateOrConnectWithoutDegreesInput = {
  create: DocumentAuditFileIssuerCreateWithoutDegreesInput;
  where: DocumentAuditFileIssuerWhereUniqueInput;
};

export type DocumentAuditFileIssuerCreateOrConnectWithoutDocumentBaseInput = {
  create: DocumentAuditFileIssuerCreateWithoutDocumentBaseInput;
  where: DocumentAuditFileIssuerWhereUniqueInput;
};

export type DocumentAuditFileIssuerCreateWithoutDegreesInput = {
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentAuditFileIssuerInput;
  searchAuditEndDate: Scalars['DateTime'];
  searchAuditStartDate: Scalars['DateTime'];
  status?: Maybe<DocumentAuditFileIssuerStatus>;
};

export type DocumentAuditFileIssuerCreateWithoutDocumentBaseInput = {
  Degrees?: Maybe<DocumentAuditFileIssuerDegreeItemCreateNestedManyWithoutDocumentAuditFileIssuerInput>;
  searchAuditEndDate: Scalars['DateTime'];
  searchAuditStartDate: Scalars['DateTime'];
  status?: Maybe<DocumentAuditFileIssuerStatus>;
};

export type DocumentAuditFileIssuerDegreeItem = {
  __typename?: 'DocumentAuditFileIssuerDegreeItem';
  DocumentAuditFileIssuer: DocumentAuditFileIssuer;
  DocumentDegree: DocumentDegree;
  documentAuditFileIssuerDocumentBaseId: Scalars['String'];
  documentDegreeDocumentBaseId: Scalars['String'];
};

export type DocumentAuditFileIssuerDegreeItemCountOrderByAggregateInput = {
  documentAuditFileIssuerDocumentBaseId?: Maybe<SortOrder>;
  documentDegreeDocumentBaseId?: Maybe<SortOrder>;
};

export type DocumentAuditFileIssuerDegreeItemCreateInput = {
  DocumentAuditFileIssuer: DocumentAuditFileIssuerCreateNestedOneWithoutDegreesInput;
  DocumentDegree: DocumentDegreeCreateNestedOneWithoutDocumentAuditFileIssuersInput;
};

export type DocumentAuditFileIssuerDegreeItemCreateManyDocumentAuditFileIssuerInput = {
  documentDegreeDocumentBaseId: Scalars['String'];
};

export type DocumentAuditFileIssuerDegreeItemCreateManyDocumentAuditFileIssuerInputEnvelope = {
  data: Array<DocumentAuditFileIssuerDegreeItemCreateManyDocumentAuditFileIssuerInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentAuditFileIssuerDegreeItemCreateManyDocumentDegreeInput = {
  documentAuditFileIssuerDocumentBaseId: Scalars['String'];
};

export type DocumentAuditFileIssuerDegreeItemCreateManyDocumentDegreeInputEnvelope = {
  data: Array<DocumentAuditFileIssuerDegreeItemCreateManyDocumentDegreeInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentAuditFileIssuerDegreeItemCreateManyInput = {
  documentAuditFileIssuerDocumentBaseId: Scalars['String'];
  documentDegreeDocumentBaseId: Scalars['String'];
};

export type DocumentAuditFileIssuerDegreeItemCreateNestedManyWithoutDocumentAuditFileIssuerInput = {
  connect?: Maybe<Array<DocumentAuditFileIssuerDegreeItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentAuditFileIssuerDegreeItemCreateOrConnectWithoutDocumentAuditFileIssuerInput>>;
  create?: Maybe<Array<DocumentAuditFileIssuerDegreeItemCreateWithoutDocumentAuditFileIssuerInput>>;
  createMany?: Maybe<DocumentAuditFileIssuerDegreeItemCreateManyDocumentAuditFileIssuerInputEnvelope>;
};

export type DocumentAuditFileIssuerDegreeItemCreateNestedManyWithoutDocumentDegreeInput = {
  connect?: Maybe<Array<DocumentAuditFileIssuerDegreeItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentAuditFileIssuerDegreeItemCreateOrConnectWithoutDocumentDegreeInput>>;
  create?: Maybe<Array<DocumentAuditFileIssuerDegreeItemCreateWithoutDocumentDegreeInput>>;
  createMany?: Maybe<DocumentAuditFileIssuerDegreeItemCreateManyDocumentDegreeInputEnvelope>;
};

export type DocumentAuditFileIssuerDegreeItemCreateOrConnectWithoutDocumentAuditFileIssuerInput = {
  create: DocumentAuditFileIssuerDegreeItemCreateWithoutDocumentAuditFileIssuerInput;
  where: DocumentAuditFileIssuerDegreeItemWhereUniqueInput;
};

export type DocumentAuditFileIssuerDegreeItemCreateOrConnectWithoutDocumentDegreeInput = {
  create: DocumentAuditFileIssuerDegreeItemCreateWithoutDocumentDegreeInput;
  where: DocumentAuditFileIssuerDegreeItemWhereUniqueInput;
};

export type DocumentAuditFileIssuerDegreeItemCreateWithoutDocumentAuditFileIssuerInput = {
  DocumentDegree: DocumentDegreeCreateNestedOneWithoutDocumentAuditFileIssuersInput;
};

export type DocumentAuditFileIssuerDegreeItemCreateWithoutDocumentDegreeInput = {
  DocumentAuditFileIssuer: DocumentAuditFileIssuerCreateNestedOneWithoutDegreesInput;
};

export type DocumentAuditFileIssuerDegreeItemDocumentAuditFileIssuerDocumentBaseIdDocumentDegreeDocumentBaseIdCompoundUniqueInput = {
  documentAuditFileIssuerDocumentBaseId: Scalars['String'];
  documentDegreeDocumentBaseId: Scalars['String'];
};

export type DocumentAuditFileIssuerDegreeItemListRelationFilter = {
  every?: Maybe<DocumentAuditFileIssuerDegreeItemWhereInput>;
  none?: Maybe<DocumentAuditFileIssuerDegreeItemWhereInput>;
  some?: Maybe<DocumentAuditFileIssuerDegreeItemWhereInput>;
};

export type DocumentAuditFileIssuerDegreeItemMaxOrderByAggregateInput = {
  documentAuditFileIssuerDocumentBaseId?: Maybe<SortOrder>;
  documentDegreeDocumentBaseId?: Maybe<SortOrder>;
};

export type DocumentAuditFileIssuerDegreeItemMinOrderByAggregateInput = {
  documentAuditFileIssuerDocumentBaseId?: Maybe<SortOrder>;
  documentDegreeDocumentBaseId?: Maybe<SortOrder>;
};

export type DocumentAuditFileIssuerDegreeItemOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type DocumentAuditFileIssuerDegreeItemOrderByWithAggregationInput = {
  _count?: Maybe<DocumentAuditFileIssuerDegreeItemCountOrderByAggregateInput>;
  _max?: Maybe<DocumentAuditFileIssuerDegreeItemMaxOrderByAggregateInput>;
  _min?: Maybe<DocumentAuditFileIssuerDegreeItemMinOrderByAggregateInput>;
  documentAuditFileIssuerDocumentBaseId?: Maybe<SortOrder>;
  documentDegreeDocumentBaseId?: Maybe<SortOrder>;
};

export type DocumentAuditFileIssuerDegreeItemOrderByWithRelationInput = {
  DocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuerOrderByWithRelationInput>;
  DocumentDegree?: Maybe<DocumentDegreeOrderByWithRelationInput>;
  documentAuditFileIssuerDocumentBaseId?: Maybe<SortOrder>;
  documentDegreeDocumentBaseId?: Maybe<SortOrder>;
};

export enum DocumentAuditFileIssuerDegreeItemScalarFieldEnum {
  DocumentAuditFileIssuerDocumentBaseId = 'documentAuditFileIssuerDocumentBaseId',
  DocumentDegreeDocumentBaseId = 'documentDegreeDocumentBaseId'
}

export type DocumentAuditFileIssuerDegreeItemScalarWhereInput = {
  AND?: Maybe<Array<DocumentAuditFileIssuerDegreeItemScalarWhereInput>>;
  NOT?: Maybe<Array<DocumentAuditFileIssuerDegreeItemScalarWhereInput>>;
  OR?: Maybe<Array<DocumentAuditFileIssuerDegreeItemScalarWhereInput>>;
  documentAuditFileIssuerDocumentBaseId?: Maybe<StringFilter>;
  documentDegreeDocumentBaseId?: Maybe<StringFilter>;
};

export type DocumentAuditFileIssuerDegreeItemScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<DocumentAuditFileIssuerDegreeItemScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<DocumentAuditFileIssuerDegreeItemScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<DocumentAuditFileIssuerDegreeItemScalarWhereWithAggregatesInput>>;
  documentAuditFileIssuerDocumentBaseId?: Maybe<StringWithAggregatesFilter>;
  documentDegreeDocumentBaseId?: Maybe<StringWithAggregatesFilter>;
};

export type DocumentAuditFileIssuerDegreeItemUpdateInput = {
  DocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuerUpdateOneRequiredWithoutDegreesNestedInput>;
  DocumentDegree?: Maybe<DocumentDegreeUpdateOneRequiredWithoutDocumentAuditFileIssuersNestedInput>;
};

export type DocumentAuditFileIssuerDegreeItemUpdateManyMutationInput = {
  _?: Maybe<Scalars['NEVER']>;
};

export type DocumentAuditFileIssuerDegreeItemUpdateManyWithWhereWithoutDocumentAuditFileIssuerInput = {
  data: DocumentAuditFileIssuerDegreeItemUpdateManyMutationInput;
  where: DocumentAuditFileIssuerDegreeItemScalarWhereInput;
};

export type DocumentAuditFileIssuerDegreeItemUpdateManyWithWhereWithoutDocumentDegreeInput = {
  data: DocumentAuditFileIssuerDegreeItemUpdateManyMutationInput;
  where: DocumentAuditFileIssuerDegreeItemScalarWhereInput;
};

export type DocumentAuditFileIssuerDegreeItemUpdateManyWithoutDocumentAuditFileIssuerNestedInput = {
  connect?: Maybe<Array<DocumentAuditFileIssuerDegreeItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentAuditFileIssuerDegreeItemCreateOrConnectWithoutDocumentAuditFileIssuerInput>>;
  create?: Maybe<Array<DocumentAuditFileIssuerDegreeItemCreateWithoutDocumentAuditFileIssuerInput>>;
  createMany?: Maybe<DocumentAuditFileIssuerDegreeItemCreateManyDocumentAuditFileIssuerInputEnvelope>;
  delete?: Maybe<Array<DocumentAuditFileIssuerDegreeItemWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentAuditFileIssuerDegreeItemScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentAuditFileIssuerDegreeItemWhereUniqueInput>>;
  set?: Maybe<Array<DocumentAuditFileIssuerDegreeItemWhereUniqueInput>>;
  update?: Maybe<Array<DocumentAuditFileIssuerDegreeItemUpdateWithWhereUniqueWithoutDocumentAuditFileIssuerInput>>;
  updateMany?: Maybe<Array<DocumentAuditFileIssuerDegreeItemUpdateManyWithWhereWithoutDocumentAuditFileIssuerInput>>;
  upsert?: Maybe<Array<DocumentAuditFileIssuerDegreeItemUpsertWithWhereUniqueWithoutDocumentAuditFileIssuerInput>>;
};

export type DocumentAuditFileIssuerDegreeItemUpdateManyWithoutDocumentDegreeNestedInput = {
  connect?: Maybe<Array<DocumentAuditFileIssuerDegreeItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentAuditFileIssuerDegreeItemCreateOrConnectWithoutDocumentDegreeInput>>;
  create?: Maybe<Array<DocumentAuditFileIssuerDegreeItemCreateWithoutDocumentDegreeInput>>;
  createMany?: Maybe<DocumentAuditFileIssuerDegreeItemCreateManyDocumentDegreeInputEnvelope>;
  delete?: Maybe<Array<DocumentAuditFileIssuerDegreeItemWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentAuditFileIssuerDegreeItemScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentAuditFileIssuerDegreeItemWhereUniqueInput>>;
  set?: Maybe<Array<DocumentAuditFileIssuerDegreeItemWhereUniqueInput>>;
  update?: Maybe<Array<DocumentAuditFileIssuerDegreeItemUpdateWithWhereUniqueWithoutDocumentDegreeInput>>;
  updateMany?: Maybe<Array<DocumentAuditFileIssuerDegreeItemUpdateManyWithWhereWithoutDocumentDegreeInput>>;
  upsert?: Maybe<Array<DocumentAuditFileIssuerDegreeItemUpsertWithWhereUniqueWithoutDocumentDegreeInput>>;
};

export type DocumentAuditFileIssuerDegreeItemUpdateWithWhereUniqueWithoutDocumentAuditFileIssuerInput = {
  data: DocumentAuditFileIssuerDegreeItemUpdateWithoutDocumentAuditFileIssuerInput;
  where: DocumentAuditFileIssuerDegreeItemWhereUniqueInput;
};

export type DocumentAuditFileIssuerDegreeItemUpdateWithWhereUniqueWithoutDocumentDegreeInput = {
  data: DocumentAuditFileIssuerDegreeItemUpdateWithoutDocumentDegreeInput;
  where: DocumentAuditFileIssuerDegreeItemWhereUniqueInput;
};

export type DocumentAuditFileIssuerDegreeItemUpdateWithoutDocumentAuditFileIssuerInput = {
  DocumentDegree?: Maybe<DocumentDegreeUpdateOneRequiredWithoutDocumentAuditFileIssuersNestedInput>;
};

export type DocumentAuditFileIssuerDegreeItemUpdateWithoutDocumentDegreeInput = {
  DocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuerUpdateOneRequiredWithoutDegreesNestedInput>;
};

export type DocumentAuditFileIssuerDegreeItemUpsertWithWhereUniqueWithoutDocumentAuditFileIssuerInput = {
  create: DocumentAuditFileIssuerDegreeItemCreateWithoutDocumentAuditFileIssuerInput;
  update: DocumentAuditFileIssuerDegreeItemUpdateWithoutDocumentAuditFileIssuerInput;
  where: DocumentAuditFileIssuerDegreeItemWhereUniqueInput;
};

export type DocumentAuditFileIssuerDegreeItemUpsertWithWhereUniqueWithoutDocumentDegreeInput = {
  create: DocumentAuditFileIssuerDegreeItemCreateWithoutDocumentDegreeInput;
  update: DocumentAuditFileIssuerDegreeItemUpdateWithoutDocumentDegreeInput;
  where: DocumentAuditFileIssuerDegreeItemWhereUniqueInput;
};

export type DocumentAuditFileIssuerDegreeItemWhereInput = {
  AND?: Maybe<Array<DocumentAuditFileIssuerDegreeItemWhereInput>>;
  DocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuerWhereInput>;
  DocumentDegree?: Maybe<DocumentDegreeWhereInput>;
  NOT?: Maybe<Array<DocumentAuditFileIssuerDegreeItemWhereInput>>;
  OR?: Maybe<Array<DocumentAuditFileIssuerDegreeItemWhereInput>>;
  documentAuditFileIssuerDocumentBaseId?: Maybe<StringFilter>;
  documentDegreeDocumentBaseId?: Maybe<StringFilter>;
};

export type DocumentAuditFileIssuerDegreeItemWhereUniqueInput = {
  AND?: Maybe<Array<DocumentAuditFileIssuerDegreeItemWhereInput>>;
  DocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuerWhereInput>;
  DocumentDegree?: Maybe<DocumentDegreeWhereInput>;
  NOT?: Maybe<Array<DocumentAuditFileIssuerDegreeItemWhereInput>>;
  OR?: Maybe<Array<DocumentAuditFileIssuerDegreeItemWhereInput>>;
  documentAuditFileIssuerDocumentBaseId?: Maybe<StringFilter>;
  documentAuditFileIssuerDocumentBaseId_documentDegreeDocumentBaseId?: Maybe<DocumentAuditFileIssuerDegreeItemDocumentAuditFileIssuerDocumentBaseIdDocumentDegreeDocumentBaseIdCompoundUniqueInput>;
  documentDegreeDocumentBaseId?: Maybe<StringFilter>;
};

export type DocumentAuditFileIssuerMaxOrderByAggregateInput = {
  documentBaseId?: Maybe<SortOrder>;
  searchAuditEndDate?: Maybe<SortOrder>;
  searchAuditStartDate?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type DocumentAuditFileIssuerMinOrderByAggregateInput = {
  documentBaseId?: Maybe<SortOrder>;
  searchAuditEndDate?: Maybe<SortOrder>;
  searchAuditStartDate?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type DocumentAuditFileIssuerNullableRelationFilter = {
  is?: Maybe<DocumentAuditFileIssuerWhereInput>;
  isNot?: Maybe<DocumentAuditFileIssuerWhereInput>;
};

export type DocumentAuditFileIssuerOrderByWithAggregationInput = {
  _count?: Maybe<DocumentAuditFileIssuerCountOrderByAggregateInput>;
  _max?: Maybe<DocumentAuditFileIssuerMaxOrderByAggregateInput>;
  _min?: Maybe<DocumentAuditFileIssuerMinOrderByAggregateInput>;
  documentBaseId?: Maybe<SortOrder>;
  searchAuditEndDate?: Maybe<SortOrder>;
  searchAuditStartDate?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type DocumentAuditFileIssuerOrderByWithRelationInput = {
  Degrees?: Maybe<DocumentAuditFileIssuerDegreeItemOrderByRelationAggregateInput>;
  DocumentBase?: Maybe<DocumentBaseOrderByWithRelationInput>;
  documentBaseId?: Maybe<SortOrder>;
  searchAuditEndDate?: Maybe<SortOrder>;
  searchAuditStartDate?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type DocumentAuditFileIssuerRelationFilter = {
  is?: Maybe<DocumentAuditFileIssuerWhereInput>;
  isNot?: Maybe<DocumentAuditFileIssuerWhereInput>;
};

export enum DocumentAuditFileIssuerScalarFieldEnum {
  DocumentBaseId = 'documentBaseId',
  SearchAuditEndDate = 'searchAuditEndDate',
  SearchAuditStartDate = 'searchAuditStartDate',
  Status = 'status'
}

export type DocumentAuditFileIssuerScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<DocumentAuditFileIssuerScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<DocumentAuditFileIssuerScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<DocumentAuditFileIssuerScalarWhereWithAggregatesInput>>;
  documentBaseId?: Maybe<StringWithAggregatesFilter>;
  searchAuditEndDate?: Maybe<DateTimeWithAggregatesFilter>;
  searchAuditStartDate?: Maybe<DateTimeWithAggregatesFilter>;
  status?: Maybe<EnumDocumentAuditFileIssuerStatusWithAggregatesFilter>;
};

export enum DocumentAuditFileIssuerStatus {
  Invalid = 'INVALID',
  InCorrection = 'IN_CORRECTION',
  InSignature = 'IN_SIGNATURE',
  InValidation = 'IN_VALIDATION',
  Issued = 'ISSUED',
  PendingReview = 'PENDING_REVIEW',
  Revoked = 'REVOKED'
}

export type DocumentAuditFileIssuerUpdateInput = {
  Degrees?: Maybe<DocumentAuditFileIssuerDegreeItemUpdateManyWithoutDocumentAuditFileIssuerNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateOneRequiredWithoutDocumentAuditFileIssuerNestedInput>;
  searchAuditEndDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  searchAuditStartDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentAuditFileIssuerStatusFieldUpdateOperationsInput>;
};

export type DocumentAuditFileIssuerUpdateManyMutationInput = {
  searchAuditEndDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  searchAuditStartDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentAuditFileIssuerStatusFieldUpdateOperationsInput>;
};

export type DocumentAuditFileIssuerUpdateOneRequiredWithoutDegreesNestedInput = {
  connect?: Maybe<DocumentAuditFileIssuerWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentAuditFileIssuerCreateOrConnectWithoutDegreesInput>;
  create?: Maybe<DocumentAuditFileIssuerCreateWithoutDegreesInput>;
  update?: Maybe<DocumentAuditFileIssuerUpdateToOneWithWhereWithoutDegreesInput>;
  upsert?: Maybe<DocumentAuditFileIssuerUpsertWithoutDegreesInput>;
};

export type DocumentAuditFileIssuerUpdateOneWithoutDocumentBaseNestedInput = {
  connect?: Maybe<DocumentAuditFileIssuerWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentAuditFileIssuerCreateOrConnectWithoutDocumentBaseInput>;
  create?: Maybe<DocumentAuditFileIssuerCreateWithoutDocumentBaseInput>;
  delete?: Maybe<DocumentAuditFileIssuerWhereInput>;
  disconnect?: Maybe<DocumentAuditFileIssuerWhereInput>;
  update?: Maybe<DocumentAuditFileIssuerUpdateToOneWithWhereWithoutDocumentBaseInput>;
  upsert?: Maybe<DocumentAuditFileIssuerUpsertWithoutDocumentBaseInput>;
};

export type DocumentAuditFileIssuerUpdateToOneWithWhereWithoutDegreesInput = {
  data: DocumentAuditFileIssuerUpdateWithoutDegreesInput;
  where?: Maybe<DocumentAuditFileIssuerWhereInput>;
};

export type DocumentAuditFileIssuerUpdateToOneWithWhereWithoutDocumentBaseInput = {
  data: DocumentAuditFileIssuerUpdateWithoutDocumentBaseInput;
  where?: Maybe<DocumentAuditFileIssuerWhereInput>;
};

export type DocumentAuditFileIssuerUpdateWithoutDegreesInput = {
  DocumentBase?: Maybe<DocumentBaseUpdateOneRequiredWithoutDocumentAuditFileIssuerNestedInput>;
  searchAuditEndDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  searchAuditStartDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentAuditFileIssuerStatusFieldUpdateOperationsInput>;
};

export type DocumentAuditFileIssuerUpdateWithoutDocumentBaseInput = {
  Degrees?: Maybe<DocumentAuditFileIssuerDegreeItemUpdateManyWithoutDocumentAuditFileIssuerNestedInput>;
  searchAuditEndDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  searchAuditStartDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentAuditFileIssuerStatusFieldUpdateOperationsInput>;
};

export type DocumentAuditFileIssuerUpsertWithoutDegreesInput = {
  create: DocumentAuditFileIssuerCreateWithoutDegreesInput;
  update: DocumentAuditFileIssuerUpdateWithoutDegreesInput;
  where?: Maybe<DocumentAuditFileIssuerWhereInput>;
};

export type DocumentAuditFileIssuerUpsertWithoutDocumentBaseInput = {
  create: DocumentAuditFileIssuerCreateWithoutDocumentBaseInput;
  update: DocumentAuditFileIssuerUpdateWithoutDocumentBaseInput;
  where?: Maybe<DocumentAuditFileIssuerWhereInput>;
};

export type DocumentAuditFileIssuerWhereInput = {
  AND?: Maybe<Array<DocumentAuditFileIssuerWhereInput>>;
  Degrees?: Maybe<DocumentAuditFileIssuerDegreeItemListRelationFilter>;
  DocumentBase?: Maybe<DocumentBaseWhereInput>;
  NOT?: Maybe<Array<DocumentAuditFileIssuerWhereInput>>;
  OR?: Maybe<Array<DocumentAuditFileIssuerWhereInput>>;
  documentBaseId?: Maybe<StringFilter>;
  searchAuditEndDate?: Maybe<DateTimeFilter>;
  searchAuditStartDate?: Maybe<DateTimeFilter>;
  status?: Maybe<EnumDocumentAuditFileIssuerStatusFilter>;
};

export type DocumentAuditFileIssuerWhereUniqueInput = {
  AND?: Maybe<Array<DocumentAuditFileIssuerWhereInput>>;
  Degrees?: Maybe<DocumentAuditFileIssuerDegreeItemListRelationFilter>;
  DocumentBase?: Maybe<DocumentBaseWhereInput>;
  NOT?: Maybe<Array<DocumentAuditFileIssuerWhereInput>>;
  OR?: Maybe<Array<DocumentAuditFileIssuerWhereInput>>;
  documentBaseId?: Maybe<Scalars['String']>;
  searchAuditEndDate?: Maybe<DateTimeFilter>;
  searchAuditStartDate?: Maybe<DateTimeFilter>;
  status?: Maybe<EnumDocumentAuditFileIssuerStatusFilter>;
};

export type DocumentBase = {
  __typename?: 'DocumentBase';
  DocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentation>;
  DocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuer>;
  DocumentBaseSignatureInviteGroups: Array<DocumentBaseSignatureInviteGroup>;
  DocumentCertificate?: Maybe<DocumentCertificate>;
  DocumentDegree?: Maybe<DocumentDegree>;
  DocumentFinalAcademicTranscript?: Maybe<DocumentFinalAcademicTranscript>;
  DocumentSchoolCurriculum?: Maybe<DocumentSchoolCurriculum>;
  ExternalSignatureInvite: Array<ExternalSignatureInvite>;
  Histories: Array<DocumentBaseHistory>;
  Team: Team;
  UserOwner: CommonUser;
  commonUserId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  creationType: DocumentAcademicDocumentationCreationType;
  /** JSON com diversas opções */
  data: Scalars['Json'];
  /** ![PrismaJson.DocumentJson] */
  dataWithIesAndFiles: Scalars['Json'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  filePath?: Maybe<Scalars['String']>;
  internalSeqId: Scalars['String'];
  signatureConfig: Array<SignatureType>;
  teamId: Scalars['Int'];
  type: DocumentBaseType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** JSON com diversas opções */
  variableJson: Scalars['Json'];
  /** 1.05 / 1.06 */
  version: Scalars['String'];
  withoutTeamInternalSeqId: Scalars['Int'];
};


export type DocumentBaseDocumentBaseSignatureInviteGroupsArgs = {
  cursor?: Maybe<DocumentBaseSignatureInviteGroupWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseSignatureInviteGroupScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseSignatureInviteGroupOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseSignatureInviteGroupWhereInput>;
};


export type DocumentBaseExternalSignatureInviteArgs = {
  cursor?: Maybe<ExternalSignatureInviteWhereUniqueInput>;
  distinct?: Maybe<Array<ExternalSignatureInviteScalarFieldEnum>>;
  orderBy?: Maybe<Array<ExternalSignatureInviteOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ExternalSignatureInviteWhereInput>;
};


export type DocumentBaseHistoriesArgs = {
  cursor?: Maybe<DocumentBaseHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseHistoryScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseHistoryOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseHistoryWhereInput>;
};


export type DocumentBaseVariableJsonArgs = {
  clean?: Maybe<Scalars['Boolean']>;
  coverWithMetaAndData?: Maybe<Scalars['Boolean']>;
  removeFiles?: Maybe<Scalars['Boolean']>;
};

export type DocumentBaseAvgOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  withoutTeamInternalSeqId?: Maybe<SortOrder>;
};

export type DocumentBaseCountOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  creationType?: Maybe<SortOrder>;
  data?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  filePath?: Maybe<SortOrder>;
  internalSeqId?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  version?: Maybe<SortOrder>;
  withoutTeamInternalSeqId?: Maybe<SortOrder>;
};

export type DocumentBaseCreateInput = {
  DocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationCreateNestedOneWithoutDocumentBaseInput>;
  DocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuerCreateNestedOneWithoutDocumentBaseInput>;
  DocumentBaseSignatureInviteGroups?: Maybe<DocumentBaseSignatureInviteGroupCreateNestedManyWithoutDocumentBaseInput>;
  DocumentCertificate?: Maybe<DocumentCertificateCreateNestedOneWithoutDocumentBaseInput>;
  DocumentDegree?: Maybe<DocumentDegreeCreateNestedOneWithoutDocumentBaseInput>;
  DocumentFinalAcademicTranscript?: Maybe<DocumentFinalAcademicTranscriptCreateNestedOneWithoutDocumentBaseInput>;
  DocumentSchoolCurriculum?: Maybe<DocumentSchoolCurriculumCreateNestedOneWithoutDocumentBaseInput>;
  ExternalSignatureInvite?: Maybe<ExternalSignatureInviteCreateNestedManyWithoutDocumentBaseInput>;
  Histories?: Maybe<DocumentBaseHistoryCreateNestedManyWithoutDocumentBaseInput>;
  Team: TeamCreateNestedOneWithoutDocumentsInput;
  UserOwner: CommonUserCreateNestedOneWithoutDocumentBaseInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationType?: Maybe<DocumentAcademicDocumentationCreationType>;
  data: Scalars['Json'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  filePath?: Maybe<Scalars['String']>;
  internalSeqId?: Maybe<Scalars['String']>;
  type: DocumentBaseType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['String']>;
  withoutTeamInternalSeqId?: Maybe<Scalars['Int']>;
};

export type DocumentBaseCreateManyInput = {
  commonUserId: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  creationType?: Maybe<DocumentAcademicDocumentationCreationType>;
  data: Scalars['Json'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  filePath?: Maybe<Scalars['String']>;
  internalSeqId?: Maybe<Scalars['String']>;
  teamId: Scalars['Int'];
  type: DocumentBaseType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['String']>;
  withoutTeamInternalSeqId?: Maybe<Scalars['Int']>;
};

export type DocumentBaseCreateManyTeamInput = {
  commonUserId: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  creationType?: Maybe<DocumentAcademicDocumentationCreationType>;
  data: Scalars['Json'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  filePath?: Maybe<Scalars['String']>;
  internalSeqId?: Maybe<Scalars['String']>;
  type: DocumentBaseType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['String']>;
  withoutTeamInternalSeqId?: Maybe<Scalars['Int']>;
};

export type DocumentBaseCreateManyTeamInputEnvelope = {
  data: Array<DocumentBaseCreateManyTeamInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentBaseCreateManyUserOwnerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  creationType?: Maybe<DocumentAcademicDocumentationCreationType>;
  data: Scalars['Json'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  filePath?: Maybe<Scalars['String']>;
  internalSeqId?: Maybe<Scalars['String']>;
  teamId: Scalars['Int'];
  type: DocumentBaseType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['String']>;
  withoutTeamInternalSeqId?: Maybe<Scalars['Int']>;
};

export type DocumentBaseCreateManyUserOwnerInputEnvelope = {
  data: Array<DocumentBaseCreateManyUserOwnerInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentBaseCreateNestedManyWithoutTeamInput = {
  connect?: Maybe<Array<DocumentBaseWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentBaseCreateOrConnectWithoutTeamInput>>;
  create?: Maybe<Array<DocumentBaseCreateWithoutTeamInput>>;
  createMany?: Maybe<DocumentBaseCreateManyTeamInputEnvelope>;
};

export type DocumentBaseCreateNestedManyWithoutUserOwnerInput = {
  connect?: Maybe<Array<DocumentBaseWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentBaseCreateOrConnectWithoutUserOwnerInput>>;
  create?: Maybe<Array<DocumentBaseCreateWithoutUserOwnerInput>>;
  createMany?: Maybe<DocumentBaseCreateManyUserOwnerInputEnvelope>;
};

export type DocumentBaseCreateNestedOneWithoutDocumentAcademicDocumentationInput = {
  connect?: Maybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentBaseCreateOrConnectWithoutDocumentAcademicDocumentationInput>;
  create?: Maybe<DocumentBaseCreateWithoutDocumentAcademicDocumentationInput>;
};

export type DocumentBaseCreateNestedOneWithoutDocumentAuditFileIssuerInput = {
  connect?: Maybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentBaseCreateOrConnectWithoutDocumentAuditFileIssuerInput>;
  create?: Maybe<DocumentBaseCreateWithoutDocumentAuditFileIssuerInput>;
};

export type DocumentBaseCreateNestedOneWithoutDocumentBaseSignatureInviteGroupsInput = {
  connect?: Maybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentBaseCreateOrConnectWithoutDocumentBaseSignatureInviteGroupsInput>;
  create?: Maybe<DocumentBaseCreateWithoutDocumentBaseSignatureInviteGroupsInput>;
};

export type DocumentBaseCreateNestedOneWithoutDocumentCertificateInput = {
  connect?: Maybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentBaseCreateOrConnectWithoutDocumentCertificateInput>;
  create?: Maybe<DocumentBaseCreateWithoutDocumentCertificateInput>;
};

export type DocumentBaseCreateNestedOneWithoutDocumentDegreeInput = {
  connect?: Maybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentBaseCreateOrConnectWithoutDocumentDegreeInput>;
  create?: Maybe<DocumentBaseCreateWithoutDocumentDegreeInput>;
};

export type DocumentBaseCreateNestedOneWithoutDocumentFinalAcademicTranscriptInput = {
  connect?: Maybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentBaseCreateOrConnectWithoutDocumentFinalAcademicTranscriptInput>;
  create?: Maybe<DocumentBaseCreateWithoutDocumentFinalAcademicTranscriptInput>;
};

export type DocumentBaseCreateNestedOneWithoutDocumentSchoolCurriculumInput = {
  connect?: Maybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentBaseCreateOrConnectWithoutDocumentSchoolCurriculumInput>;
  create?: Maybe<DocumentBaseCreateWithoutDocumentSchoolCurriculumInput>;
};

export type DocumentBaseCreateNestedOneWithoutExternalSignatureInviteInput = {
  connect?: Maybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentBaseCreateOrConnectWithoutExternalSignatureInviteInput>;
  create?: Maybe<DocumentBaseCreateWithoutExternalSignatureInviteInput>;
};

export type DocumentBaseCreateNestedOneWithoutHistoriesInput = {
  connect?: Maybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentBaseCreateOrConnectWithoutHistoriesInput>;
  create?: Maybe<DocumentBaseCreateWithoutHistoriesInput>;
};

export type DocumentBaseCreateOrConnectWithoutDocumentAcademicDocumentationInput = {
  create: DocumentBaseCreateWithoutDocumentAcademicDocumentationInput;
  where: DocumentBaseWhereUniqueInput;
};

export type DocumentBaseCreateOrConnectWithoutDocumentAuditFileIssuerInput = {
  create: DocumentBaseCreateWithoutDocumentAuditFileIssuerInput;
  where: DocumentBaseWhereUniqueInput;
};

export type DocumentBaseCreateOrConnectWithoutDocumentBaseSignatureInviteGroupsInput = {
  create: DocumentBaseCreateWithoutDocumentBaseSignatureInviteGroupsInput;
  where: DocumentBaseWhereUniqueInput;
};

export type DocumentBaseCreateOrConnectWithoutDocumentCertificateInput = {
  create: DocumentBaseCreateWithoutDocumentCertificateInput;
  where: DocumentBaseWhereUniqueInput;
};

export type DocumentBaseCreateOrConnectWithoutDocumentDegreeInput = {
  create: DocumentBaseCreateWithoutDocumentDegreeInput;
  where: DocumentBaseWhereUniqueInput;
};

export type DocumentBaseCreateOrConnectWithoutDocumentFinalAcademicTranscriptInput = {
  create: DocumentBaseCreateWithoutDocumentFinalAcademicTranscriptInput;
  where: DocumentBaseWhereUniqueInput;
};

export type DocumentBaseCreateOrConnectWithoutDocumentSchoolCurriculumInput = {
  create: DocumentBaseCreateWithoutDocumentSchoolCurriculumInput;
  where: DocumentBaseWhereUniqueInput;
};

export type DocumentBaseCreateOrConnectWithoutExternalSignatureInviteInput = {
  create: DocumentBaseCreateWithoutExternalSignatureInviteInput;
  where: DocumentBaseWhereUniqueInput;
};

export type DocumentBaseCreateOrConnectWithoutHistoriesInput = {
  create: DocumentBaseCreateWithoutHistoriesInput;
  where: DocumentBaseWhereUniqueInput;
};

export type DocumentBaseCreateOrConnectWithoutTeamInput = {
  create: DocumentBaseCreateWithoutTeamInput;
  where: DocumentBaseWhereUniqueInput;
};

export type DocumentBaseCreateOrConnectWithoutUserOwnerInput = {
  create: DocumentBaseCreateWithoutUserOwnerInput;
  where: DocumentBaseWhereUniqueInput;
};

export type DocumentBaseCreateWithoutDocumentAcademicDocumentationInput = {
  DocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuerCreateNestedOneWithoutDocumentBaseInput>;
  DocumentBaseSignatureInviteGroups?: Maybe<DocumentBaseSignatureInviteGroupCreateNestedManyWithoutDocumentBaseInput>;
  DocumentCertificate?: Maybe<DocumentCertificateCreateNestedOneWithoutDocumentBaseInput>;
  DocumentDegree?: Maybe<DocumentDegreeCreateNestedOneWithoutDocumentBaseInput>;
  DocumentFinalAcademicTranscript?: Maybe<DocumentFinalAcademicTranscriptCreateNestedOneWithoutDocumentBaseInput>;
  DocumentSchoolCurriculum?: Maybe<DocumentSchoolCurriculumCreateNestedOneWithoutDocumentBaseInput>;
  ExternalSignatureInvite?: Maybe<ExternalSignatureInviteCreateNestedManyWithoutDocumentBaseInput>;
  Histories?: Maybe<DocumentBaseHistoryCreateNestedManyWithoutDocumentBaseInput>;
  Team: TeamCreateNestedOneWithoutDocumentsInput;
  UserOwner: CommonUserCreateNestedOneWithoutDocumentBaseInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationType?: Maybe<DocumentAcademicDocumentationCreationType>;
  data: Scalars['Json'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  filePath?: Maybe<Scalars['String']>;
  internalSeqId?: Maybe<Scalars['String']>;
  type: DocumentBaseType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['String']>;
  withoutTeamInternalSeqId?: Maybe<Scalars['Int']>;
};

export type DocumentBaseCreateWithoutDocumentAuditFileIssuerInput = {
  DocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationCreateNestedOneWithoutDocumentBaseInput>;
  DocumentBaseSignatureInviteGroups?: Maybe<DocumentBaseSignatureInviteGroupCreateNestedManyWithoutDocumentBaseInput>;
  DocumentCertificate?: Maybe<DocumentCertificateCreateNestedOneWithoutDocumentBaseInput>;
  DocumentDegree?: Maybe<DocumentDegreeCreateNestedOneWithoutDocumentBaseInput>;
  DocumentFinalAcademicTranscript?: Maybe<DocumentFinalAcademicTranscriptCreateNestedOneWithoutDocumentBaseInput>;
  DocumentSchoolCurriculum?: Maybe<DocumentSchoolCurriculumCreateNestedOneWithoutDocumentBaseInput>;
  ExternalSignatureInvite?: Maybe<ExternalSignatureInviteCreateNestedManyWithoutDocumentBaseInput>;
  Histories?: Maybe<DocumentBaseHistoryCreateNestedManyWithoutDocumentBaseInput>;
  Team: TeamCreateNestedOneWithoutDocumentsInput;
  UserOwner: CommonUserCreateNestedOneWithoutDocumentBaseInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationType?: Maybe<DocumentAcademicDocumentationCreationType>;
  data: Scalars['Json'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  filePath?: Maybe<Scalars['String']>;
  internalSeqId?: Maybe<Scalars['String']>;
  type: DocumentBaseType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['String']>;
  withoutTeamInternalSeqId?: Maybe<Scalars['Int']>;
};

export type DocumentBaseCreateWithoutDocumentBaseSignatureInviteGroupsInput = {
  DocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationCreateNestedOneWithoutDocumentBaseInput>;
  DocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuerCreateNestedOneWithoutDocumentBaseInput>;
  DocumentCertificate?: Maybe<DocumentCertificateCreateNestedOneWithoutDocumentBaseInput>;
  DocumentDegree?: Maybe<DocumentDegreeCreateNestedOneWithoutDocumentBaseInput>;
  DocumentFinalAcademicTranscript?: Maybe<DocumentFinalAcademicTranscriptCreateNestedOneWithoutDocumentBaseInput>;
  DocumentSchoolCurriculum?: Maybe<DocumentSchoolCurriculumCreateNestedOneWithoutDocumentBaseInput>;
  ExternalSignatureInvite?: Maybe<ExternalSignatureInviteCreateNestedManyWithoutDocumentBaseInput>;
  Histories?: Maybe<DocumentBaseHistoryCreateNestedManyWithoutDocumentBaseInput>;
  Team: TeamCreateNestedOneWithoutDocumentsInput;
  UserOwner: CommonUserCreateNestedOneWithoutDocumentBaseInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationType?: Maybe<DocumentAcademicDocumentationCreationType>;
  data: Scalars['Json'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  filePath?: Maybe<Scalars['String']>;
  internalSeqId?: Maybe<Scalars['String']>;
  type: DocumentBaseType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['String']>;
  withoutTeamInternalSeqId?: Maybe<Scalars['Int']>;
};

export type DocumentBaseCreateWithoutDocumentCertificateInput = {
  DocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationCreateNestedOneWithoutDocumentBaseInput>;
  DocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuerCreateNestedOneWithoutDocumentBaseInput>;
  DocumentBaseSignatureInviteGroups?: Maybe<DocumentBaseSignatureInviteGroupCreateNestedManyWithoutDocumentBaseInput>;
  DocumentDegree?: Maybe<DocumentDegreeCreateNestedOneWithoutDocumentBaseInput>;
  DocumentFinalAcademicTranscript?: Maybe<DocumentFinalAcademicTranscriptCreateNestedOneWithoutDocumentBaseInput>;
  DocumentSchoolCurriculum?: Maybe<DocumentSchoolCurriculumCreateNestedOneWithoutDocumentBaseInput>;
  ExternalSignatureInvite?: Maybe<ExternalSignatureInviteCreateNestedManyWithoutDocumentBaseInput>;
  Histories?: Maybe<DocumentBaseHistoryCreateNestedManyWithoutDocumentBaseInput>;
  Team: TeamCreateNestedOneWithoutDocumentsInput;
  UserOwner: CommonUserCreateNestedOneWithoutDocumentBaseInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationType?: Maybe<DocumentAcademicDocumentationCreationType>;
  data: Scalars['Json'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  filePath?: Maybe<Scalars['String']>;
  internalSeqId?: Maybe<Scalars['String']>;
  type: DocumentBaseType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['String']>;
  withoutTeamInternalSeqId?: Maybe<Scalars['Int']>;
};

export type DocumentBaseCreateWithoutDocumentDegreeInput = {
  DocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationCreateNestedOneWithoutDocumentBaseInput>;
  DocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuerCreateNestedOneWithoutDocumentBaseInput>;
  DocumentBaseSignatureInviteGroups?: Maybe<DocumentBaseSignatureInviteGroupCreateNestedManyWithoutDocumentBaseInput>;
  DocumentCertificate?: Maybe<DocumentCertificateCreateNestedOneWithoutDocumentBaseInput>;
  DocumentFinalAcademicTranscript?: Maybe<DocumentFinalAcademicTranscriptCreateNestedOneWithoutDocumentBaseInput>;
  DocumentSchoolCurriculum?: Maybe<DocumentSchoolCurriculumCreateNestedOneWithoutDocumentBaseInput>;
  ExternalSignatureInvite?: Maybe<ExternalSignatureInviteCreateNestedManyWithoutDocumentBaseInput>;
  Histories?: Maybe<DocumentBaseHistoryCreateNestedManyWithoutDocumentBaseInput>;
  Team: TeamCreateNestedOneWithoutDocumentsInput;
  UserOwner: CommonUserCreateNestedOneWithoutDocumentBaseInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationType?: Maybe<DocumentAcademicDocumentationCreationType>;
  data: Scalars['Json'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  filePath?: Maybe<Scalars['String']>;
  internalSeqId?: Maybe<Scalars['String']>;
  type: DocumentBaseType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['String']>;
  withoutTeamInternalSeqId?: Maybe<Scalars['Int']>;
};

export type DocumentBaseCreateWithoutDocumentFinalAcademicTranscriptInput = {
  DocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationCreateNestedOneWithoutDocumentBaseInput>;
  DocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuerCreateNestedOneWithoutDocumentBaseInput>;
  DocumentBaseSignatureInviteGroups?: Maybe<DocumentBaseSignatureInviteGroupCreateNestedManyWithoutDocumentBaseInput>;
  DocumentCertificate?: Maybe<DocumentCertificateCreateNestedOneWithoutDocumentBaseInput>;
  DocumentDegree?: Maybe<DocumentDegreeCreateNestedOneWithoutDocumentBaseInput>;
  DocumentSchoolCurriculum?: Maybe<DocumentSchoolCurriculumCreateNestedOneWithoutDocumentBaseInput>;
  ExternalSignatureInvite?: Maybe<ExternalSignatureInviteCreateNestedManyWithoutDocumentBaseInput>;
  Histories?: Maybe<DocumentBaseHistoryCreateNestedManyWithoutDocumentBaseInput>;
  Team: TeamCreateNestedOneWithoutDocumentsInput;
  UserOwner: CommonUserCreateNestedOneWithoutDocumentBaseInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationType?: Maybe<DocumentAcademicDocumentationCreationType>;
  data: Scalars['Json'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  filePath?: Maybe<Scalars['String']>;
  internalSeqId?: Maybe<Scalars['String']>;
  type: DocumentBaseType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['String']>;
  withoutTeamInternalSeqId?: Maybe<Scalars['Int']>;
};

export type DocumentBaseCreateWithoutDocumentSchoolCurriculumInput = {
  DocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationCreateNestedOneWithoutDocumentBaseInput>;
  DocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuerCreateNestedOneWithoutDocumentBaseInput>;
  DocumentBaseSignatureInviteGroups?: Maybe<DocumentBaseSignatureInviteGroupCreateNestedManyWithoutDocumentBaseInput>;
  DocumentCertificate?: Maybe<DocumentCertificateCreateNestedOneWithoutDocumentBaseInput>;
  DocumentDegree?: Maybe<DocumentDegreeCreateNestedOneWithoutDocumentBaseInput>;
  DocumentFinalAcademicTranscript?: Maybe<DocumentFinalAcademicTranscriptCreateNestedOneWithoutDocumentBaseInput>;
  ExternalSignatureInvite?: Maybe<ExternalSignatureInviteCreateNestedManyWithoutDocumentBaseInput>;
  Histories?: Maybe<DocumentBaseHistoryCreateNestedManyWithoutDocumentBaseInput>;
  Team: TeamCreateNestedOneWithoutDocumentsInput;
  UserOwner: CommonUserCreateNestedOneWithoutDocumentBaseInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationType?: Maybe<DocumentAcademicDocumentationCreationType>;
  data: Scalars['Json'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  filePath?: Maybe<Scalars['String']>;
  internalSeqId?: Maybe<Scalars['String']>;
  type: DocumentBaseType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['String']>;
  withoutTeamInternalSeqId?: Maybe<Scalars['Int']>;
};

export type DocumentBaseCreateWithoutExternalSignatureInviteInput = {
  DocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationCreateNestedOneWithoutDocumentBaseInput>;
  DocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuerCreateNestedOneWithoutDocumentBaseInput>;
  DocumentBaseSignatureInviteGroups?: Maybe<DocumentBaseSignatureInviteGroupCreateNestedManyWithoutDocumentBaseInput>;
  DocumentCertificate?: Maybe<DocumentCertificateCreateNestedOneWithoutDocumentBaseInput>;
  DocumentDegree?: Maybe<DocumentDegreeCreateNestedOneWithoutDocumentBaseInput>;
  DocumentFinalAcademicTranscript?: Maybe<DocumentFinalAcademicTranscriptCreateNestedOneWithoutDocumentBaseInput>;
  DocumentSchoolCurriculum?: Maybe<DocumentSchoolCurriculumCreateNestedOneWithoutDocumentBaseInput>;
  Histories?: Maybe<DocumentBaseHistoryCreateNestedManyWithoutDocumentBaseInput>;
  Team: TeamCreateNestedOneWithoutDocumentsInput;
  UserOwner: CommonUserCreateNestedOneWithoutDocumentBaseInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationType?: Maybe<DocumentAcademicDocumentationCreationType>;
  data: Scalars['Json'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  filePath?: Maybe<Scalars['String']>;
  internalSeqId?: Maybe<Scalars['String']>;
  type: DocumentBaseType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['String']>;
  withoutTeamInternalSeqId?: Maybe<Scalars['Int']>;
};

export type DocumentBaseCreateWithoutHistoriesInput = {
  DocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationCreateNestedOneWithoutDocumentBaseInput>;
  DocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuerCreateNestedOneWithoutDocumentBaseInput>;
  DocumentBaseSignatureInviteGroups?: Maybe<DocumentBaseSignatureInviteGroupCreateNestedManyWithoutDocumentBaseInput>;
  DocumentCertificate?: Maybe<DocumentCertificateCreateNestedOneWithoutDocumentBaseInput>;
  DocumentDegree?: Maybe<DocumentDegreeCreateNestedOneWithoutDocumentBaseInput>;
  DocumentFinalAcademicTranscript?: Maybe<DocumentFinalAcademicTranscriptCreateNestedOneWithoutDocumentBaseInput>;
  DocumentSchoolCurriculum?: Maybe<DocumentSchoolCurriculumCreateNestedOneWithoutDocumentBaseInput>;
  ExternalSignatureInvite?: Maybe<ExternalSignatureInviteCreateNestedManyWithoutDocumentBaseInput>;
  Team: TeamCreateNestedOneWithoutDocumentsInput;
  UserOwner: CommonUserCreateNestedOneWithoutDocumentBaseInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationType?: Maybe<DocumentAcademicDocumentationCreationType>;
  data: Scalars['Json'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  filePath?: Maybe<Scalars['String']>;
  internalSeqId?: Maybe<Scalars['String']>;
  type: DocumentBaseType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['String']>;
  withoutTeamInternalSeqId?: Maybe<Scalars['Int']>;
};

export type DocumentBaseCreateWithoutTeamInput = {
  DocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationCreateNestedOneWithoutDocumentBaseInput>;
  DocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuerCreateNestedOneWithoutDocumentBaseInput>;
  DocumentBaseSignatureInviteGroups?: Maybe<DocumentBaseSignatureInviteGroupCreateNestedManyWithoutDocumentBaseInput>;
  DocumentCertificate?: Maybe<DocumentCertificateCreateNestedOneWithoutDocumentBaseInput>;
  DocumentDegree?: Maybe<DocumentDegreeCreateNestedOneWithoutDocumentBaseInput>;
  DocumentFinalAcademicTranscript?: Maybe<DocumentFinalAcademicTranscriptCreateNestedOneWithoutDocumentBaseInput>;
  DocumentSchoolCurriculum?: Maybe<DocumentSchoolCurriculumCreateNestedOneWithoutDocumentBaseInput>;
  ExternalSignatureInvite?: Maybe<ExternalSignatureInviteCreateNestedManyWithoutDocumentBaseInput>;
  Histories?: Maybe<DocumentBaseHistoryCreateNestedManyWithoutDocumentBaseInput>;
  UserOwner: CommonUserCreateNestedOneWithoutDocumentBaseInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationType?: Maybe<DocumentAcademicDocumentationCreationType>;
  data: Scalars['Json'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  filePath?: Maybe<Scalars['String']>;
  internalSeqId?: Maybe<Scalars['String']>;
  type: DocumentBaseType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['String']>;
  withoutTeamInternalSeqId?: Maybe<Scalars['Int']>;
};

export type DocumentBaseCreateWithoutUserOwnerInput = {
  DocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationCreateNestedOneWithoutDocumentBaseInput>;
  DocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuerCreateNestedOneWithoutDocumentBaseInput>;
  DocumentBaseSignatureInviteGroups?: Maybe<DocumentBaseSignatureInviteGroupCreateNestedManyWithoutDocumentBaseInput>;
  DocumentCertificate?: Maybe<DocumentCertificateCreateNestedOneWithoutDocumentBaseInput>;
  DocumentDegree?: Maybe<DocumentDegreeCreateNestedOneWithoutDocumentBaseInput>;
  DocumentFinalAcademicTranscript?: Maybe<DocumentFinalAcademicTranscriptCreateNestedOneWithoutDocumentBaseInput>;
  DocumentSchoolCurriculum?: Maybe<DocumentSchoolCurriculumCreateNestedOneWithoutDocumentBaseInput>;
  ExternalSignatureInvite?: Maybe<ExternalSignatureInviteCreateNestedManyWithoutDocumentBaseInput>;
  Histories?: Maybe<DocumentBaseHistoryCreateNestedManyWithoutDocumentBaseInput>;
  Team: TeamCreateNestedOneWithoutDocumentsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  creationType?: Maybe<DocumentAcademicDocumentationCreationType>;
  data: Scalars['Json'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  filePath?: Maybe<Scalars['String']>;
  internalSeqId?: Maybe<Scalars['String']>;
  type: DocumentBaseType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['String']>;
  withoutTeamInternalSeqId?: Maybe<Scalars['Int']>;
};

export type DocumentBaseDefaultSignatureInviteConfiguration = {
  __typename?: 'DocumentBaseDefaultSignatureInviteConfiguration';
  Groups: Array<DocumentBaseDefaultSignatureInviteConfigurationGroup>;
  Team: Team;
  addSignersNode: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  signatureConfig: Array<SignatureType>;
  teamId: Scalars['Int'];
  type: DocumentBaseType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type DocumentBaseDefaultSignatureInviteConfigurationGroupsArgs = {
  cursor?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationAvgOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationCountOrderByAggregateInput = {
  addSignersNode?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationCreateInput = {
  Groups?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupCreateNestedManyWithoutConfigurationInput>;
  Team: TeamCreateNestedOneWithoutDefaultSignatureInviteConfigurationsInput;
  addSignersNode?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  type: DocumentBaseType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationCreateManyInput = {
  addSignersNode?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  teamId: Scalars['Int'];
  type: DocumentBaseType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationCreateManyTeamInput = {
  addSignersNode?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  type: DocumentBaseType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationCreateManyTeamInputEnvelope = {
  data: Array<DocumentBaseDefaultSignatureInviteConfigurationCreateManyTeamInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput = {
  connect?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationCreateOrConnectWithoutTeamInput>>;
  create?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationCreateWithoutTeamInput>>;
  createMany?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationCreateManyTeamInputEnvelope>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationCreateNestedOneWithoutGroupsInput = {
  connect?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationCreateOrConnectWithoutGroupsInput>;
  create?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationCreateWithoutGroupsInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationCreateOrConnectWithoutGroupsInput = {
  create: DocumentBaseDefaultSignatureInviteConfigurationCreateWithoutGroupsInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationCreateOrConnectWithoutTeamInput = {
  create: DocumentBaseDefaultSignatureInviteConfigurationCreateWithoutTeamInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationCreateWithoutGroupsInput = {
  Team: TeamCreateNestedOneWithoutDefaultSignatureInviteConfigurationsInput;
  addSignersNode?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  type: DocumentBaseType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationCreateWithoutTeamInput = {
  Groups?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupCreateNestedManyWithoutConfigurationInput>;
  addSignersNode?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  type: DocumentBaseType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroup = {
  __typename?: 'DocumentBaseDefaultSignatureInviteConfigurationGroup';
  Configuration: DocumentBaseDefaultSignatureInviteConfiguration;
  Items: Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItem>;
  configurationId: Scalars['Int'];
  id: Scalars['Int'];
  /** Order index from 0 to 2 */
  order: Scalars['Int'];
};


export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemsArgs = {
  cursor?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupAvgOrderByAggregateInput = {
  configurationId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupCountOrderByAggregateInput = {
  configurationId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupCreateInput = {
  Configuration: DocumentBaseDefaultSignatureInviteConfigurationCreateNestedOneWithoutGroupsInput;
  Items?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateNestedManyWithoutGroupInput>;
  order: Scalars['Int'];
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupCreateManyConfigurationInput = {
  id?: Maybe<Scalars['Int']>;
  order: Scalars['Int'];
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupCreateManyConfigurationInputEnvelope = {
  data: Array<DocumentBaseDefaultSignatureInviteConfigurationGroupCreateManyConfigurationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupCreateManyInput = {
  configurationId: Scalars['Int'];
  id?: Maybe<Scalars['Int']>;
  order: Scalars['Int'];
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupCreateNestedManyWithoutConfigurationInput = {
  connect?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupCreateOrConnectWithoutConfigurationInput>>;
  create?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupCreateWithoutConfigurationInput>>;
  createMany?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupCreateManyConfigurationInputEnvelope>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupCreateNestedOneWithoutItemsInput = {
  connect?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupCreateOrConnectWithoutItemsInput>;
  create?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupCreateWithoutItemsInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupCreateOrConnectWithoutConfigurationInput = {
  create: DocumentBaseDefaultSignatureInviteConfigurationGroupCreateWithoutConfigurationInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupWhereUniqueInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupCreateOrConnectWithoutItemsInput = {
  create: DocumentBaseDefaultSignatureInviteConfigurationGroupCreateWithoutItemsInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupWhereUniqueInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupCreateWithoutConfigurationInput = {
  Items?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateNestedManyWithoutGroupInput>;
  order: Scalars['Int'];
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupCreateWithoutItemsInput = {
  Configuration: DocumentBaseDefaultSignatureInviteConfigurationCreateNestedOneWithoutGroupsInput;
  order: Scalars['Int'];
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItem = {
  __typename?: 'DocumentBaseDefaultSignatureInviteConfigurationGroupItem';
  Group: DocumentBaseDefaultSignatureInviteConfigurationGroup;
  /** If empty, its a "Institutional signature" */
  TeamMember?: Maybe<TeamMember>;
  groupId: Scalars['Int'];
  id: Scalars['Int'];
  teamMemberId?: Maybe<Scalars['Int']>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemAvgOrderByAggregateInput = {
  groupId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamMemberId?: Maybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemCountOrderByAggregateInput = {
  groupId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamMemberId?: Maybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateInput = {
  Group: DocumentBaseDefaultSignatureInviteConfigurationGroupCreateNestedOneWithoutItemsInput;
  TeamMember?: Maybe<TeamMemberCreateNestedOneWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateManyGroupInput = {
  id?: Maybe<Scalars['Int']>;
  teamMemberId?: Maybe<Scalars['Int']>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateManyGroupInputEnvelope = {
  data: Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateManyGroupInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateManyInput = {
  groupId: Scalars['Int'];
  id?: Maybe<Scalars['Int']>;
  teamMemberId?: Maybe<Scalars['Int']>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateManyTeamMemberInput = {
  groupId: Scalars['Int'];
  id?: Maybe<Scalars['Int']>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateManyTeamMemberInputEnvelope = {
  data: Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateManyTeamMemberInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateNestedManyWithoutGroupInput = {
  connect?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateOrConnectWithoutGroupInput>>;
  create?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateWithoutGroupInput>>;
  createMany?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateManyGroupInputEnvelope>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateNestedManyWithoutTeamMemberInput = {
  connect?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateOrConnectWithoutTeamMemberInput>>;
  create?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateWithoutTeamMemberInput>>;
  createMany?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateManyTeamMemberInputEnvelope>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateOrConnectWithoutGroupInput = {
  create: DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateWithoutGroupInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateOrConnectWithoutTeamMemberInput = {
  create: DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateWithoutTeamMemberInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateWithoutGroupInput = {
  TeamMember?: Maybe<TeamMemberCreateNestedOneWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateWithoutTeamMemberInput = {
  Group: DocumentBaseDefaultSignatureInviteConfigurationGroupCreateNestedOneWithoutItemsInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemListRelationFilter = {
  every?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereInput>;
  none?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereInput>;
  some?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemMaxOrderByAggregateInput = {
  groupId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamMemberId?: Maybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemMinOrderByAggregateInput = {
  groupId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamMemberId?: Maybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemOrderByWithAggregationInput = {
  _avg?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemAvgOrderByAggregateInput>;
  _count?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCountOrderByAggregateInput>;
  _max?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemMaxOrderByAggregateInput>;
  _min?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemMinOrderByAggregateInput>;
  _sum?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemSumOrderByAggregateInput>;
  groupId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamMemberId?: Maybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemOrderByWithRelationInput = {
  Group?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupOrderByWithRelationInput>;
  TeamMember?: Maybe<TeamMemberOrderByWithRelationInput>;
  groupId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamMemberId?: Maybe<SortOrder>;
};

export enum DocumentBaseDefaultSignatureInviteConfigurationGroupItemScalarFieldEnum {
  GroupId = 'groupId',
  Id = 'id',
  TeamMemberId = 'teamMemberId'
}

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemScalarWhereInput = {
  AND?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemScalarWhereInput>>;
  NOT?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemScalarWhereInput>>;
  OR?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemScalarWhereInput>>;
  groupId?: Maybe<IntFilter>;
  id?: Maybe<IntFilter>;
  teamMemberId?: Maybe<IntNullableFilter>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemScalarWhereWithAggregatesInput>>;
  groupId?: Maybe<IntWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  teamMemberId?: Maybe<IntNullableWithAggregatesFilter>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemSumOrderByAggregateInput = {
  groupId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamMemberId?: Maybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateInput = {
  Group?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateOneRequiredWithoutItemsNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateOneWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsNestedInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateManyMutationInput = {
  _?: Maybe<Scalars['NEVER']>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateManyWithWhereWithoutGroupInput = {
  data: DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateManyMutationInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupItemScalarWhereInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateManyWithWhereWithoutTeamMemberInput = {
  data: DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateManyMutationInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupItemScalarWhereInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateManyWithoutGroupNestedInput = {
  connect?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateOrConnectWithoutGroupInput>>;
  create?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateWithoutGroupInput>>;
  createMany?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateManyGroupInputEnvelope>;
  delete?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput>>;
  set?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput>>;
  update?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateWithWhereUniqueWithoutGroupInput>>;
  updateMany?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateManyWithWhereWithoutGroupInput>>;
  upsert?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpsertWithWhereUniqueWithoutGroupInput>>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateManyWithoutTeamMemberNestedInput = {
  connect?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateOrConnectWithoutTeamMemberInput>>;
  create?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateWithoutTeamMemberInput>>;
  createMany?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateManyTeamMemberInputEnvelope>;
  delete?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput>>;
  set?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput>>;
  update?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateWithWhereUniqueWithoutTeamMemberInput>>;
  updateMany?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateManyWithWhereWithoutTeamMemberInput>>;
  upsert?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpsertWithWhereUniqueWithoutTeamMemberInput>>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateWithWhereUniqueWithoutGroupInput = {
  data: DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateWithoutGroupInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateWithWhereUniqueWithoutTeamMemberInput = {
  data: DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateWithoutTeamMemberInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateWithoutGroupInput = {
  TeamMember?: Maybe<TeamMemberUpdateOneWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsNestedInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateWithoutTeamMemberInput = {
  Group?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateOneRequiredWithoutItemsNestedInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpsertWithWhereUniqueWithoutGroupInput = {
  create: DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateWithoutGroupInput;
  update: DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateWithoutGroupInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpsertWithWhereUniqueWithoutTeamMemberInput = {
  create: DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateWithoutTeamMemberInput;
  update: DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateWithoutTeamMemberInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereInput = {
  AND?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereInput>>;
  Group?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>;
  NOT?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereInput>>;
  OR?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereInput>>;
  TeamMember?: Maybe<TeamMemberWhereInput>;
  groupId?: Maybe<IntFilter>;
  id?: Maybe<IntFilter>;
  teamMemberId?: Maybe<IntNullableFilter>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput = {
  AND?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereInput>>;
  Group?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>;
  NOT?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereInput>>;
  OR?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereInput>>;
  TeamMember?: Maybe<TeamMemberWhereInput>;
  groupId?: Maybe<IntFilter>;
  id?: Maybe<Scalars['Int']>;
  teamMemberId?: Maybe<IntNullableFilter>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupListRelationFilter = {
  every?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>;
  none?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>;
  some?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupMaxOrderByAggregateInput = {
  configurationId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupMinOrderByAggregateInput = {
  configurationId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupOrderByWithAggregationInput = {
  _avg?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupAvgOrderByAggregateInput>;
  _count?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupCountOrderByAggregateInput>;
  _max?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupMaxOrderByAggregateInput>;
  _min?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupMinOrderByAggregateInput>;
  _sum?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupSumOrderByAggregateInput>;
  configurationId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupOrderByWithRelationInput = {
  Configuration?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationOrderByWithRelationInput>;
  Items?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemOrderByRelationAggregateInput>;
  configurationId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupRelationFilter = {
  is?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>;
  isNot?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>;
};

export enum DocumentBaseDefaultSignatureInviteConfigurationGroupScalarFieldEnum {
  ConfigurationId = 'configurationId',
  Id = 'id',
  Order = 'order'
}

export type DocumentBaseDefaultSignatureInviteConfigurationGroupScalarWhereInput = {
  AND?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupScalarWhereInput>>;
  NOT?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupScalarWhereInput>>;
  OR?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupScalarWhereInput>>;
  configurationId?: Maybe<IntFilter>;
  id?: Maybe<IntFilter>;
  order?: Maybe<IntFilter>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupScalarWhereWithAggregatesInput>>;
  configurationId?: Maybe<IntWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  order?: Maybe<IntWithAggregatesFilter>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupSumOrderByAggregateInput = {
  configurationId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateInput = {
  Configuration?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateOneRequiredWithoutGroupsNestedInput>;
  Items?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateManyWithoutGroupNestedInput>;
  order?: Maybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateManyMutationInput = {
  order?: Maybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateManyWithWhereWithoutConfigurationInput = {
  data: DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateManyMutationInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupScalarWhereInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateManyWithoutConfigurationNestedInput = {
  connect?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupCreateOrConnectWithoutConfigurationInput>>;
  create?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupCreateWithoutConfigurationInput>>;
  createMany?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupCreateManyConfigurationInputEnvelope>;
  delete?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereUniqueInput>>;
  set?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereUniqueInput>>;
  update?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateWithWhereUniqueWithoutConfigurationInput>>;
  updateMany?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateManyWithWhereWithoutConfigurationInput>>;
  upsert?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupUpsertWithWhereUniqueWithoutConfigurationInput>>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateOneRequiredWithoutItemsNestedInput = {
  connect?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupCreateOrConnectWithoutItemsInput>;
  create?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupCreateWithoutItemsInput>;
  update?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateToOneWithWhereWithoutItemsInput>;
  upsert?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupUpsertWithoutItemsInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateToOneWithWhereWithoutItemsInput = {
  data: DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateWithoutItemsInput;
  where?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateWithWhereUniqueWithoutConfigurationInput = {
  data: DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateWithoutConfigurationInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupWhereUniqueInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateWithoutConfigurationInput = {
  Items?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateManyWithoutGroupNestedInput>;
  order?: Maybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateWithoutItemsInput = {
  Configuration?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateOneRequiredWithoutGroupsNestedInput>;
  order?: Maybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupUpsertWithWhereUniqueWithoutConfigurationInput = {
  create: DocumentBaseDefaultSignatureInviteConfigurationGroupCreateWithoutConfigurationInput;
  update: DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateWithoutConfigurationInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupWhereUniqueInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupUpsertWithoutItemsInput = {
  create: DocumentBaseDefaultSignatureInviteConfigurationGroupCreateWithoutItemsInput;
  update: DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateWithoutItemsInput;
  where?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput = {
  AND?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>>;
  Configuration?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>;
  Items?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemListRelationFilter>;
  NOT?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>>;
  OR?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>>;
  configurationId?: Maybe<IntFilter>;
  id?: Maybe<IntFilter>;
  order?: Maybe<IntFilter>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupWhereUniqueInput = {
  AND?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>>;
  Configuration?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>;
  Items?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemListRelationFilter>;
  NOT?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>>;
  OR?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>>;
  configurationId?: Maybe<IntFilter>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<IntFilter>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationListRelationFilter = {
  every?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>;
  none?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>;
  some?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationMaxOrderByAggregateInput = {
  addSignersNode?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationMinOrderByAggregateInput = {
  addSignersNode?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationOrderByWithAggregationInput = {
  _avg?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationAvgOrderByAggregateInput>;
  _count?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationCountOrderByAggregateInput>;
  _max?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationMaxOrderByAggregateInput>;
  _min?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationMinOrderByAggregateInput>;
  _sum?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationSumOrderByAggregateInput>;
  addSignersNode?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationOrderByWithRelationInput = {
  Groups?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupOrderByRelationAggregateInput>;
  Team?: Maybe<TeamOrderByWithRelationInput>;
  addSignersNode?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationRelationFilter = {
  is?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>;
  isNot?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>;
};

export enum DocumentBaseDefaultSignatureInviteConfigurationScalarFieldEnum {
  AddSignersNode = 'addSignersNode',
  CreatedAt = 'createdAt',
  Id = 'id',
  TeamId = 'teamId',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type DocumentBaseDefaultSignatureInviteConfigurationScalarWhereInput = {
  AND?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationScalarWhereInput>>;
  NOT?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationScalarWhereInput>>;
  OR?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationScalarWhereInput>>;
  addSignersNode?: Maybe<BoolFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  teamId?: Maybe<IntFilter>;
  type?: Maybe<EnumDocumentBaseTypeFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationScalarWhereWithAggregatesInput>>;
  addSignersNode?: Maybe<BoolWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  teamId?: Maybe<IntWithAggregatesFilter>;
  type?: Maybe<EnumDocumentBaseTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationSumOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationTeamIdTypeCompoundUniqueInput = {
  teamId: Scalars['Int'];
  type: DocumentBaseType;
};

export type DocumentBaseDefaultSignatureInviteConfigurationUpdateInput = {
  Groups?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateManyWithoutConfigurationNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutDefaultSignatureInviteConfigurationsNestedInput>;
  addSignersNode?: Maybe<BoolFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  type?: Maybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationUpdateManyMutationInput = {
  addSignersNode?: Maybe<BoolFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  type?: Maybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithWhereWithoutTeamInput = {
  data: DocumentBaseDefaultSignatureInviteConfigurationUpdateManyMutationInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationScalarWhereInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput = {
  connect?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationCreateOrConnectWithoutTeamInput>>;
  create?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationCreateWithoutTeamInput>>;
  createMany?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationCreateManyTeamInputEnvelope>;
  delete?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput>>;
  set?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput>>;
  update?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationUpdateWithWhereUniqueWithoutTeamInput>>;
  updateMany?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithWhereWithoutTeamInput>>;
  upsert?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationUpsertWithWhereUniqueWithoutTeamInput>>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationUpdateOneRequiredWithoutGroupsNestedInput = {
  connect?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationCreateOrConnectWithoutGroupsInput>;
  create?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationCreateWithoutGroupsInput>;
  update?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateToOneWithWhereWithoutGroupsInput>;
  upsert?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationUpsertWithoutGroupsInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationUpdateToOneWithWhereWithoutGroupsInput = {
  data: DocumentBaseDefaultSignatureInviteConfigurationUpdateWithoutGroupsInput;
  where?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationUpdateWithWhereUniqueWithoutTeamInput = {
  data: DocumentBaseDefaultSignatureInviteConfigurationUpdateWithoutTeamInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationUpdateWithoutGroupsInput = {
  Team?: Maybe<TeamUpdateOneRequiredWithoutDefaultSignatureInviteConfigurationsNestedInput>;
  addSignersNode?: Maybe<BoolFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  type?: Maybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationUpdateWithoutTeamInput = {
  Groups?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateManyWithoutConfigurationNestedInput>;
  addSignersNode?: Maybe<BoolFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  type?: Maybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationUpsertWithWhereUniqueWithoutTeamInput = {
  create: DocumentBaseDefaultSignatureInviteConfigurationCreateWithoutTeamInput;
  update: DocumentBaseDefaultSignatureInviteConfigurationUpdateWithoutTeamInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationUpsertWithoutGroupsInput = {
  create: DocumentBaseDefaultSignatureInviteConfigurationCreateWithoutGroupsInput;
  update: DocumentBaseDefaultSignatureInviteConfigurationUpdateWithoutGroupsInput;
  where?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationWhereInput = {
  AND?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>>;
  Groups?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupListRelationFilter>;
  NOT?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>>;
  OR?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>>;
  Team?: Maybe<TeamWhereInput>;
  addSignersNode?: Maybe<BoolFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  teamId?: Maybe<IntFilter>;
  type?: Maybe<EnumDocumentBaseTypeFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput = {
  AND?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>>;
  Groups?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupListRelationFilter>;
  NOT?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>>;
  OR?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>>;
  Team?: Maybe<TeamWhereInput>;
  addSignersNode?: Maybe<BoolFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['Int']>;
  teamId?: Maybe<IntFilter>;
  teamId_type?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationTeamIdTypeCompoundUniqueInput>;
  type?: Maybe<EnumDocumentBaseTypeFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
};

export type DocumentBaseHistory = {
  __typename?: 'DocumentBaseHistory';
  DocumentBase: DocumentBase;
  UserCreated?: Maybe<CommonUser>;
  commonUserCreatedId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  /** ![PrismaJson.AnyJson] */
  data?: Maybe<Scalars['Json']>;
  /** Reproval reason, revoke reason? -- Documento deletado, validação rápida */
  description?: Maybe<Scalars['String']>;
  documentBaseId: Scalars['String'];
  id: Scalars['Int'];
  status?: Maybe<Scalars['String']>;
};

export type DocumentBaseHistoryAvgOrderByAggregateInput = {
  commonUserCreatedId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type DocumentBaseHistoryCountOrderByAggregateInput = {
  commonUserCreatedId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  data?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  documentBaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type DocumentBaseHistoryCreateInput = {
  DocumentBase: DocumentBaseCreateNestedOneWithoutHistoriesInput;
  UserCreated?: Maybe<CommonUserCreateNestedOneWithoutDocumentBaseHistoryInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['Json']>;
  description?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type DocumentBaseHistoryCreateManyDocumentBaseInput = {
  commonUserCreatedId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['Json']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
};

export type DocumentBaseHistoryCreateManyDocumentBaseInputEnvelope = {
  data: Array<DocumentBaseHistoryCreateManyDocumentBaseInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentBaseHistoryCreateManyInput = {
  commonUserCreatedId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['Json']>;
  description?: Maybe<Scalars['String']>;
  documentBaseId: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
};

export type DocumentBaseHistoryCreateManyUserCreatedInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['Json']>;
  description?: Maybe<Scalars['String']>;
  documentBaseId: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
};

export type DocumentBaseHistoryCreateManyUserCreatedInputEnvelope = {
  data: Array<DocumentBaseHistoryCreateManyUserCreatedInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentBaseHistoryCreateNestedManyWithoutDocumentBaseInput = {
  connect?: Maybe<Array<DocumentBaseHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentBaseHistoryCreateOrConnectWithoutDocumentBaseInput>>;
  create?: Maybe<Array<DocumentBaseHistoryCreateWithoutDocumentBaseInput>>;
  createMany?: Maybe<DocumentBaseHistoryCreateManyDocumentBaseInputEnvelope>;
};

export type DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput = {
  connect?: Maybe<Array<DocumentBaseHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentBaseHistoryCreateOrConnectWithoutUserCreatedInput>>;
  create?: Maybe<Array<DocumentBaseHistoryCreateWithoutUserCreatedInput>>;
  createMany?: Maybe<DocumentBaseHistoryCreateManyUserCreatedInputEnvelope>;
};

export type DocumentBaseHistoryCreateOrConnectWithoutDocumentBaseInput = {
  create: DocumentBaseHistoryCreateWithoutDocumentBaseInput;
  where: DocumentBaseHistoryWhereUniqueInput;
};

export type DocumentBaseHistoryCreateOrConnectWithoutUserCreatedInput = {
  create: DocumentBaseHistoryCreateWithoutUserCreatedInput;
  where: DocumentBaseHistoryWhereUniqueInput;
};

export type DocumentBaseHistoryCreateWithoutDocumentBaseInput = {
  UserCreated?: Maybe<CommonUserCreateNestedOneWithoutDocumentBaseHistoryInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['Json']>;
  description?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type DocumentBaseHistoryCreateWithoutUserCreatedInput = {
  DocumentBase: DocumentBaseCreateNestedOneWithoutHistoriesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['Json']>;
  description?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type DocumentBaseHistoryListRelationFilter = {
  every?: Maybe<DocumentBaseHistoryWhereInput>;
  none?: Maybe<DocumentBaseHistoryWhereInput>;
  some?: Maybe<DocumentBaseHistoryWhereInput>;
};

export type DocumentBaseHistoryMaxOrderByAggregateInput = {
  commonUserCreatedId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  documentBaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type DocumentBaseHistoryMinOrderByAggregateInput = {
  commonUserCreatedId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  documentBaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type DocumentBaseHistoryOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type DocumentBaseHistoryOrderByWithAggregationInput = {
  _avg?: Maybe<DocumentBaseHistoryAvgOrderByAggregateInput>;
  _count?: Maybe<DocumentBaseHistoryCountOrderByAggregateInput>;
  _max?: Maybe<DocumentBaseHistoryMaxOrderByAggregateInput>;
  _min?: Maybe<DocumentBaseHistoryMinOrderByAggregateInput>;
  _sum?: Maybe<DocumentBaseHistorySumOrderByAggregateInput>;
  commonUserCreatedId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  data?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  documentBaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type DocumentBaseHistoryOrderByWithRelationInput = {
  DocumentBase?: Maybe<DocumentBaseOrderByWithRelationInput>;
  UserCreated?: Maybe<CommonUserOrderByWithRelationInput>;
  commonUserCreatedId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  data?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  documentBaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export enum DocumentBaseHistoryScalarFieldEnum {
  CommonUserCreatedId = 'commonUserCreatedId',
  CreatedAt = 'createdAt',
  Data = 'data',
  Description = 'description',
  DocumentBaseId = 'documentBaseId',
  Id = 'id',
  Status = 'status'
}

export type DocumentBaseHistoryScalarWhereInput = {
  AND?: Maybe<Array<DocumentBaseHistoryScalarWhereInput>>;
  NOT?: Maybe<Array<DocumentBaseHistoryScalarWhereInput>>;
  OR?: Maybe<Array<DocumentBaseHistoryScalarWhereInput>>;
  commonUserCreatedId?: Maybe<IntNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  data?: Maybe<JsonNullableFilter>;
  description?: Maybe<StringNullableFilter>;
  documentBaseId?: Maybe<StringFilter>;
  id?: Maybe<IntFilter>;
  status?: Maybe<StringNullableFilter>;
};

export type DocumentBaseHistoryScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<DocumentBaseHistoryScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<DocumentBaseHistoryScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<DocumentBaseHistoryScalarWhereWithAggregatesInput>>;
  commonUserCreatedId?: Maybe<IntNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  data?: Maybe<JsonNullableWithAggregatesFilter>;
  description?: Maybe<StringNullableWithAggregatesFilter>;
  documentBaseId?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  status?: Maybe<StringNullableWithAggregatesFilter>;
};

export type DocumentBaseHistorySumOrderByAggregateInput = {
  commonUserCreatedId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type DocumentBaseHistoryUpdateInput = {
  DocumentBase?: Maybe<DocumentBaseUpdateOneRequiredWithoutHistoriesNestedInput>;
  UserCreated?: Maybe<CommonUserUpdateOneWithoutDocumentBaseHistoryNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  data?: Maybe<Scalars['Json']>;
  description?: Maybe<NullableStringFieldUpdateOperationsInput>;
  status?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type DocumentBaseHistoryUpdateManyMutationInput = {
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  data?: Maybe<Scalars['Json']>;
  description?: Maybe<NullableStringFieldUpdateOperationsInput>;
  status?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type DocumentBaseHistoryUpdateManyWithWhereWithoutDocumentBaseInput = {
  data: DocumentBaseHistoryUpdateManyMutationInput;
  where: DocumentBaseHistoryScalarWhereInput;
};

export type DocumentBaseHistoryUpdateManyWithWhereWithoutUserCreatedInput = {
  data: DocumentBaseHistoryUpdateManyMutationInput;
  where: DocumentBaseHistoryScalarWhereInput;
};

export type DocumentBaseHistoryUpdateManyWithoutDocumentBaseNestedInput = {
  connect?: Maybe<Array<DocumentBaseHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentBaseHistoryCreateOrConnectWithoutDocumentBaseInput>>;
  create?: Maybe<Array<DocumentBaseHistoryCreateWithoutDocumentBaseInput>>;
  createMany?: Maybe<DocumentBaseHistoryCreateManyDocumentBaseInputEnvelope>;
  delete?: Maybe<Array<DocumentBaseHistoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentBaseHistoryScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentBaseHistoryWhereUniqueInput>>;
  set?: Maybe<Array<DocumentBaseHistoryWhereUniqueInput>>;
  update?: Maybe<Array<DocumentBaseHistoryUpdateWithWhereUniqueWithoutDocumentBaseInput>>;
  updateMany?: Maybe<Array<DocumentBaseHistoryUpdateManyWithWhereWithoutDocumentBaseInput>>;
  upsert?: Maybe<Array<DocumentBaseHistoryUpsertWithWhereUniqueWithoutDocumentBaseInput>>;
};

export type DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput = {
  connect?: Maybe<Array<DocumentBaseHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentBaseHistoryCreateOrConnectWithoutUserCreatedInput>>;
  create?: Maybe<Array<DocumentBaseHistoryCreateWithoutUserCreatedInput>>;
  createMany?: Maybe<DocumentBaseHistoryCreateManyUserCreatedInputEnvelope>;
  delete?: Maybe<Array<DocumentBaseHistoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentBaseHistoryScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentBaseHistoryWhereUniqueInput>>;
  set?: Maybe<Array<DocumentBaseHistoryWhereUniqueInput>>;
  update?: Maybe<Array<DocumentBaseHistoryUpdateWithWhereUniqueWithoutUserCreatedInput>>;
  updateMany?: Maybe<Array<DocumentBaseHistoryUpdateManyWithWhereWithoutUserCreatedInput>>;
  upsert?: Maybe<Array<DocumentBaseHistoryUpsertWithWhereUniqueWithoutUserCreatedInput>>;
};

export type DocumentBaseHistoryUpdateWithWhereUniqueWithoutDocumentBaseInput = {
  data: DocumentBaseHistoryUpdateWithoutDocumentBaseInput;
  where: DocumentBaseHistoryWhereUniqueInput;
};

export type DocumentBaseHistoryUpdateWithWhereUniqueWithoutUserCreatedInput = {
  data: DocumentBaseHistoryUpdateWithoutUserCreatedInput;
  where: DocumentBaseHistoryWhereUniqueInput;
};

export type DocumentBaseHistoryUpdateWithoutDocumentBaseInput = {
  UserCreated?: Maybe<CommonUserUpdateOneWithoutDocumentBaseHistoryNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  data?: Maybe<Scalars['Json']>;
  description?: Maybe<NullableStringFieldUpdateOperationsInput>;
  status?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type DocumentBaseHistoryUpdateWithoutUserCreatedInput = {
  DocumentBase?: Maybe<DocumentBaseUpdateOneRequiredWithoutHistoriesNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  data?: Maybe<Scalars['Json']>;
  description?: Maybe<NullableStringFieldUpdateOperationsInput>;
  status?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type DocumentBaseHistoryUpsertWithWhereUniqueWithoutDocumentBaseInput = {
  create: DocumentBaseHistoryCreateWithoutDocumentBaseInput;
  update: DocumentBaseHistoryUpdateWithoutDocumentBaseInput;
  where: DocumentBaseHistoryWhereUniqueInput;
};

export type DocumentBaseHistoryUpsertWithWhereUniqueWithoutUserCreatedInput = {
  create: DocumentBaseHistoryCreateWithoutUserCreatedInput;
  update: DocumentBaseHistoryUpdateWithoutUserCreatedInput;
  where: DocumentBaseHistoryWhereUniqueInput;
};

export type DocumentBaseHistoryWhereInput = {
  AND?: Maybe<Array<DocumentBaseHistoryWhereInput>>;
  DocumentBase?: Maybe<DocumentBaseWhereInput>;
  NOT?: Maybe<Array<DocumentBaseHistoryWhereInput>>;
  OR?: Maybe<Array<DocumentBaseHistoryWhereInput>>;
  UserCreated?: Maybe<CommonUserWhereInput>;
  commonUserCreatedId?: Maybe<IntNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  data?: Maybe<JsonNullableFilter>;
  description?: Maybe<StringNullableFilter>;
  documentBaseId?: Maybe<StringFilter>;
  id?: Maybe<IntFilter>;
  status?: Maybe<StringNullableFilter>;
};

export type DocumentBaseHistoryWhereUniqueInput = {
  AND?: Maybe<Array<DocumentBaseHistoryWhereInput>>;
  DocumentBase?: Maybe<DocumentBaseWhereInput>;
  NOT?: Maybe<Array<DocumentBaseHistoryWhereInput>>;
  OR?: Maybe<Array<DocumentBaseHistoryWhereInput>>;
  UserCreated?: Maybe<CommonUserWhereInput>;
  commonUserCreatedId?: Maybe<IntNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  data?: Maybe<JsonNullableFilter>;
  description?: Maybe<StringNullableFilter>;
  documentBaseId?: Maybe<StringFilter>;
  id?: Maybe<Scalars['Int']>;
  status?: Maybe<StringNullableFilter>;
};

export type DocumentBaseListRelationFilter = {
  every?: Maybe<DocumentBaseWhereInput>;
  none?: Maybe<DocumentBaseWhereInput>;
  some?: Maybe<DocumentBaseWhereInput>;
};

export type DocumentBaseMaxOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  creationType?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  filePath?: Maybe<SortOrder>;
  internalSeqId?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  version?: Maybe<SortOrder>;
  withoutTeamInternalSeqId?: Maybe<SortOrder>;
};

export type DocumentBaseMinOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  creationType?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  filePath?: Maybe<SortOrder>;
  internalSeqId?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  version?: Maybe<SortOrder>;
  withoutTeamInternalSeqId?: Maybe<SortOrder>;
};

export type DocumentBaseOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type DocumentBaseOrderByWithAggregationInput = {
  _avg?: Maybe<DocumentBaseAvgOrderByAggregateInput>;
  _count?: Maybe<DocumentBaseCountOrderByAggregateInput>;
  _max?: Maybe<DocumentBaseMaxOrderByAggregateInput>;
  _min?: Maybe<DocumentBaseMinOrderByAggregateInput>;
  _sum?: Maybe<DocumentBaseSumOrderByAggregateInput>;
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  creationType?: Maybe<SortOrder>;
  data?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  filePath?: Maybe<SortOrder>;
  internalSeqId?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  version?: Maybe<SortOrder>;
  withoutTeamInternalSeqId?: Maybe<SortOrder>;
};

export type DocumentBaseOrderByWithRelationInput = {
  DocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationOrderByWithRelationInput>;
  DocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuerOrderByWithRelationInput>;
  DocumentBaseSignatureInviteGroups?: Maybe<DocumentBaseSignatureInviteGroupOrderByRelationAggregateInput>;
  DocumentCertificate?: Maybe<DocumentCertificateOrderByWithRelationInput>;
  DocumentDegree?: Maybe<DocumentDegreeOrderByWithRelationInput>;
  DocumentFinalAcademicTranscript?: Maybe<DocumentFinalAcademicTranscriptOrderByWithRelationInput>;
  DocumentSchoolCurriculum?: Maybe<DocumentSchoolCurriculumOrderByWithRelationInput>;
  ExternalSignatureInvite?: Maybe<ExternalSignatureInviteOrderByRelationAggregateInput>;
  Histories?: Maybe<DocumentBaseHistoryOrderByRelationAggregateInput>;
  Team?: Maybe<TeamOrderByWithRelationInput>;
  UserOwner?: Maybe<CommonUserOrderByWithRelationInput>;
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  creationType?: Maybe<SortOrder>;
  data?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  filePath?: Maybe<SortOrder>;
  internalSeqId?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  version?: Maybe<SortOrder>;
  withoutTeamInternalSeqId?: Maybe<SortOrder>;
};

export type DocumentBaseRelationFilter = {
  is?: Maybe<DocumentBaseWhereInput>;
  isNot?: Maybe<DocumentBaseWhereInput>;
};

export enum DocumentBaseScalarFieldEnum {
  CommonUserId = 'commonUserId',
  CreatedAt = 'createdAt',
  CreationType = 'creationType',
  Data = 'data',
  DeletedAt = 'deletedAt',
  FilePath = 'filePath',
  InternalSeqId = 'internalSeqId',
  TeamId = 'teamId',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  Version = 'version',
  WithoutTeamInternalSeqId = 'withoutTeamInternalSeqId'
}

export type DocumentBaseScalarWhereInput = {
  AND?: Maybe<Array<DocumentBaseScalarWhereInput>>;
  NOT?: Maybe<Array<DocumentBaseScalarWhereInput>>;
  OR?: Maybe<Array<DocumentBaseScalarWhereInput>>;
  commonUserId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  creationType?: Maybe<EnumDocumentAcademicDocumentationCreationTypeFilter>;
  data?: Maybe<JsonFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  filePath?: Maybe<StringNullableFilter>;
  internalSeqId?: Maybe<StringFilter>;
  teamId?: Maybe<IntFilter>;
  type?: Maybe<EnumDocumentBaseTypeFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
  version?: Maybe<StringFilter>;
  withoutTeamInternalSeqId?: Maybe<IntFilter>;
};

export type DocumentBaseScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<DocumentBaseScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<DocumentBaseScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<DocumentBaseScalarWhereWithAggregatesInput>>;
  commonUserId?: Maybe<IntWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  creationType?: Maybe<EnumDocumentAcademicDocumentationCreationTypeWithAggregatesFilter>;
  data?: Maybe<JsonWithAggregatesFilter>;
  deletedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  filePath?: Maybe<StringNullableWithAggregatesFilter>;
  internalSeqId?: Maybe<StringWithAggregatesFilter>;
  teamId?: Maybe<IntWithAggregatesFilter>;
  type?: Maybe<EnumDocumentBaseTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  version?: Maybe<StringWithAggregatesFilter>;
  withoutTeamInternalSeqId?: Maybe<IntWithAggregatesFilter>;
};

export type DocumentBaseSignatureInvite = {
  __typename?: 'DocumentBaseSignatureInvite';
  Group: DocumentBaseSignatureInviteGroup;
  Signatures: Array<DocumentBaseSignatureInviteSignature>;
  /** If empty, its a "Institutional signature" */
  TeamMember?: Maybe<TeamMember>;
  createdAt: Scalars['DateTime'];
  groupId: Scalars['Int'];
  id: Scalars['Int'];
  teamMemberId?: Maybe<Scalars['Int']>;
};


export type DocumentBaseSignatureInviteSignaturesArgs = {
  cursor?: Maybe<DocumentBaseSignatureInviteSignatureWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseSignatureInviteSignatureScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseSignatureInviteSignatureOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseSignatureInviteSignatureWhereInput>;
};

export type DocumentBaseSignatureInviteAvgOrderByAggregateInput = {
  groupId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamMemberId?: Maybe<SortOrder>;
};

export type DocumentBaseSignatureInviteCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  groupId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamMemberId?: Maybe<SortOrder>;
};

export type DocumentBaseSignatureInviteCreateInput = {
  Group: DocumentBaseSignatureInviteGroupCreateNestedOneWithoutInvitesInput;
  Signatures?: Maybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutInviteInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedOneWithoutInvitesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentBaseSignatureInviteCreateManyGroupInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  teamMemberId?: Maybe<Scalars['Int']>;
};

export type DocumentBaseSignatureInviteCreateManyGroupInputEnvelope = {
  data: Array<DocumentBaseSignatureInviteCreateManyGroupInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentBaseSignatureInviteCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  groupId: Scalars['Int'];
  id?: Maybe<Scalars['Int']>;
  teamMemberId?: Maybe<Scalars['Int']>;
};

export type DocumentBaseSignatureInviteCreateManyTeamMemberInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  groupId: Scalars['Int'];
  id?: Maybe<Scalars['Int']>;
};

export type DocumentBaseSignatureInviteCreateManyTeamMemberInputEnvelope = {
  data: Array<DocumentBaseSignatureInviteCreateManyTeamMemberInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentBaseSignatureInviteCreateNestedManyWithoutGroupInput = {
  connect?: Maybe<Array<DocumentBaseSignatureInviteWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentBaseSignatureInviteCreateOrConnectWithoutGroupInput>>;
  create?: Maybe<Array<DocumentBaseSignatureInviteCreateWithoutGroupInput>>;
  createMany?: Maybe<DocumentBaseSignatureInviteCreateManyGroupInputEnvelope>;
};

export type DocumentBaseSignatureInviteCreateNestedManyWithoutTeamMemberInput = {
  connect?: Maybe<Array<DocumentBaseSignatureInviteWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentBaseSignatureInviteCreateOrConnectWithoutTeamMemberInput>>;
  create?: Maybe<Array<DocumentBaseSignatureInviteCreateWithoutTeamMemberInput>>;
  createMany?: Maybe<DocumentBaseSignatureInviteCreateManyTeamMemberInputEnvelope>;
};

export type DocumentBaseSignatureInviteCreateNestedOneWithoutSignaturesInput = {
  connect?: Maybe<DocumentBaseSignatureInviteWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentBaseSignatureInviteCreateOrConnectWithoutSignaturesInput>;
  create?: Maybe<DocumentBaseSignatureInviteCreateWithoutSignaturesInput>;
};

export type DocumentBaseSignatureInviteCreateOrConnectWithoutGroupInput = {
  create: DocumentBaseSignatureInviteCreateWithoutGroupInput;
  where: DocumentBaseSignatureInviteWhereUniqueInput;
};

export type DocumentBaseSignatureInviteCreateOrConnectWithoutSignaturesInput = {
  create: DocumentBaseSignatureInviteCreateWithoutSignaturesInput;
  where: DocumentBaseSignatureInviteWhereUniqueInput;
};

export type DocumentBaseSignatureInviteCreateOrConnectWithoutTeamMemberInput = {
  create: DocumentBaseSignatureInviteCreateWithoutTeamMemberInput;
  where: DocumentBaseSignatureInviteWhereUniqueInput;
};

export type DocumentBaseSignatureInviteCreateWithoutGroupInput = {
  Signatures?: Maybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutInviteInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedOneWithoutInvitesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentBaseSignatureInviteCreateWithoutSignaturesInput = {
  Group: DocumentBaseSignatureInviteGroupCreateNestedOneWithoutInvitesInput;
  TeamMember?: Maybe<TeamMemberCreateNestedOneWithoutInvitesInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentBaseSignatureInviteCreateWithoutTeamMemberInput = {
  Group: DocumentBaseSignatureInviteGroupCreateNestedOneWithoutInvitesInput;
  Signatures?: Maybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutInviteInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentBaseSignatureInviteGroup = {
  __typename?: 'DocumentBaseSignatureInviteGroup';
  DocumentBase: DocumentBase;
  Invites: Array<DocumentBaseSignatureInvite>;
  createdAt: Scalars['DateTime'];
  documentBaseId: Scalars['String'];
  id: Scalars['Int'];
  order: Scalars['Int'];
};


export type DocumentBaseSignatureInviteGroupInvitesArgs = {
  cursor?: Maybe<DocumentBaseSignatureInviteWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseSignatureInviteScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseSignatureInviteOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseSignatureInviteWhereInput>;
};

export type DocumentBaseSignatureInviteGroupAvgOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
};

export type DocumentBaseSignatureInviteGroupCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  documentBaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
};

export type DocumentBaseSignatureInviteGroupCreateInput = {
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentBaseSignatureInviteGroupsInput;
  Invites?: Maybe<DocumentBaseSignatureInviteCreateNestedManyWithoutGroupInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  order: Scalars['Int'];
};

export type DocumentBaseSignatureInviteGroupCreateManyDocumentBaseInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  order: Scalars['Int'];
};

export type DocumentBaseSignatureInviteGroupCreateManyDocumentBaseInputEnvelope = {
  data: Array<DocumentBaseSignatureInviteGroupCreateManyDocumentBaseInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentBaseSignatureInviteGroupCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  documentBaseId: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  order: Scalars['Int'];
};

export type DocumentBaseSignatureInviteGroupCreateNestedManyWithoutDocumentBaseInput = {
  connect?: Maybe<Array<DocumentBaseSignatureInviteGroupWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentBaseSignatureInviteGroupCreateOrConnectWithoutDocumentBaseInput>>;
  create?: Maybe<Array<DocumentBaseSignatureInviteGroupCreateWithoutDocumentBaseInput>>;
  createMany?: Maybe<DocumentBaseSignatureInviteGroupCreateManyDocumentBaseInputEnvelope>;
};

export type DocumentBaseSignatureInviteGroupCreateNestedOneWithoutInvitesInput = {
  connect?: Maybe<DocumentBaseSignatureInviteGroupWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentBaseSignatureInviteGroupCreateOrConnectWithoutInvitesInput>;
  create?: Maybe<DocumentBaseSignatureInviteGroupCreateWithoutInvitesInput>;
};

export type DocumentBaseSignatureInviteGroupCreateOrConnectWithoutDocumentBaseInput = {
  create: DocumentBaseSignatureInviteGroupCreateWithoutDocumentBaseInput;
  where: DocumentBaseSignatureInviteGroupWhereUniqueInput;
};

export type DocumentBaseSignatureInviteGroupCreateOrConnectWithoutInvitesInput = {
  create: DocumentBaseSignatureInviteGroupCreateWithoutInvitesInput;
  where: DocumentBaseSignatureInviteGroupWhereUniqueInput;
};

export type DocumentBaseSignatureInviteGroupCreateWithoutDocumentBaseInput = {
  Invites?: Maybe<DocumentBaseSignatureInviteCreateNestedManyWithoutGroupInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  order: Scalars['Int'];
};

export type DocumentBaseSignatureInviteGroupCreateWithoutInvitesInput = {
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentBaseSignatureInviteGroupsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  order: Scalars['Int'];
};

export type DocumentBaseSignatureInviteGroupListRelationFilter = {
  every?: Maybe<DocumentBaseSignatureInviteGroupWhereInput>;
  none?: Maybe<DocumentBaseSignatureInviteGroupWhereInput>;
  some?: Maybe<DocumentBaseSignatureInviteGroupWhereInput>;
};

export type DocumentBaseSignatureInviteGroupMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  documentBaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
};

export type DocumentBaseSignatureInviteGroupMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  documentBaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
};

export type DocumentBaseSignatureInviteGroupOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type DocumentBaseSignatureInviteGroupOrderByWithAggregationInput = {
  _avg?: Maybe<DocumentBaseSignatureInviteGroupAvgOrderByAggregateInput>;
  _count?: Maybe<DocumentBaseSignatureInviteGroupCountOrderByAggregateInput>;
  _max?: Maybe<DocumentBaseSignatureInviteGroupMaxOrderByAggregateInput>;
  _min?: Maybe<DocumentBaseSignatureInviteGroupMinOrderByAggregateInput>;
  _sum?: Maybe<DocumentBaseSignatureInviteGroupSumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  documentBaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
};

export type DocumentBaseSignatureInviteGroupOrderByWithRelationInput = {
  DocumentBase?: Maybe<DocumentBaseOrderByWithRelationInput>;
  Invites?: Maybe<DocumentBaseSignatureInviteOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  documentBaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
};

export type DocumentBaseSignatureInviteGroupRelationFilter = {
  is?: Maybe<DocumentBaseSignatureInviteGroupWhereInput>;
  isNot?: Maybe<DocumentBaseSignatureInviteGroupWhereInput>;
};

export enum DocumentBaseSignatureInviteGroupScalarFieldEnum {
  CreatedAt = 'createdAt',
  DocumentBaseId = 'documentBaseId',
  Id = 'id',
  Order = 'order'
}

export type DocumentBaseSignatureInviteGroupScalarWhereInput = {
  AND?: Maybe<Array<DocumentBaseSignatureInviteGroupScalarWhereInput>>;
  NOT?: Maybe<Array<DocumentBaseSignatureInviteGroupScalarWhereInput>>;
  OR?: Maybe<Array<DocumentBaseSignatureInviteGroupScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  documentBaseId?: Maybe<StringFilter>;
  id?: Maybe<IntFilter>;
  order?: Maybe<IntFilter>;
};

export type DocumentBaseSignatureInviteGroupScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<DocumentBaseSignatureInviteGroupScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<DocumentBaseSignatureInviteGroupScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<DocumentBaseSignatureInviteGroupScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  documentBaseId?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  order?: Maybe<IntWithAggregatesFilter>;
};

export type DocumentBaseSignatureInviteGroupSumOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  order?: Maybe<SortOrder>;
};

export type DocumentBaseSignatureInviteGroupUpdateInput = {
  DocumentBase?: Maybe<DocumentBaseUpdateOneRequiredWithoutDocumentBaseSignatureInviteGroupsNestedInput>;
  Invites?: Maybe<DocumentBaseSignatureInviteUpdateManyWithoutGroupNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  order?: Maybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseSignatureInviteGroupUpdateManyMutationInput = {
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  order?: Maybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseSignatureInviteGroupUpdateManyWithWhereWithoutDocumentBaseInput = {
  data: DocumentBaseSignatureInviteGroupUpdateManyMutationInput;
  where: DocumentBaseSignatureInviteGroupScalarWhereInput;
};

export type DocumentBaseSignatureInviteGroupUpdateManyWithoutDocumentBaseNestedInput = {
  connect?: Maybe<Array<DocumentBaseSignatureInviteGroupWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentBaseSignatureInviteGroupCreateOrConnectWithoutDocumentBaseInput>>;
  create?: Maybe<Array<DocumentBaseSignatureInviteGroupCreateWithoutDocumentBaseInput>>;
  createMany?: Maybe<DocumentBaseSignatureInviteGroupCreateManyDocumentBaseInputEnvelope>;
  delete?: Maybe<Array<DocumentBaseSignatureInviteGroupWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentBaseSignatureInviteGroupScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentBaseSignatureInviteGroupWhereUniqueInput>>;
  set?: Maybe<Array<DocumentBaseSignatureInviteGroupWhereUniqueInput>>;
  update?: Maybe<Array<DocumentBaseSignatureInviteGroupUpdateWithWhereUniqueWithoutDocumentBaseInput>>;
  updateMany?: Maybe<Array<DocumentBaseSignatureInviteGroupUpdateManyWithWhereWithoutDocumentBaseInput>>;
  upsert?: Maybe<Array<DocumentBaseSignatureInviteGroupUpsertWithWhereUniqueWithoutDocumentBaseInput>>;
};

export type DocumentBaseSignatureInviteGroupUpdateOneRequiredWithoutInvitesNestedInput = {
  connect?: Maybe<DocumentBaseSignatureInviteGroupWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentBaseSignatureInviteGroupCreateOrConnectWithoutInvitesInput>;
  create?: Maybe<DocumentBaseSignatureInviteGroupCreateWithoutInvitesInput>;
  update?: Maybe<DocumentBaseSignatureInviteGroupUpdateToOneWithWhereWithoutInvitesInput>;
  upsert?: Maybe<DocumentBaseSignatureInviteGroupUpsertWithoutInvitesInput>;
};

export type DocumentBaseSignatureInviteGroupUpdateToOneWithWhereWithoutInvitesInput = {
  data: DocumentBaseSignatureInviteGroupUpdateWithoutInvitesInput;
  where?: Maybe<DocumentBaseSignatureInviteGroupWhereInput>;
};

export type DocumentBaseSignatureInviteGroupUpdateWithWhereUniqueWithoutDocumentBaseInput = {
  data: DocumentBaseSignatureInviteGroupUpdateWithoutDocumentBaseInput;
  where: DocumentBaseSignatureInviteGroupWhereUniqueInput;
};

export type DocumentBaseSignatureInviteGroupUpdateWithoutDocumentBaseInput = {
  Invites?: Maybe<DocumentBaseSignatureInviteUpdateManyWithoutGroupNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  order?: Maybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseSignatureInviteGroupUpdateWithoutInvitesInput = {
  DocumentBase?: Maybe<DocumentBaseUpdateOneRequiredWithoutDocumentBaseSignatureInviteGroupsNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  order?: Maybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseSignatureInviteGroupUpsertWithWhereUniqueWithoutDocumentBaseInput = {
  create: DocumentBaseSignatureInviteGroupCreateWithoutDocumentBaseInput;
  update: DocumentBaseSignatureInviteGroupUpdateWithoutDocumentBaseInput;
  where: DocumentBaseSignatureInviteGroupWhereUniqueInput;
};

export type DocumentBaseSignatureInviteGroupUpsertWithoutInvitesInput = {
  create: DocumentBaseSignatureInviteGroupCreateWithoutInvitesInput;
  update: DocumentBaseSignatureInviteGroupUpdateWithoutInvitesInput;
  where?: Maybe<DocumentBaseSignatureInviteGroupWhereInput>;
};

export type DocumentBaseSignatureInviteGroupWhereInput = {
  AND?: Maybe<Array<DocumentBaseSignatureInviteGroupWhereInput>>;
  DocumentBase?: Maybe<DocumentBaseWhereInput>;
  Invites?: Maybe<DocumentBaseSignatureInviteListRelationFilter>;
  NOT?: Maybe<Array<DocumentBaseSignatureInviteGroupWhereInput>>;
  OR?: Maybe<Array<DocumentBaseSignatureInviteGroupWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  documentBaseId?: Maybe<StringFilter>;
  id?: Maybe<IntFilter>;
  order?: Maybe<IntFilter>;
};

export type DocumentBaseSignatureInviteGroupWhereUniqueInput = {
  AND?: Maybe<Array<DocumentBaseSignatureInviteGroupWhereInput>>;
  DocumentBase?: Maybe<DocumentBaseWhereInput>;
  Invites?: Maybe<DocumentBaseSignatureInviteListRelationFilter>;
  NOT?: Maybe<Array<DocumentBaseSignatureInviteGroupWhereInput>>;
  OR?: Maybe<Array<DocumentBaseSignatureInviteGroupWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  documentBaseId?: Maybe<StringFilter>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<IntFilter>;
};

export type DocumentBaseSignatureInviteListRelationFilter = {
  every?: Maybe<DocumentBaseSignatureInviteWhereInput>;
  none?: Maybe<DocumentBaseSignatureInviteWhereInput>;
  some?: Maybe<DocumentBaseSignatureInviteWhereInput>;
};

export type DocumentBaseSignatureInviteMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  groupId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamMemberId?: Maybe<SortOrder>;
};

export type DocumentBaseSignatureInviteMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  groupId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamMemberId?: Maybe<SortOrder>;
};

export type DocumentBaseSignatureInviteOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type DocumentBaseSignatureInviteOrderByWithAggregationInput = {
  _avg?: Maybe<DocumentBaseSignatureInviteAvgOrderByAggregateInput>;
  _count?: Maybe<DocumentBaseSignatureInviteCountOrderByAggregateInput>;
  _max?: Maybe<DocumentBaseSignatureInviteMaxOrderByAggregateInput>;
  _min?: Maybe<DocumentBaseSignatureInviteMinOrderByAggregateInput>;
  _sum?: Maybe<DocumentBaseSignatureInviteSumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  groupId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamMemberId?: Maybe<SortOrder>;
};

export type DocumentBaseSignatureInviteOrderByWithRelationInput = {
  Group?: Maybe<DocumentBaseSignatureInviteGroupOrderByWithRelationInput>;
  Signatures?: Maybe<DocumentBaseSignatureInviteSignatureOrderByRelationAggregateInput>;
  TeamMember?: Maybe<TeamMemberOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  groupId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamMemberId?: Maybe<SortOrder>;
};

export type DocumentBaseSignatureInviteRelationFilter = {
  is?: Maybe<DocumentBaseSignatureInviteWhereInput>;
  isNot?: Maybe<DocumentBaseSignatureInviteWhereInput>;
};

export enum DocumentBaseSignatureInviteScalarFieldEnum {
  CreatedAt = 'createdAt',
  GroupId = 'groupId',
  Id = 'id',
  TeamMemberId = 'teamMemberId'
}

export type DocumentBaseSignatureInviteScalarWhereInput = {
  AND?: Maybe<Array<DocumentBaseSignatureInviteScalarWhereInput>>;
  NOT?: Maybe<Array<DocumentBaseSignatureInviteScalarWhereInput>>;
  OR?: Maybe<Array<DocumentBaseSignatureInviteScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  groupId?: Maybe<IntFilter>;
  id?: Maybe<IntFilter>;
  teamMemberId?: Maybe<IntNullableFilter>;
};

export type DocumentBaseSignatureInviteScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<DocumentBaseSignatureInviteScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<DocumentBaseSignatureInviteScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<DocumentBaseSignatureInviteScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  groupId?: Maybe<IntWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  teamMemberId?: Maybe<IntNullableWithAggregatesFilter>;
};

export type DocumentBaseSignatureInviteSignature = {
  __typename?: 'DocumentBaseSignatureInviteSignature';
  Invite: DocumentBaseSignatureInvite;
  User: CommonUser;
  commonUserId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  inviteId: Scalars['Int'];
};

export type DocumentBaseSignatureInviteSignatureAvgOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  inviteId?: Maybe<SortOrder>;
};

export type DocumentBaseSignatureInviteSignatureCountOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  inviteId?: Maybe<SortOrder>;
};

export type DocumentBaseSignatureInviteSignatureCreateInput = {
  Invite: DocumentBaseSignatureInviteCreateNestedOneWithoutSignaturesInput;
  User: CommonUserCreateNestedOneWithoutDocumentBaseSignatureInviteSignatureInput;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentBaseSignatureInviteSignatureCreateManyInput = {
  commonUserId: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  inviteId: Scalars['Int'];
};

export type DocumentBaseSignatureInviteSignatureCreateManyInviteInput = {
  commonUserId: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
};

export type DocumentBaseSignatureInviteSignatureCreateManyInviteInputEnvelope = {
  data: Array<DocumentBaseSignatureInviteSignatureCreateManyInviteInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentBaseSignatureInviteSignatureCreateManyUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  inviteId: Scalars['Int'];
};

export type DocumentBaseSignatureInviteSignatureCreateManyUserInputEnvelope = {
  data: Array<DocumentBaseSignatureInviteSignatureCreateManyUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutInviteInput = {
  connect?: Maybe<Array<DocumentBaseSignatureInviteSignatureWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentBaseSignatureInviteSignatureCreateOrConnectWithoutInviteInput>>;
  create?: Maybe<Array<DocumentBaseSignatureInviteSignatureCreateWithoutInviteInput>>;
  createMany?: Maybe<DocumentBaseSignatureInviteSignatureCreateManyInviteInputEnvelope>;
};

export type DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<DocumentBaseSignatureInviteSignatureWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentBaseSignatureInviteSignatureCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<DocumentBaseSignatureInviteSignatureCreateWithoutUserInput>>;
  createMany?: Maybe<DocumentBaseSignatureInviteSignatureCreateManyUserInputEnvelope>;
};

export type DocumentBaseSignatureInviteSignatureCreateOrConnectWithoutInviteInput = {
  create: DocumentBaseSignatureInviteSignatureCreateWithoutInviteInput;
  where: DocumentBaseSignatureInviteSignatureWhereUniqueInput;
};

export type DocumentBaseSignatureInviteSignatureCreateOrConnectWithoutUserInput = {
  create: DocumentBaseSignatureInviteSignatureCreateWithoutUserInput;
  where: DocumentBaseSignatureInviteSignatureWhereUniqueInput;
};

export type DocumentBaseSignatureInviteSignatureCreateWithoutInviteInput = {
  User: CommonUserCreateNestedOneWithoutDocumentBaseSignatureInviteSignatureInput;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentBaseSignatureInviteSignatureCreateWithoutUserInput = {
  Invite: DocumentBaseSignatureInviteCreateNestedOneWithoutSignaturesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentBaseSignatureInviteSignatureListRelationFilter = {
  every?: Maybe<DocumentBaseSignatureInviteSignatureWhereInput>;
  none?: Maybe<DocumentBaseSignatureInviteSignatureWhereInput>;
  some?: Maybe<DocumentBaseSignatureInviteSignatureWhereInput>;
};

export type DocumentBaseSignatureInviteSignatureMaxOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  inviteId?: Maybe<SortOrder>;
};

export type DocumentBaseSignatureInviteSignatureMinOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  inviteId?: Maybe<SortOrder>;
};

export type DocumentBaseSignatureInviteSignatureOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type DocumentBaseSignatureInviteSignatureOrderByWithAggregationInput = {
  _avg?: Maybe<DocumentBaseSignatureInviteSignatureAvgOrderByAggregateInput>;
  _count?: Maybe<DocumentBaseSignatureInviteSignatureCountOrderByAggregateInput>;
  _max?: Maybe<DocumentBaseSignatureInviteSignatureMaxOrderByAggregateInput>;
  _min?: Maybe<DocumentBaseSignatureInviteSignatureMinOrderByAggregateInput>;
  _sum?: Maybe<DocumentBaseSignatureInviteSignatureSumOrderByAggregateInput>;
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  inviteId?: Maybe<SortOrder>;
};

export type DocumentBaseSignatureInviteSignatureOrderByWithRelationInput = {
  Invite?: Maybe<DocumentBaseSignatureInviteOrderByWithRelationInput>;
  User?: Maybe<CommonUserOrderByWithRelationInput>;
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  inviteId?: Maybe<SortOrder>;
};

export enum DocumentBaseSignatureInviteSignatureScalarFieldEnum {
  CommonUserId = 'commonUserId',
  CreatedAt = 'createdAt',
  Id = 'id',
  InviteId = 'inviteId'
}

export type DocumentBaseSignatureInviteSignatureScalarWhereInput = {
  AND?: Maybe<Array<DocumentBaseSignatureInviteSignatureScalarWhereInput>>;
  NOT?: Maybe<Array<DocumentBaseSignatureInviteSignatureScalarWhereInput>>;
  OR?: Maybe<Array<DocumentBaseSignatureInviteSignatureScalarWhereInput>>;
  commonUserId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  inviteId?: Maybe<IntFilter>;
};

export type DocumentBaseSignatureInviteSignatureScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<DocumentBaseSignatureInviteSignatureScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<DocumentBaseSignatureInviteSignatureScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<DocumentBaseSignatureInviteSignatureScalarWhereWithAggregatesInput>>;
  commonUserId?: Maybe<IntWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  inviteId?: Maybe<IntWithAggregatesFilter>;
};

export type DocumentBaseSignatureInviteSignatureSumOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  inviteId?: Maybe<SortOrder>;
};

export type DocumentBaseSignatureInviteSignatureUpdateInput = {
  Invite?: Maybe<DocumentBaseSignatureInviteUpdateOneRequiredWithoutSignaturesNestedInput>;
  User?: Maybe<CommonUserUpdateOneRequiredWithoutDocumentBaseSignatureInviteSignatureNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentBaseSignatureInviteSignatureUpdateManyMutationInput = {
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentBaseSignatureInviteSignatureUpdateManyWithWhereWithoutInviteInput = {
  data: DocumentBaseSignatureInviteSignatureUpdateManyMutationInput;
  where: DocumentBaseSignatureInviteSignatureScalarWhereInput;
};

export type DocumentBaseSignatureInviteSignatureUpdateManyWithWhereWithoutUserInput = {
  data: DocumentBaseSignatureInviteSignatureUpdateManyMutationInput;
  where: DocumentBaseSignatureInviteSignatureScalarWhereInput;
};

export type DocumentBaseSignatureInviteSignatureUpdateManyWithoutInviteNestedInput = {
  connect?: Maybe<Array<DocumentBaseSignatureInviteSignatureWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentBaseSignatureInviteSignatureCreateOrConnectWithoutInviteInput>>;
  create?: Maybe<Array<DocumentBaseSignatureInviteSignatureCreateWithoutInviteInput>>;
  createMany?: Maybe<DocumentBaseSignatureInviteSignatureCreateManyInviteInputEnvelope>;
  delete?: Maybe<Array<DocumentBaseSignatureInviteSignatureWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentBaseSignatureInviteSignatureScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentBaseSignatureInviteSignatureWhereUniqueInput>>;
  set?: Maybe<Array<DocumentBaseSignatureInviteSignatureWhereUniqueInput>>;
  update?: Maybe<Array<DocumentBaseSignatureInviteSignatureUpdateWithWhereUniqueWithoutInviteInput>>;
  updateMany?: Maybe<Array<DocumentBaseSignatureInviteSignatureUpdateManyWithWhereWithoutInviteInput>>;
  upsert?: Maybe<Array<DocumentBaseSignatureInviteSignatureUpsertWithWhereUniqueWithoutInviteInput>>;
};

export type DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<DocumentBaseSignatureInviteSignatureWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentBaseSignatureInviteSignatureCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<DocumentBaseSignatureInviteSignatureCreateWithoutUserInput>>;
  createMany?: Maybe<DocumentBaseSignatureInviteSignatureCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<DocumentBaseSignatureInviteSignatureWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentBaseSignatureInviteSignatureScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentBaseSignatureInviteSignatureWhereUniqueInput>>;
  set?: Maybe<Array<DocumentBaseSignatureInviteSignatureWhereUniqueInput>>;
  update?: Maybe<Array<DocumentBaseSignatureInviteSignatureUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<DocumentBaseSignatureInviteSignatureUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<DocumentBaseSignatureInviteSignatureUpsertWithWhereUniqueWithoutUserInput>>;
};

export type DocumentBaseSignatureInviteSignatureUpdateWithWhereUniqueWithoutInviteInput = {
  data: DocumentBaseSignatureInviteSignatureUpdateWithoutInviteInput;
  where: DocumentBaseSignatureInviteSignatureWhereUniqueInput;
};

export type DocumentBaseSignatureInviteSignatureUpdateWithWhereUniqueWithoutUserInput = {
  data: DocumentBaseSignatureInviteSignatureUpdateWithoutUserInput;
  where: DocumentBaseSignatureInviteSignatureWhereUniqueInput;
};

export type DocumentBaseSignatureInviteSignatureUpdateWithoutInviteInput = {
  User?: Maybe<CommonUserUpdateOneRequiredWithoutDocumentBaseSignatureInviteSignatureNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentBaseSignatureInviteSignatureUpdateWithoutUserInput = {
  Invite?: Maybe<DocumentBaseSignatureInviteUpdateOneRequiredWithoutSignaturesNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentBaseSignatureInviteSignatureUpsertWithWhereUniqueWithoutInviteInput = {
  create: DocumentBaseSignatureInviteSignatureCreateWithoutInviteInput;
  update: DocumentBaseSignatureInviteSignatureUpdateWithoutInviteInput;
  where: DocumentBaseSignatureInviteSignatureWhereUniqueInput;
};

export type DocumentBaseSignatureInviteSignatureUpsertWithWhereUniqueWithoutUserInput = {
  create: DocumentBaseSignatureInviteSignatureCreateWithoutUserInput;
  update: DocumentBaseSignatureInviteSignatureUpdateWithoutUserInput;
  where: DocumentBaseSignatureInviteSignatureWhereUniqueInput;
};

export type DocumentBaseSignatureInviteSignatureWhereInput = {
  AND?: Maybe<Array<DocumentBaseSignatureInviteSignatureWhereInput>>;
  Invite?: Maybe<DocumentBaseSignatureInviteWhereInput>;
  NOT?: Maybe<Array<DocumentBaseSignatureInviteSignatureWhereInput>>;
  OR?: Maybe<Array<DocumentBaseSignatureInviteSignatureWhereInput>>;
  User?: Maybe<CommonUserWhereInput>;
  commonUserId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  inviteId?: Maybe<IntFilter>;
};

export type DocumentBaseSignatureInviteSignatureWhereUniqueInput = {
  AND?: Maybe<Array<DocumentBaseSignatureInviteSignatureWhereInput>>;
  Invite?: Maybe<DocumentBaseSignatureInviteWhereInput>;
  NOT?: Maybe<Array<DocumentBaseSignatureInviteSignatureWhereInput>>;
  OR?: Maybe<Array<DocumentBaseSignatureInviteSignatureWhereInput>>;
  User?: Maybe<CommonUserWhereInput>;
  commonUserId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['Int']>;
  inviteId?: Maybe<IntFilter>;
};

export type DocumentBaseSignatureInviteSumOrderByAggregateInput = {
  groupId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamMemberId?: Maybe<SortOrder>;
};

export type DocumentBaseSignatureInviteUpdateInput = {
  Group?: Maybe<DocumentBaseSignatureInviteGroupUpdateOneRequiredWithoutInvitesNestedInput>;
  Signatures?: Maybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutInviteNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateOneWithoutInvitesNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentBaseSignatureInviteUpdateManyMutationInput = {
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentBaseSignatureInviteUpdateManyWithWhereWithoutGroupInput = {
  data: DocumentBaseSignatureInviteUpdateManyMutationInput;
  where: DocumentBaseSignatureInviteScalarWhereInput;
};

export type DocumentBaseSignatureInviteUpdateManyWithWhereWithoutTeamMemberInput = {
  data: DocumentBaseSignatureInviteUpdateManyMutationInput;
  where: DocumentBaseSignatureInviteScalarWhereInput;
};

export type DocumentBaseSignatureInviteUpdateManyWithoutGroupNestedInput = {
  connect?: Maybe<Array<DocumentBaseSignatureInviteWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentBaseSignatureInviteCreateOrConnectWithoutGroupInput>>;
  create?: Maybe<Array<DocumentBaseSignatureInviteCreateWithoutGroupInput>>;
  createMany?: Maybe<DocumentBaseSignatureInviteCreateManyGroupInputEnvelope>;
  delete?: Maybe<Array<DocumentBaseSignatureInviteWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentBaseSignatureInviteScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentBaseSignatureInviteWhereUniqueInput>>;
  set?: Maybe<Array<DocumentBaseSignatureInviteWhereUniqueInput>>;
  update?: Maybe<Array<DocumentBaseSignatureInviteUpdateWithWhereUniqueWithoutGroupInput>>;
  updateMany?: Maybe<Array<DocumentBaseSignatureInviteUpdateManyWithWhereWithoutGroupInput>>;
  upsert?: Maybe<Array<DocumentBaseSignatureInviteUpsertWithWhereUniqueWithoutGroupInput>>;
};

export type DocumentBaseSignatureInviteUpdateManyWithoutTeamMemberNestedInput = {
  connect?: Maybe<Array<DocumentBaseSignatureInviteWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentBaseSignatureInviteCreateOrConnectWithoutTeamMemberInput>>;
  create?: Maybe<Array<DocumentBaseSignatureInviteCreateWithoutTeamMemberInput>>;
  createMany?: Maybe<DocumentBaseSignatureInviteCreateManyTeamMemberInputEnvelope>;
  delete?: Maybe<Array<DocumentBaseSignatureInviteWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentBaseSignatureInviteScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentBaseSignatureInviteWhereUniqueInput>>;
  set?: Maybe<Array<DocumentBaseSignatureInviteWhereUniqueInput>>;
  update?: Maybe<Array<DocumentBaseSignatureInviteUpdateWithWhereUniqueWithoutTeamMemberInput>>;
  updateMany?: Maybe<Array<DocumentBaseSignatureInviteUpdateManyWithWhereWithoutTeamMemberInput>>;
  upsert?: Maybe<Array<DocumentBaseSignatureInviteUpsertWithWhereUniqueWithoutTeamMemberInput>>;
};

export type DocumentBaseSignatureInviteUpdateOneRequiredWithoutSignaturesNestedInput = {
  connect?: Maybe<DocumentBaseSignatureInviteWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentBaseSignatureInviteCreateOrConnectWithoutSignaturesInput>;
  create?: Maybe<DocumentBaseSignatureInviteCreateWithoutSignaturesInput>;
  update?: Maybe<DocumentBaseSignatureInviteUpdateToOneWithWhereWithoutSignaturesInput>;
  upsert?: Maybe<DocumentBaseSignatureInviteUpsertWithoutSignaturesInput>;
};

export type DocumentBaseSignatureInviteUpdateToOneWithWhereWithoutSignaturesInput = {
  data: DocumentBaseSignatureInviteUpdateWithoutSignaturesInput;
  where?: Maybe<DocumentBaseSignatureInviteWhereInput>;
};

export type DocumentBaseSignatureInviteUpdateWithWhereUniqueWithoutGroupInput = {
  data: DocumentBaseSignatureInviteUpdateWithoutGroupInput;
  where: DocumentBaseSignatureInviteWhereUniqueInput;
};

export type DocumentBaseSignatureInviteUpdateWithWhereUniqueWithoutTeamMemberInput = {
  data: DocumentBaseSignatureInviteUpdateWithoutTeamMemberInput;
  where: DocumentBaseSignatureInviteWhereUniqueInput;
};

export type DocumentBaseSignatureInviteUpdateWithoutGroupInput = {
  Signatures?: Maybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutInviteNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateOneWithoutInvitesNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentBaseSignatureInviteUpdateWithoutSignaturesInput = {
  Group?: Maybe<DocumentBaseSignatureInviteGroupUpdateOneRequiredWithoutInvitesNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateOneWithoutInvitesNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentBaseSignatureInviteUpdateWithoutTeamMemberInput = {
  Group?: Maybe<DocumentBaseSignatureInviteGroupUpdateOneRequiredWithoutInvitesNestedInput>;
  Signatures?: Maybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutInviteNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentBaseSignatureInviteUpsertWithWhereUniqueWithoutGroupInput = {
  create: DocumentBaseSignatureInviteCreateWithoutGroupInput;
  update: DocumentBaseSignatureInviteUpdateWithoutGroupInput;
  where: DocumentBaseSignatureInviteWhereUniqueInput;
};

export type DocumentBaseSignatureInviteUpsertWithWhereUniqueWithoutTeamMemberInput = {
  create: DocumentBaseSignatureInviteCreateWithoutTeamMemberInput;
  update: DocumentBaseSignatureInviteUpdateWithoutTeamMemberInput;
  where: DocumentBaseSignatureInviteWhereUniqueInput;
};

export type DocumentBaseSignatureInviteUpsertWithoutSignaturesInput = {
  create: DocumentBaseSignatureInviteCreateWithoutSignaturesInput;
  update: DocumentBaseSignatureInviteUpdateWithoutSignaturesInput;
  where?: Maybe<DocumentBaseSignatureInviteWhereInput>;
};

export type DocumentBaseSignatureInviteWhereInput = {
  AND?: Maybe<Array<DocumentBaseSignatureInviteWhereInput>>;
  Group?: Maybe<DocumentBaseSignatureInviteGroupWhereInput>;
  NOT?: Maybe<Array<DocumentBaseSignatureInviteWhereInput>>;
  OR?: Maybe<Array<DocumentBaseSignatureInviteWhereInput>>;
  Signatures?: Maybe<DocumentBaseSignatureInviteSignatureListRelationFilter>;
  TeamMember?: Maybe<TeamMemberWhereInput>;
  createdAt?: Maybe<DateTimeFilter>;
  groupId?: Maybe<IntFilter>;
  id?: Maybe<IntFilter>;
  teamMemberId?: Maybe<IntNullableFilter>;
};

export type DocumentBaseSignatureInviteWhereUniqueInput = {
  AND?: Maybe<Array<DocumentBaseSignatureInviteWhereInput>>;
  Group?: Maybe<DocumentBaseSignatureInviteGroupWhereInput>;
  NOT?: Maybe<Array<DocumentBaseSignatureInviteWhereInput>>;
  OR?: Maybe<Array<DocumentBaseSignatureInviteWhereInput>>;
  Signatures?: Maybe<DocumentBaseSignatureInviteSignatureListRelationFilter>;
  TeamMember?: Maybe<TeamMemberWhereInput>;
  createdAt?: Maybe<DateTimeFilter>;
  groupId?: Maybe<IntFilter>;
  id?: Maybe<Scalars['Int']>;
  teamMemberId?: Maybe<IntNullableFilter>;
};

export type DocumentBaseSumOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  withoutTeamInternalSeqId?: Maybe<SortOrder>;
};

export enum DocumentBaseType {
  AcademicDocumentation = 'ACADEMIC_DOCUMENTATION',
  AuditFileIssuer = 'AUDIT_FILE_ISSUER',
  Certificate = 'CERTIFICATE',
  Degree = 'DEGREE',
  FinalAcademicTranscript = 'FINAL_ACADEMIC_TRANSCRIPT',
  SchoolCurriculum = 'SCHOOL_CURRICULUM'
}

export type DocumentBaseUpdateInput = {
  DocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuerUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentBaseSignatureInviteGroups?: Maybe<DocumentBaseSignatureInviteGroupUpdateManyWithoutDocumentBaseNestedInput>;
  DocumentCertificate?: Maybe<DocumentCertificateUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentDegree?: Maybe<DocumentDegreeUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentFinalAcademicTranscript?: Maybe<DocumentFinalAcademicTranscriptUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentSchoolCurriculum?: Maybe<DocumentSchoolCurriculumUpdateOneWithoutDocumentBaseNestedInput>;
  ExternalSignatureInvite?: Maybe<ExternalSignatureInviteUpdateManyWithoutDocumentBaseNestedInput>;
  Histories?: Maybe<DocumentBaseHistoryUpdateManyWithoutDocumentBaseNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutDocumentsNestedInput>;
  UserOwner?: Maybe<CommonUserUpdateOneRequiredWithoutDocumentBaseNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  creationType?: Maybe<EnumDocumentAcademicDocumentationCreationTypeFieldUpdateOperationsInput>;
  data?: Maybe<Scalars['Json']>;
  deletedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  filePath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  internalSeqId?: Maybe<StringFieldUpdateOperationsInput>;
  type?: Maybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  version?: Maybe<StringFieldUpdateOperationsInput>;
  withoutTeamInternalSeqId?: Maybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseUpdateManyMutationInput = {
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  creationType?: Maybe<EnumDocumentAcademicDocumentationCreationTypeFieldUpdateOperationsInput>;
  data?: Maybe<Scalars['Json']>;
  deletedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  filePath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  internalSeqId?: Maybe<StringFieldUpdateOperationsInput>;
  type?: Maybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  version?: Maybe<StringFieldUpdateOperationsInput>;
  withoutTeamInternalSeqId?: Maybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseUpdateManyWithWhereWithoutTeamInput = {
  data: DocumentBaseUpdateManyMutationInput;
  where: DocumentBaseScalarWhereInput;
};

export type DocumentBaseUpdateManyWithWhereWithoutUserOwnerInput = {
  data: DocumentBaseUpdateManyMutationInput;
  where: DocumentBaseScalarWhereInput;
};

export type DocumentBaseUpdateManyWithoutTeamNestedInput = {
  connect?: Maybe<Array<DocumentBaseWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentBaseCreateOrConnectWithoutTeamInput>>;
  create?: Maybe<Array<DocumentBaseCreateWithoutTeamInput>>;
  createMany?: Maybe<DocumentBaseCreateManyTeamInputEnvelope>;
  delete?: Maybe<Array<DocumentBaseWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentBaseScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentBaseWhereUniqueInput>>;
  set?: Maybe<Array<DocumentBaseWhereUniqueInput>>;
  update?: Maybe<Array<DocumentBaseUpdateWithWhereUniqueWithoutTeamInput>>;
  updateMany?: Maybe<Array<DocumentBaseUpdateManyWithWhereWithoutTeamInput>>;
  upsert?: Maybe<Array<DocumentBaseUpsertWithWhereUniqueWithoutTeamInput>>;
};

export type DocumentBaseUpdateManyWithoutUserOwnerNestedInput = {
  connect?: Maybe<Array<DocumentBaseWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentBaseCreateOrConnectWithoutUserOwnerInput>>;
  create?: Maybe<Array<DocumentBaseCreateWithoutUserOwnerInput>>;
  createMany?: Maybe<DocumentBaseCreateManyUserOwnerInputEnvelope>;
  delete?: Maybe<Array<DocumentBaseWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentBaseScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentBaseWhereUniqueInput>>;
  set?: Maybe<Array<DocumentBaseWhereUniqueInput>>;
  update?: Maybe<Array<DocumentBaseUpdateWithWhereUniqueWithoutUserOwnerInput>>;
  updateMany?: Maybe<Array<DocumentBaseUpdateManyWithWhereWithoutUserOwnerInput>>;
  upsert?: Maybe<Array<DocumentBaseUpsertWithWhereUniqueWithoutUserOwnerInput>>;
};

export type DocumentBaseUpdateOneRequiredWithoutDocumentAcademicDocumentationNestedInput = {
  connect?: Maybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentBaseCreateOrConnectWithoutDocumentAcademicDocumentationInput>;
  create?: Maybe<DocumentBaseCreateWithoutDocumentAcademicDocumentationInput>;
  update?: Maybe<DocumentBaseUpdateToOneWithWhereWithoutDocumentAcademicDocumentationInput>;
  upsert?: Maybe<DocumentBaseUpsertWithoutDocumentAcademicDocumentationInput>;
};

export type DocumentBaseUpdateOneRequiredWithoutDocumentAuditFileIssuerNestedInput = {
  connect?: Maybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentBaseCreateOrConnectWithoutDocumentAuditFileIssuerInput>;
  create?: Maybe<DocumentBaseCreateWithoutDocumentAuditFileIssuerInput>;
  update?: Maybe<DocumentBaseUpdateToOneWithWhereWithoutDocumentAuditFileIssuerInput>;
  upsert?: Maybe<DocumentBaseUpsertWithoutDocumentAuditFileIssuerInput>;
};

export type DocumentBaseUpdateOneRequiredWithoutDocumentBaseSignatureInviteGroupsNestedInput = {
  connect?: Maybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentBaseCreateOrConnectWithoutDocumentBaseSignatureInviteGroupsInput>;
  create?: Maybe<DocumentBaseCreateWithoutDocumentBaseSignatureInviteGroupsInput>;
  update?: Maybe<DocumentBaseUpdateToOneWithWhereWithoutDocumentBaseSignatureInviteGroupsInput>;
  upsert?: Maybe<DocumentBaseUpsertWithoutDocumentBaseSignatureInviteGroupsInput>;
};

export type DocumentBaseUpdateOneRequiredWithoutDocumentCertificateNestedInput = {
  connect?: Maybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentBaseCreateOrConnectWithoutDocumentCertificateInput>;
  create?: Maybe<DocumentBaseCreateWithoutDocumentCertificateInput>;
  update?: Maybe<DocumentBaseUpdateToOneWithWhereWithoutDocumentCertificateInput>;
  upsert?: Maybe<DocumentBaseUpsertWithoutDocumentCertificateInput>;
};

export type DocumentBaseUpdateOneRequiredWithoutDocumentDegreeNestedInput = {
  connect?: Maybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentBaseCreateOrConnectWithoutDocumentDegreeInput>;
  create?: Maybe<DocumentBaseCreateWithoutDocumentDegreeInput>;
  update?: Maybe<DocumentBaseUpdateToOneWithWhereWithoutDocumentDegreeInput>;
  upsert?: Maybe<DocumentBaseUpsertWithoutDocumentDegreeInput>;
};

export type DocumentBaseUpdateOneRequiredWithoutDocumentFinalAcademicTranscriptNestedInput = {
  connect?: Maybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentBaseCreateOrConnectWithoutDocumentFinalAcademicTranscriptInput>;
  create?: Maybe<DocumentBaseCreateWithoutDocumentFinalAcademicTranscriptInput>;
  update?: Maybe<DocumentBaseUpdateToOneWithWhereWithoutDocumentFinalAcademicTranscriptInput>;
  upsert?: Maybe<DocumentBaseUpsertWithoutDocumentFinalAcademicTranscriptInput>;
};

export type DocumentBaseUpdateOneRequiredWithoutDocumentSchoolCurriculumNestedInput = {
  connect?: Maybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentBaseCreateOrConnectWithoutDocumentSchoolCurriculumInput>;
  create?: Maybe<DocumentBaseCreateWithoutDocumentSchoolCurriculumInput>;
  update?: Maybe<DocumentBaseUpdateToOneWithWhereWithoutDocumentSchoolCurriculumInput>;
  upsert?: Maybe<DocumentBaseUpsertWithoutDocumentSchoolCurriculumInput>;
};

export type DocumentBaseUpdateOneRequiredWithoutExternalSignatureInviteNestedInput = {
  connect?: Maybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentBaseCreateOrConnectWithoutExternalSignatureInviteInput>;
  create?: Maybe<DocumentBaseCreateWithoutExternalSignatureInviteInput>;
  update?: Maybe<DocumentBaseUpdateToOneWithWhereWithoutExternalSignatureInviteInput>;
  upsert?: Maybe<DocumentBaseUpsertWithoutExternalSignatureInviteInput>;
};

export type DocumentBaseUpdateOneRequiredWithoutHistoriesNestedInput = {
  connect?: Maybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentBaseCreateOrConnectWithoutHistoriesInput>;
  create?: Maybe<DocumentBaseCreateWithoutHistoriesInput>;
  update?: Maybe<DocumentBaseUpdateToOneWithWhereWithoutHistoriesInput>;
  upsert?: Maybe<DocumentBaseUpsertWithoutHistoriesInput>;
};

export type DocumentBaseUpdateToOneWithWhereWithoutDocumentAcademicDocumentationInput = {
  data: DocumentBaseUpdateWithoutDocumentAcademicDocumentationInput;
  where?: Maybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpdateToOneWithWhereWithoutDocumentAuditFileIssuerInput = {
  data: DocumentBaseUpdateWithoutDocumentAuditFileIssuerInput;
  where?: Maybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpdateToOneWithWhereWithoutDocumentBaseSignatureInviteGroupsInput = {
  data: DocumentBaseUpdateWithoutDocumentBaseSignatureInviteGroupsInput;
  where?: Maybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpdateToOneWithWhereWithoutDocumentCertificateInput = {
  data: DocumentBaseUpdateWithoutDocumentCertificateInput;
  where?: Maybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpdateToOneWithWhereWithoutDocumentDegreeInput = {
  data: DocumentBaseUpdateWithoutDocumentDegreeInput;
  where?: Maybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpdateToOneWithWhereWithoutDocumentFinalAcademicTranscriptInput = {
  data: DocumentBaseUpdateWithoutDocumentFinalAcademicTranscriptInput;
  where?: Maybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpdateToOneWithWhereWithoutDocumentSchoolCurriculumInput = {
  data: DocumentBaseUpdateWithoutDocumentSchoolCurriculumInput;
  where?: Maybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpdateToOneWithWhereWithoutExternalSignatureInviteInput = {
  data: DocumentBaseUpdateWithoutExternalSignatureInviteInput;
  where?: Maybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpdateToOneWithWhereWithoutHistoriesInput = {
  data: DocumentBaseUpdateWithoutHistoriesInput;
  where?: Maybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpdateWithWhereUniqueWithoutTeamInput = {
  data: DocumentBaseUpdateWithoutTeamInput;
  where: DocumentBaseWhereUniqueInput;
};

export type DocumentBaseUpdateWithWhereUniqueWithoutUserOwnerInput = {
  data: DocumentBaseUpdateWithoutUserOwnerInput;
  where: DocumentBaseWhereUniqueInput;
};

export type DocumentBaseUpdateWithoutDocumentAcademicDocumentationInput = {
  DocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuerUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentBaseSignatureInviteGroups?: Maybe<DocumentBaseSignatureInviteGroupUpdateManyWithoutDocumentBaseNestedInput>;
  DocumentCertificate?: Maybe<DocumentCertificateUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentDegree?: Maybe<DocumentDegreeUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentFinalAcademicTranscript?: Maybe<DocumentFinalAcademicTranscriptUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentSchoolCurriculum?: Maybe<DocumentSchoolCurriculumUpdateOneWithoutDocumentBaseNestedInput>;
  ExternalSignatureInvite?: Maybe<ExternalSignatureInviteUpdateManyWithoutDocumentBaseNestedInput>;
  Histories?: Maybe<DocumentBaseHistoryUpdateManyWithoutDocumentBaseNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutDocumentsNestedInput>;
  UserOwner?: Maybe<CommonUserUpdateOneRequiredWithoutDocumentBaseNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  creationType?: Maybe<EnumDocumentAcademicDocumentationCreationTypeFieldUpdateOperationsInput>;
  data?: Maybe<Scalars['Json']>;
  deletedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  filePath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  internalSeqId?: Maybe<StringFieldUpdateOperationsInput>;
  type?: Maybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  version?: Maybe<StringFieldUpdateOperationsInput>;
  withoutTeamInternalSeqId?: Maybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseUpdateWithoutDocumentAuditFileIssuerInput = {
  DocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentBaseSignatureInviteGroups?: Maybe<DocumentBaseSignatureInviteGroupUpdateManyWithoutDocumentBaseNestedInput>;
  DocumentCertificate?: Maybe<DocumentCertificateUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentDegree?: Maybe<DocumentDegreeUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentFinalAcademicTranscript?: Maybe<DocumentFinalAcademicTranscriptUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentSchoolCurriculum?: Maybe<DocumentSchoolCurriculumUpdateOneWithoutDocumentBaseNestedInput>;
  ExternalSignatureInvite?: Maybe<ExternalSignatureInviteUpdateManyWithoutDocumentBaseNestedInput>;
  Histories?: Maybe<DocumentBaseHistoryUpdateManyWithoutDocumentBaseNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutDocumentsNestedInput>;
  UserOwner?: Maybe<CommonUserUpdateOneRequiredWithoutDocumentBaseNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  creationType?: Maybe<EnumDocumentAcademicDocumentationCreationTypeFieldUpdateOperationsInput>;
  data?: Maybe<Scalars['Json']>;
  deletedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  filePath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  internalSeqId?: Maybe<StringFieldUpdateOperationsInput>;
  type?: Maybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  version?: Maybe<StringFieldUpdateOperationsInput>;
  withoutTeamInternalSeqId?: Maybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseUpdateWithoutDocumentBaseSignatureInviteGroupsInput = {
  DocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuerUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentCertificate?: Maybe<DocumentCertificateUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentDegree?: Maybe<DocumentDegreeUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentFinalAcademicTranscript?: Maybe<DocumentFinalAcademicTranscriptUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentSchoolCurriculum?: Maybe<DocumentSchoolCurriculumUpdateOneWithoutDocumentBaseNestedInput>;
  ExternalSignatureInvite?: Maybe<ExternalSignatureInviteUpdateManyWithoutDocumentBaseNestedInput>;
  Histories?: Maybe<DocumentBaseHistoryUpdateManyWithoutDocumentBaseNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutDocumentsNestedInput>;
  UserOwner?: Maybe<CommonUserUpdateOneRequiredWithoutDocumentBaseNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  creationType?: Maybe<EnumDocumentAcademicDocumentationCreationTypeFieldUpdateOperationsInput>;
  data?: Maybe<Scalars['Json']>;
  deletedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  filePath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  internalSeqId?: Maybe<StringFieldUpdateOperationsInput>;
  type?: Maybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  version?: Maybe<StringFieldUpdateOperationsInput>;
  withoutTeamInternalSeqId?: Maybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseUpdateWithoutDocumentCertificateInput = {
  DocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuerUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentBaseSignatureInviteGroups?: Maybe<DocumentBaseSignatureInviteGroupUpdateManyWithoutDocumentBaseNestedInput>;
  DocumentDegree?: Maybe<DocumentDegreeUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentFinalAcademicTranscript?: Maybe<DocumentFinalAcademicTranscriptUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentSchoolCurriculum?: Maybe<DocumentSchoolCurriculumUpdateOneWithoutDocumentBaseNestedInput>;
  ExternalSignatureInvite?: Maybe<ExternalSignatureInviteUpdateManyWithoutDocumentBaseNestedInput>;
  Histories?: Maybe<DocumentBaseHistoryUpdateManyWithoutDocumentBaseNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutDocumentsNestedInput>;
  UserOwner?: Maybe<CommonUserUpdateOneRequiredWithoutDocumentBaseNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  creationType?: Maybe<EnumDocumentAcademicDocumentationCreationTypeFieldUpdateOperationsInput>;
  data?: Maybe<Scalars['Json']>;
  deletedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  filePath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  internalSeqId?: Maybe<StringFieldUpdateOperationsInput>;
  type?: Maybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  version?: Maybe<StringFieldUpdateOperationsInput>;
  withoutTeamInternalSeqId?: Maybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseUpdateWithoutDocumentDegreeInput = {
  DocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuerUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentBaseSignatureInviteGroups?: Maybe<DocumentBaseSignatureInviteGroupUpdateManyWithoutDocumentBaseNestedInput>;
  DocumentCertificate?: Maybe<DocumentCertificateUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentFinalAcademicTranscript?: Maybe<DocumentFinalAcademicTranscriptUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentSchoolCurriculum?: Maybe<DocumentSchoolCurriculumUpdateOneWithoutDocumentBaseNestedInput>;
  ExternalSignatureInvite?: Maybe<ExternalSignatureInviteUpdateManyWithoutDocumentBaseNestedInput>;
  Histories?: Maybe<DocumentBaseHistoryUpdateManyWithoutDocumentBaseNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutDocumentsNestedInput>;
  UserOwner?: Maybe<CommonUserUpdateOneRequiredWithoutDocumentBaseNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  creationType?: Maybe<EnumDocumentAcademicDocumentationCreationTypeFieldUpdateOperationsInput>;
  data?: Maybe<Scalars['Json']>;
  deletedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  filePath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  internalSeqId?: Maybe<StringFieldUpdateOperationsInput>;
  type?: Maybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  version?: Maybe<StringFieldUpdateOperationsInput>;
  withoutTeamInternalSeqId?: Maybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseUpdateWithoutDocumentFinalAcademicTranscriptInput = {
  DocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuerUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentBaseSignatureInviteGroups?: Maybe<DocumentBaseSignatureInviteGroupUpdateManyWithoutDocumentBaseNestedInput>;
  DocumentCertificate?: Maybe<DocumentCertificateUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentDegree?: Maybe<DocumentDegreeUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentSchoolCurriculum?: Maybe<DocumentSchoolCurriculumUpdateOneWithoutDocumentBaseNestedInput>;
  ExternalSignatureInvite?: Maybe<ExternalSignatureInviteUpdateManyWithoutDocumentBaseNestedInput>;
  Histories?: Maybe<DocumentBaseHistoryUpdateManyWithoutDocumentBaseNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutDocumentsNestedInput>;
  UserOwner?: Maybe<CommonUserUpdateOneRequiredWithoutDocumentBaseNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  creationType?: Maybe<EnumDocumentAcademicDocumentationCreationTypeFieldUpdateOperationsInput>;
  data?: Maybe<Scalars['Json']>;
  deletedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  filePath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  internalSeqId?: Maybe<StringFieldUpdateOperationsInput>;
  type?: Maybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  version?: Maybe<StringFieldUpdateOperationsInput>;
  withoutTeamInternalSeqId?: Maybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseUpdateWithoutDocumentSchoolCurriculumInput = {
  DocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuerUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentBaseSignatureInviteGroups?: Maybe<DocumentBaseSignatureInviteGroupUpdateManyWithoutDocumentBaseNestedInput>;
  DocumentCertificate?: Maybe<DocumentCertificateUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentDegree?: Maybe<DocumentDegreeUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentFinalAcademicTranscript?: Maybe<DocumentFinalAcademicTranscriptUpdateOneWithoutDocumentBaseNestedInput>;
  ExternalSignatureInvite?: Maybe<ExternalSignatureInviteUpdateManyWithoutDocumentBaseNestedInput>;
  Histories?: Maybe<DocumentBaseHistoryUpdateManyWithoutDocumentBaseNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutDocumentsNestedInput>;
  UserOwner?: Maybe<CommonUserUpdateOneRequiredWithoutDocumentBaseNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  creationType?: Maybe<EnumDocumentAcademicDocumentationCreationTypeFieldUpdateOperationsInput>;
  data?: Maybe<Scalars['Json']>;
  deletedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  filePath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  internalSeqId?: Maybe<StringFieldUpdateOperationsInput>;
  type?: Maybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  version?: Maybe<StringFieldUpdateOperationsInput>;
  withoutTeamInternalSeqId?: Maybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseUpdateWithoutExternalSignatureInviteInput = {
  DocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuerUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentBaseSignatureInviteGroups?: Maybe<DocumentBaseSignatureInviteGroupUpdateManyWithoutDocumentBaseNestedInput>;
  DocumentCertificate?: Maybe<DocumentCertificateUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentDegree?: Maybe<DocumentDegreeUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentFinalAcademicTranscript?: Maybe<DocumentFinalAcademicTranscriptUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentSchoolCurriculum?: Maybe<DocumentSchoolCurriculumUpdateOneWithoutDocumentBaseNestedInput>;
  Histories?: Maybe<DocumentBaseHistoryUpdateManyWithoutDocumentBaseNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutDocumentsNestedInput>;
  UserOwner?: Maybe<CommonUserUpdateOneRequiredWithoutDocumentBaseNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  creationType?: Maybe<EnumDocumentAcademicDocumentationCreationTypeFieldUpdateOperationsInput>;
  data?: Maybe<Scalars['Json']>;
  deletedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  filePath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  internalSeqId?: Maybe<StringFieldUpdateOperationsInput>;
  type?: Maybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  version?: Maybe<StringFieldUpdateOperationsInput>;
  withoutTeamInternalSeqId?: Maybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseUpdateWithoutHistoriesInput = {
  DocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuerUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentBaseSignatureInviteGroups?: Maybe<DocumentBaseSignatureInviteGroupUpdateManyWithoutDocumentBaseNestedInput>;
  DocumentCertificate?: Maybe<DocumentCertificateUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentDegree?: Maybe<DocumentDegreeUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentFinalAcademicTranscript?: Maybe<DocumentFinalAcademicTranscriptUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentSchoolCurriculum?: Maybe<DocumentSchoolCurriculumUpdateOneWithoutDocumentBaseNestedInput>;
  ExternalSignatureInvite?: Maybe<ExternalSignatureInviteUpdateManyWithoutDocumentBaseNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutDocumentsNestedInput>;
  UserOwner?: Maybe<CommonUserUpdateOneRequiredWithoutDocumentBaseNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  creationType?: Maybe<EnumDocumentAcademicDocumentationCreationTypeFieldUpdateOperationsInput>;
  data?: Maybe<Scalars['Json']>;
  deletedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  filePath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  internalSeqId?: Maybe<StringFieldUpdateOperationsInput>;
  type?: Maybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  version?: Maybe<StringFieldUpdateOperationsInput>;
  withoutTeamInternalSeqId?: Maybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseUpdateWithoutTeamInput = {
  DocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuerUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentBaseSignatureInviteGroups?: Maybe<DocumentBaseSignatureInviteGroupUpdateManyWithoutDocumentBaseNestedInput>;
  DocumentCertificate?: Maybe<DocumentCertificateUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentDegree?: Maybe<DocumentDegreeUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentFinalAcademicTranscript?: Maybe<DocumentFinalAcademicTranscriptUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentSchoolCurriculum?: Maybe<DocumentSchoolCurriculumUpdateOneWithoutDocumentBaseNestedInput>;
  ExternalSignatureInvite?: Maybe<ExternalSignatureInviteUpdateManyWithoutDocumentBaseNestedInput>;
  Histories?: Maybe<DocumentBaseHistoryUpdateManyWithoutDocumentBaseNestedInput>;
  UserOwner?: Maybe<CommonUserUpdateOneRequiredWithoutDocumentBaseNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  creationType?: Maybe<EnumDocumentAcademicDocumentationCreationTypeFieldUpdateOperationsInput>;
  data?: Maybe<Scalars['Json']>;
  deletedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  filePath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  internalSeqId?: Maybe<StringFieldUpdateOperationsInput>;
  type?: Maybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  version?: Maybe<StringFieldUpdateOperationsInput>;
  withoutTeamInternalSeqId?: Maybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseUpdateWithoutUserOwnerInput = {
  DocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuerUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentBaseSignatureInviteGroups?: Maybe<DocumentBaseSignatureInviteGroupUpdateManyWithoutDocumentBaseNestedInput>;
  DocumentCertificate?: Maybe<DocumentCertificateUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentDegree?: Maybe<DocumentDegreeUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentFinalAcademicTranscript?: Maybe<DocumentFinalAcademicTranscriptUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentSchoolCurriculum?: Maybe<DocumentSchoolCurriculumUpdateOneWithoutDocumentBaseNestedInput>;
  ExternalSignatureInvite?: Maybe<ExternalSignatureInviteUpdateManyWithoutDocumentBaseNestedInput>;
  Histories?: Maybe<DocumentBaseHistoryUpdateManyWithoutDocumentBaseNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutDocumentsNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  creationType?: Maybe<EnumDocumentAcademicDocumentationCreationTypeFieldUpdateOperationsInput>;
  data?: Maybe<Scalars['Json']>;
  deletedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  filePath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  internalSeqId?: Maybe<StringFieldUpdateOperationsInput>;
  type?: Maybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  version?: Maybe<StringFieldUpdateOperationsInput>;
  withoutTeamInternalSeqId?: Maybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseUpsertWithWhereUniqueWithoutTeamInput = {
  create: DocumentBaseCreateWithoutTeamInput;
  update: DocumentBaseUpdateWithoutTeamInput;
  where: DocumentBaseWhereUniqueInput;
};

export type DocumentBaseUpsertWithWhereUniqueWithoutUserOwnerInput = {
  create: DocumentBaseCreateWithoutUserOwnerInput;
  update: DocumentBaseUpdateWithoutUserOwnerInput;
  where: DocumentBaseWhereUniqueInput;
};

export type DocumentBaseUpsertWithoutDocumentAcademicDocumentationInput = {
  create: DocumentBaseCreateWithoutDocumentAcademicDocumentationInput;
  update: DocumentBaseUpdateWithoutDocumentAcademicDocumentationInput;
  where?: Maybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpsertWithoutDocumentAuditFileIssuerInput = {
  create: DocumentBaseCreateWithoutDocumentAuditFileIssuerInput;
  update: DocumentBaseUpdateWithoutDocumentAuditFileIssuerInput;
  where?: Maybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpsertWithoutDocumentBaseSignatureInviteGroupsInput = {
  create: DocumentBaseCreateWithoutDocumentBaseSignatureInviteGroupsInput;
  update: DocumentBaseUpdateWithoutDocumentBaseSignatureInviteGroupsInput;
  where?: Maybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpsertWithoutDocumentCertificateInput = {
  create: DocumentBaseCreateWithoutDocumentCertificateInput;
  update: DocumentBaseUpdateWithoutDocumentCertificateInput;
  where?: Maybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpsertWithoutDocumentDegreeInput = {
  create: DocumentBaseCreateWithoutDocumentDegreeInput;
  update: DocumentBaseUpdateWithoutDocumentDegreeInput;
  where?: Maybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpsertWithoutDocumentFinalAcademicTranscriptInput = {
  create: DocumentBaseCreateWithoutDocumentFinalAcademicTranscriptInput;
  update: DocumentBaseUpdateWithoutDocumentFinalAcademicTranscriptInput;
  where?: Maybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpsertWithoutDocumentSchoolCurriculumInput = {
  create: DocumentBaseCreateWithoutDocumentSchoolCurriculumInput;
  update: DocumentBaseUpdateWithoutDocumentSchoolCurriculumInput;
  where?: Maybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpsertWithoutExternalSignatureInviteInput = {
  create: DocumentBaseCreateWithoutExternalSignatureInviteInput;
  update: DocumentBaseUpdateWithoutExternalSignatureInviteInput;
  where?: Maybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpsertWithoutHistoriesInput = {
  create: DocumentBaseCreateWithoutHistoriesInput;
  update: DocumentBaseUpdateWithoutHistoriesInput;
  where?: Maybe<DocumentBaseWhereInput>;
};

export type DocumentBaseWhereInput = {
  AND?: Maybe<Array<DocumentBaseWhereInput>>;
  DocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationWhereInput>;
  DocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuerWhereInput>;
  DocumentBaseSignatureInviteGroups?: Maybe<DocumentBaseSignatureInviteGroupListRelationFilter>;
  DocumentCertificate?: Maybe<DocumentCertificateWhereInput>;
  DocumentDegree?: Maybe<DocumentDegreeWhereInput>;
  DocumentFinalAcademicTranscript?: Maybe<DocumentFinalAcademicTranscriptWhereInput>;
  DocumentSchoolCurriculum?: Maybe<DocumentSchoolCurriculumWhereInput>;
  ExternalSignatureInvite?: Maybe<ExternalSignatureInviteListRelationFilter>;
  Histories?: Maybe<DocumentBaseHistoryListRelationFilter>;
  NOT?: Maybe<Array<DocumentBaseWhereInput>>;
  OR?: Maybe<Array<DocumentBaseWhereInput>>;
  Team?: Maybe<TeamWhereInput>;
  UserOwner?: Maybe<CommonUserWhereInput>;
  commonUserId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  creationType?: Maybe<EnumDocumentAcademicDocumentationCreationTypeFilter>;
  data?: Maybe<JsonFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  filePath?: Maybe<StringNullableFilter>;
  internalSeqId?: Maybe<StringFilter>;
  teamId?: Maybe<IntFilter>;
  type?: Maybe<EnumDocumentBaseTypeFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
  version?: Maybe<StringFilter>;
  withoutTeamInternalSeqId?: Maybe<IntFilter>;
};

export type DocumentBaseWhereUniqueInput = {
  AND?: Maybe<Array<DocumentBaseWhereInput>>;
  DocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationWhereInput>;
  DocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuerWhereInput>;
  DocumentBaseSignatureInviteGroups?: Maybe<DocumentBaseSignatureInviteGroupListRelationFilter>;
  DocumentCertificate?: Maybe<DocumentCertificateWhereInput>;
  DocumentDegree?: Maybe<DocumentDegreeWhereInput>;
  DocumentFinalAcademicTranscript?: Maybe<DocumentFinalAcademicTranscriptWhereInput>;
  DocumentSchoolCurriculum?: Maybe<DocumentSchoolCurriculumWhereInput>;
  ExternalSignatureInvite?: Maybe<ExternalSignatureInviteListRelationFilter>;
  Histories?: Maybe<DocumentBaseHistoryListRelationFilter>;
  NOT?: Maybe<Array<DocumentBaseWhereInput>>;
  OR?: Maybe<Array<DocumentBaseWhereInput>>;
  Team?: Maybe<TeamWhereInput>;
  UserOwner?: Maybe<CommonUserWhereInput>;
  commonUserId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  creationType?: Maybe<EnumDocumentAcademicDocumentationCreationTypeFilter>;
  data?: Maybe<JsonFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  filePath?: Maybe<StringNullableFilter>;
  internalSeqId?: Maybe<Scalars['String']>;
  teamId?: Maybe<IntFilter>;
  type?: Maybe<EnumDocumentBaseTypeFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
  version?: Maybe<StringFilter>;
  withoutTeamInternalSeqId?: Maybe<IntFilter>;
};

/** Guarda o certificado gerado a partir do template | Ou feito upload direto numa funcionalidade futura */
export type DocumentCertificate = {
  __typename?: 'DocumentCertificate';
  BulkCertificateRecord?: Maybe<BulkCertificateRecord>;
  Curriculum?: Maybe<CertificateCurriculum>;
  DocumentBase: DocumentBase;
  DocumentCertificateHashHistory: Array<DocumentCertificateHashHistory>;
  DocumentCertificateSignatureItems: Array<DocumentCertificateSignatureItem>;
  Event?: Maybe<CertificateEvent>;
  MetadataList: Array<DocumentCertificateMetadata>;
  Person: Person;
  TeamEducationLevel: TeamEducationLevel;
  Template?: Maybe<CertificateTemplate>;
  batchId?: Maybe<Scalars['String']>;
  certificateCurriculumCertificateBaseId?: Maybe<Scalars['String']>;
  certificateEventCertificateBaseId?: Maybe<Scalars['String']>;
  certificateTemplateId?: Maybe<Scalars['String']>;
  documentBaseId: Scalars['String'];
  documentCertificateCPF: Scalars['String'];
  documentCertificateEmail: Scalars['String'];
  documentCertificateName: Scalars['String'];
  hasOnlyPredefinedVisualSignature: Scalars['Boolean'];
  personId: Scalars['String'];
  status: DocumentCertificateStatus;
  teamEducationLevelId: Scalars['Int'];
  /** Used to validate in public url */
  uuid: Scalars['String'];
};


/** Guarda o certificado gerado a partir do template | Ou feito upload direto numa funcionalidade futura */
export type DocumentCertificateDocumentCertificateHashHistoryArgs = {
  cursor?: Maybe<DocumentCertificateHashHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentCertificateHashHistoryScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentCertificateHashHistoryOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentCertificateHashHistoryWhereInput>;
};


/** Guarda o certificado gerado a partir do template | Ou feito upload direto numa funcionalidade futura */
export type DocumentCertificateDocumentCertificateSignatureItemsArgs = {
  cursor?: Maybe<DocumentCertificateSignatureItemWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentCertificateSignatureItemScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentCertificateSignatureItemOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentCertificateSignatureItemWhereInput>;
};


/** Guarda o certificado gerado a partir do template | Ou feito upload direto numa funcionalidade futura */
export type DocumentCertificateMetadataListArgs = {
  cursor?: Maybe<DocumentCertificateMetadataWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentCertificateMetadataScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentCertificateMetadataOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentCertificateMetadataWhereInput>;
};

export type DocumentCertificateAvgOrderByAggregateInput = {
  teamEducationLevelId?: Maybe<SortOrder>;
};

export type DocumentCertificateCountOrderByAggregateInput = {
  batchId?: Maybe<SortOrder>;
  certificateCurriculumCertificateBaseId?: Maybe<SortOrder>;
  certificateEventCertificateBaseId?: Maybe<SortOrder>;
  certificateTemplateId?: Maybe<SortOrder>;
  documentBaseId?: Maybe<SortOrder>;
  documentCertificateCPF?: Maybe<SortOrder>;
  documentCertificateEmail?: Maybe<SortOrder>;
  documentCertificateName?: Maybe<SortOrder>;
  hasOnlyPredefinedVisualSignature?: Maybe<SortOrder>;
  personId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  teamEducationLevelId?: Maybe<SortOrder>;
  uuid?: Maybe<SortOrder>;
};

export type DocumentCertificateCreateInput = {
  BulkCertificateRecord?: Maybe<BulkCertificateRecordCreateNestedOneWithoutDocumentCertificatesInput>;
  Curriculum?: Maybe<CertificateCurriculumCreateNestedOneWithoutDocumentCertificateInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentCertificateInput;
  DocumentCertificateHashHistory?: Maybe<DocumentCertificateHashHistoryCreateNestedManyWithoutDocumentCertificateInput>;
  DocumentCertificateSignatureItems?: Maybe<DocumentCertificateSignatureItemCreateNestedManyWithoutDocumentCertificateInput>;
  Event?: Maybe<CertificateEventCreateNestedOneWithoutDocumentCertificateInput>;
  MetadataList?: Maybe<DocumentCertificateMetadataCreateNestedManyWithoutDocumentCertificateInput>;
  Person: PersonCreateNestedOneWithoutDocumentCertificateInput;
  TeamEducationLevel: TeamEducationLevelCreateNestedOneWithoutDocumentCertificateInput;
  Template?: Maybe<CertificateTemplateCreateNestedOneWithoutDocumentCertificateInput>;
  documentCertificateCPF?: Maybe<Scalars['String']>;
  documentCertificateEmail?: Maybe<Scalars['String']>;
  documentCertificateName?: Maybe<Scalars['String']>;
  hasOnlyPredefinedVisualSignature?: Maybe<Scalars['Boolean']>;
  status: DocumentCertificateStatus;
  uuid?: Maybe<Scalars['String']>;
};

export type DocumentCertificateCreateManyBulkCertificateRecordInput = {
  certificateCurriculumCertificateBaseId?: Maybe<Scalars['String']>;
  certificateEventCertificateBaseId?: Maybe<Scalars['String']>;
  certificateTemplateId?: Maybe<Scalars['String']>;
  documentBaseId: Scalars['String'];
  documentCertificateCPF?: Maybe<Scalars['String']>;
  documentCertificateEmail?: Maybe<Scalars['String']>;
  documentCertificateName?: Maybe<Scalars['String']>;
  hasOnlyPredefinedVisualSignature?: Maybe<Scalars['Boolean']>;
  personId: Scalars['String'];
  status: DocumentCertificateStatus;
  teamEducationLevelId: Scalars['Int'];
  uuid?: Maybe<Scalars['String']>;
};

export type DocumentCertificateCreateManyBulkCertificateRecordInputEnvelope = {
  data: Array<DocumentCertificateCreateManyBulkCertificateRecordInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentCertificateCreateManyCurriculumInput = {
  batchId?: Maybe<Scalars['String']>;
  certificateEventCertificateBaseId?: Maybe<Scalars['String']>;
  certificateTemplateId?: Maybe<Scalars['String']>;
  documentBaseId: Scalars['String'];
  documentCertificateCPF?: Maybe<Scalars['String']>;
  documentCertificateEmail?: Maybe<Scalars['String']>;
  documentCertificateName?: Maybe<Scalars['String']>;
  hasOnlyPredefinedVisualSignature?: Maybe<Scalars['Boolean']>;
  personId: Scalars['String'];
  status: DocumentCertificateStatus;
  teamEducationLevelId: Scalars['Int'];
  uuid?: Maybe<Scalars['String']>;
};

export type DocumentCertificateCreateManyCurriculumInputEnvelope = {
  data: Array<DocumentCertificateCreateManyCurriculumInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentCertificateCreateManyEventInput = {
  batchId?: Maybe<Scalars['String']>;
  certificateCurriculumCertificateBaseId?: Maybe<Scalars['String']>;
  certificateTemplateId?: Maybe<Scalars['String']>;
  documentBaseId: Scalars['String'];
  documentCertificateCPF?: Maybe<Scalars['String']>;
  documentCertificateEmail?: Maybe<Scalars['String']>;
  documentCertificateName?: Maybe<Scalars['String']>;
  hasOnlyPredefinedVisualSignature?: Maybe<Scalars['Boolean']>;
  personId: Scalars['String'];
  status: DocumentCertificateStatus;
  teamEducationLevelId: Scalars['Int'];
  uuid?: Maybe<Scalars['String']>;
};

export type DocumentCertificateCreateManyEventInputEnvelope = {
  data: Array<DocumentCertificateCreateManyEventInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentCertificateCreateManyInput = {
  batchId?: Maybe<Scalars['String']>;
  certificateCurriculumCertificateBaseId?: Maybe<Scalars['String']>;
  certificateEventCertificateBaseId?: Maybe<Scalars['String']>;
  certificateTemplateId?: Maybe<Scalars['String']>;
  documentBaseId: Scalars['String'];
  documentCertificateCPF?: Maybe<Scalars['String']>;
  documentCertificateEmail?: Maybe<Scalars['String']>;
  documentCertificateName?: Maybe<Scalars['String']>;
  hasOnlyPredefinedVisualSignature?: Maybe<Scalars['Boolean']>;
  personId: Scalars['String'];
  status: DocumentCertificateStatus;
  teamEducationLevelId: Scalars['Int'];
  uuid?: Maybe<Scalars['String']>;
};

export type DocumentCertificateCreateManyPersonInput = {
  batchId?: Maybe<Scalars['String']>;
  certificateCurriculumCertificateBaseId?: Maybe<Scalars['String']>;
  certificateEventCertificateBaseId?: Maybe<Scalars['String']>;
  certificateTemplateId?: Maybe<Scalars['String']>;
  documentBaseId: Scalars['String'];
  documentCertificateCPF?: Maybe<Scalars['String']>;
  documentCertificateEmail?: Maybe<Scalars['String']>;
  documentCertificateName?: Maybe<Scalars['String']>;
  hasOnlyPredefinedVisualSignature?: Maybe<Scalars['Boolean']>;
  status: DocumentCertificateStatus;
  teamEducationLevelId: Scalars['Int'];
  uuid?: Maybe<Scalars['String']>;
};

export type DocumentCertificateCreateManyPersonInputEnvelope = {
  data: Array<DocumentCertificateCreateManyPersonInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentCertificateCreateManyTeamEducationLevelInput = {
  batchId?: Maybe<Scalars['String']>;
  certificateCurriculumCertificateBaseId?: Maybe<Scalars['String']>;
  certificateEventCertificateBaseId?: Maybe<Scalars['String']>;
  certificateTemplateId?: Maybe<Scalars['String']>;
  documentBaseId: Scalars['String'];
  documentCertificateCPF?: Maybe<Scalars['String']>;
  documentCertificateEmail?: Maybe<Scalars['String']>;
  documentCertificateName?: Maybe<Scalars['String']>;
  hasOnlyPredefinedVisualSignature?: Maybe<Scalars['Boolean']>;
  personId: Scalars['String'];
  status: DocumentCertificateStatus;
  uuid?: Maybe<Scalars['String']>;
};

export type DocumentCertificateCreateManyTeamEducationLevelInputEnvelope = {
  data: Array<DocumentCertificateCreateManyTeamEducationLevelInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentCertificateCreateManyTemplateInput = {
  batchId?: Maybe<Scalars['String']>;
  certificateCurriculumCertificateBaseId?: Maybe<Scalars['String']>;
  certificateEventCertificateBaseId?: Maybe<Scalars['String']>;
  documentBaseId: Scalars['String'];
  documentCertificateCPF?: Maybe<Scalars['String']>;
  documentCertificateEmail?: Maybe<Scalars['String']>;
  documentCertificateName?: Maybe<Scalars['String']>;
  hasOnlyPredefinedVisualSignature?: Maybe<Scalars['Boolean']>;
  personId: Scalars['String'];
  status: DocumentCertificateStatus;
  teamEducationLevelId: Scalars['Int'];
  uuid?: Maybe<Scalars['String']>;
};

export type DocumentCertificateCreateManyTemplateInputEnvelope = {
  data: Array<DocumentCertificateCreateManyTemplateInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentCertificateCreateNestedManyWithoutBulkCertificateRecordInput = {
  connect?: Maybe<Array<DocumentCertificateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCertificateCreateOrConnectWithoutBulkCertificateRecordInput>>;
  create?: Maybe<Array<DocumentCertificateCreateWithoutBulkCertificateRecordInput>>;
  createMany?: Maybe<DocumentCertificateCreateManyBulkCertificateRecordInputEnvelope>;
};

export type DocumentCertificateCreateNestedManyWithoutCurriculumInput = {
  connect?: Maybe<Array<DocumentCertificateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCertificateCreateOrConnectWithoutCurriculumInput>>;
  create?: Maybe<Array<DocumentCertificateCreateWithoutCurriculumInput>>;
  createMany?: Maybe<DocumentCertificateCreateManyCurriculumInputEnvelope>;
};

export type DocumentCertificateCreateNestedManyWithoutEventInput = {
  connect?: Maybe<Array<DocumentCertificateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCertificateCreateOrConnectWithoutEventInput>>;
  create?: Maybe<Array<DocumentCertificateCreateWithoutEventInput>>;
  createMany?: Maybe<DocumentCertificateCreateManyEventInputEnvelope>;
};

export type DocumentCertificateCreateNestedManyWithoutPersonInput = {
  connect?: Maybe<Array<DocumentCertificateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCertificateCreateOrConnectWithoutPersonInput>>;
  create?: Maybe<Array<DocumentCertificateCreateWithoutPersonInput>>;
  createMany?: Maybe<DocumentCertificateCreateManyPersonInputEnvelope>;
};

export type DocumentCertificateCreateNestedManyWithoutTeamEducationLevelInput = {
  connect?: Maybe<Array<DocumentCertificateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCertificateCreateOrConnectWithoutTeamEducationLevelInput>>;
  create?: Maybe<Array<DocumentCertificateCreateWithoutTeamEducationLevelInput>>;
  createMany?: Maybe<DocumentCertificateCreateManyTeamEducationLevelInputEnvelope>;
};

export type DocumentCertificateCreateNestedManyWithoutTemplateInput = {
  connect?: Maybe<Array<DocumentCertificateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCertificateCreateOrConnectWithoutTemplateInput>>;
  create?: Maybe<Array<DocumentCertificateCreateWithoutTemplateInput>>;
  createMany?: Maybe<DocumentCertificateCreateManyTemplateInputEnvelope>;
};

export type DocumentCertificateCreateNestedOneWithoutDocumentBaseInput = {
  connect?: Maybe<DocumentCertificateWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentCertificateCreateOrConnectWithoutDocumentBaseInput>;
  create?: Maybe<DocumentCertificateCreateWithoutDocumentBaseInput>;
};

export type DocumentCertificateCreateNestedOneWithoutDocumentCertificateHashHistoryInput = {
  connect?: Maybe<DocumentCertificateWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentCertificateCreateOrConnectWithoutDocumentCertificateHashHistoryInput>;
  create?: Maybe<DocumentCertificateCreateWithoutDocumentCertificateHashHistoryInput>;
};

export type DocumentCertificateCreateNestedOneWithoutDocumentCertificateSignatureItemsInput = {
  connect?: Maybe<DocumentCertificateWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentCertificateCreateOrConnectWithoutDocumentCertificateSignatureItemsInput>;
  create?: Maybe<DocumentCertificateCreateWithoutDocumentCertificateSignatureItemsInput>;
};

export type DocumentCertificateCreateNestedOneWithoutMetadataListInput = {
  connect?: Maybe<DocumentCertificateWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentCertificateCreateOrConnectWithoutMetadataListInput>;
  create?: Maybe<DocumentCertificateCreateWithoutMetadataListInput>;
};

export type DocumentCertificateCreateOrConnectWithoutBulkCertificateRecordInput = {
  create: DocumentCertificateCreateWithoutBulkCertificateRecordInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateCreateOrConnectWithoutCurriculumInput = {
  create: DocumentCertificateCreateWithoutCurriculumInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateCreateOrConnectWithoutDocumentBaseInput = {
  create: DocumentCertificateCreateWithoutDocumentBaseInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateCreateOrConnectWithoutDocumentCertificateHashHistoryInput = {
  create: DocumentCertificateCreateWithoutDocumentCertificateHashHistoryInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateCreateOrConnectWithoutDocumentCertificateSignatureItemsInput = {
  create: DocumentCertificateCreateWithoutDocumentCertificateSignatureItemsInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateCreateOrConnectWithoutEventInput = {
  create: DocumentCertificateCreateWithoutEventInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateCreateOrConnectWithoutMetadataListInput = {
  create: DocumentCertificateCreateWithoutMetadataListInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateCreateOrConnectWithoutPersonInput = {
  create: DocumentCertificateCreateWithoutPersonInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateCreateOrConnectWithoutTeamEducationLevelInput = {
  create: DocumentCertificateCreateWithoutTeamEducationLevelInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateCreateOrConnectWithoutTemplateInput = {
  create: DocumentCertificateCreateWithoutTemplateInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateCreateWithoutBulkCertificateRecordInput = {
  Curriculum?: Maybe<CertificateCurriculumCreateNestedOneWithoutDocumentCertificateInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentCertificateInput;
  DocumentCertificateHashHistory?: Maybe<DocumentCertificateHashHistoryCreateNestedManyWithoutDocumentCertificateInput>;
  DocumentCertificateSignatureItems?: Maybe<DocumentCertificateSignatureItemCreateNestedManyWithoutDocumentCertificateInput>;
  Event?: Maybe<CertificateEventCreateNestedOneWithoutDocumentCertificateInput>;
  MetadataList?: Maybe<DocumentCertificateMetadataCreateNestedManyWithoutDocumentCertificateInput>;
  Person: PersonCreateNestedOneWithoutDocumentCertificateInput;
  TeamEducationLevel: TeamEducationLevelCreateNestedOneWithoutDocumentCertificateInput;
  Template?: Maybe<CertificateTemplateCreateNestedOneWithoutDocumentCertificateInput>;
  documentCertificateCPF?: Maybe<Scalars['String']>;
  documentCertificateEmail?: Maybe<Scalars['String']>;
  documentCertificateName?: Maybe<Scalars['String']>;
  hasOnlyPredefinedVisualSignature?: Maybe<Scalars['Boolean']>;
  status: DocumentCertificateStatus;
  uuid?: Maybe<Scalars['String']>;
};

export type DocumentCertificateCreateWithoutCurriculumInput = {
  BulkCertificateRecord?: Maybe<BulkCertificateRecordCreateNestedOneWithoutDocumentCertificatesInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentCertificateInput;
  DocumentCertificateHashHistory?: Maybe<DocumentCertificateHashHistoryCreateNestedManyWithoutDocumentCertificateInput>;
  DocumentCertificateSignatureItems?: Maybe<DocumentCertificateSignatureItemCreateNestedManyWithoutDocumentCertificateInput>;
  Event?: Maybe<CertificateEventCreateNestedOneWithoutDocumentCertificateInput>;
  MetadataList?: Maybe<DocumentCertificateMetadataCreateNestedManyWithoutDocumentCertificateInput>;
  Person: PersonCreateNestedOneWithoutDocumentCertificateInput;
  TeamEducationLevel: TeamEducationLevelCreateNestedOneWithoutDocumentCertificateInput;
  Template?: Maybe<CertificateTemplateCreateNestedOneWithoutDocumentCertificateInput>;
  documentCertificateCPF?: Maybe<Scalars['String']>;
  documentCertificateEmail?: Maybe<Scalars['String']>;
  documentCertificateName?: Maybe<Scalars['String']>;
  hasOnlyPredefinedVisualSignature?: Maybe<Scalars['Boolean']>;
  status: DocumentCertificateStatus;
  uuid?: Maybe<Scalars['String']>;
};

export type DocumentCertificateCreateWithoutDocumentBaseInput = {
  BulkCertificateRecord?: Maybe<BulkCertificateRecordCreateNestedOneWithoutDocumentCertificatesInput>;
  Curriculum?: Maybe<CertificateCurriculumCreateNestedOneWithoutDocumentCertificateInput>;
  DocumentCertificateHashHistory?: Maybe<DocumentCertificateHashHistoryCreateNestedManyWithoutDocumentCertificateInput>;
  DocumentCertificateSignatureItems?: Maybe<DocumentCertificateSignatureItemCreateNestedManyWithoutDocumentCertificateInput>;
  Event?: Maybe<CertificateEventCreateNestedOneWithoutDocumentCertificateInput>;
  MetadataList?: Maybe<DocumentCertificateMetadataCreateNestedManyWithoutDocumentCertificateInput>;
  Person: PersonCreateNestedOneWithoutDocumentCertificateInput;
  TeamEducationLevel: TeamEducationLevelCreateNestedOneWithoutDocumentCertificateInput;
  Template?: Maybe<CertificateTemplateCreateNestedOneWithoutDocumentCertificateInput>;
  documentCertificateCPF?: Maybe<Scalars['String']>;
  documentCertificateEmail?: Maybe<Scalars['String']>;
  documentCertificateName?: Maybe<Scalars['String']>;
  hasOnlyPredefinedVisualSignature?: Maybe<Scalars['Boolean']>;
  status: DocumentCertificateStatus;
  uuid?: Maybe<Scalars['String']>;
};

export type DocumentCertificateCreateWithoutDocumentCertificateHashHistoryInput = {
  BulkCertificateRecord?: Maybe<BulkCertificateRecordCreateNestedOneWithoutDocumentCertificatesInput>;
  Curriculum?: Maybe<CertificateCurriculumCreateNestedOneWithoutDocumentCertificateInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentCertificateInput;
  DocumentCertificateSignatureItems?: Maybe<DocumentCertificateSignatureItemCreateNestedManyWithoutDocumentCertificateInput>;
  Event?: Maybe<CertificateEventCreateNestedOneWithoutDocumentCertificateInput>;
  MetadataList?: Maybe<DocumentCertificateMetadataCreateNestedManyWithoutDocumentCertificateInput>;
  Person: PersonCreateNestedOneWithoutDocumentCertificateInput;
  TeamEducationLevel: TeamEducationLevelCreateNestedOneWithoutDocumentCertificateInput;
  Template?: Maybe<CertificateTemplateCreateNestedOneWithoutDocumentCertificateInput>;
  documentCertificateCPF?: Maybe<Scalars['String']>;
  documentCertificateEmail?: Maybe<Scalars['String']>;
  documentCertificateName?: Maybe<Scalars['String']>;
  hasOnlyPredefinedVisualSignature?: Maybe<Scalars['Boolean']>;
  status: DocumentCertificateStatus;
  uuid?: Maybe<Scalars['String']>;
};

export type DocumentCertificateCreateWithoutDocumentCertificateSignatureItemsInput = {
  BulkCertificateRecord?: Maybe<BulkCertificateRecordCreateNestedOneWithoutDocumentCertificatesInput>;
  Curriculum?: Maybe<CertificateCurriculumCreateNestedOneWithoutDocumentCertificateInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentCertificateInput;
  DocumentCertificateHashHistory?: Maybe<DocumentCertificateHashHistoryCreateNestedManyWithoutDocumentCertificateInput>;
  Event?: Maybe<CertificateEventCreateNestedOneWithoutDocumentCertificateInput>;
  MetadataList?: Maybe<DocumentCertificateMetadataCreateNestedManyWithoutDocumentCertificateInput>;
  Person: PersonCreateNestedOneWithoutDocumentCertificateInput;
  TeamEducationLevel: TeamEducationLevelCreateNestedOneWithoutDocumentCertificateInput;
  Template?: Maybe<CertificateTemplateCreateNestedOneWithoutDocumentCertificateInput>;
  documentCertificateCPF?: Maybe<Scalars['String']>;
  documentCertificateEmail?: Maybe<Scalars['String']>;
  documentCertificateName?: Maybe<Scalars['String']>;
  hasOnlyPredefinedVisualSignature?: Maybe<Scalars['Boolean']>;
  status: DocumentCertificateStatus;
  uuid?: Maybe<Scalars['String']>;
};

export type DocumentCertificateCreateWithoutEventInput = {
  BulkCertificateRecord?: Maybe<BulkCertificateRecordCreateNestedOneWithoutDocumentCertificatesInput>;
  Curriculum?: Maybe<CertificateCurriculumCreateNestedOneWithoutDocumentCertificateInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentCertificateInput;
  DocumentCertificateHashHistory?: Maybe<DocumentCertificateHashHistoryCreateNestedManyWithoutDocumentCertificateInput>;
  DocumentCertificateSignatureItems?: Maybe<DocumentCertificateSignatureItemCreateNestedManyWithoutDocumentCertificateInput>;
  MetadataList?: Maybe<DocumentCertificateMetadataCreateNestedManyWithoutDocumentCertificateInput>;
  Person: PersonCreateNestedOneWithoutDocumentCertificateInput;
  TeamEducationLevel: TeamEducationLevelCreateNestedOneWithoutDocumentCertificateInput;
  Template?: Maybe<CertificateTemplateCreateNestedOneWithoutDocumentCertificateInput>;
  documentCertificateCPF?: Maybe<Scalars['String']>;
  documentCertificateEmail?: Maybe<Scalars['String']>;
  documentCertificateName?: Maybe<Scalars['String']>;
  hasOnlyPredefinedVisualSignature?: Maybe<Scalars['Boolean']>;
  status: DocumentCertificateStatus;
  uuid?: Maybe<Scalars['String']>;
};

export type DocumentCertificateCreateWithoutMetadataListInput = {
  BulkCertificateRecord?: Maybe<BulkCertificateRecordCreateNestedOneWithoutDocumentCertificatesInput>;
  Curriculum?: Maybe<CertificateCurriculumCreateNestedOneWithoutDocumentCertificateInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentCertificateInput;
  DocumentCertificateHashHistory?: Maybe<DocumentCertificateHashHistoryCreateNestedManyWithoutDocumentCertificateInput>;
  DocumentCertificateSignatureItems?: Maybe<DocumentCertificateSignatureItemCreateNestedManyWithoutDocumentCertificateInput>;
  Event?: Maybe<CertificateEventCreateNestedOneWithoutDocumentCertificateInput>;
  Person: PersonCreateNestedOneWithoutDocumentCertificateInput;
  TeamEducationLevel: TeamEducationLevelCreateNestedOneWithoutDocumentCertificateInput;
  Template?: Maybe<CertificateTemplateCreateNestedOneWithoutDocumentCertificateInput>;
  documentCertificateCPF?: Maybe<Scalars['String']>;
  documentCertificateEmail?: Maybe<Scalars['String']>;
  documentCertificateName?: Maybe<Scalars['String']>;
  hasOnlyPredefinedVisualSignature?: Maybe<Scalars['Boolean']>;
  status: DocumentCertificateStatus;
  uuid?: Maybe<Scalars['String']>;
};

export type DocumentCertificateCreateWithoutPersonInput = {
  BulkCertificateRecord?: Maybe<BulkCertificateRecordCreateNestedOneWithoutDocumentCertificatesInput>;
  Curriculum?: Maybe<CertificateCurriculumCreateNestedOneWithoutDocumentCertificateInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentCertificateInput;
  DocumentCertificateHashHistory?: Maybe<DocumentCertificateHashHistoryCreateNestedManyWithoutDocumentCertificateInput>;
  DocumentCertificateSignatureItems?: Maybe<DocumentCertificateSignatureItemCreateNestedManyWithoutDocumentCertificateInput>;
  Event?: Maybe<CertificateEventCreateNestedOneWithoutDocumentCertificateInput>;
  MetadataList?: Maybe<DocumentCertificateMetadataCreateNestedManyWithoutDocumentCertificateInput>;
  TeamEducationLevel: TeamEducationLevelCreateNestedOneWithoutDocumentCertificateInput;
  Template?: Maybe<CertificateTemplateCreateNestedOneWithoutDocumentCertificateInput>;
  documentCertificateCPF?: Maybe<Scalars['String']>;
  documentCertificateEmail?: Maybe<Scalars['String']>;
  documentCertificateName?: Maybe<Scalars['String']>;
  hasOnlyPredefinedVisualSignature?: Maybe<Scalars['Boolean']>;
  status: DocumentCertificateStatus;
  uuid?: Maybe<Scalars['String']>;
};

export type DocumentCertificateCreateWithoutTeamEducationLevelInput = {
  BulkCertificateRecord?: Maybe<BulkCertificateRecordCreateNestedOneWithoutDocumentCertificatesInput>;
  Curriculum?: Maybe<CertificateCurriculumCreateNestedOneWithoutDocumentCertificateInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentCertificateInput;
  DocumentCertificateHashHistory?: Maybe<DocumentCertificateHashHistoryCreateNestedManyWithoutDocumentCertificateInput>;
  DocumentCertificateSignatureItems?: Maybe<DocumentCertificateSignatureItemCreateNestedManyWithoutDocumentCertificateInput>;
  Event?: Maybe<CertificateEventCreateNestedOneWithoutDocumentCertificateInput>;
  MetadataList?: Maybe<DocumentCertificateMetadataCreateNestedManyWithoutDocumentCertificateInput>;
  Person: PersonCreateNestedOneWithoutDocumentCertificateInput;
  Template?: Maybe<CertificateTemplateCreateNestedOneWithoutDocumentCertificateInput>;
  documentCertificateCPF?: Maybe<Scalars['String']>;
  documentCertificateEmail?: Maybe<Scalars['String']>;
  documentCertificateName?: Maybe<Scalars['String']>;
  hasOnlyPredefinedVisualSignature?: Maybe<Scalars['Boolean']>;
  status: DocumentCertificateStatus;
  uuid?: Maybe<Scalars['String']>;
};

export type DocumentCertificateCreateWithoutTemplateInput = {
  BulkCertificateRecord?: Maybe<BulkCertificateRecordCreateNestedOneWithoutDocumentCertificatesInput>;
  Curriculum?: Maybe<CertificateCurriculumCreateNestedOneWithoutDocumentCertificateInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentCertificateInput;
  DocumentCertificateHashHistory?: Maybe<DocumentCertificateHashHistoryCreateNestedManyWithoutDocumentCertificateInput>;
  DocumentCertificateSignatureItems?: Maybe<DocumentCertificateSignatureItemCreateNestedManyWithoutDocumentCertificateInput>;
  Event?: Maybe<CertificateEventCreateNestedOneWithoutDocumentCertificateInput>;
  MetadataList?: Maybe<DocumentCertificateMetadataCreateNestedManyWithoutDocumentCertificateInput>;
  Person: PersonCreateNestedOneWithoutDocumentCertificateInput;
  TeamEducationLevel: TeamEducationLevelCreateNestedOneWithoutDocumentCertificateInput;
  documentCertificateCPF?: Maybe<Scalars['String']>;
  documentCertificateEmail?: Maybe<Scalars['String']>;
  documentCertificateName?: Maybe<Scalars['String']>;
  hasOnlyPredefinedVisualSignature?: Maybe<Scalars['Boolean']>;
  status: DocumentCertificateStatus;
  uuid?: Maybe<Scalars['String']>;
};

export type DocumentCertificateHashHistory = {
  __typename?: 'DocumentCertificateHashHistory';
  DocumentCertificate: DocumentCertificate;
  createdAt: Scalars['DateTime'];
  documentBaseId: Scalars['String'];
  hash: Scalars['String'];
  hashType: Scalars['String'];
  id: Scalars['String'];
};

export type DocumentCertificateHashHistoryCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  documentBaseId?: Maybe<SortOrder>;
  hash?: Maybe<SortOrder>;
  hashType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type DocumentCertificateHashHistoryCreateInput = {
  DocumentCertificate: DocumentCertificateCreateNestedOneWithoutDocumentCertificateHashHistoryInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  hash: Scalars['String'];
  hashType: DocumentCertificateSignatureHashHistoryType;
  id?: Maybe<Scalars['String']>;
};

export type DocumentCertificateHashHistoryCreateManyDocumentCertificateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hash: Scalars['String'];
  hashType: DocumentCertificateSignatureHashHistoryType;
  id?: Maybe<Scalars['String']>;
};

export type DocumentCertificateHashHistoryCreateManyDocumentCertificateInputEnvelope = {
  data: Array<DocumentCertificateHashHistoryCreateManyDocumentCertificateInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentCertificateHashHistoryCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  documentBaseId: Scalars['String'];
  hash: Scalars['String'];
  hashType: DocumentCertificateSignatureHashHistoryType;
  id?: Maybe<Scalars['String']>;
};

export type DocumentCertificateHashHistoryCreateNestedManyWithoutDocumentCertificateInput = {
  connect?: Maybe<Array<DocumentCertificateHashHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCertificateHashHistoryCreateOrConnectWithoutDocumentCertificateInput>>;
  create?: Maybe<Array<DocumentCertificateHashHistoryCreateWithoutDocumentCertificateInput>>;
  createMany?: Maybe<DocumentCertificateHashHistoryCreateManyDocumentCertificateInputEnvelope>;
};

export type DocumentCertificateHashHistoryCreateOrConnectWithoutDocumentCertificateInput = {
  create: DocumentCertificateHashHistoryCreateWithoutDocumentCertificateInput;
  where: DocumentCertificateHashHistoryWhereUniqueInput;
};

export type DocumentCertificateHashHistoryCreateWithoutDocumentCertificateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  hash: Scalars['String'];
  hashType: DocumentCertificateSignatureHashHistoryType;
  id?: Maybe<Scalars['String']>;
};

export type DocumentCertificateHashHistoryListRelationFilter = {
  every?: Maybe<DocumentCertificateHashHistoryWhereInput>;
  none?: Maybe<DocumentCertificateHashHistoryWhereInput>;
  some?: Maybe<DocumentCertificateHashHistoryWhereInput>;
};

export type DocumentCertificateHashHistoryMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  documentBaseId?: Maybe<SortOrder>;
  hash?: Maybe<SortOrder>;
  hashType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type DocumentCertificateHashHistoryMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  documentBaseId?: Maybe<SortOrder>;
  hash?: Maybe<SortOrder>;
  hashType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type DocumentCertificateHashHistoryOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type DocumentCertificateHashHistoryOrderByWithAggregationInput = {
  _count?: Maybe<DocumentCertificateHashHistoryCountOrderByAggregateInput>;
  _max?: Maybe<DocumentCertificateHashHistoryMaxOrderByAggregateInput>;
  _min?: Maybe<DocumentCertificateHashHistoryMinOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  documentBaseId?: Maybe<SortOrder>;
  hash?: Maybe<SortOrder>;
  hashType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type DocumentCertificateHashHistoryOrderByWithRelationInput = {
  DocumentCertificate?: Maybe<DocumentCertificateOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  documentBaseId?: Maybe<SortOrder>;
  hash?: Maybe<SortOrder>;
  hashType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export enum DocumentCertificateHashHistoryScalarFieldEnum {
  CreatedAt = 'createdAt',
  DocumentBaseId = 'documentBaseId',
  Hash = 'hash',
  HashType = 'hashType',
  Id = 'id'
}

export type DocumentCertificateHashHistoryScalarWhereInput = {
  AND?: Maybe<Array<DocumentCertificateHashHistoryScalarWhereInput>>;
  NOT?: Maybe<Array<DocumentCertificateHashHistoryScalarWhereInput>>;
  OR?: Maybe<Array<DocumentCertificateHashHistoryScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  documentBaseId?: Maybe<StringFilter>;
  hash?: Maybe<StringFilter>;
  hashType?: Maybe<EnumDocumentCertificateSignatureHashHistoryTypeFilter>;
  id?: Maybe<StringFilter>;
};

export type DocumentCertificateHashHistoryScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<DocumentCertificateHashHistoryScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<DocumentCertificateHashHistoryScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<DocumentCertificateHashHistoryScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  documentBaseId?: Maybe<StringWithAggregatesFilter>;
  hash?: Maybe<StringWithAggregatesFilter>;
  hashType?: Maybe<EnumDocumentCertificateSignatureHashHistoryTypeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
};

export type DocumentCertificateHashHistoryUpdateInput = {
  DocumentCertificate?: Maybe<DocumentCertificateUpdateOneRequiredWithoutDocumentCertificateHashHistoryNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  hash?: Maybe<StringFieldUpdateOperationsInput>;
  hashType?: Maybe<EnumDocumentCertificateSignatureHashHistoryTypeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateHashHistoryUpdateManyMutationInput = {
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  hash?: Maybe<StringFieldUpdateOperationsInput>;
  hashType?: Maybe<EnumDocumentCertificateSignatureHashHistoryTypeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateHashHistoryUpdateManyWithWhereWithoutDocumentCertificateInput = {
  data: DocumentCertificateHashHistoryUpdateManyMutationInput;
  where: DocumentCertificateHashHistoryScalarWhereInput;
};

export type DocumentCertificateHashHistoryUpdateManyWithoutDocumentCertificateNestedInput = {
  connect?: Maybe<Array<DocumentCertificateHashHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCertificateHashHistoryCreateOrConnectWithoutDocumentCertificateInput>>;
  create?: Maybe<Array<DocumentCertificateHashHistoryCreateWithoutDocumentCertificateInput>>;
  createMany?: Maybe<DocumentCertificateHashHistoryCreateManyDocumentCertificateInputEnvelope>;
  delete?: Maybe<Array<DocumentCertificateHashHistoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentCertificateHashHistoryScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentCertificateHashHistoryWhereUniqueInput>>;
  set?: Maybe<Array<DocumentCertificateHashHistoryWhereUniqueInput>>;
  update?: Maybe<Array<DocumentCertificateHashHistoryUpdateWithWhereUniqueWithoutDocumentCertificateInput>>;
  updateMany?: Maybe<Array<DocumentCertificateHashHistoryUpdateManyWithWhereWithoutDocumentCertificateInput>>;
  upsert?: Maybe<Array<DocumentCertificateHashHistoryUpsertWithWhereUniqueWithoutDocumentCertificateInput>>;
};

export type DocumentCertificateHashHistoryUpdateWithWhereUniqueWithoutDocumentCertificateInput = {
  data: DocumentCertificateHashHistoryUpdateWithoutDocumentCertificateInput;
  where: DocumentCertificateHashHistoryWhereUniqueInput;
};

export type DocumentCertificateHashHistoryUpdateWithoutDocumentCertificateInput = {
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  hash?: Maybe<StringFieldUpdateOperationsInput>;
  hashType?: Maybe<EnumDocumentCertificateSignatureHashHistoryTypeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateHashHistoryUpsertWithWhereUniqueWithoutDocumentCertificateInput = {
  create: DocumentCertificateHashHistoryCreateWithoutDocumentCertificateInput;
  update: DocumentCertificateHashHistoryUpdateWithoutDocumentCertificateInput;
  where: DocumentCertificateHashHistoryWhereUniqueInput;
};

export type DocumentCertificateHashHistoryWhereInput = {
  AND?: Maybe<Array<DocumentCertificateHashHistoryWhereInput>>;
  DocumentCertificate?: Maybe<DocumentCertificateWhereInput>;
  NOT?: Maybe<Array<DocumentCertificateHashHistoryWhereInput>>;
  OR?: Maybe<Array<DocumentCertificateHashHistoryWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  documentBaseId?: Maybe<StringFilter>;
  hash?: Maybe<StringFilter>;
  hashType?: Maybe<EnumDocumentCertificateSignatureHashHistoryTypeFilter>;
  id?: Maybe<StringFilter>;
};

export type DocumentCertificateHashHistoryWhereUniqueInput = {
  AND?: Maybe<Array<DocumentCertificateHashHistoryWhereInput>>;
  DocumentCertificate?: Maybe<DocumentCertificateWhereInput>;
  NOT?: Maybe<Array<DocumentCertificateHashHistoryWhereInput>>;
  OR?: Maybe<Array<DocumentCertificateHashHistoryWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  documentBaseId?: Maybe<StringFilter>;
  hash?: Maybe<Scalars['String']>;
  hashType?: Maybe<EnumDocumentCertificateSignatureHashHistoryTypeFilter>;
  id?: Maybe<Scalars['String']>;
};

export type DocumentCertificateListRelationFilter = {
  every?: Maybe<DocumentCertificateWhereInput>;
  none?: Maybe<DocumentCertificateWhereInput>;
  some?: Maybe<DocumentCertificateWhereInput>;
};

export type DocumentCertificateMaxOrderByAggregateInput = {
  batchId?: Maybe<SortOrder>;
  certificateCurriculumCertificateBaseId?: Maybe<SortOrder>;
  certificateEventCertificateBaseId?: Maybe<SortOrder>;
  certificateTemplateId?: Maybe<SortOrder>;
  documentBaseId?: Maybe<SortOrder>;
  documentCertificateCPF?: Maybe<SortOrder>;
  documentCertificateEmail?: Maybe<SortOrder>;
  documentCertificateName?: Maybe<SortOrder>;
  hasOnlyPredefinedVisualSignature?: Maybe<SortOrder>;
  personId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  teamEducationLevelId?: Maybe<SortOrder>;
  uuid?: Maybe<SortOrder>;
};

export type DocumentCertificateMetadata = {
  __typename?: 'DocumentCertificateMetadata';
  DocumentCertificate: DocumentCertificate;
  certificateId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  key: Scalars['String'];
  value: Scalars['String'];
};

export type DocumentCertificateMetadataAvgOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
};

export type DocumentCertificateMetadataCountOrderByAggregateInput = {
  certificateId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  key?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export type DocumentCertificateMetadataCreateInput = {
  DocumentCertificate: DocumentCertificateCreateNestedOneWithoutMetadataListInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  key: Scalars['String'];
  value: Scalars['String'];
};

export type DocumentCertificateMetadataCreateManyDocumentCertificateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  key: Scalars['String'];
  value: Scalars['String'];
};

export type DocumentCertificateMetadataCreateManyDocumentCertificateInputEnvelope = {
  data: Array<DocumentCertificateMetadataCreateManyDocumentCertificateInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentCertificateMetadataCreateManyInput = {
  certificateId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  key: Scalars['String'];
  value: Scalars['String'];
};

export type DocumentCertificateMetadataCreateNestedManyWithoutDocumentCertificateInput = {
  connect?: Maybe<Array<DocumentCertificateMetadataWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCertificateMetadataCreateOrConnectWithoutDocumentCertificateInput>>;
  create?: Maybe<Array<DocumentCertificateMetadataCreateWithoutDocumentCertificateInput>>;
  createMany?: Maybe<DocumentCertificateMetadataCreateManyDocumentCertificateInputEnvelope>;
};

export type DocumentCertificateMetadataCreateOrConnectWithoutDocumentCertificateInput = {
  create: DocumentCertificateMetadataCreateWithoutDocumentCertificateInput;
  where: DocumentCertificateMetadataWhereUniqueInput;
};

export type DocumentCertificateMetadataCreateWithoutDocumentCertificateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  key: Scalars['String'];
  value: Scalars['String'];
};

export type DocumentCertificateMetadataListRelationFilter = {
  every?: Maybe<DocumentCertificateMetadataWhereInput>;
  none?: Maybe<DocumentCertificateMetadataWhereInput>;
  some?: Maybe<DocumentCertificateMetadataWhereInput>;
};

export type DocumentCertificateMetadataMaxOrderByAggregateInput = {
  certificateId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  key?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export type DocumentCertificateMetadataMinOrderByAggregateInput = {
  certificateId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  key?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export type DocumentCertificateMetadataOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type DocumentCertificateMetadataOrderByWithAggregationInput = {
  _avg?: Maybe<DocumentCertificateMetadataAvgOrderByAggregateInput>;
  _count?: Maybe<DocumentCertificateMetadataCountOrderByAggregateInput>;
  _max?: Maybe<DocumentCertificateMetadataMaxOrderByAggregateInput>;
  _min?: Maybe<DocumentCertificateMetadataMinOrderByAggregateInput>;
  _sum?: Maybe<DocumentCertificateMetadataSumOrderByAggregateInput>;
  certificateId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  key?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export type DocumentCertificateMetadataOrderByWithRelationInput = {
  DocumentCertificate?: Maybe<DocumentCertificateOrderByWithRelationInput>;
  certificateId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  key?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export enum DocumentCertificateMetadataScalarFieldEnum {
  CertificateId = 'certificateId',
  CreatedAt = 'createdAt',
  Id = 'id',
  Key = 'key',
  Value = 'value'
}

export type DocumentCertificateMetadataScalarWhereInput = {
  AND?: Maybe<Array<DocumentCertificateMetadataScalarWhereInput>>;
  NOT?: Maybe<Array<DocumentCertificateMetadataScalarWhereInput>>;
  OR?: Maybe<Array<DocumentCertificateMetadataScalarWhereInput>>;
  certificateId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  key?: Maybe<StringFilter>;
  value?: Maybe<StringFilter>;
};

export type DocumentCertificateMetadataScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<DocumentCertificateMetadataScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<DocumentCertificateMetadataScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<DocumentCertificateMetadataScalarWhereWithAggregatesInput>>;
  certificateId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  key?: Maybe<StringWithAggregatesFilter>;
  value?: Maybe<StringWithAggregatesFilter>;
};

export type DocumentCertificateMetadataSumOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
};

export type DocumentCertificateMetadataUpdateInput = {
  DocumentCertificate?: Maybe<DocumentCertificateUpdateOneRequiredWithoutMetadataListNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  key?: Maybe<StringFieldUpdateOperationsInput>;
  value?: Maybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateMetadataUpdateManyMutationInput = {
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  key?: Maybe<StringFieldUpdateOperationsInput>;
  value?: Maybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateMetadataUpdateManyWithWhereWithoutDocumentCertificateInput = {
  data: DocumentCertificateMetadataUpdateManyMutationInput;
  where: DocumentCertificateMetadataScalarWhereInput;
};

export type DocumentCertificateMetadataUpdateManyWithoutDocumentCertificateNestedInput = {
  connect?: Maybe<Array<DocumentCertificateMetadataWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCertificateMetadataCreateOrConnectWithoutDocumentCertificateInput>>;
  create?: Maybe<Array<DocumentCertificateMetadataCreateWithoutDocumentCertificateInput>>;
  createMany?: Maybe<DocumentCertificateMetadataCreateManyDocumentCertificateInputEnvelope>;
  delete?: Maybe<Array<DocumentCertificateMetadataWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentCertificateMetadataScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentCertificateMetadataWhereUniqueInput>>;
  set?: Maybe<Array<DocumentCertificateMetadataWhereUniqueInput>>;
  update?: Maybe<Array<DocumentCertificateMetadataUpdateWithWhereUniqueWithoutDocumentCertificateInput>>;
  updateMany?: Maybe<Array<DocumentCertificateMetadataUpdateManyWithWhereWithoutDocumentCertificateInput>>;
  upsert?: Maybe<Array<DocumentCertificateMetadataUpsertWithWhereUniqueWithoutDocumentCertificateInput>>;
};

export type DocumentCertificateMetadataUpdateWithWhereUniqueWithoutDocumentCertificateInput = {
  data: DocumentCertificateMetadataUpdateWithoutDocumentCertificateInput;
  where: DocumentCertificateMetadataWhereUniqueInput;
};

export type DocumentCertificateMetadataUpdateWithoutDocumentCertificateInput = {
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  key?: Maybe<StringFieldUpdateOperationsInput>;
  value?: Maybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateMetadataUpsertWithWhereUniqueWithoutDocumentCertificateInput = {
  create: DocumentCertificateMetadataCreateWithoutDocumentCertificateInput;
  update: DocumentCertificateMetadataUpdateWithoutDocumentCertificateInput;
  where: DocumentCertificateMetadataWhereUniqueInput;
};

export type DocumentCertificateMetadataWhereInput = {
  AND?: Maybe<Array<DocumentCertificateMetadataWhereInput>>;
  DocumentCertificate?: Maybe<DocumentCertificateWhereInput>;
  NOT?: Maybe<Array<DocumentCertificateMetadataWhereInput>>;
  OR?: Maybe<Array<DocumentCertificateMetadataWhereInput>>;
  certificateId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  key?: Maybe<StringFilter>;
  value?: Maybe<StringFilter>;
};

export type DocumentCertificateMetadataWhereUniqueInput = {
  AND?: Maybe<Array<DocumentCertificateMetadataWhereInput>>;
  DocumentCertificate?: Maybe<DocumentCertificateWhereInput>;
  NOT?: Maybe<Array<DocumentCertificateMetadataWhereInput>>;
  OR?: Maybe<Array<DocumentCertificateMetadataWhereInput>>;
  certificateId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['Int']>;
  key?: Maybe<StringFilter>;
  value?: Maybe<StringFilter>;
};

export type DocumentCertificateMinOrderByAggregateInput = {
  batchId?: Maybe<SortOrder>;
  certificateCurriculumCertificateBaseId?: Maybe<SortOrder>;
  certificateEventCertificateBaseId?: Maybe<SortOrder>;
  certificateTemplateId?: Maybe<SortOrder>;
  documentBaseId?: Maybe<SortOrder>;
  documentCertificateCPF?: Maybe<SortOrder>;
  documentCertificateEmail?: Maybe<SortOrder>;
  documentCertificateName?: Maybe<SortOrder>;
  hasOnlyPredefinedVisualSignature?: Maybe<SortOrder>;
  personId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  teamEducationLevelId?: Maybe<SortOrder>;
  uuid?: Maybe<SortOrder>;
};

export type DocumentCertificateNullableRelationFilter = {
  is?: Maybe<DocumentCertificateWhereInput>;
  isNot?: Maybe<DocumentCertificateWhereInput>;
};

export type DocumentCertificateOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type DocumentCertificateOrderByWithAggregationInput = {
  _avg?: Maybe<DocumentCertificateAvgOrderByAggregateInput>;
  _count?: Maybe<DocumentCertificateCountOrderByAggregateInput>;
  _max?: Maybe<DocumentCertificateMaxOrderByAggregateInput>;
  _min?: Maybe<DocumentCertificateMinOrderByAggregateInput>;
  _sum?: Maybe<DocumentCertificateSumOrderByAggregateInput>;
  batchId?: Maybe<SortOrder>;
  certificateCurriculumCertificateBaseId?: Maybe<SortOrder>;
  certificateEventCertificateBaseId?: Maybe<SortOrder>;
  certificateTemplateId?: Maybe<SortOrder>;
  documentBaseId?: Maybe<SortOrder>;
  documentCertificateCPF?: Maybe<SortOrder>;
  documentCertificateEmail?: Maybe<SortOrder>;
  documentCertificateName?: Maybe<SortOrder>;
  hasOnlyPredefinedVisualSignature?: Maybe<SortOrder>;
  personId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  teamEducationLevelId?: Maybe<SortOrder>;
  uuid?: Maybe<SortOrder>;
};

export type DocumentCertificateOrderByWithRelationInput = {
  BulkCertificateRecord?: Maybe<BulkCertificateRecordOrderByWithRelationInput>;
  Curriculum?: Maybe<CertificateCurriculumOrderByWithRelationInput>;
  DocumentBase?: Maybe<DocumentBaseOrderByWithRelationInput>;
  DocumentCertificateHashHistory?: Maybe<DocumentCertificateHashHistoryOrderByRelationAggregateInput>;
  DocumentCertificateSignatureItems?: Maybe<DocumentCertificateSignatureItemOrderByRelationAggregateInput>;
  Event?: Maybe<CertificateEventOrderByWithRelationInput>;
  MetadataList?: Maybe<DocumentCertificateMetadataOrderByRelationAggregateInput>;
  Person?: Maybe<PersonOrderByWithRelationInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelOrderByWithRelationInput>;
  Template?: Maybe<CertificateTemplateOrderByWithRelationInput>;
  batchId?: Maybe<SortOrder>;
  certificateCurriculumCertificateBaseId?: Maybe<SortOrder>;
  certificateEventCertificateBaseId?: Maybe<SortOrder>;
  certificateTemplateId?: Maybe<SortOrder>;
  documentBaseId?: Maybe<SortOrder>;
  documentCertificateCPF?: Maybe<SortOrder>;
  documentCertificateEmail?: Maybe<SortOrder>;
  documentCertificateName?: Maybe<SortOrder>;
  hasOnlyPredefinedVisualSignature?: Maybe<SortOrder>;
  personId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  teamEducationLevelId?: Maybe<SortOrder>;
  uuid?: Maybe<SortOrder>;
};

export type DocumentCertificateRelationFilter = {
  is?: Maybe<DocumentCertificateWhereInput>;
  isNot?: Maybe<DocumentCertificateWhereInput>;
};

export enum DocumentCertificateScalarFieldEnum {
  BatchId = 'batchId',
  CertificateCurriculumCertificateBaseId = 'certificateCurriculumCertificateBaseId',
  CertificateEventCertificateBaseId = 'certificateEventCertificateBaseId',
  CertificateTemplateId = 'certificateTemplateId',
  DocumentBaseId = 'documentBaseId',
  DocumentCertificateCpf = 'documentCertificateCPF',
  DocumentCertificateEmail = 'documentCertificateEmail',
  DocumentCertificateName = 'documentCertificateName',
  HasOnlyPredefinedVisualSignature = 'hasOnlyPredefinedVisualSignature',
  PersonId = 'personId',
  Status = 'status',
  TeamEducationLevelId = 'teamEducationLevelId',
  Uuid = 'uuid'
}

export type DocumentCertificateScalarWhereInput = {
  AND?: Maybe<Array<DocumentCertificateScalarWhereInput>>;
  NOT?: Maybe<Array<DocumentCertificateScalarWhereInput>>;
  OR?: Maybe<Array<DocumentCertificateScalarWhereInput>>;
  batchId?: Maybe<StringNullableFilter>;
  certificateCurriculumCertificateBaseId?: Maybe<StringNullableFilter>;
  certificateEventCertificateBaseId?: Maybe<StringNullableFilter>;
  certificateTemplateId?: Maybe<StringNullableFilter>;
  documentBaseId?: Maybe<StringFilter>;
  documentCertificateCPF?: Maybe<StringFilter>;
  documentCertificateEmail?: Maybe<StringFilter>;
  documentCertificateName?: Maybe<StringFilter>;
  hasOnlyPredefinedVisualSignature?: Maybe<BoolFilter>;
  personId?: Maybe<StringFilter>;
  status?: Maybe<EnumDocumentCertificateStatusFilter>;
  teamEducationLevelId?: Maybe<IntFilter>;
  uuid?: Maybe<StringFilter>;
};

export type DocumentCertificateScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<DocumentCertificateScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<DocumentCertificateScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<DocumentCertificateScalarWhereWithAggregatesInput>>;
  batchId?: Maybe<StringNullableWithAggregatesFilter>;
  certificateCurriculumCertificateBaseId?: Maybe<StringNullableWithAggregatesFilter>;
  certificateEventCertificateBaseId?: Maybe<StringNullableWithAggregatesFilter>;
  certificateTemplateId?: Maybe<StringNullableWithAggregatesFilter>;
  documentBaseId?: Maybe<StringWithAggregatesFilter>;
  documentCertificateCPF?: Maybe<StringWithAggregatesFilter>;
  documentCertificateEmail?: Maybe<StringWithAggregatesFilter>;
  documentCertificateName?: Maybe<StringWithAggregatesFilter>;
  hasOnlyPredefinedVisualSignature?: Maybe<BoolWithAggregatesFilter>;
  personId?: Maybe<StringWithAggregatesFilter>;
  status?: Maybe<EnumDocumentCertificateStatusWithAggregatesFilter>;
  teamEducationLevelId?: Maybe<IntWithAggregatesFilter>;
  uuid?: Maybe<StringWithAggregatesFilter>;
};

export enum DocumentCertificateSignatureHashHistoryType {
  Completed = 'COMPLETED',
  Signed = 'SIGNED'
}

/**
 * Created one for each "Signature Component" in template
 * Needed another model because of the logic of "first of all signatures" and the "pdfSignature" instead of "xmlSignature"
 */
export type DocumentCertificateSignatureItem = {
  __typename?: 'DocumentCertificateSignatureItem';
  DocumentCertificate: DocumentCertificate;
  PossibleSigners: Array<DocumentCertificateSignatureItemPossibleSignerInvite>;
  createdAt: Scalars['DateTime'];
  documentCertificateDocumentBaseId: Scalars['String'];
  id: Scalars['String'];
  imageHeight: Scalars['Float'];
  imagePage: Scalars['Int'];
  imagePositionX: Scalars['Float'];
  imagePositionY: Scalars['Float'];
  imageWidth: Scalars['Float'];
  /** In case of VISUAL_REPRESENTATION with predefined image */
  predefinedImageBase64?: Maybe<Scalars['String']>;
  type: DocumentCertificateSignatureItemType;
};


/**
 * Created one for each "Signature Component" in template
 * Needed another model because of the logic of "first of all signatures" and the "pdfSignature" instead of "xmlSignature"
 */
export type DocumentCertificateSignatureItemPossibleSignersArgs = {
  cursor?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>;
};

export type DocumentCertificateSignatureItemAvgOrderByAggregateInput = {
  imageHeight?: Maybe<SortOrder>;
  imagePage?: Maybe<SortOrder>;
  imagePositionX?: Maybe<SortOrder>;
  imagePositionY?: Maybe<SortOrder>;
  imageWidth?: Maybe<SortOrder>;
};

export type DocumentCertificateSignatureItemCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  documentCertificateDocumentBaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  imageHeight?: Maybe<SortOrder>;
  imagePage?: Maybe<SortOrder>;
  imagePositionX?: Maybe<SortOrder>;
  imagePositionY?: Maybe<SortOrder>;
  imageWidth?: Maybe<SortOrder>;
  predefinedImageBase64?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
};

export type DocumentCertificateSignatureItemCreateInput = {
  DocumentCertificate: DocumentCertificateCreateNestedOneWithoutDocumentCertificateSignatureItemsInput;
  PossibleSigners?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteCreateNestedManyWithoutDocumentCertificateSignatureItemInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  imageHeight: Scalars['Float'];
  imagePage: Scalars['Int'];
  imagePositionX: Scalars['Float'];
  imagePositionY: Scalars['Float'];
  imageWidth: Scalars['Float'];
  predefinedImageBase64?: Maybe<Scalars['String']>;
  type: DocumentCertificateSignatureItemType;
};

export type DocumentCertificateSignatureItemCreateManyDocumentCertificateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  imageHeight: Scalars['Float'];
  imagePage: Scalars['Int'];
  imagePositionX: Scalars['Float'];
  imagePositionY: Scalars['Float'];
  imageWidth: Scalars['Float'];
  predefinedImageBase64?: Maybe<Scalars['String']>;
  type: DocumentCertificateSignatureItemType;
};

export type DocumentCertificateSignatureItemCreateManyDocumentCertificateInputEnvelope = {
  data: Array<DocumentCertificateSignatureItemCreateManyDocumentCertificateInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentCertificateSignatureItemCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  documentCertificateDocumentBaseId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  imageHeight: Scalars['Float'];
  imagePage: Scalars['Int'];
  imagePositionX: Scalars['Float'];
  imagePositionY: Scalars['Float'];
  imageWidth: Scalars['Float'];
  predefinedImageBase64?: Maybe<Scalars['String']>;
  type: DocumentCertificateSignatureItemType;
};

export type DocumentCertificateSignatureItemCreateNestedManyWithoutDocumentCertificateInput = {
  connect?: Maybe<Array<DocumentCertificateSignatureItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCertificateSignatureItemCreateOrConnectWithoutDocumentCertificateInput>>;
  create?: Maybe<Array<DocumentCertificateSignatureItemCreateWithoutDocumentCertificateInput>>;
  createMany?: Maybe<DocumentCertificateSignatureItemCreateManyDocumentCertificateInputEnvelope>;
};

export type DocumentCertificateSignatureItemCreateNestedOneWithoutPossibleSignersInput = {
  connect?: Maybe<DocumentCertificateSignatureItemWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentCertificateSignatureItemCreateOrConnectWithoutPossibleSignersInput>;
  create?: Maybe<DocumentCertificateSignatureItemCreateWithoutPossibleSignersInput>;
};

export type DocumentCertificateSignatureItemCreateOrConnectWithoutDocumentCertificateInput = {
  create: DocumentCertificateSignatureItemCreateWithoutDocumentCertificateInput;
  where: DocumentCertificateSignatureItemWhereUniqueInput;
};

export type DocumentCertificateSignatureItemCreateOrConnectWithoutPossibleSignersInput = {
  create: DocumentCertificateSignatureItemCreateWithoutPossibleSignersInput;
  where: DocumentCertificateSignatureItemWhereUniqueInput;
};

export type DocumentCertificateSignatureItemCreateWithoutDocumentCertificateInput = {
  PossibleSigners?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteCreateNestedManyWithoutDocumentCertificateSignatureItemInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  imageHeight: Scalars['Float'];
  imagePage: Scalars['Int'];
  imagePositionX: Scalars['Float'];
  imagePositionY: Scalars['Float'];
  imageWidth: Scalars['Float'];
  predefinedImageBase64?: Maybe<Scalars['String']>;
  type: DocumentCertificateSignatureItemType;
};

export type DocumentCertificateSignatureItemCreateWithoutPossibleSignersInput = {
  DocumentCertificate: DocumentCertificateCreateNestedOneWithoutDocumentCertificateSignatureItemsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  imageHeight: Scalars['Float'];
  imagePage: Scalars['Int'];
  imagePositionX: Scalars['Float'];
  imagePositionY: Scalars['Float'];
  imageWidth: Scalars['Float'];
  predefinedImageBase64?: Maybe<Scalars['String']>;
  type: DocumentCertificateSignatureItemType;
};

export type DocumentCertificateSignatureItemListRelationFilter = {
  every?: Maybe<DocumentCertificateSignatureItemWhereInput>;
  none?: Maybe<DocumentCertificateSignatureItemWhereInput>;
  some?: Maybe<DocumentCertificateSignatureItemWhereInput>;
};

export type DocumentCertificateSignatureItemMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  documentCertificateDocumentBaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  imageHeight?: Maybe<SortOrder>;
  imagePage?: Maybe<SortOrder>;
  imagePositionX?: Maybe<SortOrder>;
  imagePositionY?: Maybe<SortOrder>;
  imageWidth?: Maybe<SortOrder>;
  predefinedImageBase64?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
};

export type DocumentCertificateSignatureItemMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  documentCertificateDocumentBaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  imageHeight?: Maybe<SortOrder>;
  imagePage?: Maybe<SortOrder>;
  imagePositionX?: Maybe<SortOrder>;
  imagePositionY?: Maybe<SortOrder>;
  imageWidth?: Maybe<SortOrder>;
  predefinedImageBase64?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
};

export type DocumentCertificateSignatureItemOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type DocumentCertificateSignatureItemOrderByWithAggregationInput = {
  _avg?: Maybe<DocumentCertificateSignatureItemAvgOrderByAggregateInput>;
  _count?: Maybe<DocumentCertificateSignatureItemCountOrderByAggregateInput>;
  _max?: Maybe<DocumentCertificateSignatureItemMaxOrderByAggregateInput>;
  _min?: Maybe<DocumentCertificateSignatureItemMinOrderByAggregateInput>;
  _sum?: Maybe<DocumentCertificateSignatureItemSumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  documentCertificateDocumentBaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  imageHeight?: Maybe<SortOrder>;
  imagePage?: Maybe<SortOrder>;
  imagePositionX?: Maybe<SortOrder>;
  imagePositionY?: Maybe<SortOrder>;
  imageWidth?: Maybe<SortOrder>;
  predefinedImageBase64?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
};

export type DocumentCertificateSignatureItemOrderByWithRelationInput = {
  DocumentCertificate?: Maybe<DocumentCertificateOrderByWithRelationInput>;
  PossibleSigners?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  documentCertificateDocumentBaseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  imageHeight?: Maybe<SortOrder>;
  imagePage?: Maybe<SortOrder>;
  imagePositionX?: Maybe<SortOrder>;
  imagePositionY?: Maybe<SortOrder>;
  imageWidth?: Maybe<SortOrder>;
  predefinedImageBase64?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
};

/** Stores a possible signer invite */
export type DocumentCertificateSignatureItemPossibleSignerInvite = {
  __typename?: 'DocumentCertificateSignatureItemPossibleSignerInvite';
  DocumentCertificateSignatureItem: DocumentCertificateSignatureItem;
  DocumentCertificateSignatureItemPossibleSignerInviteSignature: Array<DocumentCertificateSignatureItemPossibleSignerInviteSignature>;
  TeamMember: TeamMember;
  documentCertificateSignatureItemId: Scalars['String'];
  id: Scalars['Int'];
  teamMemberId: Scalars['Int'];
};


/** Stores a possible signer invite */
export type DocumentCertificateSignatureItemPossibleSignerInviteDocumentCertificateSignatureItemPossibleSignerInviteSignatureArgs = {
  cursor?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereInput>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteAvgOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  teamMemberId?: Maybe<SortOrder>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteCountOrderByAggregateInput = {
  documentCertificateSignatureItemId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamMemberId?: Maybe<SortOrder>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteCreateInput = {
  DocumentCertificateSignatureItem: DocumentCertificateSignatureItemCreateNestedOneWithoutPossibleSignersInput;
  DocumentCertificateSignatureItemPossibleSignerInviteSignature?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateNestedManyWithoutInviteInput>;
  TeamMember: TeamMemberCreateNestedOneWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteCreateManyDocumentCertificateSignatureItemInput = {
  id?: Maybe<Scalars['Int']>;
  teamMemberId: Scalars['Int'];
};

export type DocumentCertificateSignatureItemPossibleSignerInviteCreateManyDocumentCertificateSignatureItemInputEnvelope = {
  data: Array<DocumentCertificateSignatureItemPossibleSignerInviteCreateManyDocumentCertificateSignatureItemInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteCreateManyInput = {
  documentCertificateSignatureItemId: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  teamMemberId: Scalars['Int'];
};

export type DocumentCertificateSignatureItemPossibleSignerInviteCreateManyTeamMemberInput = {
  documentCertificateSignatureItemId: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteCreateManyTeamMemberInputEnvelope = {
  data: Array<DocumentCertificateSignatureItemPossibleSignerInviteCreateManyTeamMemberInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteCreateNestedManyWithoutDocumentCertificateSignatureItemInput = {
  connect?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteCreateOrConnectWithoutDocumentCertificateSignatureItemInput>>;
  create?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteCreateWithoutDocumentCertificateSignatureItemInput>>;
  createMany?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteCreateManyDocumentCertificateSignatureItemInputEnvelope>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteCreateNestedManyWithoutTeamMemberInput = {
  connect?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteCreateOrConnectWithoutTeamMemberInput>>;
  create?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteCreateWithoutTeamMemberInput>>;
  createMany?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteCreateManyTeamMemberInputEnvelope>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteCreateNestedOneWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureInput = {
  connect?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteCreateOrConnectWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureInput>;
  create?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteCreateWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureInput>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteCreateOrConnectWithoutDocumentCertificateSignatureItemInput = {
  create: DocumentCertificateSignatureItemPossibleSignerInviteCreateWithoutDocumentCertificateSignatureItemInput;
  where: DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteCreateOrConnectWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureInput = {
  create: DocumentCertificateSignatureItemPossibleSignerInviteCreateWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureInput;
  where: DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteCreateOrConnectWithoutTeamMemberInput = {
  create: DocumentCertificateSignatureItemPossibleSignerInviteCreateWithoutTeamMemberInput;
  where: DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteCreateWithoutDocumentCertificateSignatureItemInput = {
  DocumentCertificateSignatureItemPossibleSignerInviteSignature?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateNestedManyWithoutInviteInput>;
  TeamMember: TeamMemberCreateNestedOneWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteCreateWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureInput = {
  DocumentCertificateSignatureItem: DocumentCertificateSignatureItemCreateNestedOneWithoutPossibleSignersInput;
  TeamMember: TeamMemberCreateNestedOneWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteCreateWithoutTeamMemberInput = {
  DocumentCertificateSignatureItem: DocumentCertificateSignatureItemCreateNestedOneWithoutPossibleSignersInput;
  DocumentCertificateSignatureItemPossibleSignerInviteSignature?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateNestedManyWithoutInviteInput>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteListRelationFilter = {
  every?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>;
  none?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>;
  some?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteMaxOrderByAggregateInput = {
  documentCertificateSignatureItemId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamMemberId?: Maybe<SortOrder>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteMinOrderByAggregateInput = {
  documentCertificateSignatureItemId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamMemberId?: Maybe<SortOrder>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteOrderByWithAggregationInput = {
  _avg?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteAvgOrderByAggregateInput>;
  _count?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteCountOrderByAggregateInput>;
  _max?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteMaxOrderByAggregateInput>;
  _min?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteMinOrderByAggregateInput>;
  _sum?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteSumOrderByAggregateInput>;
  documentCertificateSignatureItemId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamMemberId?: Maybe<SortOrder>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteOrderByWithRelationInput = {
  DocumentCertificateSignatureItem?: Maybe<DocumentCertificateSignatureItemOrderByWithRelationInput>;
  DocumentCertificateSignatureItemPossibleSignerInviteSignature?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureOrderByRelationAggregateInput>;
  TeamMember?: Maybe<TeamMemberOrderByWithRelationInput>;
  documentCertificateSignatureItemId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamMemberId?: Maybe<SortOrder>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteRelationFilter = {
  is?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>;
  isNot?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>;
};

export enum DocumentCertificateSignatureItemPossibleSignerInviteScalarFieldEnum {
  DocumentCertificateSignatureItemId = 'documentCertificateSignatureItemId',
  Id = 'id',
  TeamMemberId = 'teamMemberId'
}

export type DocumentCertificateSignatureItemPossibleSignerInviteScalarWhereInput = {
  AND?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteScalarWhereInput>>;
  NOT?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteScalarWhereInput>>;
  OR?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteScalarWhereInput>>;
  documentCertificateSignatureItemId?: Maybe<StringFilter>;
  id?: Maybe<IntFilter>;
  teamMemberId?: Maybe<IntFilter>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteScalarWhereWithAggregatesInput>>;
  documentCertificateSignatureItemId?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  teamMemberId?: Maybe<IntWithAggregatesFilter>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignature = {
  __typename?: 'DocumentCertificateSignatureItemPossibleSignerInviteSignature';
  Invite: DocumentCertificateSignatureItemPossibleSignerInvite;
  createdAt: Scalars['DateTime'];
  documentCertificateSignatureItemPossibleSignerInviteId: Scalars['Int'];
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  /** User IP */
  ip: Scalars['String'];
  /** 1.0.0 */
  signatureApiVersion: Scalars['String'];
  success: Scalars['Boolean'];
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureAvgOrderByAggregateInput = {
  documentCertificateSignatureItemPossibleSignerInviteId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  documentCertificateSignatureItemPossibleSignerInviteId?: Maybe<SortOrder>;
  errorMessage?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ip?: Maybe<SortOrder>;
  signatureApiVersion?: Maybe<SortOrder>;
  success?: Maybe<SortOrder>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateInput = {
  Invite: DocumentCertificateSignatureItemPossibleSignerInviteCreateNestedOneWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  ip: Scalars['String'];
  signatureApiVersion: Scalars['String'];
  success: Scalars['Boolean'];
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  documentCertificateSignatureItemPossibleSignerInviteId: Scalars['Int'];
  errorMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  ip: Scalars['String'];
  signatureApiVersion: Scalars['String'];
  success: Scalars['Boolean'];
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateManyInviteInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  ip: Scalars['String'];
  signatureApiVersion: Scalars['String'];
  success: Scalars['Boolean'];
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateManyInviteInputEnvelope = {
  data: Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateManyInviteInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateNestedManyWithoutInviteInput = {
  connect?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateOrConnectWithoutInviteInput>>;
  create?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateWithoutInviteInput>>;
  createMany?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateManyInviteInputEnvelope>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateOrConnectWithoutInviteInput = {
  create: DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateWithoutInviteInput;
  where: DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereUniqueInput;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateWithoutInviteInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  ip: Scalars['String'];
  signatureApiVersion: Scalars['String'];
  success: Scalars['Boolean'];
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureListRelationFilter = {
  every?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereInput>;
  none?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereInput>;
  some?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereInput>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  documentCertificateSignatureItemPossibleSignerInviteId?: Maybe<SortOrder>;
  errorMessage?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ip?: Maybe<SortOrder>;
  signatureApiVersion?: Maybe<SortOrder>;
  success?: Maybe<SortOrder>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  documentCertificateSignatureItemPossibleSignerInviteId?: Maybe<SortOrder>;
  errorMessage?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ip?: Maybe<SortOrder>;
  signatureApiVersion?: Maybe<SortOrder>;
  success?: Maybe<SortOrder>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureOrderByWithAggregationInput = {
  _avg?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureAvgOrderByAggregateInput>;
  _count?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureCountOrderByAggregateInput>;
  _max?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureMaxOrderByAggregateInput>;
  _min?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureMinOrderByAggregateInput>;
  _sum?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureSumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  documentCertificateSignatureItemPossibleSignerInviteId?: Maybe<SortOrder>;
  errorMessage?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ip?: Maybe<SortOrder>;
  signatureApiVersion?: Maybe<SortOrder>;
  success?: Maybe<SortOrder>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureOrderByWithRelationInput = {
  Invite?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  documentCertificateSignatureItemPossibleSignerInviteId?: Maybe<SortOrder>;
  errorMessage?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ip?: Maybe<SortOrder>;
  signatureApiVersion?: Maybe<SortOrder>;
  success?: Maybe<SortOrder>;
};

export enum DocumentCertificateSignatureItemPossibleSignerInviteSignatureScalarFieldEnum {
  CreatedAt = 'createdAt',
  DocumentCertificateSignatureItemPossibleSignerInviteId = 'documentCertificateSignatureItemPossibleSignerInviteId',
  ErrorMessage = 'errorMessage',
  Id = 'id',
  Ip = 'ip',
  SignatureApiVersion = 'signatureApiVersion',
  Success = 'success'
}

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureScalarWhereInput = {
  AND?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureScalarWhereInput>>;
  NOT?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureScalarWhereInput>>;
  OR?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  documentCertificateSignatureItemPossibleSignerInviteId?: Maybe<IntFilter>;
  errorMessage?: Maybe<StringNullableFilter>;
  id?: Maybe<IntFilter>;
  ip?: Maybe<StringFilter>;
  signatureApiVersion?: Maybe<StringFilter>;
  success?: Maybe<BoolFilter>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  documentCertificateSignatureItemPossibleSignerInviteId?: Maybe<IntWithAggregatesFilter>;
  errorMessage?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  ip?: Maybe<StringWithAggregatesFilter>;
  signatureApiVersion?: Maybe<StringWithAggregatesFilter>;
  success?: Maybe<BoolWithAggregatesFilter>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureSumOrderByAggregateInput = {
  documentCertificateSignatureItemPossibleSignerInviteId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureUpdateInput = {
  Invite?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteUpdateOneRequiredWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  errorMessage?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ip?: Maybe<StringFieldUpdateOperationsInput>;
  signatureApiVersion?: Maybe<StringFieldUpdateOperationsInput>;
  success?: Maybe<BoolFieldUpdateOperationsInput>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureUpdateManyMutationInput = {
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  errorMessage?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ip?: Maybe<StringFieldUpdateOperationsInput>;
  signatureApiVersion?: Maybe<StringFieldUpdateOperationsInput>;
  success?: Maybe<BoolFieldUpdateOperationsInput>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureUpdateManyWithWhereWithoutInviteInput = {
  data: DocumentCertificateSignatureItemPossibleSignerInviteSignatureUpdateManyMutationInput;
  where: DocumentCertificateSignatureItemPossibleSignerInviteSignatureScalarWhereInput;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureUpdateManyWithoutInviteNestedInput = {
  connect?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateOrConnectWithoutInviteInput>>;
  create?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateWithoutInviteInput>>;
  createMany?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateManyInviteInputEnvelope>;
  delete?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereUniqueInput>>;
  set?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereUniqueInput>>;
  update?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureUpdateWithWhereUniqueWithoutInviteInput>>;
  updateMany?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureUpdateManyWithWhereWithoutInviteInput>>;
  upsert?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureUpsertWithWhereUniqueWithoutInviteInput>>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureUpdateWithWhereUniqueWithoutInviteInput = {
  data: DocumentCertificateSignatureItemPossibleSignerInviteSignatureUpdateWithoutInviteInput;
  where: DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereUniqueInput;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureUpdateWithoutInviteInput = {
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  errorMessage?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ip?: Maybe<StringFieldUpdateOperationsInput>;
  signatureApiVersion?: Maybe<StringFieldUpdateOperationsInput>;
  success?: Maybe<BoolFieldUpdateOperationsInput>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureUpsertWithWhereUniqueWithoutInviteInput = {
  create: DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateWithoutInviteInput;
  update: DocumentCertificateSignatureItemPossibleSignerInviteSignatureUpdateWithoutInviteInput;
  where: DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereUniqueInput;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereInput = {
  AND?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereInput>>;
  Invite?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>;
  NOT?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereInput>>;
  OR?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  documentCertificateSignatureItemPossibleSignerInviteId?: Maybe<IntFilter>;
  errorMessage?: Maybe<StringNullableFilter>;
  id?: Maybe<IntFilter>;
  ip?: Maybe<StringFilter>;
  signatureApiVersion?: Maybe<StringFilter>;
  success?: Maybe<BoolFilter>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereUniqueInput = {
  AND?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereInput>>;
  Invite?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>;
  NOT?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereInput>>;
  OR?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  documentCertificateSignatureItemPossibleSignerInviteId?: Maybe<IntFilter>;
  errorMessage?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['Int']>;
  ip?: Maybe<StringFilter>;
  signatureApiVersion?: Maybe<StringFilter>;
  success?: Maybe<BoolFilter>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSumOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  teamMemberId?: Maybe<SortOrder>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteUpdateInput = {
  DocumentCertificateSignatureItem?: Maybe<DocumentCertificateSignatureItemUpdateOneRequiredWithoutPossibleSignersNestedInput>;
  DocumentCertificateSignatureItemPossibleSignerInviteSignature?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureUpdateManyWithoutInviteNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateOneRequiredWithoutDocumentCertificateSignatureItemPossibleSignerInvitesNestedInput>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteUpdateManyMutationInput = {
  _?: Maybe<Scalars['NEVER']>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteUpdateManyWithWhereWithoutDocumentCertificateSignatureItemInput = {
  data: DocumentCertificateSignatureItemPossibleSignerInviteUpdateManyMutationInput;
  where: DocumentCertificateSignatureItemPossibleSignerInviteScalarWhereInput;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteUpdateManyWithWhereWithoutTeamMemberInput = {
  data: DocumentCertificateSignatureItemPossibleSignerInviteUpdateManyMutationInput;
  where: DocumentCertificateSignatureItemPossibleSignerInviteScalarWhereInput;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteUpdateManyWithoutDocumentCertificateSignatureItemNestedInput = {
  connect?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteCreateOrConnectWithoutDocumentCertificateSignatureItemInput>>;
  create?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteCreateWithoutDocumentCertificateSignatureItemInput>>;
  createMany?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteCreateManyDocumentCertificateSignatureItemInputEnvelope>;
  delete?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput>>;
  set?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput>>;
  update?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteUpdateWithWhereUniqueWithoutDocumentCertificateSignatureItemInput>>;
  updateMany?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteUpdateManyWithWhereWithoutDocumentCertificateSignatureItemInput>>;
  upsert?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteUpsertWithWhereUniqueWithoutDocumentCertificateSignatureItemInput>>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteUpdateManyWithoutTeamMemberNestedInput = {
  connect?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteCreateOrConnectWithoutTeamMemberInput>>;
  create?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteCreateWithoutTeamMemberInput>>;
  createMany?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteCreateManyTeamMemberInputEnvelope>;
  delete?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput>>;
  set?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput>>;
  update?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteUpdateWithWhereUniqueWithoutTeamMemberInput>>;
  updateMany?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteUpdateManyWithWhereWithoutTeamMemberInput>>;
  upsert?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteUpsertWithWhereUniqueWithoutTeamMemberInput>>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteUpdateOneRequiredWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureNestedInput = {
  connect?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteCreateOrConnectWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureInput>;
  create?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteCreateWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureInput>;
  update?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteUpdateToOneWithWhereWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureInput>;
  upsert?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteUpsertWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureInput>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteUpdateToOneWithWhereWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureInput = {
  data: DocumentCertificateSignatureItemPossibleSignerInviteUpdateWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureInput;
  where?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteUpdateWithWhereUniqueWithoutDocumentCertificateSignatureItemInput = {
  data: DocumentCertificateSignatureItemPossibleSignerInviteUpdateWithoutDocumentCertificateSignatureItemInput;
  where: DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteUpdateWithWhereUniqueWithoutTeamMemberInput = {
  data: DocumentCertificateSignatureItemPossibleSignerInviteUpdateWithoutTeamMemberInput;
  where: DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteUpdateWithoutDocumentCertificateSignatureItemInput = {
  DocumentCertificateSignatureItemPossibleSignerInviteSignature?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureUpdateManyWithoutInviteNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateOneRequiredWithoutDocumentCertificateSignatureItemPossibleSignerInvitesNestedInput>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteUpdateWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureInput = {
  DocumentCertificateSignatureItem?: Maybe<DocumentCertificateSignatureItemUpdateOneRequiredWithoutPossibleSignersNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateOneRequiredWithoutDocumentCertificateSignatureItemPossibleSignerInvitesNestedInput>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteUpdateWithoutTeamMemberInput = {
  DocumentCertificateSignatureItem?: Maybe<DocumentCertificateSignatureItemUpdateOneRequiredWithoutPossibleSignersNestedInput>;
  DocumentCertificateSignatureItemPossibleSignerInviteSignature?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureUpdateManyWithoutInviteNestedInput>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteUpsertWithWhereUniqueWithoutDocumentCertificateSignatureItemInput = {
  create: DocumentCertificateSignatureItemPossibleSignerInviteCreateWithoutDocumentCertificateSignatureItemInput;
  update: DocumentCertificateSignatureItemPossibleSignerInviteUpdateWithoutDocumentCertificateSignatureItemInput;
  where: DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteUpsertWithWhereUniqueWithoutTeamMemberInput = {
  create: DocumentCertificateSignatureItemPossibleSignerInviteCreateWithoutTeamMemberInput;
  update: DocumentCertificateSignatureItemPossibleSignerInviteUpdateWithoutTeamMemberInput;
  where: DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteUpsertWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureInput = {
  create: DocumentCertificateSignatureItemPossibleSignerInviteCreateWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureInput;
  update: DocumentCertificateSignatureItemPossibleSignerInviteUpdateWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureInput;
  where?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteWhereInput = {
  AND?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>>;
  DocumentCertificateSignatureItem?: Maybe<DocumentCertificateSignatureItemWhereInput>;
  DocumentCertificateSignatureItemPossibleSignerInviteSignature?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureListRelationFilter>;
  NOT?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>>;
  OR?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>>;
  TeamMember?: Maybe<TeamMemberWhereInput>;
  documentCertificateSignatureItemId?: Maybe<StringFilter>;
  id?: Maybe<IntFilter>;
  teamMemberId?: Maybe<IntFilter>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput = {
  AND?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>>;
  DocumentCertificateSignatureItem?: Maybe<DocumentCertificateSignatureItemWhereInput>;
  DocumentCertificateSignatureItemPossibleSignerInviteSignature?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureListRelationFilter>;
  NOT?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>>;
  OR?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>>;
  TeamMember?: Maybe<TeamMemberWhereInput>;
  documentCertificateSignatureItemId?: Maybe<StringFilter>;
  id?: Maybe<Scalars['Int']>;
  teamMemberId?: Maybe<IntFilter>;
};

export type DocumentCertificateSignatureItemRelationFilter = {
  is?: Maybe<DocumentCertificateSignatureItemWhereInput>;
  isNot?: Maybe<DocumentCertificateSignatureItemWhereInput>;
};

export enum DocumentCertificateSignatureItemScalarFieldEnum {
  CreatedAt = 'createdAt',
  DocumentCertificateDocumentBaseId = 'documentCertificateDocumentBaseId',
  Id = 'id',
  ImageHeight = 'imageHeight',
  ImagePage = 'imagePage',
  ImagePositionX = 'imagePositionX',
  ImagePositionY = 'imagePositionY',
  ImageWidth = 'imageWidth',
  PredefinedImageBase64 = 'predefinedImageBase64',
  Type = 'type'
}

export type DocumentCertificateSignatureItemScalarWhereInput = {
  AND?: Maybe<Array<DocumentCertificateSignatureItemScalarWhereInput>>;
  NOT?: Maybe<Array<DocumentCertificateSignatureItemScalarWhereInput>>;
  OR?: Maybe<Array<DocumentCertificateSignatureItemScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  documentCertificateDocumentBaseId?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  imageHeight?: Maybe<FloatFilter>;
  imagePage?: Maybe<IntFilter>;
  imagePositionX?: Maybe<FloatFilter>;
  imagePositionY?: Maybe<FloatFilter>;
  imageWidth?: Maybe<FloatFilter>;
  predefinedImageBase64?: Maybe<StringNullableFilter>;
  type?: Maybe<EnumDocumentCertificateSignatureItemTypeFilter>;
};

export type DocumentCertificateSignatureItemScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<DocumentCertificateSignatureItemScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<DocumentCertificateSignatureItemScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<DocumentCertificateSignatureItemScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  documentCertificateDocumentBaseId?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  imageHeight?: Maybe<FloatWithAggregatesFilter>;
  imagePage?: Maybe<IntWithAggregatesFilter>;
  imagePositionX?: Maybe<FloatWithAggregatesFilter>;
  imagePositionY?: Maybe<FloatWithAggregatesFilter>;
  imageWidth?: Maybe<FloatWithAggregatesFilter>;
  predefinedImageBase64?: Maybe<StringNullableWithAggregatesFilter>;
  type?: Maybe<EnumDocumentCertificateSignatureItemTypeWithAggregatesFilter>;
};

export type DocumentCertificateSignatureItemSumOrderByAggregateInput = {
  imageHeight?: Maybe<SortOrder>;
  imagePage?: Maybe<SortOrder>;
  imagePositionX?: Maybe<SortOrder>;
  imagePositionY?: Maybe<SortOrder>;
  imageWidth?: Maybe<SortOrder>;
};

export enum DocumentCertificateSignatureItemType {
  Eletronic = 'ELETRONIC',
  OnlyVisualRepresentationWithPredefinedImage = 'ONLY_VISUAL_REPRESENTATION_WITH_PREDEFINED_IMAGE',
  OnlyVisualRepresentationWithSigners = 'ONLY_VISUAL_REPRESENTATION_WITH_SIGNERS',
  QualifiedRa = 'QUALIFIED_RA',
  QualifiedRb = 'QUALIFIED_RB',
  QualifiedRt = 'QUALIFIED_RT'
}

export type DocumentCertificateSignatureItemUpdateInput = {
  DocumentCertificate?: Maybe<DocumentCertificateUpdateOneRequiredWithoutDocumentCertificateSignatureItemsNestedInput>;
  PossibleSigners?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteUpdateManyWithoutDocumentCertificateSignatureItemNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  imageHeight?: Maybe<FloatFieldUpdateOperationsInput>;
  imagePage?: Maybe<IntFieldUpdateOperationsInput>;
  imagePositionX?: Maybe<FloatFieldUpdateOperationsInput>;
  imagePositionY?: Maybe<FloatFieldUpdateOperationsInput>;
  imageWidth?: Maybe<FloatFieldUpdateOperationsInput>;
  predefinedImageBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  type?: Maybe<EnumDocumentCertificateSignatureItemTypeFieldUpdateOperationsInput>;
};

export type DocumentCertificateSignatureItemUpdateManyMutationInput = {
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  imageHeight?: Maybe<FloatFieldUpdateOperationsInput>;
  imagePage?: Maybe<IntFieldUpdateOperationsInput>;
  imagePositionX?: Maybe<FloatFieldUpdateOperationsInput>;
  imagePositionY?: Maybe<FloatFieldUpdateOperationsInput>;
  imageWidth?: Maybe<FloatFieldUpdateOperationsInput>;
  predefinedImageBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  type?: Maybe<EnumDocumentCertificateSignatureItemTypeFieldUpdateOperationsInput>;
};

export type DocumentCertificateSignatureItemUpdateManyWithWhereWithoutDocumentCertificateInput = {
  data: DocumentCertificateSignatureItemUpdateManyMutationInput;
  where: DocumentCertificateSignatureItemScalarWhereInput;
};

export type DocumentCertificateSignatureItemUpdateManyWithoutDocumentCertificateNestedInput = {
  connect?: Maybe<Array<DocumentCertificateSignatureItemWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCertificateSignatureItemCreateOrConnectWithoutDocumentCertificateInput>>;
  create?: Maybe<Array<DocumentCertificateSignatureItemCreateWithoutDocumentCertificateInput>>;
  createMany?: Maybe<DocumentCertificateSignatureItemCreateManyDocumentCertificateInputEnvelope>;
  delete?: Maybe<Array<DocumentCertificateSignatureItemWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentCertificateSignatureItemScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentCertificateSignatureItemWhereUniqueInput>>;
  set?: Maybe<Array<DocumentCertificateSignatureItemWhereUniqueInput>>;
  update?: Maybe<Array<DocumentCertificateSignatureItemUpdateWithWhereUniqueWithoutDocumentCertificateInput>>;
  updateMany?: Maybe<Array<DocumentCertificateSignatureItemUpdateManyWithWhereWithoutDocumentCertificateInput>>;
  upsert?: Maybe<Array<DocumentCertificateSignatureItemUpsertWithWhereUniqueWithoutDocumentCertificateInput>>;
};

export type DocumentCertificateSignatureItemUpdateOneRequiredWithoutPossibleSignersNestedInput = {
  connect?: Maybe<DocumentCertificateSignatureItemWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentCertificateSignatureItemCreateOrConnectWithoutPossibleSignersInput>;
  create?: Maybe<DocumentCertificateSignatureItemCreateWithoutPossibleSignersInput>;
  update?: Maybe<DocumentCertificateSignatureItemUpdateToOneWithWhereWithoutPossibleSignersInput>;
  upsert?: Maybe<DocumentCertificateSignatureItemUpsertWithoutPossibleSignersInput>;
};

export type DocumentCertificateSignatureItemUpdateToOneWithWhereWithoutPossibleSignersInput = {
  data: DocumentCertificateSignatureItemUpdateWithoutPossibleSignersInput;
  where?: Maybe<DocumentCertificateSignatureItemWhereInput>;
};

export type DocumentCertificateSignatureItemUpdateWithWhereUniqueWithoutDocumentCertificateInput = {
  data: DocumentCertificateSignatureItemUpdateWithoutDocumentCertificateInput;
  where: DocumentCertificateSignatureItemWhereUniqueInput;
};

export type DocumentCertificateSignatureItemUpdateWithoutDocumentCertificateInput = {
  PossibleSigners?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteUpdateManyWithoutDocumentCertificateSignatureItemNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  imageHeight?: Maybe<FloatFieldUpdateOperationsInput>;
  imagePage?: Maybe<IntFieldUpdateOperationsInput>;
  imagePositionX?: Maybe<FloatFieldUpdateOperationsInput>;
  imagePositionY?: Maybe<FloatFieldUpdateOperationsInput>;
  imageWidth?: Maybe<FloatFieldUpdateOperationsInput>;
  predefinedImageBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  type?: Maybe<EnumDocumentCertificateSignatureItemTypeFieldUpdateOperationsInput>;
};

export type DocumentCertificateSignatureItemUpdateWithoutPossibleSignersInput = {
  DocumentCertificate?: Maybe<DocumentCertificateUpdateOneRequiredWithoutDocumentCertificateSignatureItemsNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  imageHeight?: Maybe<FloatFieldUpdateOperationsInput>;
  imagePage?: Maybe<IntFieldUpdateOperationsInput>;
  imagePositionX?: Maybe<FloatFieldUpdateOperationsInput>;
  imagePositionY?: Maybe<FloatFieldUpdateOperationsInput>;
  imageWidth?: Maybe<FloatFieldUpdateOperationsInput>;
  predefinedImageBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  type?: Maybe<EnumDocumentCertificateSignatureItemTypeFieldUpdateOperationsInput>;
};

export type DocumentCertificateSignatureItemUpsertWithWhereUniqueWithoutDocumentCertificateInput = {
  create: DocumentCertificateSignatureItemCreateWithoutDocumentCertificateInput;
  update: DocumentCertificateSignatureItemUpdateWithoutDocumentCertificateInput;
  where: DocumentCertificateSignatureItemWhereUniqueInput;
};

export type DocumentCertificateSignatureItemUpsertWithoutPossibleSignersInput = {
  create: DocumentCertificateSignatureItemCreateWithoutPossibleSignersInput;
  update: DocumentCertificateSignatureItemUpdateWithoutPossibleSignersInput;
  where?: Maybe<DocumentCertificateSignatureItemWhereInput>;
};

export type DocumentCertificateSignatureItemWhereInput = {
  AND?: Maybe<Array<DocumentCertificateSignatureItemWhereInput>>;
  DocumentCertificate?: Maybe<DocumentCertificateWhereInput>;
  NOT?: Maybe<Array<DocumentCertificateSignatureItemWhereInput>>;
  OR?: Maybe<Array<DocumentCertificateSignatureItemWhereInput>>;
  PossibleSigners?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  documentCertificateDocumentBaseId?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  imageHeight?: Maybe<FloatFilter>;
  imagePage?: Maybe<IntFilter>;
  imagePositionX?: Maybe<FloatFilter>;
  imagePositionY?: Maybe<FloatFilter>;
  imageWidth?: Maybe<FloatFilter>;
  predefinedImageBase64?: Maybe<StringNullableFilter>;
  type?: Maybe<EnumDocumentCertificateSignatureItemTypeFilter>;
};

export type DocumentCertificateSignatureItemWhereUniqueInput = {
  AND?: Maybe<Array<DocumentCertificateSignatureItemWhereInput>>;
  DocumentCertificate?: Maybe<DocumentCertificateWhereInput>;
  NOT?: Maybe<Array<DocumentCertificateSignatureItemWhereInput>>;
  OR?: Maybe<Array<DocumentCertificateSignatureItemWhereInput>>;
  PossibleSigners?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  documentCertificateDocumentBaseId?: Maybe<StringFilter>;
  id?: Maybe<Scalars['String']>;
  imageHeight?: Maybe<FloatFilter>;
  imagePage?: Maybe<IntFilter>;
  imagePositionX?: Maybe<FloatFilter>;
  imagePositionY?: Maybe<FloatFilter>;
  imageWidth?: Maybe<FloatFilter>;
  predefinedImageBase64?: Maybe<StringNullableFilter>;
  type?: Maybe<EnumDocumentCertificateSignatureItemTypeFilter>;
};

export enum DocumentCertificateStatus {
  InSignature = 'IN_SIGNATURE',
  Issued = 'ISSUED',
  Revoked = 'REVOKED',
  ValidationInvalid = 'VALIDATION_INVALID',
  ValidationInValidation = 'VALIDATION_IN_VALIDATION'
}

export type DocumentCertificateSumOrderByAggregateInput = {
  teamEducationLevelId?: Maybe<SortOrder>;
};

export type DocumentCertificateUpdateInput = {
  BulkCertificateRecord?: Maybe<BulkCertificateRecordUpdateOneWithoutDocumentCertificatesNestedInput>;
  Curriculum?: Maybe<CertificateCurriculumUpdateOneWithoutDocumentCertificateNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  DocumentCertificateHashHistory?: Maybe<DocumentCertificateHashHistoryUpdateManyWithoutDocumentCertificateNestedInput>;
  DocumentCertificateSignatureItems?: Maybe<DocumentCertificateSignatureItemUpdateManyWithoutDocumentCertificateNestedInput>;
  Event?: Maybe<CertificateEventUpdateOneWithoutDocumentCertificateNestedInput>;
  MetadataList?: Maybe<DocumentCertificateMetadataUpdateManyWithoutDocumentCertificateNestedInput>;
  Person?: Maybe<PersonUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  Template?: Maybe<CertificateTemplateUpdateOneWithoutDocumentCertificateNestedInput>;
  documentCertificateCPF?: Maybe<StringFieldUpdateOperationsInput>;
  documentCertificateEmail?: Maybe<StringFieldUpdateOperationsInput>;
  documentCertificateName?: Maybe<StringFieldUpdateOperationsInput>;
  hasOnlyPredefinedVisualSignature?: Maybe<BoolFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentCertificateStatusFieldUpdateOperationsInput>;
  uuid?: Maybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateUpdateManyMutationInput = {
  documentCertificateCPF?: Maybe<StringFieldUpdateOperationsInput>;
  documentCertificateEmail?: Maybe<StringFieldUpdateOperationsInput>;
  documentCertificateName?: Maybe<StringFieldUpdateOperationsInput>;
  hasOnlyPredefinedVisualSignature?: Maybe<BoolFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentCertificateStatusFieldUpdateOperationsInput>;
  uuid?: Maybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateUpdateManyWithWhereWithoutBulkCertificateRecordInput = {
  data: DocumentCertificateUpdateManyMutationInput;
  where: DocumentCertificateScalarWhereInput;
};

export type DocumentCertificateUpdateManyWithWhereWithoutCurriculumInput = {
  data: DocumentCertificateUpdateManyMutationInput;
  where: DocumentCertificateScalarWhereInput;
};

export type DocumentCertificateUpdateManyWithWhereWithoutEventInput = {
  data: DocumentCertificateUpdateManyMutationInput;
  where: DocumentCertificateScalarWhereInput;
};

export type DocumentCertificateUpdateManyWithWhereWithoutPersonInput = {
  data: DocumentCertificateUpdateManyMutationInput;
  where: DocumentCertificateScalarWhereInput;
};

export type DocumentCertificateUpdateManyWithWhereWithoutTeamEducationLevelInput = {
  data: DocumentCertificateUpdateManyMutationInput;
  where: DocumentCertificateScalarWhereInput;
};

export type DocumentCertificateUpdateManyWithWhereWithoutTemplateInput = {
  data: DocumentCertificateUpdateManyMutationInput;
  where: DocumentCertificateScalarWhereInput;
};

export type DocumentCertificateUpdateManyWithoutBulkCertificateRecordNestedInput = {
  connect?: Maybe<Array<DocumentCertificateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCertificateCreateOrConnectWithoutBulkCertificateRecordInput>>;
  create?: Maybe<Array<DocumentCertificateCreateWithoutBulkCertificateRecordInput>>;
  createMany?: Maybe<DocumentCertificateCreateManyBulkCertificateRecordInputEnvelope>;
  delete?: Maybe<Array<DocumentCertificateWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentCertificateScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentCertificateWhereUniqueInput>>;
  set?: Maybe<Array<DocumentCertificateWhereUniqueInput>>;
  update?: Maybe<Array<DocumentCertificateUpdateWithWhereUniqueWithoutBulkCertificateRecordInput>>;
  updateMany?: Maybe<Array<DocumentCertificateUpdateManyWithWhereWithoutBulkCertificateRecordInput>>;
  upsert?: Maybe<Array<DocumentCertificateUpsertWithWhereUniqueWithoutBulkCertificateRecordInput>>;
};

export type DocumentCertificateUpdateManyWithoutCurriculumNestedInput = {
  connect?: Maybe<Array<DocumentCertificateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCertificateCreateOrConnectWithoutCurriculumInput>>;
  create?: Maybe<Array<DocumentCertificateCreateWithoutCurriculumInput>>;
  createMany?: Maybe<DocumentCertificateCreateManyCurriculumInputEnvelope>;
  delete?: Maybe<Array<DocumentCertificateWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentCertificateScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentCertificateWhereUniqueInput>>;
  set?: Maybe<Array<DocumentCertificateWhereUniqueInput>>;
  update?: Maybe<Array<DocumentCertificateUpdateWithWhereUniqueWithoutCurriculumInput>>;
  updateMany?: Maybe<Array<DocumentCertificateUpdateManyWithWhereWithoutCurriculumInput>>;
  upsert?: Maybe<Array<DocumentCertificateUpsertWithWhereUniqueWithoutCurriculumInput>>;
};

export type DocumentCertificateUpdateManyWithoutEventNestedInput = {
  connect?: Maybe<Array<DocumentCertificateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCertificateCreateOrConnectWithoutEventInput>>;
  create?: Maybe<Array<DocumentCertificateCreateWithoutEventInput>>;
  createMany?: Maybe<DocumentCertificateCreateManyEventInputEnvelope>;
  delete?: Maybe<Array<DocumentCertificateWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentCertificateScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentCertificateWhereUniqueInput>>;
  set?: Maybe<Array<DocumentCertificateWhereUniqueInput>>;
  update?: Maybe<Array<DocumentCertificateUpdateWithWhereUniqueWithoutEventInput>>;
  updateMany?: Maybe<Array<DocumentCertificateUpdateManyWithWhereWithoutEventInput>>;
  upsert?: Maybe<Array<DocumentCertificateUpsertWithWhereUniqueWithoutEventInput>>;
};

export type DocumentCertificateUpdateManyWithoutPersonNestedInput = {
  connect?: Maybe<Array<DocumentCertificateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCertificateCreateOrConnectWithoutPersonInput>>;
  create?: Maybe<Array<DocumentCertificateCreateWithoutPersonInput>>;
  createMany?: Maybe<DocumentCertificateCreateManyPersonInputEnvelope>;
  delete?: Maybe<Array<DocumentCertificateWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentCertificateScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentCertificateWhereUniqueInput>>;
  set?: Maybe<Array<DocumentCertificateWhereUniqueInput>>;
  update?: Maybe<Array<DocumentCertificateUpdateWithWhereUniqueWithoutPersonInput>>;
  updateMany?: Maybe<Array<DocumentCertificateUpdateManyWithWhereWithoutPersonInput>>;
  upsert?: Maybe<Array<DocumentCertificateUpsertWithWhereUniqueWithoutPersonInput>>;
};

export type DocumentCertificateUpdateManyWithoutTeamEducationLevelNestedInput = {
  connect?: Maybe<Array<DocumentCertificateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCertificateCreateOrConnectWithoutTeamEducationLevelInput>>;
  create?: Maybe<Array<DocumentCertificateCreateWithoutTeamEducationLevelInput>>;
  createMany?: Maybe<DocumentCertificateCreateManyTeamEducationLevelInputEnvelope>;
  delete?: Maybe<Array<DocumentCertificateWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentCertificateScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentCertificateWhereUniqueInput>>;
  set?: Maybe<Array<DocumentCertificateWhereUniqueInput>>;
  update?: Maybe<Array<DocumentCertificateUpdateWithWhereUniqueWithoutTeamEducationLevelInput>>;
  updateMany?: Maybe<Array<DocumentCertificateUpdateManyWithWhereWithoutTeamEducationLevelInput>>;
  upsert?: Maybe<Array<DocumentCertificateUpsertWithWhereUniqueWithoutTeamEducationLevelInput>>;
};

export type DocumentCertificateUpdateManyWithoutTemplateNestedInput = {
  connect?: Maybe<Array<DocumentCertificateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCertificateCreateOrConnectWithoutTemplateInput>>;
  create?: Maybe<Array<DocumentCertificateCreateWithoutTemplateInput>>;
  createMany?: Maybe<DocumentCertificateCreateManyTemplateInputEnvelope>;
  delete?: Maybe<Array<DocumentCertificateWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentCertificateScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentCertificateWhereUniqueInput>>;
  set?: Maybe<Array<DocumentCertificateWhereUniqueInput>>;
  update?: Maybe<Array<DocumentCertificateUpdateWithWhereUniqueWithoutTemplateInput>>;
  updateMany?: Maybe<Array<DocumentCertificateUpdateManyWithWhereWithoutTemplateInput>>;
  upsert?: Maybe<Array<DocumentCertificateUpsertWithWhereUniqueWithoutTemplateInput>>;
};

export type DocumentCertificateUpdateOneRequiredWithoutDocumentCertificateHashHistoryNestedInput = {
  connect?: Maybe<DocumentCertificateWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentCertificateCreateOrConnectWithoutDocumentCertificateHashHistoryInput>;
  create?: Maybe<DocumentCertificateCreateWithoutDocumentCertificateHashHistoryInput>;
  update?: Maybe<DocumentCertificateUpdateToOneWithWhereWithoutDocumentCertificateHashHistoryInput>;
  upsert?: Maybe<DocumentCertificateUpsertWithoutDocumentCertificateHashHistoryInput>;
};

export type DocumentCertificateUpdateOneRequiredWithoutDocumentCertificateSignatureItemsNestedInput = {
  connect?: Maybe<DocumentCertificateWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentCertificateCreateOrConnectWithoutDocumentCertificateSignatureItemsInput>;
  create?: Maybe<DocumentCertificateCreateWithoutDocumentCertificateSignatureItemsInput>;
  update?: Maybe<DocumentCertificateUpdateToOneWithWhereWithoutDocumentCertificateSignatureItemsInput>;
  upsert?: Maybe<DocumentCertificateUpsertWithoutDocumentCertificateSignatureItemsInput>;
};

export type DocumentCertificateUpdateOneRequiredWithoutMetadataListNestedInput = {
  connect?: Maybe<DocumentCertificateWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentCertificateCreateOrConnectWithoutMetadataListInput>;
  create?: Maybe<DocumentCertificateCreateWithoutMetadataListInput>;
  update?: Maybe<DocumentCertificateUpdateToOneWithWhereWithoutMetadataListInput>;
  upsert?: Maybe<DocumentCertificateUpsertWithoutMetadataListInput>;
};

export type DocumentCertificateUpdateOneWithoutDocumentBaseNestedInput = {
  connect?: Maybe<DocumentCertificateWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentCertificateCreateOrConnectWithoutDocumentBaseInput>;
  create?: Maybe<DocumentCertificateCreateWithoutDocumentBaseInput>;
  delete?: Maybe<DocumentCertificateWhereInput>;
  disconnect?: Maybe<DocumentCertificateWhereInput>;
  update?: Maybe<DocumentCertificateUpdateToOneWithWhereWithoutDocumentBaseInput>;
  upsert?: Maybe<DocumentCertificateUpsertWithoutDocumentBaseInput>;
};

export type DocumentCertificateUpdateToOneWithWhereWithoutDocumentBaseInput = {
  data: DocumentCertificateUpdateWithoutDocumentBaseInput;
  where?: Maybe<DocumentCertificateWhereInput>;
};

export type DocumentCertificateUpdateToOneWithWhereWithoutDocumentCertificateHashHistoryInput = {
  data: DocumentCertificateUpdateWithoutDocumentCertificateHashHistoryInput;
  where?: Maybe<DocumentCertificateWhereInput>;
};

export type DocumentCertificateUpdateToOneWithWhereWithoutDocumentCertificateSignatureItemsInput = {
  data: DocumentCertificateUpdateWithoutDocumentCertificateSignatureItemsInput;
  where?: Maybe<DocumentCertificateWhereInput>;
};

export type DocumentCertificateUpdateToOneWithWhereWithoutMetadataListInput = {
  data: DocumentCertificateUpdateWithoutMetadataListInput;
  where?: Maybe<DocumentCertificateWhereInput>;
};

export type DocumentCertificateUpdateWithWhereUniqueWithoutBulkCertificateRecordInput = {
  data: DocumentCertificateUpdateWithoutBulkCertificateRecordInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateUpdateWithWhereUniqueWithoutCurriculumInput = {
  data: DocumentCertificateUpdateWithoutCurriculumInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateUpdateWithWhereUniqueWithoutEventInput = {
  data: DocumentCertificateUpdateWithoutEventInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateUpdateWithWhereUniqueWithoutPersonInput = {
  data: DocumentCertificateUpdateWithoutPersonInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateUpdateWithWhereUniqueWithoutTeamEducationLevelInput = {
  data: DocumentCertificateUpdateWithoutTeamEducationLevelInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateUpdateWithWhereUniqueWithoutTemplateInput = {
  data: DocumentCertificateUpdateWithoutTemplateInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateUpdateWithoutBulkCertificateRecordInput = {
  Curriculum?: Maybe<CertificateCurriculumUpdateOneWithoutDocumentCertificateNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  DocumentCertificateHashHistory?: Maybe<DocumentCertificateHashHistoryUpdateManyWithoutDocumentCertificateNestedInput>;
  DocumentCertificateSignatureItems?: Maybe<DocumentCertificateSignatureItemUpdateManyWithoutDocumentCertificateNestedInput>;
  Event?: Maybe<CertificateEventUpdateOneWithoutDocumentCertificateNestedInput>;
  MetadataList?: Maybe<DocumentCertificateMetadataUpdateManyWithoutDocumentCertificateNestedInput>;
  Person?: Maybe<PersonUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  Template?: Maybe<CertificateTemplateUpdateOneWithoutDocumentCertificateNestedInput>;
  documentCertificateCPF?: Maybe<StringFieldUpdateOperationsInput>;
  documentCertificateEmail?: Maybe<StringFieldUpdateOperationsInput>;
  documentCertificateName?: Maybe<StringFieldUpdateOperationsInput>;
  hasOnlyPredefinedVisualSignature?: Maybe<BoolFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentCertificateStatusFieldUpdateOperationsInput>;
  uuid?: Maybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateUpdateWithoutCurriculumInput = {
  BulkCertificateRecord?: Maybe<BulkCertificateRecordUpdateOneWithoutDocumentCertificatesNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  DocumentCertificateHashHistory?: Maybe<DocumentCertificateHashHistoryUpdateManyWithoutDocumentCertificateNestedInput>;
  DocumentCertificateSignatureItems?: Maybe<DocumentCertificateSignatureItemUpdateManyWithoutDocumentCertificateNestedInput>;
  Event?: Maybe<CertificateEventUpdateOneWithoutDocumentCertificateNestedInput>;
  MetadataList?: Maybe<DocumentCertificateMetadataUpdateManyWithoutDocumentCertificateNestedInput>;
  Person?: Maybe<PersonUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  Template?: Maybe<CertificateTemplateUpdateOneWithoutDocumentCertificateNestedInput>;
  documentCertificateCPF?: Maybe<StringFieldUpdateOperationsInput>;
  documentCertificateEmail?: Maybe<StringFieldUpdateOperationsInput>;
  documentCertificateName?: Maybe<StringFieldUpdateOperationsInput>;
  hasOnlyPredefinedVisualSignature?: Maybe<BoolFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentCertificateStatusFieldUpdateOperationsInput>;
  uuid?: Maybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateUpdateWithoutDocumentBaseInput = {
  BulkCertificateRecord?: Maybe<BulkCertificateRecordUpdateOneWithoutDocumentCertificatesNestedInput>;
  Curriculum?: Maybe<CertificateCurriculumUpdateOneWithoutDocumentCertificateNestedInput>;
  DocumentCertificateHashHistory?: Maybe<DocumentCertificateHashHistoryUpdateManyWithoutDocumentCertificateNestedInput>;
  DocumentCertificateSignatureItems?: Maybe<DocumentCertificateSignatureItemUpdateManyWithoutDocumentCertificateNestedInput>;
  Event?: Maybe<CertificateEventUpdateOneWithoutDocumentCertificateNestedInput>;
  MetadataList?: Maybe<DocumentCertificateMetadataUpdateManyWithoutDocumentCertificateNestedInput>;
  Person?: Maybe<PersonUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  Template?: Maybe<CertificateTemplateUpdateOneWithoutDocumentCertificateNestedInput>;
  documentCertificateCPF?: Maybe<StringFieldUpdateOperationsInput>;
  documentCertificateEmail?: Maybe<StringFieldUpdateOperationsInput>;
  documentCertificateName?: Maybe<StringFieldUpdateOperationsInput>;
  hasOnlyPredefinedVisualSignature?: Maybe<BoolFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentCertificateStatusFieldUpdateOperationsInput>;
  uuid?: Maybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateUpdateWithoutDocumentCertificateHashHistoryInput = {
  BulkCertificateRecord?: Maybe<BulkCertificateRecordUpdateOneWithoutDocumentCertificatesNestedInput>;
  Curriculum?: Maybe<CertificateCurriculumUpdateOneWithoutDocumentCertificateNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  DocumentCertificateSignatureItems?: Maybe<DocumentCertificateSignatureItemUpdateManyWithoutDocumentCertificateNestedInput>;
  Event?: Maybe<CertificateEventUpdateOneWithoutDocumentCertificateNestedInput>;
  MetadataList?: Maybe<DocumentCertificateMetadataUpdateManyWithoutDocumentCertificateNestedInput>;
  Person?: Maybe<PersonUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  Template?: Maybe<CertificateTemplateUpdateOneWithoutDocumentCertificateNestedInput>;
  documentCertificateCPF?: Maybe<StringFieldUpdateOperationsInput>;
  documentCertificateEmail?: Maybe<StringFieldUpdateOperationsInput>;
  documentCertificateName?: Maybe<StringFieldUpdateOperationsInput>;
  hasOnlyPredefinedVisualSignature?: Maybe<BoolFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentCertificateStatusFieldUpdateOperationsInput>;
  uuid?: Maybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateUpdateWithoutDocumentCertificateSignatureItemsInput = {
  BulkCertificateRecord?: Maybe<BulkCertificateRecordUpdateOneWithoutDocumentCertificatesNestedInput>;
  Curriculum?: Maybe<CertificateCurriculumUpdateOneWithoutDocumentCertificateNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  DocumentCertificateHashHistory?: Maybe<DocumentCertificateHashHistoryUpdateManyWithoutDocumentCertificateNestedInput>;
  Event?: Maybe<CertificateEventUpdateOneWithoutDocumentCertificateNestedInput>;
  MetadataList?: Maybe<DocumentCertificateMetadataUpdateManyWithoutDocumentCertificateNestedInput>;
  Person?: Maybe<PersonUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  Template?: Maybe<CertificateTemplateUpdateOneWithoutDocumentCertificateNestedInput>;
  documentCertificateCPF?: Maybe<StringFieldUpdateOperationsInput>;
  documentCertificateEmail?: Maybe<StringFieldUpdateOperationsInput>;
  documentCertificateName?: Maybe<StringFieldUpdateOperationsInput>;
  hasOnlyPredefinedVisualSignature?: Maybe<BoolFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentCertificateStatusFieldUpdateOperationsInput>;
  uuid?: Maybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateUpdateWithoutEventInput = {
  BulkCertificateRecord?: Maybe<BulkCertificateRecordUpdateOneWithoutDocumentCertificatesNestedInput>;
  Curriculum?: Maybe<CertificateCurriculumUpdateOneWithoutDocumentCertificateNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  DocumentCertificateHashHistory?: Maybe<DocumentCertificateHashHistoryUpdateManyWithoutDocumentCertificateNestedInput>;
  DocumentCertificateSignatureItems?: Maybe<DocumentCertificateSignatureItemUpdateManyWithoutDocumentCertificateNestedInput>;
  MetadataList?: Maybe<DocumentCertificateMetadataUpdateManyWithoutDocumentCertificateNestedInput>;
  Person?: Maybe<PersonUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  Template?: Maybe<CertificateTemplateUpdateOneWithoutDocumentCertificateNestedInput>;
  documentCertificateCPF?: Maybe<StringFieldUpdateOperationsInput>;
  documentCertificateEmail?: Maybe<StringFieldUpdateOperationsInput>;
  documentCertificateName?: Maybe<StringFieldUpdateOperationsInput>;
  hasOnlyPredefinedVisualSignature?: Maybe<BoolFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentCertificateStatusFieldUpdateOperationsInput>;
  uuid?: Maybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateUpdateWithoutMetadataListInput = {
  BulkCertificateRecord?: Maybe<BulkCertificateRecordUpdateOneWithoutDocumentCertificatesNestedInput>;
  Curriculum?: Maybe<CertificateCurriculumUpdateOneWithoutDocumentCertificateNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  DocumentCertificateHashHistory?: Maybe<DocumentCertificateHashHistoryUpdateManyWithoutDocumentCertificateNestedInput>;
  DocumentCertificateSignatureItems?: Maybe<DocumentCertificateSignatureItemUpdateManyWithoutDocumentCertificateNestedInput>;
  Event?: Maybe<CertificateEventUpdateOneWithoutDocumentCertificateNestedInput>;
  Person?: Maybe<PersonUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  Template?: Maybe<CertificateTemplateUpdateOneWithoutDocumentCertificateNestedInput>;
  documentCertificateCPF?: Maybe<StringFieldUpdateOperationsInput>;
  documentCertificateEmail?: Maybe<StringFieldUpdateOperationsInput>;
  documentCertificateName?: Maybe<StringFieldUpdateOperationsInput>;
  hasOnlyPredefinedVisualSignature?: Maybe<BoolFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentCertificateStatusFieldUpdateOperationsInput>;
  uuid?: Maybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateUpdateWithoutPersonInput = {
  BulkCertificateRecord?: Maybe<BulkCertificateRecordUpdateOneWithoutDocumentCertificatesNestedInput>;
  Curriculum?: Maybe<CertificateCurriculumUpdateOneWithoutDocumentCertificateNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  DocumentCertificateHashHistory?: Maybe<DocumentCertificateHashHistoryUpdateManyWithoutDocumentCertificateNestedInput>;
  DocumentCertificateSignatureItems?: Maybe<DocumentCertificateSignatureItemUpdateManyWithoutDocumentCertificateNestedInput>;
  Event?: Maybe<CertificateEventUpdateOneWithoutDocumentCertificateNestedInput>;
  MetadataList?: Maybe<DocumentCertificateMetadataUpdateManyWithoutDocumentCertificateNestedInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  Template?: Maybe<CertificateTemplateUpdateOneWithoutDocumentCertificateNestedInput>;
  documentCertificateCPF?: Maybe<StringFieldUpdateOperationsInput>;
  documentCertificateEmail?: Maybe<StringFieldUpdateOperationsInput>;
  documentCertificateName?: Maybe<StringFieldUpdateOperationsInput>;
  hasOnlyPredefinedVisualSignature?: Maybe<BoolFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentCertificateStatusFieldUpdateOperationsInput>;
  uuid?: Maybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateUpdateWithoutTeamEducationLevelInput = {
  BulkCertificateRecord?: Maybe<BulkCertificateRecordUpdateOneWithoutDocumentCertificatesNestedInput>;
  Curriculum?: Maybe<CertificateCurriculumUpdateOneWithoutDocumentCertificateNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  DocumentCertificateHashHistory?: Maybe<DocumentCertificateHashHistoryUpdateManyWithoutDocumentCertificateNestedInput>;
  DocumentCertificateSignatureItems?: Maybe<DocumentCertificateSignatureItemUpdateManyWithoutDocumentCertificateNestedInput>;
  Event?: Maybe<CertificateEventUpdateOneWithoutDocumentCertificateNestedInput>;
  MetadataList?: Maybe<DocumentCertificateMetadataUpdateManyWithoutDocumentCertificateNestedInput>;
  Person?: Maybe<PersonUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  Template?: Maybe<CertificateTemplateUpdateOneWithoutDocumentCertificateNestedInput>;
  documentCertificateCPF?: Maybe<StringFieldUpdateOperationsInput>;
  documentCertificateEmail?: Maybe<StringFieldUpdateOperationsInput>;
  documentCertificateName?: Maybe<StringFieldUpdateOperationsInput>;
  hasOnlyPredefinedVisualSignature?: Maybe<BoolFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentCertificateStatusFieldUpdateOperationsInput>;
  uuid?: Maybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateUpdateWithoutTemplateInput = {
  BulkCertificateRecord?: Maybe<BulkCertificateRecordUpdateOneWithoutDocumentCertificatesNestedInput>;
  Curriculum?: Maybe<CertificateCurriculumUpdateOneWithoutDocumentCertificateNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  DocumentCertificateHashHistory?: Maybe<DocumentCertificateHashHistoryUpdateManyWithoutDocumentCertificateNestedInput>;
  DocumentCertificateSignatureItems?: Maybe<DocumentCertificateSignatureItemUpdateManyWithoutDocumentCertificateNestedInput>;
  Event?: Maybe<CertificateEventUpdateOneWithoutDocumentCertificateNestedInput>;
  MetadataList?: Maybe<DocumentCertificateMetadataUpdateManyWithoutDocumentCertificateNestedInput>;
  Person?: Maybe<PersonUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  documentCertificateCPF?: Maybe<StringFieldUpdateOperationsInput>;
  documentCertificateEmail?: Maybe<StringFieldUpdateOperationsInput>;
  documentCertificateName?: Maybe<StringFieldUpdateOperationsInput>;
  hasOnlyPredefinedVisualSignature?: Maybe<BoolFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentCertificateStatusFieldUpdateOperationsInput>;
  uuid?: Maybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateUpsertWithWhereUniqueWithoutBulkCertificateRecordInput = {
  create: DocumentCertificateCreateWithoutBulkCertificateRecordInput;
  update: DocumentCertificateUpdateWithoutBulkCertificateRecordInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateUpsertWithWhereUniqueWithoutCurriculumInput = {
  create: DocumentCertificateCreateWithoutCurriculumInput;
  update: DocumentCertificateUpdateWithoutCurriculumInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateUpsertWithWhereUniqueWithoutEventInput = {
  create: DocumentCertificateCreateWithoutEventInput;
  update: DocumentCertificateUpdateWithoutEventInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateUpsertWithWhereUniqueWithoutPersonInput = {
  create: DocumentCertificateCreateWithoutPersonInput;
  update: DocumentCertificateUpdateWithoutPersonInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateUpsertWithWhereUniqueWithoutTeamEducationLevelInput = {
  create: DocumentCertificateCreateWithoutTeamEducationLevelInput;
  update: DocumentCertificateUpdateWithoutTeamEducationLevelInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateUpsertWithWhereUniqueWithoutTemplateInput = {
  create: DocumentCertificateCreateWithoutTemplateInput;
  update: DocumentCertificateUpdateWithoutTemplateInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateUpsertWithoutDocumentBaseInput = {
  create: DocumentCertificateCreateWithoutDocumentBaseInput;
  update: DocumentCertificateUpdateWithoutDocumentBaseInput;
  where?: Maybe<DocumentCertificateWhereInput>;
};

export type DocumentCertificateUpsertWithoutDocumentCertificateHashHistoryInput = {
  create: DocumentCertificateCreateWithoutDocumentCertificateHashHistoryInput;
  update: DocumentCertificateUpdateWithoutDocumentCertificateHashHistoryInput;
  where?: Maybe<DocumentCertificateWhereInput>;
};

export type DocumentCertificateUpsertWithoutDocumentCertificateSignatureItemsInput = {
  create: DocumentCertificateCreateWithoutDocumentCertificateSignatureItemsInput;
  update: DocumentCertificateUpdateWithoutDocumentCertificateSignatureItemsInput;
  where?: Maybe<DocumentCertificateWhereInput>;
};

export type DocumentCertificateUpsertWithoutMetadataListInput = {
  create: DocumentCertificateCreateWithoutMetadataListInput;
  update: DocumentCertificateUpdateWithoutMetadataListInput;
  where?: Maybe<DocumentCertificateWhereInput>;
};

export type DocumentCertificateWhereInput = {
  AND?: Maybe<Array<DocumentCertificateWhereInput>>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordWhereInput>;
  Curriculum?: Maybe<CertificateCurriculumWhereInput>;
  DocumentBase?: Maybe<DocumentBaseWhereInput>;
  DocumentCertificateHashHistory?: Maybe<DocumentCertificateHashHistoryListRelationFilter>;
  DocumentCertificateSignatureItems?: Maybe<DocumentCertificateSignatureItemListRelationFilter>;
  Event?: Maybe<CertificateEventWhereInput>;
  MetadataList?: Maybe<DocumentCertificateMetadataListRelationFilter>;
  NOT?: Maybe<Array<DocumentCertificateWhereInput>>;
  OR?: Maybe<Array<DocumentCertificateWhereInput>>;
  Person?: Maybe<PersonWhereInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelWhereInput>;
  Template?: Maybe<CertificateTemplateWhereInput>;
  batchId?: Maybe<StringNullableFilter>;
  certificateCurriculumCertificateBaseId?: Maybe<StringNullableFilter>;
  certificateEventCertificateBaseId?: Maybe<StringNullableFilter>;
  certificateTemplateId?: Maybe<StringNullableFilter>;
  documentBaseId?: Maybe<StringFilter>;
  documentCertificateCPF?: Maybe<StringFilter>;
  documentCertificateEmail?: Maybe<StringFilter>;
  documentCertificateName?: Maybe<StringFilter>;
  hasOnlyPredefinedVisualSignature?: Maybe<BoolFilter>;
  personId?: Maybe<StringFilter>;
  status?: Maybe<EnumDocumentCertificateStatusFilter>;
  teamEducationLevelId?: Maybe<IntFilter>;
  uuid?: Maybe<StringFilter>;
};

export type DocumentCertificateWhereUniqueInput = {
  AND?: Maybe<Array<DocumentCertificateWhereInput>>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordWhereInput>;
  Curriculum?: Maybe<CertificateCurriculumWhereInput>;
  DocumentBase?: Maybe<DocumentBaseWhereInput>;
  DocumentCertificateHashHistory?: Maybe<DocumentCertificateHashHistoryListRelationFilter>;
  DocumentCertificateSignatureItems?: Maybe<DocumentCertificateSignatureItemListRelationFilter>;
  Event?: Maybe<CertificateEventWhereInput>;
  MetadataList?: Maybe<DocumentCertificateMetadataListRelationFilter>;
  NOT?: Maybe<Array<DocumentCertificateWhereInput>>;
  OR?: Maybe<Array<DocumentCertificateWhereInput>>;
  Person?: Maybe<PersonWhereInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelWhereInput>;
  Template?: Maybe<CertificateTemplateWhereInput>;
  batchId?: Maybe<StringNullableFilter>;
  certificateCurriculumCertificateBaseId?: Maybe<StringNullableFilter>;
  certificateEventCertificateBaseId?: Maybe<StringNullableFilter>;
  certificateTemplateId?: Maybe<StringNullableFilter>;
  documentBaseId?: Maybe<Scalars['String']>;
  documentCertificateCPF?: Maybe<StringFilter>;
  documentCertificateEmail?: Maybe<StringFilter>;
  documentCertificateName?: Maybe<StringFilter>;
  hasOnlyPredefinedVisualSignature?: Maybe<BoolFilter>;
  personId?: Maybe<StringFilter>;
  status?: Maybe<EnumDocumentCertificateStatusFilter>;
  teamEducationLevelId?: Maybe<IntFilter>;
  uuid?: Maybe<Scalars['String']>;
};

export type DocumentChange = {
  propertyPath: Scalars['String'];
  /** 'updated', 'created', 'deleted' */
  type: Scalars['String'];
  value?: Maybe<Scalars['Json']>;
};

export type DocumentDegree = {
  __typename?: 'DocumentDegree';
  DocumentAuditFileIssuers: Array<DocumentAuditFileIssuerDegreeItem>;
  DocumentBase: DocumentBase;
  DocumentDegreeSearchView?: Maybe<DocumentDegreeSearchView>;
  ParentAcademicDocumentation?: Maybe<DocumentAcademicDocumentation>;
  documentBaseId: Scalars['String'];
  parentAcademicDocumentationId?: Maybe<Scalars['String']>;
  searchCPF: Scalars['String'];
  searchCourse: Scalars['String'];
  searchEmecCode: Scalars['String'];
  searchIssueDate: Scalars['DateTime'];
  searchRegistrationDate: Scalars['DateTime'];
  searchStudentName: Scalars['String'];
  searchValidationCode: Scalars['String'];
  status: DocumentDegreeStatus;
  visualRepresentationPath?: Maybe<Scalars['String']>;
};


export type DocumentDegreeDocumentAuditFileIssuersArgs = {
  cursor?: Maybe<DocumentAuditFileIssuerDegreeItemWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentAuditFileIssuerDegreeItemScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentAuditFileIssuerDegreeItemOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentAuditFileIssuerDegreeItemWhereInput>;
};

export type DocumentDegreeCountOrderByAggregateInput = {
  documentBaseId?: Maybe<SortOrder>;
  parentAcademicDocumentationId?: Maybe<SortOrder>;
  searchCPF?: Maybe<SortOrder>;
  searchCourse?: Maybe<SortOrder>;
  searchEmecCode?: Maybe<SortOrder>;
  searchIssueDate?: Maybe<SortOrder>;
  searchRegistrationDate?: Maybe<SortOrder>;
  searchStudentName?: Maybe<SortOrder>;
  searchValidationCode?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  visualRepresentationPath?: Maybe<SortOrder>;
};

export type DocumentDegreeCreateInput = {
  DocumentAuditFileIssuers?: Maybe<DocumentAuditFileIssuerDegreeItemCreateNestedManyWithoutDocumentDegreeInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentDegreeInput;
  DocumentDegreeSearchView?: Maybe<DocumentDegreeSearchViewCreateNestedOneWithoutDocumentDegreeInput>;
  ParentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationCreateNestedOneWithoutLinkedDegreeListInput>;
  searchCPF: Scalars['String'];
  searchCourse: Scalars['String'];
  searchEmecCode: Scalars['String'];
  searchIssueDate: Scalars['DateTime'];
  searchRegistrationDate: Scalars['DateTime'];
  searchStudentName: Scalars['String'];
  searchValidationCode: Scalars['String'];
  status?: Maybe<DocumentDegreeStatus>;
  visualRepresentationPath?: Maybe<Scalars['String']>;
};

export type DocumentDegreeCreateManyInput = {
  documentBaseId: Scalars['String'];
  parentAcademicDocumentationId?: Maybe<Scalars['String']>;
  searchCPF: Scalars['String'];
  searchCourse: Scalars['String'];
  searchEmecCode: Scalars['String'];
  searchIssueDate: Scalars['DateTime'];
  searchRegistrationDate: Scalars['DateTime'];
  searchStudentName: Scalars['String'];
  searchValidationCode: Scalars['String'];
  status?: Maybe<DocumentDegreeStatus>;
  visualRepresentationPath?: Maybe<Scalars['String']>;
};

export type DocumentDegreeCreateManyParentAcademicDocumentationInput = {
  documentBaseId: Scalars['String'];
  searchCPF: Scalars['String'];
  searchCourse: Scalars['String'];
  searchEmecCode: Scalars['String'];
  searchIssueDate: Scalars['DateTime'];
  searchRegistrationDate: Scalars['DateTime'];
  searchStudentName: Scalars['String'];
  searchValidationCode: Scalars['String'];
  status?: Maybe<DocumentDegreeStatus>;
  visualRepresentationPath?: Maybe<Scalars['String']>;
};

export type DocumentDegreeCreateManyParentAcademicDocumentationInputEnvelope = {
  data: Array<DocumentDegreeCreateManyParentAcademicDocumentationInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentDegreeCreateNestedManyWithoutParentAcademicDocumentationInput = {
  connect?: Maybe<Array<DocumentDegreeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentDegreeCreateOrConnectWithoutParentAcademicDocumentationInput>>;
  create?: Maybe<Array<DocumentDegreeCreateWithoutParentAcademicDocumentationInput>>;
  createMany?: Maybe<DocumentDegreeCreateManyParentAcademicDocumentationInputEnvelope>;
};

export type DocumentDegreeCreateNestedOneWithoutDocumentAuditFileIssuersInput = {
  connect?: Maybe<DocumentDegreeWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentDegreeCreateOrConnectWithoutDocumentAuditFileIssuersInput>;
  create?: Maybe<DocumentDegreeCreateWithoutDocumentAuditFileIssuersInput>;
};

export type DocumentDegreeCreateNestedOneWithoutDocumentBaseInput = {
  connect?: Maybe<DocumentDegreeWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentDegreeCreateOrConnectWithoutDocumentBaseInput>;
  create?: Maybe<DocumentDegreeCreateWithoutDocumentBaseInput>;
};

export type DocumentDegreeCreateNestedOneWithoutDocumentDegreeSearchViewInput = {
  connect?: Maybe<DocumentDegreeWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentDegreeCreateOrConnectWithoutDocumentDegreeSearchViewInput>;
  create?: Maybe<DocumentDegreeCreateWithoutDocumentDegreeSearchViewInput>;
};

export type DocumentDegreeCreateOrConnectWithoutDocumentAuditFileIssuersInput = {
  create: DocumentDegreeCreateWithoutDocumentAuditFileIssuersInput;
  where: DocumentDegreeWhereUniqueInput;
};

export type DocumentDegreeCreateOrConnectWithoutDocumentBaseInput = {
  create: DocumentDegreeCreateWithoutDocumentBaseInput;
  where: DocumentDegreeWhereUniqueInput;
};

export type DocumentDegreeCreateOrConnectWithoutDocumentDegreeSearchViewInput = {
  create: DocumentDegreeCreateWithoutDocumentDegreeSearchViewInput;
  where: DocumentDegreeWhereUniqueInput;
};

export type DocumentDegreeCreateOrConnectWithoutParentAcademicDocumentationInput = {
  create: DocumentDegreeCreateWithoutParentAcademicDocumentationInput;
  where: DocumentDegreeWhereUniqueInput;
};

export type DocumentDegreeCreateWithoutDocumentAuditFileIssuersInput = {
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentDegreeInput;
  DocumentDegreeSearchView?: Maybe<DocumentDegreeSearchViewCreateNestedOneWithoutDocumentDegreeInput>;
  ParentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationCreateNestedOneWithoutLinkedDegreeListInput>;
  searchCPF: Scalars['String'];
  searchCourse: Scalars['String'];
  searchEmecCode: Scalars['String'];
  searchIssueDate: Scalars['DateTime'];
  searchRegistrationDate: Scalars['DateTime'];
  searchStudentName: Scalars['String'];
  searchValidationCode: Scalars['String'];
  status?: Maybe<DocumentDegreeStatus>;
  visualRepresentationPath?: Maybe<Scalars['String']>;
};

export type DocumentDegreeCreateWithoutDocumentBaseInput = {
  DocumentAuditFileIssuers?: Maybe<DocumentAuditFileIssuerDegreeItemCreateNestedManyWithoutDocumentDegreeInput>;
  DocumentDegreeSearchView?: Maybe<DocumentDegreeSearchViewCreateNestedOneWithoutDocumentDegreeInput>;
  ParentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationCreateNestedOneWithoutLinkedDegreeListInput>;
  searchCPF: Scalars['String'];
  searchCourse: Scalars['String'];
  searchEmecCode: Scalars['String'];
  searchIssueDate: Scalars['DateTime'];
  searchRegistrationDate: Scalars['DateTime'];
  searchStudentName: Scalars['String'];
  searchValidationCode: Scalars['String'];
  status?: Maybe<DocumentDegreeStatus>;
  visualRepresentationPath?: Maybe<Scalars['String']>;
};

export type DocumentDegreeCreateWithoutDocumentDegreeSearchViewInput = {
  DocumentAuditFileIssuers?: Maybe<DocumentAuditFileIssuerDegreeItemCreateNestedManyWithoutDocumentDegreeInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentDegreeInput;
  ParentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationCreateNestedOneWithoutLinkedDegreeListInput>;
  searchCPF: Scalars['String'];
  searchCourse: Scalars['String'];
  searchEmecCode: Scalars['String'];
  searchIssueDate: Scalars['DateTime'];
  searchRegistrationDate: Scalars['DateTime'];
  searchStudentName: Scalars['String'];
  searchValidationCode: Scalars['String'];
  status?: Maybe<DocumentDegreeStatus>;
  visualRepresentationPath?: Maybe<Scalars['String']>;
};

export type DocumentDegreeCreateWithoutParentAcademicDocumentationInput = {
  DocumentAuditFileIssuers?: Maybe<DocumentAuditFileIssuerDegreeItemCreateNestedManyWithoutDocumentDegreeInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentDegreeInput;
  DocumentDegreeSearchView?: Maybe<DocumentDegreeSearchViewCreateNestedOneWithoutDocumentDegreeInput>;
  searchCPF: Scalars['String'];
  searchCourse: Scalars['String'];
  searchEmecCode: Scalars['String'];
  searchIssueDate: Scalars['DateTime'];
  searchRegistrationDate: Scalars['DateTime'];
  searchStudentName: Scalars['String'];
  searchValidationCode: Scalars['String'];
  status?: Maybe<DocumentDegreeStatus>;
  visualRepresentationPath?: Maybe<Scalars['String']>;
};

export type DocumentDegreeListRelationFilter = {
  every?: Maybe<DocumentDegreeWhereInput>;
  none?: Maybe<DocumentDegreeWhereInput>;
  some?: Maybe<DocumentDegreeWhereInput>;
};

export type DocumentDegreeMaxOrderByAggregateInput = {
  documentBaseId?: Maybe<SortOrder>;
  parentAcademicDocumentationId?: Maybe<SortOrder>;
  searchCPF?: Maybe<SortOrder>;
  searchCourse?: Maybe<SortOrder>;
  searchEmecCode?: Maybe<SortOrder>;
  searchIssueDate?: Maybe<SortOrder>;
  searchRegistrationDate?: Maybe<SortOrder>;
  searchStudentName?: Maybe<SortOrder>;
  searchValidationCode?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  visualRepresentationPath?: Maybe<SortOrder>;
};

export type DocumentDegreeMinOrderByAggregateInput = {
  documentBaseId?: Maybe<SortOrder>;
  parentAcademicDocumentationId?: Maybe<SortOrder>;
  searchCPF?: Maybe<SortOrder>;
  searchCourse?: Maybe<SortOrder>;
  searchEmecCode?: Maybe<SortOrder>;
  searchIssueDate?: Maybe<SortOrder>;
  searchRegistrationDate?: Maybe<SortOrder>;
  searchStudentName?: Maybe<SortOrder>;
  searchValidationCode?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  visualRepresentationPath?: Maybe<SortOrder>;
};

export type DocumentDegreeNullableRelationFilter = {
  is?: Maybe<DocumentDegreeWhereInput>;
  isNot?: Maybe<DocumentDegreeWhereInput>;
};

export type DocumentDegreeOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type DocumentDegreeOrderByWithAggregationInput = {
  _count?: Maybe<DocumentDegreeCountOrderByAggregateInput>;
  _max?: Maybe<DocumentDegreeMaxOrderByAggregateInput>;
  _min?: Maybe<DocumentDegreeMinOrderByAggregateInput>;
  documentBaseId?: Maybe<SortOrder>;
  parentAcademicDocumentationId?: Maybe<SortOrder>;
  searchCPF?: Maybe<SortOrder>;
  searchCourse?: Maybe<SortOrder>;
  searchEmecCode?: Maybe<SortOrder>;
  searchIssueDate?: Maybe<SortOrder>;
  searchRegistrationDate?: Maybe<SortOrder>;
  searchStudentName?: Maybe<SortOrder>;
  searchValidationCode?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  visualRepresentationPath?: Maybe<SortOrder>;
};

export type DocumentDegreeOrderByWithRelationInput = {
  DocumentAuditFileIssuers?: Maybe<DocumentAuditFileIssuerDegreeItemOrderByRelationAggregateInput>;
  DocumentBase?: Maybe<DocumentBaseOrderByWithRelationInput>;
  DocumentDegreeSearchView?: Maybe<DocumentDegreeSearchViewOrderByWithRelationInput>;
  ParentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationOrderByWithRelationInput>;
  documentBaseId?: Maybe<SortOrder>;
  parentAcademicDocumentationId?: Maybe<SortOrder>;
  searchCPF?: Maybe<SortOrder>;
  searchCourse?: Maybe<SortOrder>;
  searchEmecCode?: Maybe<SortOrder>;
  searchIssueDate?: Maybe<SortOrder>;
  searchRegistrationDate?: Maybe<SortOrder>;
  searchStudentName?: Maybe<SortOrder>;
  searchValidationCode?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  visualRepresentationPath?: Maybe<SortOrder>;
};

export type DocumentDegreeRelationFilter = {
  is?: Maybe<DocumentDegreeWhereInput>;
  isNot?: Maybe<DocumentDegreeWhereInput>;
};

export enum DocumentDegreeScalarFieldEnum {
  DocumentBaseId = 'documentBaseId',
  ParentAcademicDocumentationId = 'parentAcademicDocumentationId',
  SearchCpf = 'searchCPF',
  SearchCourse = 'searchCourse',
  SearchEmecCode = 'searchEmecCode',
  SearchIssueDate = 'searchIssueDate',
  SearchRegistrationDate = 'searchRegistrationDate',
  SearchStudentName = 'searchStudentName',
  SearchValidationCode = 'searchValidationCode',
  Status = 'status',
  VisualRepresentationPath = 'visualRepresentationPath'
}

export type DocumentDegreeScalarWhereInput = {
  AND?: Maybe<Array<DocumentDegreeScalarWhereInput>>;
  NOT?: Maybe<Array<DocumentDegreeScalarWhereInput>>;
  OR?: Maybe<Array<DocumentDegreeScalarWhereInput>>;
  documentBaseId?: Maybe<StringFilter>;
  parentAcademicDocumentationId?: Maybe<StringNullableFilter>;
  searchCPF?: Maybe<StringFilter>;
  searchCourse?: Maybe<StringFilter>;
  searchEmecCode?: Maybe<StringFilter>;
  searchIssueDate?: Maybe<DateTimeFilter>;
  searchRegistrationDate?: Maybe<DateTimeFilter>;
  searchStudentName?: Maybe<StringFilter>;
  searchValidationCode?: Maybe<StringFilter>;
  status?: Maybe<EnumDocumentDegreeStatusFilter>;
  visualRepresentationPath?: Maybe<StringNullableFilter>;
};

export type DocumentDegreeScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<DocumentDegreeScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<DocumentDegreeScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<DocumentDegreeScalarWhereWithAggregatesInput>>;
  documentBaseId?: Maybe<StringWithAggregatesFilter>;
  parentAcademicDocumentationId?: Maybe<StringNullableWithAggregatesFilter>;
  searchCPF?: Maybe<StringWithAggregatesFilter>;
  searchCourse?: Maybe<StringWithAggregatesFilter>;
  searchEmecCode?: Maybe<StringWithAggregatesFilter>;
  searchIssueDate?: Maybe<DateTimeWithAggregatesFilter>;
  searchRegistrationDate?: Maybe<DateTimeWithAggregatesFilter>;
  searchStudentName?: Maybe<StringWithAggregatesFilter>;
  searchValidationCode?: Maybe<StringWithAggregatesFilter>;
  status?: Maybe<EnumDocumentDegreeStatusWithAggregatesFilter>;
  visualRepresentationPath?: Maybe<StringNullableWithAggregatesFilter>;
};

export type DocumentDegreeSearchView = {
  __typename?: 'DocumentDegreeSearchView';
  DocumentDegree: DocumentDegree;
  documentBaseId: Scalars['String'];
  normalizedSearchCPF: Scalars['String'];
  normalizedSearchCourse: Scalars['String'];
  normalizedSearchEmecCode: Scalars['String'];
  normalizedSearchStudentName: Scalars['String'];
};

export type DocumentDegreeSearchViewCountOrderByAggregateInput = {
  documentBaseId?: Maybe<SortOrder>;
  normalizedSearchCPF?: Maybe<SortOrder>;
  normalizedSearchCourse?: Maybe<SortOrder>;
  normalizedSearchEmecCode?: Maybe<SortOrder>;
  normalizedSearchStudentName?: Maybe<SortOrder>;
};

export type DocumentDegreeSearchViewCreateInput = {
  DocumentDegree: DocumentDegreeCreateNestedOneWithoutDocumentDegreeSearchViewInput;
  normalizedSearchCPF: Scalars['String'];
  normalizedSearchCourse: Scalars['String'];
  normalizedSearchEmecCode: Scalars['String'];
  normalizedSearchStudentName: Scalars['String'];
};

export type DocumentDegreeSearchViewCreateManyInput = {
  documentBaseId: Scalars['String'];
  normalizedSearchCPF: Scalars['String'];
  normalizedSearchCourse: Scalars['String'];
  normalizedSearchEmecCode: Scalars['String'];
  normalizedSearchStudentName: Scalars['String'];
};

export type DocumentDegreeSearchViewCreateNestedOneWithoutDocumentDegreeInput = {
  connect?: Maybe<DocumentDegreeSearchViewWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentDegreeSearchViewCreateOrConnectWithoutDocumentDegreeInput>;
  create?: Maybe<DocumentDegreeSearchViewCreateWithoutDocumentDegreeInput>;
};

export type DocumentDegreeSearchViewCreateOrConnectWithoutDocumentDegreeInput = {
  create: DocumentDegreeSearchViewCreateWithoutDocumentDegreeInput;
  where: DocumentDegreeSearchViewWhereUniqueInput;
};

export type DocumentDegreeSearchViewCreateWithoutDocumentDegreeInput = {
  normalizedSearchCPF: Scalars['String'];
  normalizedSearchCourse: Scalars['String'];
  normalizedSearchEmecCode: Scalars['String'];
  normalizedSearchStudentName: Scalars['String'];
};

export type DocumentDegreeSearchViewMaxOrderByAggregateInput = {
  documentBaseId?: Maybe<SortOrder>;
  normalizedSearchCPF?: Maybe<SortOrder>;
  normalizedSearchCourse?: Maybe<SortOrder>;
  normalizedSearchEmecCode?: Maybe<SortOrder>;
  normalizedSearchStudentName?: Maybe<SortOrder>;
};

export type DocumentDegreeSearchViewMinOrderByAggregateInput = {
  documentBaseId?: Maybe<SortOrder>;
  normalizedSearchCPF?: Maybe<SortOrder>;
  normalizedSearchCourse?: Maybe<SortOrder>;
  normalizedSearchEmecCode?: Maybe<SortOrder>;
  normalizedSearchStudentName?: Maybe<SortOrder>;
};

export type DocumentDegreeSearchViewNullableRelationFilter = {
  is?: Maybe<DocumentDegreeSearchViewWhereInput>;
  isNot?: Maybe<DocumentDegreeSearchViewWhereInput>;
};

export type DocumentDegreeSearchViewOrderByWithAggregationInput = {
  _count?: Maybe<DocumentDegreeSearchViewCountOrderByAggregateInput>;
  _max?: Maybe<DocumentDegreeSearchViewMaxOrderByAggregateInput>;
  _min?: Maybe<DocumentDegreeSearchViewMinOrderByAggregateInput>;
  documentBaseId?: Maybe<SortOrder>;
  normalizedSearchCPF?: Maybe<SortOrder>;
  normalizedSearchCourse?: Maybe<SortOrder>;
  normalizedSearchEmecCode?: Maybe<SortOrder>;
  normalizedSearchStudentName?: Maybe<SortOrder>;
};

export type DocumentDegreeSearchViewOrderByWithRelationInput = {
  DocumentDegree?: Maybe<DocumentDegreeOrderByWithRelationInput>;
  documentBaseId?: Maybe<SortOrder>;
  normalizedSearchCPF?: Maybe<SortOrder>;
  normalizedSearchCourse?: Maybe<SortOrder>;
  normalizedSearchEmecCode?: Maybe<SortOrder>;
  normalizedSearchStudentName?: Maybe<SortOrder>;
};

export enum DocumentDegreeSearchViewScalarFieldEnum {
  DocumentBaseId = 'documentBaseId',
  NormalizedSearchCpf = 'normalizedSearchCPF',
  NormalizedSearchCourse = 'normalizedSearchCourse',
  NormalizedSearchEmecCode = 'normalizedSearchEmecCode',
  NormalizedSearchStudentName = 'normalizedSearchStudentName'
}

export type DocumentDegreeSearchViewScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<DocumentDegreeSearchViewScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<DocumentDegreeSearchViewScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<DocumentDegreeSearchViewScalarWhereWithAggregatesInput>>;
  documentBaseId?: Maybe<StringWithAggregatesFilter>;
  normalizedSearchCPF?: Maybe<StringWithAggregatesFilter>;
  normalizedSearchCourse?: Maybe<StringWithAggregatesFilter>;
  normalizedSearchEmecCode?: Maybe<StringWithAggregatesFilter>;
  normalizedSearchStudentName?: Maybe<StringWithAggregatesFilter>;
};

export type DocumentDegreeSearchViewUpdateInput = {
  DocumentDegree?: Maybe<DocumentDegreeUpdateOneRequiredWithoutDocumentDegreeSearchViewNestedInput>;
  normalizedSearchCPF?: Maybe<StringFieldUpdateOperationsInput>;
  normalizedSearchCourse?: Maybe<StringFieldUpdateOperationsInput>;
  normalizedSearchEmecCode?: Maybe<StringFieldUpdateOperationsInput>;
  normalizedSearchStudentName?: Maybe<StringFieldUpdateOperationsInput>;
};

export type DocumentDegreeSearchViewUpdateManyMutationInput = {
  normalizedSearchCPF?: Maybe<StringFieldUpdateOperationsInput>;
  normalizedSearchCourse?: Maybe<StringFieldUpdateOperationsInput>;
  normalizedSearchEmecCode?: Maybe<StringFieldUpdateOperationsInput>;
  normalizedSearchStudentName?: Maybe<StringFieldUpdateOperationsInput>;
};

export type DocumentDegreeSearchViewUpdateOneWithoutDocumentDegreeNestedInput = {
  connect?: Maybe<DocumentDegreeSearchViewWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentDegreeSearchViewCreateOrConnectWithoutDocumentDegreeInput>;
  create?: Maybe<DocumentDegreeSearchViewCreateWithoutDocumentDegreeInput>;
  delete?: Maybe<DocumentDegreeSearchViewWhereInput>;
  disconnect?: Maybe<DocumentDegreeSearchViewWhereInput>;
  update?: Maybe<DocumentDegreeSearchViewUpdateToOneWithWhereWithoutDocumentDegreeInput>;
  upsert?: Maybe<DocumentDegreeSearchViewUpsertWithoutDocumentDegreeInput>;
};

export type DocumentDegreeSearchViewUpdateToOneWithWhereWithoutDocumentDegreeInput = {
  data: DocumentDegreeSearchViewUpdateWithoutDocumentDegreeInput;
  where?: Maybe<DocumentDegreeSearchViewWhereInput>;
};

export type DocumentDegreeSearchViewUpdateWithoutDocumentDegreeInput = {
  normalizedSearchCPF?: Maybe<StringFieldUpdateOperationsInput>;
  normalizedSearchCourse?: Maybe<StringFieldUpdateOperationsInput>;
  normalizedSearchEmecCode?: Maybe<StringFieldUpdateOperationsInput>;
  normalizedSearchStudentName?: Maybe<StringFieldUpdateOperationsInput>;
};

export type DocumentDegreeSearchViewUpsertWithoutDocumentDegreeInput = {
  create: DocumentDegreeSearchViewCreateWithoutDocumentDegreeInput;
  update: DocumentDegreeSearchViewUpdateWithoutDocumentDegreeInput;
  where?: Maybe<DocumentDegreeSearchViewWhereInput>;
};

export type DocumentDegreeSearchViewWhereInput = {
  AND?: Maybe<Array<DocumentDegreeSearchViewWhereInput>>;
  DocumentDegree?: Maybe<DocumentDegreeWhereInput>;
  NOT?: Maybe<Array<DocumentDegreeSearchViewWhereInput>>;
  OR?: Maybe<Array<DocumentDegreeSearchViewWhereInput>>;
  documentBaseId?: Maybe<StringFilter>;
  normalizedSearchCPF?: Maybe<StringFilter>;
  normalizedSearchCourse?: Maybe<StringFilter>;
  normalizedSearchEmecCode?: Maybe<StringFilter>;
  normalizedSearchStudentName?: Maybe<StringFilter>;
};

export type DocumentDegreeSearchViewWhereUniqueInput = {
  AND?: Maybe<Array<DocumentDegreeSearchViewWhereInput>>;
  DocumentDegree?: Maybe<DocumentDegreeWhereInput>;
  NOT?: Maybe<Array<DocumentDegreeSearchViewWhereInput>>;
  OR?: Maybe<Array<DocumentDegreeSearchViewWhereInput>>;
  documentBaseId?: Maybe<Scalars['String']>;
  normalizedSearchCPF?: Maybe<StringFilter>;
  normalizedSearchCourse?: Maybe<StringFilter>;
  normalizedSearchEmecCode?: Maybe<StringFilter>;
  normalizedSearchStudentName?: Maybe<StringFilter>;
};

export enum DocumentDegreeStatus {
  Imported = 'IMPORTED',
  Revoked = 'REVOKED'
}

export type DocumentDegreeUpdateInput = {
  DocumentAuditFileIssuers?: Maybe<DocumentAuditFileIssuerDegreeItemUpdateManyWithoutDocumentDegreeNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateOneRequiredWithoutDocumentDegreeNestedInput>;
  DocumentDegreeSearchView?: Maybe<DocumentDegreeSearchViewUpdateOneWithoutDocumentDegreeNestedInput>;
  ParentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationUpdateOneWithoutLinkedDegreeListNestedInput>;
  searchCPF?: Maybe<StringFieldUpdateOperationsInput>;
  searchCourse?: Maybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: Maybe<StringFieldUpdateOperationsInput>;
  searchIssueDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  searchRegistrationDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  searchStudentName?: Maybe<StringFieldUpdateOperationsInput>;
  searchValidationCode?: Maybe<StringFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentDegreeStatusFieldUpdateOperationsInput>;
  visualRepresentationPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type DocumentDegreeUpdateManyMutationInput = {
  searchCPF?: Maybe<StringFieldUpdateOperationsInput>;
  searchCourse?: Maybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: Maybe<StringFieldUpdateOperationsInput>;
  searchIssueDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  searchRegistrationDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  searchStudentName?: Maybe<StringFieldUpdateOperationsInput>;
  searchValidationCode?: Maybe<StringFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentDegreeStatusFieldUpdateOperationsInput>;
  visualRepresentationPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type DocumentDegreeUpdateManyWithWhereWithoutParentAcademicDocumentationInput = {
  data: DocumentDegreeUpdateManyMutationInput;
  where: DocumentDegreeScalarWhereInput;
};

export type DocumentDegreeUpdateManyWithoutParentAcademicDocumentationNestedInput = {
  connect?: Maybe<Array<DocumentDegreeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentDegreeCreateOrConnectWithoutParentAcademicDocumentationInput>>;
  create?: Maybe<Array<DocumentDegreeCreateWithoutParentAcademicDocumentationInput>>;
  createMany?: Maybe<DocumentDegreeCreateManyParentAcademicDocumentationInputEnvelope>;
  delete?: Maybe<Array<DocumentDegreeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentDegreeScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentDegreeWhereUniqueInput>>;
  set?: Maybe<Array<DocumentDegreeWhereUniqueInput>>;
  update?: Maybe<Array<DocumentDegreeUpdateWithWhereUniqueWithoutParentAcademicDocumentationInput>>;
  updateMany?: Maybe<Array<DocumentDegreeUpdateManyWithWhereWithoutParentAcademicDocumentationInput>>;
  upsert?: Maybe<Array<DocumentDegreeUpsertWithWhereUniqueWithoutParentAcademicDocumentationInput>>;
};

export type DocumentDegreeUpdateOneRequiredWithoutDocumentAuditFileIssuersNestedInput = {
  connect?: Maybe<DocumentDegreeWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentDegreeCreateOrConnectWithoutDocumentAuditFileIssuersInput>;
  create?: Maybe<DocumentDegreeCreateWithoutDocumentAuditFileIssuersInput>;
  update?: Maybe<DocumentDegreeUpdateToOneWithWhereWithoutDocumentAuditFileIssuersInput>;
  upsert?: Maybe<DocumentDegreeUpsertWithoutDocumentAuditFileIssuersInput>;
};

export type DocumentDegreeUpdateOneRequiredWithoutDocumentDegreeSearchViewNestedInput = {
  connect?: Maybe<DocumentDegreeWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentDegreeCreateOrConnectWithoutDocumentDegreeSearchViewInput>;
  create?: Maybe<DocumentDegreeCreateWithoutDocumentDegreeSearchViewInput>;
  update?: Maybe<DocumentDegreeUpdateToOneWithWhereWithoutDocumentDegreeSearchViewInput>;
  upsert?: Maybe<DocumentDegreeUpsertWithoutDocumentDegreeSearchViewInput>;
};

export type DocumentDegreeUpdateOneWithoutDocumentBaseNestedInput = {
  connect?: Maybe<DocumentDegreeWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentDegreeCreateOrConnectWithoutDocumentBaseInput>;
  create?: Maybe<DocumentDegreeCreateWithoutDocumentBaseInput>;
  delete?: Maybe<DocumentDegreeWhereInput>;
  disconnect?: Maybe<DocumentDegreeWhereInput>;
  update?: Maybe<DocumentDegreeUpdateToOneWithWhereWithoutDocumentBaseInput>;
  upsert?: Maybe<DocumentDegreeUpsertWithoutDocumentBaseInput>;
};

export type DocumentDegreeUpdateToOneWithWhereWithoutDocumentAuditFileIssuersInput = {
  data: DocumentDegreeUpdateWithoutDocumentAuditFileIssuersInput;
  where?: Maybe<DocumentDegreeWhereInput>;
};

export type DocumentDegreeUpdateToOneWithWhereWithoutDocumentBaseInput = {
  data: DocumentDegreeUpdateWithoutDocumentBaseInput;
  where?: Maybe<DocumentDegreeWhereInput>;
};

export type DocumentDegreeUpdateToOneWithWhereWithoutDocumentDegreeSearchViewInput = {
  data: DocumentDegreeUpdateWithoutDocumentDegreeSearchViewInput;
  where?: Maybe<DocumentDegreeWhereInput>;
};

export type DocumentDegreeUpdateWithWhereUniqueWithoutParentAcademicDocumentationInput = {
  data: DocumentDegreeUpdateWithoutParentAcademicDocumentationInput;
  where: DocumentDegreeWhereUniqueInput;
};

export type DocumentDegreeUpdateWithoutDocumentAuditFileIssuersInput = {
  DocumentBase?: Maybe<DocumentBaseUpdateOneRequiredWithoutDocumentDegreeNestedInput>;
  DocumentDegreeSearchView?: Maybe<DocumentDegreeSearchViewUpdateOneWithoutDocumentDegreeNestedInput>;
  ParentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationUpdateOneWithoutLinkedDegreeListNestedInput>;
  searchCPF?: Maybe<StringFieldUpdateOperationsInput>;
  searchCourse?: Maybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: Maybe<StringFieldUpdateOperationsInput>;
  searchIssueDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  searchRegistrationDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  searchStudentName?: Maybe<StringFieldUpdateOperationsInput>;
  searchValidationCode?: Maybe<StringFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentDegreeStatusFieldUpdateOperationsInput>;
  visualRepresentationPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type DocumentDegreeUpdateWithoutDocumentBaseInput = {
  DocumentAuditFileIssuers?: Maybe<DocumentAuditFileIssuerDegreeItemUpdateManyWithoutDocumentDegreeNestedInput>;
  DocumentDegreeSearchView?: Maybe<DocumentDegreeSearchViewUpdateOneWithoutDocumentDegreeNestedInput>;
  ParentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationUpdateOneWithoutLinkedDegreeListNestedInput>;
  searchCPF?: Maybe<StringFieldUpdateOperationsInput>;
  searchCourse?: Maybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: Maybe<StringFieldUpdateOperationsInput>;
  searchIssueDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  searchRegistrationDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  searchStudentName?: Maybe<StringFieldUpdateOperationsInput>;
  searchValidationCode?: Maybe<StringFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentDegreeStatusFieldUpdateOperationsInput>;
  visualRepresentationPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type DocumentDegreeUpdateWithoutDocumentDegreeSearchViewInput = {
  DocumentAuditFileIssuers?: Maybe<DocumentAuditFileIssuerDegreeItemUpdateManyWithoutDocumentDegreeNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateOneRequiredWithoutDocumentDegreeNestedInput>;
  ParentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationUpdateOneWithoutLinkedDegreeListNestedInput>;
  searchCPF?: Maybe<StringFieldUpdateOperationsInput>;
  searchCourse?: Maybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: Maybe<StringFieldUpdateOperationsInput>;
  searchIssueDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  searchRegistrationDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  searchStudentName?: Maybe<StringFieldUpdateOperationsInput>;
  searchValidationCode?: Maybe<StringFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentDegreeStatusFieldUpdateOperationsInput>;
  visualRepresentationPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type DocumentDegreeUpdateWithoutParentAcademicDocumentationInput = {
  DocumentAuditFileIssuers?: Maybe<DocumentAuditFileIssuerDegreeItemUpdateManyWithoutDocumentDegreeNestedInput>;
  DocumentBase?: Maybe<DocumentBaseUpdateOneRequiredWithoutDocumentDegreeNestedInput>;
  DocumentDegreeSearchView?: Maybe<DocumentDegreeSearchViewUpdateOneWithoutDocumentDegreeNestedInput>;
  searchCPF?: Maybe<StringFieldUpdateOperationsInput>;
  searchCourse?: Maybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: Maybe<StringFieldUpdateOperationsInput>;
  searchIssueDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  searchRegistrationDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  searchStudentName?: Maybe<StringFieldUpdateOperationsInput>;
  searchValidationCode?: Maybe<StringFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentDegreeStatusFieldUpdateOperationsInput>;
  visualRepresentationPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type DocumentDegreeUpsertWithWhereUniqueWithoutParentAcademicDocumentationInput = {
  create: DocumentDegreeCreateWithoutParentAcademicDocumentationInput;
  update: DocumentDegreeUpdateWithoutParentAcademicDocumentationInput;
  where: DocumentDegreeWhereUniqueInput;
};

export type DocumentDegreeUpsertWithoutDocumentAuditFileIssuersInput = {
  create: DocumentDegreeCreateWithoutDocumentAuditFileIssuersInput;
  update: DocumentDegreeUpdateWithoutDocumentAuditFileIssuersInput;
  where?: Maybe<DocumentDegreeWhereInput>;
};

export type DocumentDegreeUpsertWithoutDocumentBaseInput = {
  create: DocumentDegreeCreateWithoutDocumentBaseInput;
  update: DocumentDegreeUpdateWithoutDocumentBaseInput;
  where?: Maybe<DocumentDegreeWhereInput>;
};

export type DocumentDegreeUpsertWithoutDocumentDegreeSearchViewInput = {
  create: DocumentDegreeCreateWithoutDocumentDegreeSearchViewInput;
  update: DocumentDegreeUpdateWithoutDocumentDegreeSearchViewInput;
  where?: Maybe<DocumentDegreeWhereInput>;
};

export type DocumentDegreeWhereInput = {
  AND?: Maybe<Array<DocumentDegreeWhereInput>>;
  DocumentAuditFileIssuers?: Maybe<DocumentAuditFileIssuerDegreeItemListRelationFilter>;
  DocumentBase?: Maybe<DocumentBaseWhereInput>;
  DocumentDegreeSearchView?: Maybe<DocumentDegreeSearchViewWhereInput>;
  NOT?: Maybe<Array<DocumentDegreeWhereInput>>;
  OR?: Maybe<Array<DocumentDegreeWhereInput>>;
  ParentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationWhereInput>;
  documentBaseId?: Maybe<StringFilter>;
  parentAcademicDocumentationId?: Maybe<StringNullableFilter>;
  searchCPF?: Maybe<StringFilter>;
  searchCourse?: Maybe<StringFilter>;
  searchEmecCode?: Maybe<StringFilter>;
  searchIssueDate?: Maybe<DateTimeFilter>;
  searchRegistrationDate?: Maybe<DateTimeFilter>;
  searchStudentName?: Maybe<StringFilter>;
  searchValidationCode?: Maybe<StringFilter>;
  status?: Maybe<EnumDocumentDegreeStatusFilter>;
  visualRepresentationPath?: Maybe<StringNullableFilter>;
};

export type DocumentDegreeWhereUniqueInput = {
  AND?: Maybe<Array<DocumentDegreeWhereInput>>;
  DocumentAuditFileIssuers?: Maybe<DocumentAuditFileIssuerDegreeItemListRelationFilter>;
  DocumentBase?: Maybe<DocumentBaseWhereInput>;
  DocumentDegreeSearchView?: Maybe<DocumentDegreeSearchViewWhereInput>;
  NOT?: Maybe<Array<DocumentDegreeWhereInput>>;
  OR?: Maybe<Array<DocumentDegreeWhereInput>>;
  ParentAcademicDocumentation?: Maybe<DocumentAcademicDocumentationWhereInput>;
  documentBaseId?: Maybe<Scalars['String']>;
  parentAcademicDocumentationId?: Maybe<StringNullableFilter>;
  searchCPF?: Maybe<StringFilter>;
  searchCourse?: Maybe<StringFilter>;
  searchEmecCode?: Maybe<StringFilter>;
  searchIssueDate?: Maybe<DateTimeFilter>;
  searchRegistrationDate?: Maybe<DateTimeFilter>;
  searchStudentName?: Maybe<StringFilter>;
  searchValidationCode?: Maybe<StringFilter>;
  status?: Maybe<EnumDocumentDegreeStatusFilter>;
  visualRepresentationPath?: Maybe<StringNullableFilter>;
};

export type DocumentFinalAcademicTranscript = {
  __typename?: 'DocumentFinalAcademicTranscript';
  DocumentBase: DocumentBase;
  DocumentFinalAcademicTranscriptView?: Maybe<DocumentFinalAcademicTranscriptView>;
  ParentDocument?: Maybe<DocumentAcademicDocumentation>;
  documentBaseId: Scalars['String'];
  parentDocumentId?: Maybe<Scalars['String']>;
  searchCPF: Scalars['String'];
  searchCourse: Scalars['String'];
  searchEmecCode: Scalars['String'];
  searchStudentName: Scalars['String'];
  searchValidationCode: Scalars['String'];
  status: DocumentFinalAcademicTranscriptStatus;
};

export type DocumentFinalAcademicTranscriptCountOrderByAggregateInput = {
  documentBaseId?: Maybe<SortOrder>;
  parentDocumentId?: Maybe<SortOrder>;
  searchCPF?: Maybe<SortOrder>;
  searchCourse?: Maybe<SortOrder>;
  searchEmecCode?: Maybe<SortOrder>;
  searchStudentName?: Maybe<SortOrder>;
  searchValidationCode?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type DocumentFinalAcademicTranscriptCreateInput = {
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentFinalAcademicTranscriptInput;
  DocumentFinalAcademicTranscriptView?: Maybe<DocumentFinalAcademicTranscriptViewCreateNestedOneWithoutDocumentFinalAcademicTranscriptInput>;
  ParentDocument?: Maybe<DocumentAcademicDocumentationCreateNestedOneWithoutChildDocumentsInput>;
  searchCPF: Scalars['String'];
  searchCourse: Scalars['String'];
  searchEmecCode: Scalars['String'];
  searchStudentName: Scalars['String'];
  searchValidationCode: Scalars['String'];
  status: DocumentFinalAcademicTranscriptStatus;
};

export type DocumentFinalAcademicTranscriptCreateManyInput = {
  documentBaseId: Scalars['String'];
  parentDocumentId?: Maybe<Scalars['String']>;
  searchCPF: Scalars['String'];
  searchCourse: Scalars['String'];
  searchEmecCode: Scalars['String'];
  searchStudentName: Scalars['String'];
  searchValidationCode: Scalars['String'];
  status: DocumentFinalAcademicTranscriptStatus;
};

export type DocumentFinalAcademicTranscriptCreateManyParentDocumentInput = {
  documentBaseId: Scalars['String'];
  searchCPF: Scalars['String'];
  searchCourse: Scalars['String'];
  searchEmecCode: Scalars['String'];
  searchStudentName: Scalars['String'];
  searchValidationCode: Scalars['String'];
  status: DocumentFinalAcademicTranscriptStatus;
};

export type DocumentFinalAcademicTranscriptCreateManyParentDocumentInputEnvelope = {
  data: Array<DocumentFinalAcademicTranscriptCreateManyParentDocumentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentFinalAcademicTranscriptCreateNestedManyWithoutParentDocumentInput = {
  connect?: Maybe<Array<DocumentFinalAcademicTranscriptWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentFinalAcademicTranscriptCreateOrConnectWithoutParentDocumentInput>>;
  create?: Maybe<Array<DocumentFinalAcademicTranscriptCreateWithoutParentDocumentInput>>;
  createMany?: Maybe<DocumentFinalAcademicTranscriptCreateManyParentDocumentInputEnvelope>;
};

export type DocumentFinalAcademicTranscriptCreateNestedOneWithoutDocumentBaseInput = {
  connect?: Maybe<DocumentFinalAcademicTranscriptWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentFinalAcademicTranscriptCreateOrConnectWithoutDocumentBaseInput>;
  create?: Maybe<DocumentFinalAcademicTranscriptCreateWithoutDocumentBaseInput>;
};

export type DocumentFinalAcademicTranscriptCreateNestedOneWithoutDocumentFinalAcademicTranscriptViewInput = {
  connect?: Maybe<DocumentFinalAcademicTranscriptWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentFinalAcademicTranscriptCreateOrConnectWithoutDocumentFinalAcademicTranscriptViewInput>;
  create?: Maybe<DocumentFinalAcademicTranscriptCreateWithoutDocumentFinalAcademicTranscriptViewInput>;
};

export type DocumentFinalAcademicTranscriptCreateOrConnectWithoutDocumentBaseInput = {
  create: DocumentFinalAcademicTranscriptCreateWithoutDocumentBaseInput;
  where: DocumentFinalAcademicTranscriptWhereUniqueInput;
};

export type DocumentFinalAcademicTranscriptCreateOrConnectWithoutDocumentFinalAcademicTranscriptViewInput = {
  create: DocumentFinalAcademicTranscriptCreateWithoutDocumentFinalAcademicTranscriptViewInput;
  where: DocumentFinalAcademicTranscriptWhereUniqueInput;
};

export type DocumentFinalAcademicTranscriptCreateOrConnectWithoutParentDocumentInput = {
  create: DocumentFinalAcademicTranscriptCreateWithoutParentDocumentInput;
  where: DocumentFinalAcademicTranscriptWhereUniqueInput;
};

export type DocumentFinalAcademicTranscriptCreateWithoutDocumentBaseInput = {
  DocumentFinalAcademicTranscriptView?: Maybe<DocumentFinalAcademicTranscriptViewCreateNestedOneWithoutDocumentFinalAcademicTranscriptInput>;
  ParentDocument?: Maybe<DocumentAcademicDocumentationCreateNestedOneWithoutChildDocumentsInput>;
  searchCPF: Scalars['String'];
  searchCourse: Scalars['String'];
  searchEmecCode: Scalars['String'];
  searchStudentName: Scalars['String'];
  searchValidationCode: Scalars['String'];
  status: DocumentFinalAcademicTranscriptStatus;
};

export type DocumentFinalAcademicTranscriptCreateWithoutDocumentFinalAcademicTranscriptViewInput = {
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentFinalAcademicTranscriptInput;
  ParentDocument?: Maybe<DocumentAcademicDocumentationCreateNestedOneWithoutChildDocumentsInput>;
  searchCPF: Scalars['String'];
  searchCourse: Scalars['String'];
  searchEmecCode: Scalars['String'];
  searchStudentName: Scalars['String'];
  searchValidationCode: Scalars['String'];
  status: DocumentFinalAcademicTranscriptStatus;
};

export type DocumentFinalAcademicTranscriptCreateWithoutParentDocumentInput = {
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentFinalAcademicTranscriptInput;
  DocumentFinalAcademicTranscriptView?: Maybe<DocumentFinalAcademicTranscriptViewCreateNestedOneWithoutDocumentFinalAcademicTranscriptInput>;
  searchCPF: Scalars['String'];
  searchCourse: Scalars['String'];
  searchEmecCode: Scalars['String'];
  searchStudentName: Scalars['String'];
  searchValidationCode: Scalars['String'];
  status: DocumentFinalAcademicTranscriptStatus;
};

export type DocumentFinalAcademicTranscriptListRelationFilter = {
  every?: Maybe<DocumentFinalAcademicTranscriptWhereInput>;
  none?: Maybe<DocumentFinalAcademicTranscriptWhereInput>;
  some?: Maybe<DocumentFinalAcademicTranscriptWhereInput>;
};

export type DocumentFinalAcademicTranscriptMaxOrderByAggregateInput = {
  documentBaseId?: Maybe<SortOrder>;
  parentDocumentId?: Maybe<SortOrder>;
  searchCPF?: Maybe<SortOrder>;
  searchCourse?: Maybe<SortOrder>;
  searchEmecCode?: Maybe<SortOrder>;
  searchStudentName?: Maybe<SortOrder>;
  searchValidationCode?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type DocumentFinalAcademicTranscriptMinOrderByAggregateInput = {
  documentBaseId?: Maybe<SortOrder>;
  parentDocumentId?: Maybe<SortOrder>;
  searchCPF?: Maybe<SortOrder>;
  searchCourse?: Maybe<SortOrder>;
  searchEmecCode?: Maybe<SortOrder>;
  searchStudentName?: Maybe<SortOrder>;
  searchValidationCode?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type DocumentFinalAcademicTranscriptNullableRelationFilter = {
  is?: Maybe<DocumentFinalAcademicTranscriptWhereInput>;
  isNot?: Maybe<DocumentFinalAcademicTranscriptWhereInput>;
};

export type DocumentFinalAcademicTranscriptOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type DocumentFinalAcademicTranscriptOrderByWithAggregationInput = {
  _count?: Maybe<DocumentFinalAcademicTranscriptCountOrderByAggregateInput>;
  _max?: Maybe<DocumentFinalAcademicTranscriptMaxOrderByAggregateInput>;
  _min?: Maybe<DocumentFinalAcademicTranscriptMinOrderByAggregateInput>;
  documentBaseId?: Maybe<SortOrder>;
  parentDocumentId?: Maybe<SortOrder>;
  searchCPF?: Maybe<SortOrder>;
  searchCourse?: Maybe<SortOrder>;
  searchEmecCode?: Maybe<SortOrder>;
  searchStudentName?: Maybe<SortOrder>;
  searchValidationCode?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type DocumentFinalAcademicTranscriptOrderByWithRelationInput = {
  DocumentBase?: Maybe<DocumentBaseOrderByWithRelationInput>;
  DocumentFinalAcademicTranscriptView?: Maybe<DocumentFinalAcademicTranscriptViewOrderByWithRelationInput>;
  ParentDocument?: Maybe<DocumentAcademicDocumentationOrderByWithRelationInput>;
  documentBaseId?: Maybe<SortOrder>;
  parentDocumentId?: Maybe<SortOrder>;
  searchCPF?: Maybe<SortOrder>;
  searchCourse?: Maybe<SortOrder>;
  searchEmecCode?: Maybe<SortOrder>;
  searchStudentName?: Maybe<SortOrder>;
  searchValidationCode?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type DocumentFinalAcademicTranscriptRelationFilter = {
  is?: Maybe<DocumentFinalAcademicTranscriptWhereInput>;
  isNot?: Maybe<DocumentFinalAcademicTranscriptWhereInput>;
};

export enum DocumentFinalAcademicTranscriptScalarFieldEnum {
  DocumentBaseId = 'documentBaseId',
  ParentDocumentId = 'parentDocumentId',
  SearchCpf = 'searchCPF',
  SearchCourse = 'searchCourse',
  SearchEmecCode = 'searchEmecCode',
  SearchStudentName = 'searchStudentName',
  SearchValidationCode = 'searchValidationCode',
  Status = 'status'
}

export type DocumentFinalAcademicTranscriptScalarWhereInput = {
  AND?: Maybe<Array<DocumentFinalAcademicTranscriptScalarWhereInput>>;
  NOT?: Maybe<Array<DocumentFinalAcademicTranscriptScalarWhereInput>>;
  OR?: Maybe<Array<DocumentFinalAcademicTranscriptScalarWhereInput>>;
  documentBaseId?: Maybe<StringFilter>;
  parentDocumentId?: Maybe<StringNullableFilter>;
  searchCPF?: Maybe<StringFilter>;
  searchCourse?: Maybe<StringFilter>;
  searchEmecCode?: Maybe<StringFilter>;
  searchStudentName?: Maybe<StringFilter>;
  searchValidationCode?: Maybe<StringFilter>;
  status?: Maybe<EnumDocumentFinalAcademicTranscriptStatusFilter>;
};

export type DocumentFinalAcademicTranscriptScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<DocumentFinalAcademicTranscriptScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<DocumentFinalAcademicTranscriptScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<DocumentFinalAcademicTranscriptScalarWhereWithAggregatesInput>>;
  documentBaseId?: Maybe<StringWithAggregatesFilter>;
  parentDocumentId?: Maybe<StringNullableWithAggregatesFilter>;
  searchCPF?: Maybe<StringWithAggregatesFilter>;
  searchCourse?: Maybe<StringWithAggregatesFilter>;
  searchEmecCode?: Maybe<StringWithAggregatesFilter>;
  searchStudentName?: Maybe<StringWithAggregatesFilter>;
  searchValidationCode?: Maybe<StringWithAggregatesFilter>;
  status?: Maybe<EnumDocumentFinalAcademicTranscriptStatusWithAggregatesFilter>;
};

export enum DocumentFinalAcademicTranscriptStatus {
  Approved = 'APPROVED',
  InSignature = 'IN_SIGNATURE',
  Issued = 'ISSUED',
  Revoked = 'REVOKED'
}

export type DocumentFinalAcademicTranscriptUpdateInput = {
  DocumentBase?: Maybe<DocumentBaseUpdateOneRequiredWithoutDocumentFinalAcademicTranscriptNestedInput>;
  DocumentFinalAcademicTranscriptView?: Maybe<DocumentFinalAcademicTranscriptViewUpdateOneWithoutDocumentFinalAcademicTranscriptNestedInput>;
  ParentDocument?: Maybe<DocumentAcademicDocumentationUpdateOneWithoutChildDocumentsNestedInput>;
  searchCPF?: Maybe<StringFieldUpdateOperationsInput>;
  searchCourse?: Maybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: Maybe<StringFieldUpdateOperationsInput>;
  searchStudentName?: Maybe<StringFieldUpdateOperationsInput>;
  searchValidationCode?: Maybe<StringFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentFinalAcademicTranscriptStatusFieldUpdateOperationsInput>;
};

export type DocumentFinalAcademicTranscriptUpdateManyMutationInput = {
  searchCPF?: Maybe<StringFieldUpdateOperationsInput>;
  searchCourse?: Maybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: Maybe<StringFieldUpdateOperationsInput>;
  searchStudentName?: Maybe<StringFieldUpdateOperationsInput>;
  searchValidationCode?: Maybe<StringFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentFinalAcademicTranscriptStatusFieldUpdateOperationsInput>;
};

export type DocumentFinalAcademicTranscriptUpdateManyWithWhereWithoutParentDocumentInput = {
  data: DocumentFinalAcademicTranscriptUpdateManyMutationInput;
  where: DocumentFinalAcademicTranscriptScalarWhereInput;
};

export type DocumentFinalAcademicTranscriptUpdateManyWithoutParentDocumentNestedInput = {
  connect?: Maybe<Array<DocumentFinalAcademicTranscriptWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentFinalAcademicTranscriptCreateOrConnectWithoutParentDocumentInput>>;
  create?: Maybe<Array<DocumentFinalAcademicTranscriptCreateWithoutParentDocumentInput>>;
  createMany?: Maybe<DocumentFinalAcademicTranscriptCreateManyParentDocumentInputEnvelope>;
  delete?: Maybe<Array<DocumentFinalAcademicTranscriptWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentFinalAcademicTranscriptScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentFinalAcademicTranscriptWhereUniqueInput>>;
  set?: Maybe<Array<DocumentFinalAcademicTranscriptWhereUniqueInput>>;
  update?: Maybe<Array<DocumentFinalAcademicTranscriptUpdateWithWhereUniqueWithoutParentDocumentInput>>;
  updateMany?: Maybe<Array<DocumentFinalAcademicTranscriptUpdateManyWithWhereWithoutParentDocumentInput>>;
  upsert?: Maybe<Array<DocumentFinalAcademicTranscriptUpsertWithWhereUniqueWithoutParentDocumentInput>>;
};

export type DocumentFinalAcademicTranscriptUpdateOneRequiredWithoutDocumentFinalAcademicTranscriptViewNestedInput = {
  connect?: Maybe<DocumentFinalAcademicTranscriptWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentFinalAcademicTranscriptCreateOrConnectWithoutDocumentFinalAcademicTranscriptViewInput>;
  create?: Maybe<DocumentFinalAcademicTranscriptCreateWithoutDocumentFinalAcademicTranscriptViewInput>;
  update?: Maybe<DocumentFinalAcademicTranscriptUpdateToOneWithWhereWithoutDocumentFinalAcademicTranscriptViewInput>;
  upsert?: Maybe<DocumentFinalAcademicTranscriptUpsertWithoutDocumentFinalAcademicTranscriptViewInput>;
};

export type DocumentFinalAcademicTranscriptUpdateOneWithoutDocumentBaseNestedInput = {
  connect?: Maybe<DocumentFinalAcademicTranscriptWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentFinalAcademicTranscriptCreateOrConnectWithoutDocumentBaseInput>;
  create?: Maybe<DocumentFinalAcademicTranscriptCreateWithoutDocumentBaseInput>;
  delete?: Maybe<DocumentFinalAcademicTranscriptWhereInput>;
  disconnect?: Maybe<DocumentFinalAcademicTranscriptWhereInput>;
  update?: Maybe<DocumentFinalAcademicTranscriptUpdateToOneWithWhereWithoutDocumentBaseInput>;
  upsert?: Maybe<DocumentFinalAcademicTranscriptUpsertWithoutDocumentBaseInput>;
};

export type DocumentFinalAcademicTranscriptUpdateToOneWithWhereWithoutDocumentBaseInput = {
  data: DocumentFinalAcademicTranscriptUpdateWithoutDocumentBaseInput;
  where?: Maybe<DocumentFinalAcademicTranscriptWhereInput>;
};

export type DocumentFinalAcademicTranscriptUpdateToOneWithWhereWithoutDocumentFinalAcademicTranscriptViewInput = {
  data: DocumentFinalAcademicTranscriptUpdateWithoutDocumentFinalAcademicTranscriptViewInput;
  where?: Maybe<DocumentFinalAcademicTranscriptWhereInput>;
};

export type DocumentFinalAcademicTranscriptUpdateWithWhereUniqueWithoutParentDocumentInput = {
  data: DocumentFinalAcademicTranscriptUpdateWithoutParentDocumentInput;
  where: DocumentFinalAcademicTranscriptWhereUniqueInput;
};

export type DocumentFinalAcademicTranscriptUpdateWithoutDocumentBaseInput = {
  DocumentFinalAcademicTranscriptView?: Maybe<DocumentFinalAcademicTranscriptViewUpdateOneWithoutDocumentFinalAcademicTranscriptNestedInput>;
  ParentDocument?: Maybe<DocumentAcademicDocumentationUpdateOneWithoutChildDocumentsNestedInput>;
  searchCPF?: Maybe<StringFieldUpdateOperationsInput>;
  searchCourse?: Maybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: Maybe<StringFieldUpdateOperationsInput>;
  searchStudentName?: Maybe<StringFieldUpdateOperationsInput>;
  searchValidationCode?: Maybe<StringFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentFinalAcademicTranscriptStatusFieldUpdateOperationsInput>;
};

export type DocumentFinalAcademicTranscriptUpdateWithoutDocumentFinalAcademicTranscriptViewInput = {
  DocumentBase?: Maybe<DocumentBaseUpdateOneRequiredWithoutDocumentFinalAcademicTranscriptNestedInput>;
  ParentDocument?: Maybe<DocumentAcademicDocumentationUpdateOneWithoutChildDocumentsNestedInput>;
  searchCPF?: Maybe<StringFieldUpdateOperationsInput>;
  searchCourse?: Maybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: Maybe<StringFieldUpdateOperationsInput>;
  searchStudentName?: Maybe<StringFieldUpdateOperationsInput>;
  searchValidationCode?: Maybe<StringFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentFinalAcademicTranscriptStatusFieldUpdateOperationsInput>;
};

export type DocumentFinalAcademicTranscriptUpdateWithoutParentDocumentInput = {
  DocumentBase?: Maybe<DocumentBaseUpdateOneRequiredWithoutDocumentFinalAcademicTranscriptNestedInput>;
  DocumentFinalAcademicTranscriptView?: Maybe<DocumentFinalAcademicTranscriptViewUpdateOneWithoutDocumentFinalAcademicTranscriptNestedInput>;
  searchCPF?: Maybe<StringFieldUpdateOperationsInput>;
  searchCourse?: Maybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: Maybe<StringFieldUpdateOperationsInput>;
  searchStudentName?: Maybe<StringFieldUpdateOperationsInput>;
  searchValidationCode?: Maybe<StringFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentFinalAcademicTranscriptStatusFieldUpdateOperationsInput>;
};

export type DocumentFinalAcademicTranscriptUpsertWithWhereUniqueWithoutParentDocumentInput = {
  create: DocumentFinalAcademicTranscriptCreateWithoutParentDocumentInput;
  update: DocumentFinalAcademicTranscriptUpdateWithoutParentDocumentInput;
  where: DocumentFinalAcademicTranscriptWhereUniqueInput;
};

export type DocumentFinalAcademicTranscriptUpsertWithoutDocumentBaseInput = {
  create: DocumentFinalAcademicTranscriptCreateWithoutDocumentBaseInput;
  update: DocumentFinalAcademicTranscriptUpdateWithoutDocumentBaseInput;
  where?: Maybe<DocumentFinalAcademicTranscriptWhereInput>;
};

export type DocumentFinalAcademicTranscriptUpsertWithoutDocumentFinalAcademicTranscriptViewInput = {
  create: DocumentFinalAcademicTranscriptCreateWithoutDocumentFinalAcademicTranscriptViewInput;
  update: DocumentFinalAcademicTranscriptUpdateWithoutDocumentFinalAcademicTranscriptViewInput;
  where?: Maybe<DocumentFinalAcademicTranscriptWhereInput>;
};

export type DocumentFinalAcademicTranscriptView = {
  __typename?: 'DocumentFinalAcademicTranscriptView';
  DocumentFinalAcademicTranscript: DocumentFinalAcademicTranscript;
  documentBaseId: Scalars['String'];
  normalizedSearchCPF: Scalars['String'];
  normalizedSearchCourse: Scalars['String'];
  normalizedSearchEmecCode: Scalars['String'];
  normalizedSearchStudentName: Scalars['String'];
};

export type DocumentFinalAcademicTranscriptViewCountOrderByAggregateInput = {
  documentBaseId?: Maybe<SortOrder>;
  normalizedSearchCPF?: Maybe<SortOrder>;
  normalizedSearchCourse?: Maybe<SortOrder>;
  normalizedSearchEmecCode?: Maybe<SortOrder>;
  normalizedSearchStudentName?: Maybe<SortOrder>;
};

export type DocumentFinalAcademicTranscriptViewCreateInput = {
  DocumentFinalAcademicTranscript: DocumentFinalAcademicTranscriptCreateNestedOneWithoutDocumentFinalAcademicTranscriptViewInput;
  normalizedSearchCPF: Scalars['String'];
  normalizedSearchCourse: Scalars['String'];
  normalizedSearchEmecCode: Scalars['String'];
  normalizedSearchStudentName: Scalars['String'];
};

export type DocumentFinalAcademicTranscriptViewCreateManyInput = {
  documentBaseId: Scalars['String'];
  normalizedSearchCPF: Scalars['String'];
  normalizedSearchCourse: Scalars['String'];
  normalizedSearchEmecCode: Scalars['String'];
  normalizedSearchStudentName: Scalars['String'];
};

export type DocumentFinalAcademicTranscriptViewCreateNestedOneWithoutDocumentFinalAcademicTranscriptInput = {
  connect?: Maybe<DocumentFinalAcademicTranscriptViewWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentFinalAcademicTranscriptViewCreateOrConnectWithoutDocumentFinalAcademicTranscriptInput>;
  create?: Maybe<DocumentFinalAcademicTranscriptViewCreateWithoutDocumentFinalAcademicTranscriptInput>;
};

export type DocumentFinalAcademicTranscriptViewCreateOrConnectWithoutDocumentFinalAcademicTranscriptInput = {
  create: DocumentFinalAcademicTranscriptViewCreateWithoutDocumentFinalAcademicTranscriptInput;
  where: DocumentFinalAcademicTranscriptViewWhereUniqueInput;
};

export type DocumentFinalAcademicTranscriptViewCreateWithoutDocumentFinalAcademicTranscriptInput = {
  normalizedSearchCPF: Scalars['String'];
  normalizedSearchCourse: Scalars['String'];
  normalizedSearchEmecCode: Scalars['String'];
  normalizedSearchStudentName: Scalars['String'];
};

export type DocumentFinalAcademicTranscriptViewMaxOrderByAggregateInput = {
  documentBaseId?: Maybe<SortOrder>;
  normalizedSearchCPF?: Maybe<SortOrder>;
  normalizedSearchCourse?: Maybe<SortOrder>;
  normalizedSearchEmecCode?: Maybe<SortOrder>;
  normalizedSearchStudentName?: Maybe<SortOrder>;
};

export type DocumentFinalAcademicTranscriptViewMinOrderByAggregateInput = {
  documentBaseId?: Maybe<SortOrder>;
  normalizedSearchCPF?: Maybe<SortOrder>;
  normalizedSearchCourse?: Maybe<SortOrder>;
  normalizedSearchEmecCode?: Maybe<SortOrder>;
  normalizedSearchStudentName?: Maybe<SortOrder>;
};

export type DocumentFinalAcademicTranscriptViewNullableRelationFilter = {
  is?: Maybe<DocumentFinalAcademicTranscriptViewWhereInput>;
  isNot?: Maybe<DocumentFinalAcademicTranscriptViewWhereInput>;
};

export type DocumentFinalAcademicTranscriptViewOrderByWithAggregationInput = {
  _count?: Maybe<DocumentFinalAcademicTranscriptViewCountOrderByAggregateInput>;
  _max?: Maybe<DocumentFinalAcademicTranscriptViewMaxOrderByAggregateInput>;
  _min?: Maybe<DocumentFinalAcademicTranscriptViewMinOrderByAggregateInput>;
  documentBaseId?: Maybe<SortOrder>;
  normalizedSearchCPF?: Maybe<SortOrder>;
  normalizedSearchCourse?: Maybe<SortOrder>;
  normalizedSearchEmecCode?: Maybe<SortOrder>;
  normalizedSearchStudentName?: Maybe<SortOrder>;
};

export type DocumentFinalAcademicTranscriptViewOrderByWithRelationInput = {
  DocumentFinalAcademicTranscript?: Maybe<DocumentFinalAcademicTranscriptOrderByWithRelationInput>;
  documentBaseId?: Maybe<SortOrder>;
  normalizedSearchCPF?: Maybe<SortOrder>;
  normalizedSearchCourse?: Maybe<SortOrder>;
  normalizedSearchEmecCode?: Maybe<SortOrder>;
  normalizedSearchStudentName?: Maybe<SortOrder>;
};

export enum DocumentFinalAcademicTranscriptViewScalarFieldEnum {
  DocumentBaseId = 'documentBaseId',
  NormalizedSearchCpf = 'normalizedSearchCPF',
  NormalizedSearchCourse = 'normalizedSearchCourse',
  NormalizedSearchEmecCode = 'normalizedSearchEmecCode',
  NormalizedSearchStudentName = 'normalizedSearchStudentName'
}

export type DocumentFinalAcademicTranscriptViewScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<DocumentFinalAcademicTranscriptViewScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<DocumentFinalAcademicTranscriptViewScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<DocumentFinalAcademicTranscriptViewScalarWhereWithAggregatesInput>>;
  documentBaseId?: Maybe<StringWithAggregatesFilter>;
  normalizedSearchCPF?: Maybe<StringWithAggregatesFilter>;
  normalizedSearchCourse?: Maybe<StringWithAggregatesFilter>;
  normalizedSearchEmecCode?: Maybe<StringWithAggregatesFilter>;
  normalizedSearchStudentName?: Maybe<StringWithAggregatesFilter>;
};

export type DocumentFinalAcademicTranscriptViewUpdateInput = {
  DocumentFinalAcademicTranscript?: Maybe<DocumentFinalAcademicTranscriptUpdateOneRequiredWithoutDocumentFinalAcademicTranscriptViewNestedInput>;
  normalizedSearchCPF?: Maybe<StringFieldUpdateOperationsInput>;
  normalizedSearchCourse?: Maybe<StringFieldUpdateOperationsInput>;
  normalizedSearchEmecCode?: Maybe<StringFieldUpdateOperationsInput>;
  normalizedSearchStudentName?: Maybe<StringFieldUpdateOperationsInput>;
};

export type DocumentFinalAcademicTranscriptViewUpdateManyMutationInput = {
  normalizedSearchCPF?: Maybe<StringFieldUpdateOperationsInput>;
  normalizedSearchCourse?: Maybe<StringFieldUpdateOperationsInput>;
  normalizedSearchEmecCode?: Maybe<StringFieldUpdateOperationsInput>;
  normalizedSearchStudentName?: Maybe<StringFieldUpdateOperationsInput>;
};

export type DocumentFinalAcademicTranscriptViewUpdateOneWithoutDocumentFinalAcademicTranscriptNestedInput = {
  connect?: Maybe<DocumentFinalAcademicTranscriptViewWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentFinalAcademicTranscriptViewCreateOrConnectWithoutDocumentFinalAcademicTranscriptInput>;
  create?: Maybe<DocumentFinalAcademicTranscriptViewCreateWithoutDocumentFinalAcademicTranscriptInput>;
  delete?: Maybe<DocumentFinalAcademicTranscriptViewWhereInput>;
  disconnect?: Maybe<DocumentFinalAcademicTranscriptViewWhereInput>;
  update?: Maybe<DocumentFinalAcademicTranscriptViewUpdateToOneWithWhereWithoutDocumentFinalAcademicTranscriptInput>;
  upsert?: Maybe<DocumentFinalAcademicTranscriptViewUpsertWithoutDocumentFinalAcademicTranscriptInput>;
};

export type DocumentFinalAcademicTranscriptViewUpdateToOneWithWhereWithoutDocumentFinalAcademicTranscriptInput = {
  data: DocumentFinalAcademicTranscriptViewUpdateWithoutDocumentFinalAcademicTranscriptInput;
  where?: Maybe<DocumentFinalAcademicTranscriptViewWhereInput>;
};

export type DocumentFinalAcademicTranscriptViewUpdateWithoutDocumentFinalAcademicTranscriptInput = {
  normalizedSearchCPF?: Maybe<StringFieldUpdateOperationsInput>;
  normalizedSearchCourse?: Maybe<StringFieldUpdateOperationsInput>;
  normalizedSearchEmecCode?: Maybe<StringFieldUpdateOperationsInput>;
  normalizedSearchStudentName?: Maybe<StringFieldUpdateOperationsInput>;
};

export type DocumentFinalAcademicTranscriptViewUpsertWithoutDocumentFinalAcademicTranscriptInput = {
  create: DocumentFinalAcademicTranscriptViewCreateWithoutDocumentFinalAcademicTranscriptInput;
  update: DocumentFinalAcademicTranscriptViewUpdateWithoutDocumentFinalAcademicTranscriptInput;
  where?: Maybe<DocumentFinalAcademicTranscriptViewWhereInput>;
};

export type DocumentFinalAcademicTranscriptViewWhereInput = {
  AND?: Maybe<Array<DocumentFinalAcademicTranscriptViewWhereInput>>;
  DocumentFinalAcademicTranscript?: Maybe<DocumentFinalAcademicTranscriptWhereInput>;
  NOT?: Maybe<Array<DocumentFinalAcademicTranscriptViewWhereInput>>;
  OR?: Maybe<Array<DocumentFinalAcademicTranscriptViewWhereInput>>;
  documentBaseId?: Maybe<StringFilter>;
  normalizedSearchCPF?: Maybe<StringFilter>;
  normalizedSearchCourse?: Maybe<StringFilter>;
  normalizedSearchEmecCode?: Maybe<StringFilter>;
  normalizedSearchStudentName?: Maybe<StringFilter>;
};

export type DocumentFinalAcademicTranscriptViewWhereUniqueInput = {
  AND?: Maybe<Array<DocumentFinalAcademicTranscriptViewWhereInput>>;
  DocumentFinalAcademicTranscript?: Maybe<DocumentFinalAcademicTranscriptWhereInput>;
  NOT?: Maybe<Array<DocumentFinalAcademicTranscriptViewWhereInput>>;
  OR?: Maybe<Array<DocumentFinalAcademicTranscriptViewWhereInput>>;
  documentBaseId?: Maybe<Scalars['String']>;
  normalizedSearchCPF?: Maybe<StringFilter>;
  normalizedSearchCourse?: Maybe<StringFilter>;
  normalizedSearchEmecCode?: Maybe<StringFilter>;
  normalizedSearchStudentName?: Maybe<StringFilter>;
};

export type DocumentFinalAcademicTranscriptWhereInput = {
  AND?: Maybe<Array<DocumentFinalAcademicTranscriptWhereInput>>;
  DocumentBase?: Maybe<DocumentBaseWhereInput>;
  DocumentFinalAcademicTranscriptView?: Maybe<DocumentFinalAcademicTranscriptViewWhereInput>;
  NOT?: Maybe<Array<DocumentFinalAcademicTranscriptWhereInput>>;
  OR?: Maybe<Array<DocumentFinalAcademicTranscriptWhereInput>>;
  ParentDocument?: Maybe<DocumentAcademicDocumentationWhereInput>;
  documentBaseId?: Maybe<StringFilter>;
  parentDocumentId?: Maybe<StringNullableFilter>;
  searchCPF?: Maybe<StringFilter>;
  searchCourse?: Maybe<StringFilter>;
  searchEmecCode?: Maybe<StringFilter>;
  searchStudentName?: Maybe<StringFilter>;
  searchValidationCode?: Maybe<StringFilter>;
  status?: Maybe<EnumDocumentFinalAcademicTranscriptStatusFilter>;
};

export type DocumentFinalAcademicTranscriptWhereUniqueInput = {
  AND?: Maybe<Array<DocumentFinalAcademicTranscriptWhereInput>>;
  DocumentBase?: Maybe<DocumentBaseWhereInput>;
  DocumentFinalAcademicTranscriptView?: Maybe<DocumentFinalAcademicTranscriptViewWhereInput>;
  NOT?: Maybe<Array<DocumentFinalAcademicTranscriptWhereInput>>;
  OR?: Maybe<Array<DocumentFinalAcademicTranscriptWhereInput>>;
  ParentDocument?: Maybe<DocumentAcademicDocumentationWhereInput>;
  documentBaseId?: Maybe<Scalars['String']>;
  parentDocumentId?: Maybe<StringNullableFilter>;
  searchCPF?: Maybe<StringFilter>;
  searchCourse?: Maybe<StringFilter>;
  searchEmecCode?: Maybe<StringFilter>;
  searchStudentName?: Maybe<StringFilter>;
  searchValidationCode?: Maybe<StringFilter>;
  status?: Maybe<EnumDocumentFinalAcademicTranscriptStatusFilter>;
};

export type DocumentSchoolCurriculum = {
  __typename?: 'DocumentSchoolCurriculum';
  DocumentBase: DocumentBase;
  documentBaseId: Scalars['String'];
  searchSchoolCurriculumCode: Scalars['String'];
  searchSchoolCurriculumName: Scalars['String'];
  searchSelectedCourse: Scalars['String'];
  searchValidationCode: Scalars['String'];
  status: DocumentSchoolCurriculumStatus;
};

export type DocumentSchoolCurriculumCountOrderByAggregateInput = {
  documentBaseId?: Maybe<SortOrder>;
  searchSchoolCurriculumCode?: Maybe<SortOrder>;
  searchSchoolCurriculumName?: Maybe<SortOrder>;
  searchSelectedCourse?: Maybe<SortOrder>;
  searchValidationCode?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type DocumentSchoolCurriculumCreateInput = {
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentSchoolCurriculumInput;
  searchSchoolCurriculumCode: Scalars['String'];
  searchSchoolCurriculumName: Scalars['String'];
  searchSelectedCourse: Scalars['String'];
  searchValidationCode: Scalars['String'];
  status?: Maybe<DocumentSchoolCurriculumStatus>;
};

export type DocumentSchoolCurriculumCreateManyInput = {
  documentBaseId: Scalars['String'];
  searchSchoolCurriculumCode: Scalars['String'];
  searchSchoolCurriculumName: Scalars['String'];
  searchSelectedCourse: Scalars['String'];
  searchValidationCode: Scalars['String'];
  status?: Maybe<DocumentSchoolCurriculumStatus>;
};

export type DocumentSchoolCurriculumCreateNestedOneWithoutDocumentBaseInput = {
  connect?: Maybe<DocumentSchoolCurriculumWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentSchoolCurriculumCreateOrConnectWithoutDocumentBaseInput>;
  create?: Maybe<DocumentSchoolCurriculumCreateWithoutDocumentBaseInput>;
};

export type DocumentSchoolCurriculumCreateOrConnectWithoutDocumentBaseInput = {
  create: DocumentSchoolCurriculumCreateWithoutDocumentBaseInput;
  where: DocumentSchoolCurriculumWhereUniqueInput;
};

export type DocumentSchoolCurriculumCreateWithoutDocumentBaseInput = {
  searchSchoolCurriculumCode: Scalars['String'];
  searchSchoolCurriculumName: Scalars['String'];
  searchSelectedCourse: Scalars['String'];
  searchValidationCode: Scalars['String'];
  status?: Maybe<DocumentSchoolCurriculumStatus>;
};

export type DocumentSchoolCurriculumMaxOrderByAggregateInput = {
  documentBaseId?: Maybe<SortOrder>;
  searchSchoolCurriculumCode?: Maybe<SortOrder>;
  searchSchoolCurriculumName?: Maybe<SortOrder>;
  searchSelectedCourse?: Maybe<SortOrder>;
  searchValidationCode?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type DocumentSchoolCurriculumMinOrderByAggregateInput = {
  documentBaseId?: Maybe<SortOrder>;
  searchSchoolCurriculumCode?: Maybe<SortOrder>;
  searchSchoolCurriculumName?: Maybe<SortOrder>;
  searchSelectedCourse?: Maybe<SortOrder>;
  searchValidationCode?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type DocumentSchoolCurriculumNullableRelationFilter = {
  is?: Maybe<DocumentSchoolCurriculumWhereInput>;
  isNot?: Maybe<DocumentSchoolCurriculumWhereInput>;
};

export type DocumentSchoolCurriculumOrderByWithAggregationInput = {
  _count?: Maybe<DocumentSchoolCurriculumCountOrderByAggregateInput>;
  _max?: Maybe<DocumentSchoolCurriculumMaxOrderByAggregateInput>;
  _min?: Maybe<DocumentSchoolCurriculumMinOrderByAggregateInput>;
  documentBaseId?: Maybe<SortOrder>;
  searchSchoolCurriculumCode?: Maybe<SortOrder>;
  searchSchoolCurriculumName?: Maybe<SortOrder>;
  searchSelectedCourse?: Maybe<SortOrder>;
  searchValidationCode?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type DocumentSchoolCurriculumOrderByWithRelationInput = {
  DocumentBase?: Maybe<DocumentBaseOrderByWithRelationInput>;
  documentBaseId?: Maybe<SortOrder>;
  searchSchoolCurriculumCode?: Maybe<SortOrder>;
  searchSchoolCurriculumName?: Maybe<SortOrder>;
  searchSelectedCourse?: Maybe<SortOrder>;
  searchValidationCode?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export enum DocumentSchoolCurriculumScalarFieldEnum {
  DocumentBaseId = 'documentBaseId',
  SearchSchoolCurriculumCode = 'searchSchoolCurriculumCode',
  SearchSchoolCurriculumName = 'searchSchoolCurriculumName',
  SearchSelectedCourse = 'searchSelectedCourse',
  SearchValidationCode = 'searchValidationCode',
  Status = 'status'
}

export type DocumentSchoolCurriculumScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<DocumentSchoolCurriculumScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<DocumentSchoolCurriculumScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<DocumentSchoolCurriculumScalarWhereWithAggregatesInput>>;
  documentBaseId?: Maybe<StringWithAggregatesFilter>;
  searchSchoolCurriculumCode?: Maybe<StringWithAggregatesFilter>;
  searchSchoolCurriculumName?: Maybe<StringWithAggregatesFilter>;
  searchSelectedCourse?: Maybe<StringWithAggregatesFilter>;
  searchValidationCode?: Maybe<StringWithAggregatesFilter>;
  status?: Maybe<EnumDocumentSchoolCurriculumStatusWithAggregatesFilter>;
};

export enum DocumentSchoolCurriculumStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  Invalid = 'INVALID',
  InCorrection = 'IN_CORRECTION',
  InSignature = 'IN_SIGNATURE',
  Issued = 'ISSUED',
  PendingReview = 'PENDING_REVIEW',
  Revoked = 'REVOKED',
  ValidationInValidation = 'VALIDATION_IN_VALIDATION'
}

export type DocumentSchoolCurriculumUpdateInput = {
  DocumentBase?: Maybe<DocumentBaseUpdateOneRequiredWithoutDocumentSchoolCurriculumNestedInput>;
  searchSchoolCurriculumCode?: Maybe<StringFieldUpdateOperationsInput>;
  searchSchoolCurriculumName?: Maybe<StringFieldUpdateOperationsInput>;
  searchSelectedCourse?: Maybe<StringFieldUpdateOperationsInput>;
  searchValidationCode?: Maybe<StringFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentSchoolCurriculumStatusFieldUpdateOperationsInput>;
};

export type DocumentSchoolCurriculumUpdateManyMutationInput = {
  searchSchoolCurriculumCode?: Maybe<StringFieldUpdateOperationsInput>;
  searchSchoolCurriculumName?: Maybe<StringFieldUpdateOperationsInput>;
  searchSelectedCourse?: Maybe<StringFieldUpdateOperationsInput>;
  searchValidationCode?: Maybe<StringFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentSchoolCurriculumStatusFieldUpdateOperationsInput>;
};

export type DocumentSchoolCurriculumUpdateOneWithoutDocumentBaseNestedInput = {
  connect?: Maybe<DocumentSchoolCurriculumWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentSchoolCurriculumCreateOrConnectWithoutDocumentBaseInput>;
  create?: Maybe<DocumentSchoolCurriculumCreateWithoutDocumentBaseInput>;
  delete?: Maybe<DocumentSchoolCurriculumWhereInput>;
  disconnect?: Maybe<DocumentSchoolCurriculumWhereInput>;
  update?: Maybe<DocumentSchoolCurriculumUpdateToOneWithWhereWithoutDocumentBaseInput>;
  upsert?: Maybe<DocumentSchoolCurriculumUpsertWithoutDocumentBaseInput>;
};

export type DocumentSchoolCurriculumUpdateToOneWithWhereWithoutDocumentBaseInput = {
  data: DocumentSchoolCurriculumUpdateWithoutDocumentBaseInput;
  where?: Maybe<DocumentSchoolCurriculumWhereInput>;
};

export type DocumentSchoolCurriculumUpdateWithoutDocumentBaseInput = {
  searchSchoolCurriculumCode?: Maybe<StringFieldUpdateOperationsInput>;
  searchSchoolCurriculumName?: Maybe<StringFieldUpdateOperationsInput>;
  searchSelectedCourse?: Maybe<StringFieldUpdateOperationsInput>;
  searchValidationCode?: Maybe<StringFieldUpdateOperationsInput>;
  status?: Maybe<EnumDocumentSchoolCurriculumStatusFieldUpdateOperationsInput>;
};

export type DocumentSchoolCurriculumUpsertWithoutDocumentBaseInput = {
  create: DocumentSchoolCurriculumCreateWithoutDocumentBaseInput;
  update: DocumentSchoolCurriculumUpdateWithoutDocumentBaseInput;
  where?: Maybe<DocumentSchoolCurriculumWhereInput>;
};

export type DocumentSchoolCurriculumWhereInput = {
  AND?: Maybe<Array<DocumentSchoolCurriculumWhereInput>>;
  DocumentBase?: Maybe<DocumentBaseWhereInput>;
  NOT?: Maybe<Array<DocumentSchoolCurriculumWhereInput>>;
  OR?: Maybe<Array<DocumentSchoolCurriculumWhereInput>>;
  documentBaseId?: Maybe<StringFilter>;
  searchSchoolCurriculumCode?: Maybe<StringFilter>;
  searchSchoolCurriculumName?: Maybe<StringFilter>;
  searchSelectedCourse?: Maybe<StringFilter>;
  searchValidationCode?: Maybe<StringFilter>;
  status?: Maybe<EnumDocumentSchoolCurriculumStatusFilter>;
};

export type DocumentSchoolCurriculumWhereUniqueInput = {
  AND?: Maybe<Array<DocumentSchoolCurriculumWhereInput>>;
  DocumentBase?: Maybe<DocumentBaseWhereInput>;
  NOT?: Maybe<Array<DocumentSchoolCurriculumWhereInput>>;
  OR?: Maybe<Array<DocumentSchoolCurriculumWhereInput>>;
  documentBaseId?: Maybe<Scalars['String']>;
  searchSchoolCurriculumCode?: Maybe<StringFilter>;
  searchSchoolCurriculumName?: Maybe<StringFilter>;
  searchSelectedCourse?: Maybe<StringFilter>;
  searchValidationCode?: Maybe<StringFilter>;
  status?: Maybe<EnumDocumentSchoolCurriculumStatusFilter>;
};

export enum EducationLevelType {
  GenericCertificates = 'GENERIC_CERTIFICATES',
  PostGraduate = 'POST_GRADUATE',
  UnderGraduate = 'UNDER_GRADUATE'
}

export type EnabledInstitution = {
  __typename?: 'EnabledInstitution';
  Team?: Maybe<Team>;
  cnpj: Scalars['String'];
  createdAt: Scalars['DateTime'];
  educationLevelType: Array<EducationLevelType>;
  email: Scalars['String'];
  id: Scalars['Int'];
  isMaintainer: Scalars['Boolean'];
  /** "Não sistema federal" - Is true when the institution is not part of the federal system */
  isNSF: Scalars['Boolean'];
  /** This name can be changed by the admin */
  placeholderName: Scalars['String'];
  syncWithLedgerDoc: Scalars['Boolean'];
};

export type EnabledInstitutionAvgOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
};

export type EnabledInstitutionCountOrderByAggregateInput = {
  cnpj?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  educationLevelType?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isMaintainer?: Maybe<SortOrder>;
  isNSF?: Maybe<SortOrder>;
  placeholderName?: Maybe<SortOrder>;
  syncWithLedgerDoc?: Maybe<SortOrder>;
};

export type EnabledInstitutionCreateInput = {
  Team?: Maybe<TeamCreateNestedOneWithoutEnabledInstitutionInput>;
  cnpj: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  educationLevelType?: Maybe<Array<EducationLevelType>>;
  email: Scalars['String'];
  isMaintainer?: Maybe<Scalars['Boolean']>;
  isNSF?: Maybe<Scalars['Boolean']>;
  placeholderName?: Maybe<Scalars['String']>;
  syncWithLedgerDoc?: Maybe<Scalars['Boolean']>;
};

export type EnabledInstitutionCreateManyInput = {
  cnpj: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  educationLevelType?: Maybe<Array<EducationLevelType>>;
  email: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  isMaintainer?: Maybe<Scalars['Boolean']>;
  isNSF?: Maybe<Scalars['Boolean']>;
  placeholderName?: Maybe<Scalars['String']>;
  syncWithLedgerDoc?: Maybe<Scalars['Boolean']>;
};

export type EnabledInstitutionCreateNestedOneWithoutTeamInput = {
  connect?: Maybe<EnabledInstitutionWhereUniqueInput>;
  connectOrCreate?: Maybe<EnabledInstitutionCreateOrConnectWithoutTeamInput>;
  create?: Maybe<EnabledInstitutionCreateWithoutTeamInput>;
};

export type EnabledInstitutionCreateOrConnectWithoutTeamInput = {
  create: EnabledInstitutionCreateWithoutTeamInput;
  where: EnabledInstitutionWhereUniqueInput;
};

export type EnabledInstitutionCreateWithoutTeamInput = {
  cnpj: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  educationLevelType?: Maybe<Array<EducationLevelType>>;
  email: Scalars['String'];
  isMaintainer?: Maybe<Scalars['Boolean']>;
  isNSF?: Maybe<Scalars['Boolean']>;
  placeholderName?: Maybe<Scalars['String']>;
  syncWithLedgerDoc?: Maybe<Scalars['Boolean']>;
};

export type EnabledInstitutionCreateeducationLevelTypeInput = {
  set: Array<EducationLevelType>;
};

export type EnabledInstitutionMaxOrderByAggregateInput = {
  cnpj?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isMaintainer?: Maybe<SortOrder>;
  isNSF?: Maybe<SortOrder>;
  placeholderName?: Maybe<SortOrder>;
  syncWithLedgerDoc?: Maybe<SortOrder>;
};

export type EnabledInstitutionMinOrderByAggregateInput = {
  cnpj?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isMaintainer?: Maybe<SortOrder>;
  isNSF?: Maybe<SortOrder>;
  placeholderName?: Maybe<SortOrder>;
  syncWithLedgerDoc?: Maybe<SortOrder>;
};

export type EnabledInstitutionNullableRelationFilter = {
  is?: Maybe<EnabledInstitutionWhereInput>;
  isNot?: Maybe<EnabledInstitutionWhereInput>;
};

export type EnabledInstitutionOrderByWithAggregationInput = {
  _avg?: Maybe<EnabledInstitutionAvgOrderByAggregateInput>;
  _count?: Maybe<EnabledInstitutionCountOrderByAggregateInput>;
  _max?: Maybe<EnabledInstitutionMaxOrderByAggregateInput>;
  _min?: Maybe<EnabledInstitutionMinOrderByAggregateInput>;
  _sum?: Maybe<EnabledInstitutionSumOrderByAggregateInput>;
  cnpj?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  educationLevelType?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isMaintainer?: Maybe<SortOrder>;
  isNSF?: Maybe<SortOrder>;
  placeholderName?: Maybe<SortOrder>;
  syncWithLedgerDoc?: Maybe<SortOrder>;
};

export type EnabledInstitutionOrderByWithRelationInput = {
  Team?: Maybe<TeamOrderByWithRelationInput>;
  cnpj?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  educationLevelType?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isMaintainer?: Maybe<SortOrder>;
  isNSF?: Maybe<SortOrder>;
  placeholderName?: Maybe<SortOrder>;
  syncWithLedgerDoc?: Maybe<SortOrder>;
};

export enum EnabledInstitutionScalarFieldEnum {
  Cnpj = 'cnpj',
  CreatedAt = 'createdAt',
  EducationLevelType = 'educationLevelType',
  Email = 'email',
  Id = 'id',
  IsMaintainer = 'isMaintainer',
  IsNsf = 'isNSF',
  PlaceholderName = 'placeholderName',
  SyncWithLedgerDoc = 'syncWithLedgerDoc'
}

export type EnabledInstitutionScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<EnabledInstitutionScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<EnabledInstitutionScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<EnabledInstitutionScalarWhereWithAggregatesInput>>;
  cnpj?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  educationLevelType?: Maybe<EnumEducationLevelTypeNullableListFilter>;
  email?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  isMaintainer?: Maybe<BoolWithAggregatesFilter>;
  isNSF?: Maybe<BoolWithAggregatesFilter>;
  placeholderName?: Maybe<StringWithAggregatesFilter>;
  syncWithLedgerDoc?: Maybe<BoolWithAggregatesFilter>;
};

export type EnabledInstitutionSumOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
};

export type EnabledInstitutionUpdateInput = {
  Team?: Maybe<TeamUpdateOneWithoutEnabledInstitutionNestedInput>;
  cnpj?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  educationLevelType?: Maybe<Array<EducationLevelType>>;
  email?: Maybe<StringFieldUpdateOperationsInput>;
  isMaintainer?: Maybe<BoolFieldUpdateOperationsInput>;
  isNSF?: Maybe<BoolFieldUpdateOperationsInput>;
  placeholderName?: Maybe<StringFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: Maybe<BoolFieldUpdateOperationsInput>;
};

export type EnabledInstitutionUpdateManyMutationInput = {
  cnpj?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  educationLevelType?: Maybe<Array<EducationLevelType>>;
  email?: Maybe<StringFieldUpdateOperationsInput>;
  isMaintainer?: Maybe<BoolFieldUpdateOperationsInput>;
  isNSF?: Maybe<BoolFieldUpdateOperationsInput>;
  placeholderName?: Maybe<StringFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: Maybe<BoolFieldUpdateOperationsInput>;
};

export type EnabledInstitutionUpdateOneWithoutTeamNestedInput = {
  connect?: Maybe<EnabledInstitutionWhereUniqueInput>;
  connectOrCreate?: Maybe<EnabledInstitutionCreateOrConnectWithoutTeamInput>;
  create?: Maybe<EnabledInstitutionCreateWithoutTeamInput>;
  delete?: Maybe<EnabledInstitutionWhereInput>;
  disconnect?: Maybe<EnabledInstitutionWhereInput>;
  update?: Maybe<EnabledInstitutionUpdateToOneWithWhereWithoutTeamInput>;
  upsert?: Maybe<EnabledInstitutionUpsertWithoutTeamInput>;
};

export type EnabledInstitutionUpdateToOneWithWhereWithoutTeamInput = {
  data: EnabledInstitutionUpdateWithoutTeamInput;
  where?: Maybe<EnabledInstitutionWhereInput>;
};

export type EnabledInstitutionUpdateWithoutTeamInput = {
  cnpj?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  educationLevelType?: Maybe<Array<EducationLevelType>>;
  email?: Maybe<StringFieldUpdateOperationsInput>;
  isMaintainer?: Maybe<BoolFieldUpdateOperationsInput>;
  isNSF?: Maybe<BoolFieldUpdateOperationsInput>;
  placeholderName?: Maybe<StringFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: Maybe<BoolFieldUpdateOperationsInput>;
};

export type EnabledInstitutionUpdateeducationLevelTypeInput = {
  push?: Maybe<Array<EducationLevelType>>;
  set?: Maybe<Array<EducationLevelType>>;
};

export type EnabledInstitutionUpsertWithoutTeamInput = {
  create: EnabledInstitutionCreateWithoutTeamInput;
  update: EnabledInstitutionUpdateWithoutTeamInput;
  where?: Maybe<EnabledInstitutionWhereInput>;
};

export type EnabledInstitutionWhereInput = {
  AND?: Maybe<Array<EnabledInstitutionWhereInput>>;
  NOT?: Maybe<Array<EnabledInstitutionWhereInput>>;
  OR?: Maybe<Array<EnabledInstitutionWhereInput>>;
  Team?: Maybe<TeamWhereInput>;
  cnpj?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  educationLevelType?: Maybe<EnumEducationLevelTypeNullableListFilter>;
  email?: Maybe<StringFilter>;
  id?: Maybe<IntFilter>;
  isMaintainer?: Maybe<BoolFilter>;
  isNSF?: Maybe<BoolFilter>;
  placeholderName?: Maybe<StringFilter>;
  syncWithLedgerDoc?: Maybe<BoolFilter>;
};

export type EnabledInstitutionWhereUniqueInput = {
  AND?: Maybe<Array<EnabledInstitutionWhereInput>>;
  NOT?: Maybe<Array<EnabledInstitutionWhereInput>>;
  OR?: Maybe<Array<EnabledInstitutionWhereInput>>;
  Team?: Maybe<TeamWhereInput>;
  cnpj?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  educationLevelType?: Maybe<EnumEducationLevelTypeNullableListFilter>;
  email?: Maybe<StringFilter>;
  id?: Maybe<Scalars['Int']>;
  isMaintainer?: Maybe<BoolFilter>;
  isNSF?: Maybe<BoolFilter>;
  placeholderName?: Maybe<StringFilter>;
  syncWithLedgerDoc?: Maybe<BoolFilter>;
};

export type EnumCertificateTypesFieldUpdateOperationsInput = {
  set?: Maybe<CertificateTypes>;
};

export type EnumCertificateTypesFilter = {
  equals?: Maybe<CertificateTypes>;
  in?: Maybe<Array<CertificateTypes>>;
  not?: Maybe<CertificateTypes>;
  notIn?: Maybe<Array<CertificateTypes>>;
};

export type EnumCertificateTypesWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCertificateTypesFilter>;
  _min?: Maybe<NestedEnumCertificateTypesFilter>;
  equals?: Maybe<CertificateTypes>;
  in?: Maybe<Array<CertificateTypes>>;
  not?: Maybe<CertificateTypes>;
  notIn?: Maybe<Array<CertificateTypes>>;
};

export type EnumDocumentAcademicDocumentationCreationTypeFieldUpdateOperationsInput = {
  set?: Maybe<DocumentAcademicDocumentationCreationType>;
};

export type EnumDocumentAcademicDocumentationCreationTypeFilter = {
  equals?: Maybe<DocumentAcademicDocumentationCreationType>;
  in?: Maybe<Array<DocumentAcademicDocumentationCreationType>>;
  not?: Maybe<DocumentAcademicDocumentationCreationType>;
  notIn?: Maybe<Array<DocumentAcademicDocumentationCreationType>>;
};

export type EnumDocumentAcademicDocumentationCreationTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumDocumentAcademicDocumentationCreationTypeFilter>;
  _min?: Maybe<NestedEnumDocumentAcademicDocumentationCreationTypeFilter>;
  equals?: Maybe<DocumentAcademicDocumentationCreationType>;
  in?: Maybe<Array<DocumentAcademicDocumentationCreationType>>;
  not?: Maybe<DocumentAcademicDocumentationCreationType>;
  notIn?: Maybe<Array<DocumentAcademicDocumentationCreationType>>;
};

export type EnumDocumentAcademicDocumentationStatusFieldUpdateOperationsInput = {
  set?: Maybe<DocumentAcademicDocumentationStatus>;
};

export type EnumDocumentAcademicDocumentationStatusFilter = {
  equals?: Maybe<DocumentAcademicDocumentationStatus>;
  in?: Maybe<Array<DocumentAcademicDocumentationStatus>>;
  not?: Maybe<DocumentAcademicDocumentationStatus>;
  notIn?: Maybe<Array<DocumentAcademicDocumentationStatus>>;
};

export type EnumDocumentAcademicDocumentationStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumDocumentAcademicDocumentationStatusFilter>;
  _min?: Maybe<NestedEnumDocumentAcademicDocumentationStatusFilter>;
  equals?: Maybe<DocumentAcademicDocumentationStatus>;
  in?: Maybe<Array<DocumentAcademicDocumentationStatus>>;
  not?: Maybe<DocumentAcademicDocumentationStatus>;
  notIn?: Maybe<Array<DocumentAcademicDocumentationStatus>>;
};

export type EnumDocumentAcademicDocumentationTypeFieldUpdateOperationsInput = {
  set?: Maybe<DocumentAcademicDocumentationType>;
};

export type EnumDocumentAcademicDocumentationTypeFilter = {
  equals?: Maybe<DocumentAcademicDocumentationType>;
  in?: Maybe<Array<DocumentAcademicDocumentationType>>;
  not?: Maybe<DocumentAcademicDocumentationType>;
  notIn?: Maybe<Array<DocumentAcademicDocumentationType>>;
};

export type EnumDocumentAcademicDocumentationTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumDocumentAcademicDocumentationTypeFilter>;
  _min?: Maybe<NestedEnumDocumentAcademicDocumentationTypeFilter>;
  equals?: Maybe<DocumentAcademicDocumentationType>;
  in?: Maybe<Array<DocumentAcademicDocumentationType>>;
  not?: Maybe<DocumentAcademicDocumentationType>;
  notIn?: Maybe<Array<DocumentAcademicDocumentationType>>;
};

export type EnumDocumentAuditFileIssuerStatusFieldUpdateOperationsInput = {
  set?: Maybe<DocumentAuditFileIssuerStatus>;
};

export type EnumDocumentAuditFileIssuerStatusFilter = {
  equals?: Maybe<DocumentAuditFileIssuerStatus>;
  in?: Maybe<Array<DocumentAuditFileIssuerStatus>>;
  not?: Maybe<DocumentAuditFileIssuerStatus>;
  notIn?: Maybe<Array<DocumentAuditFileIssuerStatus>>;
};

export type EnumDocumentAuditFileIssuerStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumDocumentAuditFileIssuerStatusFilter>;
  _min?: Maybe<NestedEnumDocumentAuditFileIssuerStatusFilter>;
  equals?: Maybe<DocumentAuditFileIssuerStatus>;
  in?: Maybe<Array<DocumentAuditFileIssuerStatus>>;
  not?: Maybe<DocumentAuditFileIssuerStatus>;
  notIn?: Maybe<Array<DocumentAuditFileIssuerStatus>>;
};

export type EnumDocumentBaseTypeFieldUpdateOperationsInput = {
  set?: Maybe<DocumentBaseType>;
};

export type EnumDocumentBaseTypeFilter = {
  equals?: Maybe<DocumentBaseType>;
  in?: Maybe<Array<DocumentBaseType>>;
  not?: Maybe<DocumentBaseType>;
  notIn?: Maybe<Array<DocumentBaseType>>;
};

export type EnumDocumentBaseTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumDocumentBaseTypeFilter>;
  _min?: Maybe<NestedEnumDocumentBaseTypeFilter>;
  equals?: Maybe<DocumentBaseType>;
  in?: Maybe<Array<DocumentBaseType>>;
  not?: Maybe<DocumentBaseType>;
  notIn?: Maybe<Array<DocumentBaseType>>;
};

export type EnumDocumentCertificateSignatureHashHistoryTypeFieldUpdateOperationsInput = {
  set?: Maybe<DocumentCertificateSignatureHashHistoryType>;
};

export type EnumDocumentCertificateSignatureHashHistoryTypeFilter = {
  equals?: Maybe<DocumentCertificateSignatureHashHistoryType>;
  in?: Maybe<Array<DocumentCertificateSignatureHashHistoryType>>;
  not?: Maybe<DocumentCertificateSignatureHashHistoryType>;
  notIn?: Maybe<Array<DocumentCertificateSignatureHashHistoryType>>;
};

export type EnumDocumentCertificateSignatureHashHistoryTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumDocumentCertificateSignatureHashHistoryTypeFilter>;
  _min?: Maybe<NestedEnumDocumentCertificateSignatureHashHistoryTypeFilter>;
  equals?: Maybe<DocumentCertificateSignatureHashHistoryType>;
  in?: Maybe<Array<DocumentCertificateSignatureHashHistoryType>>;
  not?: Maybe<DocumentCertificateSignatureHashHistoryType>;
  notIn?: Maybe<Array<DocumentCertificateSignatureHashHistoryType>>;
};

export type EnumDocumentCertificateSignatureItemTypeFieldUpdateOperationsInput = {
  set?: Maybe<DocumentCertificateSignatureItemType>;
};

export type EnumDocumentCertificateSignatureItemTypeFilter = {
  equals?: Maybe<DocumentCertificateSignatureItemType>;
  in?: Maybe<Array<DocumentCertificateSignatureItemType>>;
  not?: Maybe<DocumentCertificateSignatureItemType>;
  notIn?: Maybe<Array<DocumentCertificateSignatureItemType>>;
};

export type EnumDocumentCertificateSignatureItemTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumDocumentCertificateSignatureItemTypeFilter>;
  _min?: Maybe<NestedEnumDocumentCertificateSignatureItemTypeFilter>;
  equals?: Maybe<DocumentCertificateSignatureItemType>;
  in?: Maybe<Array<DocumentCertificateSignatureItemType>>;
  not?: Maybe<DocumentCertificateSignatureItemType>;
  notIn?: Maybe<Array<DocumentCertificateSignatureItemType>>;
};

export type EnumDocumentCertificateStatusFieldUpdateOperationsInput = {
  set?: Maybe<DocumentCertificateStatus>;
};

export type EnumDocumentCertificateStatusFilter = {
  equals?: Maybe<DocumentCertificateStatus>;
  in?: Maybe<Array<DocumentCertificateStatus>>;
  not?: Maybe<DocumentCertificateStatus>;
  notIn?: Maybe<Array<DocumentCertificateStatus>>;
};

export type EnumDocumentCertificateStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumDocumentCertificateStatusFilter>;
  _min?: Maybe<NestedEnumDocumentCertificateStatusFilter>;
  equals?: Maybe<DocumentCertificateStatus>;
  in?: Maybe<Array<DocumentCertificateStatus>>;
  not?: Maybe<DocumentCertificateStatus>;
  notIn?: Maybe<Array<DocumentCertificateStatus>>;
};

export type EnumDocumentDegreeStatusFieldUpdateOperationsInput = {
  set?: Maybe<DocumentDegreeStatus>;
};

export type EnumDocumentDegreeStatusFilter = {
  equals?: Maybe<DocumentDegreeStatus>;
  in?: Maybe<Array<DocumentDegreeStatus>>;
  not?: Maybe<DocumentDegreeStatus>;
  notIn?: Maybe<Array<DocumentDegreeStatus>>;
};

export type EnumDocumentDegreeStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumDocumentDegreeStatusFilter>;
  _min?: Maybe<NestedEnumDocumentDegreeStatusFilter>;
  equals?: Maybe<DocumentDegreeStatus>;
  in?: Maybe<Array<DocumentDegreeStatus>>;
  not?: Maybe<DocumentDegreeStatus>;
  notIn?: Maybe<Array<DocumentDegreeStatus>>;
};

export type EnumDocumentFinalAcademicTranscriptStatusFieldUpdateOperationsInput = {
  set?: Maybe<DocumentFinalAcademicTranscriptStatus>;
};

export type EnumDocumentFinalAcademicTranscriptStatusFilter = {
  equals?: Maybe<DocumentFinalAcademicTranscriptStatus>;
  in?: Maybe<Array<DocumentFinalAcademicTranscriptStatus>>;
  not?: Maybe<DocumentFinalAcademicTranscriptStatus>;
  notIn?: Maybe<Array<DocumentFinalAcademicTranscriptStatus>>;
};

export type EnumDocumentFinalAcademicTranscriptStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumDocumentFinalAcademicTranscriptStatusFilter>;
  _min?: Maybe<NestedEnumDocumentFinalAcademicTranscriptStatusFilter>;
  equals?: Maybe<DocumentFinalAcademicTranscriptStatus>;
  in?: Maybe<Array<DocumentFinalAcademicTranscriptStatus>>;
  not?: Maybe<DocumentFinalAcademicTranscriptStatus>;
  notIn?: Maybe<Array<DocumentFinalAcademicTranscriptStatus>>;
};

export type EnumDocumentSchoolCurriculumStatusFieldUpdateOperationsInput = {
  set?: Maybe<DocumentSchoolCurriculumStatus>;
};

export type EnumDocumentSchoolCurriculumStatusFilter = {
  equals?: Maybe<DocumentSchoolCurriculumStatus>;
  in?: Maybe<Array<DocumentSchoolCurriculumStatus>>;
  not?: Maybe<DocumentSchoolCurriculumStatus>;
  notIn?: Maybe<Array<DocumentSchoolCurriculumStatus>>;
};

export type EnumDocumentSchoolCurriculumStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumDocumentSchoolCurriculumStatusFilter>;
  _min?: Maybe<NestedEnumDocumentSchoolCurriculumStatusFilter>;
  equals?: Maybe<DocumentSchoolCurriculumStatus>;
  in?: Maybe<Array<DocumentSchoolCurriculumStatus>>;
  not?: Maybe<DocumentSchoolCurriculumStatus>;
  notIn?: Maybe<Array<DocumentSchoolCurriculumStatus>>;
};

export type EnumEducationLevelTypeFieldUpdateOperationsInput = {
  set?: Maybe<EducationLevelType>;
};

export type EnumEducationLevelTypeFilter = {
  equals?: Maybe<EducationLevelType>;
  in?: Maybe<Array<EducationLevelType>>;
  not?: Maybe<EducationLevelType>;
  notIn?: Maybe<Array<EducationLevelType>>;
};

export type EnumEducationLevelTypeNullableListFilter = {
  equals?: Maybe<Array<EducationLevelType>>;
  has?: Maybe<EducationLevelType>;
  hasEvery?: Maybe<Array<EducationLevelType>>;
  hasSome?: Maybe<Array<EducationLevelType>>;
  isEmpty?: Maybe<Scalars['Boolean']>;
};

export type EnumEducationLevelTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumEducationLevelTypeFilter>;
  _min?: Maybe<NestedEnumEducationLevelTypeFilter>;
  equals?: Maybe<EducationLevelType>;
  in?: Maybe<Array<EducationLevelType>>;
  not?: Maybe<EducationLevelType>;
  notIn?: Maybe<Array<EducationLevelType>>;
};

export type EnumFinancialBillingCycleFieldUpdateOperationsInput = {
  set?: Maybe<FinancialBillingCycle>;
};

export type EnumFinancialBillingCycleFilter = {
  equals?: Maybe<FinancialBillingCycle>;
  in?: Maybe<Array<FinancialBillingCycle>>;
  not?: Maybe<FinancialBillingCycle>;
  notIn?: Maybe<Array<FinancialBillingCycle>>;
};

export type EnumFinancialBillingCycleNullableFilter = {
  equals?: Maybe<FinancialBillingCycle>;
  in?: Maybe<Array<FinancialBillingCycle>>;
  not?: Maybe<FinancialBillingCycle>;
  notIn?: Maybe<Array<FinancialBillingCycle>>;
};

export type EnumFinancialBillingCycleNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumFinancialBillingCycleNullableFilter>;
  _min?: Maybe<NestedEnumFinancialBillingCycleNullableFilter>;
  equals?: Maybe<FinancialBillingCycle>;
  in?: Maybe<Array<FinancialBillingCycle>>;
  not?: Maybe<FinancialBillingCycle>;
  notIn?: Maybe<Array<FinancialBillingCycle>>;
};

export type EnumFinancialBillingCycleWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumFinancialBillingCycleFilter>;
  _min?: Maybe<NestedEnumFinancialBillingCycleFilter>;
  equals?: Maybe<FinancialBillingCycle>;
  in?: Maybe<Array<FinancialBillingCycle>>;
  not?: Maybe<FinancialBillingCycle>;
  notIn?: Maybe<Array<FinancialBillingCycle>>;
};

export type EnumFinancialChargeableServiceFieldUpdateOperationsInput = {
  set?: Maybe<FinancialChargeableService>;
};

export type EnumFinancialChargeableServiceFilter = {
  equals?: Maybe<FinancialChargeableService>;
  in?: Maybe<Array<FinancialChargeableService>>;
  not?: Maybe<FinancialChargeableService>;
  notIn?: Maybe<Array<FinancialChargeableService>>;
};

export type EnumFinancialChargeableServiceWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumFinancialChargeableServiceFilter>;
  _min?: Maybe<NestedEnumFinancialChargeableServiceFilter>;
  equals?: Maybe<FinancialChargeableService>;
  in?: Maybe<Array<FinancialChargeableService>>;
  not?: Maybe<FinancialChargeableService>;
  notIn?: Maybe<Array<FinancialChargeableService>>;
};

export type EnumFinancialPlanFieldUpdateOperationsInput = {
  set?: Maybe<FinancialPlan>;
};

export type EnumFinancialPlanFilter = {
  equals?: Maybe<FinancialPlan>;
  in?: Maybe<Array<FinancialPlan>>;
  not?: Maybe<FinancialPlan>;
  notIn?: Maybe<Array<FinancialPlan>>;
};

export type EnumFinancialPlanWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumFinancialPlanFilter>;
  _min?: Maybe<NestedEnumFinancialPlanFilter>;
  equals?: Maybe<FinancialPlan>;
  in?: Maybe<Array<FinancialPlan>>;
  not?: Maybe<FinancialPlan>;
  notIn?: Maybe<Array<FinancialPlan>>;
};

export type EnumPaymentStatusFieldUpdateOperationsInput = {
  set?: Maybe<PaymentStatus>;
};

export type EnumPaymentStatusFilter = {
  equals?: Maybe<PaymentStatus>;
  in?: Maybe<Array<PaymentStatus>>;
  not?: Maybe<PaymentStatus>;
  notIn?: Maybe<Array<PaymentStatus>>;
};

export type EnumPaymentStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumPaymentStatusFilter>;
  _min?: Maybe<NestedEnumPaymentStatusFilter>;
  equals?: Maybe<PaymentStatus>;
  in?: Maybe<Array<PaymentStatus>>;
  not?: Maybe<PaymentStatus>;
  notIn?: Maybe<Array<PaymentStatus>>;
};

export type EnumSystemGlobalAlertTypeFieldUpdateOperationsInput = {
  set?: Maybe<SystemGlobalAlertType>;
};

export type EnumSystemGlobalAlertTypeFilter = {
  equals?: Maybe<SystemGlobalAlertType>;
  in?: Maybe<Array<SystemGlobalAlertType>>;
  not?: Maybe<SystemGlobalAlertType>;
  notIn?: Maybe<Array<SystemGlobalAlertType>>;
};

export type EnumSystemGlobalAlertTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumSystemGlobalAlertTypeFilter>;
  _min?: Maybe<NestedEnumSystemGlobalAlertTypeFilter>;
  equals?: Maybe<SystemGlobalAlertType>;
  in?: Maybe<Array<SystemGlobalAlertType>>;
  not?: Maybe<SystemGlobalAlertType>;
  notIn?: Maybe<Array<SystemGlobalAlertType>>;
};

export enum Errors {
  /** Error while fast validating document */
  AcademicGenerationFastInvalid = 'ACADEMIC_GENERATION_FAST_INVALID',
  /** Error while reading form data for creating a academic documentation. Should show default message + option to read the error */
  AcademicGenerationUnexpected = 'ACADEMIC_GENERATION_UNEXPECTED',
  /** User does not have enough credits to generate a certificate with specified signature types */
  CertificateGenerationNoCredits = 'CERTIFICATE_GENERATION_NO_CREDITS',
  /** Error while validating degree at import */
  DegreeImportInvalid = 'DEGREE_IMPORT_INVALID',
  /** User not activated yet */
  UserAwaitingActivation = 'USER_AWAITING_ACTIVATION',
  /** Error while validating user */
  UserNotAuthorizedForceLogout = 'USER_NOT_AUTHORIZED_FORCE_LOGOUT',
  /** User using more credits to generate a cheaper certificate */
  UsingMoreExpensiveCredits = 'USING_MORE_EXPENSIVE_CREDITS'
}

/** Endereço consultado. */
export type ExternalCepAddress = {
  __typename?: 'ExternalCepAddress';
  cep: Scalars['String'];
  /** city */
  city?: Maybe<Scalars['String']>;
  /** neighborhood */
  neighborhood?: Maybe<Scalars['String']>;
  /** service */
  service?: Maybe<Scalars['String']>;
  /** state */
  state?: Maybe<Scalars['String']>;
  /** street */
  street?: Maybe<Scalars['String']>;
};

/** Guarda os convites de assinatura externos */
export type ExternalSignatureInvite = {
  __typename?: 'ExternalSignatureInvite';
  DocumentBase: DocumentBase;
  callbackUrl?: Maybe<Scalars['String']>;
  correlationId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  documentBaseInternalSeqId: Scalars['String'];
  documentStudentName?: Maybe<Scalars['String']>;
  /** CPF or CNPJ list ["24367828000140","27118210000135"] */
  enabledPersonIdList: Array<Scalars['String']>;
  groupIndex: Scalars['Int'];
  id: Scalars['String'];
  isSigned: Scalars['Boolean'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ExternalSignatureInviteAvgOrderByAggregateInput = {
  groupIndex?: Maybe<SortOrder>;
};

export type ExternalSignatureInviteCountOrderByAggregateInput = {
  callbackUrl?: Maybe<SortOrder>;
  correlationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  documentBaseInternalSeqId?: Maybe<SortOrder>;
  enabledPersonIdList?: Maybe<SortOrder>;
  groupIndex?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isSigned?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ExternalSignatureInviteCreateInput = {
  DocumentBase: DocumentBaseCreateNestedOneWithoutExternalSignatureInviteInput;
  callbackUrl?: Maybe<Scalars['String']>;
  correlationId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  enabledPersonIdList?: Maybe<Array<Scalars['String']>>;
  groupIndex: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  isSigned?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ExternalSignatureInviteCreateManyDocumentBaseInput = {
  callbackUrl?: Maybe<Scalars['String']>;
  correlationId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  enabledPersonIdList?: Maybe<Array<Scalars['String']>>;
  groupIndex: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  isSigned?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ExternalSignatureInviteCreateManyDocumentBaseInputEnvelope = {
  data: Array<ExternalSignatureInviteCreateManyDocumentBaseInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ExternalSignatureInviteCreateManyInput = {
  callbackUrl?: Maybe<Scalars['String']>;
  correlationId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  documentBaseInternalSeqId: Scalars['String'];
  enabledPersonIdList?: Maybe<Array<Scalars['String']>>;
  groupIndex: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  isSigned?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ExternalSignatureInviteCreateNestedManyWithoutDocumentBaseInput = {
  connect?: Maybe<Array<ExternalSignatureInviteWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ExternalSignatureInviteCreateOrConnectWithoutDocumentBaseInput>>;
  create?: Maybe<Array<ExternalSignatureInviteCreateWithoutDocumentBaseInput>>;
  createMany?: Maybe<ExternalSignatureInviteCreateManyDocumentBaseInputEnvelope>;
};

export type ExternalSignatureInviteCreateOrConnectWithoutDocumentBaseInput = {
  create: ExternalSignatureInviteCreateWithoutDocumentBaseInput;
  where: ExternalSignatureInviteWhereUniqueInput;
};

export type ExternalSignatureInviteCreateWithoutDocumentBaseInput = {
  callbackUrl?: Maybe<Scalars['String']>;
  correlationId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  enabledPersonIdList?: Maybe<Array<Scalars['String']>>;
  groupIndex: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  isSigned?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ExternalSignatureInviteCreateenabledPersonIdListInput = {
  set: Array<Scalars['String']>;
};

export type ExternalSignatureInviteListRelationFilter = {
  every?: Maybe<ExternalSignatureInviteWhereInput>;
  none?: Maybe<ExternalSignatureInviteWhereInput>;
  some?: Maybe<ExternalSignatureInviteWhereInput>;
};

export type ExternalSignatureInviteMaxOrderByAggregateInput = {
  callbackUrl?: Maybe<SortOrder>;
  correlationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  documentBaseInternalSeqId?: Maybe<SortOrder>;
  groupIndex?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isSigned?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ExternalSignatureInviteMinOrderByAggregateInput = {
  callbackUrl?: Maybe<SortOrder>;
  correlationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  documentBaseInternalSeqId?: Maybe<SortOrder>;
  groupIndex?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isSigned?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ExternalSignatureInviteOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ExternalSignatureInviteOrderByWithAggregationInput = {
  _avg?: Maybe<ExternalSignatureInviteAvgOrderByAggregateInput>;
  _count?: Maybe<ExternalSignatureInviteCountOrderByAggregateInput>;
  _max?: Maybe<ExternalSignatureInviteMaxOrderByAggregateInput>;
  _min?: Maybe<ExternalSignatureInviteMinOrderByAggregateInput>;
  _sum?: Maybe<ExternalSignatureInviteSumOrderByAggregateInput>;
  callbackUrl?: Maybe<SortOrder>;
  correlationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  documentBaseInternalSeqId?: Maybe<SortOrder>;
  enabledPersonIdList?: Maybe<SortOrder>;
  groupIndex?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isSigned?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type ExternalSignatureInviteOrderByWithRelationInput = {
  DocumentBase?: Maybe<DocumentBaseOrderByWithRelationInput>;
  callbackUrl?: Maybe<SortOrder>;
  correlationId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  documentBaseInternalSeqId?: Maybe<SortOrder>;
  enabledPersonIdList?: Maybe<SortOrder>;
  groupIndex?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isSigned?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum ExternalSignatureInviteScalarFieldEnum {
  CallbackUrl = 'callbackUrl',
  CorrelationId = 'correlationId',
  CreatedAt = 'createdAt',
  DocumentBaseInternalSeqId = 'documentBaseInternalSeqId',
  EnabledPersonIdList = 'enabledPersonIdList',
  GroupIndex = 'groupIndex',
  Id = 'id',
  IsSigned = 'isSigned',
  UpdatedAt = 'updatedAt'
}

export type ExternalSignatureInviteScalarWhereInput = {
  AND?: Maybe<Array<ExternalSignatureInviteScalarWhereInput>>;
  NOT?: Maybe<Array<ExternalSignatureInviteScalarWhereInput>>;
  OR?: Maybe<Array<ExternalSignatureInviteScalarWhereInput>>;
  callbackUrl?: Maybe<StringNullableFilter>;
  correlationId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  documentBaseInternalSeqId?: Maybe<StringFilter>;
  enabledPersonIdList?: Maybe<StringNullableListFilter>;
  groupIndex?: Maybe<IntFilter>;
  id?: Maybe<StringFilter>;
  isSigned?: Maybe<BoolFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
};

export type ExternalSignatureInviteScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ExternalSignatureInviteScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ExternalSignatureInviteScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ExternalSignatureInviteScalarWhereWithAggregatesInput>>;
  callbackUrl?: Maybe<StringNullableWithAggregatesFilter>;
  correlationId?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  documentBaseInternalSeqId?: Maybe<StringWithAggregatesFilter>;
  enabledPersonIdList?: Maybe<StringNullableListFilter>;
  groupIndex?: Maybe<IntWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  isSigned?: Maybe<BoolWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
};

export type ExternalSignatureInviteSumOrderByAggregateInput = {
  groupIndex?: Maybe<SortOrder>;
};

export type ExternalSignatureInviteUpdateInput = {
  DocumentBase?: Maybe<DocumentBaseUpdateOneRequiredWithoutExternalSignatureInviteNestedInput>;
  callbackUrl?: Maybe<NullableStringFieldUpdateOperationsInput>;
  correlationId?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  enabledPersonIdList?: Maybe<Array<Scalars['String']>>;
  groupIndex?: Maybe<IntFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  isSigned?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type ExternalSignatureInviteUpdateManyMutationInput = {
  callbackUrl?: Maybe<NullableStringFieldUpdateOperationsInput>;
  correlationId?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  enabledPersonIdList?: Maybe<Array<Scalars['String']>>;
  groupIndex?: Maybe<IntFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  isSigned?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type ExternalSignatureInviteUpdateManyWithWhereWithoutDocumentBaseInput = {
  data: ExternalSignatureInviteUpdateManyMutationInput;
  where: ExternalSignatureInviteScalarWhereInput;
};

export type ExternalSignatureInviteUpdateManyWithoutDocumentBaseNestedInput = {
  connect?: Maybe<Array<ExternalSignatureInviteWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ExternalSignatureInviteCreateOrConnectWithoutDocumentBaseInput>>;
  create?: Maybe<Array<ExternalSignatureInviteCreateWithoutDocumentBaseInput>>;
  createMany?: Maybe<ExternalSignatureInviteCreateManyDocumentBaseInputEnvelope>;
  delete?: Maybe<Array<ExternalSignatureInviteWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ExternalSignatureInviteScalarWhereInput>>;
  disconnect?: Maybe<Array<ExternalSignatureInviteWhereUniqueInput>>;
  set?: Maybe<Array<ExternalSignatureInviteWhereUniqueInput>>;
  update?: Maybe<Array<ExternalSignatureInviteUpdateWithWhereUniqueWithoutDocumentBaseInput>>;
  updateMany?: Maybe<Array<ExternalSignatureInviteUpdateManyWithWhereWithoutDocumentBaseInput>>;
  upsert?: Maybe<Array<ExternalSignatureInviteUpsertWithWhereUniqueWithoutDocumentBaseInput>>;
};

export type ExternalSignatureInviteUpdateWithWhereUniqueWithoutDocumentBaseInput = {
  data: ExternalSignatureInviteUpdateWithoutDocumentBaseInput;
  where: ExternalSignatureInviteWhereUniqueInput;
};

export type ExternalSignatureInviteUpdateWithoutDocumentBaseInput = {
  callbackUrl?: Maybe<NullableStringFieldUpdateOperationsInput>;
  correlationId?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  enabledPersonIdList?: Maybe<Array<Scalars['String']>>;
  groupIndex?: Maybe<IntFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  isSigned?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type ExternalSignatureInviteUpdateenabledPersonIdListInput = {
  push?: Maybe<Array<Scalars['String']>>;
  set?: Maybe<Array<Scalars['String']>>;
};

export type ExternalSignatureInviteUpsertWithWhereUniqueWithoutDocumentBaseInput = {
  create: ExternalSignatureInviteCreateWithoutDocumentBaseInput;
  update: ExternalSignatureInviteUpdateWithoutDocumentBaseInput;
  where: ExternalSignatureInviteWhereUniqueInput;
};

export type ExternalSignatureInviteWhereInput = {
  AND?: Maybe<Array<ExternalSignatureInviteWhereInput>>;
  DocumentBase?: Maybe<DocumentBaseWhereInput>;
  NOT?: Maybe<Array<ExternalSignatureInviteWhereInput>>;
  OR?: Maybe<Array<ExternalSignatureInviteWhereInput>>;
  callbackUrl?: Maybe<StringNullableFilter>;
  correlationId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  documentBaseInternalSeqId?: Maybe<StringFilter>;
  enabledPersonIdList?: Maybe<StringNullableListFilter>;
  groupIndex?: Maybe<IntFilter>;
  id?: Maybe<StringFilter>;
  isSigned?: Maybe<BoolFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
};

export type ExternalSignatureInviteWhereUniqueInput = {
  AND?: Maybe<Array<ExternalSignatureInviteWhereInput>>;
  DocumentBase?: Maybe<DocumentBaseWhereInput>;
  NOT?: Maybe<Array<ExternalSignatureInviteWhereInput>>;
  OR?: Maybe<Array<ExternalSignatureInviteWhereInput>>;
  callbackUrl?: Maybe<StringNullableFilter>;
  correlationId?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  documentBaseInternalSeqId?: Maybe<StringFilter>;
  enabledPersonIdList?: Maybe<StringNullableListFilter>;
  groupIndex?: Maybe<IntFilter>;
  id?: Maybe<Scalars['String']>;
  isSigned?: Maybe<BoolFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
};

export enum FinancialBillingCycle {
  Monthly = 'MONTHLY',
  Yearly = 'YEARLY'
}

export type FinancialCharge = {
  __typename?: 'FinancialCharge';
  TeamWallet: FinancialTeamWallet;
  UserExecuted: CommonUser;
  createdAt: Scalars['DateTime'];
  creditsDeducted: Scalars['Int'];
  id: Scalars['Int'];
  service: FinancialChargeableService;
  teamId: Scalars['Int'];
  userExecutedId: Scalars['Int'];
};

export type FinancialChargeAvgOrderByAggregateInput = {
  creditsDeducted?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  userExecutedId?: Maybe<SortOrder>;
};

export type FinancialChargeCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  creditsDeducted?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  service?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  userExecutedId?: Maybe<SortOrder>;
};

export type FinancialChargeCreateInput = {
  TeamWallet: FinancialTeamWalletCreateNestedOneWithoutChargesInput;
  UserExecuted: CommonUserCreateNestedOneWithoutChargesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  creditsDeducted?: Maybe<Scalars['Int']>;
  service: FinancialChargeableService;
};

export type FinancialChargeCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  creditsDeducted?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  service: FinancialChargeableService;
  teamId: Scalars['Int'];
  userExecutedId: Scalars['Int'];
};

export type FinancialChargeCreateManyTeamWalletInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  creditsDeducted?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  service: FinancialChargeableService;
  userExecutedId: Scalars['Int'];
};

export type FinancialChargeCreateManyTeamWalletInputEnvelope = {
  data: Array<FinancialChargeCreateManyTeamWalletInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type FinancialChargeCreateManyUserExecutedInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  creditsDeducted?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  service: FinancialChargeableService;
  teamId: Scalars['Int'];
};

export type FinancialChargeCreateManyUserExecutedInputEnvelope = {
  data: Array<FinancialChargeCreateManyUserExecutedInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type FinancialChargeCreateNestedManyWithoutTeamWalletInput = {
  connect?: Maybe<Array<FinancialChargeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialChargeCreateOrConnectWithoutTeamWalletInput>>;
  create?: Maybe<Array<FinancialChargeCreateWithoutTeamWalletInput>>;
  createMany?: Maybe<FinancialChargeCreateManyTeamWalletInputEnvelope>;
};

export type FinancialChargeCreateNestedManyWithoutUserExecutedInput = {
  connect?: Maybe<Array<FinancialChargeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialChargeCreateOrConnectWithoutUserExecutedInput>>;
  create?: Maybe<Array<FinancialChargeCreateWithoutUserExecutedInput>>;
  createMany?: Maybe<FinancialChargeCreateManyUserExecutedInputEnvelope>;
};

export type FinancialChargeCreateOrConnectWithoutTeamWalletInput = {
  create: FinancialChargeCreateWithoutTeamWalletInput;
  where: FinancialChargeWhereUniqueInput;
};

export type FinancialChargeCreateOrConnectWithoutUserExecutedInput = {
  create: FinancialChargeCreateWithoutUserExecutedInput;
  where: FinancialChargeWhereUniqueInput;
};

export type FinancialChargeCreateWithoutTeamWalletInput = {
  UserExecuted: CommonUserCreateNestedOneWithoutChargesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  creditsDeducted?: Maybe<Scalars['Int']>;
  service: FinancialChargeableService;
};

export type FinancialChargeCreateWithoutUserExecutedInput = {
  TeamWallet: FinancialTeamWalletCreateNestedOneWithoutChargesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  creditsDeducted?: Maybe<Scalars['Int']>;
  service: FinancialChargeableService;
};

export type FinancialChargeListRelationFilter = {
  every?: Maybe<FinancialChargeWhereInput>;
  none?: Maybe<FinancialChargeWhereInput>;
  some?: Maybe<FinancialChargeWhereInput>;
};

export type FinancialChargeMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  creditsDeducted?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  service?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  userExecutedId?: Maybe<SortOrder>;
};

export type FinancialChargeMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  creditsDeducted?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  service?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  userExecutedId?: Maybe<SortOrder>;
};

export type FinancialChargeOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type FinancialChargeOrderByWithAggregationInput = {
  _avg?: Maybe<FinancialChargeAvgOrderByAggregateInput>;
  _count?: Maybe<FinancialChargeCountOrderByAggregateInput>;
  _max?: Maybe<FinancialChargeMaxOrderByAggregateInput>;
  _min?: Maybe<FinancialChargeMinOrderByAggregateInput>;
  _sum?: Maybe<FinancialChargeSumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  creditsDeducted?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  service?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  userExecutedId?: Maybe<SortOrder>;
};

export type FinancialChargeOrderByWithRelationInput = {
  TeamWallet?: Maybe<FinancialTeamWalletOrderByWithRelationInput>;
  UserExecuted?: Maybe<CommonUserOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  creditsDeducted?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  service?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  userExecutedId?: Maybe<SortOrder>;
};

export enum FinancialChargeScalarFieldEnum {
  CreatedAt = 'createdAt',
  CreditsDeducted = 'creditsDeducted',
  Id = 'id',
  Service = 'service',
  TeamId = 'teamId',
  UserExecutedId = 'userExecutedId'
}

export type FinancialChargeScalarWhereInput = {
  AND?: Maybe<Array<FinancialChargeScalarWhereInput>>;
  NOT?: Maybe<Array<FinancialChargeScalarWhereInput>>;
  OR?: Maybe<Array<FinancialChargeScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  creditsDeducted?: Maybe<IntFilter>;
  id?: Maybe<IntFilter>;
  service?: Maybe<EnumFinancialChargeableServiceFilter>;
  teamId?: Maybe<IntFilter>;
  userExecutedId?: Maybe<IntFilter>;
};

export type FinancialChargeScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<FinancialChargeScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<FinancialChargeScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<FinancialChargeScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  creditsDeducted?: Maybe<IntWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  service?: Maybe<EnumFinancialChargeableServiceWithAggregatesFilter>;
  teamId?: Maybe<IntWithAggregatesFilter>;
  userExecutedId?: Maybe<IntWithAggregatesFilter>;
};

export type FinancialChargeSumOrderByAggregateInput = {
  creditsDeducted?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  userExecutedId?: Maybe<SortOrder>;
};

export type FinancialChargeUpdateInput = {
  TeamWallet?: Maybe<FinancialTeamWalletUpdateOneRequiredWithoutChargesNestedInput>;
  UserExecuted?: Maybe<CommonUserUpdateOneRequiredWithoutChargesNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  creditsDeducted?: Maybe<IntFieldUpdateOperationsInput>;
  service?: Maybe<EnumFinancialChargeableServiceFieldUpdateOperationsInput>;
};

export type FinancialChargeUpdateManyMutationInput = {
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  creditsDeducted?: Maybe<IntFieldUpdateOperationsInput>;
  service?: Maybe<EnumFinancialChargeableServiceFieldUpdateOperationsInput>;
};

export type FinancialChargeUpdateManyWithWhereWithoutTeamWalletInput = {
  data: FinancialChargeUpdateManyMutationInput;
  where: FinancialChargeScalarWhereInput;
};

export type FinancialChargeUpdateManyWithWhereWithoutUserExecutedInput = {
  data: FinancialChargeUpdateManyMutationInput;
  where: FinancialChargeScalarWhereInput;
};

export type FinancialChargeUpdateManyWithoutTeamWalletNestedInput = {
  connect?: Maybe<Array<FinancialChargeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialChargeCreateOrConnectWithoutTeamWalletInput>>;
  create?: Maybe<Array<FinancialChargeCreateWithoutTeamWalletInput>>;
  createMany?: Maybe<FinancialChargeCreateManyTeamWalletInputEnvelope>;
  delete?: Maybe<Array<FinancialChargeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FinancialChargeScalarWhereInput>>;
  disconnect?: Maybe<Array<FinancialChargeWhereUniqueInput>>;
  set?: Maybe<Array<FinancialChargeWhereUniqueInput>>;
  update?: Maybe<Array<FinancialChargeUpdateWithWhereUniqueWithoutTeamWalletInput>>;
  updateMany?: Maybe<Array<FinancialChargeUpdateManyWithWhereWithoutTeamWalletInput>>;
  upsert?: Maybe<Array<FinancialChargeUpsertWithWhereUniqueWithoutTeamWalletInput>>;
};

export type FinancialChargeUpdateManyWithoutUserExecutedNestedInput = {
  connect?: Maybe<Array<FinancialChargeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialChargeCreateOrConnectWithoutUserExecutedInput>>;
  create?: Maybe<Array<FinancialChargeCreateWithoutUserExecutedInput>>;
  createMany?: Maybe<FinancialChargeCreateManyUserExecutedInputEnvelope>;
  delete?: Maybe<Array<FinancialChargeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FinancialChargeScalarWhereInput>>;
  disconnect?: Maybe<Array<FinancialChargeWhereUniqueInput>>;
  set?: Maybe<Array<FinancialChargeWhereUniqueInput>>;
  update?: Maybe<Array<FinancialChargeUpdateWithWhereUniqueWithoutUserExecutedInput>>;
  updateMany?: Maybe<Array<FinancialChargeUpdateManyWithWhereWithoutUserExecutedInput>>;
  upsert?: Maybe<Array<FinancialChargeUpsertWithWhereUniqueWithoutUserExecutedInput>>;
};

export type FinancialChargeUpdateWithWhereUniqueWithoutTeamWalletInput = {
  data: FinancialChargeUpdateWithoutTeamWalletInput;
  where: FinancialChargeWhereUniqueInput;
};

export type FinancialChargeUpdateWithWhereUniqueWithoutUserExecutedInput = {
  data: FinancialChargeUpdateWithoutUserExecutedInput;
  where: FinancialChargeWhereUniqueInput;
};

export type FinancialChargeUpdateWithoutTeamWalletInput = {
  UserExecuted?: Maybe<CommonUserUpdateOneRequiredWithoutChargesNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  creditsDeducted?: Maybe<IntFieldUpdateOperationsInput>;
  service?: Maybe<EnumFinancialChargeableServiceFieldUpdateOperationsInput>;
};

export type FinancialChargeUpdateWithoutUserExecutedInput = {
  TeamWallet?: Maybe<FinancialTeamWalletUpdateOneRequiredWithoutChargesNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  creditsDeducted?: Maybe<IntFieldUpdateOperationsInput>;
  service?: Maybe<EnumFinancialChargeableServiceFieldUpdateOperationsInput>;
};

export type FinancialChargeUpsertWithWhereUniqueWithoutTeamWalletInput = {
  create: FinancialChargeCreateWithoutTeamWalletInput;
  update: FinancialChargeUpdateWithoutTeamWalletInput;
  where: FinancialChargeWhereUniqueInput;
};

export type FinancialChargeUpsertWithWhereUniqueWithoutUserExecutedInput = {
  create: FinancialChargeCreateWithoutUserExecutedInput;
  update: FinancialChargeUpdateWithoutUserExecutedInput;
  where: FinancialChargeWhereUniqueInput;
};

export type FinancialChargeWhereInput = {
  AND?: Maybe<Array<FinancialChargeWhereInput>>;
  NOT?: Maybe<Array<FinancialChargeWhereInput>>;
  OR?: Maybe<Array<FinancialChargeWhereInput>>;
  TeamWallet?: Maybe<FinancialTeamWalletWhereInput>;
  UserExecuted?: Maybe<CommonUserWhereInput>;
  createdAt?: Maybe<DateTimeFilter>;
  creditsDeducted?: Maybe<IntFilter>;
  id?: Maybe<IntFilter>;
  service?: Maybe<EnumFinancialChargeableServiceFilter>;
  teamId?: Maybe<IntFilter>;
  userExecutedId?: Maybe<IntFilter>;
};

export type FinancialChargeWhereUniqueInput = {
  AND?: Maybe<Array<FinancialChargeWhereInput>>;
  NOT?: Maybe<Array<FinancialChargeWhereInput>>;
  OR?: Maybe<Array<FinancialChargeWhereInput>>;
  TeamWallet?: Maybe<FinancialTeamWalletWhereInput>;
  UserExecuted?: Maybe<CommonUserWhereInput>;
  createdAt?: Maybe<DateTimeFilter>;
  creditsDeducted?: Maybe<IntFilter>;
  id?: Maybe<Scalars['Int']>;
  service?: Maybe<EnumFinancialChargeableServiceFilter>;
  teamId?: Maybe<IntFilter>;
  userExecutedId?: Maybe<IntFilter>;
};

export enum FinancialChargeableService {
  GenerateCertificateRb = 'GENERATE_CERTIFICATE_RB',
  GenerateCertificateRtRa = 'GENERATE_CERTIFICATE_RT_RA',
  GenerateCertificateVisual = 'GENERATE_CERTIFICATE_VISUAL'
}

export type FinancialCreditCardSaved = {
  __typename?: 'FinancialCreditCardSaved';
  TeamWallet: FinancialTeamWallet;
  UserCreated: CommonUser;
  brand: Scalars['String'];
  id: Scalars['Int'];
  number: Scalars['String'];
  token: Scalars['String'];
  userCreatedId: Scalars['Int'];
  walletId: Scalars['Int'];
};

export type FinancialCreditCardSavedAvgOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  userCreatedId?: Maybe<SortOrder>;
  walletId?: Maybe<SortOrder>;
};

export type FinancialCreditCardSavedCountOrderByAggregateInput = {
  brand?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  number?: Maybe<SortOrder>;
  token?: Maybe<SortOrder>;
  userCreatedId?: Maybe<SortOrder>;
  walletId?: Maybe<SortOrder>;
};

export type FinancialCreditCardSavedCreateInput = {
  TeamWallet: FinancialTeamWalletCreateNestedOneWithoutCreditCardSavedsInput;
  UserCreated: CommonUserCreateNestedOneWithoutCreditCardSavedsInput;
  brand: Scalars['String'];
  number: Scalars['String'];
  token: Scalars['String'];
};

export type FinancialCreditCardSavedCreateManyInput = {
  brand: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  number: Scalars['String'];
  token: Scalars['String'];
  userCreatedId: Scalars['Int'];
  walletId: Scalars['Int'];
};

export type FinancialCreditCardSavedCreateManyTeamWalletInput = {
  brand: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  number: Scalars['String'];
  token: Scalars['String'];
  userCreatedId: Scalars['Int'];
};

export type FinancialCreditCardSavedCreateManyTeamWalletInputEnvelope = {
  data: Array<FinancialCreditCardSavedCreateManyTeamWalletInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type FinancialCreditCardSavedCreateManyUserCreatedInput = {
  brand: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  number: Scalars['String'];
  token: Scalars['String'];
  walletId: Scalars['Int'];
};

export type FinancialCreditCardSavedCreateManyUserCreatedInputEnvelope = {
  data: Array<FinancialCreditCardSavedCreateManyUserCreatedInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type FinancialCreditCardSavedCreateNestedManyWithoutTeamWalletInput = {
  connect?: Maybe<Array<FinancialCreditCardSavedWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialCreditCardSavedCreateOrConnectWithoutTeamWalletInput>>;
  create?: Maybe<Array<FinancialCreditCardSavedCreateWithoutTeamWalletInput>>;
  createMany?: Maybe<FinancialCreditCardSavedCreateManyTeamWalletInputEnvelope>;
};

export type FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput = {
  connect?: Maybe<Array<FinancialCreditCardSavedWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialCreditCardSavedCreateOrConnectWithoutUserCreatedInput>>;
  create?: Maybe<Array<FinancialCreditCardSavedCreateWithoutUserCreatedInput>>;
  createMany?: Maybe<FinancialCreditCardSavedCreateManyUserCreatedInputEnvelope>;
};

export type FinancialCreditCardSavedCreateOrConnectWithoutTeamWalletInput = {
  create: FinancialCreditCardSavedCreateWithoutTeamWalletInput;
  where: FinancialCreditCardSavedWhereUniqueInput;
};

export type FinancialCreditCardSavedCreateOrConnectWithoutUserCreatedInput = {
  create: FinancialCreditCardSavedCreateWithoutUserCreatedInput;
  where: FinancialCreditCardSavedWhereUniqueInput;
};

export type FinancialCreditCardSavedCreateWithoutTeamWalletInput = {
  UserCreated: CommonUserCreateNestedOneWithoutCreditCardSavedsInput;
  brand: Scalars['String'];
  number: Scalars['String'];
  token: Scalars['String'];
};

export type FinancialCreditCardSavedCreateWithoutUserCreatedInput = {
  TeamWallet: FinancialTeamWalletCreateNestedOneWithoutCreditCardSavedsInput;
  brand: Scalars['String'];
  number: Scalars['String'];
  token: Scalars['String'];
};

export type FinancialCreditCardSavedListRelationFilter = {
  every?: Maybe<FinancialCreditCardSavedWhereInput>;
  none?: Maybe<FinancialCreditCardSavedWhereInput>;
  some?: Maybe<FinancialCreditCardSavedWhereInput>;
};

export type FinancialCreditCardSavedMaxOrderByAggregateInput = {
  brand?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  number?: Maybe<SortOrder>;
  token?: Maybe<SortOrder>;
  userCreatedId?: Maybe<SortOrder>;
  walletId?: Maybe<SortOrder>;
};

export type FinancialCreditCardSavedMinOrderByAggregateInput = {
  brand?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  number?: Maybe<SortOrder>;
  token?: Maybe<SortOrder>;
  userCreatedId?: Maybe<SortOrder>;
  walletId?: Maybe<SortOrder>;
};

export type FinancialCreditCardSavedOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type FinancialCreditCardSavedOrderByWithAggregationInput = {
  _avg?: Maybe<FinancialCreditCardSavedAvgOrderByAggregateInput>;
  _count?: Maybe<FinancialCreditCardSavedCountOrderByAggregateInput>;
  _max?: Maybe<FinancialCreditCardSavedMaxOrderByAggregateInput>;
  _min?: Maybe<FinancialCreditCardSavedMinOrderByAggregateInput>;
  _sum?: Maybe<FinancialCreditCardSavedSumOrderByAggregateInput>;
  brand?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  number?: Maybe<SortOrder>;
  token?: Maybe<SortOrder>;
  userCreatedId?: Maybe<SortOrder>;
  walletId?: Maybe<SortOrder>;
};

export type FinancialCreditCardSavedOrderByWithRelationInput = {
  TeamWallet?: Maybe<FinancialTeamWalletOrderByWithRelationInput>;
  UserCreated?: Maybe<CommonUserOrderByWithRelationInput>;
  brand?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  number?: Maybe<SortOrder>;
  token?: Maybe<SortOrder>;
  userCreatedId?: Maybe<SortOrder>;
  walletId?: Maybe<SortOrder>;
};

export enum FinancialCreditCardSavedScalarFieldEnum {
  Brand = 'brand',
  Id = 'id',
  Number = 'number',
  Token = 'token',
  UserCreatedId = 'userCreatedId',
  WalletId = 'walletId'
}

export type FinancialCreditCardSavedScalarWhereInput = {
  AND?: Maybe<Array<FinancialCreditCardSavedScalarWhereInput>>;
  NOT?: Maybe<Array<FinancialCreditCardSavedScalarWhereInput>>;
  OR?: Maybe<Array<FinancialCreditCardSavedScalarWhereInput>>;
  brand?: Maybe<StringFilter>;
  id?: Maybe<IntFilter>;
  number?: Maybe<StringFilter>;
  token?: Maybe<StringFilter>;
  userCreatedId?: Maybe<IntFilter>;
  walletId?: Maybe<IntFilter>;
};

export type FinancialCreditCardSavedScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<FinancialCreditCardSavedScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<FinancialCreditCardSavedScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<FinancialCreditCardSavedScalarWhereWithAggregatesInput>>;
  brand?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  number?: Maybe<StringWithAggregatesFilter>;
  token?: Maybe<StringWithAggregatesFilter>;
  userCreatedId?: Maybe<IntWithAggregatesFilter>;
  walletId?: Maybe<IntWithAggregatesFilter>;
};

export type FinancialCreditCardSavedSumOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  userCreatedId?: Maybe<SortOrder>;
  walletId?: Maybe<SortOrder>;
};

export type FinancialCreditCardSavedUpdateInput = {
  TeamWallet?: Maybe<FinancialTeamWalletUpdateOneRequiredWithoutCreditCardSavedsNestedInput>;
  UserCreated?: Maybe<CommonUserUpdateOneRequiredWithoutCreditCardSavedsNestedInput>;
  brand?: Maybe<StringFieldUpdateOperationsInput>;
  number?: Maybe<StringFieldUpdateOperationsInput>;
  token?: Maybe<StringFieldUpdateOperationsInput>;
};

export type FinancialCreditCardSavedUpdateManyMutationInput = {
  brand?: Maybe<StringFieldUpdateOperationsInput>;
  number?: Maybe<StringFieldUpdateOperationsInput>;
  token?: Maybe<StringFieldUpdateOperationsInput>;
};

export type FinancialCreditCardSavedUpdateManyWithWhereWithoutTeamWalletInput = {
  data: FinancialCreditCardSavedUpdateManyMutationInput;
  where: FinancialCreditCardSavedScalarWhereInput;
};

export type FinancialCreditCardSavedUpdateManyWithWhereWithoutUserCreatedInput = {
  data: FinancialCreditCardSavedUpdateManyMutationInput;
  where: FinancialCreditCardSavedScalarWhereInput;
};

export type FinancialCreditCardSavedUpdateManyWithoutTeamWalletNestedInput = {
  connect?: Maybe<Array<FinancialCreditCardSavedWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialCreditCardSavedCreateOrConnectWithoutTeamWalletInput>>;
  create?: Maybe<Array<FinancialCreditCardSavedCreateWithoutTeamWalletInput>>;
  createMany?: Maybe<FinancialCreditCardSavedCreateManyTeamWalletInputEnvelope>;
  delete?: Maybe<Array<FinancialCreditCardSavedWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FinancialCreditCardSavedScalarWhereInput>>;
  disconnect?: Maybe<Array<FinancialCreditCardSavedWhereUniqueInput>>;
  set?: Maybe<Array<FinancialCreditCardSavedWhereUniqueInput>>;
  update?: Maybe<Array<FinancialCreditCardSavedUpdateWithWhereUniqueWithoutTeamWalletInput>>;
  updateMany?: Maybe<Array<FinancialCreditCardSavedUpdateManyWithWhereWithoutTeamWalletInput>>;
  upsert?: Maybe<Array<FinancialCreditCardSavedUpsertWithWhereUniqueWithoutTeamWalletInput>>;
};

export type FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput = {
  connect?: Maybe<Array<FinancialCreditCardSavedWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialCreditCardSavedCreateOrConnectWithoutUserCreatedInput>>;
  create?: Maybe<Array<FinancialCreditCardSavedCreateWithoutUserCreatedInput>>;
  createMany?: Maybe<FinancialCreditCardSavedCreateManyUserCreatedInputEnvelope>;
  delete?: Maybe<Array<FinancialCreditCardSavedWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FinancialCreditCardSavedScalarWhereInput>>;
  disconnect?: Maybe<Array<FinancialCreditCardSavedWhereUniqueInput>>;
  set?: Maybe<Array<FinancialCreditCardSavedWhereUniqueInput>>;
  update?: Maybe<Array<FinancialCreditCardSavedUpdateWithWhereUniqueWithoutUserCreatedInput>>;
  updateMany?: Maybe<Array<FinancialCreditCardSavedUpdateManyWithWhereWithoutUserCreatedInput>>;
  upsert?: Maybe<Array<FinancialCreditCardSavedUpsertWithWhereUniqueWithoutUserCreatedInput>>;
};

export type FinancialCreditCardSavedUpdateWithWhereUniqueWithoutTeamWalletInput = {
  data: FinancialCreditCardSavedUpdateWithoutTeamWalletInput;
  where: FinancialCreditCardSavedWhereUniqueInput;
};

export type FinancialCreditCardSavedUpdateWithWhereUniqueWithoutUserCreatedInput = {
  data: FinancialCreditCardSavedUpdateWithoutUserCreatedInput;
  where: FinancialCreditCardSavedWhereUniqueInput;
};

export type FinancialCreditCardSavedUpdateWithoutTeamWalletInput = {
  UserCreated?: Maybe<CommonUserUpdateOneRequiredWithoutCreditCardSavedsNestedInput>;
  brand?: Maybe<StringFieldUpdateOperationsInput>;
  number?: Maybe<StringFieldUpdateOperationsInput>;
  token?: Maybe<StringFieldUpdateOperationsInput>;
};

export type FinancialCreditCardSavedUpdateWithoutUserCreatedInput = {
  TeamWallet?: Maybe<FinancialTeamWalletUpdateOneRequiredWithoutCreditCardSavedsNestedInput>;
  brand?: Maybe<StringFieldUpdateOperationsInput>;
  number?: Maybe<StringFieldUpdateOperationsInput>;
  token?: Maybe<StringFieldUpdateOperationsInput>;
};

export type FinancialCreditCardSavedUpsertWithWhereUniqueWithoutTeamWalletInput = {
  create: FinancialCreditCardSavedCreateWithoutTeamWalletInput;
  update: FinancialCreditCardSavedUpdateWithoutTeamWalletInput;
  where: FinancialCreditCardSavedWhereUniqueInput;
};

export type FinancialCreditCardSavedUpsertWithWhereUniqueWithoutUserCreatedInput = {
  create: FinancialCreditCardSavedCreateWithoutUserCreatedInput;
  update: FinancialCreditCardSavedUpdateWithoutUserCreatedInput;
  where: FinancialCreditCardSavedWhereUniqueInput;
};

export type FinancialCreditCardSavedWalletIdTokenCompoundUniqueInput = {
  token: Scalars['String'];
  walletId: Scalars['Int'];
};

export type FinancialCreditCardSavedWhereInput = {
  AND?: Maybe<Array<FinancialCreditCardSavedWhereInput>>;
  NOT?: Maybe<Array<FinancialCreditCardSavedWhereInput>>;
  OR?: Maybe<Array<FinancialCreditCardSavedWhereInput>>;
  TeamWallet?: Maybe<FinancialTeamWalletWhereInput>;
  UserCreated?: Maybe<CommonUserWhereInput>;
  brand?: Maybe<StringFilter>;
  id?: Maybe<IntFilter>;
  number?: Maybe<StringFilter>;
  token?: Maybe<StringFilter>;
  userCreatedId?: Maybe<IntFilter>;
  walletId?: Maybe<IntFilter>;
};

export type FinancialCreditCardSavedWhereUniqueInput = {
  AND?: Maybe<Array<FinancialCreditCardSavedWhereInput>>;
  NOT?: Maybe<Array<FinancialCreditCardSavedWhereInput>>;
  OR?: Maybe<Array<FinancialCreditCardSavedWhereInput>>;
  TeamWallet?: Maybe<FinancialTeamWalletWhereInput>;
  UserCreated?: Maybe<CommonUserWhereInput>;
  brand?: Maybe<StringFilter>;
  id?: Maybe<Scalars['Int']>;
  number?: Maybe<StringFilter>;
  token?: Maybe<StringFilter>;
  userCreatedId?: Maybe<IntFilter>;
  walletId?: Maybe<IntFilter>;
  walletId_token?: Maybe<FinancialCreditCardSavedWalletIdTokenCompoundUniqueInput>;
};

/** Fallback costs for each service */
export type FinancialGeneralCostConfig = {
  __typename?: 'FinancialGeneralCostConfig';
  cost: Scalars['Decimal'];
  id: Scalars['Int'];
  service: FinancialChargeableService;
};

export type FinancialGeneralCostConfigAvgOrderByAggregateInput = {
  cost?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type FinancialGeneralCostConfigCountOrderByAggregateInput = {
  cost?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  service?: Maybe<SortOrder>;
};

export type FinancialGeneralCostConfigCreateInput = {
  cost: Scalars['Decimal'];
  service: FinancialChargeableService;
};

export type FinancialGeneralCostConfigCreateManyInput = {
  cost: Scalars['Decimal'];
  id?: Maybe<Scalars['Int']>;
  service: FinancialChargeableService;
};

export type FinancialGeneralCostConfigMaxOrderByAggregateInput = {
  cost?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  service?: Maybe<SortOrder>;
};

export type FinancialGeneralCostConfigMinOrderByAggregateInput = {
  cost?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  service?: Maybe<SortOrder>;
};

export type FinancialGeneralCostConfigOrderByWithAggregationInput = {
  _avg?: Maybe<FinancialGeneralCostConfigAvgOrderByAggregateInput>;
  _count?: Maybe<FinancialGeneralCostConfigCountOrderByAggregateInput>;
  _max?: Maybe<FinancialGeneralCostConfigMaxOrderByAggregateInput>;
  _min?: Maybe<FinancialGeneralCostConfigMinOrderByAggregateInput>;
  _sum?: Maybe<FinancialGeneralCostConfigSumOrderByAggregateInput>;
  cost?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  service?: Maybe<SortOrder>;
};

export type FinancialGeneralCostConfigOrderByWithRelationInput = {
  cost?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  service?: Maybe<SortOrder>;
};

export enum FinancialGeneralCostConfigScalarFieldEnum {
  Cost = 'cost',
  Id = 'id',
  Service = 'service'
}

export type FinancialGeneralCostConfigScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<FinancialGeneralCostConfigScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<FinancialGeneralCostConfigScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<FinancialGeneralCostConfigScalarWhereWithAggregatesInput>>;
  cost?: Maybe<DecimalWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  service?: Maybe<EnumFinancialChargeableServiceWithAggregatesFilter>;
};

export type FinancialGeneralCostConfigSumOrderByAggregateInput = {
  cost?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type FinancialGeneralCostConfigUpdateInput = {
  cost?: Maybe<DecimalFieldUpdateOperationsInput>;
  service?: Maybe<EnumFinancialChargeableServiceFieldUpdateOperationsInput>;
};

export type FinancialGeneralCostConfigUpdateManyMutationInput = {
  cost?: Maybe<DecimalFieldUpdateOperationsInput>;
  service?: Maybe<EnumFinancialChargeableServiceFieldUpdateOperationsInput>;
};

export type FinancialGeneralCostConfigWhereInput = {
  AND?: Maybe<Array<FinancialGeneralCostConfigWhereInput>>;
  NOT?: Maybe<Array<FinancialGeneralCostConfigWhereInput>>;
  OR?: Maybe<Array<FinancialGeneralCostConfigWhereInput>>;
  cost?: Maybe<DecimalFilter>;
  id?: Maybe<IntFilter>;
  service?: Maybe<EnumFinancialChargeableServiceFilter>;
};

export type FinancialGeneralCostConfigWhereUniqueInput = {
  AND?: Maybe<Array<FinancialGeneralCostConfigWhereInput>>;
  NOT?: Maybe<Array<FinancialGeneralCostConfigWhereInput>>;
  OR?: Maybe<Array<FinancialGeneralCostConfigWhereInput>>;
  cost?: Maybe<DecimalFilter>;
  id?: Maybe<Scalars['Int']>;
  service?: Maybe<FinancialChargeableService>;
};

/**
 * Store all payments (Purchases) executed by team
 * If its a purchase of a plan + credits, link with recharge and SubscriptionPayment
 */
export type FinancialPayment = {
  __typename?: 'FinancialPayment';
  Recharge?: Maybe<FinancialRecharge>;
  SubscriptionPayment?: Maybe<FinancialTeamWalletSubscriptionPayment>;
  TeamWallet: FinancialTeamWallet;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  walletId: Scalars['Int'];
};

export type FinancialPaymentAvgOrderByAggregateInput = {
  walletId?: Maybe<SortOrder>;
};

export type FinancialPaymentCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  walletId?: Maybe<SortOrder>;
};

export type FinancialPaymentCreateInput = {
  Recharge?: Maybe<FinancialRechargeCreateNestedOneWithoutFinancialPaymentInput>;
  SubscriptionPayment?: Maybe<FinancialTeamWalletSubscriptionPaymentCreateNestedOneWithoutFinancialPaymentInput>;
  TeamWallet: FinancialTeamWalletCreateNestedOneWithoutPaymentsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
};

export type FinancialPaymentCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  walletId: Scalars['Int'];
};

export type FinancialPaymentCreateManyTeamWalletInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
};

export type FinancialPaymentCreateManyTeamWalletInputEnvelope = {
  data: Array<FinancialPaymentCreateManyTeamWalletInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type FinancialPaymentCreateNestedManyWithoutTeamWalletInput = {
  connect?: Maybe<Array<FinancialPaymentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialPaymentCreateOrConnectWithoutTeamWalletInput>>;
  create?: Maybe<Array<FinancialPaymentCreateWithoutTeamWalletInput>>;
  createMany?: Maybe<FinancialPaymentCreateManyTeamWalletInputEnvelope>;
};

export type FinancialPaymentCreateNestedOneWithoutRechargeInput = {
  connect?: Maybe<FinancialPaymentWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialPaymentCreateOrConnectWithoutRechargeInput>;
  create?: Maybe<FinancialPaymentCreateWithoutRechargeInput>;
};

export type FinancialPaymentCreateNestedOneWithoutSubscriptionPaymentInput = {
  connect?: Maybe<FinancialPaymentWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialPaymentCreateOrConnectWithoutSubscriptionPaymentInput>;
  create?: Maybe<FinancialPaymentCreateWithoutSubscriptionPaymentInput>;
};

export type FinancialPaymentCreateOrConnectWithoutRechargeInput = {
  create: FinancialPaymentCreateWithoutRechargeInput;
  where: FinancialPaymentWhereUniqueInput;
};

export type FinancialPaymentCreateOrConnectWithoutSubscriptionPaymentInput = {
  create: FinancialPaymentCreateWithoutSubscriptionPaymentInput;
  where: FinancialPaymentWhereUniqueInput;
};

export type FinancialPaymentCreateOrConnectWithoutTeamWalletInput = {
  create: FinancialPaymentCreateWithoutTeamWalletInput;
  where: FinancialPaymentWhereUniqueInput;
};

export type FinancialPaymentCreateWithoutRechargeInput = {
  SubscriptionPayment?: Maybe<FinancialTeamWalletSubscriptionPaymentCreateNestedOneWithoutFinancialPaymentInput>;
  TeamWallet: FinancialTeamWalletCreateNestedOneWithoutPaymentsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
};

export type FinancialPaymentCreateWithoutSubscriptionPaymentInput = {
  Recharge?: Maybe<FinancialRechargeCreateNestedOneWithoutFinancialPaymentInput>;
  TeamWallet: FinancialTeamWalletCreateNestedOneWithoutPaymentsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
};

export type FinancialPaymentCreateWithoutTeamWalletInput = {
  Recharge?: Maybe<FinancialRechargeCreateNestedOneWithoutFinancialPaymentInput>;
  SubscriptionPayment?: Maybe<FinancialTeamWalletSubscriptionPaymentCreateNestedOneWithoutFinancialPaymentInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
};

export type FinancialPaymentListRelationFilter = {
  every?: Maybe<FinancialPaymentWhereInput>;
  none?: Maybe<FinancialPaymentWhereInput>;
  some?: Maybe<FinancialPaymentWhereInput>;
};

export type FinancialPaymentMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  walletId?: Maybe<SortOrder>;
};

export type FinancialPaymentMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  walletId?: Maybe<SortOrder>;
};

export type FinancialPaymentOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type FinancialPaymentOrderByWithAggregationInput = {
  _avg?: Maybe<FinancialPaymentAvgOrderByAggregateInput>;
  _count?: Maybe<FinancialPaymentCountOrderByAggregateInput>;
  _max?: Maybe<FinancialPaymentMaxOrderByAggregateInput>;
  _min?: Maybe<FinancialPaymentMinOrderByAggregateInput>;
  _sum?: Maybe<FinancialPaymentSumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  walletId?: Maybe<SortOrder>;
};

export type FinancialPaymentOrderByWithRelationInput = {
  Recharge?: Maybe<FinancialRechargeOrderByWithRelationInput>;
  SubscriptionPayment?: Maybe<FinancialTeamWalletSubscriptionPaymentOrderByWithRelationInput>;
  TeamWallet?: Maybe<FinancialTeamWalletOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  walletId?: Maybe<SortOrder>;
};

export type FinancialPaymentRelationFilter = {
  is?: Maybe<FinancialPaymentWhereInput>;
  isNot?: Maybe<FinancialPaymentWhereInput>;
};

export enum FinancialPaymentScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  WalletId = 'walletId'
}

export type FinancialPaymentScalarWhereInput = {
  AND?: Maybe<Array<FinancialPaymentScalarWhereInput>>;
  NOT?: Maybe<Array<FinancialPaymentScalarWhereInput>>;
  OR?: Maybe<Array<FinancialPaymentScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  walletId?: Maybe<IntFilter>;
};

export type FinancialPaymentScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<FinancialPaymentScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<FinancialPaymentScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<FinancialPaymentScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  walletId?: Maybe<IntWithAggregatesFilter>;
};

export type FinancialPaymentSumOrderByAggregateInput = {
  walletId?: Maybe<SortOrder>;
};

export type FinancialPaymentUpdateInput = {
  Recharge?: Maybe<FinancialRechargeUpdateOneWithoutFinancialPaymentNestedInput>;
  SubscriptionPayment?: Maybe<FinancialTeamWalletSubscriptionPaymentUpdateOneWithoutFinancialPaymentNestedInput>;
  TeamWallet?: Maybe<FinancialTeamWalletUpdateOneRequiredWithoutPaymentsNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
};

export type FinancialPaymentUpdateManyMutationInput = {
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
};

export type FinancialPaymentUpdateManyWithWhereWithoutTeamWalletInput = {
  data: FinancialPaymentUpdateManyMutationInput;
  where: FinancialPaymentScalarWhereInput;
};

export type FinancialPaymentUpdateManyWithoutTeamWalletNestedInput = {
  connect?: Maybe<Array<FinancialPaymentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialPaymentCreateOrConnectWithoutTeamWalletInput>>;
  create?: Maybe<Array<FinancialPaymentCreateWithoutTeamWalletInput>>;
  createMany?: Maybe<FinancialPaymentCreateManyTeamWalletInputEnvelope>;
  delete?: Maybe<Array<FinancialPaymentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FinancialPaymentScalarWhereInput>>;
  disconnect?: Maybe<Array<FinancialPaymentWhereUniqueInput>>;
  set?: Maybe<Array<FinancialPaymentWhereUniqueInput>>;
  update?: Maybe<Array<FinancialPaymentUpdateWithWhereUniqueWithoutTeamWalletInput>>;
  updateMany?: Maybe<Array<FinancialPaymentUpdateManyWithWhereWithoutTeamWalletInput>>;
  upsert?: Maybe<Array<FinancialPaymentUpsertWithWhereUniqueWithoutTeamWalletInput>>;
};

export type FinancialPaymentUpdateOneRequiredWithoutRechargeNestedInput = {
  connect?: Maybe<FinancialPaymentWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialPaymentCreateOrConnectWithoutRechargeInput>;
  create?: Maybe<FinancialPaymentCreateWithoutRechargeInput>;
  update?: Maybe<FinancialPaymentUpdateToOneWithWhereWithoutRechargeInput>;
  upsert?: Maybe<FinancialPaymentUpsertWithoutRechargeInput>;
};

export type FinancialPaymentUpdateOneRequiredWithoutSubscriptionPaymentNestedInput = {
  connect?: Maybe<FinancialPaymentWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialPaymentCreateOrConnectWithoutSubscriptionPaymentInput>;
  create?: Maybe<FinancialPaymentCreateWithoutSubscriptionPaymentInput>;
  update?: Maybe<FinancialPaymentUpdateToOneWithWhereWithoutSubscriptionPaymentInput>;
  upsert?: Maybe<FinancialPaymentUpsertWithoutSubscriptionPaymentInput>;
};

export type FinancialPaymentUpdateToOneWithWhereWithoutRechargeInput = {
  data: FinancialPaymentUpdateWithoutRechargeInput;
  where?: Maybe<FinancialPaymentWhereInput>;
};

export type FinancialPaymentUpdateToOneWithWhereWithoutSubscriptionPaymentInput = {
  data: FinancialPaymentUpdateWithoutSubscriptionPaymentInput;
  where?: Maybe<FinancialPaymentWhereInput>;
};

export type FinancialPaymentUpdateWithWhereUniqueWithoutTeamWalletInput = {
  data: FinancialPaymentUpdateWithoutTeamWalletInput;
  where: FinancialPaymentWhereUniqueInput;
};

export type FinancialPaymentUpdateWithoutRechargeInput = {
  SubscriptionPayment?: Maybe<FinancialTeamWalletSubscriptionPaymentUpdateOneWithoutFinancialPaymentNestedInput>;
  TeamWallet?: Maybe<FinancialTeamWalletUpdateOneRequiredWithoutPaymentsNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
};

export type FinancialPaymentUpdateWithoutSubscriptionPaymentInput = {
  Recharge?: Maybe<FinancialRechargeUpdateOneWithoutFinancialPaymentNestedInput>;
  TeamWallet?: Maybe<FinancialTeamWalletUpdateOneRequiredWithoutPaymentsNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
};

export type FinancialPaymentUpdateWithoutTeamWalletInput = {
  Recharge?: Maybe<FinancialRechargeUpdateOneWithoutFinancialPaymentNestedInput>;
  SubscriptionPayment?: Maybe<FinancialTeamWalletSubscriptionPaymentUpdateOneWithoutFinancialPaymentNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
};

export type FinancialPaymentUpsertWithWhereUniqueWithoutTeamWalletInput = {
  create: FinancialPaymentCreateWithoutTeamWalletInput;
  update: FinancialPaymentUpdateWithoutTeamWalletInput;
  where: FinancialPaymentWhereUniqueInput;
};

export type FinancialPaymentUpsertWithoutRechargeInput = {
  create: FinancialPaymentCreateWithoutRechargeInput;
  update: FinancialPaymentUpdateWithoutRechargeInput;
  where?: Maybe<FinancialPaymentWhereInput>;
};

export type FinancialPaymentUpsertWithoutSubscriptionPaymentInput = {
  create: FinancialPaymentCreateWithoutSubscriptionPaymentInput;
  update: FinancialPaymentUpdateWithoutSubscriptionPaymentInput;
  where?: Maybe<FinancialPaymentWhereInput>;
};

export type FinancialPaymentWhereInput = {
  AND?: Maybe<Array<FinancialPaymentWhereInput>>;
  NOT?: Maybe<Array<FinancialPaymentWhereInput>>;
  OR?: Maybe<Array<FinancialPaymentWhereInput>>;
  Recharge?: Maybe<FinancialRechargeWhereInput>;
  SubscriptionPayment?: Maybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
  TeamWallet?: Maybe<FinancialTeamWalletWhereInput>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  walletId?: Maybe<IntFilter>;
};

export type FinancialPaymentWhereUniqueInput = {
  AND?: Maybe<Array<FinancialPaymentWhereInput>>;
  NOT?: Maybe<Array<FinancialPaymentWhereInput>>;
  OR?: Maybe<Array<FinancialPaymentWhereInput>>;
  Recharge?: Maybe<FinancialRechargeWhereInput>;
  SubscriptionPayment?: Maybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
  TeamWallet?: Maybe<FinancialTeamWalletWhereInput>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  walletId?: Maybe<IntFilter>;
};

export enum FinancialPlan {
  Business = 'BUSINESS',
  Detached = 'DETACHED',
  Enterprise = 'ENTERPRISE',
  Start = 'START',
  Trial = 'TRIAL'
}

export type FinancialRecharge = {
  __typename?: 'FinancialRecharge';
  FinancialPayment: FinancialPayment;
  UserExecuted: CommonUser;
  cost: Scalars['Decimal'];
  createdAt: Scalars['DateTime'];
  creditsCount: Scalars['Int'];
  creditsType: FinancialChargeableService;
  id: Scalars['Int'];
  paymentId: Scalars['String'];
  /** ![PrismaJson.AnyJson], thats for logging purposes */
  providerResponse?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userExecutedId: Scalars['Int'];
};

export type FinancialRechargeAvgOrderByAggregateInput = {
  cost?: Maybe<SortOrder>;
  creditsCount?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  userExecutedId?: Maybe<SortOrder>;
};

export type FinancialRechargeCountOrderByAggregateInput = {
  cost?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  creditsCount?: Maybe<SortOrder>;
  creditsType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  paymentId?: Maybe<SortOrder>;
  providerResponse?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userExecutedId?: Maybe<SortOrder>;
};

export type FinancialRechargeCreateInput = {
  FinancialPayment: FinancialPaymentCreateNestedOneWithoutRechargeInput;
  UserExecuted: CommonUserCreateNestedOneWithoutRechargesInput;
  cost?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creditsCount: Scalars['Int'];
  creditsType: FinancialChargeableService;
  providerResponse?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialRechargeCreateManyInput = {
  cost?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creditsCount: Scalars['Int'];
  creditsType: FinancialChargeableService;
  id?: Maybe<Scalars['Int']>;
  paymentId: Scalars['String'];
  providerResponse?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userExecutedId: Scalars['Int'];
};

export type FinancialRechargeCreateManyUserExecutedInput = {
  cost?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creditsCount: Scalars['Int'];
  creditsType: FinancialChargeableService;
  id?: Maybe<Scalars['Int']>;
  paymentId: Scalars['String'];
  providerResponse?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialRechargeCreateManyUserExecutedInputEnvelope = {
  data: Array<FinancialRechargeCreateManyUserExecutedInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type FinancialRechargeCreateNestedManyWithoutUserExecutedInput = {
  connect?: Maybe<Array<FinancialRechargeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialRechargeCreateOrConnectWithoutUserExecutedInput>>;
  create?: Maybe<Array<FinancialRechargeCreateWithoutUserExecutedInput>>;
  createMany?: Maybe<FinancialRechargeCreateManyUserExecutedInputEnvelope>;
};

export type FinancialRechargeCreateNestedOneWithoutFinancialPaymentInput = {
  connect?: Maybe<FinancialRechargeWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialRechargeCreateOrConnectWithoutFinancialPaymentInput>;
  create?: Maybe<FinancialRechargeCreateWithoutFinancialPaymentInput>;
};

export type FinancialRechargeCreateOrConnectWithoutFinancialPaymentInput = {
  create: FinancialRechargeCreateWithoutFinancialPaymentInput;
  where: FinancialRechargeWhereUniqueInput;
};

export type FinancialRechargeCreateOrConnectWithoutUserExecutedInput = {
  create: FinancialRechargeCreateWithoutUserExecutedInput;
  where: FinancialRechargeWhereUniqueInput;
};

export type FinancialRechargeCreateWithoutFinancialPaymentInput = {
  UserExecuted: CommonUserCreateNestedOneWithoutRechargesInput;
  cost?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creditsCount: Scalars['Int'];
  creditsType: FinancialChargeableService;
  providerResponse?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialRechargeCreateWithoutUserExecutedInput = {
  FinancialPayment: FinancialPaymentCreateNestedOneWithoutRechargeInput;
  cost?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creditsCount: Scalars['Int'];
  creditsType: FinancialChargeableService;
  providerResponse?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialRechargeListRelationFilter = {
  every?: Maybe<FinancialRechargeWhereInput>;
  none?: Maybe<FinancialRechargeWhereInput>;
  some?: Maybe<FinancialRechargeWhereInput>;
};

export type FinancialRechargeMaxOrderByAggregateInput = {
  cost?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  creditsCount?: Maybe<SortOrder>;
  creditsType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  paymentId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userExecutedId?: Maybe<SortOrder>;
};

export type FinancialRechargeMinOrderByAggregateInput = {
  cost?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  creditsCount?: Maybe<SortOrder>;
  creditsType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  paymentId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userExecutedId?: Maybe<SortOrder>;
};

export type FinancialRechargeNullableRelationFilter = {
  is?: Maybe<FinancialRechargeWhereInput>;
  isNot?: Maybe<FinancialRechargeWhereInput>;
};

export type FinancialRechargeOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type FinancialRechargeOrderByWithAggregationInput = {
  _avg?: Maybe<FinancialRechargeAvgOrderByAggregateInput>;
  _count?: Maybe<FinancialRechargeCountOrderByAggregateInput>;
  _max?: Maybe<FinancialRechargeMaxOrderByAggregateInput>;
  _min?: Maybe<FinancialRechargeMinOrderByAggregateInput>;
  _sum?: Maybe<FinancialRechargeSumOrderByAggregateInput>;
  cost?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  creditsCount?: Maybe<SortOrder>;
  creditsType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  paymentId?: Maybe<SortOrder>;
  providerResponse?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userExecutedId?: Maybe<SortOrder>;
};

export type FinancialRechargeOrderByWithRelationInput = {
  FinancialPayment?: Maybe<FinancialPaymentOrderByWithRelationInput>;
  UserExecuted?: Maybe<CommonUserOrderByWithRelationInput>;
  cost?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  creditsCount?: Maybe<SortOrder>;
  creditsType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  paymentId?: Maybe<SortOrder>;
  providerResponse?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  userExecutedId?: Maybe<SortOrder>;
};

export enum FinancialRechargeScalarFieldEnum {
  Cost = 'cost',
  CreatedAt = 'createdAt',
  CreditsCount = 'creditsCount',
  CreditsType = 'creditsType',
  Id = 'id',
  PaymentId = 'paymentId',
  ProviderResponse = 'providerResponse',
  UpdatedAt = 'updatedAt',
  UserExecutedId = 'userExecutedId'
}

export type FinancialRechargeScalarWhereInput = {
  AND?: Maybe<Array<FinancialRechargeScalarWhereInput>>;
  NOT?: Maybe<Array<FinancialRechargeScalarWhereInput>>;
  OR?: Maybe<Array<FinancialRechargeScalarWhereInput>>;
  cost?: Maybe<DecimalFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  creditsCount?: Maybe<IntFilter>;
  creditsType?: Maybe<EnumFinancialChargeableServiceFilter>;
  id?: Maybe<IntFilter>;
  paymentId?: Maybe<StringFilter>;
  providerResponse?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
  userExecutedId?: Maybe<IntFilter>;
};

export type FinancialRechargeScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<FinancialRechargeScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<FinancialRechargeScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<FinancialRechargeScalarWhereWithAggregatesInput>>;
  cost?: Maybe<DecimalWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  creditsCount?: Maybe<IntWithAggregatesFilter>;
  creditsType?: Maybe<EnumFinancialChargeableServiceWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  paymentId?: Maybe<StringWithAggregatesFilter>;
  providerResponse?: Maybe<JsonNullableWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  userExecutedId?: Maybe<IntWithAggregatesFilter>;
};

export type FinancialRechargeSumOrderByAggregateInput = {
  cost?: Maybe<SortOrder>;
  creditsCount?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  userExecutedId?: Maybe<SortOrder>;
};

export type FinancialRechargeUpdateInput = {
  FinancialPayment?: Maybe<FinancialPaymentUpdateOneRequiredWithoutRechargeNestedInput>;
  UserExecuted?: Maybe<CommonUserUpdateOneRequiredWithoutRechargesNestedInput>;
  cost?: Maybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  creditsCount?: Maybe<IntFieldUpdateOperationsInput>;
  creditsType?: Maybe<EnumFinancialChargeableServiceFieldUpdateOperationsInput>;
  providerResponse?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type FinancialRechargeUpdateManyMutationInput = {
  cost?: Maybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  creditsCount?: Maybe<IntFieldUpdateOperationsInput>;
  creditsType?: Maybe<EnumFinancialChargeableServiceFieldUpdateOperationsInput>;
  providerResponse?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type FinancialRechargeUpdateManyWithWhereWithoutUserExecutedInput = {
  data: FinancialRechargeUpdateManyMutationInput;
  where: FinancialRechargeScalarWhereInput;
};

export type FinancialRechargeUpdateManyWithoutUserExecutedNestedInput = {
  connect?: Maybe<Array<FinancialRechargeWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialRechargeCreateOrConnectWithoutUserExecutedInput>>;
  create?: Maybe<Array<FinancialRechargeCreateWithoutUserExecutedInput>>;
  createMany?: Maybe<FinancialRechargeCreateManyUserExecutedInputEnvelope>;
  delete?: Maybe<Array<FinancialRechargeWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FinancialRechargeScalarWhereInput>>;
  disconnect?: Maybe<Array<FinancialRechargeWhereUniqueInput>>;
  set?: Maybe<Array<FinancialRechargeWhereUniqueInput>>;
  update?: Maybe<Array<FinancialRechargeUpdateWithWhereUniqueWithoutUserExecutedInput>>;
  updateMany?: Maybe<Array<FinancialRechargeUpdateManyWithWhereWithoutUserExecutedInput>>;
  upsert?: Maybe<Array<FinancialRechargeUpsertWithWhereUniqueWithoutUserExecutedInput>>;
};

export type FinancialRechargeUpdateOneWithoutFinancialPaymentNestedInput = {
  connect?: Maybe<FinancialRechargeWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialRechargeCreateOrConnectWithoutFinancialPaymentInput>;
  create?: Maybe<FinancialRechargeCreateWithoutFinancialPaymentInput>;
  delete?: Maybe<FinancialRechargeWhereInput>;
  disconnect?: Maybe<FinancialRechargeWhereInput>;
  update?: Maybe<FinancialRechargeUpdateToOneWithWhereWithoutFinancialPaymentInput>;
  upsert?: Maybe<FinancialRechargeUpsertWithoutFinancialPaymentInput>;
};

export type FinancialRechargeUpdateToOneWithWhereWithoutFinancialPaymentInput = {
  data: FinancialRechargeUpdateWithoutFinancialPaymentInput;
  where?: Maybe<FinancialRechargeWhereInput>;
};

export type FinancialRechargeUpdateWithWhereUniqueWithoutUserExecutedInput = {
  data: FinancialRechargeUpdateWithoutUserExecutedInput;
  where: FinancialRechargeWhereUniqueInput;
};

export type FinancialRechargeUpdateWithoutFinancialPaymentInput = {
  UserExecuted?: Maybe<CommonUserUpdateOneRequiredWithoutRechargesNestedInput>;
  cost?: Maybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  creditsCount?: Maybe<IntFieldUpdateOperationsInput>;
  creditsType?: Maybe<EnumFinancialChargeableServiceFieldUpdateOperationsInput>;
  providerResponse?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type FinancialRechargeUpdateWithoutUserExecutedInput = {
  FinancialPayment?: Maybe<FinancialPaymentUpdateOneRequiredWithoutRechargeNestedInput>;
  cost?: Maybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  creditsCount?: Maybe<IntFieldUpdateOperationsInput>;
  creditsType?: Maybe<EnumFinancialChargeableServiceFieldUpdateOperationsInput>;
  providerResponse?: Maybe<Scalars['Json']>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type FinancialRechargeUpsertWithWhereUniqueWithoutUserExecutedInput = {
  create: FinancialRechargeCreateWithoutUserExecutedInput;
  update: FinancialRechargeUpdateWithoutUserExecutedInput;
  where: FinancialRechargeWhereUniqueInput;
};

export type FinancialRechargeUpsertWithoutFinancialPaymentInput = {
  create: FinancialRechargeCreateWithoutFinancialPaymentInput;
  update: FinancialRechargeUpdateWithoutFinancialPaymentInput;
  where?: Maybe<FinancialRechargeWhereInput>;
};

export type FinancialRechargeWhereInput = {
  AND?: Maybe<Array<FinancialRechargeWhereInput>>;
  FinancialPayment?: Maybe<FinancialPaymentWhereInput>;
  NOT?: Maybe<Array<FinancialRechargeWhereInput>>;
  OR?: Maybe<Array<FinancialRechargeWhereInput>>;
  UserExecuted?: Maybe<CommonUserWhereInput>;
  cost?: Maybe<DecimalFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  creditsCount?: Maybe<IntFilter>;
  creditsType?: Maybe<EnumFinancialChargeableServiceFilter>;
  id?: Maybe<IntFilter>;
  paymentId?: Maybe<StringFilter>;
  providerResponse?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
  userExecutedId?: Maybe<IntFilter>;
};

export type FinancialRechargeWhereUniqueInput = {
  AND?: Maybe<Array<FinancialRechargeWhereInput>>;
  FinancialPayment?: Maybe<FinancialPaymentWhereInput>;
  NOT?: Maybe<Array<FinancialRechargeWhereInput>>;
  OR?: Maybe<Array<FinancialRechargeWhereInput>>;
  UserExecuted?: Maybe<CommonUserWhereInput>;
  cost?: Maybe<DecimalFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  creditsCount?: Maybe<IntFilter>;
  creditsType?: Maybe<EnumFinancialChargeableServiceFilter>;
  id?: Maybe<Scalars['Int']>;
  paymentId?: Maybe<Scalars['String']>;
  providerResponse?: Maybe<JsonNullableFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
  userExecutedId?: Maybe<IntFilter>;
};

export type FinancialTeamCostConfig = {
  __typename?: 'FinancialTeamCostConfig';
  TeamWallet: FinancialTeamWallet;
  cost: Scalars['Decimal'];
  id: Scalars['Int'];
  service: FinancialChargeableService;
  teamId: Scalars['Int'];
};

export type FinancialTeamCostConfigAvgOrderByAggregateInput = {
  cost?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type FinancialTeamCostConfigCountOrderByAggregateInput = {
  cost?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  service?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type FinancialTeamCostConfigCreateInput = {
  TeamWallet: FinancialTeamWalletCreateNestedOneWithoutTeamCostConfigsInput;
  cost: Scalars['Decimal'];
  service: FinancialChargeableService;
};

export type FinancialTeamCostConfigCreateManyInput = {
  cost: Scalars['Decimal'];
  id?: Maybe<Scalars['Int']>;
  service: FinancialChargeableService;
  teamId: Scalars['Int'];
};

export type FinancialTeamCostConfigCreateManyTeamWalletInput = {
  cost: Scalars['Decimal'];
  id?: Maybe<Scalars['Int']>;
  service: FinancialChargeableService;
};

export type FinancialTeamCostConfigCreateManyTeamWalletInputEnvelope = {
  data: Array<FinancialTeamCostConfigCreateManyTeamWalletInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type FinancialTeamCostConfigCreateNestedManyWithoutTeamWalletInput = {
  connect?: Maybe<Array<FinancialTeamCostConfigWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialTeamCostConfigCreateOrConnectWithoutTeamWalletInput>>;
  create?: Maybe<Array<FinancialTeamCostConfigCreateWithoutTeamWalletInput>>;
  createMany?: Maybe<FinancialTeamCostConfigCreateManyTeamWalletInputEnvelope>;
};

export type FinancialTeamCostConfigCreateOrConnectWithoutTeamWalletInput = {
  create: FinancialTeamCostConfigCreateWithoutTeamWalletInput;
  where: FinancialTeamCostConfigWhereUniqueInput;
};

export type FinancialTeamCostConfigCreateWithoutTeamWalletInput = {
  cost: Scalars['Decimal'];
  service: FinancialChargeableService;
};

export type FinancialTeamCostConfigListRelationFilter = {
  every?: Maybe<FinancialTeamCostConfigWhereInput>;
  none?: Maybe<FinancialTeamCostConfigWhereInput>;
  some?: Maybe<FinancialTeamCostConfigWhereInput>;
};

export type FinancialTeamCostConfigMaxOrderByAggregateInput = {
  cost?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  service?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type FinancialTeamCostConfigMinOrderByAggregateInput = {
  cost?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  service?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type FinancialTeamCostConfigOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type FinancialTeamCostConfigOrderByWithAggregationInput = {
  _avg?: Maybe<FinancialTeamCostConfigAvgOrderByAggregateInput>;
  _count?: Maybe<FinancialTeamCostConfigCountOrderByAggregateInput>;
  _max?: Maybe<FinancialTeamCostConfigMaxOrderByAggregateInput>;
  _min?: Maybe<FinancialTeamCostConfigMinOrderByAggregateInput>;
  _sum?: Maybe<FinancialTeamCostConfigSumOrderByAggregateInput>;
  cost?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  service?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type FinancialTeamCostConfigOrderByWithRelationInput = {
  TeamWallet?: Maybe<FinancialTeamWalletOrderByWithRelationInput>;
  cost?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  service?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export enum FinancialTeamCostConfigScalarFieldEnum {
  Cost = 'cost',
  Id = 'id',
  Service = 'service',
  TeamId = 'teamId'
}

export type FinancialTeamCostConfigScalarWhereInput = {
  AND?: Maybe<Array<FinancialTeamCostConfigScalarWhereInput>>;
  NOT?: Maybe<Array<FinancialTeamCostConfigScalarWhereInput>>;
  OR?: Maybe<Array<FinancialTeamCostConfigScalarWhereInput>>;
  cost?: Maybe<DecimalFilter>;
  id?: Maybe<IntFilter>;
  service?: Maybe<EnumFinancialChargeableServiceFilter>;
  teamId?: Maybe<IntFilter>;
};

export type FinancialTeamCostConfigScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<FinancialTeamCostConfigScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<FinancialTeamCostConfigScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<FinancialTeamCostConfigScalarWhereWithAggregatesInput>>;
  cost?: Maybe<DecimalWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  service?: Maybe<EnumFinancialChargeableServiceWithAggregatesFilter>;
  teamId?: Maybe<IntWithAggregatesFilter>;
};

export type FinancialTeamCostConfigSumOrderByAggregateInput = {
  cost?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type FinancialTeamCostConfigTeamIdServiceCompoundUniqueInput = {
  service: FinancialChargeableService;
  teamId: Scalars['Int'];
};

export type FinancialTeamCostConfigUpdateInput = {
  TeamWallet?: Maybe<FinancialTeamWalletUpdateOneRequiredWithoutTeamCostConfigsNestedInput>;
  cost?: Maybe<DecimalFieldUpdateOperationsInput>;
  service?: Maybe<EnumFinancialChargeableServiceFieldUpdateOperationsInput>;
};

export type FinancialTeamCostConfigUpdateManyMutationInput = {
  cost?: Maybe<DecimalFieldUpdateOperationsInput>;
  service?: Maybe<EnumFinancialChargeableServiceFieldUpdateOperationsInput>;
};

export type FinancialTeamCostConfigUpdateManyWithWhereWithoutTeamWalletInput = {
  data: FinancialTeamCostConfigUpdateManyMutationInput;
  where: FinancialTeamCostConfigScalarWhereInput;
};

export type FinancialTeamCostConfigUpdateManyWithoutTeamWalletNestedInput = {
  connect?: Maybe<Array<FinancialTeamCostConfigWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialTeamCostConfigCreateOrConnectWithoutTeamWalletInput>>;
  create?: Maybe<Array<FinancialTeamCostConfigCreateWithoutTeamWalletInput>>;
  createMany?: Maybe<FinancialTeamCostConfigCreateManyTeamWalletInputEnvelope>;
  delete?: Maybe<Array<FinancialTeamCostConfigWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FinancialTeamCostConfigScalarWhereInput>>;
  disconnect?: Maybe<Array<FinancialTeamCostConfigWhereUniqueInput>>;
  set?: Maybe<Array<FinancialTeamCostConfigWhereUniqueInput>>;
  update?: Maybe<Array<FinancialTeamCostConfigUpdateWithWhereUniqueWithoutTeamWalletInput>>;
  updateMany?: Maybe<Array<FinancialTeamCostConfigUpdateManyWithWhereWithoutTeamWalletInput>>;
  upsert?: Maybe<Array<FinancialTeamCostConfigUpsertWithWhereUniqueWithoutTeamWalletInput>>;
};

export type FinancialTeamCostConfigUpdateWithWhereUniqueWithoutTeamWalletInput = {
  data: FinancialTeamCostConfigUpdateWithoutTeamWalletInput;
  where: FinancialTeamCostConfigWhereUniqueInput;
};

export type FinancialTeamCostConfigUpdateWithoutTeamWalletInput = {
  cost?: Maybe<DecimalFieldUpdateOperationsInput>;
  service?: Maybe<EnumFinancialChargeableServiceFieldUpdateOperationsInput>;
};

export type FinancialTeamCostConfigUpsertWithWhereUniqueWithoutTeamWalletInput = {
  create: FinancialTeamCostConfigCreateWithoutTeamWalletInput;
  update: FinancialTeamCostConfigUpdateWithoutTeamWalletInput;
  where: FinancialTeamCostConfigWhereUniqueInput;
};

export type FinancialTeamCostConfigWhereInput = {
  AND?: Maybe<Array<FinancialTeamCostConfigWhereInput>>;
  NOT?: Maybe<Array<FinancialTeamCostConfigWhereInput>>;
  OR?: Maybe<Array<FinancialTeamCostConfigWhereInput>>;
  TeamWallet?: Maybe<FinancialTeamWalletWhereInput>;
  cost?: Maybe<DecimalFilter>;
  id?: Maybe<IntFilter>;
  service?: Maybe<EnumFinancialChargeableServiceFilter>;
  teamId?: Maybe<IntFilter>;
};

export type FinancialTeamCostConfigWhereUniqueInput = {
  AND?: Maybe<Array<FinancialTeamCostConfigWhereInput>>;
  NOT?: Maybe<Array<FinancialTeamCostConfigWhereInput>>;
  OR?: Maybe<Array<FinancialTeamCostConfigWhereInput>>;
  TeamWallet?: Maybe<FinancialTeamWalletWhereInput>;
  cost?: Maybe<DecimalFilter>;
  id?: Maybe<Scalars['Int']>;
  service?: Maybe<EnumFinancialChargeableServiceFilter>;
  teamId?: Maybe<IntFilter>;
  teamId_service?: Maybe<FinancialTeamCostConfigTeamIdServiceCompoundUniqueInput>;
};

/**
 * Must be deleted after payment.
 * It will help to pay after
 */
export type FinancialTeamSignupSelectedOptions = {
  __typename?: 'FinancialTeamSignupSelectedOptions';
  TeamWallet: FinancialTeamWallet;
  billingCycle: FinancialBillingCycle;
  financialTotal: Scalars['Int'];
  plan: FinancialPlan;
  quantity: Scalars['Int'];
  typeSign: FinancialChargeableService;
  walletId: Scalars['Int'];
};

export type FinancialTeamSignupSelectedOptionsAvgOrderByAggregateInput = {
  financialTotal?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  walletId?: Maybe<SortOrder>;
};

export type FinancialTeamSignupSelectedOptionsCountOrderByAggregateInput = {
  billingCycle?: Maybe<SortOrder>;
  financialTotal?: Maybe<SortOrder>;
  plan?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  typeSign?: Maybe<SortOrder>;
  walletId?: Maybe<SortOrder>;
};

export type FinancialTeamSignupSelectedOptionsCreateInput = {
  TeamWallet: FinancialTeamWalletCreateNestedOneWithoutTeamSignupSelectedOptionsInput;
  billingCycle: FinancialBillingCycle;
  financialTotal: Scalars['Int'];
  plan: FinancialPlan;
  quantity: Scalars['Int'];
  typeSign: FinancialChargeableService;
};

export type FinancialTeamSignupSelectedOptionsCreateManyInput = {
  billingCycle: FinancialBillingCycle;
  financialTotal: Scalars['Int'];
  plan: FinancialPlan;
  quantity: Scalars['Int'];
  typeSign: FinancialChargeableService;
  walletId: Scalars['Int'];
};

export type FinancialTeamSignupSelectedOptionsCreateManyTeamWalletInput = {
  billingCycle: FinancialBillingCycle;
  financialTotal: Scalars['Int'];
  plan: FinancialPlan;
  quantity: Scalars['Int'];
  typeSign: FinancialChargeableService;
};

export type FinancialTeamSignupSelectedOptionsCreateManyTeamWalletInputEnvelope = {
  data: Array<FinancialTeamSignupSelectedOptionsCreateManyTeamWalletInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type FinancialTeamSignupSelectedOptionsCreateNestedManyWithoutTeamWalletInput = {
  connect?: Maybe<Array<FinancialTeamSignupSelectedOptionsWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialTeamSignupSelectedOptionsCreateOrConnectWithoutTeamWalletInput>>;
  create?: Maybe<Array<FinancialTeamSignupSelectedOptionsCreateWithoutTeamWalletInput>>;
  createMany?: Maybe<FinancialTeamSignupSelectedOptionsCreateManyTeamWalletInputEnvelope>;
};

export type FinancialTeamSignupSelectedOptionsCreateOrConnectWithoutTeamWalletInput = {
  create: FinancialTeamSignupSelectedOptionsCreateWithoutTeamWalletInput;
  where: FinancialTeamSignupSelectedOptionsWhereUniqueInput;
};

export type FinancialTeamSignupSelectedOptionsCreateWithoutTeamWalletInput = {
  billingCycle: FinancialBillingCycle;
  financialTotal: Scalars['Int'];
  plan: FinancialPlan;
  quantity: Scalars['Int'];
  typeSign: FinancialChargeableService;
};

export type FinancialTeamSignupSelectedOptionsListRelationFilter = {
  every?: Maybe<FinancialTeamSignupSelectedOptionsWhereInput>;
  none?: Maybe<FinancialTeamSignupSelectedOptionsWhereInput>;
  some?: Maybe<FinancialTeamSignupSelectedOptionsWhereInput>;
};

export type FinancialTeamSignupSelectedOptionsMaxOrderByAggregateInput = {
  billingCycle?: Maybe<SortOrder>;
  financialTotal?: Maybe<SortOrder>;
  plan?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  typeSign?: Maybe<SortOrder>;
  walletId?: Maybe<SortOrder>;
};

export type FinancialTeamSignupSelectedOptionsMinOrderByAggregateInput = {
  billingCycle?: Maybe<SortOrder>;
  financialTotal?: Maybe<SortOrder>;
  plan?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  typeSign?: Maybe<SortOrder>;
  walletId?: Maybe<SortOrder>;
};

export type FinancialTeamSignupSelectedOptionsOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type FinancialTeamSignupSelectedOptionsOrderByWithAggregationInput = {
  _avg?: Maybe<FinancialTeamSignupSelectedOptionsAvgOrderByAggregateInput>;
  _count?: Maybe<FinancialTeamSignupSelectedOptionsCountOrderByAggregateInput>;
  _max?: Maybe<FinancialTeamSignupSelectedOptionsMaxOrderByAggregateInput>;
  _min?: Maybe<FinancialTeamSignupSelectedOptionsMinOrderByAggregateInput>;
  _sum?: Maybe<FinancialTeamSignupSelectedOptionsSumOrderByAggregateInput>;
  billingCycle?: Maybe<SortOrder>;
  financialTotal?: Maybe<SortOrder>;
  plan?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  typeSign?: Maybe<SortOrder>;
  walletId?: Maybe<SortOrder>;
};

export type FinancialTeamSignupSelectedOptionsOrderByWithRelationInput = {
  TeamWallet?: Maybe<FinancialTeamWalletOrderByWithRelationInput>;
  billingCycle?: Maybe<SortOrder>;
  financialTotal?: Maybe<SortOrder>;
  plan?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  typeSign?: Maybe<SortOrder>;
  walletId?: Maybe<SortOrder>;
};

export enum FinancialTeamSignupSelectedOptionsScalarFieldEnum {
  BillingCycle = 'billingCycle',
  FinancialTotal = 'financialTotal',
  Plan = 'plan',
  Quantity = 'quantity',
  TypeSign = 'typeSign',
  WalletId = 'walletId'
}

export type FinancialTeamSignupSelectedOptionsScalarWhereInput = {
  AND?: Maybe<Array<FinancialTeamSignupSelectedOptionsScalarWhereInput>>;
  NOT?: Maybe<Array<FinancialTeamSignupSelectedOptionsScalarWhereInput>>;
  OR?: Maybe<Array<FinancialTeamSignupSelectedOptionsScalarWhereInput>>;
  billingCycle?: Maybe<EnumFinancialBillingCycleFilter>;
  financialTotal?: Maybe<IntFilter>;
  plan?: Maybe<EnumFinancialPlanFilter>;
  quantity?: Maybe<IntFilter>;
  typeSign?: Maybe<EnumFinancialChargeableServiceFilter>;
  walletId?: Maybe<IntFilter>;
};

export type FinancialTeamSignupSelectedOptionsScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<FinancialTeamSignupSelectedOptionsScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<FinancialTeamSignupSelectedOptionsScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<FinancialTeamSignupSelectedOptionsScalarWhereWithAggregatesInput>>;
  billingCycle?: Maybe<EnumFinancialBillingCycleWithAggregatesFilter>;
  financialTotal?: Maybe<IntWithAggregatesFilter>;
  plan?: Maybe<EnumFinancialPlanWithAggregatesFilter>;
  quantity?: Maybe<IntWithAggregatesFilter>;
  typeSign?: Maybe<EnumFinancialChargeableServiceWithAggregatesFilter>;
  walletId?: Maybe<IntWithAggregatesFilter>;
};

export type FinancialTeamSignupSelectedOptionsSumOrderByAggregateInput = {
  financialTotal?: Maybe<SortOrder>;
  quantity?: Maybe<SortOrder>;
  walletId?: Maybe<SortOrder>;
};

export type FinancialTeamSignupSelectedOptionsUpdateInput = {
  TeamWallet?: Maybe<FinancialTeamWalletUpdateOneRequiredWithoutTeamSignupSelectedOptionsNestedInput>;
  billingCycle?: Maybe<EnumFinancialBillingCycleFieldUpdateOperationsInput>;
  financialTotal?: Maybe<IntFieldUpdateOperationsInput>;
  plan?: Maybe<EnumFinancialPlanFieldUpdateOperationsInput>;
  quantity?: Maybe<IntFieldUpdateOperationsInput>;
  typeSign?: Maybe<EnumFinancialChargeableServiceFieldUpdateOperationsInput>;
};

export type FinancialTeamSignupSelectedOptionsUpdateManyMutationInput = {
  billingCycle?: Maybe<EnumFinancialBillingCycleFieldUpdateOperationsInput>;
  financialTotal?: Maybe<IntFieldUpdateOperationsInput>;
  plan?: Maybe<EnumFinancialPlanFieldUpdateOperationsInput>;
  quantity?: Maybe<IntFieldUpdateOperationsInput>;
  typeSign?: Maybe<EnumFinancialChargeableServiceFieldUpdateOperationsInput>;
};

export type FinancialTeamSignupSelectedOptionsUpdateManyWithWhereWithoutTeamWalletInput = {
  data: FinancialTeamSignupSelectedOptionsUpdateManyMutationInput;
  where: FinancialTeamSignupSelectedOptionsScalarWhereInput;
};

export type FinancialTeamSignupSelectedOptionsUpdateManyWithoutTeamWalletNestedInput = {
  connect?: Maybe<Array<FinancialTeamSignupSelectedOptionsWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialTeamSignupSelectedOptionsCreateOrConnectWithoutTeamWalletInput>>;
  create?: Maybe<Array<FinancialTeamSignupSelectedOptionsCreateWithoutTeamWalletInput>>;
  createMany?: Maybe<FinancialTeamSignupSelectedOptionsCreateManyTeamWalletInputEnvelope>;
  delete?: Maybe<Array<FinancialTeamSignupSelectedOptionsWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FinancialTeamSignupSelectedOptionsScalarWhereInput>>;
  disconnect?: Maybe<Array<FinancialTeamSignupSelectedOptionsWhereUniqueInput>>;
  set?: Maybe<Array<FinancialTeamSignupSelectedOptionsWhereUniqueInput>>;
  update?: Maybe<Array<FinancialTeamSignupSelectedOptionsUpdateWithWhereUniqueWithoutTeamWalletInput>>;
  updateMany?: Maybe<Array<FinancialTeamSignupSelectedOptionsUpdateManyWithWhereWithoutTeamWalletInput>>;
  upsert?: Maybe<Array<FinancialTeamSignupSelectedOptionsUpsertWithWhereUniqueWithoutTeamWalletInput>>;
};

export type FinancialTeamSignupSelectedOptionsUpdateWithWhereUniqueWithoutTeamWalletInput = {
  data: FinancialTeamSignupSelectedOptionsUpdateWithoutTeamWalletInput;
  where: FinancialTeamSignupSelectedOptionsWhereUniqueInput;
};

export type FinancialTeamSignupSelectedOptionsUpdateWithoutTeamWalletInput = {
  billingCycle?: Maybe<EnumFinancialBillingCycleFieldUpdateOperationsInput>;
  financialTotal?: Maybe<IntFieldUpdateOperationsInput>;
  plan?: Maybe<EnumFinancialPlanFieldUpdateOperationsInput>;
  quantity?: Maybe<IntFieldUpdateOperationsInput>;
  typeSign?: Maybe<EnumFinancialChargeableServiceFieldUpdateOperationsInput>;
};

export type FinancialTeamSignupSelectedOptionsUpsertWithWhereUniqueWithoutTeamWalletInput = {
  create: FinancialTeamSignupSelectedOptionsCreateWithoutTeamWalletInput;
  update: FinancialTeamSignupSelectedOptionsUpdateWithoutTeamWalletInput;
  where: FinancialTeamSignupSelectedOptionsWhereUniqueInput;
};

export type FinancialTeamSignupSelectedOptionsWhereInput = {
  AND?: Maybe<Array<FinancialTeamSignupSelectedOptionsWhereInput>>;
  NOT?: Maybe<Array<FinancialTeamSignupSelectedOptionsWhereInput>>;
  OR?: Maybe<Array<FinancialTeamSignupSelectedOptionsWhereInput>>;
  TeamWallet?: Maybe<FinancialTeamWalletWhereInput>;
  billingCycle?: Maybe<EnumFinancialBillingCycleFilter>;
  financialTotal?: Maybe<IntFilter>;
  plan?: Maybe<EnumFinancialPlanFilter>;
  quantity?: Maybe<IntFilter>;
  typeSign?: Maybe<EnumFinancialChargeableServiceFilter>;
  walletId?: Maybe<IntFilter>;
};

export type FinancialTeamSignupSelectedOptionsWhereUniqueInput = {
  AND?: Maybe<Array<FinancialTeamSignupSelectedOptionsWhereInput>>;
  NOT?: Maybe<Array<FinancialTeamSignupSelectedOptionsWhereInput>>;
  OR?: Maybe<Array<FinancialTeamSignupSelectedOptionsWhereInput>>;
  TeamWallet?: Maybe<FinancialTeamWalletWhereInput>;
  billingCycle?: Maybe<EnumFinancialBillingCycleFilter>;
  financialTotal?: Maybe<IntFilter>;
  plan?: Maybe<EnumFinancialPlanFilter>;
  quantity?: Maybe<IntFilter>;
  typeSign?: Maybe<EnumFinancialChargeableServiceFilter>;
  walletId?: Maybe<Scalars['Int']>;
};

/**
 * Stores the current plan of the team and the amount of credits (of each type)
 * Must be created at financial choose after account creation
 * The "Trial" must be blocked if user has already a Wallet
 * More "powerful" credits can be used to generate less powerful certificates. Its because sometime users can choose a bigger plan because of other type of functionalities thats not because of the certificate signature type
 */
export type FinancialTeamWallet = {
  __typename?: 'FinancialTeamWallet';
  Charges: Array<FinancialCharge>;
  CreditCardSaveds: Array<FinancialCreditCardSaved>;
  Payments: Array<FinancialPayment>;
  SubscriptionActive?: Maybe<FinancialTeamWalletSubscription>;
  Subscriptions: Array<FinancialTeamWalletSubscription>;
  Team: Team;
  TeamCostConfigs: Array<FinancialTeamCostConfig>;
  TeamSignupSelectedOptions: Array<FinancialTeamSignupSelectedOptions>;
  /** For RB signed certificates (and visual) */
  creditsDetachedRb: Scalars['Int'];
  /** For RT and RA signed certificates (and any other) */
  creditsDetachedRtRa: Scalars['Int'];
  /**
   * -- Detached credits --
   * These credits needs to warn-popup-notify users when used to generate cheaper certificates
   * For visual signed certificates (and only visual)
   */
  creditsDetachedVisual: Scalars['Int'];
  creditsPlanRb: Scalars['Int'];
  creditsPlanRtRa: Scalars['Int'];
  /**
   * -- Plan credits --
   * Are credits that are incremented in at plan payment
   * Different from the others, these credits will not warn-popup-notify users when used to generate cheaper certificates
   * Credits for visual signed certificates with watermark (and only visual)
   */
  creditsPlanTrial: Scalars['Int'];
  creditsPlanVisual: Scalars['Int'];
  financialProviderCustomerId?: Maybe<Scalars['String']>;
  teamId: Scalars['Int'];
};


/**
 * Stores the current plan of the team and the amount of credits (of each type)
 * Must be created at financial choose after account creation
 * The "Trial" must be blocked if user has already a Wallet
 * More "powerful" credits can be used to generate less powerful certificates. Its because sometime users can choose a bigger plan because of other type of functionalities thats not because of the certificate signature type
 */
export type FinancialTeamWalletChargesArgs = {
  cursor?: Maybe<FinancialChargeWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialChargeScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialChargeOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialChargeWhereInput>;
};


/**
 * Stores the current plan of the team and the amount of credits (of each type)
 * Must be created at financial choose after account creation
 * The "Trial" must be blocked if user has already a Wallet
 * More "powerful" credits can be used to generate less powerful certificates. Its because sometime users can choose a bigger plan because of other type of functionalities thats not because of the certificate signature type
 */
export type FinancialTeamWalletCreditCardSavedsArgs = {
  cursor?: Maybe<FinancialCreditCardSavedWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialCreditCardSavedScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialCreditCardSavedOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialCreditCardSavedWhereInput>;
};


/**
 * Stores the current plan of the team and the amount of credits (of each type)
 * Must be created at financial choose after account creation
 * The "Trial" must be blocked if user has already a Wallet
 * More "powerful" credits can be used to generate less powerful certificates. Its because sometime users can choose a bigger plan because of other type of functionalities thats not because of the certificate signature type
 */
export type FinancialTeamWalletPaymentsArgs = {
  cursor?: Maybe<FinancialPaymentWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialPaymentScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialPaymentOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialPaymentWhereInput>;
};


/**
 * Stores the current plan of the team and the amount of credits (of each type)
 * Must be created at financial choose after account creation
 * The "Trial" must be blocked if user has already a Wallet
 * More "powerful" credits can be used to generate less powerful certificates. Its because sometime users can choose a bigger plan because of other type of functionalities thats not because of the certificate signature type
 */
export type FinancialTeamWalletSubscriptionsArgs = {
  cursor?: Maybe<FinancialTeamWalletSubscriptionWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialTeamWalletSubscriptionScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialTeamWalletSubscriptionOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialTeamWalletSubscriptionWhereInput>;
};


/**
 * Stores the current plan of the team and the amount of credits (of each type)
 * Must be created at financial choose after account creation
 * The "Trial" must be blocked if user has already a Wallet
 * More "powerful" credits can be used to generate less powerful certificates. Its because sometime users can choose a bigger plan because of other type of functionalities thats not because of the certificate signature type
 */
export type FinancialTeamWalletTeamCostConfigsArgs = {
  cursor?: Maybe<FinancialTeamCostConfigWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialTeamCostConfigScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialTeamCostConfigOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialTeamCostConfigWhereInput>;
};


/**
 * Stores the current plan of the team and the amount of credits (of each type)
 * Must be created at financial choose after account creation
 * The "Trial" must be blocked if user has already a Wallet
 * More "powerful" credits can be used to generate less powerful certificates. Its because sometime users can choose a bigger plan because of other type of functionalities thats not because of the certificate signature type
 */
export type FinancialTeamWalletTeamSignupSelectedOptionsArgs = {
  cursor?: Maybe<FinancialTeamSignupSelectedOptionsWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialTeamSignupSelectedOptionsScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialTeamSignupSelectedOptionsOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialTeamSignupSelectedOptionsWhereInput>;
};

export type FinancialTeamWalletAvgOrderByAggregateInput = {
  creditsDetachedRb?: Maybe<SortOrder>;
  creditsDetachedRtRa?: Maybe<SortOrder>;
  creditsDetachedVisual?: Maybe<SortOrder>;
  creditsPlanRb?: Maybe<SortOrder>;
  creditsPlanRtRa?: Maybe<SortOrder>;
  creditsPlanTrial?: Maybe<SortOrder>;
  creditsPlanVisual?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type FinancialTeamWalletCountOrderByAggregateInput = {
  creditsDetachedRb?: Maybe<SortOrder>;
  creditsDetachedRtRa?: Maybe<SortOrder>;
  creditsDetachedVisual?: Maybe<SortOrder>;
  creditsPlanRb?: Maybe<SortOrder>;
  creditsPlanRtRa?: Maybe<SortOrder>;
  creditsPlanTrial?: Maybe<SortOrder>;
  creditsPlanVisual?: Maybe<SortOrder>;
  financialProviderCustomerId?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type FinancialTeamWalletCreateInput = {
  Charges?: Maybe<FinancialChargeCreateNestedManyWithoutTeamWalletInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedCreateNestedManyWithoutTeamWalletInput>;
  Payments?: Maybe<FinancialPaymentCreateNestedManyWithoutTeamWalletInput>;
  Subscriptions?: Maybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutTeamWalletInput>;
  Team: TeamCreateNestedOneWithoutFinancialTeamWalletInput;
  TeamCostConfigs?: Maybe<FinancialTeamCostConfigCreateNestedManyWithoutTeamWalletInput>;
  TeamSignupSelectedOptions?: Maybe<FinancialTeamSignupSelectedOptionsCreateNestedManyWithoutTeamWalletInput>;
  creditsDetachedRb?: Maybe<Scalars['Int']>;
  creditsDetachedRtRa?: Maybe<Scalars['Int']>;
  creditsDetachedVisual?: Maybe<Scalars['Int']>;
  creditsPlanRb?: Maybe<Scalars['Int']>;
  creditsPlanRtRa?: Maybe<Scalars['Int']>;
  creditsPlanTrial?: Maybe<Scalars['Int']>;
  creditsPlanVisual?: Maybe<Scalars['Int']>;
  financialProviderCustomerId?: Maybe<Scalars['String']>;
};

export type FinancialTeamWalletCreateManyInput = {
  creditsDetachedRb?: Maybe<Scalars['Int']>;
  creditsDetachedRtRa?: Maybe<Scalars['Int']>;
  creditsDetachedVisual?: Maybe<Scalars['Int']>;
  creditsPlanRb?: Maybe<Scalars['Int']>;
  creditsPlanRtRa?: Maybe<Scalars['Int']>;
  creditsPlanTrial?: Maybe<Scalars['Int']>;
  creditsPlanVisual?: Maybe<Scalars['Int']>;
  financialProviderCustomerId?: Maybe<Scalars['String']>;
  teamId: Scalars['Int'];
};

export type FinancialTeamWalletCreateNestedOneWithoutChargesInput = {
  connect?: Maybe<FinancialTeamWalletWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTeamWalletCreateOrConnectWithoutChargesInput>;
  create?: Maybe<FinancialTeamWalletCreateWithoutChargesInput>;
};

export type FinancialTeamWalletCreateNestedOneWithoutCreditCardSavedsInput = {
  connect?: Maybe<FinancialTeamWalletWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTeamWalletCreateOrConnectWithoutCreditCardSavedsInput>;
  create?: Maybe<FinancialTeamWalletCreateWithoutCreditCardSavedsInput>;
};

export type FinancialTeamWalletCreateNestedOneWithoutPaymentsInput = {
  connect?: Maybe<FinancialTeamWalletWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTeamWalletCreateOrConnectWithoutPaymentsInput>;
  create?: Maybe<FinancialTeamWalletCreateWithoutPaymentsInput>;
};

export type FinancialTeamWalletCreateNestedOneWithoutSubscriptionsInput = {
  connect?: Maybe<FinancialTeamWalletWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTeamWalletCreateOrConnectWithoutSubscriptionsInput>;
  create?: Maybe<FinancialTeamWalletCreateWithoutSubscriptionsInput>;
};

export type FinancialTeamWalletCreateNestedOneWithoutTeamCostConfigsInput = {
  connect?: Maybe<FinancialTeamWalletWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTeamWalletCreateOrConnectWithoutTeamCostConfigsInput>;
  create?: Maybe<FinancialTeamWalletCreateWithoutTeamCostConfigsInput>;
};

export type FinancialTeamWalletCreateNestedOneWithoutTeamInput = {
  connect?: Maybe<FinancialTeamWalletWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTeamWalletCreateOrConnectWithoutTeamInput>;
  create?: Maybe<FinancialTeamWalletCreateWithoutTeamInput>;
};

export type FinancialTeamWalletCreateNestedOneWithoutTeamSignupSelectedOptionsInput = {
  connect?: Maybe<FinancialTeamWalletWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTeamWalletCreateOrConnectWithoutTeamSignupSelectedOptionsInput>;
  create?: Maybe<FinancialTeamWalletCreateWithoutTeamSignupSelectedOptionsInput>;
};

export type FinancialTeamWalletCreateOrConnectWithoutChargesInput = {
  create: FinancialTeamWalletCreateWithoutChargesInput;
  where: FinancialTeamWalletWhereUniqueInput;
};

export type FinancialTeamWalletCreateOrConnectWithoutCreditCardSavedsInput = {
  create: FinancialTeamWalletCreateWithoutCreditCardSavedsInput;
  where: FinancialTeamWalletWhereUniqueInput;
};

export type FinancialTeamWalletCreateOrConnectWithoutPaymentsInput = {
  create: FinancialTeamWalletCreateWithoutPaymentsInput;
  where: FinancialTeamWalletWhereUniqueInput;
};

export type FinancialTeamWalletCreateOrConnectWithoutSubscriptionsInput = {
  create: FinancialTeamWalletCreateWithoutSubscriptionsInput;
  where: FinancialTeamWalletWhereUniqueInput;
};

export type FinancialTeamWalletCreateOrConnectWithoutTeamCostConfigsInput = {
  create: FinancialTeamWalletCreateWithoutTeamCostConfigsInput;
  where: FinancialTeamWalletWhereUniqueInput;
};

export type FinancialTeamWalletCreateOrConnectWithoutTeamInput = {
  create: FinancialTeamWalletCreateWithoutTeamInput;
  where: FinancialTeamWalletWhereUniqueInput;
};

export type FinancialTeamWalletCreateOrConnectWithoutTeamSignupSelectedOptionsInput = {
  create: FinancialTeamWalletCreateWithoutTeamSignupSelectedOptionsInput;
  where: FinancialTeamWalletWhereUniqueInput;
};

export type FinancialTeamWalletCreateWithoutChargesInput = {
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedCreateNestedManyWithoutTeamWalletInput>;
  Payments?: Maybe<FinancialPaymentCreateNestedManyWithoutTeamWalletInput>;
  Subscriptions?: Maybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutTeamWalletInput>;
  Team: TeamCreateNestedOneWithoutFinancialTeamWalletInput;
  TeamCostConfigs?: Maybe<FinancialTeamCostConfigCreateNestedManyWithoutTeamWalletInput>;
  TeamSignupSelectedOptions?: Maybe<FinancialTeamSignupSelectedOptionsCreateNestedManyWithoutTeamWalletInput>;
  creditsDetachedRb?: Maybe<Scalars['Int']>;
  creditsDetachedRtRa?: Maybe<Scalars['Int']>;
  creditsDetachedVisual?: Maybe<Scalars['Int']>;
  creditsPlanRb?: Maybe<Scalars['Int']>;
  creditsPlanRtRa?: Maybe<Scalars['Int']>;
  creditsPlanTrial?: Maybe<Scalars['Int']>;
  creditsPlanVisual?: Maybe<Scalars['Int']>;
  financialProviderCustomerId?: Maybe<Scalars['String']>;
};

export type FinancialTeamWalletCreateWithoutCreditCardSavedsInput = {
  Charges?: Maybe<FinancialChargeCreateNestedManyWithoutTeamWalletInput>;
  Payments?: Maybe<FinancialPaymentCreateNestedManyWithoutTeamWalletInput>;
  Subscriptions?: Maybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutTeamWalletInput>;
  Team: TeamCreateNestedOneWithoutFinancialTeamWalletInput;
  TeamCostConfigs?: Maybe<FinancialTeamCostConfigCreateNestedManyWithoutTeamWalletInput>;
  TeamSignupSelectedOptions?: Maybe<FinancialTeamSignupSelectedOptionsCreateNestedManyWithoutTeamWalletInput>;
  creditsDetachedRb?: Maybe<Scalars['Int']>;
  creditsDetachedRtRa?: Maybe<Scalars['Int']>;
  creditsDetachedVisual?: Maybe<Scalars['Int']>;
  creditsPlanRb?: Maybe<Scalars['Int']>;
  creditsPlanRtRa?: Maybe<Scalars['Int']>;
  creditsPlanTrial?: Maybe<Scalars['Int']>;
  creditsPlanVisual?: Maybe<Scalars['Int']>;
  financialProviderCustomerId?: Maybe<Scalars['String']>;
};

export type FinancialTeamWalletCreateWithoutPaymentsInput = {
  Charges?: Maybe<FinancialChargeCreateNestedManyWithoutTeamWalletInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedCreateNestedManyWithoutTeamWalletInput>;
  Subscriptions?: Maybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutTeamWalletInput>;
  Team: TeamCreateNestedOneWithoutFinancialTeamWalletInput;
  TeamCostConfigs?: Maybe<FinancialTeamCostConfigCreateNestedManyWithoutTeamWalletInput>;
  TeamSignupSelectedOptions?: Maybe<FinancialTeamSignupSelectedOptionsCreateNestedManyWithoutTeamWalletInput>;
  creditsDetachedRb?: Maybe<Scalars['Int']>;
  creditsDetachedRtRa?: Maybe<Scalars['Int']>;
  creditsDetachedVisual?: Maybe<Scalars['Int']>;
  creditsPlanRb?: Maybe<Scalars['Int']>;
  creditsPlanRtRa?: Maybe<Scalars['Int']>;
  creditsPlanTrial?: Maybe<Scalars['Int']>;
  creditsPlanVisual?: Maybe<Scalars['Int']>;
  financialProviderCustomerId?: Maybe<Scalars['String']>;
};

export type FinancialTeamWalletCreateWithoutSubscriptionsInput = {
  Charges?: Maybe<FinancialChargeCreateNestedManyWithoutTeamWalletInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedCreateNestedManyWithoutTeamWalletInput>;
  Payments?: Maybe<FinancialPaymentCreateNestedManyWithoutTeamWalletInput>;
  Team: TeamCreateNestedOneWithoutFinancialTeamWalletInput;
  TeamCostConfigs?: Maybe<FinancialTeamCostConfigCreateNestedManyWithoutTeamWalletInput>;
  TeamSignupSelectedOptions?: Maybe<FinancialTeamSignupSelectedOptionsCreateNestedManyWithoutTeamWalletInput>;
  creditsDetachedRb?: Maybe<Scalars['Int']>;
  creditsDetachedRtRa?: Maybe<Scalars['Int']>;
  creditsDetachedVisual?: Maybe<Scalars['Int']>;
  creditsPlanRb?: Maybe<Scalars['Int']>;
  creditsPlanRtRa?: Maybe<Scalars['Int']>;
  creditsPlanTrial?: Maybe<Scalars['Int']>;
  creditsPlanVisual?: Maybe<Scalars['Int']>;
  financialProviderCustomerId?: Maybe<Scalars['String']>;
};

export type FinancialTeamWalletCreateWithoutTeamCostConfigsInput = {
  Charges?: Maybe<FinancialChargeCreateNestedManyWithoutTeamWalletInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedCreateNestedManyWithoutTeamWalletInput>;
  Payments?: Maybe<FinancialPaymentCreateNestedManyWithoutTeamWalletInput>;
  Subscriptions?: Maybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutTeamWalletInput>;
  Team: TeamCreateNestedOneWithoutFinancialTeamWalletInput;
  TeamSignupSelectedOptions?: Maybe<FinancialTeamSignupSelectedOptionsCreateNestedManyWithoutTeamWalletInput>;
  creditsDetachedRb?: Maybe<Scalars['Int']>;
  creditsDetachedRtRa?: Maybe<Scalars['Int']>;
  creditsDetachedVisual?: Maybe<Scalars['Int']>;
  creditsPlanRb?: Maybe<Scalars['Int']>;
  creditsPlanRtRa?: Maybe<Scalars['Int']>;
  creditsPlanTrial?: Maybe<Scalars['Int']>;
  creditsPlanVisual?: Maybe<Scalars['Int']>;
  financialProviderCustomerId?: Maybe<Scalars['String']>;
};

export type FinancialTeamWalletCreateWithoutTeamInput = {
  Charges?: Maybe<FinancialChargeCreateNestedManyWithoutTeamWalletInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedCreateNestedManyWithoutTeamWalletInput>;
  Payments?: Maybe<FinancialPaymentCreateNestedManyWithoutTeamWalletInput>;
  Subscriptions?: Maybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutTeamWalletInput>;
  TeamCostConfigs?: Maybe<FinancialTeamCostConfigCreateNestedManyWithoutTeamWalletInput>;
  TeamSignupSelectedOptions?: Maybe<FinancialTeamSignupSelectedOptionsCreateNestedManyWithoutTeamWalletInput>;
  creditsDetachedRb?: Maybe<Scalars['Int']>;
  creditsDetachedRtRa?: Maybe<Scalars['Int']>;
  creditsDetachedVisual?: Maybe<Scalars['Int']>;
  creditsPlanRb?: Maybe<Scalars['Int']>;
  creditsPlanRtRa?: Maybe<Scalars['Int']>;
  creditsPlanTrial?: Maybe<Scalars['Int']>;
  creditsPlanVisual?: Maybe<Scalars['Int']>;
  financialProviderCustomerId?: Maybe<Scalars['String']>;
};

export type FinancialTeamWalletCreateWithoutTeamSignupSelectedOptionsInput = {
  Charges?: Maybe<FinancialChargeCreateNestedManyWithoutTeamWalletInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedCreateNestedManyWithoutTeamWalletInput>;
  Payments?: Maybe<FinancialPaymentCreateNestedManyWithoutTeamWalletInput>;
  Subscriptions?: Maybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutTeamWalletInput>;
  Team: TeamCreateNestedOneWithoutFinancialTeamWalletInput;
  TeamCostConfigs?: Maybe<FinancialTeamCostConfigCreateNestedManyWithoutTeamWalletInput>;
  creditsDetachedRb?: Maybe<Scalars['Int']>;
  creditsDetachedRtRa?: Maybe<Scalars['Int']>;
  creditsDetachedVisual?: Maybe<Scalars['Int']>;
  creditsPlanRb?: Maybe<Scalars['Int']>;
  creditsPlanRtRa?: Maybe<Scalars['Int']>;
  creditsPlanTrial?: Maybe<Scalars['Int']>;
  creditsPlanVisual?: Maybe<Scalars['Int']>;
  financialProviderCustomerId?: Maybe<Scalars['String']>;
};

export type FinancialTeamWalletMaxOrderByAggregateInput = {
  creditsDetachedRb?: Maybe<SortOrder>;
  creditsDetachedRtRa?: Maybe<SortOrder>;
  creditsDetachedVisual?: Maybe<SortOrder>;
  creditsPlanRb?: Maybe<SortOrder>;
  creditsPlanRtRa?: Maybe<SortOrder>;
  creditsPlanTrial?: Maybe<SortOrder>;
  creditsPlanVisual?: Maybe<SortOrder>;
  financialProviderCustomerId?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type FinancialTeamWalletMinOrderByAggregateInput = {
  creditsDetachedRb?: Maybe<SortOrder>;
  creditsDetachedRtRa?: Maybe<SortOrder>;
  creditsDetachedVisual?: Maybe<SortOrder>;
  creditsPlanRb?: Maybe<SortOrder>;
  creditsPlanRtRa?: Maybe<SortOrder>;
  creditsPlanTrial?: Maybe<SortOrder>;
  creditsPlanVisual?: Maybe<SortOrder>;
  financialProviderCustomerId?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type FinancialTeamWalletNullableRelationFilter = {
  is?: Maybe<FinancialTeamWalletWhereInput>;
  isNot?: Maybe<FinancialTeamWalletWhereInput>;
};

export type FinancialTeamWalletOrderByWithAggregationInput = {
  _avg?: Maybe<FinancialTeamWalletAvgOrderByAggregateInput>;
  _count?: Maybe<FinancialTeamWalletCountOrderByAggregateInput>;
  _max?: Maybe<FinancialTeamWalletMaxOrderByAggregateInput>;
  _min?: Maybe<FinancialTeamWalletMinOrderByAggregateInput>;
  _sum?: Maybe<FinancialTeamWalletSumOrderByAggregateInput>;
  creditsDetachedRb?: Maybe<SortOrder>;
  creditsDetachedRtRa?: Maybe<SortOrder>;
  creditsDetachedVisual?: Maybe<SortOrder>;
  creditsPlanRb?: Maybe<SortOrder>;
  creditsPlanRtRa?: Maybe<SortOrder>;
  creditsPlanTrial?: Maybe<SortOrder>;
  creditsPlanVisual?: Maybe<SortOrder>;
  financialProviderCustomerId?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type FinancialTeamWalletOrderByWithRelationInput = {
  Charges?: Maybe<FinancialChargeOrderByRelationAggregateInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedOrderByRelationAggregateInput>;
  Payments?: Maybe<FinancialPaymentOrderByRelationAggregateInput>;
  Subscriptions?: Maybe<FinancialTeamWalletSubscriptionOrderByRelationAggregateInput>;
  Team?: Maybe<TeamOrderByWithRelationInput>;
  TeamCostConfigs?: Maybe<FinancialTeamCostConfigOrderByRelationAggregateInput>;
  TeamSignupSelectedOptions?: Maybe<FinancialTeamSignupSelectedOptionsOrderByRelationAggregateInput>;
  creditsDetachedRb?: Maybe<SortOrder>;
  creditsDetachedRtRa?: Maybe<SortOrder>;
  creditsDetachedVisual?: Maybe<SortOrder>;
  creditsPlanRb?: Maybe<SortOrder>;
  creditsPlanRtRa?: Maybe<SortOrder>;
  creditsPlanTrial?: Maybe<SortOrder>;
  creditsPlanVisual?: Maybe<SortOrder>;
  financialProviderCustomerId?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type FinancialTeamWalletPurchasePlanInput = {
  billingCycle: FinancialBillingCycle;
  creditCard?: Maybe<InputFinancialPurchaseCreditCard>;
  extraCredits: Scalars['Int'];
  plan: FinancialPlan;
  savedCreditCard?: Maybe<InputFinancialPurchaseSavedCreditCard>;
  service: FinancialChargeableService;
};

export type FinancialTeamWalletRelationFilter = {
  is?: Maybe<FinancialTeamWalletWhereInput>;
  isNot?: Maybe<FinancialTeamWalletWhereInput>;
};

export enum FinancialTeamWalletScalarFieldEnum {
  CreditsDetachedRb = 'creditsDetachedRb',
  CreditsDetachedRtRa = 'creditsDetachedRtRa',
  CreditsDetachedVisual = 'creditsDetachedVisual',
  CreditsPlanRb = 'creditsPlanRb',
  CreditsPlanRtRa = 'creditsPlanRtRa',
  CreditsPlanTrial = 'creditsPlanTrial',
  CreditsPlanVisual = 'creditsPlanVisual',
  FinancialProviderCustomerId = 'financialProviderCustomerId',
  TeamId = 'teamId'
}

export type FinancialTeamWalletScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<FinancialTeamWalletScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<FinancialTeamWalletScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<FinancialTeamWalletScalarWhereWithAggregatesInput>>;
  creditsDetachedRb?: Maybe<IntWithAggregatesFilter>;
  creditsDetachedRtRa?: Maybe<IntWithAggregatesFilter>;
  creditsDetachedVisual?: Maybe<IntWithAggregatesFilter>;
  creditsPlanRb?: Maybe<IntWithAggregatesFilter>;
  creditsPlanRtRa?: Maybe<IntWithAggregatesFilter>;
  creditsPlanTrial?: Maybe<IntWithAggregatesFilter>;
  creditsPlanVisual?: Maybe<IntWithAggregatesFilter>;
  financialProviderCustomerId?: Maybe<StringNullableWithAggregatesFilter>;
  teamId?: Maybe<IntWithAggregatesFilter>;
};

/** Each wallet must have multiple subscriptions (If cancel and hire again) */
export type FinancialTeamWalletSubscription = {
  __typename?: 'FinancialTeamWalletSubscription';
  Payments: Array<FinancialTeamWalletSubscriptionPayment>;
  TeamWallet: FinancialTeamWallet;
  UserCreated: CommonUser;
  /**
   * Stores the date when the quota will be reset
   * Null if trial
   */
  annualCreditQuotaResetDate?: Maybe<Scalars['DateTime']>;
  /** Null if trial */
  billingCycle?: Maybe<FinancialBillingCycle>;
  /** User has canceled the subscription */
  canceledAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  /**
   * To show in frontend (Even if Pending payment was not created yet at Asaas (It will be created 40 days before the due date))
   * Null if trial
   */
  nextDueDate?: Maybe<Scalars['DateTime']>;
  plan: FinancialPlan;
  planName?: Maybe<Scalars['String']>;
  planUpdatedPrice: Scalars['Float'];
  userCreatedId: Scalars['Int'];
  walletId: Scalars['Int'];
};


/** Each wallet must have multiple subscriptions (If cancel and hire again) */
export type FinancialTeamWalletSubscriptionPaymentsArgs = {
  cursor?: Maybe<FinancialTeamWalletSubscriptionPaymentWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
};

export type FinancialTeamWalletSubscriptionAvgOrderByAggregateInput = {
  userCreatedId?: Maybe<SortOrder>;
  walletId?: Maybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionCountOrderByAggregateInput = {
  annualCreditQuotaResetDate?: Maybe<SortOrder>;
  billingCycle?: Maybe<SortOrder>;
  canceledAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  nextDueDate?: Maybe<SortOrder>;
  plan?: Maybe<SortOrder>;
  userCreatedId?: Maybe<SortOrder>;
  walletId?: Maybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionCreateInput = {
  Payments?: Maybe<FinancialTeamWalletSubscriptionPaymentCreateNestedManyWithoutSubscriptionInput>;
  TeamWallet: FinancialTeamWalletCreateNestedOneWithoutSubscriptionsInput;
  UserCreated: CommonUserCreateNestedOneWithoutCreatedSubscriptionsInput;
  annualCreditQuotaResetDate?: Maybe<Scalars['DateTime']>;
  billingCycle?: Maybe<FinancialBillingCycle>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  nextDueDate?: Maybe<Scalars['DateTime']>;
  plan: FinancialPlan;
};

export type FinancialTeamWalletSubscriptionCreateManyInput = {
  annualCreditQuotaResetDate?: Maybe<Scalars['DateTime']>;
  billingCycle?: Maybe<FinancialBillingCycle>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  nextDueDate?: Maybe<Scalars['DateTime']>;
  plan: FinancialPlan;
  userCreatedId: Scalars['Int'];
  walletId: Scalars['Int'];
};

export type FinancialTeamWalletSubscriptionCreateManyTeamWalletInput = {
  annualCreditQuotaResetDate?: Maybe<Scalars['DateTime']>;
  billingCycle?: Maybe<FinancialBillingCycle>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  nextDueDate?: Maybe<Scalars['DateTime']>;
  plan: FinancialPlan;
  userCreatedId: Scalars['Int'];
};

export type FinancialTeamWalletSubscriptionCreateManyTeamWalletInputEnvelope = {
  data: Array<FinancialTeamWalletSubscriptionCreateManyTeamWalletInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type FinancialTeamWalletSubscriptionCreateManyUserCreatedInput = {
  annualCreditQuotaResetDate?: Maybe<Scalars['DateTime']>;
  billingCycle?: Maybe<FinancialBillingCycle>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  nextDueDate?: Maybe<Scalars['DateTime']>;
  plan: FinancialPlan;
  walletId: Scalars['Int'];
};

export type FinancialTeamWalletSubscriptionCreateManyUserCreatedInputEnvelope = {
  data: Array<FinancialTeamWalletSubscriptionCreateManyUserCreatedInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type FinancialTeamWalletSubscriptionCreateNestedManyWithoutTeamWalletInput = {
  connect?: Maybe<Array<FinancialTeamWalletSubscriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialTeamWalletSubscriptionCreateOrConnectWithoutTeamWalletInput>>;
  create?: Maybe<Array<FinancialTeamWalletSubscriptionCreateWithoutTeamWalletInput>>;
  createMany?: Maybe<FinancialTeamWalletSubscriptionCreateManyTeamWalletInputEnvelope>;
};

export type FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput = {
  connect?: Maybe<Array<FinancialTeamWalletSubscriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialTeamWalletSubscriptionCreateOrConnectWithoutUserCreatedInput>>;
  create?: Maybe<Array<FinancialTeamWalletSubscriptionCreateWithoutUserCreatedInput>>;
  createMany?: Maybe<FinancialTeamWalletSubscriptionCreateManyUserCreatedInputEnvelope>;
};

export type FinancialTeamWalletSubscriptionCreateNestedOneWithoutPaymentsInput = {
  connect?: Maybe<FinancialTeamWalletSubscriptionWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTeamWalletSubscriptionCreateOrConnectWithoutPaymentsInput>;
  create?: Maybe<FinancialTeamWalletSubscriptionCreateWithoutPaymentsInput>;
};

export type FinancialTeamWalletSubscriptionCreateOrConnectWithoutPaymentsInput = {
  create: FinancialTeamWalletSubscriptionCreateWithoutPaymentsInput;
  where: FinancialTeamWalletSubscriptionWhereUniqueInput;
};

export type FinancialTeamWalletSubscriptionCreateOrConnectWithoutTeamWalletInput = {
  create: FinancialTeamWalletSubscriptionCreateWithoutTeamWalletInput;
  where: FinancialTeamWalletSubscriptionWhereUniqueInput;
};

export type FinancialTeamWalletSubscriptionCreateOrConnectWithoutUserCreatedInput = {
  create: FinancialTeamWalletSubscriptionCreateWithoutUserCreatedInput;
  where: FinancialTeamWalletSubscriptionWhereUniqueInput;
};

export type FinancialTeamWalletSubscriptionCreateWithoutPaymentsInput = {
  TeamWallet: FinancialTeamWalletCreateNestedOneWithoutSubscriptionsInput;
  UserCreated: CommonUserCreateNestedOneWithoutCreatedSubscriptionsInput;
  annualCreditQuotaResetDate?: Maybe<Scalars['DateTime']>;
  billingCycle?: Maybe<FinancialBillingCycle>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  nextDueDate?: Maybe<Scalars['DateTime']>;
  plan: FinancialPlan;
};

export type FinancialTeamWalletSubscriptionCreateWithoutTeamWalletInput = {
  Payments?: Maybe<FinancialTeamWalletSubscriptionPaymentCreateNestedManyWithoutSubscriptionInput>;
  UserCreated: CommonUserCreateNestedOneWithoutCreatedSubscriptionsInput;
  annualCreditQuotaResetDate?: Maybe<Scalars['DateTime']>;
  billingCycle?: Maybe<FinancialBillingCycle>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  nextDueDate?: Maybe<Scalars['DateTime']>;
  plan: FinancialPlan;
};

export type FinancialTeamWalletSubscriptionCreateWithoutUserCreatedInput = {
  Payments?: Maybe<FinancialTeamWalletSubscriptionPaymentCreateNestedManyWithoutSubscriptionInput>;
  TeamWallet: FinancialTeamWalletCreateNestedOneWithoutSubscriptionsInput;
  annualCreditQuotaResetDate?: Maybe<Scalars['DateTime']>;
  billingCycle?: Maybe<FinancialBillingCycle>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  nextDueDate?: Maybe<Scalars['DateTime']>;
  plan: FinancialPlan;
};

export type FinancialTeamWalletSubscriptionListRelationFilter = {
  every?: Maybe<FinancialTeamWalletSubscriptionWhereInput>;
  none?: Maybe<FinancialTeamWalletSubscriptionWhereInput>;
  some?: Maybe<FinancialTeamWalletSubscriptionWhereInput>;
};

export type FinancialTeamWalletSubscriptionMaxOrderByAggregateInput = {
  annualCreditQuotaResetDate?: Maybe<SortOrder>;
  billingCycle?: Maybe<SortOrder>;
  canceledAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  nextDueDate?: Maybe<SortOrder>;
  plan?: Maybe<SortOrder>;
  userCreatedId?: Maybe<SortOrder>;
  walletId?: Maybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionMinOrderByAggregateInput = {
  annualCreditQuotaResetDate?: Maybe<SortOrder>;
  billingCycle?: Maybe<SortOrder>;
  canceledAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  nextDueDate?: Maybe<SortOrder>;
  plan?: Maybe<SortOrder>;
  userCreatedId?: Maybe<SortOrder>;
  walletId?: Maybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionOrderByWithAggregationInput = {
  _avg?: Maybe<FinancialTeamWalletSubscriptionAvgOrderByAggregateInput>;
  _count?: Maybe<FinancialTeamWalletSubscriptionCountOrderByAggregateInput>;
  _max?: Maybe<FinancialTeamWalletSubscriptionMaxOrderByAggregateInput>;
  _min?: Maybe<FinancialTeamWalletSubscriptionMinOrderByAggregateInput>;
  _sum?: Maybe<FinancialTeamWalletSubscriptionSumOrderByAggregateInput>;
  annualCreditQuotaResetDate?: Maybe<SortOrder>;
  billingCycle?: Maybe<SortOrder>;
  canceledAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  nextDueDate?: Maybe<SortOrder>;
  plan?: Maybe<SortOrder>;
  userCreatedId?: Maybe<SortOrder>;
  walletId?: Maybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionOrderByWithRelationInput = {
  Payments?: Maybe<FinancialTeamWalletSubscriptionPaymentOrderByRelationAggregateInput>;
  TeamWallet?: Maybe<FinancialTeamWalletOrderByWithRelationInput>;
  UserCreated?: Maybe<CommonUserOrderByWithRelationInput>;
  annualCreditQuotaResetDate?: Maybe<SortOrder>;
  billingCycle?: Maybe<SortOrder>;
  canceledAt?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  nextDueDate?: Maybe<SortOrder>;
  plan?: Maybe<SortOrder>;
  userCreatedId?: Maybe<SortOrder>;
  walletId?: Maybe<SortOrder>;
};

/** Created on initial payment / Webhook payment created */
export type FinancialTeamWalletSubscriptionPayment = {
  __typename?: 'FinancialTeamWalletSubscriptionPayment';
  FinancialPayment: FinancialPayment;
  FinancialTeamWalletSubscriptionPaymentHistory: Array<FinancialTeamWalletSubscriptionPaymentHistory>;
  Subscription: FinancialTeamWalletSubscription;
  cost: Scalars['Decimal'];
  createdAt: Scalars['DateTime'];
  dueDate: Scalars['DateTime'];
  id: Scalars['String'];
  paymentId: Scalars['String'];
  /**
   * Asaas payment id
   * In asaas we store externalReference when we create from backend
   * But sometimes, we create payment from webhook PAYMENT_CREATED
   * So we have to store it here to update status after PAYMENT_CONFIRMED | PAYMENT_OVERDUE
   */
  providerId?: Maybe<Scalars['String']>;
  status: PaymentStatus;
  subscriptionId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


/** Created on initial payment / Webhook payment created */
export type FinancialTeamWalletSubscriptionPaymentFinancialTeamWalletSubscriptionPaymentHistoryArgs = {
  cursor?: Maybe<FinancialTeamWalletSubscriptionPaymentHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialTeamWalletSubscriptionPaymentHistoryWhereInput>;
};

export type FinancialTeamWalletSubscriptionPaymentAvgOrderByAggregateInput = {
  cost?: Maybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionPaymentCountOrderByAggregateInput = {
  cost?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  dueDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  paymentId?: Maybe<SortOrder>;
  providerId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  subscriptionId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionPaymentCreateInput = {
  FinancialPayment: FinancialPaymentCreateNestedOneWithoutSubscriptionPaymentInput;
  FinancialTeamWalletSubscriptionPaymentHistory?: Maybe<FinancialTeamWalletSubscriptionPaymentHistoryCreateNestedManyWithoutPaymentInput>;
  Subscription: FinancialTeamWalletSubscriptionCreateNestedOneWithoutPaymentsInput;
  cost: Scalars['Decimal'];
  createdAt?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  status: PaymentStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTeamWalletSubscriptionPaymentCreateManyInput = {
  cost: Scalars['Decimal'];
  createdAt?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  paymentId: Scalars['String'];
  providerId?: Maybe<Scalars['String']>;
  status: PaymentStatus;
  subscriptionId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTeamWalletSubscriptionPaymentCreateManySubscriptionInput = {
  cost: Scalars['Decimal'];
  createdAt?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  paymentId: Scalars['String'];
  providerId?: Maybe<Scalars['String']>;
  status: PaymentStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTeamWalletSubscriptionPaymentCreateManySubscriptionInputEnvelope = {
  data: Array<FinancialTeamWalletSubscriptionPaymentCreateManySubscriptionInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type FinancialTeamWalletSubscriptionPaymentCreateNestedManyWithoutSubscriptionInput = {
  connect?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentCreateOrConnectWithoutSubscriptionInput>>;
  create?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentCreateWithoutSubscriptionInput>>;
  createMany?: Maybe<FinancialTeamWalletSubscriptionPaymentCreateManySubscriptionInputEnvelope>;
};

export type FinancialTeamWalletSubscriptionPaymentCreateNestedOneWithoutFinancialPaymentInput = {
  connect?: Maybe<FinancialTeamWalletSubscriptionPaymentWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTeamWalletSubscriptionPaymentCreateOrConnectWithoutFinancialPaymentInput>;
  create?: Maybe<FinancialTeamWalletSubscriptionPaymentCreateWithoutFinancialPaymentInput>;
};

export type FinancialTeamWalletSubscriptionPaymentCreateNestedOneWithoutFinancialTeamWalletSubscriptionPaymentHistoryInput = {
  connect?: Maybe<FinancialTeamWalletSubscriptionPaymentWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTeamWalletSubscriptionPaymentCreateOrConnectWithoutFinancialTeamWalletSubscriptionPaymentHistoryInput>;
  create?: Maybe<FinancialTeamWalletSubscriptionPaymentCreateWithoutFinancialTeamWalletSubscriptionPaymentHistoryInput>;
};

export type FinancialTeamWalletSubscriptionPaymentCreateOrConnectWithoutFinancialPaymentInput = {
  create: FinancialTeamWalletSubscriptionPaymentCreateWithoutFinancialPaymentInput;
  where: FinancialTeamWalletSubscriptionPaymentWhereUniqueInput;
};

export type FinancialTeamWalletSubscriptionPaymentCreateOrConnectWithoutFinancialTeamWalletSubscriptionPaymentHistoryInput = {
  create: FinancialTeamWalletSubscriptionPaymentCreateWithoutFinancialTeamWalletSubscriptionPaymentHistoryInput;
  where: FinancialTeamWalletSubscriptionPaymentWhereUniqueInput;
};

export type FinancialTeamWalletSubscriptionPaymentCreateOrConnectWithoutSubscriptionInput = {
  create: FinancialTeamWalletSubscriptionPaymentCreateWithoutSubscriptionInput;
  where: FinancialTeamWalletSubscriptionPaymentWhereUniqueInput;
};

export type FinancialTeamWalletSubscriptionPaymentCreateWithoutFinancialPaymentInput = {
  FinancialTeamWalletSubscriptionPaymentHistory?: Maybe<FinancialTeamWalletSubscriptionPaymentHistoryCreateNestedManyWithoutPaymentInput>;
  Subscription: FinancialTeamWalletSubscriptionCreateNestedOneWithoutPaymentsInput;
  cost: Scalars['Decimal'];
  createdAt?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  status: PaymentStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTeamWalletSubscriptionPaymentCreateWithoutFinancialTeamWalletSubscriptionPaymentHistoryInput = {
  FinancialPayment: FinancialPaymentCreateNestedOneWithoutSubscriptionPaymentInput;
  Subscription: FinancialTeamWalletSubscriptionCreateNestedOneWithoutPaymentsInput;
  cost: Scalars['Decimal'];
  createdAt?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  status: PaymentStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTeamWalletSubscriptionPaymentCreateWithoutSubscriptionInput = {
  FinancialPayment: FinancialPaymentCreateNestedOneWithoutSubscriptionPaymentInput;
  FinancialTeamWalletSubscriptionPaymentHistory?: Maybe<FinancialTeamWalletSubscriptionPaymentHistoryCreateNestedManyWithoutPaymentInput>;
  cost: Scalars['Decimal'];
  createdAt?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  id?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  status: PaymentStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialTeamWalletSubscriptionPaymentHistory = {
  __typename?: 'FinancialTeamWalletSubscriptionPaymentHistory';
  Payment: FinancialTeamWalletSubscriptionPayment;
  createdAt: Scalars['DateTime'];
  /** ![PrismaJson.AnyJson], thats for logging purposes */
  data: Scalars['Json'];
  id: Scalars['Int'];
  paymentId: Scalars['String'];
};

export type FinancialTeamWalletSubscriptionPaymentHistoryAvgOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  data?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  paymentId?: Maybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryCreateInput = {
  Payment: FinancialTeamWalletSubscriptionPaymentCreateNestedOneWithoutFinancialTeamWalletSubscriptionPaymentHistoryInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  data: Scalars['Json'];
};

export type FinancialTeamWalletSubscriptionPaymentHistoryCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  data: Scalars['Json'];
  id?: Maybe<Scalars['Int']>;
  paymentId: Scalars['String'];
};

export type FinancialTeamWalletSubscriptionPaymentHistoryCreateManyPaymentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  data: Scalars['Json'];
  id?: Maybe<Scalars['Int']>;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryCreateManyPaymentInputEnvelope = {
  data: Array<FinancialTeamWalletSubscriptionPaymentHistoryCreateManyPaymentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryCreateNestedManyWithoutPaymentInput = {
  connect?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryCreateOrConnectWithoutPaymentInput>>;
  create?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryCreateWithoutPaymentInput>>;
  createMany?: Maybe<FinancialTeamWalletSubscriptionPaymentHistoryCreateManyPaymentInputEnvelope>;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryCreateOrConnectWithoutPaymentInput = {
  create: FinancialTeamWalletSubscriptionPaymentHistoryCreateWithoutPaymentInput;
  where: FinancialTeamWalletSubscriptionPaymentHistoryWhereUniqueInput;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryCreateWithoutPaymentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  data: Scalars['Json'];
};

export type FinancialTeamWalletSubscriptionPaymentHistoryListRelationFilter = {
  every?: Maybe<FinancialTeamWalletSubscriptionPaymentHistoryWhereInput>;
  none?: Maybe<FinancialTeamWalletSubscriptionPaymentHistoryWhereInput>;
  some?: Maybe<FinancialTeamWalletSubscriptionPaymentHistoryWhereInput>;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  paymentId?: Maybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  paymentId?: Maybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryOrderByWithAggregationInput = {
  _avg?: Maybe<FinancialTeamWalletSubscriptionPaymentHistoryAvgOrderByAggregateInput>;
  _count?: Maybe<FinancialTeamWalletSubscriptionPaymentHistoryCountOrderByAggregateInput>;
  _max?: Maybe<FinancialTeamWalletSubscriptionPaymentHistoryMaxOrderByAggregateInput>;
  _min?: Maybe<FinancialTeamWalletSubscriptionPaymentHistoryMinOrderByAggregateInput>;
  _sum?: Maybe<FinancialTeamWalletSubscriptionPaymentHistorySumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  data?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  paymentId?: Maybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryOrderByWithRelationInput = {
  Payment?: Maybe<FinancialTeamWalletSubscriptionPaymentOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  data?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  paymentId?: Maybe<SortOrder>;
};

export enum FinancialTeamWalletSubscriptionPaymentHistoryScalarFieldEnum {
  CreatedAt = 'createdAt',
  Data = 'data',
  Id = 'id',
  PaymentId = 'paymentId'
}

export type FinancialTeamWalletSubscriptionPaymentHistoryScalarWhereInput = {
  AND?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryScalarWhereInput>>;
  NOT?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryScalarWhereInput>>;
  OR?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  data?: Maybe<JsonFilter>;
  id?: Maybe<IntFilter>;
  paymentId?: Maybe<StringFilter>;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  data?: Maybe<JsonWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  paymentId?: Maybe<StringWithAggregatesFilter>;
};

export type FinancialTeamWalletSubscriptionPaymentHistorySumOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryUpdateInput = {
  Payment?: Maybe<FinancialTeamWalletSubscriptionPaymentUpdateOneRequiredWithoutFinancialTeamWalletSubscriptionPaymentHistoryNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  data?: Maybe<Scalars['Json']>;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryUpdateManyMutationInput = {
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  data?: Maybe<Scalars['Json']>;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryUpdateManyWithWhereWithoutPaymentInput = {
  data: FinancialTeamWalletSubscriptionPaymentHistoryUpdateManyMutationInput;
  where: FinancialTeamWalletSubscriptionPaymentHistoryScalarWhereInput;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryUpdateManyWithoutPaymentNestedInput = {
  connect?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryCreateOrConnectWithoutPaymentInput>>;
  create?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryCreateWithoutPaymentInput>>;
  createMany?: Maybe<FinancialTeamWalletSubscriptionPaymentHistoryCreateManyPaymentInputEnvelope>;
  delete?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryScalarWhereInput>>;
  disconnect?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryWhereUniqueInput>>;
  set?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryWhereUniqueInput>>;
  update?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryUpdateWithWhereUniqueWithoutPaymentInput>>;
  updateMany?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryUpdateManyWithWhereWithoutPaymentInput>>;
  upsert?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryUpsertWithWhereUniqueWithoutPaymentInput>>;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryUpdateWithWhereUniqueWithoutPaymentInput = {
  data: FinancialTeamWalletSubscriptionPaymentHistoryUpdateWithoutPaymentInput;
  where: FinancialTeamWalletSubscriptionPaymentHistoryWhereUniqueInput;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryUpdateWithoutPaymentInput = {
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  data?: Maybe<Scalars['Json']>;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryUpsertWithWhereUniqueWithoutPaymentInput = {
  create: FinancialTeamWalletSubscriptionPaymentHistoryCreateWithoutPaymentInput;
  update: FinancialTeamWalletSubscriptionPaymentHistoryUpdateWithoutPaymentInput;
  where: FinancialTeamWalletSubscriptionPaymentHistoryWhereUniqueInput;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryWhereInput = {
  AND?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryWhereInput>>;
  NOT?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryWhereInput>>;
  OR?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryWhereInput>>;
  Payment?: Maybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
  createdAt?: Maybe<DateTimeFilter>;
  data?: Maybe<JsonFilter>;
  id?: Maybe<IntFilter>;
  paymentId?: Maybe<StringFilter>;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryWhereUniqueInput = {
  AND?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryWhereInput>>;
  NOT?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryWhereInput>>;
  OR?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryWhereInput>>;
  Payment?: Maybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
  createdAt?: Maybe<DateTimeFilter>;
  data?: Maybe<JsonFilter>;
  id?: Maybe<Scalars['Int']>;
  paymentId?: Maybe<StringFilter>;
};

export type FinancialTeamWalletSubscriptionPaymentListRelationFilter = {
  every?: Maybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
  none?: Maybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
  some?: Maybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
};

export type FinancialTeamWalletSubscriptionPaymentMaxOrderByAggregateInput = {
  cost?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  dueDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  paymentId?: Maybe<SortOrder>;
  providerId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  subscriptionId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionPaymentMinOrderByAggregateInput = {
  cost?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  dueDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  paymentId?: Maybe<SortOrder>;
  providerId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  subscriptionId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionPaymentNullableRelationFilter = {
  is?: Maybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
  isNot?: Maybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
};

export type FinancialTeamWalletSubscriptionPaymentOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionPaymentOrderByWithAggregationInput = {
  _avg?: Maybe<FinancialTeamWalletSubscriptionPaymentAvgOrderByAggregateInput>;
  _count?: Maybe<FinancialTeamWalletSubscriptionPaymentCountOrderByAggregateInput>;
  _max?: Maybe<FinancialTeamWalletSubscriptionPaymentMaxOrderByAggregateInput>;
  _min?: Maybe<FinancialTeamWalletSubscriptionPaymentMinOrderByAggregateInput>;
  _sum?: Maybe<FinancialTeamWalletSubscriptionPaymentSumOrderByAggregateInput>;
  cost?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  dueDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  paymentId?: Maybe<SortOrder>;
  providerId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  subscriptionId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionPaymentOrderByWithRelationInput = {
  FinancialPayment?: Maybe<FinancialPaymentOrderByWithRelationInput>;
  FinancialTeamWalletSubscriptionPaymentHistory?: Maybe<FinancialTeamWalletSubscriptionPaymentHistoryOrderByRelationAggregateInput>;
  Subscription?: Maybe<FinancialTeamWalletSubscriptionOrderByWithRelationInput>;
  cost?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  dueDate?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  paymentId?: Maybe<SortOrder>;
  providerId?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  subscriptionId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionPaymentRelationFilter = {
  is?: Maybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
  isNot?: Maybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
};

export enum FinancialTeamWalletSubscriptionPaymentScalarFieldEnum {
  Cost = 'cost',
  CreatedAt = 'createdAt',
  DueDate = 'dueDate',
  Id = 'id',
  PaymentId = 'paymentId',
  ProviderId = 'providerId',
  Status = 'status',
  SubscriptionId = 'subscriptionId',
  UpdatedAt = 'updatedAt'
}

export type FinancialTeamWalletSubscriptionPaymentScalarWhereInput = {
  AND?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentScalarWhereInput>>;
  NOT?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentScalarWhereInput>>;
  OR?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentScalarWhereInput>>;
  cost?: Maybe<DecimalFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  dueDate?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  paymentId?: Maybe<StringFilter>;
  providerId?: Maybe<StringNullableFilter>;
  status?: Maybe<EnumPaymentStatusFilter>;
  subscriptionId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
};

export type FinancialTeamWalletSubscriptionPaymentScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentScalarWhereWithAggregatesInput>>;
  cost?: Maybe<DecimalWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  dueDate?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  paymentId?: Maybe<StringWithAggregatesFilter>;
  providerId?: Maybe<StringNullableWithAggregatesFilter>;
  status?: Maybe<EnumPaymentStatusWithAggregatesFilter>;
  subscriptionId?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
};

export type FinancialTeamWalletSubscriptionPaymentSumOrderByAggregateInput = {
  cost?: Maybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionPaymentUpdateInput = {
  FinancialPayment?: Maybe<FinancialPaymentUpdateOneRequiredWithoutSubscriptionPaymentNestedInput>;
  FinancialTeamWalletSubscriptionPaymentHistory?: Maybe<FinancialTeamWalletSubscriptionPaymentHistoryUpdateManyWithoutPaymentNestedInput>;
  Subscription?: Maybe<FinancialTeamWalletSubscriptionUpdateOneRequiredWithoutPaymentsNestedInput>;
  cost?: Maybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  dueDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  providerId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  status?: Maybe<EnumPaymentStatusFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletSubscriptionPaymentUpdateManyMutationInput = {
  cost?: Maybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  dueDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  providerId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  status?: Maybe<EnumPaymentStatusFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletSubscriptionPaymentUpdateManyWithWhereWithoutSubscriptionInput = {
  data: FinancialTeamWalletSubscriptionPaymentUpdateManyMutationInput;
  where: FinancialTeamWalletSubscriptionPaymentScalarWhereInput;
};

export type FinancialTeamWalletSubscriptionPaymentUpdateManyWithoutSubscriptionNestedInput = {
  connect?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentCreateOrConnectWithoutSubscriptionInput>>;
  create?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentCreateWithoutSubscriptionInput>>;
  createMany?: Maybe<FinancialTeamWalletSubscriptionPaymentCreateManySubscriptionInputEnvelope>;
  delete?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentScalarWhereInput>>;
  disconnect?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentWhereUniqueInput>>;
  set?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentWhereUniqueInput>>;
  update?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentUpdateWithWhereUniqueWithoutSubscriptionInput>>;
  updateMany?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentUpdateManyWithWhereWithoutSubscriptionInput>>;
  upsert?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentUpsertWithWhereUniqueWithoutSubscriptionInput>>;
};

export type FinancialTeamWalletSubscriptionPaymentUpdateOneRequiredWithoutFinancialTeamWalletSubscriptionPaymentHistoryNestedInput = {
  connect?: Maybe<FinancialTeamWalletSubscriptionPaymentWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTeamWalletSubscriptionPaymentCreateOrConnectWithoutFinancialTeamWalletSubscriptionPaymentHistoryInput>;
  create?: Maybe<FinancialTeamWalletSubscriptionPaymentCreateWithoutFinancialTeamWalletSubscriptionPaymentHistoryInput>;
  update?: Maybe<FinancialTeamWalletSubscriptionPaymentUpdateToOneWithWhereWithoutFinancialTeamWalletSubscriptionPaymentHistoryInput>;
  upsert?: Maybe<FinancialTeamWalletSubscriptionPaymentUpsertWithoutFinancialTeamWalletSubscriptionPaymentHistoryInput>;
};

export type FinancialTeamWalletSubscriptionPaymentUpdateOneWithoutFinancialPaymentNestedInput = {
  connect?: Maybe<FinancialTeamWalletSubscriptionPaymentWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTeamWalletSubscriptionPaymentCreateOrConnectWithoutFinancialPaymentInput>;
  create?: Maybe<FinancialTeamWalletSubscriptionPaymentCreateWithoutFinancialPaymentInput>;
  delete?: Maybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
  disconnect?: Maybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
  update?: Maybe<FinancialTeamWalletSubscriptionPaymentUpdateToOneWithWhereWithoutFinancialPaymentInput>;
  upsert?: Maybe<FinancialTeamWalletSubscriptionPaymentUpsertWithoutFinancialPaymentInput>;
};

export type FinancialTeamWalletSubscriptionPaymentUpdateToOneWithWhereWithoutFinancialPaymentInput = {
  data: FinancialTeamWalletSubscriptionPaymentUpdateWithoutFinancialPaymentInput;
  where?: Maybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
};

export type FinancialTeamWalletSubscriptionPaymentUpdateToOneWithWhereWithoutFinancialTeamWalletSubscriptionPaymentHistoryInput = {
  data: FinancialTeamWalletSubscriptionPaymentUpdateWithoutFinancialTeamWalletSubscriptionPaymentHistoryInput;
  where?: Maybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
};

export type FinancialTeamWalletSubscriptionPaymentUpdateWithWhereUniqueWithoutSubscriptionInput = {
  data: FinancialTeamWalletSubscriptionPaymentUpdateWithoutSubscriptionInput;
  where: FinancialTeamWalletSubscriptionPaymentWhereUniqueInput;
};

export type FinancialTeamWalletSubscriptionPaymentUpdateWithoutFinancialPaymentInput = {
  FinancialTeamWalletSubscriptionPaymentHistory?: Maybe<FinancialTeamWalletSubscriptionPaymentHistoryUpdateManyWithoutPaymentNestedInput>;
  Subscription?: Maybe<FinancialTeamWalletSubscriptionUpdateOneRequiredWithoutPaymentsNestedInput>;
  cost?: Maybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  dueDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  providerId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  status?: Maybe<EnumPaymentStatusFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletSubscriptionPaymentUpdateWithoutFinancialTeamWalletSubscriptionPaymentHistoryInput = {
  FinancialPayment?: Maybe<FinancialPaymentUpdateOneRequiredWithoutSubscriptionPaymentNestedInput>;
  Subscription?: Maybe<FinancialTeamWalletSubscriptionUpdateOneRequiredWithoutPaymentsNestedInput>;
  cost?: Maybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  dueDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  providerId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  status?: Maybe<EnumPaymentStatusFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletSubscriptionPaymentUpdateWithoutSubscriptionInput = {
  FinancialPayment?: Maybe<FinancialPaymentUpdateOneRequiredWithoutSubscriptionPaymentNestedInput>;
  FinancialTeamWalletSubscriptionPaymentHistory?: Maybe<FinancialTeamWalletSubscriptionPaymentHistoryUpdateManyWithoutPaymentNestedInput>;
  cost?: Maybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  dueDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  providerId?: Maybe<NullableStringFieldUpdateOperationsInput>;
  status?: Maybe<EnumPaymentStatusFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletSubscriptionPaymentUpsertWithWhereUniqueWithoutSubscriptionInput = {
  create: FinancialTeamWalletSubscriptionPaymentCreateWithoutSubscriptionInput;
  update: FinancialTeamWalletSubscriptionPaymentUpdateWithoutSubscriptionInput;
  where: FinancialTeamWalletSubscriptionPaymentWhereUniqueInput;
};

export type FinancialTeamWalletSubscriptionPaymentUpsertWithoutFinancialPaymentInput = {
  create: FinancialTeamWalletSubscriptionPaymentCreateWithoutFinancialPaymentInput;
  update: FinancialTeamWalletSubscriptionPaymentUpdateWithoutFinancialPaymentInput;
  where?: Maybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
};

export type FinancialTeamWalletSubscriptionPaymentUpsertWithoutFinancialTeamWalletSubscriptionPaymentHistoryInput = {
  create: FinancialTeamWalletSubscriptionPaymentCreateWithoutFinancialTeamWalletSubscriptionPaymentHistoryInput;
  update: FinancialTeamWalletSubscriptionPaymentUpdateWithoutFinancialTeamWalletSubscriptionPaymentHistoryInput;
  where?: Maybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
};

export type FinancialTeamWalletSubscriptionPaymentWhereInput = {
  AND?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentWhereInput>>;
  FinancialPayment?: Maybe<FinancialPaymentWhereInput>;
  FinancialTeamWalletSubscriptionPaymentHistory?: Maybe<FinancialTeamWalletSubscriptionPaymentHistoryListRelationFilter>;
  NOT?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentWhereInput>>;
  OR?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentWhereInput>>;
  Subscription?: Maybe<FinancialTeamWalletSubscriptionWhereInput>;
  cost?: Maybe<DecimalFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  dueDate?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  paymentId?: Maybe<StringFilter>;
  providerId?: Maybe<StringNullableFilter>;
  status?: Maybe<EnumPaymentStatusFilter>;
  subscriptionId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
};

export type FinancialTeamWalletSubscriptionPaymentWhereUniqueInput = {
  AND?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentWhereInput>>;
  FinancialPayment?: Maybe<FinancialPaymentWhereInput>;
  FinancialTeamWalletSubscriptionPaymentHistory?: Maybe<FinancialTeamWalletSubscriptionPaymentHistoryListRelationFilter>;
  NOT?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentWhereInput>>;
  OR?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentWhereInput>>;
  Subscription?: Maybe<FinancialTeamWalletSubscriptionWhereInput>;
  cost?: Maybe<DecimalFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  dueDate?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  paymentId?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  status?: Maybe<EnumPaymentStatusFilter>;
  subscriptionId?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
};

export type FinancialTeamWalletSubscriptionRelationFilter = {
  is?: Maybe<FinancialTeamWalletSubscriptionWhereInput>;
  isNot?: Maybe<FinancialTeamWalletSubscriptionWhereInput>;
};

export enum FinancialTeamWalletSubscriptionScalarFieldEnum {
  AnnualCreditQuotaResetDate = 'annualCreditQuotaResetDate',
  BillingCycle = 'billingCycle',
  CanceledAt = 'canceledAt',
  CreatedAt = 'createdAt',
  Id = 'id',
  NextDueDate = 'nextDueDate',
  Plan = 'plan',
  UserCreatedId = 'userCreatedId',
  WalletId = 'walletId'
}

export type FinancialTeamWalletSubscriptionScalarWhereInput = {
  AND?: Maybe<Array<FinancialTeamWalletSubscriptionScalarWhereInput>>;
  NOT?: Maybe<Array<FinancialTeamWalletSubscriptionScalarWhereInput>>;
  OR?: Maybe<Array<FinancialTeamWalletSubscriptionScalarWhereInput>>;
  annualCreditQuotaResetDate?: Maybe<DateTimeNullableFilter>;
  billingCycle?: Maybe<EnumFinancialBillingCycleNullableFilter>;
  canceledAt?: Maybe<DateTimeNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  nextDueDate?: Maybe<DateTimeNullableFilter>;
  plan?: Maybe<EnumFinancialPlanFilter>;
  userCreatedId?: Maybe<IntFilter>;
  walletId?: Maybe<IntFilter>;
};

export type FinancialTeamWalletSubscriptionScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<FinancialTeamWalletSubscriptionScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<FinancialTeamWalletSubscriptionScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<FinancialTeamWalletSubscriptionScalarWhereWithAggregatesInput>>;
  annualCreditQuotaResetDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  billingCycle?: Maybe<EnumFinancialBillingCycleNullableWithAggregatesFilter>;
  canceledAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  nextDueDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  plan?: Maybe<EnumFinancialPlanWithAggregatesFilter>;
  userCreatedId?: Maybe<IntWithAggregatesFilter>;
  walletId?: Maybe<IntWithAggregatesFilter>;
};

export type FinancialTeamWalletSubscriptionSumOrderByAggregateInput = {
  userCreatedId?: Maybe<SortOrder>;
  walletId?: Maybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionUpdateInput = {
  Payments?: Maybe<FinancialTeamWalletSubscriptionPaymentUpdateManyWithoutSubscriptionNestedInput>;
  TeamWallet?: Maybe<FinancialTeamWalletUpdateOneRequiredWithoutSubscriptionsNestedInput>;
  UserCreated?: Maybe<CommonUserUpdateOneRequiredWithoutCreatedSubscriptionsNestedInput>;
  annualCreditQuotaResetDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  billingCycle?: Maybe<NullableEnumFinancialBillingCycleFieldUpdateOperationsInput>;
  canceledAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  nextDueDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  plan?: Maybe<EnumFinancialPlanFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletSubscriptionUpdateManyMutationInput = {
  annualCreditQuotaResetDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  billingCycle?: Maybe<NullableEnumFinancialBillingCycleFieldUpdateOperationsInput>;
  canceledAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  nextDueDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  plan?: Maybe<EnumFinancialPlanFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletSubscriptionUpdateManyWithWhereWithoutTeamWalletInput = {
  data: FinancialTeamWalletSubscriptionUpdateManyMutationInput;
  where: FinancialTeamWalletSubscriptionScalarWhereInput;
};

export type FinancialTeamWalletSubscriptionUpdateManyWithWhereWithoutUserCreatedInput = {
  data: FinancialTeamWalletSubscriptionUpdateManyMutationInput;
  where: FinancialTeamWalletSubscriptionScalarWhereInput;
};

export type FinancialTeamWalletSubscriptionUpdateManyWithoutTeamWalletNestedInput = {
  connect?: Maybe<Array<FinancialTeamWalletSubscriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialTeamWalletSubscriptionCreateOrConnectWithoutTeamWalletInput>>;
  create?: Maybe<Array<FinancialTeamWalletSubscriptionCreateWithoutTeamWalletInput>>;
  createMany?: Maybe<FinancialTeamWalletSubscriptionCreateManyTeamWalletInputEnvelope>;
  delete?: Maybe<Array<FinancialTeamWalletSubscriptionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FinancialTeamWalletSubscriptionScalarWhereInput>>;
  disconnect?: Maybe<Array<FinancialTeamWalletSubscriptionWhereUniqueInput>>;
  set?: Maybe<Array<FinancialTeamWalletSubscriptionWhereUniqueInput>>;
  update?: Maybe<Array<FinancialTeamWalletSubscriptionUpdateWithWhereUniqueWithoutTeamWalletInput>>;
  updateMany?: Maybe<Array<FinancialTeamWalletSubscriptionUpdateManyWithWhereWithoutTeamWalletInput>>;
  upsert?: Maybe<Array<FinancialTeamWalletSubscriptionUpsertWithWhereUniqueWithoutTeamWalletInput>>;
};

export type FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput = {
  connect?: Maybe<Array<FinancialTeamWalletSubscriptionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FinancialTeamWalletSubscriptionCreateOrConnectWithoutUserCreatedInput>>;
  create?: Maybe<Array<FinancialTeamWalletSubscriptionCreateWithoutUserCreatedInput>>;
  createMany?: Maybe<FinancialTeamWalletSubscriptionCreateManyUserCreatedInputEnvelope>;
  delete?: Maybe<Array<FinancialTeamWalletSubscriptionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FinancialTeamWalletSubscriptionScalarWhereInput>>;
  disconnect?: Maybe<Array<FinancialTeamWalletSubscriptionWhereUniqueInput>>;
  set?: Maybe<Array<FinancialTeamWalletSubscriptionWhereUniqueInput>>;
  update?: Maybe<Array<FinancialTeamWalletSubscriptionUpdateWithWhereUniqueWithoutUserCreatedInput>>;
  updateMany?: Maybe<Array<FinancialTeamWalletSubscriptionUpdateManyWithWhereWithoutUserCreatedInput>>;
  upsert?: Maybe<Array<FinancialTeamWalletSubscriptionUpsertWithWhereUniqueWithoutUserCreatedInput>>;
};

export type FinancialTeamWalletSubscriptionUpdateOneRequiredWithoutPaymentsNestedInput = {
  connect?: Maybe<FinancialTeamWalletSubscriptionWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTeamWalletSubscriptionCreateOrConnectWithoutPaymentsInput>;
  create?: Maybe<FinancialTeamWalletSubscriptionCreateWithoutPaymentsInput>;
  update?: Maybe<FinancialTeamWalletSubscriptionUpdateToOneWithWhereWithoutPaymentsInput>;
  upsert?: Maybe<FinancialTeamWalletSubscriptionUpsertWithoutPaymentsInput>;
};

export type FinancialTeamWalletSubscriptionUpdateToOneWithWhereWithoutPaymentsInput = {
  data: FinancialTeamWalletSubscriptionUpdateWithoutPaymentsInput;
  where?: Maybe<FinancialTeamWalletSubscriptionWhereInput>;
};

export type FinancialTeamWalletSubscriptionUpdateWithWhereUniqueWithoutTeamWalletInput = {
  data: FinancialTeamWalletSubscriptionUpdateWithoutTeamWalletInput;
  where: FinancialTeamWalletSubscriptionWhereUniqueInput;
};

export type FinancialTeamWalletSubscriptionUpdateWithWhereUniqueWithoutUserCreatedInput = {
  data: FinancialTeamWalletSubscriptionUpdateWithoutUserCreatedInput;
  where: FinancialTeamWalletSubscriptionWhereUniqueInput;
};

export type FinancialTeamWalletSubscriptionUpdateWithoutPaymentsInput = {
  TeamWallet?: Maybe<FinancialTeamWalletUpdateOneRequiredWithoutSubscriptionsNestedInput>;
  UserCreated?: Maybe<CommonUserUpdateOneRequiredWithoutCreatedSubscriptionsNestedInput>;
  annualCreditQuotaResetDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  billingCycle?: Maybe<NullableEnumFinancialBillingCycleFieldUpdateOperationsInput>;
  canceledAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  nextDueDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  plan?: Maybe<EnumFinancialPlanFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletSubscriptionUpdateWithoutTeamWalletInput = {
  Payments?: Maybe<FinancialTeamWalletSubscriptionPaymentUpdateManyWithoutSubscriptionNestedInput>;
  UserCreated?: Maybe<CommonUserUpdateOneRequiredWithoutCreatedSubscriptionsNestedInput>;
  annualCreditQuotaResetDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  billingCycle?: Maybe<NullableEnumFinancialBillingCycleFieldUpdateOperationsInput>;
  canceledAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  nextDueDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  plan?: Maybe<EnumFinancialPlanFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletSubscriptionUpdateWithoutUserCreatedInput = {
  Payments?: Maybe<FinancialTeamWalletSubscriptionPaymentUpdateManyWithoutSubscriptionNestedInput>;
  TeamWallet?: Maybe<FinancialTeamWalletUpdateOneRequiredWithoutSubscriptionsNestedInput>;
  annualCreditQuotaResetDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  billingCycle?: Maybe<NullableEnumFinancialBillingCycleFieldUpdateOperationsInput>;
  canceledAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  nextDueDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  plan?: Maybe<EnumFinancialPlanFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletSubscriptionUpsertWithWhereUniqueWithoutTeamWalletInput = {
  create: FinancialTeamWalletSubscriptionCreateWithoutTeamWalletInput;
  update: FinancialTeamWalletSubscriptionUpdateWithoutTeamWalletInput;
  where: FinancialTeamWalletSubscriptionWhereUniqueInput;
};

export type FinancialTeamWalletSubscriptionUpsertWithWhereUniqueWithoutUserCreatedInput = {
  create: FinancialTeamWalletSubscriptionCreateWithoutUserCreatedInput;
  update: FinancialTeamWalletSubscriptionUpdateWithoutUserCreatedInput;
  where: FinancialTeamWalletSubscriptionWhereUniqueInput;
};

export type FinancialTeamWalletSubscriptionUpsertWithoutPaymentsInput = {
  create: FinancialTeamWalletSubscriptionCreateWithoutPaymentsInput;
  update: FinancialTeamWalletSubscriptionUpdateWithoutPaymentsInput;
  where?: Maybe<FinancialTeamWalletSubscriptionWhereInput>;
};

export type FinancialTeamWalletSubscriptionWhereInput = {
  AND?: Maybe<Array<FinancialTeamWalletSubscriptionWhereInput>>;
  NOT?: Maybe<Array<FinancialTeamWalletSubscriptionWhereInput>>;
  OR?: Maybe<Array<FinancialTeamWalletSubscriptionWhereInput>>;
  Payments?: Maybe<FinancialTeamWalletSubscriptionPaymentListRelationFilter>;
  TeamWallet?: Maybe<FinancialTeamWalletWhereInput>;
  UserCreated?: Maybe<CommonUserWhereInput>;
  annualCreditQuotaResetDate?: Maybe<DateTimeNullableFilter>;
  billingCycle?: Maybe<EnumFinancialBillingCycleNullableFilter>;
  canceledAt?: Maybe<DateTimeNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  nextDueDate?: Maybe<DateTimeNullableFilter>;
  plan?: Maybe<EnumFinancialPlanFilter>;
  userCreatedId?: Maybe<IntFilter>;
  walletId?: Maybe<IntFilter>;
};

export type FinancialTeamWalletSubscriptionWhereUniqueInput = {
  AND?: Maybe<Array<FinancialTeamWalletSubscriptionWhereInput>>;
  NOT?: Maybe<Array<FinancialTeamWalletSubscriptionWhereInput>>;
  OR?: Maybe<Array<FinancialTeamWalletSubscriptionWhereInput>>;
  Payments?: Maybe<FinancialTeamWalletSubscriptionPaymentListRelationFilter>;
  TeamWallet?: Maybe<FinancialTeamWalletWhereInput>;
  UserCreated?: Maybe<CommonUserWhereInput>;
  annualCreditQuotaResetDate?: Maybe<DateTimeNullableFilter>;
  billingCycle?: Maybe<EnumFinancialBillingCycleNullableFilter>;
  canceledAt?: Maybe<DateTimeNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['String']>;
  nextDueDate?: Maybe<DateTimeNullableFilter>;
  plan?: Maybe<EnumFinancialPlanFilter>;
  userCreatedId?: Maybe<IntFilter>;
  walletId?: Maybe<IntFilter>;
};

export type FinancialTeamWalletSumOrderByAggregateInput = {
  creditsDetachedRb?: Maybe<SortOrder>;
  creditsDetachedRtRa?: Maybe<SortOrder>;
  creditsDetachedVisual?: Maybe<SortOrder>;
  creditsPlanRb?: Maybe<SortOrder>;
  creditsPlanRtRa?: Maybe<SortOrder>;
  creditsPlanTrial?: Maybe<SortOrder>;
  creditsPlanVisual?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type FinancialTeamWalletUpdateInput = {
  Charges?: Maybe<FinancialChargeUpdateManyWithoutTeamWalletNestedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedUpdateManyWithoutTeamWalletNestedInput>;
  Payments?: Maybe<FinancialPaymentUpdateManyWithoutTeamWalletNestedInput>;
  Subscriptions?: Maybe<FinancialTeamWalletSubscriptionUpdateManyWithoutTeamWalletNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutFinancialTeamWalletNestedInput>;
  TeamCostConfigs?: Maybe<FinancialTeamCostConfigUpdateManyWithoutTeamWalletNestedInput>;
  TeamSignupSelectedOptions?: Maybe<FinancialTeamSignupSelectedOptionsUpdateManyWithoutTeamWalletNestedInput>;
  creditsDetachedRb?: Maybe<IntFieldUpdateOperationsInput>;
  creditsDetachedRtRa?: Maybe<IntFieldUpdateOperationsInput>;
  creditsDetachedVisual?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanRb?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanRtRa?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanTrial?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanVisual?: Maybe<IntFieldUpdateOperationsInput>;
  financialProviderCustomerId?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletUpdateManyMutationInput = {
  creditsDetachedRb?: Maybe<IntFieldUpdateOperationsInput>;
  creditsDetachedRtRa?: Maybe<IntFieldUpdateOperationsInput>;
  creditsDetachedVisual?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanRb?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanRtRa?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanTrial?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanVisual?: Maybe<IntFieldUpdateOperationsInput>;
  financialProviderCustomerId?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletUpdateOneRequiredWithoutChargesNestedInput = {
  connect?: Maybe<FinancialTeamWalletWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTeamWalletCreateOrConnectWithoutChargesInput>;
  create?: Maybe<FinancialTeamWalletCreateWithoutChargesInput>;
  update?: Maybe<FinancialTeamWalletUpdateToOneWithWhereWithoutChargesInput>;
  upsert?: Maybe<FinancialTeamWalletUpsertWithoutChargesInput>;
};

export type FinancialTeamWalletUpdateOneRequiredWithoutCreditCardSavedsNestedInput = {
  connect?: Maybe<FinancialTeamWalletWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTeamWalletCreateOrConnectWithoutCreditCardSavedsInput>;
  create?: Maybe<FinancialTeamWalletCreateWithoutCreditCardSavedsInput>;
  update?: Maybe<FinancialTeamWalletUpdateToOneWithWhereWithoutCreditCardSavedsInput>;
  upsert?: Maybe<FinancialTeamWalletUpsertWithoutCreditCardSavedsInput>;
};

export type FinancialTeamWalletUpdateOneRequiredWithoutPaymentsNestedInput = {
  connect?: Maybe<FinancialTeamWalletWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTeamWalletCreateOrConnectWithoutPaymentsInput>;
  create?: Maybe<FinancialTeamWalletCreateWithoutPaymentsInput>;
  update?: Maybe<FinancialTeamWalletUpdateToOneWithWhereWithoutPaymentsInput>;
  upsert?: Maybe<FinancialTeamWalletUpsertWithoutPaymentsInput>;
};

export type FinancialTeamWalletUpdateOneRequiredWithoutSubscriptionsNestedInput = {
  connect?: Maybe<FinancialTeamWalletWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTeamWalletCreateOrConnectWithoutSubscriptionsInput>;
  create?: Maybe<FinancialTeamWalletCreateWithoutSubscriptionsInput>;
  update?: Maybe<FinancialTeamWalletUpdateToOneWithWhereWithoutSubscriptionsInput>;
  upsert?: Maybe<FinancialTeamWalletUpsertWithoutSubscriptionsInput>;
};

export type FinancialTeamWalletUpdateOneRequiredWithoutTeamCostConfigsNestedInput = {
  connect?: Maybe<FinancialTeamWalletWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTeamWalletCreateOrConnectWithoutTeamCostConfigsInput>;
  create?: Maybe<FinancialTeamWalletCreateWithoutTeamCostConfigsInput>;
  update?: Maybe<FinancialTeamWalletUpdateToOneWithWhereWithoutTeamCostConfigsInput>;
  upsert?: Maybe<FinancialTeamWalletUpsertWithoutTeamCostConfigsInput>;
};

export type FinancialTeamWalletUpdateOneRequiredWithoutTeamSignupSelectedOptionsNestedInput = {
  connect?: Maybe<FinancialTeamWalletWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTeamWalletCreateOrConnectWithoutTeamSignupSelectedOptionsInput>;
  create?: Maybe<FinancialTeamWalletCreateWithoutTeamSignupSelectedOptionsInput>;
  update?: Maybe<FinancialTeamWalletUpdateToOneWithWhereWithoutTeamSignupSelectedOptionsInput>;
  upsert?: Maybe<FinancialTeamWalletUpsertWithoutTeamSignupSelectedOptionsInput>;
};

export type FinancialTeamWalletUpdateOneWithoutTeamNestedInput = {
  connect?: Maybe<FinancialTeamWalletWhereUniqueInput>;
  connectOrCreate?: Maybe<FinancialTeamWalletCreateOrConnectWithoutTeamInput>;
  create?: Maybe<FinancialTeamWalletCreateWithoutTeamInput>;
  delete?: Maybe<FinancialTeamWalletWhereInput>;
  disconnect?: Maybe<FinancialTeamWalletWhereInput>;
  update?: Maybe<FinancialTeamWalletUpdateToOneWithWhereWithoutTeamInput>;
  upsert?: Maybe<FinancialTeamWalletUpsertWithoutTeamInput>;
};

export type FinancialTeamWalletUpdateToOneWithWhereWithoutChargesInput = {
  data: FinancialTeamWalletUpdateWithoutChargesInput;
  where?: Maybe<FinancialTeamWalletWhereInput>;
};

export type FinancialTeamWalletUpdateToOneWithWhereWithoutCreditCardSavedsInput = {
  data: FinancialTeamWalletUpdateWithoutCreditCardSavedsInput;
  where?: Maybe<FinancialTeamWalletWhereInput>;
};

export type FinancialTeamWalletUpdateToOneWithWhereWithoutPaymentsInput = {
  data: FinancialTeamWalletUpdateWithoutPaymentsInput;
  where?: Maybe<FinancialTeamWalletWhereInput>;
};

export type FinancialTeamWalletUpdateToOneWithWhereWithoutSubscriptionsInput = {
  data: FinancialTeamWalletUpdateWithoutSubscriptionsInput;
  where?: Maybe<FinancialTeamWalletWhereInput>;
};

export type FinancialTeamWalletUpdateToOneWithWhereWithoutTeamCostConfigsInput = {
  data: FinancialTeamWalletUpdateWithoutTeamCostConfigsInput;
  where?: Maybe<FinancialTeamWalletWhereInput>;
};

export type FinancialTeamWalletUpdateToOneWithWhereWithoutTeamInput = {
  data: FinancialTeamWalletUpdateWithoutTeamInput;
  where?: Maybe<FinancialTeamWalletWhereInput>;
};

export type FinancialTeamWalletUpdateToOneWithWhereWithoutTeamSignupSelectedOptionsInput = {
  data: FinancialTeamWalletUpdateWithoutTeamSignupSelectedOptionsInput;
  where?: Maybe<FinancialTeamWalletWhereInput>;
};

export type FinancialTeamWalletUpdateWithoutChargesInput = {
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedUpdateManyWithoutTeamWalletNestedInput>;
  Payments?: Maybe<FinancialPaymentUpdateManyWithoutTeamWalletNestedInput>;
  Subscriptions?: Maybe<FinancialTeamWalletSubscriptionUpdateManyWithoutTeamWalletNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutFinancialTeamWalletNestedInput>;
  TeamCostConfigs?: Maybe<FinancialTeamCostConfigUpdateManyWithoutTeamWalletNestedInput>;
  TeamSignupSelectedOptions?: Maybe<FinancialTeamSignupSelectedOptionsUpdateManyWithoutTeamWalletNestedInput>;
  creditsDetachedRb?: Maybe<IntFieldUpdateOperationsInput>;
  creditsDetachedRtRa?: Maybe<IntFieldUpdateOperationsInput>;
  creditsDetachedVisual?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanRb?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanRtRa?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanTrial?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanVisual?: Maybe<IntFieldUpdateOperationsInput>;
  financialProviderCustomerId?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletUpdateWithoutCreditCardSavedsInput = {
  Charges?: Maybe<FinancialChargeUpdateManyWithoutTeamWalletNestedInput>;
  Payments?: Maybe<FinancialPaymentUpdateManyWithoutTeamWalletNestedInput>;
  Subscriptions?: Maybe<FinancialTeamWalletSubscriptionUpdateManyWithoutTeamWalletNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutFinancialTeamWalletNestedInput>;
  TeamCostConfigs?: Maybe<FinancialTeamCostConfigUpdateManyWithoutTeamWalletNestedInput>;
  TeamSignupSelectedOptions?: Maybe<FinancialTeamSignupSelectedOptionsUpdateManyWithoutTeamWalletNestedInput>;
  creditsDetachedRb?: Maybe<IntFieldUpdateOperationsInput>;
  creditsDetachedRtRa?: Maybe<IntFieldUpdateOperationsInput>;
  creditsDetachedVisual?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanRb?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanRtRa?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanTrial?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanVisual?: Maybe<IntFieldUpdateOperationsInput>;
  financialProviderCustomerId?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletUpdateWithoutPaymentsInput = {
  Charges?: Maybe<FinancialChargeUpdateManyWithoutTeamWalletNestedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedUpdateManyWithoutTeamWalletNestedInput>;
  Subscriptions?: Maybe<FinancialTeamWalletSubscriptionUpdateManyWithoutTeamWalletNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutFinancialTeamWalletNestedInput>;
  TeamCostConfigs?: Maybe<FinancialTeamCostConfigUpdateManyWithoutTeamWalletNestedInput>;
  TeamSignupSelectedOptions?: Maybe<FinancialTeamSignupSelectedOptionsUpdateManyWithoutTeamWalletNestedInput>;
  creditsDetachedRb?: Maybe<IntFieldUpdateOperationsInput>;
  creditsDetachedRtRa?: Maybe<IntFieldUpdateOperationsInput>;
  creditsDetachedVisual?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanRb?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanRtRa?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanTrial?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanVisual?: Maybe<IntFieldUpdateOperationsInput>;
  financialProviderCustomerId?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletUpdateWithoutSubscriptionsInput = {
  Charges?: Maybe<FinancialChargeUpdateManyWithoutTeamWalletNestedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedUpdateManyWithoutTeamWalletNestedInput>;
  Payments?: Maybe<FinancialPaymentUpdateManyWithoutTeamWalletNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutFinancialTeamWalletNestedInput>;
  TeamCostConfigs?: Maybe<FinancialTeamCostConfigUpdateManyWithoutTeamWalletNestedInput>;
  TeamSignupSelectedOptions?: Maybe<FinancialTeamSignupSelectedOptionsUpdateManyWithoutTeamWalletNestedInput>;
  creditsDetachedRb?: Maybe<IntFieldUpdateOperationsInput>;
  creditsDetachedRtRa?: Maybe<IntFieldUpdateOperationsInput>;
  creditsDetachedVisual?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanRb?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanRtRa?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanTrial?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanVisual?: Maybe<IntFieldUpdateOperationsInput>;
  financialProviderCustomerId?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletUpdateWithoutTeamCostConfigsInput = {
  Charges?: Maybe<FinancialChargeUpdateManyWithoutTeamWalletNestedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedUpdateManyWithoutTeamWalletNestedInput>;
  Payments?: Maybe<FinancialPaymentUpdateManyWithoutTeamWalletNestedInput>;
  Subscriptions?: Maybe<FinancialTeamWalletSubscriptionUpdateManyWithoutTeamWalletNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutFinancialTeamWalletNestedInput>;
  TeamSignupSelectedOptions?: Maybe<FinancialTeamSignupSelectedOptionsUpdateManyWithoutTeamWalletNestedInput>;
  creditsDetachedRb?: Maybe<IntFieldUpdateOperationsInput>;
  creditsDetachedRtRa?: Maybe<IntFieldUpdateOperationsInput>;
  creditsDetachedVisual?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanRb?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanRtRa?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanTrial?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanVisual?: Maybe<IntFieldUpdateOperationsInput>;
  financialProviderCustomerId?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletUpdateWithoutTeamInput = {
  Charges?: Maybe<FinancialChargeUpdateManyWithoutTeamWalletNestedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedUpdateManyWithoutTeamWalletNestedInput>;
  Payments?: Maybe<FinancialPaymentUpdateManyWithoutTeamWalletNestedInput>;
  Subscriptions?: Maybe<FinancialTeamWalletSubscriptionUpdateManyWithoutTeamWalletNestedInput>;
  TeamCostConfigs?: Maybe<FinancialTeamCostConfigUpdateManyWithoutTeamWalletNestedInput>;
  TeamSignupSelectedOptions?: Maybe<FinancialTeamSignupSelectedOptionsUpdateManyWithoutTeamWalletNestedInput>;
  creditsDetachedRb?: Maybe<IntFieldUpdateOperationsInput>;
  creditsDetachedRtRa?: Maybe<IntFieldUpdateOperationsInput>;
  creditsDetachedVisual?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanRb?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanRtRa?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanTrial?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanVisual?: Maybe<IntFieldUpdateOperationsInput>;
  financialProviderCustomerId?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletUpdateWithoutTeamSignupSelectedOptionsInput = {
  Charges?: Maybe<FinancialChargeUpdateManyWithoutTeamWalletNestedInput>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedUpdateManyWithoutTeamWalletNestedInput>;
  Payments?: Maybe<FinancialPaymentUpdateManyWithoutTeamWalletNestedInput>;
  Subscriptions?: Maybe<FinancialTeamWalletSubscriptionUpdateManyWithoutTeamWalletNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutFinancialTeamWalletNestedInput>;
  TeamCostConfigs?: Maybe<FinancialTeamCostConfigUpdateManyWithoutTeamWalletNestedInput>;
  creditsDetachedRb?: Maybe<IntFieldUpdateOperationsInput>;
  creditsDetachedRtRa?: Maybe<IntFieldUpdateOperationsInput>;
  creditsDetachedVisual?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanRb?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanRtRa?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanTrial?: Maybe<IntFieldUpdateOperationsInput>;
  creditsPlanVisual?: Maybe<IntFieldUpdateOperationsInput>;
  financialProviderCustomerId?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletUpsertWithoutChargesInput = {
  create: FinancialTeamWalletCreateWithoutChargesInput;
  update: FinancialTeamWalletUpdateWithoutChargesInput;
  where?: Maybe<FinancialTeamWalletWhereInput>;
};

export type FinancialTeamWalletUpsertWithoutCreditCardSavedsInput = {
  create: FinancialTeamWalletCreateWithoutCreditCardSavedsInput;
  update: FinancialTeamWalletUpdateWithoutCreditCardSavedsInput;
  where?: Maybe<FinancialTeamWalletWhereInput>;
};

export type FinancialTeamWalletUpsertWithoutPaymentsInput = {
  create: FinancialTeamWalletCreateWithoutPaymentsInput;
  update: FinancialTeamWalletUpdateWithoutPaymentsInput;
  where?: Maybe<FinancialTeamWalletWhereInput>;
};

export type FinancialTeamWalletUpsertWithoutSubscriptionsInput = {
  create: FinancialTeamWalletCreateWithoutSubscriptionsInput;
  update: FinancialTeamWalletUpdateWithoutSubscriptionsInput;
  where?: Maybe<FinancialTeamWalletWhereInput>;
};

export type FinancialTeamWalletUpsertWithoutTeamCostConfigsInput = {
  create: FinancialTeamWalletCreateWithoutTeamCostConfigsInput;
  update: FinancialTeamWalletUpdateWithoutTeamCostConfigsInput;
  where?: Maybe<FinancialTeamWalletWhereInput>;
};

export type FinancialTeamWalletUpsertWithoutTeamInput = {
  create: FinancialTeamWalletCreateWithoutTeamInput;
  update: FinancialTeamWalletUpdateWithoutTeamInput;
  where?: Maybe<FinancialTeamWalletWhereInput>;
};

export type FinancialTeamWalletUpsertWithoutTeamSignupSelectedOptionsInput = {
  create: FinancialTeamWalletCreateWithoutTeamSignupSelectedOptionsInput;
  update: FinancialTeamWalletUpdateWithoutTeamSignupSelectedOptionsInput;
  where?: Maybe<FinancialTeamWalletWhereInput>;
};

export type FinancialTeamWalletWhereInput = {
  AND?: Maybe<Array<FinancialTeamWalletWhereInput>>;
  Charges?: Maybe<FinancialChargeListRelationFilter>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedListRelationFilter>;
  NOT?: Maybe<Array<FinancialTeamWalletWhereInput>>;
  OR?: Maybe<Array<FinancialTeamWalletWhereInput>>;
  Payments?: Maybe<FinancialPaymentListRelationFilter>;
  Subscriptions?: Maybe<FinancialTeamWalletSubscriptionListRelationFilter>;
  Team?: Maybe<TeamWhereInput>;
  TeamCostConfigs?: Maybe<FinancialTeamCostConfigListRelationFilter>;
  TeamSignupSelectedOptions?: Maybe<FinancialTeamSignupSelectedOptionsListRelationFilter>;
  creditsDetachedRb?: Maybe<IntFilter>;
  creditsDetachedRtRa?: Maybe<IntFilter>;
  creditsDetachedVisual?: Maybe<IntFilter>;
  creditsPlanRb?: Maybe<IntFilter>;
  creditsPlanRtRa?: Maybe<IntFilter>;
  creditsPlanTrial?: Maybe<IntFilter>;
  creditsPlanVisual?: Maybe<IntFilter>;
  financialProviderCustomerId?: Maybe<StringNullableFilter>;
  teamId?: Maybe<IntFilter>;
};

export type FinancialTeamWalletWhereUniqueInput = {
  AND?: Maybe<Array<FinancialTeamWalletWhereInput>>;
  Charges?: Maybe<FinancialChargeListRelationFilter>;
  CreditCardSaveds?: Maybe<FinancialCreditCardSavedListRelationFilter>;
  NOT?: Maybe<Array<FinancialTeamWalletWhereInput>>;
  OR?: Maybe<Array<FinancialTeamWalletWhereInput>>;
  Payments?: Maybe<FinancialPaymentListRelationFilter>;
  Subscriptions?: Maybe<FinancialTeamWalletSubscriptionListRelationFilter>;
  Team?: Maybe<TeamWhereInput>;
  TeamCostConfigs?: Maybe<FinancialTeamCostConfigListRelationFilter>;
  TeamSignupSelectedOptions?: Maybe<FinancialTeamSignupSelectedOptionsListRelationFilter>;
  creditsDetachedRb?: Maybe<IntFilter>;
  creditsDetachedRtRa?: Maybe<IntFilter>;
  creditsDetachedVisual?: Maybe<IntFilter>;
  creditsPlanRb?: Maybe<IntFilter>;
  creditsPlanRtRa?: Maybe<IntFilter>;
  creditsPlanTrial?: Maybe<IntFilter>;
  creditsPlanVisual?: Maybe<IntFilter>;
  financialProviderCustomerId?: Maybe<StringNullableFilter>;
  teamId?: Maybe<Scalars['Int']>;
};

export type FloatFieldUpdateOperationsInput = {
  decrement?: Maybe<Scalars['Float']>;
  divide?: Maybe<Scalars['Float']>;
  increment?: Maybe<Scalars['Float']>;
  multiply?: Maybe<Scalars['Float']>;
  set?: Maybe<Scalars['Float']>;
};

export type FloatFilter = {
  equals?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  in?: Maybe<Array<Scalars['Float']>>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  not?: Maybe<NestedFloatFilter>;
  notIn?: Maybe<Array<Scalars['Float']>>;
};

export type FloatWithAggregatesFilter = {
  _avg?: Maybe<NestedFloatFilter>;
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedFloatFilter>;
  _min?: Maybe<NestedFloatFilter>;
  _sum?: Maybe<NestedFloatFilter>;
  equals?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  in?: Maybe<Array<Scalars['Float']>>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  not?: Maybe<NestedFloatWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['Float']>>;
};

export type FuzzySearch = {
  keys: Array<Scalars['String']>;
  text: Scalars['String'];
};

export type GeneratedCertificateData = {
  __typename?: 'GeneratedCertificateData';
  bulkCertificateRecordId: Scalars['String'];
  certificateId?: Maybe<Scalars['String']>;
  institutionId: Scalars['Int'];
  totalCertificates: Scalars['Int'];
  totalIssued: Scalars['Int'];
};

export type GroupEmails = {
  /** If one item was undefined, it will be considered e-CNPJ */
  emails: Array<Maybe<Scalars['String']>>;
};

export type InitializeResponseInput = {
  dataToSign: Scalars['String'];
  lastSignatureIsoString: Scalars['String'];
  signingTime: Scalars['String'];
};

export type InputFinancialPurchaseCreditCard = {
  fields: InputFinancialPurchaseCreditCardFields;
  save: Scalars['Boolean'];
};

export type InputFinancialPurchaseCreditCardFields = {
  addressComplement: Scalars['String'];
  addressNumber: Scalars['String'];
  adressCep: Scalars['String'];
  cpfCnpj: Scalars['String'];
  cvc: Scalars['String'];
  email: Scalars['String'];
  expiry: Scalars['String'];
  name: Scalars['String'];
  number: Scalars['String'];
  phone: Scalars['String'];
};

export type InputFinancialPurchaseSavedCreditCard = {
  idCard: Scalars['Int'];
};

export enum InstitutionActionMethod {
  Activate = 'ACTIVATE',
  Inactivate = 'INACTIVATE'
}

export type IntFieldUpdateOperationsInput = {
  decrement?: Maybe<Scalars['Int']>;
  divide?: Maybe<Scalars['Int']>;
  increment?: Maybe<Scalars['Int']>;
  multiply?: Maybe<Scalars['Int']>;
  set?: Maybe<Scalars['Int']>;
};

export type IntFilter = {
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type IntNullableFilter = {
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntNullableFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type IntNullableWithAggregatesFilter = {
  _avg?: Maybe<NestedFloatNullableFilter>;
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedIntNullableFilter>;
  _min?: Maybe<NestedIntNullableFilter>;
  _sum?: Maybe<NestedIntNullableFilter>;
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type IntWithAggregatesFilter = {
  _avg?: Maybe<NestedFloatFilter>;
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedIntFilter>;
  _min?: Maybe<NestedIntFilter>;
  _sum?: Maybe<NestedIntFilter>;
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type InviteGroups = {
  groups: Array<GroupEmails>;
  id: Scalars['String'];
};


export type JsonFilter = {
  array_contains?: Maybe<Scalars['Json']>;
  array_ends_with?: Maybe<Scalars['Json']>;
  array_starts_with?: Maybe<Scalars['Json']>;
  equals?: Maybe<Scalars['Json']>;
  gt?: Maybe<Scalars['Json']>;
  gte?: Maybe<Scalars['Json']>;
  lt?: Maybe<Scalars['Json']>;
  lte?: Maybe<Scalars['Json']>;
  not?: Maybe<Scalars['Json']>;
  path?: Maybe<Array<Scalars['String']>>;
  string_contains?: Maybe<Scalars['String']>;
  string_ends_with?: Maybe<Scalars['String']>;
  string_starts_with?: Maybe<Scalars['String']>;
};

export enum JsonNullValueFilter {
  AnyNull = 'AnyNull',
  DbNull = 'DbNull',
  JsonNull = 'JsonNull'
}

export enum JsonNullValueInput {
  JsonNull = 'JsonNull'
}

export type JsonNullableFilter = {
  array_contains?: Maybe<Scalars['Json']>;
  array_ends_with?: Maybe<Scalars['Json']>;
  array_starts_with?: Maybe<Scalars['Json']>;
  equals?: Maybe<Scalars['Json']>;
  gt?: Maybe<Scalars['Json']>;
  gte?: Maybe<Scalars['Json']>;
  lt?: Maybe<Scalars['Json']>;
  lte?: Maybe<Scalars['Json']>;
  not?: Maybe<Scalars['Json']>;
  path?: Maybe<Array<Scalars['String']>>;
  string_contains?: Maybe<Scalars['String']>;
  string_ends_with?: Maybe<Scalars['String']>;
  string_starts_with?: Maybe<Scalars['String']>;
};

export type JsonNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedJsonNullableFilter>;
  _min?: Maybe<NestedJsonNullableFilter>;
  array_contains?: Maybe<Scalars['Json']>;
  array_ends_with?: Maybe<Scalars['Json']>;
  array_starts_with?: Maybe<Scalars['Json']>;
  equals?: Maybe<Scalars['Json']>;
  gt?: Maybe<Scalars['Json']>;
  gte?: Maybe<Scalars['Json']>;
  lt?: Maybe<Scalars['Json']>;
  lte?: Maybe<Scalars['Json']>;
  not?: Maybe<Scalars['Json']>;
  path?: Maybe<Array<Scalars['String']>>;
  string_contains?: Maybe<Scalars['String']>;
  string_ends_with?: Maybe<Scalars['String']>;
  string_starts_with?: Maybe<Scalars['String']>;
};

export type JsonWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedJsonFilter>;
  _min?: Maybe<NestedJsonFilter>;
  array_contains?: Maybe<Scalars['Json']>;
  array_ends_with?: Maybe<Scalars['Json']>;
  array_starts_with?: Maybe<Scalars['Json']>;
  equals?: Maybe<Scalars['Json']>;
  gt?: Maybe<Scalars['Json']>;
  gte?: Maybe<Scalars['Json']>;
  lt?: Maybe<Scalars['Json']>;
  lte?: Maybe<Scalars['Json']>;
  not?: Maybe<Scalars['Json']>;
  path?: Maybe<Array<Scalars['String']>>;
  string_contains?: Maybe<Scalars['String']>;
  string_ends_with?: Maybe<Scalars['String']>;
  string_starts_with?: Maybe<Scalars['String']>;
};

export type KeyValue = {
  __typename?: 'KeyValue';
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type Maintainer = {
  __typename?: 'Maintainer';
  MainTeam: Team;
  MaintainerAdmin: Array<MaintainerAdmin>;
  Teams: Array<Team>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  mainTeamId: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type MaintainerMaintainerAdminArgs = {
  cursor?: Maybe<MaintainerAdminWhereUniqueInput>;
  distinct?: Maybe<Array<MaintainerAdminScalarFieldEnum>>;
  orderBy?: Maybe<Array<MaintainerAdminOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MaintainerAdminWhereInput>;
};


export type MaintainerTeamsArgs = {
  cursor?: Maybe<TeamWhereUniqueInput>;
  distinct?: Maybe<Array<TeamScalarFieldEnum>>;
  orderBy?: Maybe<Array<TeamOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TeamWhereInput>;
};

export type MaintainerAdmin = {
  __typename?: 'MaintainerAdmin';
  Maintainer: Maintainer;
  User: CommonUser;
  commonUserId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  maintainerId: Scalars['Int'];
};

export type MaintainerAdminAvgOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  maintainerId?: Maybe<SortOrder>;
};

export type MaintainerAdminCountOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  maintainerId?: Maybe<SortOrder>;
};

export type MaintainerAdminCreateInput = {
  Maintainer: MaintainerCreateNestedOneWithoutMaintainerAdminInput;
  User: CommonUserCreateNestedOneWithoutMaintainerAdminInput;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type MaintainerAdminCreateManyInput = {
  commonUserId: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  maintainerId: Scalars['Int'];
};

export type MaintainerAdminCreateManyMaintainerInput = {
  commonUserId: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type MaintainerAdminCreateManyMaintainerInputEnvelope = {
  data: Array<MaintainerAdminCreateManyMaintainerInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type MaintainerAdminCreateNestedManyWithoutMaintainerInput = {
  connect?: Maybe<Array<MaintainerAdminWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MaintainerAdminCreateOrConnectWithoutMaintainerInput>>;
  create?: Maybe<Array<MaintainerAdminCreateWithoutMaintainerInput>>;
  createMany?: Maybe<MaintainerAdminCreateManyMaintainerInputEnvelope>;
};

export type MaintainerAdminCreateNestedOneWithoutUserInput = {
  connect?: Maybe<MaintainerAdminWhereUniqueInput>;
  connectOrCreate?: Maybe<MaintainerAdminCreateOrConnectWithoutUserInput>;
  create?: Maybe<MaintainerAdminCreateWithoutUserInput>;
};

export type MaintainerAdminCreateOrConnectWithoutMaintainerInput = {
  create: MaintainerAdminCreateWithoutMaintainerInput;
  where: MaintainerAdminWhereUniqueInput;
};

export type MaintainerAdminCreateOrConnectWithoutUserInput = {
  create: MaintainerAdminCreateWithoutUserInput;
  where: MaintainerAdminWhereUniqueInput;
};

export type MaintainerAdminCreateWithoutMaintainerInput = {
  User: CommonUserCreateNestedOneWithoutMaintainerAdminInput;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type MaintainerAdminCreateWithoutUserInput = {
  Maintainer: MaintainerCreateNestedOneWithoutMaintainerAdminInput;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type MaintainerAdminListRelationFilter = {
  every?: Maybe<MaintainerAdminWhereInput>;
  none?: Maybe<MaintainerAdminWhereInput>;
  some?: Maybe<MaintainerAdminWhereInput>;
};

export type MaintainerAdminMaxOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  maintainerId?: Maybe<SortOrder>;
};

export type MaintainerAdminMinOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  maintainerId?: Maybe<SortOrder>;
};

export type MaintainerAdminNullableRelationFilter = {
  is?: Maybe<MaintainerAdminWhereInput>;
  isNot?: Maybe<MaintainerAdminWhereInput>;
};

export type MaintainerAdminOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type MaintainerAdminOrderByWithAggregationInput = {
  _avg?: Maybe<MaintainerAdminAvgOrderByAggregateInput>;
  _count?: Maybe<MaintainerAdminCountOrderByAggregateInput>;
  _max?: Maybe<MaintainerAdminMaxOrderByAggregateInput>;
  _min?: Maybe<MaintainerAdminMinOrderByAggregateInput>;
  _sum?: Maybe<MaintainerAdminSumOrderByAggregateInput>;
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  maintainerId?: Maybe<SortOrder>;
};

export type MaintainerAdminOrderByWithRelationInput = {
  Maintainer?: Maybe<MaintainerOrderByWithRelationInput>;
  User?: Maybe<CommonUserOrderByWithRelationInput>;
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  maintainerId?: Maybe<SortOrder>;
};

export enum MaintainerAdminScalarFieldEnum {
  CommonUserId = 'commonUserId',
  CreatedAt = 'createdAt',
  MaintainerId = 'maintainerId'
}

export type MaintainerAdminScalarWhereInput = {
  AND?: Maybe<Array<MaintainerAdminScalarWhereInput>>;
  NOT?: Maybe<Array<MaintainerAdminScalarWhereInput>>;
  OR?: Maybe<Array<MaintainerAdminScalarWhereInput>>;
  commonUserId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  maintainerId?: Maybe<IntFilter>;
};

export type MaintainerAdminScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<MaintainerAdminScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<MaintainerAdminScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<MaintainerAdminScalarWhereWithAggregatesInput>>;
  commonUserId?: Maybe<IntWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  maintainerId?: Maybe<IntWithAggregatesFilter>;
};

export type MaintainerAdminSumOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  maintainerId?: Maybe<SortOrder>;
};

export type MaintainerAdminUpdateInput = {
  Maintainer?: Maybe<MaintainerUpdateOneRequiredWithoutMaintainerAdminNestedInput>;
  User?: Maybe<CommonUserUpdateOneRequiredWithoutMaintainerAdminNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type MaintainerAdminUpdateManyMutationInput = {
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type MaintainerAdminUpdateManyWithWhereWithoutMaintainerInput = {
  data: MaintainerAdminUpdateManyMutationInput;
  where: MaintainerAdminScalarWhereInput;
};

export type MaintainerAdminUpdateManyWithoutMaintainerNestedInput = {
  connect?: Maybe<Array<MaintainerAdminWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<MaintainerAdminCreateOrConnectWithoutMaintainerInput>>;
  create?: Maybe<Array<MaintainerAdminCreateWithoutMaintainerInput>>;
  createMany?: Maybe<MaintainerAdminCreateManyMaintainerInputEnvelope>;
  delete?: Maybe<Array<MaintainerAdminWhereUniqueInput>>;
  deleteMany?: Maybe<Array<MaintainerAdminScalarWhereInput>>;
  disconnect?: Maybe<Array<MaintainerAdminWhereUniqueInput>>;
  set?: Maybe<Array<MaintainerAdminWhereUniqueInput>>;
  update?: Maybe<Array<MaintainerAdminUpdateWithWhereUniqueWithoutMaintainerInput>>;
  updateMany?: Maybe<Array<MaintainerAdminUpdateManyWithWhereWithoutMaintainerInput>>;
  upsert?: Maybe<Array<MaintainerAdminUpsertWithWhereUniqueWithoutMaintainerInput>>;
};

export type MaintainerAdminUpdateOneWithoutUserNestedInput = {
  connect?: Maybe<MaintainerAdminWhereUniqueInput>;
  connectOrCreate?: Maybe<MaintainerAdminCreateOrConnectWithoutUserInput>;
  create?: Maybe<MaintainerAdminCreateWithoutUserInput>;
  delete?: Maybe<MaintainerAdminWhereInput>;
  disconnect?: Maybe<MaintainerAdminWhereInput>;
  update?: Maybe<MaintainerAdminUpdateToOneWithWhereWithoutUserInput>;
  upsert?: Maybe<MaintainerAdminUpsertWithoutUserInput>;
};

export type MaintainerAdminUpdateToOneWithWhereWithoutUserInput = {
  data: MaintainerAdminUpdateWithoutUserInput;
  where?: Maybe<MaintainerAdminWhereInput>;
};

export type MaintainerAdminUpdateWithWhereUniqueWithoutMaintainerInput = {
  data: MaintainerAdminUpdateWithoutMaintainerInput;
  where: MaintainerAdminWhereUniqueInput;
};

export type MaintainerAdminUpdateWithoutMaintainerInput = {
  User?: Maybe<CommonUserUpdateOneRequiredWithoutMaintainerAdminNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type MaintainerAdminUpdateWithoutUserInput = {
  Maintainer?: Maybe<MaintainerUpdateOneRequiredWithoutMaintainerAdminNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type MaintainerAdminUpsertWithWhereUniqueWithoutMaintainerInput = {
  create: MaintainerAdminCreateWithoutMaintainerInput;
  update: MaintainerAdminUpdateWithoutMaintainerInput;
  where: MaintainerAdminWhereUniqueInput;
};

export type MaintainerAdminUpsertWithoutUserInput = {
  create: MaintainerAdminCreateWithoutUserInput;
  update: MaintainerAdminUpdateWithoutUserInput;
  where?: Maybe<MaintainerAdminWhereInput>;
};

export type MaintainerAdminWhereInput = {
  AND?: Maybe<Array<MaintainerAdminWhereInput>>;
  Maintainer?: Maybe<MaintainerWhereInput>;
  NOT?: Maybe<Array<MaintainerAdminWhereInput>>;
  OR?: Maybe<Array<MaintainerAdminWhereInput>>;
  User?: Maybe<CommonUserWhereInput>;
  commonUserId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  maintainerId?: Maybe<IntFilter>;
};

export type MaintainerAdminWhereUniqueInput = {
  AND?: Maybe<Array<MaintainerAdminWhereInput>>;
  Maintainer?: Maybe<MaintainerWhereInput>;
  NOT?: Maybe<Array<MaintainerAdminWhereInput>>;
  OR?: Maybe<Array<MaintainerAdminWhereInput>>;
  User?: Maybe<CommonUserWhereInput>;
  commonUserId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<DateTimeFilter>;
  maintainerId?: Maybe<IntFilter>;
};

export type MaintainerAvgOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  mainTeamId?: Maybe<SortOrder>;
};

export type MaintainerCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  mainTeamId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type MaintainerCreateInput = {
  MainTeam: TeamCreateNestedOneWithoutMainTeamOfMaintainerInput;
  MaintainerAdmin?: Maybe<MaintainerAdminCreateNestedManyWithoutMaintainerInput>;
  Teams?: Maybe<TeamCreateNestedManyWithoutMaintainerInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MaintainerCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  mainTeamId: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MaintainerCreateNestedOneWithoutMainTeamInput = {
  connect?: Maybe<MaintainerWhereUniqueInput>;
  connectOrCreate?: Maybe<MaintainerCreateOrConnectWithoutMainTeamInput>;
  create?: Maybe<MaintainerCreateWithoutMainTeamInput>;
};

export type MaintainerCreateNestedOneWithoutMaintainerAdminInput = {
  connect?: Maybe<MaintainerWhereUniqueInput>;
  connectOrCreate?: Maybe<MaintainerCreateOrConnectWithoutMaintainerAdminInput>;
  create?: Maybe<MaintainerCreateWithoutMaintainerAdminInput>;
};

export type MaintainerCreateNestedOneWithoutTeamsInput = {
  connect?: Maybe<MaintainerWhereUniqueInput>;
  connectOrCreate?: Maybe<MaintainerCreateOrConnectWithoutTeamsInput>;
  create?: Maybe<MaintainerCreateWithoutTeamsInput>;
};

export type MaintainerCreateOrConnectWithoutMainTeamInput = {
  create: MaintainerCreateWithoutMainTeamInput;
  where: MaintainerWhereUniqueInput;
};

export type MaintainerCreateOrConnectWithoutMaintainerAdminInput = {
  create: MaintainerCreateWithoutMaintainerAdminInput;
  where: MaintainerWhereUniqueInput;
};

export type MaintainerCreateOrConnectWithoutTeamsInput = {
  create: MaintainerCreateWithoutTeamsInput;
  where: MaintainerWhereUniqueInput;
};

export type MaintainerCreateWithoutMainTeamInput = {
  MaintainerAdmin?: Maybe<MaintainerAdminCreateNestedManyWithoutMaintainerInput>;
  Teams?: Maybe<TeamCreateNestedManyWithoutMaintainerInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MaintainerCreateWithoutMaintainerAdminInput = {
  MainTeam: TeamCreateNestedOneWithoutMainTeamOfMaintainerInput;
  Teams?: Maybe<TeamCreateNestedManyWithoutMaintainerInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MaintainerCreateWithoutTeamsInput = {
  MainTeam: TeamCreateNestedOneWithoutMainTeamOfMaintainerInput;
  MaintainerAdmin?: Maybe<MaintainerAdminCreateNestedManyWithoutMaintainerInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MaintainerMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  mainTeamId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type MaintainerMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  mainTeamId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type MaintainerNullableRelationFilter = {
  is?: Maybe<MaintainerWhereInput>;
  isNot?: Maybe<MaintainerWhereInput>;
};

export type MaintainerOrderByWithAggregationInput = {
  _avg?: Maybe<MaintainerAvgOrderByAggregateInput>;
  _count?: Maybe<MaintainerCountOrderByAggregateInput>;
  _max?: Maybe<MaintainerMaxOrderByAggregateInput>;
  _min?: Maybe<MaintainerMinOrderByAggregateInput>;
  _sum?: Maybe<MaintainerSumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  mainTeamId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type MaintainerOrderByWithRelationInput = {
  MainTeam?: Maybe<TeamOrderByWithRelationInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminOrderByRelationAggregateInput>;
  Teams?: Maybe<TeamOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  mainTeamId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type MaintainerRelationFilter = {
  is?: Maybe<MaintainerWhereInput>;
  isNot?: Maybe<MaintainerWhereInput>;
};

export enum MaintainerScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  MainTeamId = 'mainTeamId',
  UpdatedAt = 'updatedAt'
}

export type MaintainerScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<MaintainerScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<MaintainerScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<MaintainerScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  mainTeamId?: Maybe<IntWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
};

export type MaintainerSumOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  mainTeamId?: Maybe<SortOrder>;
};

export type MaintainerUpdateInput = {
  MainTeam?: Maybe<TeamUpdateOneRequiredWithoutMainTeamOfMaintainerNestedInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminUpdateManyWithoutMaintainerNestedInput>;
  Teams?: Maybe<TeamUpdateManyWithoutMaintainerNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type MaintainerUpdateManyMutationInput = {
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type MaintainerUpdateOneRequiredWithoutMaintainerAdminNestedInput = {
  connect?: Maybe<MaintainerWhereUniqueInput>;
  connectOrCreate?: Maybe<MaintainerCreateOrConnectWithoutMaintainerAdminInput>;
  create?: Maybe<MaintainerCreateWithoutMaintainerAdminInput>;
  update?: Maybe<MaintainerUpdateToOneWithWhereWithoutMaintainerAdminInput>;
  upsert?: Maybe<MaintainerUpsertWithoutMaintainerAdminInput>;
};

export type MaintainerUpdateOneWithoutMainTeamNestedInput = {
  connect?: Maybe<MaintainerWhereUniqueInput>;
  connectOrCreate?: Maybe<MaintainerCreateOrConnectWithoutMainTeamInput>;
  create?: Maybe<MaintainerCreateWithoutMainTeamInput>;
  delete?: Maybe<MaintainerWhereInput>;
  disconnect?: Maybe<MaintainerWhereInput>;
  update?: Maybe<MaintainerUpdateToOneWithWhereWithoutMainTeamInput>;
  upsert?: Maybe<MaintainerUpsertWithoutMainTeamInput>;
};

export type MaintainerUpdateOneWithoutTeamsNestedInput = {
  connect?: Maybe<MaintainerWhereUniqueInput>;
  connectOrCreate?: Maybe<MaintainerCreateOrConnectWithoutTeamsInput>;
  create?: Maybe<MaintainerCreateWithoutTeamsInput>;
  delete?: Maybe<MaintainerWhereInput>;
  disconnect?: Maybe<MaintainerWhereInput>;
  update?: Maybe<MaintainerUpdateToOneWithWhereWithoutTeamsInput>;
  upsert?: Maybe<MaintainerUpsertWithoutTeamsInput>;
};

export type MaintainerUpdateToOneWithWhereWithoutMainTeamInput = {
  data: MaintainerUpdateWithoutMainTeamInput;
  where?: Maybe<MaintainerWhereInput>;
};

export type MaintainerUpdateToOneWithWhereWithoutMaintainerAdminInput = {
  data: MaintainerUpdateWithoutMaintainerAdminInput;
  where?: Maybe<MaintainerWhereInput>;
};

export type MaintainerUpdateToOneWithWhereWithoutTeamsInput = {
  data: MaintainerUpdateWithoutTeamsInput;
  where?: Maybe<MaintainerWhereInput>;
};

export type MaintainerUpdateWithoutMainTeamInput = {
  MaintainerAdmin?: Maybe<MaintainerAdminUpdateManyWithoutMaintainerNestedInput>;
  Teams?: Maybe<TeamUpdateManyWithoutMaintainerNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type MaintainerUpdateWithoutMaintainerAdminInput = {
  MainTeam?: Maybe<TeamUpdateOneRequiredWithoutMainTeamOfMaintainerNestedInput>;
  Teams?: Maybe<TeamUpdateManyWithoutMaintainerNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type MaintainerUpdateWithoutTeamsInput = {
  MainTeam?: Maybe<TeamUpdateOneRequiredWithoutMainTeamOfMaintainerNestedInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminUpdateManyWithoutMaintainerNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type MaintainerUpsertWithoutMainTeamInput = {
  create: MaintainerCreateWithoutMainTeamInput;
  update: MaintainerUpdateWithoutMainTeamInput;
  where?: Maybe<MaintainerWhereInput>;
};

export type MaintainerUpsertWithoutMaintainerAdminInput = {
  create: MaintainerCreateWithoutMaintainerAdminInput;
  update: MaintainerUpdateWithoutMaintainerAdminInput;
  where?: Maybe<MaintainerWhereInput>;
};

export type MaintainerUpsertWithoutTeamsInput = {
  create: MaintainerCreateWithoutTeamsInput;
  update: MaintainerUpdateWithoutTeamsInput;
  where?: Maybe<MaintainerWhereInput>;
};

export type MaintainerWhereInput = {
  AND?: Maybe<Array<MaintainerWhereInput>>;
  MainTeam?: Maybe<TeamWhereInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminListRelationFilter>;
  NOT?: Maybe<Array<MaintainerWhereInput>>;
  OR?: Maybe<Array<MaintainerWhereInput>>;
  Teams?: Maybe<TeamListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  mainTeamId?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
};

export type MaintainerWhereUniqueInput = {
  AND?: Maybe<Array<MaintainerWhereInput>>;
  MainTeam?: Maybe<TeamWhereInput>;
  MaintainerAdmin?: Maybe<MaintainerAdminListRelationFilter>;
  NOT?: Maybe<Array<MaintainerWhereInput>>;
  OR?: Maybe<Array<MaintainerWhereInput>>;
  Teams?: Maybe<TeamListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['Int']>;
  mainTeamId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addOneTeamMember: TeamMember;
  buildOneDegreeVisualRepresentation?: Maybe<DocumentDegree>;
  /**
   * Essa mutation deve produzir o login em 3 fluxos possíveis:
   *
   * 1. Login via LedgerSign, fornecendo o token recebido no LedgerSign
   * 2. Login através da funcionalidade "Login como", fornecendo o email no lugar do token
   * 3. Login através de devs em desenvolvimento, fornecendo o email no lugar do token
   */
  codeAuthLoginLedgerSign: CommonUser;
  codeAuthRefreshTokens: CommonUser;
  /**
   * Recria o XML para re-assinatura do documento.
   * 1. Faz o build do XML
   * 2. Deleta as assinaturas "realizadas"
   */
  codeDevRebuildXml: Scalars['Boolean'];
  codeDevSetFullPermissions: Scalars['String'];
  codeServiceSendMessageToSlack: Scalars['String'];
  /** Conclui o cadastro de uma assinatura pelo celular */
  completeOneTemporarySignatureImage: SignSignatureImage;
  /** Correção de arquivo de fiscalização e envio para revisão */
  correctOneDocumentAuditFileIssuer: DocumentAuditFileIssuer;
  createApiKey: Scalars['String'];
  createBulkDocumentCertificate: BulkCertificateRecord;
  createManyAddress: Array<Address>;
  createManyBulkCertificateRecord: Array<BulkCertificateRecord>;
  createManyCertificateCurriculumSelectedDiscipline: Array<CertificateCurriculumSelectedDiscipline>;
  createManyDocumentAcademicDocumentationSearchView: Array<DocumentAcademicDocumentationSearchView>;
  createManyDocumentAuditFileIssuerDegreeItem: Array<DocumentAuditFileIssuerDegreeItem>;
  createManyDocumentBaseDefaultSignatureInviteConfigurationGroup: Array<DocumentBaseDefaultSignatureInviteConfigurationGroup>;
  createManyDocumentBaseDefaultSignatureInviteConfigurationGroupItem: Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItem>;
  createManyDocumentBaseHistory: Array<DocumentBaseHistory>;
  createManyDocumentBaseSignatureInvite: Array<DocumentBaseSignatureInvite>;
  createManyDocumentBaseSignatureInviteGroup: Array<DocumentBaseSignatureInviteGroup>;
  createManyDocumentBaseSignatureInviteSignature: Array<DocumentBaseSignatureInviteSignature>;
  createManyDocumentCertificateHashHistory: Array<DocumentCertificateHashHistory>;
  createManyDocumentCertificateMetadata: Array<DocumentCertificateMetadata>;
  createManyDocumentCertificateSignatureItem: Array<DocumentCertificateSignatureItem>;
  createManyDocumentCertificateSignatureItemPossibleSignerInvite: Array<DocumentCertificateSignatureItemPossibleSignerInvite>;
  createManyDocumentCertificateSignatureItemPossibleSignerInviteSignature: Array<DocumentCertificateSignatureItemPossibleSignerInviteSignature>;
  createManyDocumentDegreeSearchView: Array<DocumentDegreeSearchView>;
  createManyDocumentFinalAcademicTranscriptView: Array<DocumentFinalAcademicTranscriptView>;
  createManyExternalSignatureInvite: Array<ExternalSignatureInvite>;
  createManyFinancialPayment: Array<FinancialPayment>;
  createManyFinancialTeamSignupSelectedOptions: Array<FinancialTeamSignupSelectedOptions>;
  createManyFinancialTeamWallet: Array<FinancialTeamWallet>;
  createManyFinancialTeamWalletSubscription: Array<FinancialTeamWalletSubscription>;
  createManyFinancialTeamWalletSubscriptionPayment: Array<FinancialTeamWalletSubscriptionPayment>;
  createManyFinancialTeamWalletSubscriptionPaymentHistory: Array<FinancialTeamWalletSubscriptionPaymentHistory>;
  createManyPermission: Array<Permission>;
  createManySystemGlobalAlertUserDismiss: Array<SystemGlobalAlertUserDismiss>;
  createManySystemLog: Array<SystemLog>;
  createManyTeamEducationLevel: Array<TeamEducationLevel>;
  createManyTeamMemberPermission: Array<TeamMemberPermission>;
  createManyTelephone: Array<Telephone>;
  createOneAddress: Address;
  createOneBulkCertificateRecord: BulkCertificateRecord;
  createOneCertificateCourse: CertificateCourse;
  createOneCertificateCourseLevel: CertificateCourseLevel;
  createOneCertificateCurriculum: CertificateCurriculum;
  createOneCertificateCurriculumSelectedDiscipline: CertificateCurriculumSelectedDiscipline;
  createOneCertificateDiscipline: CertificateDiscipline;
  createOneCertificateEvent: CertificateEvent;
  createOneCertificateTeacher: CertificateTeacher;
  createOneCertificateTemplate: CertificateTemplate;
  createOneDegree: DocumentDegree;
  /** Finalização da documentação acadêmica e envio para revisão */
  createOneDocumentAcademicDocumentation: DocumentAcademicDocumentation;
  createOneDocumentAcademicDocumentationFromRevokedDocument: DocumentAcademicDocumentation;
  createOneDocumentAcademicDocumentationSearchView: DocumentAcademicDocumentationSearchView;
  /** Finalização do arquivo de fiscalização e envio para revisão */
  createOneDocumentAuditFileIssuer: DocumentAuditFileIssuer;
  createOneDocumentAuditFileIssuerDegreeItem: DocumentAuditFileIssuerDegreeItem;
  createOneDocumentBaseDefaultSignatureInviteConfigurationGroup: DocumentBaseDefaultSignatureInviteConfigurationGroup;
  createOneDocumentBaseDefaultSignatureInviteConfigurationGroupItem: DocumentBaseDefaultSignatureInviteConfigurationGroupItem;
  createOneDocumentBaseHistory: DocumentBaseHistory;
  createOneDocumentBaseSignatureInvite: DocumentBaseSignatureInvite;
  createOneDocumentBaseSignatureInviteGroup: DocumentBaseSignatureInviteGroup;
  createOneDocumentBaseSignatureInviteSignature: DocumentBaseSignatureInviteSignature;
  createOneDocumentCertificate: DocumentCertificate;
  createOneDocumentCertificateHashHistory: DocumentCertificateHashHistory;
  createOneDocumentCertificateMetadata: DocumentCertificateMetadata;
  createOneDocumentCertificatePreview: Scalars['String'];
  createOneDocumentCertificateSignatureItem: DocumentCertificateSignatureItem;
  createOneDocumentCertificateSignatureItemPossibleSignerInvite: DocumentCertificateSignatureItemPossibleSignerInvite;
  createOneDocumentCertificateSignatureItemPossibleSignerInviteSignature: DocumentCertificateSignatureItemPossibleSignerInviteSignature;
  createOneDocumentDegreeSearchView: DocumentDegreeSearchView;
  createOneDocumentFinalAcademicTranscript: DocumentFinalAcademicTranscript;
  createOneDocumentFinalAcademicTranscriptView: DocumentFinalAcademicTranscriptView;
  /** Finalização do curriculo escolar e envio para revisão */
  createOneDocumentSchoolCurriculum: DocumentSchoolCurriculum;
  createOneEnabledInstitution: EnabledInstitution;
  createOneExternalSignatureInvite: ExternalSignatureInvite;
  createOneFinancialPayment: FinancialPayment;
  createOneFinancialRecharge: FinancialRecharge;
  createOneFinancialTeamSignupSelectedOptions: FinancialTeamSignupSelectedOptions;
  createOneFinancialTeamWallet: FinancialTeamWallet;
  createOneFinancialTeamWalletSubscription: FinancialTeamWalletSubscription;
  createOneFinancialTeamWalletSubscriptionPayment: FinancialTeamWalletSubscriptionPayment;
  createOneFinancialTeamWalletSubscriptionPaymentHistory: FinancialTeamWalletSubscriptionPaymentHistory;
  createOneMaintainerAdmin: MaintainerAdmin;
  createOneMaintainerTeam: Team;
  createOnePermission: Permission;
  createOnePerson: Person;
  createOneReusableFormDataCurriculum: ReusableFormDataCurriculum;
  createOneSignSignatureImage: SignSignatureImage;
  createOneSystemGlobalAlert: SystemGlobalAlert;
  createOneSystemGlobalAlertUserDismiss: SystemGlobalAlertUserDismiss;
  createOneSystemLog: SystemLog;
  createOneTeamEducationLevel: TeamEducationLevel;
  createOneTeamMemberPermission: TeamMemberPermission;
  createOneTelephone: Telephone;
  defineOneSignSignatureImageAsPrimary?: Maybe<SignSignatureImage>;
  defineSigners: Array<DocumentBaseSignatureInviteGroup>;
  deleteManyAddress?: Maybe<BatchPayload>;
  deleteManyBulkCertificateRecord?: Maybe<BatchPayload>;
  deleteManyCertificateCurriculumSelectedDiscipline?: Maybe<BatchPayload>;
  deleteManyDocumentAcademicDocumentationSearchView?: Maybe<BatchPayload>;
  deleteManyDocumentAuditFileIssuerDegreeItem?: Maybe<BatchPayload>;
  deleteManyDocumentBaseDefaultSignatureInviteConfigurationGroup?: Maybe<BatchPayload>;
  deleteManyDocumentBaseDefaultSignatureInviteConfigurationGroupItem?: Maybe<BatchPayload>;
  deleteManyDocumentBaseHistory?: Maybe<BatchPayload>;
  deleteManyDocumentBaseSignatureInvite?: Maybe<BatchPayload>;
  deleteManyDocumentBaseSignatureInviteGroup?: Maybe<BatchPayload>;
  deleteManyDocumentBaseSignatureInviteSignature?: Maybe<BatchPayload>;
  deleteManyDocumentCertificateHashHistory?: Maybe<BatchPayload>;
  deleteManyDocumentCertificateMetadata?: Maybe<BatchPayload>;
  deleteManyDocumentCertificateSignatureItem?: Maybe<BatchPayload>;
  deleteManyDocumentCertificateSignatureItemPossibleSignerInvite?: Maybe<BatchPayload>;
  deleteManyDocumentCertificateSignatureItemPossibleSignerInviteSignature?: Maybe<BatchPayload>;
  deleteManyDocumentDegreeSearchView?: Maybe<BatchPayload>;
  deleteManyDocumentFinalAcademicTranscriptView?: Maybe<BatchPayload>;
  deleteManyExternalSignatureInvite?: Maybe<BatchPayload>;
  deleteManyFinancialPayment?: Maybe<BatchPayload>;
  deleteManyFinancialTeamSignupSelectedOptions?: Maybe<BatchPayload>;
  deleteManyFinancialTeamWallet?: Maybe<BatchPayload>;
  deleteManyFinancialTeamWalletSubscription?: Maybe<BatchPayload>;
  deleteManyFinancialTeamWalletSubscriptionPayment?: Maybe<BatchPayload>;
  deleteManyFinancialTeamWalletSubscriptionPaymentHistory?: Maybe<BatchPayload>;
  deleteManyPermission?: Maybe<BatchPayload>;
  deleteManySystemGlobalAlertUserDismiss?: Maybe<BatchPayload>;
  deleteManySystemLog?: Maybe<BatchPayload>;
  deleteManyTeamEducationLevel?: Maybe<BatchPayload>;
  deleteManyTeamMemberPermission?: Maybe<BatchPayload>;
  deleteManyTelephone?: Maybe<BatchPayload>;
  deleteOneAddress?: Maybe<Address>;
  deleteOneApiKey?: Maybe<ApiKey>;
  deleteOneBulkCertificateRecord?: Maybe<BulkCertificateRecord>;
  deleteOneCertificateBase?: Maybe<CertificateBase>;
  deleteOneCertificateCurriculumSelectedDiscipline?: Maybe<CertificateCurriculumSelectedDiscipline>;
  deleteOneCertificateTemplate?: Maybe<CertificateTemplate>;
  deleteOneDegreeVisualRepresentation?: Maybe<DocumentDegree>;
  deleteOneDocumentAcademicDocumentationSearchView?: Maybe<DocumentAcademicDocumentationSearchView>;
  deleteOneDocumentAuditFileIssuerDegreeItem?: Maybe<DocumentAuditFileIssuerDegreeItem>;
  deleteOneDocumentBase?: Maybe<DocumentBase>;
  deleteOneDocumentBaseDefaultSignatureInviteConfiguration: DocumentBaseDefaultSignatureInviteConfiguration;
  deleteOneDocumentBaseDefaultSignatureInviteConfigurationGroup?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroup>;
  deleteOneDocumentBaseDefaultSignatureInviteConfigurationGroupItem?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItem>;
  deleteOneDocumentBaseHistory?: Maybe<DocumentBaseHistory>;
  deleteOneDocumentBaseSignatureInvite?: Maybe<DocumentBaseSignatureInvite>;
  deleteOneDocumentBaseSignatureInviteGroup?: Maybe<DocumentBaseSignatureInviteGroup>;
  deleteOneDocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignature>;
  deleteOneDocumentCertificateHashHistory?: Maybe<DocumentCertificateHashHistory>;
  deleteOneDocumentCertificateMetadata?: Maybe<DocumentCertificateMetadata>;
  deleteOneDocumentCertificateSignatureItem?: Maybe<DocumentCertificateSignatureItem>;
  deleteOneDocumentCertificateSignatureItemPossibleSignerInvite?: Maybe<DocumentCertificateSignatureItemPossibleSignerInvite>;
  deleteOneDocumentCertificateSignatureItemPossibleSignerInviteSignature?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteSignature>;
  deleteOneDocumentDegreeSearchView?: Maybe<DocumentDegreeSearchView>;
  deleteOneDocumentFinalAcademicTranscriptView?: Maybe<DocumentFinalAcademicTranscriptView>;
  deleteOneExternalSignatureInvite?: Maybe<ExternalSignatureInvite>;
  deleteOneFinancialCreditCardSaved?: Maybe<FinancialCreditCardSaved>;
  deleteOneFinancialPayment?: Maybe<FinancialPayment>;
  deleteOneFinancialTeamSignupSelectedOptions?: Maybe<FinancialTeamSignupSelectedOptions>;
  deleteOneFinancialTeamWallet?: Maybe<FinancialTeamWallet>;
  deleteOneFinancialTeamWalletSubscription?: Maybe<FinancialTeamWalletSubscription>;
  deleteOneFinancialTeamWalletSubscriptionPayment?: Maybe<FinancialTeamWalletSubscriptionPayment>;
  deleteOneFinancialTeamWalletSubscriptionPaymentHistory?: Maybe<FinancialTeamWalletSubscriptionPaymentHistory>;
  deleteOneMaintainerAdmin?: Maybe<MaintainerAdmin>;
  deleteOneMaintainerTeam?: Maybe<Team>;
  deleteOnePermission?: Maybe<Permission>;
  deleteOnePerson?: Maybe<Person>;
  deleteOneReusableFormData?: Maybe<ReusableFormData>;
  deleteOneReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculum>;
  deleteOneSignSignatureImage?: Maybe<SignSignatureImage>;
  deleteOneSystemGlobalAlert?: Maybe<SystemGlobalAlert>;
  deleteOneSystemGlobalAlertUserDismiss?: Maybe<SystemGlobalAlertUserDismiss>;
  deleteOneSystemLog?: Maybe<SystemLog>;
  deleteOneTeamEducationLevel?: Maybe<TeamEducationLevel>;
  deleteOneTeamMember?: Maybe<TeamMember>;
  deleteOneTeamMemberPermission?: Maybe<TeamMemberPermission>;
  deleteOneTelephone?: Maybe<Telephone>;
  dismissSystemGlobalAlert: Scalars['Boolean'];
  duplicateOneCertificateTemplate: CertificateTemplate;
  finalizeOneCertificateSignature: DocumentCertificateSignatureItemPossibleSignerInviteSignature;
  finalizeOneSignature: DocumentBaseSignatureInviteSignature;
  finalizeOneSignatureExternalSignatureInvite: ExternalSignatureInvite;
  financialTeamWalletActivateTrial: FinancialTeamWallet;
  financialTeamWalletPurchasePlan: PurchasedPlanWithOldPlan;
  financialTeamWalletSubscriptionCancelPlan: FinancialTeamWalletSubscription;
  /** Usado durante os testes já que não é possível assinar */
  forceGenerateDocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentation>;
  /** Usado durante os testes já que não é possível assinar */
  forceGenerateDocumentSchoolCurriculum?: Maybe<DocumentSchoolCurriculum>;
  patchOneDocumentAcademicDocumentation: Scalars['DateTime'];
  patchOneDocumentSchoolCurriculum: Scalars['DateTime'];
  payOverduePayments: FinancialTeamWalletSubscription;
  /** Finalização da documentação acadêmica e envio para revisão */
  recreateOneAcademicDocumentationXml: DocumentAcademicDocumentation;
  replaceOneDegreeVisualRepresentation?: Maybe<DocumentDegree>;
  resendOneTeamMemberEmail: TeamMember;
  revalidateOneDocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentation>;
  reviewOneDocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentation>;
  /** Revisão do arquivo de fiscalização. Se possuir razão da reprovação, então está sendo reprovado. */
  reviewOneDocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuer>;
  /** Revisão do curriculo escolar. Se possuir razão da reprovação, então está sendo reprovado. */
  reviewOneDocumentSchoolCurriculum?: Maybe<DocumentSchoolCurriculum>;
  revokeOneDocumentBase?: Maybe<DocumentBase>;
  saveOneCommonUserConfig: CommonUserConfig;
  /** Cria o rascunho de uma documentação acadêmica */
  saveOneDocumentAcademicDocumentation: DocumentAcademicDocumentation;
  /** Cria o rascunho de um curriculo escolar */
  saveOneDocumentSchoolCurriculum: DocumentSchoolCurriculum;
  saveOneReusableFormData: ReusableFormData;
  sendActivity: Scalars['String'];
  signOnlyVisualOneSignature: DocumentCertificateSignatureItemPossibleSignerInviteSignature;
  singBulkCertificateVisualRepresentation: CustomReturnType;
  startOneCertificateSignature: StartSignature;
  startOneSignature: StartSignature;
  startOneSignatureExternalSignatureInvite: StartSignature;
  updateManyAddress: BatchPayload;
  updateManyBulkCertificateRecord: BatchPayload;
  updateManyCertificateCurriculumSelectedDiscipline: BatchPayload;
  updateManyDocumentAcademicDocumentationSearchView: BatchPayload;
  updateManyDocumentAuditFileIssuerDegreeItem: BatchPayload;
  updateManyDocumentBaseDefaultSignatureInviteConfigurationGroup: BatchPayload;
  updateManyDocumentBaseDefaultSignatureInviteConfigurationGroupItem: BatchPayload;
  updateManyDocumentBaseHistory: BatchPayload;
  updateManyDocumentBaseSignatureInvite: BatchPayload;
  updateManyDocumentBaseSignatureInviteGroup: BatchPayload;
  updateManyDocumentBaseSignatureInviteSignature: BatchPayload;
  updateManyDocumentCertificateHashHistory: BatchPayload;
  updateManyDocumentCertificateMetadata: BatchPayload;
  updateManyDocumentCertificateSignatureItem: BatchPayload;
  updateManyDocumentCertificateSignatureItemPossibleSignerInvite: BatchPayload;
  updateManyDocumentCertificateSignatureItemPossibleSignerInviteSignature: BatchPayload;
  updateManyDocumentDegreeSearchView: BatchPayload;
  updateManyDocumentFinalAcademicTranscriptView: BatchPayload;
  updateManyExternalSignatureInvite: BatchPayload;
  updateManyFinancialPayment: BatchPayload;
  updateManyFinancialTeamSignupSelectedOptions: BatchPayload;
  updateManyFinancialTeamWallet: BatchPayload;
  updateManyFinancialTeamWalletSubscription: BatchPayload;
  updateManyFinancialTeamWalletSubscriptionPayment: BatchPayload;
  updateManyFinancialTeamWalletSubscriptionPaymentHistory: BatchPayload;
  updateManyPermission: BatchPayload;
  updateManySystemGlobalAlertUserDismiss: BatchPayload;
  updateManySystemLog: BatchPayload;
  updateManyTeamEducationLevel: BatchPayload;
  updateManyTeamMemberPermission: BatchPayload;
  updateManyTelephone: BatchPayload;
  updateOneAddress?: Maybe<Address>;
  updateOneBulkCertificateRecord?: Maybe<BulkCertificateRecord>;
  updateOneCertificateCourse?: Maybe<CertificateCourse>;
  updateOneCertificateCourseLevel?: Maybe<CertificateCourseLevel>;
  updateOneCertificateCurriculum?: Maybe<CertificateCurriculum>;
  updateOneCertificateCurriculumSelectedDiscipline?: Maybe<CertificateCurriculumSelectedDiscipline>;
  updateOneCertificateDiscipline?: Maybe<CertificateDiscipline>;
  updateOneCertificateEvent?: Maybe<CertificateEvent>;
  updateOneCertificateTeacher?: Maybe<CertificateTeacher>;
  updateOneCertificateTemplate?: Maybe<CertificateTemplate>;
  updateOneDegreeVisualRepresentation?: Maybe<DocumentDegree>;
  updateOneDocumentAcademicDocumentationSearchView?: Maybe<DocumentAcademicDocumentationSearchView>;
  updateOneDocumentAuditFileIssuerDegreeItem?: Maybe<DocumentAuditFileIssuerDegreeItem>;
  updateOneDocumentBaseDefaultSignatureInviteConfigurationGroup?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroup>;
  updateOneDocumentBaseDefaultSignatureInviteConfigurationGroupItem?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItem>;
  updateOneDocumentBaseHistory?: Maybe<DocumentBaseHistory>;
  updateOneDocumentBaseSignatureInvite?: Maybe<DocumentBaseSignatureInvite>;
  updateOneDocumentBaseSignatureInviteGroup?: Maybe<DocumentBaseSignatureInviteGroup>;
  updateOneDocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignature>;
  updateOneDocumentCertificateHashHistory?: Maybe<DocumentCertificateHashHistory>;
  updateOneDocumentCertificateMetadata?: Maybe<DocumentCertificateMetadata>;
  updateOneDocumentCertificateSignatureItem?: Maybe<DocumentCertificateSignatureItem>;
  updateOneDocumentCertificateSignatureItemPossibleSignerInvite?: Maybe<DocumentCertificateSignatureItemPossibleSignerInvite>;
  updateOneDocumentCertificateSignatureItemPossibleSignerInviteSignature?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteSignature>;
  updateOneDocumentDegreeSearchView?: Maybe<DocumentDegreeSearchView>;
  updateOneDocumentFinalAcademicTranscriptView?: Maybe<DocumentFinalAcademicTranscriptView>;
  updateOneExternalSignatureInvite?: Maybe<ExternalSignatureInvite>;
  updateOneFinancialPayment?: Maybe<FinancialPayment>;
  updateOneFinancialTeamSignupSelectedOptions?: Maybe<FinancialTeamSignupSelectedOptions>;
  updateOneFinancialTeamWallet?: Maybe<FinancialTeamWallet>;
  updateOneFinancialTeamWalletSubscription?: Maybe<FinancialTeamWalletSubscription>;
  updateOneFinancialTeamWalletSubscriptionPayment?: Maybe<FinancialTeamWalletSubscriptionPayment>;
  updateOneFinancialTeamWalletSubscriptionPaymentHistory?: Maybe<FinancialTeamWalletSubscriptionPaymentHistory>;
  updateOnePermission?: Maybe<Permission>;
  updateOnePerson?: Maybe<Person>;
  updateOneReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculum>;
  updateOneSystemGlobalAlert?: Maybe<SystemGlobalAlert>;
  updateOneSystemGlobalAlertUserDismiss?: Maybe<SystemGlobalAlertUserDismiss>;
  updateOneSystemLog?: Maybe<SystemLog>;
  updateOneTeam?: Maybe<Team>;
  updateOneTeamEducationLevel?: Maybe<TeamEducationLevel>;
  updateOneTeamMember?: Maybe<TeamMember>;
  updateOneTeamMemberPermission?: Maybe<TeamMemberPermission>;
  updateOneTelephone?: Maybe<Telephone>;
  updateTeamActivationStatus: Team;
  updateTeamConfigAddDocumentSignerNode?: Maybe<Team>;
  upsertDocumentBaseDefaultSignatureInviteConfiguration: DocumentBaseDefaultSignatureInviteConfiguration;
  upsertOneAddress: Address;
  upsertOneBulkCertificateRecord: BulkCertificateRecord;
  upsertOneCertificateCurriculumSelectedDiscipline: CertificateCurriculumSelectedDiscipline;
  upsertOneDocumentAcademicDocumentationSearchView: DocumentAcademicDocumentationSearchView;
  upsertOneDocumentAuditFileIssuerDegreeItem: DocumentAuditFileIssuerDegreeItem;
  upsertOneDocumentBaseDefaultSignatureInviteConfigurationGroup: DocumentBaseDefaultSignatureInviteConfigurationGroup;
  upsertOneDocumentBaseDefaultSignatureInviteConfigurationGroupItem: DocumentBaseDefaultSignatureInviteConfigurationGroupItem;
  upsertOneDocumentBaseHistory: DocumentBaseHistory;
  upsertOneDocumentBaseSignatureInvite: DocumentBaseSignatureInvite;
  upsertOneDocumentBaseSignatureInviteGroup: DocumentBaseSignatureInviteGroup;
  upsertOneDocumentBaseSignatureInviteSignature: DocumentBaseSignatureInviteSignature;
  upsertOneDocumentCertificateHashHistory: DocumentCertificateHashHistory;
  upsertOneDocumentCertificateMetadata: DocumentCertificateMetadata;
  upsertOneDocumentCertificateSignatureItem: DocumentCertificateSignatureItem;
  upsertOneDocumentCertificateSignatureItemPossibleSignerInvite: DocumentCertificateSignatureItemPossibleSignerInvite;
  upsertOneDocumentCertificateSignatureItemPossibleSignerInviteSignature: DocumentCertificateSignatureItemPossibleSignerInviteSignature;
  upsertOneDocumentDegreeSearchView: DocumentDegreeSearchView;
  upsertOneDocumentFinalAcademicTranscriptView: DocumentFinalAcademicTranscriptView;
  upsertOneExternalSignatureInvite: ExternalSignatureInvite;
  upsertOneFinancialPayment: FinancialPayment;
  upsertOneFinancialTeamSignupSelectedOptions: FinancialTeamSignupSelectedOptions;
  upsertOneFinancialTeamWallet: FinancialTeamWallet;
  upsertOneFinancialTeamWalletSubscription: FinancialTeamWalletSubscription;
  upsertOneFinancialTeamWalletSubscriptionPayment: FinancialTeamWalletSubscriptionPayment;
  upsertOneFinancialTeamWalletSubscriptionPaymentHistory: FinancialTeamWalletSubscriptionPaymentHistory;
  upsertOnePermission: Permission;
  upsertOneSystemGlobalAlertUserDismiss: SystemGlobalAlertUserDismiss;
  upsertOneSystemLog: SystemLog;
  upsertOneTeamEducationLevel: TeamEducationLevel;
  upsertOneTeamMemberPermission: TeamMemberPermission;
  upsertOneTelephone: Telephone;
  /** Cria uma assinatura temporária ou usa uma existente para poder finalizar o cadastro pelo celular */
  upsertOneTemporarySignatureImage: SignSignatureImage;
  validateOnePdfa: Scalars['Boolean'];
};


export type MutationAddOneTeamMemberArgs = {
  email: Scalars['String'];
  permissions: Array<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};


export type MutationBuildOneDegreeVisualRepresentationArgs = {
  degreeId: Scalars['String'];
  templateId: Scalars['String'];
  variables: Scalars['Json'];
};


export type MutationCodeAuthLoginLedgerSignArgs = {
  subservice: SubService;
  token: Scalars['String'];
};


export type MutationCodeAuthRefreshTokensArgs = {
  token: Scalars['String'];
};


export type MutationCodeDevRebuildXmlArgs = {
  documentIds: Array<Scalars['String']>;
};


export type MutationCodeServiceSendMessageToSlackArgs = {
  message: Scalars['String'];
};


export type MutationCompleteOneTemporarySignatureImageArgs = {
  completeData: CompleteSignatureImage;
};


export type MutationCorrectOneDocumentAuditFileIssuerArgs = {
  degreeCount: Scalars['Int'];
  documentBaseId: Scalars['String'];
  endDate: Scalars['Date'];
  excludeRevoked: Scalars['Boolean'];
  startDate: Scalars['Date'];
};


export type MutationCreateApiKeyArgs = {
  description: Scalars['String'];
};


export type MutationCreateBulkDocumentCertificateArgs = {
  bulkCertificateRecordName?: Maybe<Scalars['String']>;
  curriculumId?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  ignoreUsingExpensiveCreditsError?: Maybe<Scalars['Boolean']>;
  importedRecords: Scalars['Json'];
  templateId: Scalars['String'];
  variables: Scalars['Json'];
};


export type MutationCreateManyAddressArgs = {
  data: Array<AddressCreateInput>;
};


export type MutationCreateManyBulkCertificateRecordArgs = {
  data: Array<BulkCertificateRecordCreateInput>;
};


export type MutationCreateManyCertificateCurriculumSelectedDisciplineArgs = {
  data: Array<CertificateCurriculumSelectedDisciplineCreateInput>;
};


export type MutationCreateManyDocumentAcademicDocumentationSearchViewArgs = {
  data: Array<DocumentAcademicDocumentationSearchViewCreateInput>;
};


export type MutationCreateManyDocumentAuditFileIssuerDegreeItemArgs = {
  data: Array<DocumentAuditFileIssuerDegreeItemCreateInput>;
};


export type MutationCreateManyDocumentBaseDefaultSignatureInviteConfigurationGroupArgs = {
  data: Array<DocumentBaseDefaultSignatureInviteConfigurationGroupCreateInput>;
};


export type MutationCreateManyDocumentBaseDefaultSignatureInviteConfigurationGroupItemArgs = {
  data: Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateInput>;
};


export type MutationCreateManyDocumentBaseHistoryArgs = {
  data: Array<DocumentBaseHistoryCreateInput>;
};


export type MutationCreateManyDocumentBaseSignatureInviteArgs = {
  data: Array<DocumentBaseSignatureInviteCreateInput>;
};


export type MutationCreateManyDocumentBaseSignatureInviteGroupArgs = {
  data: Array<DocumentBaseSignatureInviteGroupCreateInput>;
};


export type MutationCreateManyDocumentBaseSignatureInviteSignatureArgs = {
  data: Array<DocumentBaseSignatureInviteSignatureCreateInput>;
};


export type MutationCreateManyDocumentCertificateHashHistoryArgs = {
  data: Array<DocumentCertificateHashHistoryCreateInput>;
};


export type MutationCreateManyDocumentCertificateMetadataArgs = {
  data: Array<DocumentCertificateMetadataCreateInput>;
};


export type MutationCreateManyDocumentCertificateSignatureItemArgs = {
  data: Array<DocumentCertificateSignatureItemCreateInput>;
};


export type MutationCreateManyDocumentCertificateSignatureItemPossibleSignerInviteArgs = {
  data: Array<DocumentCertificateSignatureItemPossibleSignerInviteCreateInput>;
};


export type MutationCreateManyDocumentCertificateSignatureItemPossibleSignerInviteSignatureArgs = {
  data: Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateInput>;
};


export type MutationCreateManyDocumentDegreeSearchViewArgs = {
  data: Array<DocumentDegreeSearchViewCreateInput>;
};


export type MutationCreateManyDocumentFinalAcademicTranscriptViewArgs = {
  data: Array<DocumentFinalAcademicTranscriptViewCreateInput>;
};


export type MutationCreateManyExternalSignatureInviteArgs = {
  data: Array<ExternalSignatureInviteCreateInput>;
};


export type MutationCreateManyFinancialPaymentArgs = {
  data: Array<FinancialPaymentCreateInput>;
};


export type MutationCreateManyFinancialTeamSignupSelectedOptionsArgs = {
  data: Array<FinancialTeamSignupSelectedOptionsCreateInput>;
};


export type MutationCreateManyFinancialTeamWalletArgs = {
  data: Array<FinancialTeamWalletCreateInput>;
};


export type MutationCreateManyFinancialTeamWalletSubscriptionArgs = {
  data: Array<FinancialTeamWalletSubscriptionCreateInput>;
};


export type MutationCreateManyFinancialTeamWalletSubscriptionPaymentArgs = {
  data: Array<FinancialTeamWalletSubscriptionPaymentCreateInput>;
};


export type MutationCreateManyFinancialTeamWalletSubscriptionPaymentHistoryArgs = {
  data: Array<FinancialTeamWalletSubscriptionPaymentHistoryCreateInput>;
};


export type MutationCreateManyPermissionArgs = {
  data: Array<PermissionCreateInput>;
};


export type MutationCreateManySystemGlobalAlertUserDismissArgs = {
  data: Array<SystemGlobalAlertUserDismissCreateInput>;
};


export type MutationCreateManySystemLogArgs = {
  data: Array<SystemLogCreateInput>;
};


export type MutationCreateManyTeamEducationLevelArgs = {
  data: Array<TeamEducationLevelCreateInput>;
};


export type MutationCreateManyTeamMemberPermissionArgs = {
  data: Array<TeamMemberPermissionCreateInput>;
};


export type MutationCreateManyTelephoneArgs = {
  data: Array<TelephoneCreateInput>;
};


export type MutationCreateOneAddressArgs = {
  data: AddressCreateInput;
};


export type MutationCreateOneBulkCertificateRecordArgs = {
  data: BulkCertificateRecordCreateInput;
};


export type MutationCreateOneCertificateCourseArgs = {
  areaKnowledge: Scalars['String'];
  courseLevelId?: Maybe<Scalars['String']>;
  metaData: Array<Scalars['String']>;
  name: Scalars['String'];
};


export type MutationCreateOneCertificateCourseLevelArgs = {
  name: Scalars['String'];
};


export type MutationCreateOneCertificateCurriculumArgs = {
  amountOfHours?: Maybe<Scalars['Int']>;
  certificateCourseId: Scalars['String'];
  name: Scalars['String'];
  selectedDisciplines: Array<CirriculumSelectedDiscipline>;
};


export type MutationCreateOneCertificateCurriculumSelectedDisciplineArgs = {
  data: CertificateCurriculumSelectedDisciplineCreateInput;
};


export type MutationCreateOneCertificateDisciplineArgs = {
  name: Scalars['String'];
  viewOnDegree: Scalars['Boolean'];
};


export type MutationCreateOneCertificateEventArgs = {
  name: Scalars['String'];
};


export type MutationCreateOneCertificateTeacherArgs = {
  name: Scalars['String'];
  titration: Scalars['String'];
};


export type MutationCreateOneCertificateTemplateArgs = {
  data: Scalars['Json'];
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};


export type MutationCreateOneDegreeArgs = {
  degreeAcademicDocumentationId?: Maybe<Scalars['String']>;
  visualRepresentation?: Maybe<Scalars['Upload']>;
  xml: Scalars['Upload'];
};


export type MutationCreateOneDocumentAcademicDocumentationArgs = {
  draftId: Scalars['String'];
};


export type MutationCreateOneDocumentAcademicDocumentationFromRevokedDocumentArgs = {
  documentId: Scalars['String'];
};


export type MutationCreateOneDocumentAcademicDocumentationSearchViewArgs = {
  data: DocumentAcademicDocumentationSearchViewCreateInput;
};


export type MutationCreateOneDocumentAuditFileIssuerArgs = {
  degreeCount: Scalars['Int'];
  endDate: Scalars['Date'];
  excludeRevoked: Scalars['Boolean'];
  startDate: Scalars['Date'];
  version: Scalars['String'];
};


export type MutationCreateOneDocumentAuditFileIssuerDegreeItemArgs = {
  data: DocumentAuditFileIssuerDegreeItemCreateInput;
};


export type MutationCreateOneDocumentBaseDefaultSignatureInviteConfigurationGroupArgs = {
  data: DocumentBaseDefaultSignatureInviteConfigurationGroupCreateInput;
};


export type MutationCreateOneDocumentBaseDefaultSignatureInviteConfigurationGroupItemArgs = {
  data: DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateInput;
};


export type MutationCreateOneDocumentBaseHistoryArgs = {
  data: DocumentBaseHistoryCreateInput;
};


export type MutationCreateOneDocumentBaseSignatureInviteArgs = {
  data: DocumentBaseSignatureInviteCreateInput;
};


export type MutationCreateOneDocumentBaseSignatureInviteGroupArgs = {
  data: DocumentBaseSignatureInviteGroupCreateInput;
};


export type MutationCreateOneDocumentBaseSignatureInviteSignatureArgs = {
  data: DocumentBaseSignatureInviteSignatureCreateInput;
};


export type MutationCreateOneDocumentCertificateArgs = {
  curriculumDisciplinesVariables: Array<CurriculumDisciplineVariable>;
  curriculumId?: Maybe<Scalars['String']>;
  degreeId?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  ignoreUsingExpensiveCreditsError?: Maybe<Scalars['Boolean']>;
  personId?: Maybe<Scalars['String']>;
  studentCPF: Scalars['String'];
  studentEmail: Scalars['String'];
  studentName: Scalars['String'];
  templateId: Scalars['String'];
  variables: Scalars['Json'];
};


export type MutationCreateOneDocumentCertificateHashHistoryArgs = {
  data: DocumentCertificateHashHistoryCreateInput;
};


export type MutationCreateOneDocumentCertificateMetadataArgs = {
  data: DocumentCertificateMetadataCreateInput;
};


export type MutationCreateOneDocumentCertificatePreviewArgs = {
  curriculumDisciplinesVariables: Array<CurriculumDisciplineVariable>;
  curriculumId?: Maybe<Scalars['String']>;
  degreeId?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  personId?: Maybe<Scalars['String']>;
  studentCPF: Scalars['String'];
  studentEmail: Scalars['String'];
  studentName: Scalars['String'];
  templateId: Scalars['String'];
  variables: Scalars['Json'];
};


export type MutationCreateOneDocumentCertificateSignatureItemArgs = {
  data: DocumentCertificateSignatureItemCreateInput;
};


export type MutationCreateOneDocumentCertificateSignatureItemPossibleSignerInviteArgs = {
  data: DocumentCertificateSignatureItemPossibleSignerInviteCreateInput;
};


export type MutationCreateOneDocumentCertificateSignatureItemPossibleSignerInviteSignatureArgs = {
  data: DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateInput;
};


export type MutationCreateOneDocumentDegreeSearchViewArgs = {
  data: DocumentDegreeSearchViewCreateInput;
};


export type MutationCreateOneDocumentFinalAcademicTranscriptArgs = {
  baseAcademicId: Scalars['String'];
};


export type MutationCreateOneDocumentFinalAcademicTranscriptViewArgs = {
  data: DocumentFinalAcademicTranscriptViewCreateInput;
};


export type MutationCreateOneDocumentSchoolCurriculumArgs = {
  id: Scalars['String'];
};


export type MutationCreateOneEnabledInstitutionArgs = {
  data: CreateOneEnabledInstitutionInput;
};


export type MutationCreateOneExternalSignatureInviteArgs = {
  data: ExternalSignatureInviteCreateInput;
};


export type MutationCreateOneFinancialPaymentArgs = {
  data: FinancialPaymentCreateInput;
};


export type MutationCreateOneFinancialRechargeArgs = {
  data: CreateOneFinancialRechargeInput;
};


export type MutationCreateOneFinancialTeamSignupSelectedOptionsArgs = {
  data: FinancialTeamSignupSelectedOptionsCreateInput;
};


export type MutationCreateOneFinancialTeamWalletArgs = {
  data: FinancialTeamWalletCreateInput;
};


export type MutationCreateOneFinancialTeamWalletSubscriptionArgs = {
  data: FinancialTeamWalletSubscriptionCreateInput;
};


export type MutationCreateOneFinancialTeamWalletSubscriptionPaymentArgs = {
  data: FinancialTeamWalletSubscriptionPaymentCreateInput;
};


export type MutationCreateOneFinancialTeamWalletSubscriptionPaymentHistoryArgs = {
  data: FinancialTeamWalletSubscriptionPaymentHistoryCreateInput;
};


export type MutationCreateOneMaintainerAdminArgs = {
  email: Scalars['String'];
};


export type MutationCreateOneMaintainerTeamArgs = {
  CNPJ: Scalars['String'];
  educationLevelType: Array<EducationLevelType>;
  placeholderName: Scalars['String'];
};


export type MutationCreateOnePermissionArgs = {
  data: PermissionCreateInput;
};


export type MutationCreateOnePersonArgs = {
  address?: Maybe<AddressInput>;
  birthDate?: Maybe<Scalars['String']>;
  cpf?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identityDocument?: Maybe<Scalars['String']>;
  isForeign: Scalars['Boolean'];
  name: Scalars['String'];
  passport?: Maybe<Scalars['String']>;
  phones: Array<Scalars['String']>;
  receivesCertificateEmail: Scalars['Boolean'];
  receivesCertificateWhatsapp: Scalars['Boolean'];
};


export type MutationCreateOneReusableFormDataCurriculumArgs = {
  data: ReusableFormDataCurriculumCreateInputCustom;
};


export type MutationCreateOneSignSignatureImageArgs = {
  data: CreateOneSignSignatureImageData;
};


export type MutationCreateOneSystemGlobalAlertArgs = {
  data: SystemGlobalAlertCreateInput;
};


export type MutationCreateOneSystemGlobalAlertUserDismissArgs = {
  data: SystemGlobalAlertUserDismissCreateInput;
};


export type MutationCreateOneSystemLogArgs = {
  data: SystemLogCreateInput;
};


export type MutationCreateOneTeamEducationLevelArgs = {
  data: TeamEducationLevelCreateInput;
};


export type MutationCreateOneTeamMemberPermissionArgs = {
  data: TeamMemberPermissionCreateInput;
};


export type MutationCreateOneTelephoneArgs = {
  data: TelephoneCreateInput;
};


export type MutationDefineOneSignSignatureImageAsPrimaryArgs = {
  where: SignSignatureImageWhereUniqueInput;
};


export type MutationDefineSignersArgs = {
  addSignersNode?: Maybe<Scalars['Boolean']>;
  data: InviteGroups;
  saveDefault?: Maybe<Scalars['Boolean']>;
};


export type MutationDeleteManyAddressArgs = {
  where: AddressWhereInput;
};


export type MutationDeleteManyBulkCertificateRecordArgs = {
  where: BulkCertificateRecordWhereInput;
};


export type MutationDeleteManyCertificateCurriculumSelectedDisciplineArgs = {
  where: CertificateCurriculumSelectedDisciplineWhereInput;
};


export type MutationDeleteManyDocumentAcademicDocumentationSearchViewArgs = {
  where: DocumentAcademicDocumentationSearchViewWhereInput;
};


export type MutationDeleteManyDocumentAuditFileIssuerDegreeItemArgs = {
  where: DocumentAuditFileIssuerDegreeItemWhereInput;
};


export type MutationDeleteManyDocumentBaseDefaultSignatureInviteConfigurationGroupArgs = {
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput;
};


export type MutationDeleteManyDocumentBaseDefaultSignatureInviteConfigurationGroupItemArgs = {
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereInput;
};


export type MutationDeleteManyDocumentBaseHistoryArgs = {
  where: DocumentBaseHistoryWhereInput;
};


export type MutationDeleteManyDocumentBaseSignatureInviteArgs = {
  where: DocumentBaseSignatureInviteWhereInput;
};


export type MutationDeleteManyDocumentBaseSignatureInviteGroupArgs = {
  where: DocumentBaseSignatureInviteGroupWhereInput;
};


export type MutationDeleteManyDocumentBaseSignatureInviteSignatureArgs = {
  where: DocumentBaseSignatureInviteSignatureWhereInput;
};


export type MutationDeleteManyDocumentCertificateHashHistoryArgs = {
  where: DocumentCertificateHashHistoryWhereInput;
};


export type MutationDeleteManyDocumentCertificateMetadataArgs = {
  where: DocumentCertificateMetadataWhereInput;
};


export type MutationDeleteManyDocumentCertificateSignatureItemArgs = {
  where: DocumentCertificateSignatureItemWhereInput;
};


export type MutationDeleteManyDocumentCertificateSignatureItemPossibleSignerInviteArgs = {
  where: DocumentCertificateSignatureItemPossibleSignerInviteWhereInput;
};


export type MutationDeleteManyDocumentCertificateSignatureItemPossibleSignerInviteSignatureArgs = {
  where: DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereInput;
};


export type MutationDeleteManyDocumentDegreeSearchViewArgs = {
  where: DocumentDegreeSearchViewWhereInput;
};


export type MutationDeleteManyDocumentFinalAcademicTranscriptViewArgs = {
  where: DocumentFinalAcademicTranscriptViewWhereInput;
};


export type MutationDeleteManyExternalSignatureInviteArgs = {
  where: ExternalSignatureInviteWhereInput;
};


export type MutationDeleteManyFinancialPaymentArgs = {
  where: FinancialPaymentWhereInput;
};


export type MutationDeleteManyFinancialTeamSignupSelectedOptionsArgs = {
  where: FinancialTeamSignupSelectedOptionsWhereInput;
};


export type MutationDeleteManyFinancialTeamWalletArgs = {
  where: FinancialTeamWalletWhereInput;
};


export type MutationDeleteManyFinancialTeamWalletSubscriptionArgs = {
  where: FinancialTeamWalletSubscriptionWhereInput;
};


export type MutationDeleteManyFinancialTeamWalletSubscriptionPaymentArgs = {
  where: FinancialTeamWalletSubscriptionPaymentWhereInput;
};


export type MutationDeleteManyFinancialTeamWalletSubscriptionPaymentHistoryArgs = {
  where: FinancialTeamWalletSubscriptionPaymentHistoryWhereInput;
};


export type MutationDeleteManyPermissionArgs = {
  where: PermissionWhereInput;
};


export type MutationDeleteManySystemGlobalAlertUserDismissArgs = {
  where: SystemGlobalAlertUserDismissWhereInput;
};


export type MutationDeleteManySystemLogArgs = {
  where: SystemLogWhereInput;
};


export type MutationDeleteManyTeamEducationLevelArgs = {
  where: TeamEducationLevelWhereInput;
};


export type MutationDeleteManyTeamMemberPermissionArgs = {
  where: TeamMemberPermissionWhereInput;
};


export type MutationDeleteManyTelephoneArgs = {
  where: TelephoneWhereInput;
};


export type MutationDeleteOneAddressArgs = {
  where: AddressWhereUniqueInput;
};


export type MutationDeleteOneApiKeyArgs = {
  apiKeyId: Scalars['Int'];
};


export type MutationDeleteOneBulkCertificateRecordArgs = {
  where: BulkCertificateRecordWhereUniqueInput;
};


export type MutationDeleteOneCertificateBaseArgs = {
  certificateId: Scalars['String'];
};


export type MutationDeleteOneCertificateCurriculumSelectedDisciplineArgs = {
  where: CertificateCurriculumSelectedDisciplineWhereUniqueInput;
};


export type MutationDeleteOneCertificateTemplateArgs = {
  where: CertificateTemplateWhereUniqueInput;
};


export type MutationDeleteOneDegreeVisualRepresentationArgs = {
  degreeId: Scalars['String'];
};


export type MutationDeleteOneDocumentAcademicDocumentationSearchViewArgs = {
  where: DocumentAcademicDocumentationSearchViewWhereUniqueInput;
};


export type MutationDeleteOneDocumentAuditFileIssuerDegreeItemArgs = {
  where: DocumentAuditFileIssuerDegreeItemWhereUniqueInput;
};


export type MutationDeleteOneDocumentBaseArgs = {
  id: Scalars['String'];
};


export type MutationDeleteOneDocumentBaseDefaultSignatureInviteConfigurationArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteOneDocumentBaseDefaultSignatureInviteConfigurationGroupArgs = {
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupWhereUniqueInput;
};


export type MutationDeleteOneDocumentBaseDefaultSignatureInviteConfigurationGroupItemArgs = {
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput;
};


export type MutationDeleteOneDocumentBaseHistoryArgs = {
  where: DocumentBaseHistoryWhereUniqueInput;
};


export type MutationDeleteOneDocumentBaseSignatureInviteArgs = {
  where: DocumentBaseSignatureInviteWhereUniqueInput;
};


export type MutationDeleteOneDocumentBaseSignatureInviteGroupArgs = {
  where: DocumentBaseSignatureInviteGroupWhereUniqueInput;
};


export type MutationDeleteOneDocumentBaseSignatureInviteSignatureArgs = {
  where: DocumentBaseSignatureInviteSignatureWhereUniqueInput;
};


export type MutationDeleteOneDocumentCertificateHashHistoryArgs = {
  where: DocumentCertificateHashHistoryWhereUniqueInput;
};


export type MutationDeleteOneDocumentCertificateMetadataArgs = {
  where: DocumentCertificateMetadataWhereUniqueInput;
};


export type MutationDeleteOneDocumentCertificateSignatureItemArgs = {
  where: DocumentCertificateSignatureItemWhereUniqueInput;
};


export type MutationDeleteOneDocumentCertificateSignatureItemPossibleSignerInviteArgs = {
  where: DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput;
};


export type MutationDeleteOneDocumentCertificateSignatureItemPossibleSignerInviteSignatureArgs = {
  where: DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereUniqueInput;
};


export type MutationDeleteOneDocumentDegreeSearchViewArgs = {
  where: DocumentDegreeSearchViewWhereUniqueInput;
};


export type MutationDeleteOneDocumentFinalAcademicTranscriptViewArgs = {
  where: DocumentFinalAcademicTranscriptViewWhereUniqueInput;
};


export type MutationDeleteOneExternalSignatureInviteArgs = {
  where: ExternalSignatureInviteWhereUniqueInput;
};


export type MutationDeleteOneFinancialCreditCardSavedArgs = {
  where: FinancialCreditCardSavedWhereUniqueInput;
};


export type MutationDeleteOneFinancialPaymentArgs = {
  where: FinancialPaymentWhereUniqueInput;
};


export type MutationDeleteOneFinancialTeamSignupSelectedOptionsArgs = {
  where: FinancialTeamSignupSelectedOptionsWhereUniqueInput;
};


export type MutationDeleteOneFinancialTeamWalletArgs = {
  where: FinancialTeamWalletWhereUniqueInput;
};


export type MutationDeleteOneFinancialTeamWalletSubscriptionArgs = {
  where: FinancialTeamWalletSubscriptionWhereUniqueInput;
};


export type MutationDeleteOneFinancialTeamWalletSubscriptionPaymentArgs = {
  where: FinancialTeamWalletSubscriptionPaymentWhereUniqueInput;
};


export type MutationDeleteOneFinancialTeamWalletSubscriptionPaymentHistoryArgs = {
  where: FinancialTeamWalletSubscriptionPaymentHistoryWhereUniqueInput;
};


export type MutationDeleteOneMaintainerAdminArgs = {
  where: MaintainerAdminWhereUniqueInput;
};


export type MutationDeleteOneMaintainerTeamArgs = {
  where: TeamWhereUniqueInput;
};


export type MutationDeleteOnePermissionArgs = {
  where: PermissionWhereUniqueInput;
};


export type MutationDeleteOnePersonArgs = {
  id: Scalars['String'];
};


export type MutationDeleteOneReusableFormDataArgs = {
  where: ReusableFormDataWhereUniqueInput;
};


export type MutationDeleteOneReusableFormDataCurriculumArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteOneSignSignatureImageArgs = {
  where: SignSignatureImageWhereUniqueInput;
};


export type MutationDeleteOneSystemGlobalAlertArgs = {
  where: SystemGlobalAlertWhereUniqueInput;
};


export type MutationDeleteOneSystemGlobalAlertUserDismissArgs = {
  where: SystemGlobalAlertUserDismissWhereUniqueInput;
};


export type MutationDeleteOneSystemLogArgs = {
  where: SystemLogWhereUniqueInput;
};


export type MutationDeleteOneTeamEducationLevelArgs = {
  where: TeamEducationLevelWhereUniqueInput;
};


export type MutationDeleteOneTeamMemberArgs = {
  where: TeamMemberWhereUniqueInput;
};


export type MutationDeleteOneTeamMemberPermissionArgs = {
  where: TeamMemberPermissionWhereUniqueInput;
};


export type MutationDeleteOneTelephoneArgs = {
  where: TelephoneWhereUniqueInput;
};


export type MutationDismissSystemGlobalAlertArgs = {
  id: Scalars['Int'];
};


export type MutationDuplicateOneCertificateTemplateArgs = {
  templateId: Scalars['String'];
};


export type MutationFinalizeOneCertificateSignatureArgs = {
  certificate: Scalars['String'];
  initialize: InitializeResponseInput;
  inviteId: Scalars['String'];
  signatureImageId?: Maybe<Scalars['String']>;
};


export type MutationFinalizeOneSignatureArgs = {
  certificate: Scalars['String'];
  initialize: InitializeResponseInput;
  inviteId: Scalars['Int'];
};


export type MutationFinalizeOneSignatureExternalSignatureInviteArgs = {
  certificate: Scalars['String'];
  initialize: InitializeResponseInput;
  inviteId: Scalars['String'];
};


export type MutationFinancialTeamWalletPurchasePlanArgs = {
  data: FinancialTeamWalletPurchasePlanInput;
};


export type MutationForceGenerateDocumentAcademicDocumentationArgs = {
  docId: Scalars['String'];
};


export type MutationForceGenerateDocumentSchoolCurriculumArgs = {
  docId: Scalars['String'];
};


export type MutationPatchOneDocumentAcademicDocumentationArgs = {
  changes: Array<DocumentChange>;
  id: Scalars['String'];
};


export type MutationPatchOneDocumentSchoolCurriculumArgs = {
  changes: Array<DocumentChange>;
  id: Scalars['String'];
};


export type MutationPayOverduePaymentsArgs = {
  data: PlanPayOverduePaymentsInput;
};


export type MutationRecreateOneAcademicDocumentationXmlArgs = {
  documentId: Scalars['String'];
  status: DocumentAcademicDocumentationStatus;
};


export type MutationReplaceOneDegreeVisualRepresentationArgs = {
  degreeId: Scalars['String'];
  visualRepresentation: Scalars['Upload'];
};


export type MutationResendOneTeamMemberEmailArgs = {
  memberId: Scalars['Int'];
};


export type MutationRevalidateOneDocumentAcademicDocumentationArgs = {
  documentId: Scalars['String'];
};


export type MutationReviewOneDocumentAcademicDocumentationArgs = {
  academicDocumentationId: Scalars['String'];
  reproveReason?: Maybe<Scalars['String']>;
};


export type MutationReviewOneDocumentAuditFileIssuerArgs = {
  documentBaseId: Scalars['String'];
  reproveReason?: Maybe<Scalars['String']>;
};


export type MutationReviewOneDocumentSchoolCurriculumArgs = {
  reproveReason?: Maybe<Scalars['String']>;
  schoolCurriculumId: Scalars['String'];
};


export type MutationRevokeOneDocumentBaseArgs = {
  id: Scalars['String'];
  revokeReason: Scalars['String'];
};


export type MutationSaveOneCommonUserConfigArgs = {
  data: SaveOneCommonUserConfigInputData;
};


export type MutationSaveOneDocumentAcademicDocumentationArgs = {
  data: Scalars['Json'];
  type?: Maybe<DocumentAcademicDocumentationType>;
  version: Scalars['String'];
};


export type MutationSaveOneDocumentSchoolCurriculumArgs = {
  data: Scalars['Json'];
  version: Scalars['String'];
};


export type MutationSaveOneReusableFormDataArgs = {
  data: Scalars['Json'];
  id?: Maybe<Scalars['Int']>;
  type: Scalars['String'];
};


export type MutationSendActivityArgs = {
  input: WatchDocumentInput;
};


export type MutationSignOnlyVisualOneSignatureArgs = {
  inviteId: Scalars['String'];
  signatureImageId?: Maybe<Scalars['String']>;
};


export type MutationSingBulkCertificateVisualRepresentationArgs = {
  bulkId: Scalars['String'];
  certificateList: Array<Scalars['String']>;
  signatureImageId?: Maybe<Scalars['String']>;
};


export type MutationStartOneCertificateSignatureArgs = {
  certificate: Scalars['String'];
  inviteId: Scalars['String'];
  signatureImageId?: Maybe<Scalars['String']>;
};


export type MutationStartOneSignatureArgs = {
  certificate: Scalars['String'];
  inviteId: Scalars['Int'];
};


export type MutationStartOneSignatureExternalSignatureInviteArgs = {
  certificate: Scalars['String'];
  inviteId: Scalars['String'];
};


export type MutationUpdateManyAddressArgs = {
  data: AddressUpdateManyMutationInput;
  where?: Maybe<AddressWhereInput>;
};


export type MutationUpdateManyBulkCertificateRecordArgs = {
  data: BulkCertificateRecordUpdateManyMutationInput;
  where?: Maybe<BulkCertificateRecordWhereInput>;
};


export type MutationUpdateManyCertificateCurriculumSelectedDisciplineArgs = {
  data: CertificateCurriculumSelectedDisciplineUpdateManyMutationInput;
  where?: Maybe<CertificateCurriculumSelectedDisciplineWhereInput>;
};


export type MutationUpdateManyDocumentAcademicDocumentationSearchViewArgs = {
  data: DocumentAcademicDocumentationSearchViewUpdateManyMutationInput;
  where?: Maybe<DocumentAcademicDocumentationSearchViewWhereInput>;
};


export type MutationUpdateManyDocumentAuditFileIssuerDegreeItemArgs = {
  data: DocumentAuditFileIssuerDegreeItemUpdateManyMutationInput;
  where?: Maybe<DocumentAuditFileIssuerDegreeItemWhereInput>;
};


export type MutationUpdateManyDocumentBaseDefaultSignatureInviteConfigurationGroupArgs = {
  data: DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateManyMutationInput;
  where?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>;
};


export type MutationUpdateManyDocumentBaseDefaultSignatureInviteConfigurationGroupItemArgs = {
  data: DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateManyMutationInput;
  where?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereInput>;
};


export type MutationUpdateManyDocumentBaseHistoryArgs = {
  data: DocumentBaseHistoryUpdateManyMutationInput;
  where?: Maybe<DocumentBaseHistoryWhereInput>;
};


export type MutationUpdateManyDocumentBaseSignatureInviteArgs = {
  data: DocumentBaseSignatureInviteUpdateManyMutationInput;
  where?: Maybe<DocumentBaseSignatureInviteWhereInput>;
};


export type MutationUpdateManyDocumentBaseSignatureInviteGroupArgs = {
  data: DocumentBaseSignatureInviteGroupUpdateManyMutationInput;
  where?: Maybe<DocumentBaseSignatureInviteGroupWhereInput>;
};


export type MutationUpdateManyDocumentBaseSignatureInviteSignatureArgs = {
  data: DocumentBaseSignatureInviteSignatureUpdateManyMutationInput;
  where?: Maybe<DocumentBaseSignatureInviteSignatureWhereInput>;
};


export type MutationUpdateManyDocumentCertificateHashHistoryArgs = {
  data: DocumentCertificateHashHistoryUpdateManyMutationInput;
  where?: Maybe<DocumentCertificateHashHistoryWhereInput>;
};


export type MutationUpdateManyDocumentCertificateMetadataArgs = {
  data: DocumentCertificateMetadataUpdateManyMutationInput;
  where?: Maybe<DocumentCertificateMetadataWhereInput>;
};


export type MutationUpdateManyDocumentCertificateSignatureItemArgs = {
  data: DocumentCertificateSignatureItemUpdateManyMutationInput;
  where?: Maybe<DocumentCertificateSignatureItemWhereInput>;
};


export type MutationUpdateManyDocumentCertificateSignatureItemPossibleSignerInviteArgs = {
  data: DocumentCertificateSignatureItemPossibleSignerInviteUpdateManyMutationInput;
  where?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>;
};


export type MutationUpdateManyDocumentCertificateSignatureItemPossibleSignerInviteSignatureArgs = {
  data: DocumentCertificateSignatureItemPossibleSignerInviteSignatureUpdateManyMutationInput;
  where?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereInput>;
};


export type MutationUpdateManyDocumentDegreeSearchViewArgs = {
  data: DocumentDegreeSearchViewUpdateManyMutationInput;
  where?: Maybe<DocumentDegreeSearchViewWhereInput>;
};


export type MutationUpdateManyDocumentFinalAcademicTranscriptViewArgs = {
  data: DocumentFinalAcademicTranscriptViewUpdateManyMutationInput;
  where?: Maybe<DocumentFinalAcademicTranscriptViewWhereInput>;
};


export type MutationUpdateManyExternalSignatureInviteArgs = {
  data: ExternalSignatureInviteUpdateManyMutationInput;
  where?: Maybe<ExternalSignatureInviteWhereInput>;
};


export type MutationUpdateManyFinancialPaymentArgs = {
  data: FinancialPaymentUpdateManyMutationInput;
  where?: Maybe<FinancialPaymentWhereInput>;
};


export type MutationUpdateManyFinancialTeamSignupSelectedOptionsArgs = {
  data: FinancialTeamSignupSelectedOptionsUpdateManyMutationInput;
  where?: Maybe<FinancialTeamSignupSelectedOptionsWhereInput>;
};


export type MutationUpdateManyFinancialTeamWalletArgs = {
  data: FinancialTeamWalletUpdateManyMutationInput;
  where?: Maybe<FinancialTeamWalletWhereInput>;
};


export type MutationUpdateManyFinancialTeamWalletSubscriptionArgs = {
  data: FinancialTeamWalletSubscriptionUpdateManyMutationInput;
  where?: Maybe<FinancialTeamWalletSubscriptionWhereInput>;
};


export type MutationUpdateManyFinancialTeamWalletSubscriptionPaymentArgs = {
  data: FinancialTeamWalletSubscriptionPaymentUpdateManyMutationInput;
  where?: Maybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
};


export type MutationUpdateManyFinancialTeamWalletSubscriptionPaymentHistoryArgs = {
  data: FinancialTeamWalletSubscriptionPaymentHistoryUpdateManyMutationInput;
  where?: Maybe<FinancialTeamWalletSubscriptionPaymentHistoryWhereInput>;
};


export type MutationUpdateManyPermissionArgs = {
  data: PermissionUpdateManyMutationInput;
  where?: Maybe<PermissionWhereInput>;
};


export type MutationUpdateManySystemGlobalAlertUserDismissArgs = {
  data: SystemGlobalAlertUserDismissUpdateManyMutationInput;
  where?: Maybe<SystemGlobalAlertUserDismissWhereInput>;
};


export type MutationUpdateManySystemLogArgs = {
  data: SystemLogUpdateManyMutationInput;
  where?: Maybe<SystemLogWhereInput>;
};


export type MutationUpdateManyTeamEducationLevelArgs = {
  data: TeamEducationLevelUpdateManyMutationInput;
  where?: Maybe<TeamEducationLevelWhereInput>;
};


export type MutationUpdateManyTeamMemberPermissionArgs = {
  data: TeamMemberPermissionUpdateManyMutationInput;
  where?: Maybe<TeamMemberPermissionWhereInput>;
};


export type MutationUpdateManyTelephoneArgs = {
  data: TelephoneUpdateManyMutationInput;
  where?: Maybe<TelephoneWhereInput>;
};


export type MutationUpdateOneAddressArgs = {
  data: AddressUpdateInput;
  where: AddressWhereUniqueInput;
};


export type MutationUpdateOneBulkCertificateRecordArgs = {
  data: BulkCertificateRecordUpdateInput;
  where: BulkCertificateRecordWhereUniqueInput;
};


export type MutationUpdateOneCertificateCourseArgs = {
  areaKnowledge: Scalars['String'];
  certificateId: Scalars['String'];
  courseLevelId?: Maybe<Scalars['String']>;
  metaData: Array<Scalars['String']>;
  name: Scalars['String'];
};


export type MutationUpdateOneCertificateCourseLevelArgs = {
  certificateBaseId: Scalars['String'];
  name: Scalars['String'];
};


export type MutationUpdateOneCertificateCurriculumArgs = {
  amountOfHours?: Maybe<Scalars['Int']>;
  certificateCourseId: Scalars['String'];
  certificateId: Scalars['String'];
  name: Scalars['String'];
  selectedDisciplines: Array<CirriculumSelectedDiscipline>;
};


export type MutationUpdateOneCertificateCurriculumSelectedDisciplineArgs = {
  data: CertificateCurriculumSelectedDisciplineUpdateInput;
  where: CertificateCurriculumSelectedDisciplineWhereUniqueInput;
};


export type MutationUpdateOneCertificateDisciplineArgs = {
  certificateId: Scalars['String'];
  name: Scalars['String'];
  viewOnDegree: Scalars['Boolean'];
};


export type MutationUpdateOneCertificateEventArgs = {
  certificateId: Scalars['String'];
  name: Scalars['String'];
};


export type MutationUpdateOneCertificateTeacherArgs = {
  certificateId: Scalars['String'];
  name: Scalars['String'];
  titration: Scalars['String'];
};


export type MutationUpdateOneCertificateTemplateArgs = {
  data: CertificateTemplateUpdateInput;
  where: CertificateTemplateWhereUniqueInput;
};


export type MutationUpdateOneDegreeVisualRepresentationArgs = {
  degreeId: Scalars['String'];
  visualRepresentation: Scalars['Upload'];
};


export type MutationUpdateOneDocumentAcademicDocumentationSearchViewArgs = {
  data: DocumentAcademicDocumentationSearchViewUpdateInput;
  where: DocumentAcademicDocumentationSearchViewWhereUniqueInput;
};


export type MutationUpdateOneDocumentAuditFileIssuerDegreeItemArgs = {
  data: DocumentAuditFileIssuerDegreeItemUpdateInput;
  where: DocumentAuditFileIssuerDegreeItemWhereUniqueInput;
};


export type MutationUpdateOneDocumentBaseDefaultSignatureInviteConfigurationGroupArgs = {
  data: DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupWhereUniqueInput;
};


export type MutationUpdateOneDocumentBaseDefaultSignatureInviteConfigurationGroupItemArgs = {
  data: DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput;
};


export type MutationUpdateOneDocumentBaseHistoryArgs = {
  data: DocumentBaseHistoryUpdateInput;
  where: DocumentBaseHistoryWhereUniqueInput;
};


export type MutationUpdateOneDocumentBaseSignatureInviteArgs = {
  data: DocumentBaseSignatureInviteUpdateInput;
  where: DocumentBaseSignatureInviteWhereUniqueInput;
};


export type MutationUpdateOneDocumentBaseSignatureInviteGroupArgs = {
  data: DocumentBaseSignatureInviteGroupUpdateInput;
  where: DocumentBaseSignatureInviteGroupWhereUniqueInput;
};


export type MutationUpdateOneDocumentBaseSignatureInviteSignatureArgs = {
  data: DocumentBaseSignatureInviteSignatureUpdateInput;
  where: DocumentBaseSignatureInviteSignatureWhereUniqueInput;
};


export type MutationUpdateOneDocumentCertificateHashHistoryArgs = {
  data: DocumentCertificateHashHistoryUpdateInput;
  where: DocumentCertificateHashHistoryWhereUniqueInput;
};


export type MutationUpdateOneDocumentCertificateMetadataArgs = {
  data: DocumentCertificateMetadataUpdateInput;
  where: DocumentCertificateMetadataWhereUniqueInput;
};


export type MutationUpdateOneDocumentCertificateSignatureItemArgs = {
  data: DocumentCertificateSignatureItemUpdateInput;
  where: DocumentCertificateSignatureItemWhereUniqueInput;
};


export type MutationUpdateOneDocumentCertificateSignatureItemPossibleSignerInviteArgs = {
  data: DocumentCertificateSignatureItemPossibleSignerInviteUpdateInput;
  where: DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput;
};


export type MutationUpdateOneDocumentCertificateSignatureItemPossibleSignerInviteSignatureArgs = {
  data: DocumentCertificateSignatureItemPossibleSignerInviteSignatureUpdateInput;
  where: DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereUniqueInput;
};


export type MutationUpdateOneDocumentDegreeSearchViewArgs = {
  data: DocumentDegreeSearchViewUpdateInput;
  where: DocumentDegreeSearchViewWhereUniqueInput;
};


export type MutationUpdateOneDocumentFinalAcademicTranscriptViewArgs = {
  data: DocumentFinalAcademicTranscriptViewUpdateInput;
  where: DocumentFinalAcademicTranscriptViewWhereUniqueInput;
};


export type MutationUpdateOneExternalSignatureInviteArgs = {
  data: ExternalSignatureInviteUpdateInput;
  where: ExternalSignatureInviteWhereUniqueInput;
};


export type MutationUpdateOneFinancialPaymentArgs = {
  data: FinancialPaymentUpdateInput;
  where: FinancialPaymentWhereUniqueInput;
};


export type MutationUpdateOneFinancialTeamSignupSelectedOptionsArgs = {
  data: FinancialTeamSignupSelectedOptionsUpdateInput;
  where: FinancialTeamSignupSelectedOptionsWhereUniqueInput;
};


export type MutationUpdateOneFinancialTeamWalletArgs = {
  data: FinancialTeamWalletUpdateInput;
  where: FinancialTeamWalletWhereUniqueInput;
};


export type MutationUpdateOneFinancialTeamWalletSubscriptionArgs = {
  data: FinancialTeamWalletSubscriptionUpdateInput;
  where: FinancialTeamWalletSubscriptionWhereUniqueInput;
};


export type MutationUpdateOneFinancialTeamWalletSubscriptionPaymentArgs = {
  data: FinancialTeamWalletSubscriptionPaymentUpdateInput;
  where: FinancialTeamWalletSubscriptionPaymentWhereUniqueInput;
};


export type MutationUpdateOneFinancialTeamWalletSubscriptionPaymentHistoryArgs = {
  data: FinancialTeamWalletSubscriptionPaymentHistoryUpdateInput;
  where: FinancialTeamWalletSubscriptionPaymentHistoryWhereUniqueInput;
};


export type MutationUpdateOnePermissionArgs = {
  data: PermissionUpdateInput;
  where: PermissionWhereUniqueInput;
};


export type MutationUpdateOnePersonArgs = {
  address?: Maybe<AddressInput>;
  birthDate?: Maybe<Scalars['String']>;
  cpf?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identityDocument?: Maybe<Scalars['String']>;
  isForeign: Scalars['Boolean'];
  name: Scalars['String'];
  passport?: Maybe<Scalars['String']>;
  phones: Array<Scalars['String']>;
  receivesCertificateEmail: Scalars['Boolean'];
  receivesCertificateWhatsapp: Scalars['Boolean'];
};


export type MutationUpdateOneReusableFormDataCurriculumArgs = {
  data: ReusableFormDataCurriculumCreateInputCustom;
  where: ReusableFormDataCurriculumWhereUniqueInput;
};


export type MutationUpdateOneSystemGlobalAlertArgs = {
  data: SystemGlobalAlertUpdateInput;
  where: SystemGlobalAlertWhereUniqueInput;
};


export type MutationUpdateOneSystemGlobalAlertUserDismissArgs = {
  data: SystemGlobalAlertUserDismissUpdateInput;
  where: SystemGlobalAlertUserDismissWhereUniqueInput;
};


export type MutationUpdateOneSystemLogArgs = {
  data: SystemLogUpdateInput;
  where: SystemLogWhereUniqueInput;
};


export type MutationUpdateOneTeamArgs = {
  data: UpdateOneTeamData;
};


export type MutationUpdateOneTeamEducationLevelArgs = {
  data: TeamEducationLevelUpdateInput;
  where: TeamEducationLevelWhereUniqueInput;
};


export type MutationUpdateOneTeamMemberArgs = {
  cpfOrCnpj?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  permissions?: Maybe<Array<Scalars['String']>>;
  role?: Maybe<Scalars['String']>;
};


export type MutationUpdateOneTeamMemberPermissionArgs = {
  data: TeamMemberPermissionUpdateInput;
  where: TeamMemberPermissionWhereUniqueInput;
};


export type MutationUpdateOneTelephoneArgs = {
  data: TelephoneUpdateInput;
  where: TelephoneWhereUniqueInput;
};


export type MutationUpdateTeamActivationStatusArgs = {
  data: UpdateTeamActivationStatusArgs;
};


export type MutationUpdateTeamConfigAddDocumentSignerNodeArgs = {
  addSigners: Scalars['Boolean'];
};


export type MutationUpsertDocumentBaseDefaultSignatureInviteConfigurationArgs = {
  data: UpsertDocumentBaseDefaultSignatureInviteConfigurationInput;
};


export type MutationUpsertOneAddressArgs = {
  create: AddressCreateInput;
  update: AddressUpdateInput;
  where: AddressWhereUniqueInput;
};


export type MutationUpsertOneBulkCertificateRecordArgs = {
  create: BulkCertificateRecordCreateInput;
  update: BulkCertificateRecordUpdateInput;
  where: BulkCertificateRecordWhereUniqueInput;
};


export type MutationUpsertOneCertificateCurriculumSelectedDisciplineArgs = {
  create: CertificateCurriculumSelectedDisciplineCreateInput;
  update: CertificateCurriculumSelectedDisciplineUpdateInput;
  where: CertificateCurriculumSelectedDisciplineWhereUniqueInput;
};


export type MutationUpsertOneDocumentAcademicDocumentationSearchViewArgs = {
  create: DocumentAcademicDocumentationSearchViewCreateInput;
  update: DocumentAcademicDocumentationSearchViewUpdateInput;
  where: DocumentAcademicDocumentationSearchViewWhereUniqueInput;
};


export type MutationUpsertOneDocumentAuditFileIssuerDegreeItemArgs = {
  create: DocumentAuditFileIssuerDegreeItemCreateInput;
  update: DocumentAuditFileIssuerDegreeItemUpdateInput;
  where: DocumentAuditFileIssuerDegreeItemWhereUniqueInput;
};


export type MutationUpsertOneDocumentBaseDefaultSignatureInviteConfigurationGroupArgs = {
  create: DocumentBaseDefaultSignatureInviteConfigurationGroupCreateInput;
  update: DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupWhereUniqueInput;
};


export type MutationUpsertOneDocumentBaseDefaultSignatureInviteConfigurationGroupItemArgs = {
  create: DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateInput;
  update: DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput;
};


export type MutationUpsertOneDocumentBaseHistoryArgs = {
  create: DocumentBaseHistoryCreateInput;
  update: DocumentBaseHistoryUpdateInput;
  where: DocumentBaseHistoryWhereUniqueInput;
};


export type MutationUpsertOneDocumentBaseSignatureInviteArgs = {
  create: DocumentBaseSignatureInviteCreateInput;
  update: DocumentBaseSignatureInviteUpdateInput;
  where: DocumentBaseSignatureInviteWhereUniqueInput;
};


export type MutationUpsertOneDocumentBaseSignatureInviteGroupArgs = {
  create: DocumentBaseSignatureInviteGroupCreateInput;
  update: DocumentBaseSignatureInviteGroupUpdateInput;
  where: DocumentBaseSignatureInviteGroupWhereUniqueInput;
};


export type MutationUpsertOneDocumentBaseSignatureInviteSignatureArgs = {
  create: DocumentBaseSignatureInviteSignatureCreateInput;
  update: DocumentBaseSignatureInviteSignatureUpdateInput;
  where: DocumentBaseSignatureInviteSignatureWhereUniqueInput;
};


export type MutationUpsertOneDocumentCertificateHashHistoryArgs = {
  create: DocumentCertificateHashHistoryCreateInput;
  update: DocumentCertificateHashHistoryUpdateInput;
  where: DocumentCertificateHashHistoryWhereUniqueInput;
};


export type MutationUpsertOneDocumentCertificateMetadataArgs = {
  create: DocumentCertificateMetadataCreateInput;
  update: DocumentCertificateMetadataUpdateInput;
  where: DocumentCertificateMetadataWhereUniqueInput;
};


export type MutationUpsertOneDocumentCertificateSignatureItemArgs = {
  create: DocumentCertificateSignatureItemCreateInput;
  update: DocumentCertificateSignatureItemUpdateInput;
  where: DocumentCertificateSignatureItemWhereUniqueInput;
};


export type MutationUpsertOneDocumentCertificateSignatureItemPossibleSignerInviteArgs = {
  create: DocumentCertificateSignatureItemPossibleSignerInviteCreateInput;
  update: DocumentCertificateSignatureItemPossibleSignerInviteUpdateInput;
  where: DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput;
};


export type MutationUpsertOneDocumentCertificateSignatureItemPossibleSignerInviteSignatureArgs = {
  create: DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateInput;
  update: DocumentCertificateSignatureItemPossibleSignerInviteSignatureUpdateInput;
  where: DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereUniqueInput;
};


export type MutationUpsertOneDocumentDegreeSearchViewArgs = {
  create: DocumentDegreeSearchViewCreateInput;
  update: DocumentDegreeSearchViewUpdateInput;
  where: DocumentDegreeSearchViewWhereUniqueInput;
};


export type MutationUpsertOneDocumentFinalAcademicTranscriptViewArgs = {
  create: DocumentFinalAcademicTranscriptViewCreateInput;
  update: DocumentFinalAcademicTranscriptViewUpdateInput;
  where: DocumentFinalAcademicTranscriptViewWhereUniqueInput;
};


export type MutationUpsertOneExternalSignatureInviteArgs = {
  create: ExternalSignatureInviteCreateInput;
  update: ExternalSignatureInviteUpdateInput;
  where: ExternalSignatureInviteWhereUniqueInput;
};


export type MutationUpsertOneFinancialPaymentArgs = {
  create: FinancialPaymentCreateInput;
  update: FinancialPaymentUpdateInput;
  where: FinancialPaymentWhereUniqueInput;
};


export type MutationUpsertOneFinancialTeamSignupSelectedOptionsArgs = {
  create: FinancialTeamSignupSelectedOptionsCreateInput;
  update: FinancialTeamSignupSelectedOptionsUpdateInput;
  where: FinancialTeamSignupSelectedOptionsWhereUniqueInput;
};


export type MutationUpsertOneFinancialTeamWalletArgs = {
  create: FinancialTeamWalletCreateInput;
  update: FinancialTeamWalletUpdateInput;
  where: FinancialTeamWalletWhereUniqueInput;
};


export type MutationUpsertOneFinancialTeamWalletSubscriptionArgs = {
  create: FinancialTeamWalletSubscriptionCreateInput;
  update: FinancialTeamWalletSubscriptionUpdateInput;
  where: FinancialTeamWalletSubscriptionWhereUniqueInput;
};


export type MutationUpsertOneFinancialTeamWalletSubscriptionPaymentArgs = {
  create: FinancialTeamWalletSubscriptionPaymentCreateInput;
  update: FinancialTeamWalletSubscriptionPaymentUpdateInput;
  where: FinancialTeamWalletSubscriptionPaymentWhereUniqueInput;
};


export type MutationUpsertOneFinancialTeamWalletSubscriptionPaymentHistoryArgs = {
  create: FinancialTeamWalletSubscriptionPaymentHistoryCreateInput;
  update: FinancialTeamWalletSubscriptionPaymentHistoryUpdateInput;
  where: FinancialTeamWalletSubscriptionPaymentHistoryWhereUniqueInput;
};


export type MutationUpsertOnePermissionArgs = {
  create: PermissionCreateInput;
  update: PermissionUpdateInput;
  where: PermissionWhereUniqueInput;
};


export type MutationUpsertOneSystemGlobalAlertUserDismissArgs = {
  create: SystemGlobalAlertUserDismissCreateInput;
  update: SystemGlobalAlertUserDismissUpdateInput;
  where: SystemGlobalAlertUserDismissWhereUniqueInput;
};


export type MutationUpsertOneSystemLogArgs = {
  create: SystemLogCreateInput;
  update: SystemLogUpdateInput;
  where: SystemLogWhereUniqueInput;
};


export type MutationUpsertOneTeamEducationLevelArgs = {
  create: TeamEducationLevelCreateInput;
  update: TeamEducationLevelUpdateInput;
  where: TeamEducationLevelWhereUniqueInput;
};


export type MutationUpsertOneTeamMemberPermissionArgs = {
  create: TeamMemberPermissionCreateInput;
  update: TeamMemberPermissionUpdateInput;
  where: TeamMemberPermissionWhereUniqueInput;
};


export type MutationUpsertOneTelephoneArgs = {
  create: TelephoneCreateInput;
  update: TelephoneUpdateInput;
  where: TelephoneWhereUniqueInput;
};


export type MutationUpsertOneTemporarySignatureImageArgs = {
  description: Scalars['String'];
};


export type MutationValidateOnePdfaArgs = {
  base64: Scalars['String'];
};


export type NestedBoolFilter = {
  equals?: Maybe<Scalars['Boolean']>;
  not?: Maybe<NestedBoolFilter>;
};

export type NestedBoolWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedBoolFilter>;
  _min?: Maybe<NestedBoolFilter>;
  equals?: Maybe<Scalars['Boolean']>;
  not?: Maybe<NestedBoolWithAggregatesFilter>;
};

export type NestedDateTimeFilter = {
  equals?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  not?: Maybe<NestedDateTimeFilter>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  not?: Maybe<NestedDateTimeNullableFilter>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type NestedDateTimeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedDateTimeNullableFilter>;
  _min?: Maybe<NestedDateTimeNullableFilter>;
  equals?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  not?: Maybe<NestedDateTimeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type NestedDateTimeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedDateTimeFilter>;
  _min?: Maybe<NestedDateTimeFilter>;
  equals?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  not?: Maybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type NestedDecimalFilter = {
  equals?: Maybe<Scalars['Decimal']>;
  gt?: Maybe<Scalars['Decimal']>;
  gte?: Maybe<Scalars['Decimal']>;
  in?: Maybe<Array<Scalars['Decimal']>>;
  lt?: Maybe<Scalars['Decimal']>;
  lte?: Maybe<Scalars['Decimal']>;
  not?: Maybe<NestedDecimalFilter>;
  notIn?: Maybe<Array<Scalars['Decimal']>>;
};

export type NestedDecimalWithAggregatesFilter = {
  _avg?: Maybe<NestedDecimalFilter>;
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedDecimalFilter>;
  _min?: Maybe<NestedDecimalFilter>;
  _sum?: Maybe<NestedDecimalFilter>;
  equals?: Maybe<Scalars['Decimal']>;
  gt?: Maybe<Scalars['Decimal']>;
  gte?: Maybe<Scalars['Decimal']>;
  in?: Maybe<Array<Scalars['Decimal']>>;
  lt?: Maybe<Scalars['Decimal']>;
  lte?: Maybe<Scalars['Decimal']>;
  not?: Maybe<NestedDecimalWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['Decimal']>>;
};

export type NestedEnumCertificateTypesFilter = {
  equals?: Maybe<CertificateTypes>;
  in?: Maybe<Array<CertificateTypes>>;
  not?: Maybe<CertificateTypes>;
  notIn?: Maybe<Array<CertificateTypes>>;
};

export type NestedEnumCertificateTypesWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumCertificateTypesFilter>;
  _min?: Maybe<NestedEnumCertificateTypesFilter>;
  equals?: Maybe<CertificateTypes>;
  in?: Maybe<Array<CertificateTypes>>;
  not?: Maybe<CertificateTypes>;
  notIn?: Maybe<Array<CertificateTypes>>;
};

export type NestedEnumDocumentAcademicDocumentationCreationTypeFilter = {
  equals?: Maybe<DocumentAcademicDocumentationCreationType>;
  in?: Maybe<Array<DocumentAcademicDocumentationCreationType>>;
  not?: Maybe<DocumentAcademicDocumentationCreationType>;
  notIn?: Maybe<Array<DocumentAcademicDocumentationCreationType>>;
};

export type NestedEnumDocumentAcademicDocumentationCreationTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumDocumentAcademicDocumentationCreationTypeFilter>;
  _min?: Maybe<NestedEnumDocumentAcademicDocumentationCreationTypeFilter>;
  equals?: Maybe<DocumentAcademicDocumentationCreationType>;
  in?: Maybe<Array<DocumentAcademicDocumentationCreationType>>;
  not?: Maybe<DocumentAcademicDocumentationCreationType>;
  notIn?: Maybe<Array<DocumentAcademicDocumentationCreationType>>;
};

export type NestedEnumDocumentAcademicDocumentationStatusFilter = {
  equals?: Maybe<DocumentAcademicDocumentationStatus>;
  in?: Maybe<Array<DocumentAcademicDocumentationStatus>>;
  not?: Maybe<DocumentAcademicDocumentationStatus>;
  notIn?: Maybe<Array<DocumentAcademicDocumentationStatus>>;
};

export type NestedEnumDocumentAcademicDocumentationStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumDocumentAcademicDocumentationStatusFilter>;
  _min?: Maybe<NestedEnumDocumentAcademicDocumentationStatusFilter>;
  equals?: Maybe<DocumentAcademicDocumentationStatus>;
  in?: Maybe<Array<DocumentAcademicDocumentationStatus>>;
  not?: Maybe<DocumentAcademicDocumentationStatus>;
  notIn?: Maybe<Array<DocumentAcademicDocumentationStatus>>;
};

export type NestedEnumDocumentAcademicDocumentationTypeFilter = {
  equals?: Maybe<DocumentAcademicDocumentationType>;
  in?: Maybe<Array<DocumentAcademicDocumentationType>>;
  not?: Maybe<DocumentAcademicDocumentationType>;
  notIn?: Maybe<Array<DocumentAcademicDocumentationType>>;
};

export type NestedEnumDocumentAcademicDocumentationTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumDocumentAcademicDocumentationTypeFilter>;
  _min?: Maybe<NestedEnumDocumentAcademicDocumentationTypeFilter>;
  equals?: Maybe<DocumentAcademicDocumentationType>;
  in?: Maybe<Array<DocumentAcademicDocumentationType>>;
  not?: Maybe<DocumentAcademicDocumentationType>;
  notIn?: Maybe<Array<DocumentAcademicDocumentationType>>;
};

export type NestedEnumDocumentAuditFileIssuerStatusFilter = {
  equals?: Maybe<DocumentAuditFileIssuerStatus>;
  in?: Maybe<Array<DocumentAuditFileIssuerStatus>>;
  not?: Maybe<DocumentAuditFileIssuerStatus>;
  notIn?: Maybe<Array<DocumentAuditFileIssuerStatus>>;
};

export type NestedEnumDocumentAuditFileIssuerStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumDocumentAuditFileIssuerStatusFilter>;
  _min?: Maybe<NestedEnumDocumentAuditFileIssuerStatusFilter>;
  equals?: Maybe<DocumentAuditFileIssuerStatus>;
  in?: Maybe<Array<DocumentAuditFileIssuerStatus>>;
  not?: Maybe<DocumentAuditFileIssuerStatus>;
  notIn?: Maybe<Array<DocumentAuditFileIssuerStatus>>;
};

export type NestedEnumDocumentBaseTypeFilter = {
  equals?: Maybe<DocumentBaseType>;
  in?: Maybe<Array<DocumentBaseType>>;
  not?: Maybe<DocumentBaseType>;
  notIn?: Maybe<Array<DocumentBaseType>>;
};

export type NestedEnumDocumentBaseTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumDocumentBaseTypeFilter>;
  _min?: Maybe<NestedEnumDocumentBaseTypeFilter>;
  equals?: Maybe<DocumentBaseType>;
  in?: Maybe<Array<DocumentBaseType>>;
  not?: Maybe<DocumentBaseType>;
  notIn?: Maybe<Array<DocumentBaseType>>;
};

export type NestedEnumDocumentCertificateSignatureHashHistoryTypeFilter = {
  equals?: Maybe<DocumentCertificateSignatureHashHistoryType>;
  in?: Maybe<Array<DocumentCertificateSignatureHashHistoryType>>;
  not?: Maybe<DocumentCertificateSignatureHashHistoryType>;
  notIn?: Maybe<Array<DocumentCertificateSignatureHashHistoryType>>;
};

export type NestedEnumDocumentCertificateSignatureHashHistoryTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumDocumentCertificateSignatureHashHistoryTypeFilter>;
  _min?: Maybe<NestedEnumDocumentCertificateSignatureHashHistoryTypeFilter>;
  equals?: Maybe<DocumentCertificateSignatureHashHistoryType>;
  in?: Maybe<Array<DocumentCertificateSignatureHashHistoryType>>;
  not?: Maybe<DocumentCertificateSignatureHashHistoryType>;
  notIn?: Maybe<Array<DocumentCertificateSignatureHashHistoryType>>;
};

export type NestedEnumDocumentCertificateSignatureItemTypeFilter = {
  equals?: Maybe<DocumentCertificateSignatureItemType>;
  in?: Maybe<Array<DocumentCertificateSignatureItemType>>;
  not?: Maybe<DocumentCertificateSignatureItemType>;
  notIn?: Maybe<Array<DocumentCertificateSignatureItemType>>;
};

export type NestedEnumDocumentCertificateSignatureItemTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumDocumentCertificateSignatureItemTypeFilter>;
  _min?: Maybe<NestedEnumDocumentCertificateSignatureItemTypeFilter>;
  equals?: Maybe<DocumentCertificateSignatureItemType>;
  in?: Maybe<Array<DocumentCertificateSignatureItemType>>;
  not?: Maybe<DocumentCertificateSignatureItemType>;
  notIn?: Maybe<Array<DocumentCertificateSignatureItemType>>;
};

export type NestedEnumDocumentCertificateStatusFilter = {
  equals?: Maybe<DocumentCertificateStatus>;
  in?: Maybe<Array<DocumentCertificateStatus>>;
  not?: Maybe<DocumentCertificateStatus>;
  notIn?: Maybe<Array<DocumentCertificateStatus>>;
};

export type NestedEnumDocumentCertificateStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumDocumentCertificateStatusFilter>;
  _min?: Maybe<NestedEnumDocumentCertificateStatusFilter>;
  equals?: Maybe<DocumentCertificateStatus>;
  in?: Maybe<Array<DocumentCertificateStatus>>;
  not?: Maybe<DocumentCertificateStatus>;
  notIn?: Maybe<Array<DocumentCertificateStatus>>;
};

export type NestedEnumDocumentDegreeStatusFilter = {
  equals?: Maybe<DocumentDegreeStatus>;
  in?: Maybe<Array<DocumentDegreeStatus>>;
  not?: Maybe<DocumentDegreeStatus>;
  notIn?: Maybe<Array<DocumentDegreeStatus>>;
};

export type NestedEnumDocumentDegreeStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumDocumentDegreeStatusFilter>;
  _min?: Maybe<NestedEnumDocumentDegreeStatusFilter>;
  equals?: Maybe<DocumentDegreeStatus>;
  in?: Maybe<Array<DocumentDegreeStatus>>;
  not?: Maybe<DocumentDegreeStatus>;
  notIn?: Maybe<Array<DocumentDegreeStatus>>;
};

export type NestedEnumDocumentFinalAcademicTranscriptStatusFilter = {
  equals?: Maybe<DocumentFinalAcademicTranscriptStatus>;
  in?: Maybe<Array<DocumentFinalAcademicTranscriptStatus>>;
  not?: Maybe<DocumentFinalAcademicTranscriptStatus>;
  notIn?: Maybe<Array<DocumentFinalAcademicTranscriptStatus>>;
};

export type NestedEnumDocumentFinalAcademicTranscriptStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumDocumentFinalAcademicTranscriptStatusFilter>;
  _min?: Maybe<NestedEnumDocumentFinalAcademicTranscriptStatusFilter>;
  equals?: Maybe<DocumentFinalAcademicTranscriptStatus>;
  in?: Maybe<Array<DocumentFinalAcademicTranscriptStatus>>;
  not?: Maybe<DocumentFinalAcademicTranscriptStatus>;
  notIn?: Maybe<Array<DocumentFinalAcademicTranscriptStatus>>;
};

export type NestedEnumDocumentSchoolCurriculumStatusFilter = {
  equals?: Maybe<DocumentSchoolCurriculumStatus>;
  in?: Maybe<Array<DocumentSchoolCurriculumStatus>>;
  not?: Maybe<DocumentSchoolCurriculumStatus>;
  notIn?: Maybe<Array<DocumentSchoolCurriculumStatus>>;
};

export type NestedEnumDocumentSchoolCurriculumStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumDocumentSchoolCurriculumStatusFilter>;
  _min?: Maybe<NestedEnumDocumentSchoolCurriculumStatusFilter>;
  equals?: Maybe<DocumentSchoolCurriculumStatus>;
  in?: Maybe<Array<DocumentSchoolCurriculumStatus>>;
  not?: Maybe<DocumentSchoolCurriculumStatus>;
  notIn?: Maybe<Array<DocumentSchoolCurriculumStatus>>;
};

export type NestedEnumEducationLevelTypeFilter = {
  equals?: Maybe<EducationLevelType>;
  in?: Maybe<Array<EducationLevelType>>;
  not?: Maybe<EducationLevelType>;
  notIn?: Maybe<Array<EducationLevelType>>;
};

export type NestedEnumEducationLevelTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumEducationLevelTypeFilter>;
  _min?: Maybe<NestedEnumEducationLevelTypeFilter>;
  equals?: Maybe<EducationLevelType>;
  in?: Maybe<Array<EducationLevelType>>;
  not?: Maybe<EducationLevelType>;
  notIn?: Maybe<Array<EducationLevelType>>;
};

export type NestedEnumFinancialBillingCycleFilter = {
  equals?: Maybe<FinancialBillingCycle>;
  in?: Maybe<Array<FinancialBillingCycle>>;
  not?: Maybe<FinancialBillingCycle>;
  notIn?: Maybe<Array<FinancialBillingCycle>>;
};

export type NestedEnumFinancialBillingCycleNullableFilter = {
  equals?: Maybe<FinancialBillingCycle>;
  in?: Maybe<Array<FinancialBillingCycle>>;
  not?: Maybe<FinancialBillingCycle>;
  notIn?: Maybe<Array<FinancialBillingCycle>>;
};

export type NestedEnumFinancialBillingCycleNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedEnumFinancialBillingCycleNullableFilter>;
  _min?: Maybe<NestedEnumFinancialBillingCycleNullableFilter>;
  equals?: Maybe<FinancialBillingCycle>;
  in?: Maybe<Array<FinancialBillingCycle>>;
  not?: Maybe<FinancialBillingCycle>;
  notIn?: Maybe<Array<FinancialBillingCycle>>;
};

export type NestedEnumFinancialBillingCycleWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumFinancialBillingCycleFilter>;
  _min?: Maybe<NestedEnumFinancialBillingCycleFilter>;
  equals?: Maybe<FinancialBillingCycle>;
  in?: Maybe<Array<FinancialBillingCycle>>;
  not?: Maybe<FinancialBillingCycle>;
  notIn?: Maybe<Array<FinancialBillingCycle>>;
};

export type NestedEnumFinancialChargeableServiceFilter = {
  equals?: Maybe<FinancialChargeableService>;
  in?: Maybe<Array<FinancialChargeableService>>;
  not?: Maybe<FinancialChargeableService>;
  notIn?: Maybe<Array<FinancialChargeableService>>;
};

export type NestedEnumFinancialChargeableServiceWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumFinancialChargeableServiceFilter>;
  _min?: Maybe<NestedEnumFinancialChargeableServiceFilter>;
  equals?: Maybe<FinancialChargeableService>;
  in?: Maybe<Array<FinancialChargeableService>>;
  not?: Maybe<FinancialChargeableService>;
  notIn?: Maybe<Array<FinancialChargeableService>>;
};

export type NestedEnumFinancialPlanFilter = {
  equals?: Maybe<FinancialPlan>;
  in?: Maybe<Array<FinancialPlan>>;
  not?: Maybe<FinancialPlan>;
  notIn?: Maybe<Array<FinancialPlan>>;
};

export type NestedEnumFinancialPlanWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumFinancialPlanFilter>;
  _min?: Maybe<NestedEnumFinancialPlanFilter>;
  equals?: Maybe<FinancialPlan>;
  in?: Maybe<Array<FinancialPlan>>;
  not?: Maybe<FinancialPlan>;
  notIn?: Maybe<Array<FinancialPlan>>;
};

export type NestedEnumPaymentStatusFilter = {
  equals?: Maybe<PaymentStatus>;
  in?: Maybe<Array<PaymentStatus>>;
  not?: Maybe<PaymentStatus>;
  notIn?: Maybe<Array<PaymentStatus>>;
};

export type NestedEnumPaymentStatusWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumPaymentStatusFilter>;
  _min?: Maybe<NestedEnumPaymentStatusFilter>;
  equals?: Maybe<PaymentStatus>;
  in?: Maybe<Array<PaymentStatus>>;
  not?: Maybe<PaymentStatus>;
  notIn?: Maybe<Array<PaymentStatus>>;
};

export type NestedEnumSystemGlobalAlertTypeFilter = {
  equals?: Maybe<SystemGlobalAlertType>;
  in?: Maybe<Array<SystemGlobalAlertType>>;
  not?: Maybe<SystemGlobalAlertType>;
  notIn?: Maybe<Array<SystemGlobalAlertType>>;
};

export type NestedEnumSystemGlobalAlertTypeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedEnumSystemGlobalAlertTypeFilter>;
  _min?: Maybe<NestedEnumSystemGlobalAlertTypeFilter>;
  equals?: Maybe<SystemGlobalAlertType>;
  in?: Maybe<Array<SystemGlobalAlertType>>;
  not?: Maybe<SystemGlobalAlertType>;
  notIn?: Maybe<Array<SystemGlobalAlertType>>;
};

export type NestedFloatFilter = {
  equals?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  in?: Maybe<Array<Scalars['Float']>>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  not?: Maybe<NestedFloatFilter>;
  notIn?: Maybe<Array<Scalars['Float']>>;
};

export type NestedFloatNullableFilter = {
  equals?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  in?: Maybe<Array<Scalars['Float']>>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  not?: Maybe<NestedFloatNullableFilter>;
  notIn?: Maybe<Array<Scalars['Float']>>;
};

export type NestedFloatWithAggregatesFilter = {
  _avg?: Maybe<NestedFloatFilter>;
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedFloatFilter>;
  _min?: Maybe<NestedFloatFilter>;
  _sum?: Maybe<NestedFloatFilter>;
  equals?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  in?: Maybe<Array<Scalars['Float']>>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  not?: Maybe<NestedFloatWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['Float']>>;
};

export type NestedIntFilter = {
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type NestedIntNullableFilter = {
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntNullableFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type NestedIntNullableWithAggregatesFilter = {
  _avg?: Maybe<NestedFloatNullableFilter>;
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedIntNullableFilter>;
  _min?: Maybe<NestedIntNullableFilter>;
  _sum?: Maybe<NestedIntNullableFilter>;
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type NestedIntWithAggregatesFilter = {
  _avg?: Maybe<NestedFloatFilter>;
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedIntFilter>;
  _min?: Maybe<NestedIntFilter>;
  _sum?: Maybe<NestedIntFilter>;
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type NestedJsonFilter = {
  array_contains?: Maybe<Scalars['Json']>;
  array_ends_with?: Maybe<Scalars['Json']>;
  array_starts_with?: Maybe<Scalars['Json']>;
  equals?: Maybe<Scalars['Json']>;
  gt?: Maybe<Scalars['Json']>;
  gte?: Maybe<Scalars['Json']>;
  lt?: Maybe<Scalars['Json']>;
  lte?: Maybe<Scalars['Json']>;
  not?: Maybe<Scalars['Json']>;
  path?: Maybe<Array<Scalars['String']>>;
  string_contains?: Maybe<Scalars['String']>;
  string_ends_with?: Maybe<Scalars['String']>;
  string_starts_with?: Maybe<Scalars['String']>;
};

export type NestedJsonNullableFilter = {
  array_contains?: Maybe<Scalars['Json']>;
  array_ends_with?: Maybe<Scalars['Json']>;
  array_starts_with?: Maybe<Scalars['Json']>;
  equals?: Maybe<Scalars['Json']>;
  gt?: Maybe<Scalars['Json']>;
  gte?: Maybe<Scalars['Json']>;
  lt?: Maybe<Scalars['Json']>;
  lte?: Maybe<Scalars['Json']>;
  not?: Maybe<Scalars['Json']>;
  path?: Maybe<Array<Scalars['String']>>;
  string_contains?: Maybe<Scalars['String']>;
  string_ends_with?: Maybe<Scalars['String']>;
  string_starts_with?: Maybe<Scalars['String']>;
};

export type NestedStringFilter = {
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  not?: Maybe<NestedStringFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  startsWith?: Maybe<Scalars['String']>;
};

export type NestedStringNullableFilter = {
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  not?: Maybe<NestedStringNullableFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  startsWith?: Maybe<Scalars['String']>;
};

export type NestedStringNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedStringNullableFilter>;
  _min?: Maybe<NestedStringNullableFilter>;
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  not?: Maybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  startsWith?: Maybe<Scalars['String']>;
};

export type NestedStringWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedStringFilter>;
  _min?: Maybe<NestedStringFilter>;
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  not?: Maybe<NestedStringWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  startsWith?: Maybe<Scalars['String']>;
};

export type NullableDateTimeFieldUpdateOperationsInput = {
  set?: Maybe<Scalars['DateTime']>;
};

export type NullableEnumFinancialBillingCycleFieldUpdateOperationsInput = {
  set?: Maybe<FinancialBillingCycle>;
};

export type NullableIntFieldUpdateOperationsInput = {
  decrement?: Maybe<Scalars['Int']>;
  divide?: Maybe<Scalars['Int']>;
  increment?: Maybe<Scalars['Int']>;
  multiply?: Maybe<Scalars['Int']>;
  set?: Maybe<Scalars['Int']>;
};

export enum NullableJsonNullValueInput {
  DbNull = 'DbNull',
  JsonNull = 'JsonNull'
}

export type NullableStringFieldUpdateOperationsInput = {
  set?: Maybe<Scalars['String']>;
};

export enum NullsOrder {
  First = 'first',
  Last = 'last'
}

export enum PaymentStatus {
  Canceled = 'CANCELED',
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  Pending = 'PENDING'
}

export type Permission = {
  __typename?: 'Permission';
  TeamMemberPermissions: Array<TeamMemberPermission>;
  /** CREATE_UPDATE_DOCUMENT, UPDATE_OWN_DOCUMENT, UPDATE_ANY_DOCUMENT, REVIEW_DOCUMENT, INVITE_SIGNERS, SIGN_DOCUMENT, MANAGE_REUSABLE_IES, MANAGE_REUSABLE_ANY, MANAGE_USERS, REVOKE_DOCUMENT, DEGREE_IMPORT */
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['Int'];
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type PermissionTeamMemberPermissionsArgs = {
  cursor?: Maybe<TeamMemberPermissionWhereUniqueInput>;
  distinct?: Maybe<Array<TeamMemberPermissionScalarFieldEnum>>;
  orderBy?: Maybe<Array<TeamMemberPermissionOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TeamMemberPermissionWhereInput>;
};

export type PermissionAvgOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
};

export type PermissionCountOrderByAggregateInput = {
  code?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PermissionCreateInput = {
  TeamMemberPermissions?: Maybe<TeamMemberPermissionCreateNestedManyWithoutPermissionInput>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PermissionCreateManyInput = {
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PermissionCreateNestedOneWithoutTeamMemberPermissionsInput = {
  connect?: Maybe<PermissionWhereUniqueInput>;
  connectOrCreate?: Maybe<PermissionCreateOrConnectWithoutTeamMemberPermissionsInput>;
  create?: Maybe<PermissionCreateWithoutTeamMemberPermissionsInput>;
};

export type PermissionCreateOrConnectWithoutTeamMemberPermissionsInput = {
  create: PermissionCreateWithoutTeamMemberPermissionsInput;
  where: PermissionWhereUniqueInput;
};

export type PermissionCreateWithoutTeamMemberPermissionsInput = {
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PermissionMaxOrderByAggregateInput = {
  code?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PermissionMinOrderByAggregateInput = {
  code?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PermissionOrderByWithAggregationInput = {
  _avg?: Maybe<PermissionAvgOrderByAggregateInput>;
  _count?: Maybe<PermissionCountOrderByAggregateInput>;
  _max?: Maybe<PermissionMaxOrderByAggregateInput>;
  _min?: Maybe<PermissionMinOrderByAggregateInput>;
  _sum?: Maybe<PermissionSumOrderByAggregateInput>;
  code?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PermissionOrderByWithRelationInput = {
  TeamMemberPermissions?: Maybe<TeamMemberPermissionOrderByRelationAggregateInput>;
  code?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PermissionRelationFilter = {
  is?: Maybe<PermissionWhereInput>;
  isNot?: Maybe<PermissionWhereInput>;
};

export enum PermissionScalarFieldEnum {
  Code = 'code',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

export type PermissionScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<PermissionScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<PermissionScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<PermissionScalarWhereWithAggregatesInput>>;
  code?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  description?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  title?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
};

export type PermissionSumOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
};

export type PermissionUpdateInput = {
  TeamMemberPermissions?: Maybe<TeamMemberPermissionUpdateManyWithoutPermissionNestedInput>;
  code?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  description?: Maybe<StringFieldUpdateOperationsInput>;
  title?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type PermissionUpdateManyMutationInput = {
  code?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  description?: Maybe<StringFieldUpdateOperationsInput>;
  title?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type PermissionUpdateOneRequiredWithoutTeamMemberPermissionsNestedInput = {
  connect?: Maybe<PermissionWhereUniqueInput>;
  connectOrCreate?: Maybe<PermissionCreateOrConnectWithoutTeamMemberPermissionsInput>;
  create?: Maybe<PermissionCreateWithoutTeamMemberPermissionsInput>;
  update?: Maybe<PermissionUpdateToOneWithWhereWithoutTeamMemberPermissionsInput>;
  upsert?: Maybe<PermissionUpsertWithoutTeamMemberPermissionsInput>;
};

export type PermissionUpdateToOneWithWhereWithoutTeamMemberPermissionsInput = {
  data: PermissionUpdateWithoutTeamMemberPermissionsInput;
  where?: Maybe<PermissionWhereInput>;
};

export type PermissionUpdateWithoutTeamMemberPermissionsInput = {
  code?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  description?: Maybe<StringFieldUpdateOperationsInput>;
  title?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type PermissionUpsertWithoutTeamMemberPermissionsInput = {
  create: PermissionCreateWithoutTeamMemberPermissionsInput;
  update: PermissionUpdateWithoutTeamMemberPermissionsInput;
  where?: Maybe<PermissionWhereInput>;
};

export type PermissionWhereInput = {
  AND?: Maybe<Array<PermissionWhereInput>>;
  NOT?: Maybe<Array<PermissionWhereInput>>;
  OR?: Maybe<Array<PermissionWhereInput>>;
  TeamMemberPermissions?: Maybe<TeamMemberPermissionListRelationFilter>;
  code?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  id?: Maybe<IntFilter>;
  title?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
};

export type PermissionWhereUniqueInput = {
  AND?: Maybe<Array<PermissionWhereInput>>;
  NOT?: Maybe<Array<PermissionWhereInput>>;
  OR?: Maybe<Array<PermissionWhereInput>>;
  TeamMemberPermissions?: Maybe<TeamMemberPermissionListRelationFilter>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  id?: Maybe<Scalars['Int']>;
  title?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
};

export type Person = {
  __typename?: 'Person';
  Address?: Maybe<Address>;
  DocumentCertificate: Array<DocumentCertificate>;
  Phones: Array<Telephone>;
  Team: Team;
  birthDate?: Maybe<Scalars['String']>;
  cpf?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  educationLevel: EducationLevelType;
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  identityDocument?: Maybe<Scalars['String']>;
  isForeign: Scalars['Boolean'];
  name: Scalars['String'];
  passport?: Maybe<Scalars['String']>;
  receivesCertificateEmail: Scalars['Boolean'];
  receivesCertificateWhatsapp: Scalars['Boolean'];
  teamId: Scalars['Int'];
};


export type PersonDocumentCertificateArgs = {
  cursor?: Maybe<DocumentCertificateWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentCertificateScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentCertificateOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentCertificateWhereInput>;
};


export type PersonPhonesArgs = {
  cursor?: Maybe<TelephoneWhereUniqueInput>;
  distinct?: Maybe<Array<TelephoneScalarFieldEnum>>;
  orderBy?: Maybe<Array<TelephoneOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TelephoneWhereInput>;
};

export type PersonAvgOrderByAggregateInput = {
  teamId?: Maybe<SortOrder>;
};

export type PersonCountOrderByAggregateInput = {
  birthDate?: Maybe<SortOrder>;
  cpf?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  educationLevel?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  identityDocument?: Maybe<SortOrder>;
  isForeign?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  passport?: Maybe<SortOrder>;
  receivesCertificateEmail?: Maybe<SortOrder>;
  receivesCertificateWhatsapp?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type PersonCpfTeamIdCompoundUniqueInput = {
  cpf: Scalars['String'];
  teamId: Scalars['Int'];
};

export type PersonCreateInput = {
  Address?: Maybe<AddressCreateNestedOneWithoutPersonInput>;
  DocumentCertificate?: Maybe<DocumentCertificateCreateNestedManyWithoutPersonInput>;
  Phones?: Maybe<TelephoneCreateNestedManyWithoutPersonInput>;
  Team: TeamCreateNestedOneWithoutPersonInput;
  birthDate?: Maybe<Scalars['String']>;
  cpf?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  educationLevel?: Maybe<EducationLevelType>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identityDocument?: Maybe<Scalars['String']>;
  isForeign?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  passport?: Maybe<Scalars['String']>;
  receivesCertificateEmail?: Maybe<Scalars['Boolean']>;
  receivesCertificateWhatsapp?: Maybe<Scalars['Boolean']>;
};

export type PersonCreateManyInput = {
  birthDate?: Maybe<Scalars['String']>;
  cpf?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  educationLevel?: Maybe<EducationLevelType>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identityDocument?: Maybe<Scalars['String']>;
  isForeign?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  passport?: Maybe<Scalars['String']>;
  receivesCertificateEmail?: Maybe<Scalars['Boolean']>;
  receivesCertificateWhatsapp?: Maybe<Scalars['Boolean']>;
  teamId: Scalars['Int'];
};

export type PersonCreateManyTeamInput = {
  birthDate?: Maybe<Scalars['String']>;
  cpf?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  educationLevel?: Maybe<EducationLevelType>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identityDocument?: Maybe<Scalars['String']>;
  isForeign?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  passport?: Maybe<Scalars['String']>;
  receivesCertificateEmail?: Maybe<Scalars['Boolean']>;
  receivesCertificateWhatsapp?: Maybe<Scalars['Boolean']>;
};

export type PersonCreateManyTeamInputEnvelope = {
  data: Array<PersonCreateManyTeamInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type PersonCreateNestedManyWithoutTeamInput = {
  connect?: Maybe<Array<PersonWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PersonCreateOrConnectWithoutTeamInput>>;
  create?: Maybe<Array<PersonCreateWithoutTeamInput>>;
  createMany?: Maybe<PersonCreateManyTeamInputEnvelope>;
};

export type PersonCreateNestedOneWithoutAddressInput = {
  connect?: Maybe<PersonWhereUniqueInput>;
  connectOrCreate?: Maybe<PersonCreateOrConnectWithoutAddressInput>;
  create?: Maybe<PersonCreateWithoutAddressInput>;
};

export type PersonCreateNestedOneWithoutDocumentCertificateInput = {
  connect?: Maybe<PersonWhereUniqueInput>;
  connectOrCreate?: Maybe<PersonCreateOrConnectWithoutDocumentCertificateInput>;
  create?: Maybe<PersonCreateWithoutDocumentCertificateInput>;
};

export type PersonCreateNestedOneWithoutPhonesInput = {
  connect?: Maybe<PersonWhereUniqueInput>;
  connectOrCreate?: Maybe<PersonCreateOrConnectWithoutPhonesInput>;
  create?: Maybe<PersonCreateWithoutPhonesInput>;
};

export type PersonCreateOrConnectWithoutAddressInput = {
  create: PersonCreateWithoutAddressInput;
  where: PersonWhereUniqueInput;
};

export type PersonCreateOrConnectWithoutDocumentCertificateInput = {
  create: PersonCreateWithoutDocumentCertificateInput;
  where: PersonWhereUniqueInput;
};

export type PersonCreateOrConnectWithoutPhonesInput = {
  create: PersonCreateWithoutPhonesInput;
  where: PersonWhereUniqueInput;
};

export type PersonCreateOrConnectWithoutTeamInput = {
  create: PersonCreateWithoutTeamInput;
  where: PersonWhereUniqueInput;
};

export type PersonCreateWithoutAddressInput = {
  DocumentCertificate?: Maybe<DocumentCertificateCreateNestedManyWithoutPersonInput>;
  Phones?: Maybe<TelephoneCreateNestedManyWithoutPersonInput>;
  Team: TeamCreateNestedOneWithoutPersonInput;
  birthDate?: Maybe<Scalars['String']>;
  cpf?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  educationLevel?: Maybe<EducationLevelType>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identityDocument?: Maybe<Scalars['String']>;
  isForeign?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  passport?: Maybe<Scalars['String']>;
  receivesCertificateEmail?: Maybe<Scalars['Boolean']>;
  receivesCertificateWhatsapp?: Maybe<Scalars['Boolean']>;
};

export type PersonCreateWithoutDocumentCertificateInput = {
  Address?: Maybe<AddressCreateNestedOneWithoutPersonInput>;
  Phones?: Maybe<TelephoneCreateNestedManyWithoutPersonInput>;
  Team: TeamCreateNestedOneWithoutPersonInput;
  birthDate?: Maybe<Scalars['String']>;
  cpf?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  educationLevel?: Maybe<EducationLevelType>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identityDocument?: Maybe<Scalars['String']>;
  isForeign?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  passport?: Maybe<Scalars['String']>;
  receivesCertificateEmail?: Maybe<Scalars['Boolean']>;
  receivesCertificateWhatsapp?: Maybe<Scalars['Boolean']>;
};

export type PersonCreateWithoutPhonesInput = {
  Address?: Maybe<AddressCreateNestedOneWithoutPersonInput>;
  DocumentCertificate?: Maybe<DocumentCertificateCreateNestedManyWithoutPersonInput>;
  Team: TeamCreateNestedOneWithoutPersonInput;
  birthDate?: Maybe<Scalars['String']>;
  cpf?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  educationLevel?: Maybe<EducationLevelType>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identityDocument?: Maybe<Scalars['String']>;
  isForeign?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  passport?: Maybe<Scalars['String']>;
  receivesCertificateEmail?: Maybe<Scalars['Boolean']>;
  receivesCertificateWhatsapp?: Maybe<Scalars['Boolean']>;
};

export type PersonCreateWithoutTeamInput = {
  Address?: Maybe<AddressCreateNestedOneWithoutPersonInput>;
  DocumentCertificate?: Maybe<DocumentCertificateCreateNestedManyWithoutPersonInput>;
  Phones?: Maybe<TelephoneCreateNestedManyWithoutPersonInput>;
  birthDate?: Maybe<Scalars['String']>;
  cpf?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  educationLevel?: Maybe<EducationLevelType>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identityDocument?: Maybe<Scalars['String']>;
  isForeign?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  passport?: Maybe<Scalars['String']>;
  receivesCertificateEmail?: Maybe<Scalars['Boolean']>;
  receivesCertificateWhatsapp?: Maybe<Scalars['Boolean']>;
};

export type PersonListRelationFilter = {
  every?: Maybe<PersonWhereInput>;
  none?: Maybe<PersonWhereInput>;
  some?: Maybe<PersonWhereInput>;
};

export type PersonMaxOrderByAggregateInput = {
  birthDate?: Maybe<SortOrder>;
  cpf?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  educationLevel?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  identityDocument?: Maybe<SortOrder>;
  isForeign?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  passport?: Maybe<SortOrder>;
  receivesCertificateEmail?: Maybe<SortOrder>;
  receivesCertificateWhatsapp?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type PersonMinOrderByAggregateInput = {
  birthDate?: Maybe<SortOrder>;
  cpf?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  educationLevel?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  identityDocument?: Maybe<SortOrder>;
  isForeign?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  passport?: Maybe<SortOrder>;
  receivesCertificateEmail?: Maybe<SortOrder>;
  receivesCertificateWhatsapp?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type PersonOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type PersonOrderByWithAggregationInput = {
  _avg?: Maybe<PersonAvgOrderByAggregateInput>;
  _count?: Maybe<PersonCountOrderByAggregateInput>;
  _max?: Maybe<PersonMaxOrderByAggregateInput>;
  _min?: Maybe<PersonMinOrderByAggregateInput>;
  _sum?: Maybe<PersonSumOrderByAggregateInput>;
  birthDate?: Maybe<SortOrder>;
  cpf?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  educationLevel?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  identityDocument?: Maybe<SortOrder>;
  isForeign?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  passport?: Maybe<SortOrder>;
  receivesCertificateEmail?: Maybe<SortOrder>;
  receivesCertificateWhatsapp?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type PersonOrderByWithRelationInput = {
  Address?: Maybe<AddressOrderByWithRelationInput>;
  DocumentCertificate?: Maybe<DocumentCertificateOrderByRelationAggregateInput>;
  Phones?: Maybe<TelephoneOrderByRelationAggregateInput>;
  Team?: Maybe<TeamOrderByWithRelationInput>;
  birthDate?: Maybe<SortOrder>;
  cpf?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deletedAt?: Maybe<SortOrder>;
  educationLevel?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  identityDocument?: Maybe<SortOrder>;
  isForeign?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  passport?: Maybe<SortOrder>;
  receivesCertificateEmail?: Maybe<SortOrder>;
  receivesCertificateWhatsapp?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type PersonPassportTeamIdCompoundUniqueInput = {
  passport: Scalars['String'];
  teamId: Scalars['Int'];
};

export type PersonRelationFilter = {
  is?: Maybe<PersonWhereInput>;
  isNot?: Maybe<PersonWhereInput>;
};

export enum PersonScalarFieldEnum {
  BirthDate = 'birthDate',
  Cpf = 'cpf',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  EducationLevel = 'educationLevel',
  Email = 'email',
  Id = 'id',
  IdentityDocument = 'identityDocument',
  IsForeign = 'isForeign',
  Name = 'name',
  Passport = 'passport',
  ReceivesCertificateEmail = 'receivesCertificateEmail',
  ReceivesCertificateWhatsapp = 'receivesCertificateWhatsapp',
  TeamId = 'teamId'
}

export type PersonScalarWhereInput = {
  AND?: Maybe<Array<PersonScalarWhereInput>>;
  NOT?: Maybe<Array<PersonScalarWhereInput>>;
  OR?: Maybe<Array<PersonScalarWhereInput>>;
  birthDate?: Maybe<StringNullableFilter>;
  cpf?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  educationLevel?: Maybe<EnumEducationLevelTypeFilter>;
  email?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  identityDocument?: Maybe<StringNullableFilter>;
  isForeign?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  passport?: Maybe<StringNullableFilter>;
  receivesCertificateEmail?: Maybe<BoolFilter>;
  receivesCertificateWhatsapp?: Maybe<BoolFilter>;
  teamId?: Maybe<IntFilter>;
};

export type PersonScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<PersonScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<PersonScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<PersonScalarWhereWithAggregatesInput>>;
  birthDate?: Maybe<StringNullableWithAggregatesFilter>;
  cpf?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  deletedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  educationLevel?: Maybe<EnumEducationLevelTypeWithAggregatesFilter>;
  email?: Maybe<StringNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  identityDocument?: Maybe<StringNullableWithAggregatesFilter>;
  isForeign?: Maybe<BoolWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  passport?: Maybe<StringNullableWithAggregatesFilter>;
  receivesCertificateEmail?: Maybe<BoolWithAggregatesFilter>;
  receivesCertificateWhatsapp?: Maybe<BoolWithAggregatesFilter>;
  teamId?: Maybe<IntWithAggregatesFilter>;
};

export type PersonSumOrderByAggregateInput = {
  teamId?: Maybe<SortOrder>;
};

export type PersonUpdateInput = {
  Address?: Maybe<AddressUpdateOneWithoutPersonNestedInput>;
  DocumentCertificate?: Maybe<DocumentCertificateUpdateManyWithoutPersonNestedInput>;
  Phones?: Maybe<TelephoneUpdateManyWithoutPersonNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutPersonNestedInput>;
  birthDate?: Maybe<NullableStringFieldUpdateOperationsInput>;
  cpf?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  educationLevel?: Maybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  email?: Maybe<NullableStringFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  identityDocument?: Maybe<NullableStringFieldUpdateOperationsInput>;
  isForeign?: Maybe<BoolFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
  passport?: Maybe<NullableStringFieldUpdateOperationsInput>;
  receivesCertificateEmail?: Maybe<BoolFieldUpdateOperationsInput>;
  receivesCertificateWhatsapp?: Maybe<BoolFieldUpdateOperationsInput>;
};

export type PersonUpdateManyMutationInput = {
  birthDate?: Maybe<NullableStringFieldUpdateOperationsInput>;
  cpf?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  educationLevel?: Maybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  email?: Maybe<NullableStringFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  identityDocument?: Maybe<NullableStringFieldUpdateOperationsInput>;
  isForeign?: Maybe<BoolFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
  passport?: Maybe<NullableStringFieldUpdateOperationsInput>;
  receivesCertificateEmail?: Maybe<BoolFieldUpdateOperationsInput>;
  receivesCertificateWhatsapp?: Maybe<BoolFieldUpdateOperationsInput>;
};

export type PersonUpdateManyWithWhereWithoutTeamInput = {
  data: PersonUpdateManyMutationInput;
  where: PersonScalarWhereInput;
};

export type PersonUpdateManyWithoutTeamNestedInput = {
  connect?: Maybe<Array<PersonWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<PersonCreateOrConnectWithoutTeamInput>>;
  create?: Maybe<Array<PersonCreateWithoutTeamInput>>;
  createMany?: Maybe<PersonCreateManyTeamInputEnvelope>;
  delete?: Maybe<Array<PersonWhereUniqueInput>>;
  deleteMany?: Maybe<Array<PersonScalarWhereInput>>;
  disconnect?: Maybe<Array<PersonWhereUniqueInput>>;
  set?: Maybe<Array<PersonWhereUniqueInput>>;
  update?: Maybe<Array<PersonUpdateWithWhereUniqueWithoutTeamInput>>;
  updateMany?: Maybe<Array<PersonUpdateManyWithWhereWithoutTeamInput>>;
  upsert?: Maybe<Array<PersonUpsertWithWhereUniqueWithoutTeamInput>>;
};

export type PersonUpdateOneRequiredWithoutAddressNestedInput = {
  connect?: Maybe<PersonWhereUniqueInput>;
  connectOrCreate?: Maybe<PersonCreateOrConnectWithoutAddressInput>;
  create?: Maybe<PersonCreateWithoutAddressInput>;
  update?: Maybe<PersonUpdateToOneWithWhereWithoutAddressInput>;
  upsert?: Maybe<PersonUpsertWithoutAddressInput>;
};

export type PersonUpdateOneRequiredWithoutDocumentCertificateNestedInput = {
  connect?: Maybe<PersonWhereUniqueInput>;
  connectOrCreate?: Maybe<PersonCreateOrConnectWithoutDocumentCertificateInput>;
  create?: Maybe<PersonCreateWithoutDocumentCertificateInput>;
  update?: Maybe<PersonUpdateToOneWithWhereWithoutDocumentCertificateInput>;
  upsert?: Maybe<PersonUpsertWithoutDocumentCertificateInput>;
};

export type PersonUpdateOneRequiredWithoutPhonesNestedInput = {
  connect?: Maybe<PersonWhereUniqueInput>;
  connectOrCreate?: Maybe<PersonCreateOrConnectWithoutPhonesInput>;
  create?: Maybe<PersonCreateWithoutPhonesInput>;
  update?: Maybe<PersonUpdateToOneWithWhereWithoutPhonesInput>;
  upsert?: Maybe<PersonUpsertWithoutPhonesInput>;
};

export type PersonUpdateToOneWithWhereWithoutAddressInput = {
  data: PersonUpdateWithoutAddressInput;
  where?: Maybe<PersonWhereInput>;
};

export type PersonUpdateToOneWithWhereWithoutDocumentCertificateInput = {
  data: PersonUpdateWithoutDocumentCertificateInput;
  where?: Maybe<PersonWhereInput>;
};

export type PersonUpdateToOneWithWhereWithoutPhonesInput = {
  data: PersonUpdateWithoutPhonesInput;
  where?: Maybe<PersonWhereInput>;
};

export type PersonUpdateWithWhereUniqueWithoutTeamInput = {
  data: PersonUpdateWithoutTeamInput;
  where: PersonWhereUniqueInput;
};

export type PersonUpdateWithoutAddressInput = {
  DocumentCertificate?: Maybe<DocumentCertificateUpdateManyWithoutPersonNestedInput>;
  Phones?: Maybe<TelephoneUpdateManyWithoutPersonNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutPersonNestedInput>;
  birthDate?: Maybe<NullableStringFieldUpdateOperationsInput>;
  cpf?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  educationLevel?: Maybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  email?: Maybe<NullableStringFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  identityDocument?: Maybe<NullableStringFieldUpdateOperationsInput>;
  isForeign?: Maybe<BoolFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
  passport?: Maybe<NullableStringFieldUpdateOperationsInput>;
  receivesCertificateEmail?: Maybe<BoolFieldUpdateOperationsInput>;
  receivesCertificateWhatsapp?: Maybe<BoolFieldUpdateOperationsInput>;
};

export type PersonUpdateWithoutDocumentCertificateInput = {
  Address?: Maybe<AddressUpdateOneWithoutPersonNestedInput>;
  Phones?: Maybe<TelephoneUpdateManyWithoutPersonNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutPersonNestedInput>;
  birthDate?: Maybe<NullableStringFieldUpdateOperationsInput>;
  cpf?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  educationLevel?: Maybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  email?: Maybe<NullableStringFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  identityDocument?: Maybe<NullableStringFieldUpdateOperationsInput>;
  isForeign?: Maybe<BoolFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
  passport?: Maybe<NullableStringFieldUpdateOperationsInput>;
  receivesCertificateEmail?: Maybe<BoolFieldUpdateOperationsInput>;
  receivesCertificateWhatsapp?: Maybe<BoolFieldUpdateOperationsInput>;
};

export type PersonUpdateWithoutPhonesInput = {
  Address?: Maybe<AddressUpdateOneWithoutPersonNestedInput>;
  DocumentCertificate?: Maybe<DocumentCertificateUpdateManyWithoutPersonNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutPersonNestedInput>;
  birthDate?: Maybe<NullableStringFieldUpdateOperationsInput>;
  cpf?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  educationLevel?: Maybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  email?: Maybe<NullableStringFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  identityDocument?: Maybe<NullableStringFieldUpdateOperationsInput>;
  isForeign?: Maybe<BoolFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
  passport?: Maybe<NullableStringFieldUpdateOperationsInput>;
  receivesCertificateEmail?: Maybe<BoolFieldUpdateOperationsInput>;
  receivesCertificateWhatsapp?: Maybe<BoolFieldUpdateOperationsInput>;
};

export type PersonUpdateWithoutTeamInput = {
  Address?: Maybe<AddressUpdateOneWithoutPersonNestedInput>;
  DocumentCertificate?: Maybe<DocumentCertificateUpdateManyWithoutPersonNestedInput>;
  Phones?: Maybe<TelephoneUpdateManyWithoutPersonNestedInput>;
  birthDate?: Maybe<NullableStringFieldUpdateOperationsInput>;
  cpf?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  educationLevel?: Maybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  email?: Maybe<NullableStringFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  identityDocument?: Maybe<NullableStringFieldUpdateOperationsInput>;
  isForeign?: Maybe<BoolFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
  passport?: Maybe<NullableStringFieldUpdateOperationsInput>;
  receivesCertificateEmail?: Maybe<BoolFieldUpdateOperationsInput>;
  receivesCertificateWhatsapp?: Maybe<BoolFieldUpdateOperationsInput>;
};

export type PersonUpsertWithWhereUniqueWithoutTeamInput = {
  create: PersonCreateWithoutTeamInput;
  update: PersonUpdateWithoutTeamInput;
  where: PersonWhereUniqueInput;
};

export type PersonUpsertWithoutAddressInput = {
  create: PersonCreateWithoutAddressInput;
  update: PersonUpdateWithoutAddressInput;
  where?: Maybe<PersonWhereInput>;
};

export type PersonUpsertWithoutDocumentCertificateInput = {
  create: PersonCreateWithoutDocumentCertificateInput;
  update: PersonUpdateWithoutDocumentCertificateInput;
  where?: Maybe<PersonWhereInput>;
};

export type PersonUpsertWithoutPhonesInput = {
  create: PersonCreateWithoutPhonesInput;
  update: PersonUpdateWithoutPhonesInput;
  where?: Maybe<PersonWhereInput>;
};

export type PersonWhereInput = {
  AND?: Maybe<Array<PersonWhereInput>>;
  Address?: Maybe<AddressWhereInput>;
  DocumentCertificate?: Maybe<DocumentCertificateListRelationFilter>;
  NOT?: Maybe<Array<PersonWhereInput>>;
  OR?: Maybe<Array<PersonWhereInput>>;
  Phones?: Maybe<TelephoneListRelationFilter>;
  Team?: Maybe<TeamWhereInput>;
  birthDate?: Maybe<StringNullableFilter>;
  cpf?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  educationLevel?: Maybe<EnumEducationLevelTypeFilter>;
  email?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  identityDocument?: Maybe<StringNullableFilter>;
  isForeign?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  passport?: Maybe<StringNullableFilter>;
  receivesCertificateEmail?: Maybe<BoolFilter>;
  receivesCertificateWhatsapp?: Maybe<BoolFilter>;
  teamId?: Maybe<IntFilter>;
};

export type PersonWhereUniqueInput = {
  AND?: Maybe<Array<PersonWhereInput>>;
  Address?: Maybe<AddressWhereInput>;
  DocumentCertificate?: Maybe<DocumentCertificateListRelationFilter>;
  NOT?: Maybe<Array<PersonWhereInput>>;
  OR?: Maybe<Array<PersonWhereInput>>;
  Phones?: Maybe<TelephoneListRelationFilter>;
  Team?: Maybe<TeamWhereInput>;
  birthDate?: Maybe<StringNullableFilter>;
  cpf?: Maybe<StringNullableFilter>;
  cpf_teamId?: Maybe<PersonCpfTeamIdCompoundUniqueInput>;
  createdAt?: Maybe<DateTimeFilter>;
  deletedAt?: Maybe<DateTimeNullableFilter>;
  educationLevel?: Maybe<EnumEducationLevelTypeFilter>;
  email?: Maybe<StringNullableFilter>;
  id?: Maybe<Scalars['String']>;
  identityDocument?: Maybe<StringNullableFilter>;
  isForeign?: Maybe<BoolFilter>;
  name?: Maybe<StringFilter>;
  passport?: Maybe<StringNullableFilter>;
  passport_teamId?: Maybe<PersonPassportTeamIdCompoundUniqueInput>;
  receivesCertificateEmail?: Maybe<BoolFilter>;
  receivesCertificateWhatsapp?: Maybe<BoolFilter>;
  teamId?: Maybe<IntFilter>;
};

/** A financial plan with values */
export type PlanAndConditions = {
  __typename?: 'PlanAndConditions';
  disabled: Scalars['Boolean'];
  includedCertificates: Scalars['Int'];
  monthlyPricing: Scalars['Float'];
  name: Scalars['String'];
  plan: FinancialPlan;
  yearlyPricing: Scalars['Float'];
};

export type PlanPayOverduePaymentsInput = {
  creditCard?: Maybe<InputFinancialPurchaseCreditCard>;
  savedCreditCard?: Maybe<InputFinancialPurchaseSavedCreditCard>;
};

/** Quantidade rápida pra definir a quantidade de itens pra comprar na recarga */
export type Preset = {
  __typename?: 'Preset';
  count: Scalars['Int'];
};

export type PublicView = {
  __typename?: 'PublicView';
  dataKeyValues: Array<KeyValue>;
  /** Diploma Digital, ... */
  documentTypeName: Scalars['String'];
  downloadUrl: Scalars['String'];
  /** Se o documento é valido ou revogado */
  isValid: Scalars['Boolean'];
  /** Se a visualização do documento estiver habilitada para este tipo de documento */
  isVisualRepresentationEnabled: Scalars['Boolean'];
  securityCode: Scalars['String'];
  validationDatetime: Scalars['String'];
  /** Url da visualização do documento, se existir */
  visualRepresentationUrl?: Maybe<Scalars['String']>;
};

export type PurchasedPlanWithOldPlan = {
  __typename?: 'PurchasedPlanWithOldPlan';
  Wallet: FinancialTeamWallet;
  /** Verdadeiro se primeiro plano da conta. Usado para redirecionar usuário para onboarding ou não. */
  isFirstPlan: Scalars['Boolean'];
};

export type Query = {
  __typename?: 'Query';
  codeDevOnlineUsers: Scalars['Json'];
  codeDevTest?: Maybe<Scalars['Json']>;
  countAddress: Scalars['Int'];
  countApiKey: Scalars['Int'];
  countBulkCertificateRecord: Scalars['Int'];
  countCertificateBase: Scalars['Int'];
  countCertificateCourse: Scalars['Int'];
  countCertificateCourseLevel: Scalars['Int'];
  countCertificateCurriculum: Scalars['Int'];
  countCertificateCurriculumSelectedDiscipline: Scalars['Int'];
  countCertificateDiscipline: Scalars['Int'];
  countCertificateEvent: Scalars['Int'];
  countCertificateTeacher: Scalars['Int'];
  countCertificateTemplate: Scalars['Int'];
  countCommonUser: Scalars['Int'];
  countDegree: Scalars['Int'];
  countDocumentAcademicDocumentation: Scalars['Int'];
  countDocumentAcademicDocumentationSearchView: Scalars['Int'];
  countDocumentAuditFileIssuer: Scalars['Int'];
  countDocumentAuditFileIssuerDegreeItem: Scalars['Int'];
  countDocumentBase: Scalars['Int'];
  /** Contar os tipos de documento. OBS: Use apenas um type na consulta, pois essa query retorna um INT. */
  countDocumentBaseByType?: Maybe<Scalars['Int']>;
  countDocumentBaseDefaultSignatureInviteConfiguration: Scalars['Int'];
  countDocumentBaseDefaultSignatureInviteConfigurationGroup: Scalars['Int'];
  countDocumentBaseDefaultSignatureInviteConfigurationGroupItem: Scalars['Int'];
  countDocumentBaseHistory: Scalars['Int'];
  countDocumentBaseSignatureInvite: Scalars['Int'];
  countDocumentBaseSignatureInviteGroup: Scalars['Int'];
  countDocumentBaseSignatureInviteSignature: Scalars['Int'];
  countDocumentCertificate: Scalars['Int'];
  countDocumentCertificateHashHistory: Scalars['Int'];
  countDocumentCertificateMetadata: Scalars['Int'];
  countDocumentCertificateSignatureItem: Scalars['Int'];
  countDocumentCertificateSignatureItemPossibleSignerInvite: Scalars['Int'];
  countDocumentCertificateSignatureItemPossibleSignerInviteSignature: Scalars['Int'];
  countDocumentDegreeSearchView: Scalars['Int'];
  countDocumentFinalAcademicTranscript: Scalars['Int'];
  countDocumentFinalAcademicTranscriptView: Scalars['Int'];
  countDocumentSchoolCurriculum: Scalars['Int'];
  countEnabledInstitution: Scalars['Int'];
  countFinancialCharge: Scalars['Int'];
  countFinancialCreditCardSaved: Scalars['Int'];
  countFinancialPayment: Scalars['Int'];
  countFinancialRecharge: Scalars['Int'];
  countFinancialTeamSignupSelectedOptions: Scalars['Int'];
  countFinancialTeamWallet: Scalars['Int'];
  countFinancialTeamWalletSubscription: Scalars['Int'];
  countFinancialTeamWalletSubscriptionPayment: Scalars['Int'];
  countFinancialTeamWalletSubscriptionPaymentHistory: Scalars['Int'];
  countMaintainerAdmin: Scalars['Int'];
  countPermission: Scalars['Int'];
  countPerson: Scalars['Int'];
  countReusableFormData: Scalars['Int'];
  countReusableFormDataCurriculum: Scalars['Int'];
  countSignSignatureImage: Scalars['Int'];
  countSystemAuditLog: Scalars['Int'];
  countSystemGlobalAlert: Scalars['Int'];
  countSystemGlobalAlertUserDismiss: Scalars['Int'];
  countSystemLog: Scalars['Int'];
  countTeam: Scalars['Int'];
  countTeamEducationLevel: Scalars['Int'];
  countTeamMaintained: Scalars['Int'];
  countTeamMember: Scalars['Int'];
  countTeamMemberPermission: Scalars['Int'];
  countTelephone: Scalars['Int'];
  countTotalIssuedDocuments: Scalars['Int'];
  findFirstAddress?: Maybe<Address>;
  findFirstCertificateBase?: Maybe<CertificateBase>;
  findFirstCertificateCurriculumSelectedDiscipline?: Maybe<CertificateCurriculumSelectedDiscipline>;
  findFirstDocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentation>;
  findFirstDocumentAcademicDocumentationSearchView?: Maybe<DocumentAcademicDocumentationSearchView>;
  findFirstDocumentAuditFileIssuerDegreeItem?: Maybe<DocumentAuditFileIssuerDegreeItem>;
  findFirstDocumentBase?: Maybe<DocumentBase>;
  findFirstDocumentBaseDefaultSignatureInviteConfigurationGroup?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroup>;
  findFirstDocumentBaseDefaultSignatureInviteConfigurationGroupItem?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItem>;
  findFirstDocumentBaseHistory?: Maybe<DocumentBaseHistory>;
  findFirstDocumentBaseSignatureInvite?: Maybe<DocumentBaseSignatureInvite>;
  findFirstDocumentBaseSignatureInviteGroup?: Maybe<DocumentBaseSignatureInviteGroup>;
  findFirstDocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignature>;
  findFirstDocumentCertificateHashHistory?: Maybe<DocumentCertificateHashHistory>;
  findFirstDocumentCertificateMetadata?: Maybe<DocumentCertificateMetadata>;
  findFirstDocumentCertificateSignatureItemPossibleSignerInvite?: Maybe<DocumentCertificateSignatureItemPossibleSignerInvite>;
  findFirstDocumentCertificateSignatureItemPossibleSignerInviteSignature?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteSignature>;
  findFirstDocumentDegree?: Maybe<DocumentDegree>;
  findFirstDocumentDegreeSearchView?: Maybe<DocumentDegreeSearchView>;
  findFirstDocumentFinalAcademicTranscriptView?: Maybe<DocumentFinalAcademicTranscriptView>;
  findFirstFinancialTeamSignupSelectedOptions?: Maybe<FinancialTeamSignupSelectedOptions>;
  findFirstFinancialTeamWallet?: Maybe<FinancialTeamWallet>;
  findFirstFinancialTeamWalletSubscription?: Maybe<FinancialTeamWalletSubscription>;
  findFirstFinancialTeamWalletSubscriptionPayment?: Maybe<FinancialTeamWalletSubscriptionPayment>;
  findFirstFinancialTeamWalletSubscriptionPaymentHistory?: Maybe<FinancialTeamWalletSubscriptionPaymentHistory>;
  findFirstPermission?: Maybe<Permission>;
  findFirstReusableFormData?: Maybe<ReusableFormData>;
  findFirstSystemGlobalAlertUserDismiss?: Maybe<SystemGlobalAlertUserDismiss>;
  findFirstSystemLog?: Maybe<SystemLog>;
  findFirstTeam?: Maybe<Team>;
  findFirstTeamEducationLevel?: Maybe<TeamEducationLevel>;
  findFirstTeamMember?: Maybe<TeamMember>;
  findFirstTeamMemberPermission?: Maybe<TeamMemberPermission>;
  findFirstTelephone?: Maybe<Telephone>;
  findManyAddress: Array<Address>;
  findManyApiKey: Array<ApiKey>;
  findManyBulkCertificateRecord: Array<BulkCertificateRecord>;
  findManyCertificateBase: Array<CertificateBase>;
  findManyCertificateCourse: Array<CertificateCourse>;
  findManyCertificateCourseLevel: Array<CertificateCourseLevel>;
  findManyCertificateCurriculum: Array<CertificateCurriculum>;
  findManyCertificateCurriculumSelectedDiscipline: Array<CertificateCurriculumSelectedDiscipline>;
  findManyCertificateDiscipline: Array<CertificateDiscipline>;
  findManyCertificateEvent: Array<CertificateEvent>;
  findManyCertificateTeacher: Array<CertificateTeacher>;
  findManyCertificateTemplate: Array<CertificateTemplate>;
  findManyCertificatesByBatchId: Array<DocumentCertificate>;
  findManyCommonUser: Array<CommonUser>;
  findManyDegree: Array<DocumentDegree>;
  findManyDocumentAcademicDocumentation: Array<DocumentAcademicDocumentation>;
  findManyDocumentAcademicDocumentationSearchView: Array<DocumentAcademicDocumentationSearchView>;
  findManyDocumentAuditFileIssuer: Array<DocumentAuditFileIssuer>;
  findManyDocumentAuditFileIssuerDegreeItem: Array<DocumentAuditFileIssuerDegreeItem>;
  findManyDocumentBase: Array<DocumentBase>;
  findManyDocumentBaseDefaultSignatureInviteConfiguration: Array<DocumentBaseDefaultSignatureInviteConfiguration>;
  findManyDocumentBaseDefaultSignatureInviteConfigurationGroup: Array<DocumentBaseDefaultSignatureInviteConfigurationGroup>;
  findManyDocumentBaseDefaultSignatureInviteConfigurationGroupItem: Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItem>;
  findManyDocumentBaseHistory: Array<DocumentBaseHistory>;
  findManyDocumentBaseSignatureInvite: Array<DocumentBaseSignatureInvite>;
  findManyDocumentBaseSignatureInviteGroup: Array<DocumentBaseSignatureInviteGroup>;
  findManyDocumentBaseSignatureInviteSignature: Array<DocumentBaseSignatureInviteSignature>;
  findManyDocumentCertificate: Array<DocumentCertificate>;
  findManyDocumentCertificateHashHistory: Array<DocumentCertificateHashHistory>;
  findManyDocumentCertificateMetadata: Array<DocumentCertificateMetadata>;
  findManyDocumentCertificateSignatureItem: Array<DocumentCertificateSignatureItem>;
  findManyDocumentCertificateSignatureItemPossibleSignerInvite: Array<DocumentCertificateSignatureItemPossibleSignerInvite>;
  findManyDocumentCertificateSignatureItemPossibleSignerInviteSignature: Array<DocumentCertificateSignatureItemPossibleSignerInviteSignature>;
  findManyDocumentDegreeSearchView: Array<DocumentDegreeSearchView>;
  findManyDocumentFinalAcademicTranscript: Array<DocumentFinalAcademicTranscript>;
  findManyDocumentFinalAcademicTranscriptView: Array<DocumentFinalAcademicTranscriptView>;
  findManyDocumentSchoolCurriculum: Array<DocumentSchoolCurriculum>;
  findManyEnabledInstitution: Array<EnabledInstitution>;
  findManyFinancialCharge: Array<FinancialCharge>;
  findManyFinancialCreditCardSaved: Array<FinancialCreditCardSaved>;
  findManyFinancialPayment: Array<FinancialPayment>;
  findManyFinancialPlan: Array<PlanAndConditions>;
  findManyFinancialRecharge: Array<FinancialRecharge>;
  findManyFinancialTeamSignupSelectedOptions: Array<FinancialTeamSignupSelectedOptions>;
  findManyFinancialTeamWallet: Array<FinancialTeamWallet>;
  findManyFinancialTeamWalletSubscription: Array<FinancialTeamWalletSubscription>;
  findManyFinancialTeamWalletSubscriptionPayment: Array<FinancialTeamWalletSubscriptionPayment>;
  findManyFinancialTeamWalletSubscriptionPaymentHistory: Array<FinancialTeamWalletSubscriptionPaymentHistory>;
  findManyMaintainerAdmin: Array<MaintainerAdmin>;
  findManyPermission: Array<Permission>;
  findManyPerson: Array<Person>;
  findManyReusableFormData: Array<ReusableFormData>;
  findManyReusableFormDataCurriculum: Array<ReusableFormDataCurriculum>;
  findManySignSignatureImage: Array<SignSignatureImage>;
  findManySignableDocumentBaseSignatureInvite: SignableInviteItemsAndCount;
  findManySystemAuditLog: Array<SystemAuditLog>;
  findManySystemGlobalAlert: Array<SystemGlobalAlert>;
  findManySystemGlobalAlertUserDismiss: Array<SystemGlobalAlertUserDismiss>;
  findManySystemLog: Array<SystemLog>;
  findManyTeam: Array<Team>;
  findManyTeamEducationLevel: Array<TeamEducationLevel>;
  findManyTeamMaintained: Array<Team>;
  findManyTeamMember: Array<TeamMember>;
  findManyTeamMemberPermission: Array<TeamMemberPermission>;
  findManyTelephone: Array<Telephone>;
  findOneExternalCepAddress: ExternalCepAddress;
  findUniqueAddress?: Maybe<Address>;
  findUniqueBulkCertificateRecord?: Maybe<BulkCertificateRecord>;
  findUniqueCertificateBase?: Maybe<CertificateBase>;
  findUniqueCertificateCourse?: Maybe<CertificateCourse>;
  findUniqueCertificateCourseLevel?: Maybe<CertificateCourseLevel>;
  findUniqueCertificateCurriculum?: Maybe<CertificateCurriculum>;
  findUniqueCertificateCurriculumSelectedDiscipline?: Maybe<CertificateCurriculumSelectedDiscipline>;
  findUniqueCertificateDiscipline?: Maybe<CertificateDiscipline>;
  findUniqueCertificateEvent?: Maybe<CertificateEvent>;
  findUniqueCertificateTeacher?: Maybe<CertificateTeacher>;
  findUniqueCertificateTemplate?: Maybe<CertificateTemplate>;
  findUniqueDegreeToSeeBySecurityCode?: Maybe<DocumentDegree>;
  findUniqueDocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentation>;
  findUniqueDocumentAcademicDocumentationSearchView?: Maybe<DocumentAcademicDocumentationSearchView>;
  findUniqueDocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuer>;
  findUniqueDocumentAuditFileIssuerDegreeItem?: Maybe<DocumentAuditFileIssuerDegreeItem>;
  findUniqueDocumentBase?: Maybe<DocumentBase>;
  findUniqueDocumentBaseDefaultSignatureInviteConfiguration?: Maybe<DocumentBaseDefaultSignatureInviteConfiguration>;
  findUniqueDocumentBaseDefaultSignatureInviteConfigurationGroup?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroup>;
  findUniqueDocumentBaseDefaultSignatureInviteConfigurationGroupItem?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItem>;
  findUniqueDocumentBaseHistory?: Maybe<DocumentBaseHistory>;
  findUniqueDocumentBaseSignatureInvite?: Maybe<DocumentBaseSignatureInvite>;
  findUniqueDocumentBaseSignatureInviteGroup?: Maybe<DocumentBaseSignatureInviteGroup>;
  findUniqueDocumentBaseSignatureInviteSignature?: Maybe<DocumentBaseSignatureInviteSignature>;
  findUniqueDocumentCertificate?: Maybe<DocumentCertificate>;
  findUniqueDocumentCertificateHashHistory?: Maybe<DocumentCertificateHashHistory>;
  findUniqueDocumentCertificateMetadata?: Maybe<DocumentCertificateMetadata>;
  findUniqueDocumentCertificateSignatureItem?: Maybe<DocumentCertificateSignatureItem>;
  findUniqueDocumentCertificateSignatureItemPossibleSignerInvite?: Maybe<DocumentCertificateSignatureItemPossibleSignerInvite>;
  findUniqueDocumentCertificateSignatureItemPossibleSignerInviteSignature?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteSignature>;
  findUniqueDocumentDegree?: Maybe<DocumentDegree>;
  findUniqueDocumentDegreeSearchView?: Maybe<DocumentDegreeSearchView>;
  findUniqueDocumentFinalAcademicTranscript?: Maybe<DocumentFinalAcademicTranscript>;
  findUniqueDocumentFinalAcademicTranscriptView?: Maybe<DocumentFinalAcademicTranscriptView>;
  findUniqueDocumentSchoolCurriculum?: Maybe<DocumentSchoolCurriculum>;
  findUniqueExternalSignatureInvite?: Maybe<ExternalSignatureInvite>;
  findUniqueFinancialTeamSignupSelectedOptions?: Maybe<FinancialTeamSignupSelectedOptions>;
  findUniqueFinancialTeamWallet?: Maybe<FinancialTeamWallet>;
  findUniqueFinancialTeamWalletSubscription?: Maybe<FinancialTeamWalletSubscription>;
  findUniqueFinancialTeamWalletSubscriptionPayment?: Maybe<FinancialTeamWalletSubscriptionPayment>;
  findUniqueFinancialTeamWalletSubscriptionPaymentHistory?: Maybe<FinancialTeamWalletSubscriptionPaymentHistory>;
  findUniquePermission?: Maybe<Permission>;
  findUniquePerson?: Maybe<Person>;
  findUniqueReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculum>;
  findUniqueSignSignatureImage?: Maybe<SignSignatureImage>;
  findUniqueSystemGlobalAlertUserDismiss?: Maybe<SystemGlobalAlertUserDismiss>;
  findUniqueSystemLog?: Maybe<SystemLog>;
  findUniqueTeam?: Maybe<Team>;
  findUniqueTeamAndPublicDocumentBaseTypeByPublicUrl?: Maybe<TeamAndPublicDocumentBaseType>;
  findUniqueTeamEducationLevel?: Maybe<TeamEducationLevel>;
  findUniqueTeamMemberPermission?: Maybe<TeamMemberPermission>;
  findUniqueTelephone?: Maybe<Telephone>;
  findUniqueToSeePublicDocument?: Maybe<PublicView>;
  /** Retorna o base64 do PDF do certificado */
  generateSampleCertificatePdfBase64: Scalars['String'];
  getFinancialRechargePlans: RechargeOptions;
  getMineTeam?: Maybe<Team>;
  getMineTeamCount: Scalars['Int'];
  globalHealth: Scalars['String'];
  me?: Maybe<CommonUser>;
  summaryFinancialCharge: SumCount;
  validateOneDocumentCertificate: ValidateOneDocumentCertificateObject;
};


export type QueryCountAddressArgs = {
  cursor?: Maybe<AddressWhereUniqueInput>;
  distinct?: Maybe<Array<AddressScalarFieldEnum>>;
  orderBy?: Maybe<Array<AddressOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AddressWhereInput>;
};


export type QueryCountApiKeyArgs = {
  cursor?: Maybe<ApiKeyWhereUniqueInput>;
  distinct?: Maybe<Array<ApiKeyScalarFieldEnum>>;
  orderBy?: Maybe<Array<ApiKeyOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ApiKeyWhereInput>;
};


export type QueryCountBulkCertificateRecordArgs = {
  cursor?: Maybe<BulkCertificateRecordWhereUniqueInput>;
  distinct?: Maybe<Array<BulkCertificateRecordScalarFieldEnum>>;
  orderBy?: Maybe<Array<BulkCertificateRecordOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BulkCertificateRecordWhereInput>;
};


export type QueryCountCertificateBaseArgs = {
  cursor?: Maybe<CertificateBaseWhereUniqueInput>;
  distinct?: Maybe<Array<CertificateBaseScalarFieldEnum>>;
  orderBy?: Maybe<Array<CertificateBaseOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CertificateBaseWhereInput>;
};


export type QueryCountCertificateCourseArgs = {
  cursor?: Maybe<CertificateCourseWhereUniqueInput>;
  distinct?: Maybe<Array<CertificateCourseScalarFieldEnum>>;
  orderBy?: Maybe<Array<CertificateCourseOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CertificateCourseWhereInput>;
};


export type QueryCountCertificateCourseLevelArgs = {
  cursor?: Maybe<CertificateCourseLevelWhereUniqueInput>;
  distinct?: Maybe<Array<CertificateCourseLevelScalarFieldEnum>>;
  orderBy?: Maybe<Array<CertificateCourseLevelOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CertificateCourseLevelWhereInput>;
};


export type QueryCountCertificateCurriculumArgs = {
  cursor?: Maybe<CertificateCurriculumWhereUniqueInput>;
  distinct?: Maybe<Array<CertificateCurriculumScalarFieldEnum>>;
  orderBy?: Maybe<Array<CertificateCurriculumOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CertificateCurriculumWhereInput>;
};


export type QueryCountCertificateCurriculumSelectedDisciplineArgs = {
  cursor?: Maybe<CertificateCurriculumSelectedDisciplineWhereUniqueInput>;
  distinct?: Maybe<Array<CertificateCurriculumSelectedDisciplineScalarFieldEnum>>;
  orderBy?: Maybe<Array<CertificateCurriculumSelectedDisciplineOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CertificateCurriculumSelectedDisciplineWhereInput>;
};


export type QueryCountCertificateDisciplineArgs = {
  cursor?: Maybe<CertificateDisciplineWhereUniqueInput>;
  distinct?: Maybe<Array<CertificateDisciplineScalarFieldEnum>>;
  orderBy?: Maybe<Array<CertificateDisciplineOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CertificateDisciplineWhereInput>;
};


export type QueryCountCertificateEventArgs = {
  cursor?: Maybe<CertificateEventWhereUniqueInput>;
  distinct?: Maybe<Array<CertificateEventScalarFieldEnum>>;
  orderBy?: Maybe<Array<CertificateEventOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CertificateEventWhereInput>;
};


export type QueryCountCertificateTeacherArgs = {
  cursor?: Maybe<CertificateTeacherWhereUniqueInput>;
  distinct?: Maybe<Array<CertificateTeacherScalarFieldEnum>>;
  orderBy?: Maybe<Array<CertificateTeacherOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CertificateTeacherWhereInput>;
};


export type QueryCountCertificateTemplateArgs = {
  cursor?: Maybe<CertificateTemplateWhereUniqueInput>;
  distinct?: Maybe<Array<CertificateTemplateScalarFieldEnum>>;
  orderBy?: Maybe<Array<CertificateTemplateOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CertificateTemplateWhereInput>;
};


export type QueryCountCommonUserArgs = {
  cursor?: Maybe<CommonUserWhereUniqueInput>;
  distinct?: Maybe<Array<CommonUserScalarFieldEnum>>;
  orderBy?: Maybe<Array<CommonUserOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CommonUserWhereInput>;
};


export type QueryCountDegreeArgs = {
  cursor?: Maybe<DocumentDegreeWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentDegreeScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentDegreeOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentDegreeWhereInput>;
};


export type QueryCountDocumentAcademicDocumentationArgs = {
  cursor?: Maybe<DocumentAcademicDocumentationWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentAcademicDocumentationScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentAcademicDocumentationOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentAcademicDocumentationWhereInput>;
};


export type QueryCountDocumentAcademicDocumentationSearchViewArgs = {
  cursor?: Maybe<DocumentAcademicDocumentationSearchViewWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentAcademicDocumentationSearchViewScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentAcademicDocumentationSearchViewOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentAcademicDocumentationSearchViewWhereInput>;
};


export type QueryCountDocumentAuditFileIssuerArgs = {
  cursor?: Maybe<DocumentAuditFileIssuerWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentAuditFileIssuerScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentAuditFileIssuerOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentAuditFileIssuerWhereInput>;
};


export type QueryCountDocumentAuditFileIssuerDegreeItemArgs = {
  cursor?: Maybe<DocumentAuditFileIssuerDegreeItemWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentAuditFileIssuerDegreeItemScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentAuditFileIssuerDegreeItemOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentAuditFileIssuerDegreeItemWhereInput>;
};


export type QueryCountDocumentBaseArgs = {
  cursor?: Maybe<DocumentBaseWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseWhereInput>;
};


export type QueryCountDocumentBaseByTypeArgs = {
  where: DocumentBaseWhereInput;
};


export type QueryCountDocumentBaseDefaultSignatureInviteConfigurationArgs = {
  cursor?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>;
};


export type QueryCountDocumentBaseDefaultSignatureInviteConfigurationGroupArgs = {
  cursor?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>;
};


export type QueryCountDocumentBaseDefaultSignatureInviteConfigurationGroupItemArgs = {
  cursor?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereInput>;
};


export type QueryCountDocumentBaseHistoryArgs = {
  cursor?: Maybe<DocumentBaseHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseHistoryScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseHistoryOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseHistoryWhereInput>;
};


export type QueryCountDocumentBaseSignatureInviteArgs = {
  cursor?: Maybe<DocumentBaseSignatureInviteWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseSignatureInviteScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseSignatureInviteOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseSignatureInviteWhereInput>;
};


export type QueryCountDocumentBaseSignatureInviteGroupArgs = {
  cursor?: Maybe<DocumentBaseSignatureInviteGroupWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseSignatureInviteGroupScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseSignatureInviteGroupOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseSignatureInviteGroupWhereInput>;
};


export type QueryCountDocumentBaseSignatureInviteSignatureArgs = {
  cursor?: Maybe<DocumentBaseSignatureInviteSignatureWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseSignatureInviteSignatureScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseSignatureInviteSignatureOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseSignatureInviteSignatureWhereInput>;
};


export type QueryCountDocumentCertificateArgs = {
  cursor?: Maybe<DocumentCertificateWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentCertificateScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentCertificateOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentCertificateWhereInput>;
};


export type QueryCountDocumentCertificateHashHistoryArgs = {
  cursor?: Maybe<DocumentCertificateHashHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentCertificateHashHistoryScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentCertificateHashHistoryOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentCertificateHashHistoryWhereInput>;
};


export type QueryCountDocumentCertificateMetadataArgs = {
  cursor?: Maybe<DocumentCertificateMetadataWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentCertificateMetadataScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentCertificateMetadataOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentCertificateMetadataWhereInput>;
};


export type QueryCountDocumentCertificateSignatureItemArgs = {
  cursor?: Maybe<DocumentCertificateSignatureItemWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentCertificateSignatureItemScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentCertificateSignatureItemOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentCertificateSignatureItemWhereInput>;
};


export type QueryCountDocumentCertificateSignatureItemPossibleSignerInviteArgs = {
  cursor?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>;
};


export type QueryCountDocumentCertificateSignatureItemPossibleSignerInviteSignatureArgs = {
  cursor?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereInput>;
};


export type QueryCountDocumentDegreeSearchViewArgs = {
  cursor?: Maybe<DocumentDegreeSearchViewWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentDegreeSearchViewScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentDegreeSearchViewOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentDegreeSearchViewWhereInput>;
};


export type QueryCountDocumentFinalAcademicTranscriptArgs = {
  cursor?: Maybe<DocumentFinalAcademicTranscriptWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentFinalAcademicTranscriptScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentFinalAcademicTranscriptOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentFinalAcademicTranscriptWhereInput>;
};


export type QueryCountDocumentFinalAcademicTranscriptViewArgs = {
  cursor?: Maybe<DocumentFinalAcademicTranscriptViewWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentFinalAcademicTranscriptViewScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentFinalAcademicTranscriptViewOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentFinalAcademicTranscriptViewWhereInput>;
};


export type QueryCountDocumentSchoolCurriculumArgs = {
  cursor?: Maybe<DocumentSchoolCurriculumWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentSchoolCurriculumScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentSchoolCurriculumOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentSchoolCurriculumWhereInput>;
};


export type QueryCountEnabledInstitutionArgs = {
  cursor?: Maybe<EnabledInstitutionWhereUniqueInput>;
  distinct?: Maybe<Array<EnabledInstitutionScalarFieldEnum>>;
  orderBy?: Maybe<Array<EnabledInstitutionOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EnabledInstitutionWhereInput>;
};


export type QueryCountFinancialChargeArgs = {
  cursor?: Maybe<FinancialChargeWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialChargeScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialChargeOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialChargeWhereInput>;
};


export type QueryCountFinancialCreditCardSavedArgs = {
  cursor?: Maybe<FinancialCreditCardSavedWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialCreditCardSavedScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialCreditCardSavedOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialCreditCardSavedWhereInput>;
};


export type QueryCountFinancialPaymentArgs = {
  cursor?: Maybe<FinancialPaymentWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialPaymentScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialPaymentOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialPaymentWhereInput>;
};


export type QueryCountFinancialRechargeArgs = {
  cursor?: Maybe<FinancialRechargeWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialRechargeScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialRechargeOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialRechargeWhereInput>;
};


export type QueryCountFinancialTeamSignupSelectedOptionsArgs = {
  cursor?: Maybe<FinancialTeamSignupSelectedOptionsWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialTeamSignupSelectedOptionsScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialTeamSignupSelectedOptionsOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialTeamSignupSelectedOptionsWhereInput>;
};


export type QueryCountFinancialTeamWalletArgs = {
  cursor?: Maybe<FinancialTeamWalletWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialTeamWalletScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialTeamWalletOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialTeamWalletWhereInput>;
};


export type QueryCountFinancialTeamWalletSubscriptionArgs = {
  cursor?: Maybe<FinancialTeamWalletSubscriptionWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialTeamWalletSubscriptionScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialTeamWalletSubscriptionOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialTeamWalletSubscriptionWhereInput>;
};


export type QueryCountFinancialTeamWalletSubscriptionPaymentArgs = {
  cursor?: Maybe<FinancialTeamWalletSubscriptionPaymentWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
};


export type QueryCountFinancialTeamWalletSubscriptionPaymentHistoryArgs = {
  cursor?: Maybe<FinancialTeamWalletSubscriptionPaymentHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialTeamWalletSubscriptionPaymentHistoryWhereInput>;
};


export type QueryCountMaintainerAdminArgs = {
  cursor?: Maybe<MaintainerAdminWhereUniqueInput>;
  distinct?: Maybe<Array<MaintainerAdminScalarFieldEnum>>;
  orderBy?: Maybe<Array<MaintainerAdminOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MaintainerAdminWhereInput>;
};


export type QueryCountPermissionArgs = {
  cursor?: Maybe<PermissionWhereUniqueInput>;
  distinct?: Maybe<Array<PermissionScalarFieldEnum>>;
  orderBy?: Maybe<Array<PermissionOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PermissionWhereInput>;
};


export type QueryCountPersonArgs = {
  cursor?: Maybe<PersonWhereUniqueInput>;
  distinct?: Maybe<Array<PersonScalarFieldEnum>>;
  orderBy?: Maybe<Array<PersonOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PersonWhereInput>;
};


export type QueryCountReusableFormDataArgs = {
  cursor?: Maybe<ReusableFormDataWhereUniqueInput>;
  distinct?: Maybe<Array<ReusableFormDataScalarFieldEnum>>;
  orderBy?: Maybe<Array<ReusableFormDataOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ReusableFormDataWhereInputCustom>;
};


export type QueryCountReusableFormDataCurriculumArgs = {
  cursor?: Maybe<ReusableFormDataCurriculumWhereUniqueInput>;
  distinct?: Maybe<Array<ReusableFormDataCurriculumScalarFieldEnum>>;
  orderBy?: Maybe<Array<ReusableFormDataCurriculumOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ReusableFormDataCurriculumWhereInput>;
};


export type QueryCountSignSignatureImageArgs = {
  cursor?: Maybe<SignSignatureImageWhereUniqueInput>;
  distinct?: Maybe<Array<SignSignatureImageScalarFieldEnum>>;
  orderBy?: Maybe<Array<SignSignatureImageOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SignSignatureImageWhereInput>;
};


export type QueryCountSystemAuditLogArgs = {
  cursor?: Maybe<SystemAuditLogWhereUniqueInput>;
  distinct?: Maybe<Array<SystemAuditLogScalarFieldEnum>>;
  orderBy?: Maybe<Array<SystemAuditLogOrderByWithRelationInput>>;
  search?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SystemAuditLogWhereInput>;
};


export type QueryCountSystemGlobalAlertArgs = {
  cursor?: Maybe<SystemGlobalAlertWhereUniqueInput>;
  distinct?: Maybe<Array<SystemGlobalAlertScalarFieldEnum>>;
  orderBy?: Maybe<Array<SystemGlobalAlertOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SystemGlobalAlertWhereInput>;
};


export type QueryCountSystemGlobalAlertUserDismissArgs = {
  cursor?: Maybe<SystemGlobalAlertUserDismissWhereUniqueInput>;
  distinct?: Maybe<Array<SystemGlobalAlertUserDismissScalarFieldEnum>>;
  orderBy?: Maybe<Array<SystemGlobalAlertUserDismissOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SystemGlobalAlertUserDismissWhereInput>;
};


export type QueryCountSystemLogArgs = {
  cursor?: Maybe<SystemLogWhereUniqueInput>;
  distinct?: Maybe<Array<SystemLogScalarFieldEnum>>;
  orderBy?: Maybe<Array<SystemLogOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SystemLogWhereInput>;
};


export type QueryCountTeamArgs = {
  cursor?: Maybe<TeamWhereUniqueInput>;
  distinct?: Maybe<Array<TeamScalarFieldEnum>>;
  orderBy?: Maybe<Array<TeamOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TeamWhereInput>;
};


export type QueryCountTeamEducationLevelArgs = {
  cursor?: Maybe<TeamEducationLevelWhereUniqueInput>;
  distinct?: Maybe<Array<TeamEducationLevelScalarFieldEnum>>;
  orderBy?: Maybe<Array<TeamEducationLevelOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TeamEducationLevelWhereInput>;
};


export type QueryCountTeamMaintainedArgs = {
  cursor?: Maybe<TeamWhereUniqueInput>;
  distinct?: Maybe<Array<TeamScalarFieldEnum>>;
  orderBy?: Maybe<Array<TeamOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TeamWhereInput>;
};


export type QueryCountTeamMemberArgs = {
  cursor?: Maybe<TeamMemberWhereUniqueInput>;
  distinct?: Maybe<Array<TeamMemberScalarFieldEnum>>;
  orderBy?: Maybe<Array<TeamMemberOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TeamMemberWhereInput>;
};


export type QueryCountTeamMemberPermissionArgs = {
  cursor?: Maybe<TeamMemberPermissionWhereUniqueInput>;
  distinct?: Maybe<Array<TeamMemberPermissionScalarFieldEnum>>;
  orderBy?: Maybe<Array<TeamMemberPermissionOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TeamMemberPermissionWhereInput>;
};


export type QueryCountTelephoneArgs = {
  cursor?: Maybe<TelephoneWhereUniqueInput>;
  distinct?: Maybe<Array<TelephoneScalarFieldEnum>>;
  orderBy?: Maybe<Array<TelephoneOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TelephoneWhereInput>;
};


export type QueryFindFirstAddressArgs = {
  cursor?: Maybe<AddressWhereUniqueInput>;
  distinct?: Maybe<Array<AddressScalarFieldEnum>>;
  orderBy?: Maybe<Array<AddressOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AddressWhereInput>;
};


export type QueryFindFirstCertificateBaseArgs = {
  cursor?: Maybe<CertificateBaseWhereUniqueInput>;
  distinct?: Maybe<Array<CertificateBaseScalarFieldEnum>>;
  orderBy?: Maybe<Array<CertificateBaseOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CertificateBaseWhereInput>;
};


export type QueryFindFirstCertificateCurriculumSelectedDisciplineArgs = {
  cursor?: Maybe<CertificateCurriculumSelectedDisciplineWhereUniqueInput>;
  distinct?: Maybe<Array<CertificateCurriculumSelectedDisciplineScalarFieldEnum>>;
  orderBy?: Maybe<Array<CertificateCurriculumSelectedDisciplineOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CertificateCurriculumSelectedDisciplineWhereInput>;
};


export type QueryFindFirstDocumentAcademicDocumentationArgs = {
  cursor?: Maybe<DocumentAcademicDocumentationWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentAcademicDocumentationScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentAcademicDocumentationOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentAcademicDocumentationWhereInput>;
};


export type QueryFindFirstDocumentAcademicDocumentationSearchViewArgs = {
  cursor?: Maybe<DocumentAcademicDocumentationSearchViewWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentAcademicDocumentationSearchViewScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentAcademicDocumentationSearchViewOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentAcademicDocumentationSearchViewWhereInput>;
};


export type QueryFindFirstDocumentAuditFileIssuerDegreeItemArgs = {
  cursor?: Maybe<DocumentAuditFileIssuerDegreeItemWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentAuditFileIssuerDegreeItemScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentAuditFileIssuerDegreeItemOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentAuditFileIssuerDegreeItemWhereInput>;
};


export type QueryFindFirstDocumentBaseArgs = {
  cursor?: Maybe<DocumentBaseWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseWhereInput>;
};


export type QueryFindFirstDocumentBaseDefaultSignatureInviteConfigurationGroupArgs = {
  cursor?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>;
};


export type QueryFindFirstDocumentBaseDefaultSignatureInviteConfigurationGroupItemArgs = {
  cursor?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereInput>;
};


export type QueryFindFirstDocumentBaseHistoryArgs = {
  cursor?: Maybe<DocumentBaseHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseHistoryScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseHistoryOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseHistoryWhereInput>;
};


export type QueryFindFirstDocumentBaseSignatureInviteArgs = {
  cursor?: Maybe<DocumentBaseSignatureInviteWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseSignatureInviteScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseSignatureInviteOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseSignatureInviteWhereInput>;
};


export type QueryFindFirstDocumentBaseSignatureInviteGroupArgs = {
  cursor?: Maybe<DocumentBaseSignatureInviteGroupWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseSignatureInviteGroupScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseSignatureInviteGroupOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseSignatureInviteGroupWhereInput>;
};


export type QueryFindFirstDocumentBaseSignatureInviteSignatureArgs = {
  cursor?: Maybe<DocumentBaseSignatureInviteSignatureWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseSignatureInviteSignatureScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseSignatureInviteSignatureOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseSignatureInviteSignatureWhereInput>;
};


export type QueryFindFirstDocumentCertificateHashHistoryArgs = {
  cursor?: Maybe<DocumentCertificateHashHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentCertificateHashHistoryScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentCertificateHashHistoryOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentCertificateHashHistoryWhereInput>;
};


export type QueryFindFirstDocumentCertificateMetadataArgs = {
  cursor?: Maybe<DocumentCertificateMetadataWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentCertificateMetadataScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentCertificateMetadataOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentCertificateMetadataWhereInput>;
};


export type QueryFindFirstDocumentCertificateSignatureItemPossibleSignerInviteArgs = {
  cursor?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>;
};


export type QueryFindFirstDocumentCertificateSignatureItemPossibleSignerInviteSignatureArgs = {
  cursor?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereInput>;
};


export type QueryFindFirstDocumentDegreeArgs = {
  cursor?: Maybe<DocumentDegreeWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentDegreeScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentDegreeOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentDegreeWhereInput>;
};


export type QueryFindFirstDocumentDegreeSearchViewArgs = {
  cursor?: Maybe<DocumentDegreeSearchViewWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentDegreeSearchViewScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentDegreeSearchViewOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentDegreeSearchViewWhereInput>;
};


export type QueryFindFirstDocumentFinalAcademicTranscriptViewArgs = {
  cursor?: Maybe<DocumentFinalAcademicTranscriptViewWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentFinalAcademicTranscriptViewScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentFinalAcademicTranscriptViewOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentFinalAcademicTranscriptViewWhereInput>;
};


export type QueryFindFirstFinancialTeamSignupSelectedOptionsArgs = {
  cursor?: Maybe<FinancialTeamSignupSelectedOptionsWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialTeamSignupSelectedOptionsScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialTeamSignupSelectedOptionsOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialTeamSignupSelectedOptionsWhereInput>;
};


export type QueryFindFirstFinancialTeamWalletArgs = {
  cursor?: Maybe<FinancialTeamWalletWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialTeamWalletScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialTeamWalletOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialTeamWalletWhereInput>;
};


export type QueryFindFirstFinancialTeamWalletSubscriptionArgs = {
  cursor?: Maybe<FinancialTeamWalletSubscriptionWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialTeamWalletSubscriptionScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialTeamWalletSubscriptionOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialTeamWalletSubscriptionWhereInput>;
};


export type QueryFindFirstFinancialTeamWalletSubscriptionPaymentArgs = {
  cursor?: Maybe<FinancialTeamWalletSubscriptionPaymentWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
};


export type QueryFindFirstFinancialTeamWalletSubscriptionPaymentHistoryArgs = {
  cursor?: Maybe<FinancialTeamWalletSubscriptionPaymentHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialTeamWalletSubscriptionPaymentHistoryWhereInput>;
};


export type QueryFindFirstPermissionArgs = {
  cursor?: Maybe<PermissionWhereUniqueInput>;
  distinct?: Maybe<Array<PermissionScalarFieldEnum>>;
  orderBy?: Maybe<Array<PermissionOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PermissionWhereInput>;
};


export type QueryFindFirstReusableFormDataArgs = {
  cursor?: Maybe<ReusableFormDataWhereUniqueInput>;
  distinct?: Maybe<Array<ReusableFormDataScalarFieldEnum>>;
  orderBy?: Maybe<Array<ReusableFormDataOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ReusableFormDataWhereInput>;
};


export type QueryFindFirstSystemGlobalAlertUserDismissArgs = {
  cursor?: Maybe<SystemGlobalAlertUserDismissWhereUniqueInput>;
  distinct?: Maybe<Array<SystemGlobalAlertUserDismissScalarFieldEnum>>;
  orderBy?: Maybe<Array<SystemGlobalAlertUserDismissOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SystemGlobalAlertUserDismissWhereInput>;
};


export type QueryFindFirstSystemLogArgs = {
  cursor?: Maybe<SystemLogWhereUniqueInput>;
  distinct?: Maybe<Array<SystemLogScalarFieldEnum>>;
  orderBy?: Maybe<Array<SystemLogOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SystemLogWhereInput>;
};


export type QueryFindFirstTeamArgs = {
  cursor?: Maybe<TeamWhereUniqueInput>;
  distinct?: Maybe<Array<TeamScalarFieldEnum>>;
  orderBy?: Maybe<Array<TeamOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TeamWhereInput>;
};


export type QueryFindFirstTeamEducationLevelArgs = {
  cursor?: Maybe<TeamEducationLevelWhereUniqueInput>;
  distinct?: Maybe<Array<TeamEducationLevelScalarFieldEnum>>;
  orderBy?: Maybe<Array<TeamEducationLevelOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TeamEducationLevelWhereInput>;
};


export type QueryFindFirstTeamMemberArgs = {
  cursor?: Maybe<TeamMemberWhereUniqueInput>;
  distinct?: Maybe<Array<TeamMemberScalarFieldEnum>>;
  orderBy?: Maybe<Array<TeamMemberOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TeamMemberWhereInput>;
};


export type QueryFindFirstTeamMemberPermissionArgs = {
  cursor?: Maybe<TeamMemberPermissionWhereUniqueInput>;
  distinct?: Maybe<Array<TeamMemberPermissionScalarFieldEnum>>;
  orderBy?: Maybe<Array<TeamMemberPermissionOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TeamMemberPermissionWhereInput>;
};


export type QueryFindFirstTelephoneArgs = {
  cursor?: Maybe<TelephoneWhereUniqueInput>;
  distinct?: Maybe<Array<TelephoneScalarFieldEnum>>;
  orderBy?: Maybe<Array<TelephoneOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TelephoneWhereInput>;
};


export type QueryFindManyAddressArgs = {
  cursor?: Maybe<AddressWhereUniqueInput>;
  distinct?: Maybe<Array<AddressScalarFieldEnum>>;
  orderBy?: Maybe<Array<AddressOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<AddressWhereInput>;
};


export type QueryFindManyApiKeyArgs = {
  cursor?: Maybe<ApiKeyWhereUniqueInput>;
  distinct?: Maybe<Array<ApiKeyScalarFieldEnum>>;
  orderBy?: Maybe<Array<ApiKeyOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ApiKeyWhereInput>;
};


export type QueryFindManyBulkCertificateRecordArgs = {
  cursor?: Maybe<BulkCertificateRecordWhereUniqueInput>;
  distinct?: Maybe<Array<BulkCertificateRecordScalarFieldEnum>>;
  orderBy?: Maybe<Array<BulkCertificateRecordOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BulkCertificateRecordWhereInput>;
};


export type QueryFindManyCertificateBaseArgs = {
  cursor?: Maybe<CertificateBaseWhereUniqueInput>;
  distinct?: Maybe<Array<CertificateBaseScalarFieldEnum>>;
  orderBy?: Maybe<Array<CertificateBaseOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CertificateBaseWhereInput>;
};


export type QueryFindManyCertificateCourseArgs = {
  cursor?: Maybe<CertificateCourseWhereUniqueInput>;
  distinct?: Maybe<Array<CertificateCourseScalarFieldEnum>>;
  orderBy?: Maybe<Array<CertificateCourseOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CertificateCourseWhereInput>;
};


export type QueryFindManyCertificateCourseLevelArgs = {
  cursor?: Maybe<CertificateCourseLevelWhereUniqueInput>;
  distinct?: Maybe<Array<CertificateCourseLevelScalarFieldEnum>>;
  orderBy?: Maybe<Array<CertificateCourseLevelOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CertificateCourseLevelWhereInput>;
};


export type QueryFindManyCertificateCurriculumArgs = {
  cursor?: Maybe<CertificateCurriculumWhereUniqueInput>;
  distinct?: Maybe<Array<CertificateCurriculumScalarFieldEnum>>;
  orderBy?: Maybe<Array<CertificateCurriculumOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CertificateCurriculumWhereInput>;
};


export type QueryFindManyCertificateCurriculumSelectedDisciplineArgs = {
  cursor?: Maybe<CertificateCurriculumSelectedDisciplineWhereUniqueInput>;
  distinct?: Maybe<Array<CertificateCurriculumSelectedDisciplineScalarFieldEnum>>;
  orderBy?: Maybe<Array<CertificateCurriculumSelectedDisciplineOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CertificateCurriculumSelectedDisciplineWhereInput>;
};


export type QueryFindManyCertificateDisciplineArgs = {
  cursor?: Maybe<CertificateDisciplineWhereUniqueInput>;
  distinct?: Maybe<Array<CertificateDisciplineScalarFieldEnum>>;
  orderBy?: Maybe<Array<CertificateDisciplineOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CertificateDisciplineWhereInput>;
};


export type QueryFindManyCertificateEventArgs = {
  cursor?: Maybe<CertificateEventWhereUniqueInput>;
  distinct?: Maybe<Array<CertificateEventScalarFieldEnum>>;
  orderBy?: Maybe<Array<CertificateEventOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CertificateEventWhereInput>;
};


export type QueryFindManyCertificateTeacherArgs = {
  cursor?: Maybe<CertificateTeacherWhereUniqueInput>;
  distinct?: Maybe<Array<CertificateTeacherScalarFieldEnum>>;
  orderBy?: Maybe<Array<CertificateTeacherOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CertificateTeacherWhereInput>;
};


export type QueryFindManyCertificateTemplateArgs = {
  cursor?: Maybe<CertificateTemplateWhereUniqueInput>;
  distinct?: Maybe<Array<CertificateTemplateScalarFieldEnum>>;
  orderBy?: Maybe<Array<CertificateTemplateOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CertificateTemplateWhereInput>;
};


export type QueryFindManyCertificatesByBatchIdArgs = {
  batchId?: Maybe<Scalars['String']>;
};


export type QueryFindManyCommonUserArgs = {
  cursor?: Maybe<CommonUserWhereUniqueInput>;
  distinct?: Maybe<Array<CommonUserScalarFieldEnum>>;
  orderBy?: Maybe<Array<CommonUserOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CommonUserWhereInput>;
};


export type QueryFindManyDegreeArgs = {
  cursor?: Maybe<DocumentDegreeWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentDegreeScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentDegreeOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentDegreeWhereInput>;
};


export type QueryFindManyDocumentAcademicDocumentationArgs = {
  cursor?: Maybe<DocumentAcademicDocumentationWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentAcademicDocumentationScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentAcademicDocumentationOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentAcademicDocumentationWhereInput>;
};


export type QueryFindManyDocumentAcademicDocumentationSearchViewArgs = {
  cursor?: Maybe<DocumentAcademicDocumentationSearchViewWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentAcademicDocumentationSearchViewScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentAcademicDocumentationSearchViewOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentAcademicDocumentationSearchViewWhereInput>;
};


export type QueryFindManyDocumentAuditFileIssuerArgs = {
  cursor?: Maybe<DocumentAuditFileIssuerWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentAuditFileIssuerScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentAuditFileIssuerOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentAuditFileIssuerWhereInput>;
};


export type QueryFindManyDocumentAuditFileIssuerDegreeItemArgs = {
  cursor?: Maybe<DocumentAuditFileIssuerDegreeItemWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentAuditFileIssuerDegreeItemScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentAuditFileIssuerDegreeItemOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentAuditFileIssuerDegreeItemWhereInput>;
};


export type QueryFindManyDocumentBaseArgs = {
  cursor?: Maybe<DocumentBaseWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseWhereInput>;
};


export type QueryFindManyDocumentBaseDefaultSignatureInviteConfigurationArgs = {
  cursor?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>;
};


export type QueryFindManyDocumentBaseDefaultSignatureInviteConfigurationGroupArgs = {
  cursor?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>;
};


export type QueryFindManyDocumentBaseDefaultSignatureInviteConfigurationGroupItemArgs = {
  cursor?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereInput>;
};


export type QueryFindManyDocumentBaseHistoryArgs = {
  cursor?: Maybe<DocumentBaseHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseHistoryScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseHistoryOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseHistoryWhereInput>;
};


export type QueryFindManyDocumentBaseSignatureInviteArgs = {
  cursor?: Maybe<DocumentBaseSignatureInviteWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseSignatureInviteScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseSignatureInviteOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseSignatureInviteWhereInput>;
};


export type QueryFindManyDocumentBaseSignatureInviteGroupArgs = {
  cursor?: Maybe<DocumentBaseSignatureInviteGroupWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseSignatureInviteGroupScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseSignatureInviteGroupOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseSignatureInviteGroupWhereInput>;
};


export type QueryFindManyDocumentBaseSignatureInviteSignatureArgs = {
  cursor?: Maybe<DocumentBaseSignatureInviteSignatureWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseSignatureInviteSignatureScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseSignatureInviteSignatureOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseSignatureInviteSignatureWhereInput>;
};


export type QueryFindManyDocumentCertificateArgs = {
  cursor?: Maybe<DocumentCertificateWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentCertificateScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentCertificateOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentCertificateWhereInput>;
};


export type QueryFindManyDocumentCertificateHashHistoryArgs = {
  cursor?: Maybe<DocumentCertificateHashHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentCertificateHashHistoryScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentCertificateHashHistoryOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentCertificateHashHistoryWhereInput>;
};


export type QueryFindManyDocumentCertificateMetadataArgs = {
  cursor?: Maybe<DocumentCertificateMetadataWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentCertificateMetadataScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentCertificateMetadataOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentCertificateMetadataWhereInput>;
};


export type QueryFindManyDocumentCertificateSignatureItemArgs = {
  cursor?: Maybe<DocumentCertificateSignatureItemWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentCertificateSignatureItemScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentCertificateSignatureItemOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentCertificateSignatureItemWhereInput>;
};


export type QueryFindManyDocumentCertificateSignatureItemPossibleSignerInviteArgs = {
  cursor?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>;
};


export type QueryFindManyDocumentCertificateSignatureItemPossibleSignerInviteSignatureArgs = {
  cursor?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereInput>;
};


export type QueryFindManyDocumentDegreeSearchViewArgs = {
  cursor?: Maybe<DocumentDegreeSearchViewWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentDegreeSearchViewScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentDegreeSearchViewOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentDegreeSearchViewWhereInput>;
};


export type QueryFindManyDocumentFinalAcademicTranscriptArgs = {
  cursor?: Maybe<DocumentFinalAcademicTranscriptWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentFinalAcademicTranscriptScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentFinalAcademicTranscriptOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentFinalAcademicTranscriptWhereInput>;
};


export type QueryFindManyDocumentFinalAcademicTranscriptViewArgs = {
  cursor?: Maybe<DocumentFinalAcademicTranscriptViewWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentFinalAcademicTranscriptViewScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentFinalAcademicTranscriptViewOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentFinalAcademicTranscriptViewWhereInput>;
};


export type QueryFindManyDocumentSchoolCurriculumArgs = {
  cursor?: Maybe<DocumentSchoolCurriculumWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentSchoolCurriculumScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentSchoolCurriculumOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentSchoolCurriculumWhereInput>;
};


export type QueryFindManyEnabledInstitutionArgs = {
  cursor?: Maybe<EnabledInstitutionWhereUniqueInput>;
  distinct?: Maybe<Array<EnabledInstitutionScalarFieldEnum>>;
  orderBy?: Maybe<Array<EnabledInstitutionOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EnabledInstitutionWhereInput>;
};


export type QueryFindManyFinancialChargeArgs = {
  cursor?: Maybe<FinancialChargeWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialChargeScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialChargeOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialChargeWhereInput>;
};


export type QueryFindManyFinancialCreditCardSavedArgs = {
  cursor?: Maybe<FinancialCreditCardSavedWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialCreditCardSavedScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialCreditCardSavedOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialCreditCardSavedWhereInput>;
};


export type QueryFindManyFinancialPaymentArgs = {
  cursor?: Maybe<FinancialPaymentWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialPaymentScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialPaymentOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialPaymentWhereInput>;
};


export type QueryFindManyFinancialRechargeArgs = {
  cursor?: Maybe<FinancialRechargeWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialRechargeScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialRechargeOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialRechargeWhereInput>;
};


export type QueryFindManyFinancialTeamSignupSelectedOptionsArgs = {
  cursor?: Maybe<FinancialTeamSignupSelectedOptionsWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialTeamSignupSelectedOptionsScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialTeamSignupSelectedOptionsOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialTeamSignupSelectedOptionsWhereInput>;
};


export type QueryFindManyFinancialTeamWalletArgs = {
  cursor?: Maybe<FinancialTeamWalletWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialTeamWalletScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialTeamWalletOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialTeamWalletWhereInput>;
};


export type QueryFindManyFinancialTeamWalletSubscriptionArgs = {
  cursor?: Maybe<FinancialTeamWalletSubscriptionWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialTeamWalletSubscriptionScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialTeamWalletSubscriptionOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialTeamWalletSubscriptionWhereInput>;
};


export type QueryFindManyFinancialTeamWalletSubscriptionPaymentArgs = {
  cursor?: Maybe<FinancialTeamWalletSubscriptionPaymentWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
};


export type QueryFindManyFinancialTeamWalletSubscriptionPaymentHistoryArgs = {
  cursor?: Maybe<FinancialTeamWalletSubscriptionPaymentHistoryWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialTeamWalletSubscriptionPaymentHistoryWhereInput>;
};


export type QueryFindManyMaintainerAdminArgs = {
  cursor?: Maybe<MaintainerAdminWhereUniqueInput>;
  distinct?: Maybe<Array<MaintainerAdminScalarFieldEnum>>;
  orderBy?: Maybe<Array<MaintainerAdminOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<MaintainerAdminWhereInput>;
};


export type QueryFindManyPermissionArgs = {
  cursor?: Maybe<PermissionWhereUniqueInput>;
  distinct?: Maybe<Array<PermissionScalarFieldEnum>>;
  orderBy?: Maybe<Array<PermissionOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PermissionWhereInput>;
};


export type QueryFindManyPersonArgs = {
  cursor?: Maybe<PersonWhereUniqueInput>;
  distinct?: Maybe<Array<PersonScalarFieldEnum>>;
  orderBy?: Maybe<Array<PersonOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PersonWhereInput>;
};


export type QueryFindManyReusableFormDataArgs = {
  cursor?: Maybe<ReusableFormDataWhereUniqueInput>;
  distinct?: Maybe<Array<ReusableFormDataScalarFieldEnum>>;
  orderBy?: Maybe<Array<ReusableFormDataOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ReusableFormDataWhereInputCustom>;
};


export type QueryFindManyReusableFormDataCurriculumArgs = {
  cursor?: Maybe<ReusableFormDataCurriculumWhereUniqueInput>;
  distinct?: Maybe<Array<ReusableFormDataCurriculumScalarFieldEnum>>;
  orderBy?: Maybe<Array<ReusableFormDataCurriculumOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ReusableFormDataCurriculumWhereInput>;
};


export type QueryFindManySignSignatureImageArgs = {
  cursor?: Maybe<SignSignatureImageWhereUniqueInput>;
  distinct?: Maybe<Array<SignSignatureImageScalarFieldEnum>>;
  orderBy?: Maybe<Array<SignSignatureImageOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SignSignatureImageWhereInput>;
};


export type QueryFindManySignableDocumentBaseSignatureInviteArgs = {
  cursor?: Maybe<DocumentBaseSignatureInviteWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseSignatureInviteScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseSignatureInviteOrderByWithRelationInput>>;
  personId: Scalars['String'];
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseSignatureInviteWhereInput>;
};


export type QueryFindManySystemAuditLogArgs = {
  cursor?: Maybe<SystemAuditLogWhereUniqueInput>;
  distinct?: Maybe<Array<SystemAuditLogScalarFieldEnum>>;
  orderBy?: Maybe<Array<SystemAuditLogOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SystemAuditLogWhereInput>;
};


export type QueryFindManySystemGlobalAlertArgs = {
  cursor?: Maybe<SystemGlobalAlertWhereUniqueInput>;
  distinct?: Maybe<Array<SystemGlobalAlertScalarFieldEnum>>;
  orderBy?: Maybe<Array<SystemGlobalAlertOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SystemGlobalAlertWhereInput>;
};


export type QueryFindManySystemGlobalAlertUserDismissArgs = {
  cursor?: Maybe<SystemGlobalAlertUserDismissWhereUniqueInput>;
  distinct?: Maybe<Array<SystemGlobalAlertUserDismissScalarFieldEnum>>;
  orderBy?: Maybe<Array<SystemGlobalAlertUserDismissOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SystemGlobalAlertUserDismissWhereInput>;
};


export type QueryFindManySystemLogArgs = {
  cursor?: Maybe<SystemLogWhereUniqueInput>;
  distinct?: Maybe<Array<SystemLogScalarFieldEnum>>;
  orderBy?: Maybe<Array<SystemLogOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SystemLogWhereInput>;
};


export type QueryFindManyTeamArgs = {
  cursor?: Maybe<TeamWhereUniqueInput>;
  distinct?: Maybe<Array<TeamScalarFieldEnum>>;
  orderBy?: Maybe<Array<TeamOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TeamWhereInput>;
};


export type QueryFindManyTeamEducationLevelArgs = {
  cursor?: Maybe<TeamEducationLevelWhereUniqueInput>;
  distinct?: Maybe<Array<TeamEducationLevelScalarFieldEnum>>;
  orderBy?: Maybe<Array<TeamEducationLevelOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TeamEducationLevelWhereInput>;
};


export type QueryFindManyTeamMaintainedArgs = {
  cursor?: Maybe<TeamWhereUniqueInput>;
  distinct?: Maybe<Array<TeamScalarFieldEnum>>;
  orderBy?: Maybe<Array<TeamOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TeamWhereInput>;
};


export type QueryFindManyTeamMemberArgs = {
  cursor?: Maybe<TeamMemberWhereUniqueInput>;
  distinct?: Maybe<Array<TeamMemberScalarFieldEnum>>;
  orderBy?: Maybe<Array<TeamMemberOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TeamMemberWhereInput>;
};


export type QueryFindManyTeamMemberPermissionArgs = {
  cursor?: Maybe<TeamMemberPermissionWhereUniqueInput>;
  distinct?: Maybe<Array<TeamMemberPermissionScalarFieldEnum>>;
  orderBy?: Maybe<Array<TeamMemberPermissionOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TeamMemberPermissionWhereInput>;
};


export type QueryFindManyTelephoneArgs = {
  cursor?: Maybe<TelephoneWhereUniqueInput>;
  distinct?: Maybe<Array<TelephoneScalarFieldEnum>>;
  orderBy?: Maybe<Array<TelephoneOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TelephoneWhereInput>;
};


export type QueryFindOneExternalCepAddressArgs = {
  cep: Scalars['String'];
};


export type QueryFindUniqueAddressArgs = {
  where: AddressWhereUniqueInput;
};


export type QueryFindUniqueBulkCertificateRecordArgs = {
  where: BulkCertificateRecordWhereUniqueInput;
};


export type QueryFindUniqueCertificateBaseArgs = {
  where: CertificateBaseWhereUniqueInput;
};


export type QueryFindUniqueCertificateCourseArgs = {
  where: CertificateCourseWhereUniqueInput;
};


export type QueryFindUniqueCertificateCourseLevelArgs = {
  where: CertificateCourseLevelWhereUniqueInput;
};


export type QueryFindUniqueCertificateCurriculumArgs = {
  where: CertificateCurriculumWhereUniqueInput;
};


export type QueryFindUniqueCertificateCurriculumSelectedDisciplineArgs = {
  where: CertificateCurriculumSelectedDisciplineWhereUniqueInput;
};


export type QueryFindUniqueCertificateDisciplineArgs = {
  where: CertificateDisciplineWhereUniqueInput;
};


export type QueryFindUniqueCertificateEventArgs = {
  where: CertificateEventWhereUniqueInput;
};


export type QueryFindUniqueCertificateTeacherArgs = {
  where: CertificateTeacherWhereUniqueInput;
};


export type QueryFindUniqueCertificateTemplateArgs = {
  where: CertificateTemplateWhereUniqueInput;
};


export type QueryFindUniqueDegreeToSeeBySecurityCodeArgs = {
  domain: Scalars['String'];
  recaptchaResponse: Scalars['String'];
  securityCode: Scalars['String'];
};


export type QueryFindUniqueDocumentAcademicDocumentationArgs = {
  where: DocumentAcademicDocumentationWhereUniqueInput;
};


export type QueryFindUniqueDocumentAcademicDocumentationSearchViewArgs = {
  where: DocumentAcademicDocumentationSearchViewWhereUniqueInput;
};


export type QueryFindUniqueDocumentAuditFileIssuerArgs = {
  where: DocumentAuditFileIssuerWhereUniqueInput;
};


export type QueryFindUniqueDocumentAuditFileIssuerDegreeItemArgs = {
  where: DocumentAuditFileIssuerDegreeItemWhereUniqueInput;
};


export type QueryFindUniqueDocumentBaseArgs = {
  where: DocumentBaseWhereUniqueInput;
};


export type QueryFindUniqueDocumentBaseDefaultSignatureInviteConfigurationArgs = {
  where: DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput;
};


export type QueryFindUniqueDocumentBaseDefaultSignatureInviteConfigurationGroupArgs = {
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupWhereUniqueInput;
};


export type QueryFindUniqueDocumentBaseDefaultSignatureInviteConfigurationGroupItemArgs = {
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput;
};


export type QueryFindUniqueDocumentBaseHistoryArgs = {
  where: DocumentBaseHistoryWhereUniqueInput;
};


export type QueryFindUniqueDocumentBaseSignatureInviteArgs = {
  where: DocumentBaseSignatureInviteWhereUniqueInput;
};


export type QueryFindUniqueDocumentBaseSignatureInviteGroupArgs = {
  where: DocumentBaseSignatureInviteGroupWhereUniqueInput;
};


export type QueryFindUniqueDocumentBaseSignatureInviteSignatureArgs = {
  where: DocumentBaseSignatureInviteSignatureWhereUniqueInput;
};


export type QueryFindUniqueDocumentCertificateArgs = {
  where: DocumentCertificateWhereUniqueInput;
};


export type QueryFindUniqueDocumentCertificateHashHistoryArgs = {
  where: DocumentCertificateHashHistoryWhereUniqueInput;
};


export type QueryFindUniqueDocumentCertificateMetadataArgs = {
  where: DocumentCertificateMetadataWhereUniqueInput;
};


export type QueryFindUniqueDocumentCertificateSignatureItemArgs = {
  where: DocumentCertificateSignatureItemWhereUniqueInput;
};


export type QueryFindUniqueDocumentCertificateSignatureItemPossibleSignerInviteArgs = {
  where: DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput;
};


export type QueryFindUniqueDocumentCertificateSignatureItemPossibleSignerInviteSignatureArgs = {
  where: DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereUniqueInput;
};


export type QueryFindUniqueDocumentDegreeArgs = {
  where: DocumentDegreeWhereUniqueInput;
};


export type QueryFindUniqueDocumentDegreeSearchViewArgs = {
  where: DocumentDegreeSearchViewWhereUniqueInput;
};


export type QueryFindUniqueDocumentFinalAcademicTranscriptArgs = {
  where: DocumentFinalAcademicTranscriptWhereUniqueInput;
};


export type QueryFindUniqueDocumentFinalAcademicTranscriptViewArgs = {
  where: DocumentFinalAcademicTranscriptViewWhereUniqueInput;
};


export type QueryFindUniqueDocumentSchoolCurriculumArgs = {
  where: DocumentSchoolCurriculumWhereUniqueInput;
};


export type QueryFindUniqueExternalSignatureInviteArgs = {
  where: ExternalSignatureInviteWhereUniqueInput;
};


export type QueryFindUniqueFinancialTeamSignupSelectedOptionsArgs = {
  where: FinancialTeamSignupSelectedOptionsWhereUniqueInput;
};


export type QueryFindUniqueFinancialTeamWalletArgs = {
  where: FinancialTeamWalletWhereUniqueInput;
};


export type QueryFindUniqueFinancialTeamWalletSubscriptionArgs = {
  where: FinancialTeamWalletSubscriptionWhereUniqueInput;
};


export type QueryFindUniqueFinancialTeamWalletSubscriptionPaymentArgs = {
  where: FinancialTeamWalletSubscriptionPaymentWhereUniqueInput;
};


export type QueryFindUniqueFinancialTeamWalletSubscriptionPaymentHistoryArgs = {
  where: FinancialTeamWalletSubscriptionPaymentHistoryWhereUniqueInput;
};


export type QueryFindUniquePermissionArgs = {
  where: PermissionWhereUniqueInput;
};


export type QueryFindUniquePersonArgs = {
  where: PersonWhereUniqueInput;
};


export type QueryFindUniqueReusableFormDataCurriculumArgs = {
  where: ReusableFormDataCurriculumWhereUniqueInput;
};


export type QueryFindUniqueSignSignatureImageArgs = {
  where: SignSignatureImageWhereUniqueInput;
};


export type QueryFindUniqueSystemGlobalAlertUserDismissArgs = {
  where: SystemGlobalAlertUserDismissWhereUniqueInput;
};


export type QueryFindUniqueSystemLogArgs = {
  where: SystemLogWhereUniqueInput;
};


export type QueryFindUniqueTeamArgs = {
  where: TeamWhereUniqueInput;
};


export type QueryFindUniqueTeamEducationLevelArgs = {
  where: TeamEducationLevelWhereUniqueInput;
};


export type QueryFindUniqueTeamMemberPermissionArgs = {
  where: TeamMemberPermissionWhereUniqueInput;
};


export type QueryFindUniqueTelephoneArgs = {
  where: TelephoneWhereUniqueInput;
};


export type QueryFindUniqueToSeePublicDocumentArgs = {
  recaptchaResponse: Scalars['String'];
};


export type QueryGenerateSampleCertificatePdfBase64Args = {
  template: Scalars['Json'];
};


export type QueryGetMineTeamArgs = {
  cursor?: Maybe<TeamWhereUniqueInput>;
  distinct?: Maybe<Array<TeamScalarFieldEnum>>;
  orderBy?: Maybe<Array<TeamOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TeamWhereInput>;
};


export type QueryGetMineTeamCountArgs = {
  cursor?: Maybe<TeamWhereUniqueInput>;
  distinct?: Maybe<Array<TeamScalarFieldEnum>>;
  orderBy?: Maybe<Array<TeamOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TeamWhereInput>;
};


export type QuerySummaryFinancialChargeArgs = {
  cursor?: Maybe<FinancialChargeWhereUniqueInput>;
  distinct?: Maybe<Array<FinancialChargeScalarFieldEnum>>;
  orderBy?: Maybe<Array<FinancialChargeOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FinancialChargeWhereInput>;
};


export type QueryValidateOneDocumentCertificateArgs = {
  docId?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['Upload']>;
  recaptchaResponse: Scalars['String'];
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type RechargeOptions = {
  __typename?: 'RechargeOptions';
  discounts: Array<Discount>;
  presets: Array<Preset>;
  servicesPrices: Array<ServicePrice>;
};

/** Store Issuer/Course data to late user */
export type ReusableFormData = {
  __typename?: 'ReusableFormData';
  DisciplineLinks: Array<ReusableFormDataCurriculumDisciplineLink>;
  ReusableFormDataCurriculum: Array<ReusableFormDataCurriculum>;
  Team: Team;
  UserOwner: CommonUser;
  commonUserId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  /** ![PrismaJson.AnyJson] */
  data: Scalars['Json'];
  id: Scalars['Int'];
  teamId: Scalars['Int'];
  /** issuer, course, discipline, teacher */
  type: Scalars['String'];
};


/** Store Issuer/Course data to late user */
export type ReusableFormDataDisciplineLinksArgs = {
  cursor?: Maybe<ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput>;
  distinct?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkScalarFieldEnum>>;
  orderBy?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ReusableFormDataCurriculumDisciplineLinkWhereInput>;
};


/** Store Issuer/Course data to late user */
export type ReusableFormDataReusableFormDataCurriculumArgs = {
  cursor?: Maybe<ReusableFormDataCurriculumWhereUniqueInput>;
  distinct?: Maybe<Array<ReusableFormDataCurriculumScalarFieldEnum>>;
  orderBy?: Maybe<Array<ReusableFormDataCurriculumOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ReusableFormDataCurriculumWhereInput>;
};

export type ReusableFormDataAvgOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type ReusableFormDataCountOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  data?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
};

export type ReusableFormDataCreateInput = {
  DisciplineLinks?: Maybe<ReusableFormDataCurriculumDisciplineLinkCreateNestedManyWithoutDisciplineInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutCourseInput>;
  Team: TeamCreateNestedOneWithoutReusableFormDataInput;
  UserOwner: CommonUserCreateNestedOneWithoutReusableFormDatasInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  data: Scalars['Json'];
  type: Scalars['String'];
};

export type ReusableFormDataCreateManyInput = {
  commonUserId: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  data: Scalars['Json'];
  id?: Maybe<Scalars['Int']>;
  teamId: Scalars['Int'];
  type: Scalars['String'];
};

export type ReusableFormDataCreateManyTeamInput = {
  commonUserId: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  data: Scalars['Json'];
  id?: Maybe<Scalars['Int']>;
  type: Scalars['String'];
};

export type ReusableFormDataCreateManyTeamInputEnvelope = {
  data: Array<ReusableFormDataCreateManyTeamInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ReusableFormDataCreateManyUserOwnerInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  data: Scalars['Json'];
  id?: Maybe<Scalars['Int']>;
  teamId: Scalars['Int'];
  type: Scalars['String'];
};

export type ReusableFormDataCreateManyUserOwnerInputEnvelope = {
  data: Array<ReusableFormDataCreateManyUserOwnerInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ReusableFormDataCreateNestedManyWithoutTeamInput = {
  connect?: Maybe<Array<ReusableFormDataWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ReusableFormDataCreateOrConnectWithoutTeamInput>>;
  create?: Maybe<Array<ReusableFormDataCreateWithoutTeamInput>>;
  createMany?: Maybe<ReusableFormDataCreateManyTeamInputEnvelope>;
};

export type ReusableFormDataCreateNestedManyWithoutUserOwnerInput = {
  connect?: Maybe<Array<ReusableFormDataWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ReusableFormDataCreateOrConnectWithoutUserOwnerInput>>;
  create?: Maybe<Array<ReusableFormDataCreateWithoutUserOwnerInput>>;
  createMany?: Maybe<ReusableFormDataCreateManyUserOwnerInputEnvelope>;
};

export type ReusableFormDataCreateNestedOneWithoutDisciplineLinksInput = {
  connect?: Maybe<ReusableFormDataWhereUniqueInput>;
  connectOrCreate?: Maybe<ReusableFormDataCreateOrConnectWithoutDisciplineLinksInput>;
  create?: Maybe<ReusableFormDataCreateWithoutDisciplineLinksInput>;
};

export type ReusableFormDataCreateNestedOneWithoutReusableFormDataCurriculumInput = {
  connect?: Maybe<ReusableFormDataWhereUniqueInput>;
  connectOrCreate?: Maybe<ReusableFormDataCreateOrConnectWithoutReusableFormDataCurriculumInput>;
  create?: Maybe<ReusableFormDataCreateWithoutReusableFormDataCurriculumInput>;
};

export type ReusableFormDataCreateOrConnectWithoutDisciplineLinksInput = {
  create: ReusableFormDataCreateWithoutDisciplineLinksInput;
  where: ReusableFormDataWhereUniqueInput;
};

export type ReusableFormDataCreateOrConnectWithoutReusableFormDataCurriculumInput = {
  create: ReusableFormDataCreateWithoutReusableFormDataCurriculumInput;
  where: ReusableFormDataWhereUniqueInput;
};

export type ReusableFormDataCreateOrConnectWithoutTeamInput = {
  create: ReusableFormDataCreateWithoutTeamInput;
  where: ReusableFormDataWhereUniqueInput;
};

export type ReusableFormDataCreateOrConnectWithoutUserOwnerInput = {
  create: ReusableFormDataCreateWithoutUserOwnerInput;
  where: ReusableFormDataWhereUniqueInput;
};

export type ReusableFormDataCreateWithoutDisciplineLinksInput = {
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutCourseInput>;
  Team: TeamCreateNestedOneWithoutReusableFormDataInput;
  UserOwner: CommonUserCreateNestedOneWithoutReusableFormDatasInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  data: Scalars['Json'];
  type: Scalars['String'];
};

export type ReusableFormDataCreateWithoutReusableFormDataCurriculumInput = {
  DisciplineLinks?: Maybe<ReusableFormDataCurriculumDisciplineLinkCreateNestedManyWithoutDisciplineInput>;
  Team: TeamCreateNestedOneWithoutReusableFormDataInput;
  UserOwner: CommonUserCreateNestedOneWithoutReusableFormDatasInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  data: Scalars['Json'];
  type: Scalars['String'];
};

export type ReusableFormDataCreateWithoutTeamInput = {
  DisciplineLinks?: Maybe<ReusableFormDataCurriculumDisciplineLinkCreateNestedManyWithoutDisciplineInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutCourseInput>;
  UserOwner: CommonUserCreateNestedOneWithoutReusableFormDatasInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  data: Scalars['Json'];
  type: Scalars['String'];
};

export type ReusableFormDataCreateWithoutUserOwnerInput = {
  DisciplineLinks?: Maybe<ReusableFormDataCurriculumDisciplineLinkCreateNestedManyWithoutDisciplineInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutCourseInput>;
  Team: TeamCreateNestedOneWithoutReusableFormDataInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  data: Scalars['Json'];
  type: Scalars['String'];
};

/**
 * Store a Array<ReusableFormData<discipline>> to import
 * Created a new model to store references to ReusableFormData, instead of a raw JSON
 */
export type ReusableFormDataCurriculum = {
  __typename?: 'ReusableFormDataCurriculum';
  Course: ReusableFormData;
  DisciplineLinks: Array<ReusableFormDataCurriculumDisciplineLink>;
  Team: Team;
  UserOwner: CommonUser;
  commonUserId: Scalars['Int'];
  courseId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  name: Scalars['String'];
  teamId: Scalars['Int'];
};


/**
 * Store a Array<ReusableFormData<discipline>> to import
 * Created a new model to store references to ReusableFormData, instead of a raw JSON
 */
export type ReusableFormDataCurriculumDisciplineLinksArgs = {
  cursor?: Maybe<ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput>;
  distinct?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkScalarFieldEnum>>;
  orderBy?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ReusableFormDataCurriculumDisciplineLinkWhereInput>;
};

export type ReusableFormDataCurriculumAvgOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  courseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type ReusableFormDataCurriculumCountOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  courseId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type ReusableFormDataCurriculumCreateInput = {
  Course: ReusableFormDataCreateNestedOneWithoutReusableFormDataCurriculumInput;
  DisciplineLinks?: Maybe<ReusableFormDataCurriculumDisciplineLinkCreateNestedManyWithoutCurriculumInput>;
  Team: TeamCreateNestedOneWithoutReusableFormDataCurriculumInput;
  UserOwner: CommonUserCreateNestedOneWithoutReusableFormDataCurriculumListInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
};

export type ReusableFormDataCurriculumCreateInputCustom = {
  courseId: Scalars['Int'];
  disciplines: Array<Scalars['Int']>;
  name: Scalars['String'];
};

export type ReusableFormDataCurriculumCreateManyCourseInput = {
  commonUserId: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  teamId: Scalars['Int'];
};

export type ReusableFormDataCurriculumCreateManyCourseInputEnvelope = {
  data: Array<ReusableFormDataCurriculumCreateManyCourseInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ReusableFormDataCurriculumCreateManyInput = {
  commonUserId: Scalars['Int'];
  courseId: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  teamId: Scalars['Int'];
};

export type ReusableFormDataCurriculumCreateManyTeamInput = {
  commonUserId: Scalars['Int'];
  courseId: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type ReusableFormDataCurriculumCreateManyTeamInputEnvelope = {
  data: Array<ReusableFormDataCurriculumCreateManyTeamInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ReusableFormDataCurriculumCreateManyUserOwnerInput = {
  courseId: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  teamId: Scalars['Int'];
};

export type ReusableFormDataCurriculumCreateManyUserOwnerInputEnvelope = {
  data: Array<ReusableFormDataCurriculumCreateManyUserOwnerInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ReusableFormDataCurriculumCreateNestedManyWithoutCourseInput = {
  connect?: Maybe<Array<ReusableFormDataCurriculumWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ReusableFormDataCurriculumCreateOrConnectWithoutCourseInput>>;
  create?: Maybe<Array<ReusableFormDataCurriculumCreateWithoutCourseInput>>;
  createMany?: Maybe<ReusableFormDataCurriculumCreateManyCourseInputEnvelope>;
};

export type ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput = {
  connect?: Maybe<Array<ReusableFormDataCurriculumWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ReusableFormDataCurriculumCreateOrConnectWithoutTeamInput>>;
  create?: Maybe<Array<ReusableFormDataCurriculumCreateWithoutTeamInput>>;
  createMany?: Maybe<ReusableFormDataCurriculumCreateManyTeamInputEnvelope>;
};

export type ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput = {
  connect?: Maybe<Array<ReusableFormDataCurriculumWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ReusableFormDataCurriculumCreateOrConnectWithoutUserOwnerInput>>;
  create?: Maybe<Array<ReusableFormDataCurriculumCreateWithoutUserOwnerInput>>;
  createMany?: Maybe<ReusableFormDataCurriculumCreateManyUserOwnerInputEnvelope>;
};

export type ReusableFormDataCurriculumCreateNestedOneWithoutDisciplineLinksInput = {
  connect?: Maybe<ReusableFormDataCurriculumWhereUniqueInput>;
  connectOrCreate?: Maybe<ReusableFormDataCurriculumCreateOrConnectWithoutDisciplineLinksInput>;
  create?: Maybe<ReusableFormDataCurriculumCreateWithoutDisciplineLinksInput>;
};

export type ReusableFormDataCurriculumCreateOrConnectWithoutCourseInput = {
  create: ReusableFormDataCurriculumCreateWithoutCourseInput;
  where: ReusableFormDataCurriculumWhereUniqueInput;
};

export type ReusableFormDataCurriculumCreateOrConnectWithoutDisciplineLinksInput = {
  create: ReusableFormDataCurriculumCreateWithoutDisciplineLinksInput;
  where: ReusableFormDataCurriculumWhereUniqueInput;
};

export type ReusableFormDataCurriculumCreateOrConnectWithoutTeamInput = {
  create: ReusableFormDataCurriculumCreateWithoutTeamInput;
  where: ReusableFormDataCurriculumWhereUniqueInput;
};

export type ReusableFormDataCurriculumCreateOrConnectWithoutUserOwnerInput = {
  create: ReusableFormDataCurriculumCreateWithoutUserOwnerInput;
  where: ReusableFormDataCurriculumWhereUniqueInput;
};

export type ReusableFormDataCurriculumCreateWithoutCourseInput = {
  DisciplineLinks?: Maybe<ReusableFormDataCurriculumDisciplineLinkCreateNestedManyWithoutCurriculumInput>;
  Team: TeamCreateNestedOneWithoutReusableFormDataCurriculumInput;
  UserOwner: CommonUserCreateNestedOneWithoutReusableFormDataCurriculumListInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
};

export type ReusableFormDataCurriculumCreateWithoutDisciplineLinksInput = {
  Course: ReusableFormDataCreateNestedOneWithoutReusableFormDataCurriculumInput;
  Team: TeamCreateNestedOneWithoutReusableFormDataCurriculumInput;
  UserOwner: CommonUserCreateNestedOneWithoutReusableFormDataCurriculumListInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
};

export type ReusableFormDataCurriculumCreateWithoutTeamInput = {
  Course: ReusableFormDataCreateNestedOneWithoutReusableFormDataCurriculumInput;
  DisciplineLinks?: Maybe<ReusableFormDataCurriculumDisciplineLinkCreateNestedManyWithoutCurriculumInput>;
  UserOwner: CommonUserCreateNestedOneWithoutReusableFormDataCurriculumListInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
};

export type ReusableFormDataCurriculumCreateWithoutUserOwnerInput = {
  Course: ReusableFormDataCreateNestedOneWithoutReusableFormDataCurriculumInput;
  DisciplineLinks?: Maybe<ReusableFormDataCurriculumDisciplineLinkCreateNestedManyWithoutCurriculumInput>;
  Team: TeamCreateNestedOneWithoutReusableFormDataCurriculumInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
};

export type ReusableFormDataCurriculumDisciplineLink = {
  __typename?: 'ReusableFormDataCurriculumDisciplineLink';
  Curriculum: ReusableFormDataCurriculum;
  Discipline: ReusableFormData;
  id: Scalars['Int'];
  reusableFormDataCurriculumId: Scalars['Int'];
  reusableFormDataDisciplineId: Scalars['Int'];
};

export type ReusableFormDataCurriculumDisciplineLinkAvgOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  reusableFormDataCurriculumId?: Maybe<SortOrder>;
  reusableFormDataDisciplineId?: Maybe<SortOrder>;
};

export type ReusableFormDataCurriculumDisciplineLinkCountOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  reusableFormDataCurriculumId?: Maybe<SortOrder>;
  reusableFormDataDisciplineId?: Maybe<SortOrder>;
};

export type ReusableFormDataCurriculumDisciplineLinkCreateInput = {
  Curriculum: ReusableFormDataCurriculumCreateNestedOneWithoutDisciplineLinksInput;
  Discipline: ReusableFormDataCreateNestedOneWithoutDisciplineLinksInput;
};

export type ReusableFormDataCurriculumDisciplineLinkCreateManyCurriculumInput = {
  id?: Maybe<Scalars['Int']>;
  reusableFormDataDisciplineId: Scalars['Int'];
};

export type ReusableFormDataCurriculumDisciplineLinkCreateManyCurriculumInputEnvelope = {
  data: Array<ReusableFormDataCurriculumDisciplineLinkCreateManyCurriculumInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ReusableFormDataCurriculumDisciplineLinkCreateManyDisciplineInput = {
  id?: Maybe<Scalars['Int']>;
  reusableFormDataCurriculumId: Scalars['Int'];
};

export type ReusableFormDataCurriculumDisciplineLinkCreateManyDisciplineInputEnvelope = {
  data: Array<ReusableFormDataCurriculumDisciplineLinkCreateManyDisciplineInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type ReusableFormDataCurriculumDisciplineLinkCreateManyInput = {
  id?: Maybe<Scalars['Int']>;
  reusableFormDataCurriculumId: Scalars['Int'];
  reusableFormDataDisciplineId: Scalars['Int'];
};

export type ReusableFormDataCurriculumDisciplineLinkCreateNestedManyWithoutCurriculumInput = {
  connect?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkCreateOrConnectWithoutCurriculumInput>>;
  create?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkCreateWithoutCurriculumInput>>;
  createMany?: Maybe<ReusableFormDataCurriculumDisciplineLinkCreateManyCurriculumInputEnvelope>;
};

export type ReusableFormDataCurriculumDisciplineLinkCreateNestedManyWithoutDisciplineInput = {
  connect?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkCreateOrConnectWithoutDisciplineInput>>;
  create?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkCreateWithoutDisciplineInput>>;
  createMany?: Maybe<ReusableFormDataCurriculumDisciplineLinkCreateManyDisciplineInputEnvelope>;
};

export type ReusableFormDataCurriculumDisciplineLinkCreateOrConnectWithoutCurriculumInput = {
  create: ReusableFormDataCurriculumDisciplineLinkCreateWithoutCurriculumInput;
  where: ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput;
};

export type ReusableFormDataCurriculumDisciplineLinkCreateOrConnectWithoutDisciplineInput = {
  create: ReusableFormDataCurriculumDisciplineLinkCreateWithoutDisciplineInput;
  where: ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput;
};

export type ReusableFormDataCurriculumDisciplineLinkCreateWithoutCurriculumInput = {
  Discipline: ReusableFormDataCreateNestedOneWithoutDisciplineLinksInput;
};

export type ReusableFormDataCurriculumDisciplineLinkCreateWithoutDisciplineInput = {
  Curriculum: ReusableFormDataCurriculumCreateNestedOneWithoutDisciplineLinksInput;
};

export type ReusableFormDataCurriculumDisciplineLinkListRelationFilter = {
  every?: Maybe<ReusableFormDataCurriculumDisciplineLinkWhereInput>;
  none?: Maybe<ReusableFormDataCurriculumDisciplineLinkWhereInput>;
  some?: Maybe<ReusableFormDataCurriculumDisciplineLinkWhereInput>;
};

export type ReusableFormDataCurriculumDisciplineLinkMaxOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  reusableFormDataCurriculumId?: Maybe<SortOrder>;
  reusableFormDataDisciplineId?: Maybe<SortOrder>;
};

export type ReusableFormDataCurriculumDisciplineLinkMinOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  reusableFormDataCurriculumId?: Maybe<SortOrder>;
  reusableFormDataDisciplineId?: Maybe<SortOrder>;
};

export type ReusableFormDataCurriculumDisciplineLinkOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ReusableFormDataCurriculumDisciplineLinkOrderByWithAggregationInput = {
  _avg?: Maybe<ReusableFormDataCurriculumDisciplineLinkAvgOrderByAggregateInput>;
  _count?: Maybe<ReusableFormDataCurriculumDisciplineLinkCountOrderByAggregateInput>;
  _max?: Maybe<ReusableFormDataCurriculumDisciplineLinkMaxOrderByAggregateInput>;
  _min?: Maybe<ReusableFormDataCurriculumDisciplineLinkMinOrderByAggregateInput>;
  _sum?: Maybe<ReusableFormDataCurriculumDisciplineLinkSumOrderByAggregateInput>;
  id?: Maybe<SortOrder>;
  reusableFormDataCurriculumId?: Maybe<SortOrder>;
  reusableFormDataDisciplineId?: Maybe<SortOrder>;
};

export type ReusableFormDataCurriculumDisciplineLinkOrderByWithRelationInput = {
  Curriculum?: Maybe<ReusableFormDataCurriculumOrderByWithRelationInput>;
  Discipline?: Maybe<ReusableFormDataOrderByWithRelationInput>;
  id?: Maybe<SortOrder>;
  reusableFormDataCurriculumId?: Maybe<SortOrder>;
  reusableFormDataDisciplineId?: Maybe<SortOrder>;
};

export enum ReusableFormDataCurriculumDisciplineLinkScalarFieldEnum {
  Id = 'id',
  ReusableFormDataCurriculumId = 'reusableFormDataCurriculumId',
  ReusableFormDataDisciplineId = 'reusableFormDataDisciplineId'
}

export type ReusableFormDataCurriculumDisciplineLinkScalarWhereInput = {
  AND?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkScalarWhereInput>>;
  NOT?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkScalarWhereInput>>;
  OR?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkScalarWhereInput>>;
  id?: Maybe<IntFilter>;
  reusableFormDataCurriculumId?: Maybe<IntFilter>;
  reusableFormDataDisciplineId?: Maybe<IntFilter>;
};

export type ReusableFormDataCurriculumDisciplineLinkScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkScalarWhereWithAggregatesInput>>;
  id?: Maybe<IntWithAggregatesFilter>;
  reusableFormDataCurriculumId?: Maybe<IntWithAggregatesFilter>;
  reusableFormDataDisciplineId?: Maybe<IntWithAggregatesFilter>;
};

export type ReusableFormDataCurriculumDisciplineLinkSumOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  reusableFormDataCurriculumId?: Maybe<SortOrder>;
  reusableFormDataDisciplineId?: Maybe<SortOrder>;
};

export type ReusableFormDataCurriculumDisciplineLinkUpdateInput = {
  Curriculum?: Maybe<ReusableFormDataCurriculumUpdateOneRequiredWithoutDisciplineLinksNestedInput>;
  Discipline?: Maybe<ReusableFormDataUpdateOneRequiredWithoutDisciplineLinksNestedInput>;
};

export type ReusableFormDataCurriculumDisciplineLinkUpdateManyMutationInput = {
  _?: Maybe<Scalars['NEVER']>;
};

export type ReusableFormDataCurriculumDisciplineLinkUpdateManyWithWhereWithoutCurriculumInput = {
  data: ReusableFormDataCurriculumDisciplineLinkUpdateManyMutationInput;
  where: ReusableFormDataCurriculumDisciplineLinkScalarWhereInput;
};

export type ReusableFormDataCurriculumDisciplineLinkUpdateManyWithWhereWithoutDisciplineInput = {
  data: ReusableFormDataCurriculumDisciplineLinkUpdateManyMutationInput;
  where: ReusableFormDataCurriculumDisciplineLinkScalarWhereInput;
};

export type ReusableFormDataCurriculumDisciplineLinkUpdateManyWithoutCurriculumNestedInput = {
  connect?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkCreateOrConnectWithoutCurriculumInput>>;
  create?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkCreateWithoutCurriculumInput>>;
  createMany?: Maybe<ReusableFormDataCurriculumDisciplineLinkCreateManyCurriculumInputEnvelope>;
  delete?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkScalarWhereInput>>;
  disconnect?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput>>;
  set?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput>>;
  update?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkUpdateWithWhereUniqueWithoutCurriculumInput>>;
  updateMany?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkUpdateManyWithWhereWithoutCurriculumInput>>;
  upsert?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkUpsertWithWhereUniqueWithoutCurriculumInput>>;
};

export type ReusableFormDataCurriculumDisciplineLinkUpdateManyWithoutDisciplineNestedInput = {
  connect?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkCreateOrConnectWithoutDisciplineInput>>;
  create?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkCreateWithoutDisciplineInput>>;
  createMany?: Maybe<ReusableFormDataCurriculumDisciplineLinkCreateManyDisciplineInputEnvelope>;
  delete?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkScalarWhereInput>>;
  disconnect?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput>>;
  set?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput>>;
  update?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkUpdateWithWhereUniqueWithoutDisciplineInput>>;
  updateMany?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkUpdateManyWithWhereWithoutDisciplineInput>>;
  upsert?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkUpsertWithWhereUniqueWithoutDisciplineInput>>;
};

export type ReusableFormDataCurriculumDisciplineLinkUpdateWithWhereUniqueWithoutCurriculumInput = {
  data: ReusableFormDataCurriculumDisciplineLinkUpdateWithoutCurriculumInput;
  where: ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput;
};

export type ReusableFormDataCurriculumDisciplineLinkUpdateWithWhereUniqueWithoutDisciplineInput = {
  data: ReusableFormDataCurriculumDisciplineLinkUpdateWithoutDisciplineInput;
  where: ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput;
};

export type ReusableFormDataCurriculumDisciplineLinkUpdateWithoutCurriculumInput = {
  Discipline?: Maybe<ReusableFormDataUpdateOneRequiredWithoutDisciplineLinksNestedInput>;
};

export type ReusableFormDataCurriculumDisciplineLinkUpdateWithoutDisciplineInput = {
  Curriculum?: Maybe<ReusableFormDataCurriculumUpdateOneRequiredWithoutDisciplineLinksNestedInput>;
};

export type ReusableFormDataCurriculumDisciplineLinkUpsertWithWhereUniqueWithoutCurriculumInput = {
  create: ReusableFormDataCurriculumDisciplineLinkCreateWithoutCurriculumInput;
  update: ReusableFormDataCurriculumDisciplineLinkUpdateWithoutCurriculumInput;
  where: ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput;
};

export type ReusableFormDataCurriculumDisciplineLinkUpsertWithWhereUniqueWithoutDisciplineInput = {
  create: ReusableFormDataCurriculumDisciplineLinkCreateWithoutDisciplineInput;
  update: ReusableFormDataCurriculumDisciplineLinkUpdateWithoutDisciplineInput;
  where: ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput;
};

export type ReusableFormDataCurriculumDisciplineLinkWhereInput = {
  AND?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkWhereInput>>;
  Curriculum?: Maybe<ReusableFormDataCurriculumWhereInput>;
  Discipline?: Maybe<ReusableFormDataWhereInput>;
  NOT?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkWhereInput>>;
  OR?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkWhereInput>>;
  id?: Maybe<IntFilter>;
  reusableFormDataCurriculumId?: Maybe<IntFilter>;
  reusableFormDataDisciplineId?: Maybe<IntFilter>;
};

export type ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput = {
  AND?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkWhereInput>>;
  Curriculum?: Maybe<ReusableFormDataCurriculumWhereInput>;
  Discipline?: Maybe<ReusableFormDataWhereInput>;
  NOT?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkWhereInput>>;
  OR?: Maybe<Array<ReusableFormDataCurriculumDisciplineLinkWhereInput>>;
  id?: Maybe<Scalars['Int']>;
  reusableFormDataCurriculumId?: Maybe<IntFilter>;
  reusableFormDataDisciplineId?: Maybe<IntFilter>;
};

export type ReusableFormDataCurriculumListRelationFilter = {
  every?: Maybe<ReusableFormDataCurriculumWhereInput>;
  none?: Maybe<ReusableFormDataCurriculumWhereInput>;
  some?: Maybe<ReusableFormDataCurriculumWhereInput>;
};

export type ReusableFormDataCurriculumMaxOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  courseId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type ReusableFormDataCurriculumMinOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  courseId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type ReusableFormDataCurriculumOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ReusableFormDataCurriculumOrderByWithAggregationInput = {
  _avg?: Maybe<ReusableFormDataCurriculumAvgOrderByAggregateInput>;
  _count?: Maybe<ReusableFormDataCurriculumCountOrderByAggregateInput>;
  _max?: Maybe<ReusableFormDataCurriculumMaxOrderByAggregateInput>;
  _min?: Maybe<ReusableFormDataCurriculumMinOrderByAggregateInput>;
  _sum?: Maybe<ReusableFormDataCurriculumSumOrderByAggregateInput>;
  commonUserId?: Maybe<SortOrder>;
  courseId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type ReusableFormDataCurriculumOrderByWithRelationInput = {
  Course?: Maybe<ReusableFormDataOrderByWithRelationInput>;
  DisciplineLinks?: Maybe<ReusableFormDataCurriculumDisciplineLinkOrderByRelationAggregateInput>;
  Team?: Maybe<TeamOrderByWithRelationInput>;
  UserOwner?: Maybe<CommonUserOrderByWithRelationInput>;
  commonUserId?: Maybe<SortOrder>;
  courseId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type ReusableFormDataCurriculumRelationFilter = {
  is?: Maybe<ReusableFormDataCurriculumWhereInput>;
  isNot?: Maybe<ReusableFormDataCurriculumWhereInput>;
};

export enum ReusableFormDataCurriculumScalarFieldEnum {
  CommonUserId = 'commonUserId',
  CourseId = 'courseId',
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name',
  TeamId = 'teamId'
}

export type ReusableFormDataCurriculumScalarWhereInput = {
  AND?: Maybe<Array<ReusableFormDataCurriculumScalarWhereInput>>;
  NOT?: Maybe<Array<ReusableFormDataCurriculumScalarWhereInput>>;
  OR?: Maybe<Array<ReusableFormDataCurriculumScalarWhereInput>>;
  commonUserId?: Maybe<IntFilter>;
  courseId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  name?: Maybe<StringFilter>;
  teamId?: Maybe<IntFilter>;
};

export type ReusableFormDataCurriculumScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ReusableFormDataCurriculumScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ReusableFormDataCurriculumScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ReusableFormDataCurriculumScalarWhereWithAggregatesInput>>;
  commonUserId?: Maybe<IntWithAggregatesFilter>;
  courseId?: Maybe<IntWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  name?: Maybe<StringWithAggregatesFilter>;
  teamId?: Maybe<IntWithAggregatesFilter>;
};

export type ReusableFormDataCurriculumSumOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  courseId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type ReusableFormDataCurriculumUpdateInput = {
  Course?: Maybe<ReusableFormDataUpdateOneRequiredWithoutReusableFormDataCurriculumNestedInput>;
  DisciplineLinks?: Maybe<ReusableFormDataCurriculumDisciplineLinkUpdateManyWithoutCurriculumNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutReusableFormDataCurriculumNestedInput>;
  UserOwner?: Maybe<CommonUserUpdateOneRequiredWithoutReusableFormDataCurriculumListNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
};

export type ReusableFormDataCurriculumUpdateManyMutationInput = {
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
};

export type ReusableFormDataCurriculumUpdateManyWithWhereWithoutCourseInput = {
  data: ReusableFormDataCurriculumUpdateManyMutationInput;
  where: ReusableFormDataCurriculumScalarWhereInput;
};

export type ReusableFormDataCurriculumUpdateManyWithWhereWithoutTeamInput = {
  data: ReusableFormDataCurriculumUpdateManyMutationInput;
  where: ReusableFormDataCurriculumScalarWhereInput;
};

export type ReusableFormDataCurriculumUpdateManyWithWhereWithoutUserOwnerInput = {
  data: ReusableFormDataCurriculumUpdateManyMutationInput;
  where: ReusableFormDataCurriculumScalarWhereInput;
};

export type ReusableFormDataCurriculumUpdateManyWithoutCourseNestedInput = {
  connect?: Maybe<Array<ReusableFormDataCurriculumWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ReusableFormDataCurriculumCreateOrConnectWithoutCourseInput>>;
  create?: Maybe<Array<ReusableFormDataCurriculumCreateWithoutCourseInput>>;
  createMany?: Maybe<ReusableFormDataCurriculumCreateManyCourseInputEnvelope>;
  delete?: Maybe<Array<ReusableFormDataCurriculumWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ReusableFormDataCurriculumScalarWhereInput>>;
  disconnect?: Maybe<Array<ReusableFormDataCurriculumWhereUniqueInput>>;
  set?: Maybe<Array<ReusableFormDataCurriculumWhereUniqueInput>>;
  update?: Maybe<Array<ReusableFormDataCurriculumUpdateWithWhereUniqueWithoutCourseInput>>;
  updateMany?: Maybe<Array<ReusableFormDataCurriculumUpdateManyWithWhereWithoutCourseInput>>;
  upsert?: Maybe<Array<ReusableFormDataCurriculumUpsertWithWhereUniqueWithoutCourseInput>>;
};

export type ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput = {
  connect?: Maybe<Array<ReusableFormDataCurriculumWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ReusableFormDataCurriculumCreateOrConnectWithoutTeamInput>>;
  create?: Maybe<Array<ReusableFormDataCurriculumCreateWithoutTeamInput>>;
  createMany?: Maybe<ReusableFormDataCurriculumCreateManyTeamInputEnvelope>;
  delete?: Maybe<Array<ReusableFormDataCurriculumWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ReusableFormDataCurriculumScalarWhereInput>>;
  disconnect?: Maybe<Array<ReusableFormDataCurriculumWhereUniqueInput>>;
  set?: Maybe<Array<ReusableFormDataCurriculumWhereUniqueInput>>;
  update?: Maybe<Array<ReusableFormDataCurriculumUpdateWithWhereUniqueWithoutTeamInput>>;
  updateMany?: Maybe<Array<ReusableFormDataCurriculumUpdateManyWithWhereWithoutTeamInput>>;
  upsert?: Maybe<Array<ReusableFormDataCurriculumUpsertWithWhereUniqueWithoutTeamInput>>;
};

export type ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput = {
  connect?: Maybe<Array<ReusableFormDataCurriculumWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ReusableFormDataCurriculumCreateOrConnectWithoutUserOwnerInput>>;
  create?: Maybe<Array<ReusableFormDataCurriculumCreateWithoutUserOwnerInput>>;
  createMany?: Maybe<ReusableFormDataCurriculumCreateManyUserOwnerInputEnvelope>;
  delete?: Maybe<Array<ReusableFormDataCurriculumWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ReusableFormDataCurriculumScalarWhereInput>>;
  disconnect?: Maybe<Array<ReusableFormDataCurriculumWhereUniqueInput>>;
  set?: Maybe<Array<ReusableFormDataCurriculumWhereUniqueInput>>;
  update?: Maybe<Array<ReusableFormDataCurriculumUpdateWithWhereUniqueWithoutUserOwnerInput>>;
  updateMany?: Maybe<Array<ReusableFormDataCurriculumUpdateManyWithWhereWithoutUserOwnerInput>>;
  upsert?: Maybe<Array<ReusableFormDataCurriculumUpsertWithWhereUniqueWithoutUserOwnerInput>>;
};

export type ReusableFormDataCurriculumUpdateOneRequiredWithoutDisciplineLinksNestedInput = {
  connect?: Maybe<ReusableFormDataCurriculumWhereUniqueInput>;
  connectOrCreate?: Maybe<ReusableFormDataCurriculumCreateOrConnectWithoutDisciplineLinksInput>;
  create?: Maybe<ReusableFormDataCurriculumCreateWithoutDisciplineLinksInput>;
  update?: Maybe<ReusableFormDataCurriculumUpdateToOneWithWhereWithoutDisciplineLinksInput>;
  upsert?: Maybe<ReusableFormDataCurriculumUpsertWithoutDisciplineLinksInput>;
};

export type ReusableFormDataCurriculumUpdateToOneWithWhereWithoutDisciplineLinksInput = {
  data: ReusableFormDataCurriculumUpdateWithoutDisciplineLinksInput;
  where?: Maybe<ReusableFormDataCurriculumWhereInput>;
};

export type ReusableFormDataCurriculumUpdateWithWhereUniqueWithoutCourseInput = {
  data: ReusableFormDataCurriculumUpdateWithoutCourseInput;
  where: ReusableFormDataCurriculumWhereUniqueInput;
};

export type ReusableFormDataCurriculumUpdateWithWhereUniqueWithoutTeamInput = {
  data: ReusableFormDataCurriculumUpdateWithoutTeamInput;
  where: ReusableFormDataCurriculumWhereUniqueInput;
};

export type ReusableFormDataCurriculumUpdateWithWhereUniqueWithoutUserOwnerInput = {
  data: ReusableFormDataCurriculumUpdateWithoutUserOwnerInput;
  where: ReusableFormDataCurriculumWhereUniqueInput;
};

export type ReusableFormDataCurriculumUpdateWithoutCourseInput = {
  DisciplineLinks?: Maybe<ReusableFormDataCurriculumDisciplineLinkUpdateManyWithoutCurriculumNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutReusableFormDataCurriculumNestedInput>;
  UserOwner?: Maybe<CommonUserUpdateOneRequiredWithoutReusableFormDataCurriculumListNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
};

export type ReusableFormDataCurriculumUpdateWithoutDisciplineLinksInput = {
  Course?: Maybe<ReusableFormDataUpdateOneRequiredWithoutReusableFormDataCurriculumNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutReusableFormDataCurriculumNestedInput>;
  UserOwner?: Maybe<CommonUserUpdateOneRequiredWithoutReusableFormDataCurriculumListNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
};

export type ReusableFormDataCurriculumUpdateWithoutTeamInput = {
  Course?: Maybe<ReusableFormDataUpdateOneRequiredWithoutReusableFormDataCurriculumNestedInput>;
  DisciplineLinks?: Maybe<ReusableFormDataCurriculumDisciplineLinkUpdateManyWithoutCurriculumNestedInput>;
  UserOwner?: Maybe<CommonUserUpdateOneRequiredWithoutReusableFormDataCurriculumListNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
};

export type ReusableFormDataCurriculumUpdateWithoutUserOwnerInput = {
  Course?: Maybe<ReusableFormDataUpdateOneRequiredWithoutReusableFormDataCurriculumNestedInput>;
  DisciplineLinks?: Maybe<ReusableFormDataCurriculumDisciplineLinkUpdateManyWithoutCurriculumNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutReusableFormDataCurriculumNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  name?: Maybe<StringFieldUpdateOperationsInput>;
};

export type ReusableFormDataCurriculumUpsertWithWhereUniqueWithoutCourseInput = {
  create: ReusableFormDataCurriculumCreateWithoutCourseInput;
  update: ReusableFormDataCurriculumUpdateWithoutCourseInput;
  where: ReusableFormDataCurriculumWhereUniqueInput;
};

export type ReusableFormDataCurriculumUpsertWithWhereUniqueWithoutTeamInput = {
  create: ReusableFormDataCurriculumCreateWithoutTeamInput;
  update: ReusableFormDataCurriculumUpdateWithoutTeamInput;
  where: ReusableFormDataCurriculumWhereUniqueInput;
};

export type ReusableFormDataCurriculumUpsertWithWhereUniqueWithoutUserOwnerInput = {
  create: ReusableFormDataCurriculumCreateWithoutUserOwnerInput;
  update: ReusableFormDataCurriculumUpdateWithoutUserOwnerInput;
  where: ReusableFormDataCurriculumWhereUniqueInput;
};

export type ReusableFormDataCurriculumUpsertWithoutDisciplineLinksInput = {
  create: ReusableFormDataCurriculumCreateWithoutDisciplineLinksInput;
  update: ReusableFormDataCurriculumUpdateWithoutDisciplineLinksInput;
  where?: Maybe<ReusableFormDataCurriculumWhereInput>;
};

export type ReusableFormDataCurriculumWhereInput = {
  AND?: Maybe<Array<ReusableFormDataCurriculumWhereInput>>;
  Course?: Maybe<ReusableFormDataWhereInput>;
  DisciplineLinks?: Maybe<ReusableFormDataCurriculumDisciplineLinkListRelationFilter>;
  NOT?: Maybe<Array<ReusableFormDataCurriculumWhereInput>>;
  OR?: Maybe<Array<ReusableFormDataCurriculumWhereInput>>;
  Team?: Maybe<TeamWhereInput>;
  UserOwner?: Maybe<CommonUserWhereInput>;
  commonUserId?: Maybe<IntFilter>;
  courseId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  name?: Maybe<StringFilter>;
  teamId?: Maybe<IntFilter>;
};

export type ReusableFormDataCurriculumWhereUniqueInput = {
  AND?: Maybe<Array<ReusableFormDataCurriculumWhereInput>>;
  Course?: Maybe<ReusableFormDataWhereInput>;
  DisciplineLinks?: Maybe<ReusableFormDataCurriculumDisciplineLinkListRelationFilter>;
  NOT?: Maybe<Array<ReusableFormDataCurriculumWhereInput>>;
  OR?: Maybe<Array<ReusableFormDataCurriculumWhereInput>>;
  Team?: Maybe<TeamWhereInput>;
  UserOwner?: Maybe<CommonUserWhereInput>;
  commonUserId?: Maybe<IntFilter>;
  courseId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<StringFilter>;
  teamId?: Maybe<IntFilter>;
};

export type ReusableFormDataListRelationFilter = {
  every?: Maybe<ReusableFormDataWhereInput>;
  none?: Maybe<ReusableFormDataWhereInput>;
  some?: Maybe<ReusableFormDataWhereInput>;
};

export type ReusableFormDataMaxOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
};

export type ReusableFormDataMinOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
};

export type ReusableFormDataOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type ReusableFormDataOrderByWithAggregationInput = {
  _avg?: Maybe<ReusableFormDataAvgOrderByAggregateInput>;
  _count?: Maybe<ReusableFormDataCountOrderByAggregateInput>;
  _max?: Maybe<ReusableFormDataMaxOrderByAggregateInput>;
  _min?: Maybe<ReusableFormDataMinOrderByAggregateInput>;
  _sum?: Maybe<ReusableFormDataSumOrderByAggregateInput>;
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  data?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
};

export type ReusableFormDataOrderByWithRelationInput = {
  DisciplineLinks?: Maybe<ReusableFormDataCurriculumDisciplineLinkOrderByRelationAggregateInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumOrderByRelationAggregateInput>;
  Team?: Maybe<TeamOrderByWithRelationInput>;
  UserOwner?: Maybe<CommonUserOrderByWithRelationInput>;
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  data?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
};

export type ReusableFormDataRelationFilter = {
  is?: Maybe<ReusableFormDataWhereInput>;
  isNot?: Maybe<ReusableFormDataWhereInput>;
};

export enum ReusableFormDataScalarFieldEnum {
  CommonUserId = 'commonUserId',
  CreatedAt = 'createdAt',
  Data = 'data',
  Id = 'id',
  TeamId = 'teamId',
  Type = 'type'
}

export type ReusableFormDataScalarWhereInput = {
  AND?: Maybe<Array<ReusableFormDataScalarWhereInput>>;
  NOT?: Maybe<Array<ReusableFormDataScalarWhereInput>>;
  OR?: Maybe<Array<ReusableFormDataScalarWhereInput>>;
  commonUserId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  data?: Maybe<JsonFilter>;
  id?: Maybe<IntFilter>;
  teamId?: Maybe<IntFilter>;
  type?: Maybe<StringFilter>;
};

export type ReusableFormDataScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<ReusableFormDataScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<ReusableFormDataScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<ReusableFormDataScalarWhereWithAggregatesInput>>;
  commonUserId?: Maybe<IntWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  data?: Maybe<JsonWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  teamId?: Maybe<IntWithAggregatesFilter>;
  type?: Maybe<StringWithAggregatesFilter>;
};

export type ReusableFormDataSumOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type ReusableFormDataUpdateInput = {
  DisciplineLinks?: Maybe<ReusableFormDataCurriculumDisciplineLinkUpdateManyWithoutDisciplineNestedInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutCourseNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutReusableFormDataNestedInput>;
  UserOwner?: Maybe<CommonUserUpdateOneRequiredWithoutReusableFormDatasNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  data?: Maybe<Scalars['Json']>;
  type?: Maybe<StringFieldUpdateOperationsInput>;
};

export type ReusableFormDataUpdateManyMutationInput = {
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  data?: Maybe<Scalars['Json']>;
  type?: Maybe<StringFieldUpdateOperationsInput>;
};

export type ReusableFormDataUpdateManyWithWhereWithoutTeamInput = {
  data: ReusableFormDataUpdateManyMutationInput;
  where: ReusableFormDataScalarWhereInput;
};

export type ReusableFormDataUpdateManyWithWhereWithoutUserOwnerInput = {
  data: ReusableFormDataUpdateManyMutationInput;
  where: ReusableFormDataScalarWhereInput;
};

export type ReusableFormDataUpdateManyWithoutTeamNestedInput = {
  connect?: Maybe<Array<ReusableFormDataWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ReusableFormDataCreateOrConnectWithoutTeamInput>>;
  create?: Maybe<Array<ReusableFormDataCreateWithoutTeamInput>>;
  createMany?: Maybe<ReusableFormDataCreateManyTeamInputEnvelope>;
  delete?: Maybe<Array<ReusableFormDataWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ReusableFormDataScalarWhereInput>>;
  disconnect?: Maybe<Array<ReusableFormDataWhereUniqueInput>>;
  set?: Maybe<Array<ReusableFormDataWhereUniqueInput>>;
  update?: Maybe<Array<ReusableFormDataUpdateWithWhereUniqueWithoutTeamInput>>;
  updateMany?: Maybe<Array<ReusableFormDataUpdateManyWithWhereWithoutTeamInput>>;
  upsert?: Maybe<Array<ReusableFormDataUpsertWithWhereUniqueWithoutTeamInput>>;
};

export type ReusableFormDataUpdateManyWithoutUserOwnerNestedInput = {
  connect?: Maybe<Array<ReusableFormDataWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<ReusableFormDataCreateOrConnectWithoutUserOwnerInput>>;
  create?: Maybe<Array<ReusableFormDataCreateWithoutUserOwnerInput>>;
  createMany?: Maybe<ReusableFormDataCreateManyUserOwnerInputEnvelope>;
  delete?: Maybe<Array<ReusableFormDataWhereUniqueInput>>;
  deleteMany?: Maybe<Array<ReusableFormDataScalarWhereInput>>;
  disconnect?: Maybe<Array<ReusableFormDataWhereUniqueInput>>;
  set?: Maybe<Array<ReusableFormDataWhereUniqueInput>>;
  update?: Maybe<Array<ReusableFormDataUpdateWithWhereUniqueWithoutUserOwnerInput>>;
  updateMany?: Maybe<Array<ReusableFormDataUpdateManyWithWhereWithoutUserOwnerInput>>;
  upsert?: Maybe<Array<ReusableFormDataUpsertWithWhereUniqueWithoutUserOwnerInput>>;
};

export type ReusableFormDataUpdateOneRequiredWithoutDisciplineLinksNestedInput = {
  connect?: Maybe<ReusableFormDataWhereUniqueInput>;
  connectOrCreate?: Maybe<ReusableFormDataCreateOrConnectWithoutDisciplineLinksInput>;
  create?: Maybe<ReusableFormDataCreateWithoutDisciplineLinksInput>;
  update?: Maybe<ReusableFormDataUpdateToOneWithWhereWithoutDisciplineLinksInput>;
  upsert?: Maybe<ReusableFormDataUpsertWithoutDisciplineLinksInput>;
};

export type ReusableFormDataUpdateOneRequiredWithoutReusableFormDataCurriculumNestedInput = {
  connect?: Maybe<ReusableFormDataWhereUniqueInput>;
  connectOrCreate?: Maybe<ReusableFormDataCreateOrConnectWithoutReusableFormDataCurriculumInput>;
  create?: Maybe<ReusableFormDataCreateWithoutReusableFormDataCurriculumInput>;
  update?: Maybe<ReusableFormDataUpdateToOneWithWhereWithoutReusableFormDataCurriculumInput>;
  upsert?: Maybe<ReusableFormDataUpsertWithoutReusableFormDataCurriculumInput>;
};

export type ReusableFormDataUpdateToOneWithWhereWithoutDisciplineLinksInput = {
  data: ReusableFormDataUpdateWithoutDisciplineLinksInput;
  where?: Maybe<ReusableFormDataWhereInput>;
};

export type ReusableFormDataUpdateToOneWithWhereWithoutReusableFormDataCurriculumInput = {
  data: ReusableFormDataUpdateWithoutReusableFormDataCurriculumInput;
  where?: Maybe<ReusableFormDataWhereInput>;
};

export type ReusableFormDataUpdateWithWhereUniqueWithoutTeamInput = {
  data: ReusableFormDataUpdateWithoutTeamInput;
  where: ReusableFormDataWhereUniqueInput;
};

export type ReusableFormDataUpdateWithWhereUniqueWithoutUserOwnerInput = {
  data: ReusableFormDataUpdateWithoutUserOwnerInput;
  where: ReusableFormDataWhereUniqueInput;
};

export type ReusableFormDataUpdateWithoutDisciplineLinksInput = {
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutCourseNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutReusableFormDataNestedInput>;
  UserOwner?: Maybe<CommonUserUpdateOneRequiredWithoutReusableFormDatasNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  data?: Maybe<Scalars['Json']>;
  type?: Maybe<StringFieldUpdateOperationsInput>;
};

export type ReusableFormDataUpdateWithoutReusableFormDataCurriculumInput = {
  DisciplineLinks?: Maybe<ReusableFormDataCurriculumDisciplineLinkUpdateManyWithoutDisciplineNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutReusableFormDataNestedInput>;
  UserOwner?: Maybe<CommonUserUpdateOneRequiredWithoutReusableFormDatasNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  data?: Maybe<Scalars['Json']>;
  type?: Maybe<StringFieldUpdateOperationsInput>;
};

export type ReusableFormDataUpdateWithoutTeamInput = {
  DisciplineLinks?: Maybe<ReusableFormDataCurriculumDisciplineLinkUpdateManyWithoutDisciplineNestedInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutCourseNestedInput>;
  UserOwner?: Maybe<CommonUserUpdateOneRequiredWithoutReusableFormDatasNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  data?: Maybe<Scalars['Json']>;
  type?: Maybe<StringFieldUpdateOperationsInput>;
};

export type ReusableFormDataUpdateWithoutUserOwnerInput = {
  DisciplineLinks?: Maybe<ReusableFormDataCurriculumDisciplineLinkUpdateManyWithoutDisciplineNestedInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutCourseNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutReusableFormDataNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  data?: Maybe<Scalars['Json']>;
  type?: Maybe<StringFieldUpdateOperationsInput>;
};

export type ReusableFormDataUpsertWithWhereUniqueWithoutTeamInput = {
  create: ReusableFormDataCreateWithoutTeamInput;
  update: ReusableFormDataUpdateWithoutTeamInput;
  where: ReusableFormDataWhereUniqueInput;
};

export type ReusableFormDataUpsertWithWhereUniqueWithoutUserOwnerInput = {
  create: ReusableFormDataCreateWithoutUserOwnerInput;
  update: ReusableFormDataUpdateWithoutUserOwnerInput;
  where: ReusableFormDataWhereUniqueInput;
};

export type ReusableFormDataUpsertWithoutDisciplineLinksInput = {
  create: ReusableFormDataCreateWithoutDisciplineLinksInput;
  update: ReusableFormDataUpdateWithoutDisciplineLinksInput;
  where?: Maybe<ReusableFormDataWhereInput>;
};

export type ReusableFormDataUpsertWithoutReusableFormDataCurriculumInput = {
  create: ReusableFormDataCreateWithoutReusableFormDataCurriculumInput;
  update: ReusableFormDataUpdateWithoutReusableFormDataCurriculumInput;
  where?: Maybe<ReusableFormDataWhereInput>;
};

export type ReusableFormDataWhereInput = {
  AND?: Maybe<Array<ReusableFormDataWhereInput>>;
  DisciplineLinks?: Maybe<ReusableFormDataCurriculumDisciplineLinkListRelationFilter>;
  NOT?: Maybe<Array<ReusableFormDataWhereInput>>;
  OR?: Maybe<Array<ReusableFormDataWhereInput>>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumListRelationFilter>;
  Team?: Maybe<TeamWhereInput>;
  UserOwner?: Maybe<CommonUserWhereInput>;
  commonUserId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  data?: Maybe<JsonFilter>;
  id?: Maybe<IntFilter>;
  teamId?: Maybe<IntFilter>;
  type?: Maybe<StringFilter>;
};

export type ReusableFormDataWhereInputCustom = {
  AND?: Maybe<Array<ReusableFormDataWhereInput>>;
  DisciplineLinks?: Maybe<ReusableFormDataCurriculumDisciplineLinkListRelationFilter>;
  NOT?: Maybe<Array<ReusableFormDataWhereInput>>;
  OR?: Maybe<Array<ReusableFormDataWhereInput>>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumListRelationFilter>;
  Team?: Maybe<TeamWhereInput>;
  UserOwner?: Maybe<CommonUserWhereInput>;
  commonUserId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  data?: Maybe<JsonFilter>;
  fuzzySearch?: Maybe<FuzzySearch>;
  id?: Maybe<IntFilter>;
  teamId?: Maybe<IntFilter>;
  type?: Maybe<StringFilter>;
};

export type ReusableFormDataWhereUniqueInput = {
  AND?: Maybe<Array<ReusableFormDataWhereInput>>;
  DisciplineLinks?: Maybe<ReusableFormDataCurriculumDisciplineLinkListRelationFilter>;
  NOT?: Maybe<Array<ReusableFormDataWhereInput>>;
  OR?: Maybe<Array<ReusableFormDataWhereInput>>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumListRelationFilter>;
  Team?: Maybe<TeamWhereInput>;
  UserOwner?: Maybe<CommonUserWhereInput>;
  commonUserId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  data?: Maybe<JsonFilter>;
  id?: Maybe<Scalars['Int']>;
  teamId?: Maybe<IntFilter>;
  type?: Maybe<StringFilter>;
};

export type SaveOneCommonUserConfigInputData = {
  key: CommonUserConfigKeys;
  value: Scalars['Json'];
};

/** Servuço e seu preço */
export type ServicePrice = {
  __typename?: 'ServicePrice';
  service: FinancialChargeableService;
  unitPrice: Scalars['Float'];
};

export type SignSignatureImage = {
  __typename?: 'SignSignatureImage';
  UserCreated: CommonUser;
  UserUsingAsPrimary?: Maybe<CommonUser>;
  base64Image: Scalars['String'];
  commonUserId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['String'];
  percentageBelowTheLine: Scalars['Float'];
};

export type SignSignatureImageAvgOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  percentageBelowTheLine?: Maybe<SortOrder>;
};

export type SignSignatureImageCountOrderByAggregateInput = {
  base64Image?: Maybe<SortOrder>;
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  percentageBelowTheLine?: Maybe<SortOrder>;
};

export type SignSignatureImageCreateInput = {
  UserCreated: CommonUserCreateNestedOneWithoutCreatedSignatureImagesInput;
  UserUsingAsPrimary?: Maybe<CommonUserCreateNestedOneWithoutDefaultImageInput>;
  base64Image: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  percentageBelowTheLine?: Maybe<Scalars['Float']>;
};

export type SignSignatureImageCreateManyInput = {
  base64Image: Scalars['String'];
  commonUserId: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  percentageBelowTheLine?: Maybe<Scalars['Float']>;
};

export type SignSignatureImageCreateManyUserCreatedInput = {
  base64Image: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  percentageBelowTheLine?: Maybe<Scalars['Float']>;
};

export type SignSignatureImageCreateManyUserCreatedInputEnvelope = {
  data: Array<SignSignatureImageCreateManyUserCreatedInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type SignSignatureImageCreateNestedManyWithoutUserCreatedInput = {
  connect?: Maybe<Array<SignSignatureImageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SignSignatureImageCreateOrConnectWithoutUserCreatedInput>>;
  create?: Maybe<Array<SignSignatureImageCreateWithoutUserCreatedInput>>;
  createMany?: Maybe<SignSignatureImageCreateManyUserCreatedInputEnvelope>;
};

export type SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput = {
  connect?: Maybe<SignSignatureImageWhereUniqueInput>;
  connectOrCreate?: Maybe<SignSignatureImageCreateOrConnectWithoutUserUsingAsPrimaryInput>;
  create?: Maybe<SignSignatureImageCreateWithoutUserUsingAsPrimaryInput>;
};

export type SignSignatureImageCreateOrConnectWithoutUserCreatedInput = {
  create: SignSignatureImageCreateWithoutUserCreatedInput;
  where: SignSignatureImageWhereUniqueInput;
};

export type SignSignatureImageCreateOrConnectWithoutUserUsingAsPrimaryInput = {
  create: SignSignatureImageCreateWithoutUserUsingAsPrimaryInput;
  where: SignSignatureImageWhereUniqueInput;
};

export type SignSignatureImageCreateWithoutUserCreatedInput = {
  UserUsingAsPrimary?: Maybe<CommonUserCreateNestedOneWithoutDefaultImageInput>;
  base64Image: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  percentageBelowTheLine?: Maybe<Scalars['Float']>;
};

export type SignSignatureImageCreateWithoutUserUsingAsPrimaryInput = {
  UserCreated: CommonUserCreateNestedOneWithoutCreatedSignatureImagesInput;
  base64Image: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  percentageBelowTheLine?: Maybe<Scalars['Float']>;
};

export type SignSignatureImageListRelationFilter = {
  every?: Maybe<SignSignatureImageWhereInput>;
  none?: Maybe<SignSignatureImageWhereInput>;
  some?: Maybe<SignSignatureImageWhereInput>;
};

export type SignSignatureImageMaxOrderByAggregateInput = {
  base64Image?: Maybe<SortOrder>;
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  percentageBelowTheLine?: Maybe<SortOrder>;
};

export type SignSignatureImageMinOrderByAggregateInput = {
  base64Image?: Maybe<SortOrder>;
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  percentageBelowTheLine?: Maybe<SortOrder>;
};

export type SignSignatureImageNullableRelationFilter = {
  is?: Maybe<SignSignatureImageWhereInput>;
  isNot?: Maybe<SignSignatureImageWhereInput>;
};

export type SignSignatureImageOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type SignSignatureImageOrderByWithAggregationInput = {
  _avg?: Maybe<SignSignatureImageAvgOrderByAggregateInput>;
  _count?: Maybe<SignSignatureImageCountOrderByAggregateInput>;
  _max?: Maybe<SignSignatureImageMaxOrderByAggregateInput>;
  _min?: Maybe<SignSignatureImageMinOrderByAggregateInput>;
  _sum?: Maybe<SignSignatureImageSumOrderByAggregateInput>;
  base64Image?: Maybe<SortOrder>;
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  percentageBelowTheLine?: Maybe<SortOrder>;
};

export type SignSignatureImageOrderByWithRelationInput = {
  UserCreated?: Maybe<CommonUserOrderByWithRelationInput>;
  UserUsingAsPrimary?: Maybe<CommonUserOrderByWithRelationInput>;
  base64Image?: Maybe<SortOrder>;
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  percentageBelowTheLine?: Maybe<SortOrder>;
};

export enum SignSignatureImageScalarFieldEnum {
  Base64Image = 'base64Image',
  CommonUserId = 'commonUserId',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  PercentageBelowTheLine = 'percentageBelowTheLine'
}

export type SignSignatureImageScalarWhereInput = {
  AND?: Maybe<Array<SignSignatureImageScalarWhereInput>>;
  NOT?: Maybe<Array<SignSignatureImageScalarWhereInput>>;
  OR?: Maybe<Array<SignSignatureImageScalarWhereInput>>;
  base64Image?: Maybe<StringFilter>;
  commonUserId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  percentageBelowTheLine?: Maybe<FloatFilter>;
};

export type SignSignatureImageScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<SignSignatureImageScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<SignSignatureImageScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<SignSignatureImageScalarWhereWithAggregatesInput>>;
  base64Image?: Maybe<StringWithAggregatesFilter>;
  commonUserId?: Maybe<IntWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  description?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  percentageBelowTheLine?: Maybe<FloatWithAggregatesFilter>;
};

export type SignSignatureImageSumOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  percentageBelowTheLine?: Maybe<SortOrder>;
};

export type SignSignatureImageUpdateInput = {
  UserCreated?: Maybe<CommonUserUpdateOneRequiredWithoutCreatedSignatureImagesNestedInput>;
  UserUsingAsPrimary?: Maybe<CommonUserUpdateOneWithoutDefaultImageNestedInput>;
  base64Image?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  description?: Maybe<StringFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  percentageBelowTheLine?: Maybe<FloatFieldUpdateOperationsInput>;
};

export type SignSignatureImageUpdateManyMutationInput = {
  base64Image?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  description?: Maybe<StringFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  percentageBelowTheLine?: Maybe<FloatFieldUpdateOperationsInput>;
};

export type SignSignatureImageUpdateManyWithWhereWithoutUserCreatedInput = {
  data: SignSignatureImageUpdateManyMutationInput;
  where: SignSignatureImageScalarWhereInput;
};

export type SignSignatureImageUpdateManyWithoutUserCreatedNestedInput = {
  connect?: Maybe<Array<SignSignatureImageWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SignSignatureImageCreateOrConnectWithoutUserCreatedInput>>;
  create?: Maybe<Array<SignSignatureImageCreateWithoutUserCreatedInput>>;
  createMany?: Maybe<SignSignatureImageCreateManyUserCreatedInputEnvelope>;
  delete?: Maybe<Array<SignSignatureImageWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SignSignatureImageScalarWhereInput>>;
  disconnect?: Maybe<Array<SignSignatureImageWhereUniqueInput>>;
  set?: Maybe<Array<SignSignatureImageWhereUniqueInput>>;
  update?: Maybe<Array<SignSignatureImageUpdateWithWhereUniqueWithoutUserCreatedInput>>;
  updateMany?: Maybe<Array<SignSignatureImageUpdateManyWithWhereWithoutUserCreatedInput>>;
  upsert?: Maybe<Array<SignSignatureImageUpsertWithWhereUniqueWithoutUserCreatedInput>>;
};

export type SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput = {
  connect?: Maybe<SignSignatureImageWhereUniqueInput>;
  connectOrCreate?: Maybe<SignSignatureImageCreateOrConnectWithoutUserUsingAsPrimaryInput>;
  create?: Maybe<SignSignatureImageCreateWithoutUserUsingAsPrimaryInput>;
  delete?: Maybe<SignSignatureImageWhereInput>;
  disconnect?: Maybe<SignSignatureImageWhereInput>;
  update?: Maybe<SignSignatureImageUpdateToOneWithWhereWithoutUserUsingAsPrimaryInput>;
  upsert?: Maybe<SignSignatureImageUpsertWithoutUserUsingAsPrimaryInput>;
};

export type SignSignatureImageUpdateToOneWithWhereWithoutUserUsingAsPrimaryInput = {
  data: SignSignatureImageUpdateWithoutUserUsingAsPrimaryInput;
  where?: Maybe<SignSignatureImageWhereInput>;
};

export type SignSignatureImageUpdateWithWhereUniqueWithoutUserCreatedInput = {
  data: SignSignatureImageUpdateWithoutUserCreatedInput;
  where: SignSignatureImageWhereUniqueInput;
};

export type SignSignatureImageUpdateWithoutUserCreatedInput = {
  UserUsingAsPrimary?: Maybe<CommonUserUpdateOneWithoutDefaultImageNestedInput>;
  base64Image?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  description?: Maybe<StringFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  percentageBelowTheLine?: Maybe<FloatFieldUpdateOperationsInput>;
};

export type SignSignatureImageUpdateWithoutUserUsingAsPrimaryInput = {
  UserCreated?: Maybe<CommonUserUpdateOneRequiredWithoutCreatedSignatureImagesNestedInput>;
  base64Image?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  description?: Maybe<StringFieldUpdateOperationsInput>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  percentageBelowTheLine?: Maybe<FloatFieldUpdateOperationsInput>;
};

export type SignSignatureImageUpsertWithWhereUniqueWithoutUserCreatedInput = {
  create: SignSignatureImageCreateWithoutUserCreatedInput;
  update: SignSignatureImageUpdateWithoutUserCreatedInput;
  where: SignSignatureImageWhereUniqueInput;
};

export type SignSignatureImageUpsertWithoutUserUsingAsPrimaryInput = {
  create: SignSignatureImageCreateWithoutUserUsingAsPrimaryInput;
  update: SignSignatureImageUpdateWithoutUserUsingAsPrimaryInput;
  where?: Maybe<SignSignatureImageWhereInput>;
};

export type SignSignatureImageWhereInput = {
  AND?: Maybe<Array<SignSignatureImageWhereInput>>;
  NOT?: Maybe<Array<SignSignatureImageWhereInput>>;
  OR?: Maybe<Array<SignSignatureImageWhereInput>>;
  UserCreated?: Maybe<CommonUserWhereInput>;
  UserUsingAsPrimary?: Maybe<CommonUserWhereInput>;
  base64Image?: Maybe<StringFilter>;
  commonUserId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  id?: Maybe<StringFilter>;
  percentageBelowTheLine?: Maybe<FloatFilter>;
};

export type SignSignatureImageWhereUniqueInput = {
  AND?: Maybe<Array<SignSignatureImageWhereInput>>;
  NOT?: Maybe<Array<SignSignatureImageWhereInput>>;
  OR?: Maybe<Array<SignSignatureImageWhereInput>>;
  UserCreated?: Maybe<CommonUserWhereInput>;
  UserUsingAsPrimary?: Maybe<CommonUserWhereInput>;
  base64Image?: Maybe<StringFilter>;
  commonUserId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringFilter>;
  id?: Maybe<Scalars['String']>;
  percentageBelowTheLine?: Maybe<FloatFilter>;
};

export type SignableInviteItemsAndCount = {
  __typename?: 'SignableInviteItemsAndCount';
  count: Scalars['Int'];
  items: Array<DocumentBaseSignatureInvite>;
};

export enum SignatureType {
  Cnpj = 'CNPJ',
  Cpf_0OrMore = 'CPF_0_OR_MORE',
  Cpf_1OrMore = 'CPF_1_OR_MORE'
}

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type StartSignature = {
  __typename?: 'StartSignature';
  dataToSign: Scalars['String'];
  lastSignatureIsoString: Scalars['String'];
  signingTime: Scalars['String'];
};

export type StringFieldUpdateOperationsInput = {
  set?: Maybe<Scalars['String']>;
};

export type StringFilter = {
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  mode?: Maybe<QueryMode>;
  not?: Maybe<NestedStringFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  startsWith?: Maybe<Scalars['String']>;
};

export type StringNullableFilter = {
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  mode?: Maybe<QueryMode>;
  not?: Maybe<NestedStringNullableFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  startsWith?: Maybe<Scalars['String']>;
};

export type StringNullableListFilter = {
  equals?: Maybe<Array<Scalars['String']>>;
  has?: Maybe<Scalars['String']>;
  hasEvery?: Maybe<Array<Scalars['String']>>;
  hasSome?: Maybe<Array<Scalars['String']>>;
  isEmpty?: Maybe<Scalars['Boolean']>;
};

export type StringNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedStringNullableFilter>;
  _min?: Maybe<NestedStringNullableFilter>;
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  mode?: Maybe<QueryMode>;
  not?: Maybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  startsWith?: Maybe<Scalars['String']>;
};

export type StringWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedStringFilter>;
  _min?: Maybe<NestedStringFilter>;
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  mode?: Maybe<QueryMode>;
  not?: Maybe<NestedStringWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  startsWith?: Maybe<Scalars['String']>;
};

export enum SubService {
  Certificates = 'CERTIFICATES',
  UnderGraduateAndPostGraduate = 'UNDER_GRADUATE_AND_POST_GRADUATE'
}

export type Subscription = {
  __typename?: 'Subscription';
  findFirstDocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentation>;
  findUniqueDocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentation>;
  findUniqueSignSignatureImage?: Maybe<SignSignatureImage>;
  /** Notificar quando um novo certificado for gerado. */
  generatedCertificate: GeneratedCertificateData;
  /** Notificar usuário em caso de mudança num template */
  watchCertificateTemplateData: WatchCertificateTemplateData;
  /** Notificações do usuário */
  watchDocumentFocus: Array<WatchDocumentFocus>;
  /** Notificações do usuário */
  watchDocumentPatches: WatchDocumentPatch;
  /** Notificações do usuário */
  watchDocumentStatus: Scalars['String'];
  /** Créditos do time */
  watchFinancialTeamWallet: FinancialTeamWallet;
  /** Notificar quando um novo certificado for assinado. */
  watchSignBulkCertificate: WatchSignBulkCertificate;
  /** Enviar uma notificação quando uma assinatura do certificado em lote for validada. */
  watchSignValidationBulkCertificate: WatchSignValidationBulkCertificate;
  /** Enviar uma notificação quando uma assinatura de um certificado for validada. */
  watchSingleCertificateSignValidationEvent: WatchSingleCertificateSignValidationEvent;
};


export type SubscriptionFindFirstDocumentAcademicDocumentationArgs = {
  cursor?: Maybe<DocumentAcademicDocumentationWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentAcademicDocumentationScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentAcademicDocumentationOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentAcademicDocumentationWhereInput>;
};


export type SubscriptionFindUniqueDocumentAcademicDocumentationArgs = {
  where: DocumentAcademicDocumentationWhereUniqueInput;
};


export type SubscriptionFindUniqueSignSignatureImageArgs = {
  where: SignSignatureImageWhereUniqueInput;
};


export type SubscriptionGeneratedCertificateArgs = {
  bulkCertificateRecordId: Scalars['String'];
  institutionId: Scalars['Int'];
};


export type SubscriptionWatchCertificateTemplateDataArgs = {
  teamId: Scalars['Int'];
  templateId: Scalars['String'];
};


export type SubscriptionWatchDocumentFocusArgs = {
  documentId: Scalars['String'];
  teamId: Scalars['Int'];
};


export type SubscriptionWatchDocumentPatchesArgs = {
  documentId: Scalars['String'];
  teamId: Scalars['Int'];
};


export type SubscriptionWatchDocumentStatusArgs = {
  documentId: Scalars['String'];
  teamId: Scalars['Int'];
};


export type SubscriptionWatchSignBulkCertificateArgs = {
  bulkId: Scalars['String'];
};


export type SubscriptionWatchSignValidationBulkCertificateArgs = {
  bulkId: Scalars['String'];
};


export type SubscriptionWatchSingleCertificateSignValidationEventArgs = {
  inviteId: Scalars['String'];
};

export type SumCount = {
  __typename?: 'SumCount';
  count: Scalars['Int'];
  sum: Scalars['Float'];
};

/** Responsável por guardar ações do sistema. Como deleção de itens... */
export type SystemAuditLog = {
  __typename?: 'SystemAuditLog';
  Team?: Maybe<Team>;
  User?: Maybe<CommonUser>;
  /**
   * https://docs.bemi.io/postgresql/destination-database Records values after the change. Used in create / update
   * ![PrismaJson.AnyJson]
   */
  after?: Maybe<Scalars['Json']>;
  /** ![PrismaJson.AnyJson] */
  args?: Maybe<Scalars['Json']>;
  commonUserId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  /** ![PrismaJson.AnyJson] */
  extraContext?: Maybe<Scalars['Json']>;
  id: Scalars['String'];
  moduleTranslated: Scalars['String'];
  /** create, update, delete, deleteMany */
  operation: Scalars['String'];
  operationTranslated: Scalars['String'];
  primaryKey?: Maybe<Scalars['String']>;
  /** CommonUser, ... */
  table: Scalars['String'];
  teamId?: Maybe<Scalars['Int']>;
  translatedAfter: Array<KeyValue>;
};

export type SystemAuditLogAvgOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type SystemAuditLogCountOrderByAggregateInput = {
  after?: Maybe<SortOrder>;
  args?: Maybe<SortOrder>;
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  extraContext?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  operation?: Maybe<SortOrder>;
  primaryKey?: Maybe<SortOrder>;
  table?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type SystemAuditLogCreateInput = {
  Team?: Maybe<TeamCreateNestedOneWithoutSystemAuditLogsInput>;
  User?: Maybe<CommonUserCreateNestedOneWithoutSystemAuditLogsInput>;
  after?: Maybe<Scalars['Json']>;
  args?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extraContext?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  operation: Scalars['String'];
  primaryKey?: Maybe<Scalars['String']>;
  table: Scalars['String'];
};

export type SystemAuditLogCreateManyInput = {
  after?: Maybe<Scalars['Json']>;
  args?: Maybe<Scalars['Json']>;
  commonUserId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extraContext?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  operation: Scalars['String'];
  primaryKey?: Maybe<Scalars['String']>;
  table: Scalars['String'];
  teamId?: Maybe<Scalars['Int']>;
};

export type SystemAuditLogCreateManyTeamInput = {
  after?: Maybe<Scalars['Json']>;
  args?: Maybe<Scalars['Json']>;
  commonUserId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extraContext?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  operation: Scalars['String'];
  primaryKey?: Maybe<Scalars['String']>;
  table: Scalars['String'];
};

export type SystemAuditLogCreateManyTeamInputEnvelope = {
  data: Array<SystemAuditLogCreateManyTeamInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type SystemAuditLogCreateManyUserInput = {
  after?: Maybe<Scalars['Json']>;
  args?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extraContext?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  operation: Scalars['String'];
  primaryKey?: Maybe<Scalars['String']>;
  table: Scalars['String'];
  teamId?: Maybe<Scalars['Int']>;
};

export type SystemAuditLogCreateManyUserInputEnvelope = {
  data: Array<SystemAuditLogCreateManyUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type SystemAuditLogCreateNestedManyWithoutTeamInput = {
  connect?: Maybe<Array<SystemAuditLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SystemAuditLogCreateOrConnectWithoutTeamInput>>;
  create?: Maybe<Array<SystemAuditLogCreateWithoutTeamInput>>;
  createMany?: Maybe<SystemAuditLogCreateManyTeamInputEnvelope>;
};

export type SystemAuditLogCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<SystemAuditLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SystemAuditLogCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<SystemAuditLogCreateWithoutUserInput>>;
  createMany?: Maybe<SystemAuditLogCreateManyUserInputEnvelope>;
};

export type SystemAuditLogCreateOrConnectWithoutTeamInput = {
  create: SystemAuditLogCreateWithoutTeamInput;
  where: SystemAuditLogWhereUniqueInput;
};

export type SystemAuditLogCreateOrConnectWithoutUserInput = {
  create: SystemAuditLogCreateWithoutUserInput;
  where: SystemAuditLogWhereUniqueInput;
};

export type SystemAuditLogCreateWithoutTeamInput = {
  User?: Maybe<CommonUserCreateNestedOneWithoutSystemAuditLogsInput>;
  after?: Maybe<Scalars['Json']>;
  args?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extraContext?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  operation: Scalars['String'];
  primaryKey?: Maybe<Scalars['String']>;
  table: Scalars['String'];
};

export type SystemAuditLogCreateWithoutUserInput = {
  Team?: Maybe<TeamCreateNestedOneWithoutSystemAuditLogsInput>;
  after?: Maybe<Scalars['Json']>;
  args?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extraContext?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  operation: Scalars['String'];
  primaryKey?: Maybe<Scalars['String']>;
  table: Scalars['String'];
};

export type SystemAuditLogListRelationFilter = {
  every?: Maybe<SystemAuditLogWhereInput>;
  none?: Maybe<SystemAuditLogWhereInput>;
  some?: Maybe<SystemAuditLogWhereInput>;
};

export type SystemAuditLogMaxOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  operation?: Maybe<SortOrder>;
  primaryKey?: Maybe<SortOrder>;
  table?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type SystemAuditLogMinOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  operation?: Maybe<SortOrder>;
  primaryKey?: Maybe<SortOrder>;
  table?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type SystemAuditLogOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type SystemAuditLogOrderByWithAggregationInput = {
  _avg?: Maybe<SystemAuditLogAvgOrderByAggregateInput>;
  _count?: Maybe<SystemAuditLogCountOrderByAggregateInput>;
  _max?: Maybe<SystemAuditLogMaxOrderByAggregateInput>;
  _min?: Maybe<SystemAuditLogMinOrderByAggregateInput>;
  _sum?: Maybe<SystemAuditLogSumOrderByAggregateInput>;
  after?: Maybe<SortOrder>;
  args?: Maybe<SortOrder>;
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  extraContext?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  operation?: Maybe<SortOrder>;
  primaryKey?: Maybe<SortOrder>;
  table?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type SystemAuditLogOrderByWithRelationInput = {
  Team?: Maybe<TeamOrderByWithRelationInput>;
  User?: Maybe<CommonUserOrderByWithRelationInput>;
  after?: Maybe<SortOrder>;
  args?: Maybe<SortOrder>;
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  extraContext?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  operation?: Maybe<SortOrder>;
  primaryKey?: Maybe<SortOrder>;
  table?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export enum SystemAuditLogScalarFieldEnum {
  After = 'after',
  Args = 'args',
  CommonUserId = 'commonUserId',
  CreatedAt = 'createdAt',
  ExtraContext = 'extraContext',
  Id = 'id',
  Operation = 'operation',
  PrimaryKey = 'primaryKey',
  Table = 'table',
  TeamId = 'teamId'
}

export type SystemAuditLogScalarWhereInput = {
  AND?: Maybe<Array<SystemAuditLogScalarWhereInput>>;
  NOT?: Maybe<Array<SystemAuditLogScalarWhereInput>>;
  OR?: Maybe<Array<SystemAuditLogScalarWhereInput>>;
  after?: Maybe<JsonNullableFilter>;
  args?: Maybe<JsonNullableFilter>;
  commonUserId?: Maybe<IntNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  extraContext?: Maybe<JsonNullableFilter>;
  id?: Maybe<StringFilter>;
  operation?: Maybe<StringFilter>;
  primaryKey?: Maybe<StringNullableFilter>;
  table?: Maybe<StringFilter>;
  teamId?: Maybe<IntNullableFilter>;
};

export type SystemAuditLogScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<SystemAuditLogScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<SystemAuditLogScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<SystemAuditLogScalarWhereWithAggregatesInput>>;
  after?: Maybe<JsonNullableWithAggregatesFilter>;
  args?: Maybe<JsonNullableWithAggregatesFilter>;
  commonUserId?: Maybe<IntNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  extraContext?: Maybe<JsonNullableWithAggregatesFilter>;
  id?: Maybe<StringWithAggregatesFilter>;
  operation?: Maybe<StringWithAggregatesFilter>;
  primaryKey?: Maybe<StringNullableWithAggregatesFilter>;
  table?: Maybe<StringWithAggregatesFilter>;
  teamId?: Maybe<IntNullableWithAggregatesFilter>;
};

export type SystemAuditLogSumOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type SystemAuditLogUpdateInput = {
  Team?: Maybe<TeamUpdateOneWithoutSystemAuditLogsNestedInput>;
  User?: Maybe<CommonUserUpdateOneWithoutSystemAuditLogsNestedInput>;
  after?: Maybe<Scalars['Json']>;
  args?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  extraContext?: Maybe<Scalars['Json']>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  operation?: Maybe<StringFieldUpdateOperationsInput>;
  primaryKey?: Maybe<NullableStringFieldUpdateOperationsInput>;
  table?: Maybe<StringFieldUpdateOperationsInput>;
};

export type SystemAuditLogUpdateManyMutationInput = {
  after?: Maybe<Scalars['Json']>;
  args?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  extraContext?: Maybe<Scalars['Json']>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  operation?: Maybe<StringFieldUpdateOperationsInput>;
  primaryKey?: Maybe<NullableStringFieldUpdateOperationsInput>;
  table?: Maybe<StringFieldUpdateOperationsInput>;
};

export type SystemAuditLogUpdateManyWithWhereWithoutTeamInput = {
  data: SystemAuditLogUpdateManyMutationInput;
  where: SystemAuditLogScalarWhereInput;
};

export type SystemAuditLogUpdateManyWithWhereWithoutUserInput = {
  data: SystemAuditLogUpdateManyMutationInput;
  where: SystemAuditLogScalarWhereInput;
};

export type SystemAuditLogUpdateManyWithoutTeamNestedInput = {
  connect?: Maybe<Array<SystemAuditLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SystemAuditLogCreateOrConnectWithoutTeamInput>>;
  create?: Maybe<Array<SystemAuditLogCreateWithoutTeamInput>>;
  createMany?: Maybe<SystemAuditLogCreateManyTeamInputEnvelope>;
  delete?: Maybe<Array<SystemAuditLogWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SystemAuditLogScalarWhereInput>>;
  disconnect?: Maybe<Array<SystemAuditLogWhereUniqueInput>>;
  set?: Maybe<Array<SystemAuditLogWhereUniqueInput>>;
  update?: Maybe<Array<SystemAuditLogUpdateWithWhereUniqueWithoutTeamInput>>;
  updateMany?: Maybe<Array<SystemAuditLogUpdateManyWithWhereWithoutTeamInput>>;
  upsert?: Maybe<Array<SystemAuditLogUpsertWithWhereUniqueWithoutTeamInput>>;
};

export type SystemAuditLogUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<SystemAuditLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SystemAuditLogCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<SystemAuditLogCreateWithoutUserInput>>;
  createMany?: Maybe<SystemAuditLogCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<SystemAuditLogWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SystemAuditLogScalarWhereInput>>;
  disconnect?: Maybe<Array<SystemAuditLogWhereUniqueInput>>;
  set?: Maybe<Array<SystemAuditLogWhereUniqueInput>>;
  update?: Maybe<Array<SystemAuditLogUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<SystemAuditLogUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<SystemAuditLogUpsertWithWhereUniqueWithoutUserInput>>;
};

export type SystemAuditLogUpdateWithWhereUniqueWithoutTeamInput = {
  data: SystemAuditLogUpdateWithoutTeamInput;
  where: SystemAuditLogWhereUniqueInput;
};

export type SystemAuditLogUpdateWithWhereUniqueWithoutUserInput = {
  data: SystemAuditLogUpdateWithoutUserInput;
  where: SystemAuditLogWhereUniqueInput;
};

export type SystemAuditLogUpdateWithoutTeamInput = {
  User?: Maybe<CommonUserUpdateOneWithoutSystemAuditLogsNestedInput>;
  after?: Maybe<Scalars['Json']>;
  args?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  extraContext?: Maybe<Scalars['Json']>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  operation?: Maybe<StringFieldUpdateOperationsInput>;
  primaryKey?: Maybe<NullableStringFieldUpdateOperationsInput>;
  table?: Maybe<StringFieldUpdateOperationsInput>;
};

export type SystemAuditLogUpdateWithoutUserInput = {
  Team?: Maybe<TeamUpdateOneWithoutSystemAuditLogsNestedInput>;
  after?: Maybe<Scalars['Json']>;
  args?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  extraContext?: Maybe<Scalars['Json']>;
  id?: Maybe<StringFieldUpdateOperationsInput>;
  operation?: Maybe<StringFieldUpdateOperationsInput>;
  primaryKey?: Maybe<NullableStringFieldUpdateOperationsInput>;
  table?: Maybe<StringFieldUpdateOperationsInput>;
};

export type SystemAuditLogUpsertWithWhereUniqueWithoutTeamInput = {
  create: SystemAuditLogCreateWithoutTeamInput;
  update: SystemAuditLogUpdateWithoutTeamInput;
  where: SystemAuditLogWhereUniqueInput;
};

export type SystemAuditLogUpsertWithWhereUniqueWithoutUserInput = {
  create: SystemAuditLogCreateWithoutUserInput;
  update: SystemAuditLogUpdateWithoutUserInput;
  where: SystemAuditLogWhereUniqueInput;
};

export type SystemAuditLogWhereInput = {
  AND?: Maybe<Array<SystemAuditLogWhereInput>>;
  NOT?: Maybe<Array<SystemAuditLogWhereInput>>;
  OR?: Maybe<Array<SystemAuditLogWhereInput>>;
  Team?: Maybe<TeamWhereInput>;
  User?: Maybe<CommonUserWhereInput>;
  after?: Maybe<JsonNullableFilter>;
  args?: Maybe<JsonNullableFilter>;
  commonUserId?: Maybe<IntNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  extraContext?: Maybe<JsonNullableFilter>;
  id?: Maybe<StringFilter>;
  operation?: Maybe<StringFilter>;
  primaryKey?: Maybe<StringNullableFilter>;
  table?: Maybe<StringFilter>;
  teamId?: Maybe<IntNullableFilter>;
};

export type SystemAuditLogWhereUniqueInput = {
  AND?: Maybe<Array<SystemAuditLogWhereInput>>;
  NOT?: Maybe<Array<SystemAuditLogWhereInput>>;
  OR?: Maybe<Array<SystemAuditLogWhereInput>>;
  Team?: Maybe<TeamWhereInput>;
  User?: Maybe<CommonUserWhereInput>;
  after?: Maybe<JsonNullableFilter>;
  args?: Maybe<JsonNullableFilter>;
  commonUserId?: Maybe<IntNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  extraContext?: Maybe<JsonNullableFilter>;
  id?: Maybe<Scalars['String']>;
  operation?: Maybe<StringFilter>;
  primaryKey?: Maybe<StringNullableFilter>;
  table?: Maybe<StringFilter>;
  teamId?: Maybe<IntNullableFilter>;
};

/** Version of Sign Assistant, ... */
export type SystemGlobalAlert = {
  __typename?: 'SystemGlobalAlert';
  SystemGlobalAlertUserDismisses: Array<SystemGlobalAlertUserDismiss>;
  actionTitle?: Maybe<Scalars['String']>;
  actionUrl?: Maybe<Scalars['String']>;
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  dismissonsCount: Scalars['Int'];
  forcedActionUrl?: Maybe<Scalars['String']>;
  forcedDescription: Scalars['String'];
  forcedTitle: Scalars['String'];
  id: Scalars['Int'];
  message?: Maybe<Scalars['String']>;
  myDismissonsCount: Scalars['Int'];
  /** SIGN_ASSISTANT_VERSION / Message */
  type: SystemGlobalAlertType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** 1.1.3 / "Novidades no Portal da Emissora" / "Sistema indisponível" / Title */
  value: Scalars['String'];
};


/** Version of Sign Assistant, ... */
export type SystemGlobalAlertSystemGlobalAlertUserDismissesArgs = {
  cursor?: Maybe<SystemGlobalAlertUserDismissWhereUniqueInput>;
  distinct?: Maybe<Array<SystemGlobalAlertUserDismissScalarFieldEnum>>;
  orderBy?: Maybe<Array<SystemGlobalAlertUserDismissOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SystemGlobalAlertUserDismissWhereInput>;
};

export type SystemGlobalAlertAvgOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
};

export type SystemGlobalAlertCountOrderByAggregateInput = {
  actionTitle?: Maybe<SortOrder>;
  actionUrl?: Maybe<SortOrder>;
  active?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  message?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export type SystemGlobalAlertCreateInput = {
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutSystemGlobalAlertInput>;
  actionTitle?: Maybe<Scalars['String']>;
  actionUrl?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  message?: Maybe<Scalars['String']>;
  type?: Maybe<SystemGlobalAlertType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value: Scalars['String'];
};

export type SystemGlobalAlertCreateManyInput = {
  actionTitle?: Maybe<Scalars['String']>;
  actionUrl?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  type?: Maybe<SystemGlobalAlertType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value: Scalars['String'];
};

export type SystemGlobalAlertCreateNestedOneWithoutSystemGlobalAlertUserDismissesInput = {
  connect?: Maybe<SystemGlobalAlertWhereUniqueInput>;
  connectOrCreate?: Maybe<SystemGlobalAlertCreateOrConnectWithoutSystemGlobalAlertUserDismissesInput>;
  create?: Maybe<SystemGlobalAlertCreateWithoutSystemGlobalAlertUserDismissesInput>;
};

export type SystemGlobalAlertCreateOrConnectWithoutSystemGlobalAlertUserDismissesInput = {
  create: SystemGlobalAlertCreateWithoutSystemGlobalAlertUserDismissesInput;
  where: SystemGlobalAlertWhereUniqueInput;
};

export type SystemGlobalAlertCreateWithoutSystemGlobalAlertUserDismissesInput = {
  actionTitle?: Maybe<Scalars['String']>;
  actionUrl?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  message?: Maybe<Scalars['String']>;
  type?: Maybe<SystemGlobalAlertType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value: Scalars['String'];
};

export type SystemGlobalAlertMaxOrderByAggregateInput = {
  actionTitle?: Maybe<SortOrder>;
  actionUrl?: Maybe<SortOrder>;
  active?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  message?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export type SystemGlobalAlertMinOrderByAggregateInput = {
  actionTitle?: Maybe<SortOrder>;
  actionUrl?: Maybe<SortOrder>;
  active?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  message?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export type SystemGlobalAlertOrderByWithAggregationInput = {
  _avg?: Maybe<SystemGlobalAlertAvgOrderByAggregateInput>;
  _count?: Maybe<SystemGlobalAlertCountOrderByAggregateInput>;
  _max?: Maybe<SystemGlobalAlertMaxOrderByAggregateInput>;
  _min?: Maybe<SystemGlobalAlertMinOrderByAggregateInput>;
  _sum?: Maybe<SystemGlobalAlertSumOrderByAggregateInput>;
  actionTitle?: Maybe<SortOrder>;
  actionUrl?: Maybe<SortOrder>;
  active?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  message?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export type SystemGlobalAlertOrderByWithRelationInput = {
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissOrderByRelationAggregateInput>;
  actionTitle?: Maybe<SortOrder>;
  actionUrl?: Maybe<SortOrder>;
  active?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  message?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export type SystemGlobalAlertRelationFilter = {
  is?: Maybe<SystemGlobalAlertWhereInput>;
  isNot?: Maybe<SystemGlobalAlertWhereInput>;
};

export enum SystemGlobalAlertScalarFieldEnum {
  ActionTitle = 'actionTitle',
  ActionUrl = 'actionUrl',
  Active = 'active',
  CreatedAt = 'createdAt',
  Id = 'id',
  Message = 'message',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  Value = 'value'
}

export type SystemGlobalAlertScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<SystemGlobalAlertScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<SystemGlobalAlertScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<SystemGlobalAlertScalarWhereWithAggregatesInput>>;
  actionTitle?: Maybe<StringNullableWithAggregatesFilter>;
  actionUrl?: Maybe<StringNullableWithAggregatesFilter>;
  active?: Maybe<BoolWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  message?: Maybe<StringNullableWithAggregatesFilter>;
  type?: Maybe<EnumSystemGlobalAlertTypeWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  value?: Maybe<StringWithAggregatesFilter>;
};

export type SystemGlobalAlertSumOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
};

export enum SystemGlobalAlertType {
  MessagePopup = 'MESSAGE_POPUP',
  MessageToast = 'MESSAGE_TOAST',
  SignAssistantVersion = 'SIGN_ASSISTANT_VERSION'
}

export type SystemGlobalAlertUpdateInput = {
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissUpdateManyWithoutSystemGlobalAlertNestedInput>;
  actionTitle?: Maybe<NullableStringFieldUpdateOperationsInput>;
  actionUrl?: Maybe<NullableStringFieldUpdateOperationsInput>;
  active?: Maybe<BoolFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  message?: Maybe<NullableStringFieldUpdateOperationsInput>;
  type?: Maybe<EnumSystemGlobalAlertTypeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  value?: Maybe<StringFieldUpdateOperationsInput>;
};

export type SystemGlobalAlertUpdateManyMutationInput = {
  actionTitle?: Maybe<NullableStringFieldUpdateOperationsInput>;
  actionUrl?: Maybe<NullableStringFieldUpdateOperationsInput>;
  active?: Maybe<BoolFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  message?: Maybe<NullableStringFieldUpdateOperationsInput>;
  type?: Maybe<EnumSystemGlobalAlertTypeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  value?: Maybe<StringFieldUpdateOperationsInput>;
};

export type SystemGlobalAlertUpdateOneRequiredWithoutSystemGlobalAlertUserDismissesNestedInput = {
  connect?: Maybe<SystemGlobalAlertWhereUniqueInput>;
  connectOrCreate?: Maybe<SystemGlobalAlertCreateOrConnectWithoutSystemGlobalAlertUserDismissesInput>;
  create?: Maybe<SystemGlobalAlertCreateWithoutSystemGlobalAlertUserDismissesInput>;
  update?: Maybe<SystemGlobalAlertUpdateToOneWithWhereWithoutSystemGlobalAlertUserDismissesInput>;
  upsert?: Maybe<SystemGlobalAlertUpsertWithoutSystemGlobalAlertUserDismissesInput>;
};

export type SystemGlobalAlertUpdateToOneWithWhereWithoutSystemGlobalAlertUserDismissesInput = {
  data: SystemGlobalAlertUpdateWithoutSystemGlobalAlertUserDismissesInput;
  where?: Maybe<SystemGlobalAlertWhereInput>;
};

export type SystemGlobalAlertUpdateWithoutSystemGlobalAlertUserDismissesInput = {
  actionTitle?: Maybe<NullableStringFieldUpdateOperationsInput>;
  actionUrl?: Maybe<NullableStringFieldUpdateOperationsInput>;
  active?: Maybe<BoolFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  message?: Maybe<NullableStringFieldUpdateOperationsInput>;
  type?: Maybe<EnumSystemGlobalAlertTypeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  value?: Maybe<StringFieldUpdateOperationsInput>;
};

export type SystemGlobalAlertUpsertWithoutSystemGlobalAlertUserDismissesInput = {
  create: SystemGlobalAlertCreateWithoutSystemGlobalAlertUserDismissesInput;
  update: SystemGlobalAlertUpdateWithoutSystemGlobalAlertUserDismissesInput;
  where?: Maybe<SystemGlobalAlertWhereInput>;
};

export type SystemGlobalAlertUserDismiss = {
  __typename?: 'SystemGlobalAlertUserDismiss';
  CommonUser: CommonUser;
  SystemGlobalAlert: SystemGlobalAlert;
  commonUserId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  systemGlobalAlertId: Scalars['Int'];
};

export type SystemGlobalAlertUserDismissAvgOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  systemGlobalAlertId?: Maybe<SortOrder>;
};

export type SystemGlobalAlertUserDismissCommonUserIdSystemGlobalAlertIdCompoundUniqueInput = {
  commonUserId: Scalars['Int'];
  systemGlobalAlertId: Scalars['Int'];
};

export type SystemGlobalAlertUserDismissCountOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  systemGlobalAlertId?: Maybe<SortOrder>;
};

export type SystemGlobalAlertUserDismissCreateInput = {
  CommonUser: CommonUserCreateNestedOneWithoutSystemGlobalAlertUserDismissesInput;
  SystemGlobalAlert: SystemGlobalAlertCreateNestedOneWithoutSystemGlobalAlertUserDismissesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type SystemGlobalAlertUserDismissCreateManyCommonUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  systemGlobalAlertId: Scalars['Int'];
};

export type SystemGlobalAlertUserDismissCreateManyCommonUserInputEnvelope = {
  data: Array<SystemGlobalAlertUserDismissCreateManyCommonUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type SystemGlobalAlertUserDismissCreateManyInput = {
  commonUserId: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  systemGlobalAlertId: Scalars['Int'];
};

export type SystemGlobalAlertUserDismissCreateManySystemGlobalAlertInput = {
  commonUserId: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type SystemGlobalAlertUserDismissCreateManySystemGlobalAlertInputEnvelope = {
  data: Array<SystemGlobalAlertUserDismissCreateManySystemGlobalAlertInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput = {
  connect?: Maybe<Array<SystemGlobalAlertUserDismissWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SystemGlobalAlertUserDismissCreateOrConnectWithoutCommonUserInput>>;
  create?: Maybe<Array<SystemGlobalAlertUserDismissCreateWithoutCommonUserInput>>;
  createMany?: Maybe<SystemGlobalAlertUserDismissCreateManyCommonUserInputEnvelope>;
};

export type SystemGlobalAlertUserDismissCreateNestedManyWithoutSystemGlobalAlertInput = {
  connect?: Maybe<Array<SystemGlobalAlertUserDismissWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SystemGlobalAlertUserDismissCreateOrConnectWithoutSystemGlobalAlertInput>>;
  create?: Maybe<Array<SystemGlobalAlertUserDismissCreateWithoutSystemGlobalAlertInput>>;
  createMany?: Maybe<SystemGlobalAlertUserDismissCreateManySystemGlobalAlertInputEnvelope>;
};

export type SystemGlobalAlertUserDismissCreateOrConnectWithoutCommonUserInput = {
  create: SystemGlobalAlertUserDismissCreateWithoutCommonUserInput;
  where: SystemGlobalAlertUserDismissWhereUniqueInput;
};

export type SystemGlobalAlertUserDismissCreateOrConnectWithoutSystemGlobalAlertInput = {
  create: SystemGlobalAlertUserDismissCreateWithoutSystemGlobalAlertInput;
  where: SystemGlobalAlertUserDismissWhereUniqueInput;
};

export type SystemGlobalAlertUserDismissCreateWithoutCommonUserInput = {
  SystemGlobalAlert: SystemGlobalAlertCreateNestedOneWithoutSystemGlobalAlertUserDismissesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type SystemGlobalAlertUserDismissCreateWithoutSystemGlobalAlertInput = {
  CommonUser: CommonUserCreateNestedOneWithoutSystemGlobalAlertUserDismissesInput;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type SystemGlobalAlertUserDismissListRelationFilter = {
  every?: Maybe<SystemGlobalAlertUserDismissWhereInput>;
  none?: Maybe<SystemGlobalAlertUserDismissWhereInput>;
  some?: Maybe<SystemGlobalAlertUserDismissWhereInput>;
};

export type SystemGlobalAlertUserDismissMaxOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  systemGlobalAlertId?: Maybe<SortOrder>;
};

export type SystemGlobalAlertUserDismissMinOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  systemGlobalAlertId?: Maybe<SortOrder>;
};

export type SystemGlobalAlertUserDismissOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type SystemGlobalAlertUserDismissOrderByWithAggregationInput = {
  _avg?: Maybe<SystemGlobalAlertUserDismissAvgOrderByAggregateInput>;
  _count?: Maybe<SystemGlobalAlertUserDismissCountOrderByAggregateInput>;
  _max?: Maybe<SystemGlobalAlertUserDismissMaxOrderByAggregateInput>;
  _min?: Maybe<SystemGlobalAlertUserDismissMinOrderByAggregateInput>;
  _sum?: Maybe<SystemGlobalAlertUserDismissSumOrderByAggregateInput>;
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  systemGlobalAlertId?: Maybe<SortOrder>;
};

export type SystemGlobalAlertUserDismissOrderByWithRelationInput = {
  CommonUser?: Maybe<CommonUserOrderByWithRelationInput>;
  SystemGlobalAlert?: Maybe<SystemGlobalAlertOrderByWithRelationInput>;
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  systemGlobalAlertId?: Maybe<SortOrder>;
};

export enum SystemGlobalAlertUserDismissScalarFieldEnum {
  CommonUserId = 'commonUserId',
  CreatedAt = 'createdAt',
  SystemGlobalAlertId = 'systemGlobalAlertId'
}

export type SystemGlobalAlertUserDismissScalarWhereInput = {
  AND?: Maybe<Array<SystemGlobalAlertUserDismissScalarWhereInput>>;
  NOT?: Maybe<Array<SystemGlobalAlertUserDismissScalarWhereInput>>;
  OR?: Maybe<Array<SystemGlobalAlertUserDismissScalarWhereInput>>;
  commonUserId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  systemGlobalAlertId?: Maybe<IntFilter>;
};

export type SystemGlobalAlertUserDismissScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<SystemGlobalAlertUserDismissScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<SystemGlobalAlertUserDismissScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<SystemGlobalAlertUserDismissScalarWhereWithAggregatesInput>>;
  commonUserId?: Maybe<IntWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  systemGlobalAlertId?: Maybe<IntWithAggregatesFilter>;
};

export type SystemGlobalAlertUserDismissSumOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  systemGlobalAlertId?: Maybe<SortOrder>;
};

export type SystemGlobalAlertUserDismissUpdateInput = {
  CommonUser?: Maybe<CommonUserUpdateOneRequiredWithoutSystemGlobalAlertUserDismissesNestedInput>;
  SystemGlobalAlert?: Maybe<SystemGlobalAlertUpdateOneRequiredWithoutSystemGlobalAlertUserDismissesNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type SystemGlobalAlertUserDismissUpdateManyMutationInput = {
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type SystemGlobalAlertUserDismissUpdateManyWithWhereWithoutCommonUserInput = {
  data: SystemGlobalAlertUserDismissUpdateManyMutationInput;
  where: SystemGlobalAlertUserDismissScalarWhereInput;
};

export type SystemGlobalAlertUserDismissUpdateManyWithWhereWithoutSystemGlobalAlertInput = {
  data: SystemGlobalAlertUserDismissUpdateManyMutationInput;
  where: SystemGlobalAlertUserDismissScalarWhereInput;
};

export type SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput = {
  connect?: Maybe<Array<SystemGlobalAlertUserDismissWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SystemGlobalAlertUserDismissCreateOrConnectWithoutCommonUserInput>>;
  create?: Maybe<Array<SystemGlobalAlertUserDismissCreateWithoutCommonUserInput>>;
  createMany?: Maybe<SystemGlobalAlertUserDismissCreateManyCommonUserInputEnvelope>;
  delete?: Maybe<Array<SystemGlobalAlertUserDismissWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SystemGlobalAlertUserDismissScalarWhereInput>>;
  disconnect?: Maybe<Array<SystemGlobalAlertUserDismissWhereUniqueInput>>;
  set?: Maybe<Array<SystemGlobalAlertUserDismissWhereUniqueInput>>;
  update?: Maybe<Array<SystemGlobalAlertUserDismissUpdateWithWhereUniqueWithoutCommonUserInput>>;
  updateMany?: Maybe<Array<SystemGlobalAlertUserDismissUpdateManyWithWhereWithoutCommonUserInput>>;
  upsert?: Maybe<Array<SystemGlobalAlertUserDismissUpsertWithWhereUniqueWithoutCommonUserInput>>;
};

export type SystemGlobalAlertUserDismissUpdateManyWithoutSystemGlobalAlertNestedInput = {
  connect?: Maybe<Array<SystemGlobalAlertUserDismissWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SystemGlobalAlertUserDismissCreateOrConnectWithoutSystemGlobalAlertInput>>;
  create?: Maybe<Array<SystemGlobalAlertUserDismissCreateWithoutSystemGlobalAlertInput>>;
  createMany?: Maybe<SystemGlobalAlertUserDismissCreateManySystemGlobalAlertInputEnvelope>;
  delete?: Maybe<Array<SystemGlobalAlertUserDismissWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SystemGlobalAlertUserDismissScalarWhereInput>>;
  disconnect?: Maybe<Array<SystemGlobalAlertUserDismissWhereUniqueInput>>;
  set?: Maybe<Array<SystemGlobalAlertUserDismissWhereUniqueInput>>;
  update?: Maybe<Array<SystemGlobalAlertUserDismissUpdateWithWhereUniqueWithoutSystemGlobalAlertInput>>;
  updateMany?: Maybe<Array<SystemGlobalAlertUserDismissUpdateManyWithWhereWithoutSystemGlobalAlertInput>>;
  upsert?: Maybe<Array<SystemGlobalAlertUserDismissUpsertWithWhereUniqueWithoutSystemGlobalAlertInput>>;
};

export type SystemGlobalAlertUserDismissUpdateWithWhereUniqueWithoutCommonUserInput = {
  data: SystemGlobalAlertUserDismissUpdateWithoutCommonUserInput;
  where: SystemGlobalAlertUserDismissWhereUniqueInput;
};

export type SystemGlobalAlertUserDismissUpdateWithWhereUniqueWithoutSystemGlobalAlertInput = {
  data: SystemGlobalAlertUserDismissUpdateWithoutSystemGlobalAlertInput;
  where: SystemGlobalAlertUserDismissWhereUniqueInput;
};

export type SystemGlobalAlertUserDismissUpdateWithoutCommonUserInput = {
  SystemGlobalAlert?: Maybe<SystemGlobalAlertUpdateOneRequiredWithoutSystemGlobalAlertUserDismissesNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type SystemGlobalAlertUserDismissUpdateWithoutSystemGlobalAlertInput = {
  CommonUser?: Maybe<CommonUserUpdateOneRequiredWithoutSystemGlobalAlertUserDismissesNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type SystemGlobalAlertUserDismissUpsertWithWhereUniqueWithoutCommonUserInput = {
  create: SystemGlobalAlertUserDismissCreateWithoutCommonUserInput;
  update: SystemGlobalAlertUserDismissUpdateWithoutCommonUserInput;
  where: SystemGlobalAlertUserDismissWhereUniqueInput;
};

export type SystemGlobalAlertUserDismissUpsertWithWhereUniqueWithoutSystemGlobalAlertInput = {
  create: SystemGlobalAlertUserDismissCreateWithoutSystemGlobalAlertInput;
  update: SystemGlobalAlertUserDismissUpdateWithoutSystemGlobalAlertInput;
  where: SystemGlobalAlertUserDismissWhereUniqueInput;
};

export type SystemGlobalAlertUserDismissWhereInput = {
  AND?: Maybe<Array<SystemGlobalAlertUserDismissWhereInput>>;
  CommonUser?: Maybe<CommonUserWhereInput>;
  NOT?: Maybe<Array<SystemGlobalAlertUserDismissWhereInput>>;
  OR?: Maybe<Array<SystemGlobalAlertUserDismissWhereInput>>;
  SystemGlobalAlert?: Maybe<SystemGlobalAlertWhereInput>;
  commonUserId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  systemGlobalAlertId?: Maybe<IntFilter>;
};

export type SystemGlobalAlertUserDismissWhereUniqueInput = {
  AND?: Maybe<Array<SystemGlobalAlertUserDismissWhereInput>>;
  CommonUser?: Maybe<CommonUserWhereInput>;
  NOT?: Maybe<Array<SystemGlobalAlertUserDismissWhereInput>>;
  OR?: Maybe<Array<SystemGlobalAlertUserDismissWhereInput>>;
  SystemGlobalAlert?: Maybe<SystemGlobalAlertWhereInput>;
  commonUserId?: Maybe<IntFilter>;
  commonUserId_systemGlobalAlertId?: Maybe<SystemGlobalAlertUserDismissCommonUserIdSystemGlobalAlertIdCompoundUniqueInput>;
  createdAt?: Maybe<DateTimeFilter>;
  systemGlobalAlertId?: Maybe<IntFilter>;
};

export type SystemGlobalAlertWhereInput = {
  AND?: Maybe<Array<SystemGlobalAlertWhereInput>>;
  NOT?: Maybe<Array<SystemGlobalAlertWhereInput>>;
  OR?: Maybe<Array<SystemGlobalAlertWhereInput>>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissListRelationFilter>;
  actionTitle?: Maybe<StringNullableFilter>;
  actionUrl?: Maybe<StringNullableFilter>;
  active?: Maybe<BoolFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  message?: Maybe<StringNullableFilter>;
  type?: Maybe<EnumSystemGlobalAlertTypeFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
  value?: Maybe<StringFilter>;
};

export type SystemGlobalAlertWhereUniqueInput = {
  AND?: Maybe<Array<SystemGlobalAlertWhereInput>>;
  NOT?: Maybe<Array<SystemGlobalAlertWhereInput>>;
  OR?: Maybe<Array<SystemGlobalAlertWhereInput>>;
  SystemGlobalAlertUserDismisses?: Maybe<SystemGlobalAlertUserDismissListRelationFilter>;
  actionTitle?: Maybe<StringNullableFilter>;
  actionUrl?: Maybe<StringNullableFilter>;
  active?: Maybe<BoolFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['Int']>;
  message?: Maybe<StringNullableFilter>;
  type?: Maybe<EnumSystemGlobalAlertTypeFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
  value?: Maybe<StringFilter>;
};

/** Deprecated */
export type SystemLog = {
  __typename?: 'SystemLog';
  User?: Maybe<CommonUser>;
  commonUserId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  /** ![PrismaJson.AnyJson] */
  data?: Maybe<Scalars['Json']>;
  id: Scalars['Int'];
  message?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SystemLogAvgOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type SystemLogCountOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  data?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  message?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SystemLogCreateInput = {
  User?: Maybe<CommonUserCreateNestedOneWithoutSystemLogInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['Json']>;
  message?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SystemLogCreateManyInput = {
  commonUserId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SystemLogCreateManyUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SystemLogCreateManyUserInputEnvelope = {
  data: Array<SystemLogCreateManyUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type SystemLogCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<SystemLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SystemLogCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<SystemLogCreateWithoutUserInput>>;
  createMany?: Maybe<SystemLogCreateManyUserInputEnvelope>;
};

export type SystemLogCreateOrConnectWithoutUserInput = {
  create: SystemLogCreateWithoutUserInput;
  where: SystemLogWhereUniqueInput;
};

export type SystemLogCreateWithoutUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['Json']>;
  message?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SystemLogListRelationFilter = {
  every?: Maybe<SystemLogWhereInput>;
  none?: Maybe<SystemLogWhereInput>;
  some?: Maybe<SystemLogWhereInput>;
};

export type SystemLogMaxOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  message?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SystemLogMinOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  message?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SystemLogOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type SystemLogOrderByWithAggregationInput = {
  _avg?: Maybe<SystemLogAvgOrderByAggregateInput>;
  _count?: Maybe<SystemLogCountOrderByAggregateInput>;
  _max?: Maybe<SystemLogMaxOrderByAggregateInput>;
  _min?: Maybe<SystemLogMinOrderByAggregateInput>;
  _sum?: Maybe<SystemLogSumOrderByAggregateInput>;
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  data?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  message?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SystemLogOrderByWithRelationInput = {
  User?: Maybe<CommonUserOrderByWithRelationInput>;
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  data?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  message?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum SystemLogScalarFieldEnum {
  CommonUserId = 'commonUserId',
  CreatedAt = 'createdAt',
  Data = 'data',
  Id = 'id',
  Message = 'message',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type SystemLogScalarWhereInput = {
  AND?: Maybe<Array<SystemLogScalarWhereInput>>;
  NOT?: Maybe<Array<SystemLogScalarWhereInput>>;
  OR?: Maybe<Array<SystemLogScalarWhereInput>>;
  commonUserId?: Maybe<IntNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  data?: Maybe<JsonNullableFilter>;
  id?: Maybe<IntFilter>;
  message?: Maybe<StringNullableFilter>;
  type?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
};

export type SystemLogScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<SystemLogScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<SystemLogScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<SystemLogScalarWhereWithAggregatesInput>>;
  commonUserId?: Maybe<IntNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  data?: Maybe<JsonNullableWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  message?: Maybe<StringNullableWithAggregatesFilter>;
  type?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
};

export type SystemLogSumOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type SystemLogUpdateInput = {
  User?: Maybe<CommonUserUpdateOneWithoutSystemLogNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  data?: Maybe<Scalars['Json']>;
  message?: Maybe<NullableStringFieldUpdateOperationsInput>;
  type?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type SystemLogUpdateManyMutationInput = {
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  data?: Maybe<Scalars['Json']>;
  message?: Maybe<NullableStringFieldUpdateOperationsInput>;
  type?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type SystemLogUpdateManyWithWhereWithoutUserInput = {
  data: SystemLogUpdateManyMutationInput;
  where: SystemLogScalarWhereInput;
};

export type SystemLogUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<SystemLogWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<SystemLogCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<SystemLogCreateWithoutUserInput>>;
  createMany?: Maybe<SystemLogCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<SystemLogWhereUniqueInput>>;
  deleteMany?: Maybe<Array<SystemLogScalarWhereInput>>;
  disconnect?: Maybe<Array<SystemLogWhereUniqueInput>>;
  set?: Maybe<Array<SystemLogWhereUniqueInput>>;
  update?: Maybe<Array<SystemLogUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<SystemLogUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<SystemLogUpsertWithWhereUniqueWithoutUserInput>>;
};

export type SystemLogUpdateWithWhereUniqueWithoutUserInput = {
  data: SystemLogUpdateWithoutUserInput;
  where: SystemLogWhereUniqueInput;
};

export type SystemLogUpdateWithoutUserInput = {
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  data?: Maybe<Scalars['Json']>;
  message?: Maybe<NullableStringFieldUpdateOperationsInput>;
  type?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type SystemLogUpsertWithWhereUniqueWithoutUserInput = {
  create: SystemLogCreateWithoutUserInput;
  update: SystemLogUpdateWithoutUserInput;
  where: SystemLogWhereUniqueInput;
};

export type SystemLogWhereInput = {
  AND?: Maybe<Array<SystemLogWhereInput>>;
  NOT?: Maybe<Array<SystemLogWhereInput>>;
  OR?: Maybe<Array<SystemLogWhereInput>>;
  User?: Maybe<CommonUserWhereInput>;
  commonUserId?: Maybe<IntNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  data?: Maybe<JsonNullableFilter>;
  id?: Maybe<IntFilter>;
  message?: Maybe<StringNullableFilter>;
  type?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
};

export type SystemLogWhereUniqueInput = {
  AND?: Maybe<Array<SystemLogWhereInput>>;
  NOT?: Maybe<Array<SystemLogWhereInput>>;
  OR?: Maybe<Array<SystemLogWhereInput>>;
  User?: Maybe<CommonUserWhereInput>;
  commonUserId?: Maybe<IntNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  data?: Maybe<JsonNullableFilter>;
  id?: Maybe<Scalars['Int']>;
  message?: Maybe<StringNullableFilter>;
  type?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
};

/** Institution */
export type Team = {
  __typename?: 'Team';
  ApiKey: Array<ApiKey>;
  BulkCertificateRecord: Array<BulkCertificateRecord>;
  CertificateBase: Array<CertificateBase>;
  CertificateTemplates: Array<CertificateTemplate>;
  DefaultSignatureInviteConfigurations: Array<DocumentBaseDefaultSignatureInviteConfiguration>;
  Documents: Array<DocumentBase>;
  EnabledInstitution?: Maybe<EnabledInstitution>;
  /** Must be created at first purchase (When its created, cannot choose "Trial" plan again) */
  FinancialTeamWallet?: Maybe<FinancialTeamWallet>;
  MainTeamOfMaintainer?: Maybe<Maintainer>;
  Maintainer?: Maybe<Maintainer>;
  Owner: CommonUser;
  Person: Array<Person>;
  ReusableFormData: Array<ReusableFormData>;
  ReusableFormDataCurriculum: Array<ReusableFormDataCurriculum>;
  SystemAuditLogs: Array<SystemAuditLog>;
  TeamEducationLevel: Array<TeamEducationLevel>;
  TeamMember: Array<TeamMember>;
  /** CNPJ from LedgerSign company of the user */
  cnpj?: Maybe<Scalars['String']>;
  commonUserId: Scalars['Int'];
  /** Salva se ao enviar convite, o documento deve ou não incluir o signerNode */
  configAddDocumentSignerNode: Scalars['Boolean'];
  /** contract's link */
  contract: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deactivationReason?: Maybe<Scalars['String']>;
  enabledInstitutionId?: Maybe<Scalars['Int']>;
  externalSignatureWebhookURL?: Maybe<Scalars['String']>;
  faviconBase64?: Maybe<Scalars['String']>;
  financialShouldCharge: Scalars['Boolean'];
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  isNSF: Scalars['Boolean'];
  issuedCount: Scalars['Int'];
  issuerData?: Maybe<Scalars['Json']>;
  /** Nome da instituição criado em String pra manter a tipagem do front enquanto só usamos o nome */
  issuerName?: Maybe<Scalars['String']>;
  lastActivityAt: Scalars['DateTime'];
  logoBase64?: Maybe<Scalars['String']>;
  maintainerId?: Maybe<Scalars['Int']>;
  memberCount: Scalars['Int'];
  observations: Scalars['String'];
  /** This name can be changed by the admin */
  placeholderName: Scalars['String'];
  /** Domínio da instituição caso utilizem o visualizador de diplomas */
  publicViewDegreeDomainPath?: Maybe<Scalars['String']>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<Scalars['String']>;
  publicViewInstitutionName?: Maybe<Scalars['String']>;
  /** Cor primária da instituição caso utilizem o visualizador de diplomas */
  publicViewPrimaryColor?: Maybe<Scalars['String']>;
  publicViewSchoolCurriculumDomainPath?: Maybe<Scalars['String']>;
  /** Cor secundária da instituição caso utilizem o visualizador de diplomas */
  publicViewSecondaryColor?: Maybe<Scalars['String']>;
  syncWithLedgerDoc: Scalars['Boolean'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  validateCertificateURL?: Maybe<Scalars['String']>;
};


/** Institution */
export type TeamApiKeyArgs = {
  cursor?: Maybe<ApiKeyWhereUniqueInput>;
  distinct?: Maybe<Array<ApiKeyScalarFieldEnum>>;
  orderBy?: Maybe<Array<ApiKeyOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ApiKeyWhereInput>;
};


/** Institution */
export type TeamBulkCertificateRecordArgs = {
  cursor?: Maybe<BulkCertificateRecordWhereUniqueInput>;
  distinct?: Maybe<Array<BulkCertificateRecordScalarFieldEnum>>;
  orderBy?: Maybe<Array<BulkCertificateRecordOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BulkCertificateRecordWhereInput>;
};


/** Institution */
export type TeamCertificateBaseArgs = {
  cursor?: Maybe<CertificateBaseWhereUniqueInput>;
  distinct?: Maybe<Array<CertificateBaseScalarFieldEnum>>;
  orderBy?: Maybe<Array<CertificateBaseOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CertificateBaseWhereInput>;
};


/** Institution */
export type TeamCertificateTemplatesArgs = {
  cursor?: Maybe<CertificateTemplateWhereUniqueInput>;
  distinct?: Maybe<Array<CertificateTemplateScalarFieldEnum>>;
  orderBy?: Maybe<Array<CertificateTemplateOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CertificateTemplateWhereInput>;
};


/** Institution */
export type TeamDefaultSignatureInviteConfigurationsArgs = {
  cursor?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>;
};


/** Institution */
export type TeamDocumentsArgs = {
  cursor?: Maybe<DocumentBaseWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseWhereInput>;
};


/** Institution */
export type TeamPersonArgs = {
  cursor?: Maybe<PersonWhereUniqueInput>;
  distinct?: Maybe<Array<PersonScalarFieldEnum>>;
  orderBy?: Maybe<Array<PersonOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PersonWhereInput>;
};


/** Institution */
export type TeamReusableFormDataArgs = {
  cursor?: Maybe<ReusableFormDataWhereUniqueInput>;
  distinct?: Maybe<Array<ReusableFormDataScalarFieldEnum>>;
  orderBy?: Maybe<Array<ReusableFormDataOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ReusableFormDataWhereInput>;
};


/** Institution */
export type TeamReusableFormDataCurriculumArgs = {
  cursor?: Maybe<ReusableFormDataCurriculumWhereUniqueInput>;
  distinct?: Maybe<Array<ReusableFormDataCurriculumScalarFieldEnum>>;
  orderBy?: Maybe<Array<ReusableFormDataCurriculumOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<ReusableFormDataCurriculumWhereInput>;
};


/** Institution */
export type TeamSystemAuditLogsArgs = {
  cursor?: Maybe<SystemAuditLogWhereUniqueInput>;
  distinct?: Maybe<Array<SystemAuditLogScalarFieldEnum>>;
  orderBy?: Maybe<Array<SystemAuditLogOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<SystemAuditLogWhereInput>;
};


/** Institution */
export type TeamTeamEducationLevelArgs = {
  cursor?: Maybe<TeamEducationLevelWhereUniqueInput>;
  distinct?: Maybe<Array<TeamEducationLevelScalarFieldEnum>>;
  orderBy?: Maybe<Array<TeamEducationLevelOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TeamEducationLevelWhereInput>;
};


/** Institution */
export type TeamTeamMemberArgs = {
  cursor?: Maybe<TeamMemberWhereUniqueInput>;
  distinct?: Maybe<Array<TeamMemberScalarFieldEnum>>;
  orderBy?: Maybe<Array<TeamMemberOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TeamMemberWhereInput>;
};

export type TeamAndPublicDocumentBaseType = {
  __typename?: 'TeamAndPublicDocumentBaseType';
  documentSeeType: Scalars['String'];
  team: Team;
  url: Scalars['String'];
};

export type TeamAvgOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  enabledInstitutionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  maintainerId?: Maybe<SortOrder>;
};

export type TeamCountOrderByAggregateInput = {
  cnpj?: Maybe<SortOrder>;
  commonUserId?: Maybe<SortOrder>;
  configAddDocumentSignerNode?: Maybe<SortOrder>;
  contract?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deactivationReason?: Maybe<SortOrder>;
  enabledInstitutionId?: Maybe<SortOrder>;
  externalSignatureWebhookURL?: Maybe<SortOrder>;
  faviconBase64?: Maybe<SortOrder>;
  financialShouldCharge?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isNSF?: Maybe<SortOrder>;
  lastActivityAt?: Maybe<SortOrder>;
  logoBase64?: Maybe<SortOrder>;
  maintainerId?: Maybe<SortOrder>;
  observations?: Maybe<SortOrder>;
  placeholderName?: Maybe<SortOrder>;
  publicViewDegreeDomainPath?: Maybe<SortOrder>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<SortOrder>;
  publicViewInstitutionName?: Maybe<SortOrder>;
  publicViewPrimaryColor?: Maybe<SortOrder>;
  publicViewSchoolCurriculumDomainPath?: Maybe<SortOrder>;
  publicViewSecondaryColor?: Maybe<SortOrder>;
  syncWithLedgerDoc?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  validateCertificateURL?: Maybe<SortOrder>;
};

export type TeamCreateInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  Documents?: Maybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: Maybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Maintainer?: Maybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  Person?: Maybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormData?: Maybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: Maybe<Scalars['String']>;
  configAddDocumentSignerNode?: Maybe<Scalars['Boolean']>;
  contract?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationReason?: Maybe<Scalars['String']>;
  externalSignatureWebhookURL?: Maybe<Scalars['String']>;
  faviconBase64?: Maybe<Scalars['String']>;
  financialShouldCharge?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isNSF?: Maybe<Scalars['Boolean']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  logoBase64?: Maybe<Scalars['String']>;
  observations?: Maybe<Scalars['String']>;
  placeholderName?: Maybe<Scalars['String']>;
  publicViewDegreeDomainPath?: Maybe<Scalars['String']>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<Scalars['String']>;
  publicViewInstitutionName?: Maybe<Scalars['String']>;
  publicViewPrimaryColor?: Maybe<Scalars['String']>;
  publicViewSchoolCurriculumDomainPath?: Maybe<Scalars['String']>;
  publicViewSecondaryColor?: Maybe<Scalars['String']>;
  syncWithLedgerDoc?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validateCertificateURL?: Maybe<Scalars['String']>;
};

export type TeamCreateManyInput = {
  cnpj?: Maybe<Scalars['String']>;
  commonUserId: Scalars['Int'];
  configAddDocumentSignerNode?: Maybe<Scalars['Boolean']>;
  contract?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationReason?: Maybe<Scalars['String']>;
  enabledInstitutionId?: Maybe<Scalars['Int']>;
  externalSignatureWebhookURL?: Maybe<Scalars['String']>;
  faviconBase64?: Maybe<Scalars['String']>;
  financialShouldCharge?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isNSF?: Maybe<Scalars['Boolean']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  logoBase64?: Maybe<Scalars['String']>;
  maintainerId?: Maybe<Scalars['Int']>;
  observations?: Maybe<Scalars['String']>;
  placeholderName?: Maybe<Scalars['String']>;
  publicViewDegreeDomainPath?: Maybe<Scalars['String']>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<Scalars['String']>;
  publicViewInstitutionName?: Maybe<Scalars['String']>;
  publicViewPrimaryColor?: Maybe<Scalars['String']>;
  publicViewSchoolCurriculumDomainPath?: Maybe<Scalars['String']>;
  publicViewSecondaryColor?: Maybe<Scalars['String']>;
  syncWithLedgerDoc?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validateCertificateURL?: Maybe<Scalars['String']>;
};

export type TeamCreateManyMaintainerInput = {
  cnpj?: Maybe<Scalars['String']>;
  commonUserId: Scalars['Int'];
  configAddDocumentSignerNode?: Maybe<Scalars['Boolean']>;
  contract?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationReason?: Maybe<Scalars['String']>;
  enabledInstitutionId?: Maybe<Scalars['Int']>;
  externalSignatureWebhookURL?: Maybe<Scalars['String']>;
  faviconBase64?: Maybe<Scalars['String']>;
  financialShouldCharge?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isNSF?: Maybe<Scalars['Boolean']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  logoBase64?: Maybe<Scalars['String']>;
  observations?: Maybe<Scalars['String']>;
  placeholderName?: Maybe<Scalars['String']>;
  publicViewDegreeDomainPath?: Maybe<Scalars['String']>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<Scalars['String']>;
  publicViewInstitutionName?: Maybe<Scalars['String']>;
  publicViewPrimaryColor?: Maybe<Scalars['String']>;
  publicViewSchoolCurriculumDomainPath?: Maybe<Scalars['String']>;
  publicViewSecondaryColor?: Maybe<Scalars['String']>;
  syncWithLedgerDoc?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validateCertificateURL?: Maybe<Scalars['String']>;
};

export type TeamCreateManyMaintainerInputEnvelope = {
  data: Array<TeamCreateManyMaintainerInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type TeamCreateManyOwnerInput = {
  cnpj?: Maybe<Scalars['String']>;
  configAddDocumentSignerNode?: Maybe<Scalars['Boolean']>;
  contract?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationReason?: Maybe<Scalars['String']>;
  enabledInstitutionId?: Maybe<Scalars['Int']>;
  externalSignatureWebhookURL?: Maybe<Scalars['String']>;
  faviconBase64?: Maybe<Scalars['String']>;
  financialShouldCharge?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isNSF?: Maybe<Scalars['Boolean']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  logoBase64?: Maybe<Scalars['String']>;
  maintainerId?: Maybe<Scalars['Int']>;
  observations?: Maybe<Scalars['String']>;
  placeholderName?: Maybe<Scalars['String']>;
  publicViewDegreeDomainPath?: Maybe<Scalars['String']>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<Scalars['String']>;
  publicViewInstitutionName?: Maybe<Scalars['String']>;
  publicViewPrimaryColor?: Maybe<Scalars['String']>;
  publicViewSchoolCurriculumDomainPath?: Maybe<Scalars['String']>;
  publicViewSecondaryColor?: Maybe<Scalars['String']>;
  syncWithLedgerDoc?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validateCertificateURL?: Maybe<Scalars['String']>;
};

export type TeamCreateManyOwnerInputEnvelope = {
  data: Array<TeamCreateManyOwnerInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type TeamCreateNestedManyWithoutMaintainerInput = {
  connect?: Maybe<Array<TeamWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TeamCreateOrConnectWithoutMaintainerInput>>;
  create?: Maybe<Array<TeamCreateWithoutMaintainerInput>>;
  createMany?: Maybe<TeamCreateManyMaintainerInputEnvelope>;
};

export type TeamCreateNestedManyWithoutOwnerInput = {
  connect?: Maybe<Array<TeamWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TeamCreateOrConnectWithoutOwnerInput>>;
  create?: Maybe<Array<TeamCreateWithoutOwnerInput>>;
  createMany?: Maybe<TeamCreateManyOwnerInputEnvelope>;
};

export type TeamCreateNestedOneWithoutApiKeyInput = {
  connect?: Maybe<TeamWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamCreateOrConnectWithoutApiKeyInput>;
  create?: Maybe<TeamCreateWithoutApiKeyInput>;
};

export type TeamCreateNestedOneWithoutBulkCertificateRecordInput = {
  connect?: Maybe<TeamWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamCreateOrConnectWithoutBulkCertificateRecordInput>;
  create?: Maybe<TeamCreateWithoutBulkCertificateRecordInput>;
};

export type TeamCreateNestedOneWithoutCertificateBaseInput = {
  connect?: Maybe<TeamWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamCreateOrConnectWithoutCertificateBaseInput>;
  create?: Maybe<TeamCreateWithoutCertificateBaseInput>;
};

export type TeamCreateNestedOneWithoutCertificateTemplatesInput = {
  connect?: Maybe<TeamWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamCreateOrConnectWithoutCertificateTemplatesInput>;
  create?: Maybe<TeamCreateWithoutCertificateTemplatesInput>;
};

export type TeamCreateNestedOneWithoutDefaultSignatureInviteConfigurationsInput = {
  connect?: Maybe<TeamWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamCreateOrConnectWithoutDefaultSignatureInviteConfigurationsInput>;
  create?: Maybe<TeamCreateWithoutDefaultSignatureInviteConfigurationsInput>;
};

export type TeamCreateNestedOneWithoutDocumentsInput = {
  connect?: Maybe<TeamWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamCreateOrConnectWithoutDocumentsInput>;
  create?: Maybe<TeamCreateWithoutDocumentsInput>;
};

export type TeamCreateNestedOneWithoutEnabledInstitutionInput = {
  connect?: Maybe<TeamWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamCreateOrConnectWithoutEnabledInstitutionInput>;
  create?: Maybe<TeamCreateWithoutEnabledInstitutionInput>;
};

export type TeamCreateNestedOneWithoutFinancialTeamWalletInput = {
  connect?: Maybe<TeamWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamCreateOrConnectWithoutFinancialTeamWalletInput>;
  create?: Maybe<TeamCreateWithoutFinancialTeamWalletInput>;
};

export type TeamCreateNestedOneWithoutMainTeamOfMaintainerInput = {
  connect?: Maybe<TeamWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamCreateOrConnectWithoutMainTeamOfMaintainerInput>;
  create?: Maybe<TeamCreateWithoutMainTeamOfMaintainerInput>;
};

export type TeamCreateNestedOneWithoutPersonInput = {
  connect?: Maybe<TeamWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamCreateOrConnectWithoutPersonInput>;
  create?: Maybe<TeamCreateWithoutPersonInput>;
};

export type TeamCreateNestedOneWithoutReusableFormDataCurriculumInput = {
  connect?: Maybe<TeamWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamCreateOrConnectWithoutReusableFormDataCurriculumInput>;
  create?: Maybe<TeamCreateWithoutReusableFormDataCurriculumInput>;
};

export type TeamCreateNestedOneWithoutReusableFormDataInput = {
  connect?: Maybe<TeamWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamCreateOrConnectWithoutReusableFormDataInput>;
  create?: Maybe<TeamCreateWithoutReusableFormDataInput>;
};

export type TeamCreateNestedOneWithoutSystemAuditLogsInput = {
  connect?: Maybe<TeamWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamCreateOrConnectWithoutSystemAuditLogsInput>;
  create?: Maybe<TeamCreateWithoutSystemAuditLogsInput>;
};

export type TeamCreateNestedOneWithoutTeamEducationLevelInput = {
  connect?: Maybe<TeamWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamCreateOrConnectWithoutTeamEducationLevelInput>;
  create?: Maybe<TeamCreateWithoutTeamEducationLevelInput>;
};

export type TeamCreateNestedOneWithoutTeamMemberInput = {
  connect?: Maybe<TeamWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamCreateOrConnectWithoutTeamMemberInput>;
  create?: Maybe<TeamCreateWithoutTeamMemberInput>;
};

export type TeamCreateOrConnectWithoutApiKeyInput = {
  create: TeamCreateWithoutApiKeyInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateOrConnectWithoutBulkCertificateRecordInput = {
  create: TeamCreateWithoutBulkCertificateRecordInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateOrConnectWithoutCertificateBaseInput = {
  create: TeamCreateWithoutCertificateBaseInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateOrConnectWithoutCertificateTemplatesInput = {
  create: TeamCreateWithoutCertificateTemplatesInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateOrConnectWithoutDefaultSignatureInviteConfigurationsInput = {
  create: TeamCreateWithoutDefaultSignatureInviteConfigurationsInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateOrConnectWithoutDocumentsInput = {
  create: TeamCreateWithoutDocumentsInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateOrConnectWithoutEnabledInstitutionInput = {
  create: TeamCreateWithoutEnabledInstitutionInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateOrConnectWithoutFinancialTeamWalletInput = {
  create: TeamCreateWithoutFinancialTeamWalletInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateOrConnectWithoutMainTeamOfMaintainerInput = {
  create: TeamCreateWithoutMainTeamOfMaintainerInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateOrConnectWithoutMaintainerInput = {
  create: TeamCreateWithoutMaintainerInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateOrConnectWithoutOwnerInput = {
  create: TeamCreateWithoutOwnerInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateOrConnectWithoutPersonInput = {
  create: TeamCreateWithoutPersonInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateOrConnectWithoutReusableFormDataCurriculumInput = {
  create: TeamCreateWithoutReusableFormDataCurriculumInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateOrConnectWithoutReusableFormDataInput = {
  create: TeamCreateWithoutReusableFormDataInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateOrConnectWithoutSystemAuditLogsInput = {
  create: TeamCreateWithoutSystemAuditLogsInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateOrConnectWithoutTeamEducationLevelInput = {
  create: TeamCreateWithoutTeamEducationLevelInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateOrConnectWithoutTeamMemberInput = {
  create: TeamCreateWithoutTeamMemberInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateWithoutApiKeyInput = {
  BulkCertificateRecord?: Maybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  Documents?: Maybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: Maybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Maintainer?: Maybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  Person?: Maybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormData?: Maybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: Maybe<Scalars['String']>;
  configAddDocumentSignerNode?: Maybe<Scalars['Boolean']>;
  contract?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationReason?: Maybe<Scalars['String']>;
  externalSignatureWebhookURL?: Maybe<Scalars['String']>;
  faviconBase64?: Maybe<Scalars['String']>;
  financialShouldCharge?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isNSF?: Maybe<Scalars['Boolean']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  logoBase64?: Maybe<Scalars['String']>;
  observations?: Maybe<Scalars['String']>;
  placeholderName?: Maybe<Scalars['String']>;
  publicViewDegreeDomainPath?: Maybe<Scalars['String']>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<Scalars['String']>;
  publicViewInstitutionName?: Maybe<Scalars['String']>;
  publicViewPrimaryColor?: Maybe<Scalars['String']>;
  publicViewSchoolCurriculumDomainPath?: Maybe<Scalars['String']>;
  publicViewSecondaryColor?: Maybe<Scalars['String']>;
  syncWithLedgerDoc?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validateCertificateURL?: Maybe<Scalars['String']>;
};

export type TeamCreateWithoutBulkCertificateRecordInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  Documents?: Maybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: Maybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Maintainer?: Maybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  Person?: Maybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormData?: Maybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: Maybe<Scalars['String']>;
  configAddDocumentSignerNode?: Maybe<Scalars['Boolean']>;
  contract?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationReason?: Maybe<Scalars['String']>;
  externalSignatureWebhookURL?: Maybe<Scalars['String']>;
  faviconBase64?: Maybe<Scalars['String']>;
  financialShouldCharge?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isNSF?: Maybe<Scalars['Boolean']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  logoBase64?: Maybe<Scalars['String']>;
  observations?: Maybe<Scalars['String']>;
  placeholderName?: Maybe<Scalars['String']>;
  publicViewDegreeDomainPath?: Maybe<Scalars['String']>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<Scalars['String']>;
  publicViewInstitutionName?: Maybe<Scalars['String']>;
  publicViewPrimaryColor?: Maybe<Scalars['String']>;
  publicViewSchoolCurriculumDomainPath?: Maybe<Scalars['String']>;
  publicViewSecondaryColor?: Maybe<Scalars['String']>;
  syncWithLedgerDoc?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validateCertificateURL?: Maybe<Scalars['String']>;
};

export type TeamCreateWithoutCertificateBaseInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  Documents?: Maybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: Maybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Maintainer?: Maybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  Person?: Maybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormData?: Maybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: Maybe<Scalars['String']>;
  configAddDocumentSignerNode?: Maybe<Scalars['Boolean']>;
  contract?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationReason?: Maybe<Scalars['String']>;
  externalSignatureWebhookURL?: Maybe<Scalars['String']>;
  faviconBase64?: Maybe<Scalars['String']>;
  financialShouldCharge?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isNSF?: Maybe<Scalars['Boolean']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  logoBase64?: Maybe<Scalars['String']>;
  observations?: Maybe<Scalars['String']>;
  placeholderName?: Maybe<Scalars['String']>;
  publicViewDegreeDomainPath?: Maybe<Scalars['String']>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<Scalars['String']>;
  publicViewInstitutionName?: Maybe<Scalars['String']>;
  publicViewPrimaryColor?: Maybe<Scalars['String']>;
  publicViewSchoolCurriculumDomainPath?: Maybe<Scalars['String']>;
  publicViewSecondaryColor?: Maybe<Scalars['String']>;
  syncWithLedgerDoc?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validateCertificateURL?: Maybe<Scalars['String']>;
};

export type TeamCreateWithoutCertificateTemplatesInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  Documents?: Maybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: Maybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Maintainer?: Maybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  Person?: Maybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormData?: Maybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: Maybe<Scalars['String']>;
  configAddDocumentSignerNode?: Maybe<Scalars['Boolean']>;
  contract?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationReason?: Maybe<Scalars['String']>;
  externalSignatureWebhookURL?: Maybe<Scalars['String']>;
  faviconBase64?: Maybe<Scalars['String']>;
  financialShouldCharge?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isNSF?: Maybe<Scalars['Boolean']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  logoBase64?: Maybe<Scalars['String']>;
  observations?: Maybe<Scalars['String']>;
  placeholderName?: Maybe<Scalars['String']>;
  publicViewDegreeDomainPath?: Maybe<Scalars['String']>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<Scalars['String']>;
  publicViewInstitutionName?: Maybe<Scalars['String']>;
  publicViewPrimaryColor?: Maybe<Scalars['String']>;
  publicViewSchoolCurriculumDomainPath?: Maybe<Scalars['String']>;
  publicViewSecondaryColor?: Maybe<Scalars['String']>;
  syncWithLedgerDoc?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validateCertificateURL?: Maybe<Scalars['String']>;
};

export type TeamCreateWithoutDefaultSignatureInviteConfigurationsInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  Documents?: Maybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: Maybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Maintainer?: Maybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  Person?: Maybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormData?: Maybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: Maybe<Scalars['String']>;
  configAddDocumentSignerNode?: Maybe<Scalars['Boolean']>;
  contract?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationReason?: Maybe<Scalars['String']>;
  externalSignatureWebhookURL?: Maybe<Scalars['String']>;
  faviconBase64?: Maybe<Scalars['String']>;
  financialShouldCharge?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isNSF?: Maybe<Scalars['Boolean']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  logoBase64?: Maybe<Scalars['String']>;
  observations?: Maybe<Scalars['String']>;
  placeholderName?: Maybe<Scalars['String']>;
  publicViewDegreeDomainPath?: Maybe<Scalars['String']>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<Scalars['String']>;
  publicViewInstitutionName?: Maybe<Scalars['String']>;
  publicViewPrimaryColor?: Maybe<Scalars['String']>;
  publicViewSchoolCurriculumDomainPath?: Maybe<Scalars['String']>;
  publicViewSecondaryColor?: Maybe<Scalars['String']>;
  syncWithLedgerDoc?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validateCertificateURL?: Maybe<Scalars['String']>;
};

export type TeamCreateWithoutDocumentsInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: Maybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Maintainer?: Maybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  Person?: Maybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormData?: Maybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: Maybe<Scalars['String']>;
  configAddDocumentSignerNode?: Maybe<Scalars['Boolean']>;
  contract?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationReason?: Maybe<Scalars['String']>;
  externalSignatureWebhookURL?: Maybe<Scalars['String']>;
  faviconBase64?: Maybe<Scalars['String']>;
  financialShouldCharge?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isNSF?: Maybe<Scalars['Boolean']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  logoBase64?: Maybe<Scalars['String']>;
  observations?: Maybe<Scalars['String']>;
  placeholderName?: Maybe<Scalars['String']>;
  publicViewDegreeDomainPath?: Maybe<Scalars['String']>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<Scalars['String']>;
  publicViewInstitutionName?: Maybe<Scalars['String']>;
  publicViewPrimaryColor?: Maybe<Scalars['String']>;
  publicViewSchoolCurriculumDomainPath?: Maybe<Scalars['String']>;
  publicViewSecondaryColor?: Maybe<Scalars['String']>;
  syncWithLedgerDoc?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validateCertificateURL?: Maybe<Scalars['String']>;
};

export type TeamCreateWithoutEnabledInstitutionInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  Documents?: Maybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Maintainer?: Maybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  Person?: Maybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormData?: Maybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: Maybe<Scalars['String']>;
  configAddDocumentSignerNode?: Maybe<Scalars['Boolean']>;
  contract?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationReason?: Maybe<Scalars['String']>;
  externalSignatureWebhookURL?: Maybe<Scalars['String']>;
  faviconBase64?: Maybe<Scalars['String']>;
  financialShouldCharge?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isNSF?: Maybe<Scalars['Boolean']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  logoBase64?: Maybe<Scalars['String']>;
  observations?: Maybe<Scalars['String']>;
  placeholderName?: Maybe<Scalars['String']>;
  publicViewDegreeDomainPath?: Maybe<Scalars['String']>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<Scalars['String']>;
  publicViewInstitutionName?: Maybe<Scalars['String']>;
  publicViewPrimaryColor?: Maybe<Scalars['String']>;
  publicViewSchoolCurriculumDomainPath?: Maybe<Scalars['String']>;
  publicViewSecondaryColor?: Maybe<Scalars['String']>;
  syncWithLedgerDoc?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validateCertificateURL?: Maybe<Scalars['String']>;
};

export type TeamCreateWithoutFinancialTeamWalletInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  Documents?: Maybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: Maybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Maintainer?: Maybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  Person?: Maybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormData?: Maybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: Maybe<Scalars['String']>;
  configAddDocumentSignerNode?: Maybe<Scalars['Boolean']>;
  contract?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationReason?: Maybe<Scalars['String']>;
  externalSignatureWebhookURL?: Maybe<Scalars['String']>;
  faviconBase64?: Maybe<Scalars['String']>;
  financialShouldCharge?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isNSF?: Maybe<Scalars['Boolean']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  logoBase64?: Maybe<Scalars['String']>;
  observations?: Maybe<Scalars['String']>;
  placeholderName?: Maybe<Scalars['String']>;
  publicViewDegreeDomainPath?: Maybe<Scalars['String']>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<Scalars['String']>;
  publicViewInstitutionName?: Maybe<Scalars['String']>;
  publicViewPrimaryColor?: Maybe<Scalars['String']>;
  publicViewSchoolCurriculumDomainPath?: Maybe<Scalars['String']>;
  publicViewSecondaryColor?: Maybe<Scalars['String']>;
  syncWithLedgerDoc?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validateCertificateURL?: Maybe<Scalars['String']>;
};

export type TeamCreateWithoutMainTeamOfMaintainerInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  Documents?: Maybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: Maybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  Maintainer?: Maybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  Person?: Maybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormData?: Maybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: Maybe<Scalars['String']>;
  configAddDocumentSignerNode?: Maybe<Scalars['Boolean']>;
  contract?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationReason?: Maybe<Scalars['String']>;
  externalSignatureWebhookURL?: Maybe<Scalars['String']>;
  faviconBase64?: Maybe<Scalars['String']>;
  financialShouldCharge?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isNSF?: Maybe<Scalars['Boolean']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  logoBase64?: Maybe<Scalars['String']>;
  observations?: Maybe<Scalars['String']>;
  placeholderName?: Maybe<Scalars['String']>;
  publicViewDegreeDomainPath?: Maybe<Scalars['String']>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<Scalars['String']>;
  publicViewInstitutionName?: Maybe<Scalars['String']>;
  publicViewPrimaryColor?: Maybe<Scalars['String']>;
  publicViewSchoolCurriculumDomainPath?: Maybe<Scalars['String']>;
  publicViewSecondaryColor?: Maybe<Scalars['String']>;
  syncWithLedgerDoc?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validateCertificateURL?: Maybe<Scalars['String']>;
};

export type TeamCreateWithoutMaintainerInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  Documents?: Maybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: Maybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  Person?: Maybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormData?: Maybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: Maybe<Scalars['String']>;
  configAddDocumentSignerNode?: Maybe<Scalars['Boolean']>;
  contract?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationReason?: Maybe<Scalars['String']>;
  externalSignatureWebhookURL?: Maybe<Scalars['String']>;
  faviconBase64?: Maybe<Scalars['String']>;
  financialShouldCharge?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isNSF?: Maybe<Scalars['Boolean']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  logoBase64?: Maybe<Scalars['String']>;
  observations?: Maybe<Scalars['String']>;
  placeholderName?: Maybe<Scalars['String']>;
  publicViewDegreeDomainPath?: Maybe<Scalars['String']>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<Scalars['String']>;
  publicViewInstitutionName?: Maybe<Scalars['String']>;
  publicViewPrimaryColor?: Maybe<Scalars['String']>;
  publicViewSchoolCurriculumDomainPath?: Maybe<Scalars['String']>;
  publicViewSecondaryColor?: Maybe<Scalars['String']>;
  syncWithLedgerDoc?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validateCertificateURL?: Maybe<Scalars['String']>;
};

export type TeamCreateWithoutOwnerInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  Documents?: Maybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: Maybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Maintainer?: Maybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Person?: Maybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormData?: Maybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: Maybe<Scalars['String']>;
  configAddDocumentSignerNode?: Maybe<Scalars['Boolean']>;
  contract?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationReason?: Maybe<Scalars['String']>;
  externalSignatureWebhookURL?: Maybe<Scalars['String']>;
  faviconBase64?: Maybe<Scalars['String']>;
  financialShouldCharge?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isNSF?: Maybe<Scalars['Boolean']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  logoBase64?: Maybe<Scalars['String']>;
  observations?: Maybe<Scalars['String']>;
  placeholderName?: Maybe<Scalars['String']>;
  publicViewDegreeDomainPath?: Maybe<Scalars['String']>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<Scalars['String']>;
  publicViewInstitutionName?: Maybe<Scalars['String']>;
  publicViewPrimaryColor?: Maybe<Scalars['String']>;
  publicViewSchoolCurriculumDomainPath?: Maybe<Scalars['String']>;
  publicViewSecondaryColor?: Maybe<Scalars['String']>;
  syncWithLedgerDoc?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validateCertificateURL?: Maybe<Scalars['String']>;
};

export type TeamCreateWithoutPersonInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  Documents?: Maybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: Maybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Maintainer?: Maybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  ReusableFormData?: Maybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: Maybe<Scalars['String']>;
  configAddDocumentSignerNode?: Maybe<Scalars['Boolean']>;
  contract?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationReason?: Maybe<Scalars['String']>;
  externalSignatureWebhookURL?: Maybe<Scalars['String']>;
  faviconBase64?: Maybe<Scalars['String']>;
  financialShouldCharge?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isNSF?: Maybe<Scalars['Boolean']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  logoBase64?: Maybe<Scalars['String']>;
  observations?: Maybe<Scalars['String']>;
  placeholderName?: Maybe<Scalars['String']>;
  publicViewDegreeDomainPath?: Maybe<Scalars['String']>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<Scalars['String']>;
  publicViewInstitutionName?: Maybe<Scalars['String']>;
  publicViewPrimaryColor?: Maybe<Scalars['String']>;
  publicViewSchoolCurriculumDomainPath?: Maybe<Scalars['String']>;
  publicViewSecondaryColor?: Maybe<Scalars['String']>;
  syncWithLedgerDoc?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validateCertificateURL?: Maybe<Scalars['String']>;
};

export type TeamCreateWithoutReusableFormDataCurriculumInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  Documents?: Maybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: Maybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Maintainer?: Maybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  Person?: Maybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormData?: Maybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: Maybe<Scalars['String']>;
  configAddDocumentSignerNode?: Maybe<Scalars['Boolean']>;
  contract?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationReason?: Maybe<Scalars['String']>;
  externalSignatureWebhookURL?: Maybe<Scalars['String']>;
  faviconBase64?: Maybe<Scalars['String']>;
  financialShouldCharge?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isNSF?: Maybe<Scalars['Boolean']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  logoBase64?: Maybe<Scalars['String']>;
  observations?: Maybe<Scalars['String']>;
  placeholderName?: Maybe<Scalars['String']>;
  publicViewDegreeDomainPath?: Maybe<Scalars['String']>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<Scalars['String']>;
  publicViewInstitutionName?: Maybe<Scalars['String']>;
  publicViewPrimaryColor?: Maybe<Scalars['String']>;
  publicViewSchoolCurriculumDomainPath?: Maybe<Scalars['String']>;
  publicViewSecondaryColor?: Maybe<Scalars['String']>;
  syncWithLedgerDoc?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validateCertificateURL?: Maybe<Scalars['String']>;
};

export type TeamCreateWithoutReusableFormDataInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  Documents?: Maybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: Maybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Maintainer?: Maybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  Person?: Maybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: Maybe<Scalars['String']>;
  configAddDocumentSignerNode?: Maybe<Scalars['Boolean']>;
  contract?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationReason?: Maybe<Scalars['String']>;
  externalSignatureWebhookURL?: Maybe<Scalars['String']>;
  faviconBase64?: Maybe<Scalars['String']>;
  financialShouldCharge?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isNSF?: Maybe<Scalars['Boolean']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  logoBase64?: Maybe<Scalars['String']>;
  observations?: Maybe<Scalars['String']>;
  placeholderName?: Maybe<Scalars['String']>;
  publicViewDegreeDomainPath?: Maybe<Scalars['String']>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<Scalars['String']>;
  publicViewInstitutionName?: Maybe<Scalars['String']>;
  publicViewPrimaryColor?: Maybe<Scalars['String']>;
  publicViewSchoolCurriculumDomainPath?: Maybe<Scalars['String']>;
  publicViewSecondaryColor?: Maybe<Scalars['String']>;
  syncWithLedgerDoc?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validateCertificateURL?: Maybe<Scalars['String']>;
};

export type TeamCreateWithoutSystemAuditLogsInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  Documents?: Maybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: Maybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Maintainer?: Maybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  Person?: Maybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormData?: Maybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: Maybe<Scalars['String']>;
  configAddDocumentSignerNode?: Maybe<Scalars['Boolean']>;
  contract?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationReason?: Maybe<Scalars['String']>;
  externalSignatureWebhookURL?: Maybe<Scalars['String']>;
  faviconBase64?: Maybe<Scalars['String']>;
  financialShouldCharge?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isNSF?: Maybe<Scalars['Boolean']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  logoBase64?: Maybe<Scalars['String']>;
  observations?: Maybe<Scalars['String']>;
  placeholderName?: Maybe<Scalars['String']>;
  publicViewDegreeDomainPath?: Maybe<Scalars['String']>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<Scalars['String']>;
  publicViewInstitutionName?: Maybe<Scalars['String']>;
  publicViewPrimaryColor?: Maybe<Scalars['String']>;
  publicViewSchoolCurriculumDomainPath?: Maybe<Scalars['String']>;
  publicViewSecondaryColor?: Maybe<Scalars['String']>;
  syncWithLedgerDoc?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validateCertificateURL?: Maybe<Scalars['String']>;
};

export type TeamCreateWithoutTeamEducationLevelInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  Documents?: Maybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: Maybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Maintainer?: Maybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  Person?: Maybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormData?: Maybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamMember?: Maybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: Maybe<Scalars['String']>;
  configAddDocumentSignerNode?: Maybe<Scalars['Boolean']>;
  contract?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationReason?: Maybe<Scalars['String']>;
  externalSignatureWebhookURL?: Maybe<Scalars['String']>;
  faviconBase64?: Maybe<Scalars['String']>;
  financialShouldCharge?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isNSF?: Maybe<Scalars['Boolean']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  logoBase64?: Maybe<Scalars['String']>;
  observations?: Maybe<Scalars['String']>;
  placeholderName?: Maybe<Scalars['String']>;
  publicViewDegreeDomainPath?: Maybe<Scalars['String']>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<Scalars['String']>;
  publicViewInstitutionName?: Maybe<Scalars['String']>;
  publicViewPrimaryColor?: Maybe<Scalars['String']>;
  publicViewSchoolCurriculumDomainPath?: Maybe<Scalars['String']>;
  publicViewSecondaryColor?: Maybe<Scalars['String']>;
  syncWithLedgerDoc?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validateCertificateURL?: Maybe<Scalars['String']>;
};

export type TeamCreateWithoutTeamMemberInput = {
  ApiKey?: Maybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateBase?: Maybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: Maybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  Documents?: Maybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: Maybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Maintainer?: Maybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  Person?: Maybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormData?: Maybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  cnpj?: Maybe<Scalars['String']>;
  configAddDocumentSignerNode?: Maybe<Scalars['Boolean']>;
  contract?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deactivationReason?: Maybe<Scalars['String']>;
  externalSignatureWebhookURL?: Maybe<Scalars['String']>;
  faviconBase64?: Maybe<Scalars['String']>;
  financialShouldCharge?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isNSF?: Maybe<Scalars['Boolean']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  logoBase64?: Maybe<Scalars['String']>;
  observations?: Maybe<Scalars['String']>;
  placeholderName?: Maybe<Scalars['String']>;
  publicViewDegreeDomainPath?: Maybe<Scalars['String']>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<Scalars['String']>;
  publicViewInstitutionName?: Maybe<Scalars['String']>;
  publicViewPrimaryColor?: Maybe<Scalars['String']>;
  publicViewSchoolCurriculumDomainPath?: Maybe<Scalars['String']>;
  publicViewSecondaryColor?: Maybe<Scalars['String']>;
  syncWithLedgerDoc?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validateCertificateURL?: Maybe<Scalars['String']>;
};

export type TeamEducationLevel = {
  __typename?: 'TeamEducationLevel';
  DocumentCertificate: Array<DocumentCertificate>;
  createdAt: Scalars['DateTime'];
  educationLevelType: EducationLevelType;
  id: Scalars['Int'];
  team: Team;
  teamId: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type TeamEducationLevelDocumentCertificateArgs = {
  cursor?: Maybe<DocumentCertificateWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentCertificateScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentCertificateOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentCertificateWhereInput>;
};

export type TeamEducationLevelAvgOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type TeamEducationLevelCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  educationLevelType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TeamEducationLevelCreateInput = {
  DocumentCertificate?: Maybe<DocumentCertificateCreateNestedManyWithoutTeamEducationLevelInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  educationLevelType?: Maybe<EducationLevelType>;
  team: TeamCreateNestedOneWithoutTeamEducationLevelInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TeamEducationLevelCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  educationLevelType?: Maybe<EducationLevelType>;
  id?: Maybe<Scalars['Int']>;
  teamId: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TeamEducationLevelCreateManyTeamInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  educationLevelType?: Maybe<EducationLevelType>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TeamEducationLevelCreateManyTeamInputEnvelope = {
  data: Array<TeamEducationLevelCreateManyTeamInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type TeamEducationLevelCreateNestedManyWithoutTeamInput = {
  connect?: Maybe<Array<TeamEducationLevelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TeamEducationLevelCreateOrConnectWithoutTeamInput>>;
  create?: Maybe<Array<TeamEducationLevelCreateWithoutTeamInput>>;
  createMany?: Maybe<TeamEducationLevelCreateManyTeamInputEnvelope>;
};

export type TeamEducationLevelCreateNestedOneWithoutDocumentCertificateInput = {
  connect?: Maybe<TeamEducationLevelWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamEducationLevelCreateOrConnectWithoutDocumentCertificateInput>;
  create?: Maybe<TeamEducationLevelCreateWithoutDocumentCertificateInput>;
};

export type TeamEducationLevelCreateOrConnectWithoutDocumentCertificateInput = {
  create: TeamEducationLevelCreateWithoutDocumentCertificateInput;
  where: TeamEducationLevelWhereUniqueInput;
};

export type TeamEducationLevelCreateOrConnectWithoutTeamInput = {
  create: TeamEducationLevelCreateWithoutTeamInput;
  where: TeamEducationLevelWhereUniqueInput;
};

export type TeamEducationLevelCreateWithoutDocumentCertificateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  educationLevelType?: Maybe<EducationLevelType>;
  team: TeamCreateNestedOneWithoutTeamEducationLevelInput;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TeamEducationLevelCreateWithoutTeamInput = {
  DocumentCertificate?: Maybe<DocumentCertificateCreateNestedManyWithoutTeamEducationLevelInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  educationLevelType?: Maybe<EducationLevelType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TeamEducationLevelListRelationFilter = {
  every?: Maybe<TeamEducationLevelWhereInput>;
  none?: Maybe<TeamEducationLevelWhereInput>;
  some?: Maybe<TeamEducationLevelWhereInput>;
};

export type TeamEducationLevelMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  educationLevelType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TeamEducationLevelMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  educationLevelType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TeamEducationLevelOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type TeamEducationLevelOrderByWithAggregationInput = {
  _avg?: Maybe<TeamEducationLevelAvgOrderByAggregateInput>;
  _count?: Maybe<TeamEducationLevelCountOrderByAggregateInput>;
  _max?: Maybe<TeamEducationLevelMaxOrderByAggregateInput>;
  _min?: Maybe<TeamEducationLevelMinOrderByAggregateInput>;
  _sum?: Maybe<TeamEducationLevelSumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  educationLevelType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TeamEducationLevelOrderByWithRelationInput = {
  DocumentCertificate?: Maybe<DocumentCertificateOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  educationLevelType?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  team?: Maybe<TeamOrderByWithRelationInput>;
  teamId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TeamEducationLevelRelationFilter = {
  is?: Maybe<TeamEducationLevelWhereInput>;
  isNot?: Maybe<TeamEducationLevelWhereInput>;
};

export enum TeamEducationLevelScalarFieldEnum {
  CreatedAt = 'createdAt',
  EducationLevelType = 'educationLevelType',
  Id = 'id',
  TeamId = 'teamId',
  UpdatedAt = 'updatedAt'
}

export type TeamEducationLevelScalarWhereInput = {
  AND?: Maybe<Array<TeamEducationLevelScalarWhereInput>>;
  NOT?: Maybe<Array<TeamEducationLevelScalarWhereInput>>;
  OR?: Maybe<Array<TeamEducationLevelScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  educationLevelType?: Maybe<EnumEducationLevelTypeFilter>;
  id?: Maybe<IntFilter>;
  teamId?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
};

export type TeamEducationLevelScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<TeamEducationLevelScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<TeamEducationLevelScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<TeamEducationLevelScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  educationLevelType?: Maybe<EnumEducationLevelTypeWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  teamId?: Maybe<IntWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
};

export type TeamEducationLevelSumOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type TeamEducationLevelTeamIdEducationLevelTypeCompoundUniqueInput = {
  educationLevelType: EducationLevelType;
  teamId: Scalars['Int'];
};

export type TeamEducationLevelUpdateInput = {
  DocumentCertificate?: Maybe<DocumentCertificateUpdateManyWithoutTeamEducationLevelNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  educationLevelType?: Maybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  team?: Maybe<TeamUpdateOneRequiredWithoutTeamEducationLevelNestedInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TeamEducationLevelUpdateManyMutationInput = {
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  educationLevelType?: Maybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TeamEducationLevelUpdateManyWithWhereWithoutTeamInput = {
  data: TeamEducationLevelUpdateManyMutationInput;
  where: TeamEducationLevelScalarWhereInput;
};

export type TeamEducationLevelUpdateManyWithoutTeamNestedInput = {
  connect?: Maybe<Array<TeamEducationLevelWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TeamEducationLevelCreateOrConnectWithoutTeamInput>>;
  create?: Maybe<Array<TeamEducationLevelCreateWithoutTeamInput>>;
  createMany?: Maybe<TeamEducationLevelCreateManyTeamInputEnvelope>;
  delete?: Maybe<Array<TeamEducationLevelWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TeamEducationLevelScalarWhereInput>>;
  disconnect?: Maybe<Array<TeamEducationLevelWhereUniqueInput>>;
  set?: Maybe<Array<TeamEducationLevelWhereUniqueInput>>;
  update?: Maybe<Array<TeamEducationLevelUpdateWithWhereUniqueWithoutTeamInput>>;
  updateMany?: Maybe<Array<TeamEducationLevelUpdateManyWithWhereWithoutTeamInput>>;
  upsert?: Maybe<Array<TeamEducationLevelUpsertWithWhereUniqueWithoutTeamInput>>;
};

export type TeamEducationLevelUpdateOneRequiredWithoutDocumentCertificateNestedInput = {
  connect?: Maybe<TeamEducationLevelWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamEducationLevelCreateOrConnectWithoutDocumentCertificateInput>;
  create?: Maybe<TeamEducationLevelCreateWithoutDocumentCertificateInput>;
  update?: Maybe<TeamEducationLevelUpdateToOneWithWhereWithoutDocumentCertificateInput>;
  upsert?: Maybe<TeamEducationLevelUpsertWithoutDocumentCertificateInput>;
};

export type TeamEducationLevelUpdateToOneWithWhereWithoutDocumentCertificateInput = {
  data: TeamEducationLevelUpdateWithoutDocumentCertificateInput;
  where?: Maybe<TeamEducationLevelWhereInput>;
};

export type TeamEducationLevelUpdateWithWhereUniqueWithoutTeamInput = {
  data: TeamEducationLevelUpdateWithoutTeamInput;
  where: TeamEducationLevelWhereUniqueInput;
};

export type TeamEducationLevelUpdateWithoutDocumentCertificateInput = {
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  educationLevelType?: Maybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  team?: Maybe<TeamUpdateOneRequiredWithoutTeamEducationLevelNestedInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TeamEducationLevelUpdateWithoutTeamInput = {
  DocumentCertificate?: Maybe<DocumentCertificateUpdateManyWithoutTeamEducationLevelNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  educationLevelType?: Maybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TeamEducationLevelUpsertWithWhereUniqueWithoutTeamInput = {
  create: TeamEducationLevelCreateWithoutTeamInput;
  update: TeamEducationLevelUpdateWithoutTeamInput;
  where: TeamEducationLevelWhereUniqueInput;
};

export type TeamEducationLevelUpsertWithoutDocumentCertificateInput = {
  create: TeamEducationLevelCreateWithoutDocumentCertificateInput;
  update: TeamEducationLevelUpdateWithoutDocumentCertificateInput;
  where?: Maybe<TeamEducationLevelWhereInput>;
};

export type TeamEducationLevelWhereInput = {
  AND?: Maybe<Array<TeamEducationLevelWhereInput>>;
  DocumentCertificate?: Maybe<DocumentCertificateListRelationFilter>;
  NOT?: Maybe<Array<TeamEducationLevelWhereInput>>;
  OR?: Maybe<Array<TeamEducationLevelWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  educationLevelType?: Maybe<EnumEducationLevelTypeFilter>;
  id?: Maybe<IntFilter>;
  team?: Maybe<TeamWhereInput>;
  teamId?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
};

export type TeamEducationLevelWhereUniqueInput = {
  AND?: Maybe<Array<TeamEducationLevelWhereInput>>;
  DocumentCertificate?: Maybe<DocumentCertificateListRelationFilter>;
  NOT?: Maybe<Array<TeamEducationLevelWhereInput>>;
  OR?: Maybe<Array<TeamEducationLevelWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  educationLevelType?: Maybe<EnumEducationLevelTypeFilter>;
  id?: Maybe<Scalars['Int']>;
  team?: Maybe<TeamWhereInput>;
  teamId?: Maybe<IntFilter>;
  teamId_educationLevelType?: Maybe<TeamEducationLevelTeamIdEducationLevelTypeCompoundUniqueInput>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
};

export type TeamListRelationFilter = {
  every?: Maybe<TeamWhereInput>;
  none?: Maybe<TeamWhereInput>;
  some?: Maybe<TeamWhereInput>;
};

export type TeamMaxOrderByAggregateInput = {
  cnpj?: Maybe<SortOrder>;
  commonUserId?: Maybe<SortOrder>;
  configAddDocumentSignerNode?: Maybe<SortOrder>;
  contract?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deactivationReason?: Maybe<SortOrder>;
  enabledInstitutionId?: Maybe<SortOrder>;
  externalSignatureWebhookURL?: Maybe<SortOrder>;
  faviconBase64?: Maybe<SortOrder>;
  financialShouldCharge?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isNSF?: Maybe<SortOrder>;
  lastActivityAt?: Maybe<SortOrder>;
  logoBase64?: Maybe<SortOrder>;
  maintainerId?: Maybe<SortOrder>;
  observations?: Maybe<SortOrder>;
  placeholderName?: Maybe<SortOrder>;
  publicViewDegreeDomainPath?: Maybe<SortOrder>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<SortOrder>;
  publicViewInstitutionName?: Maybe<SortOrder>;
  publicViewPrimaryColor?: Maybe<SortOrder>;
  publicViewSchoolCurriculumDomainPath?: Maybe<SortOrder>;
  publicViewSecondaryColor?: Maybe<SortOrder>;
  syncWithLedgerDoc?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  validateCertificateURL?: Maybe<SortOrder>;
};

/** CPF cant be externally linked to user, so this table is necessary */
export type TeamMember = {
  __typename?: 'TeamMember';
  DocumentBaseDefaultSignatureInviteConfigurationGroupItems: Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItem>;
  DocumentCertificateSignatureItemPossibleSignerInvites: Array<DocumentCertificateSignatureItemPossibleSignerInvite>;
  Invites: Array<DocumentBaseSignatureInvite>;
  Team: Team;
  TeamMemberPermissions: Array<TeamMemberPermission>;
  User: CommonUser;
  commonUserId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  role?: Maybe<Scalars['String']>;
  teamId: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


/** CPF cant be externally linked to user, so this table is necessary */
export type TeamMemberDocumentBaseDefaultSignatureInviteConfigurationGroupItemsArgs = {
  cursor?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereInput>;
};


/** CPF cant be externally linked to user, so this table is necessary */
export type TeamMemberDocumentCertificateSignatureItemPossibleSignerInvitesArgs = {
  cursor?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>;
};


/** CPF cant be externally linked to user, so this table is necessary */
export type TeamMemberInvitesArgs = {
  cursor?: Maybe<DocumentBaseSignatureInviteWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentBaseSignatureInviteScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentBaseSignatureInviteOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentBaseSignatureInviteWhereInput>;
};


/** CPF cant be externally linked to user, so this table is necessary */
export type TeamMemberTeamMemberPermissionsArgs = {
  cursor?: Maybe<TeamMemberPermissionWhereUniqueInput>;
  distinct?: Maybe<Array<TeamMemberPermissionScalarFieldEnum>>;
  orderBy?: Maybe<Array<TeamMemberPermissionOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TeamMemberPermissionWhereInput>;
};

export type TeamMemberAvgOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type TeamMemberCountOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  role?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TeamMemberCreateInput = {
  DocumentBaseDefaultSignatureInviteConfigurationGroupItems?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateNestedManyWithoutTeamMemberInput>;
  DocumentCertificateSignatureItemPossibleSignerInvites?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteCreateNestedManyWithoutTeamMemberInput>;
  Invites?: Maybe<DocumentBaseSignatureInviteCreateNestedManyWithoutTeamMemberInput>;
  Team: TeamCreateNestedOneWithoutTeamMemberInput;
  TeamMemberPermissions?: Maybe<TeamMemberPermissionCreateNestedManyWithoutTeamMemberInput>;
  User: CommonUserCreateNestedOneWithoutTeamMemberInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  role?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TeamMemberCreateManyInput = {
  commonUserId: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  role?: Maybe<Scalars['String']>;
  teamId: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TeamMemberCreateManyTeamInput = {
  commonUserId: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  role?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TeamMemberCreateManyTeamInputEnvelope = {
  data: Array<TeamMemberCreateManyTeamInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type TeamMemberCreateManyUserInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  role?: Maybe<Scalars['String']>;
  teamId: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TeamMemberCreateManyUserInputEnvelope = {
  data: Array<TeamMemberCreateManyUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type TeamMemberCreateNestedManyWithoutTeamInput = {
  connect?: Maybe<Array<TeamMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TeamMemberCreateOrConnectWithoutTeamInput>>;
  create?: Maybe<Array<TeamMemberCreateWithoutTeamInput>>;
  createMany?: Maybe<TeamMemberCreateManyTeamInputEnvelope>;
};

export type TeamMemberCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<TeamMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TeamMemberCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<TeamMemberCreateWithoutUserInput>>;
  createMany?: Maybe<TeamMemberCreateManyUserInputEnvelope>;
};

export type TeamMemberCreateNestedOneWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput = {
  connect?: Maybe<TeamMemberWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamMemberCreateOrConnectWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput>;
  create?: Maybe<TeamMemberCreateWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput>;
};

export type TeamMemberCreateNestedOneWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput = {
  connect?: Maybe<TeamMemberWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamMemberCreateOrConnectWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput>;
  create?: Maybe<TeamMemberCreateWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput>;
};

export type TeamMemberCreateNestedOneWithoutInvitesInput = {
  connect?: Maybe<TeamMemberWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamMemberCreateOrConnectWithoutInvitesInput>;
  create?: Maybe<TeamMemberCreateWithoutInvitesInput>;
};

export type TeamMemberCreateNestedOneWithoutTeamMemberPermissionsInput = {
  connect?: Maybe<TeamMemberWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamMemberCreateOrConnectWithoutTeamMemberPermissionsInput>;
  create?: Maybe<TeamMemberCreateWithoutTeamMemberPermissionsInput>;
};

export type TeamMemberCreateOrConnectWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput = {
  create: TeamMemberCreateWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput;
  where: TeamMemberWhereUniqueInput;
};

export type TeamMemberCreateOrConnectWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput = {
  create: TeamMemberCreateWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput;
  where: TeamMemberWhereUniqueInput;
};

export type TeamMemberCreateOrConnectWithoutInvitesInput = {
  create: TeamMemberCreateWithoutInvitesInput;
  where: TeamMemberWhereUniqueInput;
};

export type TeamMemberCreateOrConnectWithoutTeamInput = {
  create: TeamMemberCreateWithoutTeamInput;
  where: TeamMemberWhereUniqueInput;
};

export type TeamMemberCreateOrConnectWithoutTeamMemberPermissionsInput = {
  create: TeamMemberCreateWithoutTeamMemberPermissionsInput;
  where: TeamMemberWhereUniqueInput;
};

export type TeamMemberCreateOrConnectWithoutUserInput = {
  create: TeamMemberCreateWithoutUserInput;
  where: TeamMemberWhereUniqueInput;
};

export type TeamMemberCreateWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput = {
  DocumentCertificateSignatureItemPossibleSignerInvites?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteCreateNestedManyWithoutTeamMemberInput>;
  Invites?: Maybe<DocumentBaseSignatureInviteCreateNestedManyWithoutTeamMemberInput>;
  Team: TeamCreateNestedOneWithoutTeamMemberInput;
  TeamMemberPermissions?: Maybe<TeamMemberPermissionCreateNestedManyWithoutTeamMemberInput>;
  User: CommonUserCreateNestedOneWithoutTeamMemberInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  role?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TeamMemberCreateWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput = {
  DocumentBaseDefaultSignatureInviteConfigurationGroupItems?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateNestedManyWithoutTeamMemberInput>;
  Invites?: Maybe<DocumentBaseSignatureInviteCreateNestedManyWithoutTeamMemberInput>;
  Team: TeamCreateNestedOneWithoutTeamMemberInput;
  TeamMemberPermissions?: Maybe<TeamMemberPermissionCreateNestedManyWithoutTeamMemberInput>;
  User: CommonUserCreateNestedOneWithoutTeamMemberInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  role?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TeamMemberCreateWithoutInvitesInput = {
  DocumentBaseDefaultSignatureInviteConfigurationGroupItems?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateNestedManyWithoutTeamMemberInput>;
  DocumentCertificateSignatureItemPossibleSignerInvites?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteCreateNestedManyWithoutTeamMemberInput>;
  Team: TeamCreateNestedOneWithoutTeamMemberInput;
  TeamMemberPermissions?: Maybe<TeamMemberPermissionCreateNestedManyWithoutTeamMemberInput>;
  User: CommonUserCreateNestedOneWithoutTeamMemberInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  role?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TeamMemberCreateWithoutTeamInput = {
  DocumentBaseDefaultSignatureInviteConfigurationGroupItems?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateNestedManyWithoutTeamMemberInput>;
  DocumentCertificateSignatureItemPossibleSignerInvites?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteCreateNestedManyWithoutTeamMemberInput>;
  Invites?: Maybe<DocumentBaseSignatureInviteCreateNestedManyWithoutTeamMemberInput>;
  TeamMemberPermissions?: Maybe<TeamMemberPermissionCreateNestedManyWithoutTeamMemberInput>;
  User: CommonUserCreateNestedOneWithoutTeamMemberInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  role?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TeamMemberCreateWithoutTeamMemberPermissionsInput = {
  DocumentBaseDefaultSignatureInviteConfigurationGroupItems?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateNestedManyWithoutTeamMemberInput>;
  DocumentCertificateSignatureItemPossibleSignerInvites?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteCreateNestedManyWithoutTeamMemberInput>;
  Invites?: Maybe<DocumentBaseSignatureInviteCreateNestedManyWithoutTeamMemberInput>;
  Team: TeamCreateNestedOneWithoutTeamMemberInput;
  User: CommonUserCreateNestedOneWithoutTeamMemberInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  role?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TeamMemberCreateWithoutUserInput = {
  DocumentBaseDefaultSignatureInviteConfigurationGroupItems?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateNestedManyWithoutTeamMemberInput>;
  DocumentCertificateSignatureItemPossibleSignerInvites?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteCreateNestedManyWithoutTeamMemberInput>;
  Invites?: Maybe<DocumentBaseSignatureInviteCreateNestedManyWithoutTeamMemberInput>;
  Team: TeamCreateNestedOneWithoutTeamMemberInput;
  TeamMemberPermissions?: Maybe<TeamMemberPermissionCreateNestedManyWithoutTeamMemberInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  role?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TeamMemberListRelationFilter = {
  every?: Maybe<TeamMemberWhereInput>;
  none?: Maybe<TeamMemberWhereInput>;
  some?: Maybe<TeamMemberWhereInput>;
};

export type TeamMemberMaxOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  role?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TeamMemberMinOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  role?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TeamMemberNullableRelationFilter = {
  is?: Maybe<TeamMemberWhereInput>;
  isNot?: Maybe<TeamMemberWhereInput>;
};

export type TeamMemberOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type TeamMemberOrderByWithAggregationInput = {
  _avg?: Maybe<TeamMemberAvgOrderByAggregateInput>;
  _count?: Maybe<TeamMemberCountOrderByAggregateInput>;
  _max?: Maybe<TeamMemberMaxOrderByAggregateInput>;
  _min?: Maybe<TeamMemberMinOrderByAggregateInput>;
  _sum?: Maybe<TeamMemberSumOrderByAggregateInput>;
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  role?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TeamMemberOrderByWithRelationInput = {
  DocumentBaseDefaultSignatureInviteConfigurationGroupItems?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemOrderByRelationAggregateInput>;
  DocumentCertificateSignatureItemPossibleSignerInvites?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteOrderByRelationAggregateInput>;
  Invites?: Maybe<DocumentBaseSignatureInviteOrderByRelationAggregateInput>;
  Team?: Maybe<TeamOrderByWithRelationInput>;
  TeamMemberPermissions?: Maybe<TeamMemberPermissionOrderByRelationAggregateInput>;
  User?: Maybe<CommonUserOrderByWithRelationInput>;
  commonUserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  role?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TeamMemberPermission = {
  __typename?: 'TeamMemberPermission';
  Permission: Permission;
  TeamMember: TeamMember;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  permissionCode: Scalars['String'];
  teamMemberId: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TeamMemberPermissionAvgOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  teamMemberId?: Maybe<SortOrder>;
};

export type TeamMemberPermissionCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  permissionCode?: Maybe<SortOrder>;
  teamMemberId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TeamMemberPermissionCreateInput = {
  Permission: PermissionCreateNestedOneWithoutTeamMemberPermissionsInput;
  TeamMember: TeamMemberCreateNestedOneWithoutTeamMemberPermissionsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TeamMemberPermissionCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  permissionCode: Scalars['String'];
  teamMemberId: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TeamMemberPermissionCreateManyPermissionInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  teamMemberId: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TeamMemberPermissionCreateManyPermissionInputEnvelope = {
  data: Array<TeamMemberPermissionCreateManyPermissionInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type TeamMemberPermissionCreateManyTeamMemberInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  permissionCode: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TeamMemberPermissionCreateManyTeamMemberInputEnvelope = {
  data: Array<TeamMemberPermissionCreateManyTeamMemberInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type TeamMemberPermissionCreateNestedManyWithoutPermissionInput = {
  connect?: Maybe<Array<TeamMemberPermissionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TeamMemberPermissionCreateOrConnectWithoutPermissionInput>>;
  create?: Maybe<Array<TeamMemberPermissionCreateWithoutPermissionInput>>;
  createMany?: Maybe<TeamMemberPermissionCreateManyPermissionInputEnvelope>;
};

export type TeamMemberPermissionCreateNestedManyWithoutTeamMemberInput = {
  connect?: Maybe<Array<TeamMemberPermissionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TeamMemberPermissionCreateOrConnectWithoutTeamMemberInput>>;
  create?: Maybe<Array<TeamMemberPermissionCreateWithoutTeamMemberInput>>;
  createMany?: Maybe<TeamMemberPermissionCreateManyTeamMemberInputEnvelope>;
};

export type TeamMemberPermissionCreateOrConnectWithoutPermissionInput = {
  create: TeamMemberPermissionCreateWithoutPermissionInput;
  where: TeamMemberPermissionWhereUniqueInput;
};

export type TeamMemberPermissionCreateOrConnectWithoutTeamMemberInput = {
  create: TeamMemberPermissionCreateWithoutTeamMemberInput;
  where: TeamMemberPermissionWhereUniqueInput;
};

export type TeamMemberPermissionCreateWithoutPermissionInput = {
  TeamMember: TeamMemberCreateNestedOneWithoutTeamMemberPermissionsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TeamMemberPermissionCreateWithoutTeamMemberInput = {
  Permission: PermissionCreateNestedOneWithoutTeamMemberPermissionsInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TeamMemberPermissionListRelationFilter = {
  every?: Maybe<TeamMemberPermissionWhereInput>;
  none?: Maybe<TeamMemberPermissionWhereInput>;
  some?: Maybe<TeamMemberPermissionWhereInput>;
};

export type TeamMemberPermissionMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  permissionCode?: Maybe<SortOrder>;
  teamMemberId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TeamMemberPermissionMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  permissionCode?: Maybe<SortOrder>;
  teamMemberId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TeamMemberPermissionOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type TeamMemberPermissionOrderByWithAggregationInput = {
  _avg?: Maybe<TeamMemberPermissionAvgOrderByAggregateInput>;
  _count?: Maybe<TeamMemberPermissionCountOrderByAggregateInput>;
  _max?: Maybe<TeamMemberPermissionMaxOrderByAggregateInput>;
  _min?: Maybe<TeamMemberPermissionMinOrderByAggregateInput>;
  _sum?: Maybe<TeamMemberPermissionSumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  permissionCode?: Maybe<SortOrder>;
  teamMemberId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type TeamMemberPermissionOrderByWithRelationInput = {
  Permission?: Maybe<PermissionOrderByWithRelationInput>;
  TeamMember?: Maybe<TeamMemberOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  permissionCode?: Maybe<SortOrder>;
  teamMemberId?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export enum TeamMemberPermissionScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  PermissionCode = 'permissionCode',
  TeamMemberId = 'teamMemberId',
  UpdatedAt = 'updatedAt'
}

export type TeamMemberPermissionScalarWhereInput = {
  AND?: Maybe<Array<TeamMemberPermissionScalarWhereInput>>;
  NOT?: Maybe<Array<TeamMemberPermissionScalarWhereInput>>;
  OR?: Maybe<Array<TeamMemberPermissionScalarWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  permissionCode?: Maybe<StringFilter>;
  teamMemberId?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
};

export type TeamMemberPermissionScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<TeamMemberPermissionScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<TeamMemberPermissionScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<TeamMemberPermissionScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  permissionCode?: Maybe<StringWithAggregatesFilter>;
  teamMemberId?: Maybe<IntWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
};

export type TeamMemberPermissionSumOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  teamMemberId?: Maybe<SortOrder>;
};

export type TeamMemberPermissionUpdateInput = {
  Permission?: Maybe<PermissionUpdateOneRequiredWithoutTeamMemberPermissionsNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateOneRequiredWithoutTeamMemberPermissionsNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TeamMemberPermissionUpdateManyMutationInput = {
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TeamMemberPermissionUpdateManyWithWhereWithoutPermissionInput = {
  data: TeamMemberPermissionUpdateManyMutationInput;
  where: TeamMemberPermissionScalarWhereInput;
};

export type TeamMemberPermissionUpdateManyWithWhereWithoutTeamMemberInput = {
  data: TeamMemberPermissionUpdateManyMutationInput;
  where: TeamMemberPermissionScalarWhereInput;
};

export type TeamMemberPermissionUpdateManyWithoutPermissionNestedInput = {
  connect?: Maybe<Array<TeamMemberPermissionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TeamMemberPermissionCreateOrConnectWithoutPermissionInput>>;
  create?: Maybe<Array<TeamMemberPermissionCreateWithoutPermissionInput>>;
  createMany?: Maybe<TeamMemberPermissionCreateManyPermissionInputEnvelope>;
  delete?: Maybe<Array<TeamMemberPermissionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TeamMemberPermissionScalarWhereInput>>;
  disconnect?: Maybe<Array<TeamMemberPermissionWhereUniqueInput>>;
  set?: Maybe<Array<TeamMemberPermissionWhereUniqueInput>>;
  update?: Maybe<Array<TeamMemberPermissionUpdateWithWhereUniqueWithoutPermissionInput>>;
  updateMany?: Maybe<Array<TeamMemberPermissionUpdateManyWithWhereWithoutPermissionInput>>;
  upsert?: Maybe<Array<TeamMemberPermissionUpsertWithWhereUniqueWithoutPermissionInput>>;
};

export type TeamMemberPermissionUpdateManyWithoutTeamMemberNestedInput = {
  connect?: Maybe<Array<TeamMemberPermissionWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TeamMemberPermissionCreateOrConnectWithoutTeamMemberInput>>;
  create?: Maybe<Array<TeamMemberPermissionCreateWithoutTeamMemberInput>>;
  createMany?: Maybe<TeamMemberPermissionCreateManyTeamMemberInputEnvelope>;
  delete?: Maybe<Array<TeamMemberPermissionWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TeamMemberPermissionScalarWhereInput>>;
  disconnect?: Maybe<Array<TeamMemberPermissionWhereUniqueInput>>;
  set?: Maybe<Array<TeamMemberPermissionWhereUniqueInput>>;
  update?: Maybe<Array<TeamMemberPermissionUpdateWithWhereUniqueWithoutTeamMemberInput>>;
  updateMany?: Maybe<Array<TeamMemberPermissionUpdateManyWithWhereWithoutTeamMemberInput>>;
  upsert?: Maybe<Array<TeamMemberPermissionUpsertWithWhereUniqueWithoutTeamMemberInput>>;
};

export type TeamMemberPermissionUpdateWithWhereUniqueWithoutPermissionInput = {
  data: TeamMemberPermissionUpdateWithoutPermissionInput;
  where: TeamMemberPermissionWhereUniqueInput;
};

export type TeamMemberPermissionUpdateWithWhereUniqueWithoutTeamMemberInput = {
  data: TeamMemberPermissionUpdateWithoutTeamMemberInput;
  where: TeamMemberPermissionWhereUniqueInput;
};

export type TeamMemberPermissionUpdateWithoutPermissionInput = {
  TeamMember?: Maybe<TeamMemberUpdateOneRequiredWithoutTeamMemberPermissionsNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TeamMemberPermissionUpdateWithoutTeamMemberInput = {
  Permission?: Maybe<PermissionUpdateOneRequiredWithoutTeamMemberPermissionsNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TeamMemberPermissionUpsertWithWhereUniqueWithoutPermissionInput = {
  create: TeamMemberPermissionCreateWithoutPermissionInput;
  update: TeamMemberPermissionUpdateWithoutPermissionInput;
  where: TeamMemberPermissionWhereUniqueInput;
};

export type TeamMemberPermissionUpsertWithWhereUniqueWithoutTeamMemberInput = {
  create: TeamMemberPermissionCreateWithoutTeamMemberInput;
  update: TeamMemberPermissionUpdateWithoutTeamMemberInput;
  where: TeamMemberPermissionWhereUniqueInput;
};

export type TeamMemberPermissionWhereInput = {
  AND?: Maybe<Array<TeamMemberPermissionWhereInput>>;
  NOT?: Maybe<Array<TeamMemberPermissionWhereInput>>;
  OR?: Maybe<Array<TeamMemberPermissionWhereInput>>;
  Permission?: Maybe<PermissionWhereInput>;
  TeamMember?: Maybe<TeamMemberWhereInput>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  permissionCode?: Maybe<StringFilter>;
  teamMemberId?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
};

export type TeamMemberPermissionWhereUniqueInput = {
  AND?: Maybe<Array<TeamMemberPermissionWhereInput>>;
  NOT?: Maybe<Array<TeamMemberPermissionWhereInput>>;
  OR?: Maybe<Array<TeamMemberPermissionWhereInput>>;
  Permission?: Maybe<PermissionWhereInput>;
  TeamMember?: Maybe<TeamMemberWhereInput>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['Int']>;
  permissionCode?: Maybe<StringFilter>;
  teamMemberId?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
};

export type TeamMemberRelationFilter = {
  is?: Maybe<TeamMemberWhereInput>;
  isNot?: Maybe<TeamMemberWhereInput>;
};

export enum TeamMemberScalarFieldEnum {
  CommonUserId = 'commonUserId',
  CreatedAt = 'createdAt',
  Id = 'id',
  Role = 'role',
  TeamId = 'teamId',
  UpdatedAt = 'updatedAt'
}

export type TeamMemberScalarWhereInput = {
  AND?: Maybe<Array<TeamMemberScalarWhereInput>>;
  NOT?: Maybe<Array<TeamMemberScalarWhereInput>>;
  OR?: Maybe<Array<TeamMemberScalarWhereInput>>;
  commonUserId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  role?: Maybe<StringNullableFilter>;
  teamId?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
};

export type TeamMemberScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<TeamMemberScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<TeamMemberScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<TeamMemberScalarWhereWithAggregatesInput>>;
  commonUserId?: Maybe<IntWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  role?: Maybe<StringNullableWithAggregatesFilter>;
  teamId?: Maybe<IntWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
};

export type TeamMemberSumOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  teamId?: Maybe<SortOrder>;
};

export type TeamMemberTeamIdCommonUserIdCompoundUniqueInput = {
  commonUserId: Scalars['Int'];
  teamId: Scalars['Int'];
};

export type TeamMemberUpdateInput = {
  DocumentBaseDefaultSignatureInviteConfigurationGroupItems?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateManyWithoutTeamMemberNestedInput>;
  DocumentCertificateSignatureItemPossibleSignerInvites?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteUpdateManyWithoutTeamMemberNestedInput>;
  Invites?: Maybe<DocumentBaseSignatureInviteUpdateManyWithoutTeamMemberNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutTeamMemberNestedInput>;
  TeamMemberPermissions?: Maybe<TeamMemberPermissionUpdateManyWithoutTeamMemberNestedInput>;
  User?: Maybe<CommonUserUpdateOneRequiredWithoutTeamMemberNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  role?: Maybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TeamMemberUpdateManyMutationInput = {
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  role?: Maybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TeamMemberUpdateManyWithWhereWithoutTeamInput = {
  data: TeamMemberUpdateManyMutationInput;
  where: TeamMemberScalarWhereInput;
};

export type TeamMemberUpdateManyWithWhereWithoutUserInput = {
  data: TeamMemberUpdateManyMutationInput;
  where: TeamMemberScalarWhereInput;
};

export type TeamMemberUpdateManyWithoutTeamNestedInput = {
  connect?: Maybe<Array<TeamMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TeamMemberCreateOrConnectWithoutTeamInput>>;
  create?: Maybe<Array<TeamMemberCreateWithoutTeamInput>>;
  createMany?: Maybe<TeamMemberCreateManyTeamInputEnvelope>;
  delete?: Maybe<Array<TeamMemberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TeamMemberScalarWhereInput>>;
  disconnect?: Maybe<Array<TeamMemberWhereUniqueInput>>;
  set?: Maybe<Array<TeamMemberWhereUniqueInput>>;
  update?: Maybe<Array<TeamMemberUpdateWithWhereUniqueWithoutTeamInput>>;
  updateMany?: Maybe<Array<TeamMemberUpdateManyWithWhereWithoutTeamInput>>;
  upsert?: Maybe<Array<TeamMemberUpsertWithWhereUniqueWithoutTeamInput>>;
};

export type TeamMemberUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<TeamMemberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TeamMemberCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<TeamMemberCreateWithoutUserInput>>;
  createMany?: Maybe<TeamMemberCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<TeamMemberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TeamMemberScalarWhereInput>>;
  disconnect?: Maybe<Array<TeamMemberWhereUniqueInput>>;
  set?: Maybe<Array<TeamMemberWhereUniqueInput>>;
  update?: Maybe<Array<TeamMemberUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<TeamMemberUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<TeamMemberUpsertWithWhereUniqueWithoutUserInput>>;
};

export type TeamMemberUpdateOneRequiredWithoutDocumentCertificateSignatureItemPossibleSignerInvitesNestedInput = {
  connect?: Maybe<TeamMemberWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamMemberCreateOrConnectWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput>;
  create?: Maybe<TeamMemberCreateWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput>;
  update?: Maybe<TeamMemberUpdateToOneWithWhereWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput>;
  upsert?: Maybe<TeamMemberUpsertWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput>;
};

export type TeamMemberUpdateOneRequiredWithoutTeamMemberPermissionsNestedInput = {
  connect?: Maybe<TeamMemberWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamMemberCreateOrConnectWithoutTeamMemberPermissionsInput>;
  create?: Maybe<TeamMemberCreateWithoutTeamMemberPermissionsInput>;
  update?: Maybe<TeamMemberUpdateToOneWithWhereWithoutTeamMemberPermissionsInput>;
  upsert?: Maybe<TeamMemberUpsertWithoutTeamMemberPermissionsInput>;
};

export type TeamMemberUpdateOneWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsNestedInput = {
  connect?: Maybe<TeamMemberWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamMemberCreateOrConnectWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput>;
  create?: Maybe<TeamMemberCreateWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput>;
  delete?: Maybe<TeamMemberWhereInput>;
  disconnect?: Maybe<TeamMemberWhereInput>;
  update?: Maybe<TeamMemberUpdateToOneWithWhereWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput>;
  upsert?: Maybe<TeamMemberUpsertWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput>;
};

export type TeamMemberUpdateOneWithoutInvitesNestedInput = {
  connect?: Maybe<TeamMemberWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamMemberCreateOrConnectWithoutInvitesInput>;
  create?: Maybe<TeamMemberCreateWithoutInvitesInput>;
  delete?: Maybe<TeamMemberWhereInput>;
  disconnect?: Maybe<TeamMemberWhereInput>;
  update?: Maybe<TeamMemberUpdateToOneWithWhereWithoutInvitesInput>;
  upsert?: Maybe<TeamMemberUpsertWithoutInvitesInput>;
};

export type TeamMemberUpdateToOneWithWhereWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput = {
  data: TeamMemberUpdateWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput;
  where?: Maybe<TeamMemberWhereInput>;
};

export type TeamMemberUpdateToOneWithWhereWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput = {
  data: TeamMemberUpdateWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput;
  where?: Maybe<TeamMemberWhereInput>;
};

export type TeamMemberUpdateToOneWithWhereWithoutInvitesInput = {
  data: TeamMemberUpdateWithoutInvitesInput;
  where?: Maybe<TeamMemberWhereInput>;
};

export type TeamMemberUpdateToOneWithWhereWithoutTeamMemberPermissionsInput = {
  data: TeamMemberUpdateWithoutTeamMemberPermissionsInput;
  where?: Maybe<TeamMemberWhereInput>;
};

export type TeamMemberUpdateWithWhereUniqueWithoutTeamInput = {
  data: TeamMemberUpdateWithoutTeamInput;
  where: TeamMemberWhereUniqueInput;
};

export type TeamMemberUpdateWithWhereUniqueWithoutUserInput = {
  data: TeamMemberUpdateWithoutUserInput;
  where: TeamMemberWhereUniqueInput;
};

export type TeamMemberUpdateWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput = {
  DocumentCertificateSignatureItemPossibleSignerInvites?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteUpdateManyWithoutTeamMemberNestedInput>;
  Invites?: Maybe<DocumentBaseSignatureInviteUpdateManyWithoutTeamMemberNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutTeamMemberNestedInput>;
  TeamMemberPermissions?: Maybe<TeamMemberPermissionUpdateManyWithoutTeamMemberNestedInput>;
  User?: Maybe<CommonUserUpdateOneRequiredWithoutTeamMemberNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  role?: Maybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TeamMemberUpdateWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput = {
  DocumentBaseDefaultSignatureInviteConfigurationGroupItems?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateManyWithoutTeamMemberNestedInput>;
  Invites?: Maybe<DocumentBaseSignatureInviteUpdateManyWithoutTeamMemberNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutTeamMemberNestedInput>;
  TeamMemberPermissions?: Maybe<TeamMemberPermissionUpdateManyWithoutTeamMemberNestedInput>;
  User?: Maybe<CommonUserUpdateOneRequiredWithoutTeamMemberNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  role?: Maybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TeamMemberUpdateWithoutInvitesInput = {
  DocumentBaseDefaultSignatureInviteConfigurationGroupItems?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateManyWithoutTeamMemberNestedInput>;
  DocumentCertificateSignatureItemPossibleSignerInvites?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteUpdateManyWithoutTeamMemberNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutTeamMemberNestedInput>;
  TeamMemberPermissions?: Maybe<TeamMemberPermissionUpdateManyWithoutTeamMemberNestedInput>;
  User?: Maybe<CommonUserUpdateOneRequiredWithoutTeamMemberNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  role?: Maybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TeamMemberUpdateWithoutTeamInput = {
  DocumentBaseDefaultSignatureInviteConfigurationGroupItems?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateManyWithoutTeamMemberNestedInput>;
  DocumentCertificateSignatureItemPossibleSignerInvites?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteUpdateManyWithoutTeamMemberNestedInput>;
  Invites?: Maybe<DocumentBaseSignatureInviteUpdateManyWithoutTeamMemberNestedInput>;
  TeamMemberPermissions?: Maybe<TeamMemberPermissionUpdateManyWithoutTeamMemberNestedInput>;
  User?: Maybe<CommonUserUpdateOneRequiredWithoutTeamMemberNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  role?: Maybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TeamMemberUpdateWithoutTeamMemberPermissionsInput = {
  DocumentBaseDefaultSignatureInviteConfigurationGroupItems?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateManyWithoutTeamMemberNestedInput>;
  DocumentCertificateSignatureItemPossibleSignerInvites?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteUpdateManyWithoutTeamMemberNestedInput>;
  Invites?: Maybe<DocumentBaseSignatureInviteUpdateManyWithoutTeamMemberNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutTeamMemberNestedInput>;
  User?: Maybe<CommonUserUpdateOneRequiredWithoutTeamMemberNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  role?: Maybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TeamMemberUpdateWithoutUserInput = {
  DocumentBaseDefaultSignatureInviteConfigurationGroupItems?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateManyWithoutTeamMemberNestedInput>;
  DocumentCertificateSignatureItemPossibleSignerInvites?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteUpdateManyWithoutTeamMemberNestedInput>;
  Invites?: Maybe<DocumentBaseSignatureInviteUpdateManyWithoutTeamMemberNestedInput>;
  Team?: Maybe<TeamUpdateOneRequiredWithoutTeamMemberNestedInput>;
  TeamMemberPermissions?: Maybe<TeamMemberPermissionUpdateManyWithoutTeamMemberNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  role?: Maybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TeamMemberUpsertWithWhereUniqueWithoutTeamInput = {
  create: TeamMemberCreateWithoutTeamInput;
  update: TeamMemberUpdateWithoutTeamInput;
  where: TeamMemberWhereUniqueInput;
};

export type TeamMemberUpsertWithWhereUniqueWithoutUserInput = {
  create: TeamMemberCreateWithoutUserInput;
  update: TeamMemberUpdateWithoutUserInput;
  where: TeamMemberWhereUniqueInput;
};

export type TeamMemberUpsertWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput = {
  create: TeamMemberCreateWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput;
  update: TeamMemberUpdateWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput;
  where?: Maybe<TeamMemberWhereInput>;
};

export type TeamMemberUpsertWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput = {
  create: TeamMemberCreateWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput;
  update: TeamMemberUpdateWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput;
  where?: Maybe<TeamMemberWhereInput>;
};

export type TeamMemberUpsertWithoutInvitesInput = {
  create: TeamMemberCreateWithoutInvitesInput;
  update: TeamMemberUpdateWithoutInvitesInput;
  where?: Maybe<TeamMemberWhereInput>;
};

export type TeamMemberUpsertWithoutTeamMemberPermissionsInput = {
  create: TeamMemberCreateWithoutTeamMemberPermissionsInput;
  update: TeamMemberUpdateWithoutTeamMemberPermissionsInput;
  where?: Maybe<TeamMemberWhereInput>;
};

export type TeamMemberWhereInput = {
  AND?: Maybe<Array<TeamMemberWhereInput>>;
  DocumentBaseDefaultSignatureInviteConfigurationGroupItems?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemListRelationFilter>;
  DocumentCertificateSignatureItemPossibleSignerInvites?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteListRelationFilter>;
  Invites?: Maybe<DocumentBaseSignatureInviteListRelationFilter>;
  NOT?: Maybe<Array<TeamMemberWhereInput>>;
  OR?: Maybe<Array<TeamMemberWhereInput>>;
  Team?: Maybe<TeamWhereInput>;
  TeamMemberPermissions?: Maybe<TeamMemberPermissionListRelationFilter>;
  User?: Maybe<CommonUserWhereInput>;
  commonUserId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  role?: Maybe<StringNullableFilter>;
  teamId?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
};

export type TeamMemberWhereUniqueInput = {
  AND?: Maybe<Array<TeamMemberWhereInput>>;
  DocumentBaseDefaultSignatureInviteConfigurationGroupItems?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemListRelationFilter>;
  DocumentCertificateSignatureItemPossibleSignerInvites?: Maybe<DocumentCertificateSignatureItemPossibleSignerInviteListRelationFilter>;
  Invites?: Maybe<DocumentBaseSignatureInviteListRelationFilter>;
  NOT?: Maybe<Array<TeamMemberWhereInput>>;
  OR?: Maybe<Array<TeamMemberWhereInput>>;
  Team?: Maybe<TeamWhereInput>;
  TeamMemberPermissions?: Maybe<TeamMemberPermissionListRelationFilter>;
  User?: Maybe<CommonUserWhereInput>;
  commonUserId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<Scalars['Int']>;
  role?: Maybe<StringNullableFilter>;
  teamId?: Maybe<IntFilter>;
  teamId_commonUserId?: Maybe<TeamMemberTeamIdCommonUserIdCompoundUniqueInput>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
};

export type TeamMinOrderByAggregateInput = {
  cnpj?: Maybe<SortOrder>;
  commonUserId?: Maybe<SortOrder>;
  configAddDocumentSignerNode?: Maybe<SortOrder>;
  contract?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deactivationReason?: Maybe<SortOrder>;
  enabledInstitutionId?: Maybe<SortOrder>;
  externalSignatureWebhookURL?: Maybe<SortOrder>;
  faviconBase64?: Maybe<SortOrder>;
  financialShouldCharge?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isNSF?: Maybe<SortOrder>;
  lastActivityAt?: Maybe<SortOrder>;
  logoBase64?: Maybe<SortOrder>;
  maintainerId?: Maybe<SortOrder>;
  observations?: Maybe<SortOrder>;
  placeholderName?: Maybe<SortOrder>;
  publicViewDegreeDomainPath?: Maybe<SortOrder>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<SortOrder>;
  publicViewInstitutionName?: Maybe<SortOrder>;
  publicViewPrimaryColor?: Maybe<SortOrder>;
  publicViewSchoolCurriculumDomainPath?: Maybe<SortOrder>;
  publicViewSecondaryColor?: Maybe<SortOrder>;
  syncWithLedgerDoc?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  validateCertificateURL?: Maybe<SortOrder>;
};

export type TeamNullableRelationFilter = {
  is?: Maybe<TeamWhereInput>;
  isNot?: Maybe<TeamWhereInput>;
};

export type TeamOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type TeamOrderByWithAggregationInput = {
  _avg?: Maybe<TeamAvgOrderByAggregateInput>;
  _count?: Maybe<TeamCountOrderByAggregateInput>;
  _max?: Maybe<TeamMaxOrderByAggregateInput>;
  _min?: Maybe<TeamMinOrderByAggregateInput>;
  _sum?: Maybe<TeamSumOrderByAggregateInput>;
  cnpj?: Maybe<SortOrder>;
  commonUserId?: Maybe<SortOrder>;
  configAddDocumentSignerNode?: Maybe<SortOrder>;
  contract?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deactivationReason?: Maybe<SortOrder>;
  enabledInstitutionId?: Maybe<SortOrder>;
  externalSignatureWebhookURL?: Maybe<SortOrder>;
  faviconBase64?: Maybe<SortOrder>;
  financialShouldCharge?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isNSF?: Maybe<SortOrder>;
  lastActivityAt?: Maybe<SortOrder>;
  logoBase64?: Maybe<SortOrder>;
  maintainerId?: Maybe<SortOrder>;
  observations?: Maybe<SortOrder>;
  placeholderName?: Maybe<SortOrder>;
  publicViewDegreeDomainPath?: Maybe<SortOrder>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<SortOrder>;
  publicViewInstitutionName?: Maybe<SortOrder>;
  publicViewPrimaryColor?: Maybe<SortOrder>;
  publicViewSchoolCurriculumDomainPath?: Maybe<SortOrder>;
  publicViewSecondaryColor?: Maybe<SortOrder>;
  syncWithLedgerDoc?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  validateCertificateURL?: Maybe<SortOrder>;
};

export type TeamOrderByWithRelationInput = {
  ApiKey?: Maybe<ApiKeyOrderByRelationAggregateInput>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordOrderByRelationAggregateInput>;
  CertificateBase?: Maybe<CertificateBaseOrderByRelationAggregateInput>;
  CertificateTemplates?: Maybe<CertificateTemplateOrderByRelationAggregateInput>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationOrderByRelationAggregateInput>;
  Documents?: Maybe<DocumentBaseOrderByRelationAggregateInput>;
  EnabledInstitution?: Maybe<EnabledInstitutionOrderByWithRelationInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletOrderByWithRelationInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerOrderByWithRelationInput>;
  Maintainer?: Maybe<MaintainerOrderByWithRelationInput>;
  Owner?: Maybe<CommonUserOrderByWithRelationInput>;
  Person?: Maybe<PersonOrderByRelationAggregateInput>;
  ReusableFormData?: Maybe<ReusableFormDataOrderByRelationAggregateInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumOrderByRelationAggregateInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogOrderByRelationAggregateInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelOrderByRelationAggregateInput>;
  TeamMember?: Maybe<TeamMemberOrderByRelationAggregateInput>;
  cnpj?: Maybe<SortOrder>;
  commonUserId?: Maybe<SortOrder>;
  configAddDocumentSignerNode?: Maybe<SortOrder>;
  contract?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  deactivationReason?: Maybe<SortOrder>;
  enabledInstitutionId?: Maybe<SortOrder>;
  externalSignatureWebhookURL?: Maybe<SortOrder>;
  faviconBase64?: Maybe<SortOrder>;
  financialShouldCharge?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  isNSF?: Maybe<SortOrder>;
  lastActivityAt?: Maybe<SortOrder>;
  logoBase64?: Maybe<SortOrder>;
  maintainerId?: Maybe<SortOrder>;
  observations?: Maybe<SortOrder>;
  placeholderName?: Maybe<SortOrder>;
  publicViewDegreeDomainPath?: Maybe<SortOrder>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<SortOrder>;
  publicViewInstitutionName?: Maybe<SortOrder>;
  publicViewPrimaryColor?: Maybe<SortOrder>;
  publicViewSchoolCurriculumDomainPath?: Maybe<SortOrder>;
  publicViewSecondaryColor?: Maybe<SortOrder>;
  syncWithLedgerDoc?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  validateCertificateURL?: Maybe<SortOrder>;
};

export type TeamRelationFilter = {
  is?: Maybe<TeamWhereInput>;
  isNot?: Maybe<TeamWhereInput>;
};

export enum TeamScalarFieldEnum {
  Cnpj = 'cnpj',
  CommonUserId = 'commonUserId',
  ConfigAddDocumentSignerNode = 'configAddDocumentSignerNode',
  Contract = 'contract',
  CreatedAt = 'createdAt',
  DeactivationReason = 'deactivationReason',
  EnabledInstitutionId = 'enabledInstitutionId',
  ExternalSignatureWebhookUrl = 'externalSignatureWebhookURL',
  FaviconBase64 = 'faviconBase64',
  FinancialShouldCharge = 'financialShouldCharge',
  Id = 'id',
  IsActive = 'isActive',
  IsNsf = 'isNSF',
  LastActivityAt = 'lastActivityAt',
  LogoBase64 = 'logoBase64',
  MaintainerId = 'maintainerId',
  Observations = 'observations',
  PlaceholderName = 'placeholderName',
  PublicViewDegreeDomainPath = 'publicViewDegreeDomainPath',
  PublicViewFinalAcademicTranscriptDomainPath = 'publicViewFinalAcademicTranscriptDomainPath',
  PublicViewInstitutionName = 'publicViewInstitutionName',
  PublicViewPrimaryColor = 'publicViewPrimaryColor',
  PublicViewSchoolCurriculumDomainPath = 'publicViewSchoolCurriculumDomainPath',
  PublicViewSecondaryColor = 'publicViewSecondaryColor',
  SyncWithLedgerDoc = 'syncWithLedgerDoc',
  UpdatedAt = 'updatedAt',
  ValidateCertificateUrl = 'validateCertificateURL'
}

export type TeamScalarWhereInput = {
  AND?: Maybe<Array<TeamScalarWhereInput>>;
  NOT?: Maybe<Array<TeamScalarWhereInput>>;
  OR?: Maybe<Array<TeamScalarWhereInput>>;
  cnpj?: Maybe<StringNullableFilter>;
  commonUserId?: Maybe<IntFilter>;
  configAddDocumentSignerNode?: Maybe<BoolFilter>;
  contract?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deactivationReason?: Maybe<StringNullableFilter>;
  enabledInstitutionId?: Maybe<IntNullableFilter>;
  externalSignatureWebhookURL?: Maybe<StringNullableFilter>;
  faviconBase64?: Maybe<StringNullableFilter>;
  financialShouldCharge?: Maybe<BoolFilter>;
  id?: Maybe<IntFilter>;
  isActive?: Maybe<BoolFilter>;
  isNSF?: Maybe<BoolFilter>;
  lastActivityAt?: Maybe<DateTimeFilter>;
  logoBase64?: Maybe<StringNullableFilter>;
  maintainerId?: Maybe<IntNullableFilter>;
  observations?: Maybe<StringFilter>;
  placeholderName?: Maybe<StringFilter>;
  publicViewDegreeDomainPath?: Maybe<StringNullableFilter>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<StringNullableFilter>;
  publicViewInstitutionName?: Maybe<StringNullableFilter>;
  publicViewPrimaryColor?: Maybe<StringNullableFilter>;
  publicViewSchoolCurriculumDomainPath?: Maybe<StringNullableFilter>;
  publicViewSecondaryColor?: Maybe<StringNullableFilter>;
  syncWithLedgerDoc?: Maybe<BoolFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
  validateCertificateURL?: Maybe<StringNullableFilter>;
};

export type TeamScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<TeamScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<TeamScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<TeamScalarWhereWithAggregatesInput>>;
  cnpj?: Maybe<StringNullableWithAggregatesFilter>;
  commonUserId?: Maybe<IntWithAggregatesFilter>;
  configAddDocumentSignerNode?: Maybe<BoolWithAggregatesFilter>;
  contract?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  deactivationReason?: Maybe<StringNullableWithAggregatesFilter>;
  enabledInstitutionId?: Maybe<IntNullableWithAggregatesFilter>;
  externalSignatureWebhookURL?: Maybe<StringNullableWithAggregatesFilter>;
  faviconBase64?: Maybe<StringNullableWithAggregatesFilter>;
  financialShouldCharge?: Maybe<BoolWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  isActive?: Maybe<BoolWithAggregatesFilter>;
  isNSF?: Maybe<BoolWithAggregatesFilter>;
  lastActivityAt?: Maybe<DateTimeWithAggregatesFilter>;
  logoBase64?: Maybe<StringNullableWithAggregatesFilter>;
  maintainerId?: Maybe<IntNullableWithAggregatesFilter>;
  observations?: Maybe<StringWithAggregatesFilter>;
  placeholderName?: Maybe<StringWithAggregatesFilter>;
  publicViewDegreeDomainPath?: Maybe<StringNullableWithAggregatesFilter>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<StringNullableWithAggregatesFilter>;
  publicViewInstitutionName?: Maybe<StringNullableWithAggregatesFilter>;
  publicViewPrimaryColor?: Maybe<StringNullableWithAggregatesFilter>;
  publicViewSchoolCurriculumDomainPath?: Maybe<StringNullableWithAggregatesFilter>;
  publicViewSecondaryColor?: Maybe<StringNullableWithAggregatesFilter>;
  syncWithLedgerDoc?: Maybe<BoolWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeNullableWithAggregatesFilter>;
  validateCertificateURL?: Maybe<StringNullableWithAggregatesFilter>;
};

export type TeamSumOrderByAggregateInput = {
  commonUserId?: Maybe<SortOrder>;
  enabledInstitutionId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  maintainerId?: Maybe<SortOrder>;
};

export type TeamUpdateInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  Documents?: Maybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: Maybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Maintainer?: Maybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Owner?: Maybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  Person?: Maybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormData?: Maybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: Maybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: Maybe<BoolFieldUpdateOperationsInput>;
  contract?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: Maybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: Maybe<BoolFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  isNSF?: Maybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  observations?: Maybe<StringFieldUpdateOperationsInput>;
  placeholderName?: Maybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateManyMutationInput = {
  cnpj?: Maybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: Maybe<BoolFieldUpdateOperationsInput>;
  contract?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: Maybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: Maybe<BoolFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  isNSF?: Maybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  observations?: Maybe<StringFieldUpdateOperationsInput>;
  placeholderName?: Maybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateManyWithWhereWithoutMaintainerInput = {
  data: TeamUpdateManyMutationInput;
  where: TeamScalarWhereInput;
};

export type TeamUpdateManyWithWhereWithoutOwnerInput = {
  data: TeamUpdateManyMutationInput;
  where: TeamScalarWhereInput;
};

export type TeamUpdateManyWithoutMaintainerNestedInput = {
  connect?: Maybe<Array<TeamWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TeamCreateOrConnectWithoutMaintainerInput>>;
  create?: Maybe<Array<TeamCreateWithoutMaintainerInput>>;
  createMany?: Maybe<TeamCreateManyMaintainerInputEnvelope>;
  delete?: Maybe<Array<TeamWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TeamScalarWhereInput>>;
  disconnect?: Maybe<Array<TeamWhereUniqueInput>>;
  set?: Maybe<Array<TeamWhereUniqueInput>>;
  update?: Maybe<Array<TeamUpdateWithWhereUniqueWithoutMaintainerInput>>;
  updateMany?: Maybe<Array<TeamUpdateManyWithWhereWithoutMaintainerInput>>;
  upsert?: Maybe<Array<TeamUpsertWithWhereUniqueWithoutMaintainerInput>>;
};

export type TeamUpdateManyWithoutOwnerNestedInput = {
  connect?: Maybe<Array<TeamWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TeamCreateOrConnectWithoutOwnerInput>>;
  create?: Maybe<Array<TeamCreateWithoutOwnerInput>>;
  createMany?: Maybe<TeamCreateManyOwnerInputEnvelope>;
  delete?: Maybe<Array<TeamWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TeamScalarWhereInput>>;
  disconnect?: Maybe<Array<TeamWhereUniqueInput>>;
  set?: Maybe<Array<TeamWhereUniqueInput>>;
  update?: Maybe<Array<TeamUpdateWithWhereUniqueWithoutOwnerInput>>;
  updateMany?: Maybe<Array<TeamUpdateManyWithWhereWithoutOwnerInput>>;
  upsert?: Maybe<Array<TeamUpsertWithWhereUniqueWithoutOwnerInput>>;
};

export type TeamUpdateOneRequiredWithoutApiKeyNestedInput = {
  connect?: Maybe<TeamWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamCreateOrConnectWithoutApiKeyInput>;
  create?: Maybe<TeamCreateWithoutApiKeyInput>;
  update?: Maybe<TeamUpdateToOneWithWhereWithoutApiKeyInput>;
  upsert?: Maybe<TeamUpsertWithoutApiKeyInput>;
};

export type TeamUpdateOneRequiredWithoutBulkCertificateRecordNestedInput = {
  connect?: Maybe<TeamWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamCreateOrConnectWithoutBulkCertificateRecordInput>;
  create?: Maybe<TeamCreateWithoutBulkCertificateRecordInput>;
  update?: Maybe<TeamUpdateToOneWithWhereWithoutBulkCertificateRecordInput>;
  upsert?: Maybe<TeamUpsertWithoutBulkCertificateRecordInput>;
};

export type TeamUpdateOneRequiredWithoutCertificateBaseNestedInput = {
  connect?: Maybe<TeamWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamCreateOrConnectWithoutCertificateBaseInput>;
  create?: Maybe<TeamCreateWithoutCertificateBaseInput>;
  update?: Maybe<TeamUpdateToOneWithWhereWithoutCertificateBaseInput>;
  upsert?: Maybe<TeamUpsertWithoutCertificateBaseInput>;
};

export type TeamUpdateOneRequiredWithoutCertificateTemplatesNestedInput = {
  connect?: Maybe<TeamWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamCreateOrConnectWithoutCertificateTemplatesInput>;
  create?: Maybe<TeamCreateWithoutCertificateTemplatesInput>;
  update?: Maybe<TeamUpdateToOneWithWhereWithoutCertificateTemplatesInput>;
  upsert?: Maybe<TeamUpsertWithoutCertificateTemplatesInput>;
};

export type TeamUpdateOneRequiredWithoutDefaultSignatureInviteConfigurationsNestedInput = {
  connect?: Maybe<TeamWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamCreateOrConnectWithoutDefaultSignatureInviteConfigurationsInput>;
  create?: Maybe<TeamCreateWithoutDefaultSignatureInviteConfigurationsInput>;
  update?: Maybe<TeamUpdateToOneWithWhereWithoutDefaultSignatureInviteConfigurationsInput>;
  upsert?: Maybe<TeamUpsertWithoutDefaultSignatureInviteConfigurationsInput>;
};

export type TeamUpdateOneRequiredWithoutDocumentsNestedInput = {
  connect?: Maybe<TeamWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamCreateOrConnectWithoutDocumentsInput>;
  create?: Maybe<TeamCreateWithoutDocumentsInput>;
  update?: Maybe<TeamUpdateToOneWithWhereWithoutDocumentsInput>;
  upsert?: Maybe<TeamUpsertWithoutDocumentsInput>;
};

export type TeamUpdateOneRequiredWithoutFinancialTeamWalletNestedInput = {
  connect?: Maybe<TeamWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamCreateOrConnectWithoutFinancialTeamWalletInput>;
  create?: Maybe<TeamCreateWithoutFinancialTeamWalletInput>;
  update?: Maybe<TeamUpdateToOneWithWhereWithoutFinancialTeamWalletInput>;
  upsert?: Maybe<TeamUpsertWithoutFinancialTeamWalletInput>;
};

export type TeamUpdateOneRequiredWithoutMainTeamOfMaintainerNestedInput = {
  connect?: Maybe<TeamWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamCreateOrConnectWithoutMainTeamOfMaintainerInput>;
  create?: Maybe<TeamCreateWithoutMainTeamOfMaintainerInput>;
  update?: Maybe<TeamUpdateToOneWithWhereWithoutMainTeamOfMaintainerInput>;
  upsert?: Maybe<TeamUpsertWithoutMainTeamOfMaintainerInput>;
};

export type TeamUpdateOneRequiredWithoutPersonNestedInput = {
  connect?: Maybe<TeamWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamCreateOrConnectWithoutPersonInput>;
  create?: Maybe<TeamCreateWithoutPersonInput>;
  update?: Maybe<TeamUpdateToOneWithWhereWithoutPersonInput>;
  upsert?: Maybe<TeamUpsertWithoutPersonInput>;
};

export type TeamUpdateOneRequiredWithoutReusableFormDataCurriculumNestedInput = {
  connect?: Maybe<TeamWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamCreateOrConnectWithoutReusableFormDataCurriculumInput>;
  create?: Maybe<TeamCreateWithoutReusableFormDataCurriculumInput>;
  update?: Maybe<TeamUpdateToOneWithWhereWithoutReusableFormDataCurriculumInput>;
  upsert?: Maybe<TeamUpsertWithoutReusableFormDataCurriculumInput>;
};

export type TeamUpdateOneRequiredWithoutReusableFormDataNestedInput = {
  connect?: Maybe<TeamWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamCreateOrConnectWithoutReusableFormDataInput>;
  create?: Maybe<TeamCreateWithoutReusableFormDataInput>;
  update?: Maybe<TeamUpdateToOneWithWhereWithoutReusableFormDataInput>;
  upsert?: Maybe<TeamUpsertWithoutReusableFormDataInput>;
};

export type TeamUpdateOneRequiredWithoutTeamEducationLevelNestedInput = {
  connect?: Maybe<TeamWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamCreateOrConnectWithoutTeamEducationLevelInput>;
  create?: Maybe<TeamCreateWithoutTeamEducationLevelInput>;
  update?: Maybe<TeamUpdateToOneWithWhereWithoutTeamEducationLevelInput>;
  upsert?: Maybe<TeamUpsertWithoutTeamEducationLevelInput>;
};

export type TeamUpdateOneRequiredWithoutTeamMemberNestedInput = {
  connect?: Maybe<TeamWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamCreateOrConnectWithoutTeamMemberInput>;
  create?: Maybe<TeamCreateWithoutTeamMemberInput>;
  update?: Maybe<TeamUpdateToOneWithWhereWithoutTeamMemberInput>;
  upsert?: Maybe<TeamUpsertWithoutTeamMemberInput>;
};

export type TeamUpdateOneWithoutEnabledInstitutionNestedInput = {
  connect?: Maybe<TeamWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamCreateOrConnectWithoutEnabledInstitutionInput>;
  create?: Maybe<TeamCreateWithoutEnabledInstitutionInput>;
  delete?: Maybe<TeamWhereInput>;
  disconnect?: Maybe<TeamWhereInput>;
  update?: Maybe<TeamUpdateToOneWithWhereWithoutEnabledInstitutionInput>;
  upsert?: Maybe<TeamUpsertWithoutEnabledInstitutionInput>;
};

export type TeamUpdateOneWithoutSystemAuditLogsNestedInput = {
  connect?: Maybe<TeamWhereUniqueInput>;
  connectOrCreate?: Maybe<TeamCreateOrConnectWithoutSystemAuditLogsInput>;
  create?: Maybe<TeamCreateWithoutSystemAuditLogsInput>;
  delete?: Maybe<TeamWhereInput>;
  disconnect?: Maybe<TeamWhereInput>;
  update?: Maybe<TeamUpdateToOneWithWhereWithoutSystemAuditLogsInput>;
  upsert?: Maybe<TeamUpsertWithoutSystemAuditLogsInput>;
};

export type TeamUpdateToOneWithWhereWithoutApiKeyInput = {
  data: TeamUpdateWithoutApiKeyInput;
  where?: Maybe<TeamWhereInput>;
};

export type TeamUpdateToOneWithWhereWithoutBulkCertificateRecordInput = {
  data: TeamUpdateWithoutBulkCertificateRecordInput;
  where?: Maybe<TeamWhereInput>;
};

export type TeamUpdateToOneWithWhereWithoutCertificateBaseInput = {
  data: TeamUpdateWithoutCertificateBaseInput;
  where?: Maybe<TeamWhereInput>;
};

export type TeamUpdateToOneWithWhereWithoutCertificateTemplatesInput = {
  data: TeamUpdateWithoutCertificateTemplatesInput;
  where?: Maybe<TeamWhereInput>;
};

export type TeamUpdateToOneWithWhereWithoutDefaultSignatureInviteConfigurationsInput = {
  data: TeamUpdateWithoutDefaultSignatureInviteConfigurationsInput;
  where?: Maybe<TeamWhereInput>;
};

export type TeamUpdateToOneWithWhereWithoutDocumentsInput = {
  data: TeamUpdateWithoutDocumentsInput;
  where?: Maybe<TeamWhereInput>;
};

export type TeamUpdateToOneWithWhereWithoutEnabledInstitutionInput = {
  data: TeamUpdateWithoutEnabledInstitutionInput;
  where?: Maybe<TeamWhereInput>;
};

export type TeamUpdateToOneWithWhereWithoutFinancialTeamWalletInput = {
  data: TeamUpdateWithoutFinancialTeamWalletInput;
  where?: Maybe<TeamWhereInput>;
};

export type TeamUpdateToOneWithWhereWithoutMainTeamOfMaintainerInput = {
  data: TeamUpdateWithoutMainTeamOfMaintainerInput;
  where?: Maybe<TeamWhereInput>;
};

export type TeamUpdateToOneWithWhereWithoutPersonInput = {
  data: TeamUpdateWithoutPersonInput;
  where?: Maybe<TeamWhereInput>;
};

export type TeamUpdateToOneWithWhereWithoutReusableFormDataCurriculumInput = {
  data: TeamUpdateWithoutReusableFormDataCurriculumInput;
  where?: Maybe<TeamWhereInput>;
};

export type TeamUpdateToOneWithWhereWithoutReusableFormDataInput = {
  data: TeamUpdateWithoutReusableFormDataInput;
  where?: Maybe<TeamWhereInput>;
};

export type TeamUpdateToOneWithWhereWithoutSystemAuditLogsInput = {
  data: TeamUpdateWithoutSystemAuditLogsInput;
  where?: Maybe<TeamWhereInput>;
};

export type TeamUpdateToOneWithWhereWithoutTeamEducationLevelInput = {
  data: TeamUpdateWithoutTeamEducationLevelInput;
  where?: Maybe<TeamWhereInput>;
};

export type TeamUpdateToOneWithWhereWithoutTeamMemberInput = {
  data: TeamUpdateWithoutTeamMemberInput;
  where?: Maybe<TeamWhereInput>;
};

export type TeamUpdateWithWhereUniqueWithoutMaintainerInput = {
  data: TeamUpdateWithoutMaintainerInput;
  where: TeamWhereUniqueInput;
};

export type TeamUpdateWithWhereUniqueWithoutOwnerInput = {
  data: TeamUpdateWithoutOwnerInput;
  where: TeamWhereUniqueInput;
};

export type TeamUpdateWithoutApiKeyInput = {
  BulkCertificateRecord?: Maybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  Documents?: Maybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: Maybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Maintainer?: Maybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Owner?: Maybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  Person?: Maybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormData?: Maybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: Maybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: Maybe<BoolFieldUpdateOperationsInput>;
  contract?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: Maybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: Maybe<BoolFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  isNSF?: Maybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  observations?: Maybe<StringFieldUpdateOperationsInput>;
  placeholderName?: Maybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateWithoutBulkCertificateRecordInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  Documents?: Maybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: Maybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Maintainer?: Maybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Owner?: Maybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  Person?: Maybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormData?: Maybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: Maybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: Maybe<BoolFieldUpdateOperationsInput>;
  contract?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: Maybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: Maybe<BoolFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  isNSF?: Maybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  observations?: Maybe<StringFieldUpdateOperationsInput>;
  placeholderName?: Maybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateWithoutCertificateBaseInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  Documents?: Maybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: Maybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Maintainer?: Maybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Owner?: Maybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  Person?: Maybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormData?: Maybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: Maybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: Maybe<BoolFieldUpdateOperationsInput>;
  contract?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: Maybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: Maybe<BoolFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  isNSF?: Maybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  observations?: Maybe<StringFieldUpdateOperationsInput>;
  placeholderName?: Maybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateWithoutCertificateTemplatesInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  Documents?: Maybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: Maybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Maintainer?: Maybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Owner?: Maybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  Person?: Maybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormData?: Maybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: Maybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: Maybe<BoolFieldUpdateOperationsInput>;
  contract?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: Maybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: Maybe<BoolFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  isNSF?: Maybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  observations?: Maybe<StringFieldUpdateOperationsInput>;
  placeholderName?: Maybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateWithoutDefaultSignatureInviteConfigurationsInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  Documents?: Maybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: Maybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Maintainer?: Maybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Owner?: Maybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  Person?: Maybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormData?: Maybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: Maybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: Maybe<BoolFieldUpdateOperationsInput>;
  contract?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: Maybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: Maybe<BoolFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  isNSF?: Maybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  observations?: Maybe<StringFieldUpdateOperationsInput>;
  placeholderName?: Maybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateWithoutDocumentsInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: Maybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Maintainer?: Maybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Owner?: Maybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  Person?: Maybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormData?: Maybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: Maybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: Maybe<BoolFieldUpdateOperationsInput>;
  contract?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: Maybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: Maybe<BoolFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  isNSF?: Maybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  observations?: Maybe<StringFieldUpdateOperationsInput>;
  placeholderName?: Maybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateWithoutEnabledInstitutionInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  Documents?: Maybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Maintainer?: Maybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Owner?: Maybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  Person?: Maybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormData?: Maybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: Maybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: Maybe<BoolFieldUpdateOperationsInput>;
  contract?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: Maybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: Maybe<BoolFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  isNSF?: Maybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  observations?: Maybe<StringFieldUpdateOperationsInput>;
  placeholderName?: Maybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateWithoutFinancialTeamWalletInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  Documents?: Maybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: Maybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Maintainer?: Maybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Owner?: Maybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  Person?: Maybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormData?: Maybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: Maybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: Maybe<BoolFieldUpdateOperationsInput>;
  contract?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: Maybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: Maybe<BoolFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  isNSF?: Maybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  observations?: Maybe<StringFieldUpdateOperationsInput>;
  placeholderName?: Maybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateWithoutMainTeamOfMaintainerInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  Documents?: Maybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: Maybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  Maintainer?: Maybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Owner?: Maybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  Person?: Maybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormData?: Maybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: Maybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: Maybe<BoolFieldUpdateOperationsInput>;
  contract?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: Maybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: Maybe<BoolFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  isNSF?: Maybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  observations?: Maybe<StringFieldUpdateOperationsInput>;
  placeholderName?: Maybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateWithoutMaintainerInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  Documents?: Maybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: Maybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Owner?: Maybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  Person?: Maybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormData?: Maybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: Maybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: Maybe<BoolFieldUpdateOperationsInput>;
  contract?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: Maybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: Maybe<BoolFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  isNSF?: Maybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  observations?: Maybe<StringFieldUpdateOperationsInput>;
  placeholderName?: Maybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateWithoutOwnerInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  Documents?: Maybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: Maybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Maintainer?: Maybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Person?: Maybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormData?: Maybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: Maybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: Maybe<BoolFieldUpdateOperationsInput>;
  contract?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: Maybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: Maybe<BoolFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  isNSF?: Maybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  observations?: Maybe<StringFieldUpdateOperationsInput>;
  placeholderName?: Maybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateWithoutPersonInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  Documents?: Maybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: Maybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Maintainer?: Maybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Owner?: Maybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  ReusableFormData?: Maybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: Maybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: Maybe<BoolFieldUpdateOperationsInput>;
  contract?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: Maybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: Maybe<BoolFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  isNSF?: Maybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  observations?: Maybe<StringFieldUpdateOperationsInput>;
  placeholderName?: Maybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateWithoutReusableFormDataCurriculumInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  Documents?: Maybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: Maybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Maintainer?: Maybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Owner?: Maybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  Person?: Maybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormData?: Maybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: Maybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: Maybe<BoolFieldUpdateOperationsInput>;
  contract?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: Maybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: Maybe<BoolFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  isNSF?: Maybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  observations?: Maybe<StringFieldUpdateOperationsInput>;
  placeholderName?: Maybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateWithoutReusableFormDataInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  Documents?: Maybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: Maybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Maintainer?: Maybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Owner?: Maybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  Person?: Maybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: Maybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: Maybe<BoolFieldUpdateOperationsInput>;
  contract?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: Maybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: Maybe<BoolFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  isNSF?: Maybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  observations?: Maybe<StringFieldUpdateOperationsInput>;
  placeholderName?: Maybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateWithoutSystemAuditLogsInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  Documents?: Maybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: Maybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Maintainer?: Maybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Owner?: Maybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  Person?: Maybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormData?: Maybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: Maybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: Maybe<BoolFieldUpdateOperationsInput>;
  contract?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: Maybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: Maybe<BoolFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  isNSF?: Maybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  observations?: Maybe<StringFieldUpdateOperationsInput>;
  placeholderName?: Maybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateWithoutTeamEducationLevelInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  Documents?: Maybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: Maybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Maintainer?: Maybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Owner?: Maybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  Person?: Maybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormData?: Maybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamMember?: Maybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: Maybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: Maybe<BoolFieldUpdateOperationsInput>;
  contract?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: Maybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: Maybe<BoolFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  isNSF?: Maybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  observations?: Maybe<StringFieldUpdateOperationsInput>;
  placeholderName?: Maybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateWithoutTeamMemberInput = {
  ApiKey?: Maybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: Maybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: Maybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  Documents?: Maybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: Maybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Maintainer?: Maybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Owner?: Maybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  Person?: Maybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormData?: Maybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: Maybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: Maybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  cnpj?: Maybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: Maybe<BoolFieldUpdateOperationsInput>;
  contract?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: Maybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: Maybe<BoolFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  isNSF?: Maybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: Maybe<NullableStringFieldUpdateOperationsInput>;
  observations?: Maybe<StringFieldUpdateOperationsInput>;
  placeholderName?: Maybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: Maybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: Maybe<NullableStringFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpsertWithWhereUniqueWithoutMaintainerInput = {
  create: TeamCreateWithoutMaintainerInput;
  update: TeamUpdateWithoutMaintainerInput;
  where: TeamWhereUniqueInput;
};

export type TeamUpsertWithWhereUniqueWithoutOwnerInput = {
  create: TeamCreateWithoutOwnerInput;
  update: TeamUpdateWithoutOwnerInput;
  where: TeamWhereUniqueInput;
};

export type TeamUpsertWithoutApiKeyInput = {
  create: TeamCreateWithoutApiKeyInput;
  update: TeamUpdateWithoutApiKeyInput;
  where?: Maybe<TeamWhereInput>;
};

export type TeamUpsertWithoutBulkCertificateRecordInput = {
  create: TeamCreateWithoutBulkCertificateRecordInput;
  update: TeamUpdateWithoutBulkCertificateRecordInput;
  where?: Maybe<TeamWhereInput>;
};

export type TeamUpsertWithoutCertificateBaseInput = {
  create: TeamCreateWithoutCertificateBaseInput;
  update: TeamUpdateWithoutCertificateBaseInput;
  where?: Maybe<TeamWhereInput>;
};

export type TeamUpsertWithoutCertificateTemplatesInput = {
  create: TeamCreateWithoutCertificateTemplatesInput;
  update: TeamUpdateWithoutCertificateTemplatesInput;
  where?: Maybe<TeamWhereInput>;
};

export type TeamUpsertWithoutDefaultSignatureInviteConfigurationsInput = {
  create: TeamCreateWithoutDefaultSignatureInviteConfigurationsInput;
  update: TeamUpdateWithoutDefaultSignatureInviteConfigurationsInput;
  where?: Maybe<TeamWhereInput>;
};

export type TeamUpsertWithoutDocumentsInput = {
  create: TeamCreateWithoutDocumentsInput;
  update: TeamUpdateWithoutDocumentsInput;
  where?: Maybe<TeamWhereInput>;
};

export type TeamUpsertWithoutEnabledInstitutionInput = {
  create: TeamCreateWithoutEnabledInstitutionInput;
  update: TeamUpdateWithoutEnabledInstitutionInput;
  where?: Maybe<TeamWhereInput>;
};

export type TeamUpsertWithoutFinancialTeamWalletInput = {
  create: TeamCreateWithoutFinancialTeamWalletInput;
  update: TeamUpdateWithoutFinancialTeamWalletInput;
  where?: Maybe<TeamWhereInput>;
};

export type TeamUpsertWithoutMainTeamOfMaintainerInput = {
  create: TeamCreateWithoutMainTeamOfMaintainerInput;
  update: TeamUpdateWithoutMainTeamOfMaintainerInput;
  where?: Maybe<TeamWhereInput>;
};

export type TeamUpsertWithoutPersonInput = {
  create: TeamCreateWithoutPersonInput;
  update: TeamUpdateWithoutPersonInput;
  where?: Maybe<TeamWhereInput>;
};

export type TeamUpsertWithoutReusableFormDataCurriculumInput = {
  create: TeamCreateWithoutReusableFormDataCurriculumInput;
  update: TeamUpdateWithoutReusableFormDataCurriculumInput;
  where?: Maybe<TeamWhereInput>;
};

export type TeamUpsertWithoutReusableFormDataInput = {
  create: TeamCreateWithoutReusableFormDataInput;
  update: TeamUpdateWithoutReusableFormDataInput;
  where?: Maybe<TeamWhereInput>;
};

export type TeamUpsertWithoutSystemAuditLogsInput = {
  create: TeamCreateWithoutSystemAuditLogsInput;
  update: TeamUpdateWithoutSystemAuditLogsInput;
  where?: Maybe<TeamWhereInput>;
};

export type TeamUpsertWithoutTeamEducationLevelInput = {
  create: TeamCreateWithoutTeamEducationLevelInput;
  update: TeamUpdateWithoutTeamEducationLevelInput;
  where?: Maybe<TeamWhereInput>;
};

export type TeamUpsertWithoutTeamMemberInput = {
  create: TeamCreateWithoutTeamMemberInput;
  update: TeamUpdateWithoutTeamMemberInput;
  where?: Maybe<TeamWhereInput>;
};

export type TeamWhereInput = {
  AND?: Maybe<Array<TeamWhereInput>>;
  ApiKey?: Maybe<ApiKeyListRelationFilter>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordListRelationFilter>;
  CertificateBase?: Maybe<CertificateBaseListRelationFilter>;
  CertificateTemplates?: Maybe<CertificateTemplateListRelationFilter>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationListRelationFilter>;
  Documents?: Maybe<DocumentBaseListRelationFilter>;
  EnabledInstitution?: Maybe<EnabledInstitutionWhereInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletWhereInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerWhereInput>;
  Maintainer?: Maybe<MaintainerWhereInput>;
  NOT?: Maybe<Array<TeamWhereInput>>;
  OR?: Maybe<Array<TeamWhereInput>>;
  Owner?: Maybe<CommonUserWhereInput>;
  Person?: Maybe<PersonListRelationFilter>;
  ReusableFormData?: Maybe<ReusableFormDataListRelationFilter>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumListRelationFilter>;
  SystemAuditLogs?: Maybe<SystemAuditLogListRelationFilter>;
  TeamEducationLevel?: Maybe<TeamEducationLevelListRelationFilter>;
  TeamMember?: Maybe<TeamMemberListRelationFilter>;
  cnpj?: Maybe<StringNullableFilter>;
  commonUserId?: Maybe<IntFilter>;
  configAddDocumentSignerNode?: Maybe<BoolFilter>;
  contract?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deactivationReason?: Maybe<StringNullableFilter>;
  enabledInstitutionId?: Maybe<IntNullableFilter>;
  externalSignatureWebhookURL?: Maybe<StringNullableFilter>;
  faviconBase64?: Maybe<StringNullableFilter>;
  financialShouldCharge?: Maybe<BoolFilter>;
  id?: Maybe<IntFilter>;
  isActive?: Maybe<BoolFilter>;
  isNSF?: Maybe<BoolFilter>;
  lastActivityAt?: Maybe<DateTimeFilter>;
  logoBase64?: Maybe<StringNullableFilter>;
  maintainerId?: Maybe<IntNullableFilter>;
  observations?: Maybe<StringFilter>;
  placeholderName?: Maybe<StringFilter>;
  publicViewDegreeDomainPath?: Maybe<StringNullableFilter>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<StringNullableFilter>;
  publicViewInstitutionName?: Maybe<StringNullableFilter>;
  publicViewPrimaryColor?: Maybe<StringNullableFilter>;
  publicViewSchoolCurriculumDomainPath?: Maybe<StringNullableFilter>;
  publicViewSecondaryColor?: Maybe<StringNullableFilter>;
  syncWithLedgerDoc?: Maybe<BoolFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
  validateCertificateURL?: Maybe<StringNullableFilter>;
};

export type TeamWhereUniqueInput = {
  AND?: Maybe<Array<TeamWhereInput>>;
  ApiKey?: Maybe<ApiKeyListRelationFilter>;
  BulkCertificateRecord?: Maybe<BulkCertificateRecordListRelationFilter>;
  CertificateBase?: Maybe<CertificateBaseListRelationFilter>;
  CertificateTemplates?: Maybe<CertificateTemplateListRelationFilter>;
  DefaultSignatureInviteConfigurations?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationListRelationFilter>;
  Documents?: Maybe<DocumentBaseListRelationFilter>;
  EnabledInstitution?: Maybe<EnabledInstitutionWhereInput>;
  FinancialTeamWallet?: Maybe<FinancialTeamWalletWhereInput>;
  MainTeamOfMaintainer?: Maybe<MaintainerWhereInput>;
  Maintainer?: Maybe<MaintainerWhereInput>;
  NOT?: Maybe<Array<TeamWhereInput>>;
  OR?: Maybe<Array<TeamWhereInput>>;
  Owner?: Maybe<CommonUserWhereInput>;
  Person?: Maybe<PersonListRelationFilter>;
  ReusableFormData?: Maybe<ReusableFormDataListRelationFilter>;
  ReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculumListRelationFilter>;
  SystemAuditLogs?: Maybe<SystemAuditLogListRelationFilter>;
  TeamEducationLevel?: Maybe<TeamEducationLevelListRelationFilter>;
  TeamMember?: Maybe<TeamMemberListRelationFilter>;
  cnpj?: Maybe<StringNullableFilter>;
  commonUserId?: Maybe<IntFilter>;
  configAddDocumentSignerNode?: Maybe<BoolFilter>;
  contract?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  deactivationReason?: Maybe<StringNullableFilter>;
  enabledInstitutionId?: Maybe<Scalars['Int']>;
  externalSignatureWebhookURL?: Maybe<StringNullableFilter>;
  faviconBase64?: Maybe<StringNullableFilter>;
  financialShouldCharge?: Maybe<BoolFilter>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<BoolFilter>;
  isNSF?: Maybe<BoolFilter>;
  lastActivityAt?: Maybe<DateTimeFilter>;
  logoBase64?: Maybe<StringNullableFilter>;
  maintainerId?: Maybe<IntNullableFilter>;
  observations?: Maybe<StringFilter>;
  placeholderName?: Maybe<StringFilter>;
  publicViewDegreeDomainPath?: Maybe<Scalars['String']>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<Scalars['String']>;
  publicViewInstitutionName?: Maybe<StringNullableFilter>;
  publicViewPrimaryColor?: Maybe<StringNullableFilter>;
  publicViewSchoolCurriculumDomainPath?: Maybe<Scalars['String']>;
  publicViewSecondaryColor?: Maybe<StringNullableFilter>;
  syncWithLedgerDoc?: Maybe<BoolFilter>;
  updatedAt?: Maybe<DateTimeNullableFilter>;
  validateCertificateURL?: Maybe<StringNullableFilter>;
};

export type Telephone = {
  __typename?: 'Telephone';
  Person: Person;
  id: Scalars['Int'];
  number: Scalars['String'];
  personId: Scalars['String'];
};

export type TelephoneAvgOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
};

export type TelephoneCountOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  number?: Maybe<SortOrder>;
  personId?: Maybe<SortOrder>;
};

export type TelephoneCreateInput = {
  Person: PersonCreateNestedOneWithoutPhonesInput;
  number: Scalars['String'];
};

export type TelephoneCreateManyInput = {
  id?: Maybe<Scalars['Int']>;
  number: Scalars['String'];
  personId: Scalars['String'];
};

export type TelephoneCreateManyPersonInput = {
  id?: Maybe<Scalars['Int']>;
  number: Scalars['String'];
};

export type TelephoneCreateManyPersonInputEnvelope = {
  data: Array<TelephoneCreateManyPersonInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type TelephoneCreateNestedManyWithoutPersonInput = {
  connect?: Maybe<Array<TelephoneWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TelephoneCreateOrConnectWithoutPersonInput>>;
  create?: Maybe<Array<TelephoneCreateWithoutPersonInput>>;
  createMany?: Maybe<TelephoneCreateManyPersonInputEnvelope>;
};

export type TelephoneCreateOrConnectWithoutPersonInput = {
  create: TelephoneCreateWithoutPersonInput;
  where: TelephoneWhereUniqueInput;
};

export type TelephoneCreateWithoutPersonInput = {
  number: Scalars['String'];
};

export type TelephoneListRelationFilter = {
  every?: Maybe<TelephoneWhereInput>;
  none?: Maybe<TelephoneWhereInput>;
  some?: Maybe<TelephoneWhereInput>;
};

export type TelephoneMaxOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  number?: Maybe<SortOrder>;
  personId?: Maybe<SortOrder>;
};

export type TelephoneMinOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
  number?: Maybe<SortOrder>;
  personId?: Maybe<SortOrder>;
};

export type TelephoneOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type TelephoneOrderByWithAggregationInput = {
  _avg?: Maybe<TelephoneAvgOrderByAggregateInput>;
  _count?: Maybe<TelephoneCountOrderByAggregateInput>;
  _max?: Maybe<TelephoneMaxOrderByAggregateInput>;
  _min?: Maybe<TelephoneMinOrderByAggregateInput>;
  _sum?: Maybe<TelephoneSumOrderByAggregateInput>;
  id?: Maybe<SortOrder>;
  number?: Maybe<SortOrder>;
  personId?: Maybe<SortOrder>;
};

export type TelephoneOrderByWithRelationInput = {
  Person?: Maybe<PersonOrderByWithRelationInput>;
  id?: Maybe<SortOrder>;
  number?: Maybe<SortOrder>;
  personId?: Maybe<SortOrder>;
};

export enum TelephoneScalarFieldEnum {
  Id = 'id',
  Number = 'number',
  PersonId = 'personId'
}

export type TelephoneScalarWhereInput = {
  AND?: Maybe<Array<TelephoneScalarWhereInput>>;
  NOT?: Maybe<Array<TelephoneScalarWhereInput>>;
  OR?: Maybe<Array<TelephoneScalarWhereInput>>;
  id?: Maybe<IntFilter>;
  number?: Maybe<StringFilter>;
  personId?: Maybe<StringFilter>;
};

export type TelephoneScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<TelephoneScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<TelephoneScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<TelephoneScalarWhereWithAggregatesInput>>;
  id?: Maybe<IntWithAggregatesFilter>;
  number?: Maybe<StringWithAggregatesFilter>;
  personId?: Maybe<StringWithAggregatesFilter>;
};

export type TelephoneSumOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
};

export type TelephoneUpdateInput = {
  Person?: Maybe<PersonUpdateOneRequiredWithoutPhonesNestedInput>;
  number?: Maybe<StringFieldUpdateOperationsInput>;
};

export type TelephoneUpdateManyMutationInput = {
  number?: Maybe<StringFieldUpdateOperationsInput>;
};

export type TelephoneUpdateManyWithWhereWithoutPersonInput = {
  data: TelephoneUpdateManyMutationInput;
  where: TelephoneScalarWhereInput;
};

export type TelephoneUpdateManyWithoutPersonNestedInput = {
  connect?: Maybe<Array<TelephoneWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<TelephoneCreateOrConnectWithoutPersonInput>>;
  create?: Maybe<Array<TelephoneCreateWithoutPersonInput>>;
  createMany?: Maybe<TelephoneCreateManyPersonInputEnvelope>;
  delete?: Maybe<Array<TelephoneWhereUniqueInput>>;
  deleteMany?: Maybe<Array<TelephoneScalarWhereInput>>;
  disconnect?: Maybe<Array<TelephoneWhereUniqueInput>>;
  set?: Maybe<Array<TelephoneWhereUniqueInput>>;
  update?: Maybe<Array<TelephoneUpdateWithWhereUniqueWithoutPersonInput>>;
  updateMany?: Maybe<Array<TelephoneUpdateManyWithWhereWithoutPersonInput>>;
  upsert?: Maybe<Array<TelephoneUpsertWithWhereUniqueWithoutPersonInput>>;
};

export type TelephoneUpdateWithWhereUniqueWithoutPersonInput = {
  data: TelephoneUpdateWithoutPersonInput;
  where: TelephoneWhereUniqueInput;
};

export type TelephoneUpdateWithoutPersonInput = {
  number?: Maybe<StringFieldUpdateOperationsInput>;
};

export type TelephoneUpsertWithWhereUniqueWithoutPersonInput = {
  create: TelephoneCreateWithoutPersonInput;
  update: TelephoneUpdateWithoutPersonInput;
  where: TelephoneWhereUniqueInput;
};

export type TelephoneWhereInput = {
  AND?: Maybe<Array<TelephoneWhereInput>>;
  NOT?: Maybe<Array<TelephoneWhereInput>>;
  OR?: Maybe<Array<TelephoneWhereInput>>;
  Person?: Maybe<PersonWhereInput>;
  id?: Maybe<IntFilter>;
  number?: Maybe<StringFilter>;
  personId?: Maybe<StringFilter>;
};

export type TelephoneWhereUniqueInput = {
  AND?: Maybe<Array<TelephoneWhereInput>>;
  NOT?: Maybe<Array<TelephoneWhereInput>>;
  OR?: Maybe<Array<TelephoneWhereInput>>;
  Person?: Maybe<PersonWhereInput>;
  id?: Maybe<Scalars['Int']>;
  number?: Maybe<StringFilter>;
  personId?: Maybe<StringFilter>;
};

export enum TransactionIsolationLevel {
  ReadCommitted = 'ReadCommitted',
  ReadUncommitted = 'ReadUncommitted',
  RepeatableRead = 'RepeatableRead',
  Serializable = 'Serializable'
}

export type UpdateOneTeamData = {
  /** Contract URL */
  contract?: Maybe<Scalars['String']>;
  educationLevelTypes?: Maybe<Array<EducationLevelType>>;
  externalSignatureWebhookURL?: Maybe<Scalars['String']>;
  faviconBase64?: Maybe<Scalars['String']>;
  isMaintainer?: Maybe<Scalars['Boolean']>;
  isNSF?: Maybe<Scalars['Boolean']>;
  logoBase64?: Maybe<Scalars['String']>;
  observations?: Maybe<Scalars['String']>;
  publicCertificateAutenticateURL?: Maybe<Scalars['String']>;
  publicViewDegreeDomainPath?: Maybe<Scalars['String']>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<Scalars['String']>;
  publicViewInstitutionName?: Maybe<Scalars['String']>;
  publicViewPrimaryColor?: Maybe<Scalars['String']>;
  publicViewSchoolCurriculumDomainPath?: Maybe<Scalars['String']>;
  publicViewSecondaryColor?: Maybe<Scalars['String']>;
  syncWithLedgerDoc?: Maybe<Scalars['Boolean']>;
  teamId: Scalars['Int'];
};


export type UpsertDocumentBaseDefaultSignatureInviteConfigurationInput = {
  /** Adiciona o nó assinantes com todos os convidados assinantes eCPF. Apenas considerado se for documentação acadêmica. */
  addSignersNode?: Maybe<Scalars['Boolean']>;
  groups: Array<GroupEmails>;
  type: DocumentBaseType;
};

export type ValidationResult = {
  __typename?: 'ValidationResult';
  isValid: Scalars['Boolean'];
};

export type WatchCertificateTemplateData = {
  __typename?: 'WatchCertificateTemplateData';
  data?: Maybe<Scalars['Json']>;
};

export type WatchDocumentFocus = {
  __typename?: 'WatchDocumentFocus';
  fieldPath: Scalars['String'];
  user: CommonUser;
};

export type WatchDocumentInput = {
  documentId: Scalars['String'];
  fieldPath: Scalars['String'];
};

export type WatchDocumentPatch = {
  __typename?: 'WatchDocumentPatch';
  changes: Array<WatchDocumentPatchesChanges>;
};

export type WatchDocumentPatchesChanges = {
  __typename?: 'WatchDocumentPatchesChanges';
  propertyPath: Scalars['String'];
  type: Scalars['String'];
  value?: Maybe<Scalars['Json']>;
};

export type WatchSignBulkCertificate = {
  __typename?: 'WatchSignBulkCertificate';
  documentsCompleted: Scalars['Int'];
  status: Scalars['String'];
  totalInviteForSign: Scalars['Int'];
};

export type WatchSignValidationBulkCertificate = {
  __typename?: 'WatchSignValidationBulkCertificate';
  status: Scalars['String'];
};

export type WatchSingleCertificateSignValidationEvent = {
  __typename?: 'WatchSingleCertificateSignValidationEvent';
  status: Scalars['String'];
};

export type UpdateTeamActivationStatusArgs = {
  method: InstitutionActionMethod;
  reason?: Maybe<Scalars['String']>;
  teamId: Scalars['Int'];
};

export type ValidateOneDocumentCertificateObject = {
  __typename?: 'validateOneDocumentCertificateObject';
  certificate: DocumentCertificateHashHistory;
  validationResult: ValidationResult;
};

export type DocumentAcademicDocumentationFieldsFragment = { __typename?: 'DocumentAcademicDocumentation', documentBaseId: string, type: DocumentAcademicDocumentationType, status: DocumentAcademicDocumentationStatus, DocumentBase: (
    { __typename?: 'DocumentBase' }
    & DocumentBaseFieldsFragment
  ), ChildDocuments: Array<{ __typename?: 'DocumentFinalAcademicTranscript', documentBaseId: string, status: DocumentFinalAcademicTranscriptStatus, DocumentBase: { __typename?: 'DocumentBase', type: DocumentBaseType, internalSeqId: string, version: string, createdAt: any } }> };

export type DocumentBaseSignatureInviteFieldsFragment = { __typename?: 'DocumentBaseSignatureInvite', id: number, createdAt: any, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: Maybe<string>, email: string, cpf?: Maybe<string> } }>, TeamMember?: Maybe<{ __typename?: 'TeamMember', User: { __typename?: 'CommonUser', cpf?: Maybe<string> } }>, Group: { __typename?: 'DocumentBaseSignatureInviteGroup', id: number, order: number, DocumentBase: { __typename?: 'DocumentBase', internalSeqId: string, version: string, type: DocumentBaseType, createdAt: any, UserOwner: { __typename?: 'CommonUser', email: string }, DocumentBaseSignatureInviteGroups: Array<(
        { __typename?: 'DocumentBaseSignatureInviteGroup' }
        & DocumentBaseSignatureInviteGroupFieldsFragment
      )>, DocumentAcademicDocumentation?: Maybe<{ __typename?: 'DocumentAcademicDocumentation', searchStudentName: string, searchCourse: string, searchCPF: string, searchEmecCode: string }>, DocumentDegree?: Maybe<{ __typename?: 'DocumentDegree', searchStudentName: string, searchCourse: string, searchCPF: string, searchEmecCode: string }>, DocumentFinalAcademicTranscript?: Maybe<{ __typename?: 'DocumentFinalAcademicTranscript', searchStudentName: string, searchCourse: string, searchCPF: string, searchEmecCode: string }>, DocumentAuditFileIssuer?: Maybe<{ __typename?: 'DocumentAuditFileIssuer', searchAuditStartDate: any, searchAuditEndDate: any }> } } };

export type DocumentBaseSignatureInviteGroupFieldsFragment = { __typename?: 'DocumentBaseSignatureInviteGroup', order: number, id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, TeamMember?: Maybe<(
      { __typename?: 'TeamMember' }
      & TeamMemberFieldsFragment
    )>, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: Maybe<string>, email: string, cpf?: Maybe<string> } }> }> };

export type DocumentBaseFieldsFragment = { __typename?: 'DocumentBase', type: DocumentBaseType, internalSeqId: string, version: string, createdAt: any, updatedAt?: Maybe<any>, creationType: DocumentAcademicDocumentationCreationType, data: any, filePath?: Maybe<string>, signatureConfig: Array<SignatureType>, UserOwner: { __typename?: 'CommonUser', id: number, email: string }, DocumentBaseSignatureInviteGroups: Array<(
    { __typename?: 'DocumentBaseSignatureInviteGroup' }
    & DocumentBaseSignatureInviteGroupFieldsFragment
  )>, Histories: Array<{ __typename?: 'DocumentBaseHistory', id: number, description?: Maybe<string>, status?: Maybe<string>, createdAt: any, data?: Maybe<any>, UserCreated?: Maybe<{ __typename?: 'CommonUser', id: number, name?: Maybe<string>, photo?: Maybe<string>, email: string }> }> };

export type DocumentDegreeFieldsFragment = { __typename?: 'DocumentDegree', documentBaseId: string, searchStudentName: string, searchCPF: string, searchCourse: string, searchEmecCode: string, status: DocumentDegreeStatus, searchValidationCode: string, searchIssueDate: any, searchRegistrationDate: any, DocumentBase: { __typename?: 'DocumentBase', internalSeqId: string, createdAt: any } };

export type DocumentDegreeUniqueFieldsFragment = { __typename?: 'DocumentDegree', documentBaseId: string, visualRepresentationPath?: Maybe<string>, searchStudentName: string, searchCPF: string, searchCourse: string, searchValidationCode: string, status: DocumentDegreeStatus, ParentAcademicDocumentation?: Maybe<{ __typename?: 'DocumentAcademicDocumentation', DocumentBase: { __typename?: 'DocumentBase', internalSeqId: string } }>, DocumentBase: (
    { __typename?: 'DocumentBase', filePath?: Maybe<string>, type: DocumentBaseType, UserOwner: { __typename?: 'CommonUser', id: number } }
    & DocumentBaseFieldsFragment
  ) };

export type PersonFieldsFragment = { __typename?: 'Person', name: string, receivesCertificateEmail: boolean, receivesCertificateWhatsapp: boolean, cpf?: Maybe<string>, birthDate?: Maybe<string>, identityDocument?: Maybe<string>, email?: Maybe<string>, isForeign: boolean, passport?: Maybe<string>, Phones: Array<{ __typename?: 'Telephone', number: string }>, Address?: Maybe<{ __typename?: 'Address', city?: Maybe<string>, complement?: Maybe<string>, neighborhood?: Maybe<string>, postalCode?: Maybe<string>, state?: Maybe<string>, street?: Maybe<string> }> };

export type DocumentSchoolCurriculumFieldsFragment = { __typename?: 'DocumentSchoolCurriculum', searchSchoolCurriculumName: string, searchSchoolCurriculumCode: string, documentBaseId: string, status: DocumentSchoolCurriculumStatus, DocumentBase: (
    { __typename?: 'DocumentBase' }
    & DocumentBaseFieldsFragment
  ) };

export type SystemGlobalAlertFieldsFragment = { __typename?: 'SystemGlobalAlert', id: number, type: SystemGlobalAlertType, value: string, actionUrl?: Maybe<string>, actionTitle?: Maybe<string>, message?: Maybe<string>, forcedTitle: string, forcedDescription: string, forcedActionUrl?: Maybe<string>, myDismissonsCount: number };

export type TeamFieldsFragment = { __typename?: 'Team', isNSF: boolean, cnpj?: Maybe<string>, createdAt: any, TeamMember: Array<{ __typename?: 'TeamMember', role?: Maybe<string>, User: { __typename?: 'CommonUser', name?: Maybe<string>, cpf?: Maybe<string>, email: string, createdAt: any } }>, TeamEducationLevel: Array<{ __typename?: 'TeamEducationLevel', educationLevelType: EducationLevelType }> };

export type TeamMemberFieldsFragment = { __typename?: 'TeamMember', id: number, role?: Maybe<string>, createdAt: any, User: { __typename?: 'CommonUser', email: string, cpf?: Maybe<string>, name?: Maybe<string>, photo?: Maybe<string> }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', Permission: { __typename?: 'Permission', code: string } }> };

export type UserFieldsFragment = { __typename?: 'CommonUser', id: number, email: string, createdAt: any, institutionCnpj?: Maybe<string>, name?: Maybe<string>, cpf?: Maybe<string>, photo?: Maybe<string>, permissions: Array<string>, teamId?: Maybe<number>, computedResolvedAt: string, loggedAs?: Maybe<boolean>, defaultSignatureImageId?: Maybe<string>, UserConfigs: Array<{ __typename?: 'CommonUserConfig', key: string, value: any }>, Team: { __typename?: 'Team', financialShouldCharge: boolean, isNSF: boolean, issuerData?: Maybe<any>, id: number, configAddDocumentSignerNode: boolean, publicViewDegreeDomainPath?: Maybe<string>, publicViewFinalAcademicTranscriptDomainPath?: Maybe<string>, publicViewSchoolCurriculumDomainPath?: Maybe<string>, externalSignatureWebhookURL?: Maybe<string>, placeholderName: string, FinancialTeamWallet?: Maybe<{ __typename?: 'FinancialTeamWallet', creditsPlanVisual: number, creditsPlanTrial: number, creditsPlanRb: number, creditsPlanRtRa: number, creditsDetachedVisual: number, creditsDetachedRb: number, creditsDetachedRtRa: number, teamId: number, SubscriptionActive?: Maybe<{ __typename?: 'FinancialTeamWalletSubscription', id: string, plan: FinancialPlan, billingCycle?: Maybe<FinancialBillingCycle>, planName?: Maybe<string>, canceledAt?: Maybe<any>, nextDueDate?: Maybe<any>, annualCreditQuotaResetDate?: Maybe<any>, createdAt: any, planUpdatedPrice: number }> }>, TeamEducationLevel: Array<{ __typename?: 'TeamEducationLevel', educationLevelType: EducationLevelType }> }, UserAlerts: Array<(
    { __typename?: 'SystemGlobalAlert' }
    & SystemGlobalAlertFieldsFragment
  )>, MaintainerAdmin?: Maybe<{ __typename?: 'MaintainerAdmin', Maintainer: { __typename?: 'Maintainer', id: number, Teams: Array<{ __typename?: 'Team', isActive: boolean, issuerName?: Maybe<string>, placeholderName: string, id: number }> } }> };

export type AddOneTeamMemberMutationVariables = Exact<{
  email: Scalars['String'];
  permissions: Array<Scalars['String']> | Scalars['String'];
  role?: Maybe<Scalars['String']>;
}>;


export type AddOneTeamMemberMutation = { addOneTeamMember: { __typename?: 'TeamMember', id: number } };

export type BuildOneDegreeVisualRepresentationMutationVariables = Exact<{
  degreeId: Scalars['String'];
  templateId: Scalars['String'];
  variables: Scalars['Json'];
}>;


export type BuildOneDegreeVisualRepresentationMutation = { buildOneDegreeVisualRepresentation?: Maybe<{ __typename?: 'DocumentDegree', documentBaseId: string, visualRepresentationPath?: Maybe<string> }> };

export type CodeAuthLoginLedgerSignMutationVariables = Exact<{
  token: Scalars['String'];
  subservice: SubService;
}>;


export type CodeAuthLoginLedgerSignMutation = { codeAuthLoginLedgerSign: (
    { __typename?: 'CommonUser' }
    & UserFieldsFragment
  ) };

export type CodeAuthRefreshTokensMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type CodeAuthRefreshTokensMutation = { codeAuthRefreshTokens: { __typename?: 'CommonUser', id: number } };

export type CodeServiceSendMessageToSlackMutationVariables = Exact<{
  message: Scalars['String'];
}>;


export type CodeServiceSendMessageToSlackMutation = { codeServiceSendMessageToSlack: string };

export type CompleteOneTemporarySignatureImageMutationVariables = Exact<{
  completeData: CompleteSignatureImage;
}>;


export type CompleteOneTemporarySignatureImageMutation = { completeOneTemporarySignatureImage: { __typename?: 'SignSignatureImage', id: string } };

export type CorrectOneDocumentAuditFileIssuerMutationVariables = Exact<{
  degreeCount: Scalars['Int'];
  documentBaseId: Scalars['String'];
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
  excludeRevoked: Scalars['Boolean'];
}>;


export type CorrectOneDocumentAuditFileIssuerMutation = { correctOneDocumentAuditFileIssuer: { __typename?: 'DocumentAuditFileIssuer', documentBaseId: string } };

export type CreateApiKeyMutationVariables = Exact<{
  description: Scalars['String'];
}>;


export type CreateApiKeyMutation = { createApiKey: string };

export type CreateBulkDocumentCertificateMutationVariables = Exact<{
  curriculumId?: Maybe<Scalars['String']>;
  templateId: Scalars['String'];
  variables: Scalars['Json'];
  importedRecords: Scalars['Json'];
  bulkCertificateRecordName: Scalars['String'];
  eventId?: Maybe<Scalars['String']>;
  ignoreUsingExpensiveCreditsError?: Maybe<Scalars['Boolean']>;
}>;


export type CreateBulkDocumentCertificateMutation = { createBulkDocumentCertificate: { __typename?: 'BulkCertificateRecord', id: string, createdAt: any, totalCertificates: number } };

export type CreateOneDocumentAcademicDocumentationMutationVariables = Exact<{
  draftId: Scalars['String'];
}>;


export type CreateOneDocumentAcademicDocumentationMutation = { createOneDocumentAcademicDocumentation: (
    { __typename?: 'DocumentAcademicDocumentation' }
    & DocumentAcademicDocumentationFieldsFragment
  ) };

export type CreateOneDocumentAcademicDocumentationFromRevokedDocumentMutationVariables = Exact<{
  documentId: Scalars['String'];
}>;


export type CreateOneDocumentAcademicDocumentationFromRevokedDocumentMutation = { createOneDocumentAcademicDocumentationFromRevokedDocument: { __typename?: 'DocumentAcademicDocumentation', DocumentBase: { __typename?: 'DocumentBase', internalSeqId: string, type: DocumentBaseType } } };

export type CreateOneCertificateCourseMutationVariables = Exact<{
  areaKnowledge: Scalars['String'];
  metaData: Array<Scalars['String']> | Scalars['String'];
  name: Scalars['String'];
  courseLevelId?: Maybe<Scalars['String']>;
}>;


export type CreateOneCertificateCourseMutation = { createOneCertificateCourse: { __typename?: 'CertificateCourse', certificateBaseId: string, name: string, areaKnowledge: string, metaData: Array<string> } };

export type CreateOneCertificateCourseLevelMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type CreateOneCertificateCourseLevelMutation = { createOneCertificateCourseLevel: { __typename?: 'CertificateCourseLevel', certificateBaseId: string, name: string } };

export type CreateOneCertificateCurriculumMutationVariables = Exact<{
  amountOfHours?: Maybe<Scalars['Int']>;
  certificateCourseId: Scalars['String'];
  name: Scalars['String'];
  selectedDisciplines: Array<CirriculumSelectedDiscipline> | CirriculumSelectedDiscipline;
}>;


export type CreateOneCertificateCurriculumMutation = { createOneCertificateCurriculum: { __typename?: 'CertificateCurriculum', certificateBaseId: string, name: string, amountOfHours?: Maybe<number> } };

export type CreateOneCertificateDisciplineMutationVariables = Exact<{
  name: Scalars['String'];
  viewOnDegree: Scalars['Boolean'];
}>;


export type CreateOneCertificateDisciplineMutation = { createOneCertificateDiscipline: { __typename?: 'CertificateDiscipline', certificateBaseId: string, name: string, viewOnDegree: boolean } };

export type CreateOneCertificateEventMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type CreateOneCertificateEventMutation = { createOneCertificateEvent: { __typename?: 'CertificateEvent', certificateBaseId: string, name: string } };

export type CreateOneCertificateTeacherMutationVariables = Exact<{
  name: Scalars['String'];
  titration: Scalars['String'];
}>;


export type CreateOneCertificateTeacherMutation = { createOneCertificateTeacher: { __typename?: 'CertificateTeacher', certificateBaseId: string, name: string, titration: string } };

export type CreateOneCertificateTemplateMutationVariables = Exact<{
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  data: Scalars['Json'];
}>;


export type CreateOneCertificateTemplateMutation = { createOneCertificateTemplate: { __typename?: 'CertificateTemplate', id: string } };

export type CreateOneDegreeMutationVariables = Exact<{
  degreeDocumentAcademicDocumentationId?: Maybe<Scalars['String']>;
  visualRepresentation?: Maybe<Scalars['Upload']>;
  xml: Scalars['Upload'];
}>;


export type CreateOneDegreeMutation = { createOneDegree: { __typename?: 'DocumentDegree', documentBaseId: string, searchCPF: string, searchCourse: string, DocumentBase: { __typename?: 'DocumentBase', filePath?: Maybe<string> } } };

export type CreateOneDocumentAuditFileIssuerMutationVariables = Exact<{
  degreeCount: Scalars['Int'];
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
  version: Scalars['String'];
  excludeRevoked: Scalars['Boolean'];
}>;


export type CreateOneDocumentAuditFileIssuerMutation = { createOneDocumentAuditFileIssuer: { __typename?: 'DocumentAuditFileIssuer', documentBaseId: string } };

export type CreateOneDocumentCertificateMutationVariables = Exact<{
  curriculumId?: Maybe<Scalars['String']>;
  studentCpf: Scalars['String'];
  studentName: Scalars['String'];
  studentEmail: Scalars['String'];
  templateId: Scalars['String'];
  variables: Scalars['Json'];
  curriculumDisciplinesVariables: Array<CurriculumDisciplineVariable> | CurriculumDisciplineVariable;
  eventId?: Maybe<Scalars['String']>;
  ignoreUsingExpensiveCreditsError?: Maybe<Scalars['Boolean']>;
  personId?: Maybe<Scalars['String']>;
}>;


export type CreateOneDocumentCertificateMutation = { createOneDocumentCertificate: { __typename?: 'DocumentCertificate', documentBaseId: string, DocumentCertificateSignatureItems: Array<{ __typename?: 'DocumentCertificateSignatureItem', id: string, type: DocumentCertificateSignatureItemType, PossibleSigners: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInvite', id: number, TeamMember: { __typename?: 'TeamMember', commonUserId: number } }> }> } };

export type CreateOneDocumentCertificatePreviewMutationVariables = Exact<{
  curriculumId?: Maybe<Scalars['String']>;
  studentCpf: Scalars['String'];
  studentName: Scalars['String'];
  studentEmail: Scalars['String'];
  templateId: Scalars['String'];
  variables: Scalars['Json'];
  curriculumDisciplinesVariables: Array<CurriculumDisciplineVariable> | CurriculumDisciplineVariable;
  eventId?: Maybe<Scalars['String']>;
  degreeId?: Maybe<Scalars['String']>;
}>;


export type CreateOneDocumentCertificatePreviewMutation = { createOneDocumentCertificatePreview: string };

export type CreateOneDocumentSchoolCurriculumMutationVariables = Exact<{
  createOneDocumentSchoolCurriculumId: Scalars['String'];
}>;


export type CreateOneDocumentSchoolCurriculumMutation = { createOneDocumentSchoolCurriculum: (
    { __typename?: 'DocumentSchoolCurriculum' }
    & DocumentSchoolCurriculumFieldsFragment
  ) };

export type CreateOneEnabledInstitutionMutationVariables = Exact<{
  data: CreateOneEnabledInstitutionInput;
}>;


export type CreateOneEnabledInstitutionMutation = { createOneEnabledInstitution: { __typename?: 'EnabledInstitution', email: string, cnpj: string, educationLevelType: Array<EducationLevelType>, isMaintainer: boolean } };

export type CreateOneDocumentFinalAcademicTranscriptMutationVariables = Exact<{
  baseAcademicId: Scalars['String'];
}>;


export type CreateOneDocumentFinalAcademicTranscriptMutation = { createOneDocumentFinalAcademicTranscript: { __typename?: 'DocumentFinalAcademicTranscript', DocumentBase: { __typename?: 'DocumentBase', internalSeqId: string, version: string } } };

export type CreateOneFinancialRechargeMutationVariables = Exact<{
  data: CreateOneFinancialRechargeInput;
}>;


export type CreateOneFinancialRechargeMutation = { createOneFinancialRecharge: { __typename?: 'FinancialRecharge', id: number } };

export type CreateOneMaintainerAdminMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type CreateOneMaintainerAdminMutation = { createOneMaintainerAdmin: { __typename?: 'MaintainerAdmin', maintainerId: number } };

export type CreateOnePersonMutationVariables = Exact<{
  isForeign: Scalars['Boolean'];
  name: Scalars['String'];
  receivesCertificateEmail: Scalars['Boolean'];
  receivesCertificateWhatsapp: Scalars['Boolean'];
  phones: Array<Scalars['String']> | Scalars['String'];
  cpf?: Maybe<Scalars['String']>;
  passport?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  identityDocument?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['String']>;
  address?: Maybe<AddressInput>;
}>;


export type CreateOnePersonMutation = { createOnePerson: { __typename?: 'Person', id: string, name: string, createdAt: any } };

export type CreateOneReusableFormDataCurriculumMutationVariables = Exact<{
  data: ReusableFormDataCurriculumCreateInputCustom;
}>;


export type CreateOneReusableFormDataCurriculumMutation = { createOneReusableFormDataCurriculum: { __typename?: 'ReusableFormDataCurriculum', id: number } };

export type CreateOneSignSignatureImageMutationVariables = Exact<{
  data: CreateOneSignSignatureImageData;
}>;


export type CreateOneSignSignatureImageMutation = { createOneSignSignatureImage: { __typename?: 'SignSignatureImage', id: string } };

export type CreateOneSystemGlobalAlertMutationVariables = Exact<{
  data: SystemGlobalAlertCreateInput;
}>;


export type CreateOneSystemGlobalAlertMutation = { createOneSystemGlobalAlert: { __typename?: 'SystemGlobalAlert', id: number } };

export type CreateOneTeamEducationLevelMutationVariables = Exact<{
  data: TeamEducationLevelCreateInput;
}>;


export type CreateOneTeamEducationLevelMutation = { createOneTeamEducationLevel: { __typename?: 'TeamEducationLevel', id: number, teamId: number, educationLevelType: EducationLevelType } };

export type DefineOneSignSignatureImageAsPrimaryMutationVariables = Exact<{
  where: SignSignatureImageWhereUniqueInput;
}>;


export type DefineOneSignSignatureImageAsPrimaryMutation = { defineOneSignSignatureImageAsPrimary?: Maybe<{ __typename?: 'SignSignatureImage', id: string }> };

export type DefineSignersMutationVariables = Exact<{
  data: InviteGroups;
  addSignersNode?: Maybe<Scalars['Boolean']>;
  saveDefault?: Maybe<Scalars['Boolean']>;
}>;


export type DefineSignersMutation = { defineSigners: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', id: number }> };

export type DeleteOneApiKeyMutationVariables = Exact<{
  apiKeyId: Scalars['Int'];
}>;


export type DeleteOneApiKeyMutation = { deleteOneApiKey?: Maybe<{ __typename?: 'ApiKey', id: number }> };

export type DeleteOneCertificateBaseMutationVariables = Exact<{
  certificateId: Scalars['String'];
}>;


export type DeleteOneCertificateBaseMutation = { deleteOneCertificateBase?: Maybe<{ __typename?: 'CertificateBase', id: string }> };

export type DeleteOneCertificateTemplateMutationVariables = Exact<{
  where: CertificateTemplateWhereUniqueInput;
}>;


export type DeleteOneCertificateTemplateMutation = { deleteOneCertificateTemplate?: Maybe<{ __typename?: 'CertificateTemplate', id: string }> };

export type DeleteOneDegreeVisualRepresentationMutationVariables = Exact<{
  degreeId: Scalars['String'];
}>;


export type DeleteOneDegreeVisualRepresentationMutation = { deleteOneDegreeVisualRepresentation?: Maybe<{ __typename?: 'DocumentDegree', documentBaseId: string, visualRepresentationPath?: Maybe<string> }> };

export type DeleteOneDocumentBaseMutationVariables = Exact<{
  deleteOneDocumentBaseId: Scalars['String'];
}>;


export type DeleteOneDocumentBaseMutation = { deleteOneDocumentBase?: Maybe<{ __typename?: 'DocumentBase', internalSeqId: string, type: DocumentBaseType }> };

export type DeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutation = { deleteOneDocumentBaseDefaultSignatureInviteConfiguration: { __typename?: 'DocumentBaseDefaultSignatureInviteConfiguration', id: number } };

export type DeleteOneTeamEducationLevelMutationVariables = Exact<{
  where: TeamEducationLevelWhereUniqueInput;
}>;


export type DeleteOneTeamEducationLevelMutation = { deleteOneTeamEducationLevel?: Maybe<{ __typename?: 'TeamEducationLevel', id: number, educationLevelType: EducationLevelType }> };

export type DeleteOneFinancialCreditCardSavedMutationVariables = Exact<{
  where: FinancialCreditCardSavedWhereUniqueInput;
}>;


export type DeleteOneFinancialCreditCardSavedMutation = { deleteOneFinancialCreditCardSaved?: Maybe<{ __typename?: 'FinancialCreditCardSaved', id: number }> };

export type DeleteOneMaintainerAdminMutationVariables = Exact<{
  where: MaintainerAdminWhereUniqueInput;
}>;


export type DeleteOneMaintainerAdminMutation = { deleteOneMaintainerAdmin?: Maybe<{ __typename?: 'MaintainerAdmin', commonUserId: number }> };

export type DeleteOneMaintainerTeamMutationVariables = Exact<{
  where: TeamWhereUniqueInput;
}>;


export type DeleteOneMaintainerTeamMutation = { deleteOneMaintainerTeam?: Maybe<{ __typename?: 'Team', id: number }> };

export type DeleteOneReusableFormDataMutationVariables = Exact<{
  where: ReusableFormDataWhereUniqueInput;
}>;


export type DeleteOneReusableFormDataMutation = { deleteOneReusableFormData?: Maybe<{ __typename?: 'ReusableFormData', id: number }> };

export type DeleteOnePersonMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteOnePersonMutation = { deleteOnePerson?: Maybe<{ __typename?: 'Person', id: string }> };

export type DeleteOneReusableFormDataCurriculumMutationVariables = Exact<{
  deleteOneReusableFormDataCurriculumId: Scalars['Int'];
}>;


export type DeleteOneReusableFormDataCurriculumMutation = { deleteOneReusableFormDataCurriculum?: Maybe<{ __typename?: 'ReusableFormDataCurriculum', id: number }> };

export type DeleteOneSignSignatureImageMutationVariables = Exact<{
  where: SignSignatureImageWhereUniqueInput;
}>;


export type DeleteOneSignSignatureImageMutation = { deleteOneSignSignatureImage?: Maybe<{ __typename?: 'SignSignatureImage', id: string }> };

export type DeleteOneSystemGlobalAlertMutationVariables = Exact<{
  where: SystemGlobalAlertWhereUniqueInput;
}>;


export type DeleteOneSystemGlobalAlertMutation = { deleteOneSystemGlobalAlert?: Maybe<{ __typename?: 'SystemGlobalAlert', id: number }> };

export type DeleteOneTeamMemberMutationVariables = Exact<{
  where: TeamMemberWhereUniqueInput;
}>;


export type DeleteOneTeamMemberMutation = { deleteOneTeamMember?: Maybe<{ __typename?: 'TeamMember', id: number }> };

export type DismissSystemGlobalAlertMutationVariables = Exact<{
  dismissSystemGlobalAlertId: Scalars['Int'];
}>;


export type DismissSystemGlobalAlertMutation = { dismissSystemGlobalAlert: boolean };

export type DuplicateOneCertificateTemplateMutationVariables = Exact<{
  templateId: Scalars['String'];
}>;


export type DuplicateOneCertificateTemplateMutation = { duplicateOneCertificateTemplate: { __typename?: 'CertificateTemplate', id: string } };

export type FinalizeOneCertificateSignatureMutationVariables = Exact<{
  certificate: Scalars['String'];
  initialize: InitializeResponseInput;
  inviteId: Scalars['String'];
  signatureImageId?: Maybe<Scalars['String']>;
}>;


export type FinalizeOneCertificateSignatureMutation = { finalizeOneCertificateSignature: { __typename?: 'DocumentCertificateSignatureItemPossibleSignerInviteSignature', id: number } };

export type FinalizeOneSignatureMutationVariables = Exact<{
  certificate: Scalars['String'];
  initialize: InitializeResponseInput;
  inviteId: Scalars['Int'];
}>;


export type FinalizeOneSignatureMutation = { finalizeOneSignature: { __typename?: 'DocumentBaseSignatureInviteSignature', id: number } };

export type FinalizeOneSignatureExternalSignatureInviteMutationVariables = Exact<{
  certificate: Scalars['String'];
  initialize: InitializeResponseInput;
  inviteId: Scalars['String'];
}>;


export type FinalizeOneSignatureExternalSignatureInviteMutation = { finalizeOneSignature: { __typename?: 'ExternalSignatureInvite', id: string } };

export type FinancialTeamWalletActivateTrialMutationVariables = Exact<{ [key: string]: never; }>;


export type FinancialTeamWalletActivateTrialMutation = { financialTeamWalletActivateTrial: { __typename?: 'FinancialTeamWallet', teamId: number, creditsPlanTrial: number, SubscriptionActive?: Maybe<{ __typename?: 'FinancialTeamWalletSubscription', plan: FinancialPlan }> } };

export type FinancialTeamWalletPurchasePlanMutationVariables = Exact<{
  data: FinancialTeamWalletPurchasePlanInput;
}>;


export type FinancialTeamWalletPurchasePlanMutation = { financialTeamWalletPurchasePlan: { __typename?: 'PurchasedPlanWithOldPlan', isFirstPlan: boolean, Wallet: { __typename?: 'FinancialTeamWallet', teamId: number } } };

export type FinancialTeamWalletSubscriptionCancelPlanMutationVariables = Exact<{ [key: string]: never; }>;


export type FinancialTeamWalletSubscriptionCancelPlanMutation = { financialTeamWalletSubscriptionCancelPlan: { __typename?: 'FinancialTeamWalletSubscription', id: string } };

export type SignSignatureImageFieldsFragment = { __typename?: 'SignSignatureImage', id: string, base64Image: string, createdAt: any, description: string, percentageBelowTheLine: number, UserUsingAsPrimary?: Maybe<{ __typename?: 'CommonUser', id: number }> };

export type FindManySignSignatureImageQueryVariables = Exact<{
  where?: Maybe<SignSignatureImageWhereInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<SignSignatureImageOrderByWithRelationInput> | SignSignatureImageOrderByWithRelationInput>;
}>;


export type FindManySignSignatureImageQuery = { countSignSignatureImage: number, findManySignSignatureImage: Array<(
    { __typename?: 'SignSignatureImage' }
    & SignSignatureImageFieldsFragment
  )> };

export type PatchOneDocumentAcademicDocumentationMutationVariables = Exact<{
  changes: Array<DocumentChange> | DocumentChange;
  patchOneDocumentAcademicDocumentationId: Scalars['String'];
}>;


export type PatchOneDocumentAcademicDocumentationMutation = { patchOneDocumentAcademicDocumentation: any };

export type PatchOneDocumentSchoolCurriculumMutationVariables = Exact<{
  changes: Array<DocumentChange> | DocumentChange;
  patchOneDocumentSchoolCurriculumId: Scalars['String'];
}>;


export type PatchOneDocumentSchoolCurriculumMutation = { patchOneDocumentSchoolCurriculum: any };

export type PayOverduePaymentsMutationVariables = Exact<{
  data: PlanPayOverduePaymentsInput;
}>;


export type PayOverduePaymentsMutation = { payOverduePayments: { __typename?: 'FinancialTeamWalletSubscription', id: string } };

export type ReplaceOneDegreeVisualRepresentationMutationVariables = Exact<{
  degreeId: Scalars['String'];
  visualRepresentation: Scalars['Upload'];
}>;


export type ReplaceOneDegreeVisualRepresentationMutation = { replaceOneDegreeVisualRepresentation?: Maybe<{ __typename?: 'DocumentDegree', documentBaseId: string, visualRepresentationPath?: Maybe<string> }> };

export type ResendOneTeamMemberEmailMutationVariables = Exact<{
  memberId: Scalars['Int'];
}>;


export type ResendOneTeamMemberEmailMutation = { resendOneTeamMemberEmail: { __typename?: 'TeamMember', id: number } };

export type RevalidateOneDocumentAcademicDocumentationMutationVariables = Exact<{
  documentId: Scalars['String'];
}>;


export type RevalidateOneDocumentAcademicDocumentationMutation = { revalidateOneDocumentAcademicDocumentation?: Maybe<{ __typename?: 'DocumentAcademicDocumentation', documentBaseId: string }> };

export type ReviewOneDocumentAcademicDocumentationMutationVariables = Exact<{
  academicDocumentationId: Scalars['String'];
  reproveReason?: Maybe<Scalars['String']>;
}>;


export type ReviewOneDocumentAcademicDocumentationMutation = { reviewOneDocumentAcademicDocumentation?: Maybe<{ __typename?: 'DocumentAcademicDocumentation', documentBaseId: string, status: DocumentAcademicDocumentationStatus }> };

export type ReviewOneDocumentAuditFileIssuerMutationVariables = Exact<{
  documentBaseId: Scalars['String'];
  reproveReason?: Maybe<Scalars['String']>;
}>;


export type ReviewOneDocumentAuditFileIssuerMutation = { reviewOneDocumentAuditFileIssuer?: Maybe<{ __typename?: 'DocumentAuditFileIssuer', documentBaseId: string, DocumentBase: { __typename?: 'DocumentBase', DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number }> }> } }> };

export type ReviewOneDocumentSchoolCurriculumMutationVariables = Exact<{
  schoolCurriculumId: Scalars['String'];
  reproveReason?: Maybe<Scalars['String']>;
}>;


export type ReviewOneDocumentSchoolCurriculumMutation = { reviewOneDocumentSchoolCurriculum?: Maybe<{ __typename?: 'DocumentSchoolCurriculum', documentBaseId: string, DocumentBase: { __typename?: 'DocumentBase', DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number }> }> } }> };

export type RevokeOneDocumentBaseMutationVariables = Exact<{
  id: Scalars['String'];
  revokeReason: Scalars['String'];
}>;


export type RevokeOneDocumentBaseMutation = { revokeOneDocumentBase?: Maybe<{ __typename?: 'DocumentBase', internalSeqId: string, type: DocumentBaseType }> };

export type SaveOneDocumentAcademicDocumentationMutationVariables = Exact<{
  data: Scalars['Json'];
  type?: Maybe<DocumentAcademicDocumentationType>;
  version: Scalars['String'];
}>;


export type SaveOneDocumentAcademicDocumentationMutation = { saveOneDocumentAcademicDocumentation: (
    { __typename?: 'DocumentAcademicDocumentation' }
    & DocumentAcademicDocumentationFieldsFragment
  ) };

export type SaveOneCommonUserConfigMutationVariables = Exact<{
  data: SaveOneCommonUserConfigInputData;
}>;


export type SaveOneCommonUserConfigMutation = { saveOneCommonUserConfig: { __typename?: 'CommonUserConfig', key: string } };

export type SaveOneReusableFormDataMutationVariables = Exact<{
  data: Scalars['Json'];
  type: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
}>;


export type SaveOneReusableFormDataMutation = { saveOneReusableFormData: { __typename?: 'ReusableFormData', id: number, data: any } };

export type SaveOneDocumentSchoolCurriculumMutationVariables = Exact<{
  data: Scalars['Json'];
  version: Scalars['String'];
}>;


export type SaveOneDocumentSchoolCurriculumMutation = { saveOneDocumentSchoolCurriculum: (
    { __typename?: 'DocumentSchoolCurriculum' }
    & DocumentSchoolCurriculumFieldsFragment
  ) };

export type SendActivityMutationVariables = Exact<{
  input: WatchDocumentInput;
}>;


export type SendActivityMutation = { sendActivity: string };

export type SignOnlyVisualOneSignatureMutationVariables = Exact<{
  inviteId: Scalars['String'];
  signatureImageId?: Maybe<Scalars['String']>;
}>;


export type SignOnlyVisualOneSignatureMutation = { signOnlyVisualOneSignature: { __typename?: 'DocumentCertificateSignatureItemPossibleSignerInviteSignature', id: number } };

export type SingBulkCertificateVisualRepresentationMutationVariables = Exact<{
  certificateList: Array<Scalars['String']> | Scalars['String'];
  signatureImageId?: Maybe<Scalars['String']>;
  bulkId: Scalars['String'];
}>;


export type SingBulkCertificateVisualRepresentationMutation = { singBulkCertificateVisualRepresentation: { __typename?: 'CustomReturnType', success: boolean, total: number } };

export type StartOneCertificateSignatureMutationVariables = Exact<{
  certificate: Scalars['String'];
  inviteId: Scalars['String'];
  signatureImageId?: Maybe<Scalars['String']>;
}>;


export type StartOneCertificateSignatureMutation = { startOneCertificateSignature: { __typename?: 'StartSignature', signingTime: string, dataToSign: string, lastSignatureIsoString: string } };

export type UpdateOneCertificateCourseMutationVariables = Exact<{
  areaKnowledge: Scalars['String'];
  certificateId: Scalars['String'];
  metaData: Array<Scalars['String']> | Scalars['String'];
  name: Scalars['String'];
  courseLevelId?: Maybe<Scalars['String']>;
}>;


export type UpdateOneCertificateCourseMutation = { updateOneCertificateCourse?: Maybe<{ __typename?: 'CertificateCourse', areaKnowledge: string, certificateBaseId: string, name: string, metaData: Array<string> }> };

export type UpdateOneCertificateCourseLevelMutationVariables = Exact<{
  certificateBaseId: Scalars['String'];
  name: Scalars['String'];
}>;


export type UpdateOneCertificateCourseLevelMutation = { updateOneCertificateCourseLevel?: Maybe<{ __typename?: 'CertificateCourseLevel', certificateBaseId: string }> };

export type UpdateOneCertificateCurriculumMutationVariables = Exact<{
  amountOfHours?: Maybe<Scalars['Int']>;
  certificateCourseId: Scalars['String'];
  certificateId: Scalars['String'];
  name: Scalars['String'];
  selectedDisciplines: Array<CirriculumSelectedDiscipline> | CirriculumSelectedDiscipline;
}>;


export type UpdateOneCertificateCurriculumMutation = { updateOneCertificateCurriculum?: Maybe<{ __typename?: 'CertificateCurriculum', certificateBaseId: string, name: string, amountOfHours?: Maybe<number> }> };

export type UpdateOneCertificateDisciplineMutationVariables = Exact<{
  certificateId: Scalars['String'];
  name: Scalars['String'];
  viewOnDegree: Scalars['Boolean'];
}>;


export type UpdateOneCertificateDisciplineMutation = { updateOneCertificateDiscipline?: Maybe<{ __typename?: 'CertificateDiscipline', certificateBaseId: string, name: string, viewOnDegree: boolean }> };

export type UpdateOneCertificateEventMutationVariables = Exact<{
  certificateId: Scalars['String'];
  name: Scalars['String'];
}>;


export type UpdateOneCertificateEventMutation = { updateOneCertificateEvent?: Maybe<{ __typename?: 'CertificateEvent', certificateBaseId: string, name: string }> };

export type UpdateOneCertificateTeacherMutationVariables = Exact<{
  name: Scalars['String'];
  titration: Scalars['String'];
  certificateId: Scalars['String'];
}>;


export type UpdateOneCertificateTeacherMutation = { updateOneCertificateTeacher?: Maybe<{ __typename?: 'CertificateTeacher', certificateBaseId: string, name: string, titration: string }> };

export type UpdateOneCertificateTemplateMutationVariables = Exact<{
  data: CertificateTemplateUpdateInput;
  where: CertificateTemplateWhereUniqueInput;
}>;


export type UpdateOneCertificateTemplateMutation = { updateOneCertificateTemplate?: Maybe<{ __typename?: 'CertificateTemplate', id: string }> };

export type UpdateOnePersonMutationVariables = Exact<{
  isForeign: Scalars['Boolean'];
  phones: Array<Scalars['String']> | Scalars['String'];
  receivesCertificateEmail: Scalars['Boolean'];
  receivesCertificateWhatsapp: Scalars['Boolean'];
  address?: Maybe<AddressInput>;
  birthDate?: Maybe<Scalars['String']>;
  cpf?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identityDocument?: Maybe<Scalars['String']>;
  passport?: Maybe<Scalars['String']>;
  name: Scalars['String'];
}>;


export type UpdateOnePersonMutation = { updateOnePerson?: Maybe<{ __typename?: 'Person', id: string, name: string }> };

export type UpdateOneReusableFormDataCurriculumMutationVariables = Exact<{
  data: ReusableFormDataCurriculumCreateInputCustom;
  where: ReusableFormDataCurriculumWhereUniqueInput;
}>;


export type UpdateOneReusableFormDataCurriculumMutation = { updateOneReusableFormDataCurriculum?: Maybe<{ __typename?: 'ReusableFormDataCurriculum', id: number }> };

export type UpdateOneSystemGlobalAlertMutationVariables = Exact<{
  data: SystemGlobalAlertUpdateInput;
  where: SystemGlobalAlertWhereUniqueInput;
}>;


export type UpdateOneSystemGlobalAlertMutation = { updateOneSystemGlobalAlert?: Maybe<{ __typename?: 'SystemGlobalAlert', id: number }> };

export type UpdateOneTeamMutationVariables = Exact<{
  data: UpdateOneTeamData;
}>;


export type UpdateOneTeamMutation = { updateOneTeam?: Maybe<{ __typename?: 'Team', cnpj?: Maybe<string>, id: number, TeamEducationLevel: Array<{ __typename?: 'TeamEducationLevel', educationLevelType: EducationLevelType }> }> };

export type UpdateOneTeamMemberMutationVariables = Exact<{
  updateOneTeamMemberId: Scalars['Int'];
  permissions?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  role?: Maybe<Scalars['String']>;
}>;


export type UpdateOneTeamMemberMutation = { updateOneTeamMember?: Maybe<{ __typename?: 'TeamMember', id: number, User: { __typename?: 'CommonUser', id: number } }> };

export type UpdateTeamActivationStatusMutationVariables = Exact<{
  data: UpdateTeamActivationStatusArgs;
}>;


export type UpdateTeamActivationStatusMutation = { updateTeamActivationStatus: { __typename?: 'Team', id: number, isActive: boolean } };

export type UpdateTeamConfigAddDocumentSignerNodeMutationVariables = Exact<{
  addSigners: Scalars['Boolean'];
}>;


export type UpdateTeamConfigAddDocumentSignerNodeMutation = { updateTeamConfigAddDocumentSignerNode?: Maybe<{ __typename?: 'Team', id: number }> };

export type UpsertDocumentBaseDefaultSignatureInviteConfigurationMutationVariables = Exact<{
  data: UpsertDocumentBaseDefaultSignatureInviteConfigurationInput;
}>;


export type UpsertDocumentBaseDefaultSignatureInviteConfigurationMutation = { upsertDocumentBaseDefaultSignatureInviteConfiguration: { __typename?: 'DocumentBaseDefaultSignatureInviteConfiguration', id: number } };

export type UpsertOneTemporarySignatureImageMutationVariables = Exact<{
  description: Scalars['String'];
}>;


export type UpsertOneTemporarySignatureImageMutation = { upsertOneTemporarySignatureImage: (
    { __typename?: 'SignSignatureImage' }
    & SignSignatureImageUniqueFieldsFragment
  ) };

export type ValidateOnePdfaMutationVariables = Exact<{
  base64: Scalars['String'];
}>;


export type ValidateOnePdfaMutation = { validateOnePdfa: boolean };

export type CountDocumentBaseByTypeQueryVariables = Exact<{
  where: DocumentBaseWhereInput;
}>;


export type CountDocumentBaseByTypeQuery = { count?: Maybe<number> };

export type CreateOneMaintainerTeamMutationVariables = Exact<{
  cnpj: Scalars['String'];
  educationLevelType: Array<EducationLevelType> | EducationLevelType;
  placeholderName: Scalars['String'];
}>;


export type CreateOneMaintainerTeamMutation = { createOneMaintainerTeam: { __typename?: 'Team', id: number, cnpj?: Maybe<string> } };

export type FindFirstDocumentAcademicDocumentationQueryVariables = Exact<{
  where: DocumentAcademicDocumentationWhereInput;
}>;


export type FindFirstDocumentAcademicDocumentationQuery = { findFirstDocumentAcademicDocumentation?: Maybe<(
    { __typename?: 'DocumentAcademicDocumentation' }
    & DocumentAcademicDocumentationFieldsFragment
  )> };

export type FindFirstDocumentBaseSignatureInviteQueryVariables = Exact<{
  where?: Maybe<DocumentBaseSignatureInviteWhereInput>;
}>;


export type FindFirstDocumentBaseSignatureInviteQuery = { findFirstDocumentBaseSignatureInvite?: Maybe<(
    { __typename?: 'DocumentBaseSignatureInvite' }
    & DocumentBaseSignatureInviteFieldsFragment
  )> };

export type FindFirstDocumentDegreeQueryVariables = Exact<{
  where: DocumentDegreeWhereInput;
}>;


export type FindFirstDocumentDegreeQuery = { findFirstDocumentDegree?: Maybe<(
    { __typename?: 'DocumentDegree' }
    & DocumentDegreeUniqueFieldsFragment
  )> };

export type FindFirstReusableFormDataQueryVariables = Exact<{
  where?: Maybe<ReusableFormDataWhereInput>;
}>;


export type FindFirstReusableFormDataQuery = { findFirstReusableFormData?: Maybe<{ __typename?: 'ReusableFormData', id: number, createdAt: any, data: any, type: string }> };

export type FindFirstTeamMemberQueryVariables = Exact<{
  where?: Maybe<TeamMemberWhereInput>;
}>;


export type FindFirstTeamMemberQuery = { findFirstTeamMember?: Maybe<(
    { __typename?: 'TeamMember' }
    & TeamMemberFieldsFragment
  )> };

export type FindManyDocumentAcademicDocumentationQueryVariables = Exact<{
  take?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<DocumentAcademicDocumentationOrderByWithRelationInput> | DocumentAcademicDocumentationOrderByWithRelationInput>;
  skip?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentAcademicDocumentationWhereInput>;
}>;


export type FindManyDocumentAcademicDocumentationQuery = { count: number, findManyDocumentAcademicDocumentation: Array<{ __typename?: 'DocumentAcademicDocumentation', documentBaseId: string, status: DocumentAcademicDocumentationStatus, type: DocumentAcademicDocumentationType, searchStudentName: string, searchCPF: string, searchCourse: string, searchEmecCode: string, DocumentBase: { __typename?: 'DocumentBase', internalSeqId: string, version: string, createdAt: any } }> };

export type FindManyDocumentBaseSignatureInviteQueryVariables = Exact<{
  where?: Maybe<DocumentBaseSignatureInviteWhereInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<DocumentBaseSignatureInviteOrderByWithRelationInput> | DocumentBaseSignatureInviteOrderByWithRelationInput>;
}>;


export type FindManyDocumentBaseSignatureInviteQuery = { count: number, findManyDocumentBaseSignatureInvite: Array<(
    { __typename?: 'DocumentBaseSignatureInvite' }
    & DocumentBaseSignatureInviteFieldsFragment
  )> };

export type FindManyApiKeyQueryVariables = Exact<{
  where?: Maybe<ApiKeyWhereInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ApiKeyOrderByWithRelationInput> | ApiKeyOrderByWithRelationInput>;
}>;


export type FindManyApiKeyQuery = { count: number, findManyApiKey: Array<{ __typename?: 'ApiKey', id: number, description: string, createdAt: any }> };

export type FindManyBulkCertificateRecordQueryVariables = Exact<{
  where?: Maybe<BulkCertificateRecordWhereInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<BulkCertificateRecordOrderByWithRelationInput> | BulkCertificateRecordOrderByWithRelationInput>;
}>;


export type FindManyBulkCertificateRecordQuery = { count: number, findManyBulkCertificateRecord: Array<{ __typename?: 'BulkCertificateRecord', id: string, bulkCertificateRecordName: string, totalCertificates: number, createdAt: any }> };

export type CertificateCourseFieldsFragment = { __typename?: 'CertificateCourse', certificateBaseId: string, name: string, areaKnowledge: string, metaData: Array<string>, CertificateBase: { __typename?: 'CertificateBase', createdAt: any }, CourseLevel?: Maybe<{ __typename?: 'CertificateCourseLevel', certificateBaseId: string, name: string }> };

export type FindManyCertificateCourseQueryVariables = Exact<{
  where?: Maybe<CertificateCourseWhereInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<CertificateCourseOrderByWithRelationInput> | CertificateCourseOrderByWithRelationInput>;
}>;


export type FindManyCertificateCourseQuery = { count: number, findManyCertificateCourse: Array<(
    { __typename?: 'CertificateCourse' }
    & CertificateCourseFieldsFragment
  )> };

export type CertificateCourseLevelFieldsFragment = { __typename?: 'CertificateCourseLevel', certificateBaseId: string, name: string, CertificateBase: { __typename?: 'CertificateBase', createdAt: any } };

export type FindManyCertificateCourseLevelQueryVariables = Exact<{
  where?: Maybe<CertificateCourseLevelWhereInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<CertificateCourseLevelOrderByWithRelationInput> | CertificateCourseLevelOrderByWithRelationInput>;
}>;


export type FindManyCertificateCourseLevelQuery = { count: number, findManyCertificateCourseLevel: Array<(
    { __typename?: 'CertificateCourseLevel' }
    & CertificateCourseLevelFieldsFragment
  )> };

export type CertificateCurriculumFieldsFragment = { __typename?: 'CertificateCurriculum', certificateBaseId: string, name: string, amountOfHours?: Maybe<number>, CertificateBase: { __typename?: 'CertificateBase', createdAt: any }, CertificateCurriculumSelectedDisciplines: Array<{ __typename?: 'CertificateCurriculumSelectedDiscipline', SelectedDiscipline: { __typename?: 'CertificateDiscipline', name: string, certificateBaseId: string } }> };

export type FindManyCertificateCurriculumQueryVariables = Exact<{
  where?: Maybe<CertificateCurriculumWhereInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<CertificateCurriculumOrderByWithRelationInput> | CertificateCurriculumOrderByWithRelationInput>;
}>;


export type FindManyCertificateCurriculumQuery = { count: number, findManyCertificateCurriculum: Array<(
    { __typename?: 'CertificateCurriculum' }
    & CertificateCurriculumFieldsFragment
  )> };

export type FindManyCertificateDisciplineQueryVariables = Exact<{
  where?: Maybe<CertificateDisciplineWhereInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<CertificateDisciplineOrderByWithRelationInput> | CertificateDisciplineOrderByWithRelationInput>;
}>;


export type FindManyCertificateDisciplineQuery = { count: number, findManyCertificateDiscipline: Array<{ __typename?: 'CertificateDiscipline', certificateBaseId: string, name: string, viewOnDegree: boolean, CertificateBase: { __typename?: 'CertificateBase', createdAt: any } }> };

export type CertificateEventFieldsFragment = { __typename?: 'CertificateEvent', certificateBaseId: string, name: string, CertificateBase: { __typename?: 'CertificateBase', createdAt: any } };

export type FindManyCertificateEventQueryVariables = Exact<{
  where?: Maybe<CertificateEventWhereInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<CertificateEventOrderByWithRelationInput> | CertificateEventOrderByWithRelationInput>;
}>;


export type FindManyCertificateEventQuery = { count: number, findManyCertificateEvent: Array<(
    { __typename?: 'CertificateEvent' }
    & CertificateEventFieldsFragment
  )> };

export type FindManyCertificateTeacherQueryVariables = Exact<{
  where?: Maybe<CertificateTeacherWhereInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<CertificateTeacherOrderByWithRelationInput> | CertificateTeacherOrderByWithRelationInput>;
}>;


export type FindManyCertificateTeacherQuery = { count: number, findManyCertificateTeacher: Array<{ __typename?: 'CertificateTeacher', certificateBaseId: string, name: string, titration: string, CertificateBase: { __typename?: 'CertificateBase', createdAt: any } }> };

export type CertificateTemplateManyFieldsFragment = { __typename?: 'CertificateTemplate', id: string, name: string, description?: Maybe<string>, createdAt: any, commonUserId: number };

export type FindManyCertificateTemplateQueryVariables = Exact<{
  where?: Maybe<CertificateTemplateWhereInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<CertificateTemplateOrderByWithRelationInput> | CertificateTemplateOrderByWithRelationInput>;
}>;


export type FindManyCertificateTemplateQuery = { count: number, items: Array<(
    { __typename?: 'CertificateTemplate' }
    & CertificateTemplateManyFieldsFragment
  )> };

export type FindManyCertificatesByBatchIdQueryVariables = Exact<{
  batchId?: Maybe<Scalars['String']>;
}>;


export type FindManyCertificatesByBatchIdQuery = { findManyCertificatesByBatchId: Array<{ __typename?: 'DocumentCertificate', documentBaseId: string, documentCertificateName: string, documentCertificateCPF: string, status: DocumentCertificateStatus, DocumentBase: { __typename?: 'DocumentBase', createdAt: any, filePath?: Maybe<string> }, DocumentCertificateSignatureItems: Array<(
      { __typename?: 'DocumentCertificateSignatureItem' }
      & DocumentCertificateSignatureItemFieldsFragment
    )> }> };

export type FindManyCommonUserQueryVariables = Exact<{
  where?: Maybe<CommonUserWhereInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<CommonUserOrderByWithRelationInput> | CommonUserOrderByWithRelationInput>;
}>;


export type FindManyCommonUserQuery = { findManyCommonUser: Array<{ __typename?: 'CommonUser', name?: Maybe<string>, id: number, email: string, photo?: Maybe<string>, Team: { __typename?: 'Team', id: number, issuerName?: Maybe<string>, placeholderName: string } }> };

export type FindManyDegreeQueryVariables = Exact<{
  where?: Maybe<DocumentDegreeWhereInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<DocumentDegreeOrderByWithRelationInput> | DocumentDegreeOrderByWithRelationInput>;
}>;


export type FindManyDegreeQuery = { count: number, findManyDegree: Array<(
    { __typename?: 'DocumentDegree' }
    & DocumentDegreeFieldsFragment
  )> };

export type FindManyDocumentAuditFileIssuerQueryVariables = Exact<{
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentAuditFileIssuerWhereInput>;
  orderBy?: Maybe<Array<DocumentAuditFileIssuerOrderByWithRelationInput> | DocumentAuditFileIssuerOrderByWithRelationInput>;
}>;


export type FindManyDocumentAuditFileIssuerQuery = { count: number, findManyDocumentAuditFileIssuer: Array<{ __typename?: 'DocumentAuditFileIssuer', documentBaseId: string, searchAuditStartDate: any, searchAuditEndDate: any, status: DocumentAuditFileIssuerStatus, DocumentBase: { __typename?: 'DocumentBase', filePath?: Maybe<string>, createdAt: any } }> };

export type FindManyDocumentBaseDefaultSignatureInviteConfigurationQueryVariables = Exact<{
  where?: Maybe<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<DocumentBaseDefaultSignatureInviteConfigurationOrderByWithRelationInput> | DocumentBaseDefaultSignatureInviteConfigurationOrderByWithRelationInput>;
}>;


export type FindManyDocumentBaseDefaultSignatureInviteConfigurationQuery = { countDocumentBaseDefaultSignatureInviteConfiguration: number, findManyDocumentBaseDefaultSignatureInviteConfiguration: Array<{ __typename?: 'DocumentBaseDefaultSignatureInviteConfiguration', id: number, type: DocumentBaseType, createdAt: any, updatedAt?: Maybe<any>, Groups: Array<{ __typename?: 'DocumentBaseDefaultSignatureInviteConfigurationGroup', id: number, Items: Array<{ __typename?: 'DocumentBaseDefaultSignatureInviteConfigurationGroupItem', teamMemberId?: Maybe<number>, TeamMember?: Maybe<{ __typename?: 'TeamMember', User: { __typename?: 'CommonUser', name?: Maybe<string>, email: string } }> }> }> }> };

export type FindManyDocumentCertificateQueryVariables = Exact<{
  where?: Maybe<DocumentCertificateWhereInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<DocumentCertificateOrderByWithRelationInput> | DocumentCertificateOrderByWithRelationInput>;
}>;


export type FindManyDocumentCertificateQuery = { count: number, findManyDocumentCertificate: Array<{ __typename?: 'DocumentCertificate', documentBaseId: string, documentCertificateName: string, documentCertificateCPF: string, status: DocumentCertificateStatus, DocumentBase: { __typename?: 'DocumentBase', createdAt: any, filePath?: Maybe<string> }, DocumentCertificateSignatureItems: Array<(
      { __typename?: 'DocumentCertificateSignatureItem' }
      & DocumentCertificateSignatureItemFieldsFragment
    )> }> };

export type FindManyDocumentCertificateSignatureItemQueryVariables = Exact<{
  where?: Maybe<DocumentCertificateSignatureItemWhereInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<DocumentCertificateSignatureItemOrderByWithRelationInput> | DocumentCertificateSignatureItemOrderByWithRelationInput>;
}>;


export type FindManyDocumentCertificateSignatureItemQuery = { countDocumentCertificateSignatureItem: number, findManyDocumentCertificateSignatureItem: Array<(
    { __typename?: 'DocumentCertificateSignatureItem', DocumentCertificate: { __typename?: 'DocumentCertificate', documentCertificateName: string, documentCertificateCPF: string, DocumentBase: { __typename?: 'DocumentBase', internalSeqId: string }, DocumentCertificateSignatureItems: Array<(
        { __typename?: 'DocumentCertificateSignatureItem' }
        & DocumentCertificateSignatureItemBaseFieldsFragment
      )> } }
    & DocumentCertificateSignatureItemBaseFieldsFragment
  )> };

export type FindManyDocumentFinalAcademicTranscriptQueryVariables = Exact<{
  where?: Maybe<DocumentFinalAcademicTranscriptWhereInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<DocumentFinalAcademicTranscriptOrderByWithRelationInput> | DocumentFinalAcademicTranscriptOrderByWithRelationInput>;
}>;


export type FindManyDocumentFinalAcademicTranscriptQuery = { count: number, findManyDocumentFinalAcademicTranscript: Array<{ __typename?: 'DocumentFinalAcademicTranscript', documentBaseId: string, status: DocumentFinalAcademicTranscriptStatus, searchStudentName: string, searchCourse: string, searchCPF: string, searchEmecCode: string, DocumentBase: { __typename?: 'DocumentBase', type: DocumentBaseType, createdAt: any } }> };

export type FindManyDocumentSchoolCurriculumQueryVariables = Exact<{
  orderBy?: Maybe<Array<DocumentSchoolCurriculumOrderByWithRelationInput> | DocumentSchoolCurriculumOrderByWithRelationInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentSchoolCurriculumWhereInput>;
}>;


export type FindManyDocumentSchoolCurriculumQuery = { count: number, findManyDocumentSchoolCurriculum: Array<{ __typename?: 'DocumentSchoolCurriculum', documentBaseId: string, searchSchoolCurriculumName: string, searchSchoolCurriculumCode: string, searchSelectedCourse: string, status: DocumentSchoolCurriculumStatus, DocumentBase: { __typename?: 'DocumentBase', createdAt: any, filePath?: Maybe<string> } }> };

export type EnabledInstitutionFieldsFragment = { __typename?: 'EnabledInstitution', cnpj: string, email: string, isMaintainer: boolean, placeholderName: string, Team?: Maybe<{ __typename?: 'Team', id: number, contract: string, observations: string, syncWithLedgerDoc: boolean, isNSF: boolean, lastActivityAt: any, issuedCount: number, logoBase64?: Maybe<string>, faviconBase64?: Maybe<string>, publicViewDegreeDomainPath?: Maybe<string>, publicViewFinalAcademicTranscriptDomainPath?: Maybe<string>, publicViewSchoolCurriculumDomainPath?: Maybe<string>, publicViewInstitutionName?: Maybe<string>, publicViewPrimaryColor?: Maybe<string>, publicViewSecondaryColor?: Maybe<string>, externalSignatureWebhookURL?: Maybe<string>, validateCertificateURL?: Maybe<string>, isActive: boolean, deactivationReason?: Maybe<string>, issuerData?: Maybe<any>, issuerName?: Maybe<string>, TeamEducationLevel: Array<{ __typename?: 'TeamEducationLevel', educationLevelType: EducationLevelType }>, Maintainer?: Maybe<{ __typename?: 'Maintainer', id: number, MainTeam: { __typename?: 'Team', id: number, issuerName?: Maybe<string> } }> }> };

export type FindManyEnabledInstitutionQueryVariables = Exact<{
  where?: Maybe<EnabledInstitutionWhereInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EnabledInstitutionOrderByWithRelationInput> | EnabledInstitutionOrderByWithRelationInput>;
}>;


export type FindManyEnabledInstitutionQuery = { count: number, totalIssuedDocuments: number, findManyEnabledInstitution: Array<(
    { __typename?: 'EnabledInstitution' }
    & EnabledInstitutionFieldsFragment
  )> };

export type FindManyFinancialChargeQueryVariables = Exact<{
  where?: Maybe<FinancialChargeWhereInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<FinancialChargeOrderByWithRelationInput> | FinancialChargeOrderByWithRelationInput>;
}>;


export type FindManyFinancialChargeQuery = { count: number, findManyFinancialCharge: Array<{ __typename?: 'FinancialCharge', id: number, service: FinancialChargeableService, createdAt: any, creditsDeducted: number, UserExecuted: { __typename?: 'CommonUser', id: number, name?: Maybe<string>, email: string, photo?: Maybe<string> } }> };

export type FindManyFinancialCreditCardSavedQueryVariables = Exact<{ [key: string]: never; }>;


export type FindManyFinancialCreditCardSavedQuery = { findManyFinancialCreditCardSaved: Array<{ __typename?: 'FinancialCreditCardSaved', id: number, token: string, number: string, brand: string }> };

export type PlanAndConditionsFieldsFragment = { __typename?: 'PlanAndConditions', includedCertificates: number, name: string, monthlyPricing: number, yearlyPricing: number, plan: FinancialPlan, disabled: boolean };

export type FindManyFinancialPlanQueryVariables = Exact<{ [key: string]: never; }>;


export type FindManyFinancialPlanQuery = { findManyFinancialPlan: Array<(
    { __typename?: 'PlanAndConditions' }
    & PlanAndConditionsFieldsFragment
  )> };

export type FindManyFinancialPaymentQueryVariables = Exact<{
  where?: Maybe<FinancialPaymentWhereInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<FinancialPaymentOrderByWithRelationInput> | FinancialPaymentOrderByWithRelationInput>;
}>;


export type FindManyFinancialPaymentQuery = { count: number, items: Array<{ __typename?: 'FinancialPayment', id: string, createdAt: any, Recharge?: Maybe<{ __typename?: 'FinancialRecharge', id: number, createdAt: any, cost: any, creditsCount: number, creditsType: FinancialChargeableService, UserExecuted: { __typename?: 'CommonUser', id: number, name?: Maybe<string>, email: string, photo?: Maybe<string> } }>, SubscriptionPayment?: Maybe<{ __typename?: 'FinancialTeamWalletSubscriptionPayment', dueDate: any, cost: any, id: string, createdAt: any, Subscription: { __typename?: 'FinancialTeamWalletSubscription', id: string, plan: FinancialPlan, planName?: Maybe<string> } }> }> };

export type FinancialTeamWalletSubscriptionPaymentFieldsFragment = { __typename?: 'FinancialTeamWalletSubscriptionPayment', id: string, dueDate: any, cost: any, createdAt: any, status: PaymentStatus };

export type FindManyFinancialTeamWalletSubscriptionPaymentQueryVariables = Exact<{
  where?: Maybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<FinancialTeamWalletSubscriptionPaymentOrderByWithRelationInput> | FinancialTeamWalletSubscriptionPaymentOrderByWithRelationInput>;
}>;


export type FindManyFinancialTeamWalletSubscriptionPaymentQuery = { count: number, items: Array<(
    { __typename?: 'FinancialTeamWalletSubscriptionPayment' }
    & FinancialTeamWalletSubscriptionPaymentFieldsFragment
  )> };

export type FindManyMaintainerAdminQueryVariables = Exact<{
  where?: Maybe<MaintainerAdminWhereInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<MaintainerAdminOrderByWithRelationInput> | MaintainerAdminOrderByWithRelationInput>;
}>;


export type FindManyMaintainerAdminQuery = { countMaintainerAdmin: number, findManyMaintainerAdmin: Array<{ __typename?: 'MaintainerAdmin', createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, idLedgerSign?: Maybe<number>, name?: Maybe<string>, cpf?: Maybe<string> } }> };

export type FindManyPermissionQueryVariables = Exact<{ [key: string]: never; }>;


export type FindManyPermissionQuery = { findManyPermission: Array<{ __typename?: 'Permission', id: number, code: string, title: string, description: string }> };

export type FindManyPersonQueryVariables = Exact<{
  cursor?: Maybe<PersonWhereUniqueInput>;
  distinct?: Maybe<Array<PersonScalarFieldEnum> | PersonScalarFieldEnum>;
  orderBy?: Maybe<Array<PersonOrderByWithRelationInput> | PersonOrderByWithRelationInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<PersonWhereInput>;
}>;


export type FindManyPersonQuery = { count: number, findManyPerson: Array<{ __typename?: 'Person', id: string, cpf?: Maybe<string>, passport?: Maybe<string>, name: string, birthDate?: Maybe<string>, email?: Maybe<string>, createdAt: any }> };

export type FindManyReusableFormDataQueryVariables = Exact<{
  where?: Maybe<ReusableFormDataWhereInputCustom>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ReusableFormDataOrderByWithRelationInput> | ReusableFormDataOrderByWithRelationInput>;
}>;


export type FindManyReusableFormDataQuery = { count: number, findManyReusableFormData: Array<{ __typename?: 'ReusableFormData', id: number, data: any, createdAt: any }> };

export type ReusableFormDataCurriculumFieldsFragment = { __typename?: 'ReusableFormDataCurriculum', id: number, name: string, createdAt: any, Course: { __typename?: 'ReusableFormData', id: number, data: any } };

export type FindManyReusableFormDataCurriculumQueryVariables = Exact<{
  where?: Maybe<ReusableFormDataCurriculumWhereInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ReusableFormDataCurriculumOrderByWithRelationInput> | ReusableFormDataCurriculumOrderByWithRelationInput>;
}>;


export type FindManyReusableFormDataCurriculumQuery = { count: number, items: Array<(
    { __typename?: 'ReusableFormDataCurriculum' }
    & ReusableFormDataCurriculumFieldsFragment
  )> };

export type FindManySignableDocumentBaseSignatureInviteQueryVariables = Exact<{
  where?: Maybe<DocumentBaseSignatureInviteWhereInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<DocumentBaseSignatureInviteOrderByWithRelationInput> | DocumentBaseSignatureInviteOrderByWithRelationInput>;
  personId: Scalars['String'];
}>;


export type FindManySignableDocumentBaseSignatureInviteQuery = { findManySignableDocumentBaseSignatureInvite: { __typename?: 'SignableInviteItemsAndCount', count: number, items: Array<(
      { __typename?: 'DocumentBaseSignatureInvite' }
      & DocumentBaseSignatureInviteFieldsFragment
    )> } };

export type SystemGlobalAlertManyFieldsFragment = { __typename?: 'SystemGlobalAlert', actionTitle?: Maybe<string>, actionUrl?: Maybe<string>, active: boolean, createdAt: any, forcedDescription: string, forcedTitle: string, id: number, message?: Maybe<string>, type: SystemGlobalAlertType, updatedAt?: Maybe<any>, value: string, dismissonsCount: number };

export type FindManySystemGlobalAlertQueryVariables = Exact<{
  where?: Maybe<SystemGlobalAlertWhereInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<SystemGlobalAlertOrderByWithRelationInput> | SystemGlobalAlertOrderByWithRelationInput>;
}>;


export type FindManySystemGlobalAlertQuery = { count: number, findManySystemGlobalAlert: Array<(
    { __typename?: 'SystemGlobalAlert' }
    & SystemGlobalAlertManyFieldsFragment
  )> };

export type TeamManyFieldsFragment = { __typename?: 'Team', id: number, issuedCount: number, placeholderName: string, validateCertificateURL?: Maybe<string>, cnpj?: Maybe<string>, lastActivityAt: any, isActive: boolean, deactivationReason?: Maybe<string>, Owner: { __typename?: 'CommonUser', id: number, name?: Maybe<string>, email: string } };

export type FindManyTeamQueryVariables = Exact<{
  where?: Maybe<TeamWhereInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<TeamOrderByWithRelationInput> | TeamOrderByWithRelationInput>;
}>;


export type FindManyTeamQuery = { count: number, totalIssuedDocuments: number, items: Array<(
    { __typename?: 'Team' }
    & TeamManyFieldsFragment
  )> };

export type FindManyTeamMaintainedQueryVariables = Exact<{
  where?: Maybe<TeamWhereInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<TeamOrderByWithRelationInput> | TeamOrderByWithRelationInput>;
}>;


export type FindManyTeamMaintainedQuery = { countTeamMaintained: number, findManyTeamMaintained: Array<{ __typename?: 'Team', id: number, issuerName?: Maybe<string>, placeholderName: string, cnpj?: Maybe<string>, createdAt: any, MainTeamOfMaintainer?: Maybe<{ __typename?: 'Maintainer', id: number, mainTeamId: number }>, Owner: { __typename?: 'CommonUser', id: number, name?: Maybe<string> } }> };

export type FindManyTeamMemberQueryVariables = Exact<{
  where?: Maybe<TeamMemberWhereInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<TeamMemberOrderByWithRelationInput> | TeamMemberOrderByWithRelationInput>;
}>;


export type FindManyTeamMemberQuery = { count: number, findManyTeamMember: Array<(
    { __typename?: 'TeamMember' }
    & TeamMemberFieldsFragment
  )> };

export type SystemAuditLogFieldsFragment = { __typename?: 'SystemAuditLog', id: string, table: string, operation: string, teamId?: Maybe<number>, operationTranslated: string, moduleTranslated: string, createdAt: any, after?: Maybe<any>, args?: Maybe<any>, extraContext?: Maybe<any>, primaryKey?: Maybe<string>, User?: Maybe<{ __typename?: 'CommonUser', id: number, name?: Maybe<string>, photo?: Maybe<string>, email: string }>, translatedAfter: Array<{ __typename?: 'KeyValue', key: string, value?: Maybe<string> }> };

export type FindManySystemAuditLogQueryVariables = Exact<{
  where?: Maybe<SystemAuditLogWhereInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<SystemAuditLogOrderByWithRelationInput> | SystemAuditLogOrderByWithRelationInput>;
}>;


export type FindManySystemAuditLogQuery = { countSystemAuditLog: number, findManySystemAuditLog: Array<(
    { __typename?: 'SystemAuditLog' }
    & SystemAuditLogFieldsFragment
  )> };

export type FindOneExternalCepAddressQueryVariables = Exact<{
  cep: Scalars['String'];
}>;


export type FindOneExternalCepAddressQuery = { findOneExternalCepAddress: { __typename?: 'ExternalCepAddress', street?: Maybe<string>, state?: Maybe<string>, service?: Maybe<string>, neighborhood?: Maybe<string>, city?: Maybe<string>, cep: string } };

export type FindUniqueBulkCertificateRecordQueryVariables = Exact<{
  where: BulkCertificateRecordWhereUniqueInput;
  countInSignaturesDocumentCertificatesWhere?: Maybe<DocumentCertificateWhereInput>;
}>;


export type FindUniqueBulkCertificateRecordQuery = { findUniqueBulkCertificateRecord?: Maybe<{ __typename?: 'BulkCertificateRecord', id: string, createdAt: any, bulkCertificateRecordName: string, totalCertificates: number, status: DocumentCertificateStatus, countDocumentCertificates: number, countDocumentCertificatesStatusInSignature: number }> };

export type TeamAndPublicDocumentBaseTypeFieldsFragment = { __typename?: 'TeamAndPublicDocumentBaseType', documentSeeType: string, url: string, team: { __typename?: 'Team', id: number, publicViewDegreeDomainPath?: Maybe<string>, publicViewFinalAcademicTranscriptDomainPath?: Maybe<string>, publicViewSchoolCurriculumDomainPath?: Maybe<string>, publicViewInstitutionName?: Maybe<string>, publicViewPrimaryColor?: Maybe<string>, publicViewSecondaryColor?: Maybe<string>, externalSignatureWebhookURL?: Maybe<string>, logoBase64?: Maybe<string>, faviconBase64?: Maybe<string> } };

export type FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQuery = { findUniqueTeamAndPublicDocumentBaseTypeByPublicUrl?: Maybe<(
    { __typename?: 'TeamAndPublicDocumentBaseType' }
    & TeamAndPublicDocumentBaseTypeFieldsFragment
  )> };

export type FindUniqueCertificateCourseQueryVariables = Exact<{
  where: CertificateCourseWhereUniqueInput;
}>;


export type FindUniqueCertificateCourseQuery = { findUniqueCertificateCourse?: Maybe<{ __typename?: 'CertificateCourse', certificateBaseId: string, name: string, areaKnowledge: string, metaData: Array<string>, CertificateBase: { __typename?: 'CertificateBase', createdAt: any }, CourseLevel?: Maybe<{ __typename?: 'CertificateCourseLevel', certificateBaseId: string, name: string }> }> };

export type FindUniqueCertificateCourseLevelQueryVariables = Exact<{
  where: CertificateCourseLevelWhereUniqueInput;
}>;


export type FindUniqueCertificateCourseLevelQuery = { findUniqueCertificateCourseLevel?: Maybe<{ __typename?: 'CertificateCourseLevel', name: string, certificateBaseId: string, CertificateBase: { __typename?: 'CertificateBase', createdAt: any } }> };

export type SelectedDisciplineFieldsFragment = { __typename?: 'CertificateCurriculumSelectedDiscipline', amountOfHours?: Maybe<number>, SelectedDiscipline: { __typename?: 'CertificateDiscipline', certificateBaseId: string, name: string }, SelectedTeacher?: Maybe<{ __typename?: 'CertificateTeacher', certificateBaseId: string, name: string }> };

export type FindUniqueCertificateCurriculumQueryVariables = Exact<{
  where: CertificateCurriculumWhereUniqueInput;
}>;


export type FindUniqueCertificateCurriculumQuery = { findUniqueCertificateCurriculum?: Maybe<{ __typename?: 'CertificateCurriculum', name: string, amountOfHours?: Maybe<number>, CertificateCourse: { __typename?: 'CertificateCourse', certificateBaseId: string, name: string }, CertificateCurriculumSelectedDisciplines: Array<(
      { __typename?: 'CertificateCurriculumSelectedDiscipline' }
      & SelectedDisciplineFieldsFragment
    )> }> };

export type FindUniqueCertificateDisciplineQueryVariables = Exact<{
  where: CertificateDisciplineWhereUniqueInput;
}>;


export type FindUniqueCertificateDisciplineQuery = { findUniqueCertificateDiscipline?: Maybe<{ __typename?: 'CertificateDiscipline', certificateBaseId: string, name: string, viewOnDegree: boolean }> };

export type FindUniqueCertificateEventQueryVariables = Exact<{
  where: CertificateEventWhereUniqueInput;
}>;


export type FindUniqueCertificateEventQuery = { findUniqueCertificateEvent?: Maybe<{ __typename?: 'CertificateEvent', certificateBaseId: string, name: string, CertificateBase: { __typename?: 'CertificateBase', createdAt: any } }> };

export type FindUniqueCertificateTeacherQueryVariables = Exact<{
  where: CertificateTeacherWhereUniqueInput;
}>;


export type FindUniqueCertificateTeacherQuery = { findUniqueCertificateTeacher?: Maybe<{ __typename?: 'CertificateTeacher', certificateBaseId: string, name: string, titration: string, CertificateBase: { __typename?: 'CertificateBase', createdAt: any } }> };

export type CertificateTemplateFieldsFragment = { __typename?: 'CertificateTemplate', id: string, name: string, description?: Maybe<string>, createdAt: any, data: any };

export type FindUniqueCertificateTemplateQueryVariables = Exact<{
  where: CertificateTemplateWhereUniqueInput;
}>;


export type FindUniqueCertificateTemplateQuery = { findUniqueCertificateTemplate?: Maybe<(
    { __typename?: 'CertificateTemplate' }
    & CertificateTemplateFieldsFragment
  )> };

export type FindUniqueDocumentDegreeQueryVariables = Exact<{
  where: DocumentDegreeWhereUniqueInput;
}>;


export type FindUniqueDocumentDegreeQuery = { findUniqueDocumentDegree?: Maybe<(
    { __typename?: 'DocumentDegree' }
    & DocumentDegreeUniqueFieldsFragment
  )> };

export type DegreeViewDegreeFragment = { __typename?: 'DocumentDegree', documentBaseId: string, searchCourse: string, searchCPF: string, searchEmecCode: string, searchStudentName: string, searchValidationCode: string, status: DocumentDegreeStatus, visualRepresentationPath?: Maybe<string>, DocumentBase: { __typename?: 'DocumentBase', createdAt: any, Team: { __typename?: 'Team', publicViewDegreeDomainPath?: Maybe<string>, publicViewFinalAcademicTranscriptDomainPath?: Maybe<string>, publicViewSchoolCurriculumDomainPath?: Maybe<string>, externalSignatureWebhookURL?: Maybe<string>, publicViewInstitutionName?: Maybe<string>, publicViewPrimaryColor?: Maybe<string>, publicViewSecondaryColor?: Maybe<string> } } };

export type FindUniqueDegreeToSeeBySecurityCodeQueryVariables = Exact<{
  domain: Scalars['String'];
  recaptchaResponse: Scalars['String'];
  securityCode: Scalars['String'];
}>;


export type FindUniqueDegreeToSeeBySecurityCodeQuery = { findUniqueDegreeToSeeBySecurityCode?: Maybe<(
    { __typename?: 'DocumentDegree' }
    & DegreeViewDegreeFragment
  )> };

export type FindUniqueDocumentAcademicDocumentationQueryVariables = Exact<{
  where: DocumentAcademicDocumentationWhereUniqueInput;
}>;


export type FindUniqueDocumentAcademicDocumentationQuery = { findUnique?: Maybe<(
    { __typename?: 'DocumentAcademicDocumentation' }
    & DocumentAcademicDocumentationFieldsFragment
  )> };

export type DocumentAuditFileIssuerFieldsFragment = { __typename?: 'DocumentAuditFileIssuer', documentBaseId: string, searchAuditStartDate: any, searchAuditEndDate: any, status: DocumentAuditFileIssuerStatus, DocumentBase: (
    { __typename?: 'DocumentBase' }
    & DocumentBaseFieldsFragment
  ) };

export type FindUniqueDocumentAuditFileIssuerQueryVariables = Exact<{
  where: DocumentAuditFileIssuerWhereUniqueInput;
}>;


export type FindUniqueDocumentAuditFileIssuerQuery = { findUnique?: Maybe<(
    { __typename?: 'DocumentAuditFileIssuer' }
    & DocumentAuditFileIssuerFieldsFragment
  )> };

export type FindUniqueDocumentBaseDefaultSignatureInviteConfigurationQueryVariables = Exact<{
  where: DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput;
}>;


export type FindUniqueDocumentBaseDefaultSignatureInviteConfigurationQuery = { findUniqueDocumentBaseDefaultSignatureInviteConfiguration?: Maybe<{ __typename?: 'DocumentBaseDefaultSignatureInviteConfiguration', id: number, type: DocumentBaseType, createdAt: any, updatedAt?: Maybe<any>, addSignersNode: boolean, signatureConfig: Array<SignatureType>, Groups: Array<{ __typename?: 'DocumentBaseDefaultSignatureInviteConfigurationGroup', id: number, Items: Array<{ __typename?: 'DocumentBaseDefaultSignatureInviteConfigurationGroupItem', id: number, teamMemberId?: Maybe<number>, TeamMember?: Maybe<{ __typename?: 'TeamMember', id: number, User: { __typename?: 'CommonUser', id: number, name?: Maybe<string>, email: string } }> }> }> }> };

export type FindUniqueDocumentBaseSignatureInviteQueryVariables = Exact<{
  where: DocumentBaseSignatureInviteWhereUniqueInput;
}>;


export type FindUniqueDocumentBaseSignatureInviteQuery = { findUniqueDocumentBaseSignatureInvite?: Maybe<(
    { __typename?: 'DocumentBaseSignatureInvite' }
    & DocumentBaseSignatureInviteFieldsFragment
  )> };

export type FindUniqueDocumentBaseSignatureInviteGroupQueryVariables = Exact<{
  where: DocumentBaseSignatureInviteGroupWhereUniqueInput;
}>;


export type FindUniqueDocumentBaseSignatureInviteGroupQuery = { findUniqueDocumentBaseSignatureInviteGroup?: Maybe<{ __typename?: 'DocumentBaseSignatureInviteGroup', documentBaseId: string, DocumentBase: { __typename?: 'DocumentBase', type: DocumentBaseType } }> };

export type DocumentCertificateSignatureItemBaseFieldsFragment = { __typename?: 'DocumentCertificateSignatureItem', id: string, predefinedImageBase64?: Maybe<string>, type: DocumentCertificateSignatureItemType, createdAt: any, PossibleSigners: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInvite', id: number, TeamMember: { __typename?: 'TeamMember', id: number, User: { __typename?: 'CommonUser', id: number, name?: Maybe<string>, email: string } }, DocumentCertificateSignatureItemPossibleSignerInviteSignature: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInviteSignature', success: boolean, createdAt: any }> }> };

export type DocumentCertificateFieldsFragment = { __typename?: 'DocumentCertificate', documentBaseId: string, uuid: string, documentCertificateCPF: string, documentCertificateName: string, certificateTemplateId?: Maybe<string>, status: DocumentCertificateStatus, hasOnlyPredefinedVisualSignature: boolean, Person: { __typename?: 'Person', id: string, name: string, cpf?: Maybe<string>, email?: Maybe<string> }, BulkCertificateRecord?: Maybe<{ __typename?: 'BulkCertificateRecord', status: DocumentCertificateStatus, id: string, bulkCertificateRecordName: string }>, DocumentCertificateSignatureItems: Array<(
    { __typename?: 'DocumentCertificateSignatureItem', id: string }
    & DocumentCertificateSignatureItemBaseFieldsFragment
  )>, DocumentCertificateHashHistory: Array<{ __typename?: 'DocumentCertificateHashHistory', hash: string }>, TeamEducationLevel: { __typename?: 'TeamEducationLevel', educationLevelType: EducationLevelType }, DocumentBase: (
    { __typename?: 'DocumentBase' }
    & DocumentBaseFieldsFragment
  ) };

export type FindUniqueDocumentCertificateQueryVariables = Exact<{
  where: DocumentCertificateWhereUniqueInput;
}>;


export type FindUniqueDocumentCertificateQuery = { findUniqueDocumentCertificate?: Maybe<(
    { __typename?: 'DocumentCertificate' }
    & DocumentCertificateFieldsFragment
  )> };

export type DocumentCertificateSignatureItemFieldsFragment = { __typename?: 'DocumentCertificateSignatureItem', id: string, predefinedImageBase64?: Maybe<string>, type: DocumentCertificateSignatureItemType, DocumentCertificate: (
    { __typename?: 'DocumentCertificate', DocumentBase: { __typename?: 'DocumentBase', type: DocumentBaseType, internalSeqId: string }, DocumentCertificateSignatureItems: Array<{ __typename?: 'DocumentCertificateSignatureItem', id: string, type: DocumentCertificateSignatureItemType, predefinedImageBase64?: Maybe<string>, PossibleSigners: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInvite', id: number, TeamMember: { __typename?: 'TeamMember', id: number, User: { __typename?: 'CommonUser', id: number, cpf?: Maybe<string>, name?: Maybe<string>, email: string } }, DocumentCertificateSignatureItemPossibleSignerInviteSignature: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInviteSignature', success: boolean, createdAt: any }> }> }> }
    & DocumentCertificateFieldsFragment
  ), PossibleSigners: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInvite', id: number, TeamMember: { __typename?: 'TeamMember', id: number, User: { __typename?: 'CommonUser', id: number, name?: Maybe<string>, email: string, cpf?: Maybe<string> } }, DocumentCertificateSignatureItemPossibleSignerInviteSignature: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInviteSignature', success: boolean, createdAt: any }> }> };

export type FindUniqueDocumentCertificateSignatureItemQueryVariables = Exact<{
  where: DocumentCertificateSignatureItemWhereUniqueInput;
}>;


export type FindUniqueDocumentCertificateSignatureItemQuery = { findUniqueDocumentCertificateSignatureItem?: Maybe<(
    { __typename?: 'DocumentCertificateSignatureItem' }
    & DocumentCertificateSignatureItemFieldsFragment
  )> };

export type DocumentFinalAcademicTranscriptFieldsFragment = { __typename?: 'DocumentFinalAcademicTranscript', documentBaseId: string, status: DocumentFinalAcademicTranscriptStatus, DocumentBase: (
    { __typename?: 'DocumentBase' }
    & DocumentBaseFieldsFragment
  ) };

export type FindUniqueDocumentFinalAcademicTranscriptQueryVariables = Exact<{
  where: DocumentFinalAcademicTranscriptWhereUniqueInput;
}>;


export type FindUniqueDocumentFinalAcademicTranscriptQuery = { findUnique?: Maybe<(
    { __typename?: 'DocumentFinalAcademicTranscript' }
    & DocumentFinalAcademicTranscriptFieldsFragment
  )> };

export type FindUniqueDocumentSchoolCurriculumQueryVariables = Exact<{
  where: DocumentSchoolCurriculumWhereUniqueInput;
}>;


export type FindUniqueDocumentSchoolCurriculumQuery = { findUniqueDocumentSchoolCurriculum?: Maybe<(
    { __typename?: 'DocumentSchoolCurriculum' }
    & DocumentSchoolCurriculumFieldsFragment
  )> };

export type ExternalSignatureInviteFieldsFragment = { __typename?: 'ExternalSignatureInvite', id: string, isSigned: boolean, callbackUrl?: Maybe<string>, createdAt: any, documentBaseInternalSeqId: string, groupIndex: number, documentStudentName?: Maybe<string>, enabledPersonIdList: Array<string>, DocumentBase: { __typename?: 'DocumentBase', type: DocumentBaseType, ExternalSignatureInvite: Array<{ __typename?: 'ExternalSignatureInvite', groupIndex: number, isSigned: boolean }> } };

export type FindUniqueExternalSignatureInviteQueryVariables = Exact<{
  where: ExternalSignatureInviteWhereUniqueInput;
}>;


export type FindUniqueExternalSignatureInviteQuery = { findUniqueExternalSignatureInvite?: Maybe<(
    { __typename?: 'ExternalSignatureInvite' }
    & ExternalSignatureInviteFieldsFragment
  )> };

export type FindUniquePersonQueryVariables = Exact<{
  where: PersonWhereUniqueInput;
}>;


export type FindUniquePersonQuery = { findUniquePerson?: Maybe<(
    { __typename?: 'Person' }
    & PersonFieldsFragment
  )> };

export type ReusableFormDataCurriculumUniqueFieldsFragment = { __typename?: 'ReusableFormDataCurriculum', id: number, name: string, Course: { __typename?: 'ReusableFormData', id: number, data: any }, DisciplineLinks: Array<{ __typename?: 'ReusableFormDataCurriculumDisciplineLink', Discipline: { __typename?: 'ReusableFormData', id: number, data: any } }> };

export type FindUniqueReusableFormDataCurriculumQueryVariables = Exact<{
  where: ReusableFormDataCurriculumWhereUniqueInput;
}>;


export type FindUniqueReusableFormDataCurriculumQuery = { findUniqueReusableFormDataCurriculum?: Maybe<(
    { __typename?: 'ReusableFormDataCurriculum' }
    & ReusableFormDataCurriculumUniqueFieldsFragment
  )> };

export type SignSignatureImageUniqueFieldsFragment = { __typename?: 'SignSignatureImage', id: string, base64Image: string, description: string, percentageBelowTheLine: number, createdAt: any };

export type FindUniqueSignSignatureImageQueryVariables = Exact<{
  where: SignSignatureImageWhereUniqueInput;
}>;


export type FindUniqueSignSignatureImageQuery = { findUniqueSignSignatureImage?: Maybe<(
    { __typename?: 'SignSignatureImage' }
    & SignSignatureImageUniqueFieldsFragment
  )> };

export type UniqueTeamFieldsFragment = { __typename?: 'Team', publicViewInstitutionName?: Maybe<string>, memberCount: number, TeamMember: Array<{ __typename?: 'TeamMember', id: number, role?: Maybe<string>, User: { __typename?: 'CommonUser', lastActivityAt: any, name?: Maybe<string>, email: string, cpf?: Maybe<string>, createdAt: any } }>, TeamEducationLevel: Array<{ __typename?: 'TeamEducationLevel', id: number, educationLevelType: EducationLevelType, teamId: number }> };

export type FindUniqueTeamQueryVariables = Exact<{
  where: TeamWhereUniqueInput;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<TeamMemberOrderByWithRelationInput> | TeamMemberOrderByWithRelationInput>;
  teamMemberWhere?: Maybe<TeamMemberWhereInput>;
}>;


export type FindUniqueTeamQuery = { findUniqueTeam?: Maybe<(
    { __typename?: 'Team' }
    & UniqueTeamFieldsFragment
  )> };

export type FindUniqueTeamEducationLevelQueryVariables = Exact<{
  where: TeamEducationLevelWhereUniqueInput;
}>;


export type FindUniqueTeamEducationLevelQuery = { findUniqueTeamEducationLevel?: Maybe<{ __typename?: 'TeamEducationLevel', id: number, educationLevelType: EducationLevelType, teamId: number }> };

export type PublicViewFieldsFragment = { __typename?: 'PublicView', documentTypeName: string, downloadUrl: string, isValid: boolean, isVisualRepresentationEnabled: boolean, securityCode: string, validationDatetime: string, visualRepresentationUrl?: Maybe<string>, dataKeyValues: Array<{ __typename?: 'KeyValue', key: string, value?: Maybe<string> }> };

export type FindUniqueToSeePublicDocumentQueryVariables = Exact<{
  recaptchaResponse: Scalars['String'];
}>;


export type FindUniqueToSeePublicDocumentQuery = { findUniqueToSeePublicDocument?: Maybe<(
    { __typename?: 'PublicView' }
    & PublicViewFieldsFragment
  )> };

export type ForceGenerateDocumentAcademicDocumentationMutationVariables = Exact<{
  docId: Scalars['String'];
}>;


export type ForceGenerateDocumentAcademicDocumentationMutation = { forceGenerateDocumentAcademicDocumentation?: Maybe<{ __typename?: 'DocumentAcademicDocumentation', documentBaseId: string }> };

export type ForceGenerateDocumentSchoolCurriculumMutationVariables = Exact<{
  docId: Scalars['String'];
}>;


export type ForceGenerateDocumentSchoolCurriculumMutation = { forceGenerateDocumentSchoolCurriculum?: Maybe<{ __typename?: 'DocumentSchoolCurriculum', documentBaseId: string }> };

export type GenerateSampleCertificatePdfBase64QueryVariables = Exact<{
  template: Scalars['Json'];
}>;


export type GenerateSampleCertificatePdfBase64Query = { generateSampleCertificatePdfBase64: string };

export type GetDocumentJsonQueryVariables = Exact<{
  where?: Maybe<DocumentAcademicDocumentationWhereInput>;
}>;


export type GetDocumentJsonQuery = { findFirstDocumentAcademicDocumentation?: Maybe<{ __typename?: 'DocumentAcademicDocumentation', documentBaseId: string, DocumentBase: { __typename?: 'DocumentBase', dataWithIesAndFiles: any } }> };

export type GetDocumentJsonSchoolCurriculumQueryVariables = Exact<{
  where: DocumentSchoolCurriculumWhereUniqueInput;
}>;


export type GetDocumentJsonSchoolCurriculumQuery = { findUniqueDocumentSchoolCurriculum?: Maybe<(
    { __typename?: 'DocumentSchoolCurriculum' }
    & DocumentSchoolCurriculumFieldsFragment
  )> };

export type GetDocumentVariableJsonQueryVariables = Exact<{
  removeFiles?: Maybe<Scalars['Boolean']>;
  coverWithMetaAndData?: Maybe<Scalars['Boolean']>;
  clean?: Maybe<Scalars['Boolean']>;
  where?: Maybe<DocumentAcademicDocumentationWhereInput>;
}>;


export type GetDocumentVariableJsonQuery = { findFirstDocumentAcademicDocumentation?: Maybe<{ __typename?: 'DocumentAcademicDocumentation', DocumentBase: { __typename?: 'DocumentBase', variableJson: any } }> };

export type GetFinancialRechargeDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFinancialRechargeDataQuery = { getFinancialRechargePlans: { __typename?: 'RechargeOptions', discounts: Array<{ __typename?: 'Discount', count: number, valueInPercent: number }>, presets: Array<{ __typename?: 'Preset', count: number }>, servicesPrices: Array<{ __typename?: 'ServicePrice', service: FinancialChargeableService, unitPrice: number }> }, findManyFinancialCreditCardSaved: Array<{ __typename?: 'FinancialCreditCardSaved', id: number, token: string, number: string, brand: string }> };

export type RechargeOptionsFieldsFragment = { __typename?: 'RechargeOptions', discounts: Array<{ __typename?: 'Discount', count: number, valueInPercent: number }>, presets: Array<{ __typename?: 'Preset', count: number }>, servicesPrices: Array<{ __typename?: 'ServicePrice', service: FinancialChargeableService, unitPrice: number }> };

export type GetFinancialRechargePlansQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFinancialRechargePlansQuery = { getFinancialRechargePlans: (
    { __typename?: 'RechargeOptions' }
    & RechargeOptionsFieldsFragment
  ) };

export type GetMineTeamQueryVariables = Exact<{
  orderBy?: Maybe<Array<TeamOrderByWithRelationInput> | TeamOrderByWithRelationInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TeamWhereInput>;
}>;


export type GetMineTeamQuery = { count: number, getMineTeam?: Maybe<{ __typename?: 'Team', id: number, createdAt: any, updatedAt?: Maybe<any>, TeamMember: Array<(
      { __typename?: 'TeamMember' }
      & TeamMemberFieldsFragment
    )>, Documents: Array<{ __typename?: 'DocumentBase', type: DocumentBaseType }> }> };

export type GetTeamConfigsQueryVariables = Exact<{
  orderBy?: Maybe<Array<TeamOrderByWithRelationInput> | TeamOrderByWithRelationInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<TeamWhereInput>;
}>;


export type GetTeamConfigsQuery = { getMineTeam?: Maybe<{ __typename?: 'Team', configAddDocumentSignerNode: boolean }> };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { me?: Maybe<(
    { __typename?: 'CommonUser' }
    & UserFieldsFragment
  )> };

export type StartOneSignatureMutationVariables = Exact<{
  inviteId: Scalars['Int'];
  certificate: Scalars['String'];
}>;


export type StartOneSignatureMutation = { startOneSignature: { __typename?: 'StartSignature', dataToSign: string, signingTime: string, lastSignatureIsoString: string } };

export type StartOneSignatureExternalSignatureInviteMutationVariables = Exact<{
  inviteId: Scalars['String'];
  certificate: Scalars['String'];
}>;


export type StartOneSignatureExternalSignatureInviteMutation = { startOneSignature: { __typename?: 'StartSignature', dataToSign: string, signingTime: string, lastSignatureIsoString: string } };

export type SummaryFinancialChargeQueryVariables = Exact<{
  where?: Maybe<FinancialChargeWhereInput>;
}>;


export type SummaryFinancialChargeQuery = { summaryFinancialCharge: { __typename?: 'SumCount', sum: number, count: number } };

export type UpdateOneDegreeVisualRepresentationMutationVariables = Exact<{
  degreeId: Scalars['String'];
  visualRepresentation: Scalars['Upload'];
}>;


export type UpdateOneDegreeVisualRepresentationMutation = { updateOneDegreeVisualRepresentation?: Maybe<{ __typename?: 'DocumentDegree', documentBaseId: string }> };

export type DocumentCertificateValidateFieldsFragment = { __typename?: 'DocumentCertificateHashHistory', id: string, hash: string, documentBaseId: string, createdAt: any, DocumentCertificate: { __typename?: 'DocumentCertificate', uuid: string, documentBaseId: string, documentCertificateCPF: string, documentCertificateName: string, status: DocumentCertificateStatus, MetadataList: Array<{ __typename?: 'DocumentCertificateMetadata', id: number, key: string, value: string }>, DocumentBase: { __typename?: 'DocumentBase', createdAt: any, updatedAt?: Maybe<any>, Team: { __typename?: 'Team', publicViewInstitutionName?: Maybe<string> }, Histories: Array<{ __typename?: 'DocumentBaseHistory', data?: Maybe<any>, status?: Maybe<string> }> }, DocumentCertificateSignatureItems: Array<{ __typename?: 'DocumentCertificateSignatureItem', id: string, createdAt: any, PossibleSigners: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInvite', DocumentCertificateSignatureItemPossibleSignerInviteSignature: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInviteSignature', success: boolean, createdAt: any }>, TeamMember: { __typename?: 'TeamMember', User: { __typename?: 'CommonUser', name?: Maybe<string> } } }> }> } };

export type ValidateOneDocumentCertificateQueryVariables = Exact<{
  file?: Maybe<Scalars['Upload']>;
  docId?: Maybe<Scalars['String']>;
  recaptchaResponse: Scalars['String'];
}>;


export type ValidateOneDocumentCertificateQuery = { validateOneDocumentCertificate: { __typename?: 'validateOneDocumentCertificateObject', certificate: (
      { __typename?: 'DocumentCertificateHashHistory' }
      & DocumentCertificateValidateFieldsFragment
    ), validationResult: { __typename?: 'ValidationResult', isValid: boolean } } };

export type WatchFindFirstDocumentAcademicDocumentationSubscriptionVariables = Exact<{
  where: DocumentAcademicDocumentationWhereInput;
}>;


export type WatchFindFirstDocumentAcademicDocumentationSubscription = { findFirstDocumentAcademicDocumentation?: Maybe<{ __typename?: 'DocumentAcademicDocumentation', documentBaseId: string, type: DocumentAcademicDocumentationType, status: DocumentAcademicDocumentationStatus, DocumentBase: { __typename?: 'DocumentBase', type: DocumentBaseType, internalSeqId: string, version: string, createdAt: any, creationType: DocumentAcademicDocumentationCreationType, data: any, filePath?: Maybe<string>, signatureConfig: Array<SignatureType>, UserOwner: { __typename?: 'CommonUser', id: number, email: string }, DocumentBaseSignatureInviteGroups: Array<(
        { __typename?: 'DocumentBaseSignatureInviteGroup' }
        & DocumentBaseSignatureInviteGroupFieldsFragment
      )>, Histories: Array<{ __typename?: 'DocumentBaseHistory', id: number, description?: Maybe<string>, status?: Maybe<string>, createdAt: any, data?: Maybe<any>, UserCreated?: Maybe<{ __typename?: 'CommonUser', id: number, name?: Maybe<string>, photo?: Maybe<string>, email: string }> }> }, ChildDocuments: Array<{ __typename?: 'DocumentFinalAcademicTranscript', status: DocumentFinalAcademicTranscriptStatus, DocumentBase: { __typename?: 'DocumentBase', internalSeqId: string, version: string, createdAt: any } }> }> };

export type FindUniqueSignSignatureImageSubSubscriptionVariables = Exact<{
  where: SignSignatureImageWhereUniqueInput;
}>;


export type FindUniqueSignSignatureImageSubSubscription = { findUniqueSignSignatureImage?: Maybe<(
    { __typename?: 'SignSignatureImage' }
    & SignSignatureImageUniqueFieldsFragment
  )> };

export type GeneratedCertificateSubscriptionVariables = Exact<{
  institutionId: Scalars['Int'];
  bulkCertificateRecordId: Scalars['String'];
}>;


export type GeneratedCertificateSubscription = { generatedCertificate: { __typename?: 'GeneratedCertificateData', institutionId: number, bulkCertificateRecordId: string, certificateId?: Maybe<string>, totalIssued: number, totalCertificates: number } };

export type WatchSignBulkCertificateSubscriptionVariables = Exact<{
  bulkId: Scalars['String'];
}>;


export type WatchSignBulkCertificateSubscription = { watchSignBulkCertificate: { __typename?: 'WatchSignBulkCertificate', documentsCompleted: number, status: string, totalInviteForSign: number } };

export type WatchSignValidationBulkCertificateSubscriptionVariables = Exact<{
  bulkId: Scalars['String'];
}>;


export type WatchSignValidationBulkCertificateSubscription = { watchSignValidationBulkCertificate: { __typename?: 'WatchSignValidationBulkCertificate', status: string } };

export type WatchSingleCertificateSignValidationEventSubscriptionVariables = Exact<{
  inviteId: Scalars['String'];
}>;


export type WatchSingleCertificateSignValidationEventSubscription = { watchSingleCertificateSignValidationEvent: { __typename?: 'WatchSingleCertificateSignValidationEvent', status: string } };

export type WatchCertificateTemplateDataSubscriptionVariables = Exact<{
  teamId: Scalars['Int'];
  templateId: Scalars['String'];
}>;


export type WatchCertificateTemplateDataSubscription = { watchCertificateTemplateData: { __typename?: 'WatchCertificateTemplateData', data?: Maybe<any> } };

export type WatchDocumentFocusFieldsFragment = { __typename?: 'WatchDocumentFocus', fieldPath: string, user: { __typename?: 'CommonUser', id: number, email: string, photo?: Maybe<string>, name?: Maybe<string> } };

export type WatchDocumentFocusSubscriptionVariables = Exact<{
  documentId: Scalars['String'];
  teamId: Scalars['Int'];
}>;


export type WatchDocumentFocusSubscription = { watchDocumentFocus: Array<(
    { __typename?: 'WatchDocumentFocus' }
    & WatchDocumentFocusFieldsFragment
  )> };

export type WatchDocumentPatchFieldsFragment = { __typename?: 'WatchDocumentPatch', changes: Array<{ __typename?: 'WatchDocumentPatchesChanges', propertyPath: string, type: string, value?: Maybe<any> }> };

export type WatchDocumentPatchesSubscriptionVariables = Exact<{
  documentId: Scalars['String'];
  teamId: Scalars['Int'];
}>;


export type WatchDocumentPatchesSubscription = { watchDocumentPatches: (
    { __typename?: 'WatchDocumentPatch' }
    & WatchDocumentPatchFieldsFragment
  ) };

export type WatchDocumentStatusSubscriptionVariables = Exact<{
  documentId: Scalars['String'];
  teamId: Scalars['Int'];
}>;


export type WatchDocumentStatusSubscription = { watchDocumentStatus: string };

export type WatchFinancialTeamWalletSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type WatchFinancialTeamWalletSubscription = { watchFinancialTeamWallet: { __typename?: 'FinancialTeamWallet', creditsPlanVisual: number, creditsPlanTrial: number, creditsPlanRb: number, creditsPlanRtRa: number, creditsDetachedVisual: number, creditsDetachedRb: number, creditsDetachedRtRa: number, teamId: number } };

export const TeamMemberFieldsFragmentDoc = gql`
    fragment TeamMemberFields on TeamMember {
  id
  role
  User {
    email
    cpf
    name
    photo
  }
  createdAt
  TeamMemberPermissions {
    Permission {
      code
    }
  }
}
    `;
export const DocumentBaseSignatureInviteGroupFieldsFragmentDoc = gql`
    fragment DocumentBaseSignatureInviteGroupFields on DocumentBaseSignatureInviteGroup {
  order
  id
  Invites {
    id
    TeamMember {
      ...TeamMemberFields
    }
    Signatures {
      id
      createdAt
      User {
        id
        name
        email
        cpf
      }
    }
  }
}
    ${TeamMemberFieldsFragmentDoc}`;
export const DocumentBaseFieldsFragmentDoc = gql`
    fragment DocumentBaseFields on DocumentBase {
  type
  internalSeqId
  version
  createdAt
  updatedAt
  creationType
  data
  filePath
  signatureConfig
  UserOwner {
    id
    email
  }
  DocumentBaseSignatureInviteGroups {
    ...DocumentBaseSignatureInviteGroupFields
  }
  Histories(orderBy: {createdAt: asc}) {
    id
    description
    status
    createdAt
    data
    UserCreated {
      id
      name
      photo
      email
    }
  }
}
    ${DocumentBaseSignatureInviteGroupFieldsFragmentDoc}`;
export const DocumentAcademicDocumentationFieldsFragmentDoc = gql`
    fragment DocumentAcademicDocumentationFields on DocumentAcademicDocumentation {
  DocumentBase {
    ...DocumentBaseFields
  }
  documentBaseId
  type
  ChildDocuments {
    documentBaseId
    status
    DocumentBase {
      type
      internalSeqId
      version
      createdAt
    }
  }
  status
}
    ${DocumentBaseFieldsFragmentDoc}`;
export const DocumentBaseSignatureInviteFieldsFragmentDoc = gql`
    fragment DocumentBaseSignatureInviteFields on DocumentBaseSignatureInvite {
  id
  createdAt
  Signatures {
    id
    createdAt
    User {
      id
      name
      email
      cpf
    }
  }
  TeamMember {
    User {
      cpf
    }
  }
  Group {
    id
    order
    DocumentBase {
      internalSeqId
      version
      UserOwner {
        email
      }
      type
      DocumentBaseSignatureInviteGroups {
        ...DocumentBaseSignatureInviteGroupFields
      }
      DocumentAcademicDocumentation {
        searchStudentName
        searchCourse
        searchCPF
        searchEmecCode
      }
      DocumentDegree {
        searchStudentName
        searchCourse
        searchCPF
        searchEmecCode
      }
      DocumentFinalAcademicTranscript {
        searchStudentName
        searchCourse
        searchCPF
        searchEmecCode
      }
      DocumentAuditFileIssuer {
        searchAuditStartDate
        searchAuditEndDate
      }
      createdAt
    }
  }
}
    ${DocumentBaseSignatureInviteGroupFieldsFragmentDoc}`;
export const DocumentDegreeFieldsFragmentDoc = gql`
    fragment DocumentDegreeFields on DocumentDegree {
  documentBaseId
  searchStudentName
  searchCPF
  searchCourse
  searchEmecCode
  status
  searchValidationCode
  searchIssueDate
  searchRegistrationDate
  DocumentBase {
    internalSeqId
    createdAt
  }
}
    `;
export const DocumentDegreeUniqueFieldsFragmentDoc = gql`
    fragment DocumentDegreeUniqueFields on DocumentDegree {
  documentBaseId
  visualRepresentationPath
  searchStudentName
  searchCPF
  searchCourse
  searchValidationCode
  status
  ParentAcademicDocumentation {
    DocumentBase {
      internalSeqId
    }
  }
  DocumentBase {
    ...DocumentBaseFields
    filePath
    type
    UserOwner {
      id
    }
  }
}
    ${DocumentBaseFieldsFragmentDoc}`;
export const PersonFieldsFragmentDoc = gql`
    fragment PersonFields on Person {
  name
  receivesCertificateEmail
  receivesCertificateWhatsapp
  Phones {
    number
  }
  cpf
  birthDate
  identityDocument
  email
  isForeign
  passport
  Address {
    city
    complement
    neighborhood
    postalCode
    state
    street
  }
}
    `;
export const DocumentSchoolCurriculumFieldsFragmentDoc = gql`
    fragment DocumentSchoolCurriculumFields on DocumentSchoolCurriculum {
  DocumentBase {
    ...DocumentBaseFields
  }
  searchSchoolCurriculumName
  searchSchoolCurriculumCode
  documentBaseId
  status
}
    ${DocumentBaseFieldsFragmentDoc}`;
export const TeamFieldsFragmentDoc = gql`
    fragment TeamFields on Team {
  isNSF
  cnpj
  createdAt
  TeamMember(where: $teamMemberWhere, skip: $skip, take: $take, orderBy: $orderBy) {
    role
    User {
      name
      cpf
      email
      createdAt
    }
  }
  TeamEducationLevel {
    educationLevelType
  }
}
    `;
export const SystemGlobalAlertFieldsFragmentDoc = gql`
    fragment SystemGlobalAlertFields on SystemGlobalAlert {
  id
  type
  value
  actionUrl
  actionTitle
  message
  forcedTitle
  forcedDescription
  forcedActionUrl
  myDismissonsCount
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on CommonUser {
  id
  email
  createdAt
  institutionCnpj
  name
  cpf
  photo
  permissions
  teamId
  computedResolvedAt
  UserConfigs {
    key
    value
  }
  Team {
    FinancialTeamWallet {
      creditsPlanVisual
      creditsPlanTrial
      creditsPlanRb
      creditsPlanRtRa
      creditsDetachedVisual
      creditsDetachedRb
      creditsDetachedRtRa
      SubscriptionActive {
        id
        plan
        billingCycle
        planName
        canceledAt
        nextDueDate
        annualCreditQuotaResetDate
        createdAt
        planUpdatedPrice
      }
      teamId
    }
    financialShouldCharge
    isNSF
    issuerData
    id
    configAddDocumentSignerNode
    publicViewDegreeDomainPath
    publicViewFinalAcademicTranscriptDomainPath
    publicViewSchoolCurriculumDomainPath
    externalSignatureWebhookURL
    TeamEducationLevel {
      educationLevelType
    }
    placeholderName
  }
  loggedAs
  defaultSignatureImageId
  UserAlerts {
    ...SystemGlobalAlertFields
  }
  MaintainerAdmin {
    Maintainer {
      id
      Teams(orderBy: [{id: asc}]) {
        isActive
        issuerName
        placeholderName
        id
      }
    }
  }
}
    ${SystemGlobalAlertFieldsFragmentDoc}`;
export const SignSignatureImageFieldsFragmentDoc = gql`
    fragment SignSignatureImageFields on SignSignatureImage {
  id
  base64Image
  createdAt
  description
  UserUsingAsPrimary {
    id
  }
  percentageBelowTheLine
}
    `;
export const CertificateCourseFieldsFragmentDoc = gql`
    fragment CertificateCourseFields on CertificateCourse {
  certificateBaseId
  name
  areaKnowledge
  metaData
  CertificateBase {
    createdAt
  }
  CourseLevel {
    certificateBaseId
    name
  }
}
    `;
export const CertificateCourseLevelFieldsFragmentDoc = gql`
    fragment CertificateCourseLevelFields on CertificateCourseLevel {
  certificateBaseId
  name
  CertificateBase {
    createdAt
  }
}
    `;
export const CertificateCurriculumFieldsFragmentDoc = gql`
    fragment CertificateCurriculumFields on CertificateCurriculum {
  certificateBaseId
  name
  amountOfHours
  CertificateBase {
    createdAt
  }
  CertificateCurriculumSelectedDisciplines {
    SelectedDiscipline {
      name
      certificateBaseId
    }
  }
}
    `;
export const CertificateEventFieldsFragmentDoc = gql`
    fragment CertificateEventFields on CertificateEvent {
  certificateBaseId
  name
  CertificateBase {
    createdAt
  }
}
    `;
export const CertificateTemplateManyFieldsFragmentDoc = gql`
    fragment CertificateTemplateManyFields on CertificateTemplate {
  id
  name
  description
  createdAt
  commonUserId
}
    `;
export const EnabledInstitutionFieldsFragmentDoc = gql`
    fragment EnabledInstitutionFields on EnabledInstitution {
  cnpj
  email
  isMaintainer
  placeholderName
  Team {
    id
    contract
    observations
    syncWithLedgerDoc
    isNSF
    lastActivityAt
    issuedCount
    logoBase64
    faviconBase64
    publicViewDegreeDomainPath
    publicViewFinalAcademicTranscriptDomainPath
    publicViewSchoolCurriculumDomainPath
    publicViewInstitutionName
    publicViewPrimaryColor
    publicViewSecondaryColor
    externalSignatureWebhookURL
    validateCertificateURL
    isActive
    deactivationReason
    TeamEducationLevel {
      educationLevelType
    }
    issuerData
    issuerName
    Maintainer {
      id
      MainTeam {
        id
        issuerName
      }
    }
  }
}
    `;
export const PlanAndConditionsFieldsFragmentDoc = gql`
    fragment PlanAndConditionsFields on PlanAndConditions {
  includedCertificates
  name
  monthlyPricing
  yearlyPricing
  plan
  disabled
}
    `;
export const FinancialTeamWalletSubscriptionPaymentFieldsFragmentDoc = gql`
    fragment FinancialTeamWalletSubscriptionPaymentFields on FinancialTeamWalletSubscriptionPayment {
  id
  dueDate
  cost
  createdAt
  status
}
    `;
export const ReusableFormDataCurriculumFieldsFragmentDoc = gql`
    fragment ReusableFormDataCurriculumFields on ReusableFormDataCurriculum {
  id
  name
  Course {
    id
    data
  }
  createdAt
}
    `;
export const SystemGlobalAlertManyFieldsFragmentDoc = gql`
    fragment SystemGlobalAlertManyFields on SystemGlobalAlert {
  actionTitle
  actionUrl
  active
  createdAt
  forcedDescription
  forcedTitle
  id
  message
  type
  updatedAt
  createdAt
  value
  dismissonsCount
}
    `;
export const TeamManyFieldsFragmentDoc = gql`
    fragment TeamManyFields on Team {
  id
  issuedCount
  placeholderName
  validateCertificateURL
  cnpj
  lastActivityAt
  isActive
  deactivationReason
  Owner {
    id
    name
    email
  }
}
    `;
export const SystemAuditLogFieldsFragmentDoc = gql`
    fragment SystemAuditLogFields on SystemAuditLog {
  id
  table
  operation
  teamId
  User {
    id
    name
    photo
    email
  }
  operationTranslated
  moduleTranslated
  createdAt
  after
  args
  extraContext
  primaryKey
  translatedAfter {
    key
    value
  }
}
    `;
export const TeamAndPublicDocumentBaseTypeFieldsFragmentDoc = gql`
    fragment TeamAndPublicDocumentBaseTypeFields on TeamAndPublicDocumentBaseType {
  team {
    id
    publicViewDegreeDomainPath
    publicViewFinalAcademicTranscriptDomainPath
    publicViewSchoolCurriculumDomainPath
    publicViewInstitutionName
    publicViewPrimaryColor
    publicViewSecondaryColor
    externalSignatureWebhookURL
    logoBase64
    faviconBase64
  }
  documentSeeType
  url
}
    `;
export const SelectedDisciplineFieldsFragmentDoc = gql`
    fragment SelectedDisciplineFields on CertificateCurriculumSelectedDiscipline {
  SelectedDiscipline {
    certificateBaseId
    name
  }
  SelectedTeacher {
    certificateBaseId
    name
  }
  amountOfHours
}
    `;
export const CertificateTemplateFieldsFragmentDoc = gql`
    fragment CertificateTemplateFields on CertificateTemplate {
  id
  name
  description
  createdAt
  data
}
    `;
export const DegreeViewDegreeFragmentDoc = gql`
    fragment DegreeViewDegree on DocumentDegree {
  documentBaseId
  searchCourse
  searchCPF
  searchEmecCode
  searchStudentName
  searchValidationCode
  status
  visualRepresentationPath
  DocumentBase {
    Team {
      publicViewDegreeDomainPath
      publicViewFinalAcademicTranscriptDomainPath
      publicViewSchoolCurriculumDomainPath
      externalSignatureWebhookURL
      publicViewInstitutionName
      publicViewPrimaryColor
      publicViewSecondaryColor
    }
    createdAt
  }
}
    `;
export const DocumentAuditFileIssuerFieldsFragmentDoc = gql`
    fragment DocumentAuditFileIssuerFields on DocumentAuditFileIssuer {
  documentBaseId
  searchAuditStartDate
  searchAuditEndDate
  status
  DocumentBase {
    ...DocumentBaseFields
  }
}
    ${DocumentBaseFieldsFragmentDoc}`;
export const DocumentCertificateSignatureItemBaseFieldsFragmentDoc = gql`
    fragment DocumentCertificateSignatureItemBaseFields on DocumentCertificateSignatureItem {
  id
  predefinedImageBase64
  type
  createdAt
  PossibleSigners {
    id
    TeamMember {
      id
      User {
        id
        name
        email
      }
    }
    DocumentCertificateSignatureItemPossibleSignerInviteSignature {
      success
      createdAt
    }
  }
}
    `;
export const DocumentCertificateFieldsFragmentDoc = gql`
    fragment DocumentCertificateFields on DocumentCertificate {
  documentBaseId
  uuid
  documentCertificateCPF
  documentCertificateName
  certificateTemplateId
  status
  hasOnlyPredefinedVisualSignature
  Person {
    id
    name
    cpf
    email
  }
  BulkCertificateRecord {
    status
    id
    bulkCertificateRecordName
  }
  DocumentCertificateSignatureItems {
    id
    ...DocumentCertificateSignatureItemBaseFields
  }
  DocumentCertificateHashHistory {
    hash
  }
  TeamEducationLevel {
    educationLevelType
  }
  DocumentBase {
    ...DocumentBaseFields
  }
  DocumentCertificateSignatureItems {
    ...DocumentCertificateSignatureItemBaseFields
  }
}
    ${DocumentCertificateSignatureItemBaseFieldsFragmentDoc}
${DocumentBaseFieldsFragmentDoc}`;
export const DocumentCertificateSignatureItemFieldsFragmentDoc = gql`
    fragment DocumentCertificateSignatureItemFields on DocumentCertificateSignatureItem {
  id
  predefinedImageBase64
  type
  DocumentCertificate {
    ...DocumentCertificateFields
    DocumentBase {
      type
      internalSeqId
    }
    DocumentCertificateSignatureItems {
      id
      type
      predefinedImageBase64
      PossibleSigners {
        id
        TeamMember {
          id
          User {
            id
            cpf
            name
            email
          }
        }
        DocumentCertificateSignatureItemPossibleSignerInviteSignature {
          success
          createdAt
        }
      }
    }
  }
  PossibleSigners {
    id
    TeamMember {
      id
      User {
        id
        name
        email
        cpf
      }
    }
    DocumentCertificateSignatureItemPossibleSignerInviteSignature {
      success
      createdAt
    }
  }
}
    ${DocumentCertificateFieldsFragmentDoc}`;
export const DocumentFinalAcademicTranscriptFieldsFragmentDoc = gql`
    fragment DocumentFinalAcademicTranscriptFields on DocumentFinalAcademicTranscript {
  DocumentBase {
    ...DocumentBaseFields
  }
  documentBaseId
  status
}
    ${DocumentBaseFieldsFragmentDoc}`;
export const ExternalSignatureInviteFieldsFragmentDoc = gql`
    fragment ExternalSignatureInviteFields on ExternalSignatureInvite {
  id
  isSigned
  callbackUrl
  createdAt
  documentBaseInternalSeqId
  groupIndex
  documentStudentName
  DocumentBase {
    type
    ExternalSignatureInvite {
      groupIndex
      isSigned
    }
  }
  enabledPersonIdList
  DocumentBase {
    ExternalSignatureInvite {
      groupIndex
      isSigned
    }
  }
}
    `;
export const ReusableFormDataCurriculumUniqueFieldsFragmentDoc = gql`
    fragment ReusableFormDataCurriculumUniqueFields on ReusableFormDataCurriculum {
  id
  name
  Course {
    id
    data
  }
  DisciplineLinks {
    Discipline {
      id
      data
    }
  }
}
    `;
export const SignSignatureImageUniqueFieldsFragmentDoc = gql`
    fragment SignSignatureImageUniqueFields on SignSignatureImage {
  id
  base64Image
  description
  percentageBelowTheLine
  createdAt
}
    `;
export const UniqueTeamFieldsFragmentDoc = gql`
    fragment UniqueTeamFields on Team {
  TeamMember(take: $take, skip: $skip, orderBy: $orderBy, where: $teamMemberWhere) {
    id
    role
    User {
      lastActivityAt
      name
      email
      cpf
      createdAt
    }
  }
  publicViewInstitutionName
  memberCount
  TeamEducationLevel {
    id
    educationLevelType
    teamId
  }
}
    `;
export const PublicViewFieldsFragmentDoc = gql`
    fragment PublicViewFields on PublicView {
  dataKeyValues {
    key
    value
  }
  documentTypeName
  downloadUrl
  isValid
  isVisualRepresentationEnabled
  securityCode
  validationDatetime
  visualRepresentationUrl
}
    `;
export const RechargeOptionsFieldsFragmentDoc = gql`
    fragment RechargeOptionsFields on RechargeOptions {
  discounts {
    count
    valueInPercent
  }
  presets {
    count
  }
  servicesPrices {
    service
    unitPrice
  }
}
    `;
export const DocumentCertificateValidateFieldsFragmentDoc = gql`
    fragment DocumentCertificateValidateFields on DocumentCertificateHashHistory {
  id
  hash
  documentBaseId
  createdAt
  DocumentCertificate {
    uuid
    documentBaseId
    MetadataList {
      id
      key
      value
    }
    DocumentBase {
      createdAt
      updatedAt
      Team {
        publicViewInstitutionName
      }
      Histories {
        data
        status
      }
    }
    documentCertificateCPF
    documentCertificateName
    DocumentCertificateSignatureItems {
      id
      createdAt
      PossibleSigners {
        DocumentCertificateSignatureItemPossibleSignerInviteSignature {
          success
          createdAt
        }
        TeamMember {
          User {
            name
          }
        }
      }
    }
    status
  }
}
    `;
export const WatchDocumentFocusFieldsFragmentDoc = gql`
    fragment WatchDocumentFocusFields on WatchDocumentFocus {
  fieldPath
  user {
    id
    email
    photo
    name
  }
}
    `;
export const WatchDocumentPatchFieldsFragmentDoc = gql`
    fragment WatchDocumentPatchFields on WatchDocumentPatch {
  changes {
    propertyPath
    type
    value
  }
}
    `;
export const AddOneTeamMemberDocument = gql`
    mutation addOneTeamMember($email: String!, $permissions: [String!]!, $role: String) {
  addOneTeamMember(email: $email, permissions: $permissions, role: $role) {
    id
  }
}
    `;
export type AddOneTeamMemberMutationFn = Apollo.MutationFunction<AddOneTeamMemberMutation, AddOneTeamMemberMutationVariables>;

/**
 * __useAddOneTeamMemberMutation__
 *
 * To run a mutation, you first call `useAddOneTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOneTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOneTeamMemberMutation, { data, loading, error }] = useAddOneTeamMemberMutation({
 *   variables: {
 *      email: // value for 'email'
 *      permissions: // value for 'permissions'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useAddOneTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<AddOneTeamMemberMutation, AddOneTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOneTeamMemberMutation, AddOneTeamMemberMutationVariables>(AddOneTeamMemberDocument, options);
      }
export type AddOneTeamMemberMutationHookResult = ReturnType<typeof useAddOneTeamMemberMutation>;
export type AddOneTeamMemberMutationResult = Apollo.MutationResult<AddOneTeamMemberMutation>;
export type AddOneTeamMemberMutationOptions = Apollo.BaseMutationOptions<AddOneTeamMemberMutation, AddOneTeamMemberMutationVariables>;
export const BuildOneDegreeVisualRepresentationDocument = gql`
    mutation buildOneDegreeVisualRepresentation($degreeId: String!, $templateId: String!, $variables: Json!) {
  buildOneDegreeVisualRepresentation(
    degreeId: $degreeId
    templateId: $templateId
    variables: $variables
  ) {
    documentBaseId
    visualRepresentationPath
  }
}
    `;
export type BuildOneDegreeVisualRepresentationMutationFn = Apollo.MutationFunction<BuildOneDegreeVisualRepresentationMutation, BuildOneDegreeVisualRepresentationMutationVariables>;

/**
 * __useBuildOneDegreeVisualRepresentationMutation__
 *
 * To run a mutation, you first call `useBuildOneDegreeVisualRepresentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuildOneDegreeVisualRepresentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buildOneDegreeVisualRepresentationMutation, { data, loading, error }] = useBuildOneDegreeVisualRepresentationMutation({
 *   variables: {
 *      degreeId: // value for 'degreeId'
 *      templateId: // value for 'templateId'
 *      variables: // value for 'variables'
 *   },
 * });
 */
export function useBuildOneDegreeVisualRepresentationMutation(baseOptions?: Apollo.MutationHookOptions<BuildOneDegreeVisualRepresentationMutation, BuildOneDegreeVisualRepresentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuildOneDegreeVisualRepresentationMutation, BuildOneDegreeVisualRepresentationMutationVariables>(BuildOneDegreeVisualRepresentationDocument, options);
      }
export type BuildOneDegreeVisualRepresentationMutationHookResult = ReturnType<typeof useBuildOneDegreeVisualRepresentationMutation>;
export type BuildOneDegreeVisualRepresentationMutationResult = Apollo.MutationResult<BuildOneDegreeVisualRepresentationMutation>;
export type BuildOneDegreeVisualRepresentationMutationOptions = Apollo.BaseMutationOptions<BuildOneDegreeVisualRepresentationMutation, BuildOneDegreeVisualRepresentationMutationVariables>;
export const CodeAuthLoginLedgerSignDocument = gql`
    mutation codeAuthLoginLedgerSign($token: String!, $subservice: SubService!) {
  codeAuthLoginLedgerSign(token: $token, subservice: $subservice) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;
export type CodeAuthLoginLedgerSignMutationFn = Apollo.MutationFunction<CodeAuthLoginLedgerSignMutation, CodeAuthLoginLedgerSignMutationVariables>;

/**
 * __useCodeAuthLoginLedgerSignMutation__
 *
 * To run a mutation, you first call `useCodeAuthLoginLedgerSignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCodeAuthLoginLedgerSignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [codeAuthLoginLedgerSignMutation, { data, loading, error }] = useCodeAuthLoginLedgerSignMutation({
 *   variables: {
 *      token: // value for 'token'
 *      subservice: // value for 'subservice'
 *   },
 * });
 */
export function useCodeAuthLoginLedgerSignMutation(baseOptions?: Apollo.MutationHookOptions<CodeAuthLoginLedgerSignMutation, CodeAuthLoginLedgerSignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CodeAuthLoginLedgerSignMutation, CodeAuthLoginLedgerSignMutationVariables>(CodeAuthLoginLedgerSignDocument, options);
      }
export type CodeAuthLoginLedgerSignMutationHookResult = ReturnType<typeof useCodeAuthLoginLedgerSignMutation>;
export type CodeAuthLoginLedgerSignMutationResult = Apollo.MutationResult<CodeAuthLoginLedgerSignMutation>;
export type CodeAuthLoginLedgerSignMutationOptions = Apollo.BaseMutationOptions<CodeAuthLoginLedgerSignMutation, CodeAuthLoginLedgerSignMutationVariables>;
export const CodeAuthRefreshTokensDocument = gql`
    mutation codeAuthRefreshTokens($token: String!) {
  codeAuthRefreshTokens(token: $token) {
    id
  }
}
    `;
export type CodeAuthRefreshTokensMutationFn = Apollo.MutationFunction<CodeAuthRefreshTokensMutation, CodeAuthRefreshTokensMutationVariables>;

/**
 * __useCodeAuthRefreshTokensMutation__
 *
 * To run a mutation, you first call `useCodeAuthRefreshTokensMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCodeAuthRefreshTokensMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [codeAuthRefreshTokensMutation, { data, loading, error }] = useCodeAuthRefreshTokensMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useCodeAuthRefreshTokensMutation(baseOptions?: Apollo.MutationHookOptions<CodeAuthRefreshTokensMutation, CodeAuthRefreshTokensMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CodeAuthRefreshTokensMutation, CodeAuthRefreshTokensMutationVariables>(CodeAuthRefreshTokensDocument, options);
      }
export type CodeAuthRefreshTokensMutationHookResult = ReturnType<typeof useCodeAuthRefreshTokensMutation>;
export type CodeAuthRefreshTokensMutationResult = Apollo.MutationResult<CodeAuthRefreshTokensMutation>;
export type CodeAuthRefreshTokensMutationOptions = Apollo.BaseMutationOptions<CodeAuthRefreshTokensMutation, CodeAuthRefreshTokensMutationVariables>;
export const CodeServiceSendMessageToSlackDocument = gql`
    mutation codeServiceSendMessageToSlack($message: String!) {
  codeServiceSendMessageToSlack(message: $message)
}
    `;
export type CodeServiceSendMessageToSlackMutationFn = Apollo.MutationFunction<CodeServiceSendMessageToSlackMutation, CodeServiceSendMessageToSlackMutationVariables>;

/**
 * __useCodeServiceSendMessageToSlackMutation__
 *
 * To run a mutation, you first call `useCodeServiceSendMessageToSlackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCodeServiceSendMessageToSlackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [codeServiceSendMessageToSlackMutation, { data, loading, error }] = useCodeServiceSendMessageToSlackMutation({
 *   variables: {
 *      message: // value for 'message'
 *   },
 * });
 */
export function useCodeServiceSendMessageToSlackMutation(baseOptions?: Apollo.MutationHookOptions<CodeServiceSendMessageToSlackMutation, CodeServiceSendMessageToSlackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CodeServiceSendMessageToSlackMutation, CodeServiceSendMessageToSlackMutationVariables>(CodeServiceSendMessageToSlackDocument, options);
      }
export type CodeServiceSendMessageToSlackMutationHookResult = ReturnType<typeof useCodeServiceSendMessageToSlackMutation>;
export type CodeServiceSendMessageToSlackMutationResult = Apollo.MutationResult<CodeServiceSendMessageToSlackMutation>;
export type CodeServiceSendMessageToSlackMutationOptions = Apollo.BaseMutationOptions<CodeServiceSendMessageToSlackMutation, CodeServiceSendMessageToSlackMutationVariables>;
export const CompleteOneTemporarySignatureImageDocument = gql`
    mutation completeOneTemporarySignatureImage($completeData: CompleteSignatureImage!) {
  completeOneTemporarySignatureImage(completeData: $completeData) {
    id
  }
}
    `;
export type CompleteOneTemporarySignatureImageMutationFn = Apollo.MutationFunction<CompleteOneTemporarySignatureImageMutation, CompleteOneTemporarySignatureImageMutationVariables>;

/**
 * __useCompleteOneTemporarySignatureImageMutation__
 *
 * To run a mutation, you first call `useCompleteOneTemporarySignatureImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteOneTemporarySignatureImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeOneTemporarySignatureImageMutation, { data, loading, error }] = useCompleteOneTemporarySignatureImageMutation({
 *   variables: {
 *      completeData: // value for 'completeData'
 *   },
 * });
 */
export function useCompleteOneTemporarySignatureImageMutation(baseOptions?: Apollo.MutationHookOptions<CompleteOneTemporarySignatureImageMutation, CompleteOneTemporarySignatureImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteOneTemporarySignatureImageMutation, CompleteOneTemporarySignatureImageMutationVariables>(CompleteOneTemporarySignatureImageDocument, options);
      }
export type CompleteOneTemporarySignatureImageMutationHookResult = ReturnType<typeof useCompleteOneTemporarySignatureImageMutation>;
export type CompleteOneTemporarySignatureImageMutationResult = Apollo.MutationResult<CompleteOneTemporarySignatureImageMutation>;
export type CompleteOneTemporarySignatureImageMutationOptions = Apollo.BaseMutationOptions<CompleteOneTemporarySignatureImageMutation, CompleteOneTemporarySignatureImageMutationVariables>;
export const CorrectOneDocumentAuditFileIssuerDocument = gql`
    mutation correctOneDocumentAuditFileIssuer($degreeCount: Int!, $documentBaseId: String!, $endDate: Date!, $startDate: Date!, $excludeRevoked: Boolean!) {
  correctOneDocumentAuditFileIssuer(
    degreeCount: $degreeCount
    documentBaseId: $documentBaseId
    endDate: $endDate
    startDate: $startDate
    excludeRevoked: $excludeRevoked
  ) {
    documentBaseId
  }
}
    `;
export type CorrectOneDocumentAuditFileIssuerMutationFn = Apollo.MutationFunction<CorrectOneDocumentAuditFileIssuerMutation, CorrectOneDocumentAuditFileIssuerMutationVariables>;

/**
 * __useCorrectOneDocumentAuditFileIssuerMutation__
 *
 * To run a mutation, you first call `useCorrectOneDocumentAuditFileIssuerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCorrectOneDocumentAuditFileIssuerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [correctOneDocumentAuditFileIssuerMutation, { data, loading, error }] = useCorrectOneDocumentAuditFileIssuerMutation({
 *   variables: {
 *      degreeCount: // value for 'degreeCount'
 *      documentBaseId: // value for 'documentBaseId'
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      excludeRevoked: // value for 'excludeRevoked'
 *   },
 * });
 */
export function useCorrectOneDocumentAuditFileIssuerMutation(baseOptions?: Apollo.MutationHookOptions<CorrectOneDocumentAuditFileIssuerMutation, CorrectOneDocumentAuditFileIssuerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CorrectOneDocumentAuditFileIssuerMutation, CorrectOneDocumentAuditFileIssuerMutationVariables>(CorrectOneDocumentAuditFileIssuerDocument, options);
      }
export type CorrectOneDocumentAuditFileIssuerMutationHookResult = ReturnType<typeof useCorrectOneDocumentAuditFileIssuerMutation>;
export type CorrectOneDocumentAuditFileIssuerMutationResult = Apollo.MutationResult<CorrectOneDocumentAuditFileIssuerMutation>;
export type CorrectOneDocumentAuditFileIssuerMutationOptions = Apollo.BaseMutationOptions<CorrectOneDocumentAuditFileIssuerMutation, CorrectOneDocumentAuditFileIssuerMutationVariables>;
export const CreateApiKeyDocument = gql`
    mutation createApiKey($description: String!) {
  createApiKey(description: $description)
}
    `;
export type CreateApiKeyMutationFn = Apollo.MutationFunction<CreateApiKeyMutation, CreateApiKeyMutationVariables>;

/**
 * __useCreateApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiKeyMutation, { data, loading, error }] = useCreateApiKeyMutation({
 *   variables: {
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreateApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<CreateApiKeyMutation, CreateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApiKeyMutation, CreateApiKeyMutationVariables>(CreateApiKeyDocument, options);
      }
export type CreateApiKeyMutationHookResult = ReturnType<typeof useCreateApiKeyMutation>;
export type CreateApiKeyMutationResult = Apollo.MutationResult<CreateApiKeyMutation>;
export type CreateApiKeyMutationOptions = Apollo.BaseMutationOptions<CreateApiKeyMutation, CreateApiKeyMutationVariables>;
export const CreateBulkDocumentCertificateDocument = gql`
    mutation createBulkDocumentCertificate($curriculumId: String, $templateId: String!, $variables: Json!, $importedRecords: Json!, $bulkCertificateRecordName: String!, $eventId: String, $ignoreUsingExpensiveCreditsError: Boolean) {
  createBulkDocumentCertificate(
    curriculumId: $curriculumId
    templateId: $templateId
    variables: $variables
    importedRecords: $importedRecords
    bulkCertificateRecordName: $bulkCertificateRecordName
    eventId: $eventId
    ignoreUsingExpensiveCreditsError: $ignoreUsingExpensiveCreditsError
  ) {
    id
    createdAt
    totalCertificates
  }
}
    `;
export type CreateBulkDocumentCertificateMutationFn = Apollo.MutationFunction<CreateBulkDocumentCertificateMutation, CreateBulkDocumentCertificateMutationVariables>;

/**
 * __useCreateBulkDocumentCertificateMutation__
 *
 * To run a mutation, you first call `useCreateBulkDocumentCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBulkDocumentCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBulkDocumentCertificateMutation, { data, loading, error }] = useCreateBulkDocumentCertificateMutation({
 *   variables: {
 *      curriculumId: // value for 'curriculumId'
 *      templateId: // value for 'templateId'
 *      variables: // value for 'variables'
 *      importedRecords: // value for 'importedRecords'
 *      bulkCertificateRecordName: // value for 'bulkCertificateRecordName'
 *      eventId: // value for 'eventId'
 *      ignoreUsingExpensiveCreditsError: // value for 'ignoreUsingExpensiveCreditsError'
 *   },
 * });
 */
export function useCreateBulkDocumentCertificateMutation(baseOptions?: Apollo.MutationHookOptions<CreateBulkDocumentCertificateMutation, CreateBulkDocumentCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBulkDocumentCertificateMutation, CreateBulkDocumentCertificateMutationVariables>(CreateBulkDocumentCertificateDocument, options);
      }
export type CreateBulkDocumentCertificateMutationHookResult = ReturnType<typeof useCreateBulkDocumentCertificateMutation>;
export type CreateBulkDocumentCertificateMutationResult = Apollo.MutationResult<CreateBulkDocumentCertificateMutation>;
export type CreateBulkDocumentCertificateMutationOptions = Apollo.BaseMutationOptions<CreateBulkDocumentCertificateMutation, CreateBulkDocumentCertificateMutationVariables>;
export const CreateOneDocumentAcademicDocumentationDocument = gql`
    mutation createOneDocumentAcademicDocumentation($draftId: String!) {
  createOneDocumentAcademicDocumentation(draftId: $draftId) {
    ...DocumentAcademicDocumentationFields
  }
}
    ${DocumentAcademicDocumentationFieldsFragmentDoc}`;
export type CreateOneDocumentAcademicDocumentationMutationFn = Apollo.MutationFunction<CreateOneDocumentAcademicDocumentationMutation, CreateOneDocumentAcademicDocumentationMutationVariables>;

/**
 * __useCreateOneDocumentAcademicDocumentationMutation__
 *
 * To run a mutation, you first call `useCreateOneDocumentAcademicDocumentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneDocumentAcademicDocumentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneDocumentAcademicDocumentationMutation, { data, loading, error }] = useCreateOneDocumentAcademicDocumentationMutation({
 *   variables: {
 *      draftId: // value for 'draftId'
 *   },
 * });
 */
export function useCreateOneDocumentAcademicDocumentationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneDocumentAcademicDocumentationMutation, CreateOneDocumentAcademicDocumentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneDocumentAcademicDocumentationMutation, CreateOneDocumentAcademicDocumentationMutationVariables>(CreateOneDocumentAcademicDocumentationDocument, options);
      }
export type CreateOneDocumentAcademicDocumentationMutationHookResult = ReturnType<typeof useCreateOneDocumentAcademicDocumentationMutation>;
export type CreateOneDocumentAcademicDocumentationMutationResult = Apollo.MutationResult<CreateOneDocumentAcademicDocumentationMutation>;
export type CreateOneDocumentAcademicDocumentationMutationOptions = Apollo.BaseMutationOptions<CreateOneDocumentAcademicDocumentationMutation, CreateOneDocumentAcademicDocumentationMutationVariables>;
export const CreateOneDocumentAcademicDocumentationFromRevokedDocumentDocument = gql`
    mutation createOneDocumentAcademicDocumentationFromRevokedDocument($documentId: String!) {
  createOneDocumentAcademicDocumentationFromRevokedDocument(
    documentId: $documentId
  ) {
    DocumentBase {
      internalSeqId
      type
    }
  }
}
    `;
export type CreateOneDocumentAcademicDocumentationFromRevokedDocumentMutationFn = Apollo.MutationFunction<CreateOneDocumentAcademicDocumentationFromRevokedDocumentMutation, CreateOneDocumentAcademicDocumentationFromRevokedDocumentMutationVariables>;

/**
 * __useCreateOneDocumentAcademicDocumentationFromRevokedDocumentMutation__
 *
 * To run a mutation, you first call `useCreateOneDocumentAcademicDocumentationFromRevokedDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneDocumentAcademicDocumentationFromRevokedDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneDocumentAcademicDocumentationFromRevokedDocumentMutation, { data, loading, error }] = useCreateOneDocumentAcademicDocumentationFromRevokedDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useCreateOneDocumentAcademicDocumentationFromRevokedDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneDocumentAcademicDocumentationFromRevokedDocumentMutation, CreateOneDocumentAcademicDocumentationFromRevokedDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneDocumentAcademicDocumentationFromRevokedDocumentMutation, CreateOneDocumentAcademicDocumentationFromRevokedDocumentMutationVariables>(CreateOneDocumentAcademicDocumentationFromRevokedDocumentDocument, options);
      }
export type CreateOneDocumentAcademicDocumentationFromRevokedDocumentMutationHookResult = ReturnType<typeof useCreateOneDocumentAcademicDocumentationFromRevokedDocumentMutation>;
export type CreateOneDocumentAcademicDocumentationFromRevokedDocumentMutationResult = Apollo.MutationResult<CreateOneDocumentAcademicDocumentationFromRevokedDocumentMutation>;
export type CreateOneDocumentAcademicDocumentationFromRevokedDocumentMutationOptions = Apollo.BaseMutationOptions<CreateOneDocumentAcademicDocumentationFromRevokedDocumentMutation, CreateOneDocumentAcademicDocumentationFromRevokedDocumentMutationVariables>;
export const CreateOneCertificateCourseDocument = gql`
    mutation createOneCertificateCourse($areaKnowledge: String!, $metaData: [String!]!, $name: String!, $courseLevelId: String) {
  createOneCertificateCourse(
    areaKnowledge: $areaKnowledge
    metaData: $metaData
    name: $name
    courseLevelId: $courseLevelId
  ) {
    certificateBaseId
    name
    areaKnowledge
    metaData
  }
}
    `;
export type CreateOneCertificateCourseMutationFn = Apollo.MutationFunction<CreateOneCertificateCourseMutation, CreateOneCertificateCourseMutationVariables>;

/**
 * __useCreateOneCertificateCourseMutation__
 *
 * To run a mutation, you first call `useCreateOneCertificateCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneCertificateCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneCertificateCourseMutation, { data, loading, error }] = useCreateOneCertificateCourseMutation({
 *   variables: {
 *      areaKnowledge: // value for 'areaKnowledge'
 *      metaData: // value for 'metaData'
 *      name: // value for 'name'
 *      courseLevelId: // value for 'courseLevelId'
 *   },
 * });
 */
export function useCreateOneCertificateCourseMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneCertificateCourseMutation, CreateOneCertificateCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneCertificateCourseMutation, CreateOneCertificateCourseMutationVariables>(CreateOneCertificateCourseDocument, options);
      }
export type CreateOneCertificateCourseMutationHookResult = ReturnType<typeof useCreateOneCertificateCourseMutation>;
export type CreateOneCertificateCourseMutationResult = Apollo.MutationResult<CreateOneCertificateCourseMutation>;
export type CreateOneCertificateCourseMutationOptions = Apollo.BaseMutationOptions<CreateOneCertificateCourseMutation, CreateOneCertificateCourseMutationVariables>;
export const CreateOneCertificateCourseLevelDocument = gql`
    mutation createOneCertificateCourseLevel($name: String!) {
  createOneCertificateCourseLevel(name: $name) {
    certificateBaseId
    name
  }
}
    `;
export type CreateOneCertificateCourseLevelMutationFn = Apollo.MutationFunction<CreateOneCertificateCourseLevelMutation, CreateOneCertificateCourseLevelMutationVariables>;

/**
 * __useCreateOneCertificateCourseLevelMutation__
 *
 * To run a mutation, you first call `useCreateOneCertificateCourseLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneCertificateCourseLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneCertificateCourseLevelMutation, { data, loading, error }] = useCreateOneCertificateCourseLevelMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateOneCertificateCourseLevelMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneCertificateCourseLevelMutation, CreateOneCertificateCourseLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneCertificateCourseLevelMutation, CreateOneCertificateCourseLevelMutationVariables>(CreateOneCertificateCourseLevelDocument, options);
      }
export type CreateOneCertificateCourseLevelMutationHookResult = ReturnType<typeof useCreateOneCertificateCourseLevelMutation>;
export type CreateOneCertificateCourseLevelMutationResult = Apollo.MutationResult<CreateOneCertificateCourseLevelMutation>;
export type CreateOneCertificateCourseLevelMutationOptions = Apollo.BaseMutationOptions<CreateOneCertificateCourseLevelMutation, CreateOneCertificateCourseLevelMutationVariables>;
export const CreateOneCertificateCurriculumDocument = gql`
    mutation createOneCertificateCurriculum($amountOfHours: Int, $certificateCourseId: String!, $name: String!, $selectedDisciplines: [CirriculumSelectedDiscipline!]!) {
  createOneCertificateCurriculum(
    amountOfHours: $amountOfHours
    certificateCourseId: $certificateCourseId
    name: $name
    selectedDisciplines: $selectedDisciplines
  ) {
    certificateBaseId
    name
    amountOfHours
  }
}
    `;
export type CreateOneCertificateCurriculumMutationFn = Apollo.MutationFunction<CreateOneCertificateCurriculumMutation, CreateOneCertificateCurriculumMutationVariables>;

/**
 * __useCreateOneCertificateCurriculumMutation__
 *
 * To run a mutation, you first call `useCreateOneCertificateCurriculumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneCertificateCurriculumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneCertificateCurriculumMutation, { data, loading, error }] = useCreateOneCertificateCurriculumMutation({
 *   variables: {
 *      amountOfHours: // value for 'amountOfHours'
 *      certificateCourseId: // value for 'certificateCourseId'
 *      name: // value for 'name'
 *      selectedDisciplines: // value for 'selectedDisciplines'
 *   },
 * });
 */
export function useCreateOneCertificateCurriculumMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneCertificateCurriculumMutation, CreateOneCertificateCurriculumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneCertificateCurriculumMutation, CreateOneCertificateCurriculumMutationVariables>(CreateOneCertificateCurriculumDocument, options);
      }
export type CreateOneCertificateCurriculumMutationHookResult = ReturnType<typeof useCreateOneCertificateCurriculumMutation>;
export type CreateOneCertificateCurriculumMutationResult = Apollo.MutationResult<CreateOneCertificateCurriculumMutation>;
export type CreateOneCertificateCurriculumMutationOptions = Apollo.BaseMutationOptions<CreateOneCertificateCurriculumMutation, CreateOneCertificateCurriculumMutationVariables>;
export const CreateOneCertificateDisciplineDocument = gql`
    mutation createOneCertificateDiscipline($name: String!, $viewOnDegree: Boolean!) {
  createOneCertificateDiscipline(name: $name, viewOnDegree: $viewOnDegree) {
    certificateBaseId
    name
    viewOnDegree
  }
}
    `;
export type CreateOneCertificateDisciplineMutationFn = Apollo.MutationFunction<CreateOneCertificateDisciplineMutation, CreateOneCertificateDisciplineMutationVariables>;

/**
 * __useCreateOneCertificateDisciplineMutation__
 *
 * To run a mutation, you first call `useCreateOneCertificateDisciplineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneCertificateDisciplineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneCertificateDisciplineMutation, { data, loading, error }] = useCreateOneCertificateDisciplineMutation({
 *   variables: {
 *      name: // value for 'name'
 *      viewOnDegree: // value for 'viewOnDegree'
 *   },
 * });
 */
export function useCreateOneCertificateDisciplineMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneCertificateDisciplineMutation, CreateOneCertificateDisciplineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneCertificateDisciplineMutation, CreateOneCertificateDisciplineMutationVariables>(CreateOneCertificateDisciplineDocument, options);
      }
export type CreateOneCertificateDisciplineMutationHookResult = ReturnType<typeof useCreateOneCertificateDisciplineMutation>;
export type CreateOneCertificateDisciplineMutationResult = Apollo.MutationResult<CreateOneCertificateDisciplineMutation>;
export type CreateOneCertificateDisciplineMutationOptions = Apollo.BaseMutationOptions<CreateOneCertificateDisciplineMutation, CreateOneCertificateDisciplineMutationVariables>;
export const CreateOneCertificateEventDocument = gql`
    mutation createOneCertificateEvent($name: String!) {
  createOneCertificateEvent(name: $name) {
    certificateBaseId
    name
  }
}
    `;
export type CreateOneCertificateEventMutationFn = Apollo.MutationFunction<CreateOneCertificateEventMutation, CreateOneCertificateEventMutationVariables>;

/**
 * __useCreateOneCertificateEventMutation__
 *
 * To run a mutation, you first call `useCreateOneCertificateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneCertificateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneCertificateEventMutation, { data, loading, error }] = useCreateOneCertificateEventMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateOneCertificateEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneCertificateEventMutation, CreateOneCertificateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneCertificateEventMutation, CreateOneCertificateEventMutationVariables>(CreateOneCertificateEventDocument, options);
      }
export type CreateOneCertificateEventMutationHookResult = ReturnType<typeof useCreateOneCertificateEventMutation>;
export type CreateOneCertificateEventMutationResult = Apollo.MutationResult<CreateOneCertificateEventMutation>;
export type CreateOneCertificateEventMutationOptions = Apollo.BaseMutationOptions<CreateOneCertificateEventMutation, CreateOneCertificateEventMutationVariables>;
export const CreateOneCertificateTeacherDocument = gql`
    mutation createOneCertificateTeacher($name: String!, $titration: String!) {
  createOneCertificateTeacher(name: $name, titration: $titration) {
    certificateBaseId
    name
    titration
  }
}
    `;
export type CreateOneCertificateTeacherMutationFn = Apollo.MutationFunction<CreateOneCertificateTeacherMutation, CreateOneCertificateTeacherMutationVariables>;

/**
 * __useCreateOneCertificateTeacherMutation__
 *
 * To run a mutation, you first call `useCreateOneCertificateTeacherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneCertificateTeacherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneCertificateTeacherMutation, { data, loading, error }] = useCreateOneCertificateTeacherMutation({
 *   variables: {
 *      name: // value for 'name'
 *      titration: // value for 'titration'
 *   },
 * });
 */
export function useCreateOneCertificateTeacherMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneCertificateTeacherMutation, CreateOneCertificateTeacherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneCertificateTeacherMutation, CreateOneCertificateTeacherMutationVariables>(CreateOneCertificateTeacherDocument, options);
      }
export type CreateOneCertificateTeacherMutationHookResult = ReturnType<typeof useCreateOneCertificateTeacherMutation>;
export type CreateOneCertificateTeacherMutationResult = Apollo.MutationResult<CreateOneCertificateTeacherMutation>;
export type CreateOneCertificateTeacherMutationOptions = Apollo.BaseMutationOptions<CreateOneCertificateTeacherMutation, CreateOneCertificateTeacherMutationVariables>;
export const CreateOneCertificateTemplateDocument = gql`
    mutation createOneCertificateTemplate($name: String!, $description: String, $data: Json!) {
  createOneCertificateTemplate(
    name: $name
    description: $description
    data: $data
  ) {
    id
  }
}
    `;
export type CreateOneCertificateTemplateMutationFn = Apollo.MutationFunction<CreateOneCertificateTemplateMutation, CreateOneCertificateTemplateMutationVariables>;

/**
 * __useCreateOneCertificateTemplateMutation__
 *
 * To run a mutation, you first call `useCreateOneCertificateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneCertificateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneCertificateTemplateMutation, { data, loading, error }] = useCreateOneCertificateTemplateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOneCertificateTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneCertificateTemplateMutation, CreateOneCertificateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneCertificateTemplateMutation, CreateOneCertificateTemplateMutationVariables>(CreateOneCertificateTemplateDocument, options);
      }
export type CreateOneCertificateTemplateMutationHookResult = ReturnType<typeof useCreateOneCertificateTemplateMutation>;
export type CreateOneCertificateTemplateMutationResult = Apollo.MutationResult<CreateOneCertificateTemplateMutation>;
export type CreateOneCertificateTemplateMutationOptions = Apollo.BaseMutationOptions<CreateOneCertificateTemplateMutation, CreateOneCertificateTemplateMutationVariables>;
export const CreateOneDegreeDocument = gql`
    mutation createOneDegree($degreeDocumentAcademicDocumentationId: String, $visualRepresentation: Upload, $xml: Upload!) {
  createOneDegree(
    degreeAcademicDocumentationId: $degreeDocumentAcademicDocumentationId
    visualRepresentation: $visualRepresentation
    xml: $xml
  ) {
    documentBaseId
    DocumentBase {
      filePath
    }
    searchCPF
    searchCourse
  }
}
    `;
export type CreateOneDegreeMutationFn = Apollo.MutationFunction<CreateOneDegreeMutation, CreateOneDegreeMutationVariables>;

/**
 * __useCreateOneDegreeMutation__
 *
 * To run a mutation, you first call `useCreateOneDegreeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneDegreeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneDegreeMutation, { data, loading, error }] = useCreateOneDegreeMutation({
 *   variables: {
 *      degreeDocumentAcademicDocumentationId: // value for 'degreeDocumentAcademicDocumentationId'
 *      visualRepresentation: // value for 'visualRepresentation'
 *      xml: // value for 'xml'
 *   },
 * });
 */
export function useCreateOneDegreeMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneDegreeMutation, CreateOneDegreeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneDegreeMutation, CreateOneDegreeMutationVariables>(CreateOneDegreeDocument, options);
      }
export type CreateOneDegreeMutationHookResult = ReturnType<typeof useCreateOneDegreeMutation>;
export type CreateOneDegreeMutationResult = Apollo.MutationResult<CreateOneDegreeMutation>;
export type CreateOneDegreeMutationOptions = Apollo.BaseMutationOptions<CreateOneDegreeMutation, CreateOneDegreeMutationVariables>;
export const CreateOneDocumentAuditFileIssuerDocument = gql`
    mutation createOneDocumentAuditFileIssuer($degreeCount: Int!, $endDate: Date!, $startDate: Date!, $version: String!, $excludeRevoked: Boolean!) {
  createOneDocumentAuditFileIssuer(
    degreeCount: $degreeCount
    endDate: $endDate
    startDate: $startDate
    version: $version
    excludeRevoked: $excludeRevoked
  ) {
    documentBaseId
  }
}
    `;
export type CreateOneDocumentAuditFileIssuerMutationFn = Apollo.MutationFunction<CreateOneDocumentAuditFileIssuerMutation, CreateOneDocumentAuditFileIssuerMutationVariables>;

/**
 * __useCreateOneDocumentAuditFileIssuerMutation__
 *
 * To run a mutation, you first call `useCreateOneDocumentAuditFileIssuerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneDocumentAuditFileIssuerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneDocumentAuditFileIssuerMutation, { data, loading, error }] = useCreateOneDocumentAuditFileIssuerMutation({
 *   variables: {
 *      degreeCount: // value for 'degreeCount'
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      version: // value for 'version'
 *      excludeRevoked: // value for 'excludeRevoked'
 *   },
 * });
 */
export function useCreateOneDocumentAuditFileIssuerMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneDocumentAuditFileIssuerMutation, CreateOneDocumentAuditFileIssuerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneDocumentAuditFileIssuerMutation, CreateOneDocumentAuditFileIssuerMutationVariables>(CreateOneDocumentAuditFileIssuerDocument, options);
      }
export type CreateOneDocumentAuditFileIssuerMutationHookResult = ReturnType<typeof useCreateOneDocumentAuditFileIssuerMutation>;
export type CreateOneDocumentAuditFileIssuerMutationResult = Apollo.MutationResult<CreateOneDocumentAuditFileIssuerMutation>;
export type CreateOneDocumentAuditFileIssuerMutationOptions = Apollo.BaseMutationOptions<CreateOneDocumentAuditFileIssuerMutation, CreateOneDocumentAuditFileIssuerMutationVariables>;
export const CreateOneDocumentCertificateDocument = gql`
    mutation createOneDocumentCertificate($curriculumId: String, $studentCpf: String!, $studentName: String!, $studentEmail: String!, $templateId: String!, $variables: Json!, $curriculumDisciplinesVariables: [CurriculumDisciplineVariable!]!, $eventId: String, $ignoreUsingExpensiveCreditsError: Boolean, $personId: String) {
  createOneDocumentCertificate(
    curriculumId: $curriculumId
    studentCPF: $studentCpf
    studentName: $studentName
    studentEmail: $studentEmail
    templateId: $templateId
    variables: $variables
    curriculumDisciplinesVariables: $curriculumDisciplinesVariables
    eventId: $eventId
    ignoreUsingExpensiveCreditsError: $ignoreUsingExpensiveCreditsError
    personId: $personId
  ) {
    documentBaseId
    DocumentCertificateSignatureItems {
      id
      PossibleSigners {
        id
        TeamMember {
          commonUserId
        }
      }
      type
    }
  }
}
    `;
export type CreateOneDocumentCertificateMutationFn = Apollo.MutationFunction<CreateOneDocumentCertificateMutation, CreateOneDocumentCertificateMutationVariables>;

/**
 * __useCreateOneDocumentCertificateMutation__
 *
 * To run a mutation, you first call `useCreateOneDocumentCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneDocumentCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneDocumentCertificateMutation, { data, loading, error }] = useCreateOneDocumentCertificateMutation({
 *   variables: {
 *      curriculumId: // value for 'curriculumId'
 *      studentCpf: // value for 'studentCpf'
 *      studentName: // value for 'studentName'
 *      studentEmail: // value for 'studentEmail'
 *      templateId: // value for 'templateId'
 *      variables: // value for 'variables'
 *      curriculumDisciplinesVariables: // value for 'curriculumDisciplinesVariables'
 *      eventId: // value for 'eventId'
 *      ignoreUsingExpensiveCreditsError: // value for 'ignoreUsingExpensiveCreditsError'
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useCreateOneDocumentCertificateMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneDocumentCertificateMutation, CreateOneDocumentCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneDocumentCertificateMutation, CreateOneDocumentCertificateMutationVariables>(CreateOneDocumentCertificateDocument, options);
      }
export type CreateOneDocumentCertificateMutationHookResult = ReturnType<typeof useCreateOneDocumentCertificateMutation>;
export type CreateOneDocumentCertificateMutationResult = Apollo.MutationResult<CreateOneDocumentCertificateMutation>;
export type CreateOneDocumentCertificateMutationOptions = Apollo.BaseMutationOptions<CreateOneDocumentCertificateMutation, CreateOneDocumentCertificateMutationVariables>;
export const CreateOneDocumentCertificatePreviewDocument = gql`
    mutation createOneDocumentCertificatePreview($curriculumId: String, $studentCpf: String!, $studentName: String!, $studentEmail: String!, $templateId: String!, $variables: Json!, $curriculumDisciplinesVariables: [CurriculumDisciplineVariable!]!, $eventId: String, $degreeId: String) {
  createOneDocumentCertificatePreview(
    curriculumId: $curriculumId
    studentCPF: $studentCpf
    studentName: $studentName
    studentEmail: $studentEmail
    templateId: $templateId
    variables: $variables
    curriculumDisciplinesVariables: $curriculumDisciplinesVariables
    eventId: $eventId
    degreeId: $degreeId
  )
}
    `;
export type CreateOneDocumentCertificatePreviewMutationFn = Apollo.MutationFunction<CreateOneDocumentCertificatePreviewMutation, CreateOneDocumentCertificatePreviewMutationVariables>;

/**
 * __useCreateOneDocumentCertificatePreviewMutation__
 *
 * To run a mutation, you first call `useCreateOneDocumentCertificatePreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneDocumentCertificatePreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneDocumentCertificatePreviewMutation, { data, loading, error }] = useCreateOneDocumentCertificatePreviewMutation({
 *   variables: {
 *      curriculumId: // value for 'curriculumId'
 *      studentCpf: // value for 'studentCpf'
 *      studentName: // value for 'studentName'
 *      studentEmail: // value for 'studentEmail'
 *      templateId: // value for 'templateId'
 *      variables: // value for 'variables'
 *      curriculumDisciplinesVariables: // value for 'curriculumDisciplinesVariables'
 *      eventId: // value for 'eventId'
 *      degreeId: // value for 'degreeId'
 *   },
 * });
 */
export function useCreateOneDocumentCertificatePreviewMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneDocumentCertificatePreviewMutation, CreateOneDocumentCertificatePreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneDocumentCertificatePreviewMutation, CreateOneDocumentCertificatePreviewMutationVariables>(CreateOneDocumentCertificatePreviewDocument, options);
      }
export type CreateOneDocumentCertificatePreviewMutationHookResult = ReturnType<typeof useCreateOneDocumentCertificatePreviewMutation>;
export type CreateOneDocumentCertificatePreviewMutationResult = Apollo.MutationResult<CreateOneDocumentCertificatePreviewMutation>;
export type CreateOneDocumentCertificatePreviewMutationOptions = Apollo.BaseMutationOptions<CreateOneDocumentCertificatePreviewMutation, CreateOneDocumentCertificatePreviewMutationVariables>;
export const CreateOneDocumentSchoolCurriculumDocument = gql`
    mutation CreateOneDocumentSchoolCurriculum($createOneDocumentSchoolCurriculumId: String!) {
  createOneDocumentSchoolCurriculum(id: $createOneDocumentSchoolCurriculumId) {
    ...DocumentSchoolCurriculumFields
  }
}
    ${DocumentSchoolCurriculumFieldsFragmentDoc}`;
export type CreateOneDocumentSchoolCurriculumMutationFn = Apollo.MutationFunction<CreateOneDocumentSchoolCurriculumMutation, CreateOneDocumentSchoolCurriculumMutationVariables>;

/**
 * __useCreateOneDocumentSchoolCurriculumMutation__
 *
 * To run a mutation, you first call `useCreateOneDocumentSchoolCurriculumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneDocumentSchoolCurriculumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneDocumentSchoolCurriculumMutation, { data, loading, error }] = useCreateOneDocumentSchoolCurriculumMutation({
 *   variables: {
 *      createOneDocumentSchoolCurriculumId: // value for 'createOneDocumentSchoolCurriculumId'
 *   },
 * });
 */
export function useCreateOneDocumentSchoolCurriculumMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneDocumentSchoolCurriculumMutation, CreateOneDocumentSchoolCurriculumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneDocumentSchoolCurriculumMutation, CreateOneDocumentSchoolCurriculumMutationVariables>(CreateOneDocumentSchoolCurriculumDocument, options);
      }
export type CreateOneDocumentSchoolCurriculumMutationHookResult = ReturnType<typeof useCreateOneDocumentSchoolCurriculumMutation>;
export type CreateOneDocumentSchoolCurriculumMutationResult = Apollo.MutationResult<CreateOneDocumentSchoolCurriculumMutation>;
export type CreateOneDocumentSchoolCurriculumMutationOptions = Apollo.BaseMutationOptions<CreateOneDocumentSchoolCurriculumMutation, CreateOneDocumentSchoolCurriculumMutationVariables>;
export const CreateOneEnabledInstitutionDocument = gql`
    mutation createOneEnabledInstitution($data: CreateOneEnabledInstitutionInput!) {
  createOneEnabledInstitution(data: $data) {
    email
    cnpj
    educationLevelType
    isMaintainer
  }
}
    `;
export type CreateOneEnabledInstitutionMutationFn = Apollo.MutationFunction<CreateOneEnabledInstitutionMutation, CreateOneEnabledInstitutionMutationVariables>;

/**
 * __useCreateOneEnabledInstitutionMutation__
 *
 * To run a mutation, you first call `useCreateOneEnabledInstitutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneEnabledInstitutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneEnabledInstitutionMutation, { data, loading, error }] = useCreateOneEnabledInstitutionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOneEnabledInstitutionMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneEnabledInstitutionMutation, CreateOneEnabledInstitutionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneEnabledInstitutionMutation, CreateOneEnabledInstitutionMutationVariables>(CreateOneEnabledInstitutionDocument, options);
      }
export type CreateOneEnabledInstitutionMutationHookResult = ReturnType<typeof useCreateOneEnabledInstitutionMutation>;
export type CreateOneEnabledInstitutionMutationResult = Apollo.MutationResult<CreateOneEnabledInstitutionMutation>;
export type CreateOneEnabledInstitutionMutationOptions = Apollo.BaseMutationOptions<CreateOneEnabledInstitutionMutation, CreateOneEnabledInstitutionMutationVariables>;
export const CreateOneDocumentFinalAcademicTranscriptDocument = gql`
    mutation createOneDocumentFinalAcademicTranscript($baseAcademicId: String!) {
  createOneDocumentFinalAcademicTranscript(baseAcademicId: $baseAcademicId) {
    DocumentBase {
      internalSeqId
      version
    }
  }
}
    `;
export type CreateOneDocumentFinalAcademicTranscriptMutationFn = Apollo.MutationFunction<CreateOneDocumentFinalAcademicTranscriptMutation, CreateOneDocumentFinalAcademicTranscriptMutationVariables>;

/**
 * __useCreateOneDocumentFinalAcademicTranscriptMutation__
 *
 * To run a mutation, you first call `useCreateOneDocumentFinalAcademicTranscriptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneDocumentFinalAcademicTranscriptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneDocumentFinalAcademicTranscriptMutation, { data, loading, error }] = useCreateOneDocumentFinalAcademicTranscriptMutation({
 *   variables: {
 *      baseAcademicId: // value for 'baseAcademicId'
 *   },
 * });
 */
export function useCreateOneDocumentFinalAcademicTranscriptMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneDocumentFinalAcademicTranscriptMutation, CreateOneDocumentFinalAcademicTranscriptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneDocumentFinalAcademicTranscriptMutation, CreateOneDocumentFinalAcademicTranscriptMutationVariables>(CreateOneDocumentFinalAcademicTranscriptDocument, options);
      }
export type CreateOneDocumentFinalAcademicTranscriptMutationHookResult = ReturnType<typeof useCreateOneDocumentFinalAcademicTranscriptMutation>;
export type CreateOneDocumentFinalAcademicTranscriptMutationResult = Apollo.MutationResult<CreateOneDocumentFinalAcademicTranscriptMutation>;
export type CreateOneDocumentFinalAcademicTranscriptMutationOptions = Apollo.BaseMutationOptions<CreateOneDocumentFinalAcademicTranscriptMutation, CreateOneDocumentFinalAcademicTranscriptMutationVariables>;
export const CreateOneFinancialRechargeDocument = gql`
    mutation createOneFinancialRecharge($data: CreateOneFinancialRechargeInput!) {
  createOneFinancialRecharge(data: $data) {
    id
  }
}
    `;
export type CreateOneFinancialRechargeMutationFn = Apollo.MutationFunction<CreateOneFinancialRechargeMutation, CreateOneFinancialRechargeMutationVariables>;

/**
 * __useCreateOneFinancialRechargeMutation__
 *
 * To run a mutation, you first call `useCreateOneFinancialRechargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneFinancialRechargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneFinancialRechargeMutation, { data, loading, error }] = useCreateOneFinancialRechargeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOneFinancialRechargeMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneFinancialRechargeMutation, CreateOneFinancialRechargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneFinancialRechargeMutation, CreateOneFinancialRechargeMutationVariables>(CreateOneFinancialRechargeDocument, options);
      }
export type CreateOneFinancialRechargeMutationHookResult = ReturnType<typeof useCreateOneFinancialRechargeMutation>;
export type CreateOneFinancialRechargeMutationResult = Apollo.MutationResult<CreateOneFinancialRechargeMutation>;
export type CreateOneFinancialRechargeMutationOptions = Apollo.BaseMutationOptions<CreateOneFinancialRechargeMutation, CreateOneFinancialRechargeMutationVariables>;
export const CreateOneMaintainerAdminDocument = gql`
    mutation createOneMaintainerAdmin($email: String!) {
  createOneMaintainerAdmin(email: $email) {
    maintainerId
  }
}
    `;
export type CreateOneMaintainerAdminMutationFn = Apollo.MutationFunction<CreateOneMaintainerAdminMutation, CreateOneMaintainerAdminMutationVariables>;

/**
 * __useCreateOneMaintainerAdminMutation__
 *
 * To run a mutation, you first call `useCreateOneMaintainerAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneMaintainerAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneMaintainerAdminMutation, { data, loading, error }] = useCreateOneMaintainerAdminMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCreateOneMaintainerAdminMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneMaintainerAdminMutation, CreateOneMaintainerAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneMaintainerAdminMutation, CreateOneMaintainerAdminMutationVariables>(CreateOneMaintainerAdminDocument, options);
      }
export type CreateOneMaintainerAdminMutationHookResult = ReturnType<typeof useCreateOneMaintainerAdminMutation>;
export type CreateOneMaintainerAdminMutationResult = Apollo.MutationResult<CreateOneMaintainerAdminMutation>;
export type CreateOneMaintainerAdminMutationOptions = Apollo.BaseMutationOptions<CreateOneMaintainerAdminMutation, CreateOneMaintainerAdminMutationVariables>;
export const CreateOnePersonDocument = gql`
    mutation CreateOnePerson($isForeign: Boolean!, $name: String!, $receivesCertificateEmail: Boolean!, $receivesCertificateWhatsapp: Boolean!, $phones: [String!]!, $cpf: String, $passport: String, $email: String, $identityDocument: String, $birthDate: String, $address: AddressInput) {
  createOnePerson(
    isForeign: $isForeign
    name: $name
    receivesCertificateEmail: $receivesCertificateEmail
    receivesCertificateWhatsapp: $receivesCertificateWhatsapp
    phones: $phones
    cpf: $cpf
    passport: $passport
    email: $email
    identityDocument: $identityDocument
    birthDate: $birthDate
    address: $address
  ) {
    id
    name
    createdAt
  }
}
    `;
export type CreateOnePersonMutationFn = Apollo.MutationFunction<CreateOnePersonMutation, CreateOnePersonMutationVariables>;

/**
 * __useCreateOnePersonMutation__
 *
 * To run a mutation, you first call `useCreateOnePersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOnePersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOnePersonMutation, { data, loading, error }] = useCreateOnePersonMutation({
 *   variables: {
 *      isForeign: // value for 'isForeign'
 *      name: // value for 'name'
 *      receivesCertificateEmail: // value for 'receivesCertificateEmail'
 *      receivesCertificateWhatsapp: // value for 'receivesCertificateWhatsapp'
 *      phones: // value for 'phones'
 *      cpf: // value for 'cpf'
 *      passport: // value for 'passport'
 *      email: // value for 'email'
 *      identityDocument: // value for 'identityDocument'
 *      birthDate: // value for 'birthDate'
 *      address: // value for 'address'
 *   },
 * });
 */
export function useCreateOnePersonMutation(baseOptions?: Apollo.MutationHookOptions<CreateOnePersonMutation, CreateOnePersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOnePersonMutation, CreateOnePersonMutationVariables>(CreateOnePersonDocument, options);
      }
export type CreateOnePersonMutationHookResult = ReturnType<typeof useCreateOnePersonMutation>;
export type CreateOnePersonMutationResult = Apollo.MutationResult<CreateOnePersonMutation>;
export type CreateOnePersonMutationOptions = Apollo.BaseMutationOptions<CreateOnePersonMutation, CreateOnePersonMutationVariables>;
export const CreateOneReusableFormDataCurriculumDocument = gql`
    mutation createOneReusableFormDataCurriculum($data: ReusableFormDataCurriculumCreateInputCustom!) {
  createOneReusableFormDataCurriculum(data: $data) {
    id
  }
}
    `;
export type CreateOneReusableFormDataCurriculumMutationFn = Apollo.MutationFunction<CreateOneReusableFormDataCurriculumMutation, CreateOneReusableFormDataCurriculumMutationVariables>;

/**
 * __useCreateOneReusableFormDataCurriculumMutation__
 *
 * To run a mutation, you first call `useCreateOneReusableFormDataCurriculumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneReusableFormDataCurriculumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneReusableFormDataCurriculumMutation, { data, loading, error }] = useCreateOneReusableFormDataCurriculumMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOneReusableFormDataCurriculumMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneReusableFormDataCurriculumMutation, CreateOneReusableFormDataCurriculumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneReusableFormDataCurriculumMutation, CreateOneReusableFormDataCurriculumMutationVariables>(CreateOneReusableFormDataCurriculumDocument, options);
      }
export type CreateOneReusableFormDataCurriculumMutationHookResult = ReturnType<typeof useCreateOneReusableFormDataCurriculumMutation>;
export type CreateOneReusableFormDataCurriculumMutationResult = Apollo.MutationResult<CreateOneReusableFormDataCurriculumMutation>;
export type CreateOneReusableFormDataCurriculumMutationOptions = Apollo.BaseMutationOptions<CreateOneReusableFormDataCurriculumMutation, CreateOneReusableFormDataCurriculumMutationVariables>;
export const CreateOneSignSignatureImageDocument = gql`
    mutation createOneSignSignatureImage($data: CreateOneSignSignatureImageData!) {
  createOneSignSignatureImage(data: $data) {
    id
  }
}
    `;
export type CreateOneSignSignatureImageMutationFn = Apollo.MutationFunction<CreateOneSignSignatureImageMutation, CreateOneSignSignatureImageMutationVariables>;

/**
 * __useCreateOneSignSignatureImageMutation__
 *
 * To run a mutation, you first call `useCreateOneSignSignatureImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneSignSignatureImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneSignSignatureImageMutation, { data, loading, error }] = useCreateOneSignSignatureImageMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOneSignSignatureImageMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneSignSignatureImageMutation, CreateOneSignSignatureImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneSignSignatureImageMutation, CreateOneSignSignatureImageMutationVariables>(CreateOneSignSignatureImageDocument, options);
      }
export type CreateOneSignSignatureImageMutationHookResult = ReturnType<typeof useCreateOneSignSignatureImageMutation>;
export type CreateOneSignSignatureImageMutationResult = Apollo.MutationResult<CreateOneSignSignatureImageMutation>;
export type CreateOneSignSignatureImageMutationOptions = Apollo.BaseMutationOptions<CreateOneSignSignatureImageMutation, CreateOneSignSignatureImageMutationVariables>;
export const CreateOneSystemGlobalAlertDocument = gql`
    mutation createOneSystemGlobalAlert($data: SystemGlobalAlertCreateInput!) {
  createOneSystemGlobalAlert(data: $data) {
    id
  }
}
    `;
export type CreateOneSystemGlobalAlertMutationFn = Apollo.MutationFunction<CreateOneSystemGlobalAlertMutation, CreateOneSystemGlobalAlertMutationVariables>;

/**
 * __useCreateOneSystemGlobalAlertMutation__
 *
 * To run a mutation, you first call `useCreateOneSystemGlobalAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneSystemGlobalAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneSystemGlobalAlertMutation, { data, loading, error }] = useCreateOneSystemGlobalAlertMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOneSystemGlobalAlertMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneSystemGlobalAlertMutation, CreateOneSystemGlobalAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneSystemGlobalAlertMutation, CreateOneSystemGlobalAlertMutationVariables>(CreateOneSystemGlobalAlertDocument, options);
      }
export type CreateOneSystemGlobalAlertMutationHookResult = ReturnType<typeof useCreateOneSystemGlobalAlertMutation>;
export type CreateOneSystemGlobalAlertMutationResult = Apollo.MutationResult<CreateOneSystemGlobalAlertMutation>;
export type CreateOneSystemGlobalAlertMutationOptions = Apollo.BaseMutationOptions<CreateOneSystemGlobalAlertMutation, CreateOneSystemGlobalAlertMutationVariables>;
export const CreateOneTeamEducationLevelDocument = gql`
    mutation createOneTeamEducationLevel($data: TeamEducationLevelCreateInput!) {
  createOneTeamEducationLevel(data: $data) {
    id
    teamId
    educationLevelType
  }
}
    `;
export type CreateOneTeamEducationLevelMutationFn = Apollo.MutationFunction<CreateOneTeamEducationLevelMutation, CreateOneTeamEducationLevelMutationVariables>;

/**
 * __useCreateOneTeamEducationLevelMutation__
 *
 * To run a mutation, you first call `useCreateOneTeamEducationLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneTeamEducationLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneTeamEducationLevelMutation, { data, loading, error }] = useCreateOneTeamEducationLevelMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOneTeamEducationLevelMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneTeamEducationLevelMutation, CreateOneTeamEducationLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneTeamEducationLevelMutation, CreateOneTeamEducationLevelMutationVariables>(CreateOneTeamEducationLevelDocument, options);
      }
export type CreateOneTeamEducationLevelMutationHookResult = ReturnType<typeof useCreateOneTeamEducationLevelMutation>;
export type CreateOneTeamEducationLevelMutationResult = Apollo.MutationResult<CreateOneTeamEducationLevelMutation>;
export type CreateOneTeamEducationLevelMutationOptions = Apollo.BaseMutationOptions<CreateOneTeamEducationLevelMutation, CreateOneTeamEducationLevelMutationVariables>;
export const DefineOneSignSignatureImageAsPrimaryDocument = gql`
    mutation defineOneSignSignatureImageAsPrimary($where: SignSignatureImageWhereUniqueInput!) {
  defineOneSignSignatureImageAsPrimary(where: $where) {
    id
  }
}
    `;
export type DefineOneSignSignatureImageAsPrimaryMutationFn = Apollo.MutationFunction<DefineOneSignSignatureImageAsPrimaryMutation, DefineOneSignSignatureImageAsPrimaryMutationVariables>;

/**
 * __useDefineOneSignSignatureImageAsPrimaryMutation__
 *
 * To run a mutation, you first call `useDefineOneSignSignatureImageAsPrimaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDefineOneSignSignatureImageAsPrimaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [defineOneSignSignatureImageAsPrimaryMutation, { data, loading, error }] = useDefineOneSignSignatureImageAsPrimaryMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDefineOneSignSignatureImageAsPrimaryMutation(baseOptions?: Apollo.MutationHookOptions<DefineOneSignSignatureImageAsPrimaryMutation, DefineOneSignSignatureImageAsPrimaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DefineOneSignSignatureImageAsPrimaryMutation, DefineOneSignSignatureImageAsPrimaryMutationVariables>(DefineOneSignSignatureImageAsPrimaryDocument, options);
      }
export type DefineOneSignSignatureImageAsPrimaryMutationHookResult = ReturnType<typeof useDefineOneSignSignatureImageAsPrimaryMutation>;
export type DefineOneSignSignatureImageAsPrimaryMutationResult = Apollo.MutationResult<DefineOneSignSignatureImageAsPrimaryMutation>;
export type DefineOneSignSignatureImageAsPrimaryMutationOptions = Apollo.BaseMutationOptions<DefineOneSignSignatureImageAsPrimaryMutation, DefineOneSignSignatureImageAsPrimaryMutationVariables>;
export const DefineSignersDocument = gql`
    mutation defineSigners($data: InviteGroups!, $addSignersNode: Boolean, $saveDefault: Boolean) {
  defineSigners(
    data: $data
    addSignersNode: $addSignersNode
    saveDefault: $saveDefault
  ) {
    id
  }
}
    `;
export type DefineSignersMutationFn = Apollo.MutationFunction<DefineSignersMutation, DefineSignersMutationVariables>;

/**
 * __useDefineSignersMutation__
 *
 * To run a mutation, you first call `useDefineSignersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDefineSignersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [defineSignersMutation, { data, loading, error }] = useDefineSignersMutation({
 *   variables: {
 *      data: // value for 'data'
 *      addSignersNode: // value for 'addSignersNode'
 *      saveDefault: // value for 'saveDefault'
 *   },
 * });
 */
export function useDefineSignersMutation(baseOptions?: Apollo.MutationHookOptions<DefineSignersMutation, DefineSignersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DefineSignersMutation, DefineSignersMutationVariables>(DefineSignersDocument, options);
      }
export type DefineSignersMutationHookResult = ReturnType<typeof useDefineSignersMutation>;
export type DefineSignersMutationResult = Apollo.MutationResult<DefineSignersMutation>;
export type DefineSignersMutationOptions = Apollo.BaseMutationOptions<DefineSignersMutation, DefineSignersMutationVariables>;
export const DeleteOneApiKeyDocument = gql`
    mutation deleteOneApiKey($apiKeyId: Int!) {
  deleteOneApiKey(apiKeyId: $apiKeyId) {
    id
  }
}
    `;
export type DeleteOneApiKeyMutationFn = Apollo.MutationFunction<DeleteOneApiKeyMutation, DeleteOneApiKeyMutationVariables>;

/**
 * __useDeleteOneApiKeyMutation__
 *
 * To run a mutation, you first call `useDeleteOneApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneApiKeyMutation, { data, loading, error }] = useDeleteOneApiKeyMutation({
 *   variables: {
 *      apiKeyId: // value for 'apiKeyId'
 *   },
 * });
 */
export function useDeleteOneApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOneApiKeyMutation, DeleteOneApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOneApiKeyMutation, DeleteOneApiKeyMutationVariables>(DeleteOneApiKeyDocument, options);
      }
export type DeleteOneApiKeyMutationHookResult = ReturnType<typeof useDeleteOneApiKeyMutation>;
export type DeleteOneApiKeyMutationResult = Apollo.MutationResult<DeleteOneApiKeyMutation>;
export type DeleteOneApiKeyMutationOptions = Apollo.BaseMutationOptions<DeleteOneApiKeyMutation, DeleteOneApiKeyMutationVariables>;
export const DeleteOneCertificateBaseDocument = gql`
    mutation deleteOneCertificateBase($certificateId: String!) {
  deleteOneCertificateBase(certificateId: $certificateId) {
    id
  }
}
    `;
export type DeleteOneCertificateBaseMutationFn = Apollo.MutationFunction<DeleteOneCertificateBaseMutation, DeleteOneCertificateBaseMutationVariables>;

/**
 * __useDeleteOneCertificateBaseMutation__
 *
 * To run a mutation, you first call `useDeleteOneCertificateBaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneCertificateBaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneCertificateBaseMutation, { data, loading, error }] = useDeleteOneCertificateBaseMutation({
 *   variables: {
 *      certificateId: // value for 'certificateId'
 *   },
 * });
 */
export function useDeleteOneCertificateBaseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOneCertificateBaseMutation, DeleteOneCertificateBaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOneCertificateBaseMutation, DeleteOneCertificateBaseMutationVariables>(DeleteOneCertificateBaseDocument, options);
      }
export type DeleteOneCertificateBaseMutationHookResult = ReturnType<typeof useDeleteOneCertificateBaseMutation>;
export type DeleteOneCertificateBaseMutationResult = Apollo.MutationResult<DeleteOneCertificateBaseMutation>;
export type DeleteOneCertificateBaseMutationOptions = Apollo.BaseMutationOptions<DeleteOneCertificateBaseMutation, DeleteOneCertificateBaseMutationVariables>;
export const DeleteOneCertificateTemplateDocument = gql`
    mutation deleteOneCertificateTemplate($where: CertificateTemplateWhereUniqueInput!) {
  deleteOneCertificateTemplate(where: $where) {
    id
  }
}
    `;
export type DeleteOneCertificateTemplateMutationFn = Apollo.MutationFunction<DeleteOneCertificateTemplateMutation, DeleteOneCertificateTemplateMutationVariables>;

/**
 * __useDeleteOneCertificateTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteOneCertificateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneCertificateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneCertificateTemplateMutation, { data, loading, error }] = useDeleteOneCertificateTemplateMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteOneCertificateTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOneCertificateTemplateMutation, DeleteOneCertificateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOneCertificateTemplateMutation, DeleteOneCertificateTemplateMutationVariables>(DeleteOneCertificateTemplateDocument, options);
      }
export type DeleteOneCertificateTemplateMutationHookResult = ReturnType<typeof useDeleteOneCertificateTemplateMutation>;
export type DeleteOneCertificateTemplateMutationResult = Apollo.MutationResult<DeleteOneCertificateTemplateMutation>;
export type DeleteOneCertificateTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteOneCertificateTemplateMutation, DeleteOneCertificateTemplateMutationVariables>;
export const DeleteOneDegreeVisualRepresentationDocument = gql`
    mutation deleteOneDegreeVisualRepresentation($degreeId: String!) {
  deleteOneDegreeVisualRepresentation(degreeId: $degreeId) {
    documentBaseId
    visualRepresentationPath
  }
}
    `;
export type DeleteOneDegreeVisualRepresentationMutationFn = Apollo.MutationFunction<DeleteOneDegreeVisualRepresentationMutation, DeleteOneDegreeVisualRepresentationMutationVariables>;

/**
 * __useDeleteOneDegreeVisualRepresentationMutation__
 *
 * To run a mutation, you first call `useDeleteOneDegreeVisualRepresentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneDegreeVisualRepresentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneDegreeVisualRepresentationMutation, { data, loading, error }] = useDeleteOneDegreeVisualRepresentationMutation({
 *   variables: {
 *      degreeId: // value for 'degreeId'
 *   },
 * });
 */
export function useDeleteOneDegreeVisualRepresentationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOneDegreeVisualRepresentationMutation, DeleteOneDegreeVisualRepresentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOneDegreeVisualRepresentationMutation, DeleteOneDegreeVisualRepresentationMutationVariables>(DeleteOneDegreeVisualRepresentationDocument, options);
      }
export type DeleteOneDegreeVisualRepresentationMutationHookResult = ReturnType<typeof useDeleteOneDegreeVisualRepresentationMutation>;
export type DeleteOneDegreeVisualRepresentationMutationResult = Apollo.MutationResult<DeleteOneDegreeVisualRepresentationMutation>;
export type DeleteOneDegreeVisualRepresentationMutationOptions = Apollo.BaseMutationOptions<DeleteOneDegreeVisualRepresentationMutation, DeleteOneDegreeVisualRepresentationMutationVariables>;
export const DeleteOneDocumentBaseDocument = gql`
    mutation deleteOneDocumentBase($deleteOneDocumentBaseId: String!) {
  deleteOneDocumentBase(id: $deleteOneDocumentBaseId) {
    internalSeqId
    type
  }
}
    `;
export type DeleteOneDocumentBaseMutationFn = Apollo.MutationFunction<DeleteOneDocumentBaseMutation, DeleteOneDocumentBaseMutationVariables>;

/**
 * __useDeleteOneDocumentBaseMutation__
 *
 * To run a mutation, you first call `useDeleteOneDocumentBaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneDocumentBaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneDocumentBaseMutation, { data, loading, error }] = useDeleteOneDocumentBaseMutation({
 *   variables: {
 *      deleteOneDocumentBaseId: // value for 'deleteOneDocumentBaseId'
 *   },
 * });
 */
export function useDeleteOneDocumentBaseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOneDocumentBaseMutation, DeleteOneDocumentBaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOneDocumentBaseMutation, DeleteOneDocumentBaseMutationVariables>(DeleteOneDocumentBaseDocument, options);
      }
export type DeleteOneDocumentBaseMutationHookResult = ReturnType<typeof useDeleteOneDocumentBaseMutation>;
export type DeleteOneDocumentBaseMutationResult = Apollo.MutationResult<DeleteOneDocumentBaseMutation>;
export type DeleteOneDocumentBaseMutationOptions = Apollo.BaseMutationOptions<DeleteOneDocumentBaseMutation, DeleteOneDocumentBaseMutationVariables>;
export const DeleteOneDocumentBaseDefaultSignatureInviteConfigurationDocument = gql`
    mutation deleteOneDocumentBaseDefaultSignatureInviteConfiguration($id: Int!) {
  deleteOneDocumentBaseDefaultSignatureInviteConfiguration(id: $id) {
    id
  }
}
    `;
export type DeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutationFn = Apollo.MutationFunction<DeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutation, DeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutationVariables>;

/**
 * __useDeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutation__
 *
 * To run a mutation, you first call `useDeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneDocumentBaseDefaultSignatureInviteConfigurationMutation, { data, loading, error }] = useDeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutation, DeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutation, DeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutationVariables>(DeleteOneDocumentBaseDefaultSignatureInviteConfigurationDocument, options);
      }
export type DeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutationHookResult = ReturnType<typeof useDeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutation>;
export type DeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutationResult = Apollo.MutationResult<DeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutation>;
export type DeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutationOptions = Apollo.BaseMutationOptions<DeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutation, DeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutationVariables>;
export const DeleteOneTeamEducationLevelDocument = gql`
    mutation deleteOneTeamEducationLevel($where: TeamEducationLevelWhereUniqueInput!) {
  deleteOneTeamEducationLevel(where: $where) {
    id
    educationLevelType
  }
}
    `;
export type DeleteOneTeamEducationLevelMutationFn = Apollo.MutationFunction<DeleteOneTeamEducationLevelMutation, DeleteOneTeamEducationLevelMutationVariables>;

/**
 * __useDeleteOneTeamEducationLevelMutation__
 *
 * To run a mutation, you first call `useDeleteOneTeamEducationLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneTeamEducationLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneTeamEducationLevelMutation, { data, loading, error }] = useDeleteOneTeamEducationLevelMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteOneTeamEducationLevelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOneTeamEducationLevelMutation, DeleteOneTeamEducationLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOneTeamEducationLevelMutation, DeleteOneTeamEducationLevelMutationVariables>(DeleteOneTeamEducationLevelDocument, options);
      }
export type DeleteOneTeamEducationLevelMutationHookResult = ReturnType<typeof useDeleteOneTeamEducationLevelMutation>;
export type DeleteOneTeamEducationLevelMutationResult = Apollo.MutationResult<DeleteOneTeamEducationLevelMutation>;
export type DeleteOneTeamEducationLevelMutationOptions = Apollo.BaseMutationOptions<DeleteOneTeamEducationLevelMutation, DeleteOneTeamEducationLevelMutationVariables>;
export const DeleteOneFinancialCreditCardSavedDocument = gql`
    mutation deleteOneFinancialCreditCardSaved($where: FinancialCreditCardSavedWhereUniqueInput!) {
  deleteOneFinancialCreditCardSaved(where: $where) {
    id
  }
}
    `;
export type DeleteOneFinancialCreditCardSavedMutationFn = Apollo.MutationFunction<DeleteOneFinancialCreditCardSavedMutation, DeleteOneFinancialCreditCardSavedMutationVariables>;

/**
 * __useDeleteOneFinancialCreditCardSavedMutation__
 *
 * To run a mutation, you first call `useDeleteOneFinancialCreditCardSavedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneFinancialCreditCardSavedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneFinancialCreditCardSavedMutation, { data, loading, error }] = useDeleteOneFinancialCreditCardSavedMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteOneFinancialCreditCardSavedMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOneFinancialCreditCardSavedMutation, DeleteOneFinancialCreditCardSavedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOneFinancialCreditCardSavedMutation, DeleteOneFinancialCreditCardSavedMutationVariables>(DeleteOneFinancialCreditCardSavedDocument, options);
      }
export type DeleteOneFinancialCreditCardSavedMutationHookResult = ReturnType<typeof useDeleteOneFinancialCreditCardSavedMutation>;
export type DeleteOneFinancialCreditCardSavedMutationResult = Apollo.MutationResult<DeleteOneFinancialCreditCardSavedMutation>;
export type DeleteOneFinancialCreditCardSavedMutationOptions = Apollo.BaseMutationOptions<DeleteOneFinancialCreditCardSavedMutation, DeleteOneFinancialCreditCardSavedMutationVariables>;
export const DeleteOneMaintainerAdminDocument = gql`
    mutation deleteOneMaintainerAdmin($where: MaintainerAdminWhereUniqueInput!) {
  deleteOneMaintainerAdmin(where: $where) {
    commonUserId
  }
}
    `;
export type DeleteOneMaintainerAdminMutationFn = Apollo.MutationFunction<DeleteOneMaintainerAdminMutation, DeleteOneMaintainerAdminMutationVariables>;

/**
 * __useDeleteOneMaintainerAdminMutation__
 *
 * To run a mutation, you first call `useDeleteOneMaintainerAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneMaintainerAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneMaintainerAdminMutation, { data, loading, error }] = useDeleteOneMaintainerAdminMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteOneMaintainerAdminMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOneMaintainerAdminMutation, DeleteOneMaintainerAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOneMaintainerAdminMutation, DeleteOneMaintainerAdminMutationVariables>(DeleteOneMaintainerAdminDocument, options);
      }
export type DeleteOneMaintainerAdminMutationHookResult = ReturnType<typeof useDeleteOneMaintainerAdminMutation>;
export type DeleteOneMaintainerAdminMutationResult = Apollo.MutationResult<DeleteOneMaintainerAdminMutation>;
export type DeleteOneMaintainerAdminMutationOptions = Apollo.BaseMutationOptions<DeleteOneMaintainerAdminMutation, DeleteOneMaintainerAdminMutationVariables>;
export const DeleteOneMaintainerTeamDocument = gql`
    mutation deleteOneMaintainerTeam($where: TeamWhereUniqueInput!) {
  deleteOneMaintainerTeam(where: $where) {
    id
  }
}
    `;
export type DeleteOneMaintainerTeamMutationFn = Apollo.MutationFunction<DeleteOneMaintainerTeamMutation, DeleteOneMaintainerTeamMutationVariables>;

/**
 * __useDeleteOneMaintainerTeamMutation__
 *
 * To run a mutation, you first call `useDeleteOneMaintainerTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneMaintainerTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneMaintainerTeamMutation, { data, loading, error }] = useDeleteOneMaintainerTeamMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteOneMaintainerTeamMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOneMaintainerTeamMutation, DeleteOneMaintainerTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOneMaintainerTeamMutation, DeleteOneMaintainerTeamMutationVariables>(DeleteOneMaintainerTeamDocument, options);
      }
export type DeleteOneMaintainerTeamMutationHookResult = ReturnType<typeof useDeleteOneMaintainerTeamMutation>;
export type DeleteOneMaintainerTeamMutationResult = Apollo.MutationResult<DeleteOneMaintainerTeamMutation>;
export type DeleteOneMaintainerTeamMutationOptions = Apollo.BaseMutationOptions<DeleteOneMaintainerTeamMutation, DeleteOneMaintainerTeamMutationVariables>;
export const DeleteOneReusableFormDataDocument = gql`
    mutation deleteOneReusableFormData($where: ReusableFormDataWhereUniqueInput!) {
  deleteOneReusableFormData(where: $where) {
    id
  }
}
    `;
export type DeleteOneReusableFormDataMutationFn = Apollo.MutationFunction<DeleteOneReusableFormDataMutation, DeleteOneReusableFormDataMutationVariables>;

/**
 * __useDeleteOneReusableFormDataMutation__
 *
 * To run a mutation, you first call `useDeleteOneReusableFormDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneReusableFormDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneReusableFormDataMutation, { data, loading, error }] = useDeleteOneReusableFormDataMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteOneReusableFormDataMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOneReusableFormDataMutation, DeleteOneReusableFormDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOneReusableFormDataMutation, DeleteOneReusableFormDataMutationVariables>(DeleteOneReusableFormDataDocument, options);
      }
export type DeleteOneReusableFormDataMutationHookResult = ReturnType<typeof useDeleteOneReusableFormDataMutation>;
export type DeleteOneReusableFormDataMutationResult = Apollo.MutationResult<DeleteOneReusableFormDataMutation>;
export type DeleteOneReusableFormDataMutationOptions = Apollo.BaseMutationOptions<DeleteOneReusableFormDataMutation, DeleteOneReusableFormDataMutationVariables>;
export const DeleteOnePersonDocument = gql`
    mutation deleteOnePerson($id: String!) {
  deleteOnePerson(id: $id) {
    id
  }
}
    `;
export type DeleteOnePersonMutationFn = Apollo.MutationFunction<DeleteOnePersonMutation, DeleteOnePersonMutationVariables>;

/**
 * __useDeleteOnePersonMutation__
 *
 * To run a mutation, you first call `useDeleteOnePersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOnePersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOnePersonMutation, { data, loading, error }] = useDeleteOnePersonMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOnePersonMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOnePersonMutation, DeleteOnePersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOnePersonMutation, DeleteOnePersonMutationVariables>(DeleteOnePersonDocument, options);
      }
export type DeleteOnePersonMutationHookResult = ReturnType<typeof useDeleteOnePersonMutation>;
export type DeleteOnePersonMutationResult = Apollo.MutationResult<DeleteOnePersonMutation>;
export type DeleteOnePersonMutationOptions = Apollo.BaseMutationOptions<DeleteOnePersonMutation, DeleteOnePersonMutationVariables>;
export const DeleteOneReusableFormDataCurriculumDocument = gql`
    mutation deleteOneReusableFormDataCurriculum($deleteOneReusableFormDataCurriculumId: Int!) {
  deleteOneReusableFormDataCurriculum(id: $deleteOneReusableFormDataCurriculumId) {
    id
  }
}
    `;
export type DeleteOneReusableFormDataCurriculumMutationFn = Apollo.MutationFunction<DeleteOneReusableFormDataCurriculumMutation, DeleteOneReusableFormDataCurriculumMutationVariables>;

/**
 * __useDeleteOneReusableFormDataCurriculumMutation__
 *
 * To run a mutation, you first call `useDeleteOneReusableFormDataCurriculumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneReusableFormDataCurriculumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneReusableFormDataCurriculumMutation, { data, loading, error }] = useDeleteOneReusableFormDataCurriculumMutation({
 *   variables: {
 *      deleteOneReusableFormDataCurriculumId: // value for 'deleteOneReusableFormDataCurriculumId'
 *   },
 * });
 */
export function useDeleteOneReusableFormDataCurriculumMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOneReusableFormDataCurriculumMutation, DeleteOneReusableFormDataCurriculumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOneReusableFormDataCurriculumMutation, DeleteOneReusableFormDataCurriculumMutationVariables>(DeleteOneReusableFormDataCurriculumDocument, options);
      }
export type DeleteOneReusableFormDataCurriculumMutationHookResult = ReturnType<typeof useDeleteOneReusableFormDataCurriculumMutation>;
export type DeleteOneReusableFormDataCurriculumMutationResult = Apollo.MutationResult<DeleteOneReusableFormDataCurriculumMutation>;
export type DeleteOneReusableFormDataCurriculumMutationOptions = Apollo.BaseMutationOptions<DeleteOneReusableFormDataCurriculumMutation, DeleteOneReusableFormDataCurriculumMutationVariables>;
export const DeleteOneSignSignatureImageDocument = gql`
    mutation deleteOneSignSignatureImage($where: SignSignatureImageWhereUniqueInput!) {
  deleteOneSignSignatureImage(where: $where) {
    id
  }
}
    `;
export type DeleteOneSignSignatureImageMutationFn = Apollo.MutationFunction<DeleteOneSignSignatureImageMutation, DeleteOneSignSignatureImageMutationVariables>;

/**
 * __useDeleteOneSignSignatureImageMutation__
 *
 * To run a mutation, you first call `useDeleteOneSignSignatureImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneSignSignatureImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneSignSignatureImageMutation, { data, loading, error }] = useDeleteOneSignSignatureImageMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteOneSignSignatureImageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOneSignSignatureImageMutation, DeleteOneSignSignatureImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOneSignSignatureImageMutation, DeleteOneSignSignatureImageMutationVariables>(DeleteOneSignSignatureImageDocument, options);
      }
export type DeleteOneSignSignatureImageMutationHookResult = ReturnType<typeof useDeleteOneSignSignatureImageMutation>;
export type DeleteOneSignSignatureImageMutationResult = Apollo.MutationResult<DeleteOneSignSignatureImageMutation>;
export type DeleteOneSignSignatureImageMutationOptions = Apollo.BaseMutationOptions<DeleteOneSignSignatureImageMutation, DeleteOneSignSignatureImageMutationVariables>;
export const DeleteOneSystemGlobalAlertDocument = gql`
    mutation deleteOneSystemGlobalAlert($where: SystemGlobalAlertWhereUniqueInput!) {
  deleteOneSystemGlobalAlert(where: $where) {
    id
  }
}
    `;
export type DeleteOneSystemGlobalAlertMutationFn = Apollo.MutationFunction<DeleteOneSystemGlobalAlertMutation, DeleteOneSystemGlobalAlertMutationVariables>;

/**
 * __useDeleteOneSystemGlobalAlertMutation__
 *
 * To run a mutation, you first call `useDeleteOneSystemGlobalAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneSystemGlobalAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneSystemGlobalAlertMutation, { data, loading, error }] = useDeleteOneSystemGlobalAlertMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteOneSystemGlobalAlertMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOneSystemGlobalAlertMutation, DeleteOneSystemGlobalAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOneSystemGlobalAlertMutation, DeleteOneSystemGlobalAlertMutationVariables>(DeleteOneSystemGlobalAlertDocument, options);
      }
export type DeleteOneSystemGlobalAlertMutationHookResult = ReturnType<typeof useDeleteOneSystemGlobalAlertMutation>;
export type DeleteOneSystemGlobalAlertMutationResult = Apollo.MutationResult<DeleteOneSystemGlobalAlertMutation>;
export type DeleteOneSystemGlobalAlertMutationOptions = Apollo.BaseMutationOptions<DeleteOneSystemGlobalAlertMutation, DeleteOneSystemGlobalAlertMutationVariables>;
export const DeleteOneTeamMemberDocument = gql`
    mutation deleteOneTeamMember($where: TeamMemberWhereUniqueInput!) {
  deleteOneTeamMember(where: $where) {
    id
  }
}
    `;
export type DeleteOneTeamMemberMutationFn = Apollo.MutationFunction<DeleteOneTeamMemberMutation, DeleteOneTeamMemberMutationVariables>;

/**
 * __useDeleteOneTeamMemberMutation__
 *
 * To run a mutation, you first call `useDeleteOneTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneTeamMemberMutation, { data, loading, error }] = useDeleteOneTeamMemberMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteOneTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOneTeamMemberMutation, DeleteOneTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOneTeamMemberMutation, DeleteOneTeamMemberMutationVariables>(DeleteOneTeamMemberDocument, options);
      }
export type DeleteOneTeamMemberMutationHookResult = ReturnType<typeof useDeleteOneTeamMemberMutation>;
export type DeleteOneTeamMemberMutationResult = Apollo.MutationResult<DeleteOneTeamMemberMutation>;
export type DeleteOneTeamMemberMutationOptions = Apollo.BaseMutationOptions<DeleteOneTeamMemberMutation, DeleteOneTeamMemberMutationVariables>;
export const DismissSystemGlobalAlertDocument = gql`
    mutation dismissSystemGlobalAlert($dismissSystemGlobalAlertId: Int!) {
  dismissSystemGlobalAlert(id: $dismissSystemGlobalAlertId)
}
    `;
export type DismissSystemGlobalAlertMutationFn = Apollo.MutationFunction<DismissSystemGlobalAlertMutation, DismissSystemGlobalAlertMutationVariables>;

/**
 * __useDismissSystemGlobalAlertMutation__
 *
 * To run a mutation, you first call `useDismissSystemGlobalAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissSystemGlobalAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissSystemGlobalAlertMutation, { data, loading, error }] = useDismissSystemGlobalAlertMutation({
 *   variables: {
 *      dismissSystemGlobalAlertId: // value for 'dismissSystemGlobalAlertId'
 *   },
 * });
 */
export function useDismissSystemGlobalAlertMutation(baseOptions?: Apollo.MutationHookOptions<DismissSystemGlobalAlertMutation, DismissSystemGlobalAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismissSystemGlobalAlertMutation, DismissSystemGlobalAlertMutationVariables>(DismissSystemGlobalAlertDocument, options);
      }
export type DismissSystemGlobalAlertMutationHookResult = ReturnType<typeof useDismissSystemGlobalAlertMutation>;
export type DismissSystemGlobalAlertMutationResult = Apollo.MutationResult<DismissSystemGlobalAlertMutation>;
export type DismissSystemGlobalAlertMutationOptions = Apollo.BaseMutationOptions<DismissSystemGlobalAlertMutation, DismissSystemGlobalAlertMutationVariables>;
export const DuplicateOneCertificateTemplateDocument = gql`
    mutation duplicateOneCertificateTemplate($templateId: String!) {
  duplicateOneCertificateTemplate(templateId: $templateId) {
    id
  }
}
    `;
export type DuplicateOneCertificateTemplateMutationFn = Apollo.MutationFunction<DuplicateOneCertificateTemplateMutation, DuplicateOneCertificateTemplateMutationVariables>;

/**
 * __useDuplicateOneCertificateTemplateMutation__
 *
 * To run a mutation, you first call `useDuplicateOneCertificateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateOneCertificateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateOneCertificateTemplateMutation, { data, loading, error }] = useDuplicateOneCertificateTemplateMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useDuplicateOneCertificateTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateOneCertificateTemplateMutation, DuplicateOneCertificateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateOneCertificateTemplateMutation, DuplicateOneCertificateTemplateMutationVariables>(DuplicateOneCertificateTemplateDocument, options);
      }
export type DuplicateOneCertificateTemplateMutationHookResult = ReturnType<typeof useDuplicateOneCertificateTemplateMutation>;
export type DuplicateOneCertificateTemplateMutationResult = Apollo.MutationResult<DuplicateOneCertificateTemplateMutation>;
export type DuplicateOneCertificateTemplateMutationOptions = Apollo.BaseMutationOptions<DuplicateOneCertificateTemplateMutation, DuplicateOneCertificateTemplateMutationVariables>;
export const FinalizeOneCertificateSignatureDocument = gql`
    mutation finalizeOneCertificateSignature($certificate: String!, $initialize: InitializeResponseInput!, $inviteId: String!, $signatureImageId: String) {
  finalizeOneCertificateSignature(
    certificate: $certificate
    initialize: $initialize
    inviteId: $inviteId
    signatureImageId: $signatureImageId
  ) {
    id
  }
}
    `;
export type FinalizeOneCertificateSignatureMutationFn = Apollo.MutationFunction<FinalizeOneCertificateSignatureMutation, FinalizeOneCertificateSignatureMutationVariables>;

/**
 * __useFinalizeOneCertificateSignatureMutation__
 *
 * To run a mutation, you first call `useFinalizeOneCertificateSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeOneCertificateSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeOneCertificateSignatureMutation, { data, loading, error }] = useFinalizeOneCertificateSignatureMutation({
 *   variables: {
 *      certificate: // value for 'certificate'
 *      initialize: // value for 'initialize'
 *      inviteId: // value for 'inviteId'
 *      signatureImageId: // value for 'signatureImageId'
 *   },
 * });
 */
export function useFinalizeOneCertificateSignatureMutation(baseOptions?: Apollo.MutationHookOptions<FinalizeOneCertificateSignatureMutation, FinalizeOneCertificateSignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalizeOneCertificateSignatureMutation, FinalizeOneCertificateSignatureMutationVariables>(FinalizeOneCertificateSignatureDocument, options);
      }
export type FinalizeOneCertificateSignatureMutationHookResult = ReturnType<typeof useFinalizeOneCertificateSignatureMutation>;
export type FinalizeOneCertificateSignatureMutationResult = Apollo.MutationResult<FinalizeOneCertificateSignatureMutation>;
export type FinalizeOneCertificateSignatureMutationOptions = Apollo.BaseMutationOptions<FinalizeOneCertificateSignatureMutation, FinalizeOneCertificateSignatureMutationVariables>;
export const FinalizeOneSignatureDocument = gql`
    mutation finalizeOneSignature($certificate: String!, $initialize: InitializeResponseInput!, $inviteId: Int!) {
  finalizeOneSignature(
    certificate: $certificate
    initialize: $initialize
    inviteId: $inviteId
  ) {
    id
  }
}
    `;
export type FinalizeOneSignatureMutationFn = Apollo.MutationFunction<FinalizeOneSignatureMutation, FinalizeOneSignatureMutationVariables>;

/**
 * __useFinalizeOneSignatureMutation__
 *
 * To run a mutation, you first call `useFinalizeOneSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeOneSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeOneSignatureMutation, { data, loading, error }] = useFinalizeOneSignatureMutation({
 *   variables: {
 *      certificate: // value for 'certificate'
 *      initialize: // value for 'initialize'
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useFinalizeOneSignatureMutation(baseOptions?: Apollo.MutationHookOptions<FinalizeOneSignatureMutation, FinalizeOneSignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalizeOneSignatureMutation, FinalizeOneSignatureMutationVariables>(FinalizeOneSignatureDocument, options);
      }
export type FinalizeOneSignatureMutationHookResult = ReturnType<typeof useFinalizeOneSignatureMutation>;
export type FinalizeOneSignatureMutationResult = Apollo.MutationResult<FinalizeOneSignatureMutation>;
export type FinalizeOneSignatureMutationOptions = Apollo.BaseMutationOptions<FinalizeOneSignatureMutation, FinalizeOneSignatureMutationVariables>;
export const FinalizeOneSignatureExternalSignatureInviteDocument = gql`
    mutation finalizeOneSignatureExternalSignatureInvite($certificate: String!, $initialize: InitializeResponseInput!, $inviteId: String!) {
  finalizeOneSignature: finalizeOneSignatureExternalSignatureInvite(
    certificate: $certificate
    initialize: $initialize
    inviteId: $inviteId
  ) {
    id
  }
}
    `;
export type FinalizeOneSignatureExternalSignatureInviteMutationFn = Apollo.MutationFunction<FinalizeOneSignatureExternalSignatureInviteMutation, FinalizeOneSignatureExternalSignatureInviteMutationVariables>;

/**
 * __useFinalizeOneSignatureExternalSignatureInviteMutation__
 *
 * To run a mutation, you first call `useFinalizeOneSignatureExternalSignatureInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeOneSignatureExternalSignatureInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeOneSignatureExternalSignatureInviteMutation, { data, loading, error }] = useFinalizeOneSignatureExternalSignatureInviteMutation({
 *   variables: {
 *      certificate: // value for 'certificate'
 *      initialize: // value for 'initialize'
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useFinalizeOneSignatureExternalSignatureInviteMutation(baseOptions?: Apollo.MutationHookOptions<FinalizeOneSignatureExternalSignatureInviteMutation, FinalizeOneSignatureExternalSignatureInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalizeOneSignatureExternalSignatureInviteMutation, FinalizeOneSignatureExternalSignatureInviteMutationVariables>(FinalizeOneSignatureExternalSignatureInviteDocument, options);
      }
export type FinalizeOneSignatureExternalSignatureInviteMutationHookResult = ReturnType<typeof useFinalizeOneSignatureExternalSignatureInviteMutation>;
export type FinalizeOneSignatureExternalSignatureInviteMutationResult = Apollo.MutationResult<FinalizeOneSignatureExternalSignatureInviteMutation>;
export type FinalizeOneSignatureExternalSignatureInviteMutationOptions = Apollo.BaseMutationOptions<FinalizeOneSignatureExternalSignatureInviteMutation, FinalizeOneSignatureExternalSignatureInviteMutationVariables>;
export const FinancialTeamWalletActivateTrialDocument = gql`
    mutation financialTeamWalletActivateTrial {
  financialTeamWalletActivateTrial {
    teamId
    creditsPlanTrial
    SubscriptionActive {
      plan
    }
  }
}
    `;
export type FinancialTeamWalletActivateTrialMutationFn = Apollo.MutationFunction<FinancialTeamWalletActivateTrialMutation, FinancialTeamWalletActivateTrialMutationVariables>;

/**
 * __useFinancialTeamWalletActivateTrialMutation__
 *
 * To run a mutation, you first call `useFinancialTeamWalletActivateTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinancialTeamWalletActivateTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [financialTeamWalletActivateTrialMutation, { data, loading, error }] = useFinancialTeamWalletActivateTrialMutation({
 *   variables: {
 *   },
 * });
 */
export function useFinancialTeamWalletActivateTrialMutation(baseOptions?: Apollo.MutationHookOptions<FinancialTeamWalletActivateTrialMutation, FinancialTeamWalletActivateTrialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinancialTeamWalletActivateTrialMutation, FinancialTeamWalletActivateTrialMutationVariables>(FinancialTeamWalletActivateTrialDocument, options);
      }
export type FinancialTeamWalletActivateTrialMutationHookResult = ReturnType<typeof useFinancialTeamWalletActivateTrialMutation>;
export type FinancialTeamWalletActivateTrialMutationResult = Apollo.MutationResult<FinancialTeamWalletActivateTrialMutation>;
export type FinancialTeamWalletActivateTrialMutationOptions = Apollo.BaseMutationOptions<FinancialTeamWalletActivateTrialMutation, FinancialTeamWalletActivateTrialMutationVariables>;
export const FinancialTeamWalletPurchasePlanDocument = gql`
    mutation financialTeamWalletPurchasePlan($data: FinancialTeamWalletPurchasePlanInput!) {
  financialTeamWalletPurchasePlan(data: $data) {
    Wallet {
      teamId
    }
    isFirstPlan
  }
}
    `;
export type FinancialTeamWalletPurchasePlanMutationFn = Apollo.MutationFunction<FinancialTeamWalletPurchasePlanMutation, FinancialTeamWalletPurchasePlanMutationVariables>;

/**
 * __useFinancialTeamWalletPurchasePlanMutation__
 *
 * To run a mutation, you first call `useFinancialTeamWalletPurchasePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinancialTeamWalletPurchasePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [financialTeamWalletPurchasePlanMutation, { data, loading, error }] = useFinancialTeamWalletPurchasePlanMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useFinancialTeamWalletPurchasePlanMutation(baseOptions?: Apollo.MutationHookOptions<FinancialTeamWalletPurchasePlanMutation, FinancialTeamWalletPurchasePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinancialTeamWalletPurchasePlanMutation, FinancialTeamWalletPurchasePlanMutationVariables>(FinancialTeamWalletPurchasePlanDocument, options);
      }
export type FinancialTeamWalletPurchasePlanMutationHookResult = ReturnType<typeof useFinancialTeamWalletPurchasePlanMutation>;
export type FinancialTeamWalletPurchasePlanMutationResult = Apollo.MutationResult<FinancialTeamWalletPurchasePlanMutation>;
export type FinancialTeamWalletPurchasePlanMutationOptions = Apollo.BaseMutationOptions<FinancialTeamWalletPurchasePlanMutation, FinancialTeamWalletPurchasePlanMutationVariables>;
export const FinancialTeamWalletSubscriptionCancelPlanDocument = gql`
    mutation financialTeamWalletSubscriptionCancelPlan {
  financialTeamWalletSubscriptionCancelPlan {
    id
  }
}
    `;
export type FinancialTeamWalletSubscriptionCancelPlanMutationFn = Apollo.MutationFunction<FinancialTeamWalletSubscriptionCancelPlanMutation, FinancialTeamWalletSubscriptionCancelPlanMutationVariables>;

/**
 * __useFinancialTeamWalletSubscriptionCancelPlanMutation__
 *
 * To run a mutation, you first call `useFinancialTeamWalletSubscriptionCancelPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinancialTeamWalletSubscriptionCancelPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [financialTeamWalletSubscriptionCancelPlanMutation, { data, loading, error }] = useFinancialTeamWalletSubscriptionCancelPlanMutation({
 *   variables: {
 *   },
 * });
 */
export function useFinancialTeamWalletSubscriptionCancelPlanMutation(baseOptions?: Apollo.MutationHookOptions<FinancialTeamWalletSubscriptionCancelPlanMutation, FinancialTeamWalletSubscriptionCancelPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinancialTeamWalletSubscriptionCancelPlanMutation, FinancialTeamWalletSubscriptionCancelPlanMutationVariables>(FinancialTeamWalletSubscriptionCancelPlanDocument, options);
      }
export type FinancialTeamWalletSubscriptionCancelPlanMutationHookResult = ReturnType<typeof useFinancialTeamWalletSubscriptionCancelPlanMutation>;
export type FinancialTeamWalletSubscriptionCancelPlanMutationResult = Apollo.MutationResult<FinancialTeamWalletSubscriptionCancelPlanMutation>;
export type FinancialTeamWalletSubscriptionCancelPlanMutationOptions = Apollo.BaseMutationOptions<FinancialTeamWalletSubscriptionCancelPlanMutation, FinancialTeamWalletSubscriptionCancelPlanMutationVariables>;
export const FindManySignSignatureImageDocument = gql`
    query findManySignSignatureImage($where: SignSignatureImageWhereInput, $take: Int, $skip: Int, $orderBy: [SignSignatureImageOrderByWithRelationInput!]) {
  findManySignSignatureImage(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    ...SignSignatureImageFields
  }
  countSignSignatureImage(where: $where)
}
    ${SignSignatureImageFieldsFragmentDoc}`;

/**
 * __useFindManySignSignatureImageQuery__
 *
 * To run a query within a React component, call `useFindManySignSignatureImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManySignSignatureImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManySignSignatureImageQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManySignSignatureImageQuery(baseOptions?: Apollo.QueryHookOptions<FindManySignSignatureImageQuery, FindManySignSignatureImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManySignSignatureImageQuery, FindManySignSignatureImageQueryVariables>(FindManySignSignatureImageDocument, options);
      }
export function useFindManySignSignatureImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManySignSignatureImageQuery, FindManySignSignatureImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManySignSignatureImageQuery, FindManySignSignatureImageQueryVariables>(FindManySignSignatureImageDocument, options);
        }
export type FindManySignSignatureImageQueryHookResult = ReturnType<typeof useFindManySignSignatureImageQuery>;
export type FindManySignSignatureImageLazyQueryHookResult = ReturnType<typeof useFindManySignSignatureImageLazyQuery>;
export type FindManySignSignatureImageQueryResult = Apollo.QueryResult<FindManySignSignatureImageQuery, FindManySignSignatureImageQueryVariables>;
export const PatchOneDocumentAcademicDocumentationDocument = gql`
    mutation patchOneDocumentAcademicDocumentation($changes: [DocumentChange!]!, $patchOneDocumentAcademicDocumentationId: String!) {
  patchOneDocumentAcademicDocumentation(
    changes: $changes
    id: $patchOneDocumentAcademicDocumentationId
  )
}
    `;
export type PatchOneDocumentAcademicDocumentationMutationFn = Apollo.MutationFunction<PatchOneDocumentAcademicDocumentationMutation, PatchOneDocumentAcademicDocumentationMutationVariables>;

/**
 * __usePatchOneDocumentAcademicDocumentationMutation__
 *
 * To run a mutation, you first call `usePatchOneDocumentAcademicDocumentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatchOneDocumentAcademicDocumentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchOneDocumentAcademicDocumentationMutation, { data, loading, error }] = usePatchOneDocumentAcademicDocumentationMutation({
 *   variables: {
 *      changes: // value for 'changes'
 *      patchOneDocumentAcademicDocumentationId: // value for 'patchOneDocumentAcademicDocumentationId'
 *   },
 * });
 */
export function usePatchOneDocumentAcademicDocumentationMutation(baseOptions?: Apollo.MutationHookOptions<PatchOneDocumentAcademicDocumentationMutation, PatchOneDocumentAcademicDocumentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PatchOneDocumentAcademicDocumentationMutation, PatchOneDocumentAcademicDocumentationMutationVariables>(PatchOneDocumentAcademicDocumentationDocument, options);
      }
export type PatchOneDocumentAcademicDocumentationMutationHookResult = ReturnType<typeof usePatchOneDocumentAcademicDocumentationMutation>;
export type PatchOneDocumentAcademicDocumentationMutationResult = Apollo.MutationResult<PatchOneDocumentAcademicDocumentationMutation>;
export type PatchOneDocumentAcademicDocumentationMutationOptions = Apollo.BaseMutationOptions<PatchOneDocumentAcademicDocumentationMutation, PatchOneDocumentAcademicDocumentationMutationVariables>;
export const PatchOneDocumentSchoolCurriculumDocument = gql`
    mutation patchOneDocumentSchoolCurriculum($changes: [DocumentChange!]!, $patchOneDocumentSchoolCurriculumId: String!) {
  patchOneDocumentSchoolCurriculum(
    changes: $changes
    id: $patchOneDocumentSchoolCurriculumId
  )
}
    `;
export type PatchOneDocumentSchoolCurriculumMutationFn = Apollo.MutationFunction<PatchOneDocumentSchoolCurriculumMutation, PatchOneDocumentSchoolCurriculumMutationVariables>;

/**
 * __usePatchOneDocumentSchoolCurriculumMutation__
 *
 * To run a mutation, you first call `usePatchOneDocumentSchoolCurriculumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatchOneDocumentSchoolCurriculumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchOneDocumentSchoolCurriculumMutation, { data, loading, error }] = usePatchOneDocumentSchoolCurriculumMutation({
 *   variables: {
 *      changes: // value for 'changes'
 *      patchOneDocumentSchoolCurriculumId: // value for 'patchOneDocumentSchoolCurriculumId'
 *   },
 * });
 */
export function usePatchOneDocumentSchoolCurriculumMutation(baseOptions?: Apollo.MutationHookOptions<PatchOneDocumentSchoolCurriculumMutation, PatchOneDocumentSchoolCurriculumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PatchOneDocumentSchoolCurriculumMutation, PatchOneDocumentSchoolCurriculumMutationVariables>(PatchOneDocumentSchoolCurriculumDocument, options);
      }
export type PatchOneDocumentSchoolCurriculumMutationHookResult = ReturnType<typeof usePatchOneDocumentSchoolCurriculumMutation>;
export type PatchOneDocumentSchoolCurriculumMutationResult = Apollo.MutationResult<PatchOneDocumentSchoolCurriculumMutation>;
export type PatchOneDocumentSchoolCurriculumMutationOptions = Apollo.BaseMutationOptions<PatchOneDocumentSchoolCurriculumMutation, PatchOneDocumentSchoolCurriculumMutationVariables>;
export const PayOverduePaymentsDocument = gql`
    mutation payOverduePayments($data: PlanPayOverduePaymentsInput!) {
  payOverduePayments(data: $data) {
    id
  }
}
    `;
export type PayOverduePaymentsMutationFn = Apollo.MutationFunction<PayOverduePaymentsMutation, PayOverduePaymentsMutationVariables>;

/**
 * __usePayOverduePaymentsMutation__
 *
 * To run a mutation, you first call `usePayOverduePaymentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayOverduePaymentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payOverduePaymentsMutation, { data, loading, error }] = usePayOverduePaymentsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePayOverduePaymentsMutation(baseOptions?: Apollo.MutationHookOptions<PayOverduePaymentsMutation, PayOverduePaymentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayOverduePaymentsMutation, PayOverduePaymentsMutationVariables>(PayOverduePaymentsDocument, options);
      }
export type PayOverduePaymentsMutationHookResult = ReturnType<typeof usePayOverduePaymentsMutation>;
export type PayOverduePaymentsMutationResult = Apollo.MutationResult<PayOverduePaymentsMutation>;
export type PayOverduePaymentsMutationOptions = Apollo.BaseMutationOptions<PayOverduePaymentsMutation, PayOverduePaymentsMutationVariables>;
export const ReplaceOneDegreeVisualRepresentationDocument = gql`
    mutation replaceOneDegreeVisualRepresentation($degreeId: String!, $visualRepresentation: Upload!) {
  replaceOneDegreeVisualRepresentation(
    degreeId: $degreeId
    visualRepresentation: $visualRepresentation
  ) {
    documentBaseId
    visualRepresentationPath
  }
}
    `;
export type ReplaceOneDegreeVisualRepresentationMutationFn = Apollo.MutationFunction<ReplaceOneDegreeVisualRepresentationMutation, ReplaceOneDegreeVisualRepresentationMutationVariables>;

/**
 * __useReplaceOneDegreeVisualRepresentationMutation__
 *
 * To run a mutation, you first call `useReplaceOneDegreeVisualRepresentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceOneDegreeVisualRepresentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceOneDegreeVisualRepresentationMutation, { data, loading, error }] = useReplaceOneDegreeVisualRepresentationMutation({
 *   variables: {
 *      degreeId: // value for 'degreeId'
 *      visualRepresentation: // value for 'visualRepresentation'
 *   },
 * });
 */
export function useReplaceOneDegreeVisualRepresentationMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceOneDegreeVisualRepresentationMutation, ReplaceOneDegreeVisualRepresentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceOneDegreeVisualRepresentationMutation, ReplaceOneDegreeVisualRepresentationMutationVariables>(ReplaceOneDegreeVisualRepresentationDocument, options);
      }
export type ReplaceOneDegreeVisualRepresentationMutationHookResult = ReturnType<typeof useReplaceOneDegreeVisualRepresentationMutation>;
export type ReplaceOneDegreeVisualRepresentationMutationResult = Apollo.MutationResult<ReplaceOneDegreeVisualRepresentationMutation>;
export type ReplaceOneDegreeVisualRepresentationMutationOptions = Apollo.BaseMutationOptions<ReplaceOneDegreeVisualRepresentationMutation, ReplaceOneDegreeVisualRepresentationMutationVariables>;
export const ResendOneTeamMemberEmailDocument = gql`
    mutation resendOneTeamMemberEmail($memberId: Int!) {
  resendOneTeamMemberEmail(memberId: $memberId) {
    id
  }
}
    `;
export type ResendOneTeamMemberEmailMutationFn = Apollo.MutationFunction<ResendOneTeamMemberEmailMutation, ResendOneTeamMemberEmailMutationVariables>;

/**
 * __useResendOneTeamMemberEmailMutation__
 *
 * To run a mutation, you first call `useResendOneTeamMemberEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendOneTeamMemberEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendOneTeamMemberEmailMutation, { data, loading, error }] = useResendOneTeamMemberEmailMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useResendOneTeamMemberEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendOneTeamMemberEmailMutation, ResendOneTeamMemberEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendOneTeamMemberEmailMutation, ResendOneTeamMemberEmailMutationVariables>(ResendOneTeamMemberEmailDocument, options);
      }
export type ResendOneTeamMemberEmailMutationHookResult = ReturnType<typeof useResendOneTeamMemberEmailMutation>;
export type ResendOneTeamMemberEmailMutationResult = Apollo.MutationResult<ResendOneTeamMemberEmailMutation>;
export type ResendOneTeamMemberEmailMutationOptions = Apollo.BaseMutationOptions<ResendOneTeamMemberEmailMutation, ResendOneTeamMemberEmailMutationVariables>;
export const RevalidateOneDocumentAcademicDocumentationDocument = gql`
    mutation revalidateOneDocumentAcademicDocumentation($documentId: String!) {
  revalidateOneDocumentAcademicDocumentation(documentId: $documentId) {
    documentBaseId
  }
}
    `;
export type RevalidateOneDocumentAcademicDocumentationMutationFn = Apollo.MutationFunction<RevalidateOneDocumentAcademicDocumentationMutation, RevalidateOneDocumentAcademicDocumentationMutationVariables>;

/**
 * __useRevalidateOneDocumentAcademicDocumentationMutation__
 *
 * To run a mutation, you first call `useRevalidateOneDocumentAcademicDocumentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevalidateOneDocumentAcademicDocumentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revalidateOneDocumentAcademicDocumentationMutation, { data, loading, error }] = useRevalidateOneDocumentAcademicDocumentationMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useRevalidateOneDocumentAcademicDocumentationMutation(baseOptions?: Apollo.MutationHookOptions<RevalidateOneDocumentAcademicDocumentationMutation, RevalidateOneDocumentAcademicDocumentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevalidateOneDocumentAcademicDocumentationMutation, RevalidateOneDocumentAcademicDocumentationMutationVariables>(RevalidateOneDocumentAcademicDocumentationDocument, options);
      }
export type RevalidateOneDocumentAcademicDocumentationMutationHookResult = ReturnType<typeof useRevalidateOneDocumentAcademicDocumentationMutation>;
export type RevalidateOneDocumentAcademicDocumentationMutationResult = Apollo.MutationResult<RevalidateOneDocumentAcademicDocumentationMutation>;
export type RevalidateOneDocumentAcademicDocumentationMutationOptions = Apollo.BaseMutationOptions<RevalidateOneDocumentAcademicDocumentationMutation, RevalidateOneDocumentAcademicDocumentationMutationVariables>;
export const ReviewOneDocumentAcademicDocumentationDocument = gql`
    mutation reviewOneDocumentAcademicDocumentation($academicDocumentationId: String!, $reproveReason: String) {
  reviewOneDocumentAcademicDocumentation(
    academicDocumentationId: $academicDocumentationId
    reproveReason: $reproveReason
  ) {
    documentBaseId
    status
  }
}
    `;
export type ReviewOneDocumentAcademicDocumentationMutationFn = Apollo.MutationFunction<ReviewOneDocumentAcademicDocumentationMutation, ReviewOneDocumentAcademicDocumentationMutationVariables>;

/**
 * __useReviewOneDocumentAcademicDocumentationMutation__
 *
 * To run a mutation, you first call `useReviewOneDocumentAcademicDocumentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewOneDocumentAcademicDocumentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewOneDocumentAcademicDocumentationMutation, { data, loading, error }] = useReviewOneDocumentAcademicDocumentationMutation({
 *   variables: {
 *      academicDocumentationId: // value for 'academicDocumentationId'
 *      reproveReason: // value for 'reproveReason'
 *   },
 * });
 */
export function useReviewOneDocumentAcademicDocumentationMutation(baseOptions?: Apollo.MutationHookOptions<ReviewOneDocumentAcademicDocumentationMutation, ReviewOneDocumentAcademicDocumentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReviewOneDocumentAcademicDocumentationMutation, ReviewOneDocumentAcademicDocumentationMutationVariables>(ReviewOneDocumentAcademicDocumentationDocument, options);
      }
export type ReviewOneDocumentAcademicDocumentationMutationHookResult = ReturnType<typeof useReviewOneDocumentAcademicDocumentationMutation>;
export type ReviewOneDocumentAcademicDocumentationMutationResult = Apollo.MutationResult<ReviewOneDocumentAcademicDocumentationMutation>;
export type ReviewOneDocumentAcademicDocumentationMutationOptions = Apollo.BaseMutationOptions<ReviewOneDocumentAcademicDocumentationMutation, ReviewOneDocumentAcademicDocumentationMutationVariables>;
export const ReviewOneDocumentAuditFileIssuerDocument = gql`
    mutation reviewOneDocumentAuditFileIssuer($documentBaseId: String!, $reproveReason: String) {
  reviewOneDocumentAuditFileIssuer(
    documentBaseId: $documentBaseId
    reproveReason: $reproveReason
  ) {
    documentBaseId
    DocumentBase {
      DocumentBaseSignatureInviteGroups {
        Invites {
          id
        }
      }
    }
  }
}
    `;
export type ReviewOneDocumentAuditFileIssuerMutationFn = Apollo.MutationFunction<ReviewOneDocumentAuditFileIssuerMutation, ReviewOneDocumentAuditFileIssuerMutationVariables>;

/**
 * __useReviewOneDocumentAuditFileIssuerMutation__
 *
 * To run a mutation, you first call `useReviewOneDocumentAuditFileIssuerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewOneDocumentAuditFileIssuerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewOneDocumentAuditFileIssuerMutation, { data, loading, error }] = useReviewOneDocumentAuditFileIssuerMutation({
 *   variables: {
 *      documentBaseId: // value for 'documentBaseId'
 *      reproveReason: // value for 'reproveReason'
 *   },
 * });
 */
export function useReviewOneDocumentAuditFileIssuerMutation(baseOptions?: Apollo.MutationHookOptions<ReviewOneDocumentAuditFileIssuerMutation, ReviewOneDocumentAuditFileIssuerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReviewOneDocumentAuditFileIssuerMutation, ReviewOneDocumentAuditFileIssuerMutationVariables>(ReviewOneDocumentAuditFileIssuerDocument, options);
      }
export type ReviewOneDocumentAuditFileIssuerMutationHookResult = ReturnType<typeof useReviewOneDocumentAuditFileIssuerMutation>;
export type ReviewOneDocumentAuditFileIssuerMutationResult = Apollo.MutationResult<ReviewOneDocumentAuditFileIssuerMutation>;
export type ReviewOneDocumentAuditFileIssuerMutationOptions = Apollo.BaseMutationOptions<ReviewOneDocumentAuditFileIssuerMutation, ReviewOneDocumentAuditFileIssuerMutationVariables>;
export const ReviewOneDocumentSchoolCurriculumDocument = gql`
    mutation reviewOneDocumentSchoolCurriculum($schoolCurriculumId: String!, $reproveReason: String) {
  reviewOneDocumentSchoolCurriculum(
    schoolCurriculumId: $schoolCurriculumId
    reproveReason: $reproveReason
  ) {
    documentBaseId
    DocumentBase {
      DocumentBaseSignatureInviteGroups {
        Invites {
          id
        }
      }
    }
  }
}
    `;
export type ReviewOneDocumentSchoolCurriculumMutationFn = Apollo.MutationFunction<ReviewOneDocumentSchoolCurriculumMutation, ReviewOneDocumentSchoolCurriculumMutationVariables>;

/**
 * __useReviewOneDocumentSchoolCurriculumMutation__
 *
 * To run a mutation, you first call `useReviewOneDocumentSchoolCurriculumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewOneDocumentSchoolCurriculumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewOneDocumentSchoolCurriculumMutation, { data, loading, error }] = useReviewOneDocumentSchoolCurriculumMutation({
 *   variables: {
 *      schoolCurriculumId: // value for 'schoolCurriculumId'
 *      reproveReason: // value for 'reproveReason'
 *   },
 * });
 */
export function useReviewOneDocumentSchoolCurriculumMutation(baseOptions?: Apollo.MutationHookOptions<ReviewOneDocumentSchoolCurriculumMutation, ReviewOneDocumentSchoolCurriculumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReviewOneDocumentSchoolCurriculumMutation, ReviewOneDocumentSchoolCurriculumMutationVariables>(ReviewOneDocumentSchoolCurriculumDocument, options);
      }
export type ReviewOneDocumentSchoolCurriculumMutationHookResult = ReturnType<typeof useReviewOneDocumentSchoolCurriculumMutation>;
export type ReviewOneDocumentSchoolCurriculumMutationResult = Apollo.MutationResult<ReviewOneDocumentSchoolCurriculumMutation>;
export type ReviewOneDocumentSchoolCurriculumMutationOptions = Apollo.BaseMutationOptions<ReviewOneDocumentSchoolCurriculumMutation, ReviewOneDocumentSchoolCurriculumMutationVariables>;
export const RevokeOneDocumentBaseDocument = gql`
    mutation revokeOneDocumentBase($id: String!, $revokeReason: String!) {
  revokeOneDocumentBase(id: $id, revokeReason: $revokeReason) {
    internalSeqId
    type
  }
}
    `;
export type RevokeOneDocumentBaseMutationFn = Apollo.MutationFunction<RevokeOneDocumentBaseMutation, RevokeOneDocumentBaseMutationVariables>;

/**
 * __useRevokeOneDocumentBaseMutation__
 *
 * To run a mutation, you first call `useRevokeOneDocumentBaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeOneDocumentBaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeOneDocumentBaseMutation, { data, loading, error }] = useRevokeOneDocumentBaseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      revokeReason: // value for 'revokeReason'
 *   },
 * });
 */
export function useRevokeOneDocumentBaseMutation(baseOptions?: Apollo.MutationHookOptions<RevokeOneDocumentBaseMutation, RevokeOneDocumentBaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeOneDocumentBaseMutation, RevokeOneDocumentBaseMutationVariables>(RevokeOneDocumentBaseDocument, options);
      }
export type RevokeOneDocumentBaseMutationHookResult = ReturnType<typeof useRevokeOneDocumentBaseMutation>;
export type RevokeOneDocumentBaseMutationResult = Apollo.MutationResult<RevokeOneDocumentBaseMutation>;
export type RevokeOneDocumentBaseMutationOptions = Apollo.BaseMutationOptions<RevokeOneDocumentBaseMutation, RevokeOneDocumentBaseMutationVariables>;
export const SaveOneDocumentAcademicDocumentationDocument = gql`
    mutation saveOneDocumentAcademicDocumentation($data: Json!, $type: DocumentAcademicDocumentationType, $version: String!) {
  saveOneDocumentAcademicDocumentation(
    data: $data
    type: $type
    version: $version
  ) {
    ...DocumentAcademicDocumentationFields
  }
}
    ${DocumentAcademicDocumentationFieldsFragmentDoc}`;
export type SaveOneDocumentAcademicDocumentationMutationFn = Apollo.MutationFunction<SaveOneDocumentAcademicDocumentationMutation, SaveOneDocumentAcademicDocumentationMutationVariables>;

/**
 * __useSaveOneDocumentAcademicDocumentationMutation__
 *
 * To run a mutation, you first call `useSaveOneDocumentAcademicDocumentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveOneDocumentAcademicDocumentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveOneDocumentAcademicDocumentationMutation, { data, loading, error }] = useSaveOneDocumentAcademicDocumentationMutation({
 *   variables: {
 *      data: // value for 'data'
 *      type: // value for 'type'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useSaveOneDocumentAcademicDocumentationMutation(baseOptions?: Apollo.MutationHookOptions<SaveOneDocumentAcademicDocumentationMutation, SaveOneDocumentAcademicDocumentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveOneDocumentAcademicDocumentationMutation, SaveOneDocumentAcademicDocumentationMutationVariables>(SaveOneDocumentAcademicDocumentationDocument, options);
      }
export type SaveOneDocumentAcademicDocumentationMutationHookResult = ReturnType<typeof useSaveOneDocumentAcademicDocumentationMutation>;
export type SaveOneDocumentAcademicDocumentationMutationResult = Apollo.MutationResult<SaveOneDocumentAcademicDocumentationMutation>;
export type SaveOneDocumentAcademicDocumentationMutationOptions = Apollo.BaseMutationOptions<SaveOneDocumentAcademicDocumentationMutation, SaveOneDocumentAcademicDocumentationMutationVariables>;
export const SaveOneCommonUserConfigDocument = gql`
    mutation saveOneCommonUserConfig($data: SaveOneCommonUserConfigInputData!) {
  saveOneCommonUserConfig(data: $data) {
    key
  }
}
    `;
export type SaveOneCommonUserConfigMutationFn = Apollo.MutationFunction<SaveOneCommonUserConfigMutation, SaveOneCommonUserConfigMutationVariables>;

/**
 * __useSaveOneCommonUserConfigMutation__
 *
 * To run a mutation, you first call `useSaveOneCommonUserConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveOneCommonUserConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveOneCommonUserConfigMutation, { data, loading, error }] = useSaveOneCommonUserConfigMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSaveOneCommonUserConfigMutation(baseOptions?: Apollo.MutationHookOptions<SaveOneCommonUserConfigMutation, SaveOneCommonUserConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveOneCommonUserConfigMutation, SaveOneCommonUserConfigMutationVariables>(SaveOneCommonUserConfigDocument, options);
      }
export type SaveOneCommonUserConfigMutationHookResult = ReturnType<typeof useSaveOneCommonUserConfigMutation>;
export type SaveOneCommonUserConfigMutationResult = Apollo.MutationResult<SaveOneCommonUserConfigMutation>;
export type SaveOneCommonUserConfigMutationOptions = Apollo.BaseMutationOptions<SaveOneCommonUserConfigMutation, SaveOneCommonUserConfigMutationVariables>;
export const SaveOneReusableFormDataDocument = gql`
    mutation saveOneReusableFormData($data: Json!, $type: String!, $id: Int) {
  saveOneReusableFormData(data: $data, type: $type, id: $id) {
    id
    data
  }
}
    `;
export type SaveOneReusableFormDataMutationFn = Apollo.MutationFunction<SaveOneReusableFormDataMutation, SaveOneReusableFormDataMutationVariables>;

/**
 * __useSaveOneReusableFormDataMutation__
 *
 * To run a mutation, you first call `useSaveOneReusableFormDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveOneReusableFormDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveOneReusableFormDataMutation, { data, loading, error }] = useSaveOneReusableFormDataMutation({
 *   variables: {
 *      data: // value for 'data'
 *      type: // value for 'type'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSaveOneReusableFormDataMutation(baseOptions?: Apollo.MutationHookOptions<SaveOneReusableFormDataMutation, SaveOneReusableFormDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveOneReusableFormDataMutation, SaveOneReusableFormDataMutationVariables>(SaveOneReusableFormDataDocument, options);
      }
export type SaveOneReusableFormDataMutationHookResult = ReturnType<typeof useSaveOneReusableFormDataMutation>;
export type SaveOneReusableFormDataMutationResult = Apollo.MutationResult<SaveOneReusableFormDataMutation>;
export type SaveOneReusableFormDataMutationOptions = Apollo.BaseMutationOptions<SaveOneReusableFormDataMutation, SaveOneReusableFormDataMutationVariables>;
export const SaveOneDocumentSchoolCurriculumDocument = gql`
    mutation saveOneDocumentSchoolCurriculum($data: Json!, $version: String!) {
  saveOneDocumentSchoolCurriculum(data: $data, version: $version) {
    ...DocumentSchoolCurriculumFields
  }
}
    ${DocumentSchoolCurriculumFieldsFragmentDoc}`;
export type SaveOneDocumentSchoolCurriculumMutationFn = Apollo.MutationFunction<SaveOneDocumentSchoolCurriculumMutation, SaveOneDocumentSchoolCurriculumMutationVariables>;

/**
 * __useSaveOneDocumentSchoolCurriculumMutation__
 *
 * To run a mutation, you first call `useSaveOneDocumentSchoolCurriculumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveOneDocumentSchoolCurriculumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveOneDocumentSchoolCurriculumMutation, { data, loading, error }] = useSaveOneDocumentSchoolCurriculumMutation({
 *   variables: {
 *      data: // value for 'data'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useSaveOneDocumentSchoolCurriculumMutation(baseOptions?: Apollo.MutationHookOptions<SaveOneDocumentSchoolCurriculumMutation, SaveOneDocumentSchoolCurriculumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveOneDocumentSchoolCurriculumMutation, SaveOneDocumentSchoolCurriculumMutationVariables>(SaveOneDocumentSchoolCurriculumDocument, options);
      }
export type SaveOneDocumentSchoolCurriculumMutationHookResult = ReturnType<typeof useSaveOneDocumentSchoolCurriculumMutation>;
export type SaveOneDocumentSchoolCurriculumMutationResult = Apollo.MutationResult<SaveOneDocumentSchoolCurriculumMutation>;
export type SaveOneDocumentSchoolCurriculumMutationOptions = Apollo.BaseMutationOptions<SaveOneDocumentSchoolCurriculumMutation, SaveOneDocumentSchoolCurriculumMutationVariables>;
export const SendActivityDocument = gql`
    mutation sendActivity($input: WatchDocumentInput!) {
  sendActivity(input: $input)
}
    `;
export type SendActivityMutationFn = Apollo.MutationFunction<SendActivityMutation, SendActivityMutationVariables>;

/**
 * __useSendActivityMutation__
 *
 * To run a mutation, you first call `useSendActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendActivityMutation, { data, loading, error }] = useSendActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendActivityMutation(baseOptions?: Apollo.MutationHookOptions<SendActivityMutation, SendActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendActivityMutation, SendActivityMutationVariables>(SendActivityDocument, options);
      }
export type SendActivityMutationHookResult = ReturnType<typeof useSendActivityMutation>;
export type SendActivityMutationResult = Apollo.MutationResult<SendActivityMutation>;
export type SendActivityMutationOptions = Apollo.BaseMutationOptions<SendActivityMutation, SendActivityMutationVariables>;
export const SignOnlyVisualOneSignatureDocument = gql`
    mutation signOnlyVisualOneSignature($inviteId: String!, $signatureImageId: String) {
  signOnlyVisualOneSignature(
    inviteId: $inviteId
    signatureImageId: $signatureImageId
  ) {
    id
  }
}
    `;
export type SignOnlyVisualOneSignatureMutationFn = Apollo.MutationFunction<SignOnlyVisualOneSignatureMutation, SignOnlyVisualOneSignatureMutationVariables>;

/**
 * __useSignOnlyVisualOneSignatureMutation__
 *
 * To run a mutation, you first call `useSignOnlyVisualOneSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignOnlyVisualOneSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signOnlyVisualOneSignatureMutation, { data, loading, error }] = useSignOnlyVisualOneSignatureMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *      signatureImageId: // value for 'signatureImageId'
 *   },
 * });
 */
export function useSignOnlyVisualOneSignatureMutation(baseOptions?: Apollo.MutationHookOptions<SignOnlyVisualOneSignatureMutation, SignOnlyVisualOneSignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignOnlyVisualOneSignatureMutation, SignOnlyVisualOneSignatureMutationVariables>(SignOnlyVisualOneSignatureDocument, options);
      }
export type SignOnlyVisualOneSignatureMutationHookResult = ReturnType<typeof useSignOnlyVisualOneSignatureMutation>;
export type SignOnlyVisualOneSignatureMutationResult = Apollo.MutationResult<SignOnlyVisualOneSignatureMutation>;
export type SignOnlyVisualOneSignatureMutationOptions = Apollo.BaseMutationOptions<SignOnlyVisualOneSignatureMutation, SignOnlyVisualOneSignatureMutationVariables>;
export const SingBulkCertificateVisualRepresentationDocument = gql`
    mutation singBulkCertificateVisualRepresentation($certificateList: [String!]!, $signatureImageId: String, $bulkId: String!) {
  singBulkCertificateVisualRepresentation(
    certificateList: $certificateList
    signatureImageId: $signatureImageId
    bulkId: $bulkId
  ) {
    success
    total
  }
}
    `;
export type SingBulkCertificateVisualRepresentationMutationFn = Apollo.MutationFunction<SingBulkCertificateVisualRepresentationMutation, SingBulkCertificateVisualRepresentationMutationVariables>;

/**
 * __useSingBulkCertificateVisualRepresentationMutation__
 *
 * To run a mutation, you first call `useSingBulkCertificateVisualRepresentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSingBulkCertificateVisualRepresentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [singBulkCertificateVisualRepresentationMutation, { data, loading, error }] = useSingBulkCertificateVisualRepresentationMutation({
 *   variables: {
 *      certificateList: // value for 'certificateList'
 *      signatureImageId: // value for 'signatureImageId'
 *      bulkId: // value for 'bulkId'
 *   },
 * });
 */
export function useSingBulkCertificateVisualRepresentationMutation(baseOptions?: Apollo.MutationHookOptions<SingBulkCertificateVisualRepresentationMutation, SingBulkCertificateVisualRepresentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SingBulkCertificateVisualRepresentationMutation, SingBulkCertificateVisualRepresentationMutationVariables>(SingBulkCertificateVisualRepresentationDocument, options);
      }
export type SingBulkCertificateVisualRepresentationMutationHookResult = ReturnType<typeof useSingBulkCertificateVisualRepresentationMutation>;
export type SingBulkCertificateVisualRepresentationMutationResult = Apollo.MutationResult<SingBulkCertificateVisualRepresentationMutation>;
export type SingBulkCertificateVisualRepresentationMutationOptions = Apollo.BaseMutationOptions<SingBulkCertificateVisualRepresentationMutation, SingBulkCertificateVisualRepresentationMutationVariables>;
export const StartOneCertificateSignatureDocument = gql`
    mutation startOneCertificateSignature($certificate: String!, $inviteId: String!, $signatureImageId: String) {
  startOneCertificateSignature(
    certificate: $certificate
    inviteId: $inviteId
    signatureImageId: $signatureImageId
  ) {
    signingTime
    dataToSign
    lastSignatureIsoString
  }
}
    `;
export type StartOneCertificateSignatureMutationFn = Apollo.MutationFunction<StartOneCertificateSignatureMutation, StartOneCertificateSignatureMutationVariables>;

/**
 * __useStartOneCertificateSignatureMutation__
 *
 * To run a mutation, you first call `useStartOneCertificateSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartOneCertificateSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startOneCertificateSignatureMutation, { data, loading, error }] = useStartOneCertificateSignatureMutation({
 *   variables: {
 *      certificate: // value for 'certificate'
 *      inviteId: // value for 'inviteId'
 *      signatureImageId: // value for 'signatureImageId'
 *   },
 * });
 */
export function useStartOneCertificateSignatureMutation(baseOptions?: Apollo.MutationHookOptions<StartOneCertificateSignatureMutation, StartOneCertificateSignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartOneCertificateSignatureMutation, StartOneCertificateSignatureMutationVariables>(StartOneCertificateSignatureDocument, options);
      }
export type StartOneCertificateSignatureMutationHookResult = ReturnType<typeof useStartOneCertificateSignatureMutation>;
export type StartOneCertificateSignatureMutationResult = Apollo.MutationResult<StartOneCertificateSignatureMutation>;
export type StartOneCertificateSignatureMutationOptions = Apollo.BaseMutationOptions<StartOneCertificateSignatureMutation, StartOneCertificateSignatureMutationVariables>;
export const UpdateOneCertificateCourseDocument = gql`
    mutation updateOneCertificateCourse($areaKnowledge: String!, $certificateId: String!, $metaData: [String!]!, $name: String!, $courseLevelId: String) {
  updateOneCertificateCourse(
    areaKnowledge: $areaKnowledge
    certificateId: $certificateId
    metaData: $metaData
    name: $name
    courseLevelId: $courseLevelId
  ) {
    areaKnowledge
    certificateBaseId
    name
    areaKnowledge
    metaData
  }
}
    `;
export type UpdateOneCertificateCourseMutationFn = Apollo.MutationFunction<UpdateOneCertificateCourseMutation, UpdateOneCertificateCourseMutationVariables>;

/**
 * __useUpdateOneCertificateCourseMutation__
 *
 * To run a mutation, you first call `useUpdateOneCertificateCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneCertificateCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneCertificateCourseMutation, { data, loading, error }] = useUpdateOneCertificateCourseMutation({
 *   variables: {
 *      areaKnowledge: // value for 'areaKnowledge'
 *      certificateId: // value for 'certificateId'
 *      metaData: // value for 'metaData'
 *      name: // value for 'name'
 *      courseLevelId: // value for 'courseLevelId'
 *   },
 * });
 */
export function useUpdateOneCertificateCourseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneCertificateCourseMutation, UpdateOneCertificateCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneCertificateCourseMutation, UpdateOneCertificateCourseMutationVariables>(UpdateOneCertificateCourseDocument, options);
      }
export type UpdateOneCertificateCourseMutationHookResult = ReturnType<typeof useUpdateOneCertificateCourseMutation>;
export type UpdateOneCertificateCourseMutationResult = Apollo.MutationResult<UpdateOneCertificateCourseMutation>;
export type UpdateOneCertificateCourseMutationOptions = Apollo.BaseMutationOptions<UpdateOneCertificateCourseMutation, UpdateOneCertificateCourseMutationVariables>;
export const UpdateOneCertificateCourseLevelDocument = gql`
    mutation updateOneCertificateCourseLevel($certificateBaseId: String!, $name: String!) {
  updateOneCertificateCourseLevel(
    certificateBaseId: $certificateBaseId
    name: $name
  ) {
    certificateBaseId
  }
}
    `;
export type UpdateOneCertificateCourseLevelMutationFn = Apollo.MutationFunction<UpdateOneCertificateCourseLevelMutation, UpdateOneCertificateCourseLevelMutationVariables>;

/**
 * __useUpdateOneCertificateCourseLevelMutation__
 *
 * To run a mutation, you first call `useUpdateOneCertificateCourseLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneCertificateCourseLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneCertificateCourseLevelMutation, { data, loading, error }] = useUpdateOneCertificateCourseLevelMutation({
 *   variables: {
 *      certificateBaseId: // value for 'certificateBaseId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateOneCertificateCourseLevelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneCertificateCourseLevelMutation, UpdateOneCertificateCourseLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneCertificateCourseLevelMutation, UpdateOneCertificateCourseLevelMutationVariables>(UpdateOneCertificateCourseLevelDocument, options);
      }
export type UpdateOneCertificateCourseLevelMutationHookResult = ReturnType<typeof useUpdateOneCertificateCourseLevelMutation>;
export type UpdateOneCertificateCourseLevelMutationResult = Apollo.MutationResult<UpdateOneCertificateCourseLevelMutation>;
export type UpdateOneCertificateCourseLevelMutationOptions = Apollo.BaseMutationOptions<UpdateOneCertificateCourseLevelMutation, UpdateOneCertificateCourseLevelMutationVariables>;
export const UpdateOneCertificateCurriculumDocument = gql`
    mutation updateOneCertificateCurriculum($amountOfHours: Int, $certificateCourseId: String!, $certificateId: String!, $name: String!, $selectedDisciplines: [CirriculumSelectedDiscipline!]!) {
  updateOneCertificateCurriculum(
    amountOfHours: $amountOfHours
    certificateCourseId: $certificateCourseId
    certificateId: $certificateId
    name: $name
    selectedDisciplines: $selectedDisciplines
  ) {
    certificateBaseId
    name
    amountOfHours
  }
}
    `;
export type UpdateOneCertificateCurriculumMutationFn = Apollo.MutationFunction<UpdateOneCertificateCurriculumMutation, UpdateOneCertificateCurriculumMutationVariables>;

/**
 * __useUpdateOneCertificateCurriculumMutation__
 *
 * To run a mutation, you first call `useUpdateOneCertificateCurriculumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneCertificateCurriculumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneCertificateCurriculumMutation, { data, loading, error }] = useUpdateOneCertificateCurriculumMutation({
 *   variables: {
 *      amountOfHours: // value for 'amountOfHours'
 *      certificateCourseId: // value for 'certificateCourseId'
 *      certificateId: // value for 'certificateId'
 *      name: // value for 'name'
 *      selectedDisciplines: // value for 'selectedDisciplines'
 *   },
 * });
 */
export function useUpdateOneCertificateCurriculumMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneCertificateCurriculumMutation, UpdateOneCertificateCurriculumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneCertificateCurriculumMutation, UpdateOneCertificateCurriculumMutationVariables>(UpdateOneCertificateCurriculumDocument, options);
      }
export type UpdateOneCertificateCurriculumMutationHookResult = ReturnType<typeof useUpdateOneCertificateCurriculumMutation>;
export type UpdateOneCertificateCurriculumMutationResult = Apollo.MutationResult<UpdateOneCertificateCurriculumMutation>;
export type UpdateOneCertificateCurriculumMutationOptions = Apollo.BaseMutationOptions<UpdateOneCertificateCurriculumMutation, UpdateOneCertificateCurriculumMutationVariables>;
export const UpdateOneCertificateDisciplineDocument = gql`
    mutation updateOneCertificateDiscipline($certificateId: String!, $name: String!, $viewOnDegree: Boolean!) {
  updateOneCertificateDiscipline(
    certificateId: $certificateId
    name: $name
    viewOnDegree: $viewOnDegree
  ) {
    certificateBaseId
    name
    viewOnDegree
  }
}
    `;
export type UpdateOneCertificateDisciplineMutationFn = Apollo.MutationFunction<UpdateOneCertificateDisciplineMutation, UpdateOneCertificateDisciplineMutationVariables>;

/**
 * __useUpdateOneCertificateDisciplineMutation__
 *
 * To run a mutation, you first call `useUpdateOneCertificateDisciplineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneCertificateDisciplineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneCertificateDisciplineMutation, { data, loading, error }] = useUpdateOneCertificateDisciplineMutation({
 *   variables: {
 *      certificateId: // value for 'certificateId'
 *      name: // value for 'name'
 *      viewOnDegree: // value for 'viewOnDegree'
 *   },
 * });
 */
export function useUpdateOneCertificateDisciplineMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneCertificateDisciplineMutation, UpdateOneCertificateDisciplineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneCertificateDisciplineMutation, UpdateOneCertificateDisciplineMutationVariables>(UpdateOneCertificateDisciplineDocument, options);
      }
export type UpdateOneCertificateDisciplineMutationHookResult = ReturnType<typeof useUpdateOneCertificateDisciplineMutation>;
export type UpdateOneCertificateDisciplineMutationResult = Apollo.MutationResult<UpdateOneCertificateDisciplineMutation>;
export type UpdateOneCertificateDisciplineMutationOptions = Apollo.BaseMutationOptions<UpdateOneCertificateDisciplineMutation, UpdateOneCertificateDisciplineMutationVariables>;
export const UpdateOneCertificateEventDocument = gql`
    mutation updateOneCertificateEvent($certificateId: String!, $name: String!) {
  updateOneCertificateEvent(certificateId: $certificateId, name: $name) {
    certificateBaseId
    name
  }
}
    `;
export type UpdateOneCertificateEventMutationFn = Apollo.MutationFunction<UpdateOneCertificateEventMutation, UpdateOneCertificateEventMutationVariables>;

/**
 * __useUpdateOneCertificateEventMutation__
 *
 * To run a mutation, you first call `useUpdateOneCertificateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneCertificateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneCertificateEventMutation, { data, loading, error }] = useUpdateOneCertificateEventMutation({
 *   variables: {
 *      certificateId: // value for 'certificateId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateOneCertificateEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneCertificateEventMutation, UpdateOneCertificateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneCertificateEventMutation, UpdateOneCertificateEventMutationVariables>(UpdateOneCertificateEventDocument, options);
      }
export type UpdateOneCertificateEventMutationHookResult = ReturnType<typeof useUpdateOneCertificateEventMutation>;
export type UpdateOneCertificateEventMutationResult = Apollo.MutationResult<UpdateOneCertificateEventMutation>;
export type UpdateOneCertificateEventMutationOptions = Apollo.BaseMutationOptions<UpdateOneCertificateEventMutation, UpdateOneCertificateEventMutationVariables>;
export const UpdateOneCertificateTeacherDocument = gql`
    mutation updateOneCertificateTeacher($name: String!, $titration: String!, $certificateId: String!) {
  updateOneCertificateTeacher(
    name: $name
    titration: $titration
    certificateId: $certificateId
  ) {
    certificateBaseId
    name
    titration
  }
}
    `;
export type UpdateOneCertificateTeacherMutationFn = Apollo.MutationFunction<UpdateOneCertificateTeacherMutation, UpdateOneCertificateTeacherMutationVariables>;

/**
 * __useUpdateOneCertificateTeacherMutation__
 *
 * To run a mutation, you first call `useUpdateOneCertificateTeacherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneCertificateTeacherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneCertificateTeacherMutation, { data, loading, error }] = useUpdateOneCertificateTeacherMutation({
 *   variables: {
 *      name: // value for 'name'
 *      titration: // value for 'titration'
 *      certificateId: // value for 'certificateId'
 *   },
 * });
 */
export function useUpdateOneCertificateTeacherMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneCertificateTeacherMutation, UpdateOneCertificateTeacherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneCertificateTeacherMutation, UpdateOneCertificateTeacherMutationVariables>(UpdateOneCertificateTeacherDocument, options);
      }
export type UpdateOneCertificateTeacherMutationHookResult = ReturnType<typeof useUpdateOneCertificateTeacherMutation>;
export type UpdateOneCertificateTeacherMutationResult = Apollo.MutationResult<UpdateOneCertificateTeacherMutation>;
export type UpdateOneCertificateTeacherMutationOptions = Apollo.BaseMutationOptions<UpdateOneCertificateTeacherMutation, UpdateOneCertificateTeacherMutationVariables>;
export const UpdateOneCertificateTemplateDocument = gql`
    mutation updateOneCertificateTemplate($data: CertificateTemplateUpdateInput!, $where: CertificateTemplateWhereUniqueInput!) {
  updateOneCertificateTemplate(data: $data, where: $where) {
    id
  }
}
    `;
export type UpdateOneCertificateTemplateMutationFn = Apollo.MutationFunction<UpdateOneCertificateTemplateMutation, UpdateOneCertificateTemplateMutationVariables>;

/**
 * __useUpdateOneCertificateTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateOneCertificateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneCertificateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneCertificateTemplateMutation, { data, loading, error }] = useUpdateOneCertificateTemplateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateOneCertificateTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneCertificateTemplateMutation, UpdateOneCertificateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneCertificateTemplateMutation, UpdateOneCertificateTemplateMutationVariables>(UpdateOneCertificateTemplateDocument, options);
      }
export type UpdateOneCertificateTemplateMutationHookResult = ReturnType<typeof useUpdateOneCertificateTemplateMutation>;
export type UpdateOneCertificateTemplateMutationResult = Apollo.MutationResult<UpdateOneCertificateTemplateMutation>;
export type UpdateOneCertificateTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateOneCertificateTemplateMutation, UpdateOneCertificateTemplateMutationVariables>;
export const UpdateOnePersonDocument = gql`
    mutation updateOnePerson($isForeign: Boolean!, $phones: [String!]!, $receivesCertificateEmail: Boolean!, $receivesCertificateWhatsapp: Boolean!, $address: AddressInput, $birthDate: String, $cpf: String, $email: String, $id: String, $identityDocument: String, $passport: String, $name: String!) {
  updateOnePerson(
    isForeign: $isForeign
    phones: $phones
    receivesCertificateEmail: $receivesCertificateEmail
    receivesCertificateWhatsapp: $receivesCertificateWhatsapp
    address: $address
    birthDate: $birthDate
    cpf: $cpf
    email: $email
    id: $id
    identityDocument: $identityDocument
    passport: $passport
    name: $name
  ) {
    id
    name
  }
}
    `;
export type UpdateOnePersonMutationFn = Apollo.MutationFunction<UpdateOnePersonMutation, UpdateOnePersonMutationVariables>;

/**
 * __useUpdateOnePersonMutation__
 *
 * To run a mutation, you first call `useUpdateOnePersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOnePersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOnePersonMutation, { data, loading, error }] = useUpdateOnePersonMutation({
 *   variables: {
 *      isForeign: // value for 'isForeign'
 *      phones: // value for 'phones'
 *      receivesCertificateEmail: // value for 'receivesCertificateEmail'
 *      receivesCertificateWhatsapp: // value for 'receivesCertificateWhatsapp'
 *      address: // value for 'address'
 *      birthDate: // value for 'birthDate'
 *      cpf: // value for 'cpf'
 *      email: // value for 'email'
 *      id: // value for 'id'
 *      identityDocument: // value for 'identityDocument'
 *      passport: // value for 'passport'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateOnePersonMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOnePersonMutation, UpdateOnePersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOnePersonMutation, UpdateOnePersonMutationVariables>(UpdateOnePersonDocument, options);
      }
export type UpdateOnePersonMutationHookResult = ReturnType<typeof useUpdateOnePersonMutation>;
export type UpdateOnePersonMutationResult = Apollo.MutationResult<UpdateOnePersonMutation>;
export type UpdateOnePersonMutationOptions = Apollo.BaseMutationOptions<UpdateOnePersonMutation, UpdateOnePersonMutationVariables>;
export const UpdateOneReusableFormDataCurriculumDocument = gql`
    mutation updateOneReusableFormDataCurriculum($data: ReusableFormDataCurriculumCreateInputCustom!, $where: ReusableFormDataCurriculumWhereUniqueInput!) {
  updateOneReusableFormDataCurriculum(data: $data, where: $where) {
    id
  }
}
    `;
export type UpdateOneReusableFormDataCurriculumMutationFn = Apollo.MutationFunction<UpdateOneReusableFormDataCurriculumMutation, UpdateOneReusableFormDataCurriculumMutationVariables>;

/**
 * __useUpdateOneReusableFormDataCurriculumMutation__
 *
 * To run a mutation, you first call `useUpdateOneReusableFormDataCurriculumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneReusableFormDataCurriculumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneReusableFormDataCurriculumMutation, { data, loading, error }] = useUpdateOneReusableFormDataCurriculumMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateOneReusableFormDataCurriculumMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneReusableFormDataCurriculumMutation, UpdateOneReusableFormDataCurriculumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneReusableFormDataCurriculumMutation, UpdateOneReusableFormDataCurriculumMutationVariables>(UpdateOneReusableFormDataCurriculumDocument, options);
      }
export type UpdateOneReusableFormDataCurriculumMutationHookResult = ReturnType<typeof useUpdateOneReusableFormDataCurriculumMutation>;
export type UpdateOneReusableFormDataCurriculumMutationResult = Apollo.MutationResult<UpdateOneReusableFormDataCurriculumMutation>;
export type UpdateOneReusableFormDataCurriculumMutationOptions = Apollo.BaseMutationOptions<UpdateOneReusableFormDataCurriculumMutation, UpdateOneReusableFormDataCurriculumMutationVariables>;
export const UpdateOneSystemGlobalAlertDocument = gql`
    mutation updateOneSystemGlobalAlert($data: SystemGlobalAlertUpdateInput!, $where: SystemGlobalAlertWhereUniqueInput!) {
  updateOneSystemGlobalAlert(data: $data, where: $where) {
    id
  }
}
    `;
export type UpdateOneSystemGlobalAlertMutationFn = Apollo.MutationFunction<UpdateOneSystemGlobalAlertMutation, UpdateOneSystemGlobalAlertMutationVariables>;

/**
 * __useUpdateOneSystemGlobalAlertMutation__
 *
 * To run a mutation, you first call `useUpdateOneSystemGlobalAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneSystemGlobalAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneSystemGlobalAlertMutation, { data, loading, error }] = useUpdateOneSystemGlobalAlertMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateOneSystemGlobalAlertMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneSystemGlobalAlertMutation, UpdateOneSystemGlobalAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneSystemGlobalAlertMutation, UpdateOneSystemGlobalAlertMutationVariables>(UpdateOneSystemGlobalAlertDocument, options);
      }
export type UpdateOneSystemGlobalAlertMutationHookResult = ReturnType<typeof useUpdateOneSystemGlobalAlertMutation>;
export type UpdateOneSystemGlobalAlertMutationResult = Apollo.MutationResult<UpdateOneSystemGlobalAlertMutation>;
export type UpdateOneSystemGlobalAlertMutationOptions = Apollo.BaseMutationOptions<UpdateOneSystemGlobalAlertMutation, UpdateOneSystemGlobalAlertMutationVariables>;
export const UpdateOneTeamDocument = gql`
    mutation updateOneTeam($data: UpdateOneTeamData!) {
  updateOneTeam(data: $data) {
    cnpj
    id
    TeamEducationLevel {
      educationLevelType
    }
  }
}
    `;
export type UpdateOneTeamMutationFn = Apollo.MutationFunction<UpdateOneTeamMutation, UpdateOneTeamMutationVariables>;

/**
 * __useUpdateOneTeamMutation__
 *
 * To run a mutation, you first call `useUpdateOneTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneTeamMutation, { data, loading, error }] = useUpdateOneTeamMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOneTeamMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneTeamMutation, UpdateOneTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneTeamMutation, UpdateOneTeamMutationVariables>(UpdateOneTeamDocument, options);
      }
export type UpdateOneTeamMutationHookResult = ReturnType<typeof useUpdateOneTeamMutation>;
export type UpdateOneTeamMutationResult = Apollo.MutationResult<UpdateOneTeamMutation>;
export type UpdateOneTeamMutationOptions = Apollo.BaseMutationOptions<UpdateOneTeamMutation, UpdateOneTeamMutationVariables>;
export const UpdateOneTeamMemberDocument = gql`
    mutation updateOneTeamMember($updateOneTeamMemberId: Int!, $permissions: [String!], $role: String) {
  updateOneTeamMember(
    id: $updateOneTeamMemberId
    permissions: $permissions
    role: $role
  ) {
    id
    User {
      id
    }
  }
}
    `;
export type UpdateOneTeamMemberMutationFn = Apollo.MutationFunction<UpdateOneTeamMemberMutation, UpdateOneTeamMemberMutationVariables>;

/**
 * __useUpdateOneTeamMemberMutation__
 *
 * To run a mutation, you first call `useUpdateOneTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneTeamMemberMutation, { data, loading, error }] = useUpdateOneTeamMemberMutation({
 *   variables: {
 *      updateOneTeamMemberId: // value for 'updateOneTeamMemberId'
 *      permissions: // value for 'permissions'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUpdateOneTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneTeamMemberMutation, UpdateOneTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneTeamMemberMutation, UpdateOneTeamMemberMutationVariables>(UpdateOneTeamMemberDocument, options);
      }
export type UpdateOneTeamMemberMutationHookResult = ReturnType<typeof useUpdateOneTeamMemberMutation>;
export type UpdateOneTeamMemberMutationResult = Apollo.MutationResult<UpdateOneTeamMemberMutation>;
export type UpdateOneTeamMemberMutationOptions = Apollo.BaseMutationOptions<UpdateOneTeamMemberMutation, UpdateOneTeamMemberMutationVariables>;
export const UpdateTeamActivationStatusDocument = gql`
    mutation updateTeamActivationStatus($data: updateTeamActivationStatusArgs!) {
  updateTeamActivationStatus(data: $data) {
    id
    isActive
  }
}
    `;
export type UpdateTeamActivationStatusMutationFn = Apollo.MutationFunction<UpdateTeamActivationStatusMutation, UpdateTeamActivationStatusMutationVariables>;

/**
 * __useUpdateTeamActivationStatusMutation__
 *
 * To run a mutation, you first call `useUpdateTeamActivationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamActivationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamActivationStatusMutation, { data, loading, error }] = useUpdateTeamActivationStatusMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTeamActivationStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamActivationStatusMutation, UpdateTeamActivationStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamActivationStatusMutation, UpdateTeamActivationStatusMutationVariables>(UpdateTeamActivationStatusDocument, options);
      }
export type UpdateTeamActivationStatusMutationHookResult = ReturnType<typeof useUpdateTeamActivationStatusMutation>;
export type UpdateTeamActivationStatusMutationResult = Apollo.MutationResult<UpdateTeamActivationStatusMutation>;
export type UpdateTeamActivationStatusMutationOptions = Apollo.BaseMutationOptions<UpdateTeamActivationStatusMutation, UpdateTeamActivationStatusMutationVariables>;
export const UpdateTeamConfigAddDocumentSignerNodeDocument = gql`
    mutation updateTeamConfigAddDocumentSignerNode($addSigners: Boolean!) {
  updateTeamConfigAddDocumentSignerNode(addSigners: $addSigners) {
    id
  }
}
    `;
export type UpdateTeamConfigAddDocumentSignerNodeMutationFn = Apollo.MutationFunction<UpdateTeamConfigAddDocumentSignerNodeMutation, UpdateTeamConfigAddDocumentSignerNodeMutationVariables>;

/**
 * __useUpdateTeamConfigAddDocumentSignerNodeMutation__
 *
 * To run a mutation, you first call `useUpdateTeamConfigAddDocumentSignerNodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamConfigAddDocumentSignerNodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamConfigAddDocumentSignerNodeMutation, { data, loading, error }] = useUpdateTeamConfigAddDocumentSignerNodeMutation({
 *   variables: {
 *      addSigners: // value for 'addSigners'
 *   },
 * });
 */
export function useUpdateTeamConfigAddDocumentSignerNodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamConfigAddDocumentSignerNodeMutation, UpdateTeamConfigAddDocumentSignerNodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamConfigAddDocumentSignerNodeMutation, UpdateTeamConfigAddDocumentSignerNodeMutationVariables>(UpdateTeamConfigAddDocumentSignerNodeDocument, options);
      }
export type UpdateTeamConfigAddDocumentSignerNodeMutationHookResult = ReturnType<typeof useUpdateTeamConfigAddDocumentSignerNodeMutation>;
export type UpdateTeamConfigAddDocumentSignerNodeMutationResult = Apollo.MutationResult<UpdateTeamConfigAddDocumentSignerNodeMutation>;
export type UpdateTeamConfigAddDocumentSignerNodeMutationOptions = Apollo.BaseMutationOptions<UpdateTeamConfigAddDocumentSignerNodeMutation, UpdateTeamConfigAddDocumentSignerNodeMutationVariables>;
export const UpsertDocumentBaseDefaultSignatureInviteConfigurationDocument = gql`
    mutation upsertDocumentBaseDefaultSignatureInviteConfiguration($data: UpsertDocumentBaseDefaultSignatureInviteConfigurationInput!) {
  upsertDocumentBaseDefaultSignatureInviteConfiguration(data: $data) {
    id
  }
}
    `;
export type UpsertDocumentBaseDefaultSignatureInviteConfigurationMutationFn = Apollo.MutationFunction<UpsertDocumentBaseDefaultSignatureInviteConfigurationMutation, UpsertDocumentBaseDefaultSignatureInviteConfigurationMutationVariables>;

/**
 * __useUpsertDocumentBaseDefaultSignatureInviteConfigurationMutation__
 *
 * To run a mutation, you first call `useUpsertDocumentBaseDefaultSignatureInviteConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDocumentBaseDefaultSignatureInviteConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDocumentBaseDefaultSignatureInviteConfigurationMutation, { data, loading, error }] = useUpsertDocumentBaseDefaultSignatureInviteConfigurationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpsertDocumentBaseDefaultSignatureInviteConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<UpsertDocumentBaseDefaultSignatureInviteConfigurationMutation, UpsertDocumentBaseDefaultSignatureInviteConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertDocumentBaseDefaultSignatureInviteConfigurationMutation, UpsertDocumentBaseDefaultSignatureInviteConfigurationMutationVariables>(UpsertDocumentBaseDefaultSignatureInviteConfigurationDocument, options);
      }
export type UpsertDocumentBaseDefaultSignatureInviteConfigurationMutationHookResult = ReturnType<typeof useUpsertDocumentBaseDefaultSignatureInviteConfigurationMutation>;
export type UpsertDocumentBaseDefaultSignatureInviteConfigurationMutationResult = Apollo.MutationResult<UpsertDocumentBaseDefaultSignatureInviteConfigurationMutation>;
export type UpsertDocumentBaseDefaultSignatureInviteConfigurationMutationOptions = Apollo.BaseMutationOptions<UpsertDocumentBaseDefaultSignatureInviteConfigurationMutation, UpsertDocumentBaseDefaultSignatureInviteConfigurationMutationVariables>;
export const UpsertOneTemporarySignatureImageDocument = gql`
    mutation upsertOneTemporarySignatureImage($description: String!) {
  upsertOneTemporarySignatureImage(description: $description) {
    ...SignSignatureImageUniqueFields
  }
}
    ${SignSignatureImageUniqueFieldsFragmentDoc}`;
export type UpsertOneTemporarySignatureImageMutationFn = Apollo.MutationFunction<UpsertOneTemporarySignatureImageMutation, UpsertOneTemporarySignatureImageMutationVariables>;

/**
 * __useUpsertOneTemporarySignatureImageMutation__
 *
 * To run a mutation, you first call `useUpsertOneTemporarySignatureImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertOneTemporarySignatureImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertOneTemporarySignatureImageMutation, { data, loading, error }] = useUpsertOneTemporarySignatureImageMutation({
 *   variables: {
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpsertOneTemporarySignatureImageMutation(baseOptions?: Apollo.MutationHookOptions<UpsertOneTemporarySignatureImageMutation, UpsertOneTemporarySignatureImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertOneTemporarySignatureImageMutation, UpsertOneTemporarySignatureImageMutationVariables>(UpsertOneTemporarySignatureImageDocument, options);
      }
export type UpsertOneTemporarySignatureImageMutationHookResult = ReturnType<typeof useUpsertOneTemporarySignatureImageMutation>;
export type UpsertOneTemporarySignatureImageMutationResult = Apollo.MutationResult<UpsertOneTemporarySignatureImageMutation>;
export type UpsertOneTemporarySignatureImageMutationOptions = Apollo.BaseMutationOptions<UpsertOneTemporarySignatureImageMutation, UpsertOneTemporarySignatureImageMutationVariables>;
export const ValidateOnePdfaDocument = gql`
    mutation validateOnePdfa($base64: String!) {
  validateOnePdfa(base64: $base64)
}
    `;
export type ValidateOnePdfaMutationFn = Apollo.MutationFunction<ValidateOnePdfaMutation, ValidateOnePdfaMutationVariables>;

/**
 * __useValidateOnePdfaMutation__
 *
 * To run a mutation, you first call `useValidateOnePdfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateOnePdfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateOnePdfaMutation, { data, loading, error }] = useValidateOnePdfaMutation({
 *   variables: {
 *      base64: // value for 'base64'
 *   },
 * });
 */
export function useValidateOnePdfaMutation(baseOptions?: Apollo.MutationHookOptions<ValidateOnePdfaMutation, ValidateOnePdfaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateOnePdfaMutation, ValidateOnePdfaMutationVariables>(ValidateOnePdfaDocument, options);
      }
export type ValidateOnePdfaMutationHookResult = ReturnType<typeof useValidateOnePdfaMutation>;
export type ValidateOnePdfaMutationResult = Apollo.MutationResult<ValidateOnePdfaMutation>;
export type ValidateOnePdfaMutationOptions = Apollo.BaseMutationOptions<ValidateOnePdfaMutation, ValidateOnePdfaMutationVariables>;
export const CountDocumentBaseByTypeDocument = gql`
    query countDocumentBaseByType($where: DocumentBaseWhereInput!) {
  count: countDocumentBaseByType(where: $where)
}
    `;

/**
 * __useCountDocumentBaseByTypeQuery__
 *
 * To run a query within a React component, call `useCountDocumentBaseByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountDocumentBaseByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountDocumentBaseByTypeQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountDocumentBaseByTypeQuery(baseOptions: Apollo.QueryHookOptions<CountDocumentBaseByTypeQuery, CountDocumentBaseByTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountDocumentBaseByTypeQuery, CountDocumentBaseByTypeQueryVariables>(CountDocumentBaseByTypeDocument, options);
      }
export function useCountDocumentBaseByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountDocumentBaseByTypeQuery, CountDocumentBaseByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountDocumentBaseByTypeQuery, CountDocumentBaseByTypeQueryVariables>(CountDocumentBaseByTypeDocument, options);
        }
export type CountDocumentBaseByTypeQueryHookResult = ReturnType<typeof useCountDocumentBaseByTypeQuery>;
export type CountDocumentBaseByTypeLazyQueryHookResult = ReturnType<typeof useCountDocumentBaseByTypeLazyQuery>;
export type CountDocumentBaseByTypeQueryResult = Apollo.QueryResult<CountDocumentBaseByTypeQuery, CountDocumentBaseByTypeQueryVariables>;
export const CreateOneMaintainerTeamDocument = gql`
    mutation createOneMaintainerTeam($cnpj: String!, $educationLevelType: [EducationLevelType!]!, $placeholderName: String!) {
  createOneMaintainerTeam(
    CNPJ: $cnpj
    educationLevelType: $educationLevelType
    placeholderName: $placeholderName
  ) {
    id
    cnpj
  }
}
    `;
export type CreateOneMaintainerTeamMutationFn = Apollo.MutationFunction<CreateOneMaintainerTeamMutation, CreateOneMaintainerTeamMutationVariables>;

/**
 * __useCreateOneMaintainerTeamMutation__
 *
 * To run a mutation, you first call `useCreateOneMaintainerTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneMaintainerTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneMaintainerTeamMutation, { data, loading, error }] = useCreateOneMaintainerTeamMutation({
 *   variables: {
 *      cnpj: // value for 'cnpj'
 *      educationLevelType: // value for 'educationLevelType'
 *      placeholderName: // value for 'placeholderName'
 *   },
 * });
 */
export function useCreateOneMaintainerTeamMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneMaintainerTeamMutation, CreateOneMaintainerTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneMaintainerTeamMutation, CreateOneMaintainerTeamMutationVariables>(CreateOneMaintainerTeamDocument, options);
      }
export type CreateOneMaintainerTeamMutationHookResult = ReturnType<typeof useCreateOneMaintainerTeamMutation>;
export type CreateOneMaintainerTeamMutationResult = Apollo.MutationResult<CreateOneMaintainerTeamMutation>;
export type CreateOneMaintainerTeamMutationOptions = Apollo.BaseMutationOptions<CreateOneMaintainerTeamMutation, CreateOneMaintainerTeamMutationVariables>;
export const FindFirstDocumentAcademicDocumentationDocument = gql`
    query findFirstDocumentAcademicDocumentation($where: DocumentAcademicDocumentationWhereInput!) {
  findFirstDocumentAcademicDocumentation(where: $where) {
    ...DocumentAcademicDocumentationFields
  }
}
    ${DocumentAcademicDocumentationFieldsFragmentDoc}`;

/**
 * __useFindFirstDocumentAcademicDocumentationQuery__
 *
 * To run a query within a React component, call `useFindFirstDocumentAcademicDocumentationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindFirstDocumentAcademicDocumentationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindFirstDocumentAcademicDocumentationQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindFirstDocumentAcademicDocumentationQuery(baseOptions: Apollo.QueryHookOptions<FindFirstDocumentAcademicDocumentationQuery, FindFirstDocumentAcademicDocumentationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindFirstDocumentAcademicDocumentationQuery, FindFirstDocumentAcademicDocumentationQueryVariables>(FindFirstDocumentAcademicDocumentationDocument, options);
      }
export function useFindFirstDocumentAcademicDocumentationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindFirstDocumentAcademicDocumentationQuery, FindFirstDocumentAcademicDocumentationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindFirstDocumentAcademicDocumentationQuery, FindFirstDocumentAcademicDocumentationQueryVariables>(FindFirstDocumentAcademicDocumentationDocument, options);
        }
export type FindFirstDocumentAcademicDocumentationQueryHookResult = ReturnType<typeof useFindFirstDocumentAcademicDocumentationQuery>;
export type FindFirstDocumentAcademicDocumentationLazyQueryHookResult = ReturnType<typeof useFindFirstDocumentAcademicDocumentationLazyQuery>;
export type FindFirstDocumentAcademicDocumentationQueryResult = Apollo.QueryResult<FindFirstDocumentAcademicDocumentationQuery, FindFirstDocumentAcademicDocumentationQueryVariables>;
export const FindFirstDocumentBaseSignatureInviteDocument = gql`
    query findFirstDocumentBaseSignatureInvite($where: DocumentBaseSignatureInviteWhereInput) {
  findFirstDocumentBaseSignatureInvite(where: $where) {
    ...DocumentBaseSignatureInviteFields
  }
}
    ${DocumentBaseSignatureInviteFieldsFragmentDoc}`;

/**
 * __useFindFirstDocumentBaseSignatureInviteQuery__
 *
 * To run a query within a React component, call `useFindFirstDocumentBaseSignatureInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindFirstDocumentBaseSignatureInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindFirstDocumentBaseSignatureInviteQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindFirstDocumentBaseSignatureInviteQuery(baseOptions?: Apollo.QueryHookOptions<FindFirstDocumentBaseSignatureInviteQuery, FindFirstDocumentBaseSignatureInviteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindFirstDocumentBaseSignatureInviteQuery, FindFirstDocumentBaseSignatureInviteQueryVariables>(FindFirstDocumentBaseSignatureInviteDocument, options);
      }
export function useFindFirstDocumentBaseSignatureInviteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindFirstDocumentBaseSignatureInviteQuery, FindFirstDocumentBaseSignatureInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindFirstDocumentBaseSignatureInviteQuery, FindFirstDocumentBaseSignatureInviteQueryVariables>(FindFirstDocumentBaseSignatureInviteDocument, options);
        }
export type FindFirstDocumentBaseSignatureInviteQueryHookResult = ReturnType<typeof useFindFirstDocumentBaseSignatureInviteQuery>;
export type FindFirstDocumentBaseSignatureInviteLazyQueryHookResult = ReturnType<typeof useFindFirstDocumentBaseSignatureInviteLazyQuery>;
export type FindFirstDocumentBaseSignatureInviteQueryResult = Apollo.QueryResult<FindFirstDocumentBaseSignatureInviteQuery, FindFirstDocumentBaseSignatureInviteQueryVariables>;
export const FindFirstDocumentDegreeDocument = gql`
    query findFirstDocumentDegree($where: DocumentDegreeWhereInput!) {
  findFirstDocumentDegree(where: $where) {
    ...DocumentDegreeUniqueFields
  }
}
    ${DocumentDegreeUniqueFieldsFragmentDoc}`;

/**
 * __useFindFirstDocumentDegreeQuery__
 *
 * To run a query within a React component, call `useFindFirstDocumentDegreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindFirstDocumentDegreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindFirstDocumentDegreeQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindFirstDocumentDegreeQuery(baseOptions: Apollo.QueryHookOptions<FindFirstDocumentDegreeQuery, FindFirstDocumentDegreeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindFirstDocumentDegreeQuery, FindFirstDocumentDegreeQueryVariables>(FindFirstDocumentDegreeDocument, options);
      }
export function useFindFirstDocumentDegreeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindFirstDocumentDegreeQuery, FindFirstDocumentDegreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindFirstDocumentDegreeQuery, FindFirstDocumentDegreeQueryVariables>(FindFirstDocumentDegreeDocument, options);
        }
export type FindFirstDocumentDegreeQueryHookResult = ReturnType<typeof useFindFirstDocumentDegreeQuery>;
export type FindFirstDocumentDegreeLazyQueryHookResult = ReturnType<typeof useFindFirstDocumentDegreeLazyQuery>;
export type FindFirstDocumentDegreeQueryResult = Apollo.QueryResult<FindFirstDocumentDegreeQuery, FindFirstDocumentDegreeQueryVariables>;
export const FindFirstReusableFormDataDocument = gql`
    query findFirstReusableFormData($where: ReusableFormDataWhereInput) {
  findFirstReusableFormData(where: $where) {
    id
    createdAt
    data
    type
  }
}
    `;

/**
 * __useFindFirstReusableFormDataQuery__
 *
 * To run a query within a React component, call `useFindFirstReusableFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindFirstReusableFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindFirstReusableFormDataQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindFirstReusableFormDataQuery(baseOptions?: Apollo.QueryHookOptions<FindFirstReusableFormDataQuery, FindFirstReusableFormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindFirstReusableFormDataQuery, FindFirstReusableFormDataQueryVariables>(FindFirstReusableFormDataDocument, options);
      }
export function useFindFirstReusableFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindFirstReusableFormDataQuery, FindFirstReusableFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindFirstReusableFormDataQuery, FindFirstReusableFormDataQueryVariables>(FindFirstReusableFormDataDocument, options);
        }
export type FindFirstReusableFormDataQueryHookResult = ReturnType<typeof useFindFirstReusableFormDataQuery>;
export type FindFirstReusableFormDataLazyQueryHookResult = ReturnType<typeof useFindFirstReusableFormDataLazyQuery>;
export type FindFirstReusableFormDataQueryResult = Apollo.QueryResult<FindFirstReusableFormDataQuery, FindFirstReusableFormDataQueryVariables>;
export const FindFirstTeamMemberDocument = gql`
    query findFirstTeamMember($where: TeamMemberWhereInput) {
  findFirstTeamMember(where: $where) {
    ...TeamMemberFields
  }
}
    ${TeamMemberFieldsFragmentDoc}`;

/**
 * __useFindFirstTeamMemberQuery__
 *
 * To run a query within a React component, call `useFindFirstTeamMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindFirstTeamMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindFirstTeamMemberQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindFirstTeamMemberQuery(baseOptions?: Apollo.QueryHookOptions<FindFirstTeamMemberQuery, FindFirstTeamMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindFirstTeamMemberQuery, FindFirstTeamMemberQueryVariables>(FindFirstTeamMemberDocument, options);
      }
export function useFindFirstTeamMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindFirstTeamMemberQuery, FindFirstTeamMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindFirstTeamMemberQuery, FindFirstTeamMemberQueryVariables>(FindFirstTeamMemberDocument, options);
        }
export type FindFirstTeamMemberQueryHookResult = ReturnType<typeof useFindFirstTeamMemberQuery>;
export type FindFirstTeamMemberLazyQueryHookResult = ReturnType<typeof useFindFirstTeamMemberLazyQuery>;
export type FindFirstTeamMemberQueryResult = Apollo.QueryResult<FindFirstTeamMemberQuery, FindFirstTeamMemberQueryVariables>;
export const FindManyDocumentAcademicDocumentationDocument = gql`
    query findManyDocumentAcademicDocumentation($take: Int, $orderBy: [DocumentAcademicDocumentationOrderByWithRelationInput!], $skip: Int, $where: DocumentAcademicDocumentationWhereInput) {
  findManyDocumentAcademicDocumentation(
    take: $take
    orderBy: $orderBy
    skip: $skip
    where: $where
  ) {
    documentBaseId
    status
    type
    searchStudentName
    searchCPF
    searchCourse
    searchEmecCode
    DocumentBase {
      internalSeqId
      version
      createdAt
    }
  }
  count: countDocumentAcademicDocumentation(where: $where)
}
    `;

/**
 * __useFindManyDocumentAcademicDocumentationQuery__
 *
 * To run a query within a React component, call `useFindManyDocumentAcademicDocumentationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyDocumentAcademicDocumentationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyDocumentAcademicDocumentationQuery({
 *   variables: {
 *      take: // value for 'take'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindManyDocumentAcademicDocumentationQuery(baseOptions?: Apollo.QueryHookOptions<FindManyDocumentAcademicDocumentationQuery, FindManyDocumentAcademicDocumentationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyDocumentAcademicDocumentationQuery, FindManyDocumentAcademicDocumentationQueryVariables>(FindManyDocumentAcademicDocumentationDocument, options);
      }
export function useFindManyDocumentAcademicDocumentationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyDocumentAcademicDocumentationQuery, FindManyDocumentAcademicDocumentationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyDocumentAcademicDocumentationQuery, FindManyDocumentAcademicDocumentationQueryVariables>(FindManyDocumentAcademicDocumentationDocument, options);
        }
export type FindManyDocumentAcademicDocumentationQueryHookResult = ReturnType<typeof useFindManyDocumentAcademicDocumentationQuery>;
export type FindManyDocumentAcademicDocumentationLazyQueryHookResult = ReturnType<typeof useFindManyDocumentAcademicDocumentationLazyQuery>;
export type FindManyDocumentAcademicDocumentationQueryResult = Apollo.QueryResult<FindManyDocumentAcademicDocumentationQuery, FindManyDocumentAcademicDocumentationQueryVariables>;
export const FindManyDocumentBaseSignatureInviteDocument = gql`
    query findManyDocumentBaseSignatureInvite($where: DocumentBaseSignatureInviteWhereInput, $take: Int, $skip: Int, $orderBy: [DocumentBaseSignatureInviteOrderByWithRelationInput!]) {
  findManyDocumentBaseSignatureInvite(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    ...DocumentBaseSignatureInviteFields
  }
  count: countDocumentBaseSignatureInvite(where: $where)
}
    ${DocumentBaseSignatureInviteFieldsFragmentDoc}`;

/**
 * __useFindManyDocumentBaseSignatureInviteQuery__
 *
 * To run a query within a React component, call `useFindManyDocumentBaseSignatureInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyDocumentBaseSignatureInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyDocumentBaseSignatureInviteQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyDocumentBaseSignatureInviteQuery(baseOptions?: Apollo.QueryHookOptions<FindManyDocumentBaseSignatureInviteQuery, FindManyDocumentBaseSignatureInviteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyDocumentBaseSignatureInviteQuery, FindManyDocumentBaseSignatureInviteQueryVariables>(FindManyDocumentBaseSignatureInviteDocument, options);
      }
export function useFindManyDocumentBaseSignatureInviteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyDocumentBaseSignatureInviteQuery, FindManyDocumentBaseSignatureInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyDocumentBaseSignatureInviteQuery, FindManyDocumentBaseSignatureInviteQueryVariables>(FindManyDocumentBaseSignatureInviteDocument, options);
        }
export type FindManyDocumentBaseSignatureInviteQueryHookResult = ReturnType<typeof useFindManyDocumentBaseSignatureInviteQuery>;
export type FindManyDocumentBaseSignatureInviteLazyQueryHookResult = ReturnType<typeof useFindManyDocumentBaseSignatureInviteLazyQuery>;
export type FindManyDocumentBaseSignatureInviteQueryResult = Apollo.QueryResult<FindManyDocumentBaseSignatureInviteQuery, FindManyDocumentBaseSignatureInviteQueryVariables>;
export const FindManyApiKeyDocument = gql`
    query findManyApiKey($where: ApiKeyWhereInput, $take: Int, $skip: Int, $orderBy: [ApiKeyOrderByWithRelationInput!]) {
  findManyApiKey(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
    id
    description
    createdAt
  }
  count: countApiKey(where: $where)
}
    `;

/**
 * __useFindManyApiKeyQuery__
 *
 * To run a query within a React component, call `useFindManyApiKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyApiKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyApiKeyQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyApiKeyQuery(baseOptions?: Apollo.QueryHookOptions<FindManyApiKeyQuery, FindManyApiKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyApiKeyQuery, FindManyApiKeyQueryVariables>(FindManyApiKeyDocument, options);
      }
export function useFindManyApiKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyApiKeyQuery, FindManyApiKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyApiKeyQuery, FindManyApiKeyQueryVariables>(FindManyApiKeyDocument, options);
        }
export type FindManyApiKeyQueryHookResult = ReturnType<typeof useFindManyApiKeyQuery>;
export type FindManyApiKeyLazyQueryHookResult = ReturnType<typeof useFindManyApiKeyLazyQuery>;
export type FindManyApiKeyQueryResult = Apollo.QueryResult<FindManyApiKeyQuery, FindManyApiKeyQueryVariables>;
export const FindManyBulkCertificateRecordDocument = gql`
    query findManyBulkCertificateRecord($where: BulkCertificateRecordWhereInput, $take: Int, $skip: Int, $orderBy: [BulkCertificateRecordOrderByWithRelationInput!]) {
  findManyBulkCertificateRecord(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    id
    bulkCertificateRecordName
    totalCertificates
    createdAt
  }
  count: countBulkCertificateRecord(where: $where)
}
    `;

/**
 * __useFindManyBulkCertificateRecordQuery__
 *
 * To run a query within a React component, call `useFindManyBulkCertificateRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyBulkCertificateRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyBulkCertificateRecordQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyBulkCertificateRecordQuery(baseOptions?: Apollo.QueryHookOptions<FindManyBulkCertificateRecordQuery, FindManyBulkCertificateRecordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyBulkCertificateRecordQuery, FindManyBulkCertificateRecordQueryVariables>(FindManyBulkCertificateRecordDocument, options);
      }
export function useFindManyBulkCertificateRecordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyBulkCertificateRecordQuery, FindManyBulkCertificateRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyBulkCertificateRecordQuery, FindManyBulkCertificateRecordQueryVariables>(FindManyBulkCertificateRecordDocument, options);
        }
export type FindManyBulkCertificateRecordQueryHookResult = ReturnType<typeof useFindManyBulkCertificateRecordQuery>;
export type FindManyBulkCertificateRecordLazyQueryHookResult = ReturnType<typeof useFindManyBulkCertificateRecordLazyQuery>;
export type FindManyBulkCertificateRecordQueryResult = Apollo.QueryResult<FindManyBulkCertificateRecordQuery, FindManyBulkCertificateRecordQueryVariables>;
export const FindManyCertificateCourseDocument = gql`
    query findManyCertificateCourse($where: CertificateCourseWhereInput, $take: Int, $skip: Int, $orderBy: [CertificateCourseOrderByWithRelationInput!]) {
  findManyCertificateCourse(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    ...CertificateCourseFields
  }
  count: countCertificateCourse(where: $where)
}
    ${CertificateCourseFieldsFragmentDoc}`;

/**
 * __useFindManyCertificateCourseQuery__
 *
 * To run a query within a React component, call `useFindManyCertificateCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyCertificateCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyCertificateCourseQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyCertificateCourseQuery(baseOptions?: Apollo.QueryHookOptions<FindManyCertificateCourseQuery, FindManyCertificateCourseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyCertificateCourseQuery, FindManyCertificateCourseQueryVariables>(FindManyCertificateCourseDocument, options);
      }
export function useFindManyCertificateCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyCertificateCourseQuery, FindManyCertificateCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyCertificateCourseQuery, FindManyCertificateCourseQueryVariables>(FindManyCertificateCourseDocument, options);
        }
export type FindManyCertificateCourseQueryHookResult = ReturnType<typeof useFindManyCertificateCourseQuery>;
export type FindManyCertificateCourseLazyQueryHookResult = ReturnType<typeof useFindManyCertificateCourseLazyQuery>;
export type FindManyCertificateCourseQueryResult = Apollo.QueryResult<FindManyCertificateCourseQuery, FindManyCertificateCourseQueryVariables>;
export const FindManyCertificateCourseLevelDocument = gql`
    query findManyCertificateCourseLevel($where: CertificateCourseLevelWhereInput, $take: Int, $skip: Int, $orderBy: [CertificateCourseLevelOrderByWithRelationInput!]) {
  findManyCertificateCourseLevel(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    ...CertificateCourseLevelFields
  }
  count: countCertificateCourseLevel(where: $where)
}
    ${CertificateCourseLevelFieldsFragmentDoc}`;

/**
 * __useFindManyCertificateCourseLevelQuery__
 *
 * To run a query within a React component, call `useFindManyCertificateCourseLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyCertificateCourseLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyCertificateCourseLevelQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyCertificateCourseLevelQuery(baseOptions?: Apollo.QueryHookOptions<FindManyCertificateCourseLevelQuery, FindManyCertificateCourseLevelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyCertificateCourseLevelQuery, FindManyCertificateCourseLevelQueryVariables>(FindManyCertificateCourseLevelDocument, options);
      }
export function useFindManyCertificateCourseLevelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyCertificateCourseLevelQuery, FindManyCertificateCourseLevelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyCertificateCourseLevelQuery, FindManyCertificateCourseLevelQueryVariables>(FindManyCertificateCourseLevelDocument, options);
        }
export type FindManyCertificateCourseLevelQueryHookResult = ReturnType<typeof useFindManyCertificateCourseLevelQuery>;
export type FindManyCertificateCourseLevelLazyQueryHookResult = ReturnType<typeof useFindManyCertificateCourseLevelLazyQuery>;
export type FindManyCertificateCourseLevelQueryResult = Apollo.QueryResult<FindManyCertificateCourseLevelQuery, FindManyCertificateCourseLevelQueryVariables>;
export const FindManyCertificateCurriculumDocument = gql`
    query findManyCertificateCurriculum($where: CertificateCurriculumWhereInput, $take: Int, $skip: Int, $orderBy: [CertificateCurriculumOrderByWithRelationInput!]) {
  findManyCertificateCurriculum(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    ...CertificateCurriculumFields
  }
  count: countCertificateCurriculum(where: $where)
}
    ${CertificateCurriculumFieldsFragmentDoc}`;

/**
 * __useFindManyCertificateCurriculumQuery__
 *
 * To run a query within a React component, call `useFindManyCertificateCurriculumQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyCertificateCurriculumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyCertificateCurriculumQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyCertificateCurriculumQuery(baseOptions?: Apollo.QueryHookOptions<FindManyCertificateCurriculumQuery, FindManyCertificateCurriculumQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyCertificateCurriculumQuery, FindManyCertificateCurriculumQueryVariables>(FindManyCertificateCurriculumDocument, options);
      }
export function useFindManyCertificateCurriculumLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyCertificateCurriculumQuery, FindManyCertificateCurriculumQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyCertificateCurriculumQuery, FindManyCertificateCurriculumQueryVariables>(FindManyCertificateCurriculumDocument, options);
        }
export type FindManyCertificateCurriculumQueryHookResult = ReturnType<typeof useFindManyCertificateCurriculumQuery>;
export type FindManyCertificateCurriculumLazyQueryHookResult = ReturnType<typeof useFindManyCertificateCurriculumLazyQuery>;
export type FindManyCertificateCurriculumQueryResult = Apollo.QueryResult<FindManyCertificateCurriculumQuery, FindManyCertificateCurriculumQueryVariables>;
export const FindManyCertificateDisciplineDocument = gql`
    query findManyCertificateDiscipline($where: CertificateDisciplineWhereInput, $take: Int, $skip: Int, $orderBy: [CertificateDisciplineOrderByWithRelationInput!]) {
  findManyCertificateDiscipline(
    take: $take
    skip: $skip
    orderBy: $orderBy
    where: $where
  ) {
    certificateBaseId
    name
    viewOnDegree
    CertificateBase {
      createdAt
    }
  }
  count: countCertificateDiscipline(where: $where)
}
    `;

/**
 * __useFindManyCertificateDisciplineQuery__
 *
 * To run a query within a React component, call `useFindManyCertificateDisciplineQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyCertificateDisciplineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyCertificateDisciplineQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyCertificateDisciplineQuery(baseOptions?: Apollo.QueryHookOptions<FindManyCertificateDisciplineQuery, FindManyCertificateDisciplineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyCertificateDisciplineQuery, FindManyCertificateDisciplineQueryVariables>(FindManyCertificateDisciplineDocument, options);
      }
export function useFindManyCertificateDisciplineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyCertificateDisciplineQuery, FindManyCertificateDisciplineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyCertificateDisciplineQuery, FindManyCertificateDisciplineQueryVariables>(FindManyCertificateDisciplineDocument, options);
        }
export type FindManyCertificateDisciplineQueryHookResult = ReturnType<typeof useFindManyCertificateDisciplineQuery>;
export type FindManyCertificateDisciplineLazyQueryHookResult = ReturnType<typeof useFindManyCertificateDisciplineLazyQuery>;
export type FindManyCertificateDisciplineQueryResult = Apollo.QueryResult<FindManyCertificateDisciplineQuery, FindManyCertificateDisciplineQueryVariables>;
export const FindManyCertificateEventDocument = gql`
    query findManyCertificateEvent($where: CertificateEventWhereInput, $take: Int, $skip: Int, $orderBy: [CertificateEventOrderByWithRelationInput!]) {
  findManyCertificateEvent(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    ...CertificateEventFields
  }
  count: countCertificateEvent(where: $where)
}
    ${CertificateEventFieldsFragmentDoc}`;

/**
 * __useFindManyCertificateEventQuery__
 *
 * To run a query within a React component, call `useFindManyCertificateEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyCertificateEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyCertificateEventQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyCertificateEventQuery(baseOptions?: Apollo.QueryHookOptions<FindManyCertificateEventQuery, FindManyCertificateEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyCertificateEventQuery, FindManyCertificateEventQueryVariables>(FindManyCertificateEventDocument, options);
      }
export function useFindManyCertificateEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyCertificateEventQuery, FindManyCertificateEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyCertificateEventQuery, FindManyCertificateEventQueryVariables>(FindManyCertificateEventDocument, options);
        }
export type FindManyCertificateEventQueryHookResult = ReturnType<typeof useFindManyCertificateEventQuery>;
export type FindManyCertificateEventLazyQueryHookResult = ReturnType<typeof useFindManyCertificateEventLazyQuery>;
export type FindManyCertificateEventQueryResult = Apollo.QueryResult<FindManyCertificateEventQuery, FindManyCertificateEventQueryVariables>;
export const FindManyCertificateTeacherDocument = gql`
    query findManyCertificateTeacher($where: CertificateTeacherWhereInput, $take: Int, $skip: Int, $orderBy: [CertificateTeacherOrderByWithRelationInput!]) {
  findManyCertificateTeacher(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    certificateBaseId
    name
    titration
    CertificateBase {
      createdAt
    }
  }
  count: countCertificateTeacher(where: $where)
}
    `;

/**
 * __useFindManyCertificateTeacherQuery__
 *
 * To run a query within a React component, call `useFindManyCertificateTeacherQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyCertificateTeacherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyCertificateTeacherQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyCertificateTeacherQuery(baseOptions?: Apollo.QueryHookOptions<FindManyCertificateTeacherQuery, FindManyCertificateTeacherQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyCertificateTeacherQuery, FindManyCertificateTeacherQueryVariables>(FindManyCertificateTeacherDocument, options);
      }
export function useFindManyCertificateTeacherLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyCertificateTeacherQuery, FindManyCertificateTeacherQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyCertificateTeacherQuery, FindManyCertificateTeacherQueryVariables>(FindManyCertificateTeacherDocument, options);
        }
export type FindManyCertificateTeacherQueryHookResult = ReturnType<typeof useFindManyCertificateTeacherQuery>;
export type FindManyCertificateTeacherLazyQueryHookResult = ReturnType<typeof useFindManyCertificateTeacherLazyQuery>;
export type FindManyCertificateTeacherQueryResult = Apollo.QueryResult<FindManyCertificateTeacherQuery, FindManyCertificateTeacherQueryVariables>;
export const FindManyCertificateTemplateDocument = gql`
    query findManyCertificateTemplate($where: CertificateTemplateWhereInput, $take: Int, $skip: Int, $orderBy: [CertificateTemplateOrderByWithRelationInput!]) {
  items: findManyCertificateTemplate(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    ...CertificateTemplateManyFields
  }
  count: countCertificateTemplate(where: $where)
}
    ${CertificateTemplateManyFieldsFragmentDoc}`;

/**
 * __useFindManyCertificateTemplateQuery__
 *
 * To run a query within a React component, call `useFindManyCertificateTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyCertificateTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyCertificateTemplateQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyCertificateTemplateQuery(baseOptions?: Apollo.QueryHookOptions<FindManyCertificateTemplateQuery, FindManyCertificateTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyCertificateTemplateQuery, FindManyCertificateTemplateQueryVariables>(FindManyCertificateTemplateDocument, options);
      }
export function useFindManyCertificateTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyCertificateTemplateQuery, FindManyCertificateTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyCertificateTemplateQuery, FindManyCertificateTemplateQueryVariables>(FindManyCertificateTemplateDocument, options);
        }
export type FindManyCertificateTemplateQueryHookResult = ReturnType<typeof useFindManyCertificateTemplateQuery>;
export type FindManyCertificateTemplateLazyQueryHookResult = ReturnType<typeof useFindManyCertificateTemplateLazyQuery>;
export type FindManyCertificateTemplateQueryResult = Apollo.QueryResult<FindManyCertificateTemplateQuery, FindManyCertificateTemplateQueryVariables>;
export const FindManyCertificatesByBatchIdDocument = gql`
    query FindManyCertificatesByBatchId($batchId: String) {
  findManyCertificatesByBatchId(batchId: $batchId) {
    documentBaseId
    documentCertificateName
    documentCertificateCPF
    status
    DocumentBase {
      createdAt
      filePath
    }
    DocumentCertificateSignatureItems {
      ...DocumentCertificateSignatureItemFields
    }
  }
}
    ${DocumentCertificateSignatureItemFieldsFragmentDoc}`;

/**
 * __useFindManyCertificatesByBatchIdQuery__
 *
 * To run a query within a React component, call `useFindManyCertificatesByBatchIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyCertificatesByBatchIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyCertificatesByBatchIdQuery({
 *   variables: {
 *      batchId: // value for 'batchId'
 *   },
 * });
 */
export function useFindManyCertificatesByBatchIdQuery(baseOptions?: Apollo.QueryHookOptions<FindManyCertificatesByBatchIdQuery, FindManyCertificatesByBatchIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyCertificatesByBatchIdQuery, FindManyCertificatesByBatchIdQueryVariables>(FindManyCertificatesByBatchIdDocument, options);
      }
export function useFindManyCertificatesByBatchIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyCertificatesByBatchIdQuery, FindManyCertificatesByBatchIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyCertificatesByBatchIdQuery, FindManyCertificatesByBatchIdQueryVariables>(FindManyCertificatesByBatchIdDocument, options);
        }
export type FindManyCertificatesByBatchIdQueryHookResult = ReturnType<typeof useFindManyCertificatesByBatchIdQuery>;
export type FindManyCertificatesByBatchIdLazyQueryHookResult = ReturnType<typeof useFindManyCertificatesByBatchIdLazyQuery>;
export type FindManyCertificatesByBatchIdQueryResult = Apollo.QueryResult<FindManyCertificatesByBatchIdQuery, FindManyCertificatesByBatchIdQueryVariables>;
export const FindManyCommonUserDocument = gql`
    query findManyCommonUser($where: CommonUserWhereInput, $take: Int, $skip: Int, $orderBy: [CommonUserOrderByWithRelationInput!]) {
  findManyCommonUser(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
    name
    id
    email
    photo
    Team {
      id
      issuerName
      placeholderName
    }
  }
}
    `;

/**
 * __useFindManyCommonUserQuery__
 *
 * To run a query within a React component, call `useFindManyCommonUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyCommonUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyCommonUserQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyCommonUserQuery(baseOptions?: Apollo.QueryHookOptions<FindManyCommonUserQuery, FindManyCommonUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyCommonUserQuery, FindManyCommonUserQueryVariables>(FindManyCommonUserDocument, options);
      }
export function useFindManyCommonUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyCommonUserQuery, FindManyCommonUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyCommonUserQuery, FindManyCommonUserQueryVariables>(FindManyCommonUserDocument, options);
        }
export type FindManyCommonUserQueryHookResult = ReturnType<typeof useFindManyCommonUserQuery>;
export type FindManyCommonUserLazyQueryHookResult = ReturnType<typeof useFindManyCommonUserLazyQuery>;
export type FindManyCommonUserQueryResult = Apollo.QueryResult<FindManyCommonUserQuery, FindManyCommonUserQueryVariables>;
export const FindManyDegreeDocument = gql`
    query FindManyDegree($where: DocumentDegreeWhereInput, $take: Int, $skip: Int, $orderBy: [DocumentDegreeOrderByWithRelationInput!]) {
  findManyDegree(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
    ...DocumentDegreeFields
  }
  count: countDegree(where: $where)
}
    ${DocumentDegreeFieldsFragmentDoc}`;

/**
 * __useFindManyDegreeQuery__
 *
 * To run a query within a React component, call `useFindManyDegreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyDegreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyDegreeQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyDegreeQuery(baseOptions?: Apollo.QueryHookOptions<FindManyDegreeQuery, FindManyDegreeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyDegreeQuery, FindManyDegreeQueryVariables>(FindManyDegreeDocument, options);
      }
export function useFindManyDegreeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyDegreeQuery, FindManyDegreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyDegreeQuery, FindManyDegreeQueryVariables>(FindManyDegreeDocument, options);
        }
export type FindManyDegreeQueryHookResult = ReturnType<typeof useFindManyDegreeQuery>;
export type FindManyDegreeLazyQueryHookResult = ReturnType<typeof useFindManyDegreeLazyQuery>;
export type FindManyDegreeQueryResult = Apollo.QueryResult<FindManyDegreeQuery, FindManyDegreeQueryVariables>;
export const FindManyDocumentAuditFileIssuerDocument = gql`
    query findManyDocumentAuditFileIssuer($take: Int, $skip: Int, $where: DocumentAuditFileIssuerWhereInput, $orderBy: [DocumentAuditFileIssuerOrderByWithRelationInput!]) {
  findManyDocumentAuditFileIssuer(
    take: $take
    skip: $skip
    where: $where
    orderBy: $orderBy
  ) {
    documentBaseId
    searchAuditStartDate
    searchAuditEndDate
    status
    DocumentBase {
      filePath
      createdAt
    }
  }
  count: countDocumentAuditFileIssuer(where: $where)
}
    `;

/**
 * __useFindManyDocumentAuditFileIssuerQuery__
 *
 * To run a query within a React component, call `useFindManyDocumentAuditFileIssuerQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyDocumentAuditFileIssuerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyDocumentAuditFileIssuerQuery({
 *   variables: {
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyDocumentAuditFileIssuerQuery(baseOptions?: Apollo.QueryHookOptions<FindManyDocumentAuditFileIssuerQuery, FindManyDocumentAuditFileIssuerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyDocumentAuditFileIssuerQuery, FindManyDocumentAuditFileIssuerQueryVariables>(FindManyDocumentAuditFileIssuerDocument, options);
      }
export function useFindManyDocumentAuditFileIssuerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyDocumentAuditFileIssuerQuery, FindManyDocumentAuditFileIssuerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyDocumentAuditFileIssuerQuery, FindManyDocumentAuditFileIssuerQueryVariables>(FindManyDocumentAuditFileIssuerDocument, options);
        }
export type FindManyDocumentAuditFileIssuerQueryHookResult = ReturnType<typeof useFindManyDocumentAuditFileIssuerQuery>;
export type FindManyDocumentAuditFileIssuerLazyQueryHookResult = ReturnType<typeof useFindManyDocumentAuditFileIssuerLazyQuery>;
export type FindManyDocumentAuditFileIssuerQueryResult = Apollo.QueryResult<FindManyDocumentAuditFileIssuerQuery, FindManyDocumentAuditFileIssuerQueryVariables>;
export const FindManyDocumentBaseDefaultSignatureInviteConfigurationDocument = gql`
    query findManyDocumentBaseDefaultSignatureInviteConfiguration($where: DocumentBaseDefaultSignatureInviteConfigurationWhereInput, $take: Int, $skip: Int, $orderBy: [DocumentBaseDefaultSignatureInviteConfigurationOrderByWithRelationInput!]) {
  countDocumentBaseDefaultSignatureInviteConfiguration(where: $where)
  findManyDocumentBaseDefaultSignatureInviteConfiguration(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    id
    type
    createdAt
    updatedAt
    Groups {
      id
      Items {
        teamMemberId
        TeamMember {
          User {
            name
            email
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFindManyDocumentBaseDefaultSignatureInviteConfigurationQuery__
 *
 * To run a query within a React component, call `useFindManyDocumentBaseDefaultSignatureInviteConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyDocumentBaseDefaultSignatureInviteConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyDocumentBaseDefaultSignatureInviteConfigurationQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyDocumentBaseDefaultSignatureInviteConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<FindManyDocumentBaseDefaultSignatureInviteConfigurationQuery, FindManyDocumentBaseDefaultSignatureInviteConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyDocumentBaseDefaultSignatureInviteConfigurationQuery, FindManyDocumentBaseDefaultSignatureInviteConfigurationQueryVariables>(FindManyDocumentBaseDefaultSignatureInviteConfigurationDocument, options);
      }
export function useFindManyDocumentBaseDefaultSignatureInviteConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyDocumentBaseDefaultSignatureInviteConfigurationQuery, FindManyDocumentBaseDefaultSignatureInviteConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyDocumentBaseDefaultSignatureInviteConfigurationQuery, FindManyDocumentBaseDefaultSignatureInviteConfigurationQueryVariables>(FindManyDocumentBaseDefaultSignatureInviteConfigurationDocument, options);
        }
export type FindManyDocumentBaseDefaultSignatureInviteConfigurationQueryHookResult = ReturnType<typeof useFindManyDocumentBaseDefaultSignatureInviteConfigurationQuery>;
export type FindManyDocumentBaseDefaultSignatureInviteConfigurationLazyQueryHookResult = ReturnType<typeof useFindManyDocumentBaseDefaultSignatureInviteConfigurationLazyQuery>;
export type FindManyDocumentBaseDefaultSignatureInviteConfigurationQueryResult = Apollo.QueryResult<FindManyDocumentBaseDefaultSignatureInviteConfigurationQuery, FindManyDocumentBaseDefaultSignatureInviteConfigurationQueryVariables>;
export const FindManyDocumentCertificateDocument = gql`
    query findManyDocumentCertificate($where: DocumentCertificateWhereInput, $take: Int, $skip: Int, $orderBy: [DocumentCertificateOrderByWithRelationInput!]) {
  findManyDocumentCertificate(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    documentBaseId
    documentCertificateName
    documentCertificateCPF
    status
    DocumentBase {
      createdAt
      filePath
    }
    DocumentCertificateSignatureItems {
      ...DocumentCertificateSignatureItemFields
    }
  }
  count: countDocumentCertificate(where: $where)
}
    ${DocumentCertificateSignatureItemFieldsFragmentDoc}`;

/**
 * __useFindManyDocumentCertificateQuery__
 *
 * To run a query within a React component, call `useFindManyDocumentCertificateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyDocumentCertificateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyDocumentCertificateQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyDocumentCertificateQuery(baseOptions?: Apollo.QueryHookOptions<FindManyDocumentCertificateQuery, FindManyDocumentCertificateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyDocumentCertificateQuery, FindManyDocumentCertificateQueryVariables>(FindManyDocumentCertificateDocument, options);
      }
export function useFindManyDocumentCertificateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyDocumentCertificateQuery, FindManyDocumentCertificateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyDocumentCertificateQuery, FindManyDocumentCertificateQueryVariables>(FindManyDocumentCertificateDocument, options);
        }
export type FindManyDocumentCertificateQueryHookResult = ReturnType<typeof useFindManyDocumentCertificateQuery>;
export type FindManyDocumentCertificateLazyQueryHookResult = ReturnType<typeof useFindManyDocumentCertificateLazyQuery>;
export type FindManyDocumentCertificateQueryResult = Apollo.QueryResult<FindManyDocumentCertificateQuery, FindManyDocumentCertificateQueryVariables>;
export const FindManyDocumentCertificateSignatureItemDocument = gql`
    query findManyDocumentCertificateSignatureItem($where: DocumentCertificateSignatureItemWhereInput, $take: Int, $skip: Int, $orderBy: [DocumentCertificateSignatureItemOrderByWithRelationInput!]) {
  findManyDocumentCertificateSignatureItem(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    ...DocumentCertificateSignatureItemBaseFields
    DocumentCertificate {
      DocumentBase {
        internalSeqId
      }
      documentCertificateName
      documentCertificateCPF
      DocumentCertificateSignatureItems {
        ...DocumentCertificateSignatureItemBaseFields
      }
    }
  }
  countDocumentCertificateSignatureItem(where: $where)
}
    ${DocumentCertificateSignatureItemBaseFieldsFragmentDoc}`;

/**
 * __useFindManyDocumentCertificateSignatureItemQuery__
 *
 * To run a query within a React component, call `useFindManyDocumentCertificateSignatureItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyDocumentCertificateSignatureItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyDocumentCertificateSignatureItemQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyDocumentCertificateSignatureItemQuery(baseOptions?: Apollo.QueryHookOptions<FindManyDocumentCertificateSignatureItemQuery, FindManyDocumentCertificateSignatureItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyDocumentCertificateSignatureItemQuery, FindManyDocumentCertificateSignatureItemQueryVariables>(FindManyDocumentCertificateSignatureItemDocument, options);
      }
export function useFindManyDocumentCertificateSignatureItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyDocumentCertificateSignatureItemQuery, FindManyDocumentCertificateSignatureItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyDocumentCertificateSignatureItemQuery, FindManyDocumentCertificateSignatureItemQueryVariables>(FindManyDocumentCertificateSignatureItemDocument, options);
        }
export type FindManyDocumentCertificateSignatureItemQueryHookResult = ReturnType<typeof useFindManyDocumentCertificateSignatureItemQuery>;
export type FindManyDocumentCertificateSignatureItemLazyQueryHookResult = ReturnType<typeof useFindManyDocumentCertificateSignatureItemLazyQuery>;
export type FindManyDocumentCertificateSignatureItemQueryResult = Apollo.QueryResult<FindManyDocumentCertificateSignatureItemQuery, FindManyDocumentCertificateSignatureItemQueryVariables>;
export const FindManyDocumentFinalAcademicTranscriptDocument = gql`
    query findManyDocumentFinalAcademicTranscript($where: DocumentFinalAcademicTranscriptWhereInput, $take: Int, $skip: Int, $orderBy: [DocumentFinalAcademicTranscriptOrderByWithRelationInput!]) {
  findManyDocumentFinalAcademicTranscript(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    documentBaseId
    status
    DocumentBase {
      type
      createdAt
    }
    searchStudentName
    searchCourse
    searchCPF
    searchEmecCode
  }
  count: countDocumentFinalAcademicTranscript(where: $where)
}
    `;

/**
 * __useFindManyDocumentFinalAcademicTranscriptQuery__
 *
 * To run a query within a React component, call `useFindManyDocumentFinalAcademicTranscriptQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyDocumentFinalAcademicTranscriptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyDocumentFinalAcademicTranscriptQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyDocumentFinalAcademicTranscriptQuery(baseOptions?: Apollo.QueryHookOptions<FindManyDocumentFinalAcademicTranscriptQuery, FindManyDocumentFinalAcademicTranscriptQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyDocumentFinalAcademicTranscriptQuery, FindManyDocumentFinalAcademicTranscriptQueryVariables>(FindManyDocumentFinalAcademicTranscriptDocument, options);
      }
export function useFindManyDocumentFinalAcademicTranscriptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyDocumentFinalAcademicTranscriptQuery, FindManyDocumentFinalAcademicTranscriptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyDocumentFinalAcademicTranscriptQuery, FindManyDocumentFinalAcademicTranscriptQueryVariables>(FindManyDocumentFinalAcademicTranscriptDocument, options);
        }
export type FindManyDocumentFinalAcademicTranscriptQueryHookResult = ReturnType<typeof useFindManyDocumentFinalAcademicTranscriptQuery>;
export type FindManyDocumentFinalAcademicTranscriptLazyQueryHookResult = ReturnType<typeof useFindManyDocumentFinalAcademicTranscriptLazyQuery>;
export type FindManyDocumentFinalAcademicTranscriptQueryResult = Apollo.QueryResult<FindManyDocumentFinalAcademicTranscriptQuery, FindManyDocumentFinalAcademicTranscriptQueryVariables>;
export const FindManyDocumentSchoolCurriculumDocument = gql`
    query findManyDocumentSchoolCurriculum($orderBy: [DocumentSchoolCurriculumOrderByWithRelationInput!], $skip: Int, $take: Int, $where: DocumentSchoolCurriculumWhereInput) {
  findManyDocumentSchoolCurriculum(
    orderBy: $orderBy
    skip: $skip
    take: $take
    where: $where
  ) {
    documentBaseId
    searchSchoolCurriculumName
    searchSchoolCurriculumCode
    searchSelectedCourse
    status
    DocumentBase {
      createdAt
      filePath
    }
  }
  count: countDocumentSchoolCurriculum(where: $where)
}
    `;

/**
 * __useFindManyDocumentSchoolCurriculumQuery__
 *
 * To run a query within a React component, call `useFindManyDocumentSchoolCurriculumQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyDocumentSchoolCurriculumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyDocumentSchoolCurriculumQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindManyDocumentSchoolCurriculumQuery(baseOptions?: Apollo.QueryHookOptions<FindManyDocumentSchoolCurriculumQuery, FindManyDocumentSchoolCurriculumQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyDocumentSchoolCurriculumQuery, FindManyDocumentSchoolCurriculumQueryVariables>(FindManyDocumentSchoolCurriculumDocument, options);
      }
export function useFindManyDocumentSchoolCurriculumLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyDocumentSchoolCurriculumQuery, FindManyDocumentSchoolCurriculumQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyDocumentSchoolCurriculumQuery, FindManyDocumentSchoolCurriculumQueryVariables>(FindManyDocumentSchoolCurriculumDocument, options);
        }
export type FindManyDocumentSchoolCurriculumQueryHookResult = ReturnType<typeof useFindManyDocumentSchoolCurriculumQuery>;
export type FindManyDocumentSchoolCurriculumLazyQueryHookResult = ReturnType<typeof useFindManyDocumentSchoolCurriculumLazyQuery>;
export type FindManyDocumentSchoolCurriculumQueryResult = Apollo.QueryResult<FindManyDocumentSchoolCurriculumQuery, FindManyDocumentSchoolCurriculumQueryVariables>;
export const FindManyEnabledInstitutionDocument = gql`
    query findManyEnabledInstitution($where: EnabledInstitutionWhereInput, $take: Int, $skip: Int, $orderBy: [EnabledInstitutionOrderByWithRelationInput!]) {
  findManyEnabledInstitution(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    ...EnabledInstitutionFields
  }
  count: countEnabledInstitution(where: $where)
  totalIssuedDocuments: countTotalIssuedDocuments
}
    ${EnabledInstitutionFieldsFragmentDoc}`;

/**
 * __useFindManyEnabledInstitutionQuery__
 *
 * To run a query within a React component, call `useFindManyEnabledInstitutionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyEnabledInstitutionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyEnabledInstitutionQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyEnabledInstitutionQuery(baseOptions?: Apollo.QueryHookOptions<FindManyEnabledInstitutionQuery, FindManyEnabledInstitutionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyEnabledInstitutionQuery, FindManyEnabledInstitutionQueryVariables>(FindManyEnabledInstitutionDocument, options);
      }
export function useFindManyEnabledInstitutionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyEnabledInstitutionQuery, FindManyEnabledInstitutionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyEnabledInstitutionQuery, FindManyEnabledInstitutionQueryVariables>(FindManyEnabledInstitutionDocument, options);
        }
export type FindManyEnabledInstitutionQueryHookResult = ReturnType<typeof useFindManyEnabledInstitutionQuery>;
export type FindManyEnabledInstitutionLazyQueryHookResult = ReturnType<typeof useFindManyEnabledInstitutionLazyQuery>;
export type FindManyEnabledInstitutionQueryResult = Apollo.QueryResult<FindManyEnabledInstitutionQuery, FindManyEnabledInstitutionQueryVariables>;
export const FindManyFinancialChargeDocument = gql`
    query findManyFinancialCharge($where: FinancialChargeWhereInput, $take: Int, $skip: Int, $orderBy: [FinancialChargeOrderByWithRelationInput!]) {
  findManyFinancialCharge(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    id
    service
    createdAt
    UserExecuted {
      id
      name
      email
      photo
    }
    creditsDeducted
  }
  count: countFinancialCharge(where: $where)
}
    `;

/**
 * __useFindManyFinancialChargeQuery__
 *
 * To run a query within a React component, call `useFindManyFinancialChargeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyFinancialChargeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyFinancialChargeQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyFinancialChargeQuery(baseOptions?: Apollo.QueryHookOptions<FindManyFinancialChargeQuery, FindManyFinancialChargeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyFinancialChargeQuery, FindManyFinancialChargeQueryVariables>(FindManyFinancialChargeDocument, options);
      }
export function useFindManyFinancialChargeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyFinancialChargeQuery, FindManyFinancialChargeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyFinancialChargeQuery, FindManyFinancialChargeQueryVariables>(FindManyFinancialChargeDocument, options);
        }
export type FindManyFinancialChargeQueryHookResult = ReturnType<typeof useFindManyFinancialChargeQuery>;
export type FindManyFinancialChargeLazyQueryHookResult = ReturnType<typeof useFindManyFinancialChargeLazyQuery>;
export type FindManyFinancialChargeQueryResult = Apollo.QueryResult<FindManyFinancialChargeQuery, FindManyFinancialChargeQueryVariables>;
export const FindManyFinancialCreditCardSavedDocument = gql`
    query findManyFinancialCreditCardSaved {
  findManyFinancialCreditCardSaved {
    id
    token
    number
    brand
  }
}
    `;

/**
 * __useFindManyFinancialCreditCardSavedQuery__
 *
 * To run a query within a React component, call `useFindManyFinancialCreditCardSavedQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyFinancialCreditCardSavedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyFinancialCreditCardSavedQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindManyFinancialCreditCardSavedQuery(baseOptions?: Apollo.QueryHookOptions<FindManyFinancialCreditCardSavedQuery, FindManyFinancialCreditCardSavedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyFinancialCreditCardSavedQuery, FindManyFinancialCreditCardSavedQueryVariables>(FindManyFinancialCreditCardSavedDocument, options);
      }
export function useFindManyFinancialCreditCardSavedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyFinancialCreditCardSavedQuery, FindManyFinancialCreditCardSavedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyFinancialCreditCardSavedQuery, FindManyFinancialCreditCardSavedQueryVariables>(FindManyFinancialCreditCardSavedDocument, options);
        }
export type FindManyFinancialCreditCardSavedQueryHookResult = ReturnType<typeof useFindManyFinancialCreditCardSavedQuery>;
export type FindManyFinancialCreditCardSavedLazyQueryHookResult = ReturnType<typeof useFindManyFinancialCreditCardSavedLazyQuery>;
export type FindManyFinancialCreditCardSavedQueryResult = Apollo.QueryResult<FindManyFinancialCreditCardSavedQuery, FindManyFinancialCreditCardSavedQueryVariables>;
export const FindManyFinancialPlanDocument = gql`
    query findManyFinancialPlan {
  findManyFinancialPlan {
    ...PlanAndConditionsFields
  }
}
    ${PlanAndConditionsFieldsFragmentDoc}`;

/**
 * __useFindManyFinancialPlanQuery__
 *
 * To run a query within a React component, call `useFindManyFinancialPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyFinancialPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyFinancialPlanQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindManyFinancialPlanQuery(baseOptions?: Apollo.QueryHookOptions<FindManyFinancialPlanQuery, FindManyFinancialPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyFinancialPlanQuery, FindManyFinancialPlanQueryVariables>(FindManyFinancialPlanDocument, options);
      }
export function useFindManyFinancialPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyFinancialPlanQuery, FindManyFinancialPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyFinancialPlanQuery, FindManyFinancialPlanQueryVariables>(FindManyFinancialPlanDocument, options);
        }
export type FindManyFinancialPlanQueryHookResult = ReturnType<typeof useFindManyFinancialPlanQuery>;
export type FindManyFinancialPlanLazyQueryHookResult = ReturnType<typeof useFindManyFinancialPlanLazyQuery>;
export type FindManyFinancialPlanQueryResult = Apollo.QueryResult<FindManyFinancialPlanQuery, FindManyFinancialPlanQueryVariables>;
export const FindManyFinancialPaymentDocument = gql`
    query findManyFinancialPayment($where: FinancialPaymentWhereInput, $take: Int, $skip: Int, $orderBy: [FinancialPaymentOrderByWithRelationInput!]) {
  count: countFinancialPayment(where: $where)
  items: findManyFinancialPayment(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    id
    createdAt
    Recharge {
      id
      createdAt
      UserExecuted {
        id
        name
        email
        photo
      }
      cost
      creditsCount
      creditsType
    }
    SubscriptionPayment {
      dueDate
      cost
      id
      createdAt
      Subscription {
        id
        plan
        planName
      }
    }
  }
}
    `;

/**
 * __useFindManyFinancialPaymentQuery__
 *
 * To run a query within a React component, call `useFindManyFinancialPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyFinancialPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyFinancialPaymentQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyFinancialPaymentQuery(baseOptions?: Apollo.QueryHookOptions<FindManyFinancialPaymentQuery, FindManyFinancialPaymentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyFinancialPaymentQuery, FindManyFinancialPaymentQueryVariables>(FindManyFinancialPaymentDocument, options);
      }
export function useFindManyFinancialPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyFinancialPaymentQuery, FindManyFinancialPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyFinancialPaymentQuery, FindManyFinancialPaymentQueryVariables>(FindManyFinancialPaymentDocument, options);
        }
export type FindManyFinancialPaymentQueryHookResult = ReturnType<typeof useFindManyFinancialPaymentQuery>;
export type FindManyFinancialPaymentLazyQueryHookResult = ReturnType<typeof useFindManyFinancialPaymentLazyQuery>;
export type FindManyFinancialPaymentQueryResult = Apollo.QueryResult<FindManyFinancialPaymentQuery, FindManyFinancialPaymentQueryVariables>;
export const FindManyFinancialTeamWalletSubscriptionPaymentDocument = gql`
    query findManyFinancialTeamWalletSubscriptionPayment($where: FinancialTeamWalletSubscriptionPaymentWhereInput, $take: Int, $skip: Int, $orderBy: [FinancialTeamWalletSubscriptionPaymentOrderByWithRelationInput!]) {
  items: findManyFinancialTeamWalletSubscriptionPayment(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    ...FinancialTeamWalletSubscriptionPaymentFields
  }
  count: countFinancialTeamWalletSubscriptionPayment(where: $where)
}
    ${FinancialTeamWalletSubscriptionPaymentFieldsFragmentDoc}`;

/**
 * __useFindManyFinancialTeamWalletSubscriptionPaymentQuery__
 *
 * To run a query within a React component, call `useFindManyFinancialTeamWalletSubscriptionPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyFinancialTeamWalletSubscriptionPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyFinancialTeamWalletSubscriptionPaymentQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyFinancialTeamWalletSubscriptionPaymentQuery(baseOptions?: Apollo.QueryHookOptions<FindManyFinancialTeamWalletSubscriptionPaymentQuery, FindManyFinancialTeamWalletSubscriptionPaymentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyFinancialTeamWalletSubscriptionPaymentQuery, FindManyFinancialTeamWalletSubscriptionPaymentQueryVariables>(FindManyFinancialTeamWalletSubscriptionPaymentDocument, options);
      }
export function useFindManyFinancialTeamWalletSubscriptionPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyFinancialTeamWalletSubscriptionPaymentQuery, FindManyFinancialTeamWalletSubscriptionPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyFinancialTeamWalletSubscriptionPaymentQuery, FindManyFinancialTeamWalletSubscriptionPaymentQueryVariables>(FindManyFinancialTeamWalletSubscriptionPaymentDocument, options);
        }
export type FindManyFinancialTeamWalletSubscriptionPaymentQueryHookResult = ReturnType<typeof useFindManyFinancialTeamWalletSubscriptionPaymentQuery>;
export type FindManyFinancialTeamWalletSubscriptionPaymentLazyQueryHookResult = ReturnType<typeof useFindManyFinancialTeamWalletSubscriptionPaymentLazyQuery>;
export type FindManyFinancialTeamWalletSubscriptionPaymentQueryResult = Apollo.QueryResult<FindManyFinancialTeamWalletSubscriptionPaymentQuery, FindManyFinancialTeamWalletSubscriptionPaymentQueryVariables>;
export const FindManyMaintainerAdminDocument = gql`
    query findManyMaintainerAdmin($where: MaintainerAdminWhereInput, $take: Int, $skip: Int, $orderBy: [MaintainerAdminOrderByWithRelationInput!]) {
  findManyMaintainerAdmin(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    createdAt
    User {
      id
      email
      idLedgerSign
      name
      cpf
    }
  }
  countMaintainerAdmin(where: $where)
}
    `;

/**
 * __useFindManyMaintainerAdminQuery__
 *
 * To run a query within a React component, call `useFindManyMaintainerAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyMaintainerAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyMaintainerAdminQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyMaintainerAdminQuery(baseOptions?: Apollo.QueryHookOptions<FindManyMaintainerAdminQuery, FindManyMaintainerAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyMaintainerAdminQuery, FindManyMaintainerAdminQueryVariables>(FindManyMaintainerAdminDocument, options);
      }
export function useFindManyMaintainerAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyMaintainerAdminQuery, FindManyMaintainerAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyMaintainerAdminQuery, FindManyMaintainerAdminQueryVariables>(FindManyMaintainerAdminDocument, options);
        }
export type FindManyMaintainerAdminQueryHookResult = ReturnType<typeof useFindManyMaintainerAdminQuery>;
export type FindManyMaintainerAdminLazyQueryHookResult = ReturnType<typeof useFindManyMaintainerAdminLazyQuery>;
export type FindManyMaintainerAdminQueryResult = Apollo.QueryResult<FindManyMaintainerAdminQuery, FindManyMaintainerAdminQueryVariables>;
export const FindManyPermissionDocument = gql`
    query findManyPermission {
  findManyPermission {
    id
    code
    title
    description
  }
}
    `;

/**
 * __useFindManyPermissionQuery__
 *
 * To run a query within a React component, call `useFindManyPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyPermissionQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindManyPermissionQuery(baseOptions?: Apollo.QueryHookOptions<FindManyPermissionQuery, FindManyPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyPermissionQuery, FindManyPermissionQueryVariables>(FindManyPermissionDocument, options);
      }
export function useFindManyPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyPermissionQuery, FindManyPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyPermissionQuery, FindManyPermissionQueryVariables>(FindManyPermissionDocument, options);
        }
export type FindManyPermissionQueryHookResult = ReturnType<typeof useFindManyPermissionQuery>;
export type FindManyPermissionLazyQueryHookResult = ReturnType<typeof useFindManyPermissionLazyQuery>;
export type FindManyPermissionQueryResult = Apollo.QueryResult<FindManyPermissionQuery, FindManyPermissionQueryVariables>;
export const FindManyPersonDocument = gql`
    query FindManyPerson($cursor: PersonWhereUniqueInput, $distinct: [PersonScalarFieldEnum!], $orderBy: [PersonOrderByWithRelationInput!], $skip: Int, $take: Int, $where: PersonWhereInput) {
  findManyPerson(
    cursor: $cursor
    distinct: $distinct
    orderBy: $orderBy
    skip: $skip
    take: $take
    where: $where
  ) {
    id
    cpf
    passport
    name
    birthDate
    email
    createdAt
  }
  count: countPerson(where: $where)
}
    `;

/**
 * __useFindManyPersonQuery__
 *
 * To run a query within a React component, call `useFindManyPersonQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyPersonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyPersonQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      distinct: // value for 'distinct'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindManyPersonQuery(baseOptions?: Apollo.QueryHookOptions<FindManyPersonQuery, FindManyPersonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyPersonQuery, FindManyPersonQueryVariables>(FindManyPersonDocument, options);
      }
export function useFindManyPersonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyPersonQuery, FindManyPersonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyPersonQuery, FindManyPersonQueryVariables>(FindManyPersonDocument, options);
        }
export type FindManyPersonQueryHookResult = ReturnType<typeof useFindManyPersonQuery>;
export type FindManyPersonLazyQueryHookResult = ReturnType<typeof useFindManyPersonLazyQuery>;
export type FindManyPersonQueryResult = Apollo.QueryResult<FindManyPersonQuery, FindManyPersonQueryVariables>;
export const FindManyReusableFormDataDocument = gql`
    query findManyReusableFormData($where: ReusableFormDataWhereInputCustom, $take: Int, $skip: Int, $orderBy: [ReusableFormDataOrderByWithRelationInput!]) {
  findManyReusableFormData(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    id
    data
    createdAt
  }
  count: countReusableFormData(where: $where)
}
    `;

/**
 * __useFindManyReusableFormDataQuery__
 *
 * To run a query within a React component, call `useFindManyReusableFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyReusableFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyReusableFormDataQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyReusableFormDataQuery(baseOptions?: Apollo.QueryHookOptions<FindManyReusableFormDataQuery, FindManyReusableFormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyReusableFormDataQuery, FindManyReusableFormDataQueryVariables>(FindManyReusableFormDataDocument, options);
      }
export function useFindManyReusableFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyReusableFormDataQuery, FindManyReusableFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyReusableFormDataQuery, FindManyReusableFormDataQueryVariables>(FindManyReusableFormDataDocument, options);
        }
export type FindManyReusableFormDataQueryHookResult = ReturnType<typeof useFindManyReusableFormDataQuery>;
export type FindManyReusableFormDataLazyQueryHookResult = ReturnType<typeof useFindManyReusableFormDataLazyQuery>;
export type FindManyReusableFormDataQueryResult = Apollo.QueryResult<FindManyReusableFormDataQuery, FindManyReusableFormDataQueryVariables>;
export const FindManyReusableFormDataCurriculumDocument = gql`
    query findManyReusableFormDataCurriculum($where: ReusableFormDataCurriculumWhereInput, $take: Int, $skip: Int, $orderBy: [ReusableFormDataCurriculumOrderByWithRelationInput!]) {
  items: findManyReusableFormDataCurriculum(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    ...ReusableFormDataCurriculumFields
  }
  count: countReusableFormDataCurriculum(where: $where)
}
    ${ReusableFormDataCurriculumFieldsFragmentDoc}`;

/**
 * __useFindManyReusableFormDataCurriculumQuery__
 *
 * To run a query within a React component, call `useFindManyReusableFormDataCurriculumQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyReusableFormDataCurriculumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyReusableFormDataCurriculumQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyReusableFormDataCurriculumQuery(baseOptions?: Apollo.QueryHookOptions<FindManyReusableFormDataCurriculumQuery, FindManyReusableFormDataCurriculumQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyReusableFormDataCurriculumQuery, FindManyReusableFormDataCurriculumQueryVariables>(FindManyReusableFormDataCurriculumDocument, options);
      }
export function useFindManyReusableFormDataCurriculumLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyReusableFormDataCurriculumQuery, FindManyReusableFormDataCurriculumQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyReusableFormDataCurriculumQuery, FindManyReusableFormDataCurriculumQueryVariables>(FindManyReusableFormDataCurriculumDocument, options);
        }
export type FindManyReusableFormDataCurriculumQueryHookResult = ReturnType<typeof useFindManyReusableFormDataCurriculumQuery>;
export type FindManyReusableFormDataCurriculumLazyQueryHookResult = ReturnType<typeof useFindManyReusableFormDataCurriculumLazyQuery>;
export type FindManyReusableFormDataCurriculumQueryResult = Apollo.QueryResult<FindManyReusableFormDataCurriculumQuery, FindManyReusableFormDataCurriculumQueryVariables>;
export const FindManySignableDocumentBaseSignatureInviteDocument = gql`
    query findManySignableDocumentBaseSignatureInvite($where: DocumentBaseSignatureInviteWhereInput, $take: Int, $skip: Int, $orderBy: [DocumentBaseSignatureInviteOrderByWithRelationInput!], $personId: String!) {
  findManySignableDocumentBaseSignatureInvite(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
    personId: $personId
  ) {
    items {
      ...DocumentBaseSignatureInviteFields
    }
    count
  }
}
    ${DocumentBaseSignatureInviteFieldsFragmentDoc}`;

/**
 * __useFindManySignableDocumentBaseSignatureInviteQuery__
 *
 * To run a query within a React component, call `useFindManySignableDocumentBaseSignatureInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManySignableDocumentBaseSignatureInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManySignableDocumentBaseSignatureInviteQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useFindManySignableDocumentBaseSignatureInviteQuery(baseOptions: Apollo.QueryHookOptions<FindManySignableDocumentBaseSignatureInviteQuery, FindManySignableDocumentBaseSignatureInviteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManySignableDocumentBaseSignatureInviteQuery, FindManySignableDocumentBaseSignatureInviteQueryVariables>(FindManySignableDocumentBaseSignatureInviteDocument, options);
      }
export function useFindManySignableDocumentBaseSignatureInviteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManySignableDocumentBaseSignatureInviteQuery, FindManySignableDocumentBaseSignatureInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManySignableDocumentBaseSignatureInviteQuery, FindManySignableDocumentBaseSignatureInviteQueryVariables>(FindManySignableDocumentBaseSignatureInviteDocument, options);
        }
export type FindManySignableDocumentBaseSignatureInviteQueryHookResult = ReturnType<typeof useFindManySignableDocumentBaseSignatureInviteQuery>;
export type FindManySignableDocumentBaseSignatureInviteLazyQueryHookResult = ReturnType<typeof useFindManySignableDocumentBaseSignatureInviteLazyQuery>;
export type FindManySignableDocumentBaseSignatureInviteQueryResult = Apollo.QueryResult<FindManySignableDocumentBaseSignatureInviteQuery, FindManySignableDocumentBaseSignatureInviteQueryVariables>;
export const FindManySystemGlobalAlertDocument = gql`
    query findManySystemGlobalAlert($where: SystemGlobalAlertWhereInput, $take: Int, $skip: Int, $orderBy: [SystemGlobalAlertOrderByWithRelationInput!]) {
  findManySystemGlobalAlert(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    ...SystemGlobalAlertManyFields
  }
  count: countSystemGlobalAlert(where: $where)
}
    ${SystemGlobalAlertManyFieldsFragmentDoc}`;

/**
 * __useFindManySystemGlobalAlertQuery__
 *
 * To run a query within a React component, call `useFindManySystemGlobalAlertQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManySystemGlobalAlertQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManySystemGlobalAlertQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManySystemGlobalAlertQuery(baseOptions?: Apollo.QueryHookOptions<FindManySystemGlobalAlertQuery, FindManySystemGlobalAlertQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManySystemGlobalAlertQuery, FindManySystemGlobalAlertQueryVariables>(FindManySystemGlobalAlertDocument, options);
      }
export function useFindManySystemGlobalAlertLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManySystemGlobalAlertQuery, FindManySystemGlobalAlertQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManySystemGlobalAlertQuery, FindManySystemGlobalAlertQueryVariables>(FindManySystemGlobalAlertDocument, options);
        }
export type FindManySystemGlobalAlertQueryHookResult = ReturnType<typeof useFindManySystemGlobalAlertQuery>;
export type FindManySystemGlobalAlertLazyQueryHookResult = ReturnType<typeof useFindManySystemGlobalAlertLazyQuery>;
export type FindManySystemGlobalAlertQueryResult = Apollo.QueryResult<FindManySystemGlobalAlertQuery, FindManySystemGlobalAlertQueryVariables>;
export const FindManyTeamDocument = gql`
    query FindManyTeam($where: TeamWhereInput, $take: Int, $skip: Int, $orderBy: [TeamOrderByWithRelationInput!]) {
  count: countTeam(where: $where)
  totalIssuedDocuments: countTotalIssuedDocuments
  items: findManyTeam(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
    ...TeamManyFields
  }
}
    ${TeamManyFieldsFragmentDoc}`;

/**
 * __useFindManyTeamQuery__
 *
 * To run a query within a React component, call `useFindManyTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyTeamQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyTeamQuery(baseOptions?: Apollo.QueryHookOptions<FindManyTeamQuery, FindManyTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyTeamQuery, FindManyTeamQueryVariables>(FindManyTeamDocument, options);
      }
export function useFindManyTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyTeamQuery, FindManyTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyTeamQuery, FindManyTeamQueryVariables>(FindManyTeamDocument, options);
        }
export type FindManyTeamQueryHookResult = ReturnType<typeof useFindManyTeamQuery>;
export type FindManyTeamLazyQueryHookResult = ReturnType<typeof useFindManyTeamLazyQuery>;
export type FindManyTeamQueryResult = Apollo.QueryResult<FindManyTeamQuery, FindManyTeamQueryVariables>;
export const FindManyTeamMaintainedDocument = gql`
    query findManyTeamMaintained($where: TeamWhereInput, $take: Int, $skip: Int, $orderBy: [TeamOrderByWithRelationInput!]) {
  findManyTeamMaintained(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    id
    issuerName
    placeholderName
    cnpj
    createdAt
    MainTeamOfMaintainer {
      id
      mainTeamId
    }
    Owner {
      id
      name
    }
  }
  countTeamMaintained(where: $where)
}
    `;

/**
 * __useFindManyTeamMaintainedQuery__
 *
 * To run a query within a React component, call `useFindManyTeamMaintainedQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyTeamMaintainedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyTeamMaintainedQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyTeamMaintainedQuery(baseOptions?: Apollo.QueryHookOptions<FindManyTeamMaintainedQuery, FindManyTeamMaintainedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyTeamMaintainedQuery, FindManyTeamMaintainedQueryVariables>(FindManyTeamMaintainedDocument, options);
      }
export function useFindManyTeamMaintainedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyTeamMaintainedQuery, FindManyTeamMaintainedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyTeamMaintainedQuery, FindManyTeamMaintainedQueryVariables>(FindManyTeamMaintainedDocument, options);
        }
export type FindManyTeamMaintainedQueryHookResult = ReturnType<typeof useFindManyTeamMaintainedQuery>;
export type FindManyTeamMaintainedLazyQueryHookResult = ReturnType<typeof useFindManyTeamMaintainedLazyQuery>;
export type FindManyTeamMaintainedQueryResult = Apollo.QueryResult<FindManyTeamMaintainedQuery, FindManyTeamMaintainedQueryVariables>;
export const FindManyTeamMemberDocument = gql`
    query findManyTeamMember($where: TeamMemberWhereInput, $take: Int, $skip: Int, $orderBy: [TeamMemberOrderByWithRelationInput!]) {
  findManyTeamMember(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
    ...TeamMemberFields
  }
  count: countTeamMember(where: $where)
}
    ${TeamMemberFieldsFragmentDoc}`;

/**
 * __useFindManyTeamMemberQuery__
 *
 * To run a query within a React component, call `useFindManyTeamMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyTeamMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyTeamMemberQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyTeamMemberQuery(baseOptions?: Apollo.QueryHookOptions<FindManyTeamMemberQuery, FindManyTeamMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyTeamMemberQuery, FindManyTeamMemberQueryVariables>(FindManyTeamMemberDocument, options);
      }
export function useFindManyTeamMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyTeamMemberQuery, FindManyTeamMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyTeamMemberQuery, FindManyTeamMemberQueryVariables>(FindManyTeamMemberDocument, options);
        }
export type FindManyTeamMemberQueryHookResult = ReturnType<typeof useFindManyTeamMemberQuery>;
export type FindManyTeamMemberLazyQueryHookResult = ReturnType<typeof useFindManyTeamMemberLazyQuery>;
export type FindManyTeamMemberQueryResult = Apollo.QueryResult<FindManyTeamMemberQuery, FindManyTeamMemberQueryVariables>;
export const FindManySystemAuditLogDocument = gql`
    query findManySystemAuditLog($where: SystemAuditLogWhereInput, $take: Int, $skip: Int, $orderBy: [SystemAuditLogOrderByWithRelationInput!]) {
  findManySystemAuditLog(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    ...SystemAuditLogFields
  }
  countSystemAuditLog(where: $where)
}
    ${SystemAuditLogFieldsFragmentDoc}`;

/**
 * __useFindManySystemAuditLogQuery__
 *
 * To run a query within a React component, call `useFindManySystemAuditLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManySystemAuditLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManySystemAuditLogQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManySystemAuditLogQuery(baseOptions?: Apollo.QueryHookOptions<FindManySystemAuditLogQuery, FindManySystemAuditLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManySystemAuditLogQuery, FindManySystemAuditLogQueryVariables>(FindManySystemAuditLogDocument, options);
      }
export function useFindManySystemAuditLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManySystemAuditLogQuery, FindManySystemAuditLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManySystemAuditLogQuery, FindManySystemAuditLogQueryVariables>(FindManySystemAuditLogDocument, options);
        }
export type FindManySystemAuditLogQueryHookResult = ReturnType<typeof useFindManySystemAuditLogQuery>;
export type FindManySystemAuditLogLazyQueryHookResult = ReturnType<typeof useFindManySystemAuditLogLazyQuery>;
export type FindManySystemAuditLogQueryResult = Apollo.QueryResult<FindManySystemAuditLogQuery, FindManySystemAuditLogQueryVariables>;
export const FindOneExternalCepAddressDocument = gql`
    query findOneExternalCepAddress($cep: String!) {
  findOneExternalCepAddress(cep: $cep) {
    street
    state
    service
    neighborhood
    city
    cep
  }
}
    `;

/**
 * __useFindOneExternalCepAddressQuery__
 *
 * To run a query within a React component, call `useFindOneExternalCepAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOneExternalCepAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOneExternalCepAddressQuery({
 *   variables: {
 *      cep: // value for 'cep'
 *   },
 * });
 */
export function useFindOneExternalCepAddressQuery(baseOptions: Apollo.QueryHookOptions<FindOneExternalCepAddressQuery, FindOneExternalCepAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindOneExternalCepAddressQuery, FindOneExternalCepAddressQueryVariables>(FindOneExternalCepAddressDocument, options);
      }
export function useFindOneExternalCepAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindOneExternalCepAddressQuery, FindOneExternalCepAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindOneExternalCepAddressQuery, FindOneExternalCepAddressQueryVariables>(FindOneExternalCepAddressDocument, options);
        }
export type FindOneExternalCepAddressQueryHookResult = ReturnType<typeof useFindOneExternalCepAddressQuery>;
export type FindOneExternalCepAddressLazyQueryHookResult = ReturnType<typeof useFindOneExternalCepAddressLazyQuery>;
export type FindOneExternalCepAddressQueryResult = Apollo.QueryResult<FindOneExternalCepAddressQuery, FindOneExternalCepAddressQueryVariables>;
export const FindUniqueBulkCertificateRecordDocument = gql`
    query findUniqueBulkCertificateRecord($where: BulkCertificateRecordWhereUniqueInput!, $countInSignaturesDocumentCertificatesWhere: DocumentCertificateWhereInput) {
  findUniqueBulkCertificateRecord(where: $where) {
    id
    createdAt
    bulkCertificateRecordName
    totalCertificates
    status
    countDocumentCertificates
    countDocumentCertificatesStatusInSignature: countDocumentCertificates(
      where: $countInSignaturesDocumentCertificatesWhere
    )
  }
}
    `;

/**
 * __useFindUniqueBulkCertificateRecordQuery__
 *
 * To run a query within a React component, call `useFindUniqueBulkCertificateRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueBulkCertificateRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueBulkCertificateRecordQuery({
 *   variables: {
 *      where: // value for 'where'
 *      countInSignaturesDocumentCertificatesWhere: // value for 'countInSignaturesDocumentCertificatesWhere'
 *   },
 * });
 */
export function useFindUniqueBulkCertificateRecordQuery(baseOptions: Apollo.QueryHookOptions<FindUniqueBulkCertificateRecordQuery, FindUniqueBulkCertificateRecordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUniqueBulkCertificateRecordQuery, FindUniqueBulkCertificateRecordQueryVariables>(FindUniqueBulkCertificateRecordDocument, options);
      }
export function useFindUniqueBulkCertificateRecordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUniqueBulkCertificateRecordQuery, FindUniqueBulkCertificateRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUniqueBulkCertificateRecordQuery, FindUniqueBulkCertificateRecordQueryVariables>(FindUniqueBulkCertificateRecordDocument, options);
        }
export type FindUniqueBulkCertificateRecordQueryHookResult = ReturnType<typeof useFindUniqueBulkCertificateRecordQuery>;
export type FindUniqueBulkCertificateRecordLazyQueryHookResult = ReturnType<typeof useFindUniqueBulkCertificateRecordLazyQuery>;
export type FindUniqueBulkCertificateRecordQueryResult = Apollo.QueryResult<FindUniqueBulkCertificateRecordQuery, FindUniqueBulkCertificateRecordQueryVariables>;
export const FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlDocument = gql`
    query findUniqueTeamAndPublicDocumentBaseTypeByPublicUrl {
  findUniqueTeamAndPublicDocumentBaseTypeByPublicUrl {
    ...TeamAndPublicDocumentBaseTypeFields
  }
}
    ${TeamAndPublicDocumentBaseTypeFieldsFragmentDoc}`;

/**
 * __useFindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQuery__
 *
 * To run a query within a React component, call `useFindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQuery(baseOptions?: Apollo.QueryHookOptions<FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQuery, FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQuery, FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQueryVariables>(FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlDocument, options);
      }
export function useFindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQuery, FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQuery, FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQueryVariables>(FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlDocument, options);
        }
export type FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQueryHookResult = ReturnType<typeof useFindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQuery>;
export type FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlLazyQueryHookResult = ReturnType<typeof useFindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlLazyQuery>;
export type FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQueryResult = Apollo.QueryResult<FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQuery, FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQueryVariables>;
export const FindUniqueCertificateCourseDocument = gql`
    query findUniqueCertificateCourse($where: CertificateCourseWhereUniqueInput!) {
  findUniqueCertificateCourse(where: $where) {
    certificateBaseId
    name
    areaKnowledge
    metaData
    CertificateBase {
      createdAt
    }
    CourseLevel {
      certificateBaseId
      name
    }
  }
}
    `;

/**
 * __useFindUniqueCertificateCourseQuery__
 *
 * To run a query within a React component, call `useFindUniqueCertificateCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueCertificateCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueCertificateCourseQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueCertificateCourseQuery(baseOptions: Apollo.QueryHookOptions<FindUniqueCertificateCourseQuery, FindUniqueCertificateCourseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUniqueCertificateCourseQuery, FindUniqueCertificateCourseQueryVariables>(FindUniqueCertificateCourseDocument, options);
      }
export function useFindUniqueCertificateCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUniqueCertificateCourseQuery, FindUniqueCertificateCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUniqueCertificateCourseQuery, FindUniqueCertificateCourseQueryVariables>(FindUniqueCertificateCourseDocument, options);
        }
export type FindUniqueCertificateCourseQueryHookResult = ReturnType<typeof useFindUniqueCertificateCourseQuery>;
export type FindUniqueCertificateCourseLazyQueryHookResult = ReturnType<typeof useFindUniqueCertificateCourseLazyQuery>;
export type FindUniqueCertificateCourseQueryResult = Apollo.QueryResult<FindUniqueCertificateCourseQuery, FindUniqueCertificateCourseQueryVariables>;
export const FindUniqueCertificateCourseLevelDocument = gql`
    query findUniqueCertificateCourseLevel($where: CertificateCourseLevelWhereUniqueInput!) {
  findUniqueCertificateCourseLevel(where: $where) {
    name
    certificateBaseId
    CertificateBase {
      createdAt
    }
  }
}
    `;

/**
 * __useFindUniqueCertificateCourseLevelQuery__
 *
 * To run a query within a React component, call `useFindUniqueCertificateCourseLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueCertificateCourseLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueCertificateCourseLevelQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueCertificateCourseLevelQuery(baseOptions: Apollo.QueryHookOptions<FindUniqueCertificateCourseLevelQuery, FindUniqueCertificateCourseLevelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUniqueCertificateCourseLevelQuery, FindUniqueCertificateCourseLevelQueryVariables>(FindUniqueCertificateCourseLevelDocument, options);
      }
export function useFindUniqueCertificateCourseLevelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUniqueCertificateCourseLevelQuery, FindUniqueCertificateCourseLevelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUniqueCertificateCourseLevelQuery, FindUniqueCertificateCourseLevelQueryVariables>(FindUniqueCertificateCourseLevelDocument, options);
        }
export type FindUniqueCertificateCourseLevelQueryHookResult = ReturnType<typeof useFindUniqueCertificateCourseLevelQuery>;
export type FindUniqueCertificateCourseLevelLazyQueryHookResult = ReturnType<typeof useFindUniqueCertificateCourseLevelLazyQuery>;
export type FindUniqueCertificateCourseLevelQueryResult = Apollo.QueryResult<FindUniqueCertificateCourseLevelQuery, FindUniqueCertificateCourseLevelQueryVariables>;
export const FindUniqueCertificateCurriculumDocument = gql`
    query findUniqueCertificateCurriculum($where: CertificateCurriculumWhereUniqueInput!) {
  findUniqueCertificateCurriculum(where: $where) {
    name
    amountOfHours
    CertificateCourse {
      certificateBaseId
      name
    }
    CertificateCurriculumSelectedDisciplines {
      ...SelectedDisciplineFields
    }
  }
}
    ${SelectedDisciplineFieldsFragmentDoc}`;

/**
 * __useFindUniqueCertificateCurriculumQuery__
 *
 * To run a query within a React component, call `useFindUniqueCertificateCurriculumQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueCertificateCurriculumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueCertificateCurriculumQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueCertificateCurriculumQuery(baseOptions: Apollo.QueryHookOptions<FindUniqueCertificateCurriculumQuery, FindUniqueCertificateCurriculumQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUniqueCertificateCurriculumQuery, FindUniqueCertificateCurriculumQueryVariables>(FindUniqueCertificateCurriculumDocument, options);
      }
export function useFindUniqueCertificateCurriculumLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUniqueCertificateCurriculumQuery, FindUniqueCertificateCurriculumQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUniqueCertificateCurriculumQuery, FindUniqueCertificateCurriculumQueryVariables>(FindUniqueCertificateCurriculumDocument, options);
        }
export type FindUniqueCertificateCurriculumQueryHookResult = ReturnType<typeof useFindUniqueCertificateCurriculumQuery>;
export type FindUniqueCertificateCurriculumLazyQueryHookResult = ReturnType<typeof useFindUniqueCertificateCurriculumLazyQuery>;
export type FindUniqueCertificateCurriculumQueryResult = Apollo.QueryResult<FindUniqueCertificateCurriculumQuery, FindUniqueCertificateCurriculumQueryVariables>;
export const FindUniqueCertificateDisciplineDocument = gql`
    query findUniqueCertificateDiscipline($where: CertificateDisciplineWhereUniqueInput!) {
  findUniqueCertificateDiscipline(where: $where) {
    certificateBaseId
    name
    viewOnDegree
  }
}
    `;

/**
 * __useFindUniqueCertificateDisciplineQuery__
 *
 * To run a query within a React component, call `useFindUniqueCertificateDisciplineQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueCertificateDisciplineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueCertificateDisciplineQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueCertificateDisciplineQuery(baseOptions: Apollo.QueryHookOptions<FindUniqueCertificateDisciplineQuery, FindUniqueCertificateDisciplineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUniqueCertificateDisciplineQuery, FindUniqueCertificateDisciplineQueryVariables>(FindUniqueCertificateDisciplineDocument, options);
      }
export function useFindUniqueCertificateDisciplineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUniqueCertificateDisciplineQuery, FindUniqueCertificateDisciplineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUniqueCertificateDisciplineQuery, FindUniqueCertificateDisciplineQueryVariables>(FindUniqueCertificateDisciplineDocument, options);
        }
export type FindUniqueCertificateDisciplineQueryHookResult = ReturnType<typeof useFindUniqueCertificateDisciplineQuery>;
export type FindUniqueCertificateDisciplineLazyQueryHookResult = ReturnType<typeof useFindUniqueCertificateDisciplineLazyQuery>;
export type FindUniqueCertificateDisciplineQueryResult = Apollo.QueryResult<FindUniqueCertificateDisciplineQuery, FindUniqueCertificateDisciplineQueryVariables>;
export const FindUniqueCertificateEventDocument = gql`
    query findUniqueCertificateEvent($where: CertificateEventWhereUniqueInput!) {
  findUniqueCertificateEvent(where: $where) {
    certificateBaseId
    name
    CertificateBase {
      createdAt
    }
  }
}
    `;

/**
 * __useFindUniqueCertificateEventQuery__
 *
 * To run a query within a React component, call `useFindUniqueCertificateEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueCertificateEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueCertificateEventQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueCertificateEventQuery(baseOptions: Apollo.QueryHookOptions<FindUniqueCertificateEventQuery, FindUniqueCertificateEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUniqueCertificateEventQuery, FindUniqueCertificateEventQueryVariables>(FindUniqueCertificateEventDocument, options);
      }
export function useFindUniqueCertificateEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUniqueCertificateEventQuery, FindUniqueCertificateEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUniqueCertificateEventQuery, FindUniqueCertificateEventQueryVariables>(FindUniqueCertificateEventDocument, options);
        }
export type FindUniqueCertificateEventQueryHookResult = ReturnType<typeof useFindUniqueCertificateEventQuery>;
export type FindUniqueCertificateEventLazyQueryHookResult = ReturnType<typeof useFindUniqueCertificateEventLazyQuery>;
export type FindUniqueCertificateEventQueryResult = Apollo.QueryResult<FindUniqueCertificateEventQuery, FindUniqueCertificateEventQueryVariables>;
export const FindUniqueCertificateTeacherDocument = gql`
    query findUniqueCertificateTeacher($where: CertificateTeacherWhereUniqueInput!) {
  findUniqueCertificateTeacher(where: $where) {
    certificateBaseId
    name
    titration
    CertificateBase {
      createdAt
    }
  }
}
    `;

/**
 * __useFindUniqueCertificateTeacherQuery__
 *
 * To run a query within a React component, call `useFindUniqueCertificateTeacherQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueCertificateTeacherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueCertificateTeacherQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueCertificateTeacherQuery(baseOptions: Apollo.QueryHookOptions<FindUniqueCertificateTeacherQuery, FindUniqueCertificateTeacherQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUniqueCertificateTeacherQuery, FindUniqueCertificateTeacherQueryVariables>(FindUniqueCertificateTeacherDocument, options);
      }
export function useFindUniqueCertificateTeacherLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUniqueCertificateTeacherQuery, FindUniqueCertificateTeacherQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUniqueCertificateTeacherQuery, FindUniqueCertificateTeacherQueryVariables>(FindUniqueCertificateTeacherDocument, options);
        }
export type FindUniqueCertificateTeacherQueryHookResult = ReturnType<typeof useFindUniqueCertificateTeacherQuery>;
export type FindUniqueCertificateTeacherLazyQueryHookResult = ReturnType<typeof useFindUniqueCertificateTeacherLazyQuery>;
export type FindUniqueCertificateTeacherQueryResult = Apollo.QueryResult<FindUniqueCertificateTeacherQuery, FindUniqueCertificateTeacherQueryVariables>;
export const FindUniqueCertificateTemplateDocument = gql`
    query findUniqueCertificateTemplate($where: CertificateTemplateWhereUniqueInput!) {
  findUniqueCertificateTemplate(where: $where) {
    ...CertificateTemplateFields
  }
}
    ${CertificateTemplateFieldsFragmentDoc}`;

/**
 * __useFindUniqueCertificateTemplateQuery__
 *
 * To run a query within a React component, call `useFindUniqueCertificateTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueCertificateTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueCertificateTemplateQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueCertificateTemplateQuery(baseOptions: Apollo.QueryHookOptions<FindUniqueCertificateTemplateQuery, FindUniqueCertificateTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUniqueCertificateTemplateQuery, FindUniqueCertificateTemplateQueryVariables>(FindUniqueCertificateTemplateDocument, options);
      }
export function useFindUniqueCertificateTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUniqueCertificateTemplateQuery, FindUniqueCertificateTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUniqueCertificateTemplateQuery, FindUniqueCertificateTemplateQueryVariables>(FindUniqueCertificateTemplateDocument, options);
        }
export type FindUniqueCertificateTemplateQueryHookResult = ReturnType<typeof useFindUniqueCertificateTemplateQuery>;
export type FindUniqueCertificateTemplateLazyQueryHookResult = ReturnType<typeof useFindUniqueCertificateTemplateLazyQuery>;
export type FindUniqueCertificateTemplateQueryResult = Apollo.QueryResult<FindUniqueCertificateTemplateQuery, FindUniqueCertificateTemplateQueryVariables>;
export const FindUniqueDocumentDegreeDocument = gql`
    query findUniqueDocumentDegree($where: DocumentDegreeWhereUniqueInput!) {
  findUniqueDocumentDegree(where: $where) {
    ...DocumentDegreeUniqueFields
  }
}
    ${DocumentDegreeUniqueFieldsFragmentDoc}`;

/**
 * __useFindUniqueDocumentDegreeQuery__
 *
 * To run a query within a React component, call `useFindUniqueDocumentDegreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueDocumentDegreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueDocumentDegreeQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueDocumentDegreeQuery(baseOptions: Apollo.QueryHookOptions<FindUniqueDocumentDegreeQuery, FindUniqueDocumentDegreeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUniqueDocumentDegreeQuery, FindUniqueDocumentDegreeQueryVariables>(FindUniqueDocumentDegreeDocument, options);
      }
export function useFindUniqueDocumentDegreeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUniqueDocumentDegreeQuery, FindUniqueDocumentDegreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUniqueDocumentDegreeQuery, FindUniqueDocumentDegreeQueryVariables>(FindUniqueDocumentDegreeDocument, options);
        }
export type FindUniqueDocumentDegreeQueryHookResult = ReturnType<typeof useFindUniqueDocumentDegreeQuery>;
export type FindUniqueDocumentDegreeLazyQueryHookResult = ReturnType<typeof useFindUniqueDocumentDegreeLazyQuery>;
export type FindUniqueDocumentDegreeQueryResult = Apollo.QueryResult<FindUniqueDocumentDegreeQuery, FindUniqueDocumentDegreeQueryVariables>;
export const FindUniqueDegreeToSeeBySecurityCodeDocument = gql`
    query findUniqueDegreeToSeeBySecurityCode($domain: String!, $recaptchaResponse: String!, $securityCode: String!) {
  findUniqueDegreeToSeeBySecurityCode(
    domain: $domain
    recaptchaResponse: $recaptchaResponse
    securityCode: $securityCode
  ) {
    ...DegreeViewDegree
  }
}
    ${DegreeViewDegreeFragmentDoc}`;

/**
 * __useFindUniqueDegreeToSeeBySecurityCodeQuery__
 *
 * To run a query within a React component, call `useFindUniqueDegreeToSeeBySecurityCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueDegreeToSeeBySecurityCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueDegreeToSeeBySecurityCodeQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *      recaptchaResponse: // value for 'recaptchaResponse'
 *      securityCode: // value for 'securityCode'
 *   },
 * });
 */
export function useFindUniqueDegreeToSeeBySecurityCodeQuery(baseOptions: Apollo.QueryHookOptions<FindUniqueDegreeToSeeBySecurityCodeQuery, FindUniqueDegreeToSeeBySecurityCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUniqueDegreeToSeeBySecurityCodeQuery, FindUniqueDegreeToSeeBySecurityCodeQueryVariables>(FindUniqueDegreeToSeeBySecurityCodeDocument, options);
      }
export function useFindUniqueDegreeToSeeBySecurityCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUniqueDegreeToSeeBySecurityCodeQuery, FindUniqueDegreeToSeeBySecurityCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUniqueDegreeToSeeBySecurityCodeQuery, FindUniqueDegreeToSeeBySecurityCodeQueryVariables>(FindUniqueDegreeToSeeBySecurityCodeDocument, options);
        }
export type FindUniqueDegreeToSeeBySecurityCodeQueryHookResult = ReturnType<typeof useFindUniqueDegreeToSeeBySecurityCodeQuery>;
export type FindUniqueDegreeToSeeBySecurityCodeLazyQueryHookResult = ReturnType<typeof useFindUniqueDegreeToSeeBySecurityCodeLazyQuery>;
export type FindUniqueDegreeToSeeBySecurityCodeQueryResult = Apollo.QueryResult<FindUniqueDegreeToSeeBySecurityCodeQuery, FindUniqueDegreeToSeeBySecurityCodeQueryVariables>;
export const FindUniqueDocumentAcademicDocumentationDocument = gql`
    query findUniqueDocumentAcademicDocumentation($where: DocumentAcademicDocumentationWhereUniqueInput!) {
  findUnique: findUniqueDocumentAcademicDocumentation(where: $where) {
    ...DocumentAcademicDocumentationFields
  }
}
    ${DocumentAcademicDocumentationFieldsFragmentDoc}`;

/**
 * __useFindUniqueDocumentAcademicDocumentationQuery__
 *
 * To run a query within a React component, call `useFindUniqueDocumentAcademicDocumentationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueDocumentAcademicDocumentationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueDocumentAcademicDocumentationQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueDocumentAcademicDocumentationQuery(baseOptions: Apollo.QueryHookOptions<FindUniqueDocumentAcademicDocumentationQuery, FindUniqueDocumentAcademicDocumentationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUniqueDocumentAcademicDocumentationQuery, FindUniqueDocumentAcademicDocumentationQueryVariables>(FindUniqueDocumentAcademicDocumentationDocument, options);
      }
export function useFindUniqueDocumentAcademicDocumentationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUniqueDocumentAcademicDocumentationQuery, FindUniqueDocumentAcademicDocumentationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUniqueDocumentAcademicDocumentationQuery, FindUniqueDocumentAcademicDocumentationQueryVariables>(FindUniqueDocumentAcademicDocumentationDocument, options);
        }
export type FindUniqueDocumentAcademicDocumentationQueryHookResult = ReturnType<typeof useFindUniqueDocumentAcademicDocumentationQuery>;
export type FindUniqueDocumentAcademicDocumentationLazyQueryHookResult = ReturnType<typeof useFindUniqueDocumentAcademicDocumentationLazyQuery>;
export type FindUniqueDocumentAcademicDocumentationQueryResult = Apollo.QueryResult<FindUniqueDocumentAcademicDocumentationQuery, FindUniqueDocumentAcademicDocumentationQueryVariables>;
export const FindUniqueDocumentAuditFileIssuerDocument = gql`
    query findUniqueDocumentAuditFileIssuer($where: DocumentAuditFileIssuerWhereUniqueInput!) {
  findUnique: findUniqueDocumentAuditFileIssuer(where: $where) {
    ...DocumentAuditFileIssuerFields
  }
}
    ${DocumentAuditFileIssuerFieldsFragmentDoc}`;

/**
 * __useFindUniqueDocumentAuditFileIssuerQuery__
 *
 * To run a query within a React component, call `useFindUniqueDocumentAuditFileIssuerQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueDocumentAuditFileIssuerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueDocumentAuditFileIssuerQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueDocumentAuditFileIssuerQuery(baseOptions: Apollo.QueryHookOptions<FindUniqueDocumentAuditFileIssuerQuery, FindUniqueDocumentAuditFileIssuerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUniqueDocumentAuditFileIssuerQuery, FindUniqueDocumentAuditFileIssuerQueryVariables>(FindUniqueDocumentAuditFileIssuerDocument, options);
      }
export function useFindUniqueDocumentAuditFileIssuerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUniqueDocumentAuditFileIssuerQuery, FindUniqueDocumentAuditFileIssuerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUniqueDocumentAuditFileIssuerQuery, FindUniqueDocumentAuditFileIssuerQueryVariables>(FindUniqueDocumentAuditFileIssuerDocument, options);
        }
export type FindUniqueDocumentAuditFileIssuerQueryHookResult = ReturnType<typeof useFindUniqueDocumentAuditFileIssuerQuery>;
export type FindUniqueDocumentAuditFileIssuerLazyQueryHookResult = ReturnType<typeof useFindUniqueDocumentAuditFileIssuerLazyQuery>;
export type FindUniqueDocumentAuditFileIssuerQueryResult = Apollo.QueryResult<FindUniqueDocumentAuditFileIssuerQuery, FindUniqueDocumentAuditFileIssuerQueryVariables>;
export const FindUniqueDocumentBaseDefaultSignatureInviteConfigurationDocument = gql`
    query findUniqueDocumentBaseDefaultSignatureInviteConfiguration($where: DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput!) {
  findUniqueDocumentBaseDefaultSignatureInviteConfiguration(where: $where) {
    id
    type
    createdAt
    updatedAt
    addSignersNode
    signatureConfig
    Groups {
      id
      Items {
        id
        teamMemberId
        TeamMember {
          id
          User {
            id
            name
            email
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFindUniqueDocumentBaseDefaultSignatureInviteConfigurationQuery__
 *
 * To run a query within a React component, call `useFindUniqueDocumentBaseDefaultSignatureInviteConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueDocumentBaseDefaultSignatureInviteConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueDocumentBaseDefaultSignatureInviteConfigurationQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueDocumentBaseDefaultSignatureInviteConfigurationQuery(baseOptions: Apollo.QueryHookOptions<FindUniqueDocumentBaseDefaultSignatureInviteConfigurationQuery, FindUniqueDocumentBaseDefaultSignatureInviteConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUniqueDocumentBaseDefaultSignatureInviteConfigurationQuery, FindUniqueDocumentBaseDefaultSignatureInviteConfigurationQueryVariables>(FindUniqueDocumentBaseDefaultSignatureInviteConfigurationDocument, options);
      }
export function useFindUniqueDocumentBaseDefaultSignatureInviteConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUniqueDocumentBaseDefaultSignatureInviteConfigurationQuery, FindUniqueDocumentBaseDefaultSignatureInviteConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUniqueDocumentBaseDefaultSignatureInviteConfigurationQuery, FindUniqueDocumentBaseDefaultSignatureInviteConfigurationQueryVariables>(FindUniqueDocumentBaseDefaultSignatureInviteConfigurationDocument, options);
        }
export type FindUniqueDocumentBaseDefaultSignatureInviteConfigurationQueryHookResult = ReturnType<typeof useFindUniqueDocumentBaseDefaultSignatureInviteConfigurationQuery>;
export type FindUniqueDocumentBaseDefaultSignatureInviteConfigurationLazyQueryHookResult = ReturnType<typeof useFindUniqueDocumentBaseDefaultSignatureInviteConfigurationLazyQuery>;
export type FindUniqueDocumentBaseDefaultSignatureInviteConfigurationQueryResult = Apollo.QueryResult<FindUniqueDocumentBaseDefaultSignatureInviteConfigurationQuery, FindUniqueDocumentBaseDefaultSignatureInviteConfigurationQueryVariables>;
export const FindUniqueDocumentBaseSignatureInviteDocument = gql`
    query findUniqueDocumentBaseSignatureInvite($where: DocumentBaseSignatureInviteWhereUniqueInput!) {
  findUniqueDocumentBaseSignatureInvite(where: $where) {
    ...DocumentBaseSignatureInviteFields
  }
}
    ${DocumentBaseSignatureInviteFieldsFragmentDoc}`;

/**
 * __useFindUniqueDocumentBaseSignatureInviteQuery__
 *
 * To run a query within a React component, call `useFindUniqueDocumentBaseSignatureInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueDocumentBaseSignatureInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueDocumentBaseSignatureInviteQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueDocumentBaseSignatureInviteQuery(baseOptions: Apollo.QueryHookOptions<FindUniqueDocumentBaseSignatureInviteQuery, FindUniqueDocumentBaseSignatureInviteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUniqueDocumentBaseSignatureInviteQuery, FindUniqueDocumentBaseSignatureInviteQueryVariables>(FindUniqueDocumentBaseSignatureInviteDocument, options);
      }
export function useFindUniqueDocumentBaseSignatureInviteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUniqueDocumentBaseSignatureInviteQuery, FindUniqueDocumentBaseSignatureInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUniqueDocumentBaseSignatureInviteQuery, FindUniqueDocumentBaseSignatureInviteQueryVariables>(FindUniqueDocumentBaseSignatureInviteDocument, options);
        }
export type FindUniqueDocumentBaseSignatureInviteQueryHookResult = ReturnType<typeof useFindUniqueDocumentBaseSignatureInviteQuery>;
export type FindUniqueDocumentBaseSignatureInviteLazyQueryHookResult = ReturnType<typeof useFindUniqueDocumentBaseSignatureInviteLazyQuery>;
export type FindUniqueDocumentBaseSignatureInviteQueryResult = Apollo.QueryResult<FindUniqueDocumentBaseSignatureInviteQuery, FindUniqueDocumentBaseSignatureInviteQueryVariables>;
export const FindUniqueDocumentBaseSignatureInviteGroupDocument = gql`
    query FindUniqueDocumentBaseSignatureInviteGroup($where: DocumentBaseSignatureInviteGroupWhereUniqueInput!) {
  findUniqueDocumentBaseSignatureInviteGroup(where: $where) {
    documentBaseId
    DocumentBase {
      type
    }
  }
}
    `;

/**
 * __useFindUniqueDocumentBaseSignatureInviteGroupQuery__
 *
 * To run a query within a React component, call `useFindUniqueDocumentBaseSignatureInviteGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueDocumentBaseSignatureInviteGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueDocumentBaseSignatureInviteGroupQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueDocumentBaseSignatureInviteGroupQuery(baseOptions: Apollo.QueryHookOptions<FindUniqueDocumentBaseSignatureInviteGroupQuery, FindUniqueDocumentBaseSignatureInviteGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUniqueDocumentBaseSignatureInviteGroupQuery, FindUniqueDocumentBaseSignatureInviteGroupQueryVariables>(FindUniqueDocumentBaseSignatureInviteGroupDocument, options);
      }
export function useFindUniqueDocumentBaseSignatureInviteGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUniqueDocumentBaseSignatureInviteGroupQuery, FindUniqueDocumentBaseSignatureInviteGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUniqueDocumentBaseSignatureInviteGroupQuery, FindUniqueDocumentBaseSignatureInviteGroupQueryVariables>(FindUniqueDocumentBaseSignatureInviteGroupDocument, options);
        }
export type FindUniqueDocumentBaseSignatureInviteGroupQueryHookResult = ReturnType<typeof useFindUniqueDocumentBaseSignatureInviteGroupQuery>;
export type FindUniqueDocumentBaseSignatureInviteGroupLazyQueryHookResult = ReturnType<typeof useFindUniqueDocumentBaseSignatureInviteGroupLazyQuery>;
export type FindUniqueDocumentBaseSignatureInviteGroupQueryResult = Apollo.QueryResult<FindUniqueDocumentBaseSignatureInviteGroupQuery, FindUniqueDocumentBaseSignatureInviteGroupQueryVariables>;
export const FindUniqueDocumentCertificateDocument = gql`
    query findUniqueDocumentCertificate($where: DocumentCertificateWhereUniqueInput!) {
  findUniqueDocumentCertificate(where: $where) {
    ...DocumentCertificateFields
  }
}
    ${DocumentCertificateFieldsFragmentDoc}`;

/**
 * __useFindUniqueDocumentCertificateQuery__
 *
 * To run a query within a React component, call `useFindUniqueDocumentCertificateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueDocumentCertificateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueDocumentCertificateQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueDocumentCertificateQuery(baseOptions: Apollo.QueryHookOptions<FindUniqueDocumentCertificateQuery, FindUniqueDocumentCertificateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUniqueDocumentCertificateQuery, FindUniqueDocumentCertificateQueryVariables>(FindUniqueDocumentCertificateDocument, options);
      }
export function useFindUniqueDocumentCertificateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUniqueDocumentCertificateQuery, FindUniqueDocumentCertificateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUniqueDocumentCertificateQuery, FindUniqueDocumentCertificateQueryVariables>(FindUniqueDocumentCertificateDocument, options);
        }
export type FindUniqueDocumentCertificateQueryHookResult = ReturnType<typeof useFindUniqueDocumentCertificateQuery>;
export type FindUniqueDocumentCertificateLazyQueryHookResult = ReturnType<typeof useFindUniqueDocumentCertificateLazyQuery>;
export type FindUniqueDocumentCertificateQueryResult = Apollo.QueryResult<FindUniqueDocumentCertificateQuery, FindUniqueDocumentCertificateQueryVariables>;
export const FindUniqueDocumentCertificateSignatureItemDocument = gql`
    query findUniqueDocumentCertificateSignatureItem($where: DocumentCertificateSignatureItemWhereUniqueInput!) {
  findUniqueDocumentCertificateSignatureItem(where: $where) {
    ...DocumentCertificateSignatureItemFields
  }
}
    ${DocumentCertificateSignatureItemFieldsFragmentDoc}`;

/**
 * __useFindUniqueDocumentCertificateSignatureItemQuery__
 *
 * To run a query within a React component, call `useFindUniqueDocumentCertificateSignatureItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueDocumentCertificateSignatureItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueDocumentCertificateSignatureItemQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueDocumentCertificateSignatureItemQuery(baseOptions: Apollo.QueryHookOptions<FindUniqueDocumentCertificateSignatureItemQuery, FindUniqueDocumentCertificateSignatureItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUniqueDocumentCertificateSignatureItemQuery, FindUniqueDocumentCertificateSignatureItemQueryVariables>(FindUniqueDocumentCertificateSignatureItemDocument, options);
      }
export function useFindUniqueDocumentCertificateSignatureItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUniqueDocumentCertificateSignatureItemQuery, FindUniqueDocumentCertificateSignatureItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUniqueDocumentCertificateSignatureItemQuery, FindUniqueDocumentCertificateSignatureItemQueryVariables>(FindUniqueDocumentCertificateSignatureItemDocument, options);
        }
export type FindUniqueDocumentCertificateSignatureItemQueryHookResult = ReturnType<typeof useFindUniqueDocumentCertificateSignatureItemQuery>;
export type FindUniqueDocumentCertificateSignatureItemLazyQueryHookResult = ReturnType<typeof useFindUniqueDocumentCertificateSignatureItemLazyQuery>;
export type FindUniqueDocumentCertificateSignatureItemQueryResult = Apollo.QueryResult<FindUniqueDocumentCertificateSignatureItemQuery, FindUniqueDocumentCertificateSignatureItemQueryVariables>;
export const FindUniqueDocumentFinalAcademicTranscriptDocument = gql`
    query findUniqueDocumentFinalAcademicTranscript($where: DocumentFinalAcademicTranscriptWhereUniqueInput!) {
  findUnique: findUniqueDocumentFinalAcademicTranscript(where: $where) {
    ...DocumentFinalAcademicTranscriptFields
  }
}
    ${DocumentFinalAcademicTranscriptFieldsFragmentDoc}`;

/**
 * __useFindUniqueDocumentFinalAcademicTranscriptQuery__
 *
 * To run a query within a React component, call `useFindUniqueDocumentFinalAcademicTranscriptQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueDocumentFinalAcademicTranscriptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueDocumentFinalAcademicTranscriptQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueDocumentFinalAcademicTranscriptQuery(baseOptions: Apollo.QueryHookOptions<FindUniqueDocumentFinalAcademicTranscriptQuery, FindUniqueDocumentFinalAcademicTranscriptQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUniqueDocumentFinalAcademicTranscriptQuery, FindUniqueDocumentFinalAcademicTranscriptQueryVariables>(FindUniqueDocumentFinalAcademicTranscriptDocument, options);
      }
export function useFindUniqueDocumentFinalAcademicTranscriptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUniqueDocumentFinalAcademicTranscriptQuery, FindUniqueDocumentFinalAcademicTranscriptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUniqueDocumentFinalAcademicTranscriptQuery, FindUniqueDocumentFinalAcademicTranscriptQueryVariables>(FindUniqueDocumentFinalAcademicTranscriptDocument, options);
        }
export type FindUniqueDocumentFinalAcademicTranscriptQueryHookResult = ReturnType<typeof useFindUniqueDocumentFinalAcademicTranscriptQuery>;
export type FindUniqueDocumentFinalAcademicTranscriptLazyQueryHookResult = ReturnType<typeof useFindUniqueDocumentFinalAcademicTranscriptLazyQuery>;
export type FindUniqueDocumentFinalAcademicTranscriptQueryResult = Apollo.QueryResult<FindUniqueDocumentFinalAcademicTranscriptQuery, FindUniqueDocumentFinalAcademicTranscriptQueryVariables>;
export const FindUniqueDocumentSchoolCurriculumDocument = gql`
    query findUniqueDocumentSchoolCurriculum($where: DocumentSchoolCurriculumWhereUniqueInput!) {
  findUniqueDocumentSchoolCurriculum(where: $where) {
    ...DocumentSchoolCurriculumFields
  }
}
    ${DocumentSchoolCurriculumFieldsFragmentDoc}`;

/**
 * __useFindUniqueDocumentSchoolCurriculumQuery__
 *
 * To run a query within a React component, call `useFindUniqueDocumentSchoolCurriculumQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueDocumentSchoolCurriculumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueDocumentSchoolCurriculumQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueDocumentSchoolCurriculumQuery(baseOptions: Apollo.QueryHookOptions<FindUniqueDocumentSchoolCurriculumQuery, FindUniqueDocumentSchoolCurriculumQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUniqueDocumentSchoolCurriculumQuery, FindUniqueDocumentSchoolCurriculumQueryVariables>(FindUniqueDocumentSchoolCurriculumDocument, options);
      }
export function useFindUniqueDocumentSchoolCurriculumLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUniqueDocumentSchoolCurriculumQuery, FindUniqueDocumentSchoolCurriculumQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUniqueDocumentSchoolCurriculumQuery, FindUniqueDocumentSchoolCurriculumQueryVariables>(FindUniqueDocumentSchoolCurriculumDocument, options);
        }
export type FindUniqueDocumentSchoolCurriculumQueryHookResult = ReturnType<typeof useFindUniqueDocumentSchoolCurriculumQuery>;
export type FindUniqueDocumentSchoolCurriculumLazyQueryHookResult = ReturnType<typeof useFindUniqueDocumentSchoolCurriculumLazyQuery>;
export type FindUniqueDocumentSchoolCurriculumQueryResult = Apollo.QueryResult<FindUniqueDocumentSchoolCurriculumQuery, FindUniqueDocumentSchoolCurriculumQueryVariables>;
export const FindUniqueExternalSignatureInviteDocument = gql`
    query findUniqueExternalSignatureInvite($where: ExternalSignatureInviteWhereUniqueInput!) {
  findUniqueExternalSignatureInvite(where: $where) {
    ...ExternalSignatureInviteFields
  }
}
    ${ExternalSignatureInviteFieldsFragmentDoc}`;

/**
 * __useFindUniqueExternalSignatureInviteQuery__
 *
 * To run a query within a React component, call `useFindUniqueExternalSignatureInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueExternalSignatureInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueExternalSignatureInviteQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueExternalSignatureInviteQuery(baseOptions: Apollo.QueryHookOptions<FindUniqueExternalSignatureInviteQuery, FindUniqueExternalSignatureInviteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUniqueExternalSignatureInviteQuery, FindUniqueExternalSignatureInviteQueryVariables>(FindUniqueExternalSignatureInviteDocument, options);
      }
export function useFindUniqueExternalSignatureInviteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUniqueExternalSignatureInviteQuery, FindUniqueExternalSignatureInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUniqueExternalSignatureInviteQuery, FindUniqueExternalSignatureInviteQueryVariables>(FindUniqueExternalSignatureInviteDocument, options);
        }
export type FindUniqueExternalSignatureInviteQueryHookResult = ReturnType<typeof useFindUniqueExternalSignatureInviteQuery>;
export type FindUniqueExternalSignatureInviteLazyQueryHookResult = ReturnType<typeof useFindUniqueExternalSignatureInviteLazyQuery>;
export type FindUniqueExternalSignatureInviteQueryResult = Apollo.QueryResult<FindUniqueExternalSignatureInviteQuery, FindUniqueExternalSignatureInviteQueryVariables>;
export const FindUniquePersonDocument = gql`
    query findUniquePerson($where: PersonWhereUniqueInput!) {
  findUniquePerson(where: $where) {
    ...PersonFields
  }
}
    ${PersonFieldsFragmentDoc}`;

/**
 * __useFindUniquePersonQuery__
 *
 * To run a query within a React component, call `useFindUniquePersonQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniquePersonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniquePersonQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniquePersonQuery(baseOptions: Apollo.QueryHookOptions<FindUniquePersonQuery, FindUniquePersonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUniquePersonQuery, FindUniquePersonQueryVariables>(FindUniquePersonDocument, options);
      }
export function useFindUniquePersonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUniquePersonQuery, FindUniquePersonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUniquePersonQuery, FindUniquePersonQueryVariables>(FindUniquePersonDocument, options);
        }
export type FindUniquePersonQueryHookResult = ReturnType<typeof useFindUniquePersonQuery>;
export type FindUniquePersonLazyQueryHookResult = ReturnType<typeof useFindUniquePersonLazyQuery>;
export type FindUniquePersonQueryResult = Apollo.QueryResult<FindUniquePersonQuery, FindUniquePersonQueryVariables>;
export const FindUniqueReusableFormDataCurriculumDocument = gql`
    query findUniqueReusableFormDataCurriculum($where: ReusableFormDataCurriculumWhereUniqueInput!) {
  findUniqueReusableFormDataCurriculum(where: $where) {
    ...ReusableFormDataCurriculumUniqueFields
  }
}
    ${ReusableFormDataCurriculumUniqueFieldsFragmentDoc}`;

/**
 * __useFindUniqueReusableFormDataCurriculumQuery__
 *
 * To run a query within a React component, call `useFindUniqueReusableFormDataCurriculumQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueReusableFormDataCurriculumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueReusableFormDataCurriculumQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueReusableFormDataCurriculumQuery(baseOptions: Apollo.QueryHookOptions<FindUniqueReusableFormDataCurriculumQuery, FindUniqueReusableFormDataCurriculumQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUniqueReusableFormDataCurriculumQuery, FindUniqueReusableFormDataCurriculumQueryVariables>(FindUniqueReusableFormDataCurriculumDocument, options);
      }
export function useFindUniqueReusableFormDataCurriculumLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUniqueReusableFormDataCurriculumQuery, FindUniqueReusableFormDataCurriculumQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUniqueReusableFormDataCurriculumQuery, FindUniqueReusableFormDataCurriculumQueryVariables>(FindUniqueReusableFormDataCurriculumDocument, options);
        }
export type FindUniqueReusableFormDataCurriculumQueryHookResult = ReturnType<typeof useFindUniqueReusableFormDataCurriculumQuery>;
export type FindUniqueReusableFormDataCurriculumLazyQueryHookResult = ReturnType<typeof useFindUniqueReusableFormDataCurriculumLazyQuery>;
export type FindUniqueReusableFormDataCurriculumQueryResult = Apollo.QueryResult<FindUniqueReusableFormDataCurriculumQuery, FindUniqueReusableFormDataCurriculumQueryVariables>;
export const FindUniqueSignSignatureImageDocument = gql`
    query findUniqueSignSignatureImage($where: SignSignatureImageWhereUniqueInput!) {
  findUniqueSignSignatureImage(where: $where) {
    ...SignSignatureImageUniqueFields
  }
}
    ${SignSignatureImageUniqueFieldsFragmentDoc}`;

/**
 * __useFindUniqueSignSignatureImageQuery__
 *
 * To run a query within a React component, call `useFindUniqueSignSignatureImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueSignSignatureImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueSignSignatureImageQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueSignSignatureImageQuery(baseOptions: Apollo.QueryHookOptions<FindUniqueSignSignatureImageQuery, FindUniqueSignSignatureImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUniqueSignSignatureImageQuery, FindUniqueSignSignatureImageQueryVariables>(FindUniqueSignSignatureImageDocument, options);
      }
export function useFindUniqueSignSignatureImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUniqueSignSignatureImageQuery, FindUniqueSignSignatureImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUniqueSignSignatureImageQuery, FindUniqueSignSignatureImageQueryVariables>(FindUniqueSignSignatureImageDocument, options);
        }
export type FindUniqueSignSignatureImageQueryHookResult = ReturnType<typeof useFindUniqueSignSignatureImageQuery>;
export type FindUniqueSignSignatureImageLazyQueryHookResult = ReturnType<typeof useFindUniqueSignSignatureImageLazyQuery>;
export type FindUniqueSignSignatureImageQueryResult = Apollo.QueryResult<FindUniqueSignSignatureImageQuery, FindUniqueSignSignatureImageQueryVariables>;
export const FindUniqueTeamDocument = gql`
    query findUniqueTeam($where: TeamWhereUniqueInput!, $take: Int, $skip: Int, $orderBy: [TeamMemberOrderByWithRelationInput!], $teamMemberWhere: TeamMemberWhereInput) {
  findUniqueTeam(where: $where) {
    ...UniqueTeamFields
  }
}
    ${UniqueTeamFieldsFragmentDoc}`;

/**
 * __useFindUniqueTeamQuery__
 *
 * To run a query within a React component, call `useFindUniqueTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueTeamQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *      teamMemberWhere: // value for 'teamMemberWhere'
 *   },
 * });
 */
export function useFindUniqueTeamQuery(baseOptions: Apollo.QueryHookOptions<FindUniqueTeamQuery, FindUniqueTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUniqueTeamQuery, FindUniqueTeamQueryVariables>(FindUniqueTeamDocument, options);
      }
export function useFindUniqueTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUniqueTeamQuery, FindUniqueTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUniqueTeamQuery, FindUniqueTeamQueryVariables>(FindUniqueTeamDocument, options);
        }
export type FindUniqueTeamQueryHookResult = ReturnType<typeof useFindUniqueTeamQuery>;
export type FindUniqueTeamLazyQueryHookResult = ReturnType<typeof useFindUniqueTeamLazyQuery>;
export type FindUniqueTeamQueryResult = Apollo.QueryResult<FindUniqueTeamQuery, FindUniqueTeamQueryVariables>;
export const FindUniqueTeamEducationLevelDocument = gql`
    query findUniqueTeamEducationLevel($where: TeamEducationLevelWhereUniqueInput!) {
  findUniqueTeamEducationLevel(where: $where) {
    id
    educationLevelType
    teamId
  }
}
    `;

/**
 * __useFindUniqueTeamEducationLevelQuery__
 *
 * To run a query within a React component, call `useFindUniqueTeamEducationLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueTeamEducationLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueTeamEducationLevelQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueTeamEducationLevelQuery(baseOptions: Apollo.QueryHookOptions<FindUniqueTeamEducationLevelQuery, FindUniqueTeamEducationLevelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUniqueTeamEducationLevelQuery, FindUniqueTeamEducationLevelQueryVariables>(FindUniqueTeamEducationLevelDocument, options);
      }
export function useFindUniqueTeamEducationLevelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUniqueTeamEducationLevelQuery, FindUniqueTeamEducationLevelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUniqueTeamEducationLevelQuery, FindUniqueTeamEducationLevelQueryVariables>(FindUniqueTeamEducationLevelDocument, options);
        }
export type FindUniqueTeamEducationLevelQueryHookResult = ReturnType<typeof useFindUniqueTeamEducationLevelQuery>;
export type FindUniqueTeamEducationLevelLazyQueryHookResult = ReturnType<typeof useFindUniqueTeamEducationLevelLazyQuery>;
export type FindUniqueTeamEducationLevelQueryResult = Apollo.QueryResult<FindUniqueTeamEducationLevelQuery, FindUniqueTeamEducationLevelQueryVariables>;
export const FindUniqueToSeePublicDocumentDocument = gql`
    query findUniqueToSeePublicDocument($recaptchaResponse: String!) {
  findUniqueToSeePublicDocument(recaptchaResponse: $recaptchaResponse) {
    ...PublicViewFields
  }
}
    ${PublicViewFieldsFragmentDoc}`;

/**
 * __useFindUniqueToSeePublicDocumentQuery__
 *
 * To run a query within a React component, call `useFindUniqueToSeePublicDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueToSeePublicDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueToSeePublicDocumentQuery({
 *   variables: {
 *      recaptchaResponse: // value for 'recaptchaResponse'
 *   },
 * });
 */
export function useFindUniqueToSeePublicDocumentQuery(baseOptions: Apollo.QueryHookOptions<FindUniqueToSeePublicDocumentQuery, FindUniqueToSeePublicDocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUniqueToSeePublicDocumentQuery, FindUniqueToSeePublicDocumentQueryVariables>(FindUniqueToSeePublicDocumentDocument, options);
      }
export function useFindUniqueToSeePublicDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUniqueToSeePublicDocumentQuery, FindUniqueToSeePublicDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUniqueToSeePublicDocumentQuery, FindUniqueToSeePublicDocumentQueryVariables>(FindUniqueToSeePublicDocumentDocument, options);
        }
export type FindUniqueToSeePublicDocumentQueryHookResult = ReturnType<typeof useFindUniqueToSeePublicDocumentQuery>;
export type FindUniqueToSeePublicDocumentLazyQueryHookResult = ReturnType<typeof useFindUniqueToSeePublicDocumentLazyQuery>;
export type FindUniqueToSeePublicDocumentQueryResult = Apollo.QueryResult<FindUniqueToSeePublicDocumentQuery, FindUniqueToSeePublicDocumentQueryVariables>;
export const ForceGenerateDocumentAcademicDocumentationDocument = gql`
    mutation forceGenerateDocumentAcademicDocumentation($docId: String!) {
  forceGenerateDocumentAcademicDocumentation(docId: $docId) {
    documentBaseId
  }
}
    `;
export type ForceGenerateDocumentAcademicDocumentationMutationFn = Apollo.MutationFunction<ForceGenerateDocumentAcademicDocumentationMutation, ForceGenerateDocumentAcademicDocumentationMutationVariables>;

/**
 * __useForceGenerateDocumentAcademicDocumentationMutation__
 *
 * To run a mutation, you first call `useForceGenerateDocumentAcademicDocumentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceGenerateDocumentAcademicDocumentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceGenerateDocumentAcademicDocumentationMutation, { data, loading, error }] = useForceGenerateDocumentAcademicDocumentationMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *   },
 * });
 */
export function useForceGenerateDocumentAcademicDocumentationMutation(baseOptions?: Apollo.MutationHookOptions<ForceGenerateDocumentAcademicDocumentationMutation, ForceGenerateDocumentAcademicDocumentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForceGenerateDocumentAcademicDocumentationMutation, ForceGenerateDocumentAcademicDocumentationMutationVariables>(ForceGenerateDocumentAcademicDocumentationDocument, options);
      }
export type ForceGenerateDocumentAcademicDocumentationMutationHookResult = ReturnType<typeof useForceGenerateDocumentAcademicDocumentationMutation>;
export type ForceGenerateDocumentAcademicDocumentationMutationResult = Apollo.MutationResult<ForceGenerateDocumentAcademicDocumentationMutation>;
export type ForceGenerateDocumentAcademicDocumentationMutationOptions = Apollo.BaseMutationOptions<ForceGenerateDocumentAcademicDocumentationMutation, ForceGenerateDocumentAcademicDocumentationMutationVariables>;
export const ForceGenerateDocumentSchoolCurriculumDocument = gql`
    mutation forceGenerateDocumentSchoolCurriculum($docId: String!) {
  forceGenerateDocumentSchoolCurriculum(docId: $docId) {
    documentBaseId
  }
}
    `;
export type ForceGenerateDocumentSchoolCurriculumMutationFn = Apollo.MutationFunction<ForceGenerateDocumentSchoolCurriculumMutation, ForceGenerateDocumentSchoolCurriculumMutationVariables>;

/**
 * __useForceGenerateDocumentSchoolCurriculumMutation__
 *
 * To run a mutation, you first call `useForceGenerateDocumentSchoolCurriculumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceGenerateDocumentSchoolCurriculumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceGenerateDocumentSchoolCurriculumMutation, { data, loading, error }] = useForceGenerateDocumentSchoolCurriculumMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *   },
 * });
 */
export function useForceGenerateDocumentSchoolCurriculumMutation(baseOptions?: Apollo.MutationHookOptions<ForceGenerateDocumentSchoolCurriculumMutation, ForceGenerateDocumentSchoolCurriculumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForceGenerateDocumentSchoolCurriculumMutation, ForceGenerateDocumentSchoolCurriculumMutationVariables>(ForceGenerateDocumentSchoolCurriculumDocument, options);
      }
export type ForceGenerateDocumentSchoolCurriculumMutationHookResult = ReturnType<typeof useForceGenerateDocumentSchoolCurriculumMutation>;
export type ForceGenerateDocumentSchoolCurriculumMutationResult = Apollo.MutationResult<ForceGenerateDocumentSchoolCurriculumMutation>;
export type ForceGenerateDocumentSchoolCurriculumMutationOptions = Apollo.BaseMutationOptions<ForceGenerateDocumentSchoolCurriculumMutation, ForceGenerateDocumentSchoolCurriculumMutationVariables>;
export const GenerateSampleCertificatePdfBase64Document = gql`
    query generateSampleCertificatePdfBase64($template: Json!) {
  generateSampleCertificatePdfBase64(template: $template)
}
    `;

/**
 * __useGenerateSampleCertificatePdfBase64Query__
 *
 * To run a query within a React component, call `useGenerateSampleCertificatePdfBase64Query` and pass it any options that fit your needs.
 * When your component renders, `useGenerateSampleCertificatePdfBase64Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateSampleCertificatePdfBase64Query({
 *   variables: {
 *      template: // value for 'template'
 *   },
 * });
 */
export function useGenerateSampleCertificatePdfBase64Query(baseOptions: Apollo.QueryHookOptions<GenerateSampleCertificatePdfBase64Query, GenerateSampleCertificatePdfBase64QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateSampleCertificatePdfBase64Query, GenerateSampleCertificatePdfBase64QueryVariables>(GenerateSampleCertificatePdfBase64Document, options);
      }
export function useGenerateSampleCertificatePdfBase64LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateSampleCertificatePdfBase64Query, GenerateSampleCertificatePdfBase64QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateSampleCertificatePdfBase64Query, GenerateSampleCertificatePdfBase64QueryVariables>(GenerateSampleCertificatePdfBase64Document, options);
        }
export type GenerateSampleCertificatePdfBase64QueryHookResult = ReturnType<typeof useGenerateSampleCertificatePdfBase64Query>;
export type GenerateSampleCertificatePdfBase64LazyQueryHookResult = ReturnType<typeof useGenerateSampleCertificatePdfBase64LazyQuery>;
export type GenerateSampleCertificatePdfBase64QueryResult = Apollo.QueryResult<GenerateSampleCertificatePdfBase64Query, GenerateSampleCertificatePdfBase64QueryVariables>;
export const GetDocumentJsonDocument = gql`
    query getDocumentJson($where: DocumentAcademicDocumentationWhereInput) {
  findFirstDocumentAcademicDocumentation(where: $where) {
    documentBaseId
    DocumentBase {
      dataWithIesAndFiles
    }
  }
}
    `;

/**
 * __useGetDocumentJsonQuery__
 *
 * To run a query within a React component, call `useGetDocumentJsonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentJsonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentJsonQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetDocumentJsonQuery(baseOptions?: Apollo.QueryHookOptions<GetDocumentJsonQuery, GetDocumentJsonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentJsonQuery, GetDocumentJsonQueryVariables>(GetDocumentJsonDocument, options);
      }
export function useGetDocumentJsonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentJsonQuery, GetDocumentJsonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentJsonQuery, GetDocumentJsonQueryVariables>(GetDocumentJsonDocument, options);
        }
export type GetDocumentJsonQueryHookResult = ReturnType<typeof useGetDocumentJsonQuery>;
export type GetDocumentJsonLazyQueryHookResult = ReturnType<typeof useGetDocumentJsonLazyQuery>;
export type GetDocumentJsonQueryResult = Apollo.QueryResult<GetDocumentJsonQuery, GetDocumentJsonQueryVariables>;
export const GetDocumentJsonSchoolCurriculumDocument = gql`
    query getDocumentJsonSchoolCurriculum($where: DocumentSchoolCurriculumWhereUniqueInput!) {
  findUniqueDocumentSchoolCurriculum(where: $where) {
    ...DocumentSchoolCurriculumFields
  }
}
    ${DocumentSchoolCurriculumFieldsFragmentDoc}`;

/**
 * __useGetDocumentJsonSchoolCurriculumQuery__
 *
 * To run a query within a React component, call `useGetDocumentJsonSchoolCurriculumQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentJsonSchoolCurriculumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentJsonSchoolCurriculumQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetDocumentJsonSchoolCurriculumQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentJsonSchoolCurriculumQuery, GetDocumentJsonSchoolCurriculumQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentJsonSchoolCurriculumQuery, GetDocumentJsonSchoolCurriculumQueryVariables>(GetDocumentJsonSchoolCurriculumDocument, options);
      }
export function useGetDocumentJsonSchoolCurriculumLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentJsonSchoolCurriculumQuery, GetDocumentJsonSchoolCurriculumQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentJsonSchoolCurriculumQuery, GetDocumentJsonSchoolCurriculumQueryVariables>(GetDocumentJsonSchoolCurriculumDocument, options);
        }
export type GetDocumentJsonSchoolCurriculumQueryHookResult = ReturnType<typeof useGetDocumentJsonSchoolCurriculumQuery>;
export type GetDocumentJsonSchoolCurriculumLazyQueryHookResult = ReturnType<typeof useGetDocumentJsonSchoolCurriculumLazyQuery>;
export type GetDocumentJsonSchoolCurriculumQueryResult = Apollo.QueryResult<GetDocumentJsonSchoolCurriculumQuery, GetDocumentJsonSchoolCurriculumQueryVariables>;
export const GetDocumentVariableJsonDocument = gql`
    query getDocumentVariableJson($removeFiles: Boolean, $coverWithMetaAndData: Boolean, $clean: Boolean, $where: DocumentAcademicDocumentationWhereInput) {
  findFirstDocumentAcademicDocumentation(where: $where) {
    DocumentBase {
      variableJson(
        removeFiles: $removeFiles
        coverWithMetaAndData: $coverWithMetaAndData
        clean: $clean
      )
    }
  }
}
    `;

/**
 * __useGetDocumentVariableJsonQuery__
 *
 * To run a query within a React component, call `useGetDocumentVariableJsonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentVariableJsonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentVariableJsonQuery({
 *   variables: {
 *      removeFiles: // value for 'removeFiles'
 *      coverWithMetaAndData: // value for 'coverWithMetaAndData'
 *      clean: // value for 'clean'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetDocumentVariableJsonQuery(baseOptions?: Apollo.QueryHookOptions<GetDocumentVariableJsonQuery, GetDocumentVariableJsonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentVariableJsonQuery, GetDocumentVariableJsonQueryVariables>(GetDocumentVariableJsonDocument, options);
      }
export function useGetDocumentVariableJsonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentVariableJsonQuery, GetDocumentVariableJsonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentVariableJsonQuery, GetDocumentVariableJsonQueryVariables>(GetDocumentVariableJsonDocument, options);
        }
export type GetDocumentVariableJsonQueryHookResult = ReturnType<typeof useGetDocumentVariableJsonQuery>;
export type GetDocumentVariableJsonLazyQueryHookResult = ReturnType<typeof useGetDocumentVariableJsonLazyQuery>;
export type GetDocumentVariableJsonQueryResult = Apollo.QueryResult<GetDocumentVariableJsonQuery, GetDocumentVariableJsonQueryVariables>;
export const GetFinancialRechargeDataDocument = gql`
    query getFinancialRechargeData {
  getFinancialRechargePlans {
    discounts {
      count
      valueInPercent
    }
    presets {
      count
    }
    servicesPrices {
      service
      unitPrice
    }
  }
  findManyFinancialCreditCardSaved {
    id
    token
    number
    brand
  }
}
    `;

/**
 * __useGetFinancialRechargeDataQuery__
 *
 * To run a query within a React component, call `useGetFinancialRechargeDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialRechargeDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialRechargeDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFinancialRechargeDataQuery(baseOptions?: Apollo.QueryHookOptions<GetFinancialRechargeDataQuery, GetFinancialRechargeDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinancialRechargeDataQuery, GetFinancialRechargeDataQueryVariables>(GetFinancialRechargeDataDocument, options);
      }
export function useGetFinancialRechargeDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFinancialRechargeDataQuery, GetFinancialRechargeDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinancialRechargeDataQuery, GetFinancialRechargeDataQueryVariables>(GetFinancialRechargeDataDocument, options);
        }
export type GetFinancialRechargeDataQueryHookResult = ReturnType<typeof useGetFinancialRechargeDataQuery>;
export type GetFinancialRechargeDataLazyQueryHookResult = ReturnType<typeof useGetFinancialRechargeDataLazyQuery>;
export type GetFinancialRechargeDataQueryResult = Apollo.QueryResult<GetFinancialRechargeDataQuery, GetFinancialRechargeDataQueryVariables>;
export const GetFinancialRechargePlansDocument = gql`
    query getFinancialRechargePlans {
  getFinancialRechargePlans {
    ...RechargeOptionsFields
  }
}
    ${RechargeOptionsFieldsFragmentDoc}`;

/**
 * __useGetFinancialRechargePlansQuery__
 *
 * To run a query within a React component, call `useGetFinancialRechargePlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialRechargePlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialRechargePlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFinancialRechargePlansQuery(baseOptions?: Apollo.QueryHookOptions<GetFinancialRechargePlansQuery, GetFinancialRechargePlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinancialRechargePlansQuery, GetFinancialRechargePlansQueryVariables>(GetFinancialRechargePlansDocument, options);
      }
export function useGetFinancialRechargePlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFinancialRechargePlansQuery, GetFinancialRechargePlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinancialRechargePlansQuery, GetFinancialRechargePlansQueryVariables>(GetFinancialRechargePlansDocument, options);
        }
export type GetFinancialRechargePlansQueryHookResult = ReturnType<typeof useGetFinancialRechargePlansQuery>;
export type GetFinancialRechargePlansLazyQueryHookResult = ReturnType<typeof useGetFinancialRechargePlansLazyQuery>;
export type GetFinancialRechargePlansQueryResult = Apollo.QueryResult<GetFinancialRechargePlansQuery, GetFinancialRechargePlansQueryVariables>;
export const GetMineTeamDocument = gql`
    query getMineTeam($orderBy: [TeamOrderByWithRelationInput!], $skip: Int, $take: Int, $where: TeamWhereInput) {
  getMineTeam(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
    id
    createdAt
    updatedAt
    TeamMember {
      ...TeamMemberFields
    }
    Documents {
      type
    }
  }
  count: getMineTeamCount(where: $where)
}
    ${TeamMemberFieldsFragmentDoc}`;

/**
 * __useGetMineTeamQuery__
 *
 * To run a query within a React component, call `useGetMineTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMineTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMineTeamQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetMineTeamQuery(baseOptions?: Apollo.QueryHookOptions<GetMineTeamQuery, GetMineTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMineTeamQuery, GetMineTeamQueryVariables>(GetMineTeamDocument, options);
      }
export function useGetMineTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMineTeamQuery, GetMineTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMineTeamQuery, GetMineTeamQueryVariables>(GetMineTeamDocument, options);
        }
export type GetMineTeamQueryHookResult = ReturnType<typeof useGetMineTeamQuery>;
export type GetMineTeamLazyQueryHookResult = ReturnType<typeof useGetMineTeamLazyQuery>;
export type GetMineTeamQueryResult = Apollo.QueryResult<GetMineTeamQuery, GetMineTeamQueryVariables>;
export const GetTeamConfigsDocument = gql`
    query getTeamConfigs($orderBy: [TeamOrderByWithRelationInput!], $skip: Int, $take: Int, $where: TeamWhereInput) {
  getMineTeam(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
    configAddDocumentSignerNode
  }
}
    `;

/**
 * __useGetTeamConfigsQuery__
 *
 * To run a query within a React component, call `useGetTeamConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamConfigsQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetTeamConfigsQuery(baseOptions?: Apollo.QueryHookOptions<GetTeamConfigsQuery, GetTeamConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamConfigsQuery, GetTeamConfigsQueryVariables>(GetTeamConfigsDocument, options);
      }
export function useGetTeamConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamConfigsQuery, GetTeamConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamConfigsQuery, GetTeamConfigsQueryVariables>(GetTeamConfigsDocument, options);
        }
export type GetTeamConfigsQueryHookResult = ReturnType<typeof useGetTeamConfigsQuery>;
export type GetTeamConfigsLazyQueryHookResult = ReturnType<typeof useGetTeamConfigsLazyQuery>;
export type GetTeamConfigsQueryResult = Apollo.QueryResult<GetTeamConfigsQuery, GetTeamConfigsQueryVariables>;
export const MeDocument = gql`
    query me {
  me {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const StartOneSignatureDocument = gql`
    mutation startOneSignature($inviteId: Int!, $certificate: String!) {
  startOneSignature(inviteId: $inviteId, certificate: $certificate) {
    dataToSign
    signingTime
    lastSignatureIsoString
  }
}
    `;
export type StartOneSignatureMutationFn = Apollo.MutationFunction<StartOneSignatureMutation, StartOneSignatureMutationVariables>;

/**
 * __useStartOneSignatureMutation__
 *
 * To run a mutation, you first call `useStartOneSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartOneSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startOneSignatureMutation, { data, loading, error }] = useStartOneSignatureMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *      certificate: // value for 'certificate'
 *   },
 * });
 */
export function useStartOneSignatureMutation(baseOptions?: Apollo.MutationHookOptions<StartOneSignatureMutation, StartOneSignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartOneSignatureMutation, StartOneSignatureMutationVariables>(StartOneSignatureDocument, options);
      }
export type StartOneSignatureMutationHookResult = ReturnType<typeof useStartOneSignatureMutation>;
export type StartOneSignatureMutationResult = Apollo.MutationResult<StartOneSignatureMutation>;
export type StartOneSignatureMutationOptions = Apollo.BaseMutationOptions<StartOneSignatureMutation, StartOneSignatureMutationVariables>;
export const StartOneSignatureExternalSignatureInviteDocument = gql`
    mutation startOneSignatureExternalSignatureInvite($inviteId: String!, $certificate: String!) {
  startOneSignature: startOneSignatureExternalSignatureInvite(
    inviteId: $inviteId
    certificate: $certificate
  ) {
    dataToSign
    signingTime
    lastSignatureIsoString
  }
}
    `;
export type StartOneSignatureExternalSignatureInviteMutationFn = Apollo.MutationFunction<StartOneSignatureExternalSignatureInviteMutation, StartOneSignatureExternalSignatureInviteMutationVariables>;

/**
 * __useStartOneSignatureExternalSignatureInviteMutation__
 *
 * To run a mutation, you first call `useStartOneSignatureExternalSignatureInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartOneSignatureExternalSignatureInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startOneSignatureExternalSignatureInviteMutation, { data, loading, error }] = useStartOneSignatureExternalSignatureInviteMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *      certificate: // value for 'certificate'
 *   },
 * });
 */
export function useStartOneSignatureExternalSignatureInviteMutation(baseOptions?: Apollo.MutationHookOptions<StartOneSignatureExternalSignatureInviteMutation, StartOneSignatureExternalSignatureInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartOneSignatureExternalSignatureInviteMutation, StartOneSignatureExternalSignatureInviteMutationVariables>(StartOneSignatureExternalSignatureInviteDocument, options);
      }
export type StartOneSignatureExternalSignatureInviteMutationHookResult = ReturnType<typeof useStartOneSignatureExternalSignatureInviteMutation>;
export type StartOneSignatureExternalSignatureInviteMutationResult = Apollo.MutationResult<StartOneSignatureExternalSignatureInviteMutation>;
export type StartOneSignatureExternalSignatureInviteMutationOptions = Apollo.BaseMutationOptions<StartOneSignatureExternalSignatureInviteMutation, StartOneSignatureExternalSignatureInviteMutationVariables>;
export const SummaryFinancialChargeDocument = gql`
    query summaryFinancialCharge($where: FinancialChargeWhereInput) {
  summaryFinancialCharge(where: $where) {
    sum
    count
  }
}
    `;

/**
 * __useSummaryFinancialChargeQuery__
 *
 * To run a query within a React component, call `useSummaryFinancialChargeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummaryFinancialChargeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummaryFinancialChargeQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSummaryFinancialChargeQuery(baseOptions?: Apollo.QueryHookOptions<SummaryFinancialChargeQuery, SummaryFinancialChargeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummaryFinancialChargeQuery, SummaryFinancialChargeQueryVariables>(SummaryFinancialChargeDocument, options);
      }
export function useSummaryFinancialChargeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummaryFinancialChargeQuery, SummaryFinancialChargeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummaryFinancialChargeQuery, SummaryFinancialChargeQueryVariables>(SummaryFinancialChargeDocument, options);
        }
export type SummaryFinancialChargeQueryHookResult = ReturnType<typeof useSummaryFinancialChargeQuery>;
export type SummaryFinancialChargeLazyQueryHookResult = ReturnType<typeof useSummaryFinancialChargeLazyQuery>;
export type SummaryFinancialChargeQueryResult = Apollo.QueryResult<SummaryFinancialChargeQuery, SummaryFinancialChargeQueryVariables>;
export const UpdateOneDegreeVisualRepresentationDocument = gql`
    mutation updateOneDegreeVisualRepresentation($degreeId: String!, $visualRepresentation: Upload!) {
  updateOneDegreeVisualRepresentation(
    degreeId: $degreeId
    visualRepresentation: $visualRepresentation
  ) {
    documentBaseId
  }
}
    `;
export type UpdateOneDegreeVisualRepresentationMutationFn = Apollo.MutationFunction<UpdateOneDegreeVisualRepresentationMutation, UpdateOneDegreeVisualRepresentationMutationVariables>;

/**
 * __useUpdateOneDegreeVisualRepresentationMutation__
 *
 * To run a mutation, you first call `useUpdateOneDegreeVisualRepresentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneDegreeVisualRepresentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneDegreeVisualRepresentationMutation, { data, loading, error }] = useUpdateOneDegreeVisualRepresentationMutation({
 *   variables: {
 *      degreeId: // value for 'degreeId'
 *      visualRepresentation: // value for 'visualRepresentation'
 *   },
 * });
 */
export function useUpdateOneDegreeVisualRepresentationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneDegreeVisualRepresentationMutation, UpdateOneDegreeVisualRepresentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneDegreeVisualRepresentationMutation, UpdateOneDegreeVisualRepresentationMutationVariables>(UpdateOneDegreeVisualRepresentationDocument, options);
      }
export type UpdateOneDegreeVisualRepresentationMutationHookResult = ReturnType<typeof useUpdateOneDegreeVisualRepresentationMutation>;
export type UpdateOneDegreeVisualRepresentationMutationResult = Apollo.MutationResult<UpdateOneDegreeVisualRepresentationMutation>;
export type UpdateOneDegreeVisualRepresentationMutationOptions = Apollo.BaseMutationOptions<UpdateOneDegreeVisualRepresentationMutation, UpdateOneDegreeVisualRepresentationMutationVariables>;
export const ValidateOneDocumentCertificateDocument = gql`
    query validateOneDocumentCertificate($file: Upload, $docId: String, $recaptchaResponse: String!) {
  validateOneDocumentCertificate(
    file: $file
    docId: $docId
    recaptchaResponse: $recaptchaResponse
  ) {
    certificate {
      ...DocumentCertificateValidateFields
    }
    validationResult {
      isValid
    }
  }
}
    ${DocumentCertificateValidateFieldsFragmentDoc}`;

/**
 * __useValidateOneDocumentCertificateQuery__
 *
 * To run a query within a React component, call `useValidateOneDocumentCertificateQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateOneDocumentCertificateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateOneDocumentCertificateQuery({
 *   variables: {
 *      file: // value for 'file'
 *      docId: // value for 'docId'
 *      recaptchaResponse: // value for 'recaptchaResponse'
 *   },
 * });
 */
export function useValidateOneDocumentCertificateQuery(baseOptions: Apollo.QueryHookOptions<ValidateOneDocumentCertificateQuery, ValidateOneDocumentCertificateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateOneDocumentCertificateQuery, ValidateOneDocumentCertificateQueryVariables>(ValidateOneDocumentCertificateDocument, options);
      }
export function useValidateOneDocumentCertificateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateOneDocumentCertificateQuery, ValidateOneDocumentCertificateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateOneDocumentCertificateQuery, ValidateOneDocumentCertificateQueryVariables>(ValidateOneDocumentCertificateDocument, options);
        }
export type ValidateOneDocumentCertificateQueryHookResult = ReturnType<typeof useValidateOneDocumentCertificateQuery>;
export type ValidateOneDocumentCertificateLazyQueryHookResult = ReturnType<typeof useValidateOneDocumentCertificateLazyQuery>;
export type ValidateOneDocumentCertificateQueryResult = Apollo.QueryResult<ValidateOneDocumentCertificateQuery, ValidateOneDocumentCertificateQueryVariables>;
export const WatchFindFirstDocumentAcademicDocumentationDocument = gql`
    subscription watchFindFirstDocumentAcademicDocumentation($where: DocumentAcademicDocumentationWhereInput!) {
  findFirstDocumentAcademicDocumentation(where: $where) {
    documentBaseId
    type
    DocumentBase {
      type
      internalSeqId
      version
      createdAt
      creationType
      data
      filePath
      signatureConfig
      UserOwner {
        id
        email
      }
      DocumentBaseSignatureInviteGroups {
        ...DocumentBaseSignatureInviteGroupFields
      }
      Histories(orderBy: {createdAt: asc}) {
        id
        description
        status
        createdAt
        data
        UserCreated {
          id
          name
          photo
          email
        }
      }
    }
    ChildDocuments {
      status
      DocumentBase {
        internalSeqId
        version
        createdAt
      }
    }
    status
  }
}
    ${DocumentBaseSignatureInviteGroupFieldsFragmentDoc}`;

/**
 * __useWatchFindFirstDocumentAcademicDocumentationSubscription__
 *
 * To run a query within a React component, call `useWatchFindFirstDocumentAcademicDocumentationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchFindFirstDocumentAcademicDocumentationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchFindFirstDocumentAcademicDocumentationSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useWatchFindFirstDocumentAcademicDocumentationSubscription(baseOptions: Apollo.SubscriptionHookOptions<WatchFindFirstDocumentAcademicDocumentationSubscription, WatchFindFirstDocumentAcademicDocumentationSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WatchFindFirstDocumentAcademicDocumentationSubscription, WatchFindFirstDocumentAcademicDocumentationSubscriptionVariables>(WatchFindFirstDocumentAcademicDocumentationDocument, options);
      }
export type WatchFindFirstDocumentAcademicDocumentationSubscriptionHookResult = ReturnType<typeof useWatchFindFirstDocumentAcademicDocumentationSubscription>;
export type WatchFindFirstDocumentAcademicDocumentationSubscriptionResult = Apollo.SubscriptionResult<WatchFindFirstDocumentAcademicDocumentationSubscription>;
export const FindUniqueSignSignatureImageSubDocument = gql`
    subscription findUniqueSignSignatureImageSub($where: SignSignatureImageWhereUniqueInput!) {
  findUniqueSignSignatureImage(where: $where) {
    ...SignSignatureImageUniqueFields
  }
}
    ${SignSignatureImageUniqueFieldsFragmentDoc}`;

/**
 * __useFindUniqueSignSignatureImageSubSubscription__
 *
 * To run a query within a React component, call `useFindUniqueSignSignatureImageSubSubscription` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueSignSignatureImageSubSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueSignSignatureImageSubSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueSignSignatureImageSubSubscription(baseOptions: Apollo.SubscriptionHookOptions<FindUniqueSignSignatureImageSubSubscription, FindUniqueSignSignatureImageSubSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<FindUniqueSignSignatureImageSubSubscription, FindUniqueSignSignatureImageSubSubscriptionVariables>(FindUniqueSignSignatureImageSubDocument, options);
      }
export type FindUniqueSignSignatureImageSubSubscriptionHookResult = ReturnType<typeof useFindUniqueSignSignatureImageSubSubscription>;
export type FindUniqueSignSignatureImageSubSubscriptionResult = Apollo.SubscriptionResult<FindUniqueSignSignatureImageSubSubscription>;
export const GeneratedCertificateDocument = gql`
    subscription GeneratedCertificate($institutionId: Int!, $bulkCertificateRecordId: String!) {
  generatedCertificate(
    institutionId: $institutionId
    bulkCertificateRecordId: $bulkCertificateRecordId
  ) {
    institutionId
    bulkCertificateRecordId
    certificateId
    totalIssued
    totalCertificates
  }
}
    `;

/**
 * __useGeneratedCertificateSubscription__
 *
 * To run a query within a React component, call `useGeneratedCertificateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGeneratedCertificateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeneratedCertificateSubscription({
 *   variables: {
 *      institutionId: // value for 'institutionId'
 *      bulkCertificateRecordId: // value for 'bulkCertificateRecordId'
 *   },
 * });
 */
export function useGeneratedCertificateSubscription(baseOptions: Apollo.SubscriptionHookOptions<GeneratedCertificateSubscription, GeneratedCertificateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GeneratedCertificateSubscription, GeneratedCertificateSubscriptionVariables>(GeneratedCertificateDocument, options);
      }
export type GeneratedCertificateSubscriptionHookResult = ReturnType<typeof useGeneratedCertificateSubscription>;
export type GeneratedCertificateSubscriptionResult = Apollo.SubscriptionResult<GeneratedCertificateSubscription>;
export const WatchSignBulkCertificateDocument = gql`
    subscription watchSignBulkCertificate($bulkId: String!) {
  watchSignBulkCertificate(bulkId: $bulkId) {
    documentsCompleted
    status
    totalInviteForSign
  }
}
    `;

/**
 * __useWatchSignBulkCertificateSubscription__
 *
 * To run a query within a React component, call `useWatchSignBulkCertificateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchSignBulkCertificateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchSignBulkCertificateSubscription({
 *   variables: {
 *      bulkId: // value for 'bulkId'
 *   },
 * });
 */
export function useWatchSignBulkCertificateSubscription(baseOptions: Apollo.SubscriptionHookOptions<WatchSignBulkCertificateSubscription, WatchSignBulkCertificateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WatchSignBulkCertificateSubscription, WatchSignBulkCertificateSubscriptionVariables>(WatchSignBulkCertificateDocument, options);
      }
export type WatchSignBulkCertificateSubscriptionHookResult = ReturnType<typeof useWatchSignBulkCertificateSubscription>;
export type WatchSignBulkCertificateSubscriptionResult = Apollo.SubscriptionResult<WatchSignBulkCertificateSubscription>;
export const WatchSignValidationBulkCertificateDocument = gql`
    subscription watchSignValidationBulkCertificate($bulkId: String!) {
  watchSignValidationBulkCertificate(bulkId: $bulkId) {
    status
  }
}
    `;

/**
 * __useWatchSignValidationBulkCertificateSubscription__
 *
 * To run a query within a React component, call `useWatchSignValidationBulkCertificateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchSignValidationBulkCertificateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchSignValidationBulkCertificateSubscription({
 *   variables: {
 *      bulkId: // value for 'bulkId'
 *   },
 * });
 */
export function useWatchSignValidationBulkCertificateSubscription(baseOptions: Apollo.SubscriptionHookOptions<WatchSignValidationBulkCertificateSubscription, WatchSignValidationBulkCertificateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WatchSignValidationBulkCertificateSubscription, WatchSignValidationBulkCertificateSubscriptionVariables>(WatchSignValidationBulkCertificateDocument, options);
      }
export type WatchSignValidationBulkCertificateSubscriptionHookResult = ReturnType<typeof useWatchSignValidationBulkCertificateSubscription>;
export type WatchSignValidationBulkCertificateSubscriptionResult = Apollo.SubscriptionResult<WatchSignValidationBulkCertificateSubscription>;
export const WatchSingleCertificateSignValidationEventDocument = gql`
    subscription watchSingleCertificateSignValidationEvent($inviteId: String!) {
  watchSingleCertificateSignValidationEvent(inviteId: $inviteId) {
    status
  }
}
    `;

/**
 * __useWatchSingleCertificateSignValidationEventSubscription__
 *
 * To run a query within a React component, call `useWatchSingleCertificateSignValidationEventSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchSingleCertificateSignValidationEventSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchSingleCertificateSignValidationEventSubscription({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useWatchSingleCertificateSignValidationEventSubscription(baseOptions: Apollo.SubscriptionHookOptions<WatchSingleCertificateSignValidationEventSubscription, WatchSingleCertificateSignValidationEventSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WatchSingleCertificateSignValidationEventSubscription, WatchSingleCertificateSignValidationEventSubscriptionVariables>(WatchSingleCertificateSignValidationEventDocument, options);
      }
export type WatchSingleCertificateSignValidationEventSubscriptionHookResult = ReturnType<typeof useWatchSingleCertificateSignValidationEventSubscription>;
export type WatchSingleCertificateSignValidationEventSubscriptionResult = Apollo.SubscriptionResult<WatchSingleCertificateSignValidationEventSubscription>;
export const WatchCertificateTemplateDataDocument = gql`
    subscription watchCertificateTemplateData($teamId: Int!, $templateId: String!) {
  watchCertificateTemplateData(teamId: $teamId, templateId: $templateId) {
    data
  }
}
    `;

/**
 * __useWatchCertificateTemplateDataSubscription__
 *
 * To run a query within a React component, call `useWatchCertificateTemplateDataSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchCertificateTemplateDataSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchCertificateTemplateDataSubscription({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useWatchCertificateTemplateDataSubscription(baseOptions: Apollo.SubscriptionHookOptions<WatchCertificateTemplateDataSubscription, WatchCertificateTemplateDataSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WatchCertificateTemplateDataSubscription, WatchCertificateTemplateDataSubscriptionVariables>(WatchCertificateTemplateDataDocument, options);
      }
export type WatchCertificateTemplateDataSubscriptionHookResult = ReturnType<typeof useWatchCertificateTemplateDataSubscription>;
export type WatchCertificateTemplateDataSubscriptionResult = Apollo.SubscriptionResult<WatchCertificateTemplateDataSubscription>;
export const WatchDocumentFocusDocument = gql`
    subscription watchDocumentFocus($documentId: String!, $teamId: Int!) {
  watchDocumentFocus(documentId: $documentId, teamId: $teamId) {
    ...WatchDocumentFocusFields
  }
}
    ${WatchDocumentFocusFieldsFragmentDoc}`;

/**
 * __useWatchDocumentFocusSubscription__
 *
 * To run a query within a React component, call `useWatchDocumentFocusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchDocumentFocusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchDocumentFocusSubscription({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useWatchDocumentFocusSubscription(baseOptions: Apollo.SubscriptionHookOptions<WatchDocumentFocusSubscription, WatchDocumentFocusSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WatchDocumentFocusSubscription, WatchDocumentFocusSubscriptionVariables>(WatchDocumentFocusDocument, options);
      }
export type WatchDocumentFocusSubscriptionHookResult = ReturnType<typeof useWatchDocumentFocusSubscription>;
export type WatchDocumentFocusSubscriptionResult = Apollo.SubscriptionResult<WatchDocumentFocusSubscription>;
export const WatchDocumentPatchesDocument = gql`
    subscription watchDocumentPatches($documentId: String!, $teamId: Int!) {
  watchDocumentPatches(documentId: $documentId, teamId: $teamId) {
    ...WatchDocumentPatchFields
  }
}
    ${WatchDocumentPatchFieldsFragmentDoc}`;

/**
 * __useWatchDocumentPatchesSubscription__
 *
 * To run a query within a React component, call `useWatchDocumentPatchesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchDocumentPatchesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchDocumentPatchesSubscription({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useWatchDocumentPatchesSubscription(baseOptions: Apollo.SubscriptionHookOptions<WatchDocumentPatchesSubscription, WatchDocumentPatchesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WatchDocumentPatchesSubscription, WatchDocumentPatchesSubscriptionVariables>(WatchDocumentPatchesDocument, options);
      }
export type WatchDocumentPatchesSubscriptionHookResult = ReturnType<typeof useWatchDocumentPatchesSubscription>;
export type WatchDocumentPatchesSubscriptionResult = Apollo.SubscriptionResult<WatchDocumentPatchesSubscription>;
export const WatchDocumentStatusDocument = gql`
    subscription watchDocumentStatus($documentId: String!, $teamId: Int!) {
  watchDocumentStatus(documentId: $documentId, teamId: $teamId)
}
    `;

/**
 * __useWatchDocumentStatusSubscription__
 *
 * To run a query within a React component, call `useWatchDocumentStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchDocumentStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchDocumentStatusSubscription({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useWatchDocumentStatusSubscription(baseOptions: Apollo.SubscriptionHookOptions<WatchDocumentStatusSubscription, WatchDocumentStatusSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WatchDocumentStatusSubscription, WatchDocumentStatusSubscriptionVariables>(WatchDocumentStatusDocument, options);
      }
export type WatchDocumentStatusSubscriptionHookResult = ReturnType<typeof useWatchDocumentStatusSubscription>;
export type WatchDocumentStatusSubscriptionResult = Apollo.SubscriptionResult<WatchDocumentStatusSubscription>;
export const WatchFinancialTeamWalletDocument = gql`
    subscription watchFinancialTeamWallet {
  watchFinancialTeamWallet {
    creditsPlanVisual
    creditsPlanTrial
    creditsPlanRb
    creditsPlanRtRa
    creditsDetachedVisual
    creditsDetachedRb
    creditsDetachedRtRa
    teamId
  }
}
    `;

/**
 * __useWatchFinancialTeamWalletSubscription__
 *
 * To run a query within a React component, call `useWatchFinancialTeamWalletSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchFinancialTeamWalletSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchFinancialTeamWalletSubscription({
 *   variables: {
 *   },
 * });
 */
export function useWatchFinancialTeamWalletSubscription(baseOptions?: Apollo.SubscriptionHookOptions<WatchFinancialTeamWalletSubscription, WatchFinancialTeamWalletSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WatchFinancialTeamWalletSubscription, WatchFinancialTeamWalletSubscriptionVariables>(WatchFinancialTeamWalletDocument, options);
      }
export type WatchFinancialTeamWalletSubscriptionHookResult = ReturnType<typeof useWatchFinancialTeamWalletSubscription>;
export type WatchFinancialTeamWalletSubscriptionResult = Apollo.SubscriptionResult<WatchFinancialTeamWalletSubscription>;